/* ================================================================================================== */
/* js/machinata-core-bundle.js */
/* Copyright 2021 Dan Krusi / Nerves GmbH */
/* License: Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International (CC BY-NC-SA 4.0) */
/* Link: https://nerves.ch */
/* Profile: reactjs */
/* Debug: yes */
/* Language: en */
/* Package: Machinata.Core */
/* Theme: default */
/* Build: 941a6590-3a33-4a37-97eb-662c9cabda58 */
/* Date: 19.07.2021 12:54 UTC */
/* ================================================================================================== */


/* -------------------------------------------------------------------------------------------------- */
/* profile-reactjs.js */
/* File: js/machinata-core-bundle.js/profile-reactjs.js */
/* -------------------------------------------------------------------------------------------------- */


/// <warning>
/// WARNING: reactjs build profile is not supported! Experimental only!
/// </warning>

/// <summary>
/// Specific reactjs Profile Code
/// </summary>

// Turn off define and require loading for all vendor plugins in this file...
const define = null;
const require = null;

/* -------------------------------------------------------------------------------------------------- */
/* global.js */
/* File: js/machinata-core-bundle.js/global.js */
/* -------------------------------------------------------------------------------------------------- */


/// <summary>
/// Provides some cross-platform (browser vs NodeJS) functionality for altering the Machinata
/// core behaviour and depencies before the actual loading of the library.
/// </summary>
/// <namespace></namespace>
/// <type>namespace</type>
/// <name>global</name>

/// <summary>
/// Shortcut multi-platform handle for the namespace for globals.
/// </summary>
/// <hidden/>
var MACHINATA_GLOBAL = (typeof global !== 'undefined') ? global : window;


/// <summary>
/// If ```true```, allows debugging output and modes to be enabled.
/// </summary>
/// <namespace>global</namespace>
/// <type>variable</type>
if (MACHINATA_GLOBAL.MACHINATA_DEBUG_ENABLED == null) MACHINATA_GLOBAL.MACHINATA_DEBUG_ENABLED = false;


/// <summary>
/// If ```true```, Machinata will auomatically noConflict() it's jQuery. This means that
/// if an version of jQuery already exists (on window.jQuery or window.$), the Machinata
/// included jQuery is "no conflicted".
/// </summary>
/// <namespace>global</namespace>
/// <type>variable</type>
MACHINATA_GLOBAL.MACHINATA_JQUERY_NO_CONFLICT_MODE = true;

/// <summary>
/// Defines the recommended minimum version of jQuery for Machinata.
/// </summary>
/// <namespace>global</namespace>
/// <type>variable</type>
MACHINATA_GLOBAL.MACHINATA_JQUERY_REQUIRED_VERSION = "3.5.1";

/// <summary>
/// If ```true```, Machinata has detected a already existing version of jQuery.
/// </summary>
/// <namespace>global</namespace>
/// <type>variable</type>
MACHINATA_GLOBAL.MACHINATA_JQUERY_ALREADY_EXISTS = false;

/// <summary>
/// If ```MACHINATA_JQUERY_ALREADY_EXISTS``` is ```true```, this stores
/// the version string of that detected version.
/// </summary>
/// <namespace>global</namespace>
/// <type>variable</type>
MACHINATA_GLOBAL.MACHINATA_JQUERY_EXISTING_VERSION = null;

/// <summary>
/// Stores a reference to the jQuery provided by Machianta.
/// </summary>
/// <namespace>global</namespace>
/// <type>variable</type>
/// <name>MACHINATA_JQUERY</name>
//MACHINATA_GLOBAL.MACHINATA_JQUERY = null;


/* -------------------------------------------------------------------------------------------------- */
/* module-es6.js */
/* File: js/machinata-core-bundle.js/module-es6.js */
/* -------------------------------------------------------------------------------------------------- */


/// <summary>
/// Provides ES6 module loading support
/// </summary>
var Machinata = {};
MACHINATA_GLOBAL.MACHINATA = Machinata;
export default Machinata;

/* -------------------------------------------------------------------------------------------------- */
/* javascript-extensions.js */
/* Copyright 2021 Dan Krusi / Nerves GmbH */
/* License: Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International (CC BY-NC-SA 4.0) */
/* File: js/machinata-core-bundle.js/javascript-extensions.js */
/* -------------------------------------------------------------------------------------------------- */

/* ======== Javascript Extensions ======== */

if (typeof String.prototype.hashCode != 'function') {
    // https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
    String.prototype.hashCode = function () {
        var hash = 0, i, chr;
        if (this.length === 0) return hash;
        for (i = 0; i < this.length; i++) {
            chr = this.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    };
}

if (typeof String.prototype.trim != 'function') {
    String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/g, "");
    };
}

if (typeof String.isEmpty != 'function') {
    String.isEmpty = function (str) {
        return (str == null || str == "");
    };
}

if (typeof String.isNullOrEmpty != 'function') {
    String.isNullOrEmpty = function (str) {
        return (str == null || str == "");
    };
}

if (typeof String.prototype.startsWith != 'function') {
    String.prototype.startsWith = function (str) {
        return this.slice(0, str.length) == str;
    };
}

if (typeof String.prototype.endsWith != 'function') {
    String.prototype.endsWith = function (str) {
        return this.slice(-str.length) == str;
    };
}

if (typeof String.prototype.contains != 'function') {
    String.prototype.contains = function (str) {
        return this.indexOf(str) > -1;
    };
}

if (typeof String.prototype.toSentence != 'function') {
    String.prototype.toSentence = function () {
        if (this.toUpperCase() == this) return this.toLowerCase();
        return this.replace(new RegExp("([A-Z])([A-Z])([a-z])|([a-z])([A-Z])","g"), "$1$4 $2$3$5");
    };
}

if (typeof String.prototype.padLeft != 'function') {
    String.prototype.padLeft = function (length, character) {
        return new Array(length - this.length + 1).join(character || '0') + this;
    };
}

if (typeof String.prototype.replaceAll != 'function') {
    String.prototype.replaceAll = function (replace, withThis) {
        //return this.replace(new RegExp(replace, 'g'), withThis);
        return this.split(replace).join(withThis);
    };
}

if (typeof String.prototype.replaceAllRegex != 'function') {
    String.prototype.replaceAllRegex = function (replace, withThis) {
        return this.replace(new RegExp(replace, 'g'), withThis);
    };
}

if (typeof String.prototype.capitalize != 'function') {
    String.prototype.capitalize = function () {
        return this[0].toUpperCase() + this.substring(1);
    };
}

if (typeof String.prototype.replaceNonAscii != 'function') {
    String.prototype.replaceNonAscii = function (withThis) {
        var ret = this;
        ret = ret.replaceAll("\\.", withThis);
        ret = ret.replaceAll("-", withThis);
        ret = ret.replaceAll(" ", withThis);
        return ret;
    };
}

if (!String.prototype.encodeHTML) {
    String.prototype.encodeHTML = function () {
        return this.replace(/&/g, '&amp;')
                   .replace(/</g, '&lt;')
                   .replace(/>/g, '&gt;')
                   .replace(/"/g, '&quot;');
        //.replace(/'/g, '&apos;');
    };
}

if (!String.prototype.decodeHTML) {
    String.prototype.decodeHTML = function () {
        //return this.replace(/&apos;/g, "'")
        return this.replace(/&quot;/g, '"')
                   .replace(/&gt;/g, '>')
                   .replace(/&lt;/g, '<')
                   .replace(/&amp;/g, '&');
    };
}

// Math.log10 Polyfill (for IE11 support)
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/log10
if (typeof Math.log10 != 'function') {
    Math.log10 = Math.log10 || function (x) {
        return Math.log(x) * Math.LOG10E;
    };
}

// Math.log10 Polyfill (for IE11 support)
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isFinite
if (typeof Number.isFinite != 'function') {
    if (Number.isFinite === undefined) Number.isFinite = function (value) {
        return typeof value === 'number' && isFinite(value);
    }
}

// Math.log10 Polyfill (for IE11 support)
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN
if (typeof Number.isNaN != 'function') {
    Number.isNaN = Number.isNaN || function isNaN(input) {
        return typeof input === 'number' && input !== input;
    }
}

/* -------------------------------------------------------------------------------------------------- */
/* jquery-noconflict-preprocess.js */
/* File: js/machinata-core-bundle.js/jquery-noconflict-preprocess.js */
/* -------------------------------------------------------------------------------------------------- */


/// <summary>
/// Detect if an existing version already exists
/// </summary>
/// <hidden/>
if (typeof window !== 'undefined' && (window.jQuery != null || window.$ != null)) {
    MACHINATA_GLOBAL.MACHINATA_JQUERY_EXISTING_VERSION = window.$.fn.jquery
    MACHINATA_GLOBAL.MACHINATA_JQUERY_ALREADY_EXISTS = true;
}

/* -------------------------------------------------------------------------------------------------- */
/* jquery-3.5.1.js */
/* File: js/machinata-core-bundle.js/jquery-3.5.1.js */
/* -------------------------------------------------------------------------------------------------- */

/*!
 * jQuery JavaScript Library v3.5.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2020-05-04T22:49Z
 */
( function( global, factory ) {

	"use strict";

	if ( false /* Note: CommonJS loader automatically stripped by Machinata reactjs profile: typeof module === "object" && typeof module.exports === "object" */ ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.5.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( _i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.5
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2020-03-14
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem.namespaceURI,
		docElem = ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();
						return result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px";
				tr.style.height = "1px";
				trChild.style.height = "9px";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = parseInt( trStyle.height ) > 3;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = (
					dataPriv.get( cur, "events" ) || Object.create( null )
				)[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script
			if ( !isSuccess && jQuery.inArray( "script", s.dataTypes ) > -1 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			if ( typeof props.top === "number" ) {
				props.top += "px";
			}
			if ( typeof props.left === "number" ) {
				props.left += "px";
			}
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/* -------------------------------------------------------------------------------------------------- */
/* jquery-noconflict-postprocess.js */
/* File: js/machinata-core-bundle.js/jquery-noconflict-postprocess.js */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// If a version exists, validate the version differences and perform the necessary actions (such as warnings or calling npoConflict)
/// </summary>
/// <hidden/>
if (MACHINATA_GLOBAL.MACHINATA_JQUERY != null) {
    // Nothing todo here
} else if (MACHINATA_GLOBAL.MACHINATA_JQUERY_ALREADY_EXISTS == true) {
    // Helper function
    function compareVersion(a, b) {
        if (a == b) {
            return 0;
        }
        var asegs = a.split(".");
        var bsegs = b.split(".");
        var len = Math.min(asegs.length, bsegs.length);
        for (var i = 0; i < len; i++) {
            if (parseInt(asegs[i]) > parseInt(bsegs[i])) {
                return 1; // a bigger than b
            }
            if (parseInt(asegs[i]) < parseInt(bsegs[i])) {
                return -1; // b bigger than a
            }
        }
        if (asegs.length > bsegs.length) {
            return 1;
        }
        if (asegs.length < bsegs.length) {
            return -1;
        }
        return 0;
    }
    console.log("Machinata: will $.noConflict() jQuery: using version " + MACHINATA_GLOBAL.MACHINATA_JQUERY_EXISTING_VERSION + " instead of packaged version " + MACHINATA_GLOBAL.MACHINATA_JQUERY_REQUIRED_VERSION);
    if (compareVersion(MACHINATA_GLOBAL.MACHINATA_JQUERY_EXISTING_VERSION, MACHINATA_GLOBAL.MACHINATA_JQUERY_REQUIRED_VERSION) < 0) {
        console.warn("Machinata: warning: existing jQuery version (" + MACHINATA_GLOBAL.MACHINATA_JQUERY_EXISTING_VERSION + ") is less than " + MACHINATA_GLOBAL.MACHINATA_JQUERY_REQUIRED_VERSION + " (see MACHINATA_REQUIRED_JQUERY_VERSION). Please update your jQuery version or use the packaged version by turning off no-conflict mode (see MACHINATA_JQUERY_NO_CONFLICT_MODE).");
    }
    if (MACHINATA_GLOBAL.MACHINATA_JQUERY_NO_CONFLICT_MODE == true) {
        MACHINATA_GLOBAL.MACHINATA_JQUERY = window.$.noConflict(); // See https://api.jquery.com/jquery.noconflict/
    } else {
        MACHINATA_GLOBAL.MACHINATA_JQUERY = window.$;
    }
} else {
    MACHINATA_GLOBAL.MACHINATA_JQUERY = window.$;
}

/* -------------------------------------------------------------------------------------------------- */
/* jquery-namespace-preprocess.js */
/* File: js/machinata-core-bundle.js/jquery-namespace-preprocess.js */
/* -------------------------------------------------------------------------------------------------- */

(function ($, jQuery, location, Globalize) { 


/* -------------------------------------------------------------------------------------------------- */
/* jquery-extensions.js */
/* File: js/machinata-core-bundle.js/jquery-extensions.js */
/* -------------------------------------------------------------------------------------------------- */




/* ======== jQuery Extensions ======== */


jQuery.fn.randomize = function (childElem) {
    function rnd(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
    };
    return this.each(function () {
        var $this = $(this);
        var elems = $this.children(childElem);
        elems.each(function () {
            $(this).data("sort", rnd(0, elems.length * 1000));
        });
        elems.sort(function (a, b) { return $(a).data("sort") < $(b).data("sort"); });
        $this.remove(childElem);
        for (var i = 0; i < elems.length; i++) $this.append(elems[i]);
    });
};

jQuery.fn.enterKey = function (fnc) {
    return this.each(function () {
        $(this).keypress(function (ev) {
            var keycode = (ev.keyCode ? ev.keyCode : ev.which);
            if (keycode == '13') {
                fnc.call(this, ev);
            }
        })
    })
};


/**
   * Copyright 2012, Digital Fusion
   * Licensed under the MIT license.
   * http://teamdf.com/jquery-plugins/license/
   *
   * @author Sam Sehnert
   * @desc A small plugin that checks whether elements are within
   *     the user visible viewport of a web browser.
   *     only accounts for vertical position, not horizontal.
   */
jQuery.fn.visible = function (partial) {
    if (partial == null) partial = true;
    var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;
    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
};

jQuery.fn.caret = function (begin, end) {
    if (this.length == 0) return;
    if (typeof begin == 'number') {
        end = (typeof end == 'number') ? end : begin;
        return this.each(function () {
            if (this.setSelectionRange) {
                this.setSelectionRange(begin, end);
            } else if (this.createTextRange) {
                var range = this.createTextRange();
                range.collapse(true);
                range.moveEnd('character', end);
                range.moveStart('character', begin);
                try { range.select(); } catch (ex) { }
            }
        });
    } else {
        if (this[0].setSelectionRange) {
            begin = this[0].selectionStart;
            end = this[0].selectionEnd;
        } else if (document.selection && document.selection.createRange) {
            var range = document.selection.createRange();
            begin = 0 - range.duplicate().moveStart('character', -100000);
            end = begin + range.text.length;
        }
        return { begin: begin, end: end };
    }
};


jQuery.fn.press = function (func) {
    throw "jQuery.fn.press via Machinata Core JS is no longer supported."
    /*
    // Cross platform mobile compatible touchend algorithm for quickly detecting 'presses'
    if (!Machinata.Device.isTouchEnabled()) {
        $(this).click(func);
    } else {
        $(this).bind('touchend', function (e) {
            // Get the element for the touch end
            var touch = event.changedTouches[0];
            var offsetX = touch.pageX - document.body.scrollLeft;
            var offsetY = touch.pageY - document.body.scrollTop;
            var elem = document.elementFromPoint(offsetX, offsetY);

            // Does it match?
            if (elem == this) {
                // Call the function via a proxy so that the this object is properly set
                var proxyFunc = $.proxy(func, this);
                _lastTouchEndEvent = new Date().getTime(); // now in ms (ticks)
                proxyFunc();
            } else {
                // Now check close by in a grid manner as last resort
                var offsetCheck = 4;
                for (var x = -1; x <= 1; x++) {
                    for (var y = -1; y <= 1; y++) {
                        if (!(x == 0 && y == 0)) {
                            var offsetX = touch.pageX - document.body.scrollLeft + (x * offsetCheck);
                            var offsetY = touch.pageY - document.body.scrollTop + (y * offsetCheck);
                            var elem = document.elementFromPoint(offsetX, offsetY);
                            if (elem == this) {
                                var proxyFunc = $.proxy(func, this);
                                _lastTouchEndEvent = new Date().getTime(); // now in ms (ticks)
                                proxyFunc();
                                return;
                            }
                        }
                    }
                }
            }
        });
    }*/
    return this;
};


jQuery.eachBack = function (obj, callback) {
    var revKeys = []; $.each(obj, function (rind, rval) { revKeys.push(rind); });
    revKeys.reverse();
    $.each(revKeys, function (kind, i) {
        if (callback.call(obj[i], i, obj[i]) === false) { return false; }
    });
    return obj;
};
jQuery.fn.eachBack = function (callback, args) {
    return jQuery.eachBack(this, callback, args);
};

jQuery.eachReverse = function (obj, callback) {
    var revKeys = []; $.each(obj, function (rind, rval) { revKeys.push(rind); });
    revKeys.reverse();
    $.each(revKeys, function (kind, i) {
        if (callback.call(obj[i], i, obj[i]) === false) { return false; }
    });
    return obj;
};
jQuery.fn.eachReverse = function (callback, args) {
    return jQuery.eachReverse(this, callback, args);
};

/* -------------------------------------------------------------------------------------------------- */
/* jquery-cookie.js */
/* File: js/machinata-core-bundle.js/jquery-cookie.js */
/* -------------------------------------------------------------------------------------------------- */

/*!
* jQuery Cookie Plugin v1.3
* https://github.com/carhartl/jquery-cookie
*
* Copyright 2011, Klaus Hartl
* Dual licensed under the MIT or GPL Version 2 licenses.
* http://www.opensource.org/licenses/mit-license.php
* http://www.opensource.org/licenses/GPL-2.0
*/
(function ($, document, undefined) {

    var pluses = /\+/g;

    function raw(s) {
        return s;
    }

    function decoded(s) {
        return decodeURIComponent(s.replace(pluses, ' '));
    }

    var config = $.cookie = function (key, value, options) {

        // write
        if (value !== undefined) {
            options = $.extend({}, config.defaults, options);

            if (value === null) {
                options.expires = -1;
            }

            if (typeof options.expires === 'number') {
                var days = options.expires, t = options.expires = new Date();
                t.setDate(t.getDate() + days);
            }

            value = config.json ? JSON.stringify(value) : String(value);

            return (document.cookie = [
encodeURIComponent(key), '=', config.raw ? value : encodeURIComponent(value),
options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
options.path ? '; path=' + options.path : '',
options.domain ? '; domain=' + options.domain : '',
options.secure ? '; secure' : ''
].join(''));
        }

        // read
        var decode = config.raw ? raw : decoded;
        var cookies = document.cookie.split('; ');
        for (var i = 0, l = cookies.length; i < l; i++) {
            var parts = cookies[i].split('=');
            if (decode(parts.shift()) === key) {
                var cookie = decode(parts.join('='));
                return config.json ? JSON.parse(cookie) : cookie;
            }
        }

        return null;
    };

    config.defaults = {};

    $.removeCookie = function (key, options) {
        if ($.cookie(key) !== null) {
            $.cookie(key, null, options);
            return true;
        }
        return false;
    };

})(jQuery, document);

/* -------------------------------------------------------------------------------------------------- */
/* jquery-scrollTo.js */
/* File: js/machinata-core-bundle.js/jquery-scrollTo.js */
/* -------------------------------------------------------------------------------------------------- */

/*!
 * jQuery.scrollTo
 * Copyright (c) 2007-2015 Ariel Flesler - aflesler<a>gmail<d>com | http://flesler.blogspot.com
 * Licensed under MIT
 * http://flesler.blogspot.com/2007/10/jqueryscrollto.html
 * @projectDescription Lightweight, cross-browser and highly customizable animated scrolling with jQuery
 * @author Ariel Flesler
 * @version 2.1.2
 */
;(function(factory) {
	'use strict';
	if (typeof define === 'function' && define.amd) {
		// AMD
		define(['jquery'], factory);
	} else if (false /* Note: CommonJS loader automatically stripped by Machinata reactjs profile: typeof module === 'object' && typeof module.exports === 'object' */) {
		// CommonJS
		module.exports = factory(require('jquery'));
	} else {
		// Global
		factory(jQuery);
	}
})(function($) {
	'use strict';

	var $scrollTo = $.scrollTo = function(target, duration, settings) {
		return $(window).scrollTo(target, duration, settings);
	};

	$scrollTo.defaults = {
		axis:'xy',
		duration: 0,
		limit:true
	};

	function isWin(elem) {
		return !elem.nodeName ||
			$.inArray(elem.nodeName.toLowerCase(), ['iframe','#document','html','body']) !== -1;
	}		

	$.fn.scrollTo = function(target, duration, settings) {
		if (typeof duration === 'object') {
			settings = duration;
			duration = 0;
		}
		if (typeof settings === 'function') {
			settings = { onAfter:settings };
		}
		if (target === 'max') {
			target = 9e9;
		}

		settings = $.extend({}, $scrollTo.defaults, settings);
		// Speed is still recognized for backwards compatibility
		duration = duration || settings.duration;
		// Make sure the settings are given right
		var queue = settings.queue && settings.axis.length > 1;
		if (queue) {
			// Let's keep the overall duration
			duration /= 2;
		}
		settings.offset = both(settings.offset);
		settings.over = both(settings.over);

		return this.each(function() {
			// Null target yields nothing, just like jQuery does
			if (target === null) return;

			var win = isWin(this),
				elem = win ? this.contentWindow || window : this,
				$elem = $(elem),
				targ = target, 
				attr = {},
				toff;

			switch (typeof targ) {
				// A number will pass the regex
				case 'number':
				case 'string':
					if (/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(targ)) {
						targ = both(targ);
						// We are done
						break;
					}
					// Relative/Absolute selector
					targ = win ? $(targ) : $(targ, elem);
					/* falls through */
				case 'object':
					if (targ.length === 0) return;
					// DOMElement / jQuery
					if (targ.is || targ.style) {
						// Get the real position of the target
						toff = (targ = $(targ)).offset();
					}
			}

			var offset = $.isFunction(settings.offset) && settings.offset(elem, targ) || settings.offset;

			$.each(settings.axis.split(''), function(i, axis) {
				var Pos	= axis === 'x' ? 'Left' : 'Top',
					pos = Pos.toLowerCase(),
					key = 'scroll' + Pos,
					prev = $elem[key](),
					max = $scrollTo.max(elem, axis);

				if (toff) {// jQuery / DOMElement
					attr[key] = toff[pos] + (win ? 0 : prev - $elem.offset()[pos]);

					// If it's a dom element, reduce the margin
					if (settings.margin) {
						attr[key] -= parseInt(targ.css('margin'+Pos), 10) || 0;
						attr[key] -= parseInt(targ.css('border'+Pos+'Width'), 10) || 0;
					}

					attr[key] += offset[pos] || 0;

					if (settings.over[pos]) {
						// Scroll to a fraction of its width/height
						attr[key] += targ[axis === 'x'?'width':'height']() * settings.over[pos];
					}
				} else {
					var val = targ[pos];
					// Handle percentage values
					attr[key] = val.slice && val.slice(-1) === '%' ?
						parseFloat(val) / 100 * max
						: val;
				}

				// Number or 'number'
				if (settings.limit && /^\d+$/.test(attr[key])) {
					// Check the limits
					attr[key] = attr[key] <= 0 ? 0 : Math.min(attr[key], max);
				}

				// Don't waste time animating, if there's no need.
				if (!i && settings.axis.length > 1) {
					if (prev === attr[key]) {
						// No animation needed
						attr = {};
					} else if (queue) {
						// Intermediate animation
						animate(settings.onAfterFirst);
						// Don't animate this axis again in the next iteration.
						attr = {};
					}
				}
			});

			animate(settings.onAfter);

			function animate(callback) {
				var opts = $.extend({}, settings, {
					// The queue setting conflicts with animate()
					// Force it to always be true
					queue: true,
					duration: duration,
					complete: callback && function() {
						callback.call(elem, targ, settings);
					}
				});
				$elem.animate(attr, opts);
			}
		});
	};

	// Max scrolling position, works on quirks mode
	// It only fails (not too badly) on IE, quirks mode.
	$scrollTo.max = function(elem, axis) {
		var Dim = axis === 'x' ? 'Width' : 'Height',
			scroll = 'scroll'+Dim;

		if (!isWin(elem))
			return elem[scroll] - $(elem)[Dim.toLowerCase()]();

		var size = 'client' + Dim,
			doc = elem.ownerDocument || elem.document,
			html = doc.documentElement,
			body = doc.body;

		return Math.max(html[scroll], body[scroll]) - Math.min(html[size], body[size]);
	};

	function both(val) {
		return $.isFunction(val) || $.isPlainObject(val) ? val : { top:val, left:val };
	}

	// Add special hooks so that window scroll properties can be animated
	$.Tween.propHooks.scrollLeft = 
	$.Tween.propHooks.scrollTop = {
		get: function(t) {
			return $(t.elem)[t.prop]();
		},
		set: function(t) {
			var curr = this.get(t);
			// If interrupt is true and user scrolled, stop animating
			if (t.options.interrupt && t._last && t._last !== curr) {
				return $(t.elem).stop();
			}
			var next = Math.round(t.now);
			// Don't waste CPU
			// Browsers don't render floating point scroll
			if (curr !== next) {
				$(t.elem)[t.prop](next);
				t._last = this.get(t);
			}
		}
	};

	// AMD requirement
	return $scrollTo;
});


/* -------------------------------------------------------------------------------------------------- */
/* jquery-progress.js */
/* File: js/machinata-core-bundle.js/jquery-progress.js */
/* -------------------------------------------------------------------------------------------------- */

/*
 * jQuery Ajax Progress - Lightweight jQuery plugin that adds support of `progress` and `uploadProgress` promises to $.ajax()
 * Copyright (c) 2015 Alexey Lizurchik <al.lizurchik@gmail.com> (http://likerrr.ru)
 * Licensed under the MIT license
 * http://likerrr.mit-license.org/
 */

(function(factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['jquery'], factory);
  } else if (false /* Note: CommonJS loader automatically stripped by Machinata reactjs profile: typeof exports === 'object' */) {
    // Node/CommonJS
    module.exports = factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
}(function($) {
  var $originalAjax = $.ajax.bind($);

  $.ajax = function (url, options) {
    if (typeof url === 'object') {
      options = url;
      url = undefined;
    }
    options = options || {};

    // Instantiate our own.
    var xmlHttpReq;

    if (!options.xhr) {
      xmlHttpReq = $.ajaxSettings.xhr();
    } else {
      xmlHttpReq = options.xhr();
    }

    // Make it use our own.
    options.xhr = function () {
      return xmlHttpReq;
    };

    var chunking = options.chunking || $.ajaxSettings.chunking;

    // this line looks strange, but without it chrome doesn't catch `progress` event on uploading. Seems like engine bug
    xmlHttpReq.upload.onprogress = null;

    var $newPromise = $originalAjax(url, options);

    // Extend our own.
    $newPromise.progress = function (handler) {
      // Download progress
      var lastChunkLen = 0;
      xmlHttpReq.addEventListener('progress', function (e) {
        var params = [e],
          chunk = '';

        if (this.readyState == 3 && chunking) {
          chunk = this.responseText.substr(lastChunkLen);
          lastChunkLen = this.responseText.length;
          params.push(chunk);
        }
        handler.apply(this, params);
      }, false);

      return this;
    };

    $newPromise.uploadProgress = function(handler) {
      // Upload progress
      if (xmlHttpReq.upload) {
        xmlHttpReq.upload.addEventListener('progress', function (e) {
          handler.apply(this, [e]);
        }, false);
      }

      return this;
    };

    return $newPromise;
  };
}));


/* -------------------------------------------------------------------------------------------------- */
/* jquery-autogrow.js */
/* File: js/machinata-core-bundle.js/jquery-autogrow.js */
/* -------------------------------------------------------------------------------------------------- */

/*!
  Non-Sucking Autogrow 1.1.6
  license: MIT
  author: Roman Pushkin
  https://github.com/ro31337/jquery.ns-autogrow
*/
(function() {
  var getVerticalScrollbarWidth;

  (function($, window) {
    return $.fn.autogrow = function(options) {
      if (options == null) {
        options = {};
      }
      if (options.horizontal == null) {
        options.horizontal = true;
      }
      if (options.vertical == null) {
        options.vertical = true;
      }
      if (options.debugx == null) {
        options.debugx = -10000;
      }
      if (options.debugy == null) {
        options.debugy = -10000;
      }
      if (options.debugcolor == null) {
        options.debugcolor = 'yellow';
      }
      if (options.flickering == null) {
        options.flickering = true;
      }
      if (options.postGrowCallback == null) {
        options.postGrowCallback = function() {};
      }
      if (options.verticalScrollbarWidth == null) {
        options.verticalScrollbarWidth = getVerticalScrollbarWidth();
      }
      if (options.horizontal === false && options.vertical === false) {
        return;
      }
      return this.filter('textarea').each(function() {
        var $e, $shadow, fontSize, heightPadding, minHeight, minWidth, update;
        $e = $(this);
        if ($e.data('autogrow-enabled')) {
          return;
        }
        $e.data('autogrow-enabled');
        minHeight = $e.height();
        minWidth = $e.width();
        heightPadding = $e.css('lineHeight') * 1 || 0;
        $e.hasVerticalScrollBar = function() {
          return $e[0].clientHeight < $e[0].scrollHeight;
        };
        $shadow = $('<div class="autogrow-shadow"></div>').css({
          position: 'absolute',
          display: 'inline-block',
          'background-color': options.debugcolor,
          top: options.debugy,
          left: options.debugx,
          'max-width': $e.css('max-width'),
          'padding': $e.css('padding'),
          fontSize: $e.css('fontSize'),
          fontFamily: $e.css('fontFamily'),
          fontWeight: $e.css('fontWeight'),
          lineHeight: $e.css('lineHeight'),
          resize: 'none',
          'word-wrap': 'break-word'
        }).appendTo(document.body);
        if (options.horizontal === false) {
          $shadow.css({
            'width': $e.width()
          });
        } else {
          fontSize = $e.css('font-size');
          $shadow.css('padding-right', '+=' + fontSize);
          $shadow.normalPaddingRight = $shadow.css('padding-right');
        }
        update = (function(_this) {
          return function(event) {
            var height, val, width;
            val = _this.value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n /g, '<br/>&nbsp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\n$/, '<br/>&nbsp;').replace(/\n/g, '<br/>').replace(/ {2,}/g, function(space) {
              return Array(space.length - 1).join('&nbsp;') + ' ';
            });
            if (/(\n|\r)/.test(_this.value)) {
              val += '<br />';
              if (options.flickering === false) {
                val += '<br />';
              }
            }
            $shadow.html(val);
            if (options.vertical === true) {
              height = Math.max($shadow.height() + heightPadding, minHeight);
              $e.height(height);
            }
            if (options.horizontal === true) {
              $shadow.css('padding-right', $shadow.normalPaddingRight);
              if (options.vertical === false && $e.hasVerticalScrollBar()) {
                $shadow.css('padding-right', "+=" + options.verticalScrollbarWidth + "px");
              }
              width = Math.max($shadow.outerWidth(), minWidth);
              $e.width(width);
            }
            return options.postGrowCallback($e);
          };
        })(this);
        $e.change(update).keyup(update).keydown(update);
        $(window).resize(update);
        return update();
      });
    };
  })(window.jQuery, window);

  getVerticalScrollbarWidth = function() {
    var inner, outer, w1, w2;
    inner = document.createElement('p');
    inner.style.width = "100%";
    inner.style.height = "200px";
    outer = document.createElement('div');
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild(inner);
    document.body.appendChild(outer);
    w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    w2 = inner.offsetWidth;
    if (w1 === w2) {
      w2 = outer.clientWidth;
    }
    document.body.removeChild(outer);
    return w1 - w2;
  };

}).call(this);


/* -------------------------------------------------------------------------------------------------- */
/* jquery-fullscreen.js */
/* File: js/machinata-core-bundle.js/jquery-fullscreen.js */
/* -------------------------------------------------------------------------------------------------- */

/**
 * @preserve jquery.fullscreen 1.1.5
 * https://github.com/code-lts/jquery-fullscreen-plugin
 * Copyright (C) 2012-2013 Klaus Reimer <k@ailis.de>
 * Licensed under the MIT license
 * (See http://www.opensource.org/licenses/mit-license)
 */

(function(jQuery) {

/**
 * Sets or gets the fullscreen state.
 *
 * @param {boolean=} state
 *            True to enable fullscreen mode, false to disable it. If not
 *            specified then the current fullscreen state is returned.
 * @return {boolean|Element|jQuery|null}
 *            When querying the fullscreen state then the current fullscreen
 *            element (or true if browser doesn't support it) is returned
 *            when browser is currently in full screen mode. False is returned
 *            if browser is not in full screen mode. Null is returned if
 *            browser doesn't support fullscreen mode at all. When setting
 *            the fullscreen state then the current jQuery selection is
 *            returned for chaining.
 * @this {jQuery}
 */
function fullScreen(state)
{
    var e, func, doc;

    // Do nothing when nothing was selected
    if (!this.length) return this;

    // We only use the first selected element because it doesn't make sense
    // to fullscreen multiple elements.
    e = (/** @type {Element} */ this[0]);

    // Find the real element and the document (Depends on whether the
    // document itself or a HTML element was selected)
    if (e.ownerDocument)
    {
        doc = e.ownerDocument;
    }
    else
    {
        doc = e;
        e = doc.documentElement;
    }

    // When no state was specified then return the current state.
    if (state == null)
    {
        // When fullscreen mode is not supported then return null
        if (!((/** @type {?Function} */ doc["exitFullscreen"])
            || (/** @type {?Function} */ doc["webkitExitFullscreen"])
            || (/** @type {?Function} */ doc["webkitCancelFullScreen"])
            || (/** @type {?Function} */ doc["msExitFullscreen"])
            || (/** @type {?Function} */ doc["mozCancelFullScreen"])))
        {
            return null;
        }

        // Check fullscreen state
        state = fullScreenState(doc);
        if (!state) return state;

        // Return current fullscreen element or "true" if browser doesn't
        // support this
        return (/** @type {?Element} */ doc["fullscreenElement"])
            || (/** @type {?Element} */ doc["webkitFullscreenElement"])
            || (/** @type {?Element} */ doc["webkitCurrentFullScreenElement"])
            || (/** @type {?Element} */ doc["msFullscreenElement"])
            || (/** @type {?Element} */ doc["mozFullScreenElement"])
            || state;
    }

    // When state was specified then enter or exit fullscreen mode.
    if (state)
    {
        // Enter fullscreen
        func = (/** @type {?Function} */ e["requestFullscreen"])
            || (/** @type {?Function} */ e["webkitRequestFullscreen"])
            || (/** @type {?Function} */ e["webkitRequestFullScreen"])
            || (/** @type {?Function} */ e["msRequestFullscreen"])
            || (/** @type {?Function} */ e["mozRequestFullScreen"]);
        if (func)
        {
            func.call(e);
        }
        return this;
    }
    else
    {
        // Exit fullscreen
        func = (/** @type {?Function} */ doc["exitFullscreen"])
            || (/** @type {?Function} */ doc["webkitExitFullscreen"])
            || (/** @type {?Function} */ doc["webkitCancelFullScreen"])
            || (/** @type {?Function} */ doc["msExitFullscreen"])
            || (/** @type {?Function} */ doc["mozCancelFullScreen"]);
        if (func && fullScreenState(doc)) func.call(doc);
        return this;
    }
}

/**
 * Check fullscreen state
 *
 * @param {Document} doc The content document
 * @return {Boolean}
 */
function fullScreenState(doc) {
    return !!(doc["fullscreenElement"] || doc["msFullscreenElement"] || doc["webkitIsFullScreen"] || doc["mozFullScreen"]);
}

/**
 * Toggles the fullscreen mode.
 *
 * @return {!jQuery}
 *            The jQuery selection for chaining.
 * @this {jQuery}
 */
function toggleFullScreen()
{
    return (/** @type {!jQuery} */ fullScreen.call(this,
        !fullScreen.call(this)));
}

/**
 * Handles the browser-specific fullscreenchange event and triggers
 * a jquery event for it.
 *
 * @param {?Event} event
 *            The fullscreenchange event.
 */
function fullScreenChangeHandler(event)
{
    jQuery(document).trigger(new jQuery.Event("fullscreenchange"));
}

/**
 * Handles the browser-specific fullscreenerror event and triggers
 * a jquery event for it.
 *
 * @param {?Event} event
 *            The fullscreenerror event.
 */
function fullScreenErrorHandler(event)
{
    jQuery(document).trigger(new jQuery.Event("fullscreenerror"));
}

/**
 * Installs the fullscreenchange event handler.
 */
function installFullScreenHandlers()
{
    var e, change, error;

    // Determine event name
    e = document;
    if (e["webkitCancelFullScreen"])
    {
        change = "webkitfullscreenchange";
        error = "webkitfullscreenerror";
    }
    else if (e["msExitFullscreen"])
    {
        change = "MSFullscreenChange";
        error = "MSFullscreenError";
    }
    else if (e["mozCancelFullScreen"])
    {
        change = "mozfullscreenchange";
        error = "mozfullscreenerror";
    }
    else
    {
        change = "fullscreenchange";
        error = "fullscreenerror";
    }

    // Install the event handlers
    jQuery(document).bind(change, fullScreenChangeHandler);
    jQuery(document).bind(error, fullScreenErrorHandler);
}

jQuery.fn["fullScreen"] = fullScreen;
jQuery.fn["toggleFullScreen"] = toggleFullScreen;
installFullScreenHandlers();

})(jQuery);

/* -------------------------------------------------------------------------------------------------- */
/* jquery-zoom.js */
/* File: js/machinata-core-bundle.js/jquery-zoom.js */
/* -------------------------------------------------------------------------------------------------- */

/*!
	Zoom 1.7.20
	license: MIT
	http://www.jacklmoore.com/zoom
    WARNING: File modified by Dan Krusi
*/
(function ($) {
	var defaults = {
		url: false,
		callback: false,
		target: false,
		duration: 120,
		on: 'mouseover', // other options: grab, click, toggle
		touch: true, // enables a touch fallback
		onZoomIn: false,
		onZoomOut: false,
		magnify: 1
	};

	// Core Zoom Logic, independent of event listeners.
	$.zoom = function(target, source, img, magnify) {
		var targetHeight,
			targetWidth,
			sourceHeight,
			sourceWidth,
			xRatio,
			yRatio,
			offset,
			$target = $(target),
			position = $target.css('position'),
			$source = $(source);

		// The parent element needs positioning so that the zoomed element can be correctly positioned within.
		target.style.position = /(absolute|fixed)/.test(position) ? position : 'relative';
		target.style.overflow = 'hidden';
		img.style.width = img.style.height = '';

		$(img)
			.addClass('zoomImg')
			.css({
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: 0,
				width: img.width * magnify,
				height: img.height * magnify,
				border: 'none',
				maxWidth: 'none',
				maxHeight: 'none'
			})
			.appendTo(target);

		return {
			init: function() {
				targetWidth = $target.outerWidth();
				targetHeight = $target.outerHeight();

				if (source === target) {
					sourceWidth = targetWidth;
					sourceHeight = targetHeight;
				} else {
					sourceWidth = $source.outerWidth();
					sourceHeight = $source.outerHeight();
				}

				xRatio = (img.width - targetWidth) / sourceWidth;
				yRatio = (img.height - targetHeight) / sourceHeight;

				offset = $source.offset();
			},
			move: function (e) {
				var left = (e.pageX - offset.left),
					top = (e.pageY - offset.top);

				top = Math.max(Math.min(top, sourceHeight), 0);
				left = Math.max(Math.min(left, sourceWidth), 0);

				img.style.left = (left * -xRatio) + 'px';
				img.style.top = (top * -yRatio) + 'px';
			}
		};
	};

	$.fn.zoom = function (options) {
		return this.each(function () {
			var
			settings = $.extend({}, defaults, options || {}),
			//target will display the zoomed image
			target = settings.target && $(settings.target)[0] || this,
			//source will provide zoom location info (thumbnail)
			source = this,
			$source = $(source),
			img = document.createElement('img'),
			$img = $(img),
			mousemove = 'mousemove.zoom',
			clicked = false,
			touched = false;

			// If a url wasn't specified, look for an image element.
			if (!settings.url) {
			    settings.url = $source.attr("data-zoomable-image");
			    if (!settings.url) {
			        settings.url = $source.css("background-image").replace("url(\"", "").replace("\")", "");
			    }
			    alert(settings.url);
				//var srcElement = source.querySelector('img');
				//if (srcElement) {
				//	settings.url = srcElement.getAttribute('data-src') || srcElement.currentSrc || srcElement.src;
				//}
				if (!settings.url) {
					return;
				}
			}

			$source.one('zoom.destroy', function(position, overflow){
				$source.off(".zoom");
				target.style.position = position;
				target.style.overflow = overflow;
				img.onload = null;
				$img.remove();
			}.bind(this, target.style.position, target.style.overflow));

			img.onload = function () {
				var zoom = $.zoom(target, source, img, settings.magnify);

				function start(e) {
					zoom.init();
					zoom.move(e);

					// Skip the fade-in for IE8 and lower since it chokes on fading-in
					// and changing position based on mousemovement at the same time.
					$img.stop()
					.fadeTo($.support.opacity ? settings.duration : 0, 1, $.isFunction(settings.onZoomIn) ? settings.onZoomIn.call(img) : false);
				}

				function stop() {
					$img.stop()
					.fadeTo(settings.duration, 0, $.isFunction(settings.onZoomOut) ? settings.onZoomOut.call(img) : false);
				}

				// Mouse events
				if (settings.on === 'grab') {
					$source
						.on('mousedown.zoom',
							function (e) {
								if (e.which === 1) {
									$(document).one('mouseup.zoom',
										function () {
											stop();

											$(document).off(mousemove, zoom.move);
										}
									);

									start(e);

									$(document).on(mousemove, zoom.move);

									e.preventDefault();
								}
							}
						);
				} else if (settings.on === 'click') {
					$source.on('click.zoom',
						function (e) {
							if (clicked) {
								// bubble the event up to the document to trigger the unbind.
								return;
							} else {
								clicked = true;
								start(e);
								$(document).on(mousemove, zoom.move);
								$(document).one('click.zoom',
									function () {
										stop();
										clicked = false;
										$(document).off(mousemove, zoom.move);
									}
								);
								return false;
							}
						}
					);
				} else if (settings.on === 'toggle') {
					$source.on('click.zoom',
						function (e) {
							if (clicked) {
								stop();
							} else {
								start(e);
							}
							clicked = !clicked;
						}
					);
				} else if (settings.on === 'mouseover') {
					zoom.init(); // Preemptively call init because IE7 will fire the mousemove handler before the hover handler.

					$source
						.on('mouseenter.zoom', start)
						.on('mouseleave.zoom', stop)
						.on(mousemove, zoom.move);
				}

				// Touch fallback
				if (settings.touch) {
					$source
						.on('touchstart.zoom', function (e) {
							e.preventDefault();
							if (touched) {
								touched = false;
								stop();
							} else {
								touched = true;
								start( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
							}
						})
						.on('touchmove.zoom', function (e) {
							e.preventDefault();
							zoom.move( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
						})
						.on('touchend.zoom', function (e) {
							e.preventDefault();
							if (touched) {
								touched = false;
								stop();
							}
						});
				}
				
				if ($.isFunction(settings.callback)) {
					settings.callback.call(img);
				}
			};

			img.setAttribute('role', 'presentation');
			img.src = settings.url;
		});
	};

	$.fn.zoom.defaults = defaults;
}(window.jQuery));


/* -------------------------------------------------------------------------------------------------- */
/* jquery-ui.js */
/* File: js/machinata-core-bundle.js/jquery-ui.js */
/* -------------------------------------------------------------------------------------------------- */

/*! jQuery UI - v1.12.1 - 2016-09-14
* http://jqueryui.com
* Includes: widget.js, position.js, data.js, disable-selection.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js, focusable.js, form-reset-mixin.js, jquery-1-7.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/draggable.js, widgets/droppable.js, widgets/menu.js, widgets/mouse.js, widgets/progressbar.js, widgets/resizable.js, widgets/selectable.js, widgets/selectmenu.js, widgets/slider.js, widgets/sortable.js, widgets/spinner.js, widgets/tabs.js, widgets/tooltip.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */

(function( factory ) {
	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define([ "jquery" ], factory );
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

$.ui = $.ui || {};

var version = $.ui.version = "1.12.1";


/*!
 * jQuery UI Widget 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Widget
//>>group: Core
//>>description: Provides a factory for creating stateful widgets with a common API.
//>>docs: http://api.jqueryui.com/jQuery.widget/
//>>demos: http://jqueryui.com/widget/



var widgetUuid = 0;
var widgetSlice = Array.prototype.slice;

$.cleanData = ( function( orig ) {
	return function( elems ) {
		var events, elem, i;
		for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {
			try {

				// Only trigger remove when necessary to save time
				events = $._data( elem, "events" );
				if ( events && events.remove ) {
					$( elem ).triggerHandler( "remove" );
				}

			// Http://bugs.jquery.com/ticket/8235
			} catch ( e ) {}
		}
		orig( elems );
	};
} )( $.cleanData );

$.widget = function( name, base, prototype ) {
	var existingConstructor, constructor, basePrototype;

	// ProxiedPrototype allows the provided prototype to remain unmodified
	// so that it can be used as a mixin for multiple widgets (#8876)
	var proxiedPrototype = {};

	var namespace = name.split( "." )[ 0 ];
	name = name.split( "." )[ 1 ];
	var fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	if ( $.isArray( prototype ) ) {
		prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
	}

	// Create selector for plugin
	$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
		return !!$.data( elem, fullName );
	};

	$[ namespace ] = $[ namespace ] || {};
	existingConstructor = $[ namespace ][ name ];
	constructor = $[ namespace ][ name ] = function( options, element ) {

		// Allow instantiation without "new" keyword
		if ( !this._createWidget ) {
			return new constructor( options, element );
		}

		// Allow instantiation without initializing for simple inheritance
		// must use "new" keyword (the code above always passes args)
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};

	// Extend with the existing constructor to carry over any static properties
	$.extend( constructor, existingConstructor, {
		version: prototype.version,

		// Copy the object used to create the prototype in case we need to
		// redefine the widget later
		_proto: $.extend( {}, prototype ),

		// Track widgets that inherit from this widget in case this widget is
		// redefined after a widget inherits from it
		_childConstructors: []
	} );

	basePrototype = new base();

	// We need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options = $.widget.extend( {}, basePrototype.options );
	$.each( prototype, function( prop, value ) {
		if ( !$.isFunction( value ) ) {
			proxiedPrototype[ prop ] = value;
			return;
		}
		proxiedPrototype[ prop ] = ( function() {
			function _super() {
				return base.prototype[ prop ].apply( this, arguments );
			}

			function _superApply( args ) {
				return base.prototype[ prop ].apply( this, args );
			}

			return function() {
				var __super = this._super;
				var __superApply = this._superApply;
				var returnValue;

				this._super = _super;
				this._superApply = _superApply;

				returnValue = value.apply( this, arguments );

				this._super = __super;
				this._superApply = __superApply;

				return returnValue;
			};
		} )();
	} );
	constructor.prototype = $.widget.extend( basePrototype, {

		// TODO: remove support for widgetEventPrefix
		// always use the name + a colon as the prefix, e.g., draggable:start
		// don't prefix for widgets that aren't DOM-based
		widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
	}, proxiedPrototype, {
		constructor: constructor,
		namespace: namespace,
		widgetName: name,
		widgetFullName: fullName
	} );

	// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if ( existingConstructor ) {
		$.each( existingConstructor._childConstructors, function( i, child ) {
			var childPrototype = child.prototype;

			// Redefine the child widget using the same prototype that was
			// originally used, but inherit from the new version of the base
			$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
				child._proto );
		} );

		// Remove the list of existing child constructors from the old constructor
		// so the old child constructors can be garbage collected
		delete existingConstructor._childConstructors;
	} else {
		base._childConstructors.push( constructor );
	}

	$.widget.bridge( name, constructor );

	return constructor;
};

$.widget.extend = function( target ) {
	var input = widgetSlice.call( arguments, 1 );
	var inputIndex = 0;
	var inputLength = input.length;
	var key;
	var value;

	for ( ; inputIndex < inputLength; inputIndex++ ) {
		for ( key in input[ inputIndex ] ) {
			value = input[ inputIndex ][ key ];
			if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {

				// Clone objects
				if ( $.isPlainObject( value ) ) {
					target[ key ] = $.isPlainObject( target[ key ] ) ?
						$.widget.extend( {}, target[ key ], value ) :

						// Don't extend strings, arrays, etc. with objects
						$.widget.extend( {}, value );

				// Copy everything else by reference
				} else {
					target[ key ] = value;
				}
			}
		}
	}
	return target;
};

$.widget.bridge = function( name, object ) {
	var fullName = object.prototype.widgetFullName || name;
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string";
		var args = widgetSlice.call( arguments, 1 );
		var returnValue = this;

		if ( isMethodCall ) {

			// If this is an empty collection, we need to have the instance method
			// return undefined instead of the jQuery instance
			if ( !this.length && options === "instance" ) {
				returnValue = undefined;
			} else {
				this.each( function() {
					var methodValue;
					var instance = $.data( this, fullName );

					if ( options === "instance" ) {
						returnValue = instance;
						return false;
					}

					if ( !instance ) {
						return $.error( "cannot call methods on " + name +
							" prior to initialization; " +
							"attempted to call method '" + options + "'" );
					}

					if ( !$.isFunction( instance[ options ] ) || options.charAt( 0 ) === "_" ) {
						return $.error( "no such method '" + options + "' for " + name +
							" widget instance" );
					}

					methodValue = instance[ options ].apply( instance, args );

					if ( methodValue !== instance && methodValue !== undefined ) {
						returnValue = methodValue && methodValue.jquery ?
							returnValue.pushStack( methodValue.get() ) :
							methodValue;
						return false;
					}
				} );
			}
		} else {

			// Allow multiple hashes to be passed on init
			if ( args.length ) {
				options = $.widget.extend.apply( null, [ options ].concat( args ) );
			}

			this.each( function() {
				var instance = $.data( this, fullName );
				if ( instance ) {
					instance.option( options || {} );
					if ( instance._init ) {
						instance._init();
					}
				} else {
					$.data( this, fullName, new object( options, this ) );
				}
			} );
		}

		return returnValue;
	};
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	defaultElement: "<div>",

	options: {
		classes: {},
		disabled: false,

		// Callbacks
		create: null
	},

	_createWidget: function( options, element ) {
		element = $( element || this.defaultElement || this )[ 0 ];
		this.element = $( element );
		this.uuid = widgetUuid++;
		this.eventNamespace = "." + this.widgetName + this.uuid;

		this.bindings = $();
		this.hoverable = $();
		this.focusable = $();
		this.classesElementLookup = {};

		if ( element !== this ) {
			$.data( element, this.widgetFullName, this );
			this._on( true, this.element, {
				remove: function( event ) {
					if ( event.target === element ) {
						this.destroy();
					}
				}
			} );
			this.document = $( element.style ?

				// Element within the document
				element.ownerDocument :

				// Element is window or document
				element.document || element );
			this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
		}

		this.options = $.widget.extend( {},
			this.options,
			this._getCreateOptions(),
			options );

		this._create();

		if ( this.options.disabled ) {
			this._setOptionDisabled( this.options.disabled );
		}

		this._trigger( "create", null, this._getCreateEventData() );
		this._init();
	},

	_getCreateOptions: function() {
		return {};
	},

	_getCreateEventData: $.noop,

	_create: $.noop,

	_init: $.noop,

	destroy: function() {
		var that = this;

		this._destroy();
		$.each( this.classesElementLookup, function( key, value ) {
			that._removeClass( value, key );
		} );

		// We can probably remove the unbind calls in 2.0
		// all event bindings should go through this._on()
		this.element
			.off( this.eventNamespace )
			.removeData( this.widgetFullName );
		this.widget()
			.off( this.eventNamespace )
			.removeAttr( "aria-disabled" );

		// Clean up events and states
		this.bindings.off( this.eventNamespace );
	},

	_destroy: $.noop,

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key;
		var parts;
		var curOption;
		var i;

		if ( arguments.length === 0 ) {

			// Don't return a reference to the internal hash
			return $.widget.extend( {}, this.options );
		}

		if ( typeof key === "string" ) {

			// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
			options = {};
			parts = key.split( "." );
			key = parts.shift();
			if ( parts.length ) {
				curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
				for ( i = 0; i < parts.length - 1; i++ ) {
					curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
					curOption = curOption[ parts[ i ] ];
				}
				key = parts.pop();
				if ( arguments.length === 1 ) {
					return curOption[ key ] === undefined ? null : curOption[ key ];
				}
				curOption[ key ] = value;
			} else {
				if ( arguments.length === 1 ) {
					return this.options[ key ] === undefined ? null : this.options[ key ];
				}
				options[ key ] = value;
			}
		}

		this._setOptions( options );

		return this;
	},

	_setOptions: function( options ) {
		var key;

		for ( key in options ) {
			this._setOption( key, options[ key ] );
		}

		return this;
	},

	_setOption: function( key, value ) {
		if ( key === "classes" ) {
			this._setOptionClasses( value );
		}

		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this._setOptionDisabled( value );
		}

		return this;
	},

	_setOptionClasses: function( value ) {
		var classKey, elements, currentElements;

		for ( classKey in value ) {
			currentElements = this.classesElementLookup[ classKey ];
			if ( value[ classKey ] === this.options.classes[ classKey ] ||
					!currentElements ||
					!currentElements.length ) {
				continue;
			}

			// We are doing this to create a new jQuery object because the _removeClass() call
			// on the next line is going to destroy the reference to the current elements being
			// tracked. We need to save a copy of this collection so that we can add the new classes
			// below.
			elements = $( currentElements.get() );
			this._removeClass( currentElements, classKey );

			// We don't use _addClass() here, because that uses this.options.classes
			// for generating the string of classes. We want to use the value passed in from
			// _setOption(), this is the new value of the classes option which was passed to
			// _setOption(). We pass this value directly to _classes().
			elements.addClass( this._classes( {
				element: elements,
				keys: classKey,
				classes: value,
				add: true
			} ) );
		}
	},

	_setOptionDisabled: function( value ) {
		this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );

		// If the widget is becoming disabled, then nothing is interactive
		if ( value ) {
			this._removeClass( this.hoverable, null, "ui-state-hover" );
			this._removeClass( this.focusable, null, "ui-state-focus" );
		}
	},

	enable: function() {
		return this._setOptions( { disabled: false } );
	},

	disable: function() {
		return this._setOptions( { disabled: true } );
	},

	_classes: function( options ) {
		var full = [];
		var that = this;

		options = $.extend( {
			element: this.element,
			classes: this.options.classes || {}
		}, options );

		function processClassString( classes, checkOption ) {
			var current, i;
			for ( i = 0; i < classes.length; i++ ) {
				current = that.classesElementLookup[ classes[ i ] ] || $();
				if ( options.add ) {
					current = $( $.unique( current.get().concat( options.element.get() ) ) );
				} else {
					current = $( current.not( options.element ).get() );
				}
				that.classesElementLookup[ classes[ i ] ] = current;
				full.push( classes[ i ] );
				if ( checkOption && options.classes[ classes[ i ] ] ) {
					full.push( options.classes[ classes[ i ] ] );
				}
			}
		}

		this._on( options.element, {
			"remove": "_untrackClassesElement"
		} );

		if ( options.keys ) {
			processClassString( options.keys.match( /\S+/g ) || [], true );
		}
		if ( options.extra ) {
			processClassString( options.extra.match( /\S+/g ) || [] );
		}

		return full.join( " " );
	},

	_untrackClassesElement: function( event ) {
		var that = this;
		$.each( that.classesElementLookup, function( key, value ) {
			if ( $.inArray( event.target, value ) !== -1 ) {
				that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
			}
		} );
	},

	_removeClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, false );
	},

	_addClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, true );
	},

	_toggleClass: function( element, keys, extra, add ) {
		add = ( typeof add === "boolean" ) ? add : extra;
		var shift = ( typeof element === "string" || element === null ),
			options = {
				extra: shift ? keys : extra,
				keys: shift ? element : keys,
				element: shift ? this.element : element,
				add: add
			};
		options.element.toggleClass( this._classes( options ), add );
		return this;
	},

	_on: function( suppressDisabledCheck, element, handlers ) {
		var delegateElement;
		var instance = this;

		// No suppressDisabledCheck flag, shuffle arguments
		if ( typeof suppressDisabledCheck !== "boolean" ) {
			handlers = element;
			element = suppressDisabledCheck;
			suppressDisabledCheck = false;
		}

		// No element argument, shuffle and use this.element
		if ( !handlers ) {
			handlers = element;
			element = this.element;
			delegateElement = this.widget();
		} else {
			element = delegateElement = $( element );
			this.bindings = this.bindings.add( element );
		}

		$.each( handlers, function( event, handler ) {
			function handlerProxy() {

				// Allow widgets to customize the disabled handling
				// - disabled as an array instead of boolean
				// - disabled class as method for disabling individual parts
				if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
						$( this ).hasClass( "ui-state-disabled" ) ) ) {
					return;
				}
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}

			// Copy the guid so direct unbinding works
			if ( typeof handler !== "string" ) {
				handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
			}

			var match = event.match( /^([\w:-]*)\s*(.*)$/ );
			var eventName = match[ 1 ] + instance.eventNamespace;
			var selector = match[ 2 ];

			if ( selector ) {
				delegateElement.on( eventName, selector, handlerProxy );
			} else {
				element.on( eventName, handlerProxy );
			}
		} );
	},

	_off: function( element, eventName ) {
		eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
			this.eventNamespace;
		element.off( eventName ).off( eventName );

		// Clear the stack to avoid memory leaks (#10056)
		this.bindings = $( this.bindings.not( element ).get() );
		this.focusable = $( this.focusable.not( element ).get() );
		this.hoverable = $( this.hoverable.not( element ).get() );
	},

	_delay: function( handler, delay ) {
		function handlerProxy() {
			return ( typeof handler === "string" ? instance[ handler ] : handler )
				.apply( instance, arguments );
		}
		var instance = this;
		return setTimeout( handlerProxy, delay || 0 );
	},

	_hoverable: function( element ) {
		this.hoverable = this.hoverable.add( element );
		this._on( element, {
			mouseenter: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
			},
			mouseleave: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
			}
		} );
	},

	_focusable: function( element ) {
		this.focusable = this.focusable.add( element );
		this._on( element, {
			focusin: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
			},
			focusout: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
			}
		} );
	},

	_trigger: function( type, event, data ) {
		var prop, orig;
		var callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();

		// The original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// Copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );
		return !( $.isFunction( callback ) &&
			callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
	}
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
		if ( typeof options === "string" ) {
			options = { effect: options };
		}

		var hasOptions;
		var effectName = !options ?
			method :
			options === true || typeof options === "number" ?
				defaultEffect :
				options.effect || defaultEffect;

		options = options || {};
		if ( typeof options === "number" ) {
			options = { duration: options };
		}

		hasOptions = !$.isEmptyObject( options );
		options.complete = callback;

		if ( options.delay ) {
			element.delay( options.delay );
		}

		if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
			element[ method ]( options );
		} else if ( effectName !== method && element[ effectName ] ) {
			element[ effectName ]( options.duration, options.easing, callback );
		} else {
			element.queue( function( next ) {
				$( this )[ method ]();
				if ( callback ) {
					callback.call( element[ 0 ] );
				}
				next();
			} );
		}
	};
} );

var widget = $.widget;


/*!
 * jQuery UI Position 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/position/
 */

//>>label: Position
//>>group: Core
//>>description: Positions elements relative to other elements.
//>>docs: http://api.jqueryui.com/position/
//>>demos: http://jqueryui.com/position/


( function() {
var cachedScrollbarWidth,
	max = Math.max,
	abs = Math.abs,
	rhorizontal = /left|center|right/,
	rvertical = /top|center|bottom/,
	roffset = /[\+\-]\d+(\.[\d]+)?%?/,
	rposition = /^\w+/,
	rpercent = /%$/,
	_position = $.fn.position;

function getOffsets( offsets, width, height ) {
	return [
		parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
		parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
	];
}

function parseCss( element, property ) {
	return parseInt( $.css( element, property ), 10 ) || 0;
}

function getDimensions( elem ) {
	var raw = elem[ 0 ];
	if ( raw.nodeType === 9 ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: 0, left: 0 }
		};
	}
	if ( $.isWindow( raw ) ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
		};
	}
	if ( raw.preventDefault ) {
		return {
			width: 0,
			height: 0,
			offset: { top: raw.pageY, left: raw.pageX }
		};
	}
	return {
		width: elem.outerWidth(),
		height: elem.outerHeight(),
		offset: elem.offset()
	};
}

$.position = {
	scrollbarWidth: function() {
		if ( cachedScrollbarWidth !== undefined ) {
			return cachedScrollbarWidth;
		}
		var w1, w2,
			div = $( "<div " +
				"style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'>" +
				"<div style='height:100px;width:auto;'></div></div>" ),
			innerDiv = div.children()[ 0 ];

		$( "body" ).append( div );
		w1 = innerDiv.offsetWidth;
		div.css( "overflow", "scroll" );

		w2 = innerDiv.offsetWidth;

		if ( w1 === w2 ) {
			w2 = div[ 0 ].clientWidth;
		}

		div.remove();

		return ( cachedScrollbarWidth = w1 - w2 );
	},
	getScrollInfo: function( within ) {
		var overflowX = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-x" ),
			overflowY = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-y" ),
			hasOverflowX = overflowX === "scroll" ||
				( overflowX === "auto" && within.width < within.element[ 0 ].scrollWidth ),
			hasOverflowY = overflowY === "scroll" ||
				( overflowY === "auto" && within.height < within.element[ 0 ].scrollHeight );
		return {
			width: hasOverflowY ? $.position.scrollbarWidth() : 0,
			height: hasOverflowX ? $.position.scrollbarWidth() : 0
		};
	},
	getWithinInfo: function( element ) {
		var withinElement = $( element || window ),
			isWindow = $.isWindow( withinElement[ 0 ] ),
			isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9,
			hasOffset = !isWindow && !isDocument;
		return {
			element: withinElement,
			isWindow: isWindow,
			isDocument: isDocument,
			offset: hasOffset ? $( element ).offset() : { left: 0, top: 0 },
			scrollLeft: withinElement.scrollLeft(),
			scrollTop: withinElement.scrollTop(),
			width: withinElement.outerWidth(),
			height: withinElement.outerHeight()
		};
	}
};

$.fn.position = function( options ) {
	if ( !options || !options.of ) {
		return _position.apply( this, arguments );
	}

	// Make a copy, we don't want to modify arguments
	options = $.extend( {}, options );

	var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
		target = $( options.of ),
		within = $.position.getWithinInfo( options.within ),
		scrollInfo = $.position.getScrollInfo( within ),
		collision = ( options.collision || "flip" ).split( " " ),
		offsets = {};

	dimensions = getDimensions( target );
	if ( target[ 0 ].preventDefault ) {

		// Force left top to allow flipping
		options.at = "left top";
	}
	targetWidth = dimensions.width;
	targetHeight = dimensions.height;
	targetOffset = dimensions.offset;

	// Clone to reuse original targetOffset later
	basePosition = $.extend( {}, targetOffset );

	// Force my and at to have valid horizontal and vertical positions
	// if a value is missing or invalid, it will be converted to center
	$.each( [ "my", "at" ], function() {
		var pos = ( options[ this ] || "" ).split( " " ),
			horizontalOffset,
			verticalOffset;

		if ( pos.length === 1 ) {
			pos = rhorizontal.test( pos[ 0 ] ) ?
				pos.concat( [ "center" ] ) :
				rvertical.test( pos[ 0 ] ) ?
					[ "center" ].concat( pos ) :
					[ "center", "center" ];
		}
		pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
		pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";

		// Calculate offsets
		horizontalOffset = roffset.exec( pos[ 0 ] );
		verticalOffset = roffset.exec( pos[ 1 ] );
		offsets[ this ] = [
			horizontalOffset ? horizontalOffset[ 0 ] : 0,
			verticalOffset ? verticalOffset[ 0 ] : 0
		];

		// Reduce to just the positions without the offsets
		options[ this ] = [
			rposition.exec( pos[ 0 ] )[ 0 ],
			rposition.exec( pos[ 1 ] )[ 0 ]
		];
	} );

	// Normalize collision option
	if ( collision.length === 1 ) {
		collision[ 1 ] = collision[ 0 ];
	}

	if ( options.at[ 0 ] === "right" ) {
		basePosition.left += targetWidth;
	} else if ( options.at[ 0 ] === "center" ) {
		basePosition.left += targetWidth / 2;
	}

	if ( options.at[ 1 ] === "bottom" ) {
		basePosition.top += targetHeight;
	} else if ( options.at[ 1 ] === "center" ) {
		basePosition.top += targetHeight / 2;
	}

	atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
	basePosition.left += atOffset[ 0 ];
	basePosition.top += atOffset[ 1 ];

	return this.each( function() {
		var collisionPosition, using,
			elem = $( this ),
			elemWidth = elem.outerWidth(),
			elemHeight = elem.outerHeight(),
			marginLeft = parseCss( this, "marginLeft" ),
			marginTop = parseCss( this, "marginTop" ),
			collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) +
				scrollInfo.width,
			collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) +
				scrollInfo.height,
			position = $.extend( {}, basePosition ),
			myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );

		if ( options.my[ 0 ] === "right" ) {
			position.left -= elemWidth;
		} else if ( options.my[ 0 ] === "center" ) {
			position.left -= elemWidth / 2;
		}

		if ( options.my[ 1 ] === "bottom" ) {
			position.top -= elemHeight;
		} else if ( options.my[ 1 ] === "center" ) {
			position.top -= elemHeight / 2;
		}

		position.left += myOffset[ 0 ];
		position.top += myOffset[ 1 ];

		collisionPosition = {
			marginLeft: marginLeft,
			marginTop: marginTop
		};

		$.each( [ "left", "top" ], function( i, dir ) {
			if ( $.ui.position[ collision[ i ] ] ) {
				$.ui.position[ collision[ i ] ][ dir ]( position, {
					targetWidth: targetWidth,
					targetHeight: targetHeight,
					elemWidth: elemWidth,
					elemHeight: elemHeight,
					collisionPosition: collisionPosition,
					collisionWidth: collisionWidth,
					collisionHeight: collisionHeight,
					offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
					my: options.my,
					at: options.at,
					within: within,
					elem: elem
				} );
			}
		} );

		if ( options.using ) {

			// Adds feedback as second argument to using callback, if present
			using = function( props ) {
				var left = targetOffset.left - position.left,
					right = left + targetWidth - elemWidth,
					top = targetOffset.top - position.top,
					bottom = top + targetHeight - elemHeight,
					feedback = {
						target: {
							element: target,
							left: targetOffset.left,
							top: targetOffset.top,
							width: targetWidth,
							height: targetHeight
						},
						element: {
							element: elem,
							left: position.left,
							top: position.top,
							width: elemWidth,
							height: elemHeight
						},
						horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
						vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
					};
				if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
					feedback.horizontal = "center";
				}
				if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
					feedback.vertical = "middle";
				}
				if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
					feedback.important = "horizontal";
				} else {
					feedback.important = "vertical";
				}
				options.using.call( this, props, feedback );
			};
		}

		elem.offset( $.extend( position, { using: using } ) );
	} );
};

$.ui.position = {
	fit: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
				outerWidth = within.width,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = withinOffset - collisionPosLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
				newOverRight;

			// Element is wider than within
			if ( data.collisionWidth > outerWidth ) {

				// Element is initially over the left side of within
				if ( overLeft > 0 && overRight <= 0 ) {
					newOverRight = position.left + overLeft + data.collisionWidth - outerWidth -
						withinOffset;
					position.left += overLeft - newOverRight;

				// Element is initially over right side of within
				} else if ( overRight > 0 && overLeft <= 0 ) {
					position.left = withinOffset;

				// Element is initially over both left and right sides of within
				} else {
					if ( overLeft > overRight ) {
						position.left = withinOffset + outerWidth - data.collisionWidth;
					} else {
						position.left = withinOffset;
					}
				}

			// Too far left -> align with left edge
			} else if ( overLeft > 0 ) {
				position.left += overLeft;

			// Too far right -> align with right edge
			} else if ( overRight > 0 ) {
				position.left -= overRight;

			// Adjust based on position and margin
			} else {
				position.left = max( position.left - collisionPosLeft, position.left );
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
				outerHeight = data.within.height,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = withinOffset - collisionPosTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
				newOverBottom;

			// Element is taller than within
			if ( data.collisionHeight > outerHeight ) {

				// Element is initially over the top of within
				if ( overTop > 0 && overBottom <= 0 ) {
					newOverBottom = position.top + overTop + data.collisionHeight - outerHeight -
						withinOffset;
					position.top += overTop - newOverBottom;

				// Element is initially over bottom of within
				} else if ( overBottom > 0 && overTop <= 0 ) {
					position.top = withinOffset;

				// Element is initially over both top and bottom of within
				} else {
					if ( overTop > overBottom ) {
						position.top = withinOffset + outerHeight - data.collisionHeight;
					} else {
						position.top = withinOffset;
					}
				}

			// Too far up -> align with top
			} else if ( overTop > 0 ) {
				position.top += overTop;

			// Too far down -> align with bottom edge
			} else if ( overBottom > 0 ) {
				position.top -= overBottom;

			// Adjust based on position and margin
			} else {
				position.top = max( position.top - collisionPosTop, position.top );
			}
		}
	},
	flip: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.left + within.scrollLeft,
				outerWidth = within.width,
				offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = collisionPosLeft - offsetLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
				myOffset = data.my[ 0 ] === "left" ?
					-data.elemWidth :
					data.my[ 0 ] === "right" ?
						data.elemWidth :
						0,
				atOffset = data.at[ 0 ] === "left" ?
					data.targetWidth :
					data.at[ 0 ] === "right" ?
						-data.targetWidth :
						0,
				offset = -2 * data.offset[ 0 ],
				newOverRight,
				newOverLeft;

			if ( overLeft < 0 ) {
				newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth -
					outerWidth - withinOffset;
				if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
					position.left += myOffset + atOffset + offset;
				}
			} else if ( overRight > 0 ) {
				newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset +
					atOffset + offset - offsetLeft;
				if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
					position.left += myOffset + atOffset + offset;
				}
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.top + within.scrollTop,
				outerHeight = within.height,
				offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = collisionPosTop - offsetTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
				top = data.my[ 1 ] === "top",
				myOffset = top ?
					-data.elemHeight :
					data.my[ 1 ] === "bottom" ?
						data.elemHeight :
						0,
				atOffset = data.at[ 1 ] === "top" ?
					data.targetHeight :
					data.at[ 1 ] === "bottom" ?
						-data.targetHeight :
						0,
				offset = -2 * data.offset[ 1 ],
				newOverTop,
				newOverBottom;
			if ( overTop < 0 ) {
				newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight -
					outerHeight - withinOffset;
				if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
					position.top += myOffset + atOffset + offset;
				}
			} else if ( overBottom > 0 ) {
				newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset +
					offset - offsetTop;
				if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
					position.top += myOffset + atOffset + offset;
				}
			}
		}
	},
	flipfit: {
		left: function() {
			$.ui.position.flip.left.apply( this, arguments );
			$.ui.position.fit.left.apply( this, arguments );
		},
		top: function() {
			$.ui.position.flip.top.apply( this, arguments );
			$.ui.position.fit.top.apply( this, arguments );
		}
	}
};

} )();

var position = $.ui.position;


/*!
 * jQuery UI :data 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: :data Selector
//>>group: Core
//>>description: Selects elements which have data stored under the specified key.
//>>docs: http://api.jqueryui.com/data-selector/


var data = $.extend( $.expr[ ":" ], {
	data: $.expr.createPseudo ?
		$.expr.createPseudo( function( dataName ) {
			return function( elem ) {
				return !!$.data( elem, dataName );
			};
		} ) :

		// Support: jQuery <1.8
		function( elem, i, match ) {
			return !!$.data( elem, match[ 3 ] );
		}
} );

/*!
 * jQuery UI Disable Selection 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: disableSelection
//>>group: Core
//>>description: Disable selection of text content within the set of matched elements.
//>>docs: http://api.jqueryui.com/disableSelection/

// This file is deprecated


var disableSelection = $.fn.extend( {
	disableSelection: ( function() {
		var eventType = "onselectstart" in document.createElement( "div" ) ?
			"selectstart" :
			"mousedown";

		return function() {
			return this.on( eventType + ".ui-disableSelection", function( event ) {
				event.preventDefault();
			} );
		};
	} )(),

	enableSelection: function() {
		return this.off( ".ui-disableSelection" );
	}
} );


/*!
 * jQuery UI Effects 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Effects Core
//>>group: Effects
// jscs:disable maximumLineLength
//>>description: Extends the internal jQuery effects. Includes morphing and easing. Required by all other effects.
// jscs:enable maximumLineLength
//>>docs: http://api.jqueryui.com/category/effects-core/
//>>demos: http://jqueryui.com/effect/



var dataSpace = "ui-effects-",
	dataSpaceStyle = "ui-effects-style",
	dataSpaceAnimated = "ui-effects-animated",

	// Create a local jQuery because jQuery Color relies on it and the
	// global may not exist with AMD and a custom build (#10199)
	jQuery = $;

$.effects = {
	effect: {}
};

/*!
 * jQuery Color Animations v2.1.2
 * https://github.com/jquery/jquery-color
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * Date: Wed Jan 16 08:47:09 2013 -0600
 */
( function( jQuery, undefined ) {

	var stepHooks = "backgroundColor borderBottomColor borderLeftColor borderRightColor " +
		"borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",

	// Plusequals test for += 100 -= 100
	rplusequals = /^([\-+])=\s*(\d+\.?\d*)/,

	// A set of RE's that can match strings and generate color tuples.
	stringParsers = [ {
			re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			parse: function( execResult ) {
				return [
					execResult[ 1 ],
					execResult[ 2 ],
					execResult[ 3 ],
					execResult[ 4 ]
				];
			}
		}, {
			re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			parse: function( execResult ) {
				return [
					execResult[ 1 ] * 2.55,
					execResult[ 2 ] * 2.55,
					execResult[ 3 ] * 2.55,
					execResult[ 4 ]
				];
			}
		}, {

			// This regex ignores A-F because it's compared against an already lowercased string
			re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
			parse: function( execResult ) {
				return [
					parseInt( execResult[ 1 ], 16 ),
					parseInt( execResult[ 2 ], 16 ),
					parseInt( execResult[ 3 ], 16 )
				];
			}
		}, {

			// This regex ignores A-F because it's compared against an already lowercased string
			re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
			parse: function( execResult ) {
				return [
					parseInt( execResult[ 1 ] + execResult[ 1 ], 16 ),
					parseInt( execResult[ 2 ] + execResult[ 2 ], 16 ),
					parseInt( execResult[ 3 ] + execResult[ 3 ], 16 )
				];
			}
		}, {
			re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			space: "hsla",
			parse: function( execResult ) {
				return [
					execResult[ 1 ],
					execResult[ 2 ] / 100,
					execResult[ 3 ] / 100,
					execResult[ 4 ]
				];
			}
		} ],

	// JQuery.Color( )
	color = jQuery.Color = function( color, green, blue, alpha ) {
		return new jQuery.Color.fn.parse( color, green, blue, alpha );
	},
	spaces = {
		rgba: {
			props: {
				red: {
					idx: 0,
					type: "byte"
				},
				green: {
					idx: 1,
					type: "byte"
				},
				blue: {
					idx: 2,
					type: "byte"
				}
			}
		},

		hsla: {
			props: {
				hue: {
					idx: 0,
					type: "degrees"
				},
				saturation: {
					idx: 1,
					type: "percent"
				},
				lightness: {
					idx: 2,
					type: "percent"
				}
			}
		}
	},
	propTypes = {
		"byte": {
			floor: true,
			max: 255
		},
		"percent": {
			max: 1
		},
		"degrees": {
			mod: 360,
			floor: true
		}
	},
	support = color.support = {},

	// Element for support tests
	supportElem = jQuery( "<p>" )[ 0 ],

	// Colors = jQuery.Color.names
	colors,

	// Local aliases of functions called often
	each = jQuery.each;

// Determine rgba support immediately
supportElem.style.cssText = "background-color:rgba(1,1,1,.5)";
support.rgba = supportElem.style.backgroundColor.indexOf( "rgba" ) > -1;

// Define cache name and alpha properties
// for rgba and hsla spaces
each( spaces, function( spaceName, space ) {
	space.cache = "_" + spaceName;
	space.props.alpha = {
		idx: 3,
		type: "percent",
		def: 1
	};
} );

function clamp( value, prop, allowEmpty ) {
	var type = propTypes[ prop.type ] || {};

	if ( value == null ) {
		return ( allowEmpty || !prop.def ) ? null : prop.def;
	}

	// ~~ is an short way of doing floor for positive numbers
	value = type.floor ? ~~value : parseFloat( value );

	// IE will pass in empty strings as value for alpha,
	// which will hit this case
	if ( isNaN( value ) ) {
		return prop.def;
	}

	if ( type.mod ) {

		// We add mod before modding to make sure that negatives values
		// get converted properly: -10 -> 350
		return ( value + type.mod ) % type.mod;
	}

	// For now all property types without mod have min and max
	return 0 > value ? 0 : type.max < value ? type.max : value;
}

function stringParse( string ) {
	var inst = color(),
		rgba = inst._rgba = [];

	string = string.toLowerCase();

	each( stringParsers, function( i, parser ) {
		var parsed,
			match = parser.re.exec( string ),
			values = match && parser.parse( match ),
			spaceName = parser.space || "rgba";

		if ( values ) {
			parsed = inst[ spaceName ]( values );

			// If this was an rgba parse the assignment might happen twice
			// oh well....
			inst[ spaces[ spaceName ].cache ] = parsed[ spaces[ spaceName ].cache ];
			rgba = inst._rgba = parsed._rgba;

			// Exit each( stringParsers ) here because we matched
			return false;
		}
	} );

	// Found a stringParser that handled it
	if ( rgba.length ) {

		// If this came from a parsed string, force "transparent" when alpha is 0
		// chrome, (and maybe others) return "transparent" as rgba(0,0,0,0)
		if ( rgba.join() === "0,0,0,0" ) {
			jQuery.extend( rgba, colors.transparent );
		}
		return inst;
	}

	// Named colors
	return colors[ string ];
}

color.fn = jQuery.extend( color.prototype, {
	parse: function( red, green, blue, alpha ) {
		if ( red === undefined ) {
			this._rgba = [ null, null, null, null ];
			return this;
		}
		if ( red.jquery || red.nodeType ) {
			red = jQuery( red ).css( green );
			green = undefined;
		}

		var inst = this,
			type = jQuery.type( red ),
			rgba = this._rgba = [];

		// More than 1 argument specified - assume ( red, green, blue, alpha )
		if ( green !== undefined ) {
			red = [ red, green, blue, alpha ];
			type = "array";
		}

		if ( type === "string" ) {
			return this.parse( stringParse( red ) || colors._default );
		}

		if ( type === "array" ) {
			each( spaces.rgba.props, function( key, prop ) {
				rgba[ prop.idx ] = clamp( red[ prop.idx ], prop );
			} );
			return this;
		}

		if ( type === "object" ) {
			if ( red instanceof color ) {
				each( spaces, function( spaceName, space ) {
					if ( red[ space.cache ] ) {
						inst[ space.cache ] = red[ space.cache ].slice();
					}
				} );
			} else {
				each( spaces, function( spaceName, space ) {
					var cache = space.cache;
					each( space.props, function( key, prop ) {

						// If the cache doesn't exist, and we know how to convert
						if ( !inst[ cache ] && space.to ) {

							// If the value was null, we don't need to copy it
							// if the key was alpha, we don't need to copy it either
							if ( key === "alpha" || red[ key ] == null ) {
								return;
							}
							inst[ cache ] = space.to( inst._rgba );
						}

						// This is the only case where we allow nulls for ALL properties.
						// call clamp with alwaysAllowEmpty
						inst[ cache ][ prop.idx ] = clamp( red[ key ], prop, true );
					} );

					// Everything defined but alpha?
					if ( inst[ cache ] &&
							jQuery.inArray( null, inst[ cache ].slice( 0, 3 ) ) < 0 ) {

						// Use the default of 1
						inst[ cache ][ 3 ] = 1;
						if ( space.from ) {
							inst._rgba = space.from( inst[ cache ] );
						}
					}
				} );
			}
			return this;
		}
	},
	is: function( compare ) {
		var is = color( compare ),
			same = true,
			inst = this;

		each( spaces, function( _, space ) {
			var localCache,
				isCache = is[ space.cache ];
			if ( isCache ) {
				localCache = inst[ space.cache ] || space.to && space.to( inst._rgba ) || [];
				each( space.props, function( _, prop ) {
					if ( isCache[ prop.idx ] != null ) {
						same = ( isCache[ prop.idx ] === localCache[ prop.idx ] );
						return same;
					}
				} );
			}
			return same;
		} );
		return same;
	},
	_space: function() {
		var used = [],
			inst = this;
		each( spaces, function( spaceName, space ) {
			if ( inst[ space.cache ] ) {
				used.push( spaceName );
			}
		} );
		return used.pop();
	},
	transition: function( other, distance ) {
		var end = color( other ),
			spaceName = end._space(),
			space = spaces[ spaceName ],
			startColor = this.alpha() === 0 ? color( "transparent" ) : this,
			start = startColor[ space.cache ] || space.to( startColor._rgba ),
			result = start.slice();

		end = end[ space.cache ];
		each( space.props, function( key, prop ) {
			var index = prop.idx,
				startValue = start[ index ],
				endValue = end[ index ],
				type = propTypes[ prop.type ] || {};

			// If null, don't override start value
			if ( endValue === null ) {
				return;
			}

			// If null - use end
			if ( startValue === null ) {
				result[ index ] = endValue;
			} else {
				if ( type.mod ) {
					if ( endValue - startValue > type.mod / 2 ) {
						startValue += type.mod;
					} else if ( startValue - endValue > type.mod / 2 ) {
						startValue -= type.mod;
					}
				}
				result[ index ] = clamp( ( endValue - startValue ) * distance + startValue, prop );
			}
		} );
		return this[ spaceName ]( result );
	},
	blend: function( opaque ) {

		// If we are already opaque - return ourself
		if ( this._rgba[ 3 ] === 1 ) {
			return this;
		}

		var rgb = this._rgba.slice(),
			a = rgb.pop(),
			blend = color( opaque )._rgba;

		return color( jQuery.map( rgb, function( v, i ) {
			return ( 1 - a ) * blend[ i ] + a * v;
		} ) );
	},
	toRgbaString: function() {
		var prefix = "rgba(",
			rgba = jQuery.map( this._rgba, function( v, i ) {
				return v == null ? ( i > 2 ? 1 : 0 ) : v;
			} );

		if ( rgba[ 3 ] === 1 ) {
			rgba.pop();
			prefix = "rgb(";
		}

		return prefix + rgba.join() + ")";
	},
	toHslaString: function() {
		var prefix = "hsla(",
			hsla = jQuery.map( this.hsla(), function( v, i ) {
				if ( v == null ) {
					v = i > 2 ? 1 : 0;
				}

				// Catch 1 and 2
				if ( i && i < 3 ) {
					v = Math.round( v * 100 ) + "%";
				}
				return v;
			} );

		if ( hsla[ 3 ] === 1 ) {
			hsla.pop();
			prefix = "hsl(";
		}
		return prefix + hsla.join() + ")";
	},
	toHexString: function( includeAlpha ) {
		var rgba = this._rgba.slice(),
			alpha = rgba.pop();

		if ( includeAlpha ) {
			rgba.push( ~~( alpha * 255 ) );
		}

		return "#" + jQuery.map( rgba, function( v ) {

			// Default to 0 when nulls exist
			v = ( v || 0 ).toString( 16 );
			return v.length === 1 ? "0" + v : v;
		} ).join( "" );
	},
	toString: function() {
		return this._rgba[ 3 ] === 0 ? "transparent" : this.toRgbaString();
	}
} );
color.fn.parse.prototype = color.fn;

// Hsla conversions adapted from:
// https://code.google.com/p/maashaack/source/browse/packages/graphics/trunk/src/graphics/colors/HUE2RGB.as?r=5021

function hue2rgb( p, q, h ) {
	h = ( h + 1 ) % 1;
	if ( h * 6 < 1 ) {
		return p + ( q - p ) * h * 6;
	}
	if ( h * 2 < 1 ) {
		return q;
	}
	if ( h * 3 < 2 ) {
		return p + ( q - p ) * ( ( 2 / 3 ) - h ) * 6;
	}
	return p;
}

spaces.hsla.to = function( rgba ) {
	if ( rgba[ 0 ] == null || rgba[ 1 ] == null || rgba[ 2 ] == null ) {
		return [ null, null, null, rgba[ 3 ] ];
	}
	var r = rgba[ 0 ] / 255,
		g = rgba[ 1 ] / 255,
		b = rgba[ 2 ] / 255,
		a = rgba[ 3 ],
		max = Math.max( r, g, b ),
		min = Math.min( r, g, b ),
		diff = max - min,
		add = max + min,
		l = add * 0.5,
		h, s;

	if ( min === max ) {
		h = 0;
	} else if ( r === max ) {
		h = ( 60 * ( g - b ) / diff ) + 360;
	} else if ( g === max ) {
		h = ( 60 * ( b - r ) / diff ) + 120;
	} else {
		h = ( 60 * ( r - g ) / diff ) + 240;
	}

	// Chroma (diff) == 0 means greyscale which, by definition, saturation = 0%
	// otherwise, saturation is based on the ratio of chroma (diff) to lightness (add)
	if ( diff === 0 ) {
		s = 0;
	} else if ( l <= 0.5 ) {
		s = diff / add;
	} else {
		s = diff / ( 2 - add );
	}
	return [ Math.round( h ) % 360, s, l, a == null ? 1 : a ];
};

spaces.hsla.from = function( hsla ) {
	if ( hsla[ 0 ] == null || hsla[ 1 ] == null || hsla[ 2 ] == null ) {
		return [ null, null, null, hsla[ 3 ] ];
	}
	var h = hsla[ 0 ] / 360,
		s = hsla[ 1 ],
		l = hsla[ 2 ],
		a = hsla[ 3 ],
		q = l <= 0.5 ? l * ( 1 + s ) : l + s - l * s,
		p = 2 * l - q;

	return [
		Math.round( hue2rgb( p, q, h + ( 1 / 3 ) ) * 255 ),
		Math.round( hue2rgb( p, q, h ) * 255 ),
		Math.round( hue2rgb( p, q, h - ( 1 / 3 ) ) * 255 ),
		a
	];
};

each( spaces, function( spaceName, space ) {
	var props = space.props,
		cache = space.cache,
		to = space.to,
		from = space.from;

	// Makes rgba() and hsla()
	color.fn[ spaceName ] = function( value ) {

		// Generate a cache for this space if it doesn't exist
		if ( to && !this[ cache ] ) {
			this[ cache ] = to( this._rgba );
		}
		if ( value === undefined ) {
			return this[ cache ].slice();
		}

		var ret,
			type = jQuery.type( value ),
			arr = ( type === "array" || type === "object" ) ? value : arguments,
			local = this[ cache ].slice();

		each( props, function( key, prop ) {
			var val = arr[ type === "object" ? key : prop.idx ];
			if ( val == null ) {
				val = local[ prop.idx ];
			}
			local[ prop.idx ] = clamp( val, prop );
		} );

		if ( from ) {
			ret = color( from( local ) );
			ret[ cache ] = local;
			return ret;
		} else {
			return color( local );
		}
	};

	// Makes red() green() blue() alpha() hue() saturation() lightness()
	each( props, function( key, prop ) {

		// Alpha is included in more than one space
		if ( color.fn[ key ] ) {
			return;
		}
		color.fn[ key ] = function( value ) {
			var vtype = jQuery.type( value ),
				fn = ( key === "alpha" ? ( this._hsla ? "hsla" : "rgba" ) : spaceName ),
				local = this[ fn ](),
				cur = local[ prop.idx ],
				match;

			if ( vtype === "undefined" ) {
				return cur;
			}

			if ( vtype === "function" ) {
				value = value.call( this, cur );
				vtype = jQuery.type( value );
			}
			if ( value == null && prop.empty ) {
				return this;
			}
			if ( vtype === "string" ) {
				match = rplusequals.exec( value );
				if ( match ) {
					value = cur + parseFloat( match[ 2 ] ) * ( match[ 1 ] === "+" ? 1 : -1 );
				}
			}
			local[ prop.idx ] = value;
			return this[ fn ]( local );
		};
	} );
} );

// Add cssHook and .fx.step function for each named hook.
// accept a space separated string of properties
color.hook = function( hook ) {
	var hooks = hook.split( " " );
	each( hooks, function( i, hook ) {
		jQuery.cssHooks[ hook ] = {
			set: function( elem, value ) {
				var parsed, curElem,
					backgroundColor = "";

				if ( value !== "transparent" && ( jQuery.type( value ) !== "string" ||
						( parsed = stringParse( value ) ) ) ) {
					value = color( parsed || value );
					if ( !support.rgba && value._rgba[ 3 ] !== 1 ) {
						curElem = hook === "backgroundColor" ? elem.parentNode : elem;
						while (
							( backgroundColor === "" || backgroundColor === "transparent" ) &&
							curElem && curElem.style
						) {
							try {
								backgroundColor = jQuery.css( curElem, "backgroundColor" );
								curElem = curElem.parentNode;
							} catch ( e ) {
							}
						}

						value = value.blend( backgroundColor && backgroundColor !== "transparent" ?
							backgroundColor :
							"_default" );
					}

					value = value.toRgbaString();
				}
				try {
					elem.style[ hook ] = value;
				} catch ( e ) {

					// Wrapped to prevent IE from throwing errors on "invalid" values like
					// 'auto' or 'inherit'
				}
			}
		};
		jQuery.fx.step[ hook ] = function( fx ) {
			if ( !fx.colorInit ) {
				fx.start = color( fx.elem, hook );
				fx.end = color( fx.end );
				fx.colorInit = true;
			}
			jQuery.cssHooks[ hook ].set( fx.elem, fx.start.transition( fx.end, fx.pos ) );
		};
	} );

};

color.hook( stepHooks );

jQuery.cssHooks.borderColor = {
	expand: function( value ) {
		var expanded = {};

		each( [ "Top", "Right", "Bottom", "Left" ], function( i, part ) {
			expanded[ "border" + part + "Color" ] = value;
		} );
		return expanded;
	}
};

// Basic color names only.
// Usage of any of the other color names requires adding yourself or including
// jquery.color.svg-names.js.
colors = jQuery.Color.names = {

	// 4.1. Basic color keywords
	aqua: "#00ffff",
	black: "#000000",
	blue: "#0000ff",
	fuchsia: "#ff00ff",
	gray: "#808080",
	green: "#008000",
	lime: "#00ff00",
	maroon: "#800000",
	navy: "#000080",
	olive: "#808000",
	purple: "#800080",
	red: "#ff0000",
	silver: "#c0c0c0",
	teal: "#008080",
	white: "#ffffff",
	yellow: "#ffff00",

	// 4.2.3. "transparent" color keyword
	transparent: [ null, null, null, 0 ],

	_default: "#ffffff"
};

} )( jQuery );

/******************************************************************************/
/****************************** CLASS ANIMATIONS ******************************/
/******************************************************************************/
( function() {

var classAnimationActions = [ "add", "remove", "toggle" ],
	shorthandStyles = {
		border: 1,
		borderBottom: 1,
		borderColor: 1,
		borderLeft: 1,
		borderRight: 1,
		borderTop: 1,
		borderWidth: 1,
		margin: 1,
		padding: 1
	};

$.each(
	[ "borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle" ],
	function( _, prop ) {
		$.fx.step[ prop ] = function( fx ) {
			if ( fx.end !== "none" && !fx.setAttr || fx.pos === 1 && !fx.setAttr ) {
				jQuery.style( fx.elem, prop, fx.end );
				fx.setAttr = true;
			}
		};
	}
);

function getElementStyles( elem ) {
	var key, len,
		style = elem.ownerDocument.defaultView ?
			elem.ownerDocument.defaultView.getComputedStyle( elem, null ) :
			elem.currentStyle,
		styles = {};

	if ( style && style.length && style[ 0 ] && style[ style[ 0 ] ] ) {
		len = style.length;
		while ( len-- ) {
			key = style[ len ];
			if ( typeof style[ key ] === "string" ) {
				styles[ $.camelCase( key ) ] = style[ key ];
			}
		}

	// Support: Opera, IE <9
	} else {
		for ( key in style ) {
			if ( typeof style[ key ] === "string" ) {
				styles[ key ] = style[ key ];
			}
		}
	}

	return styles;
}

function styleDifference( oldStyle, newStyle ) {
	var diff = {},
		name, value;

	for ( name in newStyle ) {
		value = newStyle[ name ];
		if ( oldStyle[ name ] !== value ) {
			if ( !shorthandStyles[ name ] ) {
				if ( $.fx.step[ name ] || !isNaN( parseFloat( value ) ) ) {
					diff[ name ] = value;
				}
			}
		}
	}

	return diff;
}

// Support: jQuery <1.8
if ( !$.fn.addBack ) {
	$.fn.addBack = function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	};
}

$.effects.animateClass = function( value, duration, easing, callback ) {
	var o = $.speed( duration, easing, callback );

	return this.queue( function() {
		var animated = $( this ),
			baseClass = animated.attr( "class" ) || "",
			applyClassChange,
			allAnimations = o.children ? animated.find( "*" ).addBack() : animated;

		// Map the animated objects to store the original styles.
		allAnimations = allAnimations.map( function() {
			var el = $( this );
			return {
				el: el,
				start: getElementStyles( this )
			};
		} );

		// Apply class change
		applyClassChange = function() {
			$.each( classAnimationActions, function( i, action ) {
				if ( value[ action ] ) {
					animated[ action + "Class" ]( value[ action ] );
				}
			} );
		};
		applyClassChange();

		// Map all animated objects again - calculate new styles and diff
		allAnimations = allAnimations.map( function() {
			this.end = getElementStyles( this.el[ 0 ] );
			this.diff = styleDifference( this.start, this.end );
			return this;
		} );

		// Apply original class
		animated.attr( "class", baseClass );

		// Map all animated objects again - this time collecting a promise
		allAnimations = allAnimations.map( function() {
			var styleInfo = this,
				dfd = $.Deferred(),
				opts = $.extend( {}, o, {
					queue: false,
					complete: function() {
						dfd.resolve( styleInfo );
					}
				} );

			this.el.animate( this.diff, opts );
			return dfd.promise();
		} );

		// Once all animations have completed:
		$.when.apply( $, allAnimations.get() ).done( function() {

			// Set the final class
			applyClassChange();

			// For each animated element,
			// clear all css properties that were animated
			$.each( arguments, function() {
				var el = this.el;
				$.each( this.diff, function( key ) {
					el.css( key, "" );
				} );
			} );

			// This is guarnteed to be there if you use jQuery.speed()
			// it also handles dequeuing the next anim...
			o.complete.call( animated[ 0 ] );
		} );
	} );
};

$.fn.extend( {
	addClass: ( function( orig ) {
		return function( classNames, speed, easing, callback ) {
			return speed ?
				$.effects.animateClass.call( this,
					{ add: classNames }, speed, easing, callback ) :
				orig.apply( this, arguments );
		};
	} )( $.fn.addClass ),

	removeClass: ( function( orig ) {
		return function( classNames, speed, easing, callback ) {
			return arguments.length > 1 ?
				$.effects.animateClass.call( this,
					{ remove: classNames }, speed, easing, callback ) :
				orig.apply( this, arguments );
		};
	} )( $.fn.removeClass ),

	toggleClass: ( function( orig ) {
		return function( classNames, force, speed, easing, callback ) {
			if ( typeof force === "boolean" || force === undefined ) {
				if ( !speed ) {

					// Without speed parameter
					return orig.apply( this, arguments );
				} else {
					return $.effects.animateClass.call( this,
						( force ? { add: classNames } : { remove: classNames } ),
						speed, easing, callback );
				}
			} else {

				// Without force parameter
				return $.effects.animateClass.call( this,
					{ toggle: classNames }, force, speed, easing );
			}
		};
	} )( $.fn.toggleClass ),

	switchClass: function( remove, add, speed, easing, callback ) {
		return $.effects.animateClass.call( this, {
			add: add,
			remove: remove
		}, speed, easing, callback );
	}
} );

} )();

/******************************************************************************/
/*********************************** EFFECTS **********************************/
/******************************************************************************/

( function() {

if ( $.expr && $.expr.filters && $.expr.filters.animated ) {
	$.expr.filters.animated = ( function( orig ) {
		return function( elem ) {
			return !!$( elem ).data( dataSpaceAnimated ) || orig( elem );
		};
	} )( $.expr.filters.animated );
}

if ( $.uiBackCompat !== false ) {
	$.extend( $.effects, {

		// Saves a set of properties in a data storage
		save: function( element, set ) {
			var i = 0, length = set.length;
			for ( ; i < length; i++ ) {
				if ( set[ i ] !== null ) {
					element.data( dataSpace + set[ i ], element[ 0 ].style[ set[ i ] ] );
				}
			}
		},

		// Restores a set of previously saved properties from a data storage
		restore: function( element, set ) {
			var val, i = 0, length = set.length;
			for ( ; i < length; i++ ) {
				if ( set[ i ] !== null ) {
					val = element.data( dataSpace + set[ i ] );
					element.css( set[ i ], val );
				}
			}
		},

		setMode: function( el, mode ) {
			if ( mode === "toggle" ) {
				mode = el.is( ":hidden" ) ? "show" : "hide";
			}
			return mode;
		},

		// Wraps the element around a wrapper that copies position properties
		createWrapper: function( element ) {

			// If the element is already wrapped, return it
			if ( element.parent().is( ".ui-effects-wrapper" ) ) {
				return element.parent();
			}

			// Wrap the element
			var props = {
					width: element.outerWidth( true ),
					height: element.outerHeight( true ),
					"float": element.css( "float" )
				},
				wrapper = $( "<div></div>" )
					.addClass( "ui-effects-wrapper" )
					.css( {
						fontSize: "100%",
						background: "transparent",
						border: "none",
						margin: 0,
						padding: 0
					} ),

				// Store the size in case width/height are defined in % - Fixes #5245
				size = {
					width: element.width(),
					height: element.height()
				},
				active = document.activeElement;

			// Support: Firefox
			// Firefox incorrectly exposes anonymous content
			// https://bugzilla.mozilla.org/show_bug.cgi?id=561664
			try {
				active.id;
			} catch ( e ) {
				active = document.body;
			}

			element.wrap( wrapper );

			// Fixes #7595 - Elements lose focus when wrapped.
			if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
				$( active ).trigger( "focus" );
			}

			// Hotfix for jQuery 1.4 since some change in wrap() seems to actually
			// lose the reference to the wrapped element
			wrapper = element.parent();

			// Transfer positioning properties to the wrapper
			if ( element.css( "position" ) === "static" ) {
				wrapper.css( { position: "relative" } );
				element.css( { position: "relative" } );
			} else {
				$.extend( props, {
					position: element.css( "position" ),
					zIndex: element.css( "z-index" )
				} );
				$.each( [ "top", "left", "bottom", "right" ], function( i, pos ) {
					props[ pos ] = element.css( pos );
					if ( isNaN( parseInt( props[ pos ], 10 ) ) ) {
						props[ pos ] = "auto";
					}
				} );
				element.css( {
					position: "relative",
					top: 0,
					left: 0,
					right: "auto",
					bottom: "auto"
				} );
			}
			element.css( size );

			return wrapper.css( props ).show();
		},

		removeWrapper: function( element ) {
			var active = document.activeElement;

			if ( element.parent().is( ".ui-effects-wrapper" ) ) {
				element.parent().replaceWith( element );

				// Fixes #7595 - Elements lose focus when wrapped.
				if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
					$( active ).trigger( "focus" );
				}
			}

			return element;
		}
	} );
}

$.extend( $.effects, {
	version: "1.12.1",

	define: function( name, mode, effect ) {
		if ( !effect ) {
			effect = mode;
			mode = "effect";
		}

		$.effects.effect[ name ] = effect;
		$.effects.effect[ name ].mode = mode;

		return effect;
	},

	scaledDimensions: function( element, percent, direction ) {
		if ( percent === 0 ) {
			return {
				height: 0,
				width: 0,
				outerHeight: 0,
				outerWidth: 0
			};
		}

		var x = direction !== "horizontal" ? ( ( percent || 100 ) / 100 ) : 1,
			y = direction !== "vertical" ? ( ( percent || 100 ) / 100 ) : 1;

		return {
			height: element.height() * y,
			width: element.width() * x,
			outerHeight: element.outerHeight() * y,
			outerWidth: element.outerWidth() * x
		};

	},

	clipToBox: function( animation ) {
		return {
			width: animation.clip.right - animation.clip.left,
			height: animation.clip.bottom - animation.clip.top,
			left: animation.clip.left,
			top: animation.clip.top
		};
	},

	// Injects recently queued functions to be first in line (after "inprogress")
	unshift: function( element, queueLength, count ) {
		var queue = element.queue();

		if ( queueLength > 1 ) {
			queue.splice.apply( queue,
				[ 1, 0 ].concat( queue.splice( queueLength, count ) ) );
		}
		element.dequeue();
	},

	saveStyle: function( element ) {
		element.data( dataSpaceStyle, element[ 0 ].style.cssText );
	},

	restoreStyle: function( element ) {
		element[ 0 ].style.cssText = element.data( dataSpaceStyle ) || "";
		element.removeData( dataSpaceStyle );
	},

	mode: function( element, mode ) {
		var hidden = element.is( ":hidden" );

		if ( mode === "toggle" ) {
			mode = hidden ? "show" : "hide";
		}
		if ( hidden ? mode === "hide" : mode === "show" ) {
			mode = "none";
		}
		return mode;
	},

	// Translates a [top,left] array into a baseline value
	getBaseline: function( origin, original ) {
		var y, x;

		switch ( origin[ 0 ] ) {
		case "top":
			y = 0;
			break;
		case "middle":
			y = 0.5;
			break;
		case "bottom":
			y = 1;
			break;
		default:
			y = origin[ 0 ] / original.height;
		}

		switch ( origin[ 1 ] ) {
		case "left":
			x = 0;
			break;
		case "center":
			x = 0.5;
			break;
		case "right":
			x = 1;
			break;
		default:
			x = origin[ 1 ] / original.width;
		}

		return {
			x: x,
			y: y
		};
	},

	// Creates a placeholder element so that the original element can be made absolute
	createPlaceholder: function( element ) {
		var placeholder,
			cssPosition = element.css( "position" ),
			position = element.position();

		// Lock in margins first to account for form elements, which
		// will change margin if you explicitly set height
		// see: http://jsfiddle.net/JZSMt/3/ https://bugs.webkit.org/show_bug.cgi?id=107380
		// Support: Safari
		element.css( {
			marginTop: element.css( "marginTop" ),
			marginBottom: element.css( "marginBottom" ),
			marginLeft: element.css( "marginLeft" ),
			marginRight: element.css( "marginRight" )
		} )
		.outerWidth( element.outerWidth() )
		.outerHeight( element.outerHeight() );

		if ( /^(static|relative)/.test( cssPosition ) ) {
			cssPosition = "absolute";

			placeholder = $( "<" + element[ 0 ].nodeName + ">" ).insertAfter( element ).css( {

				// Convert inline to inline block to account for inline elements
				// that turn to inline block based on content (like img)
				display: /^(inline|ruby)/.test( element.css( "display" ) ) ?
					"inline-block" :
					"block",
				visibility: "hidden",

				// Margins need to be set to account for margin collapse
				marginTop: element.css( "marginTop" ),
				marginBottom: element.css( "marginBottom" ),
				marginLeft: element.css( "marginLeft" ),
				marginRight: element.css( "marginRight" ),
				"float": element.css( "float" )
			} )
			.outerWidth( element.outerWidth() )
			.outerHeight( element.outerHeight() )
			.addClass( "ui-effects-placeholder" );

			element.data( dataSpace + "placeholder", placeholder );
		}

		element.css( {
			position: cssPosition,
			left: position.left,
			top: position.top
		} );

		return placeholder;
	},

	removePlaceholder: function( element ) {
		var dataKey = dataSpace + "placeholder",
				placeholder = element.data( dataKey );

		if ( placeholder ) {
			placeholder.remove();
			element.removeData( dataKey );
		}
	},

	// Removes a placeholder if it exists and restores
	// properties that were modified during placeholder creation
	cleanUp: function( element ) {
		$.effects.restoreStyle( element );
		$.effects.removePlaceholder( element );
	},

	setTransition: function( element, list, factor, value ) {
		value = value || {};
		$.each( list, function( i, x ) {
			var unit = element.cssUnit( x );
			if ( unit[ 0 ] > 0 ) {
				value[ x ] = unit[ 0 ] * factor + unit[ 1 ];
			}
		} );
		return value;
	}
} );

// Return an effect options object for the given parameters:
function _normalizeArguments( effect, options, speed, callback ) {

	// Allow passing all options as the first parameter
	if ( $.isPlainObject( effect ) ) {
		options = effect;
		effect = effect.effect;
	}

	// Convert to an object
	effect = { effect: effect };

	// Catch (effect, null, ...)
	if ( options == null ) {
		options = {};
	}

	// Catch (effect, callback)
	if ( $.isFunction( options ) ) {
		callback = options;
		speed = null;
		options = {};
	}

	// Catch (effect, speed, ?)
	if ( typeof options === "number" || $.fx.speeds[ options ] ) {
		callback = speed;
		speed = options;
		options = {};
	}

	// Catch (effect, options, callback)
	if ( $.isFunction( speed ) ) {
		callback = speed;
		speed = null;
	}

	// Add options to effect
	if ( options ) {
		$.extend( effect, options );
	}

	speed = speed || options.duration;
	effect.duration = $.fx.off ? 0 :
		typeof speed === "number" ? speed :
		speed in $.fx.speeds ? $.fx.speeds[ speed ] :
		$.fx.speeds._default;

	effect.complete = callback || options.complete;

	return effect;
}

function standardAnimationOption( option ) {

	// Valid standard speeds (nothing, number, named speed)
	if ( !option || typeof option === "number" || $.fx.speeds[ option ] ) {
		return true;
	}

	// Invalid strings - treat as "normal" speed
	if ( typeof option === "string" && !$.effects.effect[ option ] ) {
		return true;
	}

	// Complete callback
	if ( $.isFunction( option ) ) {
		return true;
	}

	// Options hash (but not naming an effect)
	if ( typeof option === "object" && !option.effect ) {
		return true;
	}

	// Didn't match any standard API
	return false;
}

$.fn.extend( {
	effect: function( /* effect, options, speed, callback */ ) {
		var args = _normalizeArguments.apply( this, arguments ),
			effectMethod = $.effects.effect[ args.effect ],
			defaultMode = effectMethod.mode,
			queue = args.queue,
			queueName = queue || "fx",
			complete = args.complete,
			mode = args.mode,
			modes = [],
			prefilter = function( next ) {
				var el = $( this ),
					normalizedMode = $.effects.mode( el, mode ) || defaultMode;

				// Sentinel for duck-punching the :animated psuedo-selector
				el.data( dataSpaceAnimated, true );

				// Save effect mode for later use,
				// we can't just call $.effects.mode again later,
				// as the .show() below destroys the initial state
				modes.push( normalizedMode );

				// See $.uiBackCompat inside of run() for removal of defaultMode in 1.13
				if ( defaultMode && ( normalizedMode === "show" ||
						( normalizedMode === defaultMode && normalizedMode === "hide" ) ) ) {
					el.show();
				}

				if ( !defaultMode || normalizedMode !== "none" ) {
					$.effects.saveStyle( el );
				}

				if ( $.isFunction( next ) ) {
					next();
				}
			};

		if ( $.fx.off || !effectMethod ) {

			// Delegate to the original method (e.g., .show()) if possible
			if ( mode ) {
				return this[ mode ]( args.duration, complete );
			} else {
				return this.each( function() {
					if ( complete ) {
						complete.call( this );
					}
				} );
			}
		}

		function run( next ) {
			var elem = $( this );

			function cleanup() {
				elem.removeData( dataSpaceAnimated );

				$.effects.cleanUp( elem );

				if ( args.mode === "hide" ) {
					elem.hide();
				}

				done();
			}

			function done() {
				if ( $.isFunction( complete ) ) {
					complete.call( elem[ 0 ] );
				}

				if ( $.isFunction( next ) ) {
					next();
				}
			}

			// Override mode option on a per element basis,
			// as toggle can be either show or hide depending on element state
			args.mode = modes.shift();

			if ( $.uiBackCompat !== false && !defaultMode ) {
				if ( elem.is( ":hidden" ) ? mode === "hide" : mode === "show" ) {

					// Call the core method to track "olddisplay" properly
					elem[ mode ]();
					done();
				} else {
					effectMethod.call( elem[ 0 ], args, done );
				}
			} else {
				if ( args.mode === "none" ) {

					// Call the core method to track "olddisplay" properly
					elem[ mode ]();
					done();
				} else {
					effectMethod.call( elem[ 0 ], args, cleanup );
				}
			}
		}

		// Run prefilter on all elements first to ensure that
		// any showing or hiding happens before placeholder creation,
		// which ensures that any layout changes are correctly captured.
		return queue === false ?
			this.each( prefilter ).each( run ) :
			this.queue( queueName, prefilter ).queue( queueName, run );
	},

	show: ( function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "show";
				return this.effect.call( this, args );
			}
		};
	} )( $.fn.show ),

	hide: ( function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "hide";
				return this.effect.call( this, args );
			}
		};
	} )( $.fn.hide ),

	toggle: ( function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) || typeof option === "boolean" ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "toggle";
				return this.effect.call( this, args );
			}
		};
	} )( $.fn.toggle ),

	cssUnit: function( key ) {
		var style = this.css( key ),
			val = [];

		$.each( [ "em", "px", "%", "pt" ], function( i, unit ) {
			if ( style.indexOf( unit ) > 0 ) {
				val = [ parseFloat( style ), unit ];
			}
		} );
		return val;
	},

	cssClip: function( clipObj ) {
		if ( clipObj ) {
			return this.css( "clip", "rect(" + clipObj.top + "px " + clipObj.right + "px " +
				clipObj.bottom + "px " + clipObj.left + "px)" );
		}
		return parseClip( this.css( "clip" ), this );
	},

	transfer: function( options, done ) {
		var element = $( this ),
			target = $( options.to ),
			targetFixed = target.css( "position" ) === "fixed",
			body = $( "body" ),
			fixTop = targetFixed ? body.scrollTop() : 0,
			fixLeft = targetFixed ? body.scrollLeft() : 0,
			endPosition = target.offset(),
			animation = {
				top: endPosition.top - fixTop,
				left: endPosition.left - fixLeft,
				height: target.innerHeight(),
				width: target.innerWidth()
			},
			startPosition = element.offset(),
			transfer = $( "<div class='ui-effects-transfer'></div>" )
				.appendTo( "body" )
				.addClass( options.className )
				.css( {
					top: startPosition.top - fixTop,
					left: startPosition.left - fixLeft,
					height: element.innerHeight(),
					width: element.innerWidth(),
					position: targetFixed ? "fixed" : "absolute"
				} )
				.animate( animation, options.duration, options.easing, function() {
					transfer.remove();
					if ( $.isFunction( done ) ) {
						done();
					}
				} );
	}
} );

function parseClip( str, element ) {
		var outerWidth = element.outerWidth(),
			outerHeight = element.outerHeight(),
			clipRegex = /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/,
			values = clipRegex.exec( str ) || [ "", 0, outerWidth, outerHeight, 0 ];

		return {
			top: parseFloat( values[ 1 ] ) || 0,
			right: values[ 2 ] === "auto" ? outerWidth : parseFloat( values[ 2 ] ),
			bottom: values[ 3 ] === "auto" ? outerHeight : parseFloat( values[ 3 ] ),
			left: parseFloat( values[ 4 ] ) || 0
		};
}

$.fx.step.clip = function( fx ) {
	if ( !fx.clipInit ) {
		fx.start = $( fx.elem ).cssClip();
		if ( typeof fx.end === "string" ) {
			fx.end = parseClip( fx.end, fx.elem );
		}
		fx.clipInit = true;
	}

	$( fx.elem ).cssClip( {
		top: fx.pos * ( fx.end.top - fx.start.top ) + fx.start.top,
		right: fx.pos * ( fx.end.right - fx.start.right ) + fx.start.right,
		bottom: fx.pos * ( fx.end.bottom - fx.start.bottom ) + fx.start.bottom,
		left: fx.pos * ( fx.end.left - fx.start.left ) + fx.start.left
	} );
};

} )();

/******************************************************************************/
/*********************************** EASING ***********************************/
/******************************************************************************/

( function() {

// Based on easing equations from Robert Penner (http://www.robertpenner.com/easing)

var baseEasings = {};

$.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function( i, name ) {
	baseEasings[ name ] = function( p ) {
		return Math.pow( p, i + 2 );
	};
} );

$.extend( baseEasings, {
	Sine: function( p ) {
		return 1 - Math.cos( p * Math.PI / 2 );
	},
	Circ: function( p ) {
		return 1 - Math.sqrt( 1 - p * p );
	},
	Elastic: function( p ) {
		return p === 0 || p === 1 ? p :
			-Math.pow( 2, 8 * ( p - 1 ) ) * Math.sin( ( ( p - 1 ) * 80 - 7.5 ) * Math.PI / 15 );
	},
	Back: function( p ) {
		return p * p * ( 3 * p - 2 );
	},
	Bounce: function( p ) {
		var pow2,
			bounce = 4;

		while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
		return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
	}
} );

$.each( baseEasings, function( name, easeIn ) {
	$.easing[ "easeIn" + name ] = easeIn;
	$.easing[ "easeOut" + name ] = function( p ) {
		return 1 - easeIn( 1 - p );
	};
	$.easing[ "easeInOut" + name ] = function( p ) {
		return p < 0.5 ?
			easeIn( p * 2 ) / 2 :
			1 - easeIn( p * -2 + 2 ) / 2;
	};
} );

} )();

var effect = $.effects;


/*!
 * jQuery UI Effects Blind 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Blind Effect
//>>group: Effects
//>>description: Blinds the element.
//>>docs: http://api.jqueryui.com/blind-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectBlind = $.effects.define( "blind", "hide", function( options, done ) {
	var map = {
			up: [ "bottom", "top" ],
			vertical: [ "bottom", "top" ],
			down: [ "top", "bottom" ],
			left: [ "right", "left" ],
			horizontal: [ "right", "left" ],
			right: [ "left", "right" ]
		},
		element = $( this ),
		direction = options.direction || "up",
		start = element.cssClip(),
		animate = { clip: $.extend( {}, start ) },
		placeholder = $.effects.createPlaceholder( element );

	animate.clip[ map[ direction ][ 0 ] ] = animate.clip[ map[ direction ][ 1 ] ];

	if ( options.mode === "show" ) {
		element.cssClip( animate.clip );
		if ( placeholder ) {
			placeholder.css( $.effects.clipToBox( animate ) );
		}

		animate.clip = start;
	}

	if ( placeholder ) {
		placeholder.animate( $.effects.clipToBox( animate ), options.duration, options.easing );
	}

	element.animate( animate, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );
} );


/*!
 * jQuery UI Effects Bounce 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Bounce Effect
//>>group: Effects
//>>description: Bounces an element horizontally or vertically n times.
//>>docs: http://api.jqueryui.com/bounce-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectBounce = $.effects.define( "bounce", function( options, done ) {
	var upAnim, downAnim, refValue,
		element = $( this ),

		// Defaults:
		mode = options.mode,
		hide = mode === "hide",
		show = mode === "show",
		direction = options.direction || "up",
		distance = options.distance,
		times = options.times || 5,

		// Number of internal animations
		anims = times * 2 + ( show || hide ? 1 : 0 ),
		speed = options.duration / anims,
		easing = options.easing,

		// Utility:
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		motion = ( direction === "up" || direction === "left" ),
		i = 0,

		queuelen = element.queue().length;

	$.effects.createPlaceholder( element );

	refValue = element.css( ref );

	// Default distance for the BIGGEST bounce is the outer Distance / 3
	if ( !distance ) {
		distance = element[ ref === "top" ? "outerHeight" : "outerWidth" ]() / 3;
	}

	if ( show ) {
		downAnim = { opacity: 1 };
		downAnim[ ref ] = refValue;

		// If we are showing, force opacity 0 and set the initial position
		// then do the "first" animation
		element
			.css( "opacity", 0 )
			.css( ref, motion ? -distance * 2 : distance * 2 )
			.animate( downAnim, speed, easing );
	}

	// Start at the smallest distance if we are hiding
	if ( hide ) {
		distance = distance / Math.pow( 2, times - 1 );
	}

	downAnim = {};
	downAnim[ ref ] = refValue;

	// Bounces up/down/left/right then back to 0 -- times * 2 animations happen here
	for ( ; i < times; i++ ) {
		upAnim = {};
		upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

		element
			.animate( upAnim, speed, easing )
			.animate( downAnim, speed, easing );

		distance = hide ? distance * 2 : distance / 2;
	}

	// Last Bounce when Hiding
	if ( hide ) {
		upAnim = { opacity: 0 };
		upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

		element.animate( upAnim, speed, easing );
	}

	element.queue( done );

	$.effects.unshift( element, queuelen, anims + 1 );
} );


/*!
 * jQuery UI Effects Clip 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Clip Effect
//>>group: Effects
//>>description: Clips the element on and off like an old TV.
//>>docs: http://api.jqueryui.com/clip-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectClip = $.effects.define( "clip", "hide", function( options, done ) {
	var start,
		animate = {},
		element = $( this ),
		direction = options.direction || "vertical",
		both = direction === "both",
		horizontal = both || direction === "horizontal",
		vertical = both || direction === "vertical";

	start = element.cssClip();
	animate.clip = {
		top: vertical ? ( start.bottom - start.top ) / 2 : start.top,
		right: horizontal ? ( start.right - start.left ) / 2 : start.right,
		bottom: vertical ? ( start.bottom - start.top ) / 2 : start.bottom,
		left: horizontal ? ( start.right - start.left ) / 2 : start.left
	};

	$.effects.createPlaceholder( element );

	if ( options.mode === "show" ) {
		element.cssClip( animate.clip );
		animate.clip = start;
	}

	element.animate( animate, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );

} );


/*!
 * jQuery UI Effects Drop 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Drop Effect
//>>group: Effects
//>>description: Moves an element in one direction and hides it at the same time.
//>>docs: http://api.jqueryui.com/drop-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectDrop = $.effects.define( "drop", "hide", function( options, done ) {

	var distance,
		element = $( this ),
		mode = options.mode,
		show = mode === "show",
		direction = options.direction || "left",
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		motion = ( direction === "up" || direction === "left" ) ? "-=" : "+=",
		oppositeMotion = ( motion === "+=" ) ? "-=" : "+=",
		animation = {
			opacity: 0
		};

	$.effects.createPlaceholder( element );

	distance = options.distance ||
		element[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ) / 2;

	animation[ ref ] = motion + distance;

	if ( show ) {
		element.css( animation );

		animation[ ref ] = oppositeMotion + distance;
		animation.opacity = 1;
	}

	// Animate
	element.animate( animation, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );
} );


/*!
 * jQuery UI Effects Explode 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Explode Effect
//>>group: Effects
// jscs:disable maximumLineLength
//>>description: Explodes an element in all directions into n pieces. Implodes an element to its original wholeness.
// jscs:enable maximumLineLength
//>>docs: http://api.jqueryui.com/explode-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectExplode = $.effects.define( "explode", "hide", function( options, done ) {

	var i, j, left, top, mx, my,
		rows = options.pieces ? Math.round( Math.sqrt( options.pieces ) ) : 3,
		cells = rows,
		element = $( this ),
		mode = options.mode,
		show = mode === "show",

		// Show and then visibility:hidden the element before calculating offset
		offset = element.show().css( "visibility", "hidden" ).offset(),

		// Width and height of a piece
		width = Math.ceil( element.outerWidth() / cells ),
		height = Math.ceil( element.outerHeight() / rows ),
		pieces = [];

	// Children animate complete:
	function childComplete() {
		pieces.push( this );
		if ( pieces.length === rows * cells ) {
			animComplete();
		}
	}

	// Clone the element for each row and cell.
	for ( i = 0; i < rows; i++ ) { // ===>
		top = offset.top + i * height;
		my = i - ( rows - 1 ) / 2;

		for ( j = 0; j < cells; j++ ) { // |||
			left = offset.left + j * width;
			mx = j - ( cells - 1 ) / 2;

			// Create a clone of the now hidden main element that will be absolute positioned
			// within a wrapper div off the -left and -top equal to size of our pieces
			element
				.clone()
				.appendTo( "body" )
				.wrap( "<div></div>" )
				.css( {
					position: "absolute",
					visibility: "visible",
					left: -j * width,
					top: -i * height
				} )

				// Select the wrapper - make it overflow: hidden and absolute positioned based on
				// where the original was located +left and +top equal to the size of pieces
				.parent()
					.addClass( "ui-effects-explode" )
					.css( {
						position: "absolute",
						overflow: "hidden",
						width: width,
						height: height,
						left: left + ( show ? mx * width : 0 ),
						top: top + ( show ? my * height : 0 ),
						opacity: show ? 0 : 1
					} )
					.animate( {
						left: left + ( show ? 0 : mx * width ),
						top: top + ( show ? 0 : my * height ),
						opacity: show ? 1 : 0
					}, options.duration || 500, options.easing, childComplete );
		}
	}

	function animComplete() {
		element.css( {
			visibility: "visible"
		} );
		$( pieces ).remove();
		done();
	}
} );


/*!
 * jQuery UI Effects Fade 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Fade Effect
//>>group: Effects
//>>description: Fades the element.
//>>docs: http://api.jqueryui.com/fade-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectFade = $.effects.define( "fade", "toggle", function( options, done ) {
	var show = options.mode === "show";

	$( this )
		.css( "opacity", show ? 0 : 1 )
		.animate( {
			opacity: show ? 1 : 0
		}, {
			queue: false,
			duration: options.duration,
			easing: options.easing,
			complete: done
		} );
} );


/*!
 * jQuery UI Effects Fold 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Fold Effect
//>>group: Effects
//>>description: Folds an element first horizontally and then vertically.
//>>docs: http://api.jqueryui.com/fold-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectFold = $.effects.define( "fold", "hide", function( options, done ) {

	// Create element
	var element = $( this ),
		mode = options.mode,
		show = mode === "show",
		hide = mode === "hide",
		size = options.size || 15,
		percent = /([0-9]+)%/.exec( size ),
		horizFirst = !!options.horizFirst,
		ref = horizFirst ? [ "right", "bottom" ] : [ "bottom", "right" ],
		duration = options.duration / 2,

		placeholder = $.effects.createPlaceholder( element ),

		start = element.cssClip(),
		animation1 = { clip: $.extend( {}, start ) },
		animation2 = { clip: $.extend( {}, start ) },

		distance = [ start[ ref[ 0 ] ], start[ ref[ 1 ] ] ],

		queuelen = element.queue().length;

	if ( percent ) {
		size = parseInt( percent[ 1 ], 10 ) / 100 * distance[ hide ? 0 : 1 ];
	}
	animation1.clip[ ref[ 0 ] ] = size;
	animation2.clip[ ref[ 0 ] ] = size;
	animation2.clip[ ref[ 1 ] ] = 0;

	if ( show ) {
		element.cssClip( animation2.clip );
		if ( placeholder ) {
			placeholder.css( $.effects.clipToBox( animation2 ) );
		}

		animation2.clip = start;
	}

	// Animate
	element
		.queue( function( next ) {
			if ( placeholder ) {
				placeholder
					.animate( $.effects.clipToBox( animation1 ), duration, options.easing )
					.animate( $.effects.clipToBox( animation2 ), duration, options.easing );
			}

			next();
		} )
		.animate( animation1, duration, options.easing )
		.animate( animation2, duration, options.easing )
		.queue( done );

	$.effects.unshift( element, queuelen, 4 );
} );


/*!
 * jQuery UI Effects Highlight 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Highlight Effect
//>>group: Effects
//>>description: Highlights the background of an element in a defined color for a custom duration.
//>>docs: http://api.jqueryui.com/highlight-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectHighlight = $.effects.define( "highlight", "show", function( options, done ) {
	var element = $( this ),
		animation = {
			backgroundColor: element.css( "backgroundColor" )
		};

	if ( options.mode === "hide" ) {
		animation.opacity = 0;
	}

	$.effects.saveStyle( element );

	element
		.css( {
			backgroundImage: "none",
			backgroundColor: options.color || "#ffff99"
		} )
		.animate( animation, {
			queue: false,
			duration: options.duration,
			easing: options.easing,
			complete: done
		} );
} );


/*!
 * jQuery UI Effects Size 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Size Effect
//>>group: Effects
//>>description: Resize an element to a specified width and height.
//>>docs: http://api.jqueryui.com/size-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectSize = $.effects.define( "size", function( options, done ) {

	// Create element
	var baseline, factor, temp,
		element = $( this ),

		// Copy for children
		cProps = [ "fontSize" ],
		vProps = [ "borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom" ],
		hProps = [ "borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight" ],

		// Set options
		mode = options.mode,
		restore = mode !== "effect",
		scale = options.scale || "both",
		origin = options.origin || [ "middle", "center" ],
		position = element.css( "position" ),
		pos = element.position(),
		original = $.effects.scaledDimensions( element ),
		from = options.from || original,
		to = options.to || $.effects.scaledDimensions( element, 0 );

	$.effects.createPlaceholder( element );

	if ( mode === "show" ) {
		temp = from;
		from = to;
		to = temp;
	}

	// Set scaling factor
	factor = {
		from: {
			y: from.height / original.height,
			x: from.width / original.width
		},
		to: {
			y: to.height / original.height,
			x: to.width / original.width
		}
	};

	// Scale the css box
	if ( scale === "box" || scale === "both" ) {

		// Vertical props scaling
		if ( factor.from.y !== factor.to.y ) {
			from = $.effects.setTransition( element, vProps, factor.from.y, from );
			to = $.effects.setTransition( element, vProps, factor.to.y, to );
		}

		// Horizontal props scaling
		if ( factor.from.x !== factor.to.x ) {
			from = $.effects.setTransition( element, hProps, factor.from.x, from );
			to = $.effects.setTransition( element, hProps, factor.to.x, to );
		}
	}

	// Scale the content
	if ( scale === "content" || scale === "both" ) {

		// Vertical props scaling
		if ( factor.from.y !== factor.to.y ) {
			from = $.effects.setTransition( element, cProps, factor.from.y, from );
			to = $.effects.setTransition( element, cProps, factor.to.y, to );
		}
	}

	// Adjust the position properties based on the provided origin points
	if ( origin ) {
		baseline = $.effects.getBaseline( origin, original );
		from.top = ( original.outerHeight - from.outerHeight ) * baseline.y + pos.top;
		from.left = ( original.outerWidth - from.outerWidth ) * baseline.x + pos.left;
		to.top = ( original.outerHeight - to.outerHeight ) * baseline.y + pos.top;
		to.left = ( original.outerWidth - to.outerWidth ) * baseline.x + pos.left;
	}
	element.css( from );

	// Animate the children if desired
	if ( scale === "content" || scale === "both" ) {

		vProps = vProps.concat( [ "marginTop", "marginBottom" ] ).concat( cProps );
		hProps = hProps.concat( [ "marginLeft", "marginRight" ] );

		// Only animate children with width attributes specified
		// TODO: is this right? should we include anything with css width specified as well
		element.find( "*[width]" ).each( function() {
			var child = $( this ),
				childOriginal = $.effects.scaledDimensions( child ),
				childFrom = {
					height: childOriginal.height * factor.from.y,
					width: childOriginal.width * factor.from.x,
					outerHeight: childOriginal.outerHeight * factor.from.y,
					outerWidth: childOriginal.outerWidth * factor.from.x
				},
				childTo = {
					height: childOriginal.height * factor.to.y,
					width: childOriginal.width * factor.to.x,
					outerHeight: childOriginal.height * factor.to.y,
					outerWidth: childOriginal.width * factor.to.x
				};

			// Vertical props scaling
			if ( factor.from.y !== factor.to.y ) {
				childFrom = $.effects.setTransition( child, vProps, factor.from.y, childFrom );
				childTo = $.effects.setTransition( child, vProps, factor.to.y, childTo );
			}

			// Horizontal props scaling
			if ( factor.from.x !== factor.to.x ) {
				childFrom = $.effects.setTransition( child, hProps, factor.from.x, childFrom );
				childTo = $.effects.setTransition( child, hProps, factor.to.x, childTo );
			}

			if ( restore ) {
				$.effects.saveStyle( child );
			}

			// Animate children
			child.css( childFrom );
			child.animate( childTo, options.duration, options.easing, function() {

				// Restore children
				if ( restore ) {
					$.effects.restoreStyle( child );
				}
			} );
		} );
	}

	// Animate
	element.animate( to, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: function() {

			var offset = element.offset();

			if ( to.opacity === 0 ) {
				element.css( "opacity", from.opacity );
			}

			if ( !restore ) {
				element
					.css( "position", position === "static" ? "relative" : position )
					.offset( offset );

				// Need to save style here so that automatic style restoration
				// doesn't restore to the original styles from before the animation.
				$.effects.saveStyle( element );
			}

			done();
		}
	} );

} );


/*!
 * jQuery UI Effects Scale 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Scale Effect
//>>group: Effects
//>>description: Grows or shrinks an element and its content.
//>>docs: http://api.jqueryui.com/scale-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectScale = $.effects.define( "scale", function( options, done ) {

	// Create element
	var el = $( this ),
		mode = options.mode,
		percent = parseInt( options.percent, 10 ) ||
			( parseInt( options.percent, 10 ) === 0 ? 0 : ( mode !== "effect" ? 0 : 100 ) ),

		newOptions = $.extend( true, {
			from: $.effects.scaledDimensions( el ),
			to: $.effects.scaledDimensions( el, percent, options.direction || "both" ),
			origin: options.origin || [ "middle", "center" ]
		}, options );

	// Fade option to support puff
	if ( options.fade ) {
		newOptions.from.opacity = 1;
		newOptions.to.opacity = 0;
	}

	$.effects.effect.size.call( this, newOptions, done );
} );


/*!
 * jQuery UI Effects Puff 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Puff Effect
//>>group: Effects
//>>description: Creates a puff effect by scaling the element up and hiding it at the same time.
//>>docs: http://api.jqueryui.com/puff-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectPuff = $.effects.define( "puff", "hide", function( options, done ) {
	var newOptions = $.extend( true, {}, options, {
		fade: true,
		percent: parseInt( options.percent, 10 ) || 150
	} );

	$.effects.effect.scale.call( this, newOptions, done );
} );


/*!
 * jQuery UI Effects Pulsate 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Pulsate Effect
//>>group: Effects
//>>description: Pulsates an element n times by changing the opacity to zero and back.
//>>docs: http://api.jqueryui.com/pulsate-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectPulsate = $.effects.define( "pulsate", "show", function( options, done ) {
	var element = $( this ),
		mode = options.mode,
		show = mode === "show",
		hide = mode === "hide",
		showhide = show || hide,

		// Showing or hiding leaves off the "last" animation
		anims = ( ( options.times || 5 ) * 2 ) + ( showhide ? 1 : 0 ),
		duration = options.duration / anims,
		animateTo = 0,
		i = 1,
		queuelen = element.queue().length;

	if ( show || !element.is( ":visible" ) ) {
		element.css( "opacity", 0 ).show();
		animateTo = 1;
	}

	// Anims - 1 opacity "toggles"
	for ( ; i < anims; i++ ) {
		element.animate( { opacity: animateTo }, duration, options.easing );
		animateTo = 1 - animateTo;
	}

	element.animate( { opacity: animateTo }, duration, options.easing );

	element.queue( done );

	$.effects.unshift( element, queuelen, anims + 1 );
} );


/*!
 * jQuery UI Effects Shake 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Shake Effect
//>>group: Effects
//>>description: Shakes an element horizontally or vertically n times.
//>>docs: http://api.jqueryui.com/shake-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectShake = $.effects.define( "shake", function( options, done ) {

	var i = 1,
		element = $( this ),
		direction = options.direction || "left",
		distance = options.distance || 20,
		times = options.times || 3,
		anims = times * 2 + 1,
		speed = Math.round( options.duration / anims ),
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		positiveMotion = ( direction === "up" || direction === "left" ),
		animation = {},
		animation1 = {},
		animation2 = {},

		queuelen = element.queue().length;

	$.effects.createPlaceholder( element );

	// Animation
	animation[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance;
	animation1[ ref ] = ( positiveMotion ? "+=" : "-=" ) + distance * 2;
	animation2[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance * 2;

	// Animate
	element.animate( animation, speed, options.easing );

	// Shakes
	for ( ; i < times; i++ ) {
		element
			.animate( animation1, speed, options.easing )
			.animate( animation2, speed, options.easing );
	}

	element
		.animate( animation1, speed, options.easing )
		.animate( animation, speed / 2, options.easing )
		.queue( done );

	$.effects.unshift( element, queuelen, anims + 1 );
} );


/*!
 * jQuery UI Effects Slide 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Slide Effect
//>>group: Effects
//>>description: Slides an element in and out of the viewport.
//>>docs: http://api.jqueryui.com/slide-effect/
//>>demos: http://jqueryui.com/effect/



var effectsEffectSlide = $.effects.define( "slide", "show", function( options, done ) {
	var startClip, startRef,
		element = $( this ),
		map = {
			up: [ "bottom", "top" ],
			down: [ "top", "bottom" ],
			left: [ "right", "left" ],
			right: [ "left", "right" ]
		},
		mode = options.mode,
		direction = options.direction || "left",
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		positiveMotion = ( direction === "up" || direction === "left" ),
		distance = options.distance ||
			element[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ),
		animation = {};

	$.effects.createPlaceholder( element );

	startClip = element.cssClip();
	startRef = element.position()[ ref ];

	// Define hide animation
	animation[ ref ] = ( positiveMotion ? -1 : 1 ) * distance + startRef;
	animation.clip = element.cssClip();
	animation.clip[ map[ direction ][ 1 ] ] = animation.clip[ map[ direction ][ 0 ] ];

	// Reverse the animation if we're showing
	if ( mode === "show" ) {
		element.cssClip( animation.clip );
		element.css( ref, animation[ ref ] );
		animation.clip = startClip;
		animation[ ref ] = startRef;
	}

	// Actually animate
	element.animate( animation, {
		queue: false,
		duration: options.duration,
		easing: options.easing,
		complete: done
	} );
} );


/*!
 * jQuery UI Effects Transfer 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Transfer Effect
//>>group: Effects
//>>description: Displays a transfer effect from one element to another.
//>>docs: http://api.jqueryui.com/transfer-effect/
//>>demos: http://jqueryui.com/effect/



var effect;
if ( $.uiBackCompat !== false ) {
	effect = $.effects.define( "transfer", function( options, done ) {
		$( this ).transfer( options, done );
	} );
}
var effectsEffectTransfer = effect;


/*!
 * jQuery UI Focusable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: :focusable Selector
//>>group: Core
//>>description: Selects elements which can be focused.
//>>docs: http://api.jqueryui.com/focusable-selector/



// Selectors
$.ui.focusable = function( element, hasTabindex ) {
	var map, mapName, img, focusableIfVisible, fieldset,
		nodeName = element.nodeName.toLowerCase();

	if ( "area" === nodeName ) {
		map = element.parentNode;
		mapName = map.name;
		if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
			return false;
		}
		img = $( "img[usemap='#" + mapName + "']" );
		return img.length > 0 && img.is( ":visible" );
	}

	if ( /^(input|select|textarea|button|object)$/.test( nodeName ) ) {
		focusableIfVisible = !element.disabled;

		if ( focusableIfVisible ) {

			// Form controls within a disabled fieldset are disabled.
			// However, controls within the fieldset's legend do not get disabled.
			// Since controls generally aren't placed inside legends, we skip
			// this portion of the check.
			fieldset = $( element ).closest( "fieldset" )[ 0 ];
			if ( fieldset ) {
				focusableIfVisible = !fieldset.disabled;
			}
		}
	} else if ( "a" === nodeName ) {
		focusableIfVisible = element.href || hasTabindex;
	} else {
		focusableIfVisible = hasTabindex;
	}

	return focusableIfVisible && $( element ).is( ":visible" ) && visible( $( element ) );
};

// Support: IE 8 only
// IE 8 doesn't resolve inherit to visible/hidden for computed values
function visible( element ) {
	var visibility = element.css( "visibility" );
	while ( visibility === "inherit" ) {
		element = element.parent();
		visibility = element.css( "visibility" );
	}
	return visibility !== "hidden";
}

$.extend( $.expr[ ":" ], {
	focusable: function( element ) {
		return $.ui.focusable( element, $.attr( element, "tabindex" ) != null );
	}
} );

var focusable = $.ui.focusable;




// Support: IE8 Only
// IE8 does not support the form attribute and when it is supplied. It overwrites the form prop
// with a string, so we need to find the proper form.
var form = $.fn.form = function() {
	return typeof this[ 0 ].form === "string" ? this.closest( "form" ) : $( this[ 0 ].form );
};


/*!
 * jQuery UI Form Reset Mixin 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Form Reset Mixin
//>>group: Core
//>>description: Refresh input widgets when their form is reset
//>>docs: http://api.jqueryui.com/form-reset-mixin/



var formResetMixin = $.ui.formResetMixin = {
	_formResetHandler: function() {
		var form = $( this );

		// Wait for the form reset to actually happen before refreshing
		setTimeout( function() {
			var instances = form.data( "ui-form-reset-instances" );
			$.each( instances, function() {
				this.refresh();
			} );
		} );
	},

	_bindFormResetHandler: function() {
		this.form = this.element.form();
		if ( !this.form.length ) {
			return;
		}

		var instances = this.form.data( "ui-form-reset-instances" ) || [];
		if ( !instances.length ) {

			// We don't use _on() here because we use a single event handler per form
			this.form.on( "reset.ui-form-reset", this._formResetHandler );
		}
		instances.push( this );
		this.form.data( "ui-form-reset-instances", instances );
	},

	_unbindFormResetHandler: function() {
		if ( !this.form.length ) {
			return;
		}

		var instances = this.form.data( "ui-form-reset-instances" );
		instances.splice( $.inArray( this, instances ), 1 );
		if ( instances.length ) {
			this.form.data( "ui-form-reset-instances", instances );
		} else {
			this.form
				.removeData( "ui-form-reset-instances" )
				.off( "reset.ui-form-reset" );
		}
	}
};


/*!
 * jQuery UI Support for jQuery core 1.7.x 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 */

//>>label: jQuery 1.7 Support
//>>group: Core
//>>description: Support version 1.7.x of jQuery core



// Support: jQuery 1.7 only
// Not a great way to check versions, but since we only support 1.7+ and only
// need to detect <1.8, this is a simple check that should suffice. Checking
// for "1.7." would be a bit safer, but the version string is 1.7, not 1.7.0
// and we'll never reach 1.70.0 (if we do, we certainly won't be supporting
// 1.7 anymore). See #11197 for why we're not using feature detection.
if ( $.fn.jquery.substring( 0, 3 ) === "1.7" ) {

	// Setters for .innerWidth(), .innerHeight(), .outerWidth(), .outerHeight()
	// Unlike jQuery Core 1.8+, these only support numeric values to set the
	// dimensions in pixels
	$.each( [ "Width", "Height" ], function( i, name ) {
		var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
			type = name.toLowerCase(),
			orig = {
				innerWidth: $.fn.innerWidth,
				innerHeight: $.fn.innerHeight,
				outerWidth: $.fn.outerWidth,
				outerHeight: $.fn.outerHeight
			};

		function reduce( elem, size, border, margin ) {
			$.each( side, function() {
				size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
				if ( border ) {
					size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
				}
				if ( margin ) {
					size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
				}
			} );
			return size;
		}

		$.fn[ "inner" + name ] = function( size ) {
			if ( size === undefined ) {
				return orig[ "inner" + name ].call( this );
			}

			return this.each( function() {
				$( this ).css( type, reduce( this, size ) + "px" );
			} );
		};

		$.fn[ "outer" + name ] = function( size, margin ) {
			if ( typeof size !== "number" ) {
				return orig[ "outer" + name ].call( this, size );
			}

			return this.each( function() {
				$( this ).css( type, reduce( this, size, true, margin ) + "px" );
			} );
		};
	} );

	$.fn.addBack = function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	};
}

;
/*!
 * jQuery UI Keycode 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Keycode
//>>group: Core
//>>description: Provide keycodes as keynames
//>>docs: http://api.jqueryui.com/jQuery.ui.keyCode/


var keycode = $.ui.keyCode = {
	BACKSPACE: 8,
	COMMA: 188,
	DELETE: 46,
	DOWN: 40,
	END: 35,
	ENTER: 13,
	ESCAPE: 27,
	HOME: 36,
	LEFT: 37,
	PAGE_DOWN: 34,
	PAGE_UP: 33,
	PERIOD: 190,
	RIGHT: 39,
	SPACE: 32,
	TAB: 9,
	UP: 38
};




// Internal use only
var escapeSelector = $.ui.escapeSelector = ( function() {
	var selectorEscape = /([!"#$%&'()*+,./:;<=>?@[\]^`{|}~])/g;
	return function( selector ) {
		return selector.replace( selectorEscape, "\\$1" );
	};
} )();


/*!
 * jQuery UI Labels 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: labels
//>>group: Core
//>>description: Find all the labels associated with a given input
//>>docs: http://api.jqueryui.com/labels/



var labels = $.fn.labels = function() {
	var ancestor, selector, id, labels, ancestors;

	// Check control.labels first
	if ( this[ 0 ].labels && this[ 0 ].labels.length ) {
		return this.pushStack( this[ 0 ].labels );
	}

	// Support: IE <= 11, FF <= 37, Android <= 2.3 only
	// Above browsers do not support control.labels. Everything below is to support them
	// as well as document fragments. control.labels does not work on document fragments
	labels = this.eq( 0 ).parents( "label" );

	// Look for the label based on the id
	id = this.attr( "id" );
	if ( id ) {

		// We don't search against the document in case the element
		// is disconnected from the DOM
		ancestor = this.eq( 0 ).parents().last();

		// Get a full set of top level ancestors
		ancestors = ancestor.add( ancestor.length ? ancestor.siblings() : this.siblings() );

		// Create a selector for the label based on the id
		selector = "label[for='" + $.ui.escapeSelector( id ) + "']";

		labels = labels.add( ancestors.find( selector ).addBack( selector ) );

	}

	// Return whatever we have found for labels
	return this.pushStack( labels );
};


/*!
 * jQuery UI Scroll Parent 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: scrollParent
//>>group: Core
//>>description: Get the closest ancestor element that is scrollable.
//>>docs: http://api.jqueryui.com/scrollParent/



var scrollParent = $.fn.scrollParent = function( includeHidden ) {
	var position = this.css( "position" ),
		excludeStaticParent = position === "absolute",
		overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
		scrollParent = this.parents().filter( function() {
			var parent = $( this );
			if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
				return false;
			}
			return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) +
				parent.css( "overflow-x" ) );
		} ).eq( 0 );

	return position === "fixed" || !scrollParent.length ?
		$( this[ 0 ].ownerDocument || document ) :
		scrollParent;
};


/*!
 * jQuery UI Tabbable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: :tabbable Selector
//>>group: Core
//>>description: Selects elements which can be tabbed to.
//>>docs: http://api.jqueryui.com/tabbable-selector/



var tabbable = $.extend( $.expr[ ":" ], {
	tabbable: function( element ) {
		var tabIndex = $.attr( element, "tabindex" ),
			hasTabindex = tabIndex != null;
		return ( !hasTabindex || tabIndex >= 0 ) && $.ui.focusable( element, hasTabindex );
	}
} );


/*!
 * jQuery UI Unique ID 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: uniqueId
//>>group: Core
//>>description: Functions to generate and remove uniqueId's
//>>docs: http://api.jqueryui.com/uniqueId/



var uniqueId = $.fn.extend( {
	uniqueId: ( function() {
		var uuid = 0;

		return function() {
			return this.each( function() {
				if ( !this.id ) {
					this.id = "ui-id-" + ( ++uuid );
				}
			} );
		};
	} )(),

	removeUniqueId: function() {
		return this.each( function() {
			if ( /^ui-id-\d+$/.test( this.id ) ) {
				$( this ).removeAttr( "id" );
			}
		} );
	}
} );


/*!
 * jQuery UI Accordion 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Accordion
//>>group: Widgets
// jscs:disable maximumLineLength
//>>description: Displays collapsible content panels for presenting information in a limited amount of space.
// jscs:enable maximumLineLength
//>>docs: http://api.jqueryui.com/accordion/
//>>demos: http://jqueryui.com/accordion/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/accordion.css
//>>css.theme: ../../themes/base/theme.css



var widgetsAccordion = $.widget( "ui.accordion", {
	version: "1.12.1",
	options: {
		active: 0,
		animate: {},
		classes: {
			"ui-accordion-header": "ui-corner-top",
			"ui-accordion-header-collapsed": "ui-corner-all",
			"ui-accordion-content": "ui-corner-bottom"
		},
		collapsible: false,
		event: "click",
		header: "> li > :first-child, > :not(li):even",
		heightStyle: "auto",
		icons: {
			activeHeader: "ui-icon-triangle-1-s",
			header: "ui-icon-triangle-1-e"
		},

		// Callbacks
		activate: null,
		beforeActivate: null
	},

	hideProps: {
		borderTopWidth: "hide",
		borderBottomWidth: "hide",
		paddingTop: "hide",
		paddingBottom: "hide",
		height: "hide"
	},

	showProps: {
		borderTopWidth: "show",
		borderBottomWidth: "show",
		paddingTop: "show",
		paddingBottom: "show",
		height: "show"
	},

	_create: function() {
		var options = this.options;

		this.prevShow = this.prevHide = $();
		this._addClass( "ui-accordion", "ui-widget ui-helper-reset" );
		this.element.attr( "role", "tablist" );

		// Don't allow collapsible: false and active: false / null
		if ( !options.collapsible && ( options.active === false || options.active == null ) ) {
			options.active = 0;
		}

		this._processPanels();

		// handle negative values
		if ( options.active < 0 ) {
			options.active += this.headers.length;
		}
		this._refresh();
	},

	_getCreateEventData: function() {
		return {
			header: this.active,
			panel: !this.active.length ? $() : this.active.next()
		};
	},

	_createIcons: function() {
		var icon, children,
			icons = this.options.icons;

		if ( icons ) {
			icon = $( "<span>" );
			this._addClass( icon, "ui-accordion-header-icon", "ui-icon " + icons.header );
			icon.prependTo( this.headers );
			children = this.active.children( ".ui-accordion-header-icon" );
			this._removeClass( children, icons.header )
				._addClass( children, null, icons.activeHeader )
				._addClass( this.headers, "ui-accordion-icons" );
		}
	},

	_destroyIcons: function() {
		this._removeClass( this.headers, "ui-accordion-icons" );
		this.headers.children( ".ui-accordion-header-icon" ).remove();
	},

	_destroy: function() {
		var contents;

		// Clean up main element
		this.element.removeAttr( "role" );

		// Clean up headers
		this.headers
			.removeAttr( "role aria-expanded aria-selected aria-controls tabIndex" )
			.removeUniqueId();

		this._destroyIcons();

		// Clean up content panels
		contents = this.headers.next()
			.css( "display", "" )
			.removeAttr( "role aria-hidden aria-labelledby" )
			.removeUniqueId();

		if ( this.options.heightStyle !== "content" ) {
			contents.css( "height", "" );
		}
	},

	_setOption: function( key, value ) {
		if ( key === "active" ) {

			// _activate() will handle invalid values and update this.options
			this._activate( value );
			return;
		}

		if ( key === "event" ) {
			if ( this.options.event ) {
				this._off( this.headers, this.options.event );
			}
			this._setupEvents( value );
		}

		this._super( key, value );

		// Setting collapsible: false while collapsed; open first panel
		if ( key === "collapsible" && !value && this.options.active === false ) {
			this._activate( 0 );
		}

		if ( key === "icons" ) {
			this._destroyIcons();
			if ( value ) {
				this._createIcons();
			}
		}
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", value );

		// Support: IE8 Only
		// #5332 / #6059 - opacity doesn't cascade to positioned elements in IE
		// so we need to add the disabled class to the headers and panels
		this._toggleClass( null, "ui-state-disabled", !!value );
		this._toggleClass( this.headers.add( this.headers.next() ), null, "ui-state-disabled",
			!!value );
	},

	_keydown: function( event ) {
		if ( event.altKey || event.ctrlKey ) {
			return;
		}

		var keyCode = $.ui.keyCode,
			length = this.headers.length,
			currentIndex = this.headers.index( event.target ),
			toFocus = false;

		switch ( event.keyCode ) {
		case keyCode.RIGHT:
		case keyCode.DOWN:
			toFocus = this.headers[ ( currentIndex + 1 ) % length ];
			break;
		case keyCode.LEFT:
		case keyCode.UP:
			toFocus = this.headers[ ( currentIndex - 1 + length ) % length ];
			break;
		case keyCode.SPACE:
		case keyCode.ENTER:
			this._eventHandler( event );
			break;
		case keyCode.HOME:
			toFocus = this.headers[ 0 ];
			break;
		case keyCode.END:
			toFocus = this.headers[ length - 1 ];
			break;
		}

		if ( toFocus ) {
			$( event.target ).attr( "tabIndex", -1 );
			$( toFocus ).attr( "tabIndex", 0 );
			$( toFocus ).trigger( "focus" );
			event.preventDefault();
		}
	},

	_panelKeyDown: function( event ) {
		if ( event.keyCode === $.ui.keyCode.UP && event.ctrlKey ) {
			$( event.currentTarget ).prev().trigger( "focus" );
		}
	},

	refresh: function() {
		var options = this.options;
		this._processPanels();

		// Was collapsed or no panel
		if ( ( options.active === false && options.collapsible === true ) ||
				!this.headers.length ) {
			options.active = false;
			this.active = $();

		// active false only when collapsible is true
		} else if ( options.active === false ) {
			this._activate( 0 );

		// was active, but active panel is gone
		} else if ( this.active.length && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {

			// all remaining panel are disabled
			if ( this.headers.length === this.headers.find( ".ui-state-disabled" ).length ) {
				options.active = false;
				this.active = $();

			// activate previous panel
			} else {
				this._activate( Math.max( 0, options.active - 1 ) );
			}

		// was active, active panel still exists
		} else {

			// make sure active index is correct
			options.active = this.headers.index( this.active );
		}

		this._destroyIcons();

		this._refresh();
	},

	_processPanels: function() {
		var prevHeaders = this.headers,
			prevPanels = this.panels;

		this.headers = this.element.find( this.options.header );
		this._addClass( this.headers, "ui-accordion-header ui-accordion-header-collapsed",
			"ui-state-default" );

		this.panels = this.headers.next().filter( ":not(.ui-accordion-content-active)" ).hide();
		this._addClass( this.panels, "ui-accordion-content", "ui-helper-reset ui-widget-content" );

		// Avoid memory leaks (#10056)
		if ( prevPanels ) {
			this._off( prevHeaders.not( this.headers ) );
			this._off( prevPanels.not( this.panels ) );
		}
	},

	_refresh: function() {
		var maxHeight,
			options = this.options,
			heightStyle = options.heightStyle,
			parent = this.element.parent();

		this.active = this._findActive( options.active );
		this._addClass( this.active, "ui-accordion-header-active", "ui-state-active" )
			._removeClass( this.active, "ui-accordion-header-collapsed" );
		this._addClass( this.active.next(), "ui-accordion-content-active" );
		this.active.next().show();

		this.headers
			.attr( "role", "tab" )
			.each( function() {
				var header = $( this ),
					headerId = header.uniqueId().attr( "id" ),
					panel = header.next(),
					panelId = panel.uniqueId().attr( "id" );
				header.attr( "aria-controls", panelId );
				panel.attr( "aria-labelledby", headerId );
			} )
			.next()
				.attr( "role", "tabpanel" );

		this.headers
			.not( this.active )
				.attr( {
					"aria-selected": "false",
					"aria-expanded": "false",
					tabIndex: -1
				} )
				.next()
					.attr( {
						"aria-hidden": "true"
					} )
					.hide();

		// Make sure at least one header is in the tab order
		if ( !this.active.length ) {
			this.headers.eq( 0 ).attr( "tabIndex", 0 );
		} else {
			this.active.attr( {
				"aria-selected": "true",
				"aria-expanded": "true",
				tabIndex: 0
			} )
				.next()
					.attr( {
						"aria-hidden": "false"
					} );
		}

		this._createIcons();

		this._setupEvents( options.event );

		if ( heightStyle === "fill" ) {
			maxHeight = parent.height();
			this.element.siblings( ":visible" ).each( function() {
				var elem = $( this ),
					position = elem.css( "position" );

				if ( position === "absolute" || position === "fixed" ) {
					return;
				}
				maxHeight -= elem.outerHeight( true );
			} );

			this.headers.each( function() {
				maxHeight -= $( this ).outerHeight( true );
			} );

			this.headers.next()
				.each( function() {
					$( this ).height( Math.max( 0, maxHeight -
						$( this ).innerHeight() + $( this ).height() ) );
				} )
				.css( "overflow", "auto" );
		} else if ( heightStyle === "auto" ) {
			maxHeight = 0;
			this.headers.next()
				.each( function() {
					var isVisible = $( this ).is( ":visible" );
					if ( !isVisible ) {
						$( this ).show();
					}
					maxHeight = Math.max( maxHeight, $( this ).css( "height", "" ).height() );
					if ( !isVisible ) {
						$( this ).hide();
					}
				} )
				.height( maxHeight );
		}
	},

	_activate: function( index ) {
		var active = this._findActive( index )[ 0 ];

		// Trying to activate the already active panel
		if ( active === this.active[ 0 ] ) {
			return;
		}

		// Trying to collapse, simulate a click on the currently active header
		active = active || this.active[ 0 ];

		this._eventHandler( {
			target: active,
			currentTarget: active,
			preventDefault: $.noop
		} );
	},

	_findActive: function( selector ) {
		return typeof selector === "number" ? this.headers.eq( selector ) : $();
	},

	_setupEvents: function( event ) {
		var events = {
			keydown: "_keydown"
		};
		if ( event ) {
			$.each( event.split( " " ), function( index, eventName ) {
				events[ eventName ] = "_eventHandler";
			} );
		}

		this._off( this.headers.add( this.headers.next() ) );
		this._on( this.headers, events );
		this._on( this.headers.next(), { keydown: "_panelKeyDown" } );
		this._hoverable( this.headers );
		this._focusable( this.headers );
	},

	_eventHandler: function( event ) {
		var activeChildren, clickedChildren,
			options = this.options,
			active = this.active,
			clicked = $( event.currentTarget ),
			clickedIsActive = clicked[ 0 ] === active[ 0 ],
			collapsing = clickedIsActive && options.collapsible,
			toShow = collapsing ? $() : clicked.next(),
			toHide = active.next(),
			eventData = {
				oldHeader: active,
				oldPanel: toHide,
				newHeader: collapsing ? $() : clicked,
				newPanel: toShow
			};

		event.preventDefault();

		if (

				// click on active header, but not collapsible
				( clickedIsActive && !options.collapsible ) ||

				// allow canceling activation
				( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
			return;
		}

		options.active = collapsing ? false : this.headers.index( clicked );

		// When the call to ._toggle() comes after the class changes
		// it causes a very odd bug in IE 8 (see #6720)
		this.active = clickedIsActive ? $() : clicked;
		this._toggle( eventData );

		// Switch classes
		// corner classes on the previously active header stay after the animation
		this._removeClass( active, "ui-accordion-header-active", "ui-state-active" );
		if ( options.icons ) {
			activeChildren = active.children( ".ui-accordion-header-icon" );
			this._removeClass( activeChildren, null, options.icons.activeHeader )
				._addClass( activeChildren, null, options.icons.header );
		}

		if ( !clickedIsActive ) {
			this._removeClass( clicked, "ui-accordion-header-collapsed" )
				._addClass( clicked, "ui-accordion-header-active", "ui-state-active" );
			if ( options.icons ) {
				clickedChildren = clicked.children( ".ui-accordion-header-icon" );
				this._removeClass( clickedChildren, null, options.icons.header )
					._addClass( clickedChildren, null, options.icons.activeHeader );
			}

			this._addClass( clicked.next(), "ui-accordion-content-active" );
		}
	},

	_toggle: function( data ) {
		var toShow = data.newPanel,
			toHide = this.prevShow.length ? this.prevShow : data.oldPanel;

		// Handle activating a panel during the animation for another activation
		this.prevShow.add( this.prevHide ).stop( true, true );
		this.prevShow = toShow;
		this.prevHide = toHide;

		if ( this.options.animate ) {
			this._animate( toShow, toHide, data );
		} else {
			toHide.hide();
			toShow.show();
			this._toggleComplete( data );
		}

		toHide.attr( {
			"aria-hidden": "true"
		} );
		toHide.prev().attr( {
			"aria-selected": "false",
			"aria-expanded": "false"
		} );

		// if we're switching panels, remove the old header from the tab order
		// if we're opening from collapsed state, remove the previous header from the tab order
		// if we're collapsing, then keep the collapsing header in the tab order
		if ( toShow.length && toHide.length ) {
			toHide.prev().attr( {
				"tabIndex": -1,
				"aria-expanded": "false"
			} );
		} else if ( toShow.length ) {
			this.headers.filter( function() {
				return parseInt( $( this ).attr( "tabIndex" ), 10 ) === 0;
			} )
				.attr( "tabIndex", -1 );
		}

		toShow
			.attr( "aria-hidden", "false" )
			.prev()
				.attr( {
					"aria-selected": "true",
					"aria-expanded": "true",
					tabIndex: 0
				} );
	},

	_animate: function( toShow, toHide, data ) {
		var total, easing, duration,
			that = this,
			adjust = 0,
			boxSizing = toShow.css( "box-sizing" ),
			down = toShow.length &&
				( !toHide.length || ( toShow.index() < toHide.index() ) ),
			animate = this.options.animate || {},
			options = down && animate.down || animate,
			complete = function() {
				that._toggleComplete( data );
			};

		if ( typeof options === "number" ) {
			duration = options;
		}
		if ( typeof options === "string" ) {
			easing = options;
		}

		// fall back from options to animation in case of partial down settings
		easing = easing || options.easing || animate.easing;
		duration = duration || options.duration || animate.duration;

		if ( !toHide.length ) {
			return toShow.animate( this.showProps, duration, easing, complete );
		}
		if ( !toShow.length ) {
			return toHide.animate( this.hideProps, duration, easing, complete );
		}

		total = toShow.show().outerHeight();
		toHide.animate( this.hideProps, {
			duration: duration,
			easing: easing,
			step: function( now, fx ) {
				fx.now = Math.round( now );
			}
		} );
		toShow
			.hide()
			.animate( this.showProps, {
				duration: duration,
				easing: easing,
				complete: complete,
				step: function( now, fx ) {
					fx.now = Math.round( now );
					if ( fx.prop !== "height" ) {
						if ( boxSizing === "content-box" ) {
							adjust += fx.now;
						}
					} else if ( that.options.heightStyle !== "content" ) {
						fx.now = Math.round( total - toHide.outerHeight() - adjust );
						adjust = 0;
					}
				}
			} );
	},

	_toggleComplete: function( data ) {
		var toHide = data.oldPanel,
			prev = toHide.prev();

		this._removeClass( toHide, "ui-accordion-content-active" );
		this._removeClass( prev, "ui-accordion-header-active" )
			._addClass( prev, "ui-accordion-header-collapsed" );

		// Work around for rendering bug in IE (#5421)
		if ( toHide.length ) {
			toHide.parent()[ 0 ].className = toHide.parent()[ 0 ].className;
		}
		this._trigger( "activate", null, data );
	}
} );



var safeActiveElement = $.ui.safeActiveElement = function( document ) {
	var activeElement;

	// Support: IE 9 only
	// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
	try {
		activeElement = document.activeElement;
	} catch ( error ) {
		activeElement = document.body;
	}

	// Support: IE 9 - 11 only
	// IE may return null instead of an element
	// Interestingly, this only seems to occur when NOT in an iframe
	if ( !activeElement ) {
		activeElement = document.body;
	}

	// Support: IE 11 only
	// IE11 returns a seemingly empty object in some cases when accessing
	// document.activeElement from an <iframe>
	if ( !activeElement.nodeName ) {
		activeElement = document.body;
	}

	return activeElement;
};


/*!
 * jQuery UI Menu 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Menu
//>>group: Widgets
//>>description: Creates nestable menus.
//>>docs: http://api.jqueryui.com/menu/
//>>demos: http://jqueryui.com/menu/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/menu.css
//>>css.theme: ../../themes/base/theme.css



var widgetsMenu = $.widget( "ui.menu", {
	version: "1.12.1",
	defaultElement: "<ul>",
	delay: 300,
	options: {
		icons: {
			submenu: "ui-icon-caret-1-e"
		},
		items: "> *",
		menus: "ul",
		position: {
			my: "left top",
			at: "right top"
		},
		role: "menu",

		// Callbacks
		blur: null,
		focus: null,
		select: null
	},

	_create: function() {
		this.activeMenu = this.element;

		// Flag used to prevent firing of the click handler
		// as the event bubbles up through nested menus
		this.mouseHandled = false;
		this.element
			.uniqueId()
			.attr( {
				role: this.options.role,
				tabIndex: 0
			} );

		this._addClass( "ui-menu", "ui-widget ui-widget-content" );
		this._on( {

			// Prevent focus from sticking to links inside menu after clicking
			// them (focus should always stay on UL during navigation).
			"mousedown .ui-menu-item": function( event ) {
				event.preventDefault();
			},
			"click .ui-menu-item": function( event ) {
				var target = $( event.target );
				var active = $( $.ui.safeActiveElement( this.document[ 0 ] ) );
				if ( !this.mouseHandled && target.not( ".ui-state-disabled" ).length ) {
					this.select( event );

					// Only set the mouseHandled flag if the event will bubble, see #9469.
					if ( !event.isPropagationStopped() ) {
						this.mouseHandled = true;
					}

					// Open submenu on click
					if ( target.has( ".ui-menu" ).length ) {
						this.expand( event );
					} else if ( !this.element.is( ":focus" ) &&
							active.closest( ".ui-menu" ).length ) {

						// Redirect focus to the menu
						this.element.trigger( "focus", [ true ] );

						// If the active item is on the top level, let it stay active.
						// Otherwise, blur the active item since it is no longer visible.
						if ( this.active && this.active.parents( ".ui-menu" ).length === 1 ) {
							clearTimeout( this.timer );
						}
					}
				}
			},
			"mouseenter .ui-menu-item": function( event ) {

				// Ignore mouse events while typeahead is active, see #10458.
				// Prevents focusing the wrong item when typeahead causes a scroll while the mouse
				// is over an item in the menu
				if ( this.previousFilter ) {
					return;
				}

				var actualTarget = $( event.target ).closest( ".ui-menu-item" ),
					target = $( event.currentTarget );

				// Ignore bubbled events on parent items, see #11641
				if ( actualTarget[ 0 ] !== target[ 0 ] ) {
					return;
				}

				// Remove ui-state-active class from siblings of the newly focused menu item
				// to avoid a jump caused by adjacent elements both having a class with a border
				this._removeClass( target.siblings().children( ".ui-state-active" ),
					null, "ui-state-active" );
				this.focus( event, target );
			},
			mouseleave: "collapseAll",
			"mouseleave .ui-menu": "collapseAll",
			focus: function( event, keepActiveItem ) {

				// If there's already an active item, keep it active
				// If not, activate the first item
				var item = this.active || this.element.find( this.options.items ).eq( 0 );

				if ( !keepActiveItem ) {
					this.focus( event, item );
				}
			},
			blur: function( event ) {
				this._delay( function() {
					var notContained = !$.contains(
						this.element[ 0 ],
						$.ui.safeActiveElement( this.document[ 0 ] )
					);
					if ( notContained ) {
						this.collapseAll( event );
					}
				} );
			},
			keydown: "_keydown"
		} );

		this.refresh();

		// Clicks outside of a menu collapse any open menus
		this._on( this.document, {
			click: function( event ) {
				if ( this._closeOnDocumentClick( event ) ) {
					this.collapseAll( event );
				}

				// Reset the mouseHandled flag
				this.mouseHandled = false;
			}
		} );
	},

	_destroy: function() {
		var items = this.element.find( ".ui-menu-item" )
				.removeAttr( "role aria-disabled" ),
			submenus = items.children( ".ui-menu-item-wrapper" )
				.removeUniqueId()
				.removeAttr( "tabIndex role aria-haspopup" );

		// Destroy (sub)menus
		this.element
			.removeAttr( "aria-activedescendant" )
			.find( ".ui-menu" ).addBack()
				.removeAttr( "role aria-labelledby aria-expanded aria-hidden aria-disabled " +
					"tabIndex" )
				.removeUniqueId()
				.show();

		submenus.children().each( function() {
			var elem = $( this );
			if ( elem.data( "ui-menu-submenu-caret" ) ) {
				elem.remove();
			}
		} );
	},

	_keydown: function( event ) {
		var match, prev, character, skip,
			preventDefault = true;

		switch ( event.keyCode ) {
		case $.ui.keyCode.PAGE_UP:
			this.previousPage( event );
			break;
		case $.ui.keyCode.PAGE_DOWN:
			this.nextPage( event );
			break;
		case $.ui.keyCode.HOME:
			this._move( "first", "first", event );
			break;
		case $.ui.keyCode.END:
			this._move( "last", "last", event );
			break;
		case $.ui.keyCode.UP:
			this.previous( event );
			break;
		case $.ui.keyCode.DOWN:
			this.next( event );
			break;
		case $.ui.keyCode.LEFT:
			this.collapse( event );
			break;
		case $.ui.keyCode.RIGHT:
			if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
				this.expand( event );
			}
			break;
		case $.ui.keyCode.ENTER:
		case $.ui.keyCode.SPACE:
			this._activate( event );
			break;
		case $.ui.keyCode.ESCAPE:
			this.collapse( event );
			break;
		default:
			preventDefault = false;
			prev = this.previousFilter || "";
			skip = false;

			// Support number pad values
			character = event.keyCode >= 96 && event.keyCode <= 105 ?
				( event.keyCode - 96 ).toString() : String.fromCharCode( event.keyCode );

			clearTimeout( this.filterTimer );

			if ( character === prev ) {
				skip = true;
			} else {
				character = prev + character;
			}

			match = this._filterMenuItems( character );
			match = skip && match.index( this.active.next() ) !== -1 ?
				this.active.nextAll( ".ui-menu-item" ) :
				match;

			// If no matches on the current filter, reset to the last character pressed
			// to move down the menu to the first item that starts with that character
			if ( !match.length ) {
				character = String.fromCharCode( event.keyCode );
				match = this._filterMenuItems( character );
			}

			if ( match.length ) {
				this.focus( event, match );
				this.previousFilter = character;
				this.filterTimer = this._delay( function() {
					delete this.previousFilter;
				}, 1000 );
			} else {
				delete this.previousFilter;
			}
		}

		if ( preventDefault ) {
			event.preventDefault();
		}
	},

	_activate: function( event ) {
		if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
			if ( this.active.children( "[aria-haspopup='true']" ).length ) {
				this.expand( event );
			} else {
				this.select( event );
			}
		}
	},

	refresh: function() {
		var menus, items, newSubmenus, newItems, newWrappers,
			that = this,
			icon = this.options.icons.submenu,
			submenus = this.element.find( this.options.menus );

		this._toggleClass( "ui-menu-icons", null, !!this.element.find( ".ui-icon" ).length );

		// Initialize nested menus
		newSubmenus = submenus.filter( ":not(.ui-menu)" )
			.hide()
			.attr( {
				role: this.options.role,
				"aria-hidden": "true",
				"aria-expanded": "false"
			} )
			.each( function() {
				var menu = $( this ),
					item = menu.prev(),
					submenuCaret = $( "<span>" ).data( "ui-menu-submenu-caret", true );

				that._addClass( submenuCaret, "ui-menu-icon", "ui-icon " + icon );
				item
					.attr( "aria-haspopup", "true" )
					.prepend( submenuCaret );
				menu.attr( "aria-labelledby", item.attr( "id" ) );
			} );

		this._addClass( newSubmenus, "ui-menu", "ui-widget ui-widget-content ui-front" );

		menus = submenus.add( this.element );
		items = menus.find( this.options.items );

		// Initialize menu-items containing spaces and/or dashes only as dividers
		items.not( ".ui-menu-item" ).each( function() {
			var item = $( this );
			if ( that._isDivider( item ) ) {
				that._addClass( item, "ui-menu-divider", "ui-widget-content" );
			}
		} );

		// Don't refresh list items that are already adapted
		newItems = items.not( ".ui-menu-item, .ui-menu-divider" );
		newWrappers = newItems.children()
			.not( ".ui-menu" )
				.uniqueId()
				.attr( {
					tabIndex: -1,
					role: this._itemRole()
				} );
		this._addClass( newItems, "ui-menu-item" )
			._addClass( newWrappers, "ui-menu-item-wrapper" );

		// Add aria-disabled attribute to any disabled menu item
		items.filter( ".ui-state-disabled" ).attr( "aria-disabled", "true" );

		// If the active item has been removed, blur the menu
		if ( this.active && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
			this.blur();
		}
	},

	_itemRole: function() {
		return {
			menu: "menuitem",
			listbox: "option"
		}[ this.options.role ];
	},

	_setOption: function( key, value ) {
		if ( key === "icons" ) {
			var icons = this.element.find( ".ui-menu-icon" );
			this._removeClass( icons, null, this.options.icons.submenu )
				._addClass( icons, null, value.submenu );
		}
		this._super( key, value );
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", String( value ) );
		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	focus: function( event, item ) {
		var nested, focused, activeParent;
		this.blur( event, event && event.type === "focus" );

		this._scrollIntoView( item );

		this.active = item.first();

		focused = this.active.children( ".ui-menu-item-wrapper" );
		this._addClass( focused, null, "ui-state-active" );

		// Only update aria-activedescendant if there's a role
		// otherwise we assume focus is managed elsewhere
		if ( this.options.role ) {
			this.element.attr( "aria-activedescendant", focused.attr( "id" ) );
		}

		// Highlight active parent menu item, if any
		activeParent = this.active
			.parent()
				.closest( ".ui-menu-item" )
					.children( ".ui-menu-item-wrapper" );
		this._addClass( activeParent, null, "ui-state-active" );

		if ( event && event.type === "keydown" ) {
			this._close();
		} else {
			this.timer = this._delay( function() {
				this._close();
			}, this.delay );
		}

		nested = item.children( ".ui-menu" );
		if ( nested.length && event && ( /^mouse/.test( event.type ) ) ) {
			this._startOpening( nested );
		}
		this.activeMenu = item.parent();

		this._trigger( "focus", event, { item: item } );
	},

	_scrollIntoView: function( item ) {
		var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
		if ( this._hasScroll() ) {
			borderTop = parseFloat( $.css( this.activeMenu[ 0 ], "borderTopWidth" ) ) || 0;
			paddingTop = parseFloat( $.css( this.activeMenu[ 0 ], "paddingTop" ) ) || 0;
			offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
			scroll = this.activeMenu.scrollTop();
			elementHeight = this.activeMenu.height();
			itemHeight = item.outerHeight();

			if ( offset < 0 ) {
				this.activeMenu.scrollTop( scroll + offset );
			} else if ( offset + itemHeight > elementHeight ) {
				this.activeMenu.scrollTop( scroll + offset - elementHeight + itemHeight );
			}
		}
	},

	blur: function( event, fromFocus ) {
		if ( !fromFocus ) {
			clearTimeout( this.timer );
		}

		if ( !this.active ) {
			return;
		}

		this._removeClass( this.active.children( ".ui-menu-item-wrapper" ),
			null, "ui-state-active" );

		this._trigger( "blur", event, { item: this.active } );
		this.active = null;
	},

	_startOpening: function( submenu ) {
		clearTimeout( this.timer );

		// Don't open if already open fixes a Firefox bug that caused a .5 pixel
		// shift in the submenu position when mousing over the caret icon
		if ( submenu.attr( "aria-hidden" ) !== "true" ) {
			return;
		}

		this.timer = this._delay( function() {
			this._close();
			this._open( submenu );
		}, this.delay );
	},

	_open: function( submenu ) {
		var position = $.extend( {
			of: this.active
		}, this.options.position );

		clearTimeout( this.timer );
		this.element.find( ".ui-menu" ).not( submenu.parents( ".ui-menu" ) )
			.hide()
			.attr( "aria-hidden", "true" );

		submenu
			.show()
			.removeAttr( "aria-hidden" )
			.attr( "aria-expanded", "true" )
			.position( position );
	},

	collapseAll: function( event, all ) {
		clearTimeout( this.timer );
		this.timer = this._delay( function() {

			// If we were passed an event, look for the submenu that contains the event
			var currentMenu = all ? this.element :
				$( event && event.target ).closest( this.element.find( ".ui-menu" ) );

			// If we found no valid submenu ancestor, use the main menu to close all
			// sub menus anyway
			if ( !currentMenu.length ) {
				currentMenu = this.element;
			}

			this._close( currentMenu );

			this.blur( event );

			// Work around active item staying active after menu is blurred
			this._removeClass( currentMenu.find( ".ui-state-active" ), null, "ui-state-active" );

			this.activeMenu = currentMenu;
		}, this.delay );
	},

	// With no arguments, closes the currently active menu - if nothing is active
	// it closes all menus.  If passed an argument, it will search for menus BELOW
	_close: function( startMenu ) {
		if ( !startMenu ) {
			startMenu = this.active ? this.active.parent() : this.element;
		}

		startMenu.find( ".ui-menu" )
			.hide()
			.attr( "aria-hidden", "true" )
			.attr( "aria-expanded", "false" );
	},

	_closeOnDocumentClick: function( event ) {
		return !$( event.target ).closest( ".ui-menu" ).length;
	},

	_isDivider: function( item ) {

		// Match hyphen, em dash, en dash
		return !/[^\-\u2014\u2013\s]/.test( item.text() );
	},

	collapse: function( event ) {
		var newItem = this.active &&
			this.active.parent().closest( ".ui-menu-item", this.element );
		if ( newItem && newItem.length ) {
			this._close();
			this.focus( event, newItem );
		}
	},

	expand: function( event ) {
		var newItem = this.active &&
			this.active
				.children( ".ui-menu " )
					.find( this.options.items )
						.first();

		if ( newItem && newItem.length ) {
			this._open( newItem.parent() );

			// Delay so Firefox will not hide activedescendant change in expanding submenu from AT
			this._delay( function() {
				this.focus( event, newItem );
			} );
		}
	},

	next: function( event ) {
		this._move( "next", "first", event );
	},

	previous: function( event ) {
		this._move( "prev", "last", event );
	},

	isFirstItem: function() {
		return this.active && !this.active.prevAll( ".ui-menu-item" ).length;
	},

	isLastItem: function() {
		return this.active && !this.active.nextAll( ".ui-menu-item" ).length;
	},

	_move: function( direction, filter, event ) {
		var next;
		if ( this.active ) {
			if ( direction === "first" || direction === "last" ) {
				next = this.active
					[ direction === "first" ? "prevAll" : "nextAll" ]( ".ui-menu-item" )
					.eq( -1 );
			} else {
				next = this.active
					[ direction + "All" ]( ".ui-menu-item" )
					.eq( 0 );
			}
		}
		if ( !next || !next.length || !this.active ) {
			next = this.activeMenu.find( this.options.items )[ filter ]();
		}

		this.focus( event, next );
	},

	nextPage: function( event ) {
		var item, base, height;

		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isLastItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.height();
			this.active.nextAll( ".ui-menu-item" ).each( function() {
				item = $( this );
				return item.offset().top - base - height < 0;
			} );

			this.focus( event, item );
		} else {
			this.focus( event, this.activeMenu.find( this.options.items )
				[ !this.active ? "first" : "last" ]() );
		}
	},

	previousPage: function( event ) {
		var item, base, height;
		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isFirstItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.height();
			this.active.prevAll( ".ui-menu-item" ).each( function() {
				item = $( this );
				return item.offset().top - base + height > 0;
			} );

			this.focus( event, item );
		} else {
			this.focus( event, this.activeMenu.find( this.options.items ).first() );
		}
	},

	_hasScroll: function() {
		return this.element.outerHeight() < this.element.prop( "scrollHeight" );
	},

	select: function( event ) {

		// TODO: It should never be possible to not have an active item at this
		// point, but the tests don't trigger mouseenter before click.
		this.active = this.active || $( event.target ).closest( ".ui-menu-item" );
		var ui = { item: this.active };
		if ( !this.active.has( ".ui-menu" ).length ) {
			this.collapseAll( event, true );
		}
		this._trigger( "select", event, ui );
	},

	_filterMenuItems: function( character ) {
		var escapedCharacter = character.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" ),
			regex = new RegExp( "^" + escapedCharacter, "i" );

		return this.activeMenu
			.find( this.options.items )

				// Only match on items, not dividers or other content (#10571)
				.filter( ".ui-menu-item" )
					.filter( function() {
						return regex.test(
							$.trim( $( this ).children( ".ui-menu-item-wrapper" ).text() ) );
					} );
	}
} );


/*!
 * jQuery UI Autocomplete 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Autocomplete
//>>group: Widgets
//>>description: Lists suggested words as the user is typing.
//>>docs: http://api.jqueryui.com/autocomplete/
//>>demos: http://jqueryui.com/autocomplete/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/autocomplete.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.autocomplete", {
	version: "1.12.1",
	defaultElement: "<input>",
	options: {
		appendTo: null,
		autoFocus: false,
		delay: 300,
		minLength: 1,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "none"
		},
		source: null,

		// Callbacks
		change: null,
		close: null,
		focus: null,
		open: null,
		response: null,
		search: null,
		select: null
	},

	requestIndex: 0,
	pending: 0,

	_create: function() {

		// Some browsers only repeat keydown events, not keypress events,
		// so we use the suppressKeyPress flag to determine if we've already
		// handled the keydown event. #7269
		// Unfortunately the code for & in keypress is the same as the up arrow,
		// so we use the suppressKeyPressRepeat flag to avoid handling keypress
		// events when we know the keydown event was used to modify the
		// search term. #7799
		var suppressKeyPress, suppressKeyPressRepeat, suppressInput,
			nodeName = this.element[ 0 ].nodeName.toLowerCase(),
			isTextarea = nodeName === "textarea",
			isInput = nodeName === "input";

		// Textareas are always multi-line
		// Inputs are always single-line, even if inside a contentEditable element
		// IE also treats inputs as contentEditable
		// All other element types are determined by whether or not they're contentEditable
		this.isMultiLine = isTextarea || !isInput && this._isContentEditable( this.element );

		this.valueMethod = this.element[ isTextarea || isInput ? "val" : "text" ];
		this.isNewMenu = true;

		this._addClass( "ui-autocomplete-input" );
		this.element.attr( "autocomplete", "off" );

		this._on( this.element, {
			keydown: function( event ) {
				if ( this.element.prop( "readOnly" ) ) {
					suppressKeyPress = true;
					suppressInput = true;
					suppressKeyPressRepeat = true;
					return;
				}

				suppressKeyPress = false;
				suppressInput = false;
				suppressKeyPressRepeat = false;
				var keyCode = $.ui.keyCode;
				switch ( event.keyCode ) {
				case keyCode.PAGE_UP:
					suppressKeyPress = true;
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					suppressKeyPress = true;
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					suppressKeyPress = true;
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					suppressKeyPress = true;
					this._keyEvent( "next", event );
					break;
				case keyCode.ENTER:

					// when menu is open and has focus
					if ( this.menu.active ) {

						// #6055 - Opera still allows the keypress to occur
						// which causes forms to submit
						suppressKeyPress = true;
						event.preventDefault();
						this.menu.select( event );
					}
					break;
				case keyCode.TAB:
					if ( this.menu.active ) {
						this.menu.select( event );
					}
					break;
				case keyCode.ESCAPE:
					if ( this.menu.element.is( ":visible" ) ) {
						if ( !this.isMultiLine ) {
							this._value( this.term );
						}
						this.close( event );

						// Different browsers have different default behavior for escape
						// Single press can mean undo or clear
						// Double press in IE means clear the whole form
						event.preventDefault();
					}
					break;
				default:
					suppressKeyPressRepeat = true;

					// search timeout should be triggered before the input value is changed
					this._searchTimeout( event );
					break;
				}
			},
			keypress: function( event ) {
				if ( suppressKeyPress ) {
					suppressKeyPress = false;
					if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
						event.preventDefault();
					}
					return;
				}
				if ( suppressKeyPressRepeat ) {
					return;
				}

				// Replicate some key handlers to allow them to repeat in Firefox and Opera
				var keyCode = $.ui.keyCode;
				switch ( event.keyCode ) {
				case keyCode.PAGE_UP:
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					this._keyEvent( "next", event );
					break;
				}
			},
			input: function( event ) {
				if ( suppressInput ) {
					suppressInput = false;
					event.preventDefault();
					return;
				}
				this._searchTimeout( event );
			},
			focus: function() {
				this.selectedItem = null;
				this.previous = this._value();
			},
			blur: function( event ) {
				if ( this.cancelBlur ) {
					delete this.cancelBlur;
					return;
				}

				clearTimeout( this.searching );
				this.close( event );
				this._change( event );
			}
		} );

		this._initSource();
		this.menu = $( "<ul>" )
			.appendTo( this._appendTo() )
			.menu( {

				// disable ARIA support, the live region takes care of that
				role: null
			} )
			.hide()
			.menu( "instance" );

		this._addClass( this.menu.element, "ui-autocomplete", "ui-front" );
		this._on( this.menu.element, {
			mousedown: function( event ) {

				// prevent moving focus out of the text field
				event.preventDefault();

				// IE doesn't prevent moving focus even with event.preventDefault()
				// so we set a flag to know when we should ignore the blur event
				this.cancelBlur = true;
				this._delay( function() {
					delete this.cancelBlur;

					// Support: IE 8 only
					// Right clicking a menu item or selecting text from the menu items will
					// result in focus moving out of the input. However, we've already received
					// and ignored the blur event because of the cancelBlur flag set above. So
					// we restore focus to ensure that the menu closes properly based on the user's
					// next actions.
					if ( this.element[ 0 ] !== $.ui.safeActiveElement( this.document[ 0 ] ) ) {
						this.element.trigger( "focus" );
					}
				} );
			},
			menufocus: function( event, ui ) {
				var label, item;

				// support: Firefox
				// Prevent accidental activation of menu items in Firefox (#7024 #9118)
				if ( this.isNewMenu ) {
					this.isNewMenu = false;
					if ( event.originalEvent && /^mouse/.test( event.originalEvent.type ) ) {
						this.menu.blur();

						this.document.one( "mousemove", function() {
							$( event.target ).trigger( event.originalEvent );
						} );

						return;
					}
				}

				item = ui.item.data( "ui-autocomplete-item" );
				if ( false !== this._trigger( "focus", event, { item: item } ) ) {

					// use value to match what will end up in the input, if it was a key event
					if ( event.originalEvent && /^key/.test( event.originalEvent.type ) ) {
						this._value( item.value );
					}
				}

				// Announce the value in the liveRegion
				label = ui.item.attr( "aria-label" ) || item.value;
				if ( label && $.trim( label ).length ) {
					this.liveRegion.children().hide();
					$( "<div>" ).text( label ).appendTo( this.liveRegion );
				}
			},
			menuselect: function( event, ui ) {
				var item = ui.item.data( "ui-autocomplete-item" ),
					previous = this.previous;

				// Only trigger when focus was lost (click on menu)
				if ( this.element[ 0 ] !== $.ui.safeActiveElement( this.document[ 0 ] ) ) {
					this.element.trigger( "focus" );
					this.previous = previous;

					// #6109 - IE triggers two focus events and the second
					// is asynchronous, so we need to reset the previous
					// term synchronously and asynchronously :-(
					this._delay( function() {
						this.previous = previous;
						this.selectedItem = item;
					} );
				}

				if ( false !== this._trigger( "select", event, { item: item } ) ) {
					this._value( item.value );
				}

				// reset the term after the select event
				// this allows custom select handling to work properly
				this.term = this._value();

				this.close( event );
				this.selectedItem = item;
			}
		} );

		this.liveRegion = $( "<div>", {
			role: "status",
			"aria-live": "assertive",
			"aria-relevant": "additions"
		} )
			.appendTo( this.document[ 0 ].body );

		this._addClass( this.liveRegion, null, "ui-helper-hidden-accessible" );

		// Turning off autocomplete prevents the browser from remembering the
		// value when navigating through history, so we re-enable autocomplete
		// if the page is unloaded before the widget is destroyed. #7790
		this._on( this.window, {
			beforeunload: function() {
				this.element.removeAttr( "autocomplete" );
			}
		} );
	},

	_destroy: function() {
		clearTimeout( this.searching );
		this.element.removeAttr( "autocomplete" );
		this.menu.element.remove();
		this.liveRegion.remove();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "source" ) {
			this._initSource();
		}
		if ( key === "appendTo" ) {
			this.menu.element.appendTo( this._appendTo() );
		}
		if ( key === "disabled" && value && this.xhr ) {
			this.xhr.abort();
		}
	},

	_isEventTargetInWidget: function( event ) {
		var menuElement = this.menu.element[ 0 ];

		return event.target === this.element[ 0 ] ||
			event.target === menuElement ||
			$.contains( menuElement, event.target );
	},

	_closeOnClickOutside: function( event ) {
		if ( !this._isEventTargetInWidget( event ) ) {
			this.close();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;

		if ( element ) {
			element = element.jquery || element.nodeType ?
				$( element ) :
				this.document.find( element ).eq( 0 );
		}

		if ( !element || !element[ 0 ] ) {
			element = this.element.closest( ".ui-front, dialog" );
		}

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_initSource: function() {
		var array, url,
			that = this;
		if ( $.isArray( this.options.source ) ) {
			array = this.options.source;
			this.source = function( request, response ) {
				response( $.ui.autocomplete.filter( array, request.term ) );
			};
		} else if ( typeof this.options.source === "string" ) {
			url = this.options.source;
			this.source = function( request, response ) {
				if ( that.xhr ) {
					that.xhr.abort();
				}
				that.xhr = $.ajax( {
					url: url,
					data: request,
					dataType: "json",
					success: function( data ) {
						response( data );
					},
					error: function() {
						response( [] );
					}
				} );
			};
		} else {
			this.source = this.options.source;
		}
	},

	_searchTimeout: function( event ) {
		clearTimeout( this.searching );
		this.searching = this._delay( function() {

			// Search if the value has changed, or if the user retypes the same value (see #7434)
			var equalValues = this.term === this._value(),
				menuVisible = this.menu.element.is( ":visible" ),
				modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;

			if ( !equalValues || ( equalValues && !menuVisible && !modifierKey ) ) {
				this.selectedItem = null;
				this.search( null, event );
			}
		}, this.options.delay );
	},

	search: function( value, event ) {
		value = value != null ? value : this._value();

		// Always save the actual value, not the one passed as an argument
		this.term = this._value();

		if ( value.length < this.options.minLength ) {
			return this.close( event );
		}

		if ( this._trigger( "search", event ) === false ) {
			return;
		}

		return this._search( value );
	},

	_search: function( value ) {
		this.pending++;
		this._addClass( "ui-autocomplete-loading" );
		this.cancelSearch = false;

		this.source( { term: value }, this._response() );
	},

	_response: function() {
		var index = ++this.requestIndex;

		return $.proxy( function( content ) {
			if ( index === this.requestIndex ) {
				this.__response( content );
			}

			this.pending--;
			if ( !this.pending ) {
				this._removeClass( "ui-autocomplete-loading" );
			}
		}, this );
	},

	__response: function( content ) {
		if ( content ) {
			content = this._normalize( content );
		}
		this._trigger( "response", null, { content: content } );
		if ( !this.options.disabled && content && content.length && !this.cancelSearch ) {
			this._suggest( content );
			this._trigger( "open" );
		} else {

			// use ._close() instead of .close() so we don't cancel future searches
			this._close();
		}
	},

	close: function( event ) {
		this.cancelSearch = true;
		this._close( event );
	},

	_close: function( event ) {

		// Remove the handler that closes the menu on outside clicks
		this._off( this.document, "mousedown" );

		if ( this.menu.element.is( ":visible" ) ) {
			this.menu.element.hide();
			this.menu.blur();
			this.isNewMenu = true;
			this._trigger( "close", event );
		}
	},

	_change: function( event ) {
		if ( this.previous !== this._value() ) {
			this._trigger( "change", event, { item: this.selectedItem } );
		}
	},

	_normalize: function( items ) {

		// assume all items have the right format when the first item is complete
		if ( items.length && items[ 0 ].label && items[ 0 ].value ) {
			return items;
		}
		return $.map( items, function( item ) {
			if ( typeof item === "string" ) {
				return {
					label: item,
					value: item
				};
			}
			return $.extend( {}, item, {
				label: item.label || item.value,
				value: item.value || item.label
			} );
		} );
	},

	_suggest: function( items ) {
		var ul = this.menu.element.empty();
		this._renderMenu( ul, items );
		this.isNewMenu = true;
		this.menu.refresh();

		// Size and position menu
		ul.show();
		this._resizeMenu();
		ul.position( $.extend( {
			of: this.element
		}, this.options.position ) );

		if ( this.options.autoFocus ) {
			this.menu.next();
		}

		// Listen for interactions outside of the widget (#6642)
		this._on( this.document, {
			mousedown: "_closeOnClickOutside"
		} );
	},

	_resizeMenu: function() {
		var ul = this.menu.element;
		ul.outerWidth( Math.max(

			// Firefox wraps long text (possibly a rounding bug)
			// so we add 1px to avoid the wrapping (#7513)
			ul.width( "" ).outerWidth() + 1,
			this.element.outerWidth()
		) );
	},

	_renderMenu: function( ul, items ) {
		var that = this;
		$.each( items, function( index, item ) {
			that._renderItemData( ul, item );
		} );
	},

	_renderItemData: function( ul, item ) {
		return this._renderItem( ul, item ).data( "ui-autocomplete-item", item );
	},

	_renderItem: function( ul, item ) {
		return $( "<li>" )
			.append( $( "<div>" ).text( item.label ) )
			.appendTo( ul );
	},

	_move: function( direction, event ) {
		if ( !this.menu.element.is( ":visible" ) ) {
			this.search( null, event );
			return;
		}
		if ( this.menu.isFirstItem() && /^previous/.test( direction ) ||
				this.menu.isLastItem() && /^next/.test( direction ) ) {

			if ( !this.isMultiLine ) {
				this._value( this.term );
			}

			this.menu.blur();
			return;
		}
		this.menu[ direction ]( event );
	},

	widget: function() {
		return this.menu.element;
	},

	_value: function() {
		return this.valueMethod.apply( this.element, arguments );
	},

	_keyEvent: function( keyEvent, event ) {
		if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
			this._move( keyEvent, event );

			// Prevents moving cursor to beginning/end of the text field in some browsers
			event.preventDefault();
		}
	},

	// Support: Chrome <=50
	// We should be able to just use this.element.prop( "isContentEditable" )
	// but hidden elements always report false in Chrome.
	// https://code.google.com/p/chromium/issues/detail?id=313082
	_isContentEditable: function( element ) {
		if ( !element.length ) {
			return false;
		}

		var editable = element.prop( "contentEditable" );

		if ( editable === "inherit" ) {
		  return this._isContentEditable( element.parent() );
		}

		return editable === "true";
	}
} );

$.extend( $.ui.autocomplete, {
	escapeRegex: function( value ) {
		return value.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" );
	},
	filter: function( array, term ) {
		var matcher = new RegExp( $.ui.autocomplete.escapeRegex( term ), "i" );
		return $.grep( array, function( value ) {
			return matcher.test( value.label || value.value || value );
		} );
	}
} );

// Live region extension, adding a `messages` option
// NOTE: This is an experimental API. We are still investigating
// a full solution for string manipulation and internationalization.
$.widget( "ui.autocomplete", $.ui.autocomplete, {
	options: {
		messages: {
			noResults: "No search results.",
			results: function( amount ) {
				return amount + ( amount > 1 ? " results are" : " result is" ) +
					" available, use up and down arrow keys to navigate.";
			}
		}
	},

	__response: function( content ) {
		var message;
		this._superApply( arguments );
		if ( this.options.disabled || this.cancelSearch ) {
			return;
		}
		if ( content && content.length ) {
			message = this.options.messages.results( content.length );
		} else {
			message = this.options.messages.noResults;
		}
		this.liveRegion.children().hide();
		$( "<div>" ).text( message ).appendTo( this.liveRegion );
	}
} );

var widgetsAutocomplete = $.ui.autocomplete;


/*!
 * jQuery UI Controlgroup 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Controlgroup
//>>group: Widgets
//>>description: Visually groups form control widgets
//>>docs: http://api.jqueryui.com/controlgroup/
//>>demos: http://jqueryui.com/controlgroup/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/controlgroup.css
//>>css.theme: ../../themes/base/theme.css


var controlgroupCornerRegex = /ui-corner-([a-z]){2,6}/g;

var widgetsControlgroup = $.widget( "ui.controlgroup", {
	version: "1.12.1",
	defaultElement: "<div>",
	options: {
		direction: "horizontal",
		disabled: null,
		onlyVisible: true,
		items: {
			"button": "input[type=button], input[type=submit], input[type=reset], button, a",
			"controlgroupLabel": ".ui-controlgroup-label",
			"checkboxradio": "input[type='checkbox'], input[type='radio']",
			"selectmenu": "select",
			"spinner": ".ui-spinner-input"
		}
	},

	_create: function() {
		this._enhance();
	},

	// To support the enhanced option in jQuery Mobile, we isolate DOM manipulation
	_enhance: function() {
		this.element.attr( "role", "toolbar" );
		this.refresh();
	},

	_destroy: function() {
		this._callChildMethod( "destroy" );
		this.childWidgets.removeData( "ui-controlgroup-data" );
		this.element.removeAttr( "role" );
		if ( this.options.items.controlgroupLabel ) {
			this.element
				.find( this.options.items.controlgroupLabel )
				.find( ".ui-controlgroup-label-contents" )
				.contents().unwrap();
		}
	},

	_initWidgets: function() {
		var that = this,
			childWidgets = [];

		// First we iterate over each of the items options
		$.each( this.options.items, function( widget, selector ) {
			var labels;
			var options = {};

			// Make sure the widget has a selector set
			if ( !selector ) {
				return;
			}

			if ( widget === "controlgroupLabel" ) {
				labels = that.element.find( selector );
				labels.each( function() {
					var element = $( this );

					if ( element.children( ".ui-controlgroup-label-contents" ).length ) {
						return;
					}
					element.contents()
						.wrapAll( "<span class='ui-controlgroup-label-contents'></span>" );
				} );
				that._addClass( labels, null, "ui-widget ui-widget-content ui-state-default" );
				childWidgets = childWidgets.concat( labels.get() );
				return;
			}

			// Make sure the widget actually exists
			if ( !$.fn[ widget ] ) {
				return;
			}

			// We assume everything is in the middle to start because we can't determine
			// first / last elements until all enhancments are done.
			if ( that[ "_" + widget + "Options" ] ) {
				options = that[ "_" + widget + "Options" ]( "middle" );
			} else {
				options = { classes: {} };
			}

			// Find instances of this widget inside controlgroup and init them
			that.element
				.find( selector )
				.each( function() {
					var element = $( this );
					var instance = element[ widget ]( "instance" );

					// We need to clone the default options for this type of widget to avoid
					// polluting the variable options which has a wider scope than a single widget.
					var instanceOptions = $.widget.extend( {}, options );

					// If the button is the child of a spinner ignore it
					// TODO: Find a more generic solution
					if ( widget === "button" && element.parent( ".ui-spinner" ).length ) {
						return;
					}

					// Create the widget if it doesn't exist
					if ( !instance ) {
						instance = element[ widget ]()[ widget ]( "instance" );
					}
					if ( instance ) {
						instanceOptions.classes =
							that._resolveClassesValues( instanceOptions.classes, instance );
					}
					element[ widget ]( instanceOptions );

					// Store an instance of the controlgroup to be able to reference
					// from the outermost element for changing options and refresh
					var widgetElement = element[ widget ]( "widget" );
					$.data( widgetElement[ 0 ], "ui-controlgroup-data",
						instance ? instance : element[ widget ]( "instance" ) );

					childWidgets.push( widgetElement[ 0 ] );
				} );
		} );

		this.childWidgets = $( $.unique( childWidgets ) );
		this._addClass( this.childWidgets, "ui-controlgroup-item" );
	},

	_callChildMethod: function( method ) {
		this.childWidgets.each( function() {
			var element = $( this ),
				data = element.data( "ui-controlgroup-data" );
			if ( data && data[ method ] ) {
				data[ method ]();
			}
		} );
	},

	_updateCornerClass: function( element, position ) {
		var remove = "ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all";
		var add = this._buildSimpleOptions( position, "label" ).classes.label;

		this._removeClass( element, null, remove );
		this._addClass( element, null, add );
	},

	_buildSimpleOptions: function( position, key ) {
		var direction = this.options.direction === "vertical";
		var result = {
			classes: {}
		};
		result.classes[ key ] = {
			"middle": "",
			"first": "ui-corner-" + ( direction ? "top" : "left" ),
			"last": "ui-corner-" + ( direction ? "bottom" : "right" ),
			"only": "ui-corner-all"
		}[ position ];

		return result;
	},

	_spinnerOptions: function( position ) {
		var options = this._buildSimpleOptions( position, "ui-spinner" );

		options.classes[ "ui-spinner-up" ] = "";
		options.classes[ "ui-spinner-down" ] = "";

		return options;
	},

	_buttonOptions: function( position ) {
		return this._buildSimpleOptions( position, "ui-button" );
	},

	_checkboxradioOptions: function( position ) {
		return this._buildSimpleOptions( position, "ui-checkboxradio-label" );
	},

	_selectmenuOptions: function( position ) {
		var direction = this.options.direction === "vertical";
		return {
			width: direction ? "auto" : false,
			classes: {
				middle: {
					"ui-selectmenu-button-open": "",
					"ui-selectmenu-button-closed": ""
				},
				first: {
					"ui-selectmenu-button-open": "ui-corner-" + ( direction ? "top" : "tl" ),
					"ui-selectmenu-button-closed": "ui-corner-" + ( direction ? "top" : "left" )
				},
				last: {
					"ui-selectmenu-button-open": direction ? "" : "ui-corner-tr",
					"ui-selectmenu-button-closed": "ui-corner-" + ( direction ? "bottom" : "right" )
				},
				only: {
					"ui-selectmenu-button-open": "ui-corner-top",
					"ui-selectmenu-button-closed": "ui-corner-all"
				}

			}[ position ]
		};
	},

	_resolveClassesValues: function( classes, instance ) {
		var result = {};
		$.each( classes, function( key ) {
			var current = instance.options.classes[ key ] || "";
			current = $.trim( current.replace( controlgroupCornerRegex, "" ) );
			result[ key ] = ( current + " " + classes[ key ] ).replace( /\s+/g, " " );
		} );
		return result;
	},

	_setOption: function( key, value ) {
		if ( key === "direction" ) {
			this._removeClass( "ui-controlgroup-" + this.options.direction );
		}

		this._super( key, value );
		if ( key === "disabled" ) {
			this._callChildMethod( value ? "disable" : "enable" );
			return;
		}

		this.refresh();
	},

	refresh: function() {
		var children,
			that = this;

		this._addClass( "ui-controlgroup ui-controlgroup-" + this.options.direction );

		if ( this.options.direction === "horizontal" ) {
			this._addClass( null, "ui-helper-clearfix" );
		}
		this._initWidgets();

		children = this.childWidgets;

		// We filter here because we need to track all childWidgets not just the visible ones
		if ( this.options.onlyVisible ) {
			children = children.filter( ":visible" );
		}

		if ( children.length ) {

			// We do this last because we need to make sure all enhancment is done
			// before determining first and last
			$.each( [ "first", "last" ], function( index, value ) {
				var instance = children[ value ]().data( "ui-controlgroup-data" );

				if ( instance && that[ "_" + instance.widgetName + "Options" ] ) {
					var options = that[ "_" + instance.widgetName + "Options" ](
						children.length === 1 ? "only" : value
					);
					options.classes = that._resolveClassesValues( options.classes, instance );
					instance.element[ instance.widgetName ]( options );
				} else {
					that._updateCornerClass( children[ value ](), value );
				}
			} );

			// Finally call the refresh method on each of the child widgets.
			this._callChildMethod( "refresh" );
		}
	}
} );

/*!
 * jQuery UI Checkboxradio 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Checkboxradio
//>>group: Widgets
//>>description: Enhances a form with multiple themeable checkboxes or radio buttons.
//>>docs: http://api.jqueryui.com/checkboxradio/
//>>demos: http://jqueryui.com/checkboxradio/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/button.css
//>>css.structure: ../../themes/base/checkboxradio.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.checkboxradio", [ $.ui.formResetMixin, {
	version: "1.12.1",
	options: {
		disabled: null,
		label: null,
		icon: true,
		classes: {
			"ui-checkboxradio-label": "ui-corner-all",
			"ui-checkboxradio-icon": "ui-corner-all"
		}
	},

	_getCreateOptions: function() {
		var disabled, labels;
		var that = this;
		var options = this._super() || {};

		// We read the type here, because it makes more sense to throw a element type error first,
		// rather then the error for lack of a label. Often if its the wrong type, it
		// won't have a label (e.g. calling on a div, btn, etc)
		this._readType();

		labels = this.element.labels();

		// If there are multiple labels, use the last one
		this.label = $( labels[ labels.length - 1 ] );
		if ( !this.label.length ) {
			$.error( "No label found for checkboxradio widget" );
		}

		this.originalLabel = "";

		// We need to get the label text but this may also need to make sure it does not contain the
		// input itself.
		this.label.contents().not( this.element[ 0 ] ).each( function() {

			// The label contents could be text, html, or a mix. We concat each element to get a
			// string representation of the label, without the input as part of it.
			that.originalLabel += this.nodeType === 3 ? $( this ).text() : this.outerHTML;
		} );

		// Set the label option if we found label text
		if ( this.originalLabel ) {
			options.label = this.originalLabel;
		}

		disabled = this.element[ 0 ].disabled;
		if ( disabled != null ) {
			options.disabled = disabled;
		}
		return options;
	},

	_create: function() {
		var checked = this.element[ 0 ].checked;

		this._bindFormResetHandler();

		if ( this.options.disabled == null ) {
			this.options.disabled = this.element[ 0 ].disabled;
		}

		this._setOption( "disabled", this.options.disabled );
		this._addClass( "ui-checkboxradio", "ui-helper-hidden-accessible" );
		this._addClass( this.label, "ui-checkboxradio-label", "ui-button ui-widget" );

		if ( this.type === "radio" ) {
			this._addClass( this.label, "ui-checkboxradio-radio-label" );
		}

		if ( this.options.label && this.options.label !== this.originalLabel ) {
			this._updateLabel();
		} else if ( this.originalLabel ) {
			this.options.label = this.originalLabel;
		}

		this._enhance();

		if ( checked ) {
			this._addClass( this.label, "ui-checkboxradio-checked", "ui-state-active" );
			if ( this.icon ) {
				this._addClass( this.icon, null, "ui-state-hover" );
			}
		}

		this._on( {
			change: "_toggleClasses",
			focus: function() {
				this._addClass( this.label, null, "ui-state-focus ui-visual-focus" );
			},
			blur: function() {
				this._removeClass( this.label, null, "ui-state-focus ui-visual-focus" );
			}
		} );
	},

	_readType: function() {
		var nodeName = this.element[ 0 ].nodeName.toLowerCase();
		this.type = this.element[ 0 ].type;
		if ( nodeName !== "input" || !/radio|checkbox/.test( this.type ) ) {
			$.error( "Can't create checkboxradio on element.nodeName=" + nodeName +
				" and element.type=" + this.type );
		}
	},

	// Support jQuery Mobile enhanced option
	_enhance: function() {
		this._updateIcon( this.element[ 0 ].checked );
	},

	widget: function() {
		return this.label;
	},

	_getRadioGroup: function() {
		var group;
		var name = this.element[ 0 ].name;
		var nameSelector = "input[name='" + $.ui.escapeSelector( name ) + "']";

		if ( !name ) {
			return $( [] );
		}

		if ( this.form.length ) {
			group = $( this.form[ 0 ].elements ).filter( nameSelector );
		} else {

			// Not inside a form, check all inputs that also are not inside a form
			group = $( nameSelector ).filter( function() {
				return $( this ).form().length === 0;
			} );
		}

		return group.not( this.element );
	},

	_toggleClasses: function() {
		var checked = this.element[ 0 ].checked;
		this._toggleClass( this.label, "ui-checkboxradio-checked", "ui-state-active", checked );

		if ( this.options.icon && this.type === "checkbox" ) {
			this._toggleClass( this.icon, null, "ui-icon-check ui-state-checked", checked )
				._toggleClass( this.icon, null, "ui-icon-blank", !checked );
		}

		if ( this.type === "radio" ) {
			this._getRadioGroup()
				.each( function() {
					var instance = $( this ).checkboxradio( "instance" );

					if ( instance ) {
						instance._removeClass( instance.label,
							"ui-checkboxradio-checked", "ui-state-active" );
					}
				} );
		}
	},

	_destroy: function() {
		this._unbindFormResetHandler();

		if ( this.icon ) {
			this.icon.remove();
			this.iconSpace.remove();
		}
	},

	_setOption: function( key, value ) {

		// We don't allow the value to be set to nothing
		if ( key === "label" && !value ) {
			return;
		}

		this._super( key, value );

		if ( key === "disabled" ) {
			this._toggleClass( this.label, null, "ui-state-disabled", value );
			this.element[ 0 ].disabled = value;

			// Don't refresh when setting disabled
			return;
		}
		this.refresh();
	},

	_updateIcon: function( checked ) {
		var toAdd = "ui-icon ui-icon-background ";

		if ( this.options.icon ) {
			if ( !this.icon ) {
				this.icon = $( "<span>" );
				this.iconSpace = $( "<span> </span>" );
				this._addClass( this.iconSpace, "ui-checkboxradio-icon-space" );
			}

			if ( this.type === "checkbox" ) {
				toAdd += checked ? "ui-icon-check ui-state-checked" : "ui-icon-blank";
				this._removeClass( this.icon, null, checked ? "ui-icon-blank" : "ui-icon-check" );
			} else {
				toAdd += "ui-icon-blank";
			}
			this._addClass( this.icon, "ui-checkboxradio-icon", toAdd );
			if ( !checked ) {
				this._removeClass( this.icon, null, "ui-icon-check ui-state-checked" );
			}
			this.icon.prependTo( this.label ).after( this.iconSpace );
		} else if ( this.icon !== undefined ) {
			this.icon.remove();
			this.iconSpace.remove();
			delete this.icon;
		}
	},

	_updateLabel: function() {

		// Remove the contents of the label ( minus the icon, icon space, and input )
		var contents = this.label.contents().not( this.element[ 0 ] );
		if ( this.icon ) {
			contents = contents.not( this.icon[ 0 ] );
		}
		if ( this.iconSpace ) {
			contents = contents.not( this.iconSpace[ 0 ] );
		}
		contents.remove();

		this.label.append( this.options.label );
	},

	refresh: function() {
		var checked = this.element[ 0 ].checked,
			isDisabled = this.element[ 0 ].disabled;

		this._updateIcon( checked );
		this._toggleClass( this.label, "ui-checkboxradio-checked", "ui-state-active", checked );
		if ( this.options.label !== null ) {
			this._updateLabel();
		}

		if ( isDisabled !== this.options.disabled ) {
			this._setOptions( { "disabled": isDisabled } );
		}
	}

} ] );

var widgetsCheckboxradio = $.ui.checkboxradio;


/*!
 * jQuery UI Button 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Button
//>>group: Widgets
//>>description: Enhances a form with themeable buttons.
//>>docs: http://api.jqueryui.com/button/
//>>demos: http://jqueryui.com/button/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/button.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.button", {
	version: "1.12.1",
	defaultElement: "<button>",
	options: {
		classes: {
			"ui-button": "ui-corner-all"
		},
		disabled: null,
		icon: null,
		iconPosition: "beginning",
		label: null,
		showLabel: true
	},

	_getCreateOptions: function() {
		var disabled,

			// This is to support cases like in jQuery Mobile where the base widget does have
			// an implementation of _getCreateOptions
			options = this._super() || {};

		this.isInput = this.element.is( "input" );

		disabled = this.element[ 0 ].disabled;
		if ( disabled != null ) {
			options.disabled = disabled;
		}

		this.originalLabel = this.isInput ? this.element.val() : this.element.html();
		if ( this.originalLabel ) {
			options.label = this.originalLabel;
		}

		return options;
	},

	_create: function() {
		if ( !this.option.showLabel & !this.options.icon ) {
			this.options.showLabel = true;
		}

		// We have to check the option again here even though we did in _getCreateOptions,
		// because null may have been passed on init which would override what was set in
		// _getCreateOptions
		if ( this.options.disabled == null ) {
			this.options.disabled = this.element[ 0 ].disabled || false;
		}

		this.hasTitle = !!this.element.attr( "title" );

		// Check to see if the label needs to be set or if its already correct
		if ( this.options.label && this.options.label !== this.originalLabel ) {
			if ( this.isInput ) {
				this.element.val( this.options.label );
			} else {
				this.element.html( this.options.label );
			}
		}
		this._addClass( "ui-button", "ui-widget" );
		this._setOption( "disabled", this.options.disabled );
		this._enhance();

		if ( this.element.is( "a" ) ) {
			this._on( {
				"keyup": function( event ) {
					if ( event.keyCode === $.ui.keyCode.SPACE ) {
						event.preventDefault();

						// Support: PhantomJS <= 1.9, IE 8 Only
						// If a native click is available use it so we actually cause navigation
						// otherwise just trigger a click event
						if ( this.element[ 0 ].click ) {
							this.element[ 0 ].click();
						} else {
							this.element.trigger( "click" );
						}
					}
				}
			} );
		}
	},

	_enhance: function() {
		if ( !this.element.is( "button" ) ) {
			this.element.attr( "role", "button" );
		}

		if ( this.options.icon ) {
			this._updateIcon( "icon", this.options.icon );
			this._updateTooltip();
		}
	},

	_updateTooltip: function() {
		this.title = this.element.attr( "title" );

		if ( !this.options.showLabel && !this.title ) {
			this.element.attr( "title", this.options.label );
		}
	},

	_updateIcon: function( option, value ) {
		var icon = option !== "iconPosition",
			position = icon ? this.options.iconPosition : value,
			displayBlock = position === "top" || position === "bottom";

		// Create icon
		if ( !this.icon ) {
			this.icon = $( "<span>" );

			this._addClass( this.icon, "ui-button-icon", "ui-icon" );

			if ( !this.options.showLabel ) {
				this._addClass( "ui-button-icon-only" );
			}
		} else if ( icon ) {

			// If we are updating the icon remove the old icon class
			this._removeClass( this.icon, null, this.options.icon );
		}

		// If we are updating the icon add the new icon class
		if ( icon ) {
			this._addClass( this.icon, null, value );
		}

		this._attachIcon( position );

		// If the icon is on top or bottom we need to add the ui-widget-icon-block class and remove
		// the iconSpace if there is one.
		if ( displayBlock ) {
			this._addClass( this.icon, null, "ui-widget-icon-block" );
			if ( this.iconSpace ) {
				this.iconSpace.remove();
			}
		} else {

			// Position is beginning or end so remove the ui-widget-icon-block class and add the
			// space if it does not exist
			if ( !this.iconSpace ) {
				this.iconSpace = $( "<span> </span>" );
				this._addClass( this.iconSpace, "ui-button-icon-space" );
			}
			this._removeClass( this.icon, null, "ui-wiget-icon-block" );
			this._attachIconSpace( position );
		}
	},

	_destroy: function() {
		this.element.removeAttr( "role" );

		if ( this.icon ) {
			this.icon.remove();
		}
		if ( this.iconSpace ) {
			this.iconSpace.remove();
		}
		if ( !this.hasTitle ) {
			this.element.removeAttr( "title" );
		}
	},

	_attachIconSpace: function( iconPosition ) {
		this.icon[ /^(?:end|bottom)/.test( iconPosition ) ? "before" : "after" ]( this.iconSpace );
	},

	_attachIcon: function( iconPosition ) {
		this.element[ /^(?:end|bottom)/.test( iconPosition ) ? "append" : "prepend" ]( this.icon );
	},

	_setOptions: function( options ) {
		var newShowLabel = options.showLabel === undefined ?
				this.options.showLabel :
				options.showLabel,
			newIcon = options.icon === undefined ? this.options.icon : options.icon;

		if ( !newShowLabel && !newIcon ) {
			options.showLabel = true;
		}
		this._super( options );
	},

	_setOption: function( key, value ) {
		if ( key === "icon" ) {
			if ( value ) {
				this._updateIcon( key, value );
			} else if ( this.icon ) {
				this.icon.remove();
				if ( this.iconSpace ) {
					this.iconSpace.remove();
				}
			}
		}

		if ( key === "iconPosition" ) {
			this._updateIcon( key, value );
		}

		// Make sure we can't end up with a button that has neither text nor icon
		if ( key === "showLabel" ) {
				this._toggleClass( "ui-button-icon-only", null, !value );
				this._updateTooltip();
		}

		if ( key === "label" ) {
			if ( this.isInput ) {
				this.element.val( value );
			} else {

				// If there is an icon, append it, else nothing then append the value
				// this avoids removal of the icon when setting label text
				this.element.html( value );
				if ( this.icon ) {
					this._attachIcon( this.options.iconPosition );
					this._attachIconSpace( this.options.iconPosition );
				}
			}
		}

		this._super( key, value );

		if ( key === "disabled" ) {
			this._toggleClass( null, "ui-state-disabled", value );
			this.element[ 0 ].disabled = value;
			if ( value ) {
				this.element.blur();
			}
		}
	},

	refresh: function() {

		// Make sure to only check disabled if its an element that supports this otherwise
		// check for the disabled class to determine state
		var isDisabled = this.element.is( "input, button" ) ?
			this.element[ 0 ].disabled : this.element.hasClass( "ui-button-disabled" );

		if ( isDisabled !== this.options.disabled ) {
			this._setOptions( { disabled: isDisabled } );
		}

		this._updateTooltip();
	}
} );

// DEPRECATED
if ( $.uiBackCompat !== false ) {

	// Text and Icons options
	$.widget( "ui.button", $.ui.button, {
		options: {
			text: true,
			icons: {
				primary: null,
				secondary: null
			}
		},

		_create: function() {
			if ( this.options.showLabel && !this.options.text ) {
				this.options.showLabel = this.options.text;
			}
			if ( !this.options.showLabel && this.options.text ) {
				this.options.text = this.options.showLabel;
			}
			if ( !this.options.icon && ( this.options.icons.primary ||
					this.options.icons.secondary ) ) {
				if ( this.options.icons.primary ) {
					this.options.icon = this.options.icons.primary;
				} else {
					this.options.icon = this.options.icons.secondary;
					this.options.iconPosition = "end";
				}
			} else if ( this.options.icon ) {
				this.options.icons.primary = this.options.icon;
			}
			this._super();
		},

		_setOption: function( key, value ) {
			if ( key === "text" ) {
				this._super( "showLabel", value );
				return;
			}
			if ( key === "showLabel" ) {
				this.options.text = value;
			}
			if ( key === "icon" ) {
				this.options.icons.primary = value;
			}
			if ( key === "icons" ) {
				if ( value.primary ) {
					this._super( "icon", value.primary );
					this._super( "iconPosition", "beginning" );
				} else if ( value.secondary ) {
					this._super( "icon", value.secondary );
					this._super( "iconPosition", "end" );
				}
			}
			this._superApply( arguments );
		}
	} );

	$.fn.button = ( function( orig ) {
		return function() {
			if ( !this.length || ( this.length && this[ 0 ].tagName !== "INPUT" ) ||
					( this.length && this[ 0 ].tagName === "INPUT" && (
						this.attr( "type" ) !== "checkbox" && this.attr( "type" ) !== "radio"
					) ) ) {
				return orig.apply( this, arguments );
			}
			if ( !$.ui.checkboxradio ) {
				$.error( "Checkboxradio widget missing" );
			}
			if ( arguments.length === 0 ) {
				return this.checkboxradio( {
					"icon": false
				} );
			}
			return this.checkboxradio.apply( this, arguments );
		};
	} )( $.fn.button );

	$.fn.buttonset = function() {
		if ( !$.ui.controlgroup ) {
			$.error( "Controlgroup widget missing" );
		}
		if ( arguments[ 0 ] === "option" && arguments[ 1 ] === "items" && arguments[ 2 ] ) {
			return this.controlgroup.apply( this,
				[ arguments[ 0 ], "items.button", arguments[ 2 ] ] );
		}
		if ( arguments[ 0 ] === "option" && arguments[ 1 ] === "items" ) {
			return this.controlgroup.apply( this, [ arguments[ 0 ], "items.button" ] );
		}
		if ( typeof arguments[ 0 ] === "object" && arguments[ 0 ].items ) {
			arguments[ 0 ].items = {
				button: arguments[ 0 ].items
			};
		}
		return this.controlgroup.apply( this, arguments );
	};
}

var widgetsButton = $.ui.button;


// jscs:disable maximumLineLength
/* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
/*!
 * jQuery UI Datepicker 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Datepicker
//>>group: Widgets
//>>description: Displays a calendar from an input or inline for selecting dates.
//>>docs: http://api.jqueryui.com/datepicker/
//>>demos: http://jqueryui.com/datepicker/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/datepicker.css
//>>css.theme: ../../themes/base/theme.css



$.extend( $.ui, { datepicker: { version: "1.12.1" } } );

var datepicker_instActive;

function datepicker_getZindex( elem ) {
	var position, value;
	while ( elem.length && elem[ 0 ] !== document ) {

		// Ignore z-index if position is set to a value where z-index is ignored by the browser
		// This makes behavior of this function consistent across browsers
		// WebKit always returns auto if the element is positioned
		position = elem.css( "position" );
		if ( position === "absolute" || position === "relative" || position === "fixed" ) {

			// IE returns 0 when zIndex is not specified
			// other browsers return a string
			// we ignore the case of nested elements with an explicit value of 0
			// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
			value = parseInt( elem.css( "zIndex" ), 10 );
			if ( !isNaN( value ) && value !== 0 ) {
				return value;
			}
		}
		elem = elem.parent();
	}

	return 0;
}
/* Date picker manager.
   Use the singleton instance of this class, $.datepicker, to interact with the date picker.
   Settings for (groups of) date pickers are maintained in an instance object,
   allowing multiple different settings on the same page. */

function Datepicker() {
	this._curInst = null; // The current instance in use
	this._keyEvent = false; // If the last event was a key event
	this._disabledInputs = []; // List of date picker inputs that have been disabled
	this._datepickerShowing = false; // True if the popup picker is showing , false if not
	this._inDialog = false; // True if showing within a "dialog", false if not
	this._mainDivId = "ui-datepicker-div"; // The ID of the main datepicker division
	this._inlineClass = "ui-datepicker-inline"; // The name of the inline marker class
	this._appendClass = "ui-datepicker-append"; // The name of the append marker class
	this._triggerClass = "ui-datepicker-trigger"; // The name of the trigger marker class
	this._dialogClass = "ui-datepicker-dialog"; // The name of the dialog marker class
	this._disableClass = "ui-datepicker-disabled"; // The name of the disabled covering marker class
	this._unselectableClass = "ui-datepicker-unselectable"; // The name of the unselectable cell marker class
	this._currentClass = "ui-datepicker-current-day"; // The name of the current day marker class
	this._dayOverClass = "ui-datepicker-days-cell-over"; // The name of the day hover marker class
	this.regional = []; // Available regional settings, indexed by language code
	this.regional[ "" ] = { // Default regional settings
		closeText: "Done", // Display text for close link
		prevText: "Prev", // Display text for previous month link
		nextText: "Next", // Display text for next month link
		currentText: "Today", // Display text for current month link
		monthNames: [ "January","February","March","April","May","June",
			"July","August","September","October","November","December" ], // Names of months for drop-down and formatting
		monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ], // For formatting
		dayNames: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ], // For formatting
		dayNamesShort: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ], // For formatting
		dayNamesMin: [ "Su","Mo","Tu","We","Th","Fr","Sa" ], // Column headings for days starting at Sunday
		weekHeader: "Wk", // Column header for week of the year
		dateFormat: "mm/dd/yy", // See format options on parseDate
		firstDay: 0, // The first day of the week, Sun = 0, Mon = 1, ...
		isRTL: false, // True if right-to-left language, false if left-to-right
		showMonthAfterYear: false, // True if the year select precedes month, false for month then year
		yearSuffix: "" // Additional text to append to the year in the month headers
	};
	this._defaults = { // Global defaults for all the date picker instances
		showOn: "focus", // "focus" for popup on focus,
			// "button" for trigger button, or "both" for either
		showAnim: "fadeIn", // Name of jQuery animation for popup
		showOptions: {}, // Options for enhanced animations
		defaultDate: null, // Used when field is blank: actual date,
			// +/-number for offset from today, null for today
		appendText: "", // Display text following the input box, e.g. showing the format
		buttonText: "...", // Text for trigger button
		buttonImage: "", // URL for trigger button image
		buttonImageOnly: false, // True if the image appears alone, false if it appears on a button
		hideIfNoPrevNext: false, // True to hide next/previous month links
			// if not applicable, false to just disable them
		navigationAsDateFormat: false, // True if date formatting applied to prev/today/next links
		gotoCurrent: false, // True if today link goes back to current selection instead
		changeMonth: false, // True if month can be selected directly, false if only prev/next
		changeYear: false, // True if year can be selected directly, false if only prev/next
		yearRange: "c-10:c+10", // Range of years to display in drop-down,
			// either relative to today's year (-nn:+nn), relative to currently displayed year
			// (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
		showOtherMonths: false, // True to show dates in other months, false to leave blank
		selectOtherMonths: false, // True to allow selection of dates in other months, false for unselectable
		showWeek: false, // True to show week of the year, false to not show it
		calculateWeek: this.iso8601Week, // How to calculate the week of the year,
			// takes a Date and returns the number of the week for it
		shortYearCutoff: "+10", // Short year values < this are in the current century,
			// > this are in the previous century,
			// string value starting with "+" for current year + value
		minDate: null, // The earliest selectable date, or null for no limit
		maxDate: null, // The latest selectable date, or null for no limit
		duration: "fast", // Duration of display/closure
		beforeShowDay: null, // Function that takes a date and returns an array with
			// [0] = true if selectable, false if not, [1] = custom CSS class name(s) or "",
			// [2] = cell title (optional), e.g. $.datepicker.noWeekends
		beforeShow: null, // Function that takes an input field and
			// returns a set of custom settings for the date picker
		onSelect: null, // Define a callback function when a date is selected
		onChangeMonthYear: null, // Define a callback function when the month or year is changed
		onClose: null, // Define a callback function when the datepicker is closed
		numberOfMonths: 1, // Number of months to show at a time
		showCurrentAtPos: 0, // The position in multipe months at which to show the current month (starting at 0)
		stepMonths: 1, // Number of months to step back/forward
		stepBigMonths: 12, // Number of months to step back/forward for the big links
		altField: "", // Selector for an alternate field to store selected dates into
		altFormat: "", // The date format to use for the alternate field
		constrainInput: true, // The input is constrained by the current date format
		showButtonPanel: false, // True to show button panel, false to not show it
		autoSize: false, // True to size the input for the date format, false to leave as is
		disabled: false // The initial disabled state
	};
	$.extend( this._defaults, this.regional[ "" ] );
	this.regional.en = $.extend( true, {}, this.regional[ "" ] );
	this.regional[ "en-US" ] = $.extend( true, {}, this.regional.en );
	this.dpDiv = datepicker_bindHover( $( "<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>" ) );
}

$.extend( Datepicker.prototype, {
	/* Class name added to elements to indicate already configured with a date picker. */
	markerClassName: "hasDatepicker",

	//Keep track of the maximum number of rows displayed (see #7043)
	maxRows: 4,

	// TODO rename to "widget" when switching to widget factory
	_widgetDatepicker: function() {
		return this.dpDiv;
	},

	/* Override the default settings for all instances of the date picker.
	 * @param  settings  object - the new settings to use as defaults (anonymous object)
	 * @return the manager object
	 */
	setDefaults: function( settings ) {
		datepicker_extendRemove( this._defaults, settings || {} );
		return this;
	},

	/* Attach the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 * @param  settings  object - the new settings to use for this date picker instance (anonymous)
	 */
	_attachDatepicker: function( target, settings ) {
		var nodeName, inline, inst;
		nodeName = target.nodeName.toLowerCase();
		inline = ( nodeName === "div" || nodeName === "span" );
		if ( !target.id ) {
			this.uuid += 1;
			target.id = "dp" + this.uuid;
		}
		inst = this._newInst( $( target ), inline );
		inst.settings = $.extend( {}, settings || {} );
		if ( nodeName === "input" ) {
			this._connectDatepicker( target, inst );
		} else if ( inline ) {
			this._inlineDatepicker( target, inst );
		}
	},

	/* Create a new instance object. */
	_newInst: function( target, inline ) {
		var id = target[ 0 ].id.replace( /([^A-Za-z0-9_\-])/g, "\\\\$1" ); // escape jQuery meta chars
		return { id: id, input: target, // associated target
			selectedDay: 0, selectedMonth: 0, selectedYear: 0, // current selection
			drawMonth: 0, drawYear: 0, // month being drawn
			inline: inline, // is datepicker inline or not
			dpDiv: ( !inline ? this.dpDiv : // presentation div
			datepicker_bindHover( $( "<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>" ) ) ) };
	},

	/* Attach the date picker to an input field. */
	_connectDatepicker: function( target, inst ) {
		var input = $( target );
		inst.append = $( [] );
		inst.trigger = $( [] );
		if ( input.hasClass( this.markerClassName ) ) {
			return;
		}
		this._attachments( input, inst );
		input.addClass( this.markerClassName ).on( "keydown", this._doKeyDown ).
			on( "keypress", this._doKeyPress ).on( "keyup", this._doKeyUp );
		this._autoSize( inst );
		$.data( target, "datepicker", inst );

		//If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
		if ( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}
	},

	/* Make attachments based on settings. */
	_attachments: function( input, inst ) {
		var showOn, buttonText, buttonImage,
			appendText = this._get( inst, "appendText" ),
			isRTL = this._get( inst, "isRTL" );

		if ( inst.append ) {
			inst.append.remove();
		}
		if ( appendText ) {
			inst.append = $( "<span class='" + this._appendClass + "'>" + appendText + "</span>" );
			input[ isRTL ? "before" : "after" ]( inst.append );
		}

		input.off( "focus", this._showDatepicker );

		if ( inst.trigger ) {
			inst.trigger.remove();
		}

		showOn = this._get( inst, "showOn" );
		if ( showOn === "focus" || showOn === "both" ) { // pop-up date picker when in the marked field
			input.on( "focus", this._showDatepicker );
		}
		if ( showOn === "button" || showOn === "both" ) { // pop-up date picker when button clicked
			buttonText = this._get( inst, "buttonText" );
			buttonImage = this._get( inst, "buttonImage" );
			inst.trigger = $( this._get( inst, "buttonImageOnly" ) ?
				$( "<img/>" ).addClass( this._triggerClass ).
					attr( { src: buttonImage, alt: buttonText, title: buttonText } ) :
				$( "<button type='button'></button>" ).addClass( this._triggerClass ).
					html( !buttonImage ? buttonText : $( "<img/>" ).attr(
					{ src:buttonImage, alt:buttonText, title:buttonText } ) ) );
			input[ isRTL ? "before" : "after" ]( inst.trigger );
			inst.trigger.on( "click", function() {
				if ( $.datepicker._datepickerShowing && $.datepicker._lastInput === input[ 0 ] ) {
					$.datepicker._hideDatepicker();
				} else if ( $.datepicker._datepickerShowing && $.datepicker._lastInput !== input[ 0 ] ) {
					$.datepicker._hideDatepicker();
					$.datepicker._showDatepicker( input[ 0 ] );
				} else {
					$.datepicker._showDatepicker( input[ 0 ] );
				}
				return false;
			} );
		}
	},

	/* Apply the maximum length for the date format. */
	_autoSize: function( inst ) {
		if ( this._get( inst, "autoSize" ) && !inst.inline ) {
			var findMax, max, maxI, i,
				date = new Date( 2009, 12 - 1, 20 ), // Ensure double digits
				dateFormat = this._get( inst, "dateFormat" );

			if ( dateFormat.match( /[DM]/ ) ) {
				findMax = function( names ) {
					max = 0;
					maxI = 0;
					for ( i = 0; i < names.length; i++ ) {
						if ( names[ i ].length > max ) {
							max = names[ i ].length;
							maxI = i;
						}
					}
					return maxI;
				};
				date.setMonth( findMax( this._get( inst, ( dateFormat.match( /MM/ ) ?
					"monthNames" : "monthNamesShort" ) ) ) );
				date.setDate( findMax( this._get( inst, ( dateFormat.match( /DD/ ) ?
					"dayNames" : "dayNamesShort" ) ) ) + 20 - date.getDay() );
			}
			inst.input.attr( "size", this._formatDate( inst, date ).length );
		}
	},

	/* Attach an inline date picker to a div. */
	_inlineDatepicker: function( target, inst ) {
		var divSpan = $( target );
		if ( divSpan.hasClass( this.markerClassName ) ) {
			return;
		}
		divSpan.addClass( this.markerClassName ).append( inst.dpDiv );
		$.data( target, "datepicker", inst );
		this._setDate( inst, this._getDefaultDate( inst ), true );
		this._updateDatepicker( inst );
		this._updateAlternate( inst );

		//If disabled option is true, disable the datepicker before showing it (see ticket #5665)
		if ( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}

		// Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
		// http://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
		inst.dpDiv.css( "display", "block" );
	},

	/* Pop-up the date picker in a "dialog" box.
	 * @param  input element - ignored
	 * @param  date	string or Date - the initial date to display
	 * @param  onSelect  function - the function to call when a date is selected
	 * @param  settings  object - update the dialog date picker instance's settings (anonymous object)
	 * @param  pos int[2] - coordinates for the dialog's position within the screen or
	 *					event - with x/y coordinates or
	 *					leave empty for default (screen centre)
	 * @return the manager object
	 */
	_dialogDatepicker: function( input, date, onSelect, settings, pos ) {
		var id, browserWidth, browserHeight, scrollX, scrollY,
			inst = this._dialogInst; // internal instance

		if ( !inst ) {
			this.uuid += 1;
			id = "dp" + this.uuid;
			this._dialogInput = $( "<input type='text' id='" + id +
				"' style='position: absolute; top: -100px; width: 0px;'/>" );
			this._dialogInput.on( "keydown", this._doKeyDown );
			$( "body" ).append( this._dialogInput );
			inst = this._dialogInst = this._newInst( this._dialogInput, false );
			inst.settings = {};
			$.data( this._dialogInput[ 0 ], "datepicker", inst );
		}
		datepicker_extendRemove( inst.settings, settings || {} );
		date = ( date && date.constructor === Date ? this._formatDate( inst, date ) : date );
		this._dialogInput.val( date );

		this._pos = ( pos ? ( pos.length ? pos : [ pos.pageX, pos.pageY ] ) : null );
		if ( !this._pos ) {
			browserWidth = document.documentElement.clientWidth;
			browserHeight = document.documentElement.clientHeight;
			scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
			scrollY = document.documentElement.scrollTop || document.body.scrollTop;
			this._pos = // should use actual width/height below
				[ ( browserWidth / 2 ) - 100 + scrollX, ( browserHeight / 2 ) - 150 + scrollY ];
		}

		// Move input on screen for focus, but hidden behind dialog
		this._dialogInput.css( "left", ( this._pos[ 0 ] + 20 ) + "px" ).css( "top", this._pos[ 1 ] + "px" );
		inst.settings.onSelect = onSelect;
		this._inDialog = true;
		this.dpDiv.addClass( this._dialogClass );
		this._showDatepicker( this._dialogInput[ 0 ] );
		if ( $.blockUI ) {
			$.blockUI( this.dpDiv );
		}
		$.data( this._dialogInput[ 0 ], "datepicker", inst );
		return this;
	},

	/* Detach a datepicker from its control.
	 * @param  target	element - the target input field or division or span
	 */
	_destroyDatepicker: function( target ) {
		var nodeName,
			$target = $( target ),
			inst = $.data( target, "datepicker" );

		if ( !$target.hasClass( this.markerClassName ) ) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		$.removeData( target, "datepicker" );
		if ( nodeName === "input" ) {
			inst.append.remove();
			inst.trigger.remove();
			$target.removeClass( this.markerClassName ).
				off( "focus", this._showDatepicker ).
				off( "keydown", this._doKeyDown ).
				off( "keypress", this._doKeyPress ).
				off( "keyup", this._doKeyUp );
		} else if ( nodeName === "div" || nodeName === "span" ) {
			$target.removeClass( this.markerClassName ).empty();
		}

		if ( datepicker_instActive === inst ) {
			datepicker_instActive = null;
		}
	},

	/* Enable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
	_enableDatepicker: function( target ) {
		var nodeName, inline,
			$target = $( target ),
			inst = $.data( target, "datepicker" );

		if ( !$target.hasClass( this.markerClassName ) ) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		if ( nodeName === "input" ) {
			target.disabled = false;
			inst.trigger.filter( "button" ).
				each( function() { this.disabled = false; } ).end().
				filter( "img" ).css( { opacity: "1.0", cursor: "" } );
		} else if ( nodeName === "div" || nodeName === "span" ) {
			inline = $target.children( "." + this._inlineClass );
			inline.children().removeClass( "ui-state-disabled" );
			inline.find( "select.ui-datepicker-month, select.ui-datepicker-year" ).
				prop( "disabled", false );
		}
		this._disabledInputs = $.map( this._disabledInputs,
			function( value ) { return ( value === target ? null : value ); } ); // delete entry
	},

	/* Disable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
	_disableDatepicker: function( target ) {
		var nodeName, inline,
			$target = $( target ),
			inst = $.data( target, "datepicker" );

		if ( !$target.hasClass( this.markerClassName ) ) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		if ( nodeName === "input" ) {
			target.disabled = true;
			inst.trigger.filter( "button" ).
				each( function() { this.disabled = true; } ).end().
				filter( "img" ).css( { opacity: "0.5", cursor: "default" } );
		} else if ( nodeName === "div" || nodeName === "span" ) {
			inline = $target.children( "." + this._inlineClass );
			inline.children().addClass( "ui-state-disabled" );
			inline.find( "select.ui-datepicker-month, select.ui-datepicker-year" ).
				prop( "disabled", true );
		}
		this._disabledInputs = $.map( this._disabledInputs,
			function( value ) { return ( value === target ? null : value ); } ); // delete entry
		this._disabledInputs[ this._disabledInputs.length ] = target;
	},

	/* Is the first field in a jQuery collection disabled as a datepicker?
	 * @param  target	element - the target input field or division or span
	 * @return boolean - true if disabled, false if enabled
	 */
	_isDisabledDatepicker: function( target ) {
		if ( !target ) {
			return false;
		}
		for ( var i = 0; i < this._disabledInputs.length; i++ ) {
			if ( this._disabledInputs[ i ] === target ) {
				return true;
			}
		}
		return false;
	},

	/* Retrieve the instance data for the target control.
	 * @param  target  element - the target input field or division or span
	 * @return  object - the associated instance data
	 * @throws  error if a jQuery problem getting data
	 */
	_getInst: function( target ) {
		try {
			return $.data( target, "datepicker" );
		}
		catch ( err ) {
			throw "Missing instance data for this datepicker";
		}
	},

	/* Update or retrieve the settings for a date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 * @param  name	object - the new settings to update or
	 *				string - the name of the setting to change or retrieve,
	 *				when retrieving also "all" for all instance settings or
	 *				"defaults" for all global defaults
	 * @param  value   any - the new value for the setting
	 *				(omit if above is an object or to retrieve a value)
	 */
	_optionDatepicker: function( target, name, value ) {
		var settings, date, minDate, maxDate,
			inst = this._getInst( target );

		if ( arguments.length === 2 && typeof name === "string" ) {
			return ( name === "defaults" ? $.extend( {}, $.datepicker._defaults ) :
				( inst ? ( name === "all" ? $.extend( {}, inst.settings ) :
				this._get( inst, name ) ) : null ) );
		}

		settings = name || {};
		if ( typeof name === "string" ) {
			settings = {};
			settings[ name ] = value;
		}

		if ( inst ) {
			if ( this._curInst === inst ) {
				this._hideDatepicker();
			}

			date = this._getDateDatepicker( target, true );
			minDate = this._getMinMaxDate( inst, "min" );
			maxDate = this._getMinMaxDate( inst, "max" );
			datepicker_extendRemove( inst.settings, settings );

			// reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
			if ( minDate !== null && settings.dateFormat !== undefined && settings.minDate === undefined ) {
				inst.settings.minDate = this._formatDate( inst, minDate );
			}
			if ( maxDate !== null && settings.dateFormat !== undefined && settings.maxDate === undefined ) {
				inst.settings.maxDate = this._formatDate( inst, maxDate );
			}
			if ( "disabled" in settings ) {
				if ( settings.disabled ) {
					this._disableDatepicker( target );
				} else {
					this._enableDatepicker( target );
				}
			}
			this._attachments( $( target ), inst );
			this._autoSize( inst );
			this._setDate( inst, date );
			this._updateAlternate( inst );
			this._updateDatepicker( inst );
		}
	},

	// Change method deprecated
	_changeDatepicker: function( target, name, value ) {
		this._optionDatepicker( target, name, value );
	},

	/* Redraw the date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 */
	_refreshDatepicker: function( target ) {
		var inst = this._getInst( target );
		if ( inst ) {
			this._updateDatepicker( inst );
		}
	},

	/* Set the dates for a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  date	Date - the new date
	 */
	_setDateDatepicker: function( target, date ) {
		var inst = this._getInst( target );
		if ( inst ) {
			this._setDate( inst, date );
			this._updateDatepicker( inst );
			this._updateAlternate( inst );
		}
	},

	/* Get the date(s) for the first entry in a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  noDefault boolean - true if no default date is to be used
	 * @return Date - the current date
	 */
	_getDateDatepicker: function( target, noDefault ) {
		var inst = this._getInst( target );
		if ( inst && !inst.inline ) {
			this._setDateFromField( inst, noDefault );
		}
		return ( inst ? this._getDate( inst ) : null );
	},

	/* Handle keystrokes. */
	_doKeyDown: function( event ) {
		var onSelect, dateStr, sel,
			inst = $.datepicker._getInst( event.target ),
			handled = true,
			isRTL = inst.dpDiv.is( ".ui-datepicker-rtl" );

		inst._keyEvent = true;
		if ( $.datepicker._datepickerShowing ) {
			switch ( event.keyCode ) {
				case 9: $.datepicker._hideDatepicker();
						handled = false;
						break; // hide on tab out
				case 13: sel = $( "td." + $.datepicker._dayOverClass + ":not(." +
									$.datepicker._currentClass + ")", inst.dpDiv );
						if ( sel[ 0 ] ) {
							$.datepicker._selectDay( event.target, inst.selectedMonth, inst.selectedYear, sel[ 0 ] );
						}

						onSelect = $.datepicker._get( inst, "onSelect" );
						if ( onSelect ) {
							dateStr = $.datepicker._formatDate( inst );

							// Trigger custom callback
							onSelect.apply( ( inst.input ? inst.input[ 0 ] : null ), [ dateStr, inst ] );
						} else {
							$.datepicker._hideDatepicker();
						}

						return false; // don't submit the form
				case 27: $.datepicker._hideDatepicker();
						break; // hide on escape
				case 33: $.datepicker._adjustDate( event.target, ( event.ctrlKey ?
							-$.datepicker._get( inst, "stepBigMonths" ) :
							-$.datepicker._get( inst, "stepMonths" ) ), "M" );
						break; // previous month/year on page up/+ ctrl
				case 34: $.datepicker._adjustDate( event.target, ( event.ctrlKey ?
							+$.datepicker._get( inst, "stepBigMonths" ) :
							+$.datepicker._get( inst, "stepMonths" ) ), "M" );
						break; // next month/year on page down/+ ctrl
				case 35: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._clearDate( event.target );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // clear on ctrl or command +end
				case 36: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._gotoToday( event.target );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // current on ctrl or command +home
				case 37: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, ( isRTL ? +1 : -1 ), "D" );
						}
						handled = event.ctrlKey || event.metaKey;

						// -1 day on ctrl or command +left
						if ( event.originalEvent.altKey ) {
							$.datepicker._adjustDate( event.target, ( event.ctrlKey ?
								-$.datepicker._get( inst, "stepBigMonths" ) :
								-$.datepicker._get( inst, "stepMonths" ) ), "M" );
						}

						// next month/year on alt +left on Mac
						break;
				case 38: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, -7, "D" );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // -1 week on ctrl or command +up
				case 39: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, ( isRTL ? -1 : +1 ), "D" );
						}
						handled = event.ctrlKey || event.metaKey;

						// +1 day on ctrl or command +right
						if ( event.originalEvent.altKey ) {
							$.datepicker._adjustDate( event.target, ( event.ctrlKey ?
								+$.datepicker._get( inst, "stepBigMonths" ) :
								+$.datepicker._get( inst, "stepMonths" ) ), "M" );
						}

						// next month/year on alt +right
						break;
				case 40: if ( event.ctrlKey || event.metaKey ) {
							$.datepicker._adjustDate( event.target, +7, "D" );
						}
						handled = event.ctrlKey || event.metaKey;
						break; // +1 week on ctrl or command +down
				default: handled = false;
			}
		} else if ( event.keyCode === 36 && event.ctrlKey ) { // display the date picker on ctrl+home
			$.datepicker._showDatepicker( this );
		} else {
			handled = false;
		}

		if ( handled ) {
			event.preventDefault();
			event.stopPropagation();
		}
	},

	/* Filter entered characters - based on date format. */
	_doKeyPress: function( event ) {
		var chars, chr,
			inst = $.datepicker._getInst( event.target );

		if ( $.datepicker._get( inst, "constrainInput" ) ) {
			chars = $.datepicker._possibleChars( $.datepicker._get( inst, "dateFormat" ) );
			chr = String.fromCharCode( event.charCode == null ? event.keyCode : event.charCode );
			return event.ctrlKey || event.metaKey || ( chr < " " || !chars || chars.indexOf( chr ) > -1 );
		}
	},

	/* Synchronise manual entry and field/alternate field. */
	_doKeyUp: function( event ) {
		var date,
			inst = $.datepicker._getInst( event.target );

		if ( inst.input.val() !== inst.lastVal ) {
			try {
				date = $.datepicker.parseDate( $.datepicker._get( inst, "dateFormat" ),
					( inst.input ? inst.input.val() : null ),
					$.datepicker._getFormatConfig( inst ) );

				if ( date ) { // only if valid
					$.datepicker._setDateFromField( inst );
					$.datepicker._updateAlternate( inst );
					$.datepicker._updateDatepicker( inst );
				}
			}
			catch ( err ) {
			}
		}
		return true;
	},

	/* Pop-up the date picker for a given input field.
	 * If false returned from beforeShow event handler do not show.
	 * @param  input  element - the input field attached to the date picker or
	 *					event - if triggered by focus
	 */
	_showDatepicker: function( input ) {
		input = input.target || input;
		if ( input.nodeName.toLowerCase() !== "input" ) { // find from button/image trigger
			input = $( "input", input.parentNode )[ 0 ];
		}

		if ( $.datepicker._isDisabledDatepicker( input ) || $.datepicker._lastInput === input ) { // already here
			return;
		}

		var inst, beforeShow, beforeShowSettings, isFixed,
			offset, showAnim, duration;

		inst = $.datepicker._getInst( input );
		if ( $.datepicker._curInst && $.datepicker._curInst !== inst ) {
			$.datepicker._curInst.dpDiv.stop( true, true );
			if ( inst && $.datepicker._datepickerShowing ) {
				$.datepicker._hideDatepicker( $.datepicker._curInst.input[ 0 ] );
			}
		}

		beforeShow = $.datepicker._get( inst, "beforeShow" );
		beforeShowSettings = beforeShow ? beforeShow.apply( input, [ input, inst ] ) : {};
		if ( beforeShowSettings === false ) {
			return;
		}
		datepicker_extendRemove( inst.settings, beforeShowSettings );

		inst.lastVal = null;
		$.datepicker._lastInput = input;
		$.datepicker._setDateFromField( inst );

		if ( $.datepicker._inDialog ) { // hide cursor
			input.value = "";
		}
		if ( !$.datepicker._pos ) { // position below input
			$.datepicker._pos = $.datepicker._findPos( input );
			$.datepicker._pos[ 1 ] += input.offsetHeight; // add the height
		}

		isFixed = false;
		$( input ).parents().each( function() {
			isFixed |= $( this ).css( "position" ) === "fixed";
			return !isFixed;
		} );

		offset = { left: $.datepicker._pos[ 0 ], top: $.datepicker._pos[ 1 ] };
		$.datepicker._pos = null;

		//to avoid flashes on Firefox
		inst.dpDiv.empty();

		// determine sizing offscreen
		inst.dpDiv.css( { position: "absolute", display: "block", top: "-1000px" } );
		$.datepicker._updateDatepicker( inst );

		// fix width for dynamic number of date pickers
		// and adjust position before showing
		offset = $.datepicker._checkOffset( inst, offset, isFixed );
		inst.dpDiv.css( { position: ( $.datepicker._inDialog && $.blockUI ?
			"static" : ( isFixed ? "fixed" : "absolute" ) ), display: "none",
			left: offset.left + "px", top: offset.top + "px" } );

		if ( !inst.inline ) {
			showAnim = $.datepicker._get( inst, "showAnim" );
			duration = $.datepicker._get( inst, "duration" );
			inst.dpDiv.css( "z-index", datepicker_getZindex( $( input ) ) + 1 );
			$.datepicker._datepickerShowing = true;

			if ( $.effects && $.effects.effect[ showAnim ] ) {
				inst.dpDiv.show( showAnim, $.datepicker._get( inst, "showOptions" ), duration );
			} else {
				inst.dpDiv[ showAnim || "show" ]( showAnim ? duration : null );
			}

			if ( $.datepicker._shouldFocusInput( inst ) ) {
				inst.input.trigger( "focus" );
			}

			$.datepicker._curInst = inst;
		}
	},

	/* Generate the date picker content. */
	_updateDatepicker: function( inst ) {
		this.maxRows = 4; //Reset the max number of rows being displayed (see #7043)
		datepicker_instActive = inst; // for delegate hover events
		inst.dpDiv.empty().append( this._generateHTML( inst ) );
		this._attachHandlers( inst );

		var origyearshtml,
			numMonths = this._getNumberOfMonths( inst ),
			cols = numMonths[ 1 ],
			width = 17,
			activeCell = inst.dpDiv.find( "." + this._dayOverClass + " a" );

		if ( activeCell.length > 0 ) {
			datepicker_handleMouseover.apply( activeCell.get( 0 ) );
		}

		inst.dpDiv.removeClass( "ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4" ).width( "" );
		if ( cols > 1 ) {
			inst.dpDiv.addClass( "ui-datepicker-multi-" + cols ).css( "width", ( width * cols ) + "em" );
		}
		inst.dpDiv[ ( numMonths[ 0 ] !== 1 || numMonths[ 1 ] !== 1 ? "add" : "remove" ) +
			"Class" ]( "ui-datepicker-multi" );
		inst.dpDiv[ ( this._get( inst, "isRTL" ) ? "add" : "remove" ) +
			"Class" ]( "ui-datepicker-rtl" );

		if ( inst === $.datepicker._curInst && $.datepicker._datepickerShowing && $.datepicker._shouldFocusInput( inst ) ) {
			inst.input.trigger( "focus" );
		}

		// Deffered render of the years select (to avoid flashes on Firefox)
		if ( inst.yearshtml ) {
			origyearshtml = inst.yearshtml;
			setTimeout( function() {

				//assure that inst.yearshtml didn't change.
				if ( origyearshtml === inst.yearshtml && inst.yearshtml ) {
					inst.dpDiv.find( "select.ui-datepicker-year:first" ).replaceWith( inst.yearshtml );
				}
				origyearshtml = inst.yearshtml = null;
			}, 0 );
		}
	},

	// #6694 - don't focus the input if it's already focused
	// this breaks the change event in IE
	// Support: IE and jQuery <1.9
	_shouldFocusInput: function( inst ) {
		return inst.input && inst.input.is( ":visible" ) && !inst.input.is( ":disabled" ) && !inst.input.is( ":focus" );
	},

	/* Check positioning to remain on screen. */
	_checkOffset: function( inst, offset, isFixed ) {
		var dpWidth = inst.dpDiv.outerWidth(),
			dpHeight = inst.dpDiv.outerHeight(),
			inputWidth = inst.input ? inst.input.outerWidth() : 0,
			inputHeight = inst.input ? inst.input.outerHeight() : 0,
			viewWidth = document.documentElement.clientWidth + ( isFixed ? 0 : $( document ).scrollLeft() ),
			viewHeight = document.documentElement.clientHeight + ( isFixed ? 0 : $( document ).scrollTop() );

		offset.left -= ( this._get( inst, "isRTL" ) ? ( dpWidth - inputWidth ) : 0 );
		offset.left -= ( isFixed && offset.left === inst.input.offset().left ) ? $( document ).scrollLeft() : 0;
		offset.top -= ( isFixed && offset.top === ( inst.input.offset().top + inputHeight ) ) ? $( document ).scrollTop() : 0;

		// Now check if datepicker is showing outside window viewport - move to a better place if so.
		offset.left -= Math.min( offset.left, ( offset.left + dpWidth > viewWidth && viewWidth > dpWidth ) ?
			Math.abs( offset.left + dpWidth - viewWidth ) : 0 );
		offset.top -= Math.min( offset.top, ( offset.top + dpHeight > viewHeight && viewHeight > dpHeight ) ?
			Math.abs( dpHeight + inputHeight ) : 0 );

		return offset;
	},

	/* Find an object's position on the screen. */
	_findPos: function( obj ) {
		var position,
			inst = this._getInst( obj ),
			isRTL = this._get( inst, "isRTL" );

		while ( obj && ( obj.type === "hidden" || obj.nodeType !== 1 || $.expr.filters.hidden( obj ) ) ) {
			obj = obj[ isRTL ? "previousSibling" : "nextSibling" ];
		}

		position = $( obj ).offset();
		return [ position.left, position.top ];
	},

	/* Hide the date picker from view.
	 * @param  input  element - the input field attached to the date picker
	 */
	_hideDatepicker: function( input ) {
		var showAnim, duration, postProcess, onClose,
			inst = this._curInst;

		if ( !inst || ( input && inst !== $.data( input, "datepicker" ) ) ) {
			return;
		}

		if ( this._datepickerShowing ) {
			showAnim = this._get( inst, "showAnim" );
			duration = this._get( inst, "duration" );
			postProcess = function() {
				$.datepicker._tidyDialog( inst );
			};

			// DEPRECATED: after BC for 1.8.x $.effects[ showAnim ] is not needed
			if ( $.effects && ( $.effects.effect[ showAnim ] || $.effects[ showAnim ] ) ) {
				inst.dpDiv.hide( showAnim, $.datepicker._get( inst, "showOptions" ), duration, postProcess );
			} else {
				inst.dpDiv[ ( showAnim === "slideDown" ? "slideUp" :
					( showAnim === "fadeIn" ? "fadeOut" : "hide" ) ) ]( ( showAnim ? duration : null ), postProcess );
			}

			if ( !showAnim ) {
				postProcess();
			}
			this._datepickerShowing = false;

			onClose = this._get( inst, "onClose" );
			if ( onClose ) {
				onClose.apply( ( inst.input ? inst.input[ 0 ] : null ), [ ( inst.input ? inst.input.val() : "" ), inst ] );
			}

			this._lastInput = null;
			if ( this._inDialog ) {
				this._dialogInput.css( { position: "absolute", left: "0", top: "-100px" } );
				if ( $.blockUI ) {
					$.unblockUI();
					$( "body" ).append( this.dpDiv );
				}
			}
			this._inDialog = false;
		}
	},

	/* Tidy up after a dialog display. */
	_tidyDialog: function( inst ) {
		inst.dpDiv.removeClass( this._dialogClass ).off( ".ui-datepicker-calendar" );
	},

	/* Close date picker if clicked elsewhere. */
	_checkExternalClick: function( event ) {
		if ( !$.datepicker._curInst ) {
			return;
		}

		var $target = $( event.target ),
			inst = $.datepicker._getInst( $target[ 0 ] );

		if ( ( ( $target[ 0 ].id !== $.datepicker._mainDivId &&
				$target.parents( "#" + $.datepicker._mainDivId ).length === 0 &&
				!$target.hasClass( $.datepicker.markerClassName ) &&
				!$target.closest( "." + $.datepicker._triggerClass ).length &&
				$.datepicker._datepickerShowing && !( $.datepicker._inDialog && $.blockUI ) ) ) ||
			( $target.hasClass( $.datepicker.markerClassName ) && $.datepicker._curInst !== inst ) ) {
				$.datepicker._hideDatepicker();
		}
	},

	/* Adjust one of the date sub-fields. */
	_adjustDate: function( id, offset, period ) {
		var target = $( id ),
			inst = this._getInst( target[ 0 ] );

		if ( this._isDisabledDatepicker( target[ 0 ] ) ) {
			return;
		}
		this._adjustInstDate( inst, offset +
			( period === "M" ? this._get( inst, "showCurrentAtPos" ) : 0 ), // undo positioning
			period );
		this._updateDatepicker( inst );
	},

	/* Action for current link. */
	_gotoToday: function( id ) {
		var date,
			target = $( id ),
			inst = this._getInst( target[ 0 ] );

		if ( this._get( inst, "gotoCurrent" ) && inst.currentDay ) {
			inst.selectedDay = inst.currentDay;
			inst.drawMonth = inst.selectedMonth = inst.currentMonth;
			inst.drawYear = inst.selectedYear = inst.currentYear;
		} else {
			date = new Date();
			inst.selectedDay = date.getDate();
			inst.drawMonth = inst.selectedMonth = date.getMonth();
			inst.drawYear = inst.selectedYear = date.getFullYear();
		}
		this._notifyChange( inst );
		this._adjustDate( target );
	},

	/* Action for selecting a new month/year. */
	_selectMonthYear: function( id, select, period ) {
		var target = $( id ),
			inst = this._getInst( target[ 0 ] );

		inst[ "selected" + ( period === "M" ? "Month" : "Year" ) ] =
		inst[ "draw" + ( period === "M" ? "Month" : "Year" ) ] =
			parseInt( select.options[ select.selectedIndex ].value, 10 );

		this._notifyChange( inst );
		this._adjustDate( target );
	},

	/* Action for selecting a day. */
	_selectDay: function( id, month, year, td ) {
		var inst,
			target = $( id );

		if ( $( td ).hasClass( this._unselectableClass ) || this._isDisabledDatepicker( target[ 0 ] ) ) {
			return;
		}

		inst = this._getInst( target[ 0 ] );
		inst.selectedDay = inst.currentDay = $( "a", td ).html();
		inst.selectedMonth = inst.currentMonth = month;
		inst.selectedYear = inst.currentYear = year;
		this._selectDate( id, this._formatDate( inst,
			inst.currentDay, inst.currentMonth, inst.currentYear ) );
	},

	/* Erase the input field and hide the date picker. */
	_clearDate: function( id ) {
		var target = $( id );
		this._selectDate( target, "" );
	},

	/* Update the input field with the selected date. */
	_selectDate: function( id, dateStr ) {
		var onSelect,
			target = $( id ),
			inst = this._getInst( target[ 0 ] );

		dateStr = ( dateStr != null ? dateStr : this._formatDate( inst ) );
		if ( inst.input ) {
			inst.input.val( dateStr );
		}
		this._updateAlternate( inst );

		onSelect = this._get( inst, "onSelect" );
		if ( onSelect ) {
			onSelect.apply( ( inst.input ? inst.input[ 0 ] : null ), [ dateStr, inst ] );  // trigger custom callback
		} else if ( inst.input ) {
			inst.input.trigger( "change" ); // fire the change event
		}

		if ( inst.inline ) {
			this._updateDatepicker( inst );
		} else {
			this._hideDatepicker();
			this._lastInput = inst.input[ 0 ];
			if ( typeof( inst.input[ 0 ] ) !== "object" ) {
				inst.input.trigger( "focus" ); // restore focus
			}
			this._lastInput = null;
		}
	},

	/* Update any alternate field to synchronise with the main field. */
	_updateAlternate: function( inst ) {
		var altFormat, date, dateStr,
			altField = this._get( inst, "altField" );

		if ( altField ) { // update alternate field too
			altFormat = this._get( inst, "altFormat" ) || this._get( inst, "dateFormat" );
			date = this._getDate( inst );
			dateStr = this.formatDate( altFormat, date, this._getFormatConfig( inst ) );
			$( altField ).val( dateStr );
		}
	},

	/* Set as beforeShowDay function to prevent selection of weekends.
	 * @param  date  Date - the date to customise
	 * @return [boolean, string] - is this date selectable?, what is its CSS class?
	 */
	noWeekends: function( date ) {
		var day = date.getDay();
		return [ ( day > 0 && day < 6 ), "" ];
	},

	/* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
	 * @param  date  Date - the date to get the week for
	 * @return  number - the number of the week within the year that contains this date
	 */
	iso8601Week: function( date ) {
		var time,
			checkDate = new Date( date.getTime() );

		// Find Thursday of this week starting on Monday
		checkDate.setDate( checkDate.getDate() + 4 - ( checkDate.getDay() || 7 ) );

		time = checkDate.getTime();
		checkDate.setMonth( 0 ); // Compare with Jan 1
		checkDate.setDate( 1 );
		return Math.floor( Math.round( ( time - checkDate ) / 86400000 ) / 7 ) + 1;
	},

	/* Parse a string value into a date object.
	 * See formatDate below for the possible formats.
	 *
	 * @param  format string - the expected format of the date
	 * @param  value string - the date in the above format
	 * @param  settings Object - attributes include:
	 *					shortYearCutoff  number - the cutoff year for determining the century (optional)
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  Date - the extracted date value or null if value is blank
	 */
	parseDate: function( format, value, settings ) {
		if ( format == null || value == null ) {
			throw "Invalid arguments";
		}

		value = ( typeof value === "object" ? value.toString() : value + "" );
		if ( value === "" ) {
			return null;
		}

		var iFormat, dim, extra,
			iValue = 0,
			shortYearCutoffTemp = ( settings ? settings.shortYearCutoff : null ) || this._defaults.shortYearCutoff,
			shortYearCutoff = ( typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp :
				new Date().getFullYear() % 100 + parseInt( shortYearCutoffTemp, 10 ) ),
			dayNamesShort = ( settings ? settings.dayNamesShort : null ) || this._defaults.dayNamesShort,
			dayNames = ( settings ? settings.dayNames : null ) || this._defaults.dayNames,
			monthNamesShort = ( settings ? settings.monthNamesShort : null ) || this._defaults.monthNamesShort,
			monthNames = ( settings ? settings.monthNames : null ) || this._defaults.monthNames,
			year = -1,
			month = -1,
			day = -1,
			doy = -1,
			literal = false,
			date,

			// Check whether a format character is doubled
			lookAhead = function( match ) {
				var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
				if ( matches ) {
					iFormat++;
				}
				return matches;
			},

			// Extract a number from the string value
			getNumber = function( match ) {
				var isDoubled = lookAhead( match ),
					size = ( match === "@" ? 14 : ( match === "!" ? 20 :
					( match === "y" && isDoubled ? 4 : ( match === "o" ? 3 : 2 ) ) ) ),
					minSize = ( match === "y" ? size : 1 ),
					digits = new RegExp( "^\\d{" + minSize + "," + size + "}" ),
					num = value.substring( iValue ).match( digits );
				if ( !num ) {
					throw "Missing number at position " + iValue;
				}
				iValue += num[ 0 ].length;
				return parseInt( num[ 0 ], 10 );
			},

			// Extract a name from the string value and convert to an index
			getName = function( match, shortNames, longNames ) {
				var index = -1,
					names = $.map( lookAhead( match ) ? longNames : shortNames, function( v, k ) {
						return [ [ k, v ] ];
					} ).sort( function( a, b ) {
						return -( a[ 1 ].length - b[ 1 ].length );
					} );

				$.each( names, function( i, pair ) {
					var name = pair[ 1 ];
					if ( value.substr( iValue, name.length ).toLowerCase() === name.toLowerCase() ) {
						index = pair[ 0 ];
						iValue += name.length;
						return false;
					}
				} );
				if ( index !== -1 ) {
					return index + 1;
				} else {
					throw "Unknown name at position " + iValue;
				}
			},

			// Confirm that a literal character matches the string value
			checkLiteral = function() {
				if ( value.charAt( iValue ) !== format.charAt( iFormat ) ) {
					throw "Unexpected literal at position " + iValue;
				}
				iValue++;
			};

		for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
			if ( literal ) {
				if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
					literal = false;
				} else {
					checkLiteral();
				}
			} else {
				switch ( format.charAt( iFormat ) ) {
					case "d":
						day = getNumber( "d" );
						break;
					case "D":
						getName( "D", dayNamesShort, dayNames );
						break;
					case "o":
						doy = getNumber( "o" );
						break;
					case "m":
						month = getNumber( "m" );
						break;
					case "M":
						month = getName( "M", monthNamesShort, monthNames );
						break;
					case "y":
						year = getNumber( "y" );
						break;
					case "@":
						date = new Date( getNumber( "@" ) );
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "!":
						date = new Date( ( getNumber( "!" ) - this._ticksTo1970 ) / 10000 );
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "'":
						if ( lookAhead( "'" ) ) {
							checkLiteral();
						} else {
							literal = true;
						}
						break;
					default:
						checkLiteral();
				}
			}
		}

		if ( iValue < value.length ) {
			extra = value.substr( iValue );
			if ( !/^\s+/.test( extra ) ) {
				throw "Extra/unparsed characters found in date: " + extra;
			}
		}

		if ( year === -1 ) {
			year = new Date().getFullYear();
		} else if ( year < 100 ) {
			year += new Date().getFullYear() - new Date().getFullYear() % 100 +
				( year <= shortYearCutoff ? 0 : -100 );
		}

		if ( doy > -1 ) {
			month = 1;
			day = doy;
			do {
				dim = this._getDaysInMonth( year, month - 1 );
				if ( day <= dim ) {
					break;
				}
				month++;
				day -= dim;
			} while ( true );
		}

		date = this._daylightSavingAdjust( new Date( year, month - 1, day ) );
		if ( date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day ) {
			throw "Invalid date"; // E.g. 31/02/00
		}
		return date;
	},

	/* Standard date formats. */
	ATOM: "yy-mm-dd", // RFC 3339 (ISO 8601)
	COOKIE: "D, dd M yy",
	ISO_8601: "yy-mm-dd",
	RFC_822: "D, d M y",
	RFC_850: "DD, dd-M-y",
	RFC_1036: "D, d M y",
	RFC_1123: "D, d M yy",
	RFC_2822: "D, d M yy",
	RSS: "D, d M y", // RFC 822
	TICKS: "!",
	TIMESTAMP: "@",
	W3C: "yy-mm-dd", // ISO 8601

	_ticksTo1970: ( ( ( 1970 - 1 ) * 365 + Math.floor( 1970 / 4 ) - Math.floor( 1970 / 100 ) +
		Math.floor( 1970 / 400 ) ) * 24 * 60 * 60 * 10000000 ),

	/* Format a date object into a string value.
	 * The format can be combinations of the following:
	 * d  - day of month (no leading zero)
	 * dd - day of month (two digit)
	 * o  - day of year (no leading zeros)
	 * oo - day of year (three digit)
	 * D  - day name short
	 * DD - day name long
	 * m  - month of year (no leading zero)
	 * mm - month of year (two digit)
	 * M  - month name short
	 * MM - month name long
	 * y  - year (two digit)
	 * yy - year (four digit)
	 * @ - Unix timestamp (ms since 01/01/1970)
	 * ! - Windows ticks (100ns since 01/01/0001)
	 * "..." - literal text
	 * '' - single quote
	 *
	 * @param  format string - the desired format of the date
	 * @param  date Date - the date value to format
	 * @param  settings Object - attributes include:
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  string - the date in the above format
	 */
	formatDate: function( format, date, settings ) {
		if ( !date ) {
			return "";
		}

		var iFormat,
			dayNamesShort = ( settings ? settings.dayNamesShort : null ) || this._defaults.dayNamesShort,
			dayNames = ( settings ? settings.dayNames : null ) || this._defaults.dayNames,
			monthNamesShort = ( settings ? settings.monthNamesShort : null ) || this._defaults.monthNamesShort,
			monthNames = ( settings ? settings.monthNames : null ) || this._defaults.monthNames,

			// Check whether a format character is doubled
			lookAhead = function( match ) {
				var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
				if ( matches ) {
					iFormat++;
				}
				return matches;
			},

			// Format a number, with leading zero if necessary
			formatNumber = function( match, value, len ) {
				var num = "" + value;
				if ( lookAhead( match ) ) {
					while ( num.length < len ) {
						num = "0" + num;
					}
				}
				return num;
			},

			// Format a name, short or long as requested
			formatName = function( match, value, shortNames, longNames ) {
				return ( lookAhead( match ) ? longNames[ value ] : shortNames[ value ] );
			},
			output = "",
			literal = false;

		if ( date ) {
			for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
				if ( literal ) {
					if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
						literal = false;
					} else {
						output += format.charAt( iFormat );
					}
				} else {
					switch ( format.charAt( iFormat ) ) {
						case "d":
							output += formatNumber( "d", date.getDate(), 2 );
							break;
						case "D":
							output += formatName( "D", date.getDay(), dayNamesShort, dayNames );
							break;
						case "o":
							output += formatNumber( "o",
								Math.round( ( new Date( date.getFullYear(), date.getMonth(), date.getDate() ).getTime() - new Date( date.getFullYear(), 0, 0 ).getTime() ) / 86400000 ), 3 );
							break;
						case "m":
							output += formatNumber( "m", date.getMonth() + 1, 2 );
							break;
						case "M":
							output += formatName( "M", date.getMonth(), monthNamesShort, monthNames );
							break;
						case "y":
							output += ( lookAhead( "y" ) ? date.getFullYear() :
								( date.getFullYear() % 100 < 10 ? "0" : "" ) + date.getFullYear() % 100 );
							break;
						case "@":
							output += date.getTime();
							break;
						case "!":
							output += date.getTime() * 10000 + this._ticksTo1970;
							break;
						case "'":
							if ( lookAhead( "'" ) ) {
								output += "'";
							} else {
								literal = true;
							}
							break;
						default:
							output += format.charAt( iFormat );
					}
				}
			}
		}
		return output;
	},

	/* Extract all possible characters from the date format. */
	_possibleChars: function( format ) {
		var iFormat,
			chars = "",
			literal = false,

			// Check whether a format character is doubled
			lookAhead = function( match ) {
				var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
				if ( matches ) {
					iFormat++;
				}
				return matches;
			};

		for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
			if ( literal ) {
				if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
					literal = false;
				} else {
					chars += format.charAt( iFormat );
				}
			} else {
				switch ( format.charAt( iFormat ) ) {
					case "d": case "m": case "y": case "@":
						chars += "0123456789";
						break;
					case "D": case "M":
						return null; // Accept anything
					case "'":
						if ( lookAhead( "'" ) ) {
							chars += "'";
						} else {
							literal = true;
						}
						break;
					default:
						chars += format.charAt( iFormat );
				}
			}
		}
		return chars;
	},

	/* Get a setting value, defaulting if necessary. */
	_get: function( inst, name ) {
		return inst.settings[ name ] !== undefined ?
			inst.settings[ name ] : this._defaults[ name ];
	},

	/* Parse existing date and initialise date picker. */
	_setDateFromField: function( inst, noDefault ) {
		if ( inst.input.val() === inst.lastVal ) {
			return;
		}

		var dateFormat = this._get( inst, "dateFormat" ),
			dates = inst.lastVal = inst.input ? inst.input.val() : null,
			defaultDate = this._getDefaultDate( inst ),
			date = defaultDate,
			settings = this._getFormatConfig( inst );

		try {
			date = this.parseDate( dateFormat, dates, settings ) || defaultDate;
		} catch ( event ) {
			dates = ( noDefault ? "" : dates );
		}
		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		inst.currentDay = ( dates ? date.getDate() : 0 );
		inst.currentMonth = ( dates ? date.getMonth() : 0 );
		inst.currentYear = ( dates ? date.getFullYear() : 0 );
		this._adjustInstDate( inst );
	},

	/* Retrieve the default date shown on opening. */
	_getDefaultDate: function( inst ) {
		return this._restrictMinMax( inst,
			this._determineDate( inst, this._get( inst, "defaultDate" ), new Date() ) );
	},

	/* A date may be specified as an exact value or a relative one. */
	_determineDate: function( inst, date, defaultDate ) {
		var offsetNumeric = function( offset ) {
				var date = new Date();
				date.setDate( date.getDate() + offset );
				return date;
			},
			offsetString = function( offset ) {
				try {
					return $.datepicker.parseDate( $.datepicker._get( inst, "dateFormat" ),
						offset, $.datepicker._getFormatConfig( inst ) );
				}
				catch ( e ) {

					// Ignore
				}

				var date = ( offset.toLowerCase().match( /^c/ ) ?
					$.datepicker._getDate( inst ) : null ) || new Date(),
					year = date.getFullYear(),
					month = date.getMonth(),
					day = date.getDate(),
					pattern = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,
					matches = pattern.exec( offset );

				while ( matches ) {
					switch ( matches[ 2 ] || "d" ) {
						case "d" : case "D" :
							day += parseInt( matches[ 1 ], 10 ); break;
						case "w" : case "W" :
							day += parseInt( matches[ 1 ], 10 ) * 7; break;
						case "m" : case "M" :
							month += parseInt( matches[ 1 ], 10 );
							day = Math.min( day, $.datepicker._getDaysInMonth( year, month ) );
							break;
						case "y": case "Y" :
							year += parseInt( matches[ 1 ], 10 );
							day = Math.min( day, $.datepicker._getDaysInMonth( year, month ) );
							break;
					}
					matches = pattern.exec( offset );
				}
				return new Date( year, month, day );
			},
			newDate = ( date == null || date === "" ? defaultDate : ( typeof date === "string" ? offsetString( date ) :
				( typeof date === "number" ? ( isNaN( date ) ? defaultDate : offsetNumeric( date ) ) : new Date( date.getTime() ) ) ) );

		newDate = ( newDate && newDate.toString() === "Invalid Date" ? defaultDate : newDate );
		if ( newDate ) {
			newDate.setHours( 0 );
			newDate.setMinutes( 0 );
			newDate.setSeconds( 0 );
			newDate.setMilliseconds( 0 );
		}
		return this._daylightSavingAdjust( newDate );
	},

	/* Handle switch to/from daylight saving.
	 * Hours may be non-zero on daylight saving cut-over:
	 * > 12 when midnight changeover, but then cannot generate
	 * midnight datetime, so jump to 1AM, otherwise reset.
	 * @param  date  (Date) the date to check
	 * @return  (Date) the corrected date
	 */
	_daylightSavingAdjust: function( date ) {
		if ( !date ) {
			return null;
		}
		date.setHours( date.getHours() > 12 ? date.getHours() + 2 : 0 );
		return date;
	},

	/* Set the date(s) directly. */
	_setDate: function( inst, date, noChange ) {
		var clear = !date,
			origMonth = inst.selectedMonth,
			origYear = inst.selectedYear,
			newDate = this._restrictMinMax( inst, this._determineDate( inst, date, new Date() ) );

		inst.selectedDay = inst.currentDay = newDate.getDate();
		inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
		inst.drawYear = inst.selectedYear = inst.currentYear = newDate.getFullYear();
		if ( ( origMonth !== inst.selectedMonth || origYear !== inst.selectedYear ) && !noChange ) {
			this._notifyChange( inst );
		}
		this._adjustInstDate( inst );
		if ( inst.input ) {
			inst.input.val( clear ? "" : this._formatDate( inst ) );
		}
	},

	/* Retrieve the date(s) directly. */
	_getDate: function( inst ) {
		var startDate = ( !inst.currentYear || ( inst.input && inst.input.val() === "" ) ? null :
			this._daylightSavingAdjust( new Date(
			inst.currentYear, inst.currentMonth, inst.currentDay ) ) );
			return startDate;
	},

	/* Attach the onxxx handlers.  These are declared statically so
	 * they work with static code transformers like Caja.
	 */
	_attachHandlers: function( inst ) {
		var stepMonths = this._get( inst, "stepMonths" ),
			id = "#" + inst.id.replace( /\\\\/g, "\\" );
		inst.dpDiv.find( "[data-handler]" ).map( function() {
			var handler = {
				prev: function() {
					$.datepicker._adjustDate( id, -stepMonths, "M" );
				},
				next: function() {
					$.datepicker._adjustDate( id, +stepMonths, "M" );
				},
				hide: function() {
					$.datepicker._hideDatepicker();
				},
				today: function() {
					$.datepicker._gotoToday( id );
				},
				selectDay: function() {
					$.datepicker._selectDay( id, +this.getAttribute( "data-month" ), +this.getAttribute( "data-year" ), this );
					return false;
				},
				selectMonth: function() {
					$.datepicker._selectMonthYear( id, this, "M" );
					return false;
				},
				selectYear: function() {
					$.datepicker._selectMonthYear( id, this, "Y" );
					return false;
				}
			};
			$( this ).on( this.getAttribute( "data-event" ), handler[ this.getAttribute( "data-handler" ) ] );
		} );
	},

	/* Generate the HTML for the current state of the date picker. */
	_generateHTML: function( inst ) {
		var maxDraw, prevText, prev, nextText, next, currentText, gotoDate,
			controls, buttonPanel, firstDay, showWeek, dayNames, dayNamesMin,
			monthNames, monthNamesShort, beforeShowDay, showOtherMonths,
			selectOtherMonths, defaultDate, html, dow, row, group, col, selectedDate,
			cornerClass, calender, thead, day, daysInMonth, leadDays, curRows, numRows,
			printDate, dRow, tbody, daySettings, otherMonth, unselectable,
			tempDate = new Date(),
			today = this._daylightSavingAdjust(
				new Date( tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate() ) ), // clear time
			isRTL = this._get( inst, "isRTL" ),
			showButtonPanel = this._get( inst, "showButtonPanel" ),
			hideIfNoPrevNext = this._get( inst, "hideIfNoPrevNext" ),
			navigationAsDateFormat = this._get( inst, "navigationAsDateFormat" ),
			numMonths = this._getNumberOfMonths( inst ),
			showCurrentAtPos = this._get( inst, "showCurrentAtPos" ),
			stepMonths = this._get( inst, "stepMonths" ),
			isMultiMonth = ( numMonths[ 0 ] !== 1 || numMonths[ 1 ] !== 1 ),
			currentDate = this._daylightSavingAdjust( ( !inst.currentDay ? new Date( 9999, 9, 9 ) :
				new Date( inst.currentYear, inst.currentMonth, inst.currentDay ) ) ),
			minDate = this._getMinMaxDate( inst, "min" ),
			maxDate = this._getMinMaxDate( inst, "max" ),
			drawMonth = inst.drawMonth - showCurrentAtPos,
			drawYear = inst.drawYear;

		if ( drawMonth < 0 ) {
			drawMonth += 12;
			drawYear--;
		}
		if ( maxDate ) {
			maxDraw = this._daylightSavingAdjust( new Date( maxDate.getFullYear(),
				maxDate.getMonth() - ( numMonths[ 0 ] * numMonths[ 1 ] ) + 1, maxDate.getDate() ) );
			maxDraw = ( minDate && maxDraw < minDate ? minDate : maxDraw );
			while ( this._daylightSavingAdjust( new Date( drawYear, drawMonth, 1 ) ) > maxDraw ) {
				drawMonth--;
				if ( drawMonth < 0 ) {
					drawMonth = 11;
					drawYear--;
				}
			}
		}
		inst.drawMonth = drawMonth;
		inst.drawYear = drawYear;

		prevText = this._get( inst, "prevText" );
		prevText = ( !navigationAsDateFormat ? prevText : this.formatDate( prevText,
			this._daylightSavingAdjust( new Date( drawYear, drawMonth - stepMonths, 1 ) ),
			this._getFormatConfig( inst ) ) );

		prev = ( this._canAdjustMonth( inst, -1, drawYear, drawMonth ) ?
			"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click'" +
			" title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w" ) + "'>" + prevText + "</span></a>" :
			( hideIfNoPrevNext ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w" ) + "'>" + prevText + "</span></a>" ) );

		nextText = this._get( inst, "nextText" );
		nextText = ( !navigationAsDateFormat ? nextText : this.formatDate( nextText,
			this._daylightSavingAdjust( new Date( drawYear, drawMonth + stepMonths, 1 ) ),
			this._getFormatConfig( inst ) ) );

		next = ( this._canAdjustMonth( inst, +1, drawYear, drawMonth ) ?
			"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click'" +
			" title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e" ) + "'>" + nextText + "</span></a>" :
			( hideIfNoPrevNext ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e" ) + "'>" + nextText + "</span></a>" ) );

		currentText = this._get( inst, "currentText" );
		gotoDate = ( this._get( inst, "gotoCurrent" ) && inst.currentDay ? currentDate : today );
		currentText = ( !navigationAsDateFormat ? currentText :
			this.formatDate( currentText, gotoDate, this._getFormatConfig( inst ) ) );

		controls = ( !inst.inline ? "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" +
			this._get( inst, "closeText" ) + "</button>" : "" );

		buttonPanel = ( showButtonPanel ) ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + ( isRTL ? controls : "" ) +
			( this._isInRange( inst, gotoDate ) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'" +
			">" + currentText + "</button>" : "" ) + ( isRTL ? "" : controls ) + "</div>" : "";

		firstDay = parseInt( this._get( inst, "firstDay" ), 10 );
		firstDay = ( isNaN( firstDay ) ? 0 : firstDay );

		showWeek = this._get( inst, "showWeek" );
		dayNames = this._get( inst, "dayNames" );
		dayNamesMin = this._get( inst, "dayNamesMin" );
		monthNames = this._get( inst, "monthNames" );
		monthNamesShort = this._get( inst, "monthNamesShort" );
		beforeShowDay = this._get( inst, "beforeShowDay" );
		showOtherMonths = this._get( inst, "showOtherMonths" );
		selectOtherMonths = this._get( inst, "selectOtherMonths" );
		defaultDate = this._getDefaultDate( inst );
		html = "";

		for ( row = 0; row < numMonths[ 0 ]; row++ ) {
			group = "";
			this.maxRows = 4;
			for ( col = 0; col < numMonths[ 1 ]; col++ ) {
				selectedDate = this._daylightSavingAdjust( new Date( drawYear, drawMonth, inst.selectedDay ) );
				cornerClass = " ui-corner-all";
				calender = "";
				if ( isMultiMonth ) {
					calender += "<div class='ui-datepicker-group";
					if ( numMonths[ 1 ] > 1 ) {
						switch ( col ) {
							case 0: calender += " ui-datepicker-group-first";
								cornerClass = " ui-corner-" + ( isRTL ? "right" : "left" ); break;
							case numMonths[ 1 ] - 1: calender += " ui-datepicker-group-last";
								cornerClass = " ui-corner-" + ( isRTL ? "left" : "right" ); break;
							default: calender += " ui-datepicker-group-middle"; cornerClass = ""; break;
						}
					}
					calender += "'>";
				}
				calender += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + cornerClass + "'>" +
					( /all|left/.test( cornerClass ) && row === 0 ? ( isRTL ? next : prev ) : "" ) +
					( /all|right/.test( cornerClass ) && row === 0 ? ( isRTL ? prev : next ) : "" ) +
					this._generateMonthYearHeader( inst, drawMonth, drawYear, minDate, maxDate,
					row > 0 || col > 0, monthNames, monthNamesShort ) + // draw month headers
					"</div><table class='ui-datepicker-calendar'><thead>" +
					"<tr>";
				thead = ( showWeek ? "<th class='ui-datepicker-week-col'>" + this._get( inst, "weekHeader" ) + "</th>" : "" );
				for ( dow = 0; dow < 7; dow++ ) { // days of the week
					day = ( dow + firstDay ) % 7;
					thead += "<th scope='col'" + ( ( dow + firstDay + 6 ) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "" ) + ">" +
						"<span title='" + dayNames[ day ] + "'>" + dayNamesMin[ day ] + "</span></th>";
				}
				calender += thead + "</tr></thead><tbody>";
				daysInMonth = this._getDaysInMonth( drawYear, drawMonth );
				if ( drawYear === inst.selectedYear && drawMonth === inst.selectedMonth ) {
					inst.selectedDay = Math.min( inst.selectedDay, daysInMonth );
				}
				leadDays = ( this._getFirstDayOfMonth( drawYear, drawMonth ) - firstDay + 7 ) % 7;
				curRows = Math.ceil( ( leadDays + daysInMonth ) / 7 ); // calculate the number of rows to generate
				numRows = ( isMultiMonth ? this.maxRows > curRows ? this.maxRows : curRows : curRows ); //If multiple months, use the higher number of rows (see #7043)
				this.maxRows = numRows;
				printDate = this._daylightSavingAdjust( new Date( drawYear, drawMonth, 1 - leadDays ) );
				for ( dRow = 0; dRow < numRows; dRow++ ) { // create date picker rows
					calender += "<tr>";
					tbody = ( !showWeek ? "" : "<td class='ui-datepicker-week-col'>" +
						this._get( inst, "calculateWeek" )( printDate ) + "</td>" );
					for ( dow = 0; dow < 7; dow++ ) { // create date picker days
						daySettings = ( beforeShowDay ?
							beforeShowDay.apply( ( inst.input ? inst.input[ 0 ] : null ), [ printDate ] ) : [ true, "" ] );
						otherMonth = ( printDate.getMonth() !== drawMonth );
						unselectable = ( otherMonth && !selectOtherMonths ) || !daySettings[ 0 ] ||
							( minDate && printDate < minDate ) || ( maxDate && printDate > maxDate );
						tbody += "<td class='" +
							( ( dow + firstDay + 6 ) % 7 >= 5 ? " ui-datepicker-week-end" : "" ) + // highlight weekends
							( otherMonth ? " ui-datepicker-other-month" : "" ) + // highlight days from other months
							( ( printDate.getTime() === selectedDate.getTime() && drawMonth === inst.selectedMonth && inst._keyEvent ) || // user pressed key
							( defaultDate.getTime() === printDate.getTime() && defaultDate.getTime() === selectedDate.getTime() ) ?

							// or defaultDate is current printedDate and defaultDate is selectedDate
							" " + this._dayOverClass : "" ) + // highlight selected day
							( unselectable ? " " + this._unselectableClass + " ui-state-disabled" : "" ) +  // highlight unselectable days
							( otherMonth && !showOtherMonths ? "" : " " + daySettings[ 1 ] + // highlight custom dates
							( printDate.getTime() === currentDate.getTime() ? " " + this._currentClass : "" ) + // highlight selected day
							( printDate.getTime() === today.getTime() ? " ui-datepicker-today" : "" ) ) + "'" + // highlight today (if different)
							( ( !otherMonth || showOtherMonths ) && daySettings[ 2 ] ? " title='" + daySettings[ 2 ].replace( /'/g, "&#39;" ) + "'" : "" ) + // cell title
							( unselectable ? "" : " data-handler='selectDay' data-event='click' data-month='" + printDate.getMonth() + "' data-year='" + printDate.getFullYear() + "'" ) + ">" + // actions
							( otherMonth && !showOtherMonths ? "&#xa0;" : // display for other months
							( unselectable ? "<span class='ui-state-default'>" + printDate.getDate() + "</span>" : "<a class='ui-state-default" +
							( printDate.getTime() === today.getTime() ? " ui-state-highlight" : "" ) +
							( printDate.getTime() === currentDate.getTime() ? " ui-state-active" : "" ) + // highlight selected day
							( otherMonth ? " ui-priority-secondary" : "" ) + // distinguish dates from other months
							"' href='#'>" + printDate.getDate() + "</a>" ) ) + "</td>"; // display selectable date
						printDate.setDate( printDate.getDate() + 1 );
						printDate = this._daylightSavingAdjust( printDate );
					}
					calender += tbody + "</tr>";
				}
				drawMonth++;
				if ( drawMonth > 11 ) {
					drawMonth = 0;
					drawYear++;
				}
				calender += "</tbody></table>" + ( isMultiMonth ? "</div>" +
							( ( numMonths[ 0 ] > 0 && col === numMonths[ 1 ] - 1 ) ? "<div class='ui-datepicker-row-break'></div>" : "" ) : "" );
				group += calender;
			}
			html += group;
		}
		html += buttonPanel;
		inst._keyEvent = false;
		return html;
	},

	/* Generate the month and year header. */
	_generateMonthYearHeader: function( inst, drawMonth, drawYear, minDate, maxDate,
			secondary, monthNames, monthNamesShort ) {

		var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear,
			changeMonth = this._get( inst, "changeMonth" ),
			changeYear = this._get( inst, "changeYear" ),
			showMonthAfterYear = this._get( inst, "showMonthAfterYear" ),
			html = "<div class='ui-datepicker-title'>",
			monthHtml = "";

		// Month selection
		if ( secondary || !changeMonth ) {
			monthHtml += "<span class='ui-datepicker-month'>" + monthNames[ drawMonth ] + "</span>";
		} else {
			inMinYear = ( minDate && minDate.getFullYear() === drawYear );
			inMaxYear = ( maxDate && maxDate.getFullYear() === drawYear );
			monthHtml += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";
			for ( month = 0; month < 12; month++ ) {
				if ( ( !inMinYear || month >= minDate.getMonth() ) && ( !inMaxYear || month <= maxDate.getMonth() ) ) {
					monthHtml += "<option value='" + month + "'" +
						( month === drawMonth ? " selected='selected'" : "" ) +
						">" + monthNamesShort[ month ] + "</option>";
				}
			}
			monthHtml += "</select>";
		}

		if ( !showMonthAfterYear ) {
			html += monthHtml + ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" );
		}

		// Year selection
		if ( !inst.yearshtml ) {
			inst.yearshtml = "";
			if ( secondary || !changeYear ) {
				html += "<span class='ui-datepicker-year'>" + drawYear + "</span>";
			} else {

				// determine range of years to display
				years = this._get( inst, "yearRange" ).split( ":" );
				thisYear = new Date().getFullYear();
				determineYear = function( value ) {
					var year = ( value.match( /c[+\-].*/ ) ? drawYear + parseInt( value.substring( 1 ), 10 ) :
						( value.match( /[+\-].*/ ) ? thisYear + parseInt( value, 10 ) :
						parseInt( value, 10 ) ) );
					return ( isNaN( year ) ? thisYear : year );
				};
				year = determineYear( years[ 0 ] );
				endYear = Math.max( year, determineYear( years[ 1 ] || "" ) );
				year = ( minDate ? Math.max( year, minDate.getFullYear() ) : year );
				endYear = ( maxDate ? Math.min( endYear, maxDate.getFullYear() ) : endYear );
				inst.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";
				for ( ; year <= endYear; year++ ) {
					inst.yearshtml += "<option value='" + year + "'" +
						( year === drawYear ? " selected='selected'" : "" ) +
						">" + year + "</option>";
				}
				inst.yearshtml += "</select>";

				html += inst.yearshtml;
				inst.yearshtml = null;
			}
		}

		html += this._get( inst, "yearSuffix" );
		if ( showMonthAfterYear ) {
			html += ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" ) + monthHtml;
		}
		html += "</div>"; // Close datepicker_header
		return html;
	},

	/* Adjust one of the date sub-fields. */
	_adjustInstDate: function( inst, offset, period ) {
		var year = inst.selectedYear + ( period === "Y" ? offset : 0 ),
			month = inst.selectedMonth + ( period === "M" ? offset : 0 ),
			day = Math.min( inst.selectedDay, this._getDaysInMonth( year, month ) ) + ( period === "D" ? offset : 0 ),
			date = this._restrictMinMax( inst, this._daylightSavingAdjust( new Date( year, month, day ) ) );

		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		if ( period === "M" || period === "Y" ) {
			this._notifyChange( inst );
		}
	},

	/* Ensure a date is within any min/max bounds. */
	_restrictMinMax: function( inst, date ) {
		var minDate = this._getMinMaxDate( inst, "min" ),
			maxDate = this._getMinMaxDate( inst, "max" ),
			newDate = ( minDate && date < minDate ? minDate : date );
		return ( maxDate && newDate > maxDate ? maxDate : newDate );
	},

	/* Notify change of month/year. */
	_notifyChange: function( inst ) {
		var onChange = this._get( inst, "onChangeMonthYear" );
		if ( onChange ) {
			onChange.apply( ( inst.input ? inst.input[ 0 ] : null ),
				[ inst.selectedYear, inst.selectedMonth + 1, inst ] );
		}
	},

	/* Determine the number of months to show. */
	_getNumberOfMonths: function( inst ) {
		var numMonths = this._get( inst, "numberOfMonths" );
		return ( numMonths == null ? [ 1, 1 ] : ( typeof numMonths === "number" ? [ 1, numMonths ] : numMonths ) );
	},

	/* Determine the current maximum date - ensure no time components are set. */
	_getMinMaxDate: function( inst, minMax ) {
		return this._determineDate( inst, this._get( inst, minMax + "Date" ), null );
	},

	/* Find the number of days in a given month. */
	_getDaysInMonth: function( year, month ) {
		return 32 - this._daylightSavingAdjust( new Date( year, month, 32 ) ).getDate();
	},

	/* Find the day of the week of the first of a month. */
	_getFirstDayOfMonth: function( year, month ) {
		return new Date( year, month, 1 ).getDay();
	},

	/* Determines if we should allow a "next/prev" month display change. */
	_canAdjustMonth: function( inst, offset, curYear, curMonth ) {
		var numMonths = this._getNumberOfMonths( inst ),
			date = this._daylightSavingAdjust( new Date( curYear,
			curMonth + ( offset < 0 ? offset : numMonths[ 0 ] * numMonths[ 1 ] ), 1 ) );

		if ( offset < 0 ) {
			date.setDate( this._getDaysInMonth( date.getFullYear(), date.getMonth() ) );
		}
		return this._isInRange( inst, date );
	},

	/* Is the given date in the accepted range? */
	_isInRange: function( inst, date ) {
		var yearSplit, currentYear,
			minDate = this._getMinMaxDate( inst, "min" ),
			maxDate = this._getMinMaxDate( inst, "max" ),
			minYear = null,
			maxYear = null,
			years = this._get( inst, "yearRange" );
			if ( years ) {
				yearSplit = years.split( ":" );
				currentYear = new Date().getFullYear();
				minYear = parseInt( yearSplit[ 0 ], 10 );
				maxYear = parseInt( yearSplit[ 1 ], 10 );
				if ( yearSplit[ 0 ].match( /[+\-].*/ ) ) {
					minYear += currentYear;
				}
				if ( yearSplit[ 1 ].match( /[+\-].*/ ) ) {
					maxYear += currentYear;
				}
			}

		return ( ( !minDate || date.getTime() >= minDate.getTime() ) &&
			( !maxDate || date.getTime() <= maxDate.getTime() ) &&
			( !minYear || date.getFullYear() >= minYear ) &&
			( !maxYear || date.getFullYear() <= maxYear ) );
	},

	/* Provide the configuration settings for formatting/parsing. */
	_getFormatConfig: function( inst ) {
		var shortYearCutoff = this._get( inst, "shortYearCutoff" );
		shortYearCutoff = ( typeof shortYearCutoff !== "string" ? shortYearCutoff :
			new Date().getFullYear() % 100 + parseInt( shortYearCutoff, 10 ) );
		return { shortYearCutoff: shortYearCutoff,
			dayNamesShort: this._get( inst, "dayNamesShort" ), dayNames: this._get( inst, "dayNames" ),
			monthNamesShort: this._get( inst, "monthNamesShort" ), monthNames: this._get( inst, "monthNames" ) };
	},

	/* Format the given date for display. */
	_formatDate: function( inst, day, month, year ) {
		if ( !day ) {
			inst.currentDay = inst.selectedDay;
			inst.currentMonth = inst.selectedMonth;
			inst.currentYear = inst.selectedYear;
		}
		var date = ( day ? ( typeof day === "object" ? day :
			this._daylightSavingAdjust( new Date( year, month, day ) ) ) :
			this._daylightSavingAdjust( new Date( inst.currentYear, inst.currentMonth, inst.currentDay ) ) );
		return this.formatDate( this._get( inst, "dateFormat" ), date, this._getFormatConfig( inst ) );
	}
} );

/*
 * Bind hover events for datepicker elements.
 * Done via delegate so the binding only occurs once in the lifetime of the parent div.
 * Global datepicker_instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
 */
function datepicker_bindHover( dpDiv ) {
	var selector = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
	return dpDiv.on( "mouseout", selector, function() {
			$( this ).removeClass( "ui-state-hover" );
			if ( this.className.indexOf( "ui-datepicker-prev" ) !== -1 ) {
				$( this ).removeClass( "ui-datepicker-prev-hover" );
			}
			if ( this.className.indexOf( "ui-datepicker-next" ) !== -1 ) {
				$( this ).removeClass( "ui-datepicker-next-hover" );
			}
		} )
		.on( "mouseover", selector, datepicker_handleMouseover );
}

function datepicker_handleMouseover() {
	if ( !$.datepicker._isDisabledDatepicker( datepicker_instActive.inline ? datepicker_instActive.dpDiv.parent()[ 0 ] : datepicker_instActive.input[ 0 ] ) ) {
		$( this ).parents( ".ui-datepicker-calendar" ).find( "a" ).removeClass( "ui-state-hover" );
		$( this ).addClass( "ui-state-hover" );
		if ( this.className.indexOf( "ui-datepicker-prev" ) !== -1 ) {
			$( this ).addClass( "ui-datepicker-prev-hover" );
		}
		if ( this.className.indexOf( "ui-datepicker-next" ) !== -1 ) {
			$( this ).addClass( "ui-datepicker-next-hover" );
		}
	}
}

/* jQuery extend now ignores nulls! */
function datepicker_extendRemove( target, props ) {
	$.extend( target, props );
	for ( var name in props ) {
		if ( props[ name ] == null ) {
			target[ name ] = props[ name ];
		}
	}
	return target;
}

/* Invoke the datepicker functionality.
   @param  options  string - a command, optionally followed by additional parameters or
					Object - settings for attaching new datepicker functionality
   @return  jQuery object */
$.fn.datepicker = function( options ) {

	/* Verify an empty collection wasn't passed - Fixes #6976 */
	if ( !this.length ) {
		return this;
	}

	/* Initialise the date picker. */
	if ( !$.datepicker.initialized ) {
		$( document ).on( "mousedown", $.datepicker._checkExternalClick );
		$.datepicker.initialized = true;
	}

	/* Append datepicker main container to body if not exist. */
	if ( $( "#" + $.datepicker._mainDivId ).length === 0 ) {
		$( "body" ).append( $.datepicker.dpDiv );
	}

	var otherArgs = Array.prototype.slice.call( arguments, 1 );
	if ( typeof options === "string" && ( options === "isDisabled" || options === "getDate" || options === "widget" ) ) {
		return $.datepicker[ "_" + options + "Datepicker" ].
			apply( $.datepicker, [ this[ 0 ] ].concat( otherArgs ) );
	}
	if ( options === "option" && arguments.length === 2 && typeof arguments[ 1 ] === "string" ) {
		return $.datepicker[ "_" + options + "Datepicker" ].
			apply( $.datepicker, [ this[ 0 ] ].concat( otherArgs ) );
	}
	return this.each( function() {
		typeof options === "string" ?
			$.datepicker[ "_" + options + "Datepicker" ].
				apply( $.datepicker, [ this ].concat( otherArgs ) ) :
			$.datepicker._attachDatepicker( this, options );
	} );
};

$.datepicker = new Datepicker(); // singleton instance
$.datepicker.initialized = false;
$.datepicker.uuid = new Date().getTime();
$.datepicker.version = "1.12.1";

var widgetsDatepicker = $.datepicker;




// This file is deprecated
var ie = $.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );

/*!
 * jQuery UI Mouse 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Mouse
//>>group: Widgets
//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
//>>docs: http://api.jqueryui.com/mouse/



var mouseHandled = false;
$( document ).on( "mouseup", function() {
	mouseHandled = false;
} );

var widgetsMouse = $.widget( "ui.mouse", {
	version: "1.12.1",
	options: {
		cancel: "input, textarea, button, select, option",
		distance: 1,
		delay: 0
	},
	_mouseInit: function() {
		var that = this;

		this.element
			.on( "mousedown." + this.widgetName, function( event ) {
				return that._mouseDown( event );
			} )
			.on( "click." + this.widgetName, function( event ) {
				if ( true === $.data( event.target, that.widgetName + ".preventClickEvent" ) ) {
					$.removeData( event.target, that.widgetName + ".preventClickEvent" );
					event.stopImmediatePropagation();
					return false;
				}
			} );

		this.started = false;
	},

	// TODO: make sure destroying one instance of mouse doesn't mess with
	// other instances of mouse
	_mouseDestroy: function() {
		this.element.off( "." + this.widgetName );
		if ( this._mouseMoveDelegate ) {
			this.document
				.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
		}
	},

	_mouseDown: function( event ) {

		// don't let more than one widget handle mouseStart
		if ( mouseHandled ) {
			return;
		}

		this._mouseMoved = false;

		// We may have missed mouseup (out of window)
		( this._mouseStarted && this._mouseUp( event ) );

		this._mouseDownEvent = event;

		var that = this,
			btnIsLeft = ( event.which === 1 ),

			// event.target.nodeName works around a bug in IE 8 with
			// disabled inputs (#7620)
			elIsCancel = ( typeof this.options.cancel === "string" && event.target.nodeName ?
				$( event.target ).closest( this.options.cancel ).length : false );
		if ( !btnIsLeft || elIsCancel || !this._mouseCapture( event ) ) {
			return true;
		}

		this.mouseDelayMet = !this.options.delay;
		if ( !this.mouseDelayMet ) {
			this._mouseDelayTimer = setTimeout( function() {
				that.mouseDelayMet = true;
			}, this.options.delay );
		}

		if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
			this._mouseStarted = ( this._mouseStart( event ) !== false );
			if ( !this._mouseStarted ) {
				event.preventDefault();
				return true;
			}
		}

		// Click event may never have fired (Gecko & Opera)
		if ( true === $.data( event.target, this.widgetName + ".preventClickEvent" ) ) {
			$.removeData( event.target, this.widgetName + ".preventClickEvent" );
		}

		// These delegates are required to keep context
		this._mouseMoveDelegate = function( event ) {
			return that._mouseMove( event );
		};
		this._mouseUpDelegate = function( event ) {
			return that._mouseUp( event );
		};

		this.document
			.on( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.on( "mouseup." + this.widgetName, this._mouseUpDelegate );

		event.preventDefault();

		mouseHandled = true;
		return true;
	},

	_mouseMove: function( event ) {

		// Only check for mouseups outside the document if you've moved inside the document
		// at least once. This prevents the firing of mouseup in the case of IE<9, which will
		// fire a mousemove event if content is placed under the cursor. See #7778
		// Support: IE <9
		if ( this._mouseMoved ) {

			// IE mouseup check - mouseup happened when mouse was out of window
			if ( $.ui.ie && ( !document.documentMode || document.documentMode < 9 ) &&
					!event.button ) {
				return this._mouseUp( event );

			// Iframe mouseup check - mouseup occurred in another document
			} else if ( !event.which ) {

				// Support: Safari <=8 - 9
				// Safari sets which to 0 if you press any of the following keys
				// during a drag (#14461)
				if ( event.originalEvent.altKey || event.originalEvent.ctrlKey ||
						event.originalEvent.metaKey || event.originalEvent.shiftKey ) {
					this.ignoreMissingWhich = true;
				} else if ( !this.ignoreMissingWhich ) {
					return this._mouseUp( event );
				}
			}
		}

		if ( event.which || event.button ) {
			this._mouseMoved = true;
		}

		if ( this._mouseStarted ) {
			this._mouseDrag( event );
			return event.preventDefault();
		}

		if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
			this._mouseStarted =
				( this._mouseStart( this._mouseDownEvent, event ) !== false );
			( this._mouseStarted ? this._mouseDrag( event ) : this._mouseUp( event ) );
		}

		return !this._mouseStarted;
	},

	_mouseUp: function( event ) {
		this.document
			.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.off( "mouseup." + this.widgetName, this._mouseUpDelegate );

		if ( this._mouseStarted ) {
			this._mouseStarted = false;

			if ( event.target === this._mouseDownEvent.target ) {
				$.data( event.target, this.widgetName + ".preventClickEvent", true );
			}

			this._mouseStop( event );
		}

		if ( this._mouseDelayTimer ) {
			clearTimeout( this._mouseDelayTimer );
			delete this._mouseDelayTimer;
		}

		this.ignoreMissingWhich = false;
		mouseHandled = false;
		event.preventDefault();
	},

	_mouseDistanceMet: function( event ) {
		return ( Math.max(
				Math.abs( this._mouseDownEvent.pageX - event.pageX ),
				Math.abs( this._mouseDownEvent.pageY - event.pageY )
			) >= this.options.distance
		);
	},

	_mouseDelayMet: function( /* event */ ) {
		return this.mouseDelayMet;
	},

	// These are placeholder methods, to be overriden by extending plugin
	_mouseStart: function( /* event */ ) {},
	_mouseDrag: function( /* event */ ) {},
	_mouseStop: function( /* event */ ) {},
	_mouseCapture: function( /* event */ ) { return true; }
} );




// $.ui.plugin is deprecated. Use $.widget() extensions instead.
var plugin = $.ui.plugin = {
	add: function( module, option, set ) {
		var i,
			proto = $.ui[ module ].prototype;
		for ( i in set ) {
			proto.plugins[ i ] = proto.plugins[ i ] || [];
			proto.plugins[ i ].push( [ option, set[ i ] ] );
		}
	},
	call: function( instance, name, args, allowDisconnected ) {
		var i,
			set = instance.plugins[ name ];

		if ( !set ) {
			return;
		}

		if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode ||
				instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
			return;
		}

		for ( i = 0; i < set.length; i++ ) {
			if ( instance.options[ set[ i ][ 0 ] ] ) {
				set[ i ][ 1 ].apply( instance.element, args );
			}
		}
	}
};



var safeBlur = $.ui.safeBlur = function( element ) {

	// Support: IE9 - 10 only
	// If the <body> is blurred, IE will switch windows, see #9420
	if ( element && element.nodeName.toLowerCase() !== "body" ) {
		$( element ).trigger( "blur" );
	}
};


/*!
 * jQuery UI Draggable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Draggable
//>>group: Interactions
//>>description: Enables dragging functionality for any element.
//>>docs: http://api.jqueryui.com/draggable/
//>>demos: http://jqueryui.com/draggable/
//>>css.structure: ../../themes/base/draggable.css



$.widget( "ui.draggable", $.ui.mouse, {
	version: "1.12.1",
	widgetEventPrefix: "drag",
	options: {
		addClasses: true,
		appendTo: "parent",
		axis: false,
		connectToSortable: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		grid: false,
		handle: false,
		helper: "original",
		iframeFix: false,
		opacity: false,
		refreshPositions: false,
		revert: false,
		revertDuration: 500,
		scope: "default",
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		snap: false,
		snapMode: "both",
		snapTolerance: 20,
		stack: false,
		zIndex: false,

		// Callbacks
		drag: null,
		start: null,
		stop: null
	},
	_create: function() {

		if ( this.options.helper === "original" ) {
			this._setPositionRelative();
		}
		if ( this.options.addClasses ) {
			this._addClass( "ui-draggable" );
		}
		this._setHandleClassName();

		this._mouseInit();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "handle" ) {
			this._removeHandleClassName();
			this._setHandleClassName();
		}
	},

	_destroy: function() {
		if ( ( this.helper || this.element ).is( ".ui-draggable-dragging" ) ) {
			this.destroyOnClear = true;
			return;
		}
		this._removeHandleClassName();
		this._mouseDestroy();
	},

	_mouseCapture: function( event ) {
		var o = this.options;

		// Among others, prevent a drag on a resizable-handle
		if ( this.helper || o.disabled ||
				$( event.target ).closest( ".ui-resizable-handle" ).length > 0 ) {
			return false;
		}

		//Quit if we're not on a valid handle
		this.handle = this._getHandle( event );
		if ( !this.handle ) {
			return false;
		}

		this._blurActiveElement( event );

		this._blockFrames( o.iframeFix === true ? "iframe" : o.iframeFix );

		return true;

	},

	_blockFrames: function( selector ) {
		this.iframeBlocks = this.document.find( selector ).map( function() {
			var iframe = $( this );

			return $( "<div>" )
				.css( "position", "absolute" )
				.appendTo( iframe.parent() )
				.outerWidth( iframe.outerWidth() )
				.outerHeight( iframe.outerHeight() )
				.offset( iframe.offset() )[ 0 ];
		} );
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_blurActiveElement: function( event ) {
		var activeElement = $.ui.safeActiveElement( this.document[ 0 ] ),
			target = $( event.target );

		// Don't blur if the event occurred on an element that is within
		// the currently focused element
		// See #10527, #12472
		if ( target.closest( activeElement ).length ) {
			return;
		}

		// Blur any element that currently has focus, see #4261
		$.ui.safeBlur( activeElement );
	},

	_mouseStart: function( event ) {

		var o = this.options;

		//Create and append the visible helper
		this.helper = this._createHelper( event );

		this._addClass( this.helper, "ui-draggable-dragging" );

		//Cache the helper size
		this._cacheHelperProportions();

		//If ddmanager is used for droppables, set the global draggable
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.current = this;
		}

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Store the helper's css position
		this.cssPosition = this.helper.css( "position" );
		this.scrollParent = this.helper.scrollParent( true );
		this.offsetParent = this.helper.offsetParent();
		this.hasFixedAncestor = this.helper.parents().filter( function() {
				return $( this ).css( "position" ) === "fixed";
			} ).length > 0;

		//The element's absolute position on the page minus margins
		this.positionAbs = this.element.offset();
		this._refreshOffsets( event );

		//Generate the original position
		this.originalPosition = this.position = this._generatePosition( event, false );
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		( o.cursorAt && this._adjustOffsetFromHelper( o.cursorAt ) );

		//Set a containment if given in the options
		this._setContainment();

		//Trigger event + callbacks
		if ( this._trigger( "start", event ) === false ) {
			this._clear();
			return false;
		}

		//Recache the helper size
		this._cacheHelperProportions();

		//Prepare the droppable offsets
		if ( $.ui.ddmanager && !o.dropBehaviour ) {
			$.ui.ddmanager.prepareOffsets( this, event );
		}

		// Execute the drag once - this causes the helper not to be visible before getting its
		// correct position
		this._mouseDrag( event, true );

		// If the ddmanager is used for droppables, inform the manager that dragging has started
		// (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStart( this, event );
		}

		return true;
	},

	_refreshOffsets: function( event ) {
		this.offset = {
			top: this.positionAbs.top - this.margins.top,
			left: this.positionAbs.left - this.margins.left,
			scroll: false,
			parent: this._getParentOffset(),
			relative: this._getRelativeOffset()
		};

		this.offset.click = {
			left: event.pageX - this.offset.left,
			top: event.pageY - this.offset.top
		};
	},

	_mouseDrag: function( event, noPropagation ) {

		// reset any necessary cached properties (see #5009)
		if ( this.hasFixedAncestor ) {
			this.offset.parent = this._getParentOffset();
		}

		//Compute the helpers position
		this.position = this._generatePosition( event, true );
		this.positionAbs = this._convertPositionTo( "absolute" );

		//Call plugins and callbacks and use the resulting position if something is returned
		if ( !noPropagation ) {
			var ui = this._uiHash();
			if ( this._trigger( "drag", event, ui ) === false ) {
				this._mouseUp( new $.Event( "mouseup", event ) );
				return false;
			}
			this.position = ui.position;
		}

		this.helper[ 0 ].style.left = this.position.left + "px";
		this.helper[ 0 ].style.top = this.position.top + "px";

		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.drag( this, event );
		}

		return false;
	},

	_mouseStop: function( event ) {

		//If we are using droppables, inform the manager about the drop
		var that = this,
			dropped = false;
		if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
			dropped = $.ui.ddmanager.drop( this, event );
		}

		//if a drop comes from outside (a sortable)
		if ( this.dropped ) {
			dropped = this.dropped;
			this.dropped = false;
		}

		if ( ( this.options.revert === "invalid" && !dropped ) ||
				( this.options.revert === "valid" && dropped ) ||
				this.options.revert === true || ( $.isFunction( this.options.revert ) &&
				this.options.revert.call( this.element, dropped ) )
		) {
			$( this.helper ).animate(
				this.originalPosition,
				parseInt( this.options.revertDuration, 10 ),
				function() {
					if ( that._trigger( "stop", event ) !== false ) {
						that._clear();
					}
				}
			);
		} else {
			if ( this._trigger( "stop", event ) !== false ) {
				this._clear();
			}
		}

		return false;
	},

	_mouseUp: function( event ) {
		this._unblockFrames();

		// If the ddmanager is used for droppables, inform the manager that dragging has stopped
		// (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStop( this, event );
		}

		// Only need to focus if the event occurred on the draggable itself, see #10527
		if ( this.handleElement.is( event.target ) ) {

			// The interaction is over; whether or not the click resulted in a drag,
			// focus the element
			this.element.trigger( "focus" );
		}

		return $.ui.mouse.prototype._mouseUp.call( this, event );
	},

	cancel: function() {

		if ( this.helper.is( ".ui-draggable-dragging" ) ) {
			this._mouseUp( new $.Event( "mouseup", { target: this.element[ 0 ] } ) );
		} else {
			this._clear();
		}

		return this;

	},

	_getHandle: function( event ) {
		return this.options.handle ?
			!!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
			true;
	},

	_setHandleClassName: function() {
		this.handleElement = this.options.handle ?
			this.element.find( this.options.handle ) : this.element;
		this._addClass( this.handleElement, "ui-draggable-handle" );
	},

	_removeHandleClassName: function() {
		this._removeClass( this.handleElement, "ui-draggable-handle" );
	},

	_createHelper: function( event ) {

		var o = this.options,
			helperIsFunction = $.isFunction( o.helper ),
			helper = helperIsFunction ?
				$( o.helper.apply( this.element[ 0 ], [ event ] ) ) :
				( o.helper === "clone" ?
					this.element.clone().removeAttr( "id" ) :
					this.element );

		if ( !helper.parents( "body" ).length ) {
			helper.appendTo( ( o.appendTo === "parent" ?
				this.element[ 0 ].parentNode :
				o.appendTo ) );
		}

		// Http://bugs.jqueryui.com/ticket/9446
		// a helper function can return the original element
		// which wouldn't have been set to relative in _create
		if ( helperIsFunction && helper[ 0 ] === this.element[ 0 ] ) {
			this._setPositionRelative();
		}

		if ( helper[ 0 ] !== this.element[ 0 ] &&
				!( /(fixed|absolute)/ ).test( helper.css( "position" ) ) ) {
			helper.css( "position", "absolute" );
		}

		return helper;

	},

	_setPositionRelative: function() {
		if ( !( /^(?:r|a|f)/ ).test( this.element.css( "position" ) ) ) {
			this.element[ 0 ].style.position = "relative";
		}
	},

	_adjustOffsetFromHelper: function( obj ) {
		if ( typeof obj === "string" ) {
			obj = obj.split( " " );
		}
		if ( $.isArray( obj ) ) {
			obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
		}
		if ( "left" in obj ) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ( "right" in obj ) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ( "top" in obj ) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ( "bottom" in obj ) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_isRootNode: function( element ) {
		return ( /(html|body)/i ).test( element.tagName ) || element === this.document[ 0 ];
	},

	_getParentOffset: function() {

		//Get the offsetParent and cache its position
		var po = this.offsetParent.offset(),
			document = this.document[ 0 ];

		// This is a special case where we need to modify a offset calculated on start, since the
		// following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the
		// next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
		// the document, which means that the scroll is included in the initial calculation of the
		// offset of the parent, and never recalculated upon drag
		if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== document &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		if ( this._isRootNode( this.offsetParent[ 0 ] ) ) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
			left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
		};

	},

	_getRelativeOffset: function() {
		if ( this.cssPosition !== "relative" ) {
			return { top: 0, left: 0 };
		}

		var p = this.element.position(),
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
				( !scrollIsRootNode ? this.scrollParent.scrollTop() : 0 ),
			left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
				( !scrollIsRootNode ? this.scrollParent.scrollLeft() : 0 )
		};

	},

	_cacheMargins: function() {
		this.margins = {
			left: ( parseInt( this.element.css( "marginLeft" ), 10 ) || 0 ),
			top: ( parseInt( this.element.css( "marginTop" ), 10 ) || 0 ),
			right: ( parseInt( this.element.css( "marginRight" ), 10 ) || 0 ),
			bottom: ( parseInt( this.element.css( "marginBottom" ), 10 ) || 0 )
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var isUserScrollable, c, ce,
			o = this.options,
			document = this.document[ 0 ];

		this.relativeContainer = null;

		if ( !o.containment ) {
			this.containment = null;
			return;
		}

		if ( o.containment === "window" ) {
			this.containment = [
				$( window ).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
				$( window ).scrollTop() - this.offset.relative.top - this.offset.parent.top,
				$( window ).scrollLeft() + $( window ).width() -
					this.helperProportions.width - this.margins.left,
				$( window ).scrollTop() +
					( $( window ).height() || document.body.parentNode.scrollHeight ) -
					this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment === "document" ) {
			this.containment = [
				0,
				0,
				$( document ).width() - this.helperProportions.width - this.margins.left,
				( $( document ).height() || document.body.parentNode.scrollHeight ) -
					this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment.constructor === Array ) {
			this.containment = o.containment;
			return;
		}

		if ( o.containment === "parent" ) {
			o.containment = this.helper[ 0 ].parentNode;
		}

		c = $( o.containment );
		ce = c[ 0 ];

		if ( !ce ) {
			return;
		}

		isUserScrollable = /(scroll|auto)/.test( c.css( "overflow" ) );

		this.containment = [
			( parseInt( c.css( "borderLeftWidth" ), 10 ) || 0 ) +
				( parseInt( c.css( "paddingLeft" ), 10 ) || 0 ),
			( parseInt( c.css( "borderTopWidth" ), 10 ) || 0 ) +
				( parseInt( c.css( "paddingTop" ), 10 ) || 0 ),
			( isUserScrollable ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
				( parseInt( c.css( "borderRightWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingRight" ), 10 ) || 0 ) -
				this.helperProportions.width -
				this.margins.left -
				this.margins.right,
			( isUserScrollable ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
				( parseInt( c.css( "borderBottomWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingBottom" ), 10 ) || 0 ) -
				this.helperProportions.height -
				this.margins.top -
				this.margins.bottom
		];
		this.relativeContainer = c;
	},

	_convertPositionTo: function( d, pos ) {

		if ( !pos ) {
			pos = this.position;
		}

		var mod = d === "absolute" ? 1 : -1,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: (

				// The absolute mouse position
				pos.top	+

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top * mod -
				( ( this.cssPosition === "fixed" ?
					-this.offset.scroll.top :
					( scrollIsRootNode ? 0 : this.offset.scroll.top ) ) * mod )
			),
			left: (

				// The absolute mouse position
				pos.left +

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left * mod	-
				( ( this.cssPosition === "fixed" ?
					-this.offset.scroll.left :
					( scrollIsRootNode ? 0 : this.offset.scroll.left ) ) * mod )
			)
		};

	},

	_generatePosition: function( event, constrainPosition ) {

		var containment, co, top, left,
			o = this.options,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] ),
			pageX = event.pageX,
			pageY = event.pageY;

		// Cache the scroll
		if ( !scrollIsRootNode || !this.offset.scroll ) {
			this.offset.scroll = {
				top: this.scrollParent.scrollTop(),
				left: this.scrollParent.scrollLeft()
			};
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		// If we are not dragging yet, we won't check for options
		if ( constrainPosition ) {
			if ( this.containment ) {
				if ( this.relativeContainer ) {
					co = this.relativeContainer.offset();
					containment = [
						this.containment[ 0 ] + co.left,
						this.containment[ 1 ] + co.top,
						this.containment[ 2 ] + co.left,
						this.containment[ 3 ] + co.top
					];
				} else {
					containment = this.containment;
				}

				if ( event.pageX - this.offset.click.left < containment[ 0 ] ) {
					pageX = containment[ 0 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top < containment[ 1 ] ) {
					pageY = containment[ 1 ] + this.offset.click.top;
				}
				if ( event.pageX - this.offset.click.left > containment[ 2 ] ) {
					pageX = containment[ 2 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top > containment[ 3 ] ) {
					pageY = containment[ 3 ] + this.offset.click.top;
				}
			}

			if ( o.grid ) {

				//Check for grid elements set to 0 to prevent divide by 0 error causing invalid
				// argument errors in IE (see ticket #6950)
				top = o.grid[ 1 ] ? this.originalPageY + Math.round( ( pageY -
					this.originalPageY ) / o.grid[ 1 ] ) * o.grid[ 1 ] : this.originalPageY;
				pageY = containment ? ( ( top - this.offset.click.top >= containment[ 1 ] ||
					top - this.offset.click.top > containment[ 3 ] ) ?
						top :
						( ( top - this.offset.click.top >= containment[ 1 ] ) ?
							top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) : top;

				left = o.grid[ 0 ] ? this.originalPageX +
					Math.round( ( pageX - this.originalPageX ) / o.grid[ 0 ] ) * o.grid[ 0 ] :
					this.originalPageX;
				pageX = containment ? ( ( left - this.offset.click.left >= containment[ 0 ] ||
					left - this.offset.click.left > containment[ 2 ] ) ?
						left :
						( ( left - this.offset.click.left >= containment[ 0 ] ) ?
							left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) : left;
			}

			if ( o.axis === "y" ) {
				pageX = this.originalPageX;
			}

			if ( o.axis === "x" ) {
				pageY = this.originalPageY;
			}
		}

		return {
			top: (

				// The absolute mouse position
				pageY -

				// Click offset (relative to the element)
				this.offset.click.top -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top +
				( this.cssPosition === "fixed" ?
					-this.offset.scroll.top :
					( scrollIsRootNode ? 0 : this.offset.scroll.top ) )
			),
			left: (

				// The absolute mouse position
				pageX -

				// Click offset (relative to the element)
				this.offset.click.left -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left +
				( this.cssPosition === "fixed" ?
					-this.offset.scroll.left :
					( scrollIsRootNode ? 0 : this.offset.scroll.left ) )
			)
		};

	},

	_clear: function() {
		this._removeClass( this.helper, "ui-draggable-dragging" );
		if ( this.helper[ 0 ] !== this.element[ 0 ] && !this.cancelHelperRemoval ) {
			this.helper.remove();
		}
		this.helper = null;
		this.cancelHelperRemoval = false;
		if ( this.destroyOnClear ) {
			this.destroy();
		}
	},

	// From now on bulk stuff - mainly helpers

	_trigger: function( type, event, ui ) {
		ui = ui || this._uiHash();
		$.ui.plugin.call( this, type, [ event, ui, this ], true );

		// Absolute position and offset (see #6884 ) have to be recalculated after plugins
		if ( /^(drag|start|stop)/.test( type ) ) {
			this.positionAbs = this._convertPositionTo( "absolute" );
			ui.offset = this.positionAbs;
		}
		return $.Widget.prototype._trigger.call( this, type, event, ui );
	},

	plugins: {},

	_uiHash: function() {
		return {
			helper: this.helper,
			position: this.position,
			originalPosition: this.originalPosition,
			offset: this.positionAbs
		};
	}

} );

$.ui.plugin.add( "draggable", "connectToSortable", {
	start: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		} );

		draggable.sortables = [];
		$( draggable.options.connectToSortable ).each( function() {
			var sortable = $( this ).sortable( "instance" );

			if ( sortable && !sortable.options.disabled ) {
				draggable.sortables.push( sortable );

				// RefreshPositions is called at drag start to refresh the containerCache
				// which is used in drag. This ensures it's initialized and synchronized
				// with any changes that might have happened on the page since initialization.
				sortable.refreshPositions();
				sortable._trigger( "activate", event, uiSortable );
			}
		} );
	},
	stop: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		} );

		draggable.cancelHelperRemoval = false;

		$.each( draggable.sortables, function() {
			var sortable = this;

			if ( sortable.isOver ) {
				sortable.isOver = 0;

				// Allow this sortable to handle removing the helper
				draggable.cancelHelperRemoval = true;
				sortable.cancelHelperRemoval = false;

				// Use _storedCSS To restore properties in the sortable,
				// as this also handles revert (#9675) since the draggable
				// may have modified them in unexpected ways (#8809)
				sortable._storedCSS = {
					position: sortable.placeholder.css( "position" ),
					top: sortable.placeholder.css( "top" ),
					left: sortable.placeholder.css( "left" )
				};

				sortable._mouseStop( event );

				// Once drag has ended, the sortable should return to using
				// its original helper, not the shared helper from draggable
				sortable.options.helper = sortable.options._helper;
			} else {

				// Prevent this Sortable from removing the helper.
				// However, don't set the draggable to remove the helper
				// either as another connected Sortable may yet handle the removal.
				sortable.cancelHelperRemoval = true;

				sortable._trigger( "deactivate", event, uiSortable );
			}
		} );
	},
	drag: function( event, ui, draggable ) {
		$.each( draggable.sortables, function() {
			var innermostIntersecting = false,
				sortable = this;

			// Copy over variables that sortable's _intersectsWith uses
			sortable.positionAbs = draggable.positionAbs;
			sortable.helperProportions = draggable.helperProportions;
			sortable.offset.click = draggable.offset.click;

			if ( sortable._intersectsWith( sortable.containerCache ) ) {
				innermostIntersecting = true;

				$.each( draggable.sortables, function() {

					// Copy over variables that sortable's _intersectsWith uses
					this.positionAbs = draggable.positionAbs;
					this.helperProportions = draggable.helperProportions;
					this.offset.click = draggable.offset.click;

					if ( this !== sortable &&
							this._intersectsWith( this.containerCache ) &&
							$.contains( sortable.element[ 0 ], this.element[ 0 ] ) ) {
						innermostIntersecting = false;
					}

					return innermostIntersecting;
				} );
			}

			if ( innermostIntersecting ) {

				// If it intersects, we use a little isOver variable and set it once,
				// so that the move-in stuff gets fired only once.
				if ( !sortable.isOver ) {
					sortable.isOver = 1;

					// Store draggable's parent in case we need to reappend to it later.
					draggable._parent = ui.helper.parent();

					sortable.currentItem = ui.helper
						.appendTo( sortable.element )
						.data( "ui-sortable-item", true );

					// Store helper option to later restore it
					sortable.options._helper = sortable.options.helper;

					sortable.options.helper = function() {
						return ui.helper[ 0 ];
					};

					// Fire the start events of the sortable with our passed browser event,
					// and our own helper (so it doesn't create a new one)
					event.target = sortable.currentItem[ 0 ];
					sortable._mouseCapture( event, true );
					sortable._mouseStart( event, true, true );

					// Because the browser event is way off the new appended portlet,
					// modify necessary variables to reflect the changes
					sortable.offset.click.top = draggable.offset.click.top;
					sortable.offset.click.left = draggable.offset.click.left;
					sortable.offset.parent.left -= draggable.offset.parent.left -
						sortable.offset.parent.left;
					sortable.offset.parent.top -= draggable.offset.parent.top -
						sortable.offset.parent.top;

					draggable._trigger( "toSortable", event );

					// Inform draggable that the helper is in a valid drop zone,
					// used solely in the revert option to handle "valid/invalid".
					draggable.dropped = sortable.element;

					// Need to refreshPositions of all sortables in the case that
					// adding to one sortable changes the location of the other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					} );

					// Hack so receive/update callbacks work (mostly)
					draggable.currentItem = draggable.element;
					sortable.fromOutside = draggable;
				}

				if ( sortable.currentItem ) {
					sortable._mouseDrag( event );

					// Copy the sortable's position because the draggable's can potentially reflect
					// a relative position, while sortable is always absolute, which the dragged
					// element has now become. (#8809)
					ui.position = sortable.position;
				}
			} else {

				// If it doesn't intersect with the sortable, and it intersected before,
				// we fake the drag stop of the sortable, but make sure it doesn't remove
				// the helper by using cancelHelperRemoval.
				if ( sortable.isOver ) {

					sortable.isOver = 0;
					sortable.cancelHelperRemoval = true;

					// Calling sortable's mouseStop would trigger a revert,
					// so revert must be temporarily false until after mouseStop is called.
					sortable.options._revert = sortable.options.revert;
					sortable.options.revert = false;

					sortable._trigger( "out", event, sortable._uiHash( sortable ) );
					sortable._mouseStop( event, true );

					// Restore sortable behaviors that were modfied
					// when the draggable entered the sortable area (#9481)
					sortable.options.revert = sortable.options._revert;
					sortable.options.helper = sortable.options._helper;

					if ( sortable.placeholder ) {
						sortable.placeholder.remove();
					}

					// Restore and recalculate the draggable's offset considering the sortable
					// may have modified them in unexpected ways. (#8809, #10669)
					ui.helper.appendTo( draggable._parent );
					draggable._refreshOffsets( event );
					ui.position = draggable._generatePosition( event, true );

					draggable._trigger( "fromSortable", event );

					// Inform draggable that the helper is no longer in a valid drop zone
					draggable.dropped = false;

					// Need to refreshPositions of all sortables just in case removing
					// from one sortable changes the location of other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					} );
				}
			}
		} );
	}
} );

$.ui.plugin.add( "draggable", "cursor", {
	start: function( event, ui, instance ) {
		var t = $( "body" ),
			o = instance.options;

		if ( t.css( "cursor" ) ) {
			o._cursor = t.css( "cursor" );
		}
		t.css( "cursor", o.cursor );
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if ( o._cursor ) {
			$( "body" ).css( "cursor", o._cursor );
		}
	}
} );

$.ui.plugin.add( "draggable", "opacity", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;
		if ( t.css( "opacity" ) ) {
			o._opacity = t.css( "opacity" );
		}
		t.css( "opacity", o.opacity );
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if ( o._opacity ) {
			$( ui.helper ).css( "opacity", o._opacity );
		}
	}
} );

$.ui.plugin.add( "draggable", "scroll", {
	start: function( event, ui, i ) {
		if ( !i.scrollParentNotHidden ) {
			i.scrollParentNotHidden = i.helper.scrollParent( false );
		}

		if ( i.scrollParentNotHidden[ 0 ] !== i.document[ 0 ] &&
				i.scrollParentNotHidden[ 0 ].tagName !== "HTML" ) {
			i.overflowOffset = i.scrollParentNotHidden.offset();
		}
	},
	drag: function( event, ui, i  ) {

		var o = i.options,
			scrolled = false,
			scrollParent = i.scrollParentNotHidden[ 0 ],
			document = i.document[ 0 ];

		if ( scrollParent !== document && scrollParent.tagName !== "HTML" ) {
			if ( !o.axis || o.axis !== "x" ) {
				if ( ( i.overflowOffset.top + scrollParent.offsetHeight ) - event.pageY <
						o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
				} else if ( event.pageY - i.overflowOffset.top < o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
				}
			}

			if ( !o.axis || o.axis !== "y" ) {
				if ( ( i.overflowOffset.left + scrollParent.offsetWidth ) - event.pageX <
						o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
				} else if ( event.pageX - i.overflowOffset.left < o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
				}
			}

		} else {

			if ( !o.axis || o.axis !== "x" ) {
				if ( event.pageY - $( document ).scrollTop() < o.scrollSensitivity ) {
					scrolled = $( document ).scrollTop( $( document ).scrollTop() - o.scrollSpeed );
				} else if ( $( window ).height() - ( event.pageY - $( document ).scrollTop() ) <
						o.scrollSensitivity ) {
					scrolled = $( document ).scrollTop( $( document ).scrollTop() + o.scrollSpeed );
				}
			}

			if ( !o.axis || o.axis !== "y" ) {
				if ( event.pageX - $( document ).scrollLeft() < o.scrollSensitivity ) {
					scrolled = $( document ).scrollLeft(
						$( document ).scrollLeft() - o.scrollSpeed
					);
				} else if ( $( window ).width() - ( event.pageX - $( document ).scrollLeft() ) <
						o.scrollSensitivity ) {
					scrolled = $( document ).scrollLeft(
						$( document ).scrollLeft() + o.scrollSpeed
					);
				}
			}

		}

		if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
			$.ui.ddmanager.prepareOffsets( i, event );
		}

	}
} );

$.ui.plugin.add( "draggable", "snap", {
	start: function( event, ui, i ) {

		var o = i.options;

		i.snapElements = [];

		$( o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap )
			.each( function() {
				var $t = $( this ),
					$o = $t.offset();
				if ( this !== i.element[ 0 ] ) {
					i.snapElements.push( {
						item: this,
						width: $t.outerWidth(), height: $t.outerHeight(),
						top: $o.top, left: $o.left
					} );
				}
			} );

	},
	drag: function( event, ui, inst ) {

		var ts, bs, ls, rs, l, r, t, b, i, first,
			o = inst.options,
			d = o.snapTolerance,
			x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
			y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;

		for ( i = inst.snapElements.length - 1; i >= 0; i-- ) {

			l = inst.snapElements[ i ].left - inst.margins.left;
			r = l + inst.snapElements[ i ].width;
			t = inst.snapElements[ i ].top - inst.margins.top;
			b = t + inst.snapElements[ i ].height;

			if ( x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d ||
					!$.contains( inst.snapElements[ i ].item.ownerDocument,
					inst.snapElements[ i ].item ) ) {
				if ( inst.snapElements[ i ].snapping ) {
					( inst.options.snap.release &&
						inst.options.snap.release.call(
							inst.element,
							event,
							$.extend( inst._uiHash(), { snapItem: inst.snapElements[ i ].item } )
						) );
				}
				inst.snapElements[ i ].snapping = false;
				continue;
			}

			if ( o.snapMode !== "inner" ) {
				ts = Math.abs( t - y2 ) <= d;
				bs = Math.abs( b - y1 ) <= d;
				ls = Math.abs( l - x2 ) <= d;
				rs = Math.abs( r - x1 ) <= d;
				if ( ts ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: t - inst.helperProportions.height,
						left: 0
					} ).top;
				}
				if ( bs ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: b,
						left: 0
					} ).top;
				}
				if ( ls ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: l - inst.helperProportions.width
					} ).left;
				}
				if ( rs ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: r
					} ).left;
				}
			}

			first = ( ts || bs || ls || rs );

			if ( o.snapMode !== "outer" ) {
				ts = Math.abs( t - y1 ) <= d;
				bs = Math.abs( b - y2 ) <= d;
				ls = Math.abs( l - x1 ) <= d;
				rs = Math.abs( r - x2 ) <= d;
				if ( ts ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: t,
						left: 0
					} ).top;
				}
				if ( bs ) {
					ui.position.top = inst._convertPositionTo( "relative", {
						top: b - inst.helperProportions.height,
						left: 0
					} ).top;
				}
				if ( ls ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: l
					} ).left;
				}
				if ( rs ) {
					ui.position.left = inst._convertPositionTo( "relative", {
						top: 0,
						left: r - inst.helperProportions.width
					} ).left;
				}
			}

			if ( !inst.snapElements[ i ].snapping && ( ts || bs || ls || rs || first ) ) {
				( inst.options.snap.snap &&
					inst.options.snap.snap.call(
						inst.element,
						event,
						$.extend( inst._uiHash(), {
							snapItem: inst.snapElements[ i ].item
						} ) ) );
			}
			inst.snapElements[ i ].snapping = ( ts || bs || ls || rs || first );

		}

	}
} );

$.ui.plugin.add( "draggable", "stack", {
	start: function( event, ui, instance ) {
		var min,
			o = instance.options,
			group = $.makeArray( $( o.stack ) ).sort( function( a, b ) {
				return ( parseInt( $( a ).css( "zIndex" ), 10 ) || 0 ) -
					( parseInt( $( b ).css( "zIndex" ), 10 ) || 0 );
			} );

		if ( !group.length ) { return; }

		min = parseInt( $( group[ 0 ] ).css( "zIndex" ), 10 ) || 0;
		$( group ).each( function( i ) {
			$( this ).css( "zIndex", min + i );
		} );
		this.css( "zIndex", ( min + group.length ) );
	}
} );

$.ui.plugin.add( "draggable", "zIndex", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;

		if ( t.css( "zIndex" ) ) {
			o._zIndex = t.css( "zIndex" );
		}
		t.css( "zIndex", o.zIndex );
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;

		if ( o._zIndex ) {
			$( ui.helper ).css( "zIndex", o._zIndex );
		}
	}
} );

var widgetsDraggable = $.ui.draggable;


/*!
 * jQuery UI Resizable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Resizable
//>>group: Interactions
//>>description: Enables resize functionality for any element.
//>>docs: http://api.jqueryui.com/resizable/
//>>demos: http://jqueryui.com/resizable/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/resizable.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.resizable", $.ui.mouse, {
	version: "1.12.1",
	widgetEventPrefix: "resize",
	options: {
		alsoResize: false,
		animate: false,
		animateDuration: "slow",
		animateEasing: "swing",
		aspectRatio: false,
		autoHide: false,
		classes: {
			"ui-resizable-se": "ui-icon ui-icon-gripsmall-diagonal-se"
		},
		containment: false,
		ghost: false,
		grid: false,
		handles: "e,s,se",
		helper: false,
		maxHeight: null,
		maxWidth: null,
		minHeight: 10,
		minWidth: 10,

		// See #7960
		zIndex: 90,

		// Callbacks
		resize: null,
		start: null,
		stop: null
	},

	_num: function( value ) {
		return parseFloat( value ) || 0;
	},

	_isNumber: function( value ) {
		return !isNaN( parseFloat( value ) );
	},

	_hasScroll: function( el, a ) {

		if ( $( el ).css( "overflow" ) === "hidden" ) {
			return false;
		}

		var scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop",
			has = false;

		if ( el[ scroll ] > 0 ) {
			return true;
		}

		// TODO: determine which cases actually cause this to happen
		// if the element doesn't have the scroll set, see if it's possible to
		// set the scroll
		el[ scroll ] = 1;
		has = ( el[ scroll ] > 0 );
		el[ scroll ] = 0;
		return has;
	},

	_create: function() {

		var margins,
			o = this.options,
			that = this;
		this._addClass( "ui-resizable" );

		$.extend( this, {
			_aspectRatio: !!( o.aspectRatio ),
			aspectRatio: o.aspectRatio,
			originalElement: this.element,
			_proportionallyResizeElements: [],
			_helper: o.helper || o.ghost || o.animate ? o.helper || "ui-resizable-helper" : null
		} );

		// Wrap the element if it cannot hold child nodes
		if ( this.element[ 0 ].nodeName.match( /^(canvas|textarea|input|select|button|img)$/i ) ) {

			this.element.wrap(
				$( "<div class='ui-wrapper' style='overflow: hidden;'></div>" ).css( {
					position: this.element.css( "position" ),
					width: this.element.outerWidth(),
					height: this.element.outerHeight(),
					top: this.element.css( "top" ),
					left: this.element.css( "left" )
				} )
			);

			this.element = this.element.parent().data(
				"ui-resizable", this.element.resizable( "instance" )
			);

			this.elementIsWrapper = true;

			margins = {
				marginTop: this.originalElement.css( "marginTop" ),
				marginRight: this.originalElement.css( "marginRight" ),
				marginBottom: this.originalElement.css( "marginBottom" ),
				marginLeft: this.originalElement.css( "marginLeft" )
			};

			this.element.css( margins );
			this.originalElement.css( "margin", 0 );

			// support: Safari
			// Prevent Safari textarea resize
			this.originalResizeStyle = this.originalElement.css( "resize" );
			this.originalElement.css( "resize", "none" );

			this._proportionallyResizeElements.push( this.originalElement.css( {
				position: "static",
				zoom: 1,
				display: "block"
			} ) );

			// Support: IE9
			// avoid IE jump (hard set the margin)
			this.originalElement.css( margins );

			this._proportionallyResize();
		}

		this._setupHandles();

		if ( o.autoHide ) {
			$( this.element )
				.on( "mouseenter", function() {
					if ( o.disabled ) {
						return;
					}
					that._removeClass( "ui-resizable-autohide" );
					that._handles.show();
				} )
				.on( "mouseleave", function() {
					if ( o.disabled ) {
						return;
					}
					if ( !that.resizing ) {
						that._addClass( "ui-resizable-autohide" );
						that._handles.hide();
					}
				} );
		}

		this._mouseInit();
	},

	_destroy: function() {

		this._mouseDestroy();

		var wrapper,
			_destroy = function( exp ) {
				$( exp )
					.removeData( "resizable" )
					.removeData( "ui-resizable" )
					.off( ".resizable" )
					.find( ".ui-resizable-handle" )
						.remove();
			};

		// TODO: Unwrap at same DOM position
		if ( this.elementIsWrapper ) {
			_destroy( this.element );
			wrapper = this.element;
			this.originalElement.css( {
				position: wrapper.css( "position" ),
				width: wrapper.outerWidth(),
				height: wrapper.outerHeight(),
				top: wrapper.css( "top" ),
				left: wrapper.css( "left" )
			} ).insertAfter( wrapper );
			wrapper.remove();
		}

		this.originalElement.css( "resize", this.originalResizeStyle );
		_destroy( this.originalElement );

		return this;
	},

	_setOption: function( key, value ) {
		this._super( key, value );

		switch ( key ) {
		case "handles":
			this._removeHandles();
			this._setupHandles();
			break;
		default:
			break;
		}
	},

	_setupHandles: function() {
		var o = this.options, handle, i, n, hname, axis, that = this;
		this.handles = o.handles ||
			( !$( ".ui-resizable-handle", this.element ).length ?
				"e,s,se" : {
					n: ".ui-resizable-n",
					e: ".ui-resizable-e",
					s: ".ui-resizable-s",
					w: ".ui-resizable-w",
					se: ".ui-resizable-se",
					sw: ".ui-resizable-sw",
					ne: ".ui-resizable-ne",
					nw: ".ui-resizable-nw"
				} );

		this._handles = $();
		if ( this.handles.constructor === String ) {

			if ( this.handles === "all" ) {
				this.handles = "n,e,s,w,se,sw,ne,nw";
			}

			n = this.handles.split( "," );
			this.handles = {};

			for ( i = 0; i < n.length; i++ ) {

				handle = $.trim( n[ i ] );
				hname = "ui-resizable-" + handle;
				axis = $( "<div>" );
				this._addClass( axis, "ui-resizable-handle " + hname );

				axis.css( { zIndex: o.zIndex } );

				this.handles[ handle ] = ".ui-resizable-" + handle;
				this.element.append( axis );
			}

		}

		this._renderAxis = function( target ) {

			var i, axis, padPos, padWrapper;

			target = target || this.element;

			for ( i in this.handles ) {

				if ( this.handles[ i ].constructor === String ) {
					this.handles[ i ] = this.element.children( this.handles[ i ] ).first().show();
				} else if ( this.handles[ i ].jquery || this.handles[ i ].nodeType ) {
					this.handles[ i ] = $( this.handles[ i ] );
					this._on( this.handles[ i ], { "mousedown": that._mouseDown } );
				}

				if ( this.elementIsWrapper &&
						this.originalElement[ 0 ]
							.nodeName
							.match( /^(textarea|input|select|button)$/i ) ) {
					axis = $( this.handles[ i ], this.element );

					padWrapper = /sw|ne|nw|se|n|s/.test( i ) ?
						axis.outerHeight() :
						axis.outerWidth();

					padPos = [ "padding",
						/ne|nw|n/.test( i ) ? "Top" :
						/se|sw|s/.test( i ) ? "Bottom" :
						/^e$/.test( i ) ? "Right" : "Left" ].join( "" );

					target.css( padPos, padWrapper );

					this._proportionallyResize();
				}

				this._handles = this._handles.add( this.handles[ i ] );
			}
		};

		// TODO: make renderAxis a prototype function
		this._renderAxis( this.element );

		this._handles = this._handles.add( this.element.find( ".ui-resizable-handle" ) );
		this._handles.disableSelection();

		this._handles.on( "mouseover", function() {
			if ( !that.resizing ) {
				if ( this.className ) {
					axis = this.className.match( /ui-resizable-(se|sw|ne|nw|n|e|s|w)/i );
				}
				that.axis = axis && axis[ 1 ] ? axis[ 1 ] : "se";
			}
		} );

		if ( o.autoHide ) {
			this._handles.hide();
			this._addClass( "ui-resizable-autohide" );
		}
	},

	_removeHandles: function() {
		this._handles.remove();
	},

	_mouseCapture: function( event ) {
		var i, handle,
			capture = false;

		for ( i in this.handles ) {
			handle = $( this.handles[ i ] )[ 0 ];
			if ( handle === event.target || $.contains( handle, event.target ) ) {
				capture = true;
			}
		}

		return !this.options.disabled && capture;
	},

	_mouseStart: function( event ) {

		var curleft, curtop, cursor,
			o = this.options,
			el = this.element;

		this.resizing = true;

		this._renderProxy();

		curleft = this._num( this.helper.css( "left" ) );
		curtop = this._num( this.helper.css( "top" ) );

		if ( o.containment ) {
			curleft += $( o.containment ).scrollLeft() || 0;
			curtop += $( o.containment ).scrollTop() || 0;
		}

		this.offset = this.helper.offset();
		this.position = { left: curleft, top: curtop };

		this.size = this._helper ? {
				width: this.helper.width(),
				height: this.helper.height()
			} : {
				width: el.width(),
				height: el.height()
			};

		this.originalSize = this._helper ? {
				width: el.outerWidth(),
				height: el.outerHeight()
			} : {
				width: el.width(),
				height: el.height()
			};

		this.sizeDiff = {
			width: el.outerWidth() - el.width(),
			height: el.outerHeight() - el.height()
		};

		this.originalPosition = { left: curleft, top: curtop };
		this.originalMousePosition = { left: event.pageX, top: event.pageY };

		this.aspectRatio = ( typeof o.aspectRatio === "number" ) ?
			o.aspectRatio :
			( ( this.originalSize.width / this.originalSize.height ) || 1 );

		cursor = $( ".ui-resizable-" + this.axis ).css( "cursor" );
		$( "body" ).css( "cursor", cursor === "auto" ? this.axis + "-resize" : cursor );

		this._addClass( "ui-resizable-resizing" );
		this._propagate( "start", event );
		return true;
	},

	_mouseDrag: function( event ) {

		var data, props,
			smp = this.originalMousePosition,
			a = this.axis,
			dx = ( event.pageX - smp.left ) || 0,
			dy = ( event.pageY - smp.top ) || 0,
			trigger = this._change[ a ];

		this._updatePrevProperties();

		if ( !trigger ) {
			return false;
		}

		data = trigger.apply( this, [ event, dx, dy ] );

		this._updateVirtualBoundaries( event.shiftKey );
		if ( this._aspectRatio || event.shiftKey ) {
			data = this._updateRatio( data, event );
		}

		data = this._respectSize( data, event );

		this._updateCache( data );

		this._propagate( "resize", event );

		props = this._applyChanges();

		if ( !this._helper && this._proportionallyResizeElements.length ) {
			this._proportionallyResize();
		}

		if ( !$.isEmptyObject( props ) ) {
			this._updatePrevProperties();
			this._trigger( "resize", event, this.ui() );
			this._applyChanges();
		}

		return false;
	},

	_mouseStop: function( event ) {

		this.resizing = false;
		var pr, ista, soffseth, soffsetw, s, left, top,
			o = this.options, that = this;

		if ( this._helper ) {

			pr = this._proportionallyResizeElements;
			ista = pr.length && ( /textarea/i ).test( pr[ 0 ].nodeName );
			soffseth = ista && this._hasScroll( pr[ 0 ], "left" ) ? 0 : that.sizeDiff.height;
			soffsetw = ista ? 0 : that.sizeDiff.width;

			s = {
				width: ( that.helper.width()  - soffsetw ),
				height: ( that.helper.height() - soffseth )
			};
			left = ( parseFloat( that.element.css( "left" ) ) +
				( that.position.left - that.originalPosition.left ) ) || null;
			top = ( parseFloat( that.element.css( "top" ) ) +
				( that.position.top - that.originalPosition.top ) ) || null;

			if ( !o.animate ) {
				this.element.css( $.extend( s, { top: top, left: left } ) );
			}

			that.helper.height( that.size.height );
			that.helper.width( that.size.width );

			if ( this._helper && !o.animate ) {
				this._proportionallyResize();
			}
		}

		$( "body" ).css( "cursor", "auto" );

		this._removeClass( "ui-resizable-resizing" );

		this._propagate( "stop", event );

		if ( this._helper ) {
			this.helper.remove();
		}

		return false;

	},

	_updatePrevProperties: function() {
		this.prevPosition = {
			top: this.position.top,
			left: this.position.left
		};
		this.prevSize = {
			width: this.size.width,
			height: this.size.height
		};
	},

	_applyChanges: function() {
		var props = {};

		if ( this.position.top !== this.prevPosition.top ) {
			props.top = this.position.top + "px";
		}
		if ( this.position.left !== this.prevPosition.left ) {
			props.left = this.position.left + "px";
		}
		if ( this.size.width !== this.prevSize.width ) {
			props.width = this.size.width + "px";
		}
		if ( this.size.height !== this.prevSize.height ) {
			props.height = this.size.height + "px";
		}

		this.helper.css( props );

		return props;
	},

	_updateVirtualBoundaries: function( forceAspectRatio ) {
		var pMinWidth, pMaxWidth, pMinHeight, pMaxHeight, b,
			o = this.options;

		b = {
			minWidth: this._isNumber( o.minWidth ) ? o.minWidth : 0,
			maxWidth: this._isNumber( o.maxWidth ) ? o.maxWidth : Infinity,
			minHeight: this._isNumber( o.minHeight ) ? o.minHeight : 0,
			maxHeight: this._isNumber( o.maxHeight ) ? o.maxHeight : Infinity
		};

		if ( this._aspectRatio || forceAspectRatio ) {
			pMinWidth = b.minHeight * this.aspectRatio;
			pMinHeight = b.minWidth / this.aspectRatio;
			pMaxWidth = b.maxHeight * this.aspectRatio;
			pMaxHeight = b.maxWidth / this.aspectRatio;

			if ( pMinWidth > b.minWidth ) {
				b.minWidth = pMinWidth;
			}
			if ( pMinHeight > b.minHeight ) {
				b.minHeight = pMinHeight;
			}
			if ( pMaxWidth < b.maxWidth ) {
				b.maxWidth = pMaxWidth;
			}
			if ( pMaxHeight < b.maxHeight ) {
				b.maxHeight = pMaxHeight;
			}
		}
		this._vBoundaries = b;
	},

	_updateCache: function( data ) {
		this.offset = this.helper.offset();
		if ( this._isNumber( data.left ) ) {
			this.position.left = data.left;
		}
		if ( this._isNumber( data.top ) ) {
			this.position.top = data.top;
		}
		if ( this._isNumber( data.height ) ) {
			this.size.height = data.height;
		}
		if ( this._isNumber( data.width ) ) {
			this.size.width = data.width;
		}
	},

	_updateRatio: function( data ) {

		var cpos = this.position,
			csize = this.size,
			a = this.axis;

		if ( this._isNumber( data.height ) ) {
			data.width = ( data.height * this.aspectRatio );
		} else if ( this._isNumber( data.width ) ) {
			data.height = ( data.width / this.aspectRatio );
		}

		if ( a === "sw" ) {
			data.left = cpos.left + ( csize.width - data.width );
			data.top = null;
		}
		if ( a === "nw" ) {
			data.top = cpos.top + ( csize.height - data.height );
			data.left = cpos.left + ( csize.width - data.width );
		}

		return data;
	},

	_respectSize: function( data ) {

		var o = this._vBoundaries,
			a = this.axis,
			ismaxw = this._isNumber( data.width ) && o.maxWidth && ( o.maxWidth < data.width ),
			ismaxh = this._isNumber( data.height ) && o.maxHeight && ( o.maxHeight < data.height ),
			isminw = this._isNumber( data.width ) && o.minWidth && ( o.minWidth > data.width ),
			isminh = this._isNumber( data.height ) && o.minHeight && ( o.minHeight > data.height ),
			dw = this.originalPosition.left + this.originalSize.width,
			dh = this.originalPosition.top + this.originalSize.height,
			cw = /sw|nw|w/.test( a ), ch = /nw|ne|n/.test( a );
		if ( isminw ) {
			data.width = o.minWidth;
		}
		if ( isminh ) {
			data.height = o.minHeight;
		}
		if ( ismaxw ) {
			data.width = o.maxWidth;
		}
		if ( ismaxh ) {
			data.height = o.maxHeight;
		}

		if ( isminw && cw ) {
			data.left = dw - o.minWidth;
		}
		if ( ismaxw && cw ) {
			data.left = dw - o.maxWidth;
		}
		if ( isminh && ch ) {
			data.top = dh - o.minHeight;
		}
		if ( ismaxh && ch ) {
			data.top = dh - o.maxHeight;
		}

		// Fixing jump error on top/left - bug #2330
		if ( !data.width && !data.height && !data.left && data.top ) {
			data.top = null;
		} else if ( !data.width && !data.height && !data.top && data.left ) {
			data.left = null;
		}

		return data;
	},

	_getPaddingPlusBorderDimensions: function( element ) {
		var i = 0,
			widths = [],
			borders = [
				element.css( "borderTopWidth" ),
				element.css( "borderRightWidth" ),
				element.css( "borderBottomWidth" ),
				element.css( "borderLeftWidth" )
			],
			paddings = [
				element.css( "paddingTop" ),
				element.css( "paddingRight" ),
				element.css( "paddingBottom" ),
				element.css( "paddingLeft" )
			];

		for ( ; i < 4; i++ ) {
			widths[ i ] = ( parseFloat( borders[ i ] ) || 0 );
			widths[ i ] += ( parseFloat( paddings[ i ] ) || 0 );
		}

		return {
			height: widths[ 0 ] + widths[ 2 ],
			width: widths[ 1 ] + widths[ 3 ]
		};
	},

	_proportionallyResize: function() {

		if ( !this._proportionallyResizeElements.length ) {
			return;
		}

		var prel,
			i = 0,
			element = this.helper || this.element;

		for ( ; i < this._proportionallyResizeElements.length; i++ ) {

			prel = this._proportionallyResizeElements[ i ];

			// TODO: Seems like a bug to cache this.outerDimensions
			// considering that we are in a loop.
			if ( !this.outerDimensions ) {
				this.outerDimensions = this._getPaddingPlusBorderDimensions( prel );
			}

			prel.css( {
				height: ( element.height() - this.outerDimensions.height ) || 0,
				width: ( element.width() - this.outerDimensions.width ) || 0
			} );

		}

	},

	_renderProxy: function() {

		var el = this.element, o = this.options;
		this.elementOffset = el.offset();

		if ( this._helper ) {

			this.helper = this.helper || $( "<div style='overflow:hidden;'></div>" );

			this._addClass( this.helper, this._helper );
			this.helper.css( {
				width: this.element.outerWidth(),
				height: this.element.outerHeight(),
				position: "absolute",
				left: this.elementOffset.left + "px",
				top: this.elementOffset.top + "px",
				zIndex: ++o.zIndex //TODO: Don't modify option
			} );

			this.helper
				.appendTo( "body" )
				.disableSelection();

		} else {
			this.helper = this.element;
		}

	},

	_change: {
		e: function( event, dx ) {
			return { width: this.originalSize.width + dx };
		},
		w: function( event, dx ) {
			var cs = this.originalSize, sp = this.originalPosition;
			return { left: sp.left + dx, width: cs.width - dx };
		},
		n: function( event, dx, dy ) {
			var cs = this.originalSize, sp = this.originalPosition;
			return { top: sp.top + dy, height: cs.height - dy };
		},
		s: function( event, dx, dy ) {
			return { height: this.originalSize.height + dy };
		},
		se: function( event, dx, dy ) {
			return $.extend( this._change.s.apply( this, arguments ),
				this._change.e.apply( this, [ event, dx, dy ] ) );
		},
		sw: function( event, dx, dy ) {
			return $.extend( this._change.s.apply( this, arguments ),
				this._change.w.apply( this, [ event, dx, dy ] ) );
		},
		ne: function( event, dx, dy ) {
			return $.extend( this._change.n.apply( this, arguments ),
				this._change.e.apply( this, [ event, dx, dy ] ) );
		},
		nw: function( event, dx, dy ) {
			return $.extend( this._change.n.apply( this, arguments ),
				this._change.w.apply( this, [ event, dx, dy ] ) );
		}
	},

	_propagate: function( n, event ) {
		$.ui.plugin.call( this, n, [ event, this.ui() ] );
		( n !== "resize" && this._trigger( n, event, this.ui() ) );
	},

	plugins: {},

	ui: function() {
		return {
			originalElement: this.originalElement,
			element: this.element,
			helper: this.helper,
			position: this.position,
			size: this.size,
			originalSize: this.originalSize,
			originalPosition: this.originalPosition
		};
	}

} );

/*
 * Resizable Extensions
 */

$.ui.plugin.add( "resizable", "animate", {

	stop: function( event ) {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			pr = that._proportionallyResizeElements,
			ista = pr.length && ( /textarea/i ).test( pr[ 0 ].nodeName ),
			soffseth = ista && that._hasScroll( pr[ 0 ], "left" ) ? 0 : that.sizeDiff.height,
			soffsetw = ista ? 0 : that.sizeDiff.width,
			style = {
				width: ( that.size.width - soffsetw ),
				height: ( that.size.height - soffseth )
			},
			left = ( parseFloat( that.element.css( "left" ) ) +
				( that.position.left - that.originalPosition.left ) ) || null,
			top = ( parseFloat( that.element.css( "top" ) ) +
				( that.position.top - that.originalPosition.top ) ) || null;

		that.element.animate(
			$.extend( style, top && left ? { top: top, left: left } : {} ), {
				duration: o.animateDuration,
				easing: o.animateEasing,
				step: function() {

					var data = {
						width: parseFloat( that.element.css( "width" ) ),
						height: parseFloat( that.element.css( "height" ) ),
						top: parseFloat( that.element.css( "top" ) ),
						left: parseFloat( that.element.css( "left" ) )
					};

					if ( pr && pr.length ) {
						$( pr[ 0 ] ).css( { width: data.width, height: data.height } );
					}

					// Propagating resize, and updating values for each animation step
					that._updateCache( data );
					that._propagate( "resize", event );

				}
			}
		);
	}

} );

$.ui.plugin.add( "resizable", "containment", {

	start: function() {
		var element, p, co, ch, cw, width, height,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			el = that.element,
			oc = o.containment,
			ce = ( oc instanceof $ ) ?
				oc.get( 0 ) :
				( /parent/.test( oc ) ) ? el.parent().get( 0 ) : oc;

		if ( !ce ) {
			return;
		}

		that.containerElement = $( ce );

		if ( /document/.test( oc ) || oc === document ) {
			that.containerOffset = {
				left: 0,
				top: 0
			};
			that.containerPosition = {
				left: 0,
				top: 0
			};

			that.parentData = {
				element: $( document ),
				left: 0,
				top: 0,
				width: $( document ).width(),
				height: $( document ).height() || document.body.parentNode.scrollHeight
			};
		} else {
			element = $( ce );
			p = [];
			$( [ "Top", "Right", "Left", "Bottom" ] ).each( function( i, name ) {
				p[ i ] = that._num( element.css( "padding" + name ) );
			} );

			that.containerOffset = element.offset();
			that.containerPosition = element.position();
			that.containerSize = {
				height: ( element.innerHeight() - p[ 3 ] ),
				width: ( element.innerWidth() - p[ 1 ] )
			};

			co = that.containerOffset;
			ch = that.containerSize.height;
			cw = that.containerSize.width;
			width = ( that._hasScroll ( ce, "left" ) ? ce.scrollWidth : cw );
			height = ( that._hasScroll ( ce ) ? ce.scrollHeight : ch ) ;

			that.parentData = {
				element: ce,
				left: co.left,
				top: co.top,
				width: width,
				height: height
			};
		}
	},

	resize: function( event ) {
		var woset, hoset, isParent, isOffsetRelative,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			co = that.containerOffset,
			cp = that.position,
			pRatio = that._aspectRatio || event.shiftKey,
			cop = {
				top: 0,
				left: 0
			},
			ce = that.containerElement,
			continueResize = true;

		if ( ce[ 0 ] !== document && ( /static/ ).test( ce.css( "position" ) ) ) {
			cop = co;
		}

		if ( cp.left < ( that._helper ? co.left : 0 ) ) {
			that.size.width = that.size.width +
				( that._helper ?
					( that.position.left - co.left ) :
					( that.position.left - cop.left ) );

			if ( pRatio ) {
				that.size.height = that.size.width / that.aspectRatio;
				continueResize = false;
			}
			that.position.left = o.helper ? co.left : 0;
		}

		if ( cp.top < ( that._helper ? co.top : 0 ) ) {
			that.size.height = that.size.height +
				( that._helper ?
					( that.position.top - co.top ) :
					that.position.top );

			if ( pRatio ) {
				that.size.width = that.size.height * that.aspectRatio;
				continueResize = false;
			}
			that.position.top = that._helper ? co.top : 0;
		}

		isParent = that.containerElement.get( 0 ) === that.element.parent().get( 0 );
		isOffsetRelative = /relative|absolute/.test( that.containerElement.css( "position" ) );

		if ( isParent && isOffsetRelative ) {
			that.offset.left = that.parentData.left + that.position.left;
			that.offset.top = that.parentData.top + that.position.top;
		} else {
			that.offset.left = that.element.offset().left;
			that.offset.top = that.element.offset().top;
		}

		woset = Math.abs( that.sizeDiff.width +
			( that._helper ?
				that.offset.left - cop.left :
				( that.offset.left - co.left ) ) );

		hoset = Math.abs( that.sizeDiff.height +
			( that._helper ?
				that.offset.top - cop.top :
				( that.offset.top - co.top ) ) );

		if ( woset + that.size.width >= that.parentData.width ) {
			that.size.width = that.parentData.width - woset;
			if ( pRatio ) {
				that.size.height = that.size.width / that.aspectRatio;
				continueResize = false;
			}
		}

		if ( hoset + that.size.height >= that.parentData.height ) {
			that.size.height = that.parentData.height - hoset;
			if ( pRatio ) {
				that.size.width = that.size.height * that.aspectRatio;
				continueResize = false;
			}
		}

		if ( !continueResize ) {
			that.position.left = that.prevPosition.left;
			that.position.top = that.prevPosition.top;
			that.size.width = that.prevSize.width;
			that.size.height = that.prevSize.height;
		}
	},

	stop: function() {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			co = that.containerOffset,
			cop = that.containerPosition,
			ce = that.containerElement,
			helper = $( that.helper ),
			ho = helper.offset(),
			w = helper.outerWidth() - that.sizeDiff.width,
			h = helper.outerHeight() - that.sizeDiff.height;

		if ( that._helper && !o.animate && ( /relative/ ).test( ce.css( "position" ) ) ) {
			$( this ).css( {
				left: ho.left - cop.left - co.left,
				width: w,
				height: h
			} );
		}

		if ( that._helper && !o.animate && ( /static/ ).test( ce.css( "position" ) ) ) {
			$( this ).css( {
				left: ho.left - cop.left - co.left,
				width: w,
				height: h
			} );
		}
	}
} );

$.ui.plugin.add( "resizable", "alsoResize", {

	start: function() {
		var that = $( this ).resizable( "instance" ),
			o = that.options;

		$( o.alsoResize ).each( function() {
			var el = $( this );
			el.data( "ui-resizable-alsoresize", {
				width: parseFloat( el.width() ), height: parseFloat( el.height() ),
				left: parseFloat( el.css( "left" ) ), top: parseFloat( el.css( "top" ) )
			} );
		} );
	},

	resize: function( event, ui ) {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			os = that.originalSize,
			op = that.originalPosition,
			delta = {
				height: ( that.size.height - os.height ) || 0,
				width: ( that.size.width - os.width ) || 0,
				top: ( that.position.top - op.top ) || 0,
				left: ( that.position.left - op.left ) || 0
			};

			$( o.alsoResize ).each( function() {
				var el = $( this ), start = $( this ).data( "ui-resizable-alsoresize" ), style = {},
					css = el.parents( ui.originalElement[ 0 ] ).length ?
							[ "width", "height" ] :
							[ "width", "height", "top", "left" ];

				$.each( css, function( i, prop ) {
					var sum = ( start[ prop ] || 0 ) + ( delta[ prop ] || 0 );
					if ( sum && sum >= 0 ) {
						style[ prop ] = sum || null;
					}
				} );

				el.css( style );
			} );
	},

	stop: function() {
		$( this ).removeData( "ui-resizable-alsoresize" );
	}
} );

$.ui.plugin.add( "resizable", "ghost", {

	start: function() {

		var that = $( this ).resizable( "instance" ), cs = that.size;

		that.ghost = that.originalElement.clone();
		that.ghost.css( {
			opacity: 0.25,
			display: "block",
			position: "relative",
			height: cs.height,
			width: cs.width,
			margin: 0,
			left: 0,
			top: 0
		} );

		that._addClass( that.ghost, "ui-resizable-ghost" );

		// DEPRECATED
		// TODO: remove after 1.12
		if ( $.uiBackCompat !== false && typeof that.options.ghost === "string" ) {

			// Ghost option
			that.ghost.addClass( this.options.ghost );
		}

		that.ghost.appendTo( that.helper );

	},

	resize: function() {
		var that = $( this ).resizable( "instance" );
		if ( that.ghost ) {
			that.ghost.css( {
				position: "relative",
				height: that.size.height,
				width: that.size.width
			} );
		}
	},

	stop: function() {
		var that = $( this ).resizable( "instance" );
		if ( that.ghost && that.helper ) {
			that.helper.get( 0 ).removeChild( that.ghost.get( 0 ) );
		}
	}

} );

$.ui.plugin.add( "resizable", "grid", {

	resize: function() {
		var outerDimensions,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			cs = that.size,
			os = that.originalSize,
			op = that.originalPosition,
			a = that.axis,
			grid = typeof o.grid === "number" ? [ o.grid, o.grid ] : o.grid,
			gridX = ( grid[ 0 ] || 1 ),
			gridY = ( grid[ 1 ] || 1 ),
			ox = Math.round( ( cs.width - os.width ) / gridX ) * gridX,
			oy = Math.round( ( cs.height - os.height ) / gridY ) * gridY,
			newWidth = os.width + ox,
			newHeight = os.height + oy,
			isMaxWidth = o.maxWidth && ( o.maxWidth < newWidth ),
			isMaxHeight = o.maxHeight && ( o.maxHeight < newHeight ),
			isMinWidth = o.minWidth && ( o.minWidth > newWidth ),
			isMinHeight = o.minHeight && ( o.minHeight > newHeight );

		o.grid = grid;

		if ( isMinWidth ) {
			newWidth += gridX;
		}
		if ( isMinHeight ) {
			newHeight += gridY;
		}
		if ( isMaxWidth ) {
			newWidth -= gridX;
		}
		if ( isMaxHeight ) {
			newHeight -= gridY;
		}

		if ( /^(se|s|e)$/.test( a ) ) {
			that.size.width = newWidth;
			that.size.height = newHeight;
		} else if ( /^(ne)$/.test( a ) ) {
			that.size.width = newWidth;
			that.size.height = newHeight;
			that.position.top = op.top - oy;
		} else if ( /^(sw)$/.test( a ) ) {
			that.size.width = newWidth;
			that.size.height = newHeight;
			that.position.left = op.left - ox;
		} else {
			if ( newHeight - gridY <= 0 || newWidth - gridX <= 0 ) {
				outerDimensions = that._getPaddingPlusBorderDimensions( this );
			}

			if ( newHeight - gridY > 0 ) {
				that.size.height = newHeight;
				that.position.top = op.top - oy;
			} else {
				newHeight = gridY - outerDimensions.height;
				that.size.height = newHeight;
				that.position.top = op.top + os.height - newHeight;
			}
			if ( newWidth - gridX > 0 ) {
				that.size.width = newWidth;
				that.position.left = op.left - ox;
			} else {
				newWidth = gridX - outerDimensions.width;
				that.size.width = newWidth;
				that.position.left = op.left + os.width - newWidth;
			}
		}
	}

} );

var widgetsResizable = $.ui.resizable;


/*!
 * jQuery UI Dialog 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Dialog
//>>group: Widgets
//>>description: Displays customizable dialog windows.
//>>docs: http://api.jqueryui.com/dialog/
//>>demos: http://jqueryui.com/dialog/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/dialog.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.dialog", {
	version: "1.12.1",
	options: {
		appendTo: "body",
		autoOpen: true,
		buttons: [],
		classes: {
			"ui-dialog": "ui-corner-all",
			"ui-dialog-titlebar": "ui-corner-all"
		},
		closeOnEscape: true,
		closeText: "Close",
		draggable: true,
		hide: null,
		height: "auto",
		maxHeight: null,
		maxWidth: null,
		minHeight: 150,
		minWidth: 150,
		modal: false,
		position: {
			my: "center",
			at: "center",
			of: window,
			collision: "fit",

			// Ensure the titlebar is always visible
			using: function( pos ) {
				var topOffset = $( this ).css( pos ).offset().top;
				if ( topOffset < 0 ) {
					$( this ).css( "top", pos.top - topOffset );
				}
			}
		},
		resizable: true,
		show: null,
		title: null,
		width: 300,

		// Callbacks
		beforeClose: null,
		close: null,
		drag: null,
		dragStart: null,
		dragStop: null,
		focus: null,
		open: null,
		resize: null,
		resizeStart: null,
		resizeStop: null
	},

	sizeRelatedOptions: {
		buttons: true,
		height: true,
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true,
		width: true
	},

	resizableRelatedOptions: {
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true
	},

	_create: function() {
		this.originalCss = {
			display: this.element[ 0 ].style.display,
			width: this.element[ 0 ].style.width,
			minHeight: this.element[ 0 ].style.minHeight,
			maxHeight: this.element[ 0 ].style.maxHeight,
			height: this.element[ 0 ].style.height
		};
		this.originalPosition = {
			parent: this.element.parent(),
			index: this.element.parent().children().index( this.element )
		};
		this.originalTitle = this.element.attr( "title" );
		if ( this.options.title == null && this.originalTitle != null ) {
			this.options.title = this.originalTitle;
		}

		// Dialogs can't be disabled
		if ( this.options.disabled ) {
			this.options.disabled = false;
		}

		this._createWrapper();

		this.element
			.show()
			.removeAttr( "title" )
			.appendTo( this.uiDialog );

		this._addClass( "ui-dialog-content", "ui-widget-content" );

		this._createTitlebar();
		this._createButtonPane();

		if ( this.options.draggable && $.fn.draggable ) {
			this._makeDraggable();
		}
		if ( this.options.resizable && $.fn.resizable ) {
			this._makeResizable();
		}

		this._isOpen = false;

		this._trackFocus();
	},

	_init: function() {
		if ( this.options.autoOpen ) {
			this.open();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;
		if ( element && ( element.jquery || element.nodeType ) ) {
			return $( element );
		}
		return this.document.find( element || "body" ).eq( 0 );
	},

	_destroy: function() {
		var next,
			originalPosition = this.originalPosition;

		this._untrackInstance();
		this._destroyOverlay();

		this.element
			.removeUniqueId()
			.css( this.originalCss )

			// Without detaching first, the following becomes really slow
			.detach();

		this.uiDialog.remove();

		if ( this.originalTitle ) {
			this.element.attr( "title", this.originalTitle );
		}

		next = originalPosition.parent.children().eq( originalPosition.index );

		// Don't try to place the dialog next to itself (#8613)
		if ( next.length && next[ 0 ] !== this.element[ 0 ] ) {
			next.before( this.element );
		} else {
			originalPosition.parent.append( this.element );
		}
	},

	widget: function() {
		return this.uiDialog;
	},

	disable: $.noop,
	enable: $.noop,

	close: function( event ) {
		var that = this;

		if ( !this._isOpen || this._trigger( "beforeClose", event ) === false ) {
			return;
		}

		this._isOpen = false;
		this._focusedElement = null;
		this._destroyOverlay();
		this._untrackInstance();

		if ( !this.opener.filter( ":focusable" ).trigger( "focus" ).length ) {

			// Hiding a focused element doesn't trigger blur in WebKit
			// so in case we have nothing to focus on, explicitly blur the active element
			// https://bugs.webkit.org/show_bug.cgi?id=47182
			$.ui.safeBlur( $.ui.safeActiveElement( this.document[ 0 ] ) );
		}

		this._hide( this.uiDialog, this.options.hide, function() {
			that._trigger( "close", event );
		} );
	},

	isOpen: function() {
		return this._isOpen;
	},

	moveToTop: function() {
		this._moveToTop();
	},

	_moveToTop: function( event, silent ) {
		var moved = false,
			zIndices = this.uiDialog.siblings( ".ui-front:visible" ).map( function() {
				return +$( this ).css( "z-index" );
			} ).get(),
			zIndexMax = Math.max.apply( null, zIndices );

		if ( zIndexMax >= +this.uiDialog.css( "z-index" ) ) {
			this.uiDialog.css( "z-index", zIndexMax + 1 );
			moved = true;
		}

		if ( moved && !silent ) {
			this._trigger( "focus", event );
		}
		return moved;
	},

	open: function() {
		var that = this;
		if ( this._isOpen ) {
			if ( this._moveToTop() ) {
				this._focusTabbable();
			}
			return;
		}

		this._isOpen = true;
		this.opener = $( $.ui.safeActiveElement( this.document[ 0 ] ) );

		this._size();
		this._position();
		this._createOverlay();
		this._moveToTop( null, true );

		// Ensure the overlay is moved to the top with the dialog, but only when
		// opening. The overlay shouldn't move after the dialog is open so that
		// modeless dialogs opened after the modal dialog stack properly.
		if ( this.overlay ) {
			this.overlay.css( "z-index", this.uiDialog.css( "z-index" ) - 1 );
		}

		this._show( this.uiDialog, this.options.show, function() {
			that._focusTabbable();
			that._trigger( "focus" );
		} );

		// Track the dialog immediately upon openening in case a focus event
		// somehow occurs outside of the dialog before an element inside the
		// dialog is focused (#10152)
		this._makeFocusTarget();

		this._trigger( "open" );
	},

	_focusTabbable: function() {

		// Set focus to the first match:
		// 1. An element that was focused previously
		// 2. First element inside the dialog matching [autofocus]
		// 3. Tabbable element inside the content element
		// 4. Tabbable element inside the buttonpane
		// 5. The close button
		// 6. The dialog itself
		var hasFocus = this._focusedElement;
		if ( !hasFocus ) {
			hasFocus = this.element.find( "[autofocus]" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.element.find( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialogButtonPane.find( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialogTitlebarClose.filter( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialog;
		}
		hasFocus.eq( 0 ).trigger( "focus" );
	},

	_keepFocus: function( event ) {
		function checkFocus() {
			var activeElement = $.ui.safeActiveElement( this.document[ 0 ] ),
				isActive = this.uiDialog[ 0 ] === activeElement ||
					$.contains( this.uiDialog[ 0 ], activeElement );
			if ( !isActive ) {
				this._focusTabbable();
			}
		}
		event.preventDefault();
		checkFocus.call( this );

		// support: IE
		// IE <= 8 doesn't prevent moving focus even with event.preventDefault()
		// so we check again later
		this._delay( checkFocus );
	},

	_createWrapper: function() {
		this.uiDialog = $( "<div>" )
			.hide()
			.attr( {

				// Setting tabIndex makes the div focusable
				tabIndex: -1,
				role: "dialog"
			} )
			.appendTo( this._appendTo() );

		this._addClass( this.uiDialog, "ui-dialog", "ui-widget ui-widget-content ui-front" );
		this._on( this.uiDialog, {
			keydown: function( event ) {
				if ( this.options.closeOnEscape && !event.isDefaultPrevented() && event.keyCode &&
						event.keyCode === $.ui.keyCode.ESCAPE ) {
					event.preventDefault();
					this.close( event );
					return;
				}

				// Prevent tabbing out of dialogs
				if ( event.keyCode !== $.ui.keyCode.TAB || event.isDefaultPrevented() ) {
					return;
				}
				var tabbables = this.uiDialog.find( ":tabbable" ),
					first = tabbables.filter( ":first" ),
					last = tabbables.filter( ":last" );

				if ( ( event.target === last[ 0 ] || event.target === this.uiDialog[ 0 ] ) &&
						!event.shiftKey ) {
					this._delay( function() {
						first.trigger( "focus" );
					} );
					event.preventDefault();
				} else if ( ( event.target === first[ 0 ] ||
						event.target === this.uiDialog[ 0 ] ) && event.shiftKey ) {
					this._delay( function() {
						last.trigger( "focus" );
					} );
					event.preventDefault();
				}
			},
			mousedown: function( event ) {
				if ( this._moveToTop( event ) ) {
					this._focusTabbable();
				}
			}
		} );

		// We assume that any existing aria-describedby attribute means
		// that the dialog content is marked up properly
		// otherwise we brute force the content as the description
		if ( !this.element.find( "[aria-describedby]" ).length ) {
			this.uiDialog.attr( {
				"aria-describedby": this.element.uniqueId().attr( "id" )
			} );
		}
	},

	_createTitlebar: function() {
		var uiDialogTitle;

		this.uiDialogTitlebar = $( "<div>" );
		this._addClass( this.uiDialogTitlebar,
			"ui-dialog-titlebar", "ui-widget-header ui-helper-clearfix" );
		this._on( this.uiDialogTitlebar, {
			mousedown: function( event ) {

				// Don't prevent click on close button (#8838)
				// Focusing a dialog that is partially scrolled out of view
				// causes the browser to scroll it into view, preventing the click event
				if ( !$( event.target ).closest( ".ui-dialog-titlebar-close" ) ) {

					// Dialog isn't getting focus when dragging (#8063)
					this.uiDialog.trigger( "focus" );
				}
			}
		} );

		// Support: IE
		// Use type="button" to prevent enter keypresses in textboxes from closing the
		// dialog in IE (#9312)
		this.uiDialogTitlebarClose = $( "<button type='button'></button>" )
			.button( {
				label: $( "<a>" ).text( this.options.closeText ).html(),
				icon: "ui-icon-closethick",
				showLabel: false
			} )
			.appendTo( this.uiDialogTitlebar );

		this._addClass( this.uiDialogTitlebarClose, "ui-dialog-titlebar-close" );
		this._on( this.uiDialogTitlebarClose, {
			click: function( event ) {
				event.preventDefault();
				this.close( event );
			}
		} );

		uiDialogTitle = $( "<span>" ).uniqueId().prependTo( this.uiDialogTitlebar );
		this._addClass( uiDialogTitle, "ui-dialog-title" );
		this._title( uiDialogTitle );

		this.uiDialogTitlebar.prependTo( this.uiDialog );

		this.uiDialog.attr( {
			"aria-labelledby": uiDialogTitle.attr( "id" )
		} );
	},

	_title: function( title ) {
		if ( this.options.title ) {
			title.text( this.options.title );
		} else {
			title.html( "&#160;" );
		}
	},

	_createButtonPane: function() {
		this.uiDialogButtonPane = $( "<div>" );
		this._addClass( this.uiDialogButtonPane, "ui-dialog-buttonpane",
			"ui-widget-content ui-helper-clearfix" );

		this.uiButtonSet = $( "<div>" )
			.appendTo( this.uiDialogButtonPane );
		this._addClass( this.uiButtonSet, "ui-dialog-buttonset" );

		this._createButtons();
	},

	_createButtons: function() {
		var that = this,
			buttons = this.options.buttons;

		// If we already have a button pane, remove it
		this.uiDialogButtonPane.remove();
		this.uiButtonSet.empty();

		if ( $.isEmptyObject( buttons ) || ( $.isArray( buttons ) && !buttons.length ) ) {
			this._removeClass( this.uiDialog, "ui-dialog-buttons" );
			return;
		}

		$.each( buttons, function( name, props ) {
			var click, buttonOptions;
			props = $.isFunction( props ) ?
				{ click: props, text: name } :
				props;

			// Default to a non-submitting button
			props = $.extend( { type: "button" }, props );

			// Change the context for the click callback to be the main element
			click = props.click;
			buttonOptions = {
				icon: props.icon,
				iconPosition: props.iconPosition,
				showLabel: props.showLabel,

				// Deprecated options
				icons: props.icons,
				text: props.text
			};

			delete props.click;
			delete props.icon;
			delete props.iconPosition;
			delete props.showLabel;

			// Deprecated options
			delete props.icons;
			if ( typeof props.text === "boolean" ) {
				delete props.text;
			}

			$( "<button></button>", props )
				.button( buttonOptions )
				.appendTo( that.uiButtonSet )
				.on( "click", function() {
					click.apply( that.element[ 0 ], arguments );
				} );
		} );
		this._addClass( this.uiDialog, "ui-dialog-buttons" );
		this.uiDialogButtonPane.appendTo( this.uiDialog );
	},

	_makeDraggable: function() {
		var that = this,
			options = this.options;

		function filteredUi( ui ) {
			return {
				position: ui.position,
				offset: ui.offset
			};
		}

		this.uiDialog.draggable( {
			cancel: ".ui-dialog-content, .ui-dialog-titlebar-close",
			handle: ".ui-dialog-titlebar",
			containment: "document",
			start: function( event, ui ) {
				that._addClass( $( this ), "ui-dialog-dragging" );
				that._blockFrames();
				that._trigger( "dragStart", event, filteredUi( ui ) );
			},
			drag: function( event, ui ) {
				that._trigger( "drag", event, filteredUi( ui ) );
			},
			stop: function( event, ui ) {
				var left = ui.offset.left - that.document.scrollLeft(),
					top = ui.offset.top - that.document.scrollTop();

				options.position = {
					my: "left top",
					at: "left" + ( left >= 0 ? "+" : "" ) + left + " " +
						"top" + ( top >= 0 ? "+" : "" ) + top,
					of: that.window
				};
				that._removeClass( $( this ), "ui-dialog-dragging" );
				that._unblockFrames();
				that._trigger( "dragStop", event, filteredUi( ui ) );
			}
		} );
	},

	_makeResizable: function() {
		var that = this,
			options = this.options,
			handles = options.resizable,

			// .ui-resizable has position: relative defined in the stylesheet
			// but dialogs have to use absolute or fixed positioning
			position = this.uiDialog.css( "position" ),
			resizeHandles = typeof handles === "string" ?
				handles :
				"n,e,s,w,se,sw,ne,nw";

		function filteredUi( ui ) {
			return {
				originalPosition: ui.originalPosition,
				originalSize: ui.originalSize,
				position: ui.position,
				size: ui.size
			};
		}

		this.uiDialog.resizable( {
			cancel: ".ui-dialog-content",
			containment: "document",
			alsoResize: this.element,
			maxWidth: options.maxWidth,
			maxHeight: options.maxHeight,
			minWidth: options.minWidth,
			minHeight: this._minHeight(),
			handles: resizeHandles,
			start: function( event, ui ) {
				that._addClass( $( this ), "ui-dialog-resizing" );
				that._blockFrames();
				that._trigger( "resizeStart", event, filteredUi( ui ) );
			},
			resize: function( event, ui ) {
				that._trigger( "resize", event, filteredUi( ui ) );
			},
			stop: function( event, ui ) {
				var offset = that.uiDialog.offset(),
					left = offset.left - that.document.scrollLeft(),
					top = offset.top - that.document.scrollTop();

				options.height = that.uiDialog.height();
				options.width = that.uiDialog.width();
				options.position = {
					my: "left top",
					at: "left" + ( left >= 0 ? "+" : "" ) + left + " " +
						"top" + ( top >= 0 ? "+" : "" ) + top,
					of: that.window
				};
				that._removeClass( $( this ), "ui-dialog-resizing" );
				that._unblockFrames();
				that._trigger( "resizeStop", event, filteredUi( ui ) );
			}
		} )
			.css( "position", position );
	},

	_trackFocus: function() {
		this._on( this.widget(), {
			focusin: function( event ) {
				this._makeFocusTarget();
				this._focusedElement = $( event.target );
			}
		} );
	},

	_makeFocusTarget: function() {
		this._untrackInstance();
		this._trackingInstances().unshift( this );
	},

	_untrackInstance: function() {
		var instances = this._trackingInstances(),
			exists = $.inArray( this, instances );
		if ( exists !== -1 ) {
			instances.splice( exists, 1 );
		}
	},

	_trackingInstances: function() {
		var instances = this.document.data( "ui-dialog-instances" );
		if ( !instances ) {
			instances = [];
			this.document.data( "ui-dialog-instances", instances );
		}
		return instances;
	},

	_minHeight: function() {
		var options = this.options;

		return options.height === "auto" ?
			options.minHeight :
			Math.min( options.minHeight, options.height );
	},

	_position: function() {

		// Need to show the dialog to get the actual offset in the position plugin
		var isVisible = this.uiDialog.is( ":visible" );
		if ( !isVisible ) {
			this.uiDialog.show();
		}
		this.uiDialog.position( this.options.position );
		if ( !isVisible ) {
			this.uiDialog.hide();
		}
	},

	_setOptions: function( options ) {
		var that = this,
			resize = false,
			resizableOptions = {};

		$.each( options, function( key, value ) {
			that._setOption( key, value );

			if ( key in that.sizeRelatedOptions ) {
				resize = true;
			}
			if ( key in that.resizableRelatedOptions ) {
				resizableOptions[ key ] = value;
			}
		} );

		if ( resize ) {
			this._size();
			this._position();
		}
		if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
			this.uiDialog.resizable( "option", resizableOptions );
		}
	},

	_setOption: function( key, value ) {
		var isDraggable, isResizable,
			uiDialog = this.uiDialog;

		if ( key === "disabled" ) {
			return;
		}

		this._super( key, value );

		if ( key === "appendTo" ) {
			this.uiDialog.appendTo( this._appendTo() );
		}

		if ( key === "buttons" ) {
			this._createButtons();
		}

		if ( key === "closeText" ) {
			this.uiDialogTitlebarClose.button( {

				// Ensure that we always pass a string
				label: $( "<a>" ).text( "" + this.options.closeText ).html()
			} );
		}

		if ( key === "draggable" ) {
			isDraggable = uiDialog.is( ":data(ui-draggable)" );
			if ( isDraggable && !value ) {
				uiDialog.draggable( "destroy" );
			}

			if ( !isDraggable && value ) {
				this._makeDraggable();
			}
		}

		if ( key === "position" ) {
			this._position();
		}

		if ( key === "resizable" ) {

			// currently resizable, becoming non-resizable
			isResizable = uiDialog.is( ":data(ui-resizable)" );
			if ( isResizable && !value ) {
				uiDialog.resizable( "destroy" );
			}

			// Currently resizable, changing handles
			if ( isResizable && typeof value === "string" ) {
				uiDialog.resizable( "option", "handles", value );
			}

			// Currently non-resizable, becoming resizable
			if ( !isResizable && value !== false ) {
				this._makeResizable();
			}
		}

		if ( key === "title" ) {
			this._title( this.uiDialogTitlebar.find( ".ui-dialog-title" ) );
		}
	},

	_size: function() {

		// If the user has resized the dialog, the .ui-dialog and .ui-dialog-content
		// divs will both have width and height set, so we need to reset them
		var nonContentHeight, minContentHeight, maxContentHeight,
			options = this.options;

		// Reset content sizing
		this.element.show().css( {
			width: "auto",
			minHeight: 0,
			maxHeight: "none",
			height: 0
		} );

		if ( options.minWidth > options.width ) {
			options.width = options.minWidth;
		}

		// Reset wrapper sizing
		// determine the height of all the non-content elements
		nonContentHeight = this.uiDialog.css( {
			height: "auto",
			width: options.width
		} )
			.outerHeight();
		minContentHeight = Math.max( 0, options.minHeight - nonContentHeight );
		maxContentHeight = typeof options.maxHeight === "number" ?
			Math.max( 0, options.maxHeight - nonContentHeight ) :
			"none";

		if ( options.height === "auto" ) {
			this.element.css( {
				minHeight: minContentHeight,
				maxHeight: maxContentHeight,
				height: "auto"
			} );
		} else {
			this.element.height( Math.max( 0, options.height - nonContentHeight ) );
		}

		if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
			this.uiDialog.resizable( "option", "minHeight", this._minHeight() );
		}
	},

	_blockFrames: function() {
		this.iframeBlocks = this.document.find( "iframe" ).map( function() {
			var iframe = $( this );

			return $( "<div>" )
				.css( {
					position: "absolute",
					width: iframe.outerWidth(),
					height: iframe.outerHeight()
				} )
				.appendTo( iframe.parent() )
				.offset( iframe.offset() )[ 0 ];
		} );
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_allowInteraction: function( event ) {
		if ( $( event.target ).closest( ".ui-dialog" ).length ) {
			return true;
		}

		// TODO: Remove hack when datepicker implements
		// the .ui-front logic (#8989)
		return !!$( event.target ).closest( ".ui-datepicker" ).length;
	},

	_createOverlay: function() {
		if ( !this.options.modal ) {
			return;
		}

		// We use a delay in case the overlay is created from an
		// event that we're going to be cancelling (#2804)
		var isOpening = true;
		this._delay( function() {
			isOpening = false;
		} );

		if ( !this.document.data( "ui-dialog-overlays" ) ) {

			// Prevent use of anchors and inputs
			// Using _on() for an event handler shared across many instances is
			// safe because the dialogs stack and must be closed in reverse order
			this._on( this.document, {
				focusin: function( event ) {
					if ( isOpening ) {
						return;
					}

					if ( !this._allowInteraction( event ) ) {
						event.preventDefault();
						this._trackingInstances()[ 0 ]._focusTabbable();
					}
				}
			} );
		}

		this.overlay = $( "<div>" )
			.appendTo( this._appendTo() );

		this._addClass( this.overlay, null, "ui-widget-overlay ui-front" );
		this._on( this.overlay, {
			mousedown: "_keepFocus"
		} );
		this.document.data( "ui-dialog-overlays",
			( this.document.data( "ui-dialog-overlays" ) || 0 ) + 1 );
	},

	_destroyOverlay: function() {
		if ( !this.options.modal ) {
			return;
		}

		if ( this.overlay ) {
			var overlays = this.document.data( "ui-dialog-overlays" ) - 1;

			if ( !overlays ) {
				this._off( this.document, "focusin" );
				this.document.removeData( "ui-dialog-overlays" );
			} else {
				this.document.data( "ui-dialog-overlays", overlays );
			}

			this.overlay.remove();
			this.overlay = null;
		}
	}
} );

// DEPRECATED
// TODO: switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat !== false ) {

	// Backcompat for dialogClass option
	$.widget( "ui.dialog", $.ui.dialog, {
		options: {
			dialogClass: ""
		},
		_createWrapper: function() {
			this._super();
			this.uiDialog.addClass( this.options.dialogClass );
		},
		_setOption: function( key, value ) {
			if ( key === "dialogClass" ) {
				this.uiDialog
					.removeClass( this.options.dialogClass )
					.addClass( value );
			}
			this._superApply( arguments );
		}
	} );
}

var widgetsDialog = $.ui.dialog;


/*!
 * jQuery UI Droppable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Droppable
//>>group: Interactions
//>>description: Enables drop targets for draggable elements.
//>>docs: http://api.jqueryui.com/droppable/
//>>demos: http://jqueryui.com/droppable/



$.widget( "ui.droppable", {
	version: "1.12.1",
	widgetEventPrefix: "drop",
	options: {
		accept: "*",
		addClasses: true,
		greedy: false,
		scope: "default",
		tolerance: "intersect",

		// Callbacks
		activate: null,
		deactivate: null,
		drop: null,
		out: null,
		over: null
	},
	_create: function() {

		var proportions,
			o = this.options,
			accept = o.accept;

		this.isover = false;
		this.isout = true;

		this.accept = $.isFunction( accept ) ? accept : function( d ) {
			return d.is( accept );
		};

		this.proportions = function( /* valueToWrite */ ) {
			if ( arguments.length ) {

				// Store the droppable's proportions
				proportions = arguments[ 0 ];
			} else {

				// Retrieve or derive the droppable's proportions
				return proportions ?
					proportions :
					proportions = {
						width: this.element[ 0 ].offsetWidth,
						height: this.element[ 0 ].offsetHeight
					};
			}
		};

		this._addToManager( o.scope );

		o.addClasses && this._addClass( "ui-droppable" );

	},

	_addToManager: function( scope ) {

		// Add the reference and positions to the manager
		$.ui.ddmanager.droppables[ scope ] = $.ui.ddmanager.droppables[ scope ] || [];
		$.ui.ddmanager.droppables[ scope ].push( this );
	},

	_splice: function( drop ) {
		var i = 0;
		for ( ; i < drop.length; i++ ) {
			if ( drop[ i ] === this ) {
				drop.splice( i, 1 );
			}
		}
	},

	_destroy: function() {
		var drop = $.ui.ddmanager.droppables[ this.options.scope ];

		this._splice( drop );
	},

	_setOption: function( key, value ) {

		if ( key === "accept" ) {
			this.accept = $.isFunction( value ) ? value : function( d ) {
				return d.is( value );
			};
		} else if ( key === "scope" ) {
			var drop = $.ui.ddmanager.droppables[ this.options.scope ];

			this._splice( drop );
			this._addToManager( value );
		}

		this._super( key, value );
	},

	_activate: function( event ) {
		var draggable = $.ui.ddmanager.current;

		this._addActiveClass();
		if ( draggable ) {
			this._trigger( "activate", event, this.ui( draggable ) );
		}
	},

	_deactivate: function( event ) {
		var draggable = $.ui.ddmanager.current;

		this._removeActiveClass();
		if ( draggable ) {
			this._trigger( "deactivate", event, this.ui( draggable ) );
		}
	},

	_over: function( event ) {

		var draggable = $.ui.ddmanager.current;

		// Bail if draggable and droppable are same element
		if ( !draggable || ( draggable.currentItem ||
				draggable.element )[ 0 ] === this.element[ 0 ] ) {
			return;
		}

		if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem ||
				draggable.element ) ) ) {
			this._addHoverClass();
			this._trigger( "over", event, this.ui( draggable ) );
		}

	},

	_out: function( event ) {

		var draggable = $.ui.ddmanager.current;

		// Bail if draggable and droppable are same element
		if ( !draggable || ( draggable.currentItem ||
				draggable.element )[ 0 ] === this.element[ 0 ] ) {
			return;
		}

		if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem ||
				draggable.element ) ) ) {
			this._removeHoverClass();
			this._trigger( "out", event, this.ui( draggable ) );
		}

	},

	_drop: function( event, custom ) {

		var draggable = custom || $.ui.ddmanager.current,
			childrenIntersection = false;

		// Bail if draggable and droppable are same element
		if ( !draggable || ( draggable.currentItem ||
				draggable.element )[ 0 ] === this.element[ 0 ] ) {
			return false;
		}

		this.element
			.find( ":data(ui-droppable)" )
			.not( ".ui-draggable-dragging" )
			.each( function() {
				var inst = $( this ).droppable( "instance" );
				if (
					inst.options.greedy &&
					!inst.options.disabled &&
					inst.options.scope === draggable.options.scope &&
					inst.accept.call(
						inst.element[ 0 ], ( draggable.currentItem || draggable.element )
					) &&
					intersect(
						draggable,
						$.extend( inst, { offset: inst.element.offset() } ),
						inst.options.tolerance, event
					)
				) {
					childrenIntersection = true;
					return false; }
			} );
		if ( childrenIntersection ) {
			return false;
		}

		if ( this.accept.call( this.element[ 0 ],
				( draggable.currentItem || draggable.element ) ) ) {
			this._removeActiveClass();
			this._removeHoverClass();

			this._trigger( "drop", event, this.ui( draggable ) );
			return this.element;
		}

		return false;

	},

	ui: function( c ) {
		return {
			draggable: ( c.currentItem || c.element ),
			helper: c.helper,
			position: c.position,
			offset: c.positionAbs
		};
	},

	// Extension points just to make backcompat sane and avoid duplicating logic
	// TODO: Remove in 1.13 along with call to it below
	_addHoverClass: function() {
		this._addClass( "ui-droppable-hover" );
	},

	_removeHoverClass: function() {
		this._removeClass( "ui-droppable-hover" );
	},

	_addActiveClass: function() {
		this._addClass( "ui-droppable-active" );
	},

	_removeActiveClass: function() {
		this._removeClass( "ui-droppable-active" );
	}
} );

var intersect = $.ui.intersect = ( function() {
	function isOverAxis( x, reference, size ) {
		return ( x >= reference ) && ( x < ( reference + size ) );
	}

	return function( draggable, droppable, toleranceMode, event ) {

		if ( !droppable.offset ) {
			return false;
		}

		var x1 = ( draggable.positionAbs ||
				draggable.position.absolute ).left + draggable.margins.left,
			y1 = ( draggable.positionAbs ||
				draggable.position.absolute ).top + draggable.margins.top,
			x2 = x1 + draggable.helperProportions.width,
			y2 = y1 + draggable.helperProportions.height,
			l = droppable.offset.left,
			t = droppable.offset.top,
			r = l + droppable.proportions().width,
			b = t + droppable.proportions().height;

		switch ( toleranceMode ) {
		case "fit":
			return ( l <= x1 && x2 <= r && t <= y1 && y2 <= b );
		case "intersect":
			return ( l < x1 + ( draggable.helperProportions.width / 2 ) && // Right Half
				x2 - ( draggable.helperProportions.width / 2 ) < r && // Left Half
				t < y1 + ( draggable.helperProportions.height / 2 ) && // Bottom Half
				y2 - ( draggable.helperProportions.height / 2 ) < b ); // Top Half
		case "pointer":
			return isOverAxis( event.pageY, t, droppable.proportions().height ) &&
				isOverAxis( event.pageX, l, droppable.proportions().width );
		case "touch":
			return (
				( y1 >= t && y1 <= b ) || // Top edge touching
				( y2 >= t && y2 <= b ) || // Bottom edge touching
				( y1 < t && y2 > b ) // Surrounded vertically
			) && (
				( x1 >= l && x1 <= r ) || // Left edge touching
				( x2 >= l && x2 <= r ) || // Right edge touching
				( x1 < l && x2 > r ) // Surrounded horizontally
			);
		default:
			return false;
		}
	};
} )();

/*
	This manager tracks offsets of draggables and droppables
*/
$.ui.ddmanager = {
	current: null,
	droppables: { "default": [] },
	prepareOffsets: function( t, event ) {

		var i, j,
			m = $.ui.ddmanager.droppables[ t.options.scope ] || [],
			type = event ? event.type : null, // workaround for #2317
			list = ( t.currentItem || t.element ).find( ":data(ui-droppable)" ).addBack();

		droppablesLoop: for ( i = 0; i < m.length; i++ ) {

			// No disabled and non-accepted
			if ( m[ i ].options.disabled || ( t && !m[ i ].accept.call( m[ i ].element[ 0 ],
					( t.currentItem || t.element ) ) ) ) {
				continue;
			}

			// Filter out elements in the current dragged item
			for ( j = 0; j < list.length; j++ ) {
				if ( list[ j ] === m[ i ].element[ 0 ] ) {
					m[ i ].proportions().height = 0;
					continue droppablesLoop;
				}
			}

			m[ i ].visible = m[ i ].element.css( "display" ) !== "none";
			if ( !m[ i ].visible ) {
				continue;
			}

			// Activate the droppable if used directly from draggables
			if ( type === "mousedown" ) {
				m[ i ]._activate.call( m[ i ], event );
			}

			m[ i ].offset = m[ i ].element.offset();
			m[ i ].proportions( {
				width: m[ i ].element[ 0 ].offsetWidth,
				height: m[ i ].element[ 0 ].offsetHeight
			} );

		}

	},
	drop: function( draggable, event ) {

		var dropped = false;

		// Create a copy of the droppables in case the list changes during the drop (#9116)
		$.each( ( $.ui.ddmanager.droppables[ draggable.options.scope ] || [] ).slice(), function() {

			if ( !this.options ) {
				return;
			}
			if ( !this.options.disabled && this.visible &&
					intersect( draggable, this, this.options.tolerance, event ) ) {
				dropped = this._drop.call( this, event ) || dropped;
			}

			if ( !this.options.disabled && this.visible && this.accept.call( this.element[ 0 ],
					( draggable.currentItem || draggable.element ) ) ) {
				this.isout = true;
				this.isover = false;
				this._deactivate.call( this, event );
			}

		} );
		return dropped;

	},
	dragStart: function( draggable, event ) {

		// Listen for scrolling so that if the dragging causes scrolling the position of the
		// droppables can be recalculated (see #5003)
		draggable.element.parentsUntil( "body" ).on( "scroll.droppable", function() {
			if ( !draggable.options.refreshPositions ) {
				$.ui.ddmanager.prepareOffsets( draggable, event );
			}
		} );
	},
	drag: function( draggable, event ) {

		// If you have a highly dynamic page, you might try this option. It renders positions
		// every time you move the mouse.
		if ( draggable.options.refreshPositions ) {
			$.ui.ddmanager.prepareOffsets( draggable, event );
		}

		// Run through all droppables and check their positions based on specific tolerance options
		$.each( $.ui.ddmanager.droppables[ draggable.options.scope ] || [], function() {

			if ( this.options.disabled || this.greedyChild || !this.visible ) {
				return;
			}

			var parentInstance, scope, parent,
				intersects = intersect( draggable, this, this.options.tolerance, event ),
				c = !intersects && this.isover ?
					"isout" :
					( intersects && !this.isover ? "isover" : null );
			if ( !c ) {
				return;
			}

			if ( this.options.greedy ) {

				// find droppable parents with same scope
				scope = this.options.scope;
				parent = this.element.parents( ":data(ui-droppable)" ).filter( function() {
					return $( this ).droppable( "instance" ).options.scope === scope;
				} );

				if ( parent.length ) {
					parentInstance = $( parent[ 0 ] ).droppable( "instance" );
					parentInstance.greedyChild = ( c === "isover" );
				}
			}

			// We just moved into a greedy child
			if ( parentInstance && c === "isover" ) {
				parentInstance.isover = false;
				parentInstance.isout = true;
				parentInstance._out.call( parentInstance, event );
			}

			this[ c ] = true;
			this[ c === "isout" ? "isover" : "isout" ] = false;
			this[ c === "isover" ? "_over" : "_out" ].call( this, event );

			// We just moved out of a greedy child
			if ( parentInstance && c === "isout" ) {
				parentInstance.isout = false;
				parentInstance.isover = true;
				parentInstance._over.call( parentInstance, event );
			}
		} );

	},
	dragStop: function( draggable, event ) {
		draggable.element.parentsUntil( "body" ).off( "scroll.droppable" );

		// Call prepareOffsets one final time since IE does not fire return scroll events when
		// overflow was caused by drag (see #5003)
		if ( !draggable.options.refreshPositions ) {
			$.ui.ddmanager.prepareOffsets( draggable, event );
		}
	}
};

// DEPRECATED
// TODO: switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat !== false ) {

	// Backcompat for activeClass and hoverClass options
	$.widget( "ui.droppable", $.ui.droppable, {
		options: {
			hoverClass: false,
			activeClass: false
		},
		_addActiveClass: function() {
			this._super();
			if ( this.options.activeClass ) {
				this.element.addClass( this.options.activeClass );
			}
		},
		_removeActiveClass: function() {
			this._super();
			if ( this.options.activeClass ) {
				this.element.removeClass( this.options.activeClass );
			}
		},
		_addHoverClass: function() {
			this._super();
			if ( this.options.hoverClass ) {
				this.element.addClass( this.options.hoverClass );
			}
		},
		_removeHoverClass: function() {
			this._super();
			if ( this.options.hoverClass ) {
				this.element.removeClass( this.options.hoverClass );
			}
		}
	} );
}

var widgetsDroppable = $.ui.droppable;


/*!
 * jQuery UI Progressbar 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Progressbar
//>>group: Widgets
// jscs:disable maximumLineLength
//>>description: Displays a status indicator for loading state, standard percentage, and other progress indicators.
// jscs:enable maximumLineLength
//>>docs: http://api.jqueryui.com/progressbar/
//>>demos: http://jqueryui.com/progressbar/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/progressbar.css
//>>css.theme: ../../themes/base/theme.css



var widgetsProgressbar = $.widget( "ui.progressbar", {
	version: "1.12.1",
	options: {
		classes: {
			"ui-progressbar": "ui-corner-all",
			"ui-progressbar-value": "ui-corner-left",
			"ui-progressbar-complete": "ui-corner-right"
		},
		max: 100,
		value: 0,

		change: null,
		complete: null
	},

	min: 0,

	_create: function() {

		// Constrain initial value
		this.oldValue = this.options.value = this._constrainedValue();

		this.element.attr( {

			// Only set static values; aria-valuenow and aria-valuemax are
			// set inside _refreshValue()
			role: "progressbar",
			"aria-valuemin": this.min
		} );
		this._addClass( "ui-progressbar", "ui-widget ui-widget-content" );

		this.valueDiv = $( "<div>" ).appendTo( this.element );
		this._addClass( this.valueDiv, "ui-progressbar-value", "ui-widget-header" );
		this._refreshValue();
	},

	_destroy: function() {
		this.element.removeAttr( "role aria-valuemin aria-valuemax aria-valuenow" );

		this.valueDiv.remove();
	},

	value: function( newValue ) {
		if ( newValue === undefined ) {
			return this.options.value;
		}

		this.options.value = this._constrainedValue( newValue );
		this._refreshValue();
	},

	_constrainedValue: function( newValue ) {
		if ( newValue === undefined ) {
			newValue = this.options.value;
		}

		this.indeterminate = newValue === false;

		// Sanitize value
		if ( typeof newValue !== "number" ) {
			newValue = 0;
		}

		return this.indeterminate ? false :
			Math.min( this.options.max, Math.max( this.min, newValue ) );
	},

	_setOptions: function( options ) {

		// Ensure "value" option is set after other values (like max)
		var value = options.value;
		delete options.value;

		this._super( options );

		this.options.value = this._constrainedValue( value );
		this._refreshValue();
	},

	_setOption: function( key, value ) {
		if ( key === "max" ) {

			// Don't allow a max less than min
			value = Math.max( this.min, value );
		}
		this._super( key, value );
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", value );
		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	_percentage: function() {
		return this.indeterminate ?
			100 :
			100 * ( this.options.value - this.min ) / ( this.options.max - this.min );
	},

	_refreshValue: function() {
		var value = this.options.value,
			percentage = this._percentage();

		this.valueDiv
			.toggle( this.indeterminate || value > this.min )
			.width( percentage.toFixed( 0 ) + "%" );

		this
			._toggleClass( this.valueDiv, "ui-progressbar-complete", null,
				value === this.options.max )
			._toggleClass( "ui-progressbar-indeterminate", null, this.indeterminate );

		if ( this.indeterminate ) {
			this.element.removeAttr( "aria-valuenow" );
			if ( !this.overlayDiv ) {
				this.overlayDiv = $( "<div>" ).appendTo( this.valueDiv );
				this._addClass( this.overlayDiv, "ui-progressbar-overlay" );
			}
		} else {
			this.element.attr( {
				"aria-valuemax": this.options.max,
				"aria-valuenow": value
			} );
			if ( this.overlayDiv ) {
				this.overlayDiv.remove();
				this.overlayDiv = null;
			}
		}

		if ( this.oldValue !== value ) {
			this.oldValue = value;
			this._trigger( "change" );
		}
		if ( value === this.options.max ) {
			this._trigger( "complete" );
		}
	}
} );


/*!
 * jQuery UI Selectable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Selectable
//>>group: Interactions
//>>description: Allows groups of elements to be selected with the mouse.
//>>docs: http://api.jqueryui.com/selectable/
//>>demos: http://jqueryui.com/selectable/
//>>css.structure: ../../themes/base/selectable.css



var widgetsSelectable = $.widget( "ui.selectable", $.ui.mouse, {
	version: "1.12.1",
	options: {
		appendTo: "body",
		autoRefresh: true,
		distance: 0,
		filter: "*",
		tolerance: "touch",

		// Callbacks
		selected: null,
		selecting: null,
		start: null,
		stop: null,
		unselected: null,
		unselecting: null
	},
	_create: function() {
		var that = this;

		this._addClass( "ui-selectable" );

		this.dragged = false;

		// Cache selectee children based on filter
		this.refresh = function() {
			that.elementPos = $( that.element[ 0 ] ).offset();
			that.selectees = $( that.options.filter, that.element[ 0 ] );
			that._addClass( that.selectees, "ui-selectee" );
			that.selectees.each( function() {
				var $this = $( this ),
					selecteeOffset = $this.offset(),
					pos = {
						left: selecteeOffset.left - that.elementPos.left,
						top: selecteeOffset.top - that.elementPos.top
					};
				$.data( this, "selectable-item", {
					element: this,
					$element: $this,
					left: pos.left,
					top: pos.top,
					right: pos.left + $this.outerWidth(),
					bottom: pos.top + $this.outerHeight(),
					startselected: false,
					selected: $this.hasClass( "ui-selected" ),
					selecting: $this.hasClass( "ui-selecting" ),
					unselecting: $this.hasClass( "ui-unselecting" )
				} );
			} );
		};
		this.refresh();

		this._mouseInit();

		this.helper = $( "<div>" );
		this._addClass( this.helper, "ui-selectable-helper" );
	},

	_destroy: function() {
		this.selectees.removeData( "selectable-item" );
		this._mouseDestroy();
	},

	_mouseStart: function( event ) {
		var that = this,
			options = this.options;

		this.opos = [ event.pageX, event.pageY ];
		this.elementPos = $( this.element[ 0 ] ).offset();

		if ( this.options.disabled ) {
			return;
		}

		this.selectees = $( options.filter, this.element[ 0 ] );

		this._trigger( "start", event );

		$( options.appendTo ).append( this.helper );

		// position helper (lasso)
		this.helper.css( {
			"left": event.pageX,
			"top": event.pageY,
			"width": 0,
			"height": 0
		} );

		if ( options.autoRefresh ) {
			this.refresh();
		}

		this.selectees.filter( ".ui-selected" ).each( function() {
			var selectee = $.data( this, "selectable-item" );
			selectee.startselected = true;
			if ( !event.metaKey && !event.ctrlKey ) {
				that._removeClass( selectee.$element, "ui-selected" );
				selectee.selected = false;
				that._addClass( selectee.$element, "ui-unselecting" );
				selectee.unselecting = true;

				// selectable UNSELECTING callback
				that._trigger( "unselecting", event, {
					unselecting: selectee.element
				} );
			}
		} );

		$( event.target ).parents().addBack().each( function() {
			var doSelect,
				selectee = $.data( this, "selectable-item" );
			if ( selectee ) {
				doSelect = ( !event.metaKey && !event.ctrlKey ) ||
					!selectee.$element.hasClass( "ui-selected" );
				that._removeClass( selectee.$element, doSelect ? "ui-unselecting" : "ui-selected" )
					._addClass( selectee.$element, doSelect ? "ui-selecting" : "ui-unselecting" );
				selectee.unselecting = !doSelect;
				selectee.selecting = doSelect;
				selectee.selected = doSelect;

				// selectable (UN)SELECTING callback
				if ( doSelect ) {
					that._trigger( "selecting", event, {
						selecting: selectee.element
					} );
				} else {
					that._trigger( "unselecting", event, {
						unselecting: selectee.element
					} );
				}
				return false;
			}
		} );

	},

	_mouseDrag: function( event ) {

		this.dragged = true;

		if ( this.options.disabled ) {
			return;
		}

		var tmp,
			that = this,
			options = this.options,
			x1 = this.opos[ 0 ],
			y1 = this.opos[ 1 ],
			x2 = event.pageX,
			y2 = event.pageY;

		if ( x1 > x2 ) { tmp = x2; x2 = x1; x1 = tmp; }
		if ( y1 > y2 ) { tmp = y2; y2 = y1; y1 = tmp; }
		this.helper.css( { left: x1, top: y1, width: x2 - x1, height: y2 - y1 } );

		this.selectees.each( function() {
			var selectee = $.data( this, "selectable-item" ),
				hit = false,
				offset = {};

			//prevent helper from being selected if appendTo: selectable
			if ( !selectee || selectee.element === that.element[ 0 ] ) {
				return;
			}

			offset.left   = selectee.left   + that.elementPos.left;
			offset.right  = selectee.right  + that.elementPos.left;
			offset.top    = selectee.top    + that.elementPos.top;
			offset.bottom = selectee.bottom + that.elementPos.top;

			if ( options.tolerance === "touch" ) {
				hit = ( !( offset.left > x2 || offset.right < x1 || offset.top > y2 ||
                    offset.bottom < y1 ) );
			} else if ( options.tolerance === "fit" ) {
				hit = ( offset.left > x1 && offset.right < x2 && offset.top > y1 &&
                    offset.bottom < y2 );
			}

			if ( hit ) {

				// SELECT
				if ( selectee.selected ) {
					that._removeClass( selectee.$element, "ui-selected" );
					selectee.selected = false;
				}
				if ( selectee.unselecting ) {
					that._removeClass( selectee.$element, "ui-unselecting" );
					selectee.unselecting = false;
				}
				if ( !selectee.selecting ) {
					that._addClass( selectee.$element, "ui-selecting" );
					selectee.selecting = true;

					// selectable SELECTING callback
					that._trigger( "selecting", event, {
						selecting: selectee.element
					} );
				}
			} else {

				// UNSELECT
				if ( selectee.selecting ) {
					if ( ( event.metaKey || event.ctrlKey ) && selectee.startselected ) {
						that._removeClass( selectee.$element, "ui-selecting" );
						selectee.selecting = false;
						that._addClass( selectee.$element, "ui-selected" );
						selectee.selected = true;
					} else {
						that._removeClass( selectee.$element, "ui-selecting" );
						selectee.selecting = false;
						if ( selectee.startselected ) {
							that._addClass( selectee.$element, "ui-unselecting" );
							selectee.unselecting = true;
						}

						// selectable UNSELECTING callback
						that._trigger( "unselecting", event, {
							unselecting: selectee.element
						} );
					}
				}
				if ( selectee.selected ) {
					if ( !event.metaKey && !event.ctrlKey && !selectee.startselected ) {
						that._removeClass( selectee.$element, "ui-selected" );
						selectee.selected = false;

						that._addClass( selectee.$element, "ui-unselecting" );
						selectee.unselecting = true;

						// selectable UNSELECTING callback
						that._trigger( "unselecting", event, {
							unselecting: selectee.element
						} );
					}
				}
			}
		} );

		return false;
	},

	_mouseStop: function( event ) {
		var that = this;

		this.dragged = false;

		$( ".ui-unselecting", this.element[ 0 ] ).each( function() {
			var selectee = $.data( this, "selectable-item" );
			that._removeClass( selectee.$element, "ui-unselecting" );
			selectee.unselecting = false;
			selectee.startselected = false;
			that._trigger( "unselected", event, {
				unselected: selectee.element
			} );
		} );
		$( ".ui-selecting", this.element[ 0 ] ).each( function() {
			var selectee = $.data( this, "selectable-item" );
			that._removeClass( selectee.$element, "ui-selecting" )
				._addClass( selectee.$element, "ui-selected" );
			selectee.selecting = false;
			selectee.selected = true;
			selectee.startselected = true;
			that._trigger( "selected", event, {
				selected: selectee.element
			} );
		} );
		this._trigger( "stop", event );

		this.helper.remove();

		return false;
	}

} );


/*!
 * jQuery UI Selectmenu 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Selectmenu
//>>group: Widgets
// jscs:disable maximumLineLength
//>>description: Duplicates and extends the functionality of a native HTML select element, allowing it to be customizable in behavior and appearance far beyond the limitations of a native select.
// jscs:enable maximumLineLength
//>>docs: http://api.jqueryui.com/selectmenu/
//>>demos: http://jqueryui.com/selectmenu/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/selectmenu.css, ../../themes/base/button.css
//>>css.theme: ../../themes/base/theme.css



var widgetsSelectmenu = $.widget( "ui.selectmenu", [ $.ui.formResetMixin, {
	version: "1.12.1",
	defaultElement: "<select>",
	options: {
		appendTo: null,
		classes: {
			"ui-selectmenu-button-open": "ui-corner-top",
			"ui-selectmenu-button-closed": "ui-corner-all"
		},
		disabled: null,
		icons: {
			button: "ui-icon-triangle-1-s"
		},
		position: {
			my: "left top",
			at: "left bottom",
			collision: "none"
		},
		width: false,

		// Callbacks
		change: null,
		close: null,
		focus: null,
		open: null,
		select: null
	},

	_create: function() {
		var selectmenuId = this.element.uniqueId().attr( "id" );
		this.ids = {
			element: selectmenuId,
			button: selectmenuId + "-button",
			menu: selectmenuId + "-menu"
		};

		this._drawButton();
		this._drawMenu();
		this._bindFormResetHandler();

		this._rendered = false;
		this.menuItems = $();
	},

	_drawButton: function() {
		var icon,
			that = this,
			item = this._parseOption(
				this.element.find( "option:selected" ),
				this.element[ 0 ].selectedIndex
			);

		// Associate existing label with the new button
		this.labels = this.element.labels().attr( "for", this.ids.button );
		this._on( this.labels, {
			click: function( event ) {
				this.button.focus();
				event.preventDefault();
			}
		} );

		// Hide original select element
		this.element.hide();

		// Create button
		this.button = $( "<span>", {
			tabindex: this.options.disabled ? -1 : 0,
			id: this.ids.button,
			role: "combobox",
			"aria-expanded": "false",
			"aria-autocomplete": "list",
			"aria-owns": this.ids.menu,
			"aria-haspopup": "true",
			title: this.element.attr( "title" )
		} )
			.insertAfter( this.element );

		this._addClass( this.button, "ui-selectmenu-button ui-selectmenu-button-closed",
			"ui-button ui-widget" );

		icon = $( "<span>" ).appendTo( this.button );
		this._addClass( icon, "ui-selectmenu-icon", "ui-icon " + this.options.icons.button );
		this.buttonItem = this._renderButtonItem( item )
			.appendTo( this.button );

		if ( this.options.width !== false ) {
			this._resizeButton();
		}

		this._on( this.button, this._buttonEvents );
		this.button.one( "focusin", function() {

			// Delay rendering the menu items until the button receives focus.
			// The menu may have already been rendered via a programmatic open.
			if ( !that._rendered ) {
				that._refreshMenu();
			}
		} );
	},

	_drawMenu: function() {
		var that = this;

		// Create menu
		this.menu = $( "<ul>", {
			"aria-hidden": "true",
			"aria-labelledby": this.ids.button,
			id: this.ids.menu
		} );

		// Wrap menu
		this.menuWrap = $( "<div>" ).append( this.menu );
		this._addClass( this.menuWrap, "ui-selectmenu-menu", "ui-front" );
		this.menuWrap.appendTo( this._appendTo() );

		// Initialize menu widget
		this.menuInstance = this.menu
			.menu( {
				classes: {
					"ui-menu": "ui-corner-bottom"
				},
				role: "listbox",
				select: function( event, ui ) {
					event.preventDefault();

					// Support: IE8
					// If the item was selected via a click, the text selection
					// will be destroyed in IE
					that._setSelection();

					that._select( ui.item.data( "ui-selectmenu-item" ), event );
				},
				focus: function( event, ui ) {
					var item = ui.item.data( "ui-selectmenu-item" );

					// Prevent inital focus from firing and check if its a newly focused item
					if ( that.focusIndex != null && item.index !== that.focusIndex ) {
						that._trigger( "focus", event, { item: item } );
						if ( !that.isOpen ) {
							that._select( item, event );
						}
					}
					that.focusIndex = item.index;

					that.button.attr( "aria-activedescendant",
						that.menuItems.eq( item.index ).attr( "id" ) );
				}
			} )
			.menu( "instance" );

		// Don't close the menu on mouseleave
		this.menuInstance._off( this.menu, "mouseleave" );

		// Cancel the menu's collapseAll on document click
		this.menuInstance._closeOnDocumentClick = function() {
			return false;
		};

		// Selects often contain empty items, but never contain dividers
		this.menuInstance._isDivider = function() {
			return false;
		};
	},

	refresh: function() {
		this._refreshMenu();
		this.buttonItem.replaceWith(
			this.buttonItem = this._renderButtonItem(

				// Fall back to an empty object in case there are no options
				this._getSelectedItem().data( "ui-selectmenu-item" ) || {}
			)
		);
		if ( this.options.width === null ) {
			this._resizeButton();
		}
	},

	_refreshMenu: function() {
		var item,
			options = this.element.find( "option" );

		this.menu.empty();

		this._parseOptions( options );
		this._renderMenu( this.menu, this.items );

		this.menuInstance.refresh();
		this.menuItems = this.menu.find( "li" )
			.not( ".ui-selectmenu-optgroup" )
				.find( ".ui-menu-item-wrapper" );

		this._rendered = true;

		if ( !options.length ) {
			return;
		}

		item = this._getSelectedItem();

		// Update the menu to have the correct item focused
		this.menuInstance.focus( null, item );
		this._setAria( item.data( "ui-selectmenu-item" ) );

		// Set disabled state
		this._setOption( "disabled", this.element.prop( "disabled" ) );
	},

	open: function( event ) {
		if ( this.options.disabled ) {
			return;
		}

		// If this is the first time the menu is being opened, render the items
		if ( !this._rendered ) {
			this._refreshMenu();
		} else {

			// Menu clears focus on close, reset focus to selected item
			this._removeClass( this.menu.find( ".ui-state-active" ), null, "ui-state-active" );
			this.menuInstance.focus( null, this._getSelectedItem() );
		}

		// If there are no options, don't open the menu
		if ( !this.menuItems.length ) {
			return;
		}

		this.isOpen = true;
		this._toggleAttr();
		this._resizeMenu();
		this._position();

		this._on( this.document, this._documentClick );

		this._trigger( "open", event );
	},

	_position: function() {
		this.menuWrap.position( $.extend( { of: this.button }, this.options.position ) );
	},

	close: function( event ) {
		if ( !this.isOpen ) {
			return;
		}

		this.isOpen = false;
		this._toggleAttr();

		this.range = null;
		this._off( this.document );

		this._trigger( "close", event );
	},

	widget: function() {
		return this.button;
	},

	menuWidget: function() {
		return this.menu;
	},

	_renderButtonItem: function( item ) {
		var buttonItem = $( "<span>" );

		this._setText( buttonItem, item.label );
		this._addClass( buttonItem, "ui-selectmenu-text" );

		return buttonItem;
	},

	_renderMenu: function( ul, items ) {
		var that = this,
			currentOptgroup = "";

		$.each( items, function( index, item ) {
			var li;

			if ( item.optgroup !== currentOptgroup ) {
				li = $( "<li>", {
					text: item.optgroup
				} );
				that._addClass( li, "ui-selectmenu-optgroup", "ui-menu-divider" +
					( item.element.parent( "optgroup" ).prop( "disabled" ) ?
						" ui-state-disabled" :
						"" ) );

				li.appendTo( ul );

				currentOptgroup = item.optgroup;
			}

			that._renderItemData( ul, item );
		} );
	},

	_renderItemData: function( ul, item ) {
		return this._renderItem( ul, item ).data( "ui-selectmenu-item", item );
	},

	_renderItem: function( ul, item ) {
		var li = $( "<li>" ),
			wrapper = $( "<div>", {
				title: item.element.attr( "title" )
			} );

		if ( item.disabled ) {
			this._addClass( li, null, "ui-state-disabled" );
		}
		this._setText( wrapper, item.label );

		return li.append( wrapper ).appendTo( ul );
	},

	_setText: function( element, value ) {
		if ( value ) {
			element.text( value );
		} else {
			element.html( "&#160;" );
		}
	},

	_move: function( direction, event ) {
		var item, next,
			filter = ".ui-menu-item";

		if ( this.isOpen ) {
			item = this.menuItems.eq( this.focusIndex ).parent( "li" );
		} else {
			item = this.menuItems.eq( this.element[ 0 ].selectedIndex ).parent( "li" );
			filter += ":not(.ui-state-disabled)";
		}

		if ( direction === "first" || direction === "last" ) {
			next = item[ direction === "first" ? "prevAll" : "nextAll" ]( filter ).eq( -1 );
		} else {
			next = item[ direction + "All" ]( filter ).eq( 0 );
		}

		if ( next.length ) {
			this.menuInstance.focus( event, next );
		}
	},

	_getSelectedItem: function() {
		return this.menuItems.eq( this.element[ 0 ].selectedIndex ).parent( "li" );
	},

	_toggle: function( event ) {
		this[ this.isOpen ? "close" : "open" ]( event );
	},

	_setSelection: function() {
		var selection;

		if ( !this.range ) {
			return;
		}

		if ( window.getSelection ) {
			selection = window.getSelection();
			selection.removeAllRanges();
			selection.addRange( this.range );

		// Support: IE8
		} else {
			this.range.select();
		}

		// Support: IE
		// Setting the text selection kills the button focus in IE, but
		// restoring the focus doesn't kill the selection.
		this.button.focus();
	},

	_documentClick: {
		mousedown: function( event ) {
			if ( !this.isOpen ) {
				return;
			}

			if ( !$( event.target ).closest( ".ui-selectmenu-menu, #" +
					$.ui.escapeSelector( this.ids.button ) ).length ) {
				this.close( event );
			}
		}
	},

	_buttonEvents: {

		// Prevent text selection from being reset when interacting with the selectmenu (#10144)
		mousedown: function() {
			var selection;

			if ( window.getSelection ) {
				selection = window.getSelection();
				if ( selection.rangeCount ) {
					this.range = selection.getRangeAt( 0 );
				}

			// Support: IE8
			} else {
				this.range = document.selection.createRange();
			}
		},

		click: function( event ) {
			this._setSelection();
			this._toggle( event );
		},

		keydown: function( event ) {
			var preventDefault = true;
			switch ( event.keyCode ) {
			case $.ui.keyCode.TAB:
			case $.ui.keyCode.ESCAPE:
				this.close( event );
				preventDefault = false;
				break;
			case $.ui.keyCode.ENTER:
				if ( this.isOpen ) {
					this._selectFocusedItem( event );
				}
				break;
			case $.ui.keyCode.UP:
				if ( event.altKey ) {
					this._toggle( event );
				} else {
					this._move( "prev", event );
				}
				break;
			case $.ui.keyCode.DOWN:
				if ( event.altKey ) {
					this._toggle( event );
				} else {
					this._move( "next", event );
				}
				break;
			case $.ui.keyCode.SPACE:
				if ( this.isOpen ) {
					this._selectFocusedItem( event );
				} else {
					this._toggle( event );
				}
				break;
			case $.ui.keyCode.LEFT:
				this._move( "prev", event );
				break;
			case $.ui.keyCode.RIGHT:
				this._move( "next", event );
				break;
			case $.ui.keyCode.HOME:
			case $.ui.keyCode.PAGE_UP:
				this._move( "first", event );
				break;
			case $.ui.keyCode.END:
			case $.ui.keyCode.PAGE_DOWN:
				this._move( "last", event );
				break;
			default:
				this.menu.trigger( event );
				preventDefault = false;
			}

			if ( preventDefault ) {
				event.preventDefault();
			}
		}
	},

	_selectFocusedItem: function( event ) {
		var item = this.menuItems.eq( this.focusIndex ).parent( "li" );
		if ( !item.hasClass( "ui-state-disabled" ) ) {
			this._select( item.data( "ui-selectmenu-item" ), event );
		}
	},

	_select: function( item, event ) {
		var oldIndex = this.element[ 0 ].selectedIndex;

		// Change native select element
		this.element[ 0 ].selectedIndex = item.index;
		this.buttonItem.replaceWith( this.buttonItem = this._renderButtonItem( item ) );
		this._setAria( item );
		this._trigger( "select", event, { item: item } );

		if ( item.index !== oldIndex ) {
			this._trigger( "change", event, { item: item } );
		}

		this.close( event );
	},

	_setAria: function( item ) {
		var id = this.menuItems.eq( item.index ).attr( "id" );

		this.button.attr( {
			"aria-labelledby": id,
			"aria-activedescendant": id
		} );
		this.menu.attr( "aria-activedescendant", id );
	},

	_setOption: function( key, value ) {
		if ( key === "icons" ) {
			var icon = this.button.find( "span.ui-icon" );
			this._removeClass( icon, null, this.options.icons.button )
				._addClass( icon, null, value.button );
		}

		this._super( key, value );

		if ( key === "appendTo" ) {
			this.menuWrap.appendTo( this._appendTo() );
		}

		if ( key === "width" ) {
			this._resizeButton();
		}
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.menuInstance.option( "disabled", value );
		this.button.attr( "aria-disabled", value );
		this._toggleClass( this.button, null, "ui-state-disabled", value );

		this.element.prop( "disabled", value );
		if ( value ) {
			this.button.attr( "tabindex", -1 );
			this.close();
		} else {
			this.button.attr( "tabindex", 0 );
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;

		if ( element ) {
			element = element.jquery || element.nodeType ?
				$( element ) :
				this.document.find( element ).eq( 0 );
		}

		if ( !element || !element[ 0 ] ) {
			element = this.element.closest( ".ui-front, dialog" );
		}

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_toggleAttr: function() {
		this.button.attr( "aria-expanded", this.isOpen );

		// We can't use two _toggleClass() calls here, because we need to make sure
		// we always remove classes first and add them second, otherwise if both classes have the
		// same theme class, it will be removed after we add it.
		this._removeClass( this.button, "ui-selectmenu-button-" +
			( this.isOpen ? "closed" : "open" ) )
			._addClass( this.button, "ui-selectmenu-button-" +
				( this.isOpen ? "open" : "closed" ) )
			._toggleClass( this.menuWrap, "ui-selectmenu-open", null, this.isOpen );

		this.menu.attr( "aria-hidden", !this.isOpen );
	},

	_resizeButton: function() {
		var width = this.options.width;

		// For `width: false`, just remove inline style and stop
		if ( width === false ) {
			this.button.css( "width", "" );
			return;
		}

		// For `width: null`, match the width of the original element
		if ( width === null ) {
			width = this.element.show().outerWidth();
			this.element.hide();
		}

		this.button.outerWidth( width );
	},

	_resizeMenu: function() {
		this.menu.outerWidth( Math.max(
			this.button.outerWidth(),

			// Support: IE10
			// IE10 wraps long text (possibly a rounding bug)
			// so we add 1px to avoid the wrapping
			this.menu.width( "" ).outerWidth() + 1
		) );
	},

	_getCreateOptions: function() {
		var options = this._super();

		options.disabled = this.element.prop( "disabled" );

		return options;
	},

	_parseOptions: function( options ) {
		var that = this,
			data = [];
		options.each( function( index, item ) {
			data.push( that._parseOption( $( item ), index ) );
		} );
		this.items = data;
	},

	_parseOption: function( option, index ) {
		var optgroup = option.parent( "optgroup" );

		return {
			element: option,
			index: index,
			value: option.val(),
			label: option.text(),
			optgroup: optgroup.attr( "label" ) || "",
			disabled: optgroup.prop( "disabled" ) || option.prop( "disabled" )
		};
	},

	_destroy: function() {
		this._unbindFormResetHandler();
		this.menuWrap.remove();
		this.button.remove();
		this.element.show();
		this.element.removeUniqueId();
		this.labels.attr( "for", this.ids.element );
	}
} ] );


/*!
 * jQuery UI Slider 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Slider
//>>group: Widgets
//>>description: Displays a flexible slider with ranges and accessibility via keyboard.
//>>docs: http://api.jqueryui.com/slider/
//>>demos: http://jqueryui.com/slider/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/slider.css
//>>css.theme: ../../themes/base/theme.css



var widgetsSlider = $.widget( "ui.slider", $.ui.mouse, {
	version: "1.12.1",
	widgetEventPrefix: "slide",

	options: {
		animate: false,
		classes: {
			"ui-slider": "ui-corner-all",
			"ui-slider-handle": "ui-corner-all",

			// Note: ui-widget-header isn't the most fittingly semantic framework class for this
			// element, but worked best visually with a variety of themes
			"ui-slider-range": "ui-corner-all ui-widget-header"
		},
		distance: 0,
		max: 100,
		min: 0,
		orientation: "horizontal",
		range: false,
		step: 1,
		value: 0,
		values: null,

		// Callbacks
		change: null,
		slide: null,
		start: null,
		stop: null
	},

	// Number of pages in a slider
	// (how many times can you page up/down to go through the whole range)
	numPages: 5,

	_create: function() {
		this._keySliding = false;
		this._mouseSliding = false;
		this._animateOff = true;
		this._handleIndex = null;
		this._detectOrientation();
		this._mouseInit();
		this._calculateNewMax();

		this._addClass( "ui-slider ui-slider-" + this.orientation,
			"ui-widget ui-widget-content" );

		this._refresh();

		this._animateOff = false;
	},

	_refresh: function() {
		this._createRange();
		this._createHandles();
		this._setupEvents();
		this._refreshValue();
	},

	_createHandles: function() {
		var i, handleCount,
			options = this.options,
			existingHandles = this.element.find( ".ui-slider-handle" ),
			handle = "<span tabindex='0'></span>",
			handles = [];

		handleCount = ( options.values && options.values.length ) || 1;

		if ( existingHandles.length > handleCount ) {
			existingHandles.slice( handleCount ).remove();
			existingHandles = existingHandles.slice( 0, handleCount );
		}

		for ( i = existingHandles.length; i < handleCount; i++ ) {
			handles.push( handle );
		}

		this.handles = existingHandles.add( $( handles.join( "" ) ).appendTo( this.element ) );

		this._addClass( this.handles, "ui-slider-handle", "ui-state-default" );

		this.handle = this.handles.eq( 0 );

		this.handles.each( function( i ) {
			$( this )
				.data( "ui-slider-handle-index", i )
				.attr( "tabIndex", 0 );
		} );
	},

	_createRange: function() {
		var options = this.options;

		if ( options.range ) {
			if ( options.range === true ) {
				if ( !options.values ) {
					options.values = [ this._valueMin(), this._valueMin() ];
				} else if ( options.values.length && options.values.length !== 2 ) {
					options.values = [ options.values[ 0 ], options.values[ 0 ] ];
				} else if ( $.isArray( options.values ) ) {
					options.values = options.values.slice( 0 );
				}
			}

			if ( !this.range || !this.range.length ) {
				this.range = $( "<div>" )
					.appendTo( this.element );

				this._addClass( this.range, "ui-slider-range" );
			} else {
				this._removeClass( this.range, "ui-slider-range-min ui-slider-range-max" );

				// Handle range switching from true to min/max
				this.range.css( {
					"left": "",
					"bottom": ""
				} );
			}
			if ( options.range === "min" || options.range === "max" ) {
				this._addClass( this.range, "ui-slider-range-" + options.range );
			}
		} else {
			if ( this.range ) {
				this.range.remove();
			}
			this.range = null;
		}
	},

	_setupEvents: function() {
		this._off( this.handles );
		this._on( this.handles, this._handleEvents );
		this._hoverable( this.handles );
		this._focusable( this.handles );
	},

	_destroy: function() {
		this.handles.remove();
		if ( this.range ) {
			this.range.remove();
		}

		this._mouseDestroy();
	},

	_mouseCapture: function( event ) {
		var position, normValue, distance, closestHandle, index, allowed, offset, mouseOverHandle,
			that = this,
			o = this.options;

		if ( o.disabled ) {
			return false;
		}

		this.elementSize = {
			width: this.element.outerWidth(),
			height: this.element.outerHeight()
		};
		this.elementOffset = this.element.offset();

		position = { x: event.pageX, y: event.pageY };
		normValue = this._normValueFromMouse( position );
		distance = this._valueMax() - this._valueMin() + 1;
		this.handles.each( function( i ) {
			var thisDistance = Math.abs( normValue - that.values( i ) );
			if ( ( distance > thisDistance ) ||
				( distance === thisDistance &&
					( i === that._lastChangedValue || that.values( i ) === o.min ) ) ) {
				distance = thisDistance;
				closestHandle = $( this );
				index = i;
			}
		} );

		allowed = this._start( event, index );
		if ( allowed === false ) {
			return false;
		}
		this._mouseSliding = true;

		this._handleIndex = index;

		this._addClass( closestHandle, null, "ui-state-active" );
		closestHandle.trigger( "focus" );

		offset = closestHandle.offset();
		mouseOverHandle = !$( event.target ).parents().addBack().is( ".ui-slider-handle" );
		this._clickOffset = mouseOverHandle ? { left: 0, top: 0 } : {
			left: event.pageX - offset.left - ( closestHandle.width() / 2 ),
			top: event.pageY - offset.top -
				( closestHandle.height() / 2 ) -
				( parseInt( closestHandle.css( "borderTopWidth" ), 10 ) || 0 ) -
				( parseInt( closestHandle.css( "borderBottomWidth" ), 10 ) || 0 ) +
				( parseInt( closestHandle.css( "marginTop" ), 10 ) || 0 )
		};

		if ( !this.handles.hasClass( "ui-state-hover" ) ) {
			this._slide( event, index, normValue );
		}
		this._animateOff = true;
		return true;
	},

	_mouseStart: function() {
		return true;
	},

	_mouseDrag: function( event ) {
		var position = { x: event.pageX, y: event.pageY },
			normValue = this._normValueFromMouse( position );

		this._slide( event, this._handleIndex, normValue );

		return false;
	},

	_mouseStop: function( event ) {
		this._removeClass( this.handles, null, "ui-state-active" );
		this._mouseSliding = false;

		this._stop( event, this._handleIndex );
		this._change( event, this._handleIndex );

		this._handleIndex = null;
		this._clickOffset = null;
		this._animateOff = false;

		return false;
	},

	_detectOrientation: function() {
		this.orientation = ( this.options.orientation === "vertical" ) ? "vertical" : "horizontal";
	},

	_normValueFromMouse: function( position ) {
		var pixelTotal,
			pixelMouse,
			percentMouse,
			valueTotal,
			valueMouse;

		if ( this.orientation === "horizontal" ) {
			pixelTotal = this.elementSize.width;
			pixelMouse = position.x - this.elementOffset.left -
				( this._clickOffset ? this._clickOffset.left : 0 );
		} else {
			pixelTotal = this.elementSize.height;
			pixelMouse = position.y - this.elementOffset.top -
				( this._clickOffset ? this._clickOffset.top : 0 );
		}

		percentMouse = ( pixelMouse / pixelTotal );
		if ( percentMouse > 1 ) {
			percentMouse = 1;
		}
		if ( percentMouse < 0 ) {
			percentMouse = 0;
		}
		if ( this.orientation === "vertical" ) {
			percentMouse = 1 - percentMouse;
		}

		valueTotal = this._valueMax() - this._valueMin();
		valueMouse = this._valueMin() + percentMouse * valueTotal;

		return this._trimAlignValue( valueMouse );
	},

	_uiHash: function( index, value, values ) {
		var uiHash = {
			handle: this.handles[ index ],
			handleIndex: index,
			value: value !== undefined ? value : this.value()
		};

		if ( this._hasMultipleValues() ) {
			uiHash.value = value !== undefined ? value : this.values( index );
			uiHash.values = values || this.values();
		}

		return uiHash;
	},

	_hasMultipleValues: function() {
		return this.options.values && this.options.values.length;
	},

	_start: function( event, index ) {
		return this._trigger( "start", event, this._uiHash( index ) );
	},

	_slide: function( event, index, newVal ) {
		var allowed, otherVal,
			currentValue = this.value(),
			newValues = this.values();

		if ( this._hasMultipleValues() ) {
			otherVal = this.values( index ? 0 : 1 );
			currentValue = this.values( index );

			if ( this.options.values.length === 2 && this.options.range === true ) {
				newVal =  index === 0 ? Math.min( otherVal, newVal ) : Math.max( otherVal, newVal );
			}

			newValues[ index ] = newVal;
		}

		if ( newVal === currentValue ) {
			return;
		}

		allowed = this._trigger( "slide", event, this._uiHash( index, newVal, newValues ) );

		// A slide can be canceled by returning false from the slide callback
		if ( allowed === false ) {
			return;
		}

		if ( this._hasMultipleValues() ) {
			this.values( index, newVal );
		} else {
			this.value( newVal );
		}
	},

	_stop: function( event, index ) {
		this._trigger( "stop", event, this._uiHash( index ) );
	},

	_change: function( event, index ) {
		if ( !this._keySliding && !this._mouseSliding ) {

			//store the last changed value index for reference when handles overlap
			this._lastChangedValue = index;
			this._trigger( "change", event, this._uiHash( index ) );
		}
	},

	value: function( newValue ) {
		if ( arguments.length ) {
			this.options.value = this._trimAlignValue( newValue );
			this._refreshValue();
			this._change( null, 0 );
			return;
		}

		return this._value();
	},

	values: function( index, newValue ) {
		var vals,
			newValues,
			i;

		if ( arguments.length > 1 ) {
			this.options.values[ index ] = this._trimAlignValue( newValue );
			this._refreshValue();
			this._change( null, index );
			return;
		}

		if ( arguments.length ) {
			if ( $.isArray( arguments[ 0 ] ) ) {
				vals = this.options.values;
				newValues = arguments[ 0 ];
				for ( i = 0; i < vals.length; i += 1 ) {
					vals[ i ] = this._trimAlignValue( newValues[ i ] );
					this._change( null, i );
				}
				this._refreshValue();
			} else {
				if ( this._hasMultipleValues() ) {
					return this._values( index );
				} else {
					return this.value();
				}
			}
		} else {
			return this._values();
		}
	},

	_setOption: function( key, value ) {
		var i,
			valsLength = 0;

		if ( key === "range" && this.options.range === true ) {
			if ( value === "min" ) {
				this.options.value = this._values( 0 );
				this.options.values = null;
			} else if ( value === "max" ) {
				this.options.value = this._values( this.options.values.length - 1 );
				this.options.values = null;
			}
		}

		if ( $.isArray( this.options.values ) ) {
			valsLength = this.options.values.length;
		}

		this._super( key, value );

		switch ( key ) {
			case "orientation":
				this._detectOrientation();
				this._removeClass( "ui-slider-horizontal ui-slider-vertical" )
					._addClass( "ui-slider-" + this.orientation );
				this._refreshValue();
				if ( this.options.range ) {
					this._refreshRange( value );
				}

				// Reset positioning from previous orientation
				this.handles.css( value === "horizontal" ? "bottom" : "left", "" );
				break;
			case "value":
				this._animateOff = true;
				this._refreshValue();
				this._change( null, 0 );
				this._animateOff = false;
				break;
			case "values":
				this._animateOff = true;
				this._refreshValue();

				// Start from the last handle to prevent unreachable handles (#9046)
				for ( i = valsLength - 1; i >= 0; i-- ) {
					this._change( null, i );
				}
				this._animateOff = false;
				break;
			case "step":
			case "min":
			case "max":
				this._animateOff = true;
				this._calculateNewMax();
				this._refreshValue();
				this._animateOff = false;
				break;
			case "range":
				this._animateOff = true;
				this._refresh();
				this._animateOff = false;
				break;
		}
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	//internal value getter
	// _value() returns value trimmed by min and max, aligned by step
	_value: function() {
		var val = this.options.value;
		val = this._trimAlignValue( val );

		return val;
	},

	//internal values getter
	// _values() returns array of values trimmed by min and max, aligned by step
	// _values( index ) returns single value trimmed by min and max, aligned by step
	_values: function( index ) {
		var val,
			vals,
			i;

		if ( arguments.length ) {
			val = this.options.values[ index ];
			val = this._trimAlignValue( val );

			return val;
		} else if ( this._hasMultipleValues() ) {

			// .slice() creates a copy of the array
			// this copy gets trimmed by min and max and then returned
			vals = this.options.values.slice();
			for ( i = 0; i < vals.length; i += 1 ) {
				vals[ i ] = this._trimAlignValue( vals[ i ] );
			}

			return vals;
		} else {
			return [];
		}
	},

	// Returns the step-aligned value that val is closest to, between (inclusive) min and max
	_trimAlignValue: function( val ) {
		if ( val <= this._valueMin() ) {
			return this._valueMin();
		}
		if ( val >= this._valueMax() ) {
			return this._valueMax();
		}
		var step = ( this.options.step > 0 ) ? this.options.step : 1,
			valModStep = ( val - this._valueMin() ) % step,
			alignValue = val - valModStep;

		if ( Math.abs( valModStep ) * 2 >= step ) {
			alignValue += ( valModStep > 0 ) ? step : ( -step );
		}

		// Since JavaScript has problems with large floats, round
		// the final value to 5 digits after the decimal point (see #4124)
		return parseFloat( alignValue.toFixed( 5 ) );
	},

	_calculateNewMax: function() {
		var max = this.options.max,
			min = this._valueMin(),
			step = this.options.step,
			aboveMin = Math.round( ( max - min ) / step ) * step;
		max = aboveMin + min;
		if ( max > this.options.max ) {

			//If max is not divisible by step, rounding off may increase its value
			max -= step;
		}
		this.max = parseFloat( max.toFixed( this._precision() ) );
	},

	_precision: function() {
		var precision = this._precisionOf( this.options.step );
		if ( this.options.min !== null ) {
			precision = Math.max( precision, this._precisionOf( this.options.min ) );
		}
		return precision;
	},

	_precisionOf: function( num ) {
		var str = num.toString(),
			decimal = str.indexOf( "." );
		return decimal === -1 ? 0 : str.length - decimal - 1;
	},

	_valueMin: function() {
		return this.options.min;
	},

	_valueMax: function() {
		return this.max;
	},

	_refreshRange: function( orientation ) {
		if ( orientation === "vertical" ) {
			this.range.css( { "width": "", "left": "" } );
		}
		if ( orientation === "horizontal" ) {
			this.range.css( { "height": "", "bottom": "" } );
		}
	},

	_refreshValue: function() {
		var lastValPercent, valPercent, value, valueMin, valueMax,
			oRange = this.options.range,
			o = this.options,
			that = this,
			animate = ( !this._animateOff ) ? o.animate : false,
			_set = {};

		if ( this._hasMultipleValues() ) {
			this.handles.each( function( i ) {
				valPercent = ( that.values( i ) - that._valueMin() ) / ( that._valueMax() -
					that._valueMin() ) * 100;
				_set[ that.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
				$( this ).stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
				if ( that.options.range === true ) {
					if ( that.orientation === "horizontal" ) {
						if ( i === 0 ) {
							that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
								left: valPercent + "%"
							}, o.animate );
						}
						if ( i === 1 ) {
							that.range[ animate ? "animate" : "css" ]( {
								width: ( valPercent - lastValPercent ) + "%"
							}, {
								queue: false,
								duration: o.animate
							} );
						}
					} else {
						if ( i === 0 ) {
							that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
								bottom: ( valPercent ) + "%"
							}, o.animate );
						}
						if ( i === 1 ) {
							that.range[ animate ? "animate" : "css" ]( {
								height: ( valPercent - lastValPercent ) + "%"
							}, {
								queue: false,
								duration: o.animate
							} );
						}
					}
				}
				lastValPercent = valPercent;
			} );
		} else {
			value = this.value();
			valueMin = this._valueMin();
			valueMax = this._valueMax();
			valPercent = ( valueMax !== valueMin ) ?
					( value - valueMin ) / ( valueMax - valueMin ) * 100 :
					0;
			_set[ this.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
			this.handle.stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );

			if ( oRange === "min" && this.orientation === "horizontal" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					width: valPercent + "%"
				}, o.animate );
			}
			if ( oRange === "max" && this.orientation === "horizontal" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					width: ( 100 - valPercent ) + "%"
				}, o.animate );
			}
			if ( oRange === "min" && this.orientation === "vertical" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					height: valPercent + "%"
				}, o.animate );
			}
			if ( oRange === "max" && this.orientation === "vertical" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( {
					height: ( 100 - valPercent ) + "%"
				}, o.animate );
			}
		}
	},

	_handleEvents: {
		keydown: function( event ) {
			var allowed, curVal, newVal, step,
				index = $( event.target ).data( "ui-slider-handle-index" );

			switch ( event.keyCode ) {
				case $.ui.keyCode.HOME:
				case $.ui.keyCode.END:
				case $.ui.keyCode.PAGE_UP:
				case $.ui.keyCode.PAGE_DOWN:
				case $.ui.keyCode.UP:
				case $.ui.keyCode.RIGHT:
				case $.ui.keyCode.DOWN:
				case $.ui.keyCode.LEFT:
					event.preventDefault();
					if ( !this._keySliding ) {
						this._keySliding = true;
						this._addClass( $( event.target ), null, "ui-state-active" );
						allowed = this._start( event, index );
						if ( allowed === false ) {
							return;
						}
					}
					break;
			}

			step = this.options.step;
			if ( this._hasMultipleValues() ) {
				curVal = newVal = this.values( index );
			} else {
				curVal = newVal = this.value();
			}

			switch ( event.keyCode ) {
				case $.ui.keyCode.HOME:
					newVal = this._valueMin();
					break;
				case $.ui.keyCode.END:
					newVal = this._valueMax();
					break;
				case $.ui.keyCode.PAGE_UP:
					newVal = this._trimAlignValue(
						curVal + ( ( this._valueMax() - this._valueMin() ) / this.numPages )
					);
					break;
				case $.ui.keyCode.PAGE_DOWN:
					newVal = this._trimAlignValue(
						curVal - ( ( this._valueMax() - this._valueMin() ) / this.numPages ) );
					break;
				case $.ui.keyCode.UP:
				case $.ui.keyCode.RIGHT:
					if ( curVal === this._valueMax() ) {
						return;
					}
					newVal = this._trimAlignValue( curVal + step );
					break;
				case $.ui.keyCode.DOWN:
				case $.ui.keyCode.LEFT:
					if ( curVal === this._valueMin() ) {
						return;
					}
					newVal = this._trimAlignValue( curVal - step );
					break;
			}

			this._slide( event, index, newVal );
		},
		keyup: function( event ) {
			var index = $( event.target ).data( "ui-slider-handle-index" );

			if ( this._keySliding ) {
				this._keySliding = false;
				this._stop( event, index );
				this._change( event, index );
				this._removeClass( $( event.target ), null, "ui-state-active" );
			}
		}
	}
} );


/*!
 * jQuery UI Sortable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Sortable
//>>group: Interactions
//>>description: Enables items in a list to be sorted using the mouse.
//>>docs: http://api.jqueryui.com/sortable/
//>>demos: http://jqueryui.com/sortable/
//>>css.structure: ../../themes/base/sortable.css



var widgetsSortable = $.widget( "ui.sortable", $.ui.mouse, {
	version: "1.12.1",
	widgetEventPrefix: "sort",
	ready: false,
	options: {
		appendTo: "parent",
		axis: false,
		connectWith: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		dropOnEmpty: true,
		forcePlaceholderSize: false,
		forceHelperSize: false,
		grid: false,
		handle: false,
		helper: "original",
		items: "> *",
		opacity: false,
		placeholder: false,
		revert: false,
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		scope: "default",
		tolerance: "intersect",
		zIndex: 1000,

		// Callbacks
		activate: null,
		beforeStop: null,
		change: null,
		deactivate: null,
		out: null,
		over: null,
		receive: null,
		remove: null,
		sort: null,
		start: null,
		stop: null,
		update: null
	},

	_isOverAxis: function( x, reference, size ) {
		return ( x >= reference ) && ( x < ( reference + size ) );
	},

	_isFloating: function( item ) {
		return ( /left|right/ ).test( item.css( "float" ) ) ||
			( /inline|table-cell/ ).test( item.css( "display" ) );
	},

	_create: function() {
		this.containerCache = {};
		this._addClass( "ui-sortable" );

		//Get the items
		this.refresh();

		//Let's determine the parent's offset
		this.offset = this.element.offset();

		//Initialize mouse events for interaction
		this._mouseInit();

		this._setHandleClassName();

		//We're ready to go
		this.ready = true;

	},

	_setOption: function( key, value ) {
		this._super( key, value );

		if ( key === "handle" ) {
			this._setHandleClassName();
		}
	},

	_setHandleClassName: function() {
		var that = this;
		this._removeClass( this.element.find( ".ui-sortable-handle" ), "ui-sortable-handle" );
		$.each( this.items, function() {
			that._addClass(
				this.instance.options.handle ?
					this.item.find( this.instance.options.handle ) :
					this.item,
				"ui-sortable-handle"
			);
		} );
	},

	_destroy: function() {
		this._mouseDestroy();

		for ( var i = this.items.length - 1; i >= 0; i-- ) {
			this.items[ i ].item.removeData( this.widgetName + "-item" );
		}

		return this;
	},

	_mouseCapture: function( event, overrideHandle ) {
		var currentItem = null,
			validHandle = false,
			that = this;

		if ( this.reverting ) {
			return false;
		}

		if ( this.options.disabled || this.options.type === "static" ) {
			return false;
		}

		//We have to refresh the items data once first
		this._refreshItems( event );

		//Find out if the clicked node (or one of its parents) is a actual item in this.items
		$( event.target ).parents().each( function() {
			if ( $.data( this, that.widgetName + "-item" ) === that ) {
				currentItem = $( this );
				return false;
			}
		} );
		if ( $.data( event.target, that.widgetName + "-item" ) === that ) {
			currentItem = $( event.target );
		}

		if ( !currentItem ) {
			return false;
		}
		if ( this.options.handle && !overrideHandle ) {
			$( this.options.handle, currentItem ).find( "*" ).addBack().each( function() {
				if ( this === event.target ) {
					validHandle = true;
				}
			} );
			if ( !validHandle ) {
				return false;
			}
		}

		this.currentItem = currentItem;
		this._removeCurrentsFromItems();
		return true;

	},

	_mouseStart: function( event, overrideHandle, noActivation ) {

		var i, body,
			o = this.options;

		this.currentContainer = this;

		//We only need to call refreshPositions, because the refreshItems call has been moved to
		// mouseCapture
		this.refreshPositions();

		//Create and append the visible helper
		this.helper = this._createHelper( event );

		//Cache the helper size
		this._cacheHelperProportions();

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Get the next scrolling parent
		this.scrollParent = this.helper.scrollParent();

		//The element's absolute position on the page minus margins
		this.offset = this.currentItem.offset();
		this.offset = {
			top: this.offset.top - this.margins.top,
			left: this.offset.left - this.margins.left
		};

		$.extend( this.offset, {
			click: { //Where the click happened, relative to the element
				left: event.pageX - this.offset.left,
				top: event.pageY - this.offset.top
			},
			parent: this._getParentOffset(),

			// This is a relative to absolute position minus the actual position calculation -
			// only used for relative positioned helper
			relative: this._getRelativeOffset()
		} );

		// Only after we got the offset, we can change the helper's position to absolute
		// TODO: Still need to figure out a way to make relative sorting possible
		this.helper.css( "position", "absolute" );
		this.cssPosition = this.helper.css( "position" );

		//Generate the original position
		this.originalPosition = this._generatePosition( event );
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		( o.cursorAt && this._adjustOffsetFromHelper( o.cursorAt ) );

		//Cache the former DOM position
		this.domPosition = {
			prev: this.currentItem.prev()[ 0 ],
			parent: this.currentItem.parent()[ 0 ]
		};

		// If the helper is not the original, hide the original so it's not playing any role during
		// the drag, won't cause anything bad this way
		if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
			this.currentItem.hide();
		}

		//Create the placeholder
		this._createPlaceholder();

		//Set a containment if given in the options
		if ( o.containment ) {
			this._setContainment();
		}

		if ( o.cursor && o.cursor !== "auto" ) { // cursor option
			body = this.document.find( "body" );

			// Support: IE
			this.storedCursor = body.css( "cursor" );
			body.css( "cursor", o.cursor );

			this.storedStylesheet =
				$( "<style>*{ cursor: " + o.cursor + " !important; }</style>" ).appendTo( body );
		}

		if ( o.opacity ) { // opacity option
			if ( this.helper.css( "opacity" ) ) {
				this._storedOpacity = this.helper.css( "opacity" );
			}
			this.helper.css( "opacity", o.opacity );
		}

		if ( o.zIndex ) { // zIndex option
			if ( this.helper.css( "zIndex" ) ) {
				this._storedZIndex = this.helper.css( "zIndex" );
			}
			this.helper.css( "zIndex", o.zIndex );
		}

		//Prepare scrolling
		if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				this.scrollParent[ 0 ].tagName !== "HTML" ) {
			this.overflowOffset = this.scrollParent.offset();
		}

		//Call callbacks
		this._trigger( "start", event, this._uiHash() );

		//Recache the helper size
		if ( !this._preserveHelperProportions ) {
			this._cacheHelperProportions();
		}

		//Post "activate" events to possible containers
		if ( !noActivation ) {
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				this.containers[ i ]._trigger( "activate", event, this._uiHash( this ) );
			}
		}

		//Prepare possible droppables
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.current = this;
		}

		if ( $.ui.ddmanager && !o.dropBehaviour ) {
			$.ui.ddmanager.prepareOffsets( this, event );
		}

		this.dragging = true;

		this._addClass( this.helper, "ui-sortable-helper" );

		// Execute the drag once - this causes the helper not to be visiblebefore getting its
		// correct position
		this._mouseDrag( event );
		return true;

	},

	_mouseDrag: function( event ) {
		var i, item, itemElement, intersection,
			o = this.options,
			scrolled = false;

		//Compute the helpers position
		this.position = this._generatePosition( event );
		this.positionAbs = this._convertPositionTo( "absolute" );

		if ( !this.lastPositionAbs ) {
			this.lastPositionAbs = this.positionAbs;
		}

		//Do scrolling
		if ( this.options.scroll ) {
			if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					this.scrollParent[ 0 ].tagName !== "HTML" ) {

				if ( ( this.overflowOffset.top + this.scrollParent[ 0 ].offsetHeight ) -
						event.pageY < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollTop =
						scrolled = this.scrollParent[ 0 ].scrollTop + o.scrollSpeed;
				} else if ( event.pageY - this.overflowOffset.top < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollTop =
						scrolled = this.scrollParent[ 0 ].scrollTop - o.scrollSpeed;
				}

				if ( ( this.overflowOffset.left + this.scrollParent[ 0 ].offsetWidth ) -
						event.pageX < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollLeft = scrolled =
						this.scrollParent[ 0 ].scrollLeft + o.scrollSpeed;
				} else if ( event.pageX - this.overflowOffset.left < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollLeft = scrolled =
						this.scrollParent[ 0 ].scrollLeft - o.scrollSpeed;
				}

			} else {

				if ( event.pageY - this.document.scrollTop() < o.scrollSensitivity ) {
					scrolled = this.document.scrollTop( this.document.scrollTop() - o.scrollSpeed );
				} else if ( this.window.height() - ( event.pageY - this.document.scrollTop() ) <
						o.scrollSensitivity ) {
					scrolled = this.document.scrollTop( this.document.scrollTop() + o.scrollSpeed );
				}

				if ( event.pageX - this.document.scrollLeft() < o.scrollSensitivity ) {
					scrolled = this.document.scrollLeft(
						this.document.scrollLeft() - o.scrollSpeed
					);
				} else if ( this.window.width() - ( event.pageX - this.document.scrollLeft() ) <
						o.scrollSensitivity ) {
					scrolled = this.document.scrollLeft(
						this.document.scrollLeft() + o.scrollSpeed
					);
				}

			}

			if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
				$.ui.ddmanager.prepareOffsets( this, event );
			}
		}

		//Regenerate the absolute position used for position checks
		this.positionAbs = this._convertPositionTo( "absolute" );

		//Set the helper position
		if ( !this.options.axis || this.options.axis !== "y" ) {
			this.helper[ 0 ].style.left = this.position.left + "px";
		}
		if ( !this.options.axis || this.options.axis !== "x" ) {
			this.helper[ 0 ].style.top = this.position.top + "px";
		}

		//Rearrange
		for ( i = this.items.length - 1; i >= 0; i-- ) {

			//Cache variables and intersection, continue if no intersection
			item = this.items[ i ];
			itemElement = item.item[ 0 ];
			intersection = this._intersectsWithPointer( item );
			if ( !intersection ) {
				continue;
			}

			// Only put the placeholder inside the current Container, skip all
			// items from other containers. This works because when moving
			// an item from one container to another the
			// currentContainer is switched before the placeholder is moved.
			//
			// Without this, moving items in "sub-sortables" can cause
			// the placeholder to jitter between the outer and inner container.
			if ( item.instance !== this.currentContainer ) {
				continue;
			}

			// Cannot intersect with itself
			// no useless actions that have been done before
			// no action if the item moved is the parent of the item checked
			if ( itemElement !== this.currentItem[ 0 ] &&
				this.placeholder[ intersection === 1 ? "next" : "prev" ]()[ 0 ] !== itemElement &&
				!$.contains( this.placeholder[ 0 ], itemElement ) &&
				( this.options.type === "semi-dynamic" ?
					!$.contains( this.element[ 0 ], itemElement ) :
					true
				)
			) {

				this.direction = intersection === 1 ? "down" : "up";

				if ( this.options.tolerance === "pointer" || this._intersectsWithSides( item ) ) {
					this._rearrange( event, item );
				} else {
					break;
				}

				this._trigger( "change", event, this._uiHash() );
				break;
			}
		}

		//Post events to containers
		this._contactContainers( event );

		//Interconnect with droppables
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.drag( this, event );
		}

		//Call callbacks
		this._trigger( "sort", event, this._uiHash() );

		this.lastPositionAbs = this.positionAbs;
		return false;

	},

	_mouseStop: function( event, noPropagation ) {

		if ( !event ) {
			return;
		}

		//If we are using droppables, inform the manager about the drop
		if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
			$.ui.ddmanager.drop( this, event );
		}

		if ( this.options.revert ) {
			var that = this,
				cur = this.placeholder.offset(),
				axis = this.options.axis,
				animation = {};

			if ( !axis || axis === "x" ) {
				animation.left = cur.left - this.offset.parent.left - this.margins.left +
					( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
						0 :
						this.offsetParent[ 0 ].scrollLeft
					);
			}
			if ( !axis || axis === "y" ) {
				animation.top = cur.top - this.offset.parent.top - this.margins.top +
					( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
						0 :
						this.offsetParent[ 0 ].scrollTop
					);
			}
			this.reverting = true;
			$( this.helper ).animate(
				animation,
				parseInt( this.options.revert, 10 ) || 500,
				function() {
					that._clear( event );
				}
			);
		} else {
			this._clear( event, noPropagation );
		}

		return false;

	},

	cancel: function() {

		if ( this.dragging ) {

			this._mouseUp( new $.Event( "mouseup", { target: null } ) );

			if ( this.options.helper === "original" ) {
				this.currentItem.css( this._storedCSS );
				this._removeClass( this.currentItem, "ui-sortable-helper" );
			} else {
				this.currentItem.show();
			}

			//Post deactivating events to containers
			for ( var i = this.containers.length - 1; i >= 0; i-- ) {
				this.containers[ i ]._trigger( "deactivate", null, this._uiHash( this ) );
				if ( this.containers[ i ].containerCache.over ) {
					this.containers[ i ]._trigger( "out", null, this._uiHash( this ) );
					this.containers[ i ].containerCache.over = 0;
				}
			}

		}

		if ( this.placeholder ) {

			//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
			// it unbinds ALL events from the original node!
			if ( this.placeholder[ 0 ].parentNode ) {
				this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );
			}
			if ( this.options.helper !== "original" && this.helper &&
					this.helper[ 0 ].parentNode ) {
				this.helper.remove();
			}

			$.extend( this, {
				helper: null,
				dragging: false,
				reverting: false,
				_noFinalSort: null
			} );

			if ( this.domPosition.prev ) {
				$( this.domPosition.prev ).after( this.currentItem );
			} else {
				$( this.domPosition.parent ).prepend( this.currentItem );
			}
		}

		return this;

	},

	serialize: function( o ) {

		var items = this._getItemsAsjQuery( o && o.connected ),
			str = [];
		o = o || {};

		$( items ).each( function() {
			var res = ( $( o.item || this ).attr( o.attribute || "id" ) || "" )
				.match( o.expression || ( /(.+)[\-=_](.+)/ ) );
			if ( res ) {
				str.push(
					( o.key || res[ 1 ] + "[]" ) +
					"=" + ( o.key && o.expression ? res[ 1 ] : res[ 2 ] ) );
			}
		} );

		if ( !str.length && o.key ) {
			str.push( o.key + "=" );
		}

		return str.join( "&" );

	},

	toArray: function( o ) {

		var items = this._getItemsAsjQuery( o && o.connected ),
			ret = [];

		o = o || {};

		items.each( function() {
			ret.push( $( o.item || this ).attr( o.attribute || "id" ) || "" );
		} );
		return ret;

	},

	/* Be careful with the following core functions */
	_intersectsWith: function( item ) {

		var x1 = this.positionAbs.left,
			x2 = x1 + this.helperProportions.width,
			y1 = this.positionAbs.top,
			y2 = y1 + this.helperProportions.height,
			l = item.left,
			r = l + item.width,
			t = item.top,
			b = t + item.height,
			dyClick = this.offset.click.top,
			dxClick = this.offset.click.left,
			isOverElementHeight = ( this.options.axis === "x" ) || ( ( y1 + dyClick ) > t &&
				( y1 + dyClick ) < b ),
			isOverElementWidth = ( this.options.axis === "y" ) || ( ( x1 + dxClick ) > l &&
				( x1 + dxClick ) < r ),
			isOverElement = isOverElementHeight && isOverElementWidth;

		if ( this.options.tolerance === "pointer" ||
			this.options.forcePointerForContainers ||
			( this.options.tolerance !== "pointer" &&
				this.helperProportions[ this.floating ? "width" : "height" ] >
				item[ this.floating ? "width" : "height" ] )
		) {
			return isOverElement;
		} else {

			return ( l < x1 + ( this.helperProportions.width / 2 ) && // Right Half
				x2 - ( this.helperProportions.width / 2 ) < r && // Left Half
				t < y1 + ( this.helperProportions.height / 2 ) && // Bottom Half
				y2 - ( this.helperProportions.height / 2 ) < b ); // Top Half

		}
	},

	_intersectsWithPointer: function( item ) {
		var verticalDirection, horizontalDirection,
			isOverElementHeight = ( this.options.axis === "x" ) ||
				this._isOverAxis(
					this.positionAbs.top + this.offset.click.top, item.top, item.height ),
			isOverElementWidth = ( this.options.axis === "y" ) ||
				this._isOverAxis(
					this.positionAbs.left + this.offset.click.left, item.left, item.width ),
			isOverElement = isOverElementHeight && isOverElementWidth;

		if ( !isOverElement ) {
			return false;
		}

		verticalDirection = this._getDragVerticalDirection();
		horizontalDirection = this._getDragHorizontalDirection();

		return this.floating ?
			( ( horizontalDirection === "right" || verticalDirection === "down" ) ? 2 : 1 )
			: ( verticalDirection && ( verticalDirection === "down" ? 2 : 1 ) );

	},

	_intersectsWithSides: function( item ) {

		var isOverBottomHalf = this._isOverAxis( this.positionAbs.top +
				this.offset.click.top, item.top + ( item.height / 2 ), item.height ),
			isOverRightHalf = this._isOverAxis( this.positionAbs.left +
				this.offset.click.left, item.left + ( item.width / 2 ), item.width ),
			verticalDirection = this._getDragVerticalDirection(),
			horizontalDirection = this._getDragHorizontalDirection();

		if ( this.floating && horizontalDirection ) {
			return ( ( horizontalDirection === "right" && isOverRightHalf ) ||
				( horizontalDirection === "left" && !isOverRightHalf ) );
		} else {
			return verticalDirection && ( ( verticalDirection === "down" && isOverBottomHalf ) ||
				( verticalDirection === "up" && !isOverBottomHalf ) );
		}

	},

	_getDragVerticalDirection: function() {
		var delta = this.positionAbs.top - this.lastPositionAbs.top;
		return delta !== 0 && ( delta > 0 ? "down" : "up" );
	},

	_getDragHorizontalDirection: function() {
		var delta = this.positionAbs.left - this.lastPositionAbs.left;
		return delta !== 0 && ( delta > 0 ? "right" : "left" );
	},

	refresh: function( event ) {
		this._refreshItems( event );
		this._setHandleClassName();
		this.refreshPositions();
		return this;
	},

	_connectWith: function() {
		var options = this.options;
		return options.connectWith.constructor === String ?
			[ options.connectWith ] :
			options.connectWith;
	},

	_getItemsAsjQuery: function( connected ) {

		var i, j, cur, inst,
			items = [],
			queries = [],
			connectWith = this._connectWith();

		if ( connectWith && connected ) {
			for ( i = connectWith.length - 1; i >= 0; i-- ) {
				cur = $( connectWith[ i ], this.document[ 0 ] );
				for ( j = cur.length - 1; j >= 0; j-- ) {
					inst = $.data( cur[ j ], this.widgetFullName );
					if ( inst && inst !== this && !inst.options.disabled ) {
						queries.push( [ $.isFunction( inst.options.items ) ?
							inst.options.items.call( inst.element ) :
							$( inst.options.items, inst.element )
								.not( ".ui-sortable-helper" )
								.not( ".ui-sortable-placeholder" ), inst ] );
					}
				}
			}
		}

		queries.push( [ $.isFunction( this.options.items ) ?
			this.options.items
				.call( this.element, null, { options: this.options, item: this.currentItem } ) :
			$( this.options.items, this.element )
				.not( ".ui-sortable-helper" )
				.not( ".ui-sortable-placeholder" ), this ] );

		function addItems() {
			items.push( this );
		}
		for ( i = queries.length - 1; i >= 0; i-- ) {
			queries[ i ][ 0 ].each( addItems );
		}

		return $( items );

	},

	_removeCurrentsFromItems: function() {

		var list = this.currentItem.find( ":data(" + this.widgetName + "-item)" );

		this.items = $.grep( this.items, function( item ) {
			for ( var j = 0; j < list.length; j++ ) {
				if ( list[ j ] === item.item[ 0 ] ) {
					return false;
				}
			}
			return true;
		} );

	},

	_refreshItems: function( event ) {

		this.items = [];
		this.containers = [ this ];

		var i, j, cur, inst, targetData, _queries, item, queriesLength,
			items = this.items,
			queries = [ [ $.isFunction( this.options.items ) ?
				this.options.items.call( this.element[ 0 ], event, { item: this.currentItem } ) :
				$( this.options.items, this.element ), this ] ],
			connectWith = this._connectWith();

		//Shouldn't be run the first time through due to massive slow-down
		if ( connectWith && this.ready ) {
			for ( i = connectWith.length - 1; i >= 0; i-- ) {
				cur = $( connectWith[ i ], this.document[ 0 ] );
				for ( j = cur.length - 1; j >= 0; j-- ) {
					inst = $.data( cur[ j ], this.widgetFullName );
					if ( inst && inst !== this && !inst.options.disabled ) {
						queries.push( [ $.isFunction( inst.options.items ) ?
							inst.options.items
								.call( inst.element[ 0 ], event, { item: this.currentItem } ) :
							$( inst.options.items, inst.element ), inst ] );
						this.containers.push( inst );
					}
				}
			}
		}

		for ( i = queries.length - 1; i >= 0; i-- ) {
			targetData = queries[ i ][ 1 ];
			_queries = queries[ i ][ 0 ];

			for ( j = 0, queriesLength = _queries.length; j < queriesLength; j++ ) {
				item = $( _queries[ j ] );

				// Data for target checking (mouse manager)
				item.data( this.widgetName + "-item", targetData );

				items.push( {
					item: item,
					instance: targetData,
					width: 0, height: 0,
					left: 0, top: 0
				} );
			}
		}

	},

	refreshPositions: function( fast ) {

		// Determine whether items are being displayed horizontally
		this.floating = this.items.length ?
			this.options.axis === "x" || this._isFloating( this.items[ 0 ].item ) :
			false;

		//This has to be redone because due to the item being moved out/into the offsetParent,
		// the offsetParent's position will change
		if ( this.offsetParent && this.helper ) {
			this.offset.parent = this._getParentOffset();
		}

		var i, item, t, p;

		for ( i = this.items.length - 1; i >= 0; i-- ) {
			item = this.items[ i ];

			//We ignore calculating positions of all connected containers when we're not over them
			if ( item.instance !== this.currentContainer && this.currentContainer &&
					item.item[ 0 ] !== this.currentItem[ 0 ] ) {
				continue;
			}

			t = this.options.toleranceElement ?
				$( this.options.toleranceElement, item.item ) :
				item.item;

			if ( !fast ) {
				item.width = t.outerWidth();
				item.height = t.outerHeight();
			}

			p = t.offset();
			item.left = p.left;
			item.top = p.top;
		}

		if ( this.options.custom && this.options.custom.refreshContainers ) {
			this.options.custom.refreshContainers.call( this );
		} else {
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				p = this.containers[ i ].element.offset();
				this.containers[ i ].containerCache.left = p.left;
				this.containers[ i ].containerCache.top = p.top;
				this.containers[ i ].containerCache.width =
					this.containers[ i ].element.outerWidth();
				this.containers[ i ].containerCache.height =
					this.containers[ i ].element.outerHeight();
			}
		}

		return this;
	},

	_createPlaceholder: function( that ) {
		that = that || this;
		var className,
			o = that.options;

		if ( !o.placeholder || o.placeholder.constructor === String ) {
			className = o.placeholder;
			o.placeholder = {
				element: function() {

					var nodeName = that.currentItem[ 0 ].nodeName.toLowerCase(),
						element = $( "<" + nodeName + ">", that.document[ 0 ] );

						that._addClass( element, "ui-sortable-placeholder",
								className || that.currentItem[ 0 ].className )
							._removeClass( element, "ui-sortable-helper" );

					if ( nodeName === "tbody" ) {
						that._createTrPlaceholder(
							that.currentItem.find( "tr" ).eq( 0 ),
							$( "<tr>", that.document[ 0 ] ).appendTo( element )
						);
					} else if ( nodeName === "tr" ) {
						that._createTrPlaceholder( that.currentItem, element );
					} else if ( nodeName === "img" ) {
						element.attr( "src", that.currentItem.attr( "src" ) );
					}

					if ( !className ) {
						element.css( "visibility", "hidden" );
					}

					return element;
				},
				update: function( container, p ) {

					// 1. If a className is set as 'placeholder option, we don't force sizes -
					// the class is responsible for that
					// 2. The option 'forcePlaceholderSize can be enabled to force it even if a
					// class name is specified
					if ( className && !o.forcePlaceholderSize ) {
						return;
					}

					//If the element doesn't have a actual height by itself (without styles coming
					// from a stylesheet), it receives the inline height from the dragged item
					if ( !p.height() ) {
						p.height(
							that.currentItem.innerHeight() -
							parseInt( that.currentItem.css( "paddingTop" ) || 0, 10 ) -
							parseInt( that.currentItem.css( "paddingBottom" ) || 0, 10 ) );
					}
					if ( !p.width() ) {
						p.width(
							that.currentItem.innerWidth() -
							parseInt( that.currentItem.css( "paddingLeft" ) || 0, 10 ) -
							parseInt( that.currentItem.css( "paddingRight" ) || 0, 10 ) );
					}
				}
			};
		}

		//Create the placeholder
		that.placeholder = $( o.placeholder.element.call( that.element, that.currentItem ) );

		//Append it after the actual current item
		that.currentItem.after( that.placeholder );

		//Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
		o.placeholder.update( that, that.placeholder );

	},

	_createTrPlaceholder: function( sourceTr, targetTr ) {
		var that = this;

		sourceTr.children().each( function() {
			$( "<td>&#160;</td>", that.document[ 0 ] )
				.attr( "colspan", $( this ).attr( "colspan" ) || 1 )
				.appendTo( targetTr );
		} );
	},

	_contactContainers: function( event ) {
		var i, j, dist, itemWithLeastDistance, posProperty, sizeProperty, cur, nearBottom,
			floating, axis,
			innermostContainer = null,
			innermostIndex = null;

		// Get innermost container that intersects with item
		for ( i = this.containers.length - 1; i >= 0; i-- ) {

			// Never consider a container that's located within the item itself
			if ( $.contains( this.currentItem[ 0 ], this.containers[ i ].element[ 0 ] ) ) {
				continue;
			}

			if ( this._intersectsWith( this.containers[ i ].containerCache ) ) {

				// If we've already found a container and it's more "inner" than this, then continue
				if ( innermostContainer &&
						$.contains(
							this.containers[ i ].element[ 0 ],
							innermostContainer.element[ 0 ] ) ) {
					continue;
				}

				innermostContainer = this.containers[ i ];
				innermostIndex = i;

			} else {

				// container doesn't intersect. trigger "out" event if necessary
				if ( this.containers[ i ].containerCache.over ) {
					this.containers[ i ]._trigger( "out", event, this._uiHash( this ) );
					this.containers[ i ].containerCache.over = 0;
				}
			}

		}

		// If no intersecting containers found, return
		if ( !innermostContainer ) {
			return;
		}

		// Move the item into the container if it's not there already
		if ( this.containers.length === 1 ) {
			if ( !this.containers[ innermostIndex ].containerCache.over ) {
				this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
				this.containers[ innermostIndex ].containerCache.over = 1;
			}
		} else {

			// When entering a new container, we will find the item with the least distance and
			// append our item near it
			dist = 10000;
			itemWithLeastDistance = null;
			floating = innermostContainer.floating || this._isFloating( this.currentItem );
			posProperty = floating ? "left" : "top";
			sizeProperty = floating ? "width" : "height";
			axis = floating ? "pageX" : "pageY";

			for ( j = this.items.length - 1; j >= 0; j-- ) {
				if ( !$.contains(
						this.containers[ innermostIndex ].element[ 0 ], this.items[ j ].item[ 0 ] )
				) {
					continue;
				}
				if ( this.items[ j ].item[ 0 ] === this.currentItem[ 0 ] ) {
					continue;
				}

				cur = this.items[ j ].item.offset()[ posProperty ];
				nearBottom = false;
				if ( event[ axis ] - cur > this.items[ j ][ sizeProperty ] / 2 ) {
					nearBottom = true;
				}

				if ( Math.abs( event[ axis ] - cur ) < dist ) {
					dist = Math.abs( event[ axis ] - cur );
					itemWithLeastDistance = this.items[ j ];
					this.direction = nearBottom ? "up" : "down";
				}
			}

			//Check if dropOnEmpty is enabled
			if ( !itemWithLeastDistance && !this.options.dropOnEmpty ) {
				return;
			}

			if ( this.currentContainer === this.containers[ innermostIndex ] ) {
				if ( !this.currentContainer.containerCache.over ) {
					this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash() );
					this.currentContainer.containerCache.over = 1;
				}
				return;
			}

			itemWithLeastDistance ?
				this._rearrange( event, itemWithLeastDistance, null, true ) :
				this._rearrange( event, null, this.containers[ innermostIndex ].element, true );
			this._trigger( "change", event, this._uiHash() );
			this.containers[ innermostIndex ]._trigger( "change", event, this._uiHash( this ) );
			this.currentContainer = this.containers[ innermostIndex ];

			//Update the placeholder
			this.options.placeholder.update( this.currentContainer, this.placeholder );

			this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
			this.containers[ innermostIndex ].containerCache.over = 1;
		}

	},

	_createHelper: function( event ) {

		var o = this.options,
			helper = $.isFunction( o.helper ) ?
				$( o.helper.apply( this.element[ 0 ], [ event, this.currentItem ] ) ) :
				( o.helper === "clone" ? this.currentItem.clone() : this.currentItem );

		//Add the helper to the DOM if that didn't happen already
		if ( !helper.parents( "body" ).length ) {
			$( o.appendTo !== "parent" ?
				o.appendTo :
				this.currentItem[ 0 ].parentNode )[ 0 ].appendChild( helper[ 0 ] );
		}

		if ( helper[ 0 ] === this.currentItem[ 0 ] ) {
			this._storedCSS = {
				width: this.currentItem[ 0 ].style.width,
				height: this.currentItem[ 0 ].style.height,
				position: this.currentItem.css( "position" ),
				top: this.currentItem.css( "top" ),
				left: this.currentItem.css( "left" )
			};
		}

		if ( !helper[ 0 ].style.width || o.forceHelperSize ) {
			helper.width( this.currentItem.width() );
		}
		if ( !helper[ 0 ].style.height || o.forceHelperSize ) {
			helper.height( this.currentItem.height() );
		}

		return helper;

	},

	_adjustOffsetFromHelper: function( obj ) {
		if ( typeof obj === "string" ) {
			obj = obj.split( " " );
		}
		if ( $.isArray( obj ) ) {
			obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
		}
		if ( "left" in obj ) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ( "right" in obj ) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ( "top" in obj ) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ( "bottom" in obj ) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_getParentOffset: function() {

		//Get the offsetParent and cache its position
		this.offsetParent = this.helper.offsetParent();
		var po = this.offsetParent.offset();

		// This is a special case where we need to modify a offset calculated on start, since the
		// following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the
		// next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
		// the document, which means that the scroll is included in the initial calculation of the
		// offset of the parent, and never recalculated upon drag
		if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		// This needs to be actually done for all browsers, since pageX/pageY includes this
		// information with an ugly IE fix
		if ( this.offsetParent[ 0 ] === this.document[ 0 ].body ||
				( this.offsetParent[ 0 ].tagName &&
				this.offsetParent[ 0 ].tagName.toLowerCase() === "html" && $.ui.ie ) ) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
			left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
		};

	},

	_getRelativeOffset: function() {

		if ( this.cssPosition === "relative" ) {
			var p = this.currentItem.position();
			return {
				top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
					this.scrollParent.scrollTop(),
				left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
					this.scrollParent.scrollLeft()
			};
		} else {
			return { top: 0, left: 0 };
		}

	},

	_cacheMargins: function() {
		this.margins = {
			left: ( parseInt( this.currentItem.css( "marginLeft" ), 10 ) || 0 ),
			top: ( parseInt( this.currentItem.css( "marginTop" ), 10 ) || 0 )
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var ce, co, over,
			o = this.options;
		if ( o.containment === "parent" ) {
			o.containment = this.helper[ 0 ].parentNode;
		}
		if ( o.containment === "document" || o.containment === "window" ) {
			this.containment = [
				0 - this.offset.relative.left - this.offset.parent.left,
				0 - this.offset.relative.top - this.offset.parent.top,
				o.containment === "document" ?
					this.document.width() :
					this.window.width() - this.helperProportions.width - this.margins.left,
				( o.containment === "document" ?
					( this.document.height() || document.body.parentNode.scrollHeight ) :
					this.window.height() || this.document[ 0 ].body.parentNode.scrollHeight
				) - this.helperProportions.height - this.margins.top
			];
		}

		if ( !( /^(document|window|parent)$/ ).test( o.containment ) ) {
			ce = $( o.containment )[ 0 ];
			co = $( o.containment ).offset();
			over = ( $( ce ).css( "overflow" ) !== "hidden" );

			this.containment = [
				co.left + ( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) +
					( parseInt( $( ce ).css( "paddingLeft" ), 10 ) || 0 ) - this.margins.left,
				co.top + ( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) +
					( parseInt( $( ce ).css( "paddingTop" ), 10 ) || 0 ) - this.margins.top,
				co.left + ( over ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
					( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) -
					( parseInt( $( ce ).css( "paddingRight" ), 10 ) || 0 ) -
					this.helperProportions.width - this.margins.left,
				co.top + ( over ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
					( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) -
					( parseInt( $( ce ).css( "paddingBottom" ), 10 ) || 0 ) -
					this.helperProportions.height - this.margins.top
			];
		}

	},

	_convertPositionTo: function( d, pos ) {

		if ( !pos ) {
			pos = this.position;
		}
		var mod = d === "absolute" ? 1 : -1,
			scroll = this.cssPosition === "absolute" &&
				!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
					this.offsetParent :
					this.scrollParent,
			scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );

		return {
			top: (

				// The absolute mouse position
				pos.top	+

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top * mod -
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollTop() :
					( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod )
			),
			left: (

				// The absolute mouse position
				pos.left +

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left * mod	-
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 :
					scroll.scrollLeft() ) * mod )
			)
		};

	},

	_generatePosition: function( event ) {

		var top, left,
			o = this.options,
			pageX = event.pageX,
			pageY = event.pageY,
			scroll = this.cssPosition === "absolute" &&
				!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
					this.offsetParent :
					this.scrollParent,
				scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );

		// This is another very weird special case that only happens for relative elements:
		// 1. If the css position is relative
		// 2. and the scroll parent is the document or similar to the offset parent
		// we have to refresh the relative offset during the scroll so there are no jumps
		if ( this.cssPosition === "relative" && !( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				this.scrollParent[ 0 ] !== this.offsetParent[ 0 ] ) ) {
			this.offset.relative = this._getRelativeOffset();
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		if ( this.originalPosition ) { //If we are not dragging yet, we won't check for options

			if ( this.containment ) {
				if ( event.pageX - this.offset.click.left < this.containment[ 0 ] ) {
					pageX = this.containment[ 0 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top < this.containment[ 1 ] ) {
					pageY = this.containment[ 1 ] + this.offset.click.top;
				}
				if ( event.pageX - this.offset.click.left > this.containment[ 2 ] ) {
					pageX = this.containment[ 2 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top > this.containment[ 3 ] ) {
					pageY = this.containment[ 3 ] + this.offset.click.top;
				}
			}

			if ( o.grid ) {
				top = this.originalPageY + Math.round( ( pageY - this.originalPageY ) /
					o.grid[ 1 ] ) * o.grid[ 1 ];
				pageY = this.containment ?
					( ( top - this.offset.click.top >= this.containment[ 1 ] &&
						top - this.offset.click.top <= this.containment[ 3 ] ) ?
							top :
							( ( top - this.offset.click.top >= this.containment[ 1 ] ) ?
								top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) :
								top;

				left = this.originalPageX + Math.round( ( pageX - this.originalPageX ) /
					o.grid[ 0 ] ) * o.grid[ 0 ];
				pageX = this.containment ?
					( ( left - this.offset.click.left >= this.containment[ 0 ] &&
						left - this.offset.click.left <= this.containment[ 2 ] ) ?
							left :
							( ( left - this.offset.click.left >= this.containment[ 0 ] ) ?
								left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) :
								left;
			}

		}

		return {
			top: (

				// The absolute mouse position
				pageY -

				// Click offset (relative to the element)
				this.offset.click.top -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top +
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollTop() :
					( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) )
			),
			left: (

				// The absolute mouse position
				pageX -

				// Click offset (relative to the element)
				this.offset.click.left -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left +
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollLeft() :
					scrollIsRootNode ? 0 : scroll.scrollLeft() ) )
			)
		};

	},

	_rearrange: function( event, i, a, hardRefresh ) {

		a ? a[ 0 ].appendChild( this.placeholder[ 0 ] ) :
			i.item[ 0 ].parentNode.insertBefore( this.placeholder[ 0 ],
				( this.direction === "down" ? i.item[ 0 ] : i.item[ 0 ].nextSibling ) );

		//Various things done here to improve the performance:
		// 1. we create a setTimeout, that calls refreshPositions
		// 2. on the instance, we have a counter variable, that get's higher after every append
		// 3. on the local scope, we copy the counter variable, and check in the timeout,
		// if it's still the same
		// 4. this lets only the last addition to the timeout stack through
		this.counter = this.counter ? ++this.counter : 1;
		var counter = this.counter;

		this._delay( function() {
			if ( counter === this.counter ) {

				//Precompute after each DOM insertion, NOT on mousemove
				this.refreshPositions( !hardRefresh );
			}
		} );

	},

	_clear: function( event, noPropagation ) {

		this.reverting = false;

		// We delay all events that have to be triggered to after the point where the placeholder
		// has been removed and everything else normalized again
		var i,
			delayedTriggers = [];

		// We first have to update the dom position of the actual currentItem
		// Note: don't do it if the current item is already removed (by a user), or it gets
		// reappended (see #4088)
		if ( !this._noFinalSort && this.currentItem.parent().length ) {
			this.placeholder.before( this.currentItem );
		}
		this._noFinalSort = null;

		if ( this.helper[ 0 ] === this.currentItem[ 0 ] ) {
			for ( i in this._storedCSS ) {
				if ( this._storedCSS[ i ] === "auto" || this._storedCSS[ i ] === "static" ) {
					this._storedCSS[ i ] = "";
				}
			}
			this.currentItem.css( this._storedCSS );
			this._removeClass( this.currentItem, "ui-sortable-helper" );
		} else {
			this.currentItem.show();
		}

		if ( this.fromOutside && !noPropagation ) {
			delayedTriggers.push( function( event ) {
				this._trigger( "receive", event, this._uiHash( this.fromOutside ) );
			} );
		}
		if ( ( this.fromOutside ||
				this.domPosition.prev !==
				this.currentItem.prev().not( ".ui-sortable-helper" )[ 0 ] ||
				this.domPosition.parent !== this.currentItem.parent()[ 0 ] ) && !noPropagation ) {

			// Trigger update callback if the DOM position has changed
			delayedTriggers.push( function( event ) {
				this._trigger( "update", event, this._uiHash() );
			} );
		}

		// Check if the items Container has Changed and trigger appropriate
		// events.
		if ( this !== this.currentContainer ) {
			if ( !noPropagation ) {
				delayedTriggers.push( function( event ) {
					this._trigger( "remove", event, this._uiHash() );
				} );
				delayedTriggers.push( ( function( c ) {
					return function( event ) {
						c._trigger( "receive", event, this._uiHash( this ) );
					};
				} ).call( this, this.currentContainer ) );
				delayedTriggers.push( ( function( c ) {
					return function( event ) {
						c._trigger( "update", event, this._uiHash( this ) );
					};
				} ).call( this, this.currentContainer ) );
			}
		}

		//Post events to containers
		function delayEvent( type, instance, container ) {
			return function( event ) {
				container._trigger( type, event, instance._uiHash( instance ) );
			};
		}
		for ( i = this.containers.length - 1; i >= 0; i-- ) {
			if ( !noPropagation ) {
				delayedTriggers.push( delayEvent( "deactivate", this, this.containers[ i ] ) );
			}
			if ( this.containers[ i ].containerCache.over ) {
				delayedTriggers.push( delayEvent( "out", this, this.containers[ i ] ) );
				this.containers[ i ].containerCache.over = 0;
			}
		}

		//Do what was originally in plugins
		if ( this.storedCursor ) {
			this.document.find( "body" ).css( "cursor", this.storedCursor );
			this.storedStylesheet.remove();
		}
		if ( this._storedOpacity ) {
			this.helper.css( "opacity", this._storedOpacity );
		}
		if ( this._storedZIndex ) {
			this.helper.css( "zIndex", this._storedZIndex === "auto" ? "" : this._storedZIndex );
		}

		this.dragging = false;

		if ( !noPropagation ) {
			this._trigger( "beforeStop", event, this._uiHash() );
		}

		//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
		// it unbinds ALL events from the original node!
		this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );

		if ( !this.cancelHelperRemoval ) {
			if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
				this.helper.remove();
			}
			this.helper = null;
		}

		if ( !noPropagation ) {
			for ( i = 0; i < delayedTriggers.length; i++ ) {

				// Trigger all delayed events
				delayedTriggers[ i ].call( this, event );
			}
			this._trigger( "stop", event, this._uiHash() );
		}

		this.fromOutside = false;
		return !this.cancelHelperRemoval;

	},

	_trigger: function() {
		if ( $.Widget.prototype._trigger.apply( this, arguments ) === false ) {
			this.cancel();
		}
	},

	_uiHash: function( _inst ) {
		var inst = _inst || this;
		return {
			helper: inst.helper,
			placeholder: inst.placeholder || $( [] ),
			position: inst.position,
			originalPosition: inst.originalPosition,
			offset: inst.positionAbs,
			item: inst.currentItem,
			sender: _inst ? _inst.element : null
		};
	}

} );


/*!
 * jQuery UI Spinner 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Spinner
//>>group: Widgets
//>>description: Displays buttons to easily input numbers via the keyboard or mouse.
//>>docs: http://api.jqueryui.com/spinner/
//>>demos: http://jqueryui.com/spinner/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/spinner.css
//>>css.theme: ../../themes/base/theme.css



function spinnerModifer( fn ) {
	return function() {
		var previous = this.element.val();
		fn.apply( this, arguments );
		this._refresh();
		if ( previous !== this.element.val() ) {
			this._trigger( "change" );
		}
	};
}

$.widget( "ui.spinner", {
	version: "1.12.1",
	defaultElement: "<input>",
	widgetEventPrefix: "spin",
	options: {
		classes: {
			"ui-spinner": "ui-corner-all",
			"ui-spinner-down": "ui-corner-br",
			"ui-spinner-up": "ui-corner-tr"
		},
		culture: null,
		icons: {
			down: "ui-icon-triangle-1-s",
			up: "ui-icon-triangle-1-n"
		},
		incremental: true,
		max: null,
		min: null,
		numberFormat: null,
		page: 10,
		step: 1,

		change: null,
		spin: null,
		start: null,
		stop: null
	},

	_create: function() {

		// handle string values that need to be parsed
		this._setOption( "max", this.options.max );
		this._setOption( "min", this.options.min );
		this._setOption( "step", this.options.step );

		// Only format if there is a value, prevents the field from being marked
		// as invalid in Firefox, see #9573.
		if ( this.value() !== "" ) {

			// Format the value, but don't constrain.
			this._value( this.element.val(), true );
		}

		this._draw();
		this._on( this._events );
		this._refresh();

		// Turning off autocomplete prevents the browser from remembering the
		// value when navigating through history, so we re-enable autocomplete
		// if the page is unloaded before the widget is destroyed. #7790
		this._on( this.window, {
			beforeunload: function() {
				this.element.removeAttr( "autocomplete" );
			}
		} );
	},

	_getCreateOptions: function() {
		var options = this._super();
		var element = this.element;

		$.each( [ "min", "max", "step" ], function( i, option ) {
			var value = element.attr( option );
			if ( value != null && value.length ) {
				options[ option ] = value;
			}
		} );

		return options;
	},

	_events: {
		keydown: function( event ) {
			if ( this._start( event ) && this._keydown( event ) ) {
				event.preventDefault();
			}
		},
		keyup: "_stop",
		focus: function() {
			this.previous = this.element.val();
		},
		blur: function( event ) {
			if ( this.cancelBlur ) {
				delete this.cancelBlur;
				return;
			}

			this._stop();
			this._refresh();
			if ( this.previous !== this.element.val() ) {
				this._trigger( "change", event );
			}
		},
		mousewheel: function( event, delta ) {
			if ( !delta ) {
				return;
			}
			if ( !this.spinning && !this._start( event ) ) {
				return false;
			}

			this._spin( ( delta > 0 ? 1 : -1 ) * this.options.step, event );
			clearTimeout( this.mousewheelTimer );
			this.mousewheelTimer = this._delay( function() {
				if ( this.spinning ) {
					this._stop( event );
				}
			}, 100 );
			event.preventDefault();
		},
		"mousedown .ui-spinner-button": function( event ) {
			var previous;

			// We never want the buttons to have focus; whenever the user is
			// interacting with the spinner, the focus should be on the input.
			// If the input is focused then this.previous is properly set from
			// when the input first received focus. If the input is not focused
			// then we need to set this.previous based on the value before spinning.
			previous = this.element[ 0 ] === $.ui.safeActiveElement( this.document[ 0 ] ) ?
				this.previous : this.element.val();
			function checkFocus() {
				var isActive = this.element[ 0 ] === $.ui.safeActiveElement( this.document[ 0 ] );
				if ( !isActive ) {
					this.element.trigger( "focus" );
					this.previous = previous;

					// support: IE
					// IE sets focus asynchronously, so we need to check if focus
					// moved off of the input because the user clicked on the button.
					this._delay( function() {
						this.previous = previous;
					} );
				}
			}

			// Ensure focus is on (or stays on) the text field
			event.preventDefault();
			checkFocus.call( this );

			// Support: IE
			// IE doesn't prevent moving focus even with event.preventDefault()
			// so we set a flag to know when we should ignore the blur event
			// and check (again) if focus moved off of the input.
			this.cancelBlur = true;
			this._delay( function() {
				delete this.cancelBlur;
				checkFocus.call( this );
			} );

			if ( this._start( event ) === false ) {
				return;
			}

			this._repeat( null, $( event.currentTarget )
				.hasClass( "ui-spinner-up" ) ? 1 : -1, event );
		},
		"mouseup .ui-spinner-button": "_stop",
		"mouseenter .ui-spinner-button": function( event ) {

			// button will add ui-state-active if mouse was down while mouseleave and kept down
			if ( !$( event.currentTarget ).hasClass( "ui-state-active" ) ) {
				return;
			}

			if ( this._start( event ) === false ) {
				return false;
			}
			this._repeat( null, $( event.currentTarget )
				.hasClass( "ui-spinner-up" ) ? 1 : -1, event );
		},

		// TODO: do we really want to consider this a stop?
		// shouldn't we just stop the repeater and wait until mouseup before
		// we trigger the stop event?
		"mouseleave .ui-spinner-button": "_stop"
	},

	// Support mobile enhanced option and make backcompat more sane
	_enhance: function() {
		this.uiSpinner = this.element
			.attr( "autocomplete", "off" )
			.wrap( "<span>" )
			.parent()

				// Add buttons
				.append(
					"<a></a><a></a>"
				);
	},

	_draw: function() {
		this._enhance();

		this._addClass( this.uiSpinner, "ui-spinner", "ui-widget ui-widget-content" );
		this._addClass( "ui-spinner-input" );

		this.element.attr( "role", "spinbutton" );

		// Button bindings
		this.buttons = this.uiSpinner.children( "a" )
			.attr( "tabIndex", -1 )
			.attr( "aria-hidden", true )
			.button( {
				classes: {
					"ui-button": ""
				}
			} );

		// TODO: Right now button does not support classes this is already updated in button PR
		this._removeClass( this.buttons, "ui-corner-all" );

		this._addClass( this.buttons.first(), "ui-spinner-button ui-spinner-up" );
		this._addClass( this.buttons.last(), "ui-spinner-button ui-spinner-down" );
		this.buttons.first().button( {
			"icon": this.options.icons.up,
			"showLabel": false
		} );
		this.buttons.last().button( {
			"icon": this.options.icons.down,
			"showLabel": false
		} );

		// IE 6 doesn't understand height: 50% for the buttons
		// unless the wrapper has an explicit height
		if ( this.buttons.height() > Math.ceil( this.uiSpinner.height() * 0.5 ) &&
				this.uiSpinner.height() > 0 ) {
			this.uiSpinner.height( this.uiSpinner.height() );
		}
	},

	_keydown: function( event ) {
		var options = this.options,
			keyCode = $.ui.keyCode;

		switch ( event.keyCode ) {
		case keyCode.UP:
			this._repeat( null, 1, event );
			return true;
		case keyCode.DOWN:
			this._repeat( null, -1, event );
			return true;
		case keyCode.PAGE_UP:
			this._repeat( null, options.page, event );
			return true;
		case keyCode.PAGE_DOWN:
			this._repeat( null, -options.page, event );
			return true;
		}

		return false;
	},

	_start: function( event ) {
		if ( !this.spinning && this._trigger( "start", event ) === false ) {
			return false;
		}

		if ( !this.counter ) {
			this.counter = 1;
		}
		this.spinning = true;
		return true;
	},

	_repeat: function( i, steps, event ) {
		i = i || 500;

		clearTimeout( this.timer );
		this.timer = this._delay( function() {
			this._repeat( 40, steps, event );
		}, i );

		this._spin( steps * this.options.step, event );
	},

	_spin: function( step, event ) {
		var value = this.value() || 0;

		if ( !this.counter ) {
			this.counter = 1;
		}

		value = this._adjustValue( value + step * this._increment( this.counter ) );

		if ( !this.spinning || this._trigger( "spin", event, { value: value } ) !== false ) {
			this._value( value );
			this.counter++;
		}
	},

	_increment: function( i ) {
		var incremental = this.options.incremental;

		if ( incremental ) {
			return $.isFunction( incremental ) ?
				incremental( i ) :
				Math.floor( i * i * i / 50000 - i * i / 500 + 17 * i / 200 + 1 );
		}

		return 1;
	},

	_precision: function() {
		var precision = this._precisionOf( this.options.step );
		if ( this.options.min !== null ) {
			precision = Math.max( precision, this._precisionOf( this.options.min ) );
		}
		return precision;
	},

	_precisionOf: function( num ) {
		var str = num.toString(),
			decimal = str.indexOf( "." );
		return decimal === -1 ? 0 : str.length - decimal - 1;
	},

	_adjustValue: function( value ) {
		var base, aboveMin,
			options = this.options;

		// Make sure we're at a valid step
		// - find out where we are relative to the base (min or 0)
		base = options.min !== null ? options.min : 0;
		aboveMin = value - base;

		// - round to the nearest step
		aboveMin = Math.round( aboveMin / options.step ) * options.step;

		// - rounding is based on 0, so adjust back to our base
		value = base + aboveMin;

		// Fix precision from bad JS floating point math
		value = parseFloat( value.toFixed( this._precision() ) );

		// Clamp the value
		if ( options.max !== null && value > options.max ) {
			return options.max;
		}
		if ( options.min !== null && value < options.min ) {
			return options.min;
		}

		return value;
	},

	_stop: function( event ) {
		if ( !this.spinning ) {
			return;
		}

		clearTimeout( this.timer );
		clearTimeout( this.mousewheelTimer );
		this.counter = 0;
		this.spinning = false;
		this._trigger( "stop", event );
	},

	_setOption: function( key, value ) {
		var prevValue, first, last;

		if ( key === "culture" || key === "numberFormat" ) {
			prevValue = this._parse( this.element.val() );
			this.options[ key ] = value;
			this.element.val( this._format( prevValue ) );
			return;
		}

		if ( key === "max" || key === "min" || key === "step" ) {
			if ( typeof value === "string" ) {
				value = this._parse( value );
			}
		}
		if ( key === "icons" ) {
			first = this.buttons.first().find( ".ui-icon" );
			this._removeClass( first, null, this.options.icons.up );
			this._addClass( first, null, value.up );
			last = this.buttons.last().find( ".ui-icon" );
			this._removeClass( last, null, this.options.icons.down );
			this._addClass( last, null, value.down );
		}

		this._super( key, value );
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this._toggleClass( this.uiSpinner, null, "ui-state-disabled", !!value );
		this.element.prop( "disabled", !!value );
		this.buttons.button( value ? "disable" : "enable" );
	},

	_setOptions: spinnerModifer( function( options ) {
		this._super( options );
	} ),

	_parse: function( val ) {
		if ( typeof val === "string" && val !== "" ) {
			val = window.Globalize && this.options.numberFormat ?
				Globalize.parseFloat( val, 10, this.options.culture ) : +val;
		}
		return val === "" || isNaN( val ) ? null : val;
	},

	_format: function( value ) {
		if ( value === "" ) {
			return "";
		}
		return window.Globalize && this.options.numberFormat ?
			Globalize.format( value, this.options.numberFormat, this.options.culture ) :
			value;
	},

	_refresh: function() {
		this.element.attr( {
			"aria-valuemin": this.options.min,
			"aria-valuemax": this.options.max,

			// TODO: what should we do with values that can't be parsed?
			"aria-valuenow": this._parse( this.element.val() )
		} );
	},

	isValid: function() {
		var value = this.value();

		// Null is invalid
		if ( value === null ) {
			return false;
		}

		// If value gets adjusted, it's invalid
		return value === this._adjustValue( value );
	},

	// Update the value without triggering change
	_value: function( value, allowAny ) {
		var parsed;
		if ( value !== "" ) {
			parsed = this._parse( value );
			if ( parsed !== null ) {
				if ( !allowAny ) {
					parsed = this._adjustValue( parsed );
				}
				value = this._format( parsed );
			}
		}
		this.element.val( value );
		this._refresh();
	},

	_destroy: function() {
		this.element
			.prop( "disabled", false )
			.removeAttr( "autocomplete role aria-valuemin aria-valuemax aria-valuenow" );

		this.uiSpinner.replaceWith( this.element );
	},

	stepUp: spinnerModifer( function( steps ) {
		this._stepUp( steps );
	} ),
	_stepUp: function( steps ) {
		if ( this._start() ) {
			this._spin( ( steps || 1 ) * this.options.step );
			this._stop();
		}
	},

	stepDown: spinnerModifer( function( steps ) {
		this._stepDown( steps );
	} ),
	_stepDown: function( steps ) {
		if ( this._start() ) {
			this._spin( ( steps || 1 ) * -this.options.step );
			this._stop();
		}
	},

	pageUp: spinnerModifer( function( pages ) {
		this._stepUp( ( pages || 1 ) * this.options.page );
	} ),

	pageDown: spinnerModifer( function( pages ) {
		this._stepDown( ( pages || 1 ) * this.options.page );
	} ),

	value: function( newVal ) {
		if ( !arguments.length ) {
			return this._parse( this.element.val() );
		}
		spinnerModifer( this._value ).call( this, newVal );
	},

	widget: function() {
		return this.uiSpinner;
	}
} );

// DEPRECATED
// TODO: switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat !== false ) {

	// Backcompat for spinner html extension points
	$.widget( "ui.spinner", $.ui.spinner, {
		_enhance: function() {
			this.uiSpinner = this.element
				.attr( "autocomplete", "off" )
				.wrap( this._uiSpinnerHtml() )
				.parent()

					// Add buttons
					.append( this._buttonHtml() );
		},
		_uiSpinnerHtml: function() {
			return "<span>";
		},

		_buttonHtml: function() {
			return "<a></a><a></a>";
		}
	} );
}

var widgetsSpinner = $.ui.spinner;


/*!
 * jQuery UI Tabs 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Tabs
//>>group: Widgets
//>>description: Transforms a set of container elements into a tab structure.
//>>docs: http://api.jqueryui.com/tabs/
//>>demos: http://jqueryui.com/tabs/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/tabs.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.tabs", {
	version: "1.12.1",
	delay: 300,
	options: {
		active: null,
		classes: {
			"ui-tabs": "ui-corner-all",
			"ui-tabs-nav": "ui-corner-all",
			"ui-tabs-panel": "ui-corner-bottom",
			"ui-tabs-tab": "ui-corner-top"
		},
		collapsible: false,
		event: "click",
		heightStyle: "content",
		hide: null,
		show: null,

		// Callbacks
		activate: null,
		beforeActivate: null,
		beforeLoad: null,
		load: null
	},

	_isLocal: ( function() {
		var rhash = /#.*$/;

		return function( anchor ) {
			var anchorUrl, locationUrl;

			anchorUrl = anchor.href.replace( rhash, "" );
			locationUrl = location.href.replace( rhash, "" );

			// Decoding may throw an error if the URL isn't UTF-8 (#9518)
			try {
				anchorUrl = decodeURIComponent( anchorUrl );
			} catch ( error ) {}
			try {
				locationUrl = decodeURIComponent( locationUrl );
			} catch ( error ) {}

			return anchor.hash.length > 1 && anchorUrl === locationUrl;
		};
	} )(),

	_create: function() {
		var that = this,
			options = this.options;

		this.running = false;

		this._addClass( "ui-tabs", "ui-widget ui-widget-content" );
		this._toggleClass( "ui-tabs-collapsible", null, options.collapsible );

		this._processTabs();
		options.active = this._initialActive();

		// Take disabling tabs via class attribute from HTML
		// into account and update option properly.
		if ( $.isArray( options.disabled ) ) {
			options.disabled = $.unique( options.disabled.concat(
				$.map( this.tabs.filter( ".ui-state-disabled" ), function( li ) {
					return that.tabs.index( li );
				} )
			) ).sort();
		}

		// Check for length avoids error when initializing empty list
		if ( this.options.active !== false && this.anchors.length ) {
			this.active = this._findActive( options.active );
		} else {
			this.active = $();
		}

		this._refresh();

		if ( this.active.length ) {
			this.load( options.active );
		}
	},

	_initialActive: function() {
		var active = this.options.active,
			collapsible = this.options.collapsible,
			locationHash = location.hash.substring( 1 );

		if ( active === null ) {

			// check the fragment identifier in the URL
			if ( locationHash ) {
				this.tabs.each( function( i, tab ) {
					if ( $( tab ).attr( "aria-controls" ) === locationHash ) {
						active = i;
						return false;
					}
				} );
			}

			// Check for a tab marked active via a class
			if ( active === null ) {
				active = this.tabs.index( this.tabs.filter( ".ui-tabs-active" ) );
			}

			// No active tab, set to false
			if ( active === null || active === -1 ) {
				active = this.tabs.length ? 0 : false;
			}
		}

		// Handle numbers: negative, out of range
		if ( active !== false ) {
			active = this.tabs.index( this.tabs.eq( active ) );
			if ( active === -1 ) {
				active = collapsible ? false : 0;
			}
		}

		// Don't allow collapsible: false and active: false
		if ( !collapsible && active === false && this.anchors.length ) {
			active = 0;
		}

		return active;
	},

	_getCreateEventData: function() {
		return {
			tab: this.active,
			panel: !this.active.length ? $() : this._getPanelForTab( this.active )
		};
	},

	_tabKeydown: function( event ) {
		var focusedTab = $( $.ui.safeActiveElement( this.document[ 0 ] ) ).closest( "li" ),
			selectedIndex = this.tabs.index( focusedTab ),
			goingForward = true;

		if ( this._handlePageNav( event ) ) {
			return;
		}

		switch ( event.keyCode ) {
		case $.ui.keyCode.RIGHT:
		case $.ui.keyCode.DOWN:
			selectedIndex++;
			break;
		case $.ui.keyCode.UP:
		case $.ui.keyCode.LEFT:
			goingForward = false;
			selectedIndex--;
			break;
		case $.ui.keyCode.END:
			selectedIndex = this.anchors.length - 1;
			break;
		case $.ui.keyCode.HOME:
			selectedIndex = 0;
			break;
		case $.ui.keyCode.SPACE:

			// Activate only, no collapsing
			event.preventDefault();
			clearTimeout( this.activating );
			this._activate( selectedIndex );
			return;
		case $.ui.keyCode.ENTER:

			// Toggle (cancel delayed activation, allow collapsing)
			event.preventDefault();
			clearTimeout( this.activating );

			// Determine if we should collapse or activate
			this._activate( selectedIndex === this.options.active ? false : selectedIndex );
			return;
		default:
			return;
		}

		// Focus the appropriate tab, based on which key was pressed
		event.preventDefault();
		clearTimeout( this.activating );
		selectedIndex = this._focusNextTab( selectedIndex, goingForward );

		// Navigating with control/command key will prevent automatic activation
		if ( !event.ctrlKey && !event.metaKey ) {

			// Update aria-selected immediately so that AT think the tab is already selected.
			// Otherwise AT may confuse the user by stating that they need to activate the tab,
			// but the tab will already be activated by the time the announcement finishes.
			focusedTab.attr( "aria-selected", "false" );
			this.tabs.eq( selectedIndex ).attr( "aria-selected", "true" );

			this.activating = this._delay( function() {
				this.option( "active", selectedIndex );
			}, this.delay );
		}
	},

	_panelKeydown: function( event ) {
		if ( this._handlePageNav( event ) ) {
			return;
		}

		// Ctrl+up moves focus to the current tab
		if ( event.ctrlKey && event.keyCode === $.ui.keyCode.UP ) {
			event.preventDefault();
			this.active.trigger( "focus" );
		}
	},

	// Alt+page up/down moves focus to the previous/next tab (and activates)
	_handlePageNav: function( event ) {
		if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_UP ) {
			this._activate( this._focusNextTab( this.options.active - 1, false ) );
			return true;
		}
		if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_DOWN ) {
			this._activate( this._focusNextTab( this.options.active + 1, true ) );
			return true;
		}
	},

	_findNextTab: function( index, goingForward ) {
		var lastTabIndex = this.tabs.length - 1;

		function constrain() {
			if ( index > lastTabIndex ) {
				index = 0;
			}
			if ( index < 0 ) {
				index = lastTabIndex;
			}
			return index;
		}

		while ( $.inArray( constrain(), this.options.disabled ) !== -1 ) {
			index = goingForward ? index + 1 : index - 1;
		}

		return index;
	},

	_focusNextTab: function( index, goingForward ) {
		index = this._findNextTab( index, goingForward );
		this.tabs.eq( index ).trigger( "focus" );
		return index;
	},

	_setOption: function( key, value ) {
		if ( key === "active" ) {

			// _activate() will handle invalid values and update this.options
			this._activate( value );
			return;
		}

		this._super( key, value );

		if ( key === "collapsible" ) {
			this._toggleClass( "ui-tabs-collapsible", null, value );

			// Setting collapsible: false while collapsed; open first panel
			if ( !value && this.options.active === false ) {
				this._activate( 0 );
			}
		}

		if ( key === "event" ) {
			this._setupEvents( value );
		}

		if ( key === "heightStyle" ) {
			this._setupHeightStyle( value );
		}
	},

	_sanitizeSelector: function( hash ) {
		return hash ? hash.replace( /[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g, "\\$&" ) : "";
	},

	refresh: function() {
		var options = this.options,
			lis = this.tablist.children( ":has(a[href])" );

		// Get disabled tabs from class attribute from HTML
		// this will get converted to a boolean if needed in _refresh()
		options.disabled = $.map( lis.filter( ".ui-state-disabled" ), function( tab ) {
			return lis.index( tab );
		} );

		this._processTabs();

		// Was collapsed or no tabs
		if ( options.active === false || !this.anchors.length ) {
			options.active = false;
			this.active = $();

		// was active, but active tab is gone
		} else if ( this.active.length && !$.contains( this.tablist[ 0 ], this.active[ 0 ] ) ) {

			// all remaining tabs are disabled
			if ( this.tabs.length === options.disabled.length ) {
				options.active = false;
				this.active = $();

			// activate previous tab
			} else {
				this._activate( this._findNextTab( Math.max( 0, options.active - 1 ), false ) );
			}

		// was active, active tab still exists
		} else {

			// make sure active index is correct
			options.active = this.tabs.index( this.active );
		}

		this._refresh();
	},

	_refresh: function() {
		this._setOptionDisabled( this.options.disabled );
		this._setupEvents( this.options.event );
		this._setupHeightStyle( this.options.heightStyle );

		this.tabs.not( this.active ).attr( {
			"aria-selected": "false",
			"aria-expanded": "false",
			tabIndex: -1
		} );
		this.panels.not( this._getPanelForTab( this.active ) )
			.hide()
			.attr( {
				"aria-hidden": "true"
			} );

		// Make sure one tab is in the tab order
		if ( !this.active.length ) {
			this.tabs.eq( 0 ).attr( "tabIndex", 0 );
		} else {
			this.active
				.attr( {
					"aria-selected": "true",
					"aria-expanded": "true",
					tabIndex: 0
				} );
			this._addClass( this.active, "ui-tabs-active", "ui-state-active" );
			this._getPanelForTab( this.active )
				.show()
				.attr( {
					"aria-hidden": "false"
				} );
		}
	},

	_processTabs: function() {
		var that = this,
			prevTabs = this.tabs,
			prevAnchors = this.anchors,
			prevPanels = this.panels;

		this.tablist = this._getList().attr( "role", "tablist" );
		this._addClass( this.tablist, "ui-tabs-nav",
			"ui-helper-reset ui-helper-clearfix ui-widget-header" );

		// Prevent users from focusing disabled tabs via click
		this.tablist
			.on( "mousedown" + this.eventNamespace, "> li", function( event ) {
				if ( $( this ).is( ".ui-state-disabled" ) ) {
					event.preventDefault();
				}
			} )

			// Support: IE <9
			// Preventing the default action in mousedown doesn't prevent IE
			// from focusing the element, so if the anchor gets focused, blur.
			// We don't have to worry about focusing the previously focused
			// element since clicking on a non-focusable element should focus
			// the body anyway.
			.on( "focus" + this.eventNamespace, ".ui-tabs-anchor", function() {
				if ( $( this ).closest( "li" ).is( ".ui-state-disabled" ) ) {
					this.blur();
				}
			} );

		this.tabs = this.tablist.find( "> li:has(a[href])" )
			.attr( {
				role: "tab",
				tabIndex: -1
			} );
		this._addClass( this.tabs, "ui-tabs-tab", "ui-state-default" );

		this.anchors = this.tabs.map( function() {
			return $( "a", this )[ 0 ];
		} )
			.attr( {
				role: "presentation",
				tabIndex: -1
			} );
		this._addClass( this.anchors, "ui-tabs-anchor" );

		this.panels = $();

		this.anchors.each( function( i, anchor ) {
			var selector, panel, panelId,
				anchorId = $( anchor ).uniqueId().attr( "id" ),
				tab = $( anchor ).closest( "li" ),
				originalAriaControls = tab.attr( "aria-controls" );

			// Inline tab
			if ( that._isLocal( anchor ) ) {
				selector = anchor.hash;
				panelId = selector.substring( 1 );
				panel = that.element.find( that._sanitizeSelector( selector ) );

			// remote tab
			} else {

				// If the tab doesn't already have aria-controls,
				// generate an id by using a throw-away element
				panelId = tab.attr( "aria-controls" ) || $( {} ).uniqueId()[ 0 ].id;
				selector = "#" + panelId;
				panel = that.element.find( selector );
				if ( !panel.length ) {
					panel = that._createPanel( panelId );
					panel.insertAfter( that.panels[ i - 1 ] || that.tablist );
				}
				panel.attr( "aria-live", "polite" );
			}

			if ( panel.length ) {
				that.panels = that.panels.add( panel );
			}
			if ( originalAriaControls ) {
				tab.data( "ui-tabs-aria-controls", originalAriaControls );
			}
			tab.attr( {
				"aria-controls": panelId,
				"aria-labelledby": anchorId
			} );
			panel.attr( "aria-labelledby", anchorId );
		} );

		this.panels.attr( "role", "tabpanel" );
		this._addClass( this.panels, "ui-tabs-panel", "ui-widget-content" );

		// Avoid memory leaks (#10056)
		if ( prevTabs ) {
			this._off( prevTabs.not( this.tabs ) );
			this._off( prevAnchors.not( this.anchors ) );
			this._off( prevPanels.not( this.panels ) );
		}
	},

	// Allow overriding how to find the list for rare usage scenarios (#7715)
	_getList: function() {
		return this.tablist || this.element.find( "ol, ul" ).eq( 0 );
	},

	_createPanel: function( id ) {
		return $( "<div>" )
			.attr( "id", id )
			.data( "ui-tabs-destroy", true );
	},

	_setOptionDisabled: function( disabled ) {
		var currentItem, li, i;

		if ( $.isArray( disabled ) ) {
			if ( !disabled.length ) {
				disabled = false;
			} else if ( disabled.length === this.anchors.length ) {
				disabled = true;
			}
		}

		// Disable tabs
		for ( i = 0; ( li = this.tabs[ i ] ); i++ ) {
			currentItem = $( li );
			if ( disabled === true || $.inArray( i, disabled ) !== -1 ) {
				currentItem.attr( "aria-disabled", "true" );
				this._addClass( currentItem, null, "ui-state-disabled" );
			} else {
				currentItem.removeAttr( "aria-disabled" );
				this._removeClass( currentItem, null, "ui-state-disabled" );
			}
		}

		this.options.disabled = disabled;

		this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null,
			disabled === true );
	},

	_setupEvents: function( event ) {
		var events = {};
		if ( event ) {
			$.each( event.split( " " ), function( index, eventName ) {
				events[ eventName ] = "_eventHandler";
			} );
		}

		this._off( this.anchors.add( this.tabs ).add( this.panels ) );

		// Always prevent the default action, even when disabled
		this._on( true, this.anchors, {
			click: function( event ) {
				event.preventDefault();
			}
		} );
		this._on( this.anchors, events );
		this._on( this.tabs, { keydown: "_tabKeydown" } );
		this._on( this.panels, { keydown: "_panelKeydown" } );

		this._focusable( this.tabs );
		this._hoverable( this.tabs );
	},

	_setupHeightStyle: function( heightStyle ) {
		var maxHeight,
			parent = this.element.parent();

		if ( heightStyle === "fill" ) {
			maxHeight = parent.height();
			maxHeight -= this.element.outerHeight() - this.element.height();

			this.element.siblings( ":visible" ).each( function() {
				var elem = $( this ),
					position = elem.css( "position" );

				if ( position === "absolute" || position === "fixed" ) {
					return;
				}
				maxHeight -= elem.outerHeight( true );
			} );

			this.element.children().not( this.panels ).each( function() {
				maxHeight -= $( this ).outerHeight( true );
			} );

			this.panels.each( function() {
				$( this ).height( Math.max( 0, maxHeight -
					$( this ).innerHeight() + $( this ).height() ) );
			} )
				.css( "overflow", "auto" );
		} else if ( heightStyle === "auto" ) {
			maxHeight = 0;
			this.panels.each( function() {
				maxHeight = Math.max( maxHeight, $( this ).height( "" ).height() );
			} ).height( maxHeight );
		}
	},

	_eventHandler: function( event ) {
		var options = this.options,
			active = this.active,
			anchor = $( event.currentTarget ),
			tab = anchor.closest( "li" ),
			clickedIsActive = tab[ 0 ] === active[ 0 ],
			collapsing = clickedIsActive && options.collapsible,
			toShow = collapsing ? $() : this._getPanelForTab( tab ),
			toHide = !active.length ? $() : this._getPanelForTab( active ),
			eventData = {
				oldTab: active,
				oldPanel: toHide,
				newTab: collapsing ? $() : tab,
				newPanel: toShow
			};

		event.preventDefault();

		if ( tab.hasClass( "ui-state-disabled" ) ||

				// tab is already loading
				tab.hasClass( "ui-tabs-loading" ) ||

				// can't switch durning an animation
				this.running ||

				// click on active header, but not collapsible
				( clickedIsActive && !options.collapsible ) ||

				// allow canceling activation
				( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
			return;
		}

		options.active = collapsing ? false : this.tabs.index( tab );

		this.active = clickedIsActive ? $() : tab;
		if ( this.xhr ) {
			this.xhr.abort();
		}

		if ( !toHide.length && !toShow.length ) {
			$.error( "jQuery UI Tabs: Mismatching fragment identifier." );
		}

		if ( toShow.length ) {
			this.load( this.tabs.index( tab ), event );
		}
		this._toggle( event, eventData );
	},

	// Handles show/hide for selecting tabs
	_toggle: function( event, eventData ) {
		var that = this,
			toShow = eventData.newPanel,
			toHide = eventData.oldPanel;

		this.running = true;

		function complete() {
			that.running = false;
			that._trigger( "activate", event, eventData );
		}

		function show() {
			that._addClass( eventData.newTab.closest( "li" ), "ui-tabs-active", "ui-state-active" );

			if ( toShow.length && that.options.show ) {
				that._show( toShow, that.options.show, complete );
			} else {
				toShow.show();
				complete();
			}
		}

		// Start out by hiding, then showing, then completing
		if ( toHide.length && this.options.hide ) {
			this._hide( toHide, this.options.hide, function() {
				that._removeClass( eventData.oldTab.closest( "li" ),
					"ui-tabs-active", "ui-state-active" );
				show();
			} );
		} else {
			this._removeClass( eventData.oldTab.closest( "li" ),
				"ui-tabs-active", "ui-state-active" );
			toHide.hide();
			show();
		}

		toHide.attr( "aria-hidden", "true" );
		eventData.oldTab.attr( {
			"aria-selected": "false",
			"aria-expanded": "false"
		} );

		// If we're switching tabs, remove the old tab from the tab order.
		// If we're opening from collapsed state, remove the previous tab from the tab order.
		// If we're collapsing, then keep the collapsing tab in the tab order.
		if ( toShow.length && toHide.length ) {
			eventData.oldTab.attr( "tabIndex", -1 );
		} else if ( toShow.length ) {
			this.tabs.filter( function() {
				return $( this ).attr( "tabIndex" ) === 0;
			} )
				.attr( "tabIndex", -1 );
		}

		toShow.attr( "aria-hidden", "false" );
		eventData.newTab.attr( {
			"aria-selected": "true",
			"aria-expanded": "true",
			tabIndex: 0
		} );
	},

	_activate: function( index ) {
		var anchor,
			active = this._findActive( index );

		// Trying to activate the already active panel
		if ( active[ 0 ] === this.active[ 0 ] ) {
			return;
		}

		// Trying to collapse, simulate a click on the current active header
		if ( !active.length ) {
			active = this.active;
		}

		anchor = active.find( ".ui-tabs-anchor" )[ 0 ];
		this._eventHandler( {
			target: anchor,
			currentTarget: anchor,
			preventDefault: $.noop
		} );
	},

	_findActive: function( index ) {
		return index === false ? $() : this.tabs.eq( index );
	},

	_getIndex: function( index ) {

		// meta-function to give users option to provide a href string instead of a numerical index.
		if ( typeof index === "string" ) {
			index = this.anchors.index( this.anchors.filter( "[href$='" +
				$.ui.escapeSelector( index ) + "']" ) );
		}

		return index;
	},

	_destroy: function() {
		if ( this.xhr ) {
			this.xhr.abort();
		}

		this.tablist
			.removeAttr( "role" )
			.off( this.eventNamespace );

		this.anchors
			.removeAttr( "role tabIndex" )
			.removeUniqueId();

		this.tabs.add( this.panels ).each( function() {
			if ( $.data( this, "ui-tabs-destroy" ) ) {
				$( this ).remove();
			} else {
				$( this ).removeAttr( "role tabIndex " +
					"aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded" );
			}
		} );

		this.tabs.each( function() {
			var li = $( this ),
				prev = li.data( "ui-tabs-aria-controls" );
			if ( prev ) {
				li
					.attr( "aria-controls", prev )
					.removeData( "ui-tabs-aria-controls" );
			} else {
				li.removeAttr( "aria-controls" );
			}
		} );

		this.panels.show();

		if ( this.options.heightStyle !== "content" ) {
			this.panels.css( "height", "" );
		}
	},

	enable: function( index ) {
		var disabled = this.options.disabled;
		if ( disabled === false ) {
			return;
		}

		if ( index === undefined ) {
			disabled = false;
		} else {
			index = this._getIndex( index );
			if ( $.isArray( disabled ) ) {
				disabled = $.map( disabled, function( num ) {
					return num !== index ? num : null;
				} );
			} else {
				disabled = $.map( this.tabs, function( li, num ) {
					return num !== index ? num : null;
				} );
			}
		}
		this._setOptionDisabled( disabled );
	},

	disable: function( index ) {
		var disabled = this.options.disabled;
		if ( disabled === true ) {
			return;
		}

		if ( index === undefined ) {
			disabled = true;
		} else {
			index = this._getIndex( index );
			if ( $.inArray( index, disabled ) !== -1 ) {
				return;
			}
			if ( $.isArray( disabled ) ) {
				disabled = $.merge( [ index ], disabled ).sort();
			} else {
				disabled = [ index ];
			}
		}
		this._setOptionDisabled( disabled );
	},

	load: function( index, event ) {
		index = this._getIndex( index );
		var that = this,
			tab = this.tabs.eq( index ),
			anchor = tab.find( ".ui-tabs-anchor" ),
			panel = this._getPanelForTab( tab ),
			eventData = {
				tab: tab,
				panel: panel
			},
			complete = function( jqXHR, status ) {
				if ( status === "abort" ) {
					that.panels.stop( false, true );
				}

				that._removeClass( tab, "ui-tabs-loading" );
				panel.removeAttr( "aria-busy" );

				if ( jqXHR === that.xhr ) {
					delete that.xhr;
				}
			};

		// Not remote
		if ( this._isLocal( anchor[ 0 ] ) ) {
			return;
		}

		this.xhr = $.ajax( this._ajaxSettings( anchor, event, eventData ) );

		// Support: jQuery <1.8
		// jQuery <1.8 returns false if the request is canceled in beforeSend,
		// but as of 1.8, $.ajax() always returns a jqXHR object.
		if ( this.xhr && this.xhr.statusText !== "canceled" ) {
			this._addClass( tab, "ui-tabs-loading" );
			panel.attr( "aria-busy", "true" );

			this.xhr
				.done( function( response, status, jqXHR ) {

					// support: jQuery <1.8
					// http://bugs.jquery.com/ticket/11778
					setTimeout( function() {
						panel.html( response );
						that._trigger( "load", event, eventData );

						complete( jqXHR, status );
					}, 1 );
				} )
				.fail( function( jqXHR, status ) {

					// support: jQuery <1.8
					// http://bugs.jquery.com/ticket/11778
					setTimeout( function() {
						complete( jqXHR, status );
					}, 1 );
				} );
		}
	},

	_ajaxSettings: function( anchor, event, eventData ) {
		var that = this;
		return {

			// Support: IE <11 only
			// Strip any hash that exists to prevent errors with the Ajax request
			url: anchor.attr( "href" ).replace( /#.*$/, "" ),
			beforeSend: function( jqXHR, settings ) {
				return that._trigger( "beforeLoad", event,
					$.extend( { jqXHR: jqXHR, ajaxSettings: settings }, eventData ) );
			}
		};
	},

	_getPanelForTab: function( tab ) {
		var id = $( tab ).attr( "aria-controls" );
		return this.element.find( this._sanitizeSelector( "#" + id ) );
	}
} );

// DEPRECATED
// TODO: Switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat !== false ) {

	// Backcompat for ui-tab class (now ui-tabs-tab)
	$.widget( "ui.tabs", $.ui.tabs, {
		_processTabs: function() {
			this._superApply( arguments );
			this._addClass( this.tabs, "ui-tab" );
		}
	} );
}

var widgetsTabs = $.ui.tabs;


/*!
 * jQuery UI Tooltip 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Tooltip
//>>group: Widgets
//>>description: Shows additional information for any element on hover or focus.
//>>docs: http://api.jqueryui.com/tooltip/
//>>demos: http://jqueryui.com/tooltip/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/tooltip.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.tooltip", {
	version: "1.12.1",
	options: {
		classes: {
			"ui-tooltip": "ui-corner-all ui-widget-shadow"
		},
		content: function() {

			// support: IE<9, Opera in jQuery <1.7
			// .text() can't accept undefined, so coerce to a string
			var title = $( this ).attr( "title" ) || "";

			// Escape title, since we're going from an attribute to raw HTML
			return $( "<a>" ).text( title ).html();
		},
		hide: true,

		// Disabled elements have inconsistent behavior across browsers (#8661)
		items: "[title]:not([disabled])",
		position: {
			my: "left top+15",
			at: "left bottom",
			collision: "flipfit flip"
		},
		show: true,
		track: false,

		// Callbacks
		close: null,
		open: null
	},

	_addDescribedBy: function( elem, id ) {
		var describedby = ( elem.attr( "aria-describedby" ) || "" ).split( /\s+/ );
		describedby.push( id );
		elem
			.data( "ui-tooltip-id", id )
			.attr( "aria-describedby", $.trim( describedby.join( " " ) ) );
	},

	_removeDescribedBy: function( elem ) {
		var id = elem.data( "ui-tooltip-id" ),
			describedby = ( elem.attr( "aria-describedby" ) || "" ).split( /\s+/ ),
			index = $.inArray( id, describedby );

		if ( index !== -1 ) {
			describedby.splice( index, 1 );
		}

		elem.removeData( "ui-tooltip-id" );
		describedby = $.trim( describedby.join( " " ) );
		if ( describedby ) {
			elem.attr( "aria-describedby", describedby );
		} else {
			elem.removeAttr( "aria-describedby" );
		}
	},

	_create: function() {
		this._on( {
			mouseover: "open",
			focusin: "open"
		} );

		// IDs of generated tooltips, needed for destroy
		this.tooltips = {};

		// IDs of parent tooltips where we removed the title attribute
		this.parents = {};

		// Append the aria-live region so tooltips announce correctly
		this.liveRegion = $( "<div>" )
			.attr( {
				role: "log",
				"aria-live": "assertive",
				"aria-relevant": "additions"
			} )
			.appendTo( this.document[ 0 ].body );
		this._addClass( this.liveRegion, null, "ui-helper-hidden-accessible" );

		this.disabledTitles = $( [] );
	},

	_setOption: function( key, value ) {
		var that = this;

		this._super( key, value );

		if ( key === "content" ) {
			$.each( this.tooltips, function( id, tooltipData ) {
				that._updateContent( tooltipData.element );
			} );
		}
	},

	_setOptionDisabled: function( value ) {
		this[ value ? "_disable" : "_enable" ]();
	},

	_disable: function() {
		var that = this;

		// Close open tooltips
		$.each( this.tooltips, function( id, tooltipData ) {
			var event = $.Event( "blur" );
			event.target = event.currentTarget = tooltipData.element[ 0 ];
			that.close( event, true );
		} );

		// Remove title attributes to prevent native tooltips
		this.disabledTitles = this.disabledTitles.add(
			this.element.find( this.options.items ).addBack()
				.filter( function() {
					var element = $( this );
					if ( element.is( "[title]" ) ) {
						return element
							.data( "ui-tooltip-title", element.attr( "title" ) )
							.removeAttr( "title" );
					}
				} )
		);
	},

	_enable: function() {

		// restore title attributes
		this.disabledTitles.each( function() {
			var element = $( this );
			if ( element.data( "ui-tooltip-title" ) ) {
				element.attr( "title", element.data( "ui-tooltip-title" ) );
			}
		} );
		this.disabledTitles = $( [] );
	},

	open: function( event ) {
		var that = this,
			target = $( event ? event.target : this.element )

				// we need closest here due to mouseover bubbling,
				// but always pointing at the same event target
				.closest( this.options.items );

		// No element to show a tooltip for or the tooltip is already open
		if ( !target.length || target.data( "ui-tooltip-id" ) ) {
			return;
		}

		if ( target.attr( "title" ) ) {
			target.data( "ui-tooltip-title", target.attr( "title" ) );
		}

		target.data( "ui-tooltip-open", true );

		// Kill parent tooltips, custom or native, for hover
		if ( event && event.type === "mouseover" ) {
			target.parents().each( function() {
				var parent = $( this ),
					blurEvent;
				if ( parent.data( "ui-tooltip-open" ) ) {
					blurEvent = $.Event( "blur" );
					blurEvent.target = blurEvent.currentTarget = this;
					that.close( blurEvent, true );
				}
				if ( parent.attr( "title" ) ) {
					parent.uniqueId();
					that.parents[ this.id ] = {
						element: this,
						title: parent.attr( "title" )
					};
					parent.attr( "title", "" );
				}
			} );
		}

		this._registerCloseHandlers( event, target );
		this._updateContent( target, event );
	},

	_updateContent: function( target, event ) {
		var content,
			contentOption = this.options.content,
			that = this,
			eventType = event ? event.type : null;

		if ( typeof contentOption === "string" || contentOption.nodeType ||
				contentOption.jquery ) {
			return this._open( event, target, contentOption );
		}

		content = contentOption.call( target[ 0 ], function( response ) {

			// IE may instantly serve a cached response for ajax requests
			// delay this call to _open so the other call to _open runs first
			that._delay( function() {

				// Ignore async response if tooltip was closed already
				if ( !target.data( "ui-tooltip-open" ) ) {
					return;
				}

				// JQuery creates a special event for focusin when it doesn't
				// exist natively. To improve performance, the native event
				// object is reused and the type is changed. Therefore, we can't
				// rely on the type being correct after the event finished
				// bubbling, so we set it back to the previous value. (#8740)
				if ( event ) {
					event.type = eventType;
				}
				this._open( event, target, response );
			} );
		} );
		if ( content ) {
			this._open( event, target, content );
		}
	},

	_open: function( event, target, content ) {
		var tooltipData, tooltip, delayedShow, a11yContent,
			positionOption = $.extend( {}, this.options.position );

		if ( !content ) {
			return;
		}

		// Content can be updated multiple times. If the tooltip already
		// exists, then just update the content and bail.
		tooltipData = this._find( target );
		if ( tooltipData ) {
			tooltipData.tooltip.find( ".ui-tooltip-content" ).html( content );
			return;
		}

		// If we have a title, clear it to prevent the native tooltip
		// we have to check first to avoid defining a title if none exists
		// (we don't want to cause an element to start matching [title])
		//
		// We use removeAttr only for key events, to allow IE to export the correct
		// accessible attributes. For mouse events, set to empty string to avoid
		// native tooltip showing up (happens only when removing inside mouseover).
		if ( target.is( "[title]" ) ) {
			if ( event && event.type === "mouseover" ) {
				target.attr( "title", "" );
			} else {
				target.removeAttr( "title" );
			}
		}

		tooltipData = this._tooltip( target );
		tooltip = tooltipData.tooltip;
		this._addDescribedBy( target, tooltip.attr( "id" ) );
		tooltip.find( ".ui-tooltip-content" ).html( content );

		// Support: Voiceover on OS X, JAWS on IE <= 9
		// JAWS announces deletions even when aria-relevant="additions"
		// Voiceover will sometimes re-read the entire log region's contents from the beginning
		this.liveRegion.children().hide();
		a11yContent = $( "<div>" ).html( tooltip.find( ".ui-tooltip-content" ).html() );
		a11yContent.removeAttr( "name" ).find( "[name]" ).removeAttr( "name" );
		a11yContent.removeAttr( "id" ).find( "[id]" ).removeAttr( "id" );
		a11yContent.appendTo( this.liveRegion );

		function position( event ) {
			positionOption.of = event;
			if ( tooltip.is( ":hidden" ) ) {
				return;
			}
			tooltip.position( positionOption );
		}
		if ( this.options.track && event && /^mouse/.test( event.type ) ) {
			this._on( this.document, {
				mousemove: position
			} );

			// trigger once to override element-relative positioning
			position( event );
		} else {
			tooltip.position( $.extend( {
				of: target
			}, this.options.position ) );
		}

		tooltip.hide();

		this._show( tooltip, this.options.show );

		// Handle tracking tooltips that are shown with a delay (#8644). As soon
		// as the tooltip is visible, position the tooltip using the most recent
		// event.
		// Adds the check to add the timers only when both delay and track options are set (#14682)
		if ( this.options.track && this.options.show && this.options.show.delay ) {
			delayedShow = this.delayedShow = setInterval( function() {
				if ( tooltip.is( ":visible" ) ) {
					position( positionOption.of );
					clearInterval( delayedShow );
				}
			}, $.fx.interval );
		}

		this._trigger( "open", event, { tooltip: tooltip } );
	},

	_registerCloseHandlers: function( event, target ) {
		var events = {
			keyup: function( event ) {
				if ( event.keyCode === $.ui.keyCode.ESCAPE ) {
					var fakeEvent = $.Event( event );
					fakeEvent.currentTarget = target[ 0 ];
					this.close( fakeEvent, true );
				}
			}
		};

		// Only bind remove handler for delegated targets. Non-delegated
		// tooltips will handle this in destroy.
		if ( target[ 0 ] !== this.element[ 0 ] ) {
			events.remove = function() {
				this._removeTooltip( this._find( target ).tooltip );
			};
		}

		if ( !event || event.type === "mouseover" ) {
			events.mouseleave = "close";
		}
		if ( !event || event.type === "focusin" ) {
			events.focusout = "close";
		}
		this._on( true, target, events );
	},

	close: function( event ) {
		var tooltip,
			that = this,
			target = $( event ? event.currentTarget : this.element ),
			tooltipData = this._find( target );

		// The tooltip may already be closed
		if ( !tooltipData ) {

			// We set ui-tooltip-open immediately upon open (in open()), but only set the
			// additional data once there's actually content to show (in _open()). So even if the
			// tooltip doesn't have full data, we always remove ui-tooltip-open in case we're in
			// the period between open() and _open().
			target.removeData( "ui-tooltip-open" );
			return;
		}

		tooltip = tooltipData.tooltip;

		// Disabling closes the tooltip, so we need to track when we're closing
		// to avoid an infinite loop in case the tooltip becomes disabled on close
		if ( tooltipData.closing ) {
			return;
		}

		// Clear the interval for delayed tracking tooltips
		clearInterval( this.delayedShow );

		// Only set title if we had one before (see comment in _open())
		// If the title attribute has changed since open(), don't restore
		if ( target.data( "ui-tooltip-title" ) && !target.attr( "title" ) ) {
			target.attr( "title", target.data( "ui-tooltip-title" ) );
		}

		this._removeDescribedBy( target );

		tooltipData.hiding = true;
		tooltip.stop( true );
		this._hide( tooltip, this.options.hide, function() {
			that._removeTooltip( $( this ) );
		} );

		target.removeData( "ui-tooltip-open" );
		this._off( target, "mouseleave focusout keyup" );

		// Remove 'remove' binding only on delegated targets
		if ( target[ 0 ] !== this.element[ 0 ] ) {
			this._off( target, "remove" );
		}
		this._off( this.document, "mousemove" );

		if ( event && event.type === "mouseleave" ) {
			$.each( this.parents, function( id, parent ) {
				$( parent.element ).attr( "title", parent.title );
				delete that.parents[ id ];
			} );
		}

		tooltipData.closing = true;
		this._trigger( "close", event, { tooltip: tooltip } );
		if ( !tooltipData.hiding ) {
			tooltipData.closing = false;
		}
	},

	_tooltip: function( element ) {
		var tooltip = $( "<div>" ).attr( "role", "tooltip" ),
			content = $( "<div>" ).appendTo( tooltip ),
			id = tooltip.uniqueId().attr( "id" );

		this._addClass( content, "ui-tooltip-content" );
		this._addClass( tooltip, "ui-tooltip", "ui-widget ui-widget-content" );

		tooltip.appendTo( this._appendTo( element ) );

		return this.tooltips[ id ] = {
			element: element,
			tooltip: tooltip
		};
	},

	_find: function( target ) {
		var id = target.data( "ui-tooltip-id" );
		return id ? this.tooltips[ id ] : null;
	},

	_removeTooltip: function( tooltip ) {
		tooltip.remove();
		delete this.tooltips[ tooltip.attr( "id" ) ];
	},

	_appendTo: function( target ) {
		var element = target.closest( ".ui-front, dialog" );

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_destroy: function() {
		var that = this;

		// Close open tooltips
		$.each( this.tooltips, function( id, tooltipData ) {

			// Delegate to close method to handle common cleanup
			var event = $.Event( "blur" ),
				element = tooltipData.element;
			event.target = event.currentTarget = element[ 0 ];
			that.close( event, true );

			// Remove immediately; destroying an open tooltip doesn't use the
			// hide animation
			$( "#" + id ).remove();

			// Restore the title
			if ( element.data( "ui-tooltip-title" ) ) {

				// If the title attribute has changed since open(), don't restore
				if ( !element.attr( "title" ) ) {
					element.attr( "title", element.data( "ui-tooltip-title" ) );
				}
				element.removeData( "ui-tooltip-title" );
			}
		} );
		this.liveRegion.remove();
	}
} );

// DEPRECATED
// TODO: Switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat !== false ) {

	// Backcompat for tooltipClass option
	$.widget( "ui.tooltip", $.ui.tooltip, {
		options: {
			tooltipClass: null
		},
		_tooltip: function() {
			var tooltipData = this._superApply( arguments );
			if ( this.options.tooltipClass ) {
				tooltipData.tooltip.addClass( this.options.tooltipClass );
			}
			return tooltipData;
		}
	} );
}

var widgetsTooltip = $.ui.tooltip;




}));

/* -------------------------------------------------------------------------------------------------- */
/* jquery-ui-timepicker-addon.js */
/* File: js/machinata-core-bundle.js/jquery-ui-timepicker-addon.js */
/* -------------------------------------------------------------------------------------------------- */

/*
 * jQuery Timepicker Addon
 * By: Trent Richardson [http://trentrichardson.com]
 *
 * Copyright 2013 Trent Richardson
 * You may use this project under MIT license.
 * http://trentrichardson.com/Impromptu/MIT-LICENSE.txt
 */

(function (factory) {
	if (typeof define === 'function' && define.amd) {
		define(['jquery', 'jquery-ui'], factory);
	} else {
		factory(jQuery);
	}
}(function ($) {

	/*
	* Lets not redefine timepicker, Prevent "Uncaught RangeError: Maximum call stack size exceeded"
	*/
	$.ui.timepicker = $.ui.timepicker || {};
	if ($.ui.timepicker.version) {
		return;
	}

	/*
	* Extend jQueryUI, get it started with our version number
	*/
	$.extend($.ui, {
		timepicker: {
			version: "@@version"
		}
	});

	/*
	* Timepicker manager.
	* Use the singleton instance of this class, $.timepicker, to interact with the time picker.
	* Settings for (groups of) time pickers are maintained in an instance object,
	* allowing multiple different settings on the same page.
	*/
	var Timepicker = function () {
		this.regional = []; // Available regional settings, indexed by language code
		this.regional[''] = { // Default regional settings
			currentText: 'Now',
			closeText: 'Done',
			amNames: ['AM', 'A'],
			pmNames: ['PM', 'P'],
			timeFormat: 'HH:mm',
			timeSuffix: '',
			timeOnlyTitle: 'Choose Time',
			timeText: 'Time',
			hourText: 'Hour',
			minuteText: 'Minute',
			secondText: 'Second',
			millisecText: 'Millisecond',
			microsecText: 'Microsecond',
			timezoneText: 'Time Zone',
			isRTL: false
		};
		this._defaults = { // Global defaults for all the datetime picker instances
			showButtonPanel: true,
			timeOnly: false,
			timeOnlyShowDate: false,
			showHour: null,
			showMinute: null,
			showSecond: null,
			showMillisec: null,
			showMicrosec: null,
			showTimezone: null,
			showTime: true,
			stepHour: 1,
			stepMinute: 1,
			stepSecond: 1,
			stepMillisec: 1,
			stepMicrosec: 1,
			hour: 0,
			minute: 0,
			second: 0,
			millisec: 0,
			microsec: 0,
			timezone: null,
			hourMin: 0,
			minuteMin: 0,
			secondMin: 0,
			millisecMin: 0,
			microsecMin: 0,
			hourMax: 23,
			minuteMax: 59,
			secondMax: 59,
			millisecMax: 999,
			microsecMax: 999,
			minDateTime: null,
			maxDateTime: null,
			maxTime: null,
			minTime: null,
			onSelect: null,
			hourGrid: 0,
			minuteGrid: 0,
			secondGrid: 0,
			millisecGrid: 0,
			microsecGrid: 0,
			alwaysSetTime: true,
			separator: ' ',
			altFieldTimeOnly: true,
			altTimeFormat: null,
			altSeparator: null,
			altTimeSuffix: null,
			altRedirectFocus: true,
			pickerTimeFormat: null,
			pickerTimeSuffix: null,
			showTimepicker: true,
			timezoneList: null,
			addSliderAccess: false,
			sliderAccessArgs: null,
			controlType: 'slider',
			oneLine: false,
			defaultValue: null,
			parse: 'strict',
			afterInject: null
		};
		$.extend(this._defaults, this.regional['']);
	};

	$.extend(Timepicker.prototype, {
		$input: null,
		$altInput: null,
		$timeObj: null,
		inst: null,
		hour_slider: null,
		minute_slider: null,
		second_slider: null,
		millisec_slider: null,
		microsec_slider: null,
		timezone_select: null,
		maxTime: null,
		minTime: null,
		hour: 0,
		minute: 0,
		second: 0,
		millisec: 0,
		microsec: 0,
		timezone: null,
		hourMinOriginal: null,
		minuteMinOriginal: null,
		secondMinOriginal: null,
		millisecMinOriginal: null,
		microsecMinOriginal: null,
		hourMaxOriginal: null,
		minuteMaxOriginal: null,
		secondMaxOriginal: null,
		millisecMaxOriginal: null,
		microsecMaxOriginal: null,
		ampm: '',
		formattedDate: '',
		formattedTime: '',
		formattedDateTime: '',
		timezoneList: null,
		units: ['hour', 'minute', 'second', 'millisec', 'microsec'],
		support: {},
		control: null,

		/*
		* Override the default settings for all instances of the time picker.
		* @param  {Object} settings  object - the new settings to use as defaults (anonymous object)
		* @return {Object} the manager object
		*/
		setDefaults: function (settings) {
			extendRemove(this._defaults, settings || {});
			return this;
		},

		/*
		* Create a new Timepicker instance
		*/
		_newInst: function ($input, opts) {
			var tp_inst = new Timepicker(),
				inlineSettings = {},
				fns = {},
				overrides, i;

			for (var attrName in this._defaults) {
				if (this._defaults.hasOwnProperty(attrName)) {
					var attrValue = $input.attr('time:' + attrName);
					if (attrValue) {
						try {
							inlineSettings[attrName] = eval(attrValue);
						} catch (err) {
							inlineSettings[attrName] = attrValue;
						}
					}
				}
			}

			overrides = {
				beforeShow: function (input, dp_inst) {
					if ($.isFunction(tp_inst._defaults.evnts.beforeShow)) {
						return tp_inst._defaults.evnts.beforeShow.call($input[0], input, dp_inst, tp_inst);
					}
				},
				onChangeMonthYear: function (year, month, dp_inst) {
					// Update the time as well : this prevents the time from disappearing from the $input field.
					// tp_inst._updateDateTime(dp_inst);
					if ($.isFunction(tp_inst._defaults.evnts.onChangeMonthYear)) {
						tp_inst._defaults.evnts.onChangeMonthYear.call($input[0], year, month, dp_inst, tp_inst);
					}
				},
				onClose: function (dateText, dp_inst) {
					if (tp_inst.timeDefined === true && $input.val() !== '') {
						tp_inst._updateDateTime(dp_inst);
					}
					if ($.isFunction(tp_inst._defaults.evnts.onClose)) {
						tp_inst._defaults.evnts.onClose.call($input[0], dateText, dp_inst, tp_inst);
					}
				}
			};
			for (i in overrides) {
				if (overrides.hasOwnProperty(i)) {
					fns[i] = opts[i] || this._defaults[i] || null;
				}
			}

			tp_inst._defaults = $.extend({}, this._defaults, inlineSettings, opts, overrides, {
				evnts: fns,
				timepicker: tp_inst // add timepicker as a property of datepicker: $.datepicker._get(dp_inst, 'timepicker');
			});
			tp_inst.amNames = $.map(tp_inst._defaults.amNames, function (val) {
				return val.toUpperCase();
			});
			tp_inst.pmNames = $.map(tp_inst._defaults.pmNames, function (val) {
				return val.toUpperCase();
			});

			// detect which units are supported
			tp_inst.support = detectSupport(
					tp_inst._defaults.timeFormat +
					(tp_inst._defaults.pickerTimeFormat ? tp_inst._defaults.pickerTimeFormat : '') +
					(tp_inst._defaults.altTimeFormat ? tp_inst._defaults.altTimeFormat : ''));

			// controlType is string - key to our this._controls
			if (typeof(tp_inst._defaults.controlType) === 'string') {
				if (tp_inst._defaults.controlType === 'slider' && typeof($.ui.slider) === 'undefined') {
					tp_inst._defaults.controlType = 'select';
				}
				tp_inst.control = tp_inst._controls[tp_inst._defaults.controlType];
			}
			// controlType is an object and must implement create, options, value methods
			else {
				tp_inst.control = tp_inst._defaults.controlType;
			}

			// prep the timezone options
			var timezoneList = [-720, -660, -600, -570, -540, -480, -420, -360, -300, -270, -240, -210, -180, -120, -60,
					0, 60, 120, 180, 210, 240, 270, 300, 330, 345, 360, 390, 420, 480, 525, 540, 570, 600, 630, 660, 690, 720, 765, 780, 840];
			if (tp_inst._defaults.timezoneList !== null) {
				timezoneList = tp_inst._defaults.timezoneList;
			}
			var tzl = timezoneList.length, tzi = 0, tzv = null;
			if (tzl > 0 && typeof timezoneList[0] !== 'object') {
				for (; tzi < tzl; tzi++) {
					tzv = timezoneList[tzi];
					timezoneList[tzi] = { value: tzv, label: $.timepicker.timezoneOffsetString(tzv, tp_inst.support.iso8601) };
				}
			}
			tp_inst._defaults.timezoneList = timezoneList;

			// set the default units
			tp_inst.timezone = tp_inst._defaults.timezone !== null ? $.timepicker.timezoneOffsetNumber(tp_inst._defaults.timezone) :
							((new Date()).getTimezoneOffset() * -1);
			tp_inst.hour = tp_inst._defaults.hour < tp_inst._defaults.hourMin ? tp_inst._defaults.hourMin :
							tp_inst._defaults.hour > tp_inst._defaults.hourMax ? tp_inst._defaults.hourMax : tp_inst._defaults.hour;
			tp_inst.minute = tp_inst._defaults.minute < tp_inst._defaults.minuteMin ? tp_inst._defaults.minuteMin :
							tp_inst._defaults.minute > tp_inst._defaults.minuteMax ? tp_inst._defaults.minuteMax : tp_inst._defaults.minute;
			tp_inst.second = tp_inst._defaults.second < tp_inst._defaults.secondMin ? tp_inst._defaults.secondMin :
							tp_inst._defaults.second > tp_inst._defaults.secondMax ? tp_inst._defaults.secondMax : tp_inst._defaults.second;
			tp_inst.millisec = tp_inst._defaults.millisec < tp_inst._defaults.millisecMin ? tp_inst._defaults.millisecMin :
							tp_inst._defaults.millisec > tp_inst._defaults.millisecMax ? tp_inst._defaults.millisecMax : tp_inst._defaults.millisec;
			tp_inst.microsec = tp_inst._defaults.microsec < tp_inst._defaults.microsecMin ? tp_inst._defaults.microsecMin :
							tp_inst._defaults.microsec > tp_inst._defaults.microsecMax ? tp_inst._defaults.microsecMax : tp_inst._defaults.microsec;
			tp_inst.ampm = '';
			tp_inst.$input = $input;

			if (tp_inst._defaults.altField) {
				tp_inst.$altInput = $(tp_inst._defaults.altField);
				if (tp_inst._defaults.altRedirectFocus === true) {
					tp_inst.$altInput.css({
						cursor: 'pointer'
					}).focus(function () {
						$input.trigger("focus");
					});
				}
			}

			if (tp_inst._defaults.minDate === 0 || tp_inst._defaults.minDateTime === 0) {
				tp_inst._defaults.minDate = new Date();
			}
			if (tp_inst._defaults.maxDate === 0 || tp_inst._defaults.maxDateTime === 0) {
				tp_inst._defaults.maxDate = new Date();
			}

			// datepicker needs minDate/maxDate, timepicker needs minDateTime/maxDateTime..
			if (tp_inst._defaults.minDate !== undefined && tp_inst._defaults.minDate instanceof Date) {
				tp_inst._defaults.minDateTime = new Date(tp_inst._defaults.minDate.getTime());
			}
			if (tp_inst._defaults.minDateTime !== undefined && tp_inst._defaults.minDateTime instanceof Date) {
				tp_inst._defaults.minDate = new Date(tp_inst._defaults.minDateTime.getTime());
			}
			if (tp_inst._defaults.maxDate !== undefined && tp_inst._defaults.maxDate instanceof Date) {
				tp_inst._defaults.maxDateTime = new Date(tp_inst._defaults.maxDate.getTime());
			}
			if (tp_inst._defaults.maxDateTime !== undefined && tp_inst._defaults.maxDateTime instanceof Date) {
				tp_inst._defaults.maxDate = new Date(tp_inst._defaults.maxDateTime.getTime());
			}
			tp_inst.$input.bind('focus', function () {
				tp_inst._onFocus();
			});

			return tp_inst;
		},

		/*
		* add our sliders to the calendar
		*/
		_addTimePicker: function (dp_inst) {
			var currDT = $.trim((this.$altInput && this._defaults.altFieldTimeOnly) ? this.$input.val() + ' ' + this.$altInput.val() : this.$input.val());

			this.timeDefined = this._parseTime(currDT);
			this._limitMinMaxDateTime(dp_inst, false);
			this._injectTimePicker();
			this._afterInject();
		},

		/*
		* parse the time string from input value or _setTime
		*/
		_parseTime: function (timeString, withDate) {
			if (!this.inst) {
				this.inst = $.datepicker._getInst(this.$input[0]);
			}

			if (withDate || !this._defaults.timeOnly) {
				var dp_dateFormat = $.datepicker._get(this.inst, 'dateFormat');
				try {
					var parseRes = parseDateTimeInternal(dp_dateFormat, this._defaults.timeFormat, timeString, $.datepicker._getFormatConfig(this.inst), this._defaults);
					if (!parseRes.timeObj) {
						return false;
					}
					$.extend(this, parseRes.timeObj);
				} catch (err) {
					$.timepicker.log("Error parsing the date/time string: " + err +
									"\ndate/time string = " + timeString +
									"\ntimeFormat = " + this._defaults.timeFormat +
									"\ndateFormat = " + dp_dateFormat);
					return false;
				}
				return true;
			} else {
				var timeObj = $.datepicker.parseTime(this._defaults.timeFormat, timeString, this._defaults);
				if (!timeObj) {
					return false;
				}
				$.extend(this, timeObj);
				return true;
			}
		},

		/*
		* Handle callback option after injecting timepicker
		*/
		_afterInject: function() {
			var o = this.inst.settings;
			if ($.isFunction(o.afterInject)) {
				o.afterInject.call(this);
			}
		},

		/*
		* generate and inject html for timepicker into ui datepicker
		*/
		_injectTimePicker: function () {
			var $dp = this.inst.dpDiv,
				o = this.inst.settings,
				tp_inst = this,
				litem = '',
				uitem = '',
				show = null,
				max = {},
				gridSize = {},
				size = null,
				i = 0,
				l = 0;

			// Prevent displaying twice
			if ($dp.find("div.ui-timepicker-div").length === 0 && o.showTimepicker) {
				var noDisplay = ' ui_tpicker_unit_hide',
					html = '<div class="ui-timepicker-div' + (o.isRTL ? ' ui-timepicker-rtl' : '') + (o.oneLine && o.controlType === 'select' ? ' ui-timepicker-oneLine' : '') + '"><dl>' + '<dt class="ui_tpicker_time_label' + ((o.showTime) ? '' : noDisplay) + '">' + o.timeText + '</dt>' +
								'<dd class="ui_tpicker_time '+ ((o.showTime) ? '' : noDisplay) + '"><input class="ui_tpicker_time_input" ' + (o.timeInput ? '' : 'disabled') + '/></dd>';

				// Create the markup
				for (i = 0, l = this.units.length; i < l; i++) {
					litem = this.units[i];
					uitem = litem.substr(0, 1).toUpperCase() + litem.substr(1);
					show = o['show' + uitem] !== null ? o['show' + uitem] : this.support[litem];

					// Added by Peter Medeiros:
					// - Figure out what the hour/minute/second max should be based on the step values.
					// - Example: if stepMinute is 15, then minMax is 45.
					max[litem] = parseInt((o[litem + 'Max'] - ((o[litem + 'Max'] - o[litem + 'Min']) % o['step' + uitem])), 10);
					gridSize[litem] = 0;

					html += '<dt class="ui_tpicker_' + litem + '_label' + (show ? '' : noDisplay) + '">' + o[litem + 'Text'] + '</dt>' +
								'<dd class="ui_tpicker_' + litem + (show ? '' : noDisplay) + '"><div class="ui_tpicker_' + litem + '_slider' + (show ? '' : noDisplay) + '"></div>';

					if (show && o[litem + 'Grid'] > 0) {
						html += '<div style="padding-left: 1px"><table class="ui-tpicker-grid-label"><tr>';

						if (litem === 'hour') {
							for (var h = o[litem + 'Min']; h <= max[litem]; h += parseInt(o[litem + 'Grid'], 10)) {
								gridSize[litem]++;
								var tmph = $.datepicker.formatTime(this.support.ampm ? 'hht' : 'HH', {hour: h}, o);
								html += '<td data-for="' + litem + '">' + tmph + '</td>';
							}
						}
						else {
							for (var m = o[litem + 'Min']; m <= max[litem]; m += parseInt(o[litem + 'Grid'], 10)) {
								gridSize[litem]++;
								html += '<td data-for="' + litem + '">' + ((m < 10) ? '0' : '') + m + '</td>';
							}
						}

						html += '</tr></table></div>';
					}
					html += '</dd>';
				}

				// Timezone
				var showTz = o.showTimezone !== null ? o.showTimezone : this.support.timezone;
				html += '<dt class="ui_tpicker_timezone_label' + (showTz ? '' : noDisplay) + '">' + o.timezoneText + '</dt>';
				html += '<dd class="ui_tpicker_timezone' + (showTz ? '' : noDisplay) + '"></dd>';

				// Create the elements from string
				html += '</dl></div>';
				var $tp = $(html);

				// if we only want time picker...
				if (o.timeOnly === true) {
					$tp.prepend('<div class="ui-widget-header ui-helper-clearfix ui-corner-all">' + '<div class="ui-datepicker-title">' + o.timeOnlyTitle + '</div>' + '</div>');
					$dp.find('.ui-datepicker-header, .ui-datepicker-calendar').hide();
				}

				// add sliders, adjust grids, add events
				for (i = 0, l = tp_inst.units.length; i < l; i++) {
					litem = tp_inst.units[i];
					uitem = litem.substr(0, 1).toUpperCase() + litem.substr(1);
					show = o['show' + uitem] !== null ? o['show' + uitem] : this.support[litem];

					// add the slider
					tp_inst[litem + '_slider'] = tp_inst.control.create(tp_inst, $tp.find('.ui_tpicker_' + litem + '_slider'), litem, tp_inst[litem], o[litem + 'Min'], max[litem], o['step' + uitem]);

					// adjust the grid and add click event
					if (show && o[litem + 'Grid'] > 0) {
						size = 100 * gridSize[litem] * o[litem + 'Grid'] / (max[litem] - o[litem + 'Min']);
						$tp.find('.ui_tpicker_' + litem + ' table').css({
							width: size + "%",
							marginLeft: o.isRTL ? '0' : ((size / (-2 * gridSize[litem])) + "%"),
							marginRight: o.isRTL ? ((size / (-2 * gridSize[litem])) + "%") : '0',
							borderCollapse: 'collapse'
						}).find("td").click(function (e) {
								var $t = $(this),
									h = $t.html(),
									n = parseInt(h.replace(/[^0-9]/g), 10),
									ap = h.replace(/[^apm]/ig),
									f = $t.data('for'); // loses scope, so we use data-for

								if (f === 'hour') {
									if (ap.indexOf('p') !== -1 && n < 12) {
										n += 12;
									}
									else {
										if (ap.indexOf('a') !== -1 && n === 12) {
											n = 0;
										}
									}
								}

								tp_inst.control.value(tp_inst, tp_inst[f + '_slider'], litem, n);

								tp_inst._onTimeChange();
								tp_inst._onSelectHandler();
							}).css({
								cursor: 'pointer',
								width: (100 / gridSize[litem]) + '%',
								textAlign: 'center',
								overflow: 'hidden'
							});
					} // end if grid > 0
				} // end for loop

				// Add timezone options
				this.timezone_select = $tp.find('.ui_tpicker_timezone').append('<select></select>').find("select");
				$.fn.append.apply(this.timezone_select,
				$.map(o.timezoneList, function (val, idx) {
					return $("<option />").val(typeof val === "object" ? val.value : val).text(typeof val === "object" ? val.label : val);
				}));
				if (typeof(this.timezone) !== "undefined" && this.timezone !== null && this.timezone !== "") {
					var local_timezone = (new Date(this.inst.selectedYear, this.inst.selectedMonth, this.inst.selectedDay, 12)).getTimezoneOffset() * -1;
					if (local_timezone === this.timezone) {
						selectLocalTimezone(tp_inst);
					} else {
						this.timezone_select.val(this.timezone);
					}
				} else {
					if (typeof(this.hour) !== "undefined" && this.hour !== null && this.hour !== "") {
						this.timezone_select.val(o.timezone);
					} else {
						selectLocalTimezone(tp_inst);
					}
				}
				this.timezone_select.change(function () {
					tp_inst._onTimeChange();
					tp_inst._onSelectHandler();
					tp_inst._afterInject();
				});
				// End timezone options

				// inject timepicker into datepicker
				var $buttonPanel = $dp.find('.ui-datepicker-buttonpane');
				if ($buttonPanel.length) {
					$buttonPanel.before($tp);
				} else {
					$dp.append($tp);
				}

				this.$timeObj = $tp.find('.ui_tpicker_time_input');
				this.$timeObj.change(function () {
					var timeFormat = tp_inst.inst.settings.timeFormat;
					var parsedTime = $.datepicker.parseTime(timeFormat, this.value);
					var update = new Date();
					if (parsedTime) {
						update.setHours(parsedTime.hour);
						update.setMinutes(parsedTime.minute);
						update.setSeconds(parsedTime.second);
						$.datepicker._setTime(tp_inst.inst, update);
					} else {
						this.value = tp_inst.formattedTime;
						this.blur();
					}
				});

				if (this.inst !== null) {
					var timeDefined = this.timeDefined;
					this._onTimeChange();
					this.timeDefined = timeDefined;
				}

				// slideAccess integration: http://trentrichardson.com/2011/11/11/jquery-ui-sliders-and-touch-accessibility/
				if (this._defaults.addSliderAccess) {
					var sliderAccessArgs = this._defaults.sliderAccessArgs,
						rtl = this._defaults.isRTL;
					sliderAccessArgs.isRTL = rtl;

					setTimeout(function () { // fix for inline mode
						if ($tp.find('.ui-slider-access').length === 0) {
							$tp.find('.ui-slider:visible').sliderAccess(sliderAccessArgs);

							// fix any grids since sliders are shorter
							var sliderAccessWidth = $tp.find('.ui-slider-access:eq(0)').outerWidth(true);
							if (sliderAccessWidth) {
								$tp.find('table:visible').each(function () {
									var $g = $(this),
										oldWidth = $g.outerWidth(),
										oldMarginLeft = $g.css(rtl ? 'marginRight' : 'marginLeft').toString().replace('%', ''),
										newWidth = oldWidth - sliderAccessWidth,
										newMarginLeft = ((oldMarginLeft * newWidth) / oldWidth) + '%',
										css = { width: newWidth, marginRight: 0, marginLeft: 0 };
									css[rtl ? 'marginRight' : 'marginLeft'] = newMarginLeft;
									$g.css(css);
								});
							}
						}
					}, 10);
				}
				// end slideAccess integration

				tp_inst._limitMinMaxDateTime(this.inst, true);
			}
		},

		/*
		* This function tries to limit the ability to go outside the
		* min/max date range
		*/
		_limitMinMaxDateTime: function (dp_inst, adjustSliders) {
			var o = this._defaults,
				dp_date = new Date(dp_inst.selectedYear, dp_inst.selectedMonth, dp_inst.selectedDay);

			if (!this._defaults.showTimepicker) {
				return;
			} // No time so nothing to check here

			if ($.datepicker._get(dp_inst, 'minDateTime') !== null && $.datepicker._get(dp_inst, 'minDateTime') !== undefined && dp_date) {
				var minDateTime = $.datepicker._get(dp_inst, 'minDateTime'),
					minDateTimeDate = new Date(minDateTime.getFullYear(), minDateTime.getMonth(), minDateTime.getDate(), 0, 0, 0, 0);

				if (this.hourMinOriginal === null || this.minuteMinOriginal === null || this.secondMinOriginal === null || this.millisecMinOriginal === null || this.microsecMinOriginal === null) {
					this.hourMinOriginal = o.hourMin;
					this.minuteMinOriginal = o.minuteMin;
					this.secondMinOriginal = o.secondMin;
					this.millisecMinOriginal = o.millisecMin;
					this.microsecMinOriginal = o.microsecMin;
				}

				if (dp_inst.settings.timeOnly || minDateTimeDate.getTime() === dp_date.getTime()) {
					this._defaults.hourMin = minDateTime.getHours();
					if (this.hour <= this._defaults.hourMin) {
						this.hour = this._defaults.hourMin;
						this._defaults.minuteMin = minDateTime.getMinutes();
						if (this.minute <= this._defaults.minuteMin) {
							this.minute = this._defaults.minuteMin;
							this._defaults.secondMin = minDateTime.getSeconds();
							if (this.second <= this._defaults.secondMin) {
								this.second = this._defaults.secondMin;
								this._defaults.millisecMin = minDateTime.getMilliseconds();
								if (this.millisec <= this._defaults.millisecMin) {
									this.millisec = this._defaults.millisecMin;
									this._defaults.microsecMin = minDateTime.getMicroseconds();
								} else {
									if (this.microsec < this._defaults.microsecMin) {
										this.microsec = this._defaults.microsecMin;
									}
									this._defaults.microsecMin = this.microsecMinOriginal;
								}
							} else {
								this._defaults.millisecMin = this.millisecMinOriginal;
								this._defaults.microsecMin = this.microsecMinOriginal;
							}
						} else {
							this._defaults.secondMin = this.secondMinOriginal;
							this._defaults.millisecMin = this.millisecMinOriginal;
							this._defaults.microsecMin = this.microsecMinOriginal;
						}
					} else {
						this._defaults.minuteMin = this.minuteMinOriginal;
						this._defaults.secondMin = this.secondMinOriginal;
						this._defaults.millisecMin = this.millisecMinOriginal;
						this._defaults.microsecMin = this.microsecMinOriginal;
					}
				} else {
					this._defaults.hourMin = this.hourMinOriginal;
					this._defaults.minuteMin = this.minuteMinOriginal;
					this._defaults.secondMin = this.secondMinOriginal;
					this._defaults.millisecMin = this.millisecMinOriginal;
					this._defaults.microsecMin = this.microsecMinOriginal;
				}
			}

			if ($.datepicker._get(dp_inst, 'maxDateTime') !== null && $.datepicker._get(dp_inst, 'maxDateTime') !== undefined && dp_date) {
				var maxDateTime = $.datepicker._get(dp_inst, 'maxDateTime'),
					maxDateTimeDate = new Date(maxDateTime.getFullYear(), maxDateTime.getMonth(), maxDateTime.getDate(), 0, 0, 0, 0);

				if (this.hourMaxOriginal === null || this.minuteMaxOriginal === null || this.secondMaxOriginal === null || this.millisecMaxOriginal === null) {
					this.hourMaxOriginal = o.hourMax;
					this.minuteMaxOriginal = o.minuteMax;
					this.secondMaxOriginal = o.secondMax;
					this.millisecMaxOriginal = o.millisecMax;
					this.microsecMaxOriginal = o.microsecMax;
				}

				if (dp_inst.settings.timeOnly || maxDateTimeDate.getTime() === dp_date.getTime()) {
					this._defaults.hourMax = maxDateTime.getHours();
					if (this.hour >= this._defaults.hourMax) {
						this.hour = this._defaults.hourMax;
						this._defaults.minuteMax = maxDateTime.getMinutes();
						if (this.minute >= this._defaults.minuteMax) {
							this.minute = this._defaults.minuteMax;
							this._defaults.secondMax = maxDateTime.getSeconds();
							if (this.second >= this._defaults.secondMax) {
								this.second = this._defaults.secondMax;
								this._defaults.millisecMax = maxDateTime.getMilliseconds();
								if (this.millisec >= this._defaults.millisecMax) {
									this.millisec = this._defaults.millisecMax;
									this._defaults.microsecMax = maxDateTime.getMicroseconds();
								} else {
									if (this.microsec > this._defaults.microsecMax) {
										this.microsec = this._defaults.microsecMax;
									}
									this._defaults.microsecMax = this.microsecMaxOriginal;
								}
							} else {
								this._defaults.millisecMax = this.millisecMaxOriginal;
								this._defaults.microsecMax = this.microsecMaxOriginal;
							}
						} else {
							this._defaults.secondMax = this.secondMaxOriginal;
							this._defaults.millisecMax = this.millisecMaxOriginal;
							this._defaults.microsecMax = this.microsecMaxOriginal;
						}
					} else {
						this._defaults.minuteMax = this.minuteMaxOriginal;
						this._defaults.secondMax = this.secondMaxOriginal;
						this._defaults.millisecMax = this.millisecMaxOriginal;
						this._defaults.microsecMax = this.microsecMaxOriginal;
					}
				} else {
					this._defaults.hourMax = this.hourMaxOriginal;
					this._defaults.minuteMax = this.minuteMaxOriginal;
					this._defaults.secondMax = this.secondMaxOriginal;
					this._defaults.millisecMax = this.millisecMaxOriginal;
					this._defaults.microsecMax = this.microsecMaxOriginal;
				}
			}

			if (dp_inst.settings.minTime!==null) {
				var tempMinTime=new Date("01/01/1970 " + dp_inst.settings.minTime);
				if (this.hour<tempMinTime.getHours()) {
					this.hour=this._defaults.hourMin=tempMinTime.getHours();
					this.minute=this._defaults.minuteMin=tempMinTime.getMinutes();
				} else if (this.hour===tempMinTime.getHours() && this.minute<tempMinTime.getMinutes()) {
					this.minute=this._defaults.minuteMin=tempMinTime.getMinutes();
				} else {
					if (this._defaults.hourMin<tempMinTime.getHours()) {
						this._defaults.hourMin=tempMinTime.getHours();
						this._defaults.minuteMin=tempMinTime.getMinutes();
					} else if (this._defaults.hourMin===tempMinTime.getHours()===this.hour && this._defaults.minuteMin<tempMinTime.getMinutes()) {
						this._defaults.minuteMin=tempMinTime.getMinutes();
					} else {
						this._defaults.minuteMin=0;
					}
				}
			}

			if (dp_inst.settings.maxTime!==null) {
				var tempMaxTime=new Date("01/01/1970 " + dp_inst.settings.maxTime);
				if (this.hour>tempMaxTime.getHours()) {
					this.hour=this._defaults.hourMax=tempMaxTime.getHours();
					this.minute=this._defaults.minuteMax=tempMaxTime.getMinutes();
				} else if (this.hour===tempMaxTime.getHours() && this.minute>tempMaxTime.getMinutes()) {
					this.minute=this._defaults.minuteMax=tempMaxTime.getMinutes();
				} else {
					if (this._defaults.hourMax>tempMaxTime.getHours()) {
						this._defaults.hourMax=tempMaxTime.getHours();
						this._defaults.minuteMax=tempMaxTime.getMinutes();
					} else if (this._defaults.hourMax===tempMaxTime.getHours()===this.hour && this._defaults.minuteMax>tempMaxTime.getMinutes()) {
						this._defaults.minuteMax=tempMaxTime.getMinutes();
					} else {
						this._defaults.minuteMax=59;
					}
				}
			}

			if (adjustSliders !== undefined && adjustSliders === true) {
				var hourMax = parseInt((this._defaults.hourMax - ((this._defaults.hourMax - this._defaults.hourMin) % this._defaults.stepHour)), 10),
					minMax = parseInt((this._defaults.minuteMax - ((this._defaults.minuteMax - this._defaults.minuteMin) % this._defaults.stepMinute)), 10),
					secMax = parseInt((this._defaults.secondMax - ((this._defaults.secondMax - this._defaults.secondMin) % this._defaults.stepSecond)), 10),
					millisecMax = parseInt((this._defaults.millisecMax - ((this._defaults.millisecMax - this._defaults.millisecMin) % this._defaults.stepMillisec)), 10),
					microsecMax = parseInt((this._defaults.microsecMax - ((this._defaults.microsecMax - this._defaults.microsecMin) % this._defaults.stepMicrosec)), 10);

				if (this.hour_slider) {
					this.control.options(this, this.hour_slider, 'hour', { min: this._defaults.hourMin, max: hourMax, step: this._defaults.stepHour });
					this.control.value(this, this.hour_slider, 'hour', this.hour - (this.hour % this._defaults.stepHour));
				}
				if (this.minute_slider) {
					this.control.options(this, this.minute_slider, 'minute', { min: this._defaults.minuteMin, max: minMax, step: this._defaults.stepMinute });
					this.control.value(this, this.minute_slider, 'minute', this.minute - (this.minute % this._defaults.stepMinute));
				}
				if (this.second_slider) {
					this.control.options(this, this.second_slider, 'second', { min: this._defaults.secondMin, max: secMax, step: this._defaults.stepSecond });
					this.control.value(this, this.second_slider, 'second', this.second - (this.second % this._defaults.stepSecond));
				}
				if (this.millisec_slider) {
					this.control.options(this, this.millisec_slider, 'millisec', { min: this._defaults.millisecMin, max: millisecMax, step: this._defaults.stepMillisec });
					this.control.value(this, this.millisec_slider, 'millisec', this.millisec - (this.millisec % this._defaults.stepMillisec));
				}
				if (this.microsec_slider) {
					this.control.options(this, this.microsec_slider, 'microsec', { min: this._defaults.microsecMin, max: microsecMax, step: this._defaults.stepMicrosec });
					this.control.value(this, this.microsec_slider, 'microsec', this.microsec - (this.microsec % this._defaults.stepMicrosec));
				}
			}

		},

		/*
		* when a slider moves, set the internal time...
		* on time change is also called when the time is updated in the text field
		*/
		_onTimeChange: function () {
			if (!this._defaults.showTimepicker) {
                                return;
			}
			var hour = (this.hour_slider) ? this.control.value(this, this.hour_slider, 'hour') : false,
				minute = (this.minute_slider) ? this.control.value(this, this.minute_slider, 'minute') : false,
				second = (this.second_slider) ? this.control.value(this, this.second_slider, 'second') : false,
				millisec = (this.millisec_slider) ? this.control.value(this, this.millisec_slider, 'millisec') : false,
				microsec = (this.microsec_slider) ? this.control.value(this, this.microsec_slider, 'microsec') : false,
				timezone = (this.timezone_select) ? this.timezone_select.val() : false,
				o = this._defaults,
				pickerTimeFormat = o.pickerTimeFormat || o.timeFormat,
				pickerTimeSuffix = o.pickerTimeSuffix || o.timeSuffix;

			if (typeof(hour) === 'object') {
				hour = false;
			}
			if (typeof(minute) === 'object') {
				minute = false;
			}
			if (typeof(second) === 'object') {
				second = false;
			}
			if (typeof(millisec) === 'object') {
				millisec = false;
			}
			if (typeof(microsec) === 'object') {
				microsec = false;
			}
			if (typeof(timezone) === 'object') {
				timezone = false;
			}

			if (hour !== false) {
				hour = parseInt(hour, 10);
			}
			if (minute !== false) {
				minute = parseInt(minute, 10);
			}
			if (second !== false) {
				second = parseInt(second, 10);
			}
			if (millisec !== false) {
				millisec = parseInt(millisec, 10);
			}
			if (microsec !== false) {
				microsec = parseInt(microsec, 10);
			}
			if (timezone !== false) {
				timezone = timezone.toString();
			}

			var ampm = o[hour < 12 ? 'amNames' : 'pmNames'][0];

			// If the update was done in the input field, the input field should not be updated.
			// If the update was done using the sliders, update the input field.
			var hasChanged = (
						hour !== parseInt(this.hour,10) || // sliders should all be numeric
						minute !== parseInt(this.minute,10) ||
						second !== parseInt(this.second,10) ||
						millisec !== parseInt(this.millisec,10) ||
						microsec !== parseInt(this.microsec,10) ||
						(this.ampm.length > 0 && (hour < 12) !== ($.inArray(this.ampm.toUpperCase(), this.amNames) !== -1)) ||
						(this.timezone !== null && timezone !== this.timezone.toString()) // could be numeric or "EST" format, so use toString()
					);

			if (hasChanged) {

				if (hour !== false) {
					this.hour = hour;
				}
				if (minute !== false) {
					this.minute = minute;
				}
				if (second !== false) {
					this.second = second;
				}
				if (millisec !== false) {
					this.millisec = millisec;
				}
				if (microsec !== false) {
					this.microsec = microsec;
				}
				if (timezone !== false) {
					this.timezone = timezone;
				}

				if (!this.inst) {
					this.inst = $.datepicker._getInst(this.$input[0]);
				}

				this._limitMinMaxDateTime(this.inst, true);
			}
			if (this.support.ampm) {
				this.ampm = ampm;
			}

			// Updates the time within the timepicker
			this.formattedTime = $.datepicker.formatTime(o.timeFormat, this, o);
			if (this.$timeObj) {
				if (pickerTimeFormat === o.timeFormat) {
					this.$timeObj.val(this.formattedTime + pickerTimeSuffix);
				}
				else {
					this.$timeObj.val($.datepicker.formatTime(pickerTimeFormat, this, o) + pickerTimeSuffix);
				}
				if (this.$timeObj[0].setSelectionRange) {
					var sPos = this.$timeObj[0].selectionStart;
					var ePos = this.$timeObj[0].selectionEnd;
					this.$timeObj[0].setSelectionRange(sPos, ePos);
				}
			}

			this.timeDefined = true;
			if (hasChanged) {
				this._updateDateTime();
				//this.$input.focus(); // may automatically open the picker on setDate
			}
		},

		/*
		* call custom onSelect.
		* bind to sliders slidestop, and grid click.
		*/
		_onSelectHandler: function () {
			var onSelect = this._defaults.onSelect || this.inst.settings.onSelect;
			var inputEl = this.$input ? this.$input[0] : null;
			if (onSelect && inputEl) {
				onSelect.apply(inputEl, [this.formattedDateTime, this]);
			}
		},

		/*
		* update our input with the new date time..
		*/
		_updateDateTime: function (dp_inst) {
			dp_inst = this.inst || dp_inst;
			var dtTmp = (dp_inst.currentYear > 0?
							new Date(dp_inst.currentYear, dp_inst.currentMonth, dp_inst.currentDay) :
							new Date(dp_inst.selectedYear, dp_inst.selectedMonth, dp_inst.selectedDay)),
				dt = $.datepicker._daylightSavingAdjust(dtTmp),
				//dt = $.datepicker._daylightSavingAdjust(new Date(dp_inst.selectedYear, dp_inst.selectedMonth, dp_inst.selectedDay)),
				//dt = $.datepicker._daylightSavingAdjust(new Date(dp_inst.currentYear, dp_inst.currentMonth, dp_inst.currentDay)),
				dateFmt = $.datepicker._get(dp_inst, 'dateFormat'),
				formatCfg = $.datepicker._getFormatConfig(dp_inst),
				timeAvailable = dt !== null && this.timeDefined;
			this.formattedDate = $.datepicker.formatDate(dateFmt, (dt === null ? new Date() : dt), formatCfg);
			var formattedDateTime = this.formattedDate;

			// if a slider was changed but datepicker doesn't have a value yet, set it
			if (dp_inst.lastVal === "") {
                dp_inst.currentYear = dp_inst.selectedYear;
                dp_inst.currentMonth = dp_inst.selectedMonth;
                dp_inst.currentDay = dp_inst.selectedDay;
            }

			/*
			* remove following lines to force every changes in date picker to change the input value
			* Bug descriptions: when an input field has a default value, and click on the field to pop up the date picker.
			* If the user manually empty the value in the input field, the date picker will never change selected value.
			*/
			//if (dp_inst.lastVal !== undefined && (dp_inst.lastVal.length > 0 && this.$input.val().length === 0)) {
			//	return;
			//}

			if (this._defaults.timeOnly === true && this._defaults.timeOnlyShowDate === false) {
				formattedDateTime = this.formattedTime;
			} else if ((this._defaults.timeOnly !== true && (this._defaults.alwaysSetTime || timeAvailable)) || (this._defaults.timeOnly === true && this._defaults.timeOnlyShowDate === true)) {
				formattedDateTime += this._defaults.separator + this.formattedTime + this._defaults.timeSuffix;
			}

			this.formattedDateTime = formattedDateTime;

			if (!this._defaults.showTimepicker) {
				this.$input.val(this.formattedDate);
			} else if (this.$altInput && this._defaults.timeOnly === false && this._defaults.altFieldTimeOnly === true) {
				this.$altInput.val(this.formattedTime);
				this.$input.val(this.formattedDate);
			} else if (this.$altInput) {
				this.$input.val(formattedDateTime);
				var altFormattedDateTime = '',
					altSeparator = this._defaults.altSeparator !== null ? this._defaults.altSeparator : this._defaults.separator,
					altTimeSuffix = this._defaults.altTimeSuffix !== null ? this._defaults.altTimeSuffix : this._defaults.timeSuffix;

				if (!this._defaults.timeOnly) {
					if (this._defaults.altFormat) {
						altFormattedDateTime = $.datepicker.formatDate(this._defaults.altFormat, (dt === null ? new Date() : dt), formatCfg);
					}
					else {
						altFormattedDateTime = this.formattedDate;
					}

					if (altFormattedDateTime) {
						altFormattedDateTime += altSeparator;
					}
				}

				if (this._defaults.altTimeFormat !== null) {
					altFormattedDateTime += $.datepicker.formatTime(this._defaults.altTimeFormat, this, this._defaults) + altTimeSuffix;
				}
				else {
					altFormattedDateTime += this.formattedTime + altTimeSuffix;
				}
				this.$altInput.val(altFormattedDateTime);
			} else {
				this.$input.val(formattedDateTime);
			}

			this.$input.trigger("change");
		},

		_onFocus: function () {
			if (!this.$input.val() && this._defaults.defaultValue) {
				this.$input.val(this._defaults.defaultValue);
				var inst = $.datepicker._getInst(this.$input.get(0)),
					tp_inst = $.datepicker._get(inst, 'timepicker');
				if (tp_inst) {
					if (tp_inst._defaults.timeOnly && (inst.input.val() !== inst.lastVal)) {
						try {
							$.datepicker._updateDatepicker(inst);
						} catch (err) {
							$.timepicker.log(err);
						}
					}
				}
			}
		},

		/*
		* Small abstraction to control types
		* We can add more, just be sure to follow the pattern: create, options, value
		*/
		_controls: {
			// slider methods
			slider: {
				create: function (tp_inst, obj, unit, val, min, max, step) {
					var rtl = tp_inst._defaults.isRTL; // if rtl go -60->0 instead of 0->60
					return obj.prop('slide', null).slider({
						orientation: "horizontal",
						value: rtl ? val * -1 : val,
						min: rtl ? max * -1 : min,
						max: rtl ? min * -1 : max,
						step: step,
						slide: function (event, ui) {
							tp_inst.control.value(tp_inst, $(this), unit, rtl ? ui.value * -1 : ui.value);
							tp_inst._onTimeChange();
						},
						stop: function (event, ui) {
							tp_inst._onSelectHandler();
						}
					});
				},
				options: function (tp_inst, obj, unit, opts, val) {
					if (tp_inst._defaults.isRTL) {
						if (typeof(opts) === 'string') {
							if (opts === 'min' || opts === 'max') {
								if (val !== undefined) {
									return obj.slider(opts, val * -1);
								}
								return Math.abs(obj.slider(opts));
							}
							return obj.slider(opts);
						}
						var min = opts.min,
							max = opts.max;
						opts.min = opts.max = null;
						if (min !== undefined) {
							opts.max = min * -1;
						}
						if (max !== undefined) {
							opts.min = max * -1;
						}
						return obj.slider(opts);
					}
					if (typeof(opts) === 'string' && val !== undefined) {
						return obj.slider(opts, val);
					}
					return obj.slider(opts);
				},
				value: function (tp_inst, obj, unit, val) {
					if (tp_inst._defaults.isRTL) {
						if (val !== undefined) {
							return obj.slider('value', val * -1);
						}
						return Math.abs(obj.slider('value'));
					}
					if (val !== undefined) {
						return obj.slider('value', val);
					}
					return obj.slider('value');
				}
			},
			// select methods
			select: {
				create: function (tp_inst, obj, unit, val, min, max, step) {
					var sel = '<select class="ui-timepicker-select ui-state-default ui-corner-all" data-unit="' + unit + '" data-min="' + min + '" data-max="' + max + '" data-step="' + step + '">',
						format = tp_inst._defaults.pickerTimeFormat || tp_inst._defaults.timeFormat;

					for (var i = min; i <= max; i += step) {
						sel += '<option value="' + i + '"' + (i === val ? ' selected' : '') + '>';
						if (unit === 'hour') {
							sel += $.datepicker.formatTime($.trim(format.replace(/[^ht ]/ig, '')), {hour: i}, tp_inst._defaults);
						}
						else if (unit === 'millisec' || unit === 'microsec' || i >= 10) { sel += i; }
						else {sel += '0' + i.toString(); }
						sel += '</option>';
					}
					sel += '</select>';

					obj.children('select').remove();

					$(sel).appendTo(obj).change(function (e) {
						tp_inst._onTimeChange();
						tp_inst._onSelectHandler();
						tp_inst._afterInject();
					});

					return obj;
				},
				options: function (tp_inst, obj, unit, opts, val) {
					var o = {},
						$t = obj.children('select');
					if (typeof(opts) === 'string') {
						if (val === undefined) {
							return $t.data(opts);
						}
						o[opts] = val;
					}
					else { o = opts; }
					return tp_inst.control.create(tp_inst, obj, $t.data('unit'), $t.val(), o.min>=0 ? o.min : $t.data('min'), o.max || $t.data('max'), o.step || $t.data('step'));
				},
				value: function (tp_inst, obj, unit, val) {
					var $t = obj.children('select');
					if (val !== undefined) {
						return $t.val(val);
					}
					return $t.val();
				}
			}
		} // end _controls

	});

	$.fn.extend({
		/*
		* shorthand just to use timepicker.
		*/
		timepicker: function (o) {
			o = o || {};
			var tmp_args = Array.prototype.slice.call(arguments);

			if (typeof o === 'object') {
				tmp_args[0] = $.extend(o, {
					timeOnly: true
				});
			}

			return $(this).each(function () {
				$.fn.datetimepicker.apply($(this), tmp_args);
			});
		},

		/*
		* extend timepicker to datepicker
		*/
		datetimepicker: function (o) {
			o = o || {};
			var tmp_args = arguments;

			if (typeof(o) === 'string') {
				if (o === 'getDate'  || (o === 'option' && tmp_args.length === 2 && typeof (tmp_args[1]) === 'string')) {
					return $.fn.datepicker.apply($(this[0]), tmp_args);
				} else {
					return this.each(function () {
						var $t = $(this);
						$t.datepicker.apply($t, tmp_args);
					});
				}
			} else {
				return this.each(function () {
					var $t = $(this);
					$t.datepicker($.timepicker._newInst($t, o)._defaults);
				});
			}
		}
	});

	/*
	* Public Utility to parse date and time
	*/
	$.datepicker.parseDateTime = function (dateFormat, timeFormat, dateTimeString, dateSettings, timeSettings) {
		var parseRes = parseDateTimeInternal(dateFormat, timeFormat, dateTimeString, dateSettings, timeSettings);
		if (parseRes.timeObj) {
			var t = parseRes.timeObj;
			parseRes.date.setHours(t.hour, t.minute, t.second, t.millisec);
			parseRes.date.setMicroseconds(t.microsec);
		}

		return parseRes.date;
	};

	/*
	* Public utility to parse time
	*/
	$.datepicker.parseTime = function (timeFormat, timeString, options) {
		var o = extendRemove(extendRemove({}, $.timepicker._defaults), options || {}),
			iso8601 = (timeFormat.replace(/\'.*?\'/g, '').indexOf('Z') !== -1);

		// Strict parse requires the timeString to match the timeFormat exactly
		var strictParse = function (f, s, o) {

			// pattern for standard and localized AM/PM markers
			var getPatternAmpm = function (amNames, pmNames) {
				var markers = [];
				if (amNames) {
					$.merge(markers, amNames);
				}
				if (pmNames) {
					$.merge(markers, pmNames);
				}
				markers = $.map(markers, function (val) {
					return val.replace(/[.*+?|()\[\]{}\\]/g, '\\$&');
				});
				return '(' + markers.join('|') + ')?';
			};

			// figure out position of time elements.. cause js cant do named captures
			var getFormatPositions = function (timeFormat) {
				var finds = timeFormat.toLowerCase().match(/(h{1,2}|m{1,2}|s{1,2}|l{1}|c{1}|t{1,2}|z|'.*?')/g),
					orders = {
						h: -1,
						m: -1,
						s: -1,
						l: -1,
						c: -1,
						t: -1,
						z: -1
					};

				if (finds) {
					for (var i = 0; i < finds.length; i++) {
						if (orders[finds[i].toString().charAt(0)] === -1) {
							orders[finds[i].toString().charAt(0)] = i + 1;
						}
					}
				}
				return orders;
			};

			var regstr = '^' + f.toString()
					.replace(/([hH]{1,2}|mm?|ss?|[tT]{1,2}|[zZ]|[lc]|'.*?')/g, function (match) {
							var ml = match.length;
							switch (match.charAt(0).toLowerCase()) {
							case 'h':
								return ml === 1 ? '(\\d?\\d)' : '(\\d{' + ml + '})';
							case 'm':
								return ml === 1 ? '(\\d?\\d)' : '(\\d{' + ml + '})';
							case 's':
								return ml === 1 ? '(\\d?\\d)' : '(\\d{' + ml + '})';
							case 'l':
								return '(\\d?\\d?\\d)';
							case 'c':
								return '(\\d?\\d?\\d)';
							case 'z':
								return '(z|[-+]\\d\\d:?\\d\\d|\\S+)?';
							case 't':
								return getPatternAmpm(o.amNames, o.pmNames);
							default:    // literal escaped in quotes
								return '(' + match.replace(/\'/g, "").replace(/(\.|\$|\^|\\|\/|\(|\)|\[|\]|\?|\+|\*)/g, function (m) { return "\\" + m; }) + ')?';
							}
						})
					.replace(/\s/g, '\\s?') +
					o.timeSuffix + '$',
				order = getFormatPositions(f),
				ampm = '',
				treg;

			treg = s.match(new RegExp(regstr, 'i'));

			var resTime = {
				hour: 0,
				minute: 0,
				second: 0,
				millisec: 0,
				microsec: 0
			};

			if (treg) {
				if (order.t !== -1) {
					if (treg[order.t] === undefined || treg[order.t].length === 0) {
						ampm = '';
						resTime.ampm = '';
					} else {
						ampm = $.inArray(treg[order.t].toUpperCase(), $.map(o.amNames, function (x,i) { return x.toUpperCase(); })) !== -1 ? 'AM' : 'PM';
						resTime.ampm = o[ampm === 'AM' ? 'amNames' : 'pmNames'][0];
					}
				}

				if (order.h !== -1) {
					if (ampm === 'AM' && treg[order.h] === '12') {
						resTime.hour = 0; // 12am = 0 hour
					} else {
						if (ampm === 'PM' && treg[order.h] !== '12') {
							resTime.hour = parseInt(treg[order.h], 10) + 12; // 12pm = 12 hour, any other pm = hour + 12
						} else {
							resTime.hour = Number(treg[order.h]);
						}
					}
				}

				if (order.m !== -1) {
					resTime.minute = Number(treg[order.m]);
				}
				if (order.s !== -1) {
					resTime.second = Number(treg[order.s]);
				}
				if (order.l !== -1) {
					resTime.millisec = Number(treg[order.l]);
				}
				if (order.c !== -1) {
					resTime.microsec = Number(treg[order.c]);
				}
				if (order.z !== -1 && treg[order.z] !== undefined) {
					resTime.timezone = $.timepicker.timezoneOffsetNumber(treg[order.z]);
				}


				return resTime;
			}
			return false;
		};// end strictParse

		// First try JS Date, if that fails, use strictParse
		var looseParse = function (f, s, o) {
			try {
				var d = new Date('2012-01-01 ' + s);
				if (isNaN(d.getTime())) {
					d = new Date('2012-01-01T' + s);
					if (isNaN(d.getTime())) {
						d = new Date('01/01/2012 ' + s);
						if (isNaN(d.getTime())) {
							throw "Unable to parse time with native Date: " + s;
						}
					}
				}

				return {
					hour: d.getHours(),
					minute: d.getMinutes(),
					second: d.getSeconds(),
					millisec: d.getMilliseconds(),
					microsec: d.getMicroseconds(),
					timezone: d.getTimezoneOffset() * -1
				};
			}
			catch (err) {
				try {
					return strictParse(f, s, o);
				}
				catch (err2) {
					$.timepicker.log("Unable to parse \ntimeString: " + s + "\ntimeFormat: " + f);
				}
			}
			return false;
		}; // end looseParse

		if (typeof o.parse === "function") {
			return o.parse(timeFormat, timeString, o);
		}
		if (o.parse === 'loose') {
			return looseParse(timeFormat, timeString, o);
		}
		return strictParse(timeFormat, timeString, o);
	};

	/**
	 * Public utility to format the time
	 * @param {string} format format of the time
	 * @param {Object} time Object not a Date for timezones
	 * @param {Object} [options] essentially the regional[].. amNames, pmNames, ampm
	 * @returns {string} the formatted time
	 */
	$.datepicker.formatTime = function (format, time, options) {
		options = options || {};
		options = $.extend({}, $.timepicker._defaults, options);
		time = $.extend({
			hour: 0,
			minute: 0,
			second: 0,
			millisec: 0,
			microsec: 0,
			timezone: null
		}, time);

		var tmptime = format,
			ampmName = options.amNames[0],
			hour = parseInt(time.hour, 10);

		if (hour > 11) {
			ampmName = options.pmNames[0];
		}

		tmptime = tmptime.replace(/(?:HH?|hh?|mm?|ss?|[tT]{1,2}|[zZ]|[lc]|'.*?')/g, function (match) {
			switch (match) {
			case 'HH':
				return ('0' + hour).slice(-2);
			case 'H':
				return hour;
			case 'hh':
				return ('0' + convert24to12(hour)).slice(-2);
			case 'h':
				return convert24to12(hour);
			case 'mm':
				return ('0' + time.minute).slice(-2);
			case 'm':
				return time.minute;
			case 'ss':
				return ('0' + time.second).slice(-2);
			case 's':
				return time.second;
			case 'l':
				return ('00' + time.millisec).slice(-3);
			case 'c':
				return ('00' + time.microsec).slice(-3);
			case 'z':
				return $.timepicker.timezoneOffsetString(time.timezone === null ? options.timezone : time.timezone, false);
			case 'Z':
				return $.timepicker.timezoneOffsetString(time.timezone === null ? options.timezone : time.timezone, true);
			case 'T':
				return ampmName.charAt(0).toUpperCase();
			case 'TT':
				return ampmName.toUpperCase();
			case 't':
				return ampmName.charAt(0).toLowerCase();
			case 'tt':
				return ampmName.toLowerCase();
			default:
				return match.replace(/'/g, "");
			}
		});

		return tmptime;
	};

	/*
	* the bad hack :/ override datepicker so it doesn't close on select
	// inspired: http://stackoverflow.com/questions/1252512/jquery-datepicker-prevent-closing-picker-when-clicking-a-date/1762378#1762378
	*/
	$.datepicker._base_selectDate = $.datepicker._selectDate;
	$.datepicker._selectDate = function (id, dateStr) {
		var inst = this._getInst($(id)[0]),
			tp_inst = this._get(inst, 'timepicker'),
			was_inline;

		if (tp_inst && inst.settings.showTimepicker) {
			tp_inst._limitMinMaxDateTime(inst, true);
			was_inline = inst.inline;
			inst.inline = inst.stay_open = true;
			//This way the onSelect handler called from calendarpicker get the full dateTime
			this._base_selectDate(id, dateStr);
			inst.inline = was_inline;
			inst.stay_open = false;
			this._notifyChange(inst);
			this._updateDatepicker(inst);
		} else {
			this._base_selectDate(id, dateStr);
		}
	};

	/*
	* second bad hack :/ override datepicker so it triggers an event when changing the input field
	* and does not redraw the datepicker on every selectDate event
	*/
	$.datepicker._base_updateDatepicker = $.datepicker._updateDatepicker;
	$.datepicker._updateDatepicker = function (inst) {

		// don't popup the datepicker if there is another instance already opened
		var input = inst.input[0];
		if ($.datepicker._curInst && $.datepicker._curInst !== inst && $.datepicker._datepickerShowing && $.datepicker._lastInput !== input) {
			return;
		}

		if (typeof(inst.stay_open) !== 'boolean' || inst.stay_open === false) {

			this._base_updateDatepicker(inst);

			// Reload the time control when changing something in the input text field.
			var tp_inst = this._get(inst, 'timepicker');
			if (tp_inst) {
				tp_inst._addTimePicker(inst);
			}
		}
	};

	/*
	* third bad hack :/ override datepicker so it allows spaces and colon in the input field
	*/
	$.datepicker._base_doKeyPress = $.datepicker._doKeyPress;
	$.datepicker._doKeyPress = function (event) {
		var inst = $.datepicker._getInst(event.target),
			tp_inst = $.datepicker._get(inst, 'timepicker');

		if (tp_inst) {
			if ($.datepicker._get(inst, 'constrainInput')) {
				var ampm = tp_inst.support.ampm,
					tz = tp_inst._defaults.showTimezone !== null ? tp_inst._defaults.showTimezone : tp_inst.support.timezone,
					dateChars = $.datepicker._possibleChars($.datepicker._get(inst, 'dateFormat')),
					datetimeChars = tp_inst._defaults.timeFormat.toString()
											.replace(/[hms]/g, '')
											.replace(/TT/g, ampm ? 'APM' : '')
											.replace(/Tt/g, ampm ? 'AaPpMm' : '')
											.replace(/tT/g, ampm ? 'AaPpMm' : '')
											.replace(/T/g, ampm ? 'AP' : '')
											.replace(/tt/g, ampm ? 'apm' : '')
											.replace(/t/g, ampm ? 'ap' : '') +
											" " + tp_inst._defaults.separator +
											tp_inst._defaults.timeSuffix +
											(tz ? tp_inst._defaults.timezoneList.join('') : '') +
											(tp_inst._defaults.amNames.join('')) + (tp_inst._defaults.pmNames.join('')) +
											dateChars,
					chr = String.fromCharCode(event.charCode === undefined ? event.keyCode : event.charCode);
				return event.ctrlKey || (chr < ' ' || !dateChars || datetimeChars.indexOf(chr) > -1);
			}
		}

		return $.datepicker._base_doKeyPress(event);
	};

	/*
	* Fourth bad hack :/ override _updateAlternate function used in inline mode to init altField
	* Update any alternate field to synchronise with the main field.
	*/
	$.datepicker._base_updateAlternate = $.datepicker._updateAlternate;
	$.datepicker._updateAlternate = function (inst) {
		var tp_inst = this._get(inst, 'timepicker');
		if (tp_inst) {
			var altField = tp_inst._defaults.altField;
			if (altField) { // update alternate field too
				var altFormat = tp_inst._defaults.altFormat || tp_inst._defaults.dateFormat,
					date = this._getDate(inst),
					formatCfg = $.datepicker._getFormatConfig(inst),
					altFormattedDateTime = '',
					altSeparator = tp_inst._defaults.altSeparator ? tp_inst._defaults.altSeparator : tp_inst._defaults.separator,
					altTimeSuffix = tp_inst._defaults.altTimeSuffix ? tp_inst._defaults.altTimeSuffix : tp_inst._defaults.timeSuffix,
					altTimeFormat = tp_inst._defaults.altTimeFormat !== null ? tp_inst._defaults.altTimeFormat : tp_inst._defaults.timeFormat;

				altFormattedDateTime += $.datepicker.formatTime(altTimeFormat, tp_inst, tp_inst._defaults) + altTimeSuffix;
				if (!tp_inst._defaults.timeOnly && !tp_inst._defaults.altFieldTimeOnly && date !== null) {
					if (tp_inst._defaults.altFormat) {
						altFormattedDateTime = $.datepicker.formatDate(tp_inst._defaults.altFormat, date, formatCfg) + altSeparator + altFormattedDateTime;
					}
					else {
						altFormattedDateTime = tp_inst.formattedDate + altSeparator + altFormattedDateTime;
					}
				}
				$(altField).val( inst.input.val() ? altFormattedDateTime : "");
			}
		}
		else {
			$.datepicker._base_updateAlternate(inst);
		}
	};

	/*
	* Override key up event to sync manual input changes.
	*/
	$.datepicker._base_doKeyUp = $.datepicker._doKeyUp;
	$.datepicker._doKeyUp = function (event) {
		var inst = $.datepicker._getInst(event.target),
			tp_inst = $.datepicker._get(inst, 'timepicker');

		if (tp_inst) {
			if (tp_inst._defaults.timeOnly && (inst.input.val() !== inst.lastVal)) {
				try {
					$.datepicker._updateDatepicker(inst);
				} catch (err) {
					$.timepicker.log(err);
				}
			}
		}

		return $.datepicker._base_doKeyUp(event);
	};

	/*
	* override "Today" button to also grab the time and set it to input field.
	*/
	$.datepicker._base_gotoToday = $.datepicker._gotoToday;
	$.datepicker._gotoToday = function (id) {
		var inst = this._getInst($(id)[0]);
		this._base_gotoToday(id);
		var tp_inst = this._get(inst, 'timepicker');
		if (!tp_inst) {
		  return;
		}

		var tzoffset = $.timepicker.timezoneOffsetNumber(tp_inst.timezone);
		var now = new Date();
		now.setMinutes(now.getMinutes() + now.getTimezoneOffset() + parseInt(tzoffset, 10));
		this._setTime(inst, now);
		this._setDate(inst, now);
		tp_inst._onSelectHandler();
	};

	/*
	* Disable & enable the Time in the datetimepicker
	*/
	$.datepicker._disableTimepickerDatepicker = function (target) {
		var inst = this._getInst(target);
		if (!inst) {
			return;
		}

		var tp_inst = this._get(inst, 'timepicker');
		$(target).datepicker('getDate'); // Init selected[Year|Month|Day]
		if (tp_inst) {
			inst.settings.showTimepicker = false;
			tp_inst._defaults.showTimepicker = false;
			tp_inst._updateDateTime(inst);
		}
	};

	$.datepicker._enableTimepickerDatepicker = function (target) {
		var inst = this._getInst(target);
		if (!inst) {
			return;
		}

		var tp_inst = this._get(inst, 'timepicker');
		$(target).datepicker('getDate'); // Init selected[Year|Month|Day]
		if (tp_inst) {
			inst.settings.showTimepicker = true;
			tp_inst._defaults.showTimepicker = true;
			tp_inst._addTimePicker(inst); // Could be disabled on page load
			tp_inst._updateDateTime(inst);
		}
	};

	/*
	* Create our own set time function
	*/
	$.datepicker._setTime = function (inst, date) {
		var tp_inst = this._get(inst, 'timepicker');
		if (tp_inst) {
			var defaults = tp_inst._defaults;

			// calling _setTime with no date sets time to defaults
			tp_inst.hour = date ? date.getHours() : defaults.hour;
			tp_inst.minute = date ? date.getMinutes() : defaults.minute;
			tp_inst.second = date ? date.getSeconds() : defaults.second;
			tp_inst.millisec = date ? date.getMilliseconds() : defaults.millisec;
			tp_inst.microsec = date ? date.getMicroseconds() : defaults.microsec;

			//check if within min/max times..
			tp_inst._limitMinMaxDateTime(inst, true);

			tp_inst._onTimeChange();
			tp_inst._updateDateTime(inst);
		}
	};

	/*
	* Create new public method to set only time, callable as $().datepicker('setTime', date)
	*/
	$.datepicker._setTimeDatepicker = function (target, date, withDate) {
		var inst = this._getInst(target);
		if (!inst) {
			return;
		}

		var tp_inst = this._get(inst, 'timepicker');

		if (tp_inst) {
			this._setDateFromField(inst);
			var tp_date;
			if (date) {
				if (typeof date === "string") {
					tp_inst._parseTime(date, withDate);
					tp_date = new Date();
					tp_date.setHours(tp_inst.hour, tp_inst.minute, tp_inst.second, tp_inst.millisec);
					tp_date.setMicroseconds(tp_inst.microsec);
				} else {
					tp_date = new Date(date.getTime());
					tp_date.setMicroseconds(date.getMicroseconds());
				}
				if (tp_date.toString() === 'Invalid Date') {
					tp_date = undefined;
				}
				this._setTime(inst, tp_date);
			}
		}

	};

	/*
	* override setDate() to allow setting time too within Date object
	*/
	$.datepicker._base_setDateDatepicker = $.datepicker._setDateDatepicker;
	$.datepicker._setDateDatepicker = function (target, _date) {
		var inst = this._getInst(target);
		var date = _date;
		if (!inst) {
			return;
		}

		if (typeof(_date) === 'string') {
			date = new Date(_date);
			if (!date.getTime()) {
				this._base_setDateDatepicker.apply(this, arguments);
				date = $(target).datepicker('getDate');
			}
		}

		var tp_inst = this._get(inst, 'timepicker');
		var tp_date;
		if (date instanceof Date) {
			tp_date = new Date(date.getTime());
			tp_date.setMicroseconds(date.getMicroseconds());
		} else {
			tp_date = date;
		}

		// This is important if you are using the timezone option, javascript's Date
		// object will only return the timezone offset for the current locale, so we
		// adjust it accordingly.  If not using timezone option this won't matter..
		// If a timezone is different in tp, keep the timezone as is
		if (tp_inst && tp_date) {
			// look out for DST if tz wasn't specified
			if (!tp_inst.support.timezone && tp_inst._defaults.timezone === null) {
				tp_inst.timezone = tp_date.getTimezoneOffset() * -1;
			}
			date = $.timepicker.timezoneAdjust(date, $.timepicker.timezoneOffsetString(-date.getTimezoneOffset()), tp_inst.timezone);
			tp_date = $.timepicker.timezoneAdjust(tp_date, $.timepicker.timezoneOffsetString(-tp_date.getTimezoneOffset()), tp_inst.timezone);
		}

		this._updateDatepicker(inst);
		this._base_setDateDatepicker.apply(this, arguments);
		this._setTimeDatepicker(target, tp_date, true);
	};

	/*
	* override getDate() to allow getting time too within Date object
	*/
	$.datepicker._base_getDateDatepicker = $.datepicker._getDateDatepicker;
	$.datepicker._getDateDatepicker = function (target, noDefault) {
		var inst = this._getInst(target);
		if (!inst) {
			return;
		}

		var tp_inst = this._get(inst, 'timepicker');

		if (tp_inst) {
			// if it hasn't yet been defined, grab from field
			if (inst.lastVal === undefined) {
				this._setDateFromField(inst, noDefault);
			}

			var date = this._getDate(inst);

			var currDT = null;

			if (tp_inst.$altInput && tp_inst._defaults.altFieldTimeOnly) {
				currDT = tp_inst.$input.val() + ' ' + tp_inst.$altInput.val();
			}
			else if (tp_inst.$input.get(0).tagName !== 'INPUT' && tp_inst.$altInput) {
				/**
				 * in case the datetimepicker has been applied to a non-input tag for inline UI,
				 * and the user has not configured the plugin to display only time in altInput,
				 * pick current date time from the altInput (and hope for the best, for now, until "ER1" is applied)
				 *
				 * @todo ER1. Since altInput can have a totally difference format, convert it to standard format by reading input format from "altFormat" and "altTimeFormat" option values
				 */
				currDT = tp_inst.$altInput.val();
			}
			else {
				currDT = tp_inst.$input.val();
			}

			if (date && tp_inst._parseTime(currDT, !inst.settings.timeOnly)) {
				date.setHours(tp_inst.hour, tp_inst.minute, tp_inst.second, tp_inst.millisec);
				date.setMicroseconds(tp_inst.microsec);

				// This is important if you are using the timezone option, javascript's Date
				// object will only return the timezone offset for the current locale, so we
				// adjust it accordingly.  If not using timezone option this won't matter..
				if (tp_inst.timezone != null) {
					// look out for DST if tz wasn't specified
					if (!tp_inst.support.timezone && tp_inst._defaults.timezone === null) {
						tp_inst.timezone = date.getTimezoneOffset() * -1;
					}
					date = $.timepicker.timezoneAdjust(date, tp_inst.timezone, $.timepicker.timezoneOffsetString(-date.getTimezoneOffset()));
				}
			}
			return date;
		}
		return this._base_getDateDatepicker(target, noDefault);
	};

	/*
	* override parseDate() because UI 1.8.14 throws an error about "Extra characters"
	* An option in datapicker to ignore extra format characters would be nicer.
	*/
	$.datepicker._base_parseDate = $.datepicker.parseDate;
	$.datepicker.parseDate = function (format, value, settings) {
		var date;
		try {
			date = this._base_parseDate(format, value, settings);
		} catch (err) {
			// Hack!  The error message ends with a colon, a space, and
			// the "extra" characters.  We rely on that instead of
			// attempting to perfectly reproduce the parsing algorithm.
			if (err.indexOf(":") >= 0) {
				date = this._base_parseDate(format, value.substring(0, value.length - (err.length - err.indexOf(':') - 2)), settings);
				$.timepicker.log("Error parsing the date string: " + err + "\ndate string = " + value + "\ndate format = " + format);
			} else {
				throw err;
			}
		}
		return date;
	};

	/*
	* override formatDate to set date with time to the input
	*/
	$.datepicker._base_formatDate = $.datepicker._formatDate;
	$.datepicker._formatDate = function (inst, day, month, year) {
		var tp_inst = this._get(inst, 'timepicker');
		if (tp_inst) {
			tp_inst._updateDateTime(inst);
			return tp_inst.$input.val();
		}
		return this._base_formatDate(inst);
	};

	/*
	* override options setter to add time to maxDate(Time) and minDate(Time). MaxDate
	*/
	$.datepicker._base_optionDatepicker = $.datepicker._optionDatepicker;
	$.datepicker._optionDatepicker = function (target, name, value) {
		var inst = this._getInst(target),
			name_clone;
		if (!inst) {
			return null;
		}

		var tp_inst = this._get(inst, 'timepicker');
		if (tp_inst) {
			var min = null,
				max = null,
				onselect = null,
				overrides = tp_inst._defaults.evnts,
				fns = {},
				prop,
				ret,
				oldVal,
				$target;
			if (typeof name === 'string') { // if min/max was set with the string
				if (name === 'minDate' || name === 'minDateTime') {
					min = value;
				} else if (name === 'maxDate' || name === 'maxDateTime') {
					max = value;
				} else if (name === 'onSelect') {
					onselect = value;
				} else if (overrides.hasOwnProperty(name)) {
					if (typeof (value) === 'undefined') {
						return overrides[name];
					}
					fns[name] = value;
					name_clone = {}; //empty results in exiting function after overrides updated
				}
			} else if (typeof name === 'object') { //if min/max was set with the JSON
				if (name.minDate) {
					min = name.minDate;
				} else if (name.minDateTime) {
					min = name.minDateTime;
				} else if (name.maxDate) {
					max = name.maxDate;
				} else if (name.maxDateTime) {
					max = name.maxDateTime;
				}
				for (prop in overrides) {
					if (overrides.hasOwnProperty(prop) && name[prop]) {
						fns[prop] = name[prop];
					}
				}
			}
			for (prop in fns) {
				if (fns.hasOwnProperty(prop)) {
					overrides[prop] = fns[prop];
					if (!name_clone) { name_clone = $.extend({}, name); }
					delete name_clone[prop];
				}
			}
			if (name_clone && isEmptyObject(name_clone)) { return; }
			if (min) { //if min was set
				if (min === 0) {
					min = new Date();
				} else {
					min = new Date(min);
				}
				tp_inst._defaults.minDate = min;
				tp_inst._defaults.minDateTime = min;
			} else if (max) { //if max was set
				if (max === 0) {
					max = new Date();
				} else {
					max = new Date(max);
				}
				tp_inst._defaults.maxDate = max;
				tp_inst._defaults.maxDateTime = max;
			} else if (onselect) {
				tp_inst._defaults.onSelect = onselect;
			}

			// Datepicker will override our date when we call _base_optionDatepicker when
			// calling minDate/maxDate, so we will first grab the value, call
			// _base_optionDatepicker, then set our value back.
			if(min || max){
				$target = $(target);
				oldVal = $target.datetimepicker('getDate');
				ret = this._base_optionDatepicker.call($.datepicker, target, name_clone || name, value);
				$target.datetimepicker('setDate', oldVal);
				return ret;
			}
		}
		if (value === undefined) {
			return this._base_optionDatepicker.call($.datepicker, target, name);
		}
		return this._base_optionDatepicker.call($.datepicker, target, name_clone || name, value);
	};

	/*
	* jQuery isEmptyObject does not check hasOwnProperty - if someone has added to the object prototype,
	* it will return false for all objects
	*/
	var isEmptyObject = function (obj) {
		var prop;
		for (prop in obj) {
			if (obj.hasOwnProperty(prop)) {
				return false;
			}
		}
		return true;
	};

	/*
	* jQuery extend now ignores nulls!
	*/
	var extendRemove = function (target, props) {
		$.extend(target, props);
		for (var name in props) {
			if (props[name] === null || props[name] === undefined) {
				target[name] = props[name];
			}
		}
		return target;
	};

	/*
	* Determine by the time format which units are supported
	* Returns an object of booleans for each unit
	*/
	var detectSupport = function (timeFormat) {
		var tf = timeFormat.replace(/'.*?'/g, '').toLowerCase(), // removes literals
			isIn = function (f, t) { // does the format contain the token?
					return f.indexOf(t) !== -1 ? true : false;
				};
		return {
				hour: isIn(tf, 'h'),
				minute: isIn(tf, 'm'),
				second: isIn(tf, 's'),
				millisec: isIn(tf, 'l'),
				microsec: isIn(tf, 'c'),
				timezone: isIn(tf, 'z'),
				ampm: isIn(tf, 't') && isIn(timeFormat, 'h'),
				iso8601: isIn(timeFormat, 'Z')
			};
	};

	/*
	* Converts 24 hour format into 12 hour
	* Returns 12 hour without leading 0
	*/
	var convert24to12 = function (hour) {
		hour %= 12;

		if (hour === 0) {
			hour = 12;
		}

		return String(hour);
	};

	var computeEffectiveSetting = function (settings, property) {
		return settings && settings[property] ? settings[property] : $.timepicker._defaults[property];
	};

	/*
	* Splits datetime string into date and time substrings.
	* Throws exception when date can't be parsed
	* Returns {dateString: dateString, timeString: timeString}
	*/
	var splitDateTime = function (dateTimeString, timeSettings) {
		// The idea is to get the number separator occurrences in datetime and the time format requested (since time has
		// fewer unknowns, mostly numbers and am/pm). We will use the time pattern to split.
		var separator = computeEffectiveSetting(timeSettings, 'separator'),
			format = computeEffectiveSetting(timeSettings, 'timeFormat'),
			timeParts = format.split(separator), // how many occurrences of separator may be in our format?
			timePartsLen = timeParts.length,
			allParts = dateTimeString.split(separator),
			allPartsLen = allParts.length;

		if (allPartsLen > 1) {
			return {
				dateString: allParts.splice(0, allPartsLen - timePartsLen).join(separator),
				timeString: allParts.splice(0, timePartsLen).join(separator)
			};
		}

		return {
			dateString: dateTimeString,
			timeString: ''
		};
	};

	/*
	* Internal function to parse datetime interval
	* Returns: {date: Date, timeObj: Object}, where
	*   date - parsed date without time (type Date)
	*   timeObj = {hour: , minute: , second: , millisec: , microsec: } - parsed time. Optional
	*/
	var parseDateTimeInternal = function (dateFormat, timeFormat, dateTimeString, dateSettings, timeSettings) {
		var date,
			parts,
			parsedTime;

		parts = splitDateTime(dateTimeString, timeSettings);
		date = $.datepicker._base_parseDate(dateFormat, parts.dateString, dateSettings);

		if (parts.timeString === '') {
			return {
				date: date
			};
		}

		parsedTime = $.datepicker.parseTime(timeFormat, parts.timeString, timeSettings);

		if (!parsedTime) {
			throw 'Wrong time format';
		}

		return {
			date: date,
			timeObj: parsedTime
		};
	};

	/*
	* Internal function to set timezone_select to the local timezone
	*/
	var selectLocalTimezone = function (tp_inst, date) {
		if (tp_inst && tp_inst.timezone_select) {
			var now = date || new Date();
			tp_inst.timezone_select.val(-now.getTimezoneOffset());
		}
	};

	/*
	* Create a Singleton Instance
	*/
	$.timepicker = new Timepicker();

	/**
	 * Get the timezone offset as string from a date object (eg '+0530' for UTC+5.5)
	 * @param {number} tzMinutes if not a number, less than -720 (-1200), or greater than 840 (+1400) this value is returned
	 * @param {boolean} iso8601 if true formats in accordance to iso8601 "+12:45"
	 * @return {string}
	 */
	$.timepicker.timezoneOffsetString = function (tzMinutes, iso8601) {
		if (isNaN(tzMinutes) || tzMinutes > 840 || tzMinutes < -720) {
			return tzMinutes;
		}

		var off = tzMinutes,
			minutes = off % 60,
			hours = (off - minutes) / 60,
			iso = iso8601 ? ':' : '',
			tz = (off >= 0 ? '+' : '-') + ('0' + Math.abs(hours)).slice(-2) + iso + ('0' + Math.abs(minutes)).slice(-2);

		if (tz === '+00:00') {
			return 'Z';
		}
		return tz;
	};

	/**
	 * Get the number in minutes that represents a timezone string
	 * @param  {string} tzString formatted like "+0500", "-1245", "Z"
	 * @return {number} the offset minutes or the original string if it doesn't match expectations
	 */
	$.timepicker.timezoneOffsetNumber = function (tzString) {
		var normalized = tzString.toString().replace(':', ''); // excuse any iso8601, end up with "+1245"

		if (normalized.toUpperCase() === 'Z') { // if iso8601 with Z, its 0 minute offset
			return 0;
		}

		if (!/^(\-|\+)\d{4}$/.test(normalized)) { // possibly a user defined tz, so just give it back
			return parseInt(tzString, 10);
		}

		return ((normalized.substr(0, 1) === '-' ? -1 : 1) * // plus or minus
					((parseInt(normalized.substr(1, 2), 10) * 60) + // hours (converted to minutes)
					parseInt(normalized.substr(3, 2), 10))); // minutes
	};

	/**
	 * No way to set timezone in js Date, so we must adjust the minutes to compensate. (think setDate, getDate)
	 * @param  {Date} date
	 * @param  {string} fromTimezone formatted like "+0500", "-1245"
	 * @param  {string} toTimezone formatted like "+0500", "-1245"
	 * @return {Date}
	 */
	$.timepicker.timezoneAdjust = function (date, fromTimezone, toTimezone) {
		var fromTz = $.timepicker.timezoneOffsetNumber(fromTimezone);
		var toTz = $.timepicker.timezoneOffsetNumber(toTimezone);
		if (!isNaN(toTz)) {
			date.setMinutes(date.getMinutes() + (-fromTz) - (-toTz));
		}
		return date;
	};

	/**
	 * Calls `timepicker()` on the `startTime` and `endTime` elements, and configures them to
	 * enforce date range limits.
	 * n.b. The input value must be correctly formatted (reformatting is not supported)
	 * @param  {Element} startTime
	 * @param  {Element} endTime
	 * @param  {Object} options Options for the timepicker() call
	 * @return {jQuery}
	 */
	$.timepicker.timeRange = function (startTime, endTime, options) {
		return $.timepicker.handleRange('timepicker', startTime, endTime, options);
	};

	/**
	 * Calls `datetimepicker` on the `startTime` and `endTime` elements, and configures them to
	 * enforce date range limits.
	 * @param  {Element} startTime
	 * @param  {Element} endTime
	 * @param  {Object} options Options for the `timepicker()` call. Also supports `reformat`,
	 *   a boolean value that can be used to reformat the input values to the `dateFormat`.
	 * @param  {string} method Can be used to specify the type of picker to be added
	 * @return {jQuery}
	 */
	$.timepicker.datetimeRange = function (startTime, endTime, options) {
		$.timepicker.handleRange('datetimepicker', startTime, endTime, options);
	};

	/**
	 * Calls `datepicker` on the `startTime` and `endTime` elements, and configures them to
	 * enforce date range limits.
	 * @param  {Element} startTime
	 * @param  {Element} endTime
	 * @param  {Object} options Options for the `timepicker()` call. Also supports `reformat`,
	 *   a boolean value that can be used to reformat the input values to the `dateFormat`.
	 * @return {jQuery}
	 */
	$.timepicker.dateRange = function (startTime, endTime, options) {
		$.timepicker.handleRange('datepicker', startTime, endTime, options);
	};

	/**
	 * Calls `method` on the `startTime` and `endTime` elements, and configures them to
	 * enforce date range limits.
	 * @param  {string} method Can be used to specify the type of picker to be added
	 * @param  {Element} startTime
	 * @param  {Element} endTime
	 * @param  {Object} options Options for the `timepicker()` call. Also supports `reformat`,
	 *   a boolean value that can be used to reformat the input values to the `dateFormat`.
	 * @return {jQuery}
	 */
	$.timepicker.handleRange = function (method, startTime, endTime, options) {
		options = $.extend({}, {
			minInterval: 0, // min allowed interval in milliseconds
			maxInterval: 0, // max allowed interval in milliseconds
			start: {},      // options for start picker
			end: {}         // options for end picker
		}, options);

		// for the mean time this fixes an issue with calling getDate with timepicker()
		var timeOnly = false;
		if(method === 'timepicker'){
			timeOnly = true;
			method = 'datetimepicker';
		}

		function checkDates(changed, other) {
			var startdt = startTime[method]('getDate'),
				enddt = endTime[method]('getDate'),
				changeddt = changed[method]('getDate');

			if (startdt !== null) {
				var minDate = new Date(startdt.getTime()),
					maxDate = new Date(startdt.getTime());

				minDate.setMilliseconds(minDate.getMilliseconds() + options.minInterval);
				maxDate.setMilliseconds(maxDate.getMilliseconds() + options.maxInterval);

				if (options.minInterval > 0 && minDate > enddt) { // minInterval check
					endTime[method]('setDate', minDate);
				}
				else if (options.maxInterval > 0 && maxDate < enddt) { // max interval check
					endTime[method]('setDate', maxDate);
				}
				else if (startdt > enddt) {
					other[method]('setDate', changeddt);
				}
			}
		}

		function selected(changed, other, option) {
			if (!changed.val()) {
				return;
			}
			var date = changed[method].call(changed, 'getDate');
			if (date !== null && options.minInterval > 0) {
				if (option === 'minDate') {
					date.setMilliseconds(date.getMilliseconds() + options.minInterval);
				}
				if (option === 'maxDate') {
					date.setMilliseconds(date.getMilliseconds() - options.minInterval);
				}
			}

			if (date.getTime) {
				other[method].call(other, 'option', option, date);
			}
		}

		$.fn[method].call(startTime, $.extend({
			timeOnly: timeOnly,
			onClose: function (dateText, inst) {
				checkDates($(this), endTime);
			},
			onSelect: function (selectedDateTime) {
				selected($(this), endTime, 'minDate');
			}
		}, options, options.start));
		$.fn[method].call(endTime, $.extend({
			timeOnly: timeOnly,
			onClose: function (dateText, inst) {
				checkDates($(this), startTime);
			},
			onSelect: function (selectedDateTime) {
				selected($(this), startTime, 'maxDate');
			}
		}, options, options.end));

		checkDates(startTime, endTime);

		selected(startTime, endTime, 'minDate');
		selected(endTime, startTime, 'maxDate');

		return $([startTime.get(0), endTime.get(0)]);
	};

	/**
	 * Log error or data to the console during error or debugging
	 * @param  {Object} err pass any type object to log to the console during error or debugging
	 * @return {void}
	 */
	$.timepicker.log = function () {
		// Older IE (9, maybe 10) throw error on accessing `window.console.log.apply`, so check first.
		if (window.console && window.console.log && window.console.log.apply) {
			window.console.log.apply(window.console, Array.prototype.slice.call(arguments));
		}
	};

	/*
	 * Add util object to allow access to private methods for testability.
	 */
	$.timepicker._util = {
		_extendRemove: extendRemove,
		_isEmptyObject: isEmptyObject,
		_convert24to12: convert24to12,
		_detectSupport: detectSupport,
		_selectLocalTimezone: selectLocalTimezone,
		_computeEffectiveSetting: computeEffectiveSetting,
		_splitDateTime: splitDateTime,
		_parseDateTimeInternal: parseDateTimeInternal
	};

	/*
	* Microsecond support
	*/
	if (!Date.prototype.getMicroseconds) {
		Date.prototype.microseconds = 0;
		Date.prototype.getMicroseconds = function () { return this.microseconds; };
		Date.prototype.setMicroseconds = function (m) {
			this.setMilliseconds(this.getMilliseconds() + Math.floor(m / 1000));
			this.microseconds = m % 1000;
			return this;
		};
	}

	/*
	* Keep up with the version
	*/
	$.timepicker.version = "@@version";

}));


/* -------------------------------------------------------------------------------------------------- */
/* jquery-stickytableheaders.js */
/* File: js/machinata-core-bundle.js/jquery-stickytableheaders.js */
/* -------------------------------------------------------------------------------------------------- */

/*! Copyright (c) Jonas Mosbech - https://github.com/jmosbech/StickyTableHeaders
	MIT license info: https://github.com/jmosbech/StickyTableHeaders/blob/master/license.txt */

;(function ($, window, undefined) {
	'use strict';

	var name = 'stickyTableHeaders',
		id = 0,
		defaults = {
			fixedOffset: 0,
			leftOffset: 0,
			marginTop: 0,
			objDocument: document,
			objHead: 'head',
			objWindow: window,
			scrollableArea: window,
			cacheHeaderHeight: false,
			zIndex: 3
		};

	function Plugin (el, options) {
		// To avoid scope issues, use 'base' instead of 'this'
		// to reference this class from internal events and functions.
		var base = this;

		// Access to jQuery and DOM versions of element
		base.$el = $(el);
		base.el = el;
		base.id = id++;

		// Listen for destroyed, call teardown
		base.$el.bind('destroyed',
			$.proxy(base.teardown, base));

		// Cache DOM refs for performance reasons
		base.$clonedHeader = null;
		base.$originalHeader = null;

		// Cache header height for performance reasons
		base.cachedHeaderHeight = null;

		// Keep track of state
		base.isSticky = false;
		base.hasBeenSticky = false;
		base.leftOffset = null;
		base.topOffset = null;

		base.init = function () {
			base.setOptions(options);

			base.$el.each(function () {
				var $this = $(this);

				// remove padding on <table> to fix issue #7
				$this.css('padding', 0);

				base.$originalHeader = $('thead:first', this);
				base.$clonedHeader = base.$originalHeader.clone();
				$this.trigger('clonedHeader.' + name, [base.$clonedHeader]);

				base.$clonedHeader.addClass('tableFloatingHeader');
				base.$clonedHeader.css({display: 'none', opacity: 0.0});

				base.$originalHeader.addClass('tableFloatingHeaderOriginal');

				base.$originalHeader.after(base.$clonedHeader);

				base.$printStyle = $('<style type="text/css" media="print">' +
					'.tableFloatingHeader{display:none !important;}' +
					'.tableFloatingHeaderOriginal{position:static !important;}' +
					'</style>');
				base.$head.append(base.$printStyle);
			});
			
			base.$clonedHeader.find("input, select").attr("disabled", true);

			base.updateWidth();
			base.toggleHeaders();
			base.bind();
		};

		base.destroy = function (){
			base.$el.unbind('destroyed', base.teardown);
			base.teardown();
		};

		base.teardown = function(){
			if (base.isSticky) {
				base.$originalHeader.css('position', 'static');
			}
			$.removeData(base.el, 'plugin_' + name);
			base.unbind();

			base.$clonedHeader.remove();
			base.$originalHeader.removeClass('tableFloatingHeaderOriginal');
			base.$originalHeader.css('visibility', 'visible');
			base.$printStyle.remove();

			base.el = null;
			base.$el = null;
		};

		base.bind = function(){
			base.$scrollableArea.on('scroll.' + name, base.toggleHeaders);
			if (!base.isWindowScrolling) {
				base.$window.on('scroll.' + name + base.id, base.setPositionValues);
				base.$window.on('resize.' + name + base.id, base.toggleHeaders);
			}
			base.$scrollableArea.on('resize.' + name, base.toggleHeaders);
			base.$scrollableArea.on('resize.' + name, base.updateWidth);
		};

		base.unbind = function(){
			// unbind window events by specifying handle so we don't remove too much
			base.$scrollableArea.off('.' + name, base.toggleHeaders);
			if (!base.isWindowScrolling) {
				base.$window.off('.' + name + base.id, base.setPositionValues);
				base.$window.off('.' + name + base.id, base.toggleHeaders);
			}
			base.$scrollableArea.off('.' + name, base.updateWidth);
		};

		// We debounce the functions bound to the scroll and resize events
		base.debounce = function (fn, delay) {
			var timer = null;
			return function () {
				var context = this, args = arguments;
				clearTimeout(timer);
				timer = setTimeout(function () {
					fn.apply(context, args);
				}, delay);
			};
		};

		base.toggleHeaders = base.debounce(function () {
			if (base.$el) {
				base.$el.each(function () {
					var $this = $(this),
						newLeft,
						newTopOffset = base.isWindowScrolling ? (
									isNaN(base.options.fixedOffset) ?
									base.options.fixedOffset.outerHeight() :
									base.options.fixedOffset
								) :
								base.$scrollableArea.offset().top + (!isNaN(base.options.fixedOffset) ? base.options.fixedOffset : 0),
						offset = $this.offset(),

						scrollTop = base.$scrollableArea.scrollTop() + newTopOffset,
						scrollLeft = base.$scrollableArea.scrollLeft(),

						headerHeight,

						scrolledPastTop = base.isWindowScrolling ?
								scrollTop > offset.top :
								newTopOffset > offset.top,
						notScrolledPastBottom;

					if (scrolledPastTop) {
						headerHeight = base.options.cacheHeaderHeight ? base.cachedHeaderHeight : base.$clonedHeader.height();
						notScrolledPastBottom = (base.isWindowScrolling ? scrollTop : 0) <
							(offset.top + $this.height() - headerHeight - (base.isWindowScrolling ? 0 : newTopOffset));
					}

					if (scrolledPastTop && notScrolledPastBottom) {
						newLeft = offset.left - scrollLeft + base.options.leftOffset;
						base.$originalHeader.css({
							'position': 'fixed',
							'margin-top': base.options.marginTop,
                                                        'top': 0,
							'left': newLeft,
							'z-index': base.options.zIndex
						});
						base.leftOffset = newLeft;
						base.topOffset = newTopOffset;
						base.$clonedHeader.css('display', '');
						if (!base.isSticky) {
							base.isSticky = true;
							// make sure the width is correct: the user might have resized the browser while in static mode
							base.updateWidth();
							$this.trigger('enabledStickiness.' + name);
						}
						base.setPositionValues();
					} else if (base.isSticky) {
						base.$originalHeader.css('position', 'static');
						base.$clonedHeader.css('display', 'none');
						base.isSticky = false;
						base.resetWidth($('td,th', base.$clonedHeader), $('td,th', base.$originalHeader));
						$this.trigger('disabledStickiness.' + name);
					}
				});
			}
		}, 0);

		base.setPositionValues = base.debounce(function () {
			var winScrollTop = base.$window.scrollTop(),
				winScrollLeft = base.$window.scrollLeft();
			if (!base.isSticky ||
					winScrollTop < 0 || winScrollTop + base.$window.height() > base.$document.height() ||
					winScrollLeft < 0 || winScrollLeft + base.$window.width() > base.$document.width()) {
				return;
			}
			base.$originalHeader.css({
				'top': base.topOffset - (base.isWindowScrolling ? 0 : winScrollTop),
				'left': base.leftOffset - (base.isWindowScrolling ? 0 : winScrollLeft)
			});
		}, 0);

		base.updateWidth = base.debounce(function () {
			if (!base.isSticky) {
				return;
			}
			// Copy cell widths from clone
			if (!base.$originalHeaderCells) {
				base.$originalHeaderCells = $('th,td', base.$originalHeader);
			}
			if (!base.$clonedHeaderCells) {
				base.$clonedHeaderCells = $('th,td', base.$clonedHeader);
			}
			var cellWidths = base.getWidth(base.$clonedHeaderCells);
			base.setWidth(cellWidths, base.$clonedHeaderCells, base.$originalHeaderCells);

			// Copy row width from whole table
			base.$originalHeader.css('width', base.$clonedHeader.width());

			// If we're caching the height, we need to update the cached value when the width changes
			if (base.options.cacheHeaderHeight) {
				base.cachedHeaderHeight = base.$clonedHeader.height();
			}
		}, 0);

		base.getWidth = function ($clonedHeaders) {
			var widths = [];
			$clonedHeaders.each(function (index) {
				var width, $this = $(this);

				if ($this.css('box-sizing') === 'border-box') {
					var boundingClientRect = $this[0].getBoundingClientRect();
					if(boundingClientRect.width) {
						width = boundingClientRect.width; // #39: border-box bug
					} else {
						width = boundingClientRect.right - boundingClientRect.left; // ie8 bug: getBoundingClientRect() does not have a width property
					}
				} else {
					var $origTh = $('th', base.$originalHeader);
					if ($origTh.css('border-collapse') === 'collapse') {
						if (window.getComputedStyle) {
							width = parseFloat(window.getComputedStyle(this, null).width);
						} else {
							// ie8 only
							var leftPadding = parseFloat($this.css('padding-left'));
							var rightPadding = parseFloat($this.css('padding-right'));
							// Needs more investigation - this is assuming constant border around this cell and it's neighbours.
							var border = parseFloat($this.css('border-width'));
							width = $this.outerWidth() - leftPadding - rightPadding - border;
						}
					} else {
						width = $this.width();
					}
				}

				widths[index] = width;
			});
			return widths;
		};

		base.setWidth = function (widths, $clonedHeaders, $origHeaders) {
			$clonedHeaders.each(function (index) {
				var width = widths[index];
				$origHeaders.eq(index).css({
					'min-width': width,
					'max-width': width
				});
			});
		};

		base.resetWidth = function ($clonedHeaders, $origHeaders) {
			$clonedHeaders.each(function (index) {
				var $this = $(this);
				$origHeaders.eq(index).css({
					'min-width': $this.css('min-width'),
					'max-width': $this.css('max-width')
				});
			});
		};

		base.setOptions = function (options) {
			base.options = $.extend({}, defaults, options);
			base.$window = $(base.options.objWindow);
			base.$head = $(base.options.objHead);
			base.$document = $(base.options.objDocument);
			base.$scrollableArea = $(base.options.scrollableArea);
			base.isWindowScrolling = base.$scrollableArea[0] === base.$window[0];
		};

		base.updateOptions = function (options) {
			base.setOptions(options);
			// scrollableArea might have changed
			base.unbind();
			base.bind();
			base.updateWidth();
			base.toggleHeaders();
		};

		// Run initializer
		base.init();
	}

	// A plugin wrapper around the constructor,
	// preventing against multiple instantiations
	$.fn[name] = function ( options ) {
		return this.each(function () {
			var instance = $.data(this, 'plugin_' + name);
			if (instance) {
				if (typeof options === 'string') {
					instance[options].apply(instance);
				} else {
					instance.updateOptions(options);
				}
			} else if(options !== 'destroy') {
				$.data(this, 'plugin_' + name, new Plugin( this, options ));
			}
		});
	};

})(jQuery, window);

/* -------------------------------------------------------------------------------------------------- */
/* jquery-autonumeric.js */
/* File: js/machinata-core-bundle.js/jquery-autonumeric.js */
/* -------------------------------------------------------------------------------------------------- */

/**
* autoNumeric.js
* @author: Bob Knothe
* @author: Sokolov Yura
* @version: 1.9.26 - 2014-10-07 GMT 2:00 PM
*
* Created by Robert J. Knothe on 2010-10-25. Please report any bugs to https://github.com/BobKnothe/autoNumeric
* Created by Sokolov Yura on 2010-11-07
*
* Copyright (c) 2011 Robert J. Knothe http://www.decorplanit.com/plugin/
*
* The MIT License (http://www.opensource.org/licenses/mit-license.php)
*
* Permission is hereby granted, free of charge, to any person
* obtaining a copy of this software and associated documentation
* files (the "Software"), to deal in the Software without
* restriction, including without limitation the rights to use,
* copy, modify, merge, publish, distribute, sublicense, and/or sell
* copies of the Software, and to permit persons to whom the
* Software is furnished to do so, subject to the following
* conditions:
*
* The above copyright notice and this permission notice shall be
* included in all copies or substantial portions of the Software.
*
* THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
* EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
* OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
* NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
* HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
* FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
* OTHER DEALINGS IN THE SOFTWARE.
*/
(function ($) {
    "use strict";
    /*jslint browser: true*/
    /*global jQuery: false*/
    /* Cross browser routine for getting selected range/cursor position
     */
    function getElementSelection(that) {
        var position = {};
        if (that.selectionStart === undefined) {
            that.focus();
            var select = document.selection.createRange();
            position.length = select.text.length;
            select.moveStart('character', -that.value.length);
            position.end = select.text.length;
            position.start = position.end - position.length;
        } else {
            position.start = that.selectionStart;
            position.end = that.selectionEnd;
            position.length = position.end - position.start;
        }
        return position;
    }
    /**
     * Cross browser routine for setting selected range/cursor position
     */
    function setElementSelection(that, start, end) {
        if (that.selectionStart === undefined) {
            that.focus();
            var r = that.createTextRange();
            r.collapse(true);
            r.moveEnd('character', end);
            r.moveStart('character', start);
            r.select();
        } else {
            that.selectionStart = start;
            that.selectionEnd = end;
        }
    }
    /**
     * run callbacks in parameters if any
     * any parameter could be a callback:
     * - a function, which invoked with jQuery element, parameters and this parameter name and returns parameter value
     * - a name of function, attached to $(selector).autoNumeric.functionName(){} - which was called previously
     */
    function runCallbacks($this, settings) {
        /**
         * loops through the settings object (option array) to find the following
         * k = option name example k=aNum
         * val = option value example val=0123456789
         */
        $.each(settings, function (k, val) {
            if (typeof val === 'function') {
                settings[k] = val($this, settings, k);
            } else if (typeof $this.autoNumeric[val] === 'function') {
                /**
                 * calls the attached function from the html5 data example: data-a-sign="functionName"
                 */
                settings[k] = $this.autoNumeric[val]($this, settings, k);
            }
        });
    }
    function convertKeyToNumber(settings, key) {
        if (typeof (settings[key]) === 'string') {
            settings[key] *= 1;
        }
    }
    /**
     * Preparing user defined options for further usage
     * merge them with defaults appropriately
     */
    function autoCode($this, settings) {
        runCallbacks($this, settings);
        settings.oEvent = null;
        settings.tagList = ['b', 'caption', 'cite', 'code', 'dd', 'del', 'div', 'dfn', 'dt', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ins', 'kdb', 'label', 'li', 'output', 'p', 'q', 's', 'sample', 'span', 'strong', 'td', 'th', 'u', 'var'];
        var vmax = settings.vMax.toString().split('.'),
            vmin = (!settings.vMin && settings.vMin !== 0) ? [] : settings.vMin.toString().split('.');
        convertKeyToNumber(settings, 'vMax');
        convertKeyToNumber(settings, 'vMin');
        convertKeyToNumber(settings, 'mDec'); /** set mDec if not defined by user */
        settings.mDec = (settings.mRound === 'CHF') ? '2' : settings.mDec;
        settings.allowLeading = true;
        settings.aNeg = settings.vMin < 0 ? '-' : '';
        vmax[0] = vmax[0].replace('-', '');
        vmin[0] = vmin[0].replace('-', '');
        settings.mInt = Math.max(vmax[0].length, vmin[0].length, 1);
        if (settings.mDec === null) {
            var vmaxLength = 0,
                vminLength = 0;
            if (vmax[1]) {
                vmaxLength = vmax[1].length;
            }
            if (vmin[1]) {
                vminLength = vmin[1].length;
            }
            settings.mDec = Math.max(vmaxLength, vminLength);
        } /** set alternative decimal separator key */
        if (settings.altDec === null && settings.mDec > 0) {
            if (settings.aDec === '.' && settings.aSep !== ',') {
                settings.altDec = ',';
            } else if (settings.aDec === ',' && settings.aSep !== '.') {
                settings.altDec = '.';
            }
        }
        /** cache regexps for autoStrip */
        var aNegReg = settings.aNeg ? '([-\\' + settings.aNeg + ']?)' : '(-?)';
        settings.aNegRegAutoStrip = aNegReg;
        settings.skipFirstAutoStrip = new RegExp(aNegReg + '[^-' + (settings.aNeg ? '\\' + settings.aNeg : '') + '\\' + settings.aDec + '\\d]' + '.*?(\\d|\\' + settings.aDec + '\\d)');
        settings.skipLastAutoStrip = new RegExp('(\\d\\' + settings.aDec + '?)[^\\' + settings.aDec + '\\d]\\D*$');
        var allowed = '-' + settings.aNum + '\\' + settings.aDec;
        settings.allowedAutoStrip = new RegExp('[^' + allowed + ']', 'gi');
        settings.numRegAutoStrip = new RegExp(aNegReg + '(?:\\' + settings.aDec + '?(\\d+\\' + settings.aDec + '\\d+)|(\\d*(?:\\' + settings.aDec + '\\d*)?))');
        return settings;
    }
    /**
     * strip all unwanted characters and leave only a number alert
     */
    function autoStrip(s, settings, strip_zero) {
        if (settings.aSign) { /** remove currency sign */
            while (s.indexOf(settings.aSign) > -1) {
                s = s.replace(settings.aSign, '');
            }
        }
        s = s.replace(settings.skipFirstAutoStrip, '$1$2'); /** first replace anything before digits */
        s = s.replace(settings.skipLastAutoStrip, '$1'); /** then replace anything after digits */
        s = s.replace(settings.allowedAutoStrip, ''); /** then remove any uninterested characters */
        if (settings.altDec) {
            s = s.replace(settings.altDec, settings.aDec);
        } /** get only number string */
        var m = s.match(settings.numRegAutoStrip);
        s = m ? [m[1], m[2], m[3]].join('') : '';
        if ((settings.lZero === 'allow' || settings.lZero === 'keep') && strip_zero !== 'strip') {
            var parts = [],
                nSign = '';
            parts = s.split(settings.aDec);
            if (parts[0].indexOf('-') !== -1) {
                nSign = '-';
                parts[0] = parts[0].replace('-', '');
            }
            if (parts[0].length > settings.mInt && parts[0].charAt(0) === '0') { /** strip leading zero if need */
                parts[0] = parts[0].slice(1);
            }
            s = nSign + parts.join(settings.aDec);
        }
        if ((strip_zero && settings.lZero === 'deny') || (strip_zero && settings.lZero === 'allow' && settings.allowLeading === false)) {
            var strip_reg = '^' + settings.aNegRegAutoStrip + '0*(\\d' + (strip_zero === 'leading' ? ')' : '|$)');
            strip_reg = new RegExp(strip_reg);
            s = s.replace(strip_reg, '$1$2');
        }
        return s;
    }
    /**
     * places or removes brackets on negative values
     */
    function negativeBracket(s, nBracket, oEvent) { /** oEvent = settings.oEvent */
        nBracket = nBracket.split(',');
        if (oEvent === 'set' || oEvent === 'focusout') {
            s = s.replace('-', '');
            s = nBracket[0] + s + nBracket[1];
        } else if ((oEvent === 'get' || oEvent === 'focusin' || oEvent === 'pageLoad') && s.charAt(0) === nBracket[0]) {
            s = s.replace(nBracket[0], '-');
            s = s.replace(nBracket[1], '');
        }
        return s;
    }
    /**
     * truncate decimal part of a number
     */
    function truncateDecimal(s, aDec, mDec) {
        if (aDec && mDec) {
            var parts = s.split(aDec);
            /** truncate decimal part to satisfying length
             * cause we would round it anyway */
            if (parts[1] && parts[1].length > mDec) {
                if (mDec > 0) {
                    parts[1] = parts[1].substring(0, mDec);
                    s = parts.join(aDec);
                } else {
                    s = parts[0];
                }
            }
        }
        return s;
    }
    /**
     * prepare number string to be converted to real number
     */
    function fixNumber(s, aDec, aNeg) {
        if (aDec && aDec !== '.') {
            s = s.replace(aDec, '.');
        }
        if (aNeg && aNeg !== '-') {
            s = s.replace(aNeg, '-');
        }
        if (!s.match(/\d/)) {
            s += '0';
        }
        return s;
    }
    /**
     * function to handle numbers less than 0 that are stored in Exponential notation ex: .0000001 stored as 1e-7
     */
    function checkValue(value, settings) {
        if (value) {
            var checkSmall = +value;
            if (checkSmall < 0.000001 && checkSmall > -1) {
                value = +value;
                if (value < 0.000001 && value > 0) {
                    value = (value + 10).toString();
                    value = value.substring(1);
                }
                if (value < 0 && value > -1) {
                    value = (value - 10).toString();
                    value = '-' + value.substring(2);
                }
                value = value.toString();
            } else {
                var parts = value.split('.');
                if (parts[1] !== undefined) {
                    if (+parts[1] === 0) {
                        value = parts[0];
                    } else {
                        parts[1] = parts[1].replace(/0*$/, '');
                        value = parts.join('.');
                    }
                }
            }
        }
        return (settings.lZero === 'keep') ? value : value.replace(/^0*(\d)/, '$1');
    }
    /**
     * prepare real number to be converted to our format
     */
    function presentNumber(s, aDec, aNeg) {
        if (aNeg && aNeg !== '-') {
            s = s.replace('-', aNeg);
        }
        if (aDec && aDec !== '.') {
            s = s.replace('.', aDec);
        }
        return s;
    }
    /**
     * checking that number satisfy format conditions
     * and lays between settings.vMin and settings.vMax
     * and the string length does not exceed the digits in settings.vMin and settings.vMax
     */
    function autoCheck(s, settings) {
        s = autoStrip(s, settings);
        s = truncateDecimal(s, settings.aDec, settings.mDec);
        s = fixNumber(s, settings.aDec, settings.aNeg);
        var value = +s;
        if (settings.oEvent === 'set' && (value < settings.vMin || value > settings.vMax)) {
            $.error("The value (" + value + ") from the 'set' method falls outside of the vMin / vMax range");
        }
        return value >= settings.vMin && value <= settings.vMax;
    }
    /**
     * private function to check for empty value
     */
    function checkEmpty(iv, settings, signOnEmpty) {
        if (iv === '' || iv === settings.aNeg) {
            if (settings.wEmpty === 'zero') {
                return iv + '0';
            }
            if (settings.wEmpty === 'sign' || signOnEmpty) {
                return iv + settings.aSign;
            }
            return iv;
        }
        return null;
    }
    /**
     * private function that formats our number
     */
    function autoGroup(iv, settings) {
        iv = autoStrip(iv, settings);
        var testNeg = iv.replace(',', '.'),
            empty = checkEmpty(iv, settings, true);
        if (empty !== null) {
            return empty;
        }
        var digitalGroup = '';
        if (settings.dGroup === 2) {
            digitalGroup = /(\d)((\d)(\d{2}?)+)$/;
        } else if (settings.dGroup === 4) {
            digitalGroup = /(\d)((\d{4}?)+)$/;
        } else {
            digitalGroup = /(\d)((\d{3}?)+)$/;
        } /** splits the string at the decimal string */
        var ivSplit = iv.split(settings.aDec);
        if (settings.altDec && ivSplit.length === 1) {
            ivSplit = iv.split(settings.altDec);
        } /** assigns the whole number to the a varibale (s) */
        var s = ivSplit[0];
        if (settings.aSep) {
            while (digitalGroup.test(s)) { /** re-inserts the thousand sepparator via a regualer expression */
                s = s.replace(digitalGroup, '$1' + settings.aSep + '$2');
            }
        }
        if (settings.mDec !== 0 && ivSplit.length > 1) {
            if (ivSplit[1].length > settings.mDec) {
                ivSplit[1] = ivSplit[1].substring(0, settings.mDec);
            } /** joins the whole number with the deciaml value */
            iv = s + settings.aDec + ivSplit[1];
        } else { /** if whole numbers only */
            iv = s;
        }
        if (settings.aSign) {
            var has_aNeg = iv.indexOf(settings.aNeg) !== -1;
            iv = iv.replace(settings.aNeg, '');
            iv = settings.pSign === 'p' ? settings.aSign + iv : iv + settings.aSign;
            if (has_aNeg) {
                iv = settings.aNeg + iv;
            }
        }
        if (settings.oEvent === 'set' && testNeg < 0 && settings.nBracket !== null) { /** removes the negative sign and places brackets */
            iv = negativeBracket(iv, settings.nBracket, settings.oEvent);
        }
        return iv;
    }
    /**
     * round number after setting by pasting or $().autoNumericSet()
     * private function for round the number
     * please note this handled as text - JavaScript math function can return inaccurate values
     * also this offers multiple rounding methods that are not easily accomplished in JavaScript
     */
    function autoRound(iv, settings) { /** value to string */
        iv = (iv === '') ? '0' : iv.toString();
        convertKeyToNumber(settings, 'mDec'); /** set mDec to number needed when mDec set by 'update method */
        if (settings.mRound === 'CHF') {
            iv = (Math.round(iv * 20) / 20).toString();
        }
        var ivRounded = '',
            i = 0,
            nSign = '',
            rDec = (typeof (settings.aPad) === 'boolean' || settings.aPad === null) ? (settings.aPad ? settings.mDec : 0) : +settings.aPad;
        var truncateZeros = function (ivRounded) { /** truncate not needed zeros */
            var regex = (rDec === 0) ? (/(\.(?:\d*[1-9])?)0*$/) : rDec === 1 ? (/(\.\d(?:\d*[1-9])?)0*$/) : new RegExp('(\\.\\d{' + rDec + '}(?:\\d*[1-9])?)0*$');
            ivRounded = ivRounded.replace(regex, '$1'); /** If there are no decimal places, we don't need a decimal point at the end */
            if (rDec === 0) {
                ivRounded = ivRounded.replace(/\.$/, '');
            }
            return ivRounded;
        };
        if (iv.charAt(0) === '-') { /** Checks if the iv (input Value)is a negative value */
            nSign = '-';
            iv = iv.replace('-', ''); /** removes the negative sign will be added back later if required */
        }
        if (!iv.match(/^\d/)) { /** append a zero if first character is not a digit (then it is likely to be a dot)*/
            iv = '0' + iv;
        }
        if (nSign === '-' && +iv === 0) { /** determines if the value is zero - if zero no negative sign */
            nSign = '';
        }
        if ((+iv > 0 && settings.lZero !== 'keep') || (iv.length > 0 && settings.lZero === 'allow')) { /** trims leading zero's if needed */
            iv = iv.replace(/^0*(\d)/, '$1');
        }
        var dPos = iv.lastIndexOf('.'), /** virtual decimal position */
            vdPos = (dPos === -1) ? iv.length - 1 : dPos, /** checks decimal places to determine if rounding is required */
            cDec = (iv.length - 1) - vdPos; /** check if no rounding is required */
        if (cDec <= settings.mDec) {
            ivRounded = iv; /** check if we need to pad with zeros */
            if (cDec < rDec) {
                if (dPos === -1) {
                    ivRounded += '.';
                }
                var zeros = '000000';
                while (cDec < rDec) {
                    zeros = zeros.substring(0, rDec - cDec);
                    ivRounded += zeros;
                    cDec += zeros.length;
                }
            } else if (cDec > rDec) {
                ivRounded = truncateZeros(ivRounded);
            } else if (cDec === 0 && rDec === 0) {
                ivRounded = ivRounded.replace(/\.$/, '');
            }
            if (settings.mRound !== 'CHF') {
                return (+ivRounded === 0) ? ivRounded : nSign + ivRounded;
            }
            if (settings.mRound === 'CHF') {
                dPos = ivRounded.lastIndexOf('.');
                iv = ivRounded;
            }

        } /** rounded length of the string after rounding */
        var rLength = dPos + settings.mDec,
            tRound = +iv.charAt(rLength + 1),
            ivArray = iv.substring(0, rLength + 1).split(''),
            odd = (iv.charAt(rLength) === '.') ? (iv.charAt(rLength - 1) % 2) : (iv.charAt(rLength) % 2),
            onePass = true;
        if (odd !== 1) {
            odd = (odd === 0 && (iv.substring(rLength + 2, iv.length) > 0)) ? 1 : 0;
        }
        if ((tRound > 4 && settings.mRound === 'S') || /** Round half up symmetric */
                (tRound > 4 && settings.mRound === 'A' && nSign === '') || /** Round half up asymmetric positive values */
                (tRound > 5 && settings.mRound === 'A' && nSign === '-') || /** Round half up asymmetric negative values */
                (tRound > 5 && settings.mRound === 's') || /** Round half down symmetric */
                (tRound > 5 && settings.mRound === 'a' && nSign === '') || /** Round half down asymmetric positive values */
                (tRound > 4 && settings.mRound === 'a' && nSign === '-') || /** Round half down asymmetric negative values */
                (tRound > 5 && settings.mRound === 'B') || /** Round half even "Banker's Rounding" */
                (tRound === 5 && settings.mRound === 'B' && odd === 1) || /** Round half even "Banker's Rounding" */
                (tRound > 0 && settings.mRound === 'C' && nSign === '') || /** Round to ceiling toward positive infinite */
                (tRound > 0 && settings.mRound === 'F' && nSign === '-') || /** Round to floor toward negative infinite */
                (tRound > 0 && settings.mRound === 'U') ||
                (settings.mRound === 'CHF')) { /** round up away from zero */
            for (i = (ivArray.length - 1); i >= 0; i -= 1) { /** Round up the last digit if required, and continue until no more 9's are found */
                if (ivArray[i] !== '.') {
                    if (settings.mRound === 'CHF' && ivArray[i] <= 2 && onePass) {
                        ivArray[i] = 0;
                        onePass = false;
                        break;
                    }
                    if (settings.mRound === 'CHF' && ivArray[i] <= 7 && onePass) {
                        ivArray[i] = 5;
                        onePass = false;
                        break;
                    }
                    if (settings.mRound === 'CHF' && onePass) {
                        ivArray[i] = 10;
                        onePass = false;
                    } else {
                        ivArray[i] = +ivArray[i] + 1;
                    }
                    if (ivArray[i] < 10) {
                        break;
                    }
                    if (i > 0) {
                        ivArray[i] = '0';
                    }
                }
            }
        }
        ivArray = ivArray.slice(0, rLength + 1); /** Reconstruct the string, converting any 10's to 0's */
        ivRounded = truncateZeros(ivArray.join('')); /** return rounded value */
        return (+ivRounded === 0) ? ivRounded : nSign + ivRounded;
    }
    /**
     * Holder object for field properties
     */
    function AutoNumericHolder(that, settings) {
        this.settings = settings;
        this.that = that;
        this.$that = $(that);
        this.formatted = false;
        this.settingsClone = autoCode(this.$that, this.settings);
        this.value = that.value;
    }
    AutoNumericHolder.prototype = {
        init: function (e) {
            this.value = this.that.value;
            this.settingsClone = autoCode(this.$that, this.settings);
            this.ctrlKey = e.ctrlKey;
            this.cmdKey = e.metaKey;
            this.shiftKey = e.shiftKey;
            this.selection = getElementSelection(this.that); /** keypress event overwrites meaningful value of e.keyCode */
            if (e.type === 'keydown' || e.type === 'keyup') {
                this.kdCode = e.keyCode;
            }
            this.which = e.which;
            this.processed = false;
            this.formatted = false;
        },
        setSelection: function (start, end, setReal) {
            start = Math.max(start, 0);
            end = Math.min(end, this.that.value.length);
            this.selection = {
                start: start,
                end: end,
                length: end - start
            };
            if (setReal === undefined || setReal) {
                setElementSelection(this.that, start, end);
            }
        },
        setPosition: function (pos, setReal) {
            this.setSelection(pos, pos, setReal);
        },
        getBeforeAfter: function () {
            var value = this.value,
                left = value.substring(0, this.selection.start),
                right = value.substring(this.selection.end, value.length);
            return [left, right];
        },
        getBeforeAfterStriped: function () {
            var parts = this.getBeforeAfter();
            parts[0] = autoStrip(parts[0], this.settingsClone);
            parts[1] = autoStrip(parts[1], this.settingsClone);
            return parts;
        },
        /**
         * strip parts from excess characters and leading zeroes
         */
        normalizeParts: function (left, right) {
            var settingsClone = this.settingsClone;
            right = autoStrip(right, settingsClone); /** if right is not empty and first character is not aDec, */
            /** we could strip all zeros, otherwise only leading */
            var strip = right.match(/^\d/) ? true : 'leading';
            left = autoStrip(left, settingsClone, strip); /** prevents multiple leading zeros from being entered */
            if ((left === '' || left === settingsClone.aNeg) && settingsClone.lZero === 'deny') {
                if (right > '') {
                    right = right.replace(/^0*(\d)/, '$1');
                }
            }
            var new_value = left + right; /** insert zero if has leading dot */
            if (settingsClone.aDec) {
                var m = new_value.match(new RegExp('^' + settingsClone.aNegRegAutoStrip + '\\' + settingsClone.aDec));
                if (m) {
                    left = left.replace(m[1], m[1] + '0');
                    new_value = left + right;
                }
            } /** insert zero if number is empty and io.wEmpty == 'zero' */
            if (settingsClone.wEmpty === 'zero' && (new_value === settingsClone.aNeg || new_value === '')) {
                left += '0';
            }
            return [left, right];
        },
        /**
         * set part of number to value keeping position of cursor
         */
        setValueParts: function (left, right) {
            var settingsClone = this.settingsClone,
                parts = this.normalizeParts(left, right),
                new_value = parts.join(''),
                position = parts[0].length;
            if (autoCheck(new_value, settingsClone)) {
                new_value = truncateDecimal(new_value, settingsClone.aDec, settingsClone.mDec);
                if (position > new_value.length) {
                    position = new_value.length;
                }
                this.value = new_value;
                this.setPosition(position, false);
                return true;
            }
            return false;
        },
        /**
         * helper function for expandSelectionOnSign
         * returns sign position of a formatted value
         */
        signPosition: function () {
            var settingsClone = this.settingsClone,
                aSign = settingsClone.aSign,
                that = this.that;
            if (aSign) {
                var aSignLen = aSign.length;
                if (settingsClone.pSign === 'p') {
                    var hasNeg = settingsClone.aNeg && that.value && that.value.charAt(0) === settingsClone.aNeg;
                    return hasNeg ? [1, aSignLen + 1] : [0, aSignLen];
                }
                var valueLen = that.value.length;
                return [valueLen - aSignLen, valueLen];
            }
            return [1000, -1];
        },
        /**
         * expands selection to cover whole sign
         * prevents partial deletion/copying/overwriting of a sign
         */
        expandSelectionOnSign: function (setReal) {
            var sign_position = this.signPosition(),
                selection = this.selection;
            if (selection.start < sign_position[1] && selection.end > sign_position[0]) { /** if selection catches something except sign and catches only space from sign */
                if ((selection.start < sign_position[0] || selection.end > sign_position[1]) && this.value.substring(Math.max(selection.start, sign_position[0]), Math.min(selection.end, sign_position[1])).match(/^\s*$/)) { /** then select without empty space */
                    if (selection.start < sign_position[0]) {
                        this.setSelection(selection.start, sign_position[0], setReal);
                    } else {
                        this.setSelection(sign_position[1], selection.end, setReal);
                    }
                } else { /** else select with whole sign */
                    this.setSelection(Math.min(selection.start, sign_position[0]), Math.max(selection.end, sign_position[1]), setReal);
                }
            }
        },
        /**
         * try to strip pasted value to digits
         */
        checkPaste: function () {
            if (this.valuePartsBeforePaste !== undefined) {
                var parts = this.getBeforeAfter(),
                    oldParts = this.valuePartsBeforePaste;
                delete this.valuePartsBeforePaste; /** try to strip pasted value first */
                parts[0] = parts[0].substr(0, oldParts[0].length) + autoStrip(parts[0].substr(oldParts[0].length), this.settingsClone);
                if (!this.setValueParts(parts[0], parts[1])) {
                    this.value = oldParts.join('');
                    this.setPosition(oldParts[0].length, false);
                }
            }
        },
        /**
         * process pasting, cursor moving and skipping of not interesting keys
         * if returns true, further processing is not performed
         */
        skipAllways: function (e) {
            var kdCode = this.kdCode,
                which = this.which,
                ctrlKey = this.ctrlKey,
                cmdKey = this.cmdKey,
                shiftKey = this.shiftKey; /** catch the ctrl up on ctrl-v */
            if (((ctrlKey || cmdKey) && e.type === 'keyup' && this.valuePartsBeforePaste !== undefined) || (shiftKey && kdCode === 45)) {
                this.checkPaste();
                return false;
            }
            /** codes are taken from http://www.cambiaresearch.com/c4/702b8cd1-e5b0-42e6-83ac-25f0306e3e25/Javascript-Char-Codes-Key-Codes.aspx
             * skip Fx keys, windows keys, other special keys
             */
            if ((kdCode >= 112 && kdCode <= 123) || (kdCode >= 91 && kdCode <= 93) || (kdCode >= 9 && kdCode <= 31) || (kdCode < 8 && (which === 0 || which === kdCode)) || kdCode === 144 || kdCode === 145 || kdCode === 45) {
                return true;
            }
            if ((ctrlKey || cmdKey) && kdCode === 65) { /** if select all (a=65)*/
                return true;
            }
            if ((ctrlKey || cmdKey) && (kdCode === 67 || kdCode === 86 || kdCode === 88)) { /** if copy (c=67) paste (v=86) or cut (x=88) */
                if (e.type === 'keydown') {
                    this.expandSelectionOnSign();
                }
                if (kdCode === 86 || kdCode === 45) { /** try to prevent wrong paste */
                    if (e.type === 'keydown' || e.type === 'keypress') {
                        if (this.valuePartsBeforePaste === undefined) {
                            this.valuePartsBeforePaste = this.getBeforeAfter();
                        }
                    } else {
                        this.checkPaste();
                    }
                }
                return e.type === 'keydown' || e.type === 'keypress' || kdCode === 67;
            }
            if (ctrlKey || cmdKey) {
                return true;
            }
            if (kdCode === 37 || kdCode === 39) { /** jump over thousand separator */
                var aSep = this.settingsClone.aSep,
                    start = this.selection.start,
                    value = this.that.value;
                if (e.type === 'keydown' && aSep && !this.shiftKey) {
                    if (kdCode === 37 && value.charAt(start - 2) === aSep) {
                        this.setPosition(start - 1);
                    } else if (kdCode === 39 && value.charAt(start + 1) === aSep) {
                        this.setPosition(start + 1);
                    }
                }
                return true;
            }
            if (kdCode >= 34 && kdCode <= 40) {
                return true;
            }
            return false;
        },
        /**
         * process deletion of characters
         * returns true if processing performed
         */
        processAllways: function () {
            var parts; /** process backspace or delete */
            if (this.kdCode === 8 || this.kdCode === 46) {
                if (!this.selection.length) {
                    parts = this.getBeforeAfterStriped();
                    if (this.kdCode === 8) {
                        parts[0] = parts[0].substring(0, parts[0].length - 1);
                    } else {
                        parts[1] = parts[1].substring(1, parts[1].length);
                    }
                    this.setValueParts(parts[0], parts[1]);
                } else {
                    this.expandSelectionOnSign(false);
                    parts = this.getBeforeAfterStriped();
                    this.setValueParts(parts[0], parts[1]);
                }
                return true;
            }
            return false;
        },
        /**
         * process insertion of characters
         * returns true if processing performed
         */
        processKeypress: function () {
            var settingsClone = this.settingsClone,
                cCode = String.fromCharCode(this.which),
                parts = this.getBeforeAfterStriped(),
                left = parts[0],
                right = parts[1]; /** start rules when the decimal character key is pressed */
            /** always use numeric pad dot to insert decimal separator */
            if (cCode === settingsClone.aDec || (settingsClone.altDec && cCode === settingsClone.altDec) || ((cCode === '.' || cCode === ',') && this.kdCode === 110)) { /** do not allow decimal character if no decimal part allowed */
                if (!settingsClone.mDec || !settingsClone.aDec) {
                    return true;
                } /** do not allow decimal character before aNeg character */
                if (settingsClone.aNeg && right.indexOf(settingsClone.aNeg) > -1) {
                    return true;
                } /** do not allow decimal character if other decimal character present */
                if (left.indexOf(settingsClone.aDec) > -1) {
                    return true;
                }
                if (right.indexOf(settingsClone.aDec) > 0) {
                    return true;
                }
                if (right.indexOf(settingsClone.aDec) === 0) {
                    right = right.substr(1);
                }
                this.setValueParts(left + settingsClone.aDec, right);
                return true;
            }
            /**
             * start rule on negative sign & prevent minus if not allowed
             */
            if (cCode === '-' || cCode === '+') {
                if (!settingsClone.aNeg) {
                    return true;
                } /** caret is always after minus */
                if (left === '' && right.indexOf(settingsClone.aNeg) > -1) {
                    left = settingsClone.aNeg;
                    right = right.substring(1, right.length);
                } /** change sign of number, remove part if should */
                if (left.charAt(0) === settingsClone.aNeg) {
                    left = left.substring(1, left.length);
                } else {
                    left = (cCode === '-') ? settingsClone.aNeg + left : left;
                }
                this.setValueParts(left, right);
                return true;
            } /** digits */
            if (cCode >= '0' && cCode <= '9') { /** if try to insert digit before minus */
                if (settingsClone.aNeg && left === '' && right.indexOf(settingsClone.aNeg) > -1) {
                    left = settingsClone.aNeg;
                    right = right.substring(1, right.length);
                }
                if (settingsClone.vMax <= 0 && settingsClone.vMin < settingsClone.vMax && this.value.indexOf(settingsClone.aNeg) === -1 && cCode !== '0') {
                    left = settingsClone.aNeg + left;
                }
                this.setValueParts(left + cCode, right);
                return true;
            } /** prevent any other character */
            return true;
        },
        /**
         * formatting of just processed value with keeping of cursor position
         */
        formatQuick: function () {
            var settingsClone = this.settingsClone,
                parts = this.getBeforeAfterStriped(),
                leftLength = this.value;
            if ((settingsClone.aSep === '' || (settingsClone.aSep !== '' && leftLength.indexOf(settingsClone.aSep) === -1)) && (settingsClone.aSign === '' || (settingsClone.aSign !== '' && leftLength.indexOf(settingsClone.aSign) === -1))) {
                var subParts = [],
                    nSign = '';
                subParts = leftLength.split(settingsClone.aDec);
                if (subParts[0].indexOf('-') > -1) {
                    nSign = '-';
                    subParts[0] = subParts[0].replace('-', '');
                    parts[0] = parts[0].replace('-', '');
                }
                if (subParts[0].length > settingsClone.mInt && parts[0].charAt(0) === '0') { /** strip leading zero if need */
                    parts[0] = parts[0].slice(1);
                }
                parts[0] = nSign + parts[0];
            }
            var value = autoGroup(this.value, this.settingsClone),
                position = value.length;
            if (value) {
                /** prepare regexp which searches for cursor position from unformatted left part */
                var left_ar = parts[0].split(''),
                    i = 0;
                for (i; i < left_ar.length; i += 1) { /** thanks Peter Kovari */
                    if (!left_ar[i].match('\\d')) {
                        left_ar[i] = '\\' + left_ar[i];
                    }
                }
                var leftReg = new RegExp('^.*?' + left_ar.join('.*?'));
                /** search cursor position in formatted value */
                var newLeft = value.match(leftReg);
                if (newLeft) {
                    position = newLeft[0].length;
                    /** if we are just before sign which is in prefix position */
                    if (((position === 0 && value.charAt(0) !== settingsClone.aNeg) || (position === 1 && value.charAt(0) === settingsClone.aNeg)) && settingsClone.aSign && settingsClone.pSign === 'p') {
                        /** place caret after prefix sign */
                        position = this.settingsClone.aSign.length + (value.charAt(0) === '-' ? 1 : 0);
                    }
                } else if (settingsClone.aSign && settingsClone.pSign === 's') {
                    /** if we could not find a place for cursor and have a sign as a suffix */
                    /** place carret before suffix currency sign */
                    position -= settingsClone.aSign.length;
                }
            }
            this.that.value = value;
            this.setPosition(position);
            this.formatted = true;
        }
    };
    /** thanks to Anthony & Evan C */
    function autoGet(obj) {
        if (typeof obj === 'string') {
            obj = obj.replace(/\[/g, "\\[").replace(/\]/g, "\\]");
            obj = '#' + obj.replace(/(:|\.)/g, '\\$1');
            /** obj = '#' + obj.replace(/([;&,\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g, '\\$1'); */
            /** possible modification to replace the above 2 lines */
        }
        return $(obj);
    }

    function getHolder($that, settings, update) {
        var data = $that.data('autoNumeric');
        if (!data) {
            data = {};
            $that.data('autoNumeric', data);
        }
        var holder = data.holder;
        if ((holder === undefined && settings) || update) {
            holder = new AutoNumericHolder($that.get(0), settings);
            data.holder = holder;
        }
        return holder;
    }
    var methods = {
        init: function (options) {
            return this.each(function () {
                var $this = $(this),
                    settings = $this.data('autoNumeric'), /** attempt to grab 'autoNumeric' settings, if they don't exist returns "undefined". */
                    tagData = $this.data(); /** attempt to grab HTML5 data, if they don't exist we'll get "undefined".*/
                if (typeof settings !== 'object') { /** If we couldn't grab settings, create them from defaults and passed options. */
                    var defaults = {
                        /** allowed numeric values
                         * please do not modify
                         */
                        aNum: '0123456789',
                        /** allowed thousand separator characters
                         * comma = ','
                         * period "full stop" = '.'
                         * apostrophe is escaped = '\''
                         * space = ' '
                         * none = ''
                         * NOTE: do not use numeric characters
                         */
                        aSep: ',',
                        /** digital grouping for the thousand separator used in Format
                         * dGroup: '2', results in 99,99,99,999 common in India for values less than 1 billion and greater than -1 billion
                         * dGroup: '3', results in 999,999,999 default
                         * dGroup: '4', results in 9999,9999,9999 used in some Asian countries
                         */
                        dGroup: '3',
                        /** allowed decimal separator characters
                         * period "full stop" = '.'
                         * comma = ','
                         */
                        aDec: '.',
                        /** allow to declare alternative decimal separator which is automatically replaced by aDec
                         * developed for countries the use a comma ',' as the decimal character
                         * and have keyboards\numeric pads that have a period 'full stop' as the decimal characters (Spain is an example)
                         */
                        altDec: null,
                        /** allowed currency symbol
                         * Must be in quotes aSign: '$', a space is allowed aSign: '$ '
                         */
                        aSign: '',
                        /** placement of currency sign
                         * for prefix pSign: 'p',
                         * for suffix pSign: 's',
                         */
                        pSign: 'p',
                        /** maximum possible value
                         * value must be enclosed in quotes and use the period for the decimal point
                         * value must be larger than vMin
                         */
                        vMax: '9999999999999.99',
                        /** minimum possible value
                         * value must be enclosed in quotes and use the period for the decimal point
                         * value must be smaller than vMax
                         */
                        vMin: '0.00',
                        /** max number of decimal places = used to override decimal places set by the vMin & vMax values
                         * value must be enclosed in quotes example mDec: '3',
                         * This can also set the value via a call back function mDec: 'css:#
                         */
                        mDec: null,
                        /** method used for rounding
                         * mRound: 'S', Round-Half-Up Symmetric (default)
                         * mRound: 'A', Round-Half-Up Asymmetric
                         * mRound: 's', Round-Half-Down Symmetric (lower case s)
                         * mRound: 'a', Round-Half-Down Asymmetric (lower case a)
                         * mRound: 'B', Round-Half-Even "Bankers Rounding"
                         * mRound: 'U', Round Up "Round-Away-From-Zero"
                         * mRound: 'D', Round Down "Round-Toward-Zero" - same as truncate
                         * mRound: 'C', Round to Ceiling "Toward Positive Infinity"
                         * mRound: 'F', Round to Floor "Toward Negative Infinity"
                         */
                        mRound: 'S',
                        /** controls decimal padding
                         * aPad: true - always Pad decimals with zeros
                         * aPad: false - does not pad with zeros.
                         * aPad: `some number` - pad decimals with zero to number different from mDec
                         * thanks to Jonas Johansson for the suggestion
                         */
                        aPad: true,
                        /** places brackets on negative value -$ 999.99 to (999.99)
                         * visible only when the field does NOT have focus the left and right symbols should be enclosed in quotes and seperated by a comma
                         * nBracket: null, nBracket: '(,)', nBracket: '[,]', nBracket: '<,>' or nBracket: '{,}'
                         */
                        nBracket: null,
                        /** Displayed on empty string
                         * wEmpty: 'empty', - input can be blank
                         * wEmpty: 'zero', - displays zero
                         * wEmpty: 'sign', - displays the currency sign
                         */
                        wEmpty: 'empty',
                        /** controls leading zero behavior
                         * lZero: 'allow', - allows leading zeros to be entered. Zeros will be truncated when entering additional digits. On focusout zeros will be deleted.
                         * lZero: 'deny', - allows only one leading zero on values less than one
                         * lZero: 'keep', - allows leading zeros to be entered. on fousout zeros will be retained.
                         */
                        lZero: 'allow',
                        /** determine if the default value will be formatted on page ready.
                         * true = automatically formats the default value on page ready
                         * false = will not format the default value
                         */
                        aForm: true,
                        /** future use */
                        onSomeEvent: function () {}
                    };
                    settings = $.extend({}, defaults, tagData, options); /** Merge defaults, tagData and options */
                    if (settings.aDec === settings.aSep) {
                        $.error("autoNumeric will not function properly when the decimal character aDec: '" + settings.aDec + "' and thousand separator aSep: '" + settings.aSep + "' are the same character");
                        return this;
                    }
                    $this.data('autoNumeric', settings); /** Save our new settings */
                } else {
                    return this;
                }
                settings.runOnce = false;
                var holder = getHolder($this, settings);
                if ($.inArray($this.prop('tagName').toLowerCase(), settings.tagList) === -1 && $this.prop('tagName').toLowerCase() !== 'input') {
                    $.error("The <" + $this.prop('tagName').toLowerCase() + "> is not supported by autoNumeric()");
                    return this;
                }
                if (settings.runOnce === false && settings.aForm) {/** routine to format default value on page load */
                    if ($this.is('input[type=text], input[type=hidden], input[type=tel], input:not([type])')) {
                        var setValue = true;
                        if ($this[0].value === '' && settings.wEmpty === 'empty') {
                            $this[0].value = '';
                            setValue = false;
                        }
                        if ($this[0].value === '' && settings.wEmpty === 'sign') {
                            $this[0].value = settings.aSign;
                            setValue = false;
                        }
                        if (setValue) {
                            $this.autoNumeric('set', $this.val());
                        }
                    }
                    if ($.inArray($this.prop('tagName').toLowerCase(), settings.tagList) !== -1 && $this.text() !== '') {
                        $this.autoNumeric('set', $this.text());
                    }
                }
                settings.runOnce = true;
                if ($this.is('input[type=text], input[type=hidden], input[type=tel], input:not([type])')) { /**added hidden type */
                    $this.on('keydown.autoNumeric', function (e) {
                        holder = getHolder($this);
                        if (holder.settings.aDec === holder.settings.aSep) {
                            $.error("autoNumeric will not function properly when the decimal character aDec: '" + holder.settings.aDec + "' and thousand separator aSep: '" + holder.settings.aSep + "' are the same character");
                            return this;
                        }
                        if (holder.that.readOnly) {
                            holder.processed = true;
                            return true;
                        }
                        /** The below streamed code / comment allows the "enter" keydown to throw a change() event */
                        /** if (e.keyCode === 13 && holder.inVal !== $this.val()){
                            $this.change();
                            holder.inVal = $this.val();
                        }*/
                        holder.init(e);
                        holder.settings.oEvent = 'keydown';
                        if (holder.skipAllways(e)) {
                            holder.processed = true;
                            return true;
                        }
                        if (holder.processAllways()) {
                            holder.processed = true;
                            holder.formatQuick();
                            e.preventDefault();
                            return false;
                        }
                        holder.formatted = false;
                        return true;
                    });
                    $this.on('keypress.autoNumeric', function (e) {
                        var holder = getHolder($this),
                            processed = holder.processed;
                        holder.init(e);
                        holder.settings.oEvent = 'keypress';
                        if (holder.skipAllways(e)) {
                            return true;
                        }
                        if (processed) {
                            e.preventDefault();
                            return false;
                        }
                        if (holder.processAllways() || holder.processKeypress()) {
                            holder.formatQuick();
                            e.preventDefault();
                            return false;
                        }
                        holder.formatted = false;
                    });
                    $this.on('keyup.autoNumeric', function (e) {
                        var holder = getHolder($this);
                        holder.init(e);
                        holder.settings.oEvent = 'keyup';
                        var skip = holder.skipAllways(e);
                        holder.kdCode = 0;
                        delete holder.valuePartsBeforePaste;
                        if ($this[0].value === holder.settings.aSign) { /** added to properly place the caret when only the currency is present */
                            if (holder.settings.pSign === 's') {
                                setElementSelection(this, 0, 0);
                            } else {
                                setElementSelection(this, holder.settings.aSign.length, holder.settings.aSign.length);
                            }
                        }
                        if (skip) {
                            return true;
                        }
                        if (this.value === '') {
                            return true;
                        }
                        if (!holder.formatted) {
                            holder.formatQuick();
                        }
                    });
                    $this.on('focusin.autoNumeric', function () {
                        var holder = getHolder($this);
                        holder.settingsClone.oEvent = 'focusin';
                        if (holder.settingsClone.nBracket !== null) {
                            var checkVal = $this.val();
                            $this.val(negativeBracket(checkVal, holder.settingsClone.nBracket, holder.settingsClone.oEvent));
                        }
                        holder.inVal = $this.val();
                        var onempty = checkEmpty(holder.inVal, holder.settingsClone, true);
                        if (onempty !== null) {
                            $this.val(onempty);
                            if (holder.settings.pSign === 's') {
                                setElementSelection(this, 0, 0);
                            } else {
                                setElementSelection(this, holder.settings.aSign.length, holder.settings.aSign.length);
                            }
                        }
                    });
                    $this.on('focusout.autoNumeric', function () {
                        var holder = getHolder($this),
                            settingsClone = holder.settingsClone,
                            value = $this.val(),
                            origValue = value;
                        holder.settingsClone.oEvent = 'focusout';
                        var strip_zero = ''; /** added to control leading zero */
                        if (settingsClone.lZero === 'allow') { /** added to control leading zero */
                            settingsClone.allowLeading = false;
                            strip_zero = 'leading';
                        }
                        if (value !== '') {
                            value = autoStrip(value, settingsClone, strip_zero);
                            if (checkEmpty(value, settingsClone) === null && autoCheck(value, settingsClone, $this[0])) {
                                value = fixNumber(value, settingsClone.aDec, settingsClone.aNeg);
                                value = autoRound(value, settingsClone);
                                value = presentNumber(value, settingsClone.aDec, settingsClone.aNeg);
                            } else {
                                value = '';
                            }
                        }
                        var groupedValue = checkEmpty(value, settingsClone, false);
                        if (groupedValue === null) {
                            groupedValue = autoGroup(value, settingsClone);
                        }
                        if (groupedValue !== origValue) {
                            $this.val(groupedValue);
                        }
                        if (groupedValue !== holder.inVal) {
                            $this.change();
                            delete holder.inVal;
                        }
                        if (settingsClone.nBracket !== null && $this.autoNumeric('get') < 0) {
                            holder.settingsClone.oEvent = 'focusout';
                            $this.val(negativeBracket($this.val(), settingsClone.nBracket, settingsClone.oEvent));
                        }
                    });
                }
            });
        },
        /** method to remove settings and stop autoNumeric() */
        destroy: function () {
            return $(this).each(function () {
                var $this = $(this);
                $this.off('.autoNumeric');
                $this.removeData('autoNumeric');
            });
        },
        /** method to update settings - can call as many times */
        update: function (options) {
            return $(this).each(function () {
                var $this = autoGet($(this)),
                    settings = $this.data('autoNumeric');
                if (typeof settings !== 'object') {
                    $.error("You must initialize autoNumeric('init', {options}) prior to calling the 'update' method");
                    return this;
                }
                var strip = $this.autoNumeric('get');
                settings = $.extend(settings, options);
                getHolder($this, settings, true);
                if (settings.aDec === settings.aSep) {
                    $.error("autoNumeric will not function properly when the decimal character aDec: '" + settings.aDec + "' and thousand separator aSep: '" + settings.aSep + "' are the same character");
                    return this;
                }
                $this.data('autoNumeric', settings);
                if ($this.val() !== '' || $this.text() !== '') {
                    return $this.autoNumeric('set', strip);
                }
                return;
            });
        },
        /** returns a formatted strings for "input:text" fields Uses jQuery's .val() method*/
        set: function (valueIn) {
            if (valueIn === null) {
                return;
            }
            return $(this).each(function () {
                var $this = autoGet($(this)),
                    settings = $this.data('autoNumeric'),
                    value = valueIn.toString(),
                    testValue = valueIn.toString();
                if (typeof settings !== 'object') {
                    $.error("You must initialize autoNumeric('init', {options}) prior to calling the 'set' method");
                    return this;
                }
                /** routine to handle page re-load from back button */
                if (testValue !== $this.attr('value') && $this.prop('tagName').toLowerCase() === 'input' && settings.runOnce === false) {
                    value = (settings.nBracket !== null) ? negativeBracket($this.val(), settings.nBracket, 'pageLoad') : value;
                    value = autoStrip(value, settings);
                }
               /** allows locale decimal separator to be a comma */
                if ((testValue === $this.attr('value') || testValue === $this.text()) && settings.runOnce === false) {
                    value = value.replace(',', '.');
                }
                /** returns a empty string if the value being 'set' contains non-numeric characters and or more than decimal point (full stop) and will not be formatted */
                if (!$.isNumeric(+value)) {
                    return '';
                }
                value = checkValue(value, settings);
                settings.oEvent = 'set';
                value.toString();
                if (value !== '') {
                    value = autoRound(value, settings);
                }
                value = presentNumber(value, settings.aDec, settings.aNeg);
                if (!autoCheck(value, settings)) {
                    value = autoRound('', settings);
                }
                value = autoGroup(value, settings);
                if ($this.is('input[type=text], input[type=hidden], input[type=tel], input:not([type])')) { /**added hidden type */
                    return $this.val(value);
                }
                if ($.inArray($this.prop('tagName').toLowerCase(), settings.tagList) !== -1) {
                    return $this.text(value);
                }
                $.error("The <" + $this.prop('tagName').toLowerCase() + "> is not supported by autoNumeric()");
                return false;
            });
        },
        /** method to get the unformatted value from a specific input field, returns a numeric value */
        get: function () {
            var $this = autoGet($(this)),
                settings = $this.data('autoNumeric');
            if (typeof settings !== 'object') {
                $.error("You must initialize autoNumeric('init', {options}) prior to calling the 'get' method");
                return this;
            }
            settings.oEvent = 'get';
            var getValue = '';
            /** determine the element type then use .eq(0) selector to grab the value of the first element in selector */
            if ($this.is('input[type=text], input[type=hidden], input[type=tel], input:not([type])')) { /**added hidden type */
                getValue = $this.eq(0).val();
            } else if ($.inArray($this.prop('tagName').toLowerCase(), settings.tagList) !== -1) {
                getValue = $this.eq(0).text();
            } else {
                $.error("The <" + $this.prop('tagName').toLowerCase() + "> is not supported by autoNumeric()");
                return false;
            }
            if ((getValue === '' && settings.wEmpty === 'empty') || (getValue === settings.aSign && (settings.wEmpty === 'sign' || settings.wEmpty === 'empty'))) {
                return '';
            }
            if (settings.nBracket !== null && getValue !== '') {
                getValue = negativeBracket(getValue, settings.nBracket, settings.oEvent);
            }
            if (settings.runOnce || settings.aForm === false) {
                getValue = autoStrip(getValue, settings);
            }
            getValue = fixNumber(getValue, settings.aDec, settings.aNeg);
            if (+getValue === 0 && settings.lZero !== 'keep') {
                getValue = '0';
            }
            if (settings.lZero === 'keep') {
                return getValue;
            }
            getValue = checkValue(getValue, settings);
            return getValue; /** returned Numeric String */
        },
        /** method to get the unformatted value from multiple fields */
        getString: function () {
            var isAutoNumeric = false,
                $this = autoGet($(this)),
                str = $this.serialize(),
                parts = str.split('&'),
                formIndex = $('form').index($this),
                i = 0;
            for (i; i < parts.length; i += 1) {
                var miniParts = parts[i].split('='),
                    $field = $('form:eq(' + formIndex + ') input[name="' + decodeURIComponent(miniParts[0]) + '"]'),
                    settings = $field.data('autoNumeric');
                if (typeof settings === 'object') {
                    if (miniParts[1] !== null) {
                        miniParts[1] = $field.autoNumeric('get');
                        parts[i] = miniParts.join('=');
                        isAutoNumeric = true;
                    }
                }
            }
            if (isAutoNumeric === true) {
                return parts.join('&');
            }
            return str;
        },
        /** method to get the unformatted value from multiple fields */
        getArray: function () {
            var isAutoNumeric = false,
                $this = autoGet($(this)),
                formFields = $this.serializeArray(),
                formIndex = $('form').index($this);
            /*jslint unparam: true*/
            $.each(formFields, function (i, field) {
                var $field = $('form:eq(' + formIndex + ') input[name="' + decodeURIComponent(field.name) + '"]'),
                    settings = $field.data('autoNumeric');
                if (typeof settings === 'object') {
                    if (field.value !== '') {
                        field.value = $field.autoNumeric('get').toString();
                    }
                    isAutoNumeric = true;
                }
            });
            /*jslint unparam: false*/
            if (isAutoNumeric === true) {
                return formFields;
            }
            return this;
        },
        /** returns the settings object for those who need to look under the hood */
        getSettings: function () {
            var $this = autoGet($(this));
            return $this.eq(0).data('autoNumeric');
        }
    };
    $.fn.autoNumeric = function (method) {
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        }
        if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        }
        $.error('Method "' + method + '" is not supported by autoNumeric()');
    };
}(jQuery));

/* -------------------------------------------------------------------------------------------------- */
/* jquery-tablesorter.js */
/* File: js/machinata-core-bundle.js/jquery-tablesorter.js */
/* -------------------------------------------------------------------------------------------------- */

(function(factory){if (typeof define === 'function' && define.amd){define(['jquery'], factory);} else if (false /* Note: CommonJS loader automatically stripped by Machinata reactjs profile: typeof module === 'object' && typeof module.exports === 'object' */){module.exports = factory(require('jquery'));} else {factory(jQuery);}}(function(jQuery){
/*! TableSorter (FORK) v2.31.3 *//*
* Client-side table sorting with ease!
* @requires jQuery v1.2.6+
*
* Copyright (c) 2007 Christian Bach
* fork maintained by Rob Garrison
*
* Examples and original docs at: http://tablesorter.com
* Dual licensed under the MIT and GPL licenses:
* http://www.opensource.org/licenses/mit-license.php
* http://www.gnu.org/licenses/gpl.html
*
* @type jQuery
* @name tablesorter (FORK)
* @cat Plugins/Tablesorter
* @author Christian Bach - christian.bach@polyester.se
* @contributor Rob Garrison - https://github.com/Mottie/tablesorter
* @docs (fork) - https://mottie.github.io/tablesorter/docs/
*/
/*jshint browser:true, jquery:true, unused:false, expr: true */
;( function( $ ) {
	'use strict';
	var ts = $.tablesorter = {

		version : '2.31.3',

		parsers : [],
		widgets : [],
		defaults : {

			// *** appearance
			theme            : 'default',  // adds tablesorter-{theme} to the table for styling
			widthFixed       : false,      // adds colgroup to fix widths of columns
			showProcessing   : false,      // show an indeterminate timer icon in the header when the table is sorted or filtered.

			headerTemplate   : '{content}',// header layout template (HTML ok); {content} = innerHTML, {icon} = <i></i> // class from cssIcon
			onRenderTemplate : null,       // function( index, template ) { return template; }, // template is a string
			onRenderHeader   : null,       // function( index ) {}, // nothing to return

			// *** functionality
			cancelSelection  : true,       // prevent text selection in the header
			tabIndex         : true,       // add tabindex to header for keyboard accessibility
			dateFormat       : 'mmddyyyy', // other options: 'ddmmyyy' or 'yyyymmdd'
			sortMultiSortKey : 'shiftKey', // key used to select additional columns
			sortResetKey     : 'ctrlKey',  // key used to remove sorting on a column
			usNumberFormat   : true,       // false for German '1.234.567,89' or French '1 234 567,89'
			delayInit        : false,      // if false, the parsed table contents will not update until the first sort
			serverSideSorting: false,      // if true, server-side sorting should be performed because client-side sorting will be disabled, but the ui and events will still be used.
			resort           : true,       // default setting to trigger a resort after an 'update', 'addRows', 'updateCell', etc has completed

			// *** sort options
			headers          : {},         // set sorter, string, empty, locked order, sortInitialOrder, filter, etc.
			ignoreCase       : true,       // ignore case while sorting
			sortForce        : null,       // column(s) first sorted; always applied
			sortList         : [],         // Initial sort order; applied initially; updated when manually sorted
			sortAppend       : null,       // column(s) sorted last; always applied
			sortStable       : false,      // when sorting two rows with exactly the same content, the original sort order is maintained

			sortInitialOrder : 'asc',      // sort direction on first click
			sortLocaleCompare: false,      // replace equivalent character (accented characters)
			sortReset        : false,      // third click on the header will reset column to default - unsorted
			sortRestart      : false,      // restart sort to 'sortInitialOrder' when clicking on previously unsorted columns

			emptyTo          : 'bottom',   // sort empty cell to bottom, top, none, zero, emptyMax, emptyMin
			stringTo         : 'max',      // sort strings in numerical column as max, min, top, bottom, zero
			duplicateSpan    : true,       // colspan cells in the tbody will have duplicated content in the cache for each spanned column
			textExtraction   : 'basic',    // text extraction method/function - function( node, table, cellIndex ) {}
			textAttribute    : 'data-text',// data-attribute that contains alternate cell text (used in default textExtraction function)
			textSorter       : null,       // choose overall or specific column sorter function( a, b, direction, table, columnIndex ) [alt: ts.sortText]
			numberSorter     : null,       // choose overall numeric sorter function( a, b, direction, maxColumnValue )

			// *** widget options
			initWidgets      : true,       // apply widgets on tablesorter initialization
			widgetClass      : 'widget-{name}', // table class name template to match to include a widget
			widgets          : [],         // method to add widgets, e.g. widgets: ['zebra']
			widgetOptions    : {
				zebra : [ 'even', 'odd' ]  // zebra widget alternating row class names
			},

			// *** callbacks
			initialized      : null,       // function( table ) {},

			// *** extra css class names
			tableClass       : '',
			cssAsc           : '',
			cssDesc          : '',
			cssNone          : '',
			cssHeader        : '',
			cssHeaderRow     : '',
			cssProcessing    : '', // processing icon applied to header during sort/filter

			cssChildRow      : 'tablesorter-childRow', // class name indiciating that a row is to be attached to its parent
			cssInfoBlock     : 'tablesorter-infoOnly', // don't sort tbody with this class name (only one class name allowed here!)
			cssNoSort        : 'tablesorter-noSort',   // class name added to element inside header; clicking on it won't cause a sort
			cssIgnoreRow     : 'tablesorter-ignoreRow',// header row to ignore; cells within this row will not be added to c.$headers

			cssIcon          : 'tablesorter-icon', // if this class does not exist, the {icon} will not be added from the headerTemplate
			cssIconNone      : '', // class name added to the icon when there is no column sort
			cssIconAsc       : '', // class name added to the icon when the column has an ascending sort
			cssIconDesc      : '', // class name added to the icon when the column has a descending sort
			cssIconDisabled  : '', // class name added to the icon when the column has a disabled sort

			// *** events
			pointerClick     : 'click',
			pointerDown      : 'mousedown',
			pointerUp        : 'mouseup',

			// *** selectors
			selectorHeaders  : '> thead th, > thead td',
			selectorSort     : 'th, td', // jQuery selector of content within selectorHeaders that is clickable to trigger a sort
			selectorRemove   : '.remove-me',

			// *** advanced
			debug            : false,

			// *** Internal variables
			headerList: [],
			empties: {},
			strings: {},
			parsers: [],

			// *** parser options for validator; values must be falsy!
			globalize: 0,
			imgAttr: 0

			// removed: widgetZebra: { css: ['even', 'odd'] }

		},

		// internal css classes - these will ALWAYS be added to
		// the table and MUST only contain one class name - fixes #381
		css : {
			table      : 'tablesorter',
			cssHasChild: 'tablesorter-hasChildRow',
			childRow   : 'tablesorter-childRow',
			colgroup   : 'tablesorter-colgroup',
			header     : 'tablesorter-header',
			headerRow  : 'tablesorter-headerRow',
			headerIn   : 'tablesorter-header-inner',
			icon       : 'tablesorter-icon',
			processing : 'tablesorter-processing',
			sortAsc    : 'tablesorter-headerAsc',
			sortDesc   : 'tablesorter-headerDesc',
			sortNone   : 'tablesorter-headerUnSorted'
		},

		// labels applied to sortable headers for accessibility (aria) support
		language : {
			sortAsc      : 'Ascending sort applied, ',
			sortDesc     : 'Descending sort applied, ',
			sortNone     : 'No sort applied, ',
			sortDisabled : 'sorting is disabled',
			nextAsc      : 'activate to apply an ascending sort',
			nextDesc     : 'activate to apply a descending sort',
			nextNone     : 'activate to remove the sort'
		},

		regex : {
			templateContent : /\{content\}/g,
			templateIcon    : /\{icon\}/g,
			templateName    : /\{name\}/i,
			spaces          : /\s+/g,
			nonWord         : /\W/g,
			formElements    : /(input|select|button|textarea)/i,

			// *** sort functions ***
			// regex used in natural sort
			// chunk/tokenize numbers & letters
			chunk  : /(^([+\-]?(?:\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi,
			// replace chunks @ ends
			chunks : /(^\\0|\\0$)/,
			hex    : /^0x[0-9a-f]+$/i,

			// *** formatFloat ***
			comma                : /,/g,
			digitNonUS           : /[\s|\.]/g,
			digitNegativeTest    : /^\s*\([.\d]+\)/,
			digitNegativeReplace : /^\s*\(([.\d]+)\)/,

			// *** isDigit ***
			digitTest    : /^[\-+(]?\d+[)]?$/,
			digitReplace : /[,.'"\s]/g

		},

		// digit sort, text location
		string : {
			max      : 1,
			min      : -1,
			emptymin : 1,
			emptymax : -1,
			zero     : 0,
			none     : 0,
			'null'   : 0,
			top      : true,
			bottom   : false
		},

		keyCodes : {
			enter : 13
		},

		// placeholder date parser data (globalize)
		dates : {},

		// These methods can be applied on table.config instance
		instanceMethods : {},

		/*
		▄█████ ██████ ██████ ██  ██ █████▄
		▀█▄    ██▄▄     ██   ██  ██ ██▄▄██
		   ▀█▄ ██▀▀     ██   ██  ██ ██▀▀▀
		█████▀ ██████   ██   ▀████▀ ██
		*/

		setup : function( table, c ) {
			// if no thead or tbody, or tablesorter is already present, quit
			if ( !table || !table.tHead || table.tBodies.length === 0 || table.hasInitialized === true ) {
				if ( ts.debug(c, 'core') ) {
					if ( table.hasInitialized ) {
						console.warn( 'Stopping initialization. Tablesorter has already been initialized' );
					} else {
						console.error( 'Stopping initialization! No table, thead or tbody', table );
					}
				}
				return;
			}

			var tmp = '',
				$table = $( table ),
				meta = $.metadata;
			// initialization flag
			table.hasInitialized = false;
			// table is being processed flag
			table.isProcessing = true;
			// make sure to store the config object
			table.config = c;
			// save the settings where they read
			$.data( table, 'tablesorter', c );
			if ( ts.debug(c, 'core') ) {
				console[ console.group ? 'group' : 'log' ]( 'Initializing tablesorter v' + ts.version );
				$.data( table, 'startoveralltimer', new Date() );
			}

			// removing this in version 3 (only supports jQuery 1.7+)
			c.supportsDataObject = ( function( version ) {
				version[ 0 ] = parseInt( version[ 0 ], 10 );
				return ( version[ 0 ] > 1 ) || ( version[ 0 ] === 1 && parseInt( version[ 1 ], 10 ) >= 4 );
			})( $.fn.jquery.split( '.' ) );
			// ensure case insensitivity
			c.emptyTo = c.emptyTo.toLowerCase();
			c.stringTo = c.stringTo.toLowerCase();
			c.last = { sortList : [], clickedIndex : -1 };
			// add table theme class only if there isn't already one there
			if ( !/tablesorter\-/.test( $table.attr( 'class' ) ) ) {
				tmp = ( c.theme !== '' ? ' tablesorter-' + c.theme : '' );
			}

			// give the table a unique id, which will be used in namespace binding
			if ( !c.namespace ) {
				c.namespace = '.tablesorter' + Math.random().toString( 16 ).slice( 2 );
			} else {
				// make sure namespace starts with a period & doesn't have weird characters
				c.namespace = '.' + c.namespace.replace( ts.regex.nonWord, '' );
			}

			c.table = table;
			c.$table = $table
				// add namespace to table to allow bindings on extra elements to target
				// the parent table (e.g. parser-input-select)
				.addClass( ts.css.table + ' ' + c.tableClass + tmp + ' ' + c.namespace.slice(1) )
				.attr( 'role', 'grid' );
			c.$headers = $table.find( c.selectorHeaders );

			c.$table.children().children( 'tr' ).attr( 'role', 'row' );
			c.$tbodies = $table.children( 'tbody:not(.' + c.cssInfoBlock + ')' ).attr({
				'aria-live' : 'polite',
				'aria-relevant' : 'all'
			});
			if ( c.$table.children( 'caption' ).length ) {
				tmp = c.$table.children( 'caption' )[ 0 ];
				if ( !tmp.id ) { tmp.id = c.namespace.slice( 1 ) + 'caption'; }
				c.$table.attr( 'aria-labelledby', tmp.id );
			}
			c.widgetInit = {}; // keep a list of initialized widgets
			// change textExtraction via data-attribute
			c.textExtraction = c.$table.attr( 'data-text-extraction' ) || c.textExtraction || 'basic';
			// build headers
			ts.buildHeaders( c );
			// fixate columns if the users supplies the fixedWidth option
			// do this after theme has been applied
			ts.fixColumnWidth( table );
			// add widgets from class name
			ts.addWidgetFromClass( table );
			// add widget options before parsing (e.g. grouping widget has parser settings)
			ts.applyWidgetOptions( table );
			// try to auto detect column type, and store in tables config
			ts.setupParsers( c );
			// start total row count at zero
			c.totalRows = 0;
			// only validate options while debugging. See #1528
			if (c.debug) {
				ts.validateOptions( c );
			}
			// build the cache for the tbody cells
			// delayInit will delay building the cache until the user starts a sort
			if ( !c.delayInit ) { ts.buildCache( c ); }
			// bind all header events and methods
			ts.bindEvents( table, c.$headers, true );
			ts.bindMethods( c );
			// get sort list from jQuery data or metadata
			// in jQuery < 1.4, an error occurs when calling $table.data()
			if ( c.supportsDataObject && typeof $table.data().sortlist !== 'undefined' ) {
				c.sortList = $table.data().sortlist;
			} else if ( meta && ( $table.metadata() && $table.metadata().sortlist ) ) {
				c.sortList = $table.metadata().sortlist;
			}
			// apply widget init code
			ts.applyWidget( table, true );
			// if user has supplied a sort list to constructor
			if ( c.sortList.length > 0 ) {
				// save sortList before any sortAppend is added
				c.last.sortList = c.sortList;
				ts.sortOn( c, c.sortList, {}, !c.initWidgets );
			} else {
				ts.setHeadersCss( c );
				if ( c.initWidgets ) {
					// apply widget format
					ts.applyWidget( table, false );
				}
			}

			// show processesing icon
			if ( c.showProcessing ) {
				$table
				.unbind( 'sortBegin' + c.namespace + ' sortEnd' + c.namespace )
				.bind( 'sortBegin' + c.namespace + ' sortEnd' + c.namespace, function( e ) {
					clearTimeout( c.timerProcessing );
					ts.isProcessing( table );
					if ( e.type === 'sortBegin' ) {
						c.timerProcessing = setTimeout( function() {
							ts.isProcessing( table, true );
						}, 500 );
					}
				});
			}

			// initialized
			table.hasInitialized = true;
			table.isProcessing = false;
			if ( ts.debug(c, 'core') ) {
				console.log( 'Overall initialization time:' + ts.benchmark( $.data( table, 'startoveralltimer' ) ) );
				if ( ts.debug(c, 'core') && console.groupEnd ) { console.groupEnd(); }
			}
			$table.triggerHandler( 'tablesorter-initialized', table );
			if ( typeof c.initialized === 'function' ) {
				c.initialized( table );
			}
		},

		bindMethods : function( c ) {
			var $table = c.$table,
				namespace = c.namespace,
				events = ( 'sortReset update updateRows updateAll updateHeaders addRows updateCell updateComplete ' +
					'sorton appendCache updateCache applyWidgetId applyWidgets refreshWidgets destroy mouseup ' +
					'mouseleave ' ).split( ' ' )
					.join( namespace + ' ' );
			// apply easy methods that trigger bound events
			$table
			.unbind( events.replace( ts.regex.spaces, ' ' ) )
			.bind( 'sortReset' + namespace, function( e, callback ) {
				e.stopPropagation();
				// using this.config to ensure functions are getting a non-cached version of the config
				ts.sortReset( this.config, function( table ) {
					if (table.isApplyingWidgets) {
						// multiple triggers in a row... filterReset, then sortReset - see #1361
						// wait to update widgets
						setTimeout( function() {
							ts.applyWidget( table, '', callback );
						}, 100 );
					} else {
						ts.applyWidget( table, '', callback );
					}
				});
			})
			.bind( 'updateAll' + namespace, function( e, resort, callback ) {
				e.stopPropagation();
				ts.updateAll( this.config, resort, callback );
			})
			.bind( 'update' + namespace + ' updateRows' + namespace, function( e, resort, callback ) {
				e.stopPropagation();
				ts.update( this.config, resort, callback );
			})
			.bind( 'updateHeaders' + namespace, function( e, callback ) {
				e.stopPropagation();
				ts.updateHeaders( this.config, callback );
			})
			.bind( 'updateCell' + namespace, function( e, cell, resort, callback ) {
				e.stopPropagation();
				ts.updateCell( this.config, cell, resort, callback );
			})
			.bind( 'addRows' + namespace, function( e, $row, resort, callback ) {
				e.stopPropagation();
				ts.addRows( this.config, $row, resort, callback );
			})
			.bind( 'updateComplete' + namespace, function() {
				this.isUpdating = false;
			})
			.bind( 'sorton' + namespace, function( e, list, callback, init ) {
				e.stopPropagation();
				ts.sortOn( this.config, list, callback, init );
			})
			.bind( 'appendCache' + namespace, function( e, callback, init ) {
				e.stopPropagation();
				ts.appendCache( this.config, init );
				if ( $.isFunction( callback ) ) {
					callback( this );
				}
			})
			// $tbodies variable is used by the tbody sorting widget
			.bind( 'updateCache' + namespace, function( e, callback, $tbodies ) {
				e.stopPropagation();
				ts.updateCache( this.config, callback, $tbodies );
			})
			.bind( 'applyWidgetId' + namespace, function( e, id ) {
				e.stopPropagation();
				ts.applyWidgetId( this, id );
			})
			.bind( 'applyWidgets' + namespace, function( e, callback ) {
				e.stopPropagation();
				// apply widgets (false = not initializing)
				ts.applyWidget( this, false, callback );
			})
			.bind( 'refreshWidgets' + namespace, function( e, all, dontapply ) {
				e.stopPropagation();
				ts.refreshWidgets( this, all, dontapply );
			})
			.bind( 'removeWidget' + namespace, function( e, name, refreshing ) {
				e.stopPropagation();
				ts.removeWidget( this, name, refreshing );
			})
			.bind( 'destroy' + namespace, function( e, removeClasses, callback ) {
				e.stopPropagation();
				ts.destroy( this, removeClasses, callback );
			})
			.bind( 'resetToLoadState' + namespace, function( e ) {
				e.stopPropagation();
				// remove all widgets
				ts.removeWidget( this, true, false );
				var tmp = $.extend( true, {}, c.originalSettings );
				// restore original settings; this clears out current settings, but does not clear
				// values saved to storage.
				c = $.extend( true, {}, ts.defaults, tmp );
				c.originalSettings = tmp;
				this.hasInitialized = false;
				// setup the entire table again
				ts.setup( this, c );
			});
		},

		bindEvents : function( table, $headers, core ) {
			table = $( table )[ 0 ];
			var tmp,
				c = table.config,
				namespace = c.namespace,
				downTarget = null;
			if ( core !== true ) {
				$headers.addClass( namespace.slice( 1 ) + '_extra_headers' );
				tmp = ts.getClosest( $headers, 'table' );
				if ( tmp.length && tmp[ 0 ].nodeName === 'TABLE' && tmp[ 0 ] !== table ) {
					$( tmp[ 0 ] ).addClass( namespace.slice( 1 ) + '_extra_table' );
				}
			}
			tmp = ( c.pointerDown + ' ' + c.pointerUp + ' ' + c.pointerClick + ' sort keyup ' )
				.replace( ts.regex.spaces, ' ' )
				.split( ' ' )
				.join( namespace + ' ' );
			// apply event handling to headers and/or additional headers (stickyheaders, scroller, etc)
			$headers
			// http://stackoverflow.com/questions/5312849/jquery-find-self;
			.find( c.selectorSort )
			.add( $headers.filter( c.selectorSort ) )
			.unbind( tmp )
			.bind( tmp, function( e, external ) {
				var $cell, cell, temp,
					$target = $( e.target ),
					// wrap event type in spaces, so the match doesn't trigger on inner words
					type = ' ' + e.type + ' ';
				// only recognize left clicks
				if ( ( ( e.which || e.button ) !== 1 && !type.match( ' ' + c.pointerClick + ' | sort | keyup ' ) ) ||
					// allow pressing enter
					( type === ' keyup ' && e.which !== ts.keyCodes.enter ) ||
					// allow triggering a click event (e.which is undefined) & ignore physical clicks
					( type.match( ' ' + c.pointerClick + ' ' ) && typeof e.which !== 'undefined' ) ) {
					return;
				}
				// ignore mouseup if mousedown wasn't on the same target
				if ( type.match( ' ' + c.pointerUp + ' ' ) && downTarget !== e.target && external !== true ) {
					return;
				}
				// set target on mousedown
				if ( type.match( ' ' + c.pointerDown + ' ' ) ) {
					downTarget = e.target;
					// preventDefault needed or jQuery v1.3.2 and older throws an
					// "Uncaught TypeError: handler.apply is not a function" error
					temp = $target.jquery.split( '.' );
					if ( temp[ 0 ] === '1' && temp[ 1 ] < 4 ) { e.preventDefault(); }
					return;
				}
				downTarget = null;
				$cell = ts.getClosest( $( this ), '.' + ts.css.header );
				// prevent sort being triggered on form elements
				if ( ts.regex.formElements.test( e.target.nodeName ) ||
					// nosort class name, or elements within a nosort container
					$target.hasClass( c.cssNoSort ) || $target.parents( '.' + c.cssNoSort ).length > 0 ||
					// disabled cell directly clicked
					$cell.hasClass( 'sorter-false' ) ||
					// elements within a button
					$target.parents( 'button' ).length > 0 ) {
					return !c.cancelSelection;
				}
				if ( c.delayInit && ts.isEmptyObject( c.cache ) ) {
					ts.buildCache( c );
				}
				// use column index from data-attribute or index of current row; fixes #1116
				c.last.clickedIndex = $cell.attr( 'data-column' ) || $cell.index();
				cell = c.$headerIndexed[ c.last.clickedIndex ][0];
				if ( cell && !cell.sortDisabled ) {
					ts.initSort( c, cell, e );
				}
			});
			if ( c.cancelSelection ) {
				// cancel selection
				$headers
					.attr( 'unselectable', 'on' )
					.bind( 'selectstart', false )
					.css({
						'user-select' : 'none',
						'MozUserSelect' : 'none' // not needed for jQuery 1.8+
					});
			}
		},

		buildHeaders : function( c ) {
			var $temp, icon, timer, indx;
			c.headerList = [];
			c.headerContent = [];
			c.sortVars = [];
			if ( ts.debug(c, 'core') ) {
				timer = new Date();
			}
			// children tr in tfoot - see issue #196 & #547
			// don't pass table.config to computeColumnIndex here - widgets (math) pass it to "quickly" index tbody cells
			c.columns = ts.computeColumnIndex( c.$table.children( 'thead, tfoot' ).children( 'tr' ) );
			// add icon if cssIcon option exists
			icon = c.cssIcon ?
				'<i class="' + ( c.cssIcon === ts.css.icon ? ts.css.icon : c.cssIcon + ' ' + ts.css.icon ) + '"></i>' :
				'';
			// redefine c.$headers here in case of an updateAll that replaces or adds an entire header cell - see #683
			c.$headers = $( $.map( c.$table.find( c.selectorHeaders ), function( elem, index ) {
				var configHeaders, header, column, template, tmp,
					$elem = $( elem );
				// ignore cell (don't add it to c.$headers) if row has ignoreRow class
				if ( ts.getClosest( $elem, 'tr' ).hasClass( c.cssIgnoreRow ) ) { return; }
				// transfer data-column to element if not th/td - #1459
				if ( !/(th|td)/i.test( elem.nodeName ) ) {
					tmp = ts.getClosest( $elem, 'th, td' );
					$elem.attr( 'data-column', tmp.attr( 'data-column' ) );
				}
				// make sure to get header cell & not column indexed cell
				configHeaders = ts.getColumnData( c.table, c.headers, index, true );
				// save original header content
				c.headerContent[ index ] = $elem.html();
				// if headerTemplate is empty, don't reformat the header cell
				if ( c.headerTemplate !== '' && !$elem.find( '.' + ts.css.headerIn ).length ) {
					// set up header template
					template = c.headerTemplate
						.replace( ts.regex.templateContent, $elem.html() )
						.replace( ts.regex.templateIcon, $elem.find( '.' + ts.css.icon ).length ? '' : icon );
					if ( c.onRenderTemplate ) {
						header = c.onRenderTemplate.apply( $elem, [ index, template ] );
						// only change t if something is returned
						if ( header && typeof header === 'string' ) {
							template = header;
						}
					}
					$elem.html( '<div class="' + ts.css.headerIn + '">' + template + '</div>' ); // faster than wrapInner
				}
				if ( c.onRenderHeader ) {
					c.onRenderHeader.apply( $elem, [ index, c, c.$table ] );
				}
				column = parseInt( $elem.attr( 'data-column' ), 10 );
				elem.column = column;
				tmp = ts.getOrder( ts.getData( $elem, configHeaders, 'sortInitialOrder' ) || c.sortInitialOrder );
				// this may get updated numerous times if there are multiple rows
				c.sortVars[ column ] = {
					count : -1, // set to -1 because clicking on the header automatically adds one
					order : tmp ?
						( c.sortReset ? [ 1, 0, 2 ] : [ 1, 0 ] ) : // desc, asc, unsorted
						( c.sortReset ? [ 0, 1, 2 ] : [ 0, 1 ] ),  // asc, desc, unsorted
					lockedOrder : false,
					sortedBy : ''
				};
				tmp = ts.getData( $elem, configHeaders, 'lockedOrder' ) || false;
				if ( typeof tmp !== 'undefined' && tmp !== false ) {
					c.sortVars[ column ].lockedOrder = true;
					c.sortVars[ column ].order = ts.getOrder( tmp ) ? [ 1, 1 ] : [ 0, 0 ];
				}
				// add cell to headerList
				c.headerList[ index ] = elem;
				$elem.addClass( ts.css.header + ' ' + c.cssHeader );
				// add to parent in case there are multiple rows
				ts.getClosest( $elem, 'tr' )
					.addClass( ts.css.headerRow + ' ' + c.cssHeaderRow )
					.attr( 'role', 'row' );
				// allow keyboard cursor to focus on element
				if ( c.tabIndex ) {
					$elem.attr( 'tabindex', 0 );
				}
				return elem;
			}) );
			// cache headers per column
			c.$headerIndexed = [];
			for ( indx = 0; indx < c.columns; indx++ ) {
				// colspan in header making a column undefined
				if ( ts.isEmptyObject( c.sortVars[ indx ] ) ) {
					c.sortVars[ indx ] = {};
				}
				// Use c.$headers.parent() in case selectorHeaders doesn't point to the th/td
				$temp = c.$headers.filter( '[data-column="' + indx + '"]' );
				// target sortable column cells, unless there are none, then use non-sortable cells
				// .last() added in jQuery 1.4; use .filter(':last') to maintain compatibility with jQuery v1.2.6
				c.$headerIndexed[ indx ] = $temp.length ?
					$temp.not( '.sorter-false' ).length ?
						$temp.not( '.sorter-false' ).filter( ':last' ) :
						$temp.filter( ':last' ) :
					$();
			}
			c.$table.find( c.selectorHeaders ).attr({
				scope: 'col',
				role : 'columnheader'
			});
			// enable/disable sorting
			ts.updateHeader( c );
			if ( ts.debug(c, 'core') ) {
				console.log( 'Built headers:' + ts.benchmark( timer ) );
				console.log( c.$headers );
			}
		},

		// Use it to add a set of methods to table.config which will be available for all tables.
		// This should be done before table initialization
		addInstanceMethods : function( methods ) {
			$.extend( ts.instanceMethods, methods );
		},

		/*
		█████▄ ▄████▄ █████▄ ▄█████ ██████ █████▄ ▄█████
		██▄▄██ ██▄▄██ ██▄▄██ ▀█▄    ██▄▄   ██▄▄██ ▀█▄
		██▀▀▀  ██▀▀██ ██▀██     ▀█▄ ██▀▀   ██▀██     ▀█▄
		██     ██  ██ ██  ██ █████▀ ██████ ██  ██ █████▀
		*/
		setupParsers : function( c, $tbodies ) {
			var rows, list, span, max, colIndex, indx, header, configHeaders,
				noParser, parser, extractor, time, tbody, len,
				table = c.table,
				tbodyIndex = 0,
				debug = ts.debug(c, 'core'),
				debugOutput = {};
			// update table bodies in case we start with an empty table
			c.$tbodies = c.$table.children( 'tbody:not(.' + c.cssInfoBlock + ')' );
			tbody = typeof $tbodies === 'undefined' ? c.$tbodies : $tbodies;
			len = tbody.length;
			if ( len === 0 ) {
				return debug ? console.warn( 'Warning: *Empty table!* Not building a parser cache' ) : '';
			} else if ( debug ) {
				time = new Date();
				console[ console.group ? 'group' : 'log' ]( 'Detecting parsers for each column' );
			}
			list = {
				extractors: [],
				parsers: []
			};
			while ( tbodyIndex < len ) {
				rows = tbody[ tbodyIndex ].rows;
				if ( rows.length ) {
					colIndex = 0;
					max = c.columns;
					for ( indx = 0; indx < max; indx++ ) {
						header = c.$headerIndexed[ colIndex ];
						if ( header && header.length ) {
							// get column indexed table cell; adding true parameter fixes #1362 but
							// it would break backwards compatibility...
							configHeaders = ts.getColumnData( table, c.headers, colIndex ); // , true );
							// get column parser/extractor
							extractor = ts.getParserById( ts.getData( header, configHeaders, 'extractor' ) );
							parser = ts.getParserById( ts.getData( header, configHeaders, 'sorter' ) );
							noParser = ts.getData( header, configHeaders, 'parser' ) === 'false';
							// empty cells behaviour - keeping emptyToBottom for backwards compatibility
							c.empties[colIndex] = (
								ts.getData( header, configHeaders, 'empty' ) ||
								c.emptyTo || ( c.emptyToBottom ? 'bottom' : 'top' ) ).toLowerCase();
							// text strings behaviour in numerical sorts
							c.strings[colIndex] = (
								ts.getData( header, configHeaders, 'string' ) ||
								c.stringTo ||
								'max' ).toLowerCase();
							if ( noParser ) {
								parser = ts.getParserById( 'no-parser' );
							}
							if ( !extractor ) {
								// For now, maybe detect someday
								extractor = false;
							}
							if ( !parser ) {
								parser = ts.detectParserForColumn( c, rows, -1, colIndex );
							}
							if ( debug ) {
								debugOutput[ '(' + colIndex + ') ' + header.text() ] = {
									parser : parser.id,
									extractor : extractor ? extractor.id : 'none',
									string : c.strings[ colIndex ],
									empty  : c.empties[ colIndex ]
								};
							}
							list.parsers[ colIndex ] = parser;
							list.extractors[ colIndex ] = extractor;
							span = header[ 0 ].colSpan - 1;
							if ( span > 0 ) {
								colIndex += span;
								max += span;
								while ( span + 1 > 0 ) {
									// set colspan columns to use the same parsers & extractors
									list.parsers[ colIndex - span ] = parser;
									list.extractors[ colIndex - span ] = extractor;
									span--;
								}
							}
						}
						colIndex++;
					}
				}
				tbodyIndex += ( list.parsers.length ) ? len : 1;
			}
			if ( debug ) {
				if ( !ts.isEmptyObject( debugOutput ) ) {
					console[ console.table ? 'table' : 'log' ]( debugOutput );
				} else {
					console.warn( '  No parsers detected!' );
				}
				console.log( 'Completed detecting parsers' + ts.benchmark( time ) );
				if ( console.groupEnd ) { console.groupEnd(); }
			}
			c.parsers = list.parsers;
			c.extractors = list.extractors;
		},

		addParser : function( parser ) {
			var indx,
				len = ts.parsers.length,
				add = true;
			for ( indx = 0; indx < len; indx++ ) {
				if ( ts.parsers[ indx ].id.toLowerCase() === parser.id.toLowerCase() ) {
					add = false;
				}
			}
			if ( add ) {
				ts.parsers[ ts.parsers.length ] = parser;
			}
		},

		getParserById : function( name ) {
			/*jshint eqeqeq:false */ // eslint-disable-next-line eqeqeq
			if ( name == 'false' ) { return false; }
			var indx,
				len = ts.parsers.length;
			for ( indx = 0; indx < len; indx++ ) {
				if ( ts.parsers[ indx ].id.toLowerCase() === ( name.toString() ).toLowerCase() ) {
					return ts.parsers[ indx ];
				}
			}
			return false;
		},

		detectParserForColumn : function( c, rows, rowIndex, cellIndex ) {
			var cur, $node, row,
				indx = ts.parsers.length,
				node = false,
				nodeValue = '',
				debug = ts.debug(c, 'core'),
				keepLooking = true;
			while ( nodeValue === '' && keepLooking ) {
				rowIndex++;
				row = rows[ rowIndex ];
				// stop looking after 50 empty rows
				if ( row && rowIndex < 50 ) {
					if ( row.className.indexOf( ts.cssIgnoreRow ) < 0 ) {
						node = rows[ rowIndex ].cells[ cellIndex ];
						nodeValue = ts.getElementText( c, node, cellIndex );
						$node = $( node );
						if ( debug ) {
							console.log( 'Checking if value was empty on row ' + rowIndex + ', column: ' +
								cellIndex + ': "' + nodeValue + '"' );
						}
					}
				} else {
					keepLooking = false;
				}
			}
			while ( --indx >= 0 ) {
				cur = ts.parsers[ indx ];
				// ignore the default text parser because it will always be true
				if ( cur && cur.id !== 'text' && cur.is && cur.is( nodeValue, c.table, node, $node ) ) {
					return cur;
				}
			}
			// nothing found, return the generic parser (text)
			return ts.getParserById( 'text' );
		},

		getElementText : function( c, node, cellIndex ) {
			if ( !node ) { return ''; }
			var tmp,
				extract = c.textExtraction || '',
				// node could be a jquery object
				// http://jsperf.com/jquery-vs-instanceof-jquery/2
				$node = node.jquery ? node : $( node );
			if ( typeof extract === 'string' ) {
				// check data-attribute first when set to 'basic'; don't use node.innerText - it's really slow!
				// http://www.kellegous.com/j/2013/02/27/innertext-vs-textcontent/
				if ( extract === 'basic' && typeof ( tmp = $node.attr( c.textAttribute ) ) !== 'undefined' ) {
					return $.trim( tmp );
				}
				return $.trim( node.textContent || $node.text() );
			} else {
				if ( typeof extract === 'function' ) {
					return $.trim( extract( $node[ 0 ], c.table, cellIndex ) );
				} else if ( typeof ( tmp = ts.getColumnData( c.table, extract, cellIndex ) ) === 'function' ) {
					return $.trim( tmp( $node[ 0 ], c.table, cellIndex ) );
				}
			}
			// fallback
			return $.trim( $node[ 0 ].textContent || $node.text() );
		},

		// centralized function to extract/parse cell contents
		getParsedText : function( c, cell, colIndex, txt ) {
			if ( typeof txt === 'undefined' ) {
				txt = ts.getElementText( c, cell, colIndex );
			}
			// if no parser, make sure to return the txt
			var val = '' + txt,
				parser = c.parsers[ colIndex ],
				extractor = c.extractors[ colIndex ];
			if ( parser ) {
				// do extract before parsing, if there is one
				if ( extractor && typeof extractor.format === 'function' ) {
					txt = extractor.format( txt, c.table, cell, colIndex );
				}
				// allow parsing if the string is empty, previously parsing would change it to zero,
				// in case the parser needs to extract data from the table cell attributes
				val = parser.id === 'no-parser' ? '' :
					// make sure txt is a string (extractor may have converted it)
					parser.format( '' + txt, c.table, cell, colIndex );
				if ( c.ignoreCase && typeof val === 'string' ) {
					val = val.toLowerCase();
				}
			}
			return val;
		},

		/*
		▄████▄ ▄████▄ ▄████▄ ██  ██ ██████
		██  ▀▀ ██▄▄██ ██  ▀▀ ██▄▄██ ██▄▄
		██  ▄▄ ██▀▀██ ██  ▄▄ ██▀▀██ ██▀▀
		▀████▀ ██  ██ ▀████▀ ██  ██ ██████
		*/
		buildCache : function( c, callback, $tbodies ) {
			var cache, val, txt, rowIndex, colIndex, tbodyIndex, $tbody, $row,
				cols, $cells, cell, cacheTime, totalRows, rowData, prevRowData,
				colMax, span, cacheIndex, hasParser, max, len, index,
				table = c.table,
				parsers = c.parsers,
				debug = ts.debug(c, 'core');
			// update tbody variable
			c.$tbodies = c.$table.children( 'tbody:not(.' + c.cssInfoBlock + ')' );
			$tbody = typeof $tbodies === 'undefined' ? c.$tbodies : $tbodies;
			c.cache = {};
			c.totalRows = 0;
			// if no parsers found, return - it's an empty table.
			if ( !parsers ) {
				return debug ? console.warn( 'Warning: *Empty table!* Not building a cache' ) : '';
			}
			if ( debug ) {
				cacheTime = new Date();
			}
			// processing icon
			if ( c.showProcessing ) {
				ts.isProcessing( table, true );
			}
			for ( tbodyIndex = 0; tbodyIndex < $tbody.length; tbodyIndex++ ) {
				colMax = []; // column max value per tbody
				cache = c.cache[ tbodyIndex ] = {
					normalized: [] // array of normalized row data; last entry contains 'rowData' above
					// colMax: #   // added at the end
				};

				totalRows = ( $tbody[ tbodyIndex ] && $tbody[ tbodyIndex ].rows.length ) || 0;
				for ( rowIndex = 0; rowIndex < totalRows; ++rowIndex ) {
					rowData = {
						// order: original row order #
						// $row : jQuery Object[]
						child: [], // child row text (filter widget)
						raw: []    // original row text
					};
					/** Add the table data to main data array */
					$row = $( $tbody[ tbodyIndex ].rows[ rowIndex ] );
					cols = [];
					// ignore "remove-me" rows
					if ( $row.hasClass( c.selectorRemove.slice(1) ) ) {
						continue;
					}
					// if this is a child row, add it to the last row's children and continue to the next row
					// ignore child row class, if it is the first row
					if ( $row.hasClass( c.cssChildRow ) && rowIndex !== 0 ) {
						len = cache.normalized.length - 1;
						prevRowData = cache.normalized[ len ][ c.columns ];
						prevRowData.$row = prevRowData.$row.add( $row );
						// add 'hasChild' class name to parent row
						if ( !$row.prev().hasClass( c.cssChildRow ) ) {
							$row.prev().addClass( ts.css.cssHasChild );
						}
						// save child row content (un-parsed!)
						$cells = $row.children( 'th, td' );
						len = prevRowData.child.length;
						prevRowData.child[ len ] = [];
						// child row content does not account for colspans/rowspans; so indexing may be off
						cacheIndex = 0;
						max = c.columns;
						for ( colIndex = 0; colIndex < max; colIndex++ ) {
							cell = $cells[ colIndex ];
							if ( cell ) {
								prevRowData.child[ len ][ colIndex ] = ts.getParsedText( c, cell, colIndex );
								span = $cells[ colIndex ].colSpan - 1;
								if ( span > 0 ) {
									cacheIndex += span;
									max += span;
								}
							}
							cacheIndex++;
						}
						// go to the next for loop
						continue;
					}
					rowData.$row = $row;
					rowData.order = rowIndex; // add original row position to rowCache
					cacheIndex = 0;
					max = c.columns;
					for ( colIndex = 0; colIndex < max; ++colIndex ) {
						cell = $row[ 0 ].cells[ colIndex ];
						if ( cell && cacheIndex < c.columns ) {
							hasParser = typeof parsers[ cacheIndex ] !== 'undefined';
							if ( !hasParser && debug ) {
								console.warn( 'No parser found for row: ' + rowIndex + ', column: ' + colIndex +
									'; cell containing: "' + $(cell).text() + '"; does it have a header?' );
							}
							val = ts.getElementText( c, cell, cacheIndex );
							rowData.raw[ cacheIndex ] = val; // save original row text
							// save raw column text even if there is no parser set
							txt = ts.getParsedText( c, cell, cacheIndex, val );
							cols[ cacheIndex ] = txt;
							if ( hasParser && ( parsers[ cacheIndex ].type || '' ).toLowerCase() === 'numeric' ) {
								// determine column max value (ignore sign)
								colMax[ cacheIndex ] = Math.max( Math.abs( txt ) || 0, colMax[ cacheIndex ] || 0 );
							}
							// allow colSpan in tbody
							span = cell.colSpan - 1;
							if ( span > 0 ) {
								index = 0;
								while ( index <= span ) {
									// duplicate text (or not) to spanned columns
									// instead of setting duplicate span to empty string, use textExtraction to try to get a value
									// see http://stackoverflow.com/q/36449711/145346
									txt = c.duplicateSpan || index === 0 ?
										txt :
										typeof c.textExtraction !== 'string' ?
											ts.getElementText( c, cell, cacheIndex + index ) || '' :
											'';
									rowData.raw[ cacheIndex + index ] = txt;
									cols[ cacheIndex + index ] = txt;
									index++;
								}
								cacheIndex += span;
								max += span;
							}
						}
						cacheIndex++;
					}
					// ensure rowData is always in the same location (after the last column)
					cols[ c.columns ] = rowData;
					cache.normalized[ cache.normalized.length ] = cols;
				}
				cache.colMax = colMax;
				// total up rows, not including child rows
				c.totalRows += cache.normalized.length;

			}
			if ( c.showProcessing ) {
				ts.isProcessing( table ); // remove processing icon
			}
			if ( debug ) {
				len = Math.min( 5, c.cache[ 0 ].normalized.length );
				console[ console.group ? 'group' : 'log' ]( 'Building cache for ' + c.totalRows +
					' rows (showing ' + len + ' rows in log) and ' + c.columns + ' columns' +
					ts.benchmark( cacheTime ) );
				val = {};
				for ( colIndex = 0; colIndex < c.columns; colIndex++ ) {
					for ( cacheIndex = 0; cacheIndex < len; cacheIndex++ ) {
						if ( !val[ 'row: ' + cacheIndex ] ) {
							val[ 'row: ' + cacheIndex ] = {};
						}
						val[ 'row: ' + cacheIndex ][ c.$headerIndexed[ colIndex ].text() ] =
							c.cache[ 0 ].normalized[ cacheIndex ][ colIndex ];
					}
				}
				console[ console.table ? 'table' : 'log' ]( val );
				if ( console.groupEnd ) { console.groupEnd(); }
			}
			if ( $.isFunction( callback ) ) {
				callback( table );
			}
		},

		getColumnText : function( table, column, callback, rowFilter ) {
			table = $( table )[0];
			var tbodyIndex, rowIndex, cache, row, tbodyLen, rowLen, raw, parsed, $cell, result,
				hasCallback = typeof callback === 'function',
				allColumns = column === 'all',
				data = { raw : [], parsed: [], $cell: [] },
				c = table.config;
			if ( ts.isEmptyObject( c ) ) {
				if ( ts.debug(c, 'core') ) {
					console.warn( 'No cache found - aborting getColumnText function!' );
				}
			} else {
				tbodyLen = c.$tbodies.length;
				for ( tbodyIndex = 0; tbodyIndex < tbodyLen; tbodyIndex++ ) {
					cache = c.cache[ tbodyIndex ].normalized;
					rowLen = cache.length;
					for ( rowIndex = 0; rowIndex < rowLen; rowIndex++ ) {
						row = cache[ rowIndex ];
						if ( rowFilter && !row[ c.columns ].$row.is( rowFilter ) ) {
							continue;
						}
						result = true;
						parsed = ( allColumns ) ? row.slice( 0, c.columns ) : row[ column ];
						row = row[ c.columns ];
						raw = ( allColumns ) ? row.raw : row.raw[ column ];
						$cell = ( allColumns ) ? row.$row.children() : row.$row.children().eq( column );
						if ( hasCallback ) {
							result = callback({
								tbodyIndex : tbodyIndex,
								rowIndex : rowIndex,
								parsed : parsed,
								raw : raw,
								$row : row.$row,
								$cell : $cell
							});
						}
						if ( result !== false ) {
							data.parsed[ data.parsed.length ] = parsed;
							data.raw[ data.raw.length ] = raw;
							data.$cell[ data.$cell.length ] = $cell;
						}
					}
				}
				// return everything
				return data;
			}
		},

		/*
		██  ██ █████▄ █████▄ ▄████▄ ██████ ██████
		██  ██ ██▄▄██ ██  ██ ██▄▄██   ██   ██▄▄
		██  ██ ██▀▀▀  ██  ██ ██▀▀██   ██   ██▀▀
		▀████▀ ██     █████▀ ██  ██   ██   ██████
		*/
		setHeadersCss : function( c ) {
			var indx, column,
				list = c.sortList,
				len = list.length,
				none = ts.css.sortNone + ' ' + c.cssNone,
				css = [ ts.css.sortAsc + ' ' + c.cssAsc, ts.css.sortDesc + ' ' + c.cssDesc ],
				cssIcon = [ c.cssIconAsc, c.cssIconDesc, c.cssIconNone ],
				aria = [ 'ascending', 'descending' ],
				updateColumnSort = function($el, index) {
					$el
						.removeClass( none )
						.addClass( css[ index ] )
						.attr( 'aria-sort', aria[ index ] )
						.find( '.' + ts.css.icon )
						.removeClass( cssIcon[ 2 ] )
						.addClass( cssIcon[ index ] );
				},
				// find the footer
				$extras = c.$table
					.find( 'tfoot tr' )
					.children( 'td, th' )
					.add( $( c.namespace + '_extra_headers' ) )
					.removeClass( css.join( ' ' ) ),
				// remove all header information
				$sorted = c.$headers
					.add( $( 'thead ' + c.namespace + '_extra_headers' ) )
					.removeClass( css.join( ' ' ) )
					.addClass( none )
					.attr( 'aria-sort', 'none' )
					.find( '.' + ts.css.icon )
					.removeClass( cssIcon.join( ' ' ) )
					.end();
			// add css none to all sortable headers
			$sorted
				.not( '.sorter-false' )
				.find( '.' + ts.css.icon )
				.addClass( cssIcon[ 2 ] );
			// add disabled css icon class
			if ( c.cssIconDisabled ) {
				$sorted
					.filter( '.sorter-false' )
					.find( '.' + ts.css.icon )
					.addClass( c.cssIconDisabled );
			}
			for ( indx = 0; indx < len; indx++ ) {
				// direction = 2 means reset!
				if ( list[ indx ][ 1 ] !== 2 ) {
					// multicolumn sorting updating - see #1005
					// .not(function() {}) needs jQuery 1.4
					// filter(function(i, el) {}) <- el is undefined in jQuery v1.2.6
					$sorted = c.$headers.filter( function( i ) {
						// only include headers that are in the sortList (this includes colspans)
						var include = true,
							$el = c.$headers.eq( i ),
							col = parseInt( $el.attr( 'data-column' ), 10 ),
							end = col + ts.getClosest( $el, 'th, td' )[0].colSpan;
						for ( ; col < end; col++ ) {
							include = include ? include || ts.isValueInArray( col, c.sortList ) > -1 : false;
						}
						return include;
					});

					// choose the :last in case there are nested columns
					$sorted = $sorted
						.not( '.sorter-false' )
						.filter( '[data-column="' + list[ indx ][ 0 ] + '"]' + ( len === 1 ? ':last' : '' ) );
					if ( $sorted.length ) {
						for ( column = 0; column < $sorted.length; column++ ) {
							if ( !$sorted[ column ].sortDisabled ) {
								updateColumnSort( $sorted.eq( column ), list[ indx ][ 1 ] );
							}
						}
					}
					// add sorted class to footer & extra headers, if they exist
					if ( $extras.length ) {
						updateColumnSort( $extras.filter( '[data-column="' + list[ indx ][ 0 ] + '"]' ), list[ indx ][ 1 ] );
					}
				}
			}
			// add verbose aria labels
			len = c.$headers.length;
			for ( indx = 0; indx < len; indx++ ) {
				ts.setColumnAriaLabel( c, c.$headers.eq( indx ) );
			}
		},

		getClosest : function( $el, selector ) {
			// jQuery v1.2.6 doesn't have closest()
			if ( $.fn.closest ) {
				return $el.closest( selector );
			}
			return $el.is( selector ) ?
				$el :
				$el.parents( selector ).filter( ':first' );
		},

		// nextSort (optional), lets you disable next sort text
		setColumnAriaLabel : function( c, $header, nextSort ) {
			if ( $header.length ) {
				var column = parseInt( $header.attr( 'data-column' ), 10 ),
					vars = c.sortVars[ column ],
					tmp = $header.hasClass( ts.css.sortAsc ) ?
						'sortAsc' :
						$header.hasClass( ts.css.sortDesc ) ? 'sortDesc' : 'sortNone',
					txt = $.trim( $header.text() ) + ': ' + ts.language[ tmp ];
				if ( $header.hasClass( 'sorter-false' ) || nextSort === false ) {
					txt += ts.language.sortDisabled;
				} else {
					tmp = ( vars.count + 1 ) % vars.order.length;
					nextSort = vars.order[ tmp ];
					// if nextSort
					txt += ts.language[ nextSort === 0 ? 'nextAsc' : nextSort === 1 ? 'nextDesc' : 'nextNone' ];
				}
				$header.attr( 'aria-label', txt );
				if (vars.sortedBy) {
					$header.attr( 'data-sortedBy', vars.sortedBy );
				} else {
					$header.removeAttr('data-sortedBy');
				}
			}
		},

		updateHeader : function( c ) {
			var index, isDisabled, $header, col,
				table = c.table,
				len = c.$headers.length;
			for ( index = 0; index < len; index++ ) {
				$header = c.$headers.eq( index );
				col = ts.getColumnData( table, c.headers, index, true );
				// add 'sorter-false' class if 'parser-false' is set
				isDisabled = ts.getData( $header, col, 'sorter' ) === 'false' || ts.getData( $header, col, 'parser' ) === 'false';
				ts.setColumnSort( c, $header, isDisabled );
			}
		},

		setColumnSort : function( c, $header, isDisabled ) {
			var id = c.table.id;
			$header[ 0 ].sortDisabled = isDisabled;
			$header[ isDisabled ? 'addClass' : 'removeClass' ]( 'sorter-false' )
				.attr( 'aria-disabled', '' + isDisabled );
			// disable tab index on disabled cells
			if ( c.tabIndex ) {
				if ( isDisabled ) {
					$header.removeAttr( 'tabindex' );
				} else {
					$header.attr( 'tabindex', '0' );
				}
			}
			// aria-controls - requires table ID
			if ( id ) {
				if ( isDisabled ) {
					$header.removeAttr( 'aria-controls' );
				} else {
					$header.attr( 'aria-controls', id );
				}
			}
		},

		updateHeaderSortCount : function( c, list ) {
			var col, dir, group, indx, primary, temp, val, order,
				sortList = list || c.sortList,
				len = sortList.length;
			c.sortList = [];
			for ( indx = 0; indx < len; indx++ ) {
				val = sortList[ indx ];
				// ensure all sortList values are numeric - fixes #127
				col = parseInt( val[ 0 ], 10 );
				// prevents error if sorton array is wrong
				if ( col < c.columns ) {

					// set order if not already defined - due to colspan header without associated header cell
					// adding this check prevents a javascript error
					if ( !c.sortVars[ col ].order ) {
						if ( ts.getOrder( c.sortInitialOrder ) ) {
							order = c.sortReset ? [ 1, 0, 2 ] : [ 1, 0 ];
						} else {
							order = c.sortReset ? [ 0, 1, 2 ] : [ 0, 1 ];
						}
						c.sortVars[ col ].order = order;
						c.sortVars[ col ].count = 0;
					}

					order = c.sortVars[ col ].order;
					dir = ( '' + val[ 1 ] ).match( /^(1|d|s|o|n)/ );
					dir = dir ? dir[ 0 ] : '';
					// 0/(a)sc (default), 1/(d)esc, (s)ame, (o)pposite, (n)ext
					switch ( dir ) {
						case '1' : case 'd' : // descending
							dir = 1;
							break;
						case 's' : // same direction (as primary column)
							// if primary sort is set to 's', make it ascending
							dir = primary || 0;
							break;
						case 'o' :
							temp = order[ ( primary || 0 ) % order.length ];
							// opposite of primary column; but resets if primary resets
							dir = temp === 0 ? 1 : temp === 1 ? 0 : 2;
							break;
						case 'n' :
							dir = order[ ( ++c.sortVars[ col ].count ) % order.length ];
							break;
						default : // ascending
							dir = 0;
							break;
					}
					primary = indx === 0 ? dir : primary;
					group = [ col, parseInt( dir, 10 ) || 0 ];
					c.sortList[ c.sortList.length ] = group;
					dir = $.inArray( group[ 1 ], order ); // fixes issue #167
					c.sortVars[ col ].count = dir >= 0 ? dir : group[ 1 ] % order.length;
				}
			}
		},

		updateAll : function( c, resort, callback ) {
			var table = c.table;
			table.isUpdating = true;
			ts.refreshWidgets( table, true, true );
			ts.buildHeaders( c );
			ts.bindEvents( table, c.$headers, true );
			ts.bindMethods( c );
			ts.commonUpdate( c, resort, callback );
		},

		update : function( c, resort, callback ) {
			var table = c.table;
			table.isUpdating = true;
			// update sorting (if enabled/disabled)
			ts.updateHeader( c );
			ts.commonUpdate( c, resort, callback );
		},

		// simple header update - see #989
		updateHeaders : function( c, callback ) {
			c.table.isUpdating = true;
			ts.buildHeaders( c );
			ts.bindEvents( c.table, c.$headers, true );
			ts.resortComplete( c, callback );
		},

		updateCell : function( c, cell, resort, callback ) {
			// updateCell for child rows is a mess - we'll ignore them for now
			// eventually I'll break out the "update" row cache code to make everything consistent
			if ( $( cell ).closest( 'tr' ).hasClass( c.cssChildRow ) ) {
				console.warn('Tablesorter Warning! "updateCell" for child row content has been disabled, use "update" instead');
				return;
			}
			if ( ts.isEmptyObject( c.cache ) ) {
				// empty table, do an update instead - fixes #1099
				ts.updateHeader( c );
				ts.commonUpdate( c, resort, callback );
				return;
			}
			c.table.isUpdating = true;
			c.$table.find( c.selectorRemove ).remove();
			// get position from the dom
			var tmp, indx, row, icell, cache, len,
				$tbodies = c.$tbodies,
				$cell = $( cell ),
				// update cache - format: function( s, table, cell, cellIndex )
				// no closest in jQuery v1.2.6
				tbodyIndex = $tbodies.index( ts.getClosest( $cell, 'tbody' ) ),
				tbcache = c.cache[ tbodyIndex ],
				$row = ts.getClosest( $cell, 'tr' );
			cell = $cell[ 0 ]; // in case cell is a jQuery object
			// tbody may not exist if update is initialized while tbody is removed for processing
			if ( $tbodies.length && tbodyIndex >= 0 ) {
				row = $tbodies.eq( tbodyIndex ).find( 'tr' ).not( '.' + c.cssChildRow ).index( $row );
				cache = tbcache.normalized[ row ];
				len = $row[ 0 ].cells.length;
				if ( len !== c.columns ) {
					// colspan in here somewhere!
					icell = 0;
					tmp = false;
					for ( indx = 0; indx < len; indx++ ) {
						if ( !tmp && $row[ 0 ].cells[ indx ] !== cell ) {
							icell += $row[ 0 ].cells[ indx ].colSpan;
						} else {
							tmp = true;
						}
					}
				} else {
					icell = $cell.index();
				}
				tmp = ts.getElementText( c, cell, icell ); // raw
				cache[ c.columns ].raw[ icell ] = tmp;
				tmp = ts.getParsedText( c, cell, icell, tmp );
				cache[ icell ] = tmp; // parsed
				if ( ( c.parsers[ icell ].type || '' ).toLowerCase() === 'numeric' ) {
					// update column max value (ignore sign)
					tbcache.colMax[ icell ] = Math.max( Math.abs( tmp ) || 0, tbcache.colMax[ icell ] || 0 );
				}
				tmp = resort !== 'undefined' ? resort : c.resort;
				if ( tmp !== false ) {
					// widgets will be reapplied
					ts.checkResort( c, tmp, callback );
				} else {
					// don't reapply widgets is resort is false, just in case it causes
					// problems with element focus
					ts.resortComplete( c, callback );
				}
			} else {
				if ( ts.debug(c, 'core') ) {
					console.error( 'updateCell aborted, tbody missing or not within the indicated table' );
				}
				c.table.isUpdating = false;
			}
		},

		addRows : function( c, $row, resort, callback ) {
			var txt, val, tbodyIndex, rowIndex, rows, cellIndex, len, order,
				cacheIndex, rowData, cells, cell, span,
				// allow passing a row string if only one non-info tbody exists in the table
				valid = typeof $row === 'string' && c.$tbodies.length === 1 && /<tr/.test( $row || '' ),
				table = c.table;
			if ( valid ) {
				$row = $( $row );
				c.$tbodies.append( $row );
			} else if (
				!$row ||
				// row is a jQuery object?
				!( $row instanceof $ ) ||
				// row contained in the table?
				( ts.getClosest( $row, 'table' )[ 0 ] !== c.table )
			) {
				if ( ts.debug(c, 'core') ) {
					console.error( 'addRows method requires (1) a jQuery selector reference to rows that have already ' +
						'been added to the table, or (2) row HTML string to be added to a table with only one tbody' );
				}
				return false;
			}
			table.isUpdating = true;
			if ( ts.isEmptyObject( c.cache ) ) {
				// empty table, do an update instead - fixes #450
				ts.updateHeader( c );
				ts.commonUpdate( c, resort, callback );
			} else {
				rows = $row.filter( 'tr' ).attr( 'role', 'row' ).length;
				tbodyIndex = c.$tbodies.index( $row.parents( 'tbody' ).filter( ':first' ) );
				// fixes adding rows to an empty table - see issue #179
				if ( !( c.parsers && c.parsers.length ) ) {
					ts.setupParsers( c );
				}
				// add each row
				for ( rowIndex = 0; rowIndex < rows; rowIndex++ ) {
					cacheIndex = 0;
					len = $row[ rowIndex ].cells.length;
					order = c.cache[ tbodyIndex ].normalized.length;
					cells = [];
					rowData = {
						child : [],
						raw : [],
						$row : $row.eq( rowIndex ),
						order : order
					};
					// add each cell
					for ( cellIndex = 0; cellIndex < len; cellIndex++ ) {
						cell = $row[ rowIndex ].cells[ cellIndex ];
						txt = ts.getElementText( c, cell, cacheIndex );
						rowData.raw[ cacheIndex ] = txt;
						val = ts.getParsedText( c, cell, cacheIndex, txt );
						cells[ cacheIndex ] = val;
						if ( ( c.parsers[ cacheIndex ].type || '' ).toLowerCase() === 'numeric' ) {
							// update column max value (ignore sign)
							c.cache[ tbodyIndex ].colMax[ cacheIndex ] =
								Math.max( Math.abs( val ) || 0, c.cache[ tbodyIndex ].colMax[ cacheIndex ] || 0 );
						}
						span = cell.colSpan - 1;
						if ( span > 0 ) {
							cacheIndex += span;
						}
						cacheIndex++;
					}
					// add the row data to the end
					cells[ c.columns ] = rowData;
					// update cache
					c.cache[ tbodyIndex ].normalized[ order ] = cells;
				}
				// resort using current settings
				ts.checkResort( c, resort, callback );
			}
		},

		updateCache : function( c, callback, $tbodies ) {
			// rebuild parsers
			if ( !( c.parsers && c.parsers.length ) ) {
				ts.setupParsers( c, $tbodies );
			}
			// rebuild the cache map
			ts.buildCache( c, callback, $tbodies );
		},

		// init flag (true) used by pager plugin to prevent widget application
		// renamed from appendToTable
		appendCache : function( c, init ) {
			var parsed, totalRows, $tbody, $curTbody, rowIndex, tbodyIndex, appendTime,
				table = c.table,
				$tbodies = c.$tbodies,
				rows = [],
				cache = c.cache;
			// empty table - fixes #206/#346
			if ( ts.isEmptyObject( cache ) ) {
				// run pager appender in case the table was just emptied
				return c.appender ? c.appender( table, rows ) :
					table.isUpdating ? c.$table.triggerHandler( 'updateComplete', table ) : ''; // Fixes #532
			}
			if ( ts.debug(c, 'core') ) {
				appendTime = new Date();
			}
			for ( tbodyIndex = 0; tbodyIndex < $tbodies.length; tbodyIndex++ ) {
				$tbody = $tbodies.eq( tbodyIndex );
				if ( $tbody.length ) {
					// detach tbody for manipulation
					$curTbody = ts.processTbody( table, $tbody, true );
					parsed = cache[ tbodyIndex ].normalized;
					totalRows = parsed.length;
					for ( rowIndex = 0; rowIndex < totalRows; rowIndex++ ) {
						rows[rows.length] = parsed[ rowIndex ][ c.columns ].$row;
						// removeRows used by the pager plugin; don't render if using ajax - fixes #411
						if ( !c.appender || ( c.pager && !c.pager.removeRows && !c.pager.ajax ) ) {
							$curTbody.append( parsed[ rowIndex ][ c.columns ].$row );
						}
					}
					// restore tbody
					ts.processTbody( table, $curTbody, false );
				}
			}
			if ( c.appender ) {
				c.appender( table, rows );
			}
			if ( ts.debug(c, 'core') ) {
				console.log( 'Rebuilt table' + ts.benchmark( appendTime ) );
			}
			// apply table widgets; but not before ajax completes
			if ( !init && !c.appender ) {
				ts.applyWidget( table );
			}
			if ( table.isUpdating ) {
				c.$table.triggerHandler( 'updateComplete', table );
			}
		},

		commonUpdate : function( c, resort, callback ) {
			// remove rows/elements before update
			c.$table.find( c.selectorRemove ).remove();
			// rebuild parsers
			ts.setupParsers( c );
			// rebuild the cache map
			ts.buildCache( c );
			ts.checkResort( c, resort, callback );
		},

		/*
		▄█████ ▄████▄ █████▄ ██████ ██ █████▄ ▄████▄
		▀█▄    ██  ██ ██▄▄██   ██   ██ ██  ██ ██ ▄▄▄
		   ▀█▄ ██  ██ ██▀██    ██   ██ ██  ██ ██ ▀██
		█████▀ ▀████▀ ██  ██   ██   ██ ██  ██ ▀████▀
		*/
		initSort : function( c, cell, event ) {
			if ( c.table.isUpdating ) {
				// let any updates complete before initializing a sort
				return setTimeout( function() {
					ts.initSort( c, cell, event );
				}, 50 );
			}

			var arry, indx, headerIndx, dir, temp, tmp, $header,
				notMultiSort = !event[ c.sortMultiSortKey ],
				table = c.table,
				len = c.$headers.length,
				th = ts.getClosest( $( cell ), 'th, td' ),
				col = parseInt( th.attr( 'data-column' ), 10 ),
				sortedBy = event.type === 'mouseup' ? 'user' : event.type,
				order = c.sortVars[ col ].order;
			th = th[0];
			// Only call sortStart if sorting is enabled
			c.$table.triggerHandler( 'sortStart', table );
			// get current column sort order
			tmp = ( c.sortVars[ col ].count + 1 ) % order.length;
			c.sortVars[ col ].count = event[ c.sortResetKey ] ? 2 : tmp;
			// reset all sorts on non-current column - issue #30
			if ( c.sortRestart ) {
				for ( headerIndx = 0; headerIndx < len; headerIndx++ ) {
					$header = c.$headers.eq( headerIndx );
					tmp = parseInt( $header.attr( 'data-column' ), 10 );
					// only reset counts on columns that weren't just clicked on and if not included in a multisort
					if ( col !== tmp && ( notMultiSort || $header.hasClass( ts.css.sortNone ) ) ) {
						c.sortVars[ tmp ].count = -1;
					}
				}
			}
			// user only wants to sort on one column
			if ( notMultiSort ) {
				$.each( c.sortVars, function( i ) {
					c.sortVars[ i ].sortedBy = '';
				});
				// flush the sort list
				c.sortList = [];
				c.last.sortList = [];
				if ( c.sortForce !== null ) {
					arry = c.sortForce;
					for ( indx = 0; indx < arry.length; indx++ ) {
						if ( arry[ indx ][ 0 ] !== col ) {
							c.sortList[ c.sortList.length ] = arry[ indx ];
							c.sortVars[ arry[ indx ][ 0 ] ].sortedBy = 'sortForce';
						}
					}
				}
				// add column to sort list
				dir = order[ c.sortVars[ col ].count ];
				if ( dir < 2 ) {
					c.sortList[ c.sortList.length ] = [ col, dir ];
					c.sortVars[ col ].sortedBy = sortedBy;
					// add other columns if header spans across multiple
					if ( th.colSpan > 1 ) {
						for ( indx = 1; indx < th.colSpan; indx++ ) {
							c.sortList[ c.sortList.length ] = [ col + indx, dir ];
							// update count on columns in colSpan
							c.sortVars[ col + indx ].count = $.inArray( dir, order );
							c.sortVars[ col + indx ].sortedBy = sortedBy;
						}
					}
				}
				// multi column sorting
			} else {
				// get rid of the sortAppend before adding more - fixes issue #115 & #523
				c.sortList = $.extend( [], c.last.sortList );

				// the user has clicked on an already sorted column
				if ( ts.isValueInArray( col, c.sortList ) >= 0 ) {
					// reverse the sorting direction
					c.sortVars[ col ].sortedBy = sortedBy;
					for ( indx = 0; indx < c.sortList.length; indx++ ) {
						tmp = c.sortList[ indx ];
						if ( tmp[ 0 ] === col ) {
							// order.count seems to be incorrect when compared to cell.count
							tmp[ 1 ] = order[ c.sortVars[ col ].count ];
							if ( tmp[1] === 2 ) {
								c.sortList.splice( indx, 1 );
								c.sortVars[ col ].count = -1;
							}
						}
					}
				} else {
					// add column to sort list array
					dir = order[ c.sortVars[ col ].count ];
					c.sortVars[ col ].sortedBy = sortedBy;
					if ( dir < 2 ) {
						c.sortList[ c.sortList.length ] = [ col, dir ];
						// add other columns if header spans across multiple
						if ( th.colSpan > 1 ) {
							for ( indx = 1; indx < th.colSpan; indx++ ) {
								c.sortList[ c.sortList.length ] = [ col + indx, dir ];
								// update count on columns in colSpan
								c.sortVars[ col + indx ].count = $.inArray( dir, order );
								c.sortVars[ col + indx ].sortedBy = sortedBy;
							}
						}
					}
				}
			}
			// save sort before applying sortAppend
			c.last.sortList = $.extend( [], c.sortList );
			if ( c.sortList.length && c.sortAppend ) {
				arry = $.isArray( c.sortAppend ) ? c.sortAppend : c.sortAppend[ c.sortList[ 0 ][ 0 ] ];
				if ( !ts.isEmptyObject( arry ) ) {
					for ( indx = 0; indx < arry.length; indx++ ) {
						if ( arry[ indx ][ 0 ] !== col && ts.isValueInArray( arry[ indx ][ 0 ], c.sortList ) < 0 ) {
							dir = arry[ indx ][ 1 ];
							temp = ( '' + dir ).match( /^(a|d|s|o|n)/ );
							if ( temp ) {
								tmp = c.sortList[ 0 ][ 1 ];
								switch ( temp[ 0 ] ) {
									case 'd' :
										dir = 1;
										break;
									case 's' :
										dir = tmp;
										break;
									case 'o' :
										dir = tmp === 0 ? 1 : 0;
										break;
									case 'n' :
										dir = ( tmp + 1 ) % order.length;
										break;
									default:
										dir = 0;
										break;
								}
							}
							c.sortList[ c.sortList.length ] = [ arry[ indx ][ 0 ], dir ];
							c.sortVars[ arry[ indx ][ 0 ] ].sortedBy = 'sortAppend';
						}
					}
				}
			}
			// sortBegin event triggered immediately before the sort
			c.$table.triggerHandler( 'sortBegin', table );
			// setTimeout needed so the processing icon shows up
			setTimeout( function() {
				// set css for headers
				ts.setHeadersCss( c );
				ts.multisort( c );
				ts.appendCache( c );
				c.$table.triggerHandler( 'sortBeforeEnd', table );
				c.$table.triggerHandler( 'sortEnd', table );
			}, 1 );
		},

		// sort multiple columns
		multisort : function( c ) { /*jshint loopfunc:true */
			var tbodyIndex, sortTime, colMax, rows, tmp,
				table = c.table,
				sorter = [],
				dir = 0,
				textSorter = c.textSorter || '',
				sortList = c.sortList,
				sortLen = sortList.length,
				len = c.$tbodies.length;
			if ( c.serverSideSorting || ts.isEmptyObject( c.cache ) ) {
				// empty table - fixes #206/#346
				return;
			}
			if ( ts.debug(c, 'core') ) { sortTime = new Date(); }
			// cache textSorter to optimize speed
			if ( typeof textSorter === 'object' ) {
				colMax = c.columns;
				while ( colMax-- ) {
					tmp = ts.getColumnData( table, textSorter, colMax );
					if ( typeof tmp === 'function' ) {
						sorter[ colMax ] = tmp;
					}
				}
			}
			for ( tbodyIndex = 0; tbodyIndex < len; tbodyIndex++ ) {
				colMax = c.cache[ tbodyIndex ].colMax;
				rows = c.cache[ tbodyIndex ].normalized;

				rows.sort( function( a, b ) {
					var sortIndex, num, col, order, sort, x, y;
					// rows is undefined here in IE, so don't use it!
					for ( sortIndex = 0; sortIndex < sortLen; sortIndex++ ) {
						col = sortList[ sortIndex ][ 0 ];
						order = sortList[ sortIndex ][ 1 ];
						// sort direction, true = asc, false = desc
						dir = order === 0;

						if ( c.sortStable && a[ col ] === b[ col ] && sortLen === 1 ) {
							return a[ c.columns ].order - b[ c.columns ].order;
						}

						// fallback to natural sort since it is more robust
						num = /n/i.test( ts.getSortType( c.parsers, col ) );
						if ( num && c.strings[ col ] ) {
							// sort strings in numerical columns
							if ( typeof ( ts.string[ c.strings[ col ] ] ) === 'boolean' ) {
								num = ( dir ? 1 : -1 ) * ( ts.string[ c.strings[ col ] ] ? -1 : 1 );
							} else {
								num = ( c.strings[ col ] ) ? ts.string[ c.strings[ col ] ] || 0 : 0;
							}
							// fall back to built-in numeric sort
							// var sort = $.tablesorter['sort' + s]( a[col], b[col], dir, colMax[col], table );
							sort = c.numberSorter ? c.numberSorter( a[ col ], b[ col ], dir, colMax[ col ], table ) :
								ts[ 'sortNumeric' + ( dir ? 'Asc' : 'Desc' ) ]( a[ col ], b[ col ], num, colMax[ col ], col, c );
						} else {
							// set a & b depending on sort direction
							x = dir ? a : b;
							y = dir ? b : a;
							// text sort function
							if ( typeof textSorter === 'function' ) {
								// custom OVERALL text sorter
								sort = textSorter( x[ col ], y[ col ], dir, col, table );
							} else if ( typeof sorter[ col ] === 'function' ) {
								// custom text sorter for a SPECIFIC COLUMN
								sort = sorter[ col ]( x[ col ], y[ col ], dir, col, table );
							} else {
								// fall back to natural sort
								sort = ts[ 'sortNatural' + ( dir ? 'Asc' : 'Desc' ) ]( a[ col ] || '', b[ col ] || '', col, c );
							}
						}
						if ( sort ) { return sort; }
					}
					return a[ c.columns ].order - b[ c.columns ].order;
				});
			}
			if ( ts.debug(c, 'core') ) {
				console.log( 'Applying sort ' + sortList.toString() + ts.benchmark( sortTime ) );
			}
		},

		resortComplete : function( c, callback ) {
			if ( c.table.isUpdating ) {
				c.$table.triggerHandler( 'updateComplete', c.table );
			}
			if ( $.isFunction( callback ) ) {
				callback( c.table );
			}
		},

		checkResort : function( c, resort, callback ) {
			var sortList = $.isArray( resort ) ? resort : c.sortList,
				// if no resort parameter is passed, fallback to config.resort (true by default)
				resrt = typeof resort === 'undefined' ? c.resort : resort;
			// don't try to resort if the table is still processing
			// this will catch spamming of the updateCell method
			if ( resrt !== false && !c.serverSideSorting && !c.table.isProcessing ) {
				if ( sortList.length ) {
					ts.sortOn( c, sortList, function() {
						ts.resortComplete( c, callback );
					}, true );
				} else {
					ts.sortReset( c, function() {
						ts.resortComplete( c, callback );
						ts.applyWidget( c.table, false );
					} );
				}
			} else {
				ts.resortComplete( c, callback );
				ts.applyWidget( c.table, false );
			}
		},

		sortOn : function( c, list, callback, init ) {
			var indx,
				table = c.table;
			c.$table.triggerHandler( 'sortStart', table );
			for (indx = 0; indx < c.columns; indx++) {
				c.sortVars[ indx ].sortedBy = ts.isValueInArray( indx, list ) > -1 ? 'sorton' : '';
			}
			// update header count index
			ts.updateHeaderSortCount( c, list );
			// set css for headers
			ts.setHeadersCss( c );
			// fixes #346
			if ( c.delayInit && ts.isEmptyObject( c.cache ) ) {
				ts.buildCache( c );
			}
			c.$table.triggerHandler( 'sortBegin', table );
			// sort the table and append it to the dom
			ts.multisort( c );
			ts.appendCache( c, init );
			c.$table.triggerHandler( 'sortBeforeEnd', table );
			c.$table.triggerHandler( 'sortEnd', table );
			ts.applyWidget( table );
			if ( $.isFunction( callback ) ) {
				callback( table );
			}
		},

		sortReset : function( c, callback ) {
			c.sortList = [];
			var indx;
			for (indx = 0; indx < c.columns; indx++) {
				c.sortVars[ indx ].count = -1;
				c.sortVars[ indx ].sortedBy = '';
			}
			ts.setHeadersCss( c );
			ts.multisort( c );
			ts.appendCache( c );
			if ( $.isFunction( callback ) ) {
				callback( c.table );
			}
		},

		getSortType : function( parsers, column ) {
			return ( parsers && parsers[ column ] ) ? parsers[ column ].type || '' : '';
		},

		getOrder : function( val ) {
			// look for 'd' in 'desc' order; return true
			return ( /^d/i.test( val ) || val === 1 );
		},

		// Natural sort - https://github.com/overset/javascript-natural-sort (date sorting removed)
		sortNatural : function( a, b ) {
			if ( a === b ) { return 0; }
			a = ( a || '' ).toString();
			b = ( b || '' ).toString();
			var aNum, bNum, aFloat, bFloat, indx, max,
				regex = ts.regex;
			// first try and sort Hex codes
			if ( regex.hex.test( b ) ) {
				aNum = parseInt( a.match( regex.hex ), 16 );
				bNum = parseInt( b.match( regex.hex ), 16 );
				if ( aNum < bNum ) { return -1; }
				if ( aNum > bNum ) { return 1; }
			}
			// chunk/tokenize
			aNum = a.replace( regex.chunk, '\\0$1\\0' ).replace( regex.chunks, '' ).split( '\\0' );
			bNum = b.replace( regex.chunk, '\\0$1\\0' ).replace( regex.chunks, '' ).split( '\\0' );
			max = Math.max( aNum.length, bNum.length );
			// natural sorting through split numeric strings and default strings
			for ( indx = 0; indx < max; indx++ ) {
				// find floats not starting with '0', string or 0 if not defined
				aFloat = isNaN( aNum[ indx ] ) ? aNum[ indx ] || 0 : parseFloat( aNum[ indx ] ) || 0;
				bFloat = isNaN( bNum[ indx ] ) ? bNum[ indx ] || 0 : parseFloat( bNum[ indx ] ) || 0;
				// handle numeric vs string comparison - number < string - (Kyle Adams)
				if ( isNaN( aFloat ) !== isNaN( bFloat ) ) { return isNaN( aFloat ) ? 1 : -1; }
				// rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
				if ( typeof aFloat !== typeof bFloat ) {
					aFloat += '';
					bFloat += '';
				}
				if ( aFloat < bFloat ) { return -1; }
				if ( aFloat > bFloat ) { return 1; }
			}
			return 0;
		},

		sortNaturalAsc : function( a, b, col, c ) {
			if ( a === b ) { return 0; }
			var empty = ts.string[ ( c.empties[ col ] || c.emptyTo ) ];
			if ( a === '' && empty !== 0 ) { return typeof empty === 'boolean' ? ( empty ? -1 : 1 ) : -empty || -1; }
			if ( b === '' && empty !== 0 ) { return typeof empty === 'boolean' ? ( empty ? 1 : -1 ) : empty || 1; }
			return ts.sortNatural( a, b );
		},

		sortNaturalDesc : function( a, b, col, c ) {
			if ( a === b ) { return 0; }
			var empty = ts.string[ ( c.empties[ col ] || c.emptyTo ) ];
			if ( a === '' && empty !== 0 ) { return typeof empty === 'boolean' ? ( empty ? -1 : 1 ) : empty || 1; }
			if ( b === '' && empty !== 0 ) { return typeof empty === 'boolean' ? ( empty ? 1 : -1 ) : -empty || -1; }
			return ts.sortNatural( b, a );
		},

		// basic alphabetical sort
		sortText : function( a, b ) {
			return a > b ? 1 : ( a < b ? -1 : 0 );
		},

		// return text string value by adding up ascii value
		// so the text is somewhat sorted when using a digital sort
		// this is NOT an alphanumeric sort
		getTextValue : function( val, num, max ) {
			if ( max ) {
				// make sure the text value is greater than the max numerical value (max)
				var indx,
					len = val ? val.length : 0,
					n = max + num;
				for ( indx = 0; indx < len; indx++ ) {
					n += val.charCodeAt( indx );
				}
				return num * n;
			}
			return 0;
		},

		sortNumericAsc : function( a, b, num, max, col, c ) {
			if ( a === b ) { return 0; }
			var empty = ts.string[ ( c.empties[ col ] || c.emptyTo ) ];
			if ( a === '' && empty !== 0 ) { return typeof empty === 'boolean' ? ( empty ? -1 : 1 ) : -empty || -1; }
			if ( b === '' && empty !== 0 ) { return typeof empty === 'boolean' ? ( empty ? 1 : -1 ) : empty || 1; }
			if ( isNaN( a ) ) { a = ts.getTextValue( a, num, max ); }
			if ( isNaN( b ) ) { b = ts.getTextValue( b, num, max ); }
			return a - b;
		},

		sortNumericDesc : function( a, b, num, max, col, c ) {
			if ( a === b ) { return 0; }
			var empty = ts.string[ ( c.empties[ col ] || c.emptyTo ) ];
			if ( a === '' && empty !== 0 ) { return typeof empty === 'boolean' ? ( empty ? -1 : 1 ) : empty || 1; }
			if ( b === '' && empty !== 0 ) { return typeof empty === 'boolean' ? ( empty ? 1 : -1 ) : -empty || -1; }
			if ( isNaN( a ) ) { a = ts.getTextValue( a, num, max ); }
			if ( isNaN( b ) ) { b = ts.getTextValue( b, num, max ); }
			return b - a;
		},

		sortNumeric : function( a, b ) {
			return a - b;
		},

		/*
		██ ██ ██ ██ █████▄ ▄████▄ ██████ ██████ ▄█████
		██ ██ ██ ██ ██  ██ ██ ▄▄▄ ██▄▄     ██   ▀█▄
		██ ██ ██ ██ ██  ██ ██ ▀██ ██▀▀     ██      ▀█▄
		███████▀ ██ █████▀ ▀████▀ ██████   ██   █████▀
		*/
		addWidget : function( widget ) {
			if ( widget.id && !ts.isEmptyObject( ts.getWidgetById( widget.id ) ) ) {
				console.warn( '"' + widget.id + '" widget was loaded more than once!' );
			}
			ts.widgets[ ts.widgets.length ] = widget;
		},

		hasWidget : function( $table, name ) {
			$table = $( $table );
			return $table.length && $table[ 0 ].config && $table[ 0 ].config.widgetInit[ name ] || false;
		},

		getWidgetById : function( name ) {
			var indx, widget,
				len = ts.widgets.length;
			for ( indx = 0; indx < len; indx++ ) {
				widget = ts.widgets[ indx ];
				if ( widget && widget.id && widget.id.toLowerCase() === name.toLowerCase() ) {
					return widget;
				}
			}
		},

		applyWidgetOptions : function( table ) {
			var indx, widget, wo,
				c = table.config,
				len = c.widgets.length;
			if ( len ) {
				for ( indx = 0; indx < len; indx++ ) {
					widget = ts.getWidgetById( c.widgets[ indx ] );
					if ( widget && widget.options ) {
						wo = $.extend( true, {}, widget.options );
						c.widgetOptions = $.extend( true, wo, c.widgetOptions );
						// add widgetOptions to defaults for option validator
						$.extend( true, ts.defaults.widgetOptions, widget.options );
					}
				}
			}
		},

		addWidgetFromClass : function( table ) {
			var len, indx,
				c = table.config,
				// look for widgets to apply from table class
				// don't match from 'ui-widget-content'; use \S instead of \w to include widgets
				// with dashes in the name, e.g. "widget-test-2" extracts out "test-2"
				regex = '^' + c.widgetClass.replace( ts.regex.templateName, '(\\S+)+' ) + '$',
				widgetClass = new RegExp( regex, 'g' ),
				// split up table class (widget id's can include dashes) - stop using match
				// otherwise only one widget gets extracted, see #1109
				widgets = ( table.className || '' ).split( ts.regex.spaces );
			if ( widgets.length ) {
				len = widgets.length;
				for ( indx = 0; indx < len; indx++ ) {
					if ( widgets[ indx ].match( widgetClass ) ) {
						c.widgets[ c.widgets.length ] = widgets[ indx ].replace( widgetClass, '$1' );
					}
				}
			}
		},

		applyWidgetId : function( table, id, init ) {
			table = $(table)[0];
			var applied, time, name,
				c = table.config,
				wo = c.widgetOptions,
				debug = ts.debug(c, 'core'),
				widget = ts.getWidgetById( id );
			if ( widget ) {
				name = widget.id;
				applied = false;
				// add widget name to option list so it gets reapplied after sorting, filtering, etc
				if ( $.inArray( name, c.widgets ) < 0 ) {
					c.widgets[ c.widgets.length ] = name;
				}
				if ( debug ) { time = new Date(); }

				if ( init || !( c.widgetInit[ name ] ) ) {
					// set init flag first to prevent calling init more than once (e.g. pager)
					c.widgetInit[ name ] = true;
					if ( table.hasInitialized ) {
						// don't reapply widget options on tablesorter init
						ts.applyWidgetOptions( table );
					}
					if ( typeof widget.init === 'function' ) {
						applied = true;
						if ( debug ) {
							console[ console.group ? 'group' : 'log' ]( 'Initializing ' + name + ' widget' );
						}
						widget.init( table, widget, c, wo );
					}
				}
				if ( !init && typeof widget.format === 'function' ) {
					applied = true;
					if ( debug ) {
						console[ console.group ? 'group' : 'log' ]( 'Updating ' + name + ' widget' );
					}
					widget.format( table, c, wo, false );
				}
				if ( debug ) {
					if ( applied ) {
						console.log( 'Completed ' + ( init ? 'initializing ' : 'applying ' ) + name + ' widget' + ts.benchmark( time ) );
						if ( console.groupEnd ) { console.groupEnd(); }
					}
				}
			}
		},

		applyWidget : function( table, init, callback ) {
			table = $( table )[ 0 ]; // in case this is called externally
			var indx, len, names, widget, time,
				c = table.config,
				debug = ts.debug(c, 'core'),
				widgets = [];
			// prevent numerous consecutive widget applications
			if ( init !== false && table.hasInitialized && ( table.isApplyingWidgets || table.isUpdating ) ) {
				return;
			}
			if ( debug ) { time = new Date(); }
			ts.addWidgetFromClass( table );
			// prevent "tablesorter-ready" from firing multiple times in a row
			clearTimeout( c.timerReady );
			if ( c.widgets.length ) {
				table.isApplyingWidgets = true;
				// ensure unique widget ids
				c.widgets = $.grep( c.widgets, function( val, index ) {
					return $.inArray( val, c.widgets ) === index;
				});
				names = c.widgets || [];
				len = names.length;
				// build widget array & add priority as needed
				for ( indx = 0; indx < len; indx++ ) {
					widget = ts.getWidgetById( names[ indx ] );
					if ( widget && widget.id ) {
						// set priority to 10 if not defined
						if ( !widget.priority ) { widget.priority = 10; }
						widgets[ indx ] = widget;
					} else if ( debug ) {
						console.warn( '"' + names[ indx ] + '" was enabled, but the widget code has not been loaded!' );
					}
				}
				// sort widgets by priority
				widgets.sort( function( a, b ) {
					return a.priority < b.priority ? -1 : a.priority === b.priority ? 0 : 1;
				});
				// add/update selected widgets
				len = widgets.length;
				if ( debug ) {
					console[ console.group ? 'group' : 'log' ]( 'Start ' + ( init ? 'initializing' : 'applying' ) + ' widgets' );
				}
				for ( indx = 0; indx < len; indx++ ) {
					widget = widgets[ indx ];
					if ( widget && widget.id ) {
						ts.applyWidgetId( table, widget.id, init );
					}
				}
				if ( debug && console.groupEnd ) { console.groupEnd(); }
			}
			c.timerReady = setTimeout( function() {
				table.isApplyingWidgets = false;
				$.data( table, 'lastWidgetApplication', new Date() );
				c.$table.triggerHandler( 'tablesorter-ready' );
				// callback executed on init only
				if ( !init && typeof callback === 'function' ) {
					callback( table );
				}
				if ( debug ) {
					widget = c.widgets.length;
					console.log( 'Completed ' +
						( init === true ? 'initializing ' : 'applying ' ) + widget +
						' widget' + ( widget !== 1 ? 's' : '' ) + ts.benchmark( time ) );
				}
			}, 10 );
		},

		removeWidget : function( table, name, refreshing ) {
			table = $( table )[ 0 ];
			var index, widget, indx, len,
				c = table.config;
			// if name === true, add all widgets from $.tablesorter.widgets
			if ( name === true ) {
				name = [];
				len = ts.widgets.length;
				for ( indx = 0; indx < len; indx++ ) {
					widget = ts.widgets[ indx ];
					if ( widget && widget.id ) {
						name[ name.length ] = widget.id;
					}
				}
			} else {
				// name can be either an array of widgets names,
				// or a space/comma separated list of widget names
				name = ( $.isArray( name ) ? name.join( ',' ) : name || '' ).toLowerCase().split( /[\s,]+/ );
			}
			len = name.length;
			for ( index = 0; index < len; index++ ) {
				widget = ts.getWidgetById( name[ index ] );
				indx = $.inArray( name[ index ], c.widgets );
				// don't remove the widget from config.widget if refreshing
				if ( indx >= 0 && refreshing !== true ) {
					c.widgets.splice( indx, 1 );
				}
				if ( widget && widget.remove ) {
					if ( ts.debug(c, 'core') ) {
						console.log( ( refreshing ? 'Refreshing' : 'Removing' ) + ' "' + name[ index ] + '" widget' );
					}
					widget.remove( table, c, c.widgetOptions, refreshing );
					c.widgetInit[ name[ index ] ] = false;
				}
			}
			c.$table.triggerHandler( 'widgetRemoveEnd', table );
		},

		refreshWidgets : function( table, doAll, dontapply ) {
			table = $( table )[ 0 ]; // see issue #243
			var indx, widget,
				c = table.config,
				curWidgets = c.widgets,
				widgets = ts.widgets,
				len = widgets.length,
				list = [],
				callback = function( table ) {
					$( table ).triggerHandler( 'refreshComplete' );
				};
			// remove widgets not defined in config.widgets, unless doAll is true
			for ( indx = 0; indx < len; indx++ ) {
				widget = widgets[ indx ];
				if ( widget && widget.id && ( doAll || $.inArray( widget.id, curWidgets ) < 0 ) ) {
					list[ list.length ] = widget.id;
				}
			}
			ts.removeWidget( table, list.join( ',' ), true );
			if ( dontapply !== true ) {
				// call widget init if
				ts.applyWidget( table, doAll || false, callback );
				if ( doAll ) {
					// apply widget format
					ts.applyWidget( table, false, callback );
				}
			} else {
				callback( table );
			}
		},

		/*
		██  ██ ██████ ██ ██     ██ ██████ ██ ██████ ▄█████
		██  ██   ██   ██ ██     ██   ██   ██ ██▄▄   ▀█▄
		██  ██   ██   ██ ██     ██   ██   ██ ██▀▀      ▀█▄
		▀████▀   ██   ██ ██████ ██   ██   ██ ██████ █████▀
		*/
		benchmark : function( diff ) {
			return ( ' (' + ( new Date().getTime() - diff.getTime() ) + ' ms)' );
		},
		// deprecated ts.log
		log : function() {
			console.log( arguments );
		},
		debug : function(c, name) {
			return c && (
				c.debug === true ||
				typeof c.debug === 'string' && c.debug.indexOf(name) > -1
			);
		},

		// $.isEmptyObject from jQuery v1.4
		isEmptyObject : function( obj ) {
			/*jshint forin: false */
			for ( var name in obj ) {
				return false;
			}
			return true;
		},

		isValueInArray : function( column, arry ) {
			var indx,
				len = arry && arry.length || 0;
			for ( indx = 0; indx < len; indx++ ) {
				if ( arry[ indx ][ 0 ] === column ) {
					return indx;
				}
			}
			return -1;
		},

		formatFloat : function( str, table ) {
			if ( typeof str !== 'string' || str === '' ) { return str; }
			// allow using formatFloat without a table; defaults to US number format
			var num,
				usFormat = table && table.config ? table.config.usNumberFormat !== false :
					typeof table !== 'undefined' ? table : true;
			if ( usFormat ) {
				// US Format - 1,234,567.89 -> 1234567.89
				str = str.replace( ts.regex.comma, '' );
			} else {
				// German Format = 1.234.567,89 -> 1234567.89
				// French Format = 1 234 567,89 -> 1234567.89
				str = str.replace( ts.regex.digitNonUS, '' ).replace( ts.regex.comma, '.' );
			}
			if ( ts.regex.digitNegativeTest.test( str ) ) {
				// make (#) into a negative number -> (10) = -10
				str = str.replace( ts.regex.digitNegativeReplace, '-$1' );
			}
			num = parseFloat( str );
			// return the text instead of zero
			return isNaN( num ) ? $.trim( str ) : num;
		},

		isDigit : function( str ) {
			// replace all unwanted chars and match
			return isNaN( str ) ?
				ts.regex.digitTest.test( str.toString().replace( ts.regex.digitReplace, '' ) ) :
				str !== '';
		},

		// computeTableHeaderCellIndexes from:
		// http://www.javascripttoolbox.com/lib/table/examples.php
		// http://www.javascripttoolbox.com/temp/table_cellindex.html
		computeColumnIndex : function( $rows, c ) {
			var i, j, k, l, cell, cells, rowIndex, rowSpan, colSpan, firstAvailCol,
				// total columns has been calculated, use it to set the matrixrow
				columns = c && c.columns || 0,
				matrix = [],
				matrixrow = new Array( columns );
			for ( i = 0; i < $rows.length; i++ ) {
				cells = $rows[ i ].cells;
				for ( j = 0; j < cells.length; j++ ) {
					cell = cells[ j ];
					rowIndex = i;
					rowSpan = cell.rowSpan || 1;
					colSpan = cell.colSpan || 1;
					if ( typeof matrix[ rowIndex ] === 'undefined' ) {
						matrix[ rowIndex ] = [];
					}
					// Find first available column in the first row
					for ( k = 0; k < matrix[ rowIndex ].length + 1; k++ ) {
						if ( typeof matrix[ rowIndex ][ k ] === 'undefined' ) {
							firstAvailCol = k;
							break;
						}
					}
					// jscs:disable disallowEmptyBlocks
					if ( columns && cell.cellIndex === firstAvailCol ) {
						// don't to anything
					} else if ( cell.setAttribute ) {
						// jscs:enable disallowEmptyBlocks
						// add data-column (setAttribute = IE8+)
						cell.setAttribute( 'data-column', firstAvailCol );
					} else {
						// remove once we drop support for IE7 - 1/12/2016
						$( cell ).attr( 'data-column', firstAvailCol );
					}
					for ( k = rowIndex; k < rowIndex + rowSpan; k++ ) {
						if ( typeof matrix[ k ] === 'undefined' ) {
							matrix[ k ] = [];
						}
						matrixrow = matrix[ k ];
						for ( l = firstAvailCol; l < firstAvailCol + colSpan; l++ ) {
							matrixrow[ l ] = 'x';
						}
					}
				}
			}
			ts.checkColumnCount($rows, matrix, matrixrow.length);
			return matrixrow.length;
		},

		checkColumnCount : function($rows, matrix, columns) {
			// this DOES NOT report any tbody column issues, except for the math and
			// and column selector widgets
			var i, len,
				valid = true,
				cells = [];
			for ( i = 0; i < matrix.length; i++ ) {
				// some matrix entries are undefined when testing the footer because
				// it is using the rowIndex property
				if ( matrix[i] ) {
					len = matrix[i].length;
					if ( matrix[i].length !== columns ) {
						valid = false;
						break;
					}
				}
			}
			if ( !valid ) {
				$rows.each( function( indx, el ) {
					var cell = el.parentElement.nodeName;
					if ( cells.indexOf( cell ) < 0 ) {
						cells.push( cell );
					}
				});
				console.error(
					'Invalid or incorrect number of columns in the ' +
					cells.join( ' or ' ) + '; expected ' + columns +
					', but found ' + len + ' columns'
				);
			}
		},

		// automatically add a colgroup with col elements set to a percentage width
		fixColumnWidth : function( table ) {
			table = $( table )[ 0 ];
			var overallWidth, percent, $tbodies, len, index,
				c = table.config,
				$colgroup = c.$table.children( 'colgroup' );
			// remove plugin-added colgroup, in case we need to refresh the widths
			if ( $colgroup.length && $colgroup.hasClass( ts.css.colgroup ) ) {
				$colgroup.remove();
			}
			if ( c.widthFixed && c.$table.children( 'colgroup' ).length === 0 ) {
				$colgroup = $( '<colgroup class="' + ts.css.colgroup + '">' );
				overallWidth = c.$table.width();
				// only add col for visible columns - fixes #371
				$tbodies = c.$tbodies.find( 'tr:first' ).children( ':visible' );
				len = $tbodies.length;
				for ( index = 0; index < len; index++ ) {
					percent = parseInt( ( $tbodies.eq( index ).width() / overallWidth ) * 1000, 10 ) / 10 + '%';
					$colgroup.append( $( '<col>' ).css( 'width', percent ) );
				}
				c.$table.prepend( $colgroup );
			}
		},

		// get sorter, string, empty, etc options for each column from
		// jQuery data, metadata, header option or header class name ('sorter-false')
		// priority = jQuery data > meta > headers option > header class name
		getData : function( header, configHeader, key ) {
			var meta, cl4ss,
				val = '',
				$header = $( header );
			if ( !$header.length ) { return ''; }
			meta = $.metadata ? $header.metadata() : false;
			cl4ss = ' ' + ( $header.attr( 'class' ) || '' );
			if ( typeof $header.data( key ) !== 'undefined' ||
				typeof $header.data( key.toLowerCase() ) !== 'undefined' ) {
				// 'data-lockedOrder' is assigned to 'lockedorder'; but 'data-locked-order' is assigned to 'lockedOrder'
				// 'data-sort-initial-order' is assigned to 'sortInitialOrder'
				val += $header.data( key ) || $header.data( key.toLowerCase() );
			} else if ( meta && typeof meta[ key ] !== 'undefined' ) {
				val += meta[ key ];
			} else if ( configHeader && typeof configHeader[ key ] !== 'undefined' ) {
				val += configHeader[ key ];
			} else if ( cl4ss !== ' ' && cl4ss.match( ' ' + key + '-' ) ) {
				// include sorter class name 'sorter-text', etc; now works with 'sorter-my-custom-parser'
				val = cl4ss.match( new RegExp( '\\s' + key + '-([\\w-]+)' ) )[ 1 ] || '';
			}
			return $.trim( val );
		},

		getColumnData : function( table, obj, indx, getCell, $headers ) {
			if ( typeof obj !== 'object' || obj === null ) {
				return obj;
			}
			table = $( table )[ 0 ];
			var $header, key,
				c = table.config,
				$cells = ( $headers || c.$headers ),
				// c.$headerIndexed is not defined initially
				$cell = c.$headerIndexed && c.$headerIndexed[ indx ] ||
					$cells.find( '[data-column="' + indx + '"]:last' );
			if ( typeof obj[ indx ] !== 'undefined' ) {
				return getCell ? obj[ indx ] : obj[ $cells.index( $cell ) ];
			}
			for ( key in obj ) {
				if ( typeof key === 'string' ) {
					$header = $cell
						// header cell with class/id
						.filter( key )
						// find elements within the header cell with cell/id
						.add( $cell.find( key ) );
					if ( $header.length ) {
						return obj[ key ];
					}
				}
			}
			return;
		},

		// *** Process table ***
		// add processing indicator
		isProcessing : function( $table, toggle, $headers ) {
			$table = $( $table );
			var c = $table[ 0 ].config,
				// default to all headers
				$header = $headers || $table.find( '.' + ts.css.header );
			if ( toggle ) {
				// don't use sortList if custom $headers used
				if ( typeof $headers !== 'undefined' && c.sortList.length > 0 ) {
					// get headers from the sortList
					$header = $header.filter( function() {
						// get data-column from attr to keep compatibility with jQuery 1.2.6
						return this.sortDisabled ?
							false :
							ts.isValueInArray( parseFloat( $( this ).attr( 'data-column' ) ), c.sortList ) >= 0;
					});
				}
				$table.add( $header ).addClass( ts.css.processing + ' ' + c.cssProcessing );
			} else {
				$table.add( $header ).removeClass( ts.css.processing + ' ' + c.cssProcessing );
			}
		},

		// detach tbody but save the position
		// don't use tbody because there are portions that look for a tbody index (updateCell)
		processTbody : function( table, $tb, getIt ) {
			table = $( table )[ 0 ];
			if ( getIt ) {
				table.isProcessing = true;
				$tb.before( '<colgroup class="tablesorter-savemyplace"/>' );
				return $.fn.detach ? $tb.detach() : $tb.remove();
			}
			var holdr = $( table ).find( 'colgroup.tablesorter-savemyplace' );
			$tb.insertAfter( holdr );
			holdr.remove();
			table.isProcessing = false;
		},

		clearTableBody : function( table ) {
			$( table )[ 0 ].config.$tbodies.children().detach();
		},

		// used when replacing accented characters during sorting
		characterEquivalents : {
			'a' : '\u00e1\u00e0\u00e2\u00e3\u00e4\u0105\u00e5', // áàâãäąå
			'A' : '\u00c1\u00c0\u00c2\u00c3\u00c4\u0104\u00c5', // ÁÀÂÃÄĄÅ
			'c' : '\u00e7\u0107\u010d', // çćč
			'C' : '\u00c7\u0106\u010c', // ÇĆČ
			'e' : '\u00e9\u00e8\u00ea\u00eb\u011b\u0119', // éèêëěę
			'E' : '\u00c9\u00c8\u00ca\u00cb\u011a\u0118', // ÉÈÊËĚĘ
			'i' : '\u00ed\u00ec\u0130\u00ee\u00ef\u0131', // íìİîïı
			'I' : '\u00cd\u00cc\u0130\u00ce\u00cf', // ÍÌİÎÏ
			'o' : '\u00f3\u00f2\u00f4\u00f5\u00f6\u014d', // óòôõöō
			'O' : '\u00d3\u00d2\u00d4\u00d5\u00d6\u014c', // ÓÒÔÕÖŌ
			'ss': '\u00df', // ß (s sharp)
			'SS': '\u1e9e', // ẞ (Capital sharp s)
			'u' : '\u00fa\u00f9\u00fb\u00fc\u016f', // úùûüů
			'U' : '\u00da\u00d9\u00db\u00dc\u016e' // ÚÙÛÜŮ
		},

		replaceAccents : function( str ) {
			var chr,
				acc = '[',
				eq = ts.characterEquivalents;
			if ( !ts.characterRegex ) {
				ts.characterRegexArray = {};
				for ( chr in eq ) {
					if ( typeof chr === 'string' ) {
						acc += eq[ chr ];
						ts.characterRegexArray[ chr ] = new RegExp( '[' + eq[ chr ] + ']', 'g' );
					}
				}
				ts.characterRegex = new RegExp( acc + ']' );
			}
			if ( ts.characterRegex.test( str ) ) {
				for ( chr in eq ) {
					if ( typeof chr === 'string' ) {
						str = str.replace( ts.characterRegexArray[ chr ], chr );
					}
				}
			}
			return str;
		},

		validateOptions : function( c ) {
			var setting, setting2, typ, timer,
				// ignore options containing an array
				ignore = 'headers sortForce sortList sortAppend widgets'.split( ' ' ),
				orig = c.originalSettings;
			if ( orig ) {
				if ( ts.debug(c, 'core') ) {
					timer = new Date();
				}
				for ( setting in orig ) {
					typ = typeof ts.defaults[setting];
					if ( typ === 'undefined' ) {
						console.warn( 'Tablesorter Warning! "table.config.' + setting + '" option not recognized' );
					} else if ( typ === 'object' ) {
						for ( setting2 in orig[setting] ) {
							typ = ts.defaults[setting] && typeof ts.defaults[setting][setting2];
							if ( $.inArray( setting, ignore ) < 0 && typ === 'undefined' ) {
								console.warn( 'Tablesorter Warning! "table.config.' + setting + '.' + setting2 + '" option not recognized' );
							}
						}
					}
				}
				if ( ts.debug(c, 'core') ) {
					console.log( 'validate options time:' + ts.benchmark( timer ) );
				}
			}
		},

		// restore headers
		restoreHeaders : function( table ) {
			var index, $cell,
				c = $( table )[ 0 ].config,
				$headers = c.$table.find( c.selectorHeaders ),
				len = $headers.length;
			// don't use c.$headers here in case header cells were swapped
			for ( index = 0; index < len; index++ ) {
				$cell = $headers.eq( index );
				// only restore header cells if it is wrapped
				// because this is also used by the updateAll method
				if ( $cell.find( '.' + ts.css.headerIn ).length ) {
					$cell.html( c.headerContent[ index ] );
				}
			}
		},

		destroy : function( table, removeClasses, callback ) {
			table = $( table )[ 0 ];
			if ( !table.hasInitialized ) { return; }
			// remove all widgets
			ts.removeWidget( table, true, false );
			var events,
				$t = $( table ),
				c = table.config,
				$h = $t.find( 'thead:first' ),
				$r = $h.find( 'tr.' + ts.css.headerRow ).removeClass( ts.css.headerRow + ' ' + c.cssHeaderRow ),
				$f = $t.find( 'tfoot:first > tr' ).children( 'th, td' );
			if ( removeClasses === false && $.inArray( 'uitheme', c.widgets ) >= 0 ) {
				// reapply uitheme classes, in case we want to maintain appearance
				$t.triggerHandler( 'applyWidgetId', [ 'uitheme' ] );
				$t.triggerHandler( 'applyWidgetId', [ 'zebra' ] );
			}
			// remove widget added rows, just in case
			$h.find( 'tr' ).not( $r ).remove();
			// disable tablesorter - not using .unbind( namespace ) because namespacing was
			// added in jQuery v1.4.3 - see http://api.jquery.com/event.namespace/
			events = 'sortReset update updateRows updateAll updateHeaders updateCell addRows updateComplete sorton ' +
				'appendCache updateCache applyWidgetId applyWidgets refreshWidgets removeWidget destroy mouseup mouseleave ' +
				'keypress sortBegin sortEnd resetToLoadState '.split( ' ' )
				.join( c.namespace + ' ' );
			$t
				.removeData( 'tablesorter' )
				.unbind( events.replace( ts.regex.spaces, ' ' ) );
			c.$headers
				.add( $f )
				.removeClass( [ ts.css.header, c.cssHeader, c.cssAsc, c.cssDesc, ts.css.sortAsc, ts.css.sortDesc, ts.css.sortNone ].join( ' ' ) )
				.removeAttr( 'data-column' )
				.removeAttr( 'aria-label' )
				.attr( 'aria-disabled', 'true' );
			$r
				.find( c.selectorSort )
				.unbind( ( 'mousedown mouseup keypress '.split( ' ' ).join( c.namespace + ' ' ) ).replace( ts.regex.spaces, ' ' ) );
			ts.restoreHeaders( table );
			$t.toggleClass( ts.css.table + ' ' + c.tableClass + ' tablesorter-' + c.theme, removeClasses === false );
			$t.removeClass(c.namespace.slice(1));
			// clear flag in case the plugin is initialized again
			table.hasInitialized = false;
			delete table.config.cache;
			if ( typeof callback === 'function' ) {
				callback( table );
			}
			if ( ts.debug(c, 'core') ) {
				console.log( 'tablesorter has been removed' );
			}
		}

	};

	$.fn.tablesorter = function( settings ) {
		return this.each( function() {
			var table = this,
			// merge & extend config options
			c = $.extend( true, {}, ts.defaults, settings, ts.instanceMethods );
			// save initial settings
			c.originalSettings = settings;
			// create a table from data (build table widget)
			if ( !table.hasInitialized && ts.buildTable && this.nodeName !== 'TABLE' ) {
				// return the table (in case the original target is the table's container)
				ts.buildTable( table, c );
			} else {
				ts.setup( table, c );
			}
		});
	};

	// set up debug logs
	if ( !( window.console && window.console.log ) ) {
		// access $.tablesorter.logs for browsers that don't have a console...
		ts.logs = [];
		/*jshint -W020 */
		console = {};
		console.log = console.warn = console.error = console.table = function() {
			var arg = arguments.length > 1 ? arguments : arguments[0];
			ts.logs[ ts.logs.length ] = { date: Date.now(), log: arg };
		};
	}

	// add default parsers
	ts.addParser({
		id : 'no-parser',
		is : function() {
			return false;
		},
		format : function() {
			return '';
		},
		type : 'text'
	});

	ts.addParser({
		id : 'text',
		is : function() {
			return true;
		},
		format : function( str, table ) {
			var c = table.config;
			if ( str ) {
				str = $.trim( c.ignoreCase ? str.toLocaleLowerCase() : str );
				str = c.sortLocaleCompare ? ts.replaceAccents( str ) : str;
			}
			return str;
		},
		type : 'text'
	});

	ts.regex.nondigit = /[^\w,. \-()]/g;
	ts.addParser({
		id : 'digit',
		is : function( str ) {
			return ts.isDigit( str );
		},
		format : function( str, table ) {
			var num = ts.formatFloat( ( str || '' ).replace( ts.regex.nondigit, '' ), table );
			return str && typeof num === 'number' ? num :
				str ? $.trim( str && table.config.ignoreCase ? str.toLocaleLowerCase() : str ) : str;
		},
		type : 'numeric'
	});

	ts.regex.currencyReplace = /[+\-,. ]/g;
	ts.regex.currencyTest = /^\(?\d+[\u00a3$\u20ac\u00a4\u00a5\u00a2?.]|[\u00a3$\u20ac\u00a4\u00a5\u00a2?.]\d+\)?$/;
	ts.addParser({
		id : 'currency',
		is : function( str ) {
			str = ( str || '' ).replace( ts.regex.currencyReplace, '' );
			// test for £$€¤¥¢
			return ts.regex.currencyTest.test( str );
		},
		format : function( str, table ) {
			var num = ts.formatFloat( ( str || '' ).replace( ts.regex.nondigit, '' ), table );
			return str && typeof num === 'number' ? num :
				str ? $.trim( str && table.config.ignoreCase ? str.toLocaleLowerCase() : str ) : str;
		},
		type : 'numeric'
	});

	// too many protocols to add them all https://en.wikipedia.org/wiki/URI_scheme
	// now, this regex can be updated before initialization
	ts.regex.urlProtocolTest = /^(https?|ftp|file):\/\//;
	ts.regex.urlProtocolReplace = /(https?|ftp|file):\/\/(www\.)?/;
	ts.addParser({
		id : 'url',
		is : function( str ) {
			return ts.regex.urlProtocolTest.test( str );
		},
		format : function( str ) {
			return str ? $.trim( str.replace( ts.regex.urlProtocolReplace, '' ) ) : str;
		},
		type : 'text'
	});

	ts.regex.dash = /-/g;
	ts.regex.isoDate = /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}/;
	ts.addParser({
		id : 'isoDate',
		is : function( str ) {
			return ts.regex.isoDate.test( str );
		},
		format : function( str ) {
			var date = str ? new Date( str.replace( ts.regex.dash, '/' ) ) : str;
			return date instanceof Date && isFinite( date ) ? date.getTime() : str;
		},
		type : 'numeric'
	});

	ts.regex.percent = /%/g;
	ts.regex.percentTest = /(\d\s*?%|%\s*?\d)/;
	ts.addParser({
		id : 'percent',
		is : function( str ) {
			return ts.regex.percentTest.test( str ) && str.length < 15;
		},
		format : function( str, table ) {
			return str ? ts.formatFloat( str.replace( ts.regex.percent, '' ), table ) : str;
		},
		type : 'numeric'
	});

	// added image parser to core v2.17.9
	ts.addParser({
		id : 'image',
		is : function( str, table, node, $node ) {
			return $node.find( 'img' ).length > 0;
		},
		format : function( str, table, cell ) {
			return $( cell ).find( 'img' ).attr( table.config.imgAttr || 'alt' ) || str;
		},
		parsed : true, // filter widget flag
		type : 'text'
	});

	ts.regex.dateReplace = /(\S)([AP]M)$/i; // used by usLongDate & time parser
	ts.regex.usLongDateTest1 = /^[A-Z]{3,10}\.?\s+\d{1,2},?\s+(\d{4})(\s+\d{1,2}:\d{2}(:\d{2})?(\s+[AP]M)?)?$/i;
	ts.regex.usLongDateTest2 = /^\d{1,2}\s+[A-Z]{3,10}\s+\d{4}/i;
	ts.addParser({
		id : 'usLongDate',
		is : function( str ) {
			// two digit years are not allowed cross-browser
			// Jan 01, 2013 12:34:56 PM or 01 Jan 2013
			return ts.regex.usLongDateTest1.test( str ) || ts.regex.usLongDateTest2.test( str );
		},
		format : function( str ) {
			var date = str ? new Date( str.replace( ts.regex.dateReplace, '$1 $2' ) ) : str;
			return date instanceof Date && isFinite( date ) ? date.getTime() : str;
		},
		type : 'numeric'
	});

	// testing for ##-##-#### or ####-##-##, so it's not perfect; time can be included
	ts.regex.shortDateTest = /(^\d{1,2}[\/\s]\d{1,2}[\/\s]\d{4})|(^\d{4}[\/\s]\d{1,2}[\/\s]\d{1,2})/;
	// escaped "-" because JSHint in Firefox was showing it as an error
	ts.regex.shortDateReplace = /[\-.,]/g;
	// XXY covers MDY & DMY formats
	ts.regex.shortDateXXY = /(\d{1,2})[\/\s](\d{1,2})[\/\s](\d{4})/;
	ts.regex.shortDateYMD = /(\d{4})[\/\s](\d{1,2})[\/\s](\d{1,2})/;
	ts.convertFormat = function( dateString, format ) {
		dateString = ( dateString || '' )
			.replace( ts.regex.spaces, ' ' )
			.replace( ts.regex.shortDateReplace, '/' );
		if ( format === 'mmddyyyy' ) {
			dateString = dateString.replace( ts.regex.shortDateXXY, '$3/$1/$2' );
		} else if ( format === 'ddmmyyyy' ) {
			dateString = dateString.replace( ts.regex.shortDateXXY, '$3/$2/$1' );
		} else if ( format === 'yyyymmdd' ) {
			dateString = dateString.replace( ts.regex.shortDateYMD, '$1/$2/$3' );
		}
		var date = new Date( dateString );
		return date instanceof Date && isFinite( date ) ? date.getTime() : '';
	};

	ts.addParser({
		id : 'shortDate', // 'mmddyyyy', 'ddmmyyyy' or 'yyyymmdd'
		is : function( str ) {
			str = ( str || '' ).replace( ts.regex.spaces, ' ' ).replace( ts.regex.shortDateReplace, '/' );
			return ts.regex.shortDateTest.test( str );
		},
		format : function( str, table, cell, cellIndex ) {
			if ( str ) {
				var c = table.config,
					$header = c.$headerIndexed[ cellIndex ],
					format = $header.length && $header.data( 'dateFormat' ) ||
						ts.getData( $header, ts.getColumnData( table, c.headers, cellIndex ), 'dateFormat' ) ||
						c.dateFormat;
				// save format because getData can be slow...
				if ( $header.length ) {
					$header.data( 'dateFormat', format );
				}
				return ts.convertFormat( str, format ) || str;
			}
			return str;
		},
		type : 'numeric'
	});

	// match 24 hour time & 12 hours time + am/pm - see http://regexr.com/3c3tk
	ts.regex.timeTest = /^(0?[1-9]|1[0-2]):([0-5]\d)(\s[AP]M)$|^((?:[01]\d|[2][0-4]):[0-5]\d)$/i;
	ts.regex.timeMatch = /(0?[1-9]|1[0-2]):([0-5]\d)(\s[AP]M)|((?:[01]\d|[2][0-4]):[0-5]\d)/i;
	ts.addParser({
		id : 'time',
		is : function( str ) {
			return ts.regex.timeTest.test( str );
		},
		format : function( str ) {
			// isolate time... ignore month, day and year
			var temp,
				timePart = ( str || '' ).match( ts.regex.timeMatch ),
				orig = new Date( str ),
				// no time component? default to 00:00 by leaving it out, but only if str is defined
				time = str && ( timePart !== null ? timePart[ 0 ] : '00:00 AM' ),
				date = time ? new Date( '2000/01/01 ' + time.replace( ts.regex.dateReplace, '$1 $2' ) ) : time;
			if ( date instanceof Date && isFinite( date ) ) {
				temp = orig instanceof Date && isFinite( orig ) ? orig.getTime() : 0;
				// if original string was a valid date, add it to the decimal so the column sorts in some kind of order
				// luckily new Date() ignores the decimals
				return temp ? parseFloat( date.getTime() + '.' + orig.getTime() ) : date.getTime();
			}
			return str;
		},
		type : 'numeric'
	});

	ts.addParser({
		id : 'metadata',
		is : function() {
			return false;
		},
		format : function( str, table, cell ) {
			var c = table.config,
			p = ( !c.parserMetadataName ) ? 'sortValue' : c.parserMetadataName;
			return $( cell ).metadata()[ p ];
		},
		type : 'numeric'
	});

	/*
		██████ ██████ █████▄ █████▄ ▄████▄
		  ▄█▀  ██▄▄   ██▄▄██ ██▄▄██ ██▄▄██
		▄█▀    ██▀▀   ██▀▀██ ██▀▀█  ██▀▀██
		██████ ██████ █████▀ ██  ██ ██  ██
		*/
	// add default widgets
	ts.addWidget({
		id : 'zebra',
		priority : 90,
		format : function( table, c, wo ) {
			var $visibleRows, $row, count, isEven, tbodyIndex, rowIndex, len,
				child = new RegExp( c.cssChildRow, 'i' ),
				$tbodies = c.$tbodies.add( $( c.namespace + '_extra_table' ).children( 'tbody:not(.' + c.cssInfoBlock + ')' ) );
			for ( tbodyIndex = 0; tbodyIndex < $tbodies.length; tbodyIndex++ ) {
				// loop through the visible rows
				count = 0;
				$visibleRows = $tbodies.eq( tbodyIndex ).children( 'tr:visible' ).not( c.selectorRemove );
				len = $visibleRows.length;
				for ( rowIndex = 0; rowIndex < len; rowIndex++ ) {
					$row = $visibleRows.eq( rowIndex );
					// style child rows the same way the parent row was styled
					if ( !child.test( $row[ 0 ].className ) ) { count++; }
					isEven = ( count % 2 === 0 );
					$row
						.removeClass( wo.zebra[ isEven ? 1 : 0 ] )
						.addClass( wo.zebra[ isEven ? 0 : 1 ] );
				}
			}
		},
		remove : function( table, c, wo, refreshing ) {
			if ( refreshing ) { return; }
			var tbodyIndex, $tbody,
				$tbodies = c.$tbodies,
				toRemove = ( wo.zebra || [ 'even', 'odd' ] ).join( ' ' );
			for ( tbodyIndex = 0; tbodyIndex < $tbodies.length; tbodyIndex++ ) {
				$tbody = ts.processTbody( table, $tbodies.eq( tbodyIndex ), true ); // remove tbody
				$tbody.children().removeClass( toRemove );
				ts.processTbody( table, $tbody, false ); // restore tbody
			}
		}
	});

})( jQuery );
return jQuery.tablesorter;}));


/* -------------------------------------------------------------------------------------------------- */
/* jquery-tablesorter-widgets.js */
/* File: js/machinata-core-bundle.js/jquery-tablesorter-widgets.js */
/* -------------------------------------------------------------------------------------------------- */

/*! tablesorter (FORK) - updated 2020-03-03 (v2.31.3)*/
/* Includes widgets ( storage,uitheme,columns,filter,stickyHeaders,resizable,saveSort ) */
(function(factory){if (typeof define === 'function' && define.amd){define(['jquery'], factory);} else if (false /* Note: CommonJS loader automatically stripped by Machinata reactjs profile: typeof module === 'object' && typeof module.exports === 'object' */){module.exports = factory(require('jquery'));} else {factory(jQuery);}}(function(jQuery) {
/*! Widget: storage - updated 2018-03-18 (v2.30.0) */
/*global JSON:false */
;(function ($, window, document) {
	'use strict';

	var ts = $.tablesorter || {};

	// update defaults for validator; these values must be falsy!
	$.extend(true, ts.defaults, {
		fixedUrl: '',
		widgetOptions: {
			storage_fixedUrl: '',
			storage_group: '',
			storage_page: '',
			storage_storageType: '',
			storage_tableId: '',
			storage_useSessionStorage: ''
		}
	});

	// *** Store data in local storage, with a cookie fallback ***
	/* IE7 needs JSON library for JSON.stringify - (http://caniuse.com/#search=json)
	   if you need it, then include https://github.com/douglascrockford/JSON-js

	   $.parseJSON is not available is jQuery versions older than 1.4.1, using older
	   versions will only allow storing information for one page at a time

	   // *** Save data (JSON format only) ***
	   // val must be valid JSON... use http://jsonlint.com/ to ensure it is valid
	   var val = { "mywidget" : "data1" }; // valid JSON uses double quotes
	   // $.tablesorter.storage(table, key, val);
	   $.tablesorter.storage(table, 'tablesorter-mywidget', val);

	   // *** Get data: $.tablesorter.storage(table, key); ***
	   v = $.tablesorter.storage(table, 'tablesorter-mywidget');
	   // val may be empty, so also check for your data
	   val = (v && v.hasOwnProperty('mywidget')) ? v.mywidget : '';
	   alert(val); // 'data1' if saved, or '' if not
	*/
	ts.storage = function(table, key, value, options) {
		table = $(table)[0];
		var cookieIndex, cookies, date,
			hasStorage = false,
			values = {},
			c = table.config,
			wo = c && c.widgetOptions,
			debug = ts.debug(c, 'storage'),
			storageType = (
				( options && options.storageType ) || ( wo && wo.storage_storageType )
			).toString().charAt(0).toLowerCase(),
			// deprecating "useSessionStorage"; any storageType setting overrides it
			session = storageType ? '' :
				( options && options.useSessionStorage ) || ( wo && wo.storage_useSessionStorage ),
			$table = $(table),
			// id from (1) options ID, (2) table 'data-table-group' attribute, (3) widgetOptions.storage_tableId,
			// (4) table ID, then (5) table index
			id = options && options.id ||
				$table.attr( options && options.group || wo && wo.storage_group || 'data-table-group') ||
				wo && wo.storage_tableId || table.id || $('.tablesorter').index( $table ),
			// url from (1) options url, (2) table 'data-table-page' attribute, (3) widgetOptions.storage_fixedUrl,
			// (4) table.config.fixedUrl (deprecated), then (5) window location path
			url = options && options.url ||
				$table.attr(options && options.page || wo && wo.storage_page || 'data-table-page') ||
				wo && wo.storage_fixedUrl || c && c.fixedUrl || window.location.pathname;

		// skip if using cookies
		if (storageType !== 'c') {
			storageType = (storageType === 's' || session) ? 'sessionStorage' : 'localStorage';
			// https://gist.github.com/paulirish/5558557
			if (storageType in window) {
				try {
					window[storageType].setItem('_tmptest', 'temp');
					hasStorage = true;
					window[storageType].removeItem('_tmptest');
				} catch (error) {
					console.warn( storageType + ' is not supported in this browser' );
				}
			}
		}
		if (debug) {
			console.log('Storage >> Using', hasStorage ? storageType : 'cookies');
		}
		// *** get value ***
		if ($.parseJSON) {
			if (hasStorage) {
				values = $.parseJSON( window[storageType][key] || 'null' ) || {};
			} else {
				// old browser, using cookies
				cookies = document.cookie.split(/[;\s|=]/);
				// add one to get from the key to the value
				cookieIndex = $.inArray(key, cookies) + 1;
				values = (cookieIndex !== 0) ? $.parseJSON(cookies[cookieIndex] || 'null') || {} : {};
			}
		}
		// allow value to be an empty string too
		if (typeof value !== 'undefined' && window.JSON && JSON.hasOwnProperty('stringify')) {
			// add unique identifiers = url pathname > table ID/index on page > data
			if (!values[url]) {
				values[url] = {};
			}
			values[url][id] = value;
			// *** set value ***
			if (hasStorage) {
				window[storageType][key] = JSON.stringify(values);
			} else {
				date = new Date();
				date.setTime(date.getTime() + (31536e+6)); // 365 days
				document.cookie = key + '=' + (JSON.stringify(values)).replace(/\"/g, '\"') + '; expires=' + date.toGMTString() + '; path=/';
			}
		} else {
			return values && values[url] ? values[url][id] : '';
		}
	};

})(jQuery, window, document);

/*! Widget: uitheme - updated 2018-03-18 (v2.30.0) */
;(function ($) {
	'use strict';
	var ts = $.tablesorter || {};

	ts.themes = {
		'bootstrap' : {
			table        : 'table table-bordered table-striped',
			caption      : 'caption',
			// header class names
			header       : 'bootstrap-header', // give the header a gradient background (theme.bootstrap_2.css)
			sortNone     : '',
			sortAsc      : '',
			sortDesc     : '',
			active       : '', // applied when column is sorted
			hover        : '', // custom css required - a defined bootstrap style may not override other classes
			// icon class names
			icons        : '', // add 'bootstrap-icon-white' to make them white; this icon class is added to the <i> in the header
			iconSortNone : 'bootstrap-icon-unsorted', // class name added to icon when column is not sorted
			iconSortAsc  : 'glyphicon glyphicon-chevron-up', // class name added to icon when column has ascending sort
			iconSortDesc : 'glyphicon glyphicon-chevron-down', // class name added to icon when column has descending sort
			filterRow    : '', // filter row class
			footerRow    : '',
			footerCells  : '',
			even         : '', // even row zebra striping
			odd          : ''  // odd row zebra striping
		},
		'jui' : {
			table        : 'ui-widget ui-widget-content ui-corner-all', // table classes
			caption      : 'ui-widget-content',
			// header class names
			header       : 'ui-widget-header ui-corner-all ui-state-default', // header classes
			sortNone     : '',
			sortAsc      : '',
			sortDesc     : '',
			active       : 'ui-state-active', // applied when column is sorted
			hover        : 'ui-state-hover',  // hover class
			// icon class names
			icons        : 'ui-icon', // icon class added to the <i> in the header
			iconSortNone : 'ui-icon-carat-2-n-s ui-icon-caret-2-n-s', // class name added to icon when column is not sorted
			iconSortAsc  : 'ui-icon-carat-1-n ui-icon-caret-1-n', // class name added to icon when column has ascending sort
			iconSortDesc : 'ui-icon-carat-1-s ui-icon-caret-1-s', // class name added to icon when column has descending sort
			filterRow    : '',
			footerRow    : '',
			footerCells  : '',
			even         : 'ui-widget-content', // even row zebra striping
			odd          : 'ui-state-default'   // odd row zebra striping
		}
	};

	$.extend(ts.css, {
		wrapper : 'tablesorter-wrapper' // ui theme & resizable
	});

	ts.addWidget({
		id: 'uitheme',
		priority: 10,
		format: function(table, c, wo) {
			var i, tmp, hdr, icon, time, $header, $icon, $tfoot, $h, oldtheme, oldremove, oldIconRmv, hasOldTheme,
				themesAll = ts.themes,
				$table = c.$table.add( $( c.namespace + '_extra_table' ) ),
				$headers = c.$headers.add( $( c.namespace + '_extra_headers' ) ),
				theme = c.theme || 'jui',
				themes = themesAll[theme] || {},
				remove = $.trim( [ themes.sortNone, themes.sortDesc, themes.sortAsc, themes.active ].join( ' ' ) ),
				iconRmv = $.trim( [ themes.iconSortNone, themes.iconSortDesc, themes.iconSortAsc ].join( ' ' ) ),
				debug = ts.debug(c, 'uitheme');
			if (debug) { time = new Date(); }
			// initialization code - run once
			if (!$table.hasClass('tablesorter-' + theme) || c.theme !== c.appliedTheme || !wo.uitheme_applied) {
				wo.uitheme_applied = true;
				oldtheme = themesAll[c.appliedTheme] || {};
				hasOldTheme = !$.isEmptyObject(oldtheme);
				oldremove =  hasOldTheme ? [ oldtheme.sortNone, oldtheme.sortDesc, oldtheme.sortAsc, oldtheme.active ].join( ' ' ) : '';
				oldIconRmv = hasOldTheme ? [ oldtheme.iconSortNone, oldtheme.iconSortDesc, oldtheme.iconSortAsc ].join( ' ' ) : '';
				if (hasOldTheme) {
					wo.zebra[0] = $.trim( ' ' + wo.zebra[0].replace(' ' + oldtheme.even, '') );
					wo.zebra[1] = $.trim( ' ' + wo.zebra[1].replace(' ' + oldtheme.odd, '') );
					c.$tbodies.children().removeClass( [ oldtheme.even, oldtheme.odd ].join(' ') );
				}
				// update zebra stripes
				if (themes.even) { wo.zebra[0] += ' ' + themes.even; }
				if (themes.odd) { wo.zebra[1] += ' ' + themes.odd; }
				// add caption style
				$table.children('caption')
					.removeClass(oldtheme.caption || '')
					.addClass(themes.caption);
				// add table/footer class names
				$tfoot = $table
					// remove other selected themes
					.removeClass( (c.appliedTheme ? 'tablesorter-' + (c.appliedTheme || '') : '') + ' ' + (oldtheme.table || '') )
					.addClass('tablesorter-' + theme + ' ' + (themes.table || '')) // add theme widget class name
					.children('tfoot');
				c.appliedTheme = c.theme;

				if ($tfoot.length) {
					$tfoot
						// if oldtheme.footerRow or oldtheme.footerCells are undefined, all class names are removed
						.children('tr').removeClass(oldtheme.footerRow || '').addClass(themes.footerRow)
						.children('th, td').removeClass(oldtheme.footerCells || '').addClass(themes.footerCells);
				}
				// update header classes
				$headers
					.removeClass( (hasOldTheme ? [ oldtheme.header, oldtheme.hover, oldremove ].join(' ') : '') || '' )
					.addClass(themes.header)
					.not('.sorter-false')
					.unbind('mouseenter.tsuitheme mouseleave.tsuitheme')
					.bind('mouseenter.tsuitheme mouseleave.tsuitheme', function(event) {
						// toggleClass with switch added in jQuery 1.3
						$(this)[ event.type === 'mouseenter' ? 'addClass' : 'removeClass' ](themes.hover || '');
					});

				$headers.each(function() {
					var $this = $(this);
					if (!$this.find('.' + ts.css.wrapper).length) {
						// Firefox needs this inner div to position the icon & resizer correctly
						$this.wrapInner('<div class="' + ts.css.wrapper + '" style="position:relative;height:100%;width:100%"></div>');
					}
				});
				if (c.cssIcon) {
					// if c.cssIcon is '', then no <i> is added to the header
					$headers
						.find('.' + ts.css.icon)
						.removeClass(hasOldTheme ? [ oldtheme.icons, oldIconRmv ].join(' ') : '')
						.addClass(themes.icons || '');
				}
				// filter widget initializes after uitheme
				if (ts.hasWidget( c.table, 'filter' )) {
					tmp = function() {
						$table.children('thead').children('.' + ts.css.filterRow)
							.removeClass(hasOldTheme ? oldtheme.filterRow || '' : '')
							.addClass(themes.filterRow || '');
					};
					if (wo.filter_initialized) {
						tmp();
					} else {
						$table.one('filterInit', function() {
							tmp();
						});
					}
				}
			}
			for (i = 0; i < c.columns; i++) {
				$header = c.$headers
					.add($(c.namespace + '_extra_headers'))
					.not('.sorter-false')
					.filter('[data-column="' + i + '"]');
				$icon = (ts.css.icon) ? $header.find('.' + ts.css.icon) : $();
				$h = $headers.not('.sorter-false').filter('[data-column="' + i + '"]:last');
				if ($h.length) {
					$header.removeClass(remove);
					$icon.removeClass(iconRmv);
					if ($h[0].sortDisabled) {
						// no sort arrows for disabled columns!
						$icon.removeClass(themes.icons || '');
					} else {
						hdr = themes.sortNone;
						icon = themes.iconSortNone;
						if ($h.hasClass(ts.css.sortAsc)) {
							hdr = [ themes.sortAsc, themes.active ].join(' ');
							icon = themes.iconSortAsc;
						} else if ($h.hasClass(ts.css.sortDesc)) {
							hdr = [ themes.sortDesc, themes.active ].join(' ');
							icon = themes.iconSortDesc;
						}
						$header.addClass(hdr);
						$icon.addClass(icon || '');
					}
				}
			}
			if (debug) {
				console.log('uitheme >> Applied ' + theme + ' theme' + ts.benchmark(time));
			}
		},
		remove: function(table, c, wo, refreshing) {
			if (!wo.uitheme_applied) { return; }
			var $table = c.$table,
				theme = c.appliedTheme || 'jui',
				themes = ts.themes[ theme ] || ts.themes.jui,
				$headers = $table.children('thead').children(),
				remove = themes.sortNone + ' ' + themes.sortDesc + ' ' + themes.sortAsc,
				iconRmv = themes.iconSortNone + ' ' + themes.iconSortDesc + ' ' + themes.iconSortAsc;
			$table.removeClass('tablesorter-' + theme + ' ' + themes.table);
			wo.uitheme_applied = false;
			if (refreshing) { return; }
			$table.find(ts.css.header).removeClass(themes.header);
			$headers
				.unbind('mouseenter.tsuitheme mouseleave.tsuitheme') // remove hover
				.removeClass(themes.hover + ' ' + remove + ' ' + themes.active)
				.filter('.' + ts.css.filterRow)
				.removeClass(themes.filterRow);
			$headers.find('.' + ts.css.icon).removeClass(themes.icons + ' ' + iconRmv);
		}
	});

})(jQuery);

/*! Widget: columns - updated 5/24/2017 (v2.28.11) */
;(function ($) {
	'use strict';
	var ts = $.tablesorter || {};

	ts.addWidget({
		id: 'columns',
		priority: 65,
		options : {
			columns : [ 'primary', 'secondary', 'tertiary' ]
		},
		format: function(table, c, wo) {
			var $tbody, tbodyIndex, $rows, rows, $row, $cells, remove, indx,
			$table = c.$table,
			$tbodies = c.$tbodies,
			sortList = c.sortList,
			len = sortList.length,
			// removed c.widgetColumns support
			css = wo && wo.columns || [ 'primary', 'secondary', 'tertiary' ],
			last = css.length - 1;
			remove = css.join(' ');
			// check if there is a sort (on initialization there may not be one)
			for (tbodyIndex = 0; tbodyIndex < $tbodies.length; tbodyIndex++ ) {
				$tbody = ts.processTbody(table, $tbodies.eq(tbodyIndex), true); // detach tbody
				$rows = $tbody.children('tr');
				// loop through the visible rows
				$rows.each(function() {
					$row = $(this);
					if (this.style.display !== 'none') {
						// remove all columns class names
						$cells = $row.children().removeClass(remove);
						// add appropriate column class names
						if (sortList && sortList[0]) {
							// primary sort column class
							$cells.eq(sortList[0][0]).addClass(css[0]);
							if (len > 1) {
								for (indx = 1; indx < len; indx++) {
									// secondary, tertiary, etc sort column classes
									$cells.eq(sortList[indx][0]).addClass( css[indx] || css[last] );
								}
							}
						}
					}
				});
				ts.processTbody(table, $tbody, false);
			}
			// add classes to thead and tfoot
			rows = wo.columns_thead !== false ? [ 'thead tr' ] : [];
			if (wo.columns_tfoot !== false) {
				rows.push('tfoot tr');
			}
			if (rows.length) {
				$rows = $table.find( rows.join(',') ).children().removeClass(remove);
				if (len) {
					for (indx = 0; indx < len; indx++) {
						// add primary. secondary, tertiary, etc sort column classes
						$rows.filter('[data-column="' + sortList[indx][0] + '"]').addClass(css[indx] || css[last]);
					}
				}
			}
		},
		remove: function(table, c, wo) {
			var tbodyIndex, $tbody,
				$tbodies = c.$tbodies,
				remove = (wo.columns || [ 'primary', 'secondary', 'tertiary' ]).join(' ');
			c.$headers.removeClass(remove);
			c.$table.children('tfoot').children('tr').children('th, td').removeClass(remove);
			for (tbodyIndex = 0; tbodyIndex < $tbodies.length; tbodyIndex++ ) {
				$tbody = ts.processTbody(table, $tbodies.eq(tbodyIndex), true); // remove tbody
				$tbody.children('tr').each(function() {
					$(this).children().removeClass(remove);
				});
				ts.processTbody(table, $tbody, false); // restore tbody
			}
		}
	});

})(jQuery);

/*! Widget: filter - updated 2018-03-18 (v2.30.0) *//*
 * Requires tablesorter v2.8+ and jQuery 1.7+
 * by Rob Garrison
 */
;( function ( $ ) {
	'use strict';
	var tsf, tsfRegex,
		ts = $.tablesorter || {},
		tscss = ts.css,
		tskeyCodes = ts.keyCodes;

	$.extend( tscss, {
		filterRow      : 'tablesorter-filter-row',
		filter         : 'tablesorter-filter',
		filterDisabled : 'disabled',
		filterRowHide  : 'hideme'
	});

	$.extend( tskeyCodes, {
		backSpace : 8,
		escape : 27,
		space : 32,
		left : 37,
		down : 40
	});

	ts.addWidget({
		id: 'filter',
		priority: 50,
		options : {
			filter_cellFilter    : '',    // css class name added to the filter cell ( string or array )
			filter_childRows     : false, // if true, filter includes child row content in the search
			filter_childByColumn : false, // ( filter_childRows must be true ) if true = search child rows by column; false = search all child row text grouped
			filter_childWithSibs : true,  // if true, include matching child row siblings
			filter_columnAnyMatch: true,  // if true, allows using '#:{query}' in AnyMatch searches ( column:query )
			filter_columnFilters : true,  // if true, a filter will be added to the top of each table column
			filter_cssFilter     : '',    // css class name added to the filter row & each input in the row ( tablesorter-filter is ALWAYS added )
			filter_defaultAttrib : 'data-value', // data attribute in the header cell that contains the default filter value
			filter_defaultFilter : {},    // add a default column filter type '~{query}' to make fuzzy searches default; '{q1} AND {q2}' to make all searches use a logical AND.
			filter_excludeFilter : {},    // filters to exclude, per column
			filter_external      : '',    // jQuery selector string ( or jQuery object ) of external filters
			filter_filteredRow   : 'filtered', // class added to filtered rows; define in css with "display:none" to hide the filtered-out rows
			filter_filterLabel   : 'Filter "{{label}}" column by...', // Aria-label added to filter input/select; see #1495
			filter_formatter     : null,  // add custom filter elements to the filter row
			filter_functions     : null,  // add custom filter functions using this option
			filter_hideEmpty     : true,  // hide filter row when table is empty
			filter_hideFilters   : false, // collapse filter row when mouse leaves the area
			filter_ignoreCase    : true,  // if true, make all searches case-insensitive
			filter_liveSearch    : true,  // if true, search column content while the user types ( with a delay )
			filter_matchType     : { 'input': 'exact', 'select': 'exact' }, // global query settings ('exact' or 'match'); overridden by "filter-match" or "filter-exact" class
			filter_onlyAvail     : 'filter-onlyAvail', // a header with a select dropdown & this class name will only show available ( visible ) options within the drop down
			filter_placeholder   : { search : '', select : '' }, // default placeholder text ( overridden by any header 'data-placeholder' setting )
			filter_reset         : null,  // jQuery selector string of an element used to reset the filters
			filter_resetOnEsc    : true,  // Reset filter input when the user presses escape - normalized across browsers
			filter_saveFilters   : false, // Use the $.tablesorter.storage utility to save the most recent filters
			filter_searchDelay   : 300,   // typing delay in milliseconds before starting a search
			filter_searchFiltered: true,  // allow searching through already filtered rows in special circumstances; will speed up searching in large tables if true
			filter_selectSource  : null,  // include a function to return an array of values to be added to the column filter select
			filter_selectSourceSeparator : '|', // filter_selectSource array text left of the separator is added to the option value, right into the option text
			filter_serversideFiltering : false, // if true, must perform server-side filtering b/c client-side filtering is disabled, but the ui and events will still be used.
			filter_startsWith    : false, // if true, filter start from the beginning of the cell contents
			filter_useParsedData : false  // filter all data using parsed content
		},
		format: function( table, c, wo ) {
			if ( !c.$table.hasClass( 'hasFilters' ) ) {
				tsf.init( table, c, wo );
			}
		},
		remove: function( table, c, wo, refreshing ) {
			var tbodyIndex, $tbody,
				$table = c.$table,
				$tbodies = c.$tbodies,
				events = (
					'addRows updateCell update updateRows updateComplete appendCache filterReset ' +
					'filterAndSortReset filterFomatterUpdate filterEnd search stickyHeadersInit '
				).split( ' ' ).join( c.namespace + 'filter ' );
			$table
				.removeClass( 'hasFilters' )
				// add filter namespace to all BUT search
				.unbind( events.replace( ts.regex.spaces, ' ' ) )
				// remove the filter row even if refreshing, because the column might have been moved
				.find( '.' + tscss.filterRow ).remove();
			wo.filter_initialized = false;
			if ( refreshing ) { return; }
			for ( tbodyIndex = 0; tbodyIndex < $tbodies.length; tbodyIndex++ ) {
				$tbody = ts.processTbody( table, $tbodies.eq( tbodyIndex ), true ); // remove tbody
				$tbody.children().removeClass( wo.filter_filteredRow ).show();
				ts.processTbody( table, $tbody, false ); // restore tbody
			}
			if ( wo.filter_reset ) {
				$( document ).undelegate( wo.filter_reset, 'click' + c.namespace + 'filter' );
			}
		}
	});

	tsf = ts.filter = {

		// regex used in filter 'check' functions - not for general use and not documented
		regex: {
			regex     : /^\/((?:\\\/|[^\/])+)\/([migyu]{0,5})?$/, // regex to test for regex
			child     : /tablesorter-childRow/, // child row class name; this gets updated in the script
			filtered  : /filtered/, // filtered (hidden) row class name; updated in the script
			type      : /undefined|number/, // check type
			exact     : /(^[\"\'=]+)|([\"\'=]+$)/g, // exact match (allow '==')
			operators : /[<>=]/g, // replace operators
			query     : '(q|query)', // replace filter queries
			wild01    : /\?/g, // wild card match 0 or 1
			wild0More : /\*/g, // wild care match 0 or more
			quote     : /\"/g,
			isNeg1    : /(>=?\s*-\d)/,
			isNeg2    : /(<=?\s*\d)/
		},
		// function( c, data ) { }
		// c = table.config
		// data.$row = jQuery object of the row currently being processed
		// data.$cells = jQuery object of all cells within the current row
		// data.filters = array of filters for all columns ( some may be undefined )
		// data.filter = filter for the current column
		// data.iFilter = same as data.filter, except lowercase ( if wo.filter_ignoreCase is true )
		// data.exact = table cell text ( or parsed data if column parser enabled; may be a number & not a string )
		// data.iExact = same as data.exact, except lowercase ( if wo.filter_ignoreCase is true; may be a number & not a string )
		// data.cache = table cell text from cache, so it has been parsed ( & in all lower case if c.ignoreCase is true )
		// data.cacheArray = An array of parsed content from each table cell in the row being processed
		// data.index = column index; table = table element ( DOM )
		// data.parsed = array ( by column ) of boolean values ( from filter_useParsedData or 'filter-parsed' class )
		types: {
			or : function( c, data, vars ) {
				// look for "|", but not if it is inside of a regular expression
				if ( ( tsfRegex.orTest.test( data.iFilter ) || tsfRegex.orSplit.test( data.filter ) ) &&
					// this test for regex has potential to slow down the overall search
					!tsfRegex.regex.test( data.filter ) ) {
					var indx, filterMatched, query, regex,
						// duplicate data but split filter
						data2 = $.extend( {}, data ),
						filter = data.filter.split( tsfRegex.orSplit ),
						iFilter = data.iFilter.split( tsfRegex.orSplit ),
						len = filter.length;
					for ( indx = 0; indx < len; indx++ ) {
						data2.nestedFilters = true;
						data2.filter = '' + ( tsf.parseFilter( c, filter[ indx ], data ) || '' );
						data2.iFilter = '' + ( tsf.parseFilter( c, iFilter[ indx ], data ) || '' );
						query = '(' + ( tsf.parseFilter( c, data2.filter, data ) || '' ) + ')';
						try {
							// use try/catch, because query may not be a valid regex if "|" is contained within a partial regex search,
							// e.g "/(Alex|Aar" -> Uncaught SyntaxError: Invalid regular expression: /(/(Alex)/: Unterminated group
							regex = new RegExp( data.isMatch ? query : '^' + query + '$', c.widgetOptions.filter_ignoreCase ? 'i' : '' );
							// filterMatched = data2.filter === '' && indx > 0 ? true
							// look for an exact match with the 'or' unless the 'filter-match' class is found
							filterMatched = regex.test( data2.exact ) || tsf.processTypes( c, data2, vars );
							if ( filterMatched ) {
								return filterMatched;
							}
						} catch ( error ) {
							return null;
						}
					}
					// may be null from processing types
					return filterMatched || false;
				}
				return null;
			},
			// Look for an AND or && operator ( logical and )
			and : function( c, data, vars ) {
				if ( tsfRegex.andTest.test( data.filter ) ) {
					var indx, filterMatched, result, query, regex,
						// duplicate data but split filter
						data2 = $.extend( {}, data ),
						filter = data.filter.split( tsfRegex.andSplit ),
						iFilter = data.iFilter.split( tsfRegex.andSplit ),
						len = filter.length;
					for ( indx = 0; indx < len; indx++ ) {
						data2.nestedFilters = true;
						data2.filter = '' + ( tsf.parseFilter( c, filter[ indx ], data ) || '' );
						data2.iFilter = '' + ( tsf.parseFilter( c, iFilter[ indx ], data ) || '' );
						query = ( '(' + ( tsf.parseFilter( c, data2.filter, data ) || '' ) + ')' )
							// replace wild cards since /(a*)/i will match anything
							.replace( tsfRegex.wild01, '\\S{1}' ).replace( tsfRegex.wild0More, '\\S*' );
						try {
							// use try/catch just in case RegExp is invalid
							regex = new RegExp( data.isMatch ? query : '^' + query + '$', c.widgetOptions.filter_ignoreCase ? 'i' : '' );
							// look for an exact match with the 'and' unless the 'filter-match' class is found
							result = ( regex.test( data2.exact ) || tsf.processTypes( c, data2, vars ) );
							if ( indx === 0 ) {
								filterMatched = result;
							} else {
								filterMatched = filterMatched && result;
							}
						} catch ( error ) {
							return null;
						}
					}
					// may be null from processing types
					return filterMatched || false;
				}
				return null;
			},
			// Look for regex
			regex: function( c, data ) {
				if ( tsfRegex.regex.test( data.filter ) ) {
					var matches,
						// cache regex per column for optimal speed
						regex = data.filter_regexCache[ data.index ] || tsfRegex.regex.exec( data.filter ),
						isRegex = regex instanceof RegExp;
					try {
						if ( !isRegex ) {
							// force case insensitive search if ignoreCase option set?
							// if ( c.ignoreCase && !regex[2] ) { regex[2] = 'i'; }
							data.filter_regexCache[ data.index ] = regex = new RegExp( regex[1], regex[2] );
						}
						matches = regex.test( data.exact );
					} catch ( error ) {
						matches = false;
					}
					return matches;
				}
				return null;
			},
			// Look for operators >, >=, < or <=
			operators: function( c, data ) {
				// ignore empty strings... because '' < 10 is true
				if ( tsfRegex.operTest.test( data.iFilter ) && data.iExact !== '' ) {
					var cachedValue, result, txt,
						table = c.table,
						parsed = data.parsed[ data.index ],
						query = ts.formatFloat( data.iFilter.replace( tsfRegex.operators, '' ), table ),
						parser = c.parsers[ data.index ] || {},
						savedSearch = query;
					// parse filter value in case we're comparing numbers ( dates )
					if ( parsed || parser.type === 'numeric' ) {
						txt = $.trim( '' + data.iFilter.replace( tsfRegex.operators, '' ) );
						result = tsf.parseFilter( c, txt, data, true );
						query = ( typeof result === 'number' && result !== '' && !isNaN( result ) ) ? result : query;
					}
					// iExact may be numeric - see issue #149;
					// check if cached is defined, because sometimes j goes out of range? ( numeric columns )
					if ( ( parsed || parser.type === 'numeric' ) && !isNaN( query ) &&
						typeof data.cache !== 'undefined' ) {
						cachedValue = data.cache;
					} else {
						txt = isNaN( data.iExact ) ? data.iExact.replace( ts.regex.nondigit, '' ) : data.iExact;
						cachedValue = ts.formatFloat( txt, table );
					}
					if ( tsfRegex.gtTest.test( data.iFilter ) ) {
						result = tsfRegex.gteTest.test( data.iFilter ) ? cachedValue >= query : cachedValue > query;
					} else if ( tsfRegex.ltTest.test( data.iFilter ) ) {
						result = tsfRegex.lteTest.test( data.iFilter ) ? cachedValue <= query : cachedValue < query;
					}
					// keep showing all rows if nothing follows the operator
					if ( !result && savedSearch === '' ) {
						result = true;
					}
					return result;
				}
				return null;
			},
			// Look for a not match
			notMatch: function( c, data ) {
				if ( tsfRegex.notTest.test( data.iFilter ) ) {
					var indx,
						txt = data.iFilter.replace( '!', '' ),
						filter = tsf.parseFilter( c, txt, data ) || '';
					if ( tsfRegex.exact.test( filter ) ) {
						// look for exact not matches - see #628
						filter = filter.replace( tsfRegex.exact, '' );
						return filter === '' ? true : $.trim( filter ) !== data.iExact;
					} else {
						indx = data.iExact.search( $.trim( filter ) );
						return filter === '' ? true :
							// return true if not found
							data.anyMatch ? indx < 0 :
							// return false if found
							!( c.widgetOptions.filter_startsWith ? indx === 0 : indx >= 0 );
					}
				}
				return null;
			},
			// Look for quotes or equals to get an exact match; ignore type since iExact could be numeric
			exact: function( c, data ) {
				/*jshint eqeqeq:false */
				if ( tsfRegex.exact.test( data.iFilter ) ) {
					var txt = data.iFilter.replace( tsfRegex.exact, '' ),
						filter = tsf.parseFilter( c, txt, data ) || '';
					// eslint-disable-next-line eqeqeq
					return data.anyMatch ? $.inArray( filter, data.rowArray ) >= 0 : filter == data.iExact;
				}
				return null;
			},
			// Look for a range ( using ' to ' or ' - ' ) - see issue #166; thanks matzhu!
			range : function( c, data ) {
				if ( tsfRegex.toTest.test( data.iFilter ) ) {
					var result, tmp, range1, range2,
						table = c.table,
						index = data.index,
						parsed = data.parsed[index],
						// make sure the dash is for a range and not indicating a negative number
						query = data.iFilter.split( tsfRegex.toSplit );

					tmp = query[0].replace( ts.regex.nondigit, '' ) || '';
					range1 = ts.formatFloat( tsf.parseFilter( c, tmp, data ), table );
					tmp = query[1].replace( ts.regex.nondigit, '' ) || '';
					range2 = ts.formatFloat( tsf.parseFilter( c, tmp, data ), table );
					// parse filter value in case we're comparing numbers ( dates )
					if ( parsed || c.parsers[ index ].type === 'numeric' ) {
						result = c.parsers[ index ].format( '' + query[0], table, c.$headers.eq( index ), index );
						range1 = ( result !== '' && !isNaN( result ) ) ? result : range1;
						result = c.parsers[ index ].format( '' + query[1], table, c.$headers.eq( index ), index );
						range2 = ( result !== '' && !isNaN( result ) ) ? result : range2;
					}
					if ( ( parsed || c.parsers[ index ].type === 'numeric' ) && !isNaN( range1 ) && !isNaN( range2 ) ) {
						result = data.cache;
					} else {
						tmp = isNaN( data.iExact ) ? data.iExact.replace( ts.regex.nondigit, '' ) : data.iExact;
						result = ts.formatFloat( tmp, table );
					}
					if ( range1 > range2 ) {
						tmp = range1; range1 = range2; range2 = tmp; // swap
					}
					return ( result >= range1 && result <= range2 ) || ( range1 === '' || range2 === '' );
				}
				return null;
			},
			// Look for wild card: ? = single, * = multiple, or | = logical OR
			wild : function( c, data ) {
				if ( tsfRegex.wildOrTest.test( data.iFilter ) ) {
					var query = '' + ( tsf.parseFilter( c, data.iFilter, data ) || '' );
					// look for an exact match with the 'or' unless the 'filter-match' class is found
					if ( !tsfRegex.wildTest.test( query ) && data.nestedFilters ) {
						query = data.isMatch ? query : '^(' + query + ')$';
					}
					// parsing the filter may not work properly when using wildcards =/
					try {
						return new RegExp(
							query.replace( tsfRegex.wild01, '\\S{1}' ).replace( tsfRegex.wild0More, '\\S*' ),
							c.widgetOptions.filter_ignoreCase ? 'i' : ''
						)
						.test( data.exact );
					} catch ( error ) {
						return null;
					}
				}
				return null;
			},
			// fuzzy text search; modified from https://github.com/mattyork/fuzzy ( MIT license )
			fuzzy: function( c, data ) {
				if ( tsfRegex.fuzzyTest.test( data.iFilter ) ) {
					var indx,
						patternIndx = 0,
						len = data.iExact.length,
						txt = data.iFilter.slice( 1 ),
						pattern = tsf.parseFilter( c, txt, data ) || '';
					for ( indx = 0; indx < len; indx++ ) {
						if ( data.iExact[ indx ] === pattern[ patternIndx ] ) {
							patternIndx += 1;
						}
					}
					return patternIndx === pattern.length;
				}
				return null;
			}
		},
		init: function( table ) {
			// filter language options
			ts.language = $.extend( true, {}, {
				to  : 'to',
				or  : 'or',
				and : 'and'
			}, ts.language );

			var options, string, txt, $header, column, val, fxn, noSelect,
				c = table.config,
				wo = c.widgetOptions,
				processStr = function(prefix, str, suffix) {
					str = str.trim();
					// don't include prefix/suffix if str is empty
					return str === '' ? '' : (prefix || '') + str + (suffix || '');
				};
			c.$table.addClass( 'hasFilters' );
			c.lastSearch = [];

			// define timers so using clearTimeout won't cause an undefined error
			wo.filter_searchTimer = null;
			wo.filter_initTimer = null;
			wo.filter_formatterCount = 0;
			wo.filter_formatterInit = [];
			wo.filter_anyColumnSelector = '[data-column="all"],[data-column="any"]';
			wo.filter_multipleColumnSelector = '[data-column*="-"],[data-column*=","]';

			val = '\\{' + tsfRegex.query + '\\}';
			$.extend( tsfRegex, {
				child : new RegExp( c.cssChildRow ),
				filtered : new RegExp( wo.filter_filteredRow ),
				alreadyFiltered : new RegExp( '(\\s+(-' + processStr('|', ts.language.or) + processStr('|', ts.language.to) + ')\\s+)', 'i' ),
				toTest : new RegExp( '\\s+(-' + processStr('|', ts.language.to) + ')\\s+', 'i' ),
				toSplit : new RegExp( '(?:\\s+(?:-' + processStr('|', ts.language.to) + ')\\s+)', 'gi' ),
				andTest : new RegExp( '\\s+(' + processStr('', ts.language.and, '|') + '&&)\\s+', 'i' ),
				andSplit : new RegExp( '(?:\\s+(?:' + processStr('', ts.language.and, '|') + '&&)\\s+)', 'gi' ),
				orTest : new RegExp( '(\\|' + processStr('|\\s+', ts.language.or, '\\s+') + ')', 'i' ),
				orSplit : new RegExp( '(?:\\|' + processStr('|\\s+(?:', ts.language.or, ')\\s+') + ')', 'gi' ),
				iQuery : new RegExp( val, 'i' ),
				igQuery : new RegExp( val, 'ig' ),
				operTest : /^[<>]=?/,
				gtTest  : />/,
				gteTest : />=/,
				ltTest  : /</,
				lteTest : /<=/,
				notTest : /^\!/,
				wildOrTest : /[\?\*\|]/,
				wildTest : /\?\*/,
				fuzzyTest : /^~/,
				exactTest : /[=\"\|!]/
			});

			// don't build filter row if columnFilters is false or all columns are set to 'filter-false'
			// see issue #156
			val = c.$headers.filter( '.filter-false, .parser-false' ).length;
			if ( wo.filter_columnFilters !== false && val !== c.$headers.length ) {
				// build filter row
				tsf.buildRow( table, c, wo );
			}

			txt = 'addRows updateCell update updateRows updateComplete appendCache filterReset ' +
				'filterAndSortReset filterResetSaved filterEnd search '.split( ' ' ).join( c.namespace + 'filter ' );
			c.$table.bind( txt, function( event, filter ) {
				val = wo.filter_hideEmpty &&
					$.isEmptyObject( c.cache ) &&
					!( c.delayInit && event.type === 'appendCache' );
				// hide filter row using the 'filtered' class name
				c.$table.find( '.' + tscss.filterRow ).toggleClass( wo.filter_filteredRow, val ); // fixes #450
				if ( !/(search|filter)/.test( event.type ) ) {
					event.stopPropagation();
					tsf.buildDefault( table, true );
				}
				// Add filterAndSortReset - see #1361
				if ( event.type === 'filterReset' || event.type === 'filterAndSortReset' ) {
					c.$table.find( '.' + tscss.filter ).add( wo.filter_$externalFilters ).val( '' );
					if ( event.type === 'filterAndSortReset' ) {
						ts.sortReset( this.config, function() {
							tsf.searching( table, [] );
						});
					} else {
						tsf.searching( table, [] );
					}
				} else if ( event.type === 'filterResetSaved' ) {
					ts.storage( table, 'tablesorter-filters', '' );
				} else if ( event.type === 'filterEnd' ) {
					tsf.buildDefault( table, true );
				} else {
					// send false argument to force a new search; otherwise if the filter hasn't changed,
					// it will return
					filter = event.type === 'search' ? filter :
						event.type === 'updateComplete' ? c.$table.data( 'lastSearch' ) : '';
					if ( /(update|add)/.test( event.type ) && event.type !== 'updateComplete' ) {
						// force a new search since content has changed
						c.lastCombinedFilter = null;
						c.lastSearch = [];
						// update filterFormatters after update (& small delay) - Fixes #1237
						setTimeout(function() {
							c.$table.triggerHandler( 'filterFomatterUpdate' );
						}, 100);
					}
					// pass true ( skipFirst ) to prevent the tablesorter.setFilters function from skipping the first
					// input ensures all inputs are updated when a search is triggered on the table
					// $( 'table' ).trigger( 'search', [...] );
					tsf.searching( table, filter, true );
				}
				return false;
			});

			// reset button/link
			if ( wo.filter_reset ) {
				if ( wo.filter_reset instanceof $ ) {
					// reset contains a jQuery object, bind to it
					wo.filter_reset.click( function() {
						c.$table.triggerHandler( 'filterReset' );
					});
				} else if ( $( wo.filter_reset ).length ) {
					// reset is a jQuery selector, use event delegation
					$( document )
						.undelegate( wo.filter_reset, 'click' + c.namespace + 'filter' )
						.delegate( wo.filter_reset, 'click' + c.namespace + 'filter', function() {
							// trigger a reset event, so other functions ( filter_formatter ) know when to reset
							c.$table.triggerHandler( 'filterReset' );
						});
				}
			}
			if ( wo.filter_functions ) {
				for ( column = 0; column < c.columns; column++ ) {
					fxn = ts.getColumnData( table, wo.filter_functions, column );
					if ( fxn ) {
						// remove 'filter-select' from header otherwise the options added here are replaced with
						// all options
						$header = c.$headerIndexed[ column ].removeClass( 'filter-select' );
						// don't build select if 'filter-false' or 'parser-false' set
						noSelect = !( $header.hasClass( 'filter-false' ) || $header.hasClass( 'parser-false' ) );
						options = '';
						if ( fxn === true && noSelect ) {
							tsf.buildSelect( table, column );
						} else if ( typeof fxn === 'object' && noSelect ) {
							// add custom drop down list
							for ( string in fxn ) {
								if ( typeof string === 'string' ) {
									options += options === '' ?
										'<option value="">' +
											( $header.data( 'placeholder' ) ||
												$header.attr( 'data-placeholder' ) ||
												wo.filter_placeholder.select ||
												''
											) +
										'</option>' : '';
									val = string;
									txt = string;
									if ( string.indexOf( wo.filter_selectSourceSeparator ) >= 0 ) {
										val = string.split( wo.filter_selectSourceSeparator );
										txt = val[1];
										val = val[0];
									}
									options += '<option ' +
										( txt === val ? '' : 'data-function-name="' + string + '" ' ) +
										'value="' + val + '">' + txt + '</option>';
								}
							}
							c.$table
								.find( 'thead' )
								.find( 'select.' + tscss.filter + '[data-column="' + column + '"]' )
								.append( options );
							txt = wo.filter_selectSource;
							fxn = typeof txt === 'function' ? true : ts.getColumnData( table, txt, column );
							if ( fxn ) {
								// updating so the extra options are appended
								tsf.buildSelect( c.table, column, '', true, $header.hasClass( wo.filter_onlyAvail ) );
							}
						}
					}
				}
			}
			// not really updating, but if the column has both the 'filter-select' class &
			// filter_functions set to true, it would append the same options twice.
			tsf.buildDefault( table, true );

			tsf.bindSearch( table, c.$table.find( '.' + tscss.filter ), true );
			if ( wo.filter_external ) {
				tsf.bindSearch( table, wo.filter_external );
			}

			if ( wo.filter_hideFilters ) {
				tsf.hideFilters( c );
			}

			// show processing icon
			if ( c.showProcessing ) {
				txt = 'filterStart filterEnd '.split( ' ' ).join( c.namespace + 'filter-sp ' );
				c.$table
					.unbind( txt.replace( ts.regex.spaces, ' ' ) )
					.bind( txt, function( event, columns ) {
					// only add processing to certain columns to all columns
					$header = ( columns ) ?
						c.$table
							.find( '.' + tscss.header )
							.filter( '[data-column]' )
							.filter( function() {
								return columns[ $( this ).data( 'column' ) ] !== '';
							}) : '';
					ts.isProcessing( table, event.type === 'filterStart', columns ? $header : '' );
				});
			}

			// set filtered rows count ( intially unfiltered )
			c.filteredRows = c.totalRows;

			// add default values
			txt = 'tablesorter-initialized pagerBeforeInitialized '.split( ' ' ).join( c.namespace + 'filter ' );
			c.$table
			.unbind( txt.replace( ts.regex.spaces, ' ' ) )
			.bind( txt, function() {
				tsf.completeInit( this );
			});
			// if filter widget is added after pager has initialized; then set filter init flag
			if ( c.pager && c.pager.initialized && !wo.filter_initialized ) {
				c.$table.triggerHandler( 'filterFomatterUpdate' );
				setTimeout( function() {
					tsf.filterInitComplete( c );
				}, 100 );
			} else if ( !wo.filter_initialized ) {
				tsf.completeInit( table );
			}
		},
		completeInit: function( table ) {
			// redefine 'c' & 'wo' so they update properly inside this callback
			var c = table.config,
				wo = c.widgetOptions,
				filters = tsf.setDefaults( table, c, wo ) || [];
			if ( filters.length ) {
				// prevent delayInit from triggering a cache build if filters are empty
				if ( !( c.delayInit && filters.join( '' ) === '' ) ) {
					ts.setFilters( table, filters, true );
				}
			}
			c.$table.triggerHandler( 'filterFomatterUpdate' );
			// trigger init after setTimeout to prevent multiple filterStart/End/Init triggers
			setTimeout( function() {
				if ( !wo.filter_initialized ) {
					tsf.filterInitComplete( c );
				}
			}, 100 );
		},

		// $cell parameter, but not the config, is passed to the filter_formatters,
		// so we have to work with it instead
		formatterUpdated: function( $cell, column ) {
			// prevent error if $cell is undefined - see #1056
			var $table = $cell && $cell.closest( 'table' );
			var config = $table.length && $table[0].config,
				wo = config && config.widgetOptions;
			if ( wo && !wo.filter_initialized ) {
				// add updates by column since this function
				// may be called numerous times before initialization
				wo.filter_formatterInit[ column ] = 1;
			}
		},
		filterInitComplete: function( c ) {
			var indx, len,
				wo = c.widgetOptions,
				count = 0,
				completed = function() {
					wo.filter_initialized = true;
					// update lastSearch - it gets cleared often
					c.lastSearch = c.$table.data( 'lastSearch' );
					c.$table.triggerHandler( 'filterInit', c );
					tsf.findRows( c.table, c.lastSearch || [] );
					if (ts.debug(c, 'filter')) {
						console.log('Filter >> Widget initialized');
					}
				};
			if ( $.isEmptyObject( wo.filter_formatter ) ) {
				completed();
			} else {
				len = wo.filter_formatterInit.length;
				for ( indx = 0; indx < len; indx++ ) {
					if ( wo.filter_formatterInit[ indx ] === 1 ) {
						count++;
					}
				}
				clearTimeout( wo.filter_initTimer );
				if ( !wo.filter_initialized && count === wo.filter_formatterCount ) {
					// filter widget initialized
					completed();
				} else if ( !wo.filter_initialized ) {
					// fall back in case a filter_formatter doesn't call
					// $.tablesorter.filter.formatterUpdated( $cell, column ), and the count is off
					wo.filter_initTimer = setTimeout( function() {
						completed();
					}, 500 );
				}
			}
		},
		// encode or decode filters for storage; see #1026
		processFilters: function( filters, encode ) {
			var indx,
				// fixes #1237; previously returning an encoded "filters" value
				result = [],
				mode = encode ? encodeURIComponent : decodeURIComponent,
				len = filters.length;
			for ( indx = 0; indx < len; indx++ ) {
				if ( filters[ indx ] ) {
					result[ indx ] = mode( filters[ indx ] );
				}
			}
			return result;
		},
		setDefaults: function( table, c, wo ) {
			var isArray, saved, indx, col, $filters,
				// get current ( default ) filters
				filters = ts.getFilters( table ) || [];
			if ( wo.filter_saveFilters && ts.storage ) {
				saved = ts.storage( table, 'tablesorter-filters' ) || [];
				isArray = $.isArray( saved );
				// make sure we're not just getting an empty array
				if ( !( isArray && saved.join( '' ) === '' || !isArray ) ) {
					filters = tsf.processFilters( saved );
				}
			}
			// if no filters saved, then check default settings
			if ( filters.join( '' ) === '' ) {
				// allow adding default setting to external filters
				$filters = c.$headers.add( wo.filter_$externalFilters )
					.filter( '[' + wo.filter_defaultAttrib + ']' );
				for ( indx = 0; indx <= c.columns; indx++ ) {
					// include data-column='all' external filters
					col = indx === c.columns ? 'all' : indx;
					filters[ indx ] = $filters
						.filter( '[data-column="' + col + '"]' )
						.attr( wo.filter_defaultAttrib ) || filters[indx] || '';
				}
			}
			c.$table.data( 'lastSearch', filters );
			return filters;
		},
		parseFilter: function( c, filter, data, parsed ) {
			return parsed || data.parsed[ data.index ] ?
				c.parsers[ data.index ].format( filter, c.table, [], data.index ) :
				filter;
		},
		buildRow: function( table, c, wo ) {
			var $filter, col, column, $header, makeSelect, disabled, name, ffxn, tmp,
				// c.columns defined in computeThIndexes()
				cellFilter = wo.filter_cellFilter,
				columns = c.columns,
				arry = $.isArray( cellFilter ),
				buildFilter = '<tr role="search" class="' + tscss.filterRow + ' ' + c.cssIgnoreRow + '">';
			for ( column = 0; column < columns; column++ ) {
				if ( c.$headerIndexed[ column ].length ) {
					// account for entire column set with colspan. See #1047
					tmp = c.$headerIndexed[ column ] && c.$headerIndexed[ column ][0].colSpan || 0;
					if ( tmp > 1 ) {
						buildFilter += '<td data-column="' + column + '-' + ( column + tmp - 1 ) + '" colspan="' + tmp + '"';
					} else {
						buildFilter += '<td data-column="' + column + '"';
					}
					if ( arry ) {
						buildFilter += ( cellFilter[ column ] ? ' class="' + cellFilter[ column ] + '"' : '' );
					} else {
						buildFilter += ( cellFilter !== '' ? ' class="' + cellFilter + '"' : '' );
					}
					buildFilter += '></td>';
				}
			}
			c.$filters = $( buildFilter += '</tr>' )
				.appendTo( c.$table.children( 'thead' ).eq( 0 ) )
				.children( 'td' );
			// build each filter input
			for ( column = 0; column < columns; column++ ) {
				disabled = false;
				// assuming last cell of a column is the main column
				$header = c.$headerIndexed[ column ];
				if ( $header && $header.length ) {
					// $filter = c.$filters.filter( '[data-column="' + column + '"]' );
					$filter = tsf.getColumnElm( c, c.$filters, column );
					ffxn = ts.getColumnData( table, wo.filter_functions, column );
					makeSelect = ( wo.filter_functions && ffxn && typeof ffxn !== 'function' ) ||
						$header.hasClass( 'filter-select' );
					// get data from jQuery data, metadata, headers option or header class name
					col = ts.getColumnData( table, c.headers, column );
					disabled = ts.getData( $header[0], col, 'filter' ) === 'false' ||
						ts.getData( $header[0], col, 'parser' ) === 'false';

					if ( makeSelect ) {
						buildFilter = $( '<select>' ).appendTo( $filter );
					} else {
						ffxn = ts.getColumnData( table, wo.filter_formatter, column );
						if ( ffxn ) {
							wo.filter_formatterCount++;
							buildFilter = ffxn( $filter, column );
							// no element returned, so lets go find it
							if ( buildFilter && buildFilter.length === 0 ) {
								buildFilter = $filter.children( 'input' );
							}
							// element not in DOM, so lets attach it
							if ( buildFilter && ( buildFilter.parent().length === 0 ||
								( buildFilter.parent().length && buildFilter.parent()[0] !== $filter[0] ) ) ) {
								$filter.append( buildFilter );
							}
						} else {
							buildFilter = $( '<input type="search">' ).appendTo( $filter );
						}
						if ( buildFilter ) {
							tmp = $header.data( 'placeholder' ) ||
								$header.attr( 'data-placeholder' ) ||
								wo.filter_placeholder.search || '';
							buildFilter.attr( 'placeholder', tmp );
						}
					}
					if ( buildFilter ) {
						// add filter class name
						name = ( $.isArray( wo.filter_cssFilter ) ?
							( typeof wo.filter_cssFilter[column] !== 'undefined' ? wo.filter_cssFilter[column] || '' : '' ) :
							wo.filter_cssFilter ) || '';
						// copy data-column from table cell (it will include colspan)
						buildFilter.addClass( tscss.filter + ' ' + name );
						name = wo.filter_filterLabel;
						tmp = name.match(/{{([^}]+?)}}/g);
						if (!tmp) {
							tmp = [ '{{label}}' ];
						}
						$.each(tmp, function(indx, attr) {
							var regex = new RegExp(attr, 'g'),
								data = $header.attr('data-' + attr.replace(/{{|}}/g, '')),
								text = typeof data === 'undefined' ? $header.text() : data;
							name = name.replace( regex, $.trim( text ) );
						});
						buildFilter.attr({
							'data-column': $filter.attr( 'data-column' ),
							'aria-label': name
						});
						if ( disabled ) {
							buildFilter.attr( 'placeholder', '' ).addClass( tscss.filterDisabled )[0].disabled = true;
						}
					}
				}
			}
		},
		bindSearch: function( table, $el, internal ) {
			table = $( table )[0];
			$el = $( $el ); // allow passing a selector string
			if ( !$el.length ) { return; }
			var tmp,
				c = table.config,
				wo = c.widgetOptions,
				namespace = c.namespace + 'filter',
				$ext = wo.filter_$externalFilters;
			if ( internal !== true ) {
				// save anyMatch element
				tmp = wo.filter_anyColumnSelector + ',' + wo.filter_multipleColumnSelector;
				wo.filter_$anyMatch = $el.filter( tmp );
				if ( $ext && $ext.length ) {
					wo.filter_$externalFilters = wo.filter_$externalFilters.add( $el );
				} else {
					wo.filter_$externalFilters = $el;
				}
				// update values ( external filters added after table initialization )
				ts.setFilters( table, c.$table.data( 'lastSearch' ) || [], internal === false );
			}
			// unbind events
			tmp = ( 'keypress keyup keydown search change input '.split( ' ' ).join( namespace + ' ' ) );
			$el
			// use data attribute instead of jQuery data since the head is cloned without including
			// the data/binding
			.attr( 'data-lastSearchTime', new Date().getTime() )
			.unbind( tmp.replace( ts.regex.spaces, ' ' ) )
			.bind( 'keydown' + namespace, function( event ) {
				if ( event.which === tskeyCodes.escape && !table.config.widgetOptions.filter_resetOnEsc ) {
					// prevent keypress event
					return false;
				}
			})
			.bind( 'keyup' + namespace, function( event ) {
				wo = table.config.widgetOptions; // make sure "wo" isn't cached
				var column = parseInt( $( this ).attr( 'data-column' ), 10 ),
					liveSearch = typeof wo.filter_liveSearch === 'boolean' ? wo.filter_liveSearch :
						ts.getColumnData( table, wo.filter_liveSearch, column );
				if ( typeof liveSearch === 'undefined' ) {
					liveSearch = wo.filter_liveSearch.fallback || false;
				}
				$( this ).attr( 'data-lastSearchTime', new Date().getTime() );
				// emulate what webkit does.... escape clears the filter
				if ( event.which === tskeyCodes.escape ) {
					// make sure to restore the last value on escape
					this.value = wo.filter_resetOnEsc ? '' : c.lastSearch[column];
					// don't return if the search value is empty ( all rows need to be revealed )
				} else if ( this.value !== '' && (
					// liveSearch can contain a min value length; ignore arrow and meta keys, but allow backspace
					( typeof liveSearch === 'number' && this.value.length < liveSearch ) ||
					// let return & backspace continue on, but ignore arrows & non-valid characters
					( event.which !== tskeyCodes.enter && event.which !== tskeyCodes.backSpace &&
						( event.which < tskeyCodes.space || ( event.which >= tskeyCodes.left && event.which <= tskeyCodes.down ) ) ) ) ) {
					return;
					// live search
				} else if ( liveSearch === false ) {
					if ( this.value !== '' && event.which !== tskeyCodes.enter ) {
						return;
					}
				}
				// change event = no delay; last true flag tells getFilters to skip newest timed input
				tsf.searching( table, true, true, column );
			})
			// include change for select - fixes #473
			.bind( 'search change keypress input blur '.split( ' ' ).join( namespace + ' ' ), function( event ) {
				// don't get cached data, in case data-column changes dynamically
				var column = parseInt( $( this ).attr( 'data-column' ), 10 ),
					eventType = event.type,
					liveSearch = typeof wo.filter_liveSearch === 'boolean' ?
						wo.filter_liveSearch :
						ts.getColumnData( table, wo.filter_liveSearch, column );
				if ( table.config.widgetOptions.filter_initialized &&
					// immediate search if user presses enter
					( event.which === tskeyCodes.enter ||
						// immediate search if a "search" or "blur" is triggered on the input
						( eventType === 'search' || eventType === 'blur' ) ||
						// change & input events must be ignored if liveSearch !== true
						( eventType === 'change' || eventType === 'input' ) &&
						// prevent search if liveSearch is a number
						( liveSearch === true || liveSearch !== true && event.target.nodeName !== 'INPUT' ) &&
						// don't allow 'change' or 'input' event to process if the input value
						// is the same - fixes #685
						this.value !== c.lastSearch[column]
					)
				) {
					event.preventDefault();
					// init search with no delay
					$( this ).attr( 'data-lastSearchTime', new Date().getTime() );
					tsf.searching( table, eventType !== 'keypress' || event.which === tskeyCodes.enter, true, column );
				}
			});
		},
		searching: function( table, filter, skipFirst, column ) {
			var liveSearch,
				wo = table.config.widgetOptions;
			if (typeof column === 'undefined') {
				// no delay
				liveSearch = false;
			} else {
				liveSearch = typeof wo.filter_liveSearch === 'boolean' ?
					wo.filter_liveSearch :
					// get column setting, or set to fallback value, or default to false
					ts.getColumnData( table, wo.filter_liveSearch, column );
				if ( typeof liveSearch === 'undefined' ) {
					liveSearch = wo.filter_liveSearch.fallback || false;
				}
			}
			clearTimeout( wo.filter_searchTimer );
			if ( typeof filter === 'undefined' || filter === true ) {
				// delay filtering
				wo.filter_searchTimer = setTimeout( function() {
					tsf.checkFilters( table, filter, skipFirst );
				}, liveSearch ? wo.filter_searchDelay : 10 );
			} else {
				// skip delay
				tsf.checkFilters( table, filter, skipFirst );
			}
		},
		equalFilters: function (c, filter1, filter2) {
			var indx,
				f1 = [],
				f2 = [],
				len = c.columns + 1; // add one to include anyMatch filter
			filter1 = $.isArray(filter1) ? filter1 : [];
			filter2 = $.isArray(filter2) ? filter2 : [];
			for (indx = 0; indx < len; indx++) {
				f1[indx] = filter1[indx] || '';
				f2[indx] = filter2[indx] || '';
			}
			return f1.join(',') === f2.join(',');
		},
		checkFilters: function( table, filter, skipFirst ) {
			var c = table.config,
				wo = c.widgetOptions,
				filterArray = $.isArray( filter ),
				filters = ( filterArray ) ? filter : ts.getFilters( table, true ),
				currentFilters = filters || []; // current filter values
			// prevent errors if delay init is set
			if ( $.isEmptyObject( c.cache ) ) {
				// update cache if delayInit set & pager has initialized ( after user initiates a search )
				if ( c.delayInit && ( !c.pager || c.pager && c.pager.initialized ) ) {
					ts.updateCache( c, function() {
						tsf.checkFilters( table, false, skipFirst );
					});
				}
				return;
			}
			// add filter array back into inputs
			if ( filterArray ) {
				ts.setFilters( table, filters, false, skipFirst !== true );
				if ( !wo.filter_initialized ) {
					c.lastSearch = [];
					c.lastCombinedFilter = '';
				}
			}
			if ( wo.filter_hideFilters ) {
				// show/hide filter row as needed
				c.$table
					.find( '.' + tscss.filterRow )
					.triggerHandler( tsf.hideFiltersCheck( c ) ? 'mouseleave' : 'mouseenter' );
			}
			// return if the last search is the same; but filter === false when updating the search
			// see example-widget-filter.html filter toggle buttons
			if ( tsf.equalFilters(c, c.lastSearch, currentFilters) ) {
				if ( filter !== false ) {
					return;
				} else {
					// force filter refresh
					c.lastCombinedFilter = '';
					c.lastSearch = [];
				}
			}
			// define filter inside it is false
			filters = filters || [];
			// convert filters to strings - see #1070
			filters = Array.prototype.map ?
				filters.map( String ) :
				// for IE8 & older browsers - maybe not the best method
				filters.join( '\ufffd' ).split( '\ufffd' );

			if ( wo.filter_initialized ) {
				c.$table.triggerHandler( 'filterStart', [ filters ] );
			}
			if ( c.showProcessing ) {
				// give it time for the processing icon to kick in
				setTimeout( function() {
					tsf.findRows( table, filters, currentFilters );
					return false;
				}, 30 );
			} else {
				tsf.findRows( table, filters, currentFilters );
				return false;
			}
		},
		hideFiltersCheck: function( c ) {
			if (typeof c.widgetOptions.filter_hideFilters === 'function') {
				var val = c.widgetOptions.filter_hideFilters( c );
				if (typeof val === 'boolean') {
					return val;
				}
			}
			return ts.getFilters( c.$table ).join( '' ) === '';
		},
		hideFilters: function( c, $table ) {
			var timer;
			( $table || c.$table )
				.find( '.' + tscss.filterRow )
				.addClass( tscss.filterRowHide )
				.bind( 'mouseenter mouseleave', function( e ) {
					// save event object - http://bugs.jquery.com/ticket/12140
					var event = e,
						$row = $( this );
					clearTimeout( timer );
					timer = setTimeout( function() {
						if ( /enter|over/.test( event.type ) ) {
							$row.removeClass( tscss.filterRowHide );
						} else {
							// don't hide if input has focus
							// $( ':focus' ) needs jQuery 1.6+
							if ( $( document.activeElement ).closest( 'tr' )[0] !== $row[0] ) {
								// don't hide row if any filter has a value
								$row.toggleClass( tscss.filterRowHide, tsf.hideFiltersCheck( c ) );
							}
						}
					}, 200 );
				})
				.find( 'input, select' ).bind( 'focus blur', function( e ) {
					var event = e,
						$row = $( this ).closest( 'tr' );
					clearTimeout( timer );
					timer = setTimeout( function() {
						clearTimeout( timer );
						// don't hide row if any filter has a value
						$row.toggleClass( tscss.filterRowHide, tsf.hideFiltersCheck( c ) && event.type !== 'focus' );
					}, 200 );
				});
		},
		defaultFilter: function( filter, mask ) {
			if ( filter === '' ) { return filter; }
			var regex = tsfRegex.iQuery,
				maskLen = mask.match( tsfRegex.igQuery ).length,
				query = maskLen > 1 ? $.trim( filter ).split( /\s/ ) : [ $.trim( filter ) ],
				len = query.length - 1,
				indx = 0,
				val = mask;
			if ( len < 1 && maskLen > 1 ) {
				// only one 'word' in query but mask has >1 slots
				query[1] = query[0];
			}
			// replace all {query} with query words...
			// if query = 'Bob', then convert mask from '!{query}' to '!Bob'
			// if query = 'Bob Joe Frank', then convert mask '{q} OR {q}' to 'Bob OR Joe OR Frank'
			while ( regex.test( val ) ) {
				val = val.replace( regex, query[indx++] || '' );
				if ( regex.test( val ) && indx < len && ( query[indx] || '' ) !== '' ) {
					val = mask.replace( regex, val );
				}
			}
			return val;
		},
		getLatestSearch: function( $input ) {
			if ( $input ) {
				return $input.sort( function( a, b ) {
					return $( b ).attr( 'data-lastSearchTime' ) - $( a ).attr( 'data-lastSearchTime' );
				});
			}
			return $input || $();
		},
		findRange: function( c, val, ignoreRanges ) {
			// look for multiple columns '1-3,4-6,8' in data-column
			var temp, ranges, range, start, end, singles, i, indx, len,
				columns = [];
			if ( /^[0-9]+$/.test( val ) ) {
				// always return an array
				return [ parseInt( val, 10 ) ];
			}
			// process column range
			if ( !ignoreRanges && /-/.test( val ) ) {
				ranges = val.match( /(\d+)\s*-\s*(\d+)/g );
				len = ranges ? ranges.length : 0;
				for ( indx = 0; indx < len; indx++ ) {
					range = ranges[indx].split( /\s*-\s*/ );
					start = parseInt( range[0], 10 ) || 0;
					end = parseInt( range[1], 10 ) || ( c.columns - 1 );
					if ( start > end ) {
						temp = start; start = end; end = temp; // swap
					}
					if ( end >= c.columns ) {
						end = c.columns - 1;
					}
					for ( ; start <= end; start++ ) {
						columns[ columns.length ] = start;
					}
					// remove processed range from val
					val = val.replace( ranges[ indx ], '' );
				}
			}
			// process single columns
			if ( !ignoreRanges && /,/.test( val ) ) {
				singles = val.split( /\s*,\s*/ );
				len = singles.length;
				for ( i = 0; i < len; i++ ) {
					if ( singles[ i ] !== '' ) {
						indx = parseInt( singles[ i ], 10 );
						if ( indx < c.columns ) {
							columns[ columns.length ] = indx;
						}
					}
				}
			}
			// return all columns
			if ( !columns.length ) {
				for ( indx = 0; indx < c.columns; indx++ ) {
					columns[ columns.length ] = indx;
				}
			}
			return columns;
		},
		getColumnElm: function( c, $elements, column ) {
			// data-column may contain multiple columns '1-3,5-6,8'
			// replaces: c.$filters.filter( '[data-column="' + column + '"]' );
			return $elements.filter( function() {
				var cols = tsf.findRange( c, $( this ).attr( 'data-column' ) );
				return $.inArray( column, cols ) > -1;
			});
		},
		multipleColumns: function( c, $input ) {
			// look for multiple columns '1-3,4-6,8' in data-column
			var wo = c.widgetOptions,
				// only target 'all' column inputs on initialization
				// & don't target 'all' column inputs if they don't exist
				targets = wo.filter_initialized || !$input.filter( wo.filter_anyColumnSelector ).length,
				val = $.trim( tsf.getLatestSearch( $input ).attr( 'data-column' ) || '' );
			return tsf.findRange( c, val, !targets );
		},
		processTypes: function( c, data, vars ) {
			var ffxn,
				filterMatched = null,
				matches = null;
			for ( ffxn in tsf.types ) {
				if ( $.inArray( ffxn, vars.excludeMatch ) < 0 && matches === null ) {
					matches = tsf.types[ffxn]( c, data, vars );
					if ( matches !== null ) {
						data.matchedOn = ffxn;
						filterMatched = matches;
					}
				}
			}
			return filterMatched;
		},
		matchType: function( c, columnIndex ) {
			var isMatch,
				wo = c.widgetOptions,
				$el = c.$headerIndexed[ columnIndex ];
			// filter-exact > filter-match > filter_matchType for type
			if ( $el.hasClass( 'filter-exact' ) ) {
				isMatch = false;
			} else if ( $el.hasClass( 'filter-match' ) ) {
				isMatch = true;
			} else {
				// filter-select is not applied when filter_functions are used, so look for a select
				if ( wo.filter_columnFilters ) {
					$el = c.$filters
						.find( '.' + tscss.filter )
						.add( wo.filter_$externalFilters )
						.filter( '[data-column="' + columnIndex + '"]' );
				} else if ( wo.filter_$externalFilters ) {
					$el = wo.filter_$externalFilters.filter( '[data-column="' + columnIndex + '"]' );
				}
				isMatch = $el.length ?
					c.widgetOptions.filter_matchType[ ( $el[ 0 ].nodeName || '' ).toLowerCase() ] === 'match' :
					// default to exact, if no inputs found
					false;
			}
			return isMatch;
		},
		processRow: function( c, data, vars ) {
			var result, filterMatched,
				fxn, ffxn, txt,
				wo = c.widgetOptions,
				showRow = true,
				hasAnyMatchInput = wo.filter_$anyMatch && wo.filter_$anyMatch.length,

				// if wo.filter_$anyMatch data-column attribute is changed dynamically
				// we don't want to do an "anyMatch" search on one column using data
				// for the entire row - see #998
				columnIndex = wo.filter_$anyMatch && wo.filter_$anyMatch.length ?
					// look for multiple columns '1-3,4-6,8'
					tsf.multipleColumns( c, wo.filter_$anyMatch ) :
					[];
			data.$cells = data.$row.children();
			data.matchedOn = null;
			if ( data.anyMatchFlag && columnIndex.length > 1 || ( data.anyMatchFilter && !hasAnyMatchInput ) ) {
				data.anyMatch = true;
				data.isMatch = true;
				data.rowArray = data.$cells.map( function( i ) {
					if ( $.inArray( i, columnIndex ) > -1 || ( data.anyMatchFilter && !hasAnyMatchInput ) ) {
						if ( data.parsed[ i ] ) {
							txt = data.cacheArray[ i ];
						} else {
							txt = data.rawArray[ i ];
							txt = $.trim( wo.filter_ignoreCase ? txt.toLowerCase() : txt );
							if ( c.sortLocaleCompare ) {
								txt = ts.replaceAccents( txt );
							}
						}
						return txt;
					}
				}).get();
				data.filter = data.anyMatchFilter;
				data.iFilter = data.iAnyMatchFilter;
				data.exact = data.rowArray.join( ' ' );
				data.iExact = wo.filter_ignoreCase ? data.exact.toLowerCase() : data.exact;
				data.cache = data.cacheArray.slice( 0, -1 ).join( ' ' );
				vars.excludeMatch = vars.noAnyMatch;
				filterMatched = tsf.processTypes( c, data, vars );
				if ( filterMatched !== null ) {
					showRow = filterMatched;
				} else {
					if ( wo.filter_startsWith ) {
						showRow = false;
						// data.rowArray may not contain all columns
						columnIndex = Math.min( c.columns, data.rowArray.length );
						while ( !showRow && columnIndex > 0 ) {
							columnIndex--;
							showRow = showRow || data.rowArray[ columnIndex ].indexOf( data.iFilter ) === 0;
						}
					} else {
						showRow = ( data.iExact + data.childRowText ).indexOf( data.iFilter ) >= 0;
					}
				}
				data.anyMatch = false;
				// no other filters to process
				if ( data.filters.join( '' ) === data.filter ) {
					return showRow;
				}
			}

			for ( columnIndex = 0; columnIndex < c.columns; columnIndex++ ) {
				data.filter = data.filters[ columnIndex ];
				data.index = columnIndex;

				// filter types to exclude, per column
				vars.excludeMatch = vars.excludeFilter[ columnIndex ];

				// ignore if filter is empty or disabled
				if ( data.filter ) {
					data.cache = data.cacheArray[ columnIndex ];
					result = data.parsed[ columnIndex ] ? data.cache : data.rawArray[ columnIndex ] || '';
					data.exact = c.sortLocaleCompare ? ts.replaceAccents( result ) : result; // issue #405
					data.iExact = !tsfRegex.type.test( typeof data.exact ) && wo.filter_ignoreCase ?
						data.exact.toLowerCase() : data.exact;
					data.isMatch = tsf.matchType( c, columnIndex );

					result = showRow; // if showRow is true, show that row

					// in case select filter option has a different value vs text 'a - z|A through Z'
					ffxn = wo.filter_columnFilters ?
						c.$filters.add( wo.filter_$externalFilters )
							.filter( '[data-column="' + columnIndex + '"]' )
							.find( 'select option:selected' )
							.attr( 'data-function-name' ) || '' : '';
					// replace accents - see #357
					if ( c.sortLocaleCompare ) {
						data.filter = ts.replaceAccents( data.filter );
					}

					// replace column specific default filters - see #1088
					if ( wo.filter_defaultFilter && tsfRegex.iQuery.test( vars.defaultColFilter[ columnIndex ] ) ) {
						data.filter = tsf.defaultFilter( data.filter, vars.defaultColFilter[ columnIndex ] );
					}

					// data.iFilter = case insensitive ( if wo.filter_ignoreCase is true ),
					// data.filter = case sensitive
					data.iFilter = wo.filter_ignoreCase ? ( data.filter || '' ).toLowerCase() : data.filter;
					fxn = vars.functions[ columnIndex ];
					filterMatched = null;
					if ( fxn ) {
						if ( typeof fxn === 'function' ) {
							// filter callback( exact cell content, parser normalized content,
							// filter input value, column index, jQuery row object )
							filterMatched = fxn( data.exact, data.cache, data.filter, columnIndex, data.$row, c, data );
						} else if ( typeof fxn[ ffxn || data.filter ] === 'function' ) {
							// selector option function
							txt = ffxn || data.filter;
							filterMatched =
								fxn[ txt ]( data.exact, data.cache, data.filter, columnIndex, data.$row, c, data );
						}
					}
					if ( filterMatched === null ) {
						// cycle through the different filters
						// filters return a boolean or null if nothing matches
						filterMatched = tsf.processTypes( c, data, vars );
						// select with exact match; ignore "and" or "or" within the text; fixes #1486
						txt = fxn === true && (data.matchedOn === 'and' || data.matchedOn === 'or');
						if ( filterMatched !== null && !txt) {
							result = filterMatched;
						// Look for match, and add child row data for matching
						} else {
							// check fxn (filter-select in header) after filter types are checked
							// without this, the filter + jQuery UI selectmenu demo was breaking
							if ( fxn === true ) {
								// default selector uses exact match unless 'filter-match' class is found
								result = data.isMatch ?
									// data.iExact may be a number
									( '' + data.iExact ).search( data.iFilter ) >= 0 :
									data.filter === data.exact;
							} else {
								txt = ( data.iExact + data.childRowText ).indexOf( tsf.parseFilter( c, data.iFilter, data ) );
								result = ( ( !wo.filter_startsWith && txt >= 0 ) || ( wo.filter_startsWith && txt === 0 ) );
							}
						}
					} else {
						result = filterMatched;
					}
					showRow = ( result ) ? showRow : false;
				}
			}
			return showRow;
		},
		findRows: function( table, filters, currentFilters ) {
			if (
				tsf.equalFilters(table.config, table.config.lastSearch, currentFilters) ||
				!table.config.widgetOptions.filter_initialized
			) {
				return;
			}
			var len, norm_rows, rowData, $rows, $row, rowIndex, tbodyIndex, $tbody, columnIndex,
				isChild, childRow, lastSearch, showRow, showParent, time, val, indx,
				notFiltered, searchFiltered, query, injected, res, id, txt,
				storedFilters = $.extend( [], filters ),
				c = table.config,
				wo = c.widgetOptions,
				debug = ts.debug(c, 'filter'),
				// data object passed to filters; anyMatch is a flag for the filters
				data = {
					anyMatch: false,
					filters: filters,
					// regex filter type cache
					filter_regexCache : []
				},
				vars = {
					// anyMatch really screws up with these types of filters
					noAnyMatch: [ 'range',  'operators' ],
					// cache filter variables that use ts.getColumnData in the main loop
					functions : [],
					excludeFilter : [],
					defaultColFilter : [],
					defaultAnyFilter : ts.getColumnData( table, wo.filter_defaultFilter, c.columns, true ) || ''
				};
			// parse columns after formatter, in case the class is added at that point
			data.parsed = [];
			for ( columnIndex = 0; columnIndex < c.columns; columnIndex++ ) {
				data.parsed[ columnIndex ] = wo.filter_useParsedData ||
					// parser has a "parsed" parameter
					( c.parsers && c.parsers[ columnIndex ] && c.parsers[ columnIndex ].parsed ||
					// getData may not return 'parsed' if other 'filter-' class names exist
					// ( e.g. <th class="filter-select filter-parsed"> )
					ts.getData && ts.getData( c.$headerIndexed[ columnIndex ],
						ts.getColumnData( table, c.headers, columnIndex ), 'filter' ) === 'parsed' ||
					c.$headerIndexed[ columnIndex ].hasClass( 'filter-parsed' ) );

				vars.functions[ columnIndex ] =
					ts.getColumnData( table, wo.filter_functions, columnIndex ) ||
					c.$headerIndexed[ columnIndex ].hasClass( 'filter-select' );
				vars.defaultColFilter[ columnIndex ] =
					ts.getColumnData( table, wo.filter_defaultFilter, columnIndex ) || '';
				vars.excludeFilter[ columnIndex ] =
					( ts.getColumnData( table, wo.filter_excludeFilter, columnIndex, true ) || '' ).split( /\s+/ );
			}

			if ( debug ) {
				console.log( 'Filter >> Starting filter widget search', filters );
				time = new Date();
			}
			// filtered rows count
			c.filteredRows = 0;
			c.totalRows = 0;
			currentFilters = ( storedFilters || [] );

			for ( tbodyIndex = 0; tbodyIndex < c.$tbodies.length; tbodyIndex++ ) {
				$tbody = ts.processTbody( table, c.$tbodies.eq( tbodyIndex ), true );
				// skip child rows & widget added ( removable ) rows - fixes #448 thanks to @hempel!
				// $rows = $tbody.children( 'tr' ).not( c.selectorRemove );
				columnIndex = c.columns;
				// convert stored rows into a jQuery object
				norm_rows = c.cache[ tbodyIndex ].normalized;
				$rows = $( $.map( norm_rows, function( el ) {
					return el[ columnIndex ].$row.get();
				}) );

				if ( currentFilters.join('') === '' || wo.filter_serversideFiltering ) {
					$rows
						.removeClass( wo.filter_filteredRow )
						.not( '.' + c.cssChildRow )
						.css( 'display', '' );
				} else {
					// filter out child rows
					$rows = $rows.not( '.' + c.cssChildRow );
					len = $rows.length;

					if ( ( wo.filter_$anyMatch && wo.filter_$anyMatch.length ) ||
						typeof filters[c.columns] !== 'undefined' ) {
						data.anyMatchFlag = true;
						data.anyMatchFilter = '' + (
							filters[ c.columns ] ||
							wo.filter_$anyMatch && tsf.getLatestSearch( wo.filter_$anyMatch ).val() ||
							''
						);
						if ( wo.filter_columnAnyMatch ) {
							// specific columns search
							query = data.anyMatchFilter.split( tsfRegex.andSplit );
							injected = false;
							for ( indx = 0; indx < query.length; indx++ ) {
								res = query[ indx ].split( ':' );
								if ( res.length > 1 ) {
									// make the column a one-based index ( non-developers start counting from one :P )
									if ( isNaN( res[0] ) ) {
										$.each( c.headerContent, function( i, txt ) {
											// multiple matches are possible
											if ( txt.toLowerCase().indexOf( res[0] ) > -1 ) {
												id = i;
												filters[ id ] = res[1];
											}
										});
									} else {
										id = parseInt( res[0], 10 ) - 1;
									}
									if ( id >= 0 && id < c.columns ) { // if id is an integer
										filters[ id ] = res[1];
										query.splice( indx, 1 );
										indx--;
										injected = true;
									}
								}
							}
							if ( injected ) {
								data.anyMatchFilter = query.join( ' && ' );
							}
						}
					}

					// optimize searching only through already filtered rows - see #313
					searchFiltered = wo.filter_searchFiltered;
					lastSearch = c.lastSearch || c.$table.data( 'lastSearch' ) || [];
					if ( searchFiltered ) {
						// cycle through all filters; include last ( columnIndex + 1 = match any column ). Fixes #669
						for ( indx = 0; indx < columnIndex + 1; indx++ ) {
							val = filters[indx] || '';
							// break out of loop if we've already determined not to search filtered rows
							if ( !searchFiltered ) { indx = columnIndex; }
							// search already filtered rows if...
							searchFiltered = searchFiltered && lastSearch.length &&
								// there are no changes from beginning of filter
								val.indexOf( lastSearch[indx] || '' ) === 0 &&
								// if there is NOT a logical 'or', or range ( 'to' or '-' ) in the string
								!tsfRegex.alreadyFiltered.test( val ) &&
								// if we are not doing exact matches, using '|' ( logical or ) or not '!'
								!tsfRegex.exactTest.test( val ) &&
								// don't search only filtered if the value is negative
								// ( '> -10' => '> -100' will ignore hidden rows )
								!( tsfRegex.isNeg1.test( val ) || tsfRegex.isNeg2.test( val ) ) &&
								// if filtering using a select without a 'filter-match' class ( exact match ) - fixes #593
								!( val !== '' && c.$filters && c.$filters.filter( '[data-column="' + indx + '"]' ).find( 'select' ).length &&
									!tsf.matchType( c, indx ) );
						}
					}
					notFiltered = $rows.not( '.' + wo.filter_filteredRow ).length;
					// can't search when all rows are hidden - this happens when looking for exact matches
					if ( searchFiltered && notFiltered === 0 ) { searchFiltered = false; }
					if ( debug ) {
						console.log( 'Filter >> Searching through ' +
							( searchFiltered && notFiltered < len ? notFiltered : 'all' ) + ' rows' );
					}
					if ( data.anyMatchFlag ) {
						if ( c.sortLocaleCompare ) {
							// replace accents
							data.anyMatchFilter = ts.replaceAccents( data.anyMatchFilter );
						}
						if ( wo.filter_defaultFilter && tsfRegex.iQuery.test( vars.defaultAnyFilter ) ) {
							data.anyMatchFilter = tsf.defaultFilter( data.anyMatchFilter, vars.defaultAnyFilter );
							// clear search filtered flag because default filters are not saved to the last search
							searchFiltered = false;
						}
						// make iAnyMatchFilter lowercase unless both filter widget & core ignoreCase options are true
						// when c.ignoreCase is true, the cache contains all lower case data
						data.iAnyMatchFilter = !( wo.filter_ignoreCase && c.ignoreCase ) ?
							data.anyMatchFilter :
							data.anyMatchFilter.toLowerCase();
					}

					// loop through the rows
					for ( rowIndex = 0; rowIndex < len; rowIndex++ ) {

						txt = $rows[ rowIndex ].className;
						// the first row can never be a child row
						isChild = rowIndex && tsfRegex.child.test( txt );
						// skip child rows & already filtered rows
						if ( isChild || ( searchFiltered && tsfRegex.filtered.test( txt ) ) ) {
							continue;
						}

						data.$row = $rows.eq( rowIndex );
						data.rowIndex = rowIndex;
						data.cacheArray = norm_rows[ rowIndex ];
						rowData = data.cacheArray[ c.columns ];
						data.rawArray = rowData.raw;
						data.childRowText = '';

						if ( !wo.filter_childByColumn ) {
							txt = '';
							// child row cached text
							childRow = rowData.child;
							// so, if 'table.config.widgetOptions.filter_childRows' is true and there is
							// a match anywhere in the child row, then it will make the row visible
							// checked here so the option can be changed dynamically
							for ( indx = 0; indx < childRow.length; indx++ ) {
								txt += ' ' + childRow[indx].join( ' ' ) || '';
							}
							data.childRowText = wo.filter_childRows ?
								( wo.filter_ignoreCase ? txt.toLowerCase() : txt ) :
								'';
						}

						showRow = false;
						showParent = tsf.processRow( c, data, vars );
						$row = rowData.$row;

						// don't pass reference to val
						val = showParent ? true : false;
						childRow = rowData.$row.filter( ':gt(0)' );
						if ( wo.filter_childRows && childRow.length ) {
							if ( wo.filter_childByColumn ) {
								if ( !wo.filter_childWithSibs ) {
									// hide all child rows
									childRow.addClass( wo.filter_filteredRow );
									// if only showing resulting child row, only include parent
									$row = $row.eq( 0 );
								}
								// cycle through each child row
								for ( indx = 0; indx < childRow.length; indx++ ) {
									data.$row = childRow.eq( indx );
									data.cacheArray = rowData.child[ indx ];
									data.rawArray = data.cacheArray;
									val = tsf.processRow( c, data, vars );
									// use OR comparison on child rows
									showRow = showRow || val;
									if ( !wo.filter_childWithSibs && val ) {
										childRow.eq( indx ).removeClass( wo.filter_filteredRow );
									}
								}
							}
							// keep parent row match even if no child matches... see #1020
							showRow = showRow || showParent;
						} else {
							showRow = val;
						}
						$row
							.toggleClass( wo.filter_filteredRow, !showRow )[0]
							.display = showRow ? '' : 'none';
					}
				}
				c.filteredRows += $rows.not( '.' + wo.filter_filteredRow ).length;
				c.totalRows += $rows.length;
				ts.processTbody( table, $tbody, false );
			}
			// lastCombinedFilter is no longer used internally
			c.lastCombinedFilter = storedFilters.join(''); // save last search
			// don't save 'filters' directly since it may have altered ( AnyMatch column searches )
			c.lastSearch = storedFilters;
			c.$table.data( 'lastSearch', storedFilters );
			if ( wo.filter_saveFilters && ts.storage ) {
				ts.storage( table, 'tablesorter-filters', tsf.processFilters( storedFilters, true ) );
			}
			if ( debug ) {
				console.log( 'Filter >> Completed search' + ts.benchmark(time) );
			}
			if ( wo.filter_initialized ) {
				c.$table.triggerHandler( 'filterBeforeEnd', c );
				c.$table.triggerHandler( 'filterEnd', c );
			}
			setTimeout( function() {
				ts.applyWidget( c.table ); // make sure zebra widget is applied
			}, 0 );
		},
		getOptionSource: function( table, column, onlyAvail ) {
			table = $( table )[0];
			var c = table.config,
				wo = c.widgetOptions,
				arry = false,
				source = wo.filter_selectSource,
				last = c.$table.data( 'lastSearch' ) || [],
				fxn = typeof source === 'function' ? true : ts.getColumnData( table, source, column );

			if ( onlyAvail && last[column] !== '' ) {
				onlyAvail = false;
			}

			// filter select source option
			if ( fxn === true ) {
				// OVERALL source
				arry = source( table, column, onlyAvail );
			} else if ( fxn instanceof $ || ( $.type( fxn ) === 'string' && fxn.indexOf( '</option>' ) >= 0 ) ) {
				// selectSource is a jQuery object or string of options
				return fxn;
			} else if ( $.isArray( fxn ) ) {
				arry = fxn;
			} else if ( $.type( source ) === 'object' && fxn ) {
				// custom select source function for a SPECIFIC COLUMN
				arry = fxn( table, column, onlyAvail );
				// abort - updating the selects from an external method
				if (arry === null) {
					return null;
				}
			}
			if ( arry === false ) {
				// fall back to original method
				arry = tsf.getOptions( table, column, onlyAvail );
			}

			return tsf.processOptions( table, column, arry );

		},
		processOptions: function( table, column, arry ) {
			if ( !$.isArray( arry ) ) {
				return false;
			}
			table = $( table )[0];
			var cts, txt, indx, len, parsedTxt, str,
				c = table.config,
				validColumn = typeof column !== 'undefined' && column !== null && column >= 0 && column < c.columns,
				direction = validColumn ? c.$headerIndexed[ column ].hasClass( 'filter-select-sort-desc' ) : false,
				parsed = [];
			// get unique elements and sort the list
			// if $.tablesorter.sortText exists ( not in the original tablesorter ),
			// then natural sort the list otherwise use a basic sort
			arry = $.grep( arry, function( value, indx ) {
				if ( value.text ) {
					return true;
				}
				return $.inArray( value, arry ) === indx;
			});
			if ( validColumn && c.$headerIndexed[ column ].hasClass( 'filter-select-nosort' ) ) {
				// unsorted select options
				return arry;
			} else {
				len = arry.length;
				// parse select option values
				for ( indx = 0; indx < len; indx++ ) {
					txt = arry[ indx ];
					// check for object
					str = txt.text ? txt.text : txt;
					// sortNatural breaks if you don't pass it strings
					parsedTxt = ( validColumn && c.parsers && c.parsers.length &&
						c.parsers[ column ].format( str, table, [], column ) || str ).toString();
					parsedTxt = c.widgetOptions.filter_ignoreCase ? parsedTxt.toLowerCase() : parsedTxt;
					// parse array data using set column parser; this DOES NOT pass the original
					// table cell to the parser format function
					if ( txt.text ) {
						txt.parsed = parsedTxt;
						parsed[ parsed.length ] = txt;
					} else {
						parsed[ parsed.length ] = {
							text : txt,
							// check parser length - fixes #934
							parsed : parsedTxt
						};
					}
				}
				// sort parsed select options
				cts = c.textSorter || '';
				parsed.sort( function( a, b ) {
					var x = direction ? b.parsed : a.parsed,
						y = direction ? a.parsed : b.parsed;
					if ( validColumn && typeof cts === 'function' ) {
						// custom OVERALL text sorter
						return cts( x, y, true, column, table );
					} else if ( validColumn && typeof cts === 'object' && cts.hasOwnProperty( column ) ) {
						// custom text sorter for a SPECIFIC COLUMN
						return cts[column]( x, y, true, column, table );
					} else if ( ts.sortNatural ) {
						// fall back to natural sort
						return ts.sortNatural( x, y );
					}
					// using an older version! do a basic sort
					return true;
				});
				// rebuild arry from sorted parsed data
				arry = [];
				len = parsed.length;
				for ( indx = 0; indx < len; indx++ ) {
					arry[ arry.length ] = parsed[indx];
				}
				return arry;
			}
		},
		getOptions: function( table, column, onlyAvail ) {
			table = $( table )[0];
			var rowIndex, tbodyIndex, len, row, cache, indx, child, childLen,
				c = table.config,
				wo = c.widgetOptions,
				arry = [];
			for ( tbodyIndex = 0; tbodyIndex < c.$tbodies.length; tbodyIndex++ ) {
				cache = c.cache[tbodyIndex];
				len = c.cache[tbodyIndex].normalized.length;
				// loop through the rows
				for ( rowIndex = 0; rowIndex < len; rowIndex++ ) {
					// get cached row from cache.row ( old ) or row data object
					// ( new; last item in normalized array )
					row = cache.row ?
						cache.row[ rowIndex ] :
						cache.normalized[ rowIndex ][ c.columns ].$row[0];
					// check if has class filtered
					if ( onlyAvail && row.className.match( wo.filter_filteredRow ) ) {
						continue;
					}
					// get non-normalized cell content
					if ( wo.filter_useParsedData ||
						c.parsers[column].parsed ||
						c.$headerIndexed[column].hasClass( 'filter-parsed' ) ) {
						arry[ arry.length ] = '' + cache.normalized[ rowIndex ][ column ];
						// child row parsed data
						if ( wo.filter_childRows && wo.filter_childByColumn ) {
							childLen = cache.normalized[ rowIndex ][ c.columns ].$row.length - 1;
							for ( indx = 0; indx < childLen; indx++ ) {
								arry[ arry.length ] = '' + cache.normalized[ rowIndex ][ c.columns ].child[ indx ][ column ];
							}
						}
					} else {
						// get raw cached data instead of content directly from the cells
						arry[ arry.length ] = cache.normalized[ rowIndex ][ c.columns ].raw[ column ];
						// child row unparsed data
						if ( wo.filter_childRows && wo.filter_childByColumn ) {
							childLen = cache.normalized[ rowIndex ][ c.columns ].$row.length;
							for ( indx = 1; indx < childLen; indx++ ) {
								child =  cache.normalized[ rowIndex ][ c.columns ].$row.eq( indx ).children().eq( column );
								arry[ arry.length ] = '' + ts.getElementText( c, child, column );
							}
						}
					}
				}
			}
			return arry;
		},
		buildSelect: function( table, column, arry, updating, onlyAvail ) {
			table = $( table )[0];
			column = parseInt( column, 10 );
			if ( !table.config.cache || $.isEmptyObject( table.config.cache ) ) {
				return;
			}

			var indx, val, txt, t, $filters, $filter, option,
				c = table.config,
				wo = c.widgetOptions,
				node = c.$headerIndexed[ column ],
				// t.data( 'placeholder' ) won't work in jQuery older than 1.4.3
				options = '<option value="">' +
					( node.data( 'placeholder' ) ||
						node.attr( 'data-placeholder' ) ||
						wo.filter_placeholder.select || ''
					) + '</option>',
				// Get curent filter value
				currentValue = c.$table
					.find( 'thead' )
					.find( 'select.' + tscss.filter + '[data-column="' + column + '"]' )
					.val();

			// nothing included in arry ( external source ), so get the options from
			// filter_selectSource or column data
			if ( typeof arry === 'undefined' || arry === '' ) {
				arry = tsf.getOptionSource( table, column, onlyAvail );
				// abort, selects are updated by an external method
				if (arry === null) {
					return;
				}
			}

			if ( $.isArray( arry ) ) {
				// build option list
				for ( indx = 0; indx < arry.length; indx++ ) {
					option = arry[ indx ];
					if ( option.text ) {
						// OBJECT!! add data-function-name in case the value is set in filter_functions
						option['data-function-name'] = typeof option.value === 'undefined' ? option.text : option.value;

						// support jQuery < v1.8, otherwise the below code could be shortened to
						// options += $( '<option>', option )[ 0 ].outerHTML;
						options += '<option';
						for ( val in option ) {
							if ( option.hasOwnProperty( val ) && val !== 'text' ) {
								options += ' ' + val + '="' + option[ val ].replace( tsfRegex.quote, '&quot;' ) + '"';
							}
						}
						if ( !option.value ) {
							options += ' value="' + option.text.replace( tsfRegex.quote, '&quot;' ) + '"';
						}
						options += '>' + option.text.replace( tsfRegex.quote, '&quot;' ) + '</option>';
						// above code is needed in jQuery < v1.8

						// make sure we don't turn an object into a string (objects without a "text" property)
					} else if ( '' + option !== '[object Object]' ) {
						txt = option = ( '' + option ).replace( tsfRegex.quote, '&quot;' );
						val = txt;
						// allow including a symbol in the selectSource array
						// 'a-z|A through Z' so that 'a-z' becomes the option value
						// and 'A through Z' becomes the option text
						if ( txt.indexOf( wo.filter_selectSourceSeparator ) >= 0 ) {
							t = txt.split( wo.filter_selectSourceSeparator );
							val = t[0];
							txt = t[1];
						}
						// replace quotes - fixes #242 & ignore empty strings
						// see http://stackoverflow.com/q/14990971/145346
						options += option !== '' ?
							'<option ' +
								( val === txt ? '' : 'data-function-name="' + option + '" ' ) +
								'value="' + val + '">' + txt +
							'</option>' : '';
					}
				}
				// clear arry so it doesn't get appended twice
				arry = [];
			}

			// update all selects in the same column ( clone thead in sticky headers &
			// any external selects ) - fixes 473
			$filters = ( c.$filters ? c.$filters : c.$table.children( 'thead' ) )
				.find( '.' + tscss.filter );
			if ( wo.filter_$externalFilters ) {
				$filters = $filters && $filters.length ?
					$filters.add( wo.filter_$externalFilters ) :
					wo.filter_$externalFilters;
			}
			$filter = $filters.filter( 'select[data-column="' + column + '"]' );

			// make sure there is a select there!
			if ( $filter.length ) {
				$filter[ updating ? 'html' : 'append' ]( options );
				if ( !$.isArray( arry ) ) {
					// append options if arry is provided externally as a string or jQuery object
					// options ( default value ) was already added
					$filter.append( arry ).val( currentValue );
				}
				$filter.val( currentValue );
			}
		},
		buildDefault: function( table, updating ) {
			var columnIndex, $header, noSelect,
				c = table.config,
				wo = c.widgetOptions,
				columns = c.columns;
			// build default select dropdown
			for ( columnIndex = 0; columnIndex < columns; columnIndex++ ) {
				$header = c.$headerIndexed[columnIndex];
				noSelect = !( $header.hasClass( 'filter-false' ) || $header.hasClass( 'parser-false' ) );
				// look for the filter-select class; build/update it if found
				if ( ( $header.hasClass( 'filter-select' ) ||
					ts.getColumnData( table, wo.filter_functions, columnIndex ) === true ) && noSelect ) {
					tsf.buildSelect( table, columnIndex, '', updating, $header.hasClass( wo.filter_onlyAvail ) );
				}
			}
		}
	};

	// filter regex variable
	tsfRegex = tsf.regex;

	ts.getFilters = function( table, getRaw, setFilters, skipFirst ) {
		var i, $filters, $column, cols,
			filters = [],
			c = table ? $( table )[0].config : '',
			wo = c ? c.widgetOptions : '';
		if ( ( getRaw !== true && wo && !wo.filter_columnFilters ) ||
			// setFilters called, but last search is exactly the same as the current
			// fixes issue #733 & #903 where calling update causes the input values to reset
			( $.isArray(setFilters) && tsf.equalFilters(c, setFilters, c.lastSearch) )
		) {
			return $( table ).data( 'lastSearch' ) || [];
		}
		if ( c ) {
			if ( c.$filters ) {
				$filters = c.$filters.find( '.' + tscss.filter );
			}
			if ( wo.filter_$externalFilters ) {
				$filters = $filters && $filters.length ?
					$filters.add( wo.filter_$externalFilters ) :
					wo.filter_$externalFilters;
			}
			if ( $filters && $filters.length ) {
				filters = setFilters || [];
				for ( i = 0; i < c.columns + 1; i++ ) {
					cols = ( i === c.columns ?
						// 'all' columns can now include a range or set of columms ( data-column='0-2,4,6-7' )
						wo.filter_anyColumnSelector + ',' + wo.filter_multipleColumnSelector :
						'[data-column="' + i + '"]' );
					$column = $filters.filter( cols );
					if ( $column.length ) {
						// move the latest search to the first slot in the array
						$column = tsf.getLatestSearch( $column );
						if ( $.isArray( setFilters ) ) {
							// skip first ( latest input ) to maintain cursor position while typing
							if ( skipFirst && $column.length > 1 ) {
								$column = $column.slice( 1 );
							}
							if ( i === c.columns ) {
								// prevent data-column='all' from filling data-column='0,1' ( etc )
								cols = $column.filter( wo.filter_anyColumnSelector );
								$column = cols.length ? cols : $column;
							}
							$column
								.val( setFilters[ i ] )
								// must include a namespace here; but not c.namespace + 'filter'?
								.trigger( 'change' + c.namespace );
						} else {
							filters[i] = $column.val() || '';
							// don't change the first... it will move the cursor
							if ( i === c.columns ) {
								// don't update range columns from 'all' setting
								$column
									.slice( 1 )
									.filter( '[data-column*="' + $column.attr( 'data-column' ) + '"]' )
									.val( filters[ i ] );
							} else {
								$column
									.slice( 1 )
									.val( filters[ i ] );
							}
						}
						// save any match input dynamically
						if ( i === c.columns && $column.length ) {
							wo.filter_$anyMatch = $column;
						}
					}
				}
			}
		}
		return filters;
	};

	ts.setFilters = function( table, filter, apply, skipFirst ) {
		var c = table ? $( table )[0].config : '',
			valid = ts.getFilters( table, true, filter, skipFirst );
		// default apply to "true"
		if ( typeof apply === 'undefined' ) {
			apply = true;
		}
		if ( c && apply ) {
			// ensure new set filters are applied, even if the search is the same
			c.lastCombinedFilter = null;
			c.lastSearch = [];
			tsf.searching( c.table, filter, skipFirst );
			c.$table.triggerHandler( 'filterFomatterUpdate' );
		}
		return valid.length !== 0;
	};

})( jQuery );

/*! Widget: stickyHeaders - updated 9/27/2017 (v2.29.0) *//*
 * Requires tablesorter v2.8+ and jQuery 1.4.3+
 * by Rob Garrison
 */
;(function ($, window) {
	'use strict';
	var ts = $.tablesorter || {};

	$.extend(ts.css, {
		sticky    : 'tablesorter-stickyHeader', // stickyHeader
		stickyVis : 'tablesorter-sticky-visible',
		stickyHide: 'tablesorter-sticky-hidden',
		stickyWrap: 'tablesorter-sticky-wrapper'
	});

	// Add a resize event to table headers
	ts.addHeaderResizeEvent = function(table, disable, settings) {
		table = $(table)[0]; // make sure we're using a dom element
		if ( !table.config ) { return; }
		var defaults = {
				timer : 250
			},
			options = $.extend({}, defaults, settings),
			c = table.config,
			wo = c.widgetOptions,
			checkSizes = function( triggerEvent ) {
				var index, headers, $header, sizes, width, height,
					len = c.$headers.length;
				wo.resize_flag = true;
				headers = [];
				for ( index = 0; index < len; index++ ) {
					$header = c.$headers.eq( index );
					sizes = $header.data( 'savedSizes' ) || [ 0, 0 ]; // fixes #394
					width = $header[0].offsetWidth;
					height = $header[0].offsetHeight;
					if ( width !== sizes[0] || height !== sizes[1] ) {
						$header.data( 'savedSizes', [ width, height ] );
						headers.push( $header[0] );
					}
				}
				if ( headers.length && triggerEvent !== false ) {
					c.$table.triggerHandler( 'resize', [ headers ] );
				}
				wo.resize_flag = false;
			};
		clearInterval(wo.resize_timer);
		if (disable) {
			wo.resize_flag = false;
			return false;
		}
		checkSizes( false );
		wo.resize_timer = setInterval(function() {
			if (wo.resize_flag) { return; }
			checkSizes();
		}, options.timer);
	};

	function getStickyOffset(c, wo) {
		var $el = isNaN(wo.stickyHeaders_offset) ? $(wo.stickyHeaders_offset) : [];
		return $el.length ?
			$el.height() || 0 :
			parseInt(wo.stickyHeaders_offset, 10) || 0;
	}

	// Sticky headers based on this awesome article:
	// http://css-tricks.com/13465-persistent-headers/
	// and https://github.com/jmosbech/StickyTableHeaders by Jonas Mosbech
	// **************************
	ts.addWidget({
		id: 'stickyHeaders',
		priority: 54, // sticky widget must be initialized after the filter & before pager widget!
		options: {
			stickyHeaders : '',       // extra class name added to the sticky header row
			stickyHeaders_appendTo : null, // jQuery selector or object to phycially attach the sticky headers
			stickyHeaders_attachTo : null, // jQuery selector or object to attach scroll listener to (overridden by xScroll & yScroll settings)
			stickyHeaders_xScroll : null, // jQuery selector or object to monitor horizontal scroll position (defaults: xScroll > attachTo > window)
			stickyHeaders_yScroll : null, // jQuery selector or object to monitor vertical scroll position (defaults: yScroll > attachTo > window)
			stickyHeaders_offset : 0, // number or jquery selector targeting the position:fixed element
			stickyHeaders_filteredToTop: true, // scroll table top into view after filtering
			stickyHeaders_cloneId : '-sticky', // added to table ID, if it exists
			stickyHeaders_addResizeEvent : true, // trigger 'resize' event on headers
			stickyHeaders_includeCaption : true, // if false and a caption exist, it won't be included in the sticky header
			stickyHeaders_zIndex : 2 // The zIndex of the stickyHeaders, allows the user to adjust this to their needs
		},
		format: function(table, c, wo) {
			// filter widget doesn't initialize on an empty table. Fixes #449
			if ( c.$table.hasClass('hasStickyHeaders') || ($.inArray('filter', c.widgets) >= 0 && !c.$table.hasClass('hasFilters')) ) {
				return;
			}
			var index, len, $t,
				$table = c.$table,
				// add position: relative to attach element, hopefully it won't cause trouble.
				$attach = $(wo.stickyHeaders_attachTo || wo.stickyHeaders_appendTo),
				namespace = c.namespace + 'stickyheaders ',
				// element to watch for the scroll event
				$yScroll = $(wo.stickyHeaders_yScroll || wo.stickyHeaders_attachTo || window),
				$xScroll = $(wo.stickyHeaders_xScroll || wo.stickyHeaders_attachTo || window),
				$thead = $table.children('thead:first'),
				$header = $thead.children('tr').not('.sticky-false').children(),
				$tfoot = $table.children('tfoot'),
				stickyOffset = getStickyOffset(c, wo),
				// is this table nested? If so, find parent sticky header wrapper (div, not table)
				$nestedSticky = $table.parent().closest('.' + ts.css.table).hasClass('hasStickyHeaders') ?
					$table.parent().closest('table.tablesorter')[0].config.widgetOptions.$sticky.parent() : [],
				nestedStickyTop = $nestedSticky.length ? $nestedSticky.height() : 0,
				// clone table, then wrap to make sticky header
				$stickyTable = wo.$sticky = $table.clone()
					.addClass('containsStickyHeaders ' + ts.css.sticky + ' ' + wo.stickyHeaders + ' ' + c.namespace.slice(1) + '_extra_table' )
					.wrap('<div class="' + ts.css.stickyWrap + '">'),
				$stickyWrap = $stickyTable.parent()
					.addClass(ts.css.stickyHide)
					.css({
						position   : $attach.length ? 'absolute' : 'fixed',
						padding    : parseInt( $stickyTable.parent().parent().css('padding-left'), 10 ),
						top        : stickyOffset + nestedStickyTop,
						left       : 0,
						visibility : 'hidden',
						zIndex     : wo.stickyHeaders_zIndex || 2
					}),
				$stickyThead = $stickyTable.children('thead:first'),
				$stickyCells,
				laststate = '',
				setWidth = function($orig, $clone) {
					var index, width, border, $cell, $this,
						$cells = $orig.filter(':visible'),
						len = $cells.length;
					for ( index = 0; index < len; index++ ) {
						$cell = $clone.filter(':visible').eq(index);
						$this = $cells.eq(index);
						// code from https://github.com/jmosbech/StickyTableHeaders
						if ($this.css('box-sizing') === 'border-box') {
							width = $this.outerWidth();
						} else {
							if ($cell.css('border-collapse') === 'collapse') {
								if (window.getComputedStyle) {
									width = parseFloat( window.getComputedStyle($this[0], null).width );
								} else {
									// ie8 only
									border = parseFloat( $this.css('border-width') );
									width = $this.outerWidth() - parseFloat( $this.css('padding-left') ) - parseFloat( $this.css('padding-right') ) - border;
								}
							} else {
								width = $this.width();
							}
						}
						$cell.css({
							'width': width,
							'min-width': width,
							'max-width': width
						});
					}
				},
				getLeftPosition = function(yWindow) {
					if (yWindow === false && $nestedSticky.length) {
						return $table.position().left;
					}
					return $attach.length ?
						parseInt($attach.css('padding-left'), 10) || 0 :
						$table.offset().left - parseInt($table.css('margin-left'), 10) - $(window).scrollLeft();
				},
				resizeHeader = function() {
					$stickyWrap.css({
						left : getLeftPosition(),
						width: $table.outerWidth()
					});
					setWidth( $table, $stickyTable );
					setWidth( $header, $stickyCells );
				},
				scrollSticky = function( resizing ) {
					if (!$table.is(':visible')) { return; } // fixes #278
					// Detect nested tables - fixes #724
					nestedStickyTop = $nestedSticky.length ? $nestedSticky.offset().top - $yScroll.scrollTop() + $nestedSticky.height() : 0;
					var tmp,
						offset = $table.offset(),
						stickyOffset = getStickyOffset(c, wo),
						yWindow = $.isWindow( $yScroll[0] ), // $.isWindow needs jQuery 1.4.3
						yScroll = yWindow ?
							$yScroll.scrollTop() :
							// use parent sticky position if nested AND inside of a scrollable element - see #1512
							$nestedSticky.length ? parseInt($nestedSticky[0].style.top, 10) : $yScroll.offset().top,
						attachTop = $attach.length ? yScroll : $yScroll.scrollTop(),
						captionHeight = wo.stickyHeaders_includeCaption ? 0 : $table.children( 'caption' ).height() || 0,
						scrollTop = attachTop + stickyOffset + nestedStickyTop - captionHeight,
						tableHeight = $table.height() - ($stickyWrap.height() + ($tfoot.height() || 0)) - captionHeight,
						isVisible = ( scrollTop > offset.top ) && ( scrollTop < offset.top + tableHeight ) ? 'visible' : 'hidden',
						state = isVisible === 'visible' ? ts.css.stickyVis : ts.css.stickyHide,
						needsUpdating = !$stickyWrap.hasClass( state ),
						cssSettings = { visibility : isVisible };
					if ($attach.length) {
						// attached sticky headers always need updating
						needsUpdating = true;
						cssSettings.top = yWindow ? scrollTop - $attach.offset().top : $attach.scrollTop();
					}
					// adjust when scrolling horizontally - fixes issue #143
					tmp = getLeftPosition(yWindow);
					if (tmp !== parseInt($stickyWrap.css('left'), 10)) {
						needsUpdating = true;
						cssSettings.left = tmp;
					}
					cssSettings.top = ( cssSettings.top || 0 ) +
						// If nested AND inside of a scrollable element, only add parent sticky height
						(!yWindow && $nestedSticky.length ? $nestedSticky.height() : stickyOffset + nestedStickyTop);
					if (needsUpdating) {
						$stickyWrap
							.removeClass( ts.css.stickyVis + ' ' + ts.css.stickyHide )
							.addClass( state )
							.css(cssSettings);
					}
					if (isVisible !== laststate || resizing) {
						// make sure the column widths match
						resizeHeader();
						laststate = isVisible;
					}
				};
			// only add a position relative if a position isn't already defined
			if ($attach.length && !$attach.css('position')) {
				$attach.css('position', 'relative');
			}
			// fix clone ID, if it exists - fixes #271
			if ($stickyTable.attr('id')) { $stickyTable[0].id += wo.stickyHeaders_cloneId; }
			// clear out cloned table, except for sticky header
			// include caption & filter row (fixes #126 & #249) - don't remove cells to get correct cell indexing
			$stickyTable.find('> thead:gt(0), tr.sticky-false').hide();
			$stickyTable.find('> tbody, > tfoot').remove();
			$stickyTable.find('caption').toggle(wo.stickyHeaders_includeCaption);
			// issue #172 - find td/th in sticky header
			$stickyCells = $stickyThead.children().children();
			$stickyTable.css({ height:0, width:0, margin: 0 });
			// remove resizable block
			$stickyCells.find('.' + ts.css.resizer).remove();
			// update sticky header class names to match real header after sorting
			$table
				.addClass('hasStickyHeaders')
				.bind('pagerComplete' + namespace, function() {
					resizeHeader();
				});

			ts.bindEvents(table, $stickyThead.children().children('.' + ts.css.header));

			if (wo.stickyHeaders_appendTo) {
				$(wo.stickyHeaders_appendTo).append( $stickyWrap );
			} else {
				// add stickyheaders AFTER the table. If the table is selected by ID, the original one (first) will be returned.
				$table.after( $stickyWrap );
			}

			// onRenderHeader is defined, we need to do something about it (fixes #641)
			if (c.onRenderHeader) {
				$t = $stickyThead.children('tr').children();
				len = $t.length;
				for ( index = 0; index < len; index++ ) {
					// send second parameter
					c.onRenderHeader.apply( $t.eq( index ), [ index, c, $stickyTable ] );
				}
			}
			// make it sticky!
			$xScroll.add($yScroll)
				.unbind( ('scroll resize '.split(' ').join( namespace )).replace(/\s+/g, ' ') )
				.bind('scroll resize '.split(' ').join( namespace ), function( event ) {
					scrollSticky( event.type === 'resize' );
				});
			c.$table
				.unbind('stickyHeadersUpdate' + namespace)
				.bind('stickyHeadersUpdate' + namespace, function() {
					scrollSticky( true );
				});

			if (wo.stickyHeaders_addResizeEvent) {
				ts.addHeaderResizeEvent(table);
			}

			// look for filter widget
			if ($table.hasClass('hasFilters') && wo.filter_columnFilters) {
				// scroll table into view after filtering, if sticky header is active - #482
				$table.bind('filterEnd' + namespace, function() {
					// $(':focus') needs jQuery 1.6+
					var $td = $(document.activeElement).closest('td'),
						column = $td.parent().children().index($td);
					// only scroll if sticky header is active
					if ($stickyWrap.hasClass(ts.css.stickyVis) && wo.stickyHeaders_filteredToTop) {
						// scroll to original table (not sticky clone)
						window.scrollTo(0, $table.position().top);
						// give same input/select focus; check if c.$filters exists; fixes #594
						if (column >= 0 && c.$filters) {
							c.$filters.eq(column).find('a, select, input').filter(':visible').focus();
						}
					}
				});
				ts.filter.bindSearch( $table, $stickyCells.find('.' + ts.css.filter) );
				// support hideFilters
				if (wo.filter_hideFilters) {
					ts.filter.hideFilters(c, $stickyTable);
				}
			}

			// resize table (Firefox)
			if (wo.stickyHeaders_addResizeEvent) {
				$table.bind('resize' + c.namespace + 'stickyheaders', function() {
					resizeHeader();
				});
			}

			// make sure sticky is visible if page is partially scrolled
			scrollSticky( true );
			$table.triggerHandler('stickyHeadersInit');

		},
		remove: function(table, c, wo) {
			var namespace = c.namespace + 'stickyheaders ';
			c.$table
				.removeClass('hasStickyHeaders')
				.unbind( ('pagerComplete resize filterEnd stickyHeadersUpdate '.split(' ').join(namespace)).replace(/\s+/g, ' ') )
				.next('.' + ts.css.stickyWrap).remove();
			if (wo.$sticky && wo.$sticky.length) { wo.$sticky.remove(); } // remove cloned table
			$(window)
				.add(wo.stickyHeaders_xScroll)
				.add(wo.stickyHeaders_yScroll)
				.add(wo.stickyHeaders_attachTo)
				.unbind( ('scroll resize '.split(' ').join(namespace)).replace(/\s+/g, ' ') );
			ts.addHeaderResizeEvent(table, true);
		}
	});

})(jQuery, window);

/*! Widget: resizable - updated 2018-03-26 (v2.30.2) */
/*jshint browser:true, jquery:true, unused:false */
;(function ($, window) {
	'use strict';
	var ts = $.tablesorter || {};

	$.extend(ts.css, {
		resizableContainer : 'tablesorter-resizable-container',
		resizableHandle    : 'tablesorter-resizable-handle',
		resizableNoSelect  : 'tablesorter-disableSelection',
		resizableStorage   : 'tablesorter-resizable'
	});

	// Add extra scroller css
	$(function() {
		var s = '<style>' +
			'body.' + ts.css.resizableNoSelect + ' { -ms-user-select: none; -moz-user-select: -moz-none;' +
				'-khtml-user-select: none; -webkit-user-select: none; user-select: none; }' +
			'.' + ts.css.resizableContainer + ' { position: relative; height: 1px; }' +
			// make handle z-index > than stickyHeader z-index, so the handle stays above sticky header
			'.' + ts.css.resizableHandle + ' { position: absolute; display: inline-block; width: 8px;' +
				'top: 1px; cursor: ew-resize; z-index: 3; user-select: none; -moz-user-select: none; }' +
			'</style>';
		$('head').append(s);
	});

	ts.resizable = {
		init : function( c, wo ) {
			if ( c.$table.hasClass( 'hasResizable' ) ) { return; }
			c.$table.addClass( 'hasResizable' );

			var noResize, $header, column, storedSizes, tmp,
				$table = c.$table,
				$parent = $table.parent(),
				marginTop = parseInt( $table.css( 'margin-top' ), 10 ),

			// internal variables
			vars = wo.resizable_vars = {
				useStorage : ts.storage && wo.resizable !== false,
				$wrap : $parent,
				mouseXPosition : 0,
				$target : null,
				$next : null,
				overflow : $parent.css('overflow') === 'auto' ||
					$parent.css('overflow') === 'scroll' ||
					$parent.css('overflow-x') === 'auto' ||
					$parent.css('overflow-x') === 'scroll',
				storedSizes : []
			};

			// set default widths
			ts.resizableReset( c.table, true );

			// now get measurements!
			vars.tableWidth = $table.width();
			// attempt to autodetect
			vars.fullWidth = Math.abs( $parent.width() - vars.tableWidth ) < 20;

			/*
			// Hacky method to determine if table width is set to 'auto'
			// http://stackoverflow.com/a/20892048/145346
			if ( !vars.fullWidth ) {
				tmp = $table.width();
				$header = $table.wrap('<span>').parent(); // temp variable
				storedSizes = parseInt( $table.css( 'margin-left' ), 10 ) || 0;
				$table.css( 'margin-left', storedSizes + 50 );
				vars.tableWidth = $header.width() > tmp ? 'auto' : tmp;
				$table.css( 'margin-left', storedSizes ? storedSizes : '' );
				$header = null;
				$table.unwrap('<span>');
			}
			*/

			if ( vars.useStorage && vars.overflow ) {
				// save table width
				ts.storage( c.table, 'tablesorter-table-original-css-width', vars.tableWidth );
				tmp = ts.storage( c.table, 'tablesorter-table-resized-width' ) || 'auto';
				ts.resizable.setWidth( $table, tmp, true );
			}
			wo.resizable_vars.storedSizes = storedSizes = ( vars.useStorage ?
				ts.storage( c.table, ts.css.resizableStorage ) :
				[] ) || [];
			ts.resizable.setWidths( c, wo, storedSizes );
			ts.resizable.updateStoredSizes( c, wo );

			wo.$resizable_container = $( '<div class="' + ts.css.resizableContainer + '">' )
				.css({ top : marginTop })
				.insertBefore( $table );
			// add container
			for ( column = 0; column < c.columns; column++ ) {
				$header = c.$headerIndexed[ column ];
				tmp = ts.getColumnData( c.table, c.headers, column );
				noResize = ts.getData( $header, tmp, 'resizable' ) === 'false';
				if ( !noResize ) {
					$( '<div class="' + ts.css.resizableHandle + '">' )
						.appendTo( wo.$resizable_container )
						.attr({
							'data-column' : column,
							'unselectable' : 'on'
						})
						.data( 'header', $header )
						.bind( 'selectstart', false );
				}
			}
			ts.resizable.bindings( c, wo );
		},

		updateStoredSizes : function( c, wo ) {
			var column, $header,
				len = c.columns,
				vars = wo.resizable_vars;
			vars.storedSizes = [];
			for ( column = 0; column < len; column++ ) {
				$header = c.$headerIndexed[ column ];
				vars.storedSizes[ column ] = $header.is(':visible') ? $header.width() : 0;
			}
		},

		setWidth : function( $el, width, overflow ) {
			// overflow tables need min & max width set as well
			$el.css({
				'width' : width,
				'min-width' : overflow ? width : '',
				'max-width' : overflow ? width : ''
			});
		},

		setWidths : function( c, wo, storedSizes ) {
			var column, $temp,
				vars = wo.resizable_vars,
				$extra = $( c.namespace + '_extra_headers' ),
				$col = c.$table.children( 'colgroup' ).children( 'col' );
			storedSizes = storedSizes || vars.storedSizes || [];
			// process only if table ID or url match
			if ( storedSizes.length ) {
				for ( column = 0; column < c.columns; column++ ) {
					// set saved resizable widths
					ts.resizable.setWidth( c.$headerIndexed[ column ], storedSizes[ column ], vars.overflow );
					if ( $extra.length ) {
						// stickyHeaders needs to modify min & max width as well
						$temp = $extra.eq( column ).add( $col.eq( column ) );
						ts.resizable.setWidth( $temp, storedSizes[ column ], vars.overflow );
					}
				}
				$temp = $( c.namespace + '_extra_table' );
				if ( $temp.length && !ts.hasWidget( c.table, 'scroller' ) ) {
					ts.resizable.setWidth( $temp, c.$table.outerWidth(), vars.overflow );
				}
			}
		},

		setHandlePosition : function( c, wo ) {
			var startPosition,
				tableHeight = c.$table.height(),
				$handles = wo.$resizable_container.children(),
				handleCenter = Math.floor( $handles.width() / 2 );

			if ( ts.hasWidget( c.table, 'scroller' ) ) {
				tableHeight = 0;
				c.$table.closest( '.' + ts.css.scrollerWrap ).children().each(function() {
					var $this = $(this);
					// center table has a max-height set
					tableHeight += $this.filter('[style*="height"]').length ? $this.height() : $this.children('table').height();
				});
			}

			if ( !wo.resizable_includeFooter && c.$table.children('tfoot').length ) {
				tableHeight -= c.$table.children('tfoot').height();
			}
			// subtract out table left position from resizable handles. Fixes #864
			// jQuery v3.3.0+ appears to include the start position with the $header.position().left; see #1544
			startPosition = parseFloat($.fn.jquery) >= 3.3 ? 0 : c.$table.position().left;
			$handles.each( function() {
				var $this = $(this),
					column = parseInt( $this.attr( 'data-column' ), 10 ),
					columns = c.columns - 1,
					$header = $this.data( 'header' );
				if ( !$header ) { return; } // see #859
				if (
					!$header.is(':visible') ||
					( !wo.resizable_addLastColumn && ts.resizable.checkVisibleColumns(c, column) )
				) {
					$this.hide();
				} else if ( column < columns || column === columns && wo.resizable_addLastColumn ) {
					$this.css({
						display: 'inline-block',
						height : tableHeight,
						left : $header.position().left - startPosition + $header.outerWidth() - handleCenter
					});
				}
			});
		},

		// Fixes #1485
		checkVisibleColumns: function( c, column ) {
			var i,
				len = 0;
			for ( i = column + 1; i < c.columns; i++ ) {
				len += c.$headerIndexed[i].is( ':visible' ) ? 1 : 0;
			}
			return len === 0;
		},

		// prevent text selection while dragging resize bar
		toggleTextSelection : function( c, wo, toggle ) {
			var namespace = c.namespace + 'tsresize';
			wo.resizable_vars.disabled = toggle;
			$( 'body' ).toggleClass( ts.css.resizableNoSelect, toggle );
			if ( toggle ) {
				$( 'body' )
					.attr( 'unselectable', 'on' )
					.bind( 'selectstart' + namespace, false );
			} else {
				$( 'body' )
					.removeAttr( 'unselectable' )
					.unbind( 'selectstart' + namespace );
			}
		},

		bindings : function( c, wo ) {
			var namespace = c.namespace + 'tsresize';
			wo.$resizable_container.children().bind( 'mousedown', function( event ) {
				// save header cell and mouse position
				var column,
					vars = wo.resizable_vars,
					$extras = $( c.namespace + '_extra_headers' ),
					$header = $( event.target ).data( 'header' );

				column = parseInt( $header.attr( 'data-column' ), 10 );
				vars.$target = $header = $header.add( $extras.filter('[data-column="' + column + '"]') );
				vars.target = column;

				// if table is not as wide as it's parent, then resize the table
				vars.$next = event.shiftKey || wo.resizable_targetLast ?
					$header.parent().children().not( '.resizable-false' ).filter( ':last' ) :
					$header.nextAll( ':not(.resizable-false)' ).eq( 0 );

				column = parseInt( vars.$next.attr( 'data-column' ), 10 );
				vars.$next = vars.$next.add( $extras.filter('[data-column="' + column + '"]') );
				vars.next = column;

				vars.mouseXPosition = event.pageX;
				ts.resizable.updateStoredSizes( c, wo );
				ts.resizable.toggleTextSelection(c, wo, true );
			});

			$( document )
				.bind( 'mousemove' + namespace, function( event ) {
					var vars = wo.resizable_vars;
					// ignore mousemove if no mousedown
					if ( !vars.disabled || vars.mouseXPosition === 0 || !vars.$target ) { return; }
					if ( wo.resizable_throttle ) {
						clearTimeout( vars.timer );
						vars.timer = setTimeout( function() {
							ts.resizable.mouseMove( c, wo, event );
						}, isNaN( wo.resizable_throttle ) ? 5 : wo.resizable_throttle );
					} else {
						ts.resizable.mouseMove( c, wo, event );
					}
				})
				.bind( 'mouseup' + namespace, function() {
					if (!wo.resizable_vars.disabled) { return; }
					ts.resizable.toggleTextSelection( c, wo, false );
					ts.resizable.stopResize( c, wo );
					ts.resizable.setHandlePosition( c, wo );
				});

			// resizeEnd event triggered by scroller widget
			$( window ).bind( 'resize' + namespace + ' resizeEnd' + namespace, function() {
				ts.resizable.setHandlePosition( c, wo );
			});

			// right click to reset columns to default widths
			c.$table
				.bind( 'columnUpdate pagerComplete resizableUpdate '.split( ' ' ).join( namespace + ' ' ), function() {
					ts.resizable.setHandlePosition( c, wo );
				})
				.bind( 'resizableReset' + namespace, function() {
					ts.resizableReset( c.table );
				})
				.find( 'thead:first' )
				.add( $( c.namespace + '_extra_table' ).find( 'thead:first' ) )
				.bind( 'contextmenu' + namespace, function() {
					// $.isEmptyObject() needs jQuery 1.4+; allow right click if already reset
					var allowClick = wo.resizable_vars.storedSizes.length === 0;
					ts.resizableReset( c.table );
					ts.resizable.setHandlePosition( c, wo );
					wo.resizable_vars.storedSizes = [];
					return allowClick;
				});

		},

		mouseMove : function( c, wo, event ) {
			if ( wo.resizable_vars.mouseXPosition === 0 || !wo.resizable_vars.$target ) { return; }
			// resize columns
			var column,
				total = 0,
				vars = wo.resizable_vars,
				$next = vars.$next,
				tar = vars.storedSizes[ vars.target ],
				leftEdge = event.pageX - vars.mouseXPosition;
			if ( vars.overflow ) {
				if ( tar + leftEdge > 0 ) {
					vars.storedSizes[ vars.target ] += leftEdge;
					ts.resizable.setWidth( vars.$target, vars.storedSizes[ vars.target ], true );
					// update the entire table width
					for ( column = 0; column < c.columns; column++ ) {
						total += vars.storedSizes[ column ];
					}
					ts.resizable.setWidth( c.$table.add( $( c.namespace + '_extra_table' ) ), total );
				}
				if ( !$next.length ) {
					// if expanding right-most column, scroll the wrapper
					vars.$wrap[0].scrollLeft = c.$table.width();
				}
			} else if ( vars.fullWidth ) {
				vars.storedSizes[ vars.target ] += leftEdge;
				vars.storedSizes[ vars.next ] -= leftEdge;
				ts.resizable.setWidths( c, wo );
			} else {
				vars.storedSizes[ vars.target ] += leftEdge;
				ts.resizable.setWidths( c, wo );
			}
			vars.mouseXPosition = event.pageX;
			// dynamically update sticky header widths
			c.$table.triggerHandler('stickyHeadersUpdate');
		},

		stopResize : function( c, wo ) {
			var vars = wo.resizable_vars;
			ts.resizable.updateStoredSizes( c, wo );
			if ( vars.useStorage ) {
				// save all column widths
				ts.storage( c.table, ts.css.resizableStorage, vars.storedSizes );
				ts.storage( c.table, 'tablesorter-table-resized-width', c.$table.width() );
			}
			vars.mouseXPosition = 0;
			vars.$target = vars.$next = null;
			// will update stickyHeaders, just in case, see #912
			c.$table.triggerHandler('stickyHeadersUpdate');
			c.$table.triggerHandler('resizableComplete');
		}
	};

	// this widget saves the column widths if
	// $.tablesorter.storage function is included
	// **************************
	ts.addWidget({
		id: 'resizable',
		priority: 40,
		options: {
			resizable : true, // save column widths to storage
			resizable_addLastColumn : false,
			resizable_includeFooter: true,
			resizable_widths : [],
			resizable_throttle : false, // set to true (5ms) or any number 0-10 range
			resizable_targetLast : false
		},
		init: function(table, thisWidget, c, wo) {
			ts.resizable.init( c, wo );
		},
		format: function( table, c, wo ) {
			ts.resizable.setHandlePosition( c, wo );
		},
		remove: function( table, c, wo, refreshing ) {
			if (wo.$resizable_container) {
				var namespace = c.namespace + 'tsresize';
				c.$table.add( $( c.namespace + '_extra_table' ) )
					.removeClass('hasResizable')
					.children( 'thead' )
					.unbind( 'contextmenu' + namespace );

				wo.$resizable_container.remove();
				ts.resizable.toggleTextSelection( c, wo, false );
				ts.resizableReset( table, refreshing );
				$( document ).unbind( 'mousemove' + namespace + ' mouseup' + namespace );
			}
		}
	});

	ts.resizableReset = function( table, refreshing ) {
		$( table ).each(function() {
			var index, $t,
				c = this.config,
				wo = c && c.widgetOptions,
				vars = wo.resizable_vars;
			if ( table && c && c.$headerIndexed.length ) {
				// restore the initial table width
				if ( vars.overflow && vars.tableWidth ) {
					ts.resizable.setWidth( c.$table, vars.tableWidth, true );
					if ( vars.useStorage ) {
						ts.storage( table, 'tablesorter-table-resized-width', vars.tableWidth );
					}
				}
				for ( index = 0; index < c.columns; index++ ) {
					$t = c.$headerIndexed[ index ];
					if ( wo.resizable_widths && wo.resizable_widths[ index ] ) {
						ts.resizable.setWidth( $t, wo.resizable_widths[ index ], vars.overflow );
					} else if ( !$t.hasClass( 'resizable-false' ) ) {
						// don't clear the width of any column that is not resizable
						ts.resizable.setWidth( $t, '', vars.overflow );
					}
				}

				// reset stickyHeader widths
				c.$table.triggerHandler( 'stickyHeadersUpdate' );
				if ( ts.storage && !refreshing ) {
					ts.storage( this, ts.css.resizableStorage, [] );
				}
			}
		});
	};

})( jQuery, window );

/*! Widget: saveSort - updated 2018-03-19 (v2.30.1) *//*
* Requires tablesorter v2.16+
* by Rob Garrison
*/
;(function ($) {
	'use strict';
	var ts = $.tablesorter || {};

	function getStoredSortList(c) {
		var stored = ts.storage( c.table, 'tablesorter-savesort' );
		return (stored && stored.hasOwnProperty('sortList') && $.isArray(stored.sortList)) ? stored.sortList : [];
	}

	function sortListChanged(c, sortList) {
		return (sortList || getStoredSortList(c)).join(',') !== c.sortList.join(',');
	}

	// this widget saves the last sort only if the
	// saveSort widget option is true AND the
	// $.tablesorter.storage function is included
	// **************************
	ts.addWidget({
		id: 'saveSort',
		priority: 20,
		options: {
			saveSort : true
		},
		init: function(table, thisWidget, c, wo) {
			// run widget format before all other widgets are applied to the table
			thisWidget.format(table, c, wo, true);
		},
		format: function(table, c, wo, init) {
			var time,
				$table = c.$table,
				saveSort = wo.saveSort !== false, // make saveSort active/inactive; default to true
				sortList = { 'sortList' : c.sortList },
				debug = ts.debug(c, 'saveSort');
			if (debug) {
				time = new Date();
			}
			if ($table.hasClass('hasSaveSort')) {
				if (saveSort && table.hasInitialized && ts.storage && sortListChanged(c)) {
					ts.storage( table, 'tablesorter-savesort', sortList );
					if (debug) {
						console.log('saveSort >> Saving last sort: ' + c.sortList + ts.benchmark(time));
					}
				}
			} else {
				// set table sort on initial run of the widget
				$table.addClass('hasSaveSort');
				sortList = '';
				// get data
				if (ts.storage) {
					sortList = getStoredSortList(c);
					if (debug) {
						console.log('saveSort >> Last sort loaded: "' + sortList + '"' + ts.benchmark(time));
					}
					$table.bind('saveSortReset', function(event) {
						event.stopPropagation();
						ts.storage( table, 'tablesorter-savesort', '' );
					});
				}
				// init is true when widget init is run, this will run this widget before all other widgets have initialized
				// this method allows using this widget in the original tablesorter plugin; but then it will run all widgets twice.
				if (init && sortList && sortList.length > 0) {
					c.sortList = sortList;
				} else if (table.hasInitialized && sortList && sortList.length > 0) {
					// update sort change
					if (sortListChanged(c, sortList)) {
						ts.sortOn(c, sortList);
					}
				}
			}
		},
		remove: function(table, c) {
			c.$table.removeClass('hasSaveSort');
			// clear storage
			if (ts.storage) { ts.storage( table, 'tablesorter-savesort', '' ); }
		}
	});

})(jQuery);
return jQuery.tablesorter;}));


/* -------------------------------------------------------------------------------------------------- */
/* jquery-tablesorter-widgets-widget-staticRow.js */
/* File: js/machinata-core-bundle.js/jquery-tablesorter-widgets-widget-staticRow.js */
/* -------------------------------------------------------------------------------------------------- */

/*
 * StaticRow widget for jQuery TableSorter 2.0
 * Version 1.2 - modified by Rob Garrison (6/28/2014 for tablesorter v2.16.1-beta+)
 * Requires:
 *  jQuery v1.4+
 *  tablesorter plugin, v2.8+, available at http://mottie.github.com/tablesorter/docs/
 *
 * Copyright (c) 2011 Nils Luxton
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */
/*jshint browser:true, jquery:true, unused:false */
/*global jQuery: false */
;(function($){
"use strict";
var ts = $.tablesorter,

// events triggered on the table that update this widget
events = 'staticRowsRefresh updateComplete '.split(' ').join('.tsstaticrows '),

// add/refresh row indexes
addIndexes = function(table){
	var $tr, wo, v, indx, rows,
		c = table.config;
	// "Index" the static rows, saving their current (starting) position in the
	// table inside a data() param on the <tr> element itself for later use.
	if (c) {
		wo = c.widgetOptions;
		c.$tbodies.each(function(){
			$tr = $(this).children();
			rows = $tr.length;
			$tr.filter(wo.staticRow_class).each(function() {
				$tr = $(this);
				indx = $tr.data(wo.staticRow_index);
				if (typeof indx !== "undefined") {
					v = parseFloat(indx);
					// percentage of total rows
					indx = (/%/.test(indx)) ? Math.round(v/100 * rows) : v;
				} else {
					indx = $tr.index();
				}
				// row indexing starts over within each tbody
				$tr.data( wo.staticRow_data, indx );
			});
		});
	}
};

ts.addWidget({
	// Give the new Widget an ID to be used in the tablesorter() call, as follows:
	// $('#myElement').tablesorter({ widgets: ['zebra', 'staticRow'] });
	id: 'staticRow',

	options: {
		staticRow_class : '.static',
		staticRow_data  : 'static-index',
		staticRow_index : 'row-index'
	},

	init: function(table, thisWidget, c, wo){
		addIndexes(table);
		// refresh static rows after updates
		c.$table
			.unbind(events)
			.bind(events, function(){
				addIndexes(table);
				c.$table.trigger('applyWidgets');
			});
	},

	format: function(table, c, wo) {
		// Loop thru static rows, moving them to their original "indexed" position,
		// & repeat until no more re-shuffling is needed
		var targetIndex, $thisRow, indx, numRows, $tbody, hasShuffled, $rows, max;

		c.$tbodies.each(function(){
			$tbody = $.tablesorter.processTbody(table, $(this), true); // remove tbody
			hasShuffled = true;
			indx = 0;
			$rows = $tbody.children(wo.staticRow_class);
			numRows = $tbody.children('tr').length - 1;
			max = $rows.length;

			// don't allow the while loop to cycle more times than the set number of static rows
			while (hasShuffled && indx < max) {
				hasShuffled = false;
				/*jshint loopfunc:true */
				$rows.each(function() {
					targetIndex = $(this).data(wo.staticRow_data);
					// allow setting target index >> num rows to always make a row last
					targetIndex = targetIndex >= numRows ? numRows : targetIndex < 0 ? 0 : targetIndex;
					if (targetIndex !== $(this).index()) {
						hasShuffled = true;
						$thisRow = $(this).detach();

						if (targetIndex >= numRows) {
							// Are we trying to be the last row?
							$thisRow.appendTo( $tbody );
						} else if (targetIndex === 0) {
								// Are we trying to be the first row?
								$thisRow.prependTo( $tbody );
						} else {
							// No, we want to be somewhere in the middle!
							$thisRow.insertBefore( $tbody.find('tr:eq(' + targetIndex + ')') );
						}
					}
				});
				indx++;
			}

			$.tablesorter.processTbody(table, $tbody, false); // restore tbody
		});

		c.$table.trigger('staticRowsComplete', table);
	},

	remove : function(table, c, wo){
		c.$table.unbind(events);
	}

});

})(jQuery);

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core.js */
/* Copyright 2021 Dan Krusi / Nerves GmbH */
/* License: Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International (CC BY-NC-SA 4.0) */
/* Link: https://nerves.ch */
/* File: js/machinata-core-bundle.js/machinata-core.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */


/// <summary>
/// Machinata Core JS Library
///
/// A extensive Javscript library that provides rapid web development and aligns nicely
/// with the Machinata Server.
///
/// All modules should be mounted on this namespace.
/// </summary>
/// <namespace></namespace>
/// <name>Machinata</name>
/// <type>namespace</type>


/* ======== Globals ========================================================== */

/// <summary>
/// Main debug switch. Is automatically enabled with ?debug=true
/// Deprecated: use MACHINATA_GLOBAL.MACHINATA_DEBUG_ENABLED instead
/// </summary>
/// <deprecated/>
/// <hidden/>
/// <namespace>Machinata</namespace>
/// <name>DebugEnabled</name>
Machinata.DebugEnabled = MACHINATA_GLOBAL.MACHINATA_DEBUG_ENABLED;

/* ======== Debugging Functions ========================================================== */

/// <summary>
/// Debug output to console, but only if debug is enabled.
/// </summary>
Machinata.debug = function (str1, str2, str3, str4) {
    if (Machinata.DebugEnabled == false) return; // so that it can be compiled away completely...
    if(str4 != null) console.log(str1, str2, str3, str4);
    else if(str3 != null) console.log(str1, str2, str3);
    else if(str2 != null) console.log(str1, str2);
    else console.log(str1);
};

/// <summary>
/// Warning output to console.
/// </summary>
Machinata.warning = function (str1, str2) {
    if (str2 != null) console.log("WARNING: " + str1 + " " + str2);
    else console.log("WARNING: " + str1);
};

/// <summary>
/// Shorthand for debug of object data
/// </summary>
Machinata.echo = function (data) {
    alert(JSON.stringify(data));
};

/// <summary>
/// Util method for a void function that does nothing.
/// </summary>
Machinata.noop = function () {};



/* ======== Helper Functions ========================================================== */

/// <summary>
/// Given a string, a full function name is automatically resolved.
/// For example, Machinata.UI.xyz would return xyz function object, bound to Machinata.UI object.
/// </summary>
Machinata.unpackScopedFunctionByName = function (string) {
    var scope = window;
    var scopeSplit = string.split('.');
    for (var i = 0; i < scopeSplit.length - 1; i++) {
        scope = scope[scopeSplit[i]];
        if (scope == undefined) return;
    }
    return scope[scopeSplit[scopeSplit.length - 1]];
};

/// <summary>
/// Automatically processes a callback string
/// Callback strings can either be paths to resources (such as
/// a page) specified by a starting slash (/),
/// or an actually function
/// Callback strings are automatically parsed for variables
/// contained in the data object. For example, if the data object has
/// node { path = "xyz" } you can use the variable {node.path} or 
/// { data.node.path }.
/// </summary>
Machinata.processCallback = function (callbackString, message) {
    if (callbackString == null) return;
    Machinata.debug("processCallback", callbackString);
    // Function or page?
    if (callbackString.startsWith("/")) {
        // Page
        // Process all variables
        if (message != null && message.data != null) {
            function traverse(key, jsonObj) {
                if (typeof jsonObj == "object") {
                    $.each(jsonObj, function (k, v) {
                        // k is either an array index or object key
                        var newKey = key + (key != "" ? "." : "") + k;
                        if (typeof v != "object") {
                            callbackString = callbackString.replaceAll("{" + newKey + "}", v);
                            callbackString = callbackString.replaceAll("{data." + newKey + "}", v);
                        }
                        traverse(newKey, v);
                    });
                } else {
                    // jsonOb is a number or string
                    //alert(jsonObj);
                }
            }
            traverse("", message.data);
        }
        Machinata.goToPage(callbackString);
    } else {
        // Function
        var fn = Machinata.unpackScopedFunctionByName(callbackString);
        if (typeof fn === 'function') {
            fn(message);
        } else {
            Machinata.warning("Could not processCallback for", callbackString);
        }
    }
};

/* ======== Init Routines ========================================================== */



/// <summary>
/// This is the main init routine for Machinata. It is automatically called and doesn't
/// need to be manually called.
/// </summary>
Machinata.init = function () {
    // Debug?
    if (Machinata.queryParameter("debug") == "true") {
        Machinata.DebugEnabled = true;
    }
    // Run all init routines...
    for (var i = 0; i < Machinata._onInits.length; i++) Machinata._onInits[i]();
    // Run all on ready...
    for (var i = 0; i < Machinata._onReady.length; i++) Machinata._onReady[i]();
};

Machinata._onInits = [];

/// <summary>
/// Bind a handler to the Machinata init routine.
/// Use this method to init things such as modules.
/// </summary>
/// <type>function</type>
Machinata.onInit = function (fn) {
    Machinata._onInits.push(fn);
};


Machinata._onReady = [];

/// <summary>
/// Bind a handler to the Machinata ready routine.
/// Use this method to setup things that rely on other modules and the DOM.
/// </summary>
Machinata.ready = function (fn) {
    Machinata._onReady.push(fn);
};


Machinata._onLoaded = [];

/// <summary>
/// Bind a handler to the window loaded routine.
/// </summary>
Machinata.loaded = function (fn) {
    Machinata._onLoaded.push(fn);
};


Machinata._doOnce = {};

/// <summary>
/// Execute a function only once for the given id.
/// A second call using the same id is ignored.
/// </summary>
Machinata.doOnce = function (id, fn) {
    if (Machinata._doOnce[id] == true) return;
    Machinata._doOnce[id] = true;
    fn();
};


/* ======== API Functions ========================================================== */

/// <summary>
/// Class for handling a standard AJAX API call to a Machinata server.
/// </summary>
/// <type>class</type>
var APICall = function (call, data, method) {
    this.call = call;
    this._data = data;
    this.dataType = "json";
    this.contentType = "application/x-www-form-urlencoded; charset=UTF-8"; // by default we send form encoded key/vals
    this.method = method;
    this._files = null;
    this._rawFiles = null; // native javascript File objects
    this._onSuccesses = [];
    this._onErrors = [];
    this._onProgresses = [];
};

/// <summary>
/// 
/// </summary>
APICall.prototype.success = function (onSuccessFunction) {
    this._onSuccesses.push(onSuccessFunction);
    return this;
};

/// <summary>
/// 
/// </summary>
APICall.prototype.error = function (onErrorFunction) {
    this._onErrors.push(onErrorFunction);
    return this;
};

/// <summary>
/// 
/// </summary>
APICall.prototype.progress = function (onProgressFunction) {
    this._onProgresses.push(onProgressFunction);
    return this;
};

/// <summary>
/// 
/// </summary>
APICall.prototype.genericError = function () {
    this.error(function (message) {
        Machinata.apiError(message.data.code, message.data.message, message);
    });
    return this;
};

/// <summary>
/// 
/// </summary>
APICall.prototype.send = function () {
    return this.process();
};

/// <summary>
/// 
/// </summary>
APICall.prototype.data = function (data) {
    this._data = data;
    return this;
};

/// <summary>
/// 
/// </summary>
APICall.prototype.json = function (data) {
    this._data = JSON.stringify(data);
    this.contentType = "application/json"; //TODO: charset?? + "; charset=UTF-8"
    return this;
};

/// <summary>
/// Attaches a file using a native html file input element.
/// </summary>
APICall.prototype.attachFileInput = function (object, name, filename) {
    if (this._files == null) this._files = [];
    var file = {};
    file.object = object;
    file.name = name;
    file.filename = filename;
    this._files.push(file);
    return this;
};

/// <summary>
/// Attaches a file using a native javascript File object.
/// </summary>
APICall.prototype.attachFileObject = function (fileObject) {
    if (this._rawFiles == null) this._rawFiles = [];
    this._rawFiles.push(fileObject);
    return this;
};

/// <summary>
/// Attaches a file by automatically creating and invoking a file input elem.
/// </summary>
APICall.prototype.attachFileAndSend = function (inputAccept) {
    var self = this;
    if (inputAccept == null) inputAccept = "*";
    var inputElem = $("<input type='file' accept='" + inputAccept + "' style='position:absolute;left:-10000px;top:0px;'/>");
    $("body").append(inputElem);
    inputElem.on("change", function () {
        // Attach file to call and send
        var fileNative = $(this)[0];
        //self.attachFileInput(fileNative.files[0], name, fileNative.files[0].name);
        self.attachFileInput(fileNative.files[0], null, fileNative.files[0].name);
        self.send();
    });
    inputElem.trigger("click");
    return this;
};

/// <summary>
/// 
/// </summary>
APICall.prototype.process = function () {
    Machinata.showLoading(true);

    // Get data type
    if (this.dataType == null) this.dataType = "json"; // default
    if (this.method == null) this.method = "POST"; // default

    // Compile url
    var url = this.call;
    //if (authToken != null && authToken != "") url += "&auth-token=" + authToken;
    Machinata.debug("APICall.process() url=" + url + " method=" + this.method);

    // Set language, if not already
    if (this._data == null) this._data = {};
    if (this._data["lang"] == null) {
        this._data["lang"] = "en";
    }
    // Create new data object
    // Per default we use standard jquery processData = true,
    // but if we have a file we create our own HTML FormData object
    var formData = this._data;
    var processData = true;
    var contentType = this.contentType;
    var dataType = this.dataType;
    if (this._files != null || this._rawFiles != null) {
        var formData = new FormData();
        for (var key in this._data) {
            formData.append(key, this._data[key]);
        }
        if (this._files != null) {
            for (var i = 0; i < this._files.length; i++) {
                formData.append(this._files[i].name, this._files[i].object, this._files[i].filename);
            }
        }
        if (this._rawFiles != null) {
            for (var i = 0; i < this._rawFiles.length; i++) {
                formData.append("file",this._rawFiles[i]);
            }
        }
        dataType = null;
        processData = false;
        contentType = false;
    }

    // Send off request
    var self = this;
    $.ajax({
        type: self.method,
        url: url,
        data: formData,
        cache: false,
        traditional: true,
        processData: processData,
        contentType: contentType,
        success: function (message) {
            Machinata.showLoading(false);
            if (self.dataType == "html") {
                Machinata.debug("API success");
                for (var i = 0; i < self._onSuccesses.length; i++) self._onSuccesses[i](message);
            } else if (message) {
                Machinata.debug("API success: " + message.type);
                for (var i = 0; i < self._onSuccesses.length; i++) self._onSuccesses[i](message);
            } else {
                Machinata.apiError("response-message-null", "No message was recieved from server.");
            }
        },
        error: function (xhr, status, errorThrown) {
            Machinata.showLoading(false);
            Machinata.debug("API error: " + errorThrown);
            // Server error
            var message;
            try {
                message = JSON.parse(xhr.responseText);
            } catch (jsonError) {
                if (self._onErrors.length > 0) {
                    for (var i = 0; i < self._onErrors.length; i++) self._onErrors[i]({ type: "error", data: { code: "invalid-response", message: "The server did not respond." } });
                } else {
                    Machinata.apiError("invalid-response", "The server did not respond.");
                }
                return self;
            }
            //TODO: what if the server responds with non-JSON error?
            if (Machinata.error401Handler != null && xhr.status == 401) {
                Machinata.error401Handler(message.data.code, message.data.message, self);
            } else {
                if (self._onErrors.length > 0) {
                    for (var i = 0; i < self._onErrors.length; i++) self._onErrors[i](message);
                } else {
                    // Show generic error
                    Machinata.apiError(message.data.code, message.data.message, self);
                }
            }
        },
        dataType: dataType
    }).uploadProgress(function(e) {
        if (e.lengthComputable && self._onProgresses.length > 0) {
            var percentage = Math.round((e.loaded * 100) / e.total);
            Machinata.debug("APICall.uploadProgress " + percentage);
            for (var i = 0; i < self._onProgresses.length; i++) self._onProgresses[i](percentage);
        }
    });
    return this;
};


/// <summary>
/// Shorthand method for creating a API call object.
/// </summary>
Machinata.apiCall = function (call, data, method) {
    Machinata.debug("apiCall(" + call + "," + JSON.stringify(data) + ")");
    var apiCall = new APICall(call, data, method);
    return apiCall;
};


/* ======== API Errors ========================================================== */

/// <summary>
/// Standardized handling of generic API call errors.
/// </summary>
Machinata.apiErrorForGeneric = function (code, message, data) {
    Machinata.apiError(code, message, data);
};

/// <summary>
/// Standardized handling of API call errors.
/// </summary>
Machinata.apiError = function (code, message, data) {
    Machinata.debug("apiError: " + code + ": " + message);
    Machinata.errorHandler(code, message, data);
};

/* ======== Error Handler ========================================================== */

/// <summary>
/// Standardized error message.
/// </summary>
Machinata.genericError = function (code, message) {
    Machinata.errorHandler(code, message, null);
};

/// <summary>
/// Provides a standard and universal out-of-the-box error handler.
/// </summary>
Machinata.errorHandler = function (code, message, data) {
    Machinata.debug("errorHandler: " + code + ": " + message);
    var diag = Machinata.messageDialog("Error", message + " (" + code + ")");
    if (data != null && data.data != null && data.data.stacktrace != null) {
        diag.button("Details");
        diag.button("Okay");
    }
    diag.okay(function (id) {
        if (id == "details") {
            var diag2 = Machinata.messageDialog("Error Details", data.data.stacktrace + "<br/>" + data.data.logtrace)
            diag2.design("wide");
            diag2.show();
        }
    });
    diag.show();
};

/// <summary>
/// Provides a mechanism to handle 401 (unauthorized) errors for a projects.
/// For example: you can implement this method to call up a signup/login form
/// on a 401 error caused by a API call.
/// Parameters: 
///     Machinata.error401Handler = function (code, message, apiCall) { your code };
/// </summary>
Machinata.error401Handler = null;

/* ======== Basic UI ========================================================== */

/// <summary>
/// Make the body register a loading state.
/// Call this any time a routine is causing a UI to wait or block.
/// </summary>
Machinata.showLoading = function (show) {
    if (show == true) $("body").addClass("loading");
    else $("body").removeClass("loading");
};

/// <summary>
/// Navigate to a page. This method handles a loading state automatically for
/// leaving a page via a link (for example) and then navigating back via the back button.
/// </summary>
Machinata.goToPage = function (page, showLoading) {
    if (showLoading != false) {
        if (!$("body").hasClass("bb-window-blur-bound")) {
            $(window).on("blur", function () {
                Machinata.showLoading(false);
            });
            $("body").addClass("bb-window-blur-bound");
        }
        Machinata.showLoading(true);
    }
    window.location = page;
};

/// <summary>
/// Open a page in a new window.
/// </summary>
Machinata.openPage = function (page) {
    window.open(page, '_blank');
};

/// <summary>
/// Navigates back a page
/// </summary>
Machinata.backAPage = function (page) {
    window.history.back();
};

/// <summary>
/// Do something after a delay in milliseconds.
/// </summary>
Machinata.delay = function (ms, fn) {
    var self = this;
    setTimeout(function () {
        if (fn) fn();
        return self;
    }, ms);
};

/// <summary>
/// Shorthand for calling a function safely if it exists.
/// You can pass null without raising an exception.
/// </summary>
Machinata["do"] = function (fn) {  // Note do is reserved Ecma keyword
    if (fn) fn();
    return this;
};

/// <summary>
/// Reloads the current page.
/// </summary>
Machinata.reload = function (soft) {
    if (soft == true) {
        Machinata.showLoading(true);
        Machinata.changeQueryString("reload-guid", Machinata.guid());
    } else {
        Machinata.showLoading(true);
        document.location.reload();
    }
};

/* ========  Functions ========================================================== */

/// <summary>
/// Returns a key value objection with build information.
/// </summary>
/// <example>
/// ```
/// {
///     id: "a18829bfc0feaa0e99aeb24f53d6fb445413598551ef351806e6903cb1ab7019",
///     date: "02.09.2019 13:17 UTC",
///     timestamp: "2019-09-02T13:15:41.1500000Z",
///     user: "username",
///     machine: "MACHINE"
/// }
///  ```
/// </example>
Machinata.buildInfo = function () {
    return {
        id: "941a6590-3a33-4a37-97eb-662c9cabda58",
        version: "1.0.7859.25662",
        date: "19.07.2021 12:54 UTC",
        timestamp: "2021-07-15T12:48:33.0000000Z",
        user: "Micha Aprile",
        machine: "BRODIE",
        profile: "reactjs"
    };
};


/// <summary>
/// Returns a GUID using Math.random()
/// </summary>
Machinata.guid = function () {
    var lut = []; for (var i = 0; i < 256; i++) { lut[i] = (i < 16 ? '0' : '') + (i).toString(16); }
    var d0 = Math.random() * 0xffffffff | 0;
    var d1 = Math.random() * 0xffffffff | 0;
    var d2 = Math.random() * 0xffffffff | 0;
    var d3 = Math.random() * 0xffffffff | 0;
    return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' +
      lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' +
      lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] +
      lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
};

/// <summary>
/// Retrieves a single query parameter from the query string.
/// </summary>
Machinata.queryParameter = function (name) {
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(window.location.search);
    if (results == null) return "";
    else return decodeURIComponent(results[1].replace(/\+/g, " "));
};

/// <summary>
/// Returns true if a query parameters is not null or empty string.
/// </summary>
Machinata.hasQueryParameter = function (name) {
    var ret = Machinata.queryParameter(name);
    if (ret != null && ret != "") return true;
};

/// <summary>
/// Retrieves a single query parameter from the a URL.
/// </summary>
Machinata.queryParameterFromURL = function (name,url) {
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(url);
    if (results == null) return "";
    else return decodeURIComponent(results[1].replace(/\+/g, " "));
};

/// <summary>
/// Changes or switches a single parameter in the query string.
/// If no URL is provided, then the current URL is used.
/// The new URL is navigated to.
/// </summary>
Machinata.changeQueryString = function (key, value, url) {
    Machinata.showLoading(true);
    if (!url) url = window.location.href;
    window.location.href = Machinata.updateQueryString(key, value, url);
};

/// <summary>
/// Updates a query string parameter without navigating away from the page.
/// </summary>
Machinata.updateQueryString = function (key, value, url) {
    if (typeof value !== 'undefined' && value !== null) value = encodeURIComponent(value);
    if (!url) url = window.location.href;
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi");
    if (re.test(url)) {
        if (typeof value !== 'undefined' && value !== null)
            return url.replace(re, '$1' + key + "=" + value + '$2$3');
        else {
            var hash = url.split('#');
            url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
            if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                url += '#' + hash[1];
            return url;
        }
    } else {
        if (typeof value !== 'undefined' && value !== null) {
            var separator = url.indexOf('?') !== -1 ? '&' : '?',
                hash = url.split('#');
            url = hash[0] + separator + key + '=' + value;
            if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                url += '#' + hash[1];
            return url;
        }
        else
            return url;
    }
};

/// <summary>
/// Removes a parameter from a URL.
/// </summary>
Machinata.removeQueryParameter = function (key, url) {
    if (!url) url = window.location.href;
    var rtn = url.split("?")[0],
        param,
        params_arr = [],
        queryString = (url.indexOf("?") !== -1) ? url.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        if (params_arr.length > 0) {
            rtn = rtn + "?" + params_arr.join("&");
        }
    }
    return rtn;
};


/// <summary>
/// Returns a string array list of all query parameters.
/// If no parametes, returns empty array.
/// </summary>
Machinata.getAllQueryParameter = function (url, filter) {
    if (!url) url = window.location.href;
    var rtn = url.split("?")[0],
        param,
        params_arr = [],
        queryString = (url.indexOf("?") !== -1) ? url.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        var ret = [];
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (filter == null || param.startsWith(filter)) {
                ret.push(param);
            }
        }
        return ret;
    }
    return []; // empty
};


/// <summary>
/// Returns only the path portion of the current page URL.
/// </summary>
Machinata.getPagePath = function (url) {
    if (!url) url = window.location.href;
    return url.split('?')[0].split('#')[0]; //TODO: is this safe on all browsers?
};




/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-constants.js */
/* File: js/machinata-core-bundle.js/machinata-core-constants.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/* ======== Machinata Constants ======== */

/// <summary>
/// All countries
/// </summary>
Machinata.COUNTRIES = [{"name":"Afghanistan","code":"af"},{"name":"Åland Islands","code":"ax"},{"name":"Albania","code":"al"},{"name":"Algeria","code":"dz"},{"name":"American Samoa","code":"as"},{"name":"Andorra","code":"ad"},{"name":"Angola","code":"ao"},{"name":"Anguilla","code":"ai"},{"name":"Antarctica","code":"aq"},{"name":"Antigua and Barbuda","code":"ag"},{"name":"Argentina","code":"ar"},{"name":"Armenia","code":"am"},{"name":"Aruba","code":"aw"},{"name":"Australia","code":"au"},{"name":"Austria","code":"at"},{"name":"Azerbaijan","code":"az"},{"name":"Bahamas","code":"bs"},{"name":"Bahrain","code":"bh"},{"name":"Bangladesh","code":"bd"},{"name":"Barbados","code":"bb"},{"name":"Belarus","code":"by"},{"name":"Belgium","code":"be"},{"name":"Belize","code":"bz"},{"name":"Benin","code":"bj"},{"name":"Bermuda","code":"bm"},{"name":"Bhutan","code":"bt"},{"name":"Bolivia","code":"bo"},{"name":"Bosnia and Herzegovina","code":"ba"},{"name":"Botswana","code":"bw"},{"name":"Bouvet Island","code":"bv"},{"name":"Brazil","code":"br"},{"name":"British Indian Ocean Territory","code":"io"},{"name":"Brunei Darussalam","code":"bn"},{"name":"Bulgaria","code":"bg"},{"name":"Burkina Faso","code":"bf"},{"name":"Burundi","code":"bi"},{"name":"Cambodia","code":"kh"},{"name":"Cameroon","code":"cm"},{"name":"Canada","code":"ca"},{"name":"Cape Verde","code":"cv"},{"name":"Cayman Islands","code":"ky"},{"name":"Central African Republic","code":"cf"},{"name":"Chad","code":"td"},{"name":"Chile","code":"cl"},{"name":"China","code":"cn"},{"name":"Christmas Island","code":"cx"},{"name":"Cocos (Keeling) Islands","code":"cc"},{"name":"Colombia","code":"co"},{"name":"Comoros","code":"km"},{"name":"Congo","code":"cg"},{"name":"Congo, The Democratic Republic of the","code":"cd"},{"name":"Cook Islands","code":"ck"},{"name":"Costa Rica","code":"cr"},{"name":"Cote D'Ivoire","code":"ci"},{"name":"Croatia","code":"hr"},{"name":"Cuba","code":"cu"},{"name":"Cyprus","code":"cy"},{"name":"Czech Republic","code":"cz"},{"name":"Denmark","code":"dk"},{"name":"Djibouti","code":"dj"},{"name":"Dominica","code":"dm"},{"name":"Dominican Republic","code":"do"},{"name":"Ecuador","code":"ec"},{"name":"Egypt","code":"eg"},{"name":"El Salvador","code":"sv"},{"name":"Equatorial Guinea","code":"gq"},{"name":"Eritrea","code":"er"},{"name":"Estonia","code":"ee"},{"name":"Ethiopia","code":"et"},{"name":"Falkland Islands (Malvinas)","code":"fk"},{"name":"Faroe Islands","code":"fo"},{"name":"Fiji","code":"fj"},{"name":"Finland","code":"fi"},{"name":"France","code":"fr"},{"name":"French Guiana","code":"gf"},{"name":"French Polynesia","code":"pf"},{"name":"French Southern Territories","code":"tf"},{"name":"Gabon","code":"ga"},{"name":"Gambia","code":"gm"},{"name":"Georgia","code":"ge"},{"name":"Germany","code":"de"},{"name":"Ghana","code":"gh"},{"name":"Gibraltar","code":"gi"},{"name":"Greece","code":"gr"},{"name":"Greenland","code":"gl"},{"name":"Grenada","code":"gd"},{"name":"Guadeloupe","code":"gp"},{"name":"Guam","code":"gu"},{"name":"Guatemala","code":"gt"},{"name":"Guernsey","code":"gg"},{"name":"Guinea","code":"gn"},{"name":"Guinea-Bissau","code":"gw"},{"name":"Guyana","code":"gy"},{"name":"Haiti","code":"ht"},{"name":"Heard Island and Mcdonald Islands","code":"hm"},{"name":"Holy See (Vatican City State)","code":"va"},{"name":"Honduras","code":"hn"},{"name":"Hong Kong","code":"hk"},{"name":"Hungary","code":"hu"},{"name":"Iceland","code":"is"},{"name":"India","code":"in"},{"name":"Indonesia","code":"id"},{"name":"Iran, Islamic Republic Of","code":"ir"},{"name":"Iraq","code":"iq"},{"name":"Ireland","code":"ie"},{"name":"Isle of Man","code":"im"},{"name":"Israel","code":"il"},{"name":"Italy","code":"it"},{"name":"Jamaica","code":"jm"},{"name":"Japan","code":"jp"},{"name":"Jersey","code":"je"},{"name":"Jordan","code":"jo"},{"name":"Kazakhstan","code":"kz"},{"name":"Kenya","code":"ke"},{"name":"Kiribati","code":"ki"},{"name":"North Korea","code":"kp"},{"name":"South Korea","code":"kr"},{"name":"Kuwait","code":"kw"},{"name":"Kyrgyzstan","code":"kg"},{"name":"Lao People'S Democratic Republic","code":"la"},{"name":"Latvia","code":"lv"},{"name":"Lebanon","code":"lb"},{"name":"Lesotho","code":"ls"},{"name":"Liberia","code":"lr"},{"name":"Libyan Arab Jamahiriya","code":"ly"},{"name":"Liechtenstein","code":"li"},{"name":"Lithuania","code":"lt"},{"name":"Luxembourg","code":"lu"},{"name":"Macao","code":"mo"},{"name":"Macedonia, The Former Yugoslav Republic of","code":"mk"},{"name":"Madagascar","code":"mg"},{"name":"Malawi","code":"mw"},{"name":"Malaysia","code":"my"},{"name":"Maldives","code":"mv"},{"name":"Mali","code":"ml"},{"name":"Malta","code":"mt"},{"name":"Marshall Islands","code":"mh"},{"name":"Martinique","code":"mq"},{"name":"Mauritania","code":"mr"},{"name":"Mauritius","code":"mu"},{"name":"Mayotte","code":"yt"},{"name":"Mexico","code":"mx"},{"name":"Micronesia, Federated States of","code":"fm"},{"name":"Moldova, Republic of","code":"md"},{"name":"Monaco","code":"mc"},{"name":"Mongolia","code":"mn"},{"name":"Montserrat","code":"ms"},{"name":"Morocco","code":"ma"},{"name":"Mozambique","code":"mz"},{"name":"Myanmar","code":"mm"},{"name":"Namibia","code":"na"},{"name":"Nauru","code":"nr"},{"name":"Nepal","code":"np"},{"name":"Netherlands","code":"nl"},{"name":"Netherlands Antilles","code":"an"},{"name":"New Caledonia","code":"nc"},{"name":"New Zealand","code":"nz"},{"name":"Nicaragua","code":"ni"},{"name":"Niger","code":"ne"},{"name":"Nigeria","code":"ng"},{"name":"Niue","code":"nu"},{"name":"Norfolk Island","code":"nf"},{"name":"Northern Mariana Islands","code":"mp"},{"name":"Norway","code":"no"},{"name":"Oman","code":"om"},{"name":"Pakistan","code":"pk"},{"name":"Palau","code":"pw"},{"name":"Palestinian Territory, Occupied","code":"ps"},{"name":"Panama","code":"pa"},{"name":"Papua New Guinea","code":"pg"},{"name":"Paraguay","code":"py"},{"name":"Peru","code":"pe"},{"name":"Philippines","code":"ph"},{"name":"Pitcairn","code":"pn"},{"name":"Poland","code":"pl"},{"name":"Portugal","code":"pt"},{"name":"Puerto Rico","code":"pr"},{"name":"Qatar","code":"qa"},{"name":"Reunion","code":"re"},{"name":"Romania","code":"ro"},{"name":"Russian Federation","code":"ru"},{"name":"RWANDA","code":"rw"},{"name":"Saint Helena","code":"sh"},{"name":"Saint Kitts and Nevis","code":"kn"},{"name":"Saint Lucia","code":"lc"},{"name":"Saint Pierre and Miquelon","code":"pm"},{"name":"Saint Vincent and the Grenadines","code":"vc"},{"name":"Samoa","code":"ws"},{"name":"San Marino","code":"sm"},{"name":"Sao Tome and Principe","code":"st"},{"name":"Saudi Arabia","code":"sa"},{"name":"Senegal","code":"sn"},{"name":"Serbia and Montenegro","code":"cs"},{"name":"Seychelles","code":"sc"},{"name":"Sierra Leone","code":"sl"},{"name":"Singapore","code":"sg"},{"name":"Slovakia","code":"sk"},{"name":"Slovenia","code":"si"},{"name":"Solomon Islands","code":"sb"},{"name":"Somalia","code":"so"},{"name":"South Africa","code":"za"},{"name":"South Georgia and the South Sandwich Islands","code":"gs"},{"name":"Spain","code":"es"},{"name":"Sri Lanka","code":"lk"},{"name":"Sudan","code":"sd"},{"name":"Suriname","code":"sr"},{"name":"Svalbard and Jan Mayen","code":"sj"},{"name":"Swaziland","code":"sz"},{"name":"Sweden","code":"se"},{"name":"Switzerland","code":"ch"},{"name":"Syrian Arab Republic","code":"sy"},{"name":"Taiwan, Province of China","code":"tw"},{"name":"Tajikistan","code":"tj"},{"name":"Tanzania, United Republic of","code":"tz"},{"name":"Thailand","code":"th"},{"name":"Timor-Leste","code":"tl"},{"name":"Togo","code":"tg"},{"name":"Tokelau","code":"tk"},{"name":"Tonga","code":"to"},{"name":"Trinidad and Tobago","code":"tt"},{"name":"Tunisia","code":"tn"},{"name":"Turkey","code":"tr"},{"name":"Turkmenistan","code":"tm"},{"name":"Turks and Caicos Islands","code":"tc"},{"name":"Tuvalu","code":"tv"},{"name":"Uganda","code":"ug"},{"name":"Ukraine","code":"ua"},{"name":"United Arab Emirates","code":"ae"},{"name":"United Kingdom","code":"gb"},{"name":"United States","code":"us"},{"name":"United States Minor Outlying Islands","code":"um"},{"name":"Uruguay","code":"uy"},{"name":"Uzbekistan","code":"uz"},{"name":"Vanuatu","code":"vu"},{"name":"Venezuela","code":"ve"},{"name":"Viet Nam","code":"vn"},{"name":"Virgin Islands, British","code":"vg"},{"name":"Virgin Islands, U.S.","code":"vi"},{"name":"Wallis and Futuna","code":"wf"},{"name":"Western Sahara","code":"eh"},{"name":"Yemen","code":"ye"},{"name":"Zambia","code":"zm"},{"name":"Zimbabwe","code":"zw"}];

/// <summary>
/// European Union & EFTA (European Free Trade Association) & North America
/// </summary>
Machinata.COUNTRY_CODES_WESTERN = ["at","be","bg","ca","ch","cy","cz","de","dk","ee","el","es","fi","fr","gb","hr","hu","ie","is","it","li","lt","lu","lv","mt","nl","no","pl","pt","ro","se","sk","uk","us"];

/// <summary>
/// European Union & EFTA (European Free Trade Association)
/// </summary>
Machinata.COUNTRY_CODES_EUEFTA = ["at","be","bg","ch","cy","cz","de","dk","ee","el","es","fi","fr","gb","hr","hu","ie","is","it","li","lt","lu","lv","mt","nl","no","pl","pt","ro","se","sk","uk"];

/// <summary>
/// Asia
/// </summary>
Machinata.COUNTRY_CODES_ASIA = ["ae","af","am","az","bd","bh","bn","bt","cn","ge","hk","id","il","in","iq","ir","jo","jp","kg","kh","kp","kr","kw","kz","la","lb","lk","mn","mo","mv","my","np","om","ph","pk","qa","sa","sg","sy","th","tj","tm","tr","tw","uz","vn","ye"];


/// <summary>
/// Swiss zip codes.
/// </summary>
Machinata.ZIP_CODES_CH = {"1000":"Lausanne","1001":"Lausanne","1002":"Lausanne","1003":"Lausanne","1004":"Lausanne","1005":"Lausanne","1006":"Lausanne","1007":"Lausanne","1008":"Jouxtens-Mézery - Prilly","1009":"Pully","1010":"Lausanne","1011":"Lausanne","1012":"Lausanne","1015":"Lausanne","1018":"Lausanne","1020":"Renens","1022":"Chavannes-près-Renens","1023":"Crissier","1024":"Ecublens","1025":"St-Sulpice","1026":"Echandens - Denges","1027":"Lonay","1028":"Préverenges","1029":"Villars-Ste-Croix","1030":"Bussigny-près-Lausanne","1031":"Mex","1032":"Romanel-sur-Lausanne","1033":"Cheseaux-sur-Lausanne","1034":"Boussens","1035":"Bournens","1036":"Sullens","1037":"Etagnières","1038":"Bercher","1039":"Cheseaux Polyval","1040":"Echallens - St-Barthélemy - Villars-le-Terroir","1041":"Poliez-le-Grand - Bottens - Poliez-Pittet - Naz - Dommartin - Montaubion-Chardonney","1042":"Bioley-Orjulaz - Bettens - Assens","1043":"Sugnens","1044":"Fey","1045":"Ogens","1046":"Rueyres","1047":"Oppens","1052":"Le Mont-sur-Lausanne","1053":"Cugy - Bretigny-sur-Morrens","1054":"Morrens","1055":"Froideville","1058":"Villars-Tiercelin","1059":"Peney-le-Jorat","1061":"Villars-Mendraz","1062":"Sottens","1063":"Martherenges - Chapelle-sur-Moudon - Boulens - Peyres-Possens","1066":"Epalinges","1068":"Les Monts-de-Pully","1070":"Puidoux","1071":"Rivaz - St-Saphorin (Lavaux) - Chexbres","1072":"Forel (Lavaux)","1073":"Savigny - Mollie-Margot","1076":"Ferlens","1077":"Servion","1078":"Essertes","1080":"Les Cullayes","1081":"Montpreveyres","1082":"Corcelles-le-Jorat","1083":"Mézières","1084":"Carrouge","1085":"Vulliens","1088":"Ropraz","1090":"La Croix (Lutry)","1091":"Chenaux - Grandvaux - Aran","1092":"Belmont-sur-Lausanne","1093":"La Conversion","1094":"Paudex","1095":"Lutry","1096":"Villette (Lavaux) - Cully","1097":"Riex","1098":"Epesses","1110":"Morges","1112":"Echichens","1113":"St-Saphorin-sur-Morges","1114":"Colombier","1115":"Vullierens","1116":"Cottens","1117":"Grancy","1121":"Bremblens","1122":"Romanel-sur-Morges","1123":"Aclens","1124":"Gollion","1125":"Monnaz","1126":"Vaux-sur-Morges","1127":"Clarmont","1128":"Reverolle","1131":"Tolochenaz","1132":"Lully","1134":"Vufflens-le-Château - Chigny","1135":"Denens","1136":"Bussy-Chardonney","1141":"Sévery","1142":"Pampigny","1143":"Apples","1144":"Ballens","1145":"Bière","1146":"Mollens","1147":"Montricher","1148":"La Praz - Chavannes-le-Veyron - Villars-Bozon - La Coudre - Cuarnens - Moiry - Mont-la-Ville - Mauraz - L'Isle","1149":"Berolle","1162":"St-Prex","1163":"Etoy","1164":"Buchillon","1165":"Allaman","1166":"Perroy","1167":"Lussy-sur-Morges","1168":"Villars-sous-Yens","1169":"Yens","1170":"Aubonne","1172":"Bougy-Villars","1173":"Féchy","1174":"Montherod - Pizy","1175":"Lavigny","1176":"St-Livres","1180":"Tartegnin - Rolle","1182":"Gilly","1183":"Bursins","1184":"Luins - Vinzel","1185":"Mont-sur-Rolle","1186":"Essertines-sur-Rolle","1187":"St-Oyens","1188":"Gimel - St-George","1189":"Saubraz","1195":"Bursinel - Dully","1196":"Gland","1197":"Prangins","1200":"Genève","1201":"Genève","1202":"Genève","1203":"Genève","1204":"Genève","1205":"Genève","1206":"Genève","1207":"Genève","1208":"Genève","1209":"Genève","1211":"Genève","1212":"Grand-Lancy","1213":"Onex - Petit-Lancy","1214":"Vernier","1215":"Genève","1216":"Cointrin","1217":"Meyrin","1218":"Le Grand-Saconnex","1219":"Châtelaine - Le Lignon - Aïre","1220":"Les Avanchets","1222":"Vésenaz","1223":"Cologny","1224":"Chêne-Bougeries","1225":"Chêne-Bourg","1226":"Thônex","1227":"Les Acacias - Carouge","1228":"Plan-les-Ouates","1231":"Conches","1232":"Confignon","1233":"Bernex","1234":"Vessy","1236":"Cartigny","1237":"Avully","1239":"Collex","1240":"Genève","1241":"Puplinge","1242":"Satigny","1243":"Presinge","1244":"Choulex","1245":"Collonge-Bellerive","1246":"Corsier","1247":"Anières","1248":"Hermance","1251":"Gy","1252":"Meinier","1253":"Vandoeuvres","1254":"Jussy","1255":"Veyrier","1256":"Troinex","1257":"La Croix-de-Rozon","1258":"Perly","1260":"Nyon","1261":"Longirod - Le Vaud - Marchissy","1262":"Eysins","1263":"Crassier","1264":"St-Cergue","1265":"La Cure","1266":"Duillier","1267":"Vich - Coinsins","1268":"Burtigny - Begnins","1269":"Bassins","1270":"Trélex","1271":"Givrins","1272":"Genolier","1273":"Le Muids - Arzier","1274":"Grens - Signy","1275":"Chéserex","1276":"Gingins","1277":"Borex - Arnex-sur-Nyon","1278":"La Rippe","1279":"Chavannes-de-Bogis - Bogis-Bossey","1281":"Russin","1283":"Dardagny - La Plaine","1284":"Chancy","1285":"Athenaz (Avusy)","1286":"Soral","1287":"Laconnex","1288":"Aire-la-Ville","1289":"Genève","1290":"Versoix - Chavannes-des-Bois","1291":"Commugny","1292":"Chambésy","1293":"Bellevue","1294":"Genthod","1295":"Mies - Tannay","1296":"Coppet","1297":"Founex","1298":"Céligny","1299":"Crans-près-Céligny","1300":"Eclépens","1302":"Vufflens-la-Ville","1303":"Penthaz","1304":"Dizy - Senarclens - Allens - Cossonay-Ville","1305":"Penthalaz","1306":"Daillens","1307":"Lussery-Villars","1308":"La Chaux (Cossonay)","1310":"Daillens","1311":"Eclépens","1312":"Eclépens","1313":"Ferreyres","1315":"La Sarraz","1316":"Chevilly","1317":"Orny","1318":"Pompaples","1320":"Daillens","1321":"Arnex-sur-Orbe","1322":"Croy","1323":"Romainmôtier","1324":"Premier","1325":"Vaulion","1326":"Juriens","1329":"Bretonnières","1330":"Daillens","1337":"Vallorbe","1338":"Ballaigues","1341":"Orient","1342":"Le Pont","1343":"Les Charbonnières","1344":"L'Abbaye","1345":"Le Lieu","1346":"Les Bioux","1347":"Le Sentier - Le Solliat","1348":"Le Brassus","1350":"Orbe","1352":"Agiez","1353":"Bofflens","1354":"Montcherand","1355":"Sergey - L'Abergement","1356":"La Russille - Les Clées","1357":"Lignerolle","1358":"Valeyres-sous-Rances","1372":"Bavois","1373":"Chavornay","1374":"Corcelles-sur-Chavornay","1375":"Penthéréaz","1376":"Eclagnens - Goumoens-la-Ville - Goumoens-le-Jux","1377":"Oulens-sous-Echallens","1400":"Yverdon-les-Bains - Cheseaux-Noréaz","1401":"Yverdon-les-Bains","1404":"Cuarny - Villars-Epeney","1405":"Pomy","1406":"Cronay","1407":"Donneloye - Gossens - Mézery-près-Donneloye - Bioley-Magnoux","1408":"Prahins","1409":"Chanéaz","1410":"Prévondavaux - Thierrens - St-Cierges - Correvon - Denezy","1412":"Ursins - Valeyres-sous-Ursins","1413":"Orzens","1415":"Molondin - Démoret","1416":"Pailly","1417":"Epautheyres - Essertines-sur-Yverdon","1418":"Vuarrens","1420":"Fiez","1421":"Grandevent - Fontaines-sur-Grandson","1422":"Grandson","1423":"Vaugondry - Fontanezier - Romairon - Villars-Burquin","1424":"Champagne","1425":"Onnens","1426":"Concise - Corcelles-près-Concise","1427":"Bonvillars","1428":"Provence - Mutrux","1429":"Giez","1430":"Orges","1431":"Novalles - Vugelles-La Mothe","1432":"Gressy - Belmont-sur-Yverdon","1433":"Suchy","1434":"Ependes","1435":"Essert-Pittet","1436":"Treycovagnes - Chamblon","1437":"Suscévaz","1438":"Mathod","1439":"Rances","1440":"Montagny-Chamard","1441":"Valeyres-sous-Montagny","1442":"Montagny-près-Yverdon","1443":"Essert-sous-Champvent - Champvent - Villars-sous-Champvent","1445":"Vuiteboeuf","1446":"Baulmes","1450":"Le Château-de-Ste-Croix - La Sagne (Ste-Croix) - Ste-Croix","1452":"Les Rasses","1453":"Mauborget - Bullet","1454":"L'Auberson - La Vraconnaz","1462":"Yvonand","1463":"Rovray","1464":"Chavannes-le-Chêne - Chêne-Pâquier","1468":"Cheyres","1470":"Seiry - Bollion - Lully - Estavayer-le-Lac","1473":"Font - Châtillon","1474":"Châbles","1475":"Autavaux - Montbrelloz - Forel","1482":"Cugy","1483":"Frasses - Montet (Broye) - Vesin","1484":"Granges-de-Vesin - Aumont","1485":"Nuvilly","1486":"Vuissens","1489":"Murist","1509":"Vucherens","1510":"Syens - Moudon","1512":"Chavannes-sur-Moudon","1513":"Hermenches - Rossenges","1514":"Bussy-sur-Moudon","1515":"Villars-le-Comte - Neyruz-sur-Moudon","1521":"Curtilles","1522":"Oulens-sur-Lucens - Lucens","1523":"Granges-près-Marnand","1524":"Marnand","1525":"Seigneux - Henniez","1526":"Forel-sur-Lucens - Cremin","1527":"Villeneuve","1528":"Surpierre - Praratoud","1529":"Cheiry","1530":"Payerne","1532":"Fétigny","1533":"Ménières","1534":"Chapelle (Broye) - Sassel","1535":"Combremont-le-Grand","1536":"Combremont-le-Petit","1537":"Champtauroz","1538":"Treytorrens (Payerne)","1541":"Sévaz - Morens - Bussy","1542":"Rueyres-les-Prés","1543":"Grandcour","1544":"Gletterens","1545":"Chevroux","1551":"Vers-chez-Perrin","1552":"Trey","1553":"Châtonnaye","1554":"Sédeilles - Rossens","1555":"Villarzel","1562":"Corcelles-près-Payerne","1563":"Dompierre","1564":"Domdidier","1565":"Vallon - Missy","1566":"St-Aubin - Les Friques","1567":"Delley","1568":"Portalban","1580":"Avenches - Oleyres","1582":"Donatyre","1583":"Villarepos","1584":"Villars-le-Grand","1585":"Salavaux - Cotterd - Bellerive","1586":"Vallamand","1587":"Constantine - Montmagny","1588":"Cudrefin","1589":"Chabrey","1595":"Clavaleyres - Faoug","1607":"Les Tavernes - Palézieux-Village - Les Thioleyres - Palézieux","1608":"Chapelle (Glâne) - Bussigny-sur-Oron - Chesalles-sur-Oron - Oron-le-Châtel","1609":"Besencens - Fiaugères - St-Martin","1610":"Vuibroye - Châtillens - Oron-la-Ville","1611":"Le Crêt-près-Semsales","1612":"Ecoteaux","1613":"Maracon","1614":"Granges (Veveyse)","1615":"Bossonnens","1616":"Attalens","1617":"Remaufens - Tatroz","1618":"Châtel-St-Denis","1619":"Les Paccots","1623":"Semsales","1624":"Grattavache - La Verrerie - Progens","1625":"Sâles (Gruyère) - Maules","1626":"Romanens - Treyfayes - Rueyres-Treyfayes","1627":"Vaulruz","1628":"Vuadens","1630":"Bulle","1631":"Bulle","1632":"Riaz","1633":"Vuippens - Marsens","1634":"La Roche","1635":"La Tour-de-Trême","1636":"Broc","1637":"Charmey (Gruyère)","1638":"Morlon","1642":"Sorens","1643":"Gumefens","1644":"Avry-devant-Pont","1645":"Le Bry","1646":"Echarlens","1647":"Corbières","1648":"Hauteville","1649":"Pont-la-Ville","1651":"Villarvolard","1652":"Villarbeney - Botterens","1653":"Châtel-sur-Montsalvens - Crésuz","1654":"Cerniat","1656":"Jaun - Im Fang","1657":"Abländschen","1658":"La Tine - Rossinière","1659":"Flendruz - Rougemont","1660":"La Lécherette - Château-d'Oex - Les Moulins - L'Etivaz","1661":"Le Pâquier-Montbarry","1663":"Moléson-sur-Gruyères - Epagny - Pringy - Gruyères","1665":"Estavannens","1666":"Villars-sous-Mont - Grandvillard","1667":"Enney","1669":"Albeuve - Neirivue - Les Sciernes-d'Albeuve - Montbovon - Lessoc","1670":"Ursy - Bionnens - Esmonts","1673":"Rue - Promasens - Auboranges - Gillarens - Ecublens","1674":"Montet (Glâne) - Morlens - Vuarmarens","1675":"Mossel - Blessens - Vauderens","1676":"Chavannes-les-Forts","1677":"Prez-vers-Siviriez","1678":"Siviriez","1679":"Villaraboud","1680":"Romont - Berlens","1681":"Billens - Hennens","1682":"Prévonloup - Dompierre - Lovatens - Villars-Bramard - Cerniaz","1683":"Brenles - Sarzens - Chesalles-sur-Moudon","1684":"Mézières","1685":"Villariaz","1686":"Grangettes-près-Romont - La Neirigue","1687":"Vuisternens-devant-Romont - Estévenens - La Magne","1688":"Lieffrens - Sommentier","1689":"Le Châtelard-près-Romont","1690":"Lussy - Villaz-St-Pierre","1691":"Villarimboud","1692":"Massonnens","1694":"Villargiroud - Orsonnens - Chavannes-sous-Orsonnens - Villarsiviriaux","1695":"Villarsel-le-Gibloux - Villarlod - Estavayer-le-Gibloux - Rueyres-St-Laurent","1696":"Vuisternens-en-Ogoz","1697":"La Joux - Les Ecasseys","1699":"Pont (Veveyse) - Bouloz - Porsel","1700":"Fribourg","1701":"Fribourg","1702":"Fribourg","1704":"Fribourg","1705":"Fribourg","1707":"Fribourg","1708":"Fribourg","1709":"Fribourg","1712":"Tafers","1713":"St. Antoni","1714":"Heitenried","1715":"Alterswil","1716":"Schwarzsee - Plaffeien - Oberschrot","1717":"St. Ursen","1718":"Rechthalten","1719":"Brünisried - Zumholz","1720":"Corminboeuf - Chésopelloz","1721":"Courtion - Cormérod - Misery","1722":"Bourguillon","1723":"Marly - Pierrafortscha - Villarsel-sur-Marly","1724":"Senèdes - Zénauva - Montévraz - Bonnefontaine - Le Mouret - Oberried - Essert - Ferpicloz","1725":"Posieux","1726":"Grenilles - Farvagny-le-Petit - Posat - Farvagny","1727":"Magnedens - Corpataux-Magnedens","1728":"Rossens","1730":"Ecuvillens","1731":"Ependes","1732":"Arconciel","1733":"Treyvaux","1734":"Tentlingen","1735":"Giffers","1736":"St. Silvester","1737":"Plasselb","1738":"Sangernboden","1740":"Neyruz","1741":"Cottens","1742":"Autigny","1744":"Chénens","1745":"Lentigny","1746":"Prez-vers-Noréaz","1747":"Corserey","1748":"Torny-le-Grand","1749":"Middes","1752":"Villars-sur-Glâne","1753":"Matran","1754":"Rosé - Avry-sur-Matran - Avry-Centre - Corjolens","1756":"Onnens - Lovens","1757":"Noréaz","1762":"Givisiez","1763":"Granges-Paccot","1772":"Ponthaux - Grolley - Nierlet-les-Bois","1773":"Russy - Chandon - Léchelles","1774":"Cousset - Montagny-les-Monts","1775":"Mannens - Grandsivaz","1776":"Montagny-la-Ville","1782":"La Corbaz - Lossy - Belfaux - Autafond - Cormagens - Formangueires","1783":"Barberêche - Pensier","1784":"Courtepin - Wallenried - Cournillens","1785":"Cressier","1786":"Sugiez","1787":"Môtier (Vully) - Mur (Vully)","1788":"Praz (Vully)","1789":"Lugnorre","1791":"Courtaman","1792":"Guschelmuth - Cordast","1793":"Jeuss","1794":"Salvenach","1795":"Courlevon","1796":"Courgevaux","1797":"Münchenwiler","1800":"Vevey","1801":"Le Mont-Pèlerin","1802":"Corseaux","1803":"Chardonne","1804":"Corsier-sur-Vevey","1805":"Jongny","1806":"St-Légier-La Chiésaz","1807":"Blonay","1808":"Les Monts-de-Corsier","1809":"Fenil-sur-Corsier","1814":"La Tour-de-Peilz","1815":"Clarens","1816":"Chailly-Montreux","1817":"Brent","1820":"Territet - Veytaux - Montreux","1822":"Chernex","1823":"Glion","1824":"Caux","1832":"Villard-sur-Chamby - Chamby","1833":"Les Avants","1844":"Villeneuve","1845":"Noville","1846":"Chessel","1847":"Rennaz","1852":"Roche","1853":"Yvorne","1854":"Leysin","1856":"Corbeyrier","1860":"Aigle","1862":"La Comballaz - Les Mosses","1863":"Le Sépey","1864":"Vers-l'Eglise","1865":"Les Diablerets","1866":"La Forclaz","1867":"St-Triphon - Panex - Ollon","1868":"Collombey","1869":"Massongex","1870":"Monthey","1871":"Les Giettes - Choëx","1872":"Troistorrents","1873":"Val-d'Illiez - Les Crosets - Champoussin","1874":"Champéry","1875":"Morgins","1880":"Frenières-sur-Bex - Fenalet-sur-Bex - Les Plans-sur-Bex - Les Posses-sur-Bex - Bex","1882":"Gryon - Les Posses-sur-Bex","1884":"Villars-sur-Ollon - Arveyes - Huémoz","1885":"Chesières","1890":"Mex - St-Maurice","1891":"Vérossaz","1892":"Morcles - Lavey-les-Bains - Lavey-Village","1893":"Muraz (Collombey)","1895":"Vionnaz","1896":"Miex - Vouvry","1897":"Les Evouettes - Bouveret","1898":"St-Gingolph","1899":"Torgon","1902":"Evionnaz","1903":"Collonges","1904":"Vernayaz","1905":"Dorénaz","1906":"Charrat","1907":"Saxon","1908":"Riddes","1911":"Mayens-de-Chamoson - Ovronnaz","1912":"Leytron - Dugny (Leytron) - Montagnon (Leytron) - Produit (Leytron)","1913":"Saillon","1914":"Isérables - Auddes-sur-Riddes","1918":"La Tzoumaz","1920":"Martigny","1921":"Martigny-Croix","1922":"Les Granges (Salvan) - Salvan","1923":"Les Marécottes - Le Trétien","1925":"Le Châtelard - Finhaut","1926":"Fully","1927":"Chemin","1928":"Ravoire","1929":"Trient","1932":"Les Valettes (Bovernier) - Martigny-Croix","1933":"Chamoille (Sembrancher) - La Garde (Sembrancher) - Vens (Sembrancher) - Sembrancher","1934":"Fontenelle (Le Châble) - Le Châble - Bruson - Montagnier (Le Châble) - Villette (Le Châble) - Cotterg (Le Châble)","1936":"Verbier","1937":"Orsières","1938":"Champex-Lac","1941":"Vollèges - Cries (Vollèges)","1942":"Levron","1943":"Praz-de-Fort","1944":"La Fouly","1945":"Rive Haute (Liddes) - Palasuit (Liddes) - Dranse (Liddes) - Les Moulins (Liddes) - Liddes - Vichères (Liddes) - Fontaine Dessous (Liddes) - Fontaine Dessus (Liddes) - Chez Petit (Liddes) - Petit Vichères (Liddes) - Fornex (Liddes) - Chandonne (Liddes)","1946":"Bourg-St-Pierre","1947":"Les Places (Versegères) - Versegères - Prarreyer (Versegères) - Le Fregnoley (Versegères) - La Montoz (Versegères) - Champsec (Versegères)","1948":"Le Planchamp (Lourtier) - Le Morgnes (Lourtier) - Fionnay - Lourtier - Sarreyer","1950":"Sion","1951":"Sion","1955":"Némiaz (Chamoson) - Grugnay (Chamoson) - St-Pierre-de-Clages - Les Vérines (Chamoson) - Chamoson","1957":"Ardon","1958":"St-Léonard - Uvrier","1961":"Vernamiège","1962":"Pont-de-la-Morge (Sion)","1963":"Vétroz","1964":"Conthey","1965":"Savièse - Roumaz (Savièse) - Drône - Mayens-de-la-Zour (Savièse) - St-Germain (Savièse) - Chandolin-près-Savièse - Monteiller-Savièse - Granois (Savièse) - Ormône (Savièse)","1966":"St-Romain (Ayent) - Blignou (Ayent) - Villa (Ayent) - Argnou (Ayent) - Signèse (Ayent) - La Place (Ayent) - Botyre (Ayent) - Saxonne (Ayent) - Luc (Ayent) - Fortunau (Ayent)","1967":"Bramois","1968":"Mase","1969":"Eison (St.Martin) - St-Martin - Suen (St-Martin) - Liez (St-Martin) - Trogne (St-Martin)","1971":"Grimisuat - Champlan (Grimisuat)","1972":"Anzère","1973":"Nax","1974":"Arbaz","1975":"St-Séverin","1976":"Daillon - Aven - Erde","1977":"Icogne","1978":"Lens","1981":"Vex","1982":"Euseigne","1983":"Lana (Evolène) - Evolène","1984":"Les Haudères - La Tour","1985":"La Forclaz - La Sage - Villaz","1986":"Arolla","1987":"Hérémence","1988":"Les Collons - Thyon","1991":"Turin (Salins) - Arvillard (Salins) - Pravidondaz (Salins) - Misériez (Salins) - Salins","1992":"Crête-à-l'Oeil (Les Agettes) - Les Mayens-de-Sion - La Vernaz (Les Agettes) - Les Agettes","1993":"Clèbes (Nendaz) - Veysonnaz","1994":"Aproz (Nendaz)","1996":"Condémines (Nendaz) - Brignon (Nendaz) - Fey (Nendaz) - Bieudron (Nendaz) - Basse-Nendaz - Baar (Nendaz) - Beuson (Nendaz) - Saclentse","1997":"Siviez (Nendaz) - Haute-Nendaz - Sornard (Nendaz)","2000":"Neuchâtel","2001":"Neuchâtel 1","2002":"Neuchâtel 2","2003":"Neuchâtel 3","2004":"Neuchâtel 4","2006":"Neuchâtel 6","2007":"Neuchâtel 7","2008":"Neuchâtel","2009":"Neuchâtel 9","2010":"Neuchâtel","2012":"Auvernier","2013":"Colombier","2014":"Bôle","2015":"Areuse","2016":"Cortaillod","2017":"Boudry","2019":"Chambrelien - Rochefort","2022":"Bevaix","2023":"Gorgier","2024":"St-Aubin-Sauges","2025":"Chez-le-Bart","2027":"Montalchez - Fresens","2028":"Vaumarcus","2034":"Peseux","2035":"Corcelles","2036":"Cormondrèche","2037":"Montezillon - Montmollin","2042":"Valangin","2043":"Boudevilliers","2046":"Fontaines","2052":"Fontainemelon - La Vue-des-Alpes","2053":"Cernier","2054":"Les Vieux-Prés - Chézard-St-Martin","2056":"Dombresson","2057":"Villiers","2058":"Le Pâquier","2063":"Vilars - Saules - Fenin - Engollon","2065":"Savagnier","2067":"Chaumont","2068":"Hauterive","2072":"St-Blaise","2073":"Enges","2074":"Marin-Epagnier","2075":"Wavre - Thielle","2087":"Cornaux","2088":"Cressier","2103":"Noiraigue","2105":"Travers","2108":"Couvet","2112":"Môtiers","2113":"Boveresse","2114":"Fleurier","2115":"Buttes","2116":"Mont-de-Buttes","2117":"La Côte-aux-Fées","2123":"St-Sulpice","2124":"Les Sagnettes","2126":"Les Verrières","2127":"Les Bayards","2149":"Fretereules - Champ-du-Moulin - Brot-Dessous","2206":"Les Geneveys-sur-Coffrane","2207":"Coffrane","2208":"Les Hauts-Geneveys","2300":"La Chaux-de-Fonds - La Cibourg","2301":"La Chx-de-F. Combe-à-l'Ours - La Chaux-de-Fonds","2302":"La Chaux-de-Fonds","2303":"La Chaux-de-Fonds","2304":"La Chaux-de-Fonds","2306":"La Chaux-de-Fonds","2314":"La Sagne NE","2316":"Les Ponts-de-Martel - Petit-Martel","2318":"Brot-Plamboz","2322":"Le Crêt-du-Locle","2325":"Les Planchettes","2333":"La Cibourg - La Ferrière","2336":"Les Bois","2338":"Muriaux - Les Emibois","2340":"Le Noirmont","2345":"Les Breuleux - La Chaux-des-Breuleux - Le Cerneux-Veusil","2350":"Saignelégier","2353":"Les Pommerats","2354":"Goumois","2360":"Le Bémont","2362":"Montfaucon - Montfavergier","2363":"Les Enfers","2364":"St-Brais","2400":"Le Locle - Le Prévoux","2405":"La Chaux-du-Milieu","2406":"Les Taillères - Le Brouillet - La Châtagne - La Brévine","2414":"Le Cerneux-Péquignot","2416":"Les Brenets","2500":"Biel/Bienne","2501":"Biel/Bienne","2502":"Biel/Bienne","2503":"Biel/Bienne","2504":"Biel/Bienne","2505":"Biel/Bienne","2512":"Tüscherz-Alfermée","2513":"Twann","2514":"Ligerz","2515":"Prêles","2516":"Lamboing","2517":"Diesse","2518":"Nods","2520":"La Neuveville","2523":"Lignières","2525":"Le Landeron","2532":"Macolin","2533":"Evilard","2534":"Orvin - Les Prés-d'Orvin","2535":"Frinvillier","2536":"Plagne","2537":"Vauffelin","2538":"Romont","2540":"Grenchen","2542":"Pieterlen","2543":"Lengnau","2544":"Bettlach","2545":"Selzach","2552":"Orpund","2553":"Safnern","2554":"Meinisberg","2555":"Brügg","2556":"Schwadernau - Scheuren","2557":"Studen","2558":"Aegerten","2560":"Nidau","2562":"Port","2563":"Ipsach","2564":"Bellmund","2565":"Jens","2572":"Sutz - Mörigen","2575":"Hagneck - Täuffelen - Gerolfingen","2576":"Lüscherz","2577":"Finsterhennen - Siselen","2603":"Péry","2604":"La Heutte","2605":"Sonceboz-Sombeval","2606":"Corgémont","2607":"Cortébert","2608":"Courtelary - Montagne-de-Courtelary","2610":"St-Imier - Mont-Crosin - Mont-Soleil - Les Pontins","2612":"Cormoret","2613":"Villeret","2615":"Montagne-de-Sonvilier - Sonvilier","2616":"La Cibourg - Renan","2710":"Tavannes","2712":"Le Fuet","2713":"Bellelay","2714":"Le Prédame - Les Genevez","2715":"Monible - Châtelat","2716":"Sornetan","2717":"Fornet-Dessous - Rebévelier","2718":"Lajoux - Fornet-Dessus","2720":"La Tanne - Tramelan","2722":"Les Reussilles","2723":"Mont-Tramelan","2732":"Loveresse - Saicourt - Saules - Reconvilier","2733":"Pontenet","2735":"Bévilard - Malleray - Champoz","2736":"Sorvilier","2738":"Court","2740":"Moutier","2742":"Perrefitte","2743":"Eschert","2744":"Belprahon","2745":"Grandval","2746":"Crémines","2747":"Seehof - Corcelles","2748":"Souboz - Les Ecorcheresses","2762":"Roches","2800":"Delémont","2802":"Develier","2803":"Bourrignon","2805":"Soyhières","2806":"Mettembert","2807":"Lucelle - Pleigne","2812":"Movelier","2813":"Ederswiler","2814":"Roggenburg","2822":"Courroux","2823":"Courcelon","2824":"Vicques","2825":"Courchapoix","2826":"Corban","2827":"Schelten - Mervelier","2828":"Montsevelier","2829":"Vermes","2830":"Vellerat - Courrendlin","2832":"Rebeuvelier","2842":"Rossemaison","2843":"Châtillon","2852":"Courtételle","2853":"Courfaivre","2854":"Bassecourt","2855":"Glovelier","2856":"Boécourt","2857":"Montavon","2863":"Undervelier","2864":"Soulce","2873":"Saulcy","2882":"St-Ursanne","2883":"Montmelon","2884":"Montenol","2885":"Epauvillers","2886":"Epiquerez","2887":"Soubey","2888":"Seleute","2889":"Ocourt","2900":"Porrentruy","2902":"Fontenais","2903":"Villars-sur-Fontenais","2904":"Bressaucourt","2905":"Courtedoux","2906":"Chevenez","2907":"Rocourt","2908":"Grandfontaine","2912":"Roche-d'Or - Réclère","2914":"Damvant","2915":"Bure","2916":"Fahy","2922":"Courchavon","2923":"Courtemaîche","2924":"Montignez","2925":"Buix","2926":"Boncourt","2932":"Coeuve","2933":"Damphreux - Lugnez","2935":"Beurnevésin","2942":"Alle","2943":"Vendlincourt","2944":"Bonfol","2946":"Miécourt","2947":"Charmoille","2950":"Courgenay - Courtemautruy","2952":"Cornol","2953":"Fregiécourt - Pleujouse","2954":"Asuel","3000":"Bern","3001":"Bern","3003":"Bern","3004":"Bern","3005":"Bern","3006":"Bern","3007":"Bern","3008":"Bern","3010":"Bern","3011":"Bern","3012":"Bern","3013":"Bern","3014":"Bern","3015":"Bern","3018":"Bern","3019":"Bern","3020":"Bern","3024":"Bern","3027":"Bern","3030":"Bern","3032":"Hinterkappelen","3033":"Wohlen b. Bern","3034":"Murzelen","3035":"Frieswil","3036":"Detligen","3037":"Herrenschwanden","3038":"Kirchlindach","3040":"Bern","3042":"Ortschwaben","3043":"Uettligen","3044":"Innerberg","3045":"Meikirch","3046":"Wahlendorf","3047":"Bremgarten b. Bern","3048":"Worblaufen","3049":"Säriswil","3052":"Zollikofen","3053":"Lätti - Münchenbuchsee - Wiggiswil - Diemerswil - Deisswil b. Münchenbuchsee","3054":"Schüpfen","3063":"Ittigen","3065":"Bolligen","3066":"Stettlen","3067":"Boll","3068":"Utzigen","3072":"Ostermundigen","3073":"Gümligen","3074":"Muri b. Bern","3075":"Rüfenacht - Vielbringen b. Worb","3076":"Worb","3077":"Enggistein","3078":"Richigen","3082":"Schlosswil","3083":"Trimstein","3084":"Wabern","3086":"Englisberg - Zimmerwald","3087":"Niedermuhlern","3088":"Oberbütschel - Rüeggisberg","3089":"Hinterfultigen","3095":"Spiegel b. Bern","3096":"Oberbalm","3097":"Liebefeld","3098":"Köniz - Schliern b. Köniz","3099":"Rüti b. Riggisberg","3110":"Münsingen","3111":"Tägertschi","3112":"Allmendingen b. Bern","3113":"Rubigen","3114":"Wichtrach","3115":"Gerzensee","3116":"Mühledorf - Kirchdorf - Noflen","3122":"Kehrsatz","3123":"Belp","3124":"Belpberg","3125":"Toffen","3126":"Gelterfingen - Kaufdorf","3127":"Mühlethurnen - Lohnstorf","3128":"Rümligen - Kirchenthurnen","3132":"Riggisberg","3144":"Gasel","3145":"Niederscherli","3147":"Mittelhäusern","3148":"Lanzenhäusern","3150":"Schwarzenburg","3152":"Mamishaus","3153":"Rüschegg Gambach","3154":"Rüschegg Heubach","3155":"Helgisried-Rohrbach","3156":"Riffenmatt","3157":"Milken","3158":"Guggisberg","3159":"Riedstätt","3172":"Niederwangen b. Bern","3173":"Oberwangen b. Bern","3174":"Thörishaus","3175":"Flamatt","3176":"Neuenegg","3177":"Laupen","3178":"Bösingen","3179":"Kriechenwil","3182":"Ueberstorf","3183":"Albligen","3184":"Wünnewil","3185":"Schmitten","3186":"Düdingen","3202":"Frauenkappelen","3203":"Mühleberg","3204":"Rosshäusern","3205":"Gümmenen","3206":"Gammen - Rizenbach - Biberen - Ferenbalm - Wallenbuch","3207":"Wileroltigen - Golaten","3208":"Gurbrü","3210":"Kerzers","3212":"Kleingurmels - Gurmels","3213":"Kleinbösingen - Liebistorf","3214":"Ulmiz","3215":"Lurtigen - Büchslen - Gempenach","3216":"Ried b. Kerzers - Agriswil","3225":"Müntschemier","3226":"Treiten","3232":"Ins","3233":"Tschugg","3234":"Vinelz","3235":"Erlach","3236":"Gampelen","3237":"Brüttelen","3238":"Gals","3250":"Lyss","3251":"Ruppoldsried - Wengi b. Büren","3252":"Worben","3253":"Schnottwil","3254":"Messen - Balm b. Messen","3255":"Rapperswil","3256":"Dieterswil - Bangerten b. Dieterswil - Seewil","3257":"Ammerzwil - Grossaffoltern","3262":"Suberg","3263":"Büetigen","3264":"Diessbach b. Büren","3266":"Wiler b. Seedorf","3267":"Seedorf","3268":"Lobsigen","3270":"Aarberg","3271":"Radelfingen b. Aarberg","3272":"Walperswil - Epsach","3273":"Kappelen","3274":"Merzligen - Hermrigen - Bühl b. Aarberg","3280":"Greng - Murten - Meyriez","3282":"Bargen","3283":"Kallnach - Niederried b. Kallnach","3284":"Fräschels","3285":"Galmiz","3286":"Muntelier","3292":"Busswil","3293":"Dotzigen","3294":"Meienried - Büren an der Aare","3295":"Rüti b. Büren","3296":"Arch","3297":"Leuzigen","3298":"Oberwil b. Büren","3302":"Moosseedorf","3303":"Ballmoos - Münchringen - Jegenstorf - Zuzwil","3305":"Iffwil - Scheunen","3306":"Etzelkofen","3307":"Brunnenthal","3308":"Grafenried","3309":"Kernenried - Zauggenried","3312":"Fraubrunnen","3313":"Büren zum Hof","3314":"Schalunen","3315":"Kräiligen - Bätterkinden","3317":"Mülchi - Limpach","3321":"Schönbühl Einkaufszentrum","3322":"Mattstetten - Urtenen-Schönbühl","3323":"Bäriswil","3324":"Mötschwil - Hindelbank","3325":"Hettiswil b. Hindelbank","3326":"Krauchthal","3360":"Herzogenbuchsee","3362":"Niederönz","3363":"Oberönz","3365":"Seeberg - Grasswil","3366":"Bettenhausen - Bollodingen","3367":"Thörigen - Ochlenberg","3368":"Bleienbach","3372":"Wanzwil","3373":"Röthenbach Herzogenbuchsee - Heimenhausen","3374":"Wangenried","3375":"Inkwil","3376":"Berken - Graben","3377":"Walliswil b. Wangen","3380":"Wangen an der Aare - Walliswil b. Niederbipp","3400":"Burgdorf","3401":"Burgdorf","3402":"Burgdorf","3412":"Heimiswil","3413":"Kaltacker","3414":"Oberburg","3415":"Rüegsauschachen - Schafhausen im Emmental - Hasle b. Burgdorf","3416":"Affoltern im Emmental","3417":"Rüegsau","3418":"Rüegsbach","3419":"Biembach im Emmental","3421":"Rüti b. Lyssach - Lyssach","3422":"Alchenflüh - Kirchberg - Rüdtligen","3423":"Ersigen","3424":"Niederösch - Oberösch","3425":"Koppigen - Willadingen","3426":"Aefligen","3427":"Utzenstorf","3428":"Wiler b. Utzenstorf","3429":"Höchstetten - Hellsau","3432":"Lützelflüh-Goldbach","3433":"Schwanden im Emmental","3434":"Obergoldbach - Landiswil","3435":"Ramsei","3436":"Zollbrück","3437":"Rüderswil","3438":"Lauperswil","3439":"Ranflüh","3452":"Grünenmatt","3453":"Heimisbach","3454":"Sumiswald","3455":"Grünen","3456":"Trachselwald","3457":"Wasen im Emmental","3462":"Weier im Emmental","3463":"Häusernmoos im Emmental","3464":"Schmidigen-Mühleweg","3465":"Dürrenroth","3472":"Rumendingen - Wynigen","3473":"Alchenstorf","3474":"Rüedisbach","3475":"Riedtwil - Hermiswil","3476":"Oschwand","3503":"Gysenstein","3504":"Oberhünigen - Niederhünigen","3506":"Grosshöchstetten","3507":"Biglen","3508":"Arni","3510":"Häutligen - Konolfingen - Freimettigen","3512":"Walkringen","3513":"Bigenthal","3531":"Oberthal","3532":"Zäziwil - Mirchel","3533":"Bowil","3534":"Signau","3535":"Schüpbach","3536":"Aeschau","3537":"Eggiwil","3538":"Röthenbach im Emmental","3543":"Emmenmatt","3550":"Langnau im Emmental","3551":"Oberfrittenbach","3552":"Bärau","3553":"Gohl","3555":"Trubschachen","3556":"Trub","3557":"Fankhaus (Trub)","3600":"Thun","3601":"Thun","3602":"Thun","3603":"Thun","3604":"Thun","3605":"Thun","3607":"Thun","3608":"Thun","3609":"Thun","3612":"Steffisburg","3613":"Steffisburg","3614":"Unterlangenegg","3615":"Heimenschwand","3616":"Schwarzenegg","3617":"Fahrni b. Thun","3618":"Süderen","3619":"Eriz - Innereriz","3622":"Homberg b. Thun","3623":"Teuffenthal b. Thun - Horrenbach - Buchen","3624":"Goldiwil (Thun) - Schwendibach","3625":"Heiligenschwendi","3626":"Hünibach","3627":"Heimberg","3628":"Kienersrüti - Uttigen","3629":"Oppligen - Kiesen - Jaberg","3631":"Höfen b. Thun","3632":"Oberstocken - Niederstocken","3633":"Amsoldingen","3634":"Thierachern","3635":"Uebeschi","3636":"Forst b. Längenbühl - Längenbühl","3638":"Blumenstein - Pohlern","3645":"Gwatt (Thun) - Zwieselberg","3646":"Einigen","3647":"Reutigen","3652":"Hilterfingen","3653":"Oberhofen am Thunersee","3654":"Gunten","3655":"Sigriswil","3656":"Tschingel ob Gunten - Ringoldswil - Aeschlen ob Gunten","3657":"Schwanden (Sigriswil)","3658":"Merligen","3661":"Uetendorf","3662":"Seftigen","3663":"Gurzelen","3664":"Burgistein","3665":"Wattenwil","3671":"Brenzikofen - Herbligen","3672":"Oberdiessbach - Aeschlen b. Oberdiessbach","3673":"Linden","3674":"Bleiken b. Oberdiessbach","3700":"Spiez","3702":"Hondrich","3703":"Aeschi b. Spiez - Aeschiried","3704":"Krattigen","3705":"Faulensee","3706":"Leissigen","3707":"Därligen","3711":"Mülenen - Emdthal","3713":"Reichenbach im Kandertal","3714":"Frutigen - Wengi b. Frutigen","3715":"Adelboden","3716":"Kandergrund","3717":"Blausee-Mitholz","3718":"Kandersteg","3722":"Scharnachtal","3723":"Kiental","3724":"Ried (Frutigen)","3725":"Achseten","3752":"Wimmis","3753":"Oey","3754":"Diemtigen","3755":"Horboden","3756":"Zwischenflüh","3757":"Schwenden im Diemtigtal","3758":"Latterbach","3762":"Erlenbach im Simmental","3763":"Därstetten","3764":"Weissenburg","3765":"Oberwil im Simmental","3766":"Boltigen","3770":"Zweisimmen","3771":"Blankenburg","3772":"St. Stephan","3773":"Matten (St. Stephan)","3775":"Lenk im Simmental","3776":"Oeschseite","3777":"Saanenmöser","3778":"Schönried","3780":"Gstaad","3781":"Turbach","3782":"Lauenen b. Gstaad","3783":"Grund b. Gstaad","3784":"Feutersoey","3785":"Gsteig b. Gstaad","3792":"Saanen","3800":"Sundlauenen - Matten b. Interlaken - Interlaken - Unterseen","3801":"Jungfraujoch","3803":"Beatenberg","3804":"Habkern","3805":"Goldswil b. Interlaken","3806":"Bönigen b. Interlaken","3807":"Iseltwald","3812":"Wilderswil","3813":"Saxeten","3814":"Gsteigwiler","3815":"Gündlischwand - Zweilütschinen","3816":"Lütschental - Burglauenen","3818":"Grindelwald","3822":"Lauterbrunnen - Isenfluh","3823":"Eigergletscher - Kleine Scheidegg - Wengen","3824":"Stechelberg","3825":"Mürren","3826":"Gimmelwald","3852":"Ringgenberg","3853":"Niederried b. Interlaken","3854":"Oberried am Brienzersee","3855":"Axalp - Brienz - Schwanden b. Brienz","3856":"Brienzwiler","3857":"Unterbach","3858":"Hofstetten b. Brienz","3860":"Meiringen - Schattenhalb - Brünig - Rosenlaui","3862":"Innertkirchen","3863":"Gadmen","3864":"Guttannen","3900":"Brig - Brigerbad - Gamsen","3901":"Rothwald","3902":"Glis","3903":"Mund - Birgisch","3904":"Naters","3905":"Saas-Almagell","3906":"Saas-Fee","3907":"Simplon Hospiz - Simplon Dorf - Gondo - Gabi (Simplon)","3908":"Saas-Balen","3910":"Saas-Grund","3911":"Ried-Brig","3912":"Termen","3913":"Rosswald","3914":"Blatten b. Naters - Belalp","3916":"Ferden","3917":"Goppenstein - Kippel","3918":"Wiler (Lötschen)","3919":"Blatten (Lötschen)","3920":"Zermatt","3922":"Eisten - Stalden - Kalpetran","3923":"Törbel","3924":"St. Niklaus - Gasenried","3925":"Grächen","3926":"Embd","3927":"Herbriggen","3928":"Randa","3929":"Täsch","3930":"Visp - Eyholz","3931":"Lalden","3932":"Visperterminen","3933":"Staldenried","3934":"Zeneggen","3935":"Bürchen","3937":"Baltschieder","3938":"Ausserberg","3939":"Eggerberg","3940":"Steg","3942":"Raron - St. German - Niedergesteln","3943":"Eischoll","3944":"Unterbäch","3945":"Gampel - Niedergampel","3946":"Turtmann - Gruben","3947":"Ergisch","3948":"Unterems - Oberems","3949":"Hohtenn","3951":"Agarn","3952":"Susten","3953":"Varen - Inden - Leuk Stadt","3954":"Leukerbad","3955":"Albinen","3956":"Guttet-Feschel","3957":"Erschmatt - Bratsch","3960":"Muraz (Sierre) - Sierre - Loc - Niouc - Corin-de-la-Crête","3961":"Zinal - St-Jean - St-Luc - Chandolin - Vissoie - Grimentz - Ayer","3963":"Montana - Aminona - Crans-Montana","3965":"Chippis","3966":"Chalais - Réchy","3967":"Vercorin","3968":"Veyras","3970":"Salgesch","3971":"Chermignon - Chermignon-d'en-Bas - Ollon","3972":"Miège","3973":"Venthône","3974":"Mollens","3975":"Randogne","3976":"Champzabé - Noës","3977":"Granges","3978":"Flanthey","3979":"Grône","3982":"Bitsch","3983":"Greich - Mörel - Bister - Filet - Goppisberg","3984":"Fieschertal - Fiesch","3985":"Münster - Geschinen","3986":"Ried-Mörel","3987":"Riederalp","3988":"Ulrichen - Obergesteln","3989":"Blitzingen - Selkingen - Ritzingen - Biel - Niederwald","3991":"Betten","3992":"Bettmeralp","3993":"Grengiols","3994":"Lax - Martisberg","3995":"Ernen - Mühlebach (Goms) - Steinhaus - Ausserbinn","3996":"Binn","3997":"Bellwald","3998":"Reckingen - Gluringen","3999":"Oberwald","4000":"Basel","4001":"Basel","4002":"Basel","4003":"Basel","4004":"Basel","4005":"Basel","4007":"Basel","4008":"Basel","4009":"Basel","4010":"Basel","4011":"Basel","4012":"Basel","4013":"Basel","4015":"Basel","4016":"Basel","4017":"Basel","4018":"Basel","4019":"Basel","4020":"Basel","4023":"Basel","4024":"Basel","4025":"Basel","4030":"Basel","4032":"Basel","4039":"Basel","4040":"Basel","4051":"Basel","4052":"Basel","4053":"Basel","4054":"Basel","4055":"Basel","4056":"Basel","4057":"Basel","4058":"Basel","4059":"Basel","4070":"Basel","4075":"Basel","4080":"Basel","4083":"Basel","4084":"Basel","4085":"Basel","4086":"Basel","4087":"Basel","4088":"Basel","4091":"Basel","4101":"Bruderholz","4102":"Binningen","4103":"Bottmingen","4104":"Oberwil","4105":"Biel-Benken","4106":"Therwil","4107":"Ettingen","4108":"Witterswil","4112":"Flüh - Bättwil","4114":"Hofstetten","4115":"Mariastein","4116":"Metzerlen","4117":"Burg im Leimental","4118":"Rodersdorf","4123":"Allschwil","4124":"Schönenbuch","4125":"Riehen","4126":"Bettingen","4127":"Birsfelden","4132":"Muttenz","4133":"Pratteln","4142":"Münchenstein","4143":"Dornach","4144":"Arlesheim","4145":"Gempen","4146":"Hochwald","4147":"Aesch","4148":"Pfeffingen","4153":"Reinach","4202":"Duggingen","4203":"Grellingen","4204":"Himmelried","4206":"Seewen","4207":"Bretzwil","4208":"Nunningen","4222":"Zwingen","4223":"Blauen","4224":"Nenzlingen","4225":"Brislach","4226":"Breitenbach","4227":"Büsserach","4228":"Erschwil","4229":"Beinwil","4232":"Fehren","4233":"Meltingen","4234":"Zullwil","4242":"Laufen","4243":"Dittingen","4244":"Röschenz","4245":"Kleinlützel","4246":"Wahlen b. Laufen","4247":"Grindel","4252":"Bärschwil","4253":"Liesberg","4254":"Liesberg Dorf","4302":"Augst","4303":"Kaiseraugst","4304":"Giebenach","4305":"Olsberg","4310":"Rheinfelden","4312":"Magden","4313":"Möhlin","4314":"Zeiningen","4315":"Zuzgen","4316":"Hellikon","4317":"Wegenstetten","4322":"Mumpf","4323":"Wallbach","4324":"Obermumpf","4325":"Schupfart","4332":"Stein","4333":"Münchwilen","4334":"Sisseln","4402":"Frenkendorf","4410":"Liestal","4411":"Seltisberg","4412":"Nuglar","4413":"Büren","4414":"Füllinsdorf","4415":"Lausen","4416":"Bubendorf","4417":"Ziefen","4418":"Reigoldswil","4419":"Lupsingen","4421":"St. Pantaleon","4422":"Arisdorf","4423":"Hersberg","4424":"Arboldswil","4425":"Titterten","4426":"Lauwil","4431":"Bennwil","4432":"Lampenberg","4433":"Ramlinsburg","4434":"Hölstein","4435":"Niederdorf","4436":"Liedertswil - Oberdorf","4437":"Waldenburg","4438":"Langenbruck","4441":"Thürnen","4442":"Diepflingen","4443":"Wittinsburg","4444":"Rümlingen","4445":"Häfelfingen","4446":"Buckten","4447":"Känerkinden","4448":"Läufelfingen","4450":"Sissach","4451":"Wintersingen","4452":"Itingen","4453":"Nusshof","4455":"Zunzgen","4456":"Tenniken","4457":"Diegten","4458":"Eptingen","4460":"Gelterkinden","4461":"Böckten","4462":"Rickenbach","4463":"Buus","4464":"Maisprach","4465":"Hemmiken","4466":"Ormalingen","4467":"Rothenfluh","4468":"Kienberg","4469":"Anwil","4492":"Tecknau","4493":"Wenslingen","4494":"Oltingen","4495":"Zeglingen","4496":"Kilchberg","4497":"Rünenberg","4500":"Solothurn","4501":"Solothurn","4502":"Solothurn","4503":"Solothurn","4509":"Solothurn","4512":"Bellach","4513":"Langendorf","4514":"Lommiswil","4515":"Weissenstein b. Solothurn - Oberdorf","4522":"Rüttenen","4523":"Niederwil","4524":"Günsberg - Oberbalmberg - Balmberg","4525":"Balm b. Günsberg","4528":"Zuchwil","4532":"Feldbrunnen","4533":"Riedholz","4534":"Flumenthal","4535":"Hubersdorf - Kammersrohr","4536":"Attiswil","4537":"Wiedlisbach","4538":"Oberbipp","4539":"Farnern - Rumisberg","4542":"Luterbach","4543":"Deitingen","4552":"Derendingen","4553":"Subingen","4554":"Etziken - Hüniken","4556":"Aeschi - Burgäschi - Steinhof - Bolken","4557":"Horriwil","4558":"Heinrichswil - Hersiwil - Winistorf","4562":"Biberist","4563":"Gerlafingen","4564":"Zielebach - Obergerlafingen","4565":"Recherswil","4566":"Oekingen - Kriegstetten - Halten","4571":"Ichertswil - Lüterkofen","4573":"Lohn-Ammannsegg","4574":"Lüsslingen - Nennigkofen","4576":"Tscheppach","4577":"Hessigkofen","4578":"Bibern","4579":"Gossliwil","4581":"Küttigkofen","4582":"Brügglen","4583":"Mühledorf - Aetigkofen","4584":"Gächliwil - Lüterswil","4585":"Biezwil","4586":"Kyburg-Buchegg","4587":"Aetingen","4588":"Unterramsern - Oberramsern - Brittern","4600":"Olten","4603":"Olten","4612":"Wangen b. Olten","4613":"Rickenbach","4614":"Hägendorf","4615":"Allerheiligenberg","4616":"Kappel","4617":"Gunzgen","4618":"Boningen","4620":"Härkingen","4621":"Härkingen","4622":"Egerkingen","4623":"Neuendorf","4624":"Härkingen","4625":"Oberbuchsiten","4626":"Niederbuchsiten","4628":"Wolfwil","4629":"Fulenbach","4632":"Trimbach","4633":"Hauenstein","4634":"Wisen","4652":"Winznau","4653":"Obergösgen","4654":"Lostorf","4655":"Stüsslingen - Rohr b. Olten","4656":"Starrkirch-Wil","4657":"Dulliken","4658":"Däniken","4663":"Aarburg","4665":"Oftringen","4702":"Oensingen","4703":"Kestenholz","4704":"Wolfisberg - Niederbipp","4710":"Balsthal","4712":"Laupersdorf","4713":"Matzendorf","4714":"Aedermannsdorf","4715":"Herbetswil","4716":"Gänsbrunnen - Welschenrohr","4717":"Mümliswil","4718":"Holderbank","4719":"Ramiswil","4800":"Zofingen","4802":"Strengelbach","4803":"Vordemwald","4805":"Brittnau","4806":"Wikon","4812":"Mühlethal","4813":"Uerkheim","4814":"Bottenwil","4852":"Rothrist","4853":"Murgenthal - Riken","4856":"Glashütten","4900":"Langenthal","4901":"Langenthal","4902":"Langenthal","4911":"Schwarzhäusern","4912":"Aarwangen","4913":"Bannwil","4914":"Roggwil","4915":"St. Urban","4916":"Untersteckholz","4917":"Busswil b. Melchnau - Melchnau","4919":"Reisiswil","4922":"Bützberg - Thunstetten","4923":"Wynau","4924":"Obersteckholz","4932":"Lotzwil - Gutenburg","4933":"Rütschelen","4934":"Madiswil","4935":"Leimiswil","4936":"Kleindietwil","4937":"Ursenbach","4938":"Rohrbach - Rohrbachgraben","4942":"Walterswil","4943":"Oeschenbach","4944":"Auswil","4950":"Huttwil","4952":"Eriswil","4953":"Schwarzenbach (Huttwil)","4954":"Wyssachen","4955":"Gondiswil","5000":"Aarau","5004":"Aarau","5012":"Wöschnau - Eppenberg - Schönenwerd","5013":"Niedergösgen","5014":"Gretzenbach","5015":"Erlinsbach","5017":"Barmelweid","5018":"Erlinsbach","5022":"Rombach","5023":"Biberstein","5024":"Küttigen","5025":"Asp","5026":"Densbüren","5027":"Herznach","5028":"Ueken","5032":"Aarau Rohr","5033":"Buchs","5034":"Suhr","5035":"Unterentfelden","5036":"Oberentfelden","5037":"Muhen","5040":"Schöftland","5042":"Hirschthal","5043":"Holziken","5044":"Schlossrued","5046":"Schmiedrued - Walde","5053":"Wittwil - Staffelbach","5054":"Kirchleerau - Moosleerau","5056":"Attelwil","5057":"Reitnau","5058":"Wiliberg","5062":"Oberhof","5063":"Wölflinswil","5064":"Wittnau","5070":"Frick","5072":"Oeschgen","5073":"Gipf-Oberfrick","5074":"Eiken","5075":"Hornussen","5076":"Bözen","5077":"Elfingen","5078":"Effingen","5079":"Zeihen","5080":"Laufenburg","5082":"Kaisten","5083":"Ittenthal","5084":"Rheinsulz","5085":"Sulz","5102":"Rupperswil","5103":"Möriken - Wildegg","5105":"Auenstein","5106":"Veltheim","5107":"Schinznach Dorf","5108":"Oberflachs","5112":"Thalheim","5113":"Holderbank","5116":"Schinznach Bad","5200":"Brugg","5201":"Brugg","5210":"Windisch","5212":"Hausen","5213":"Villnachern","5222":"Umiken","5223":"Riniken","5224":"Unterbözberg - Linn - Gallenkirch","5225":"Oberbözberg","5233":"Stilli","5234":"Villigen","5235":"Rüfenach","5236":"Remigen","5237":"Mönthal","5242":"Lupfig - Birr","5243":"Mülligen","5244":"Birrhard","5245":"Habsburg","5246":"Scherz","5272":"Gansingen","5273":"Oberhofen","5274":"Mettau","5275":"Etzgen","5276":"Wil","5277":"Hottwil","5300":"Turgi","5301":"Siggenthal Station","5303":"Würenlingen","5304":"Endingen","5305":"Unterendingen","5306":"Tegerfelden","5312":"Döttingen","5313":"Klingnau","5314":"Kleindöttingen","5315":"Böttstein","5316":"Felsenau - Leuggern","5317":"Hettenschwil","5318":"Mandach","5322":"Koblenz","5323":"Rietheim","5324":"Full-Reuenthal","5325":"Leibstadt","5326":"Schwaderloch","5330":"Bad Zurzach","5332":"Rekingen","5333":"Baldingen","5334":"Böbikon","5400":"Baden","5401":"Baden","5402":"Baden","5404":"Baden","5405":"Dättwil","5406":"Rütihof","5408":"Ennetbaden","5412":"Vogelsang - Gebenstorf","5413":"Birmenstorf","5415":"Rieden - Nussbaumen - Hertenstein","5416":"Kirchdorf","5417":"Untersiggenthal","5420":"Ehrendingen","5423":"Freienwil","5425":"Schneisingen","5426":"Lengnau","5430":"Wettingen","5431":"Wettingen Sonderdienste","5432":"Neuenhof","5436":"Würenlos","5442":"Fislisbach","5443":"Niederrohrdorf","5444":"Künten","5445":"Eggenwil","5452":"Oberrohrdorf","5453":"Remetschwil","5454":"Bellikon","5462":"Siglistorf","5463":"Wislikofen","5464":"Rümikon","5465":"Mellikon","5466":"Kaiserstuhl","5467":"Fisibach","5502":"Hunzenschwil","5503":"Schafisheim","5504":"Othmarsingen","5505":"Brunegg","5506":"Mägenwil","5507":"Mellingen","5512":"Wohlenschwil","5522":"Tägerig","5524":"Nesselnbach - Niederwil","5525":"Fischbach-Göslikon","5600":"Lenzburg - Ammerswil","5601":"Lenzburg Sonderdienste","5603":"Staufen","5604":"Hendschiken","5605":"Dottikon","5606":"Dintikon","5607":"Hägglingen","5608":"Stetten","5610":"Wohlen","5611":"Anglikon","5612":"Villmergen","5613":"Hilfikon","5614":"Sarmenstorf","5615":"Fahrwangen","5616":"Meisterschwanden","5617":"Tennwil","5618":"Bettwil","5619":"Büttikon - Uezwil","5620":"Bremgarten","5621":"Zufikon","5622":"Waltenschwil","5623":"Boswil","5624":"Bünzen - Waldhäusern","5625":"Kallern","5626":"Hermetschwil-Staffeln","5627":"Besenbüren","5628":"Aristau","5630":"Muri","5632":"Buttwil","5634":"Merenschwand","5636":"Benzenschwil","5637":"Beinwil (Freiamt) - Geltwil","5642":"Mühlau","5643":"Alikon - Meienberg - Sins","5644":"Auw","5645":"Aettenschwil - Fenkrieden","5646":"Abtwil","5647":"Oberrüti","5702":"Niederlenz","5703":"Seon","5704":"Egliswil","5705":"Hallwil","5706":"Boniswil","5707":"Seengen","5708":"Birrwil","5712":"Beinwil am See","5722":"Gränichen","5723":"Teufenthal","5724":"Dürrenäsch","5725":"Leutwil","5726":"Unterkulm","5727":"Oberkulm","5728":"Gontenschwil","5732":"Zetzwil","5733":"Leimbach","5734":"Reinach","5735":"Pfeffikon","5736":"Burg","5737":"Menziken","5742":"Kölliken","5745":"Safenwil","5746":"Walterswil","6000":"Luzern","6002":"Luzern","6003":"Luzern","6004":"Luzern","6005":"St. Niklausen - Luzern","6006":"Luzern","6007":"Luzern","6009":"Luzern","6010":"Kriens","6011":"Kriens","6012":"Obernau","6013":"Eigenthal","6014":"Luzern","6015":"Luzern","6016":"Hellbühl","6017":"Ruswil","6018":"Buttisholz","6019":"Sigigen","6020":"Emmenbrücke","6021":"Emmenbrücke","6022":"Grosswangen","6023":"Rothenburg","6024":"Hildisrieden","6025":"Neudorf","6026":"Rain","6027":"Römerswil","6028":"Herlisberg","6030":"Ebikon","6031":"Ebikon","6032":"Emmen","6033":"Buchrain","6034":"Inwil","6035":"Perlen","6036":"Dierikon","6037":"Root","6038":"Honau - Gisikon","6039":"Root Längenbold","6042":"Dietwil","6043":"Adligenswil","6044":"Udligenswil","6045":"Meggen","6047":"Kastanienbaum","6048":"Horw","6052":"Hergiswil","6053":"Alpnachstad","6055":"Alpnach Dorf","6056":"Kägiswil","6060":"Sarnen - Ramersberg","6061":"Sarnen 1","6062":"Wilen (Sarnen)","6063":"Stalden (Sarnen)","6064":"Kerns","6066":"St. Niklausen","6067":"Melchtal","6068":"Melchsee-Frutt","6072":"Sachseln","6073":"Flüeli-Ranft","6074":"Giswil","6078":"Bürglen - Lungern","6083":"Hasliberg Hohfluh","6084":"Hasliberg Wasserwendi","6085":"Hasliberg Goldern","6086":"Hasliberg Reuti","6102":"Malters","6103":"Schwarzenberg","6105":"Schachen","6106":"Werthenstein","6110":"Wolhusen - Fontannen b. Wolhusen","6112":"Doppleschwand","6113":"Romoos","6114":"Steinhuserberg","6122":"Menznau","6123":"Geiss","6125":"Menzberg","6126":"Daiwil","6130":"Willisau","6132":"Rohrmatt","6133":"Hergiswil b. Willisau","6142":"Gettnau","6143":"Ohmstal","6144":"Zell","6145":"Fischbach","6146":"Grossdietwil","6147":"Altbüron","6152":"Hüswil","6153":"Ufhusen","6154":"Hofstatt","6156":"Luthern - Luthern Bad","6162":"Finsterwald b. Entlebuch - Entlebuch - Rengg","6163":"Ebnet","6166":"Hasle","6167":"Bramboden","6170":"Schüpfheim","6173":"Flühli","6174":"Sörenberg","6182":"Escholzmatt","6192":"Wiggen","6196":"Marbach","6197":"Schangnau","6203":"Sempach Station","6204":"Sempach","6205":"Eich","6206":"Neuenkirch","6207":"Nottwil","6208":"Oberkirch","6210":"Sursee","6211":"Buchs","6212":"Kaltbach - St. Erhard","6213":"Knutwil","6214":"Schenkon","6215":"Beromünster - Schwarzenbach","6216":"Mauensee","6217":"Kottwil","6218":"Ettiswil","6221":"Rickenbach","6222":"Gunzwil","6231":"Schlierbach","6232":"Geuensee","6233":"Büron","6234":"Kulmerau - Triengen","6235":"Winikon","6236":"Wilihof","6242":"Wauwil","6243":"Egolzwil","6244":"Nebikon","6245":"Ebersecken","6246":"Altishofen","6247":"Schötz","6248":"Alberswil","6252":"Dagmersellen","6253":"Uffikon","6260":"Reidermoos - Reiden - Hintermoos - Mehlsecken","6262":"Langnau b. Reiden","6263":"Richenthal","6264":"Pfaffnau","6265":"Roggliswil","6274":"Eschenbach","6275":"Ballwil","6276":"Hohenrain","6277":"Kleinwangen - Lieli","6280":"Urswil - Hochdorf","6281":"Hochdorf","6283":"Baldegg","6284":"Gelfingen - Sulz","6285":"Hitzkirch - Retschwil","6286":"Altwis","6287":"Aesch","6288":"Schongau","6289":"Müswangen - Hämikon","6294":"Ermensee","6295":"Mosen","6300":"Zug - Zugerberg","6301":"Zug","6302":"Zug","6303":"Zug","6304":"Zug","6310":"Zug Sonderdienste","6312":"Steinhausen","6313":"Edlibach - Finstersee - Menzingen","6314":"Neuägeri - Unterägeri","6315":"Alosen - Morgarten - Oberägeri","6317":"Oberwil b. Zug","6318":"Walchwil","6319":"Allenwinden","6330":"Cham","6331":"Hünenberg","6332":"Hagendorn","6333":"Hünenberg See","6340":"Baar - Sihlbrugg","6341":"Baar","6342":"Baar","6343":"Buonas - Risch - Rotkreuz - Holzhäusern","6344":"Meierskappel","6345":"Neuheim","6346":"Baar 3","6349":"Baar Sonderdienste","6353":"Weggis","6354":"Vitznau","6356":"Rigi Kaltbad","6362":"Stansstad","6363":"Obbürgen - Bürgenstock - Fürigen","6365":"Kehrsiten","6370":"Stans - Oberdorf","6371":"Stans","6372":"Ennetmoos","6373":"Ennetbürgen","6374":"Buochs","6375":"Beckenried","6376":"Emmetten","6377":"Seelisberg","6382":"Büren","6383":"Wiesenberg - Wirzweli - Niederrickenbach - Dallenwil","6386":"Wolfenschiessen","6387":"Oberrickenbach","6388":"Grafenort","6390":"Engelberg","6391":"Engelberg","6402":"Merlischachen","6403":"Küssnacht am Rigi","6404":"Greppen","6405":"Immensee","6410":"Rigi Kulm - Rigi Staffel - Rigi Scheidegg - Rigi Klösterli - Goldau","6414":"Oberarth","6415":"Arth","6416":"Steinerberg","6417":"Sattel","6418":"Rothenthurm","6422":"Steinen","6423":"Seewen","6424":"Lauerz","6430":"Schwyz","6431":"Schwyz","6432":"Rickenbach b. Schwyz","6433":"Stoos","6434":"Illgau","6436":"Ried (Muotathal) - Muotathal - Bisisthal","6438":"Ibach","6440":"Brunnen","6441":"Rütli","6442":"Gersau","6443":"Morschach","6452":"Riemenstalden - Sisikon","6454":"Flüelen","6460":"Altdorf","6461":"Isenthal","6462":"Seedorf","6463":"Bürglen","6464":"Spiringen","6465":"Unterschächen","6466":"Bauen","6467":"Schattdorf","6468":"Attinghausen","6469":"Haldi b. Schattdorf","6472":"Erstfeld","6473":"Silenen","6474":"Amsteg","6475":"Bristen","6476":"Intschi","6482":"Gurtnellen","6484":"Wassen","6485":"Meien","6487":"Göschenen","6490":"Andermatt","6491":"Realp","6493":"Hospental","6500":"Bellinzona","6501":"Bellinzona","6503":"Bellinzona","6512":"Giubiasco","6513":"Monte Carasso","6514":"Sementina","6515":"Gudo","6516":"Cugnasco","6517":"Arbedo","6518":"Gorduno","6523":"Preonzo","6524":"Moleno","6525":"Gnosca","6526":"Prosito","6527":"Lodrino","6528":"Camorino","6532":"Castione","6533":"Lumino","6534":"S. Vittore","6535":"Roveredo","6537":"Grono","6538":"Verdabbio","6540":"Castaneda","6541":"Sta. Maria in Calanca","6542":"Buseno","6543":"Arvigo","6544":"Braggio","6545":"Selma","6546":"Cauco","6547":"Augio","6548":"Rossa","6549":"Laura","6556":"Leggia","6557":"Cama","6558":"Lostallo","6562":"Soazza","6563":"Mesocco","6565":"S. Bernardino","6571":"Indemini","6572":"Quartino","6573":"Magadino","6574":"Vira (Gambarogno)","6575":"Vairano - S. Nazzaro","6576":"Gerra (Gambarogno)","6577":"Ranzo","6578":"Caviano","6579":"Piazzogna","6582":"Pianezzo","6583":"S. Antonio (Val Morobbia)","6584":"Carena","6592":"S. Antonino","6593":"Cadenazzo","6594":"Contone","6595":"Riazzino","6596":"Gordola","6597":"Agarone","6598":"Tenero","6599":"Robasacco","6600":"Muralto - Solduno - Locarno","6601":"Locarno","6602":"Muralto","6604":"Locarno","6605":"Locarno - Monte Brè sopra Locarno","6611":"Mosogno - Crana - Gresso","6612":"Ascona","6613":"Porto Ronco","6614":"Isole di Brissago - Brissago","6616":"Losone","6618":"Arcegno","6622":"Ronco sopra Ascona","6631":"Corippo","6632":"Vogorno","6633":"Lavertezzo","6634":"Brione (Verzasca)","6635":"Gerra (Verzasca)","6636":"Frasco","6637":"Sonogno","6644":"Orselina","6645":"Brione sopra Minusio","6646":"Contra","6647":"Mergoscia","6648":"Minusio","6652":"Tegna","6653":"Verscio","6654":"Cavigliano","6655":"Rasa - Intragna - Verdasio","6656":"Golino","6657":"Palagnedra","6658":"Borgnone","6659":"Camedo - Moneto","6661":"Berzona - Auressio - Loco","6662":"Russo","6663":"Comologno - Spruga","6664":"Vergeletto","6670":"Avegno","6672":"Gordevio","6673":"Maggia","6674":"Riveo - Someo","6675":"Cevio","6676":"Bignasco","6677":"Moghegno - Aurigeno","6678":"Lodano - Giumaglio - Coglio","6682":"Linescio","6683":"Niva (Vallemaggia) - Cerentino","6684":"Campo (Vallemaggia) - Cimalmotto","6685":"Bosco/Gurin","6690":"S. Carlo (Val Bavona) - Cavergno","6692":"Menzonio - Brontallo","6693":"Broglio","6694":"Prato-Sornico","6695":"Piano di Peccia - Peccia","6696":"Fusio","6702":"Claro","6703":"Osogna","6705":"Cresciano","6707":"Iragna","6710":"Biasca - Biasca Stazione","6713":"Malvaglia","6714":"Semione","6715":"Dongio","6716":"Acquarossa - Leontica - Lottigna","6717":"Dangio-Torre - Torre","6718":"Olivone - Camperio","6719":"Aquila","6720":"Ghirone - Campo (Blenio)","6721":"Motto (Blenio) - Ludiano","6722":"Corzoneso","6723":"Marolta - Castro - Prugiasco","6724":"Largario - Ponto Valentino","6742":"Pollegio","6743":"Bodio","6744":"Personico","6745":"Giornico","6746":"Calonico - Nivo - Lavorgo","6747":"Chironico","6748":"Anzonico","6749":"Sobrio - Cavagnago","6760":"Rossura - Molare - Faido - Carì - Calpiogna - Campello","6763":"Mairengo - Osco","6764":"Chiggiogna","6772":"Rodi-Fiesso","6773":"Prato (Leventina)","6774":"Dalpe","6775":"Ambrì","6776":"Piotta","6777":"Varenzo - Quinto","6780":"Madrano - Airolo","6781":"Villa Bedretto - Bedretto","6802":"Rivera","6803":"Camignolo","6804":"Bironico","6805":"Mezzovico","6806":"Sigirino","6807":"Taverne","6808":"Torricella","6809":"Medeglia","6810":"Isone","6814":"Lamone - Cadempino","6815":"Melide","6816":"Bissone","6817":"Maroggia","6818":"Melano","6821":"Rovio","6822":"Arogno","6823":"Pugerna","6825":"Capolago","6826":"Riva San Vitale","6827":"Brusino Arsizio","6828":"Balerna","6830":"Chiasso","6832":"Pedrinate - Seseglio","6833":"Vacallo","6834":"Morbio Inferiore","6835":"Morbio Superiore","6836":"Serfontana","6837":"Caneggio - Bruzella","6838":"Scudellate - Muggio - Cabbio","6839":"Sagno","6850":"Mendrisio","6852":"Genestrerio","6853":"Ligornetto","6854":"S. Pietro","6855":"Stabio","6862":"Rancate","6863":"Besazio","6864":"Arzo","6865":"Tremona","6866":"Meride","6867":"Serpiano","6872":"Somazzo - Salorino","6873":"Corteglia","6874":"Castel San Pietro","6875":"Casima - Monte","6877":"Coldrerio","6883":"Novazzano","6900":"Massagno - Lugano - Paradiso","6901":"Lugano","6902":"Lugano","6903":"Lugano","6904":"Lugano","6905":"Lugano","6906":"Lugano","6907":"Lugano","6908":"Massagno Caselle","6911":"Campione d'Italia","6912":"Pazzallo","6913":"Carabbia","6914":"Carona","6915":"Pambio-Noranco","6916":"Grancia","6917":"Barbengo","6918":"Figino","6919":"Carabietta","6921":"Vico Morcote","6922":"Morcote","6924":"Sorengo","6925":"Gentilino","6926":"Montagnola","6927":"Agra","6928":"Manno","6929":"Gravesano","6930":"Bedano","6932":"Breganzona","6933":"Muzzano","6934":"Bioggio","6935":"Bosco Luganese","6936":"Cademario","6937":"Breno","6938":"Fescoggia - Vezio","6939":"Mugena - Arosio","6942":"Savosa","6943":"Vezia","6944":"Cureglia","6945":"Origlio","6946":"Ponte Capriasca","6947":"Vaglio","6948":"Porza","6949":"Comano","6950":"Tesserete","6951":"Cozzo - Signôra - Bogno - Scareglia - Odogno - Insone - Colla","6952":"Canobbio","6953":"Lugaggia","6954":"Bigorio - Sala Capriasca","6955":"Cagiallo - Oggio","6956":"Lopagno","6957":"Roveredo","6958":"Corticiasca - Bidogno","6959":"Piandera Paese - Maglio di Colla - Cimadera - Certara - Curtina","6962":"Viganello","6963":"Pregassona - Cureggia","6964":"Davesco-Soragno","6965":"Cadro","6966":"Villa Luganese","6967":"Dino","6968":"Sonvico","6974":"Aldesago","6976":"Castagnola","6977":"Ruvigliana","6978":"Gandria","6979":"Brè sopra Lugano","6980":"Castelrotto","6981":"Banco - Bombinasco - Bedigliora - Biogno-Beride","6982":"Agno","6983":"Magliaso","6984":"Pura","6986":"Miglieglia - Novaggio - Curio","6987":"Caslano","6988":"Ponte Tresa","6989":"Purasca","6990":"Cassina d'Agno","6991":"Neggio","6992":"Vernate - Cimo","6993":"Iseo","6994":"Aranno","6995":"Madonna del Piano - Molinazzo di Monteggio","6996":"Ponte Cremenaga","6997":"Sessa","6998":"Termine","6999":"Astano","7000":"Chur","7001":"Chur","7002":"Chur","7003":"Chur ","7004":"Chur","7006":"Chur","7007":"Chur","7012":"Felsberg","7013":"Domat/Ems","7014":"Trin","7015":"Tamins","7016":"Trin Mulin","7017":"Flims Dorf","7018":"Flims Waldhaus","7019":"Fidaz","7023":"Haldenstein","7026":"Maladers","7027":"Lüen - Castiel - Calfreisen","7028":"Pagig - St. Peter","7029":"Peist","7031":"Laax","7032":"Laax","7050":"Arosa","7056":"Molinis","7057":"Langwies","7058":"Litzirüti","7062":"Passugg-Araschgen","7063":"Praden","7064":"Tschiertschen","7074":"Malix","7075":"Churwalden","7076":"Parpan","7077":"Valbella","7078":"Lenzerheide/Lai","7082":"Vaz/Obervaz","7083":"Lantsch/Lenz","7084":"Brienz/Brinzauls","7104":"Versam - Arezen","7106":"Tenna","7107":"Safien Platz","7109":"Thalkirch","7110":"Peiden","7111":"Pitasch","7112":"Duvin","7113":"Camuns","7114":"Uors (Lumnezia)","7115":"Surcasti","7116":"St. Martin (Lugnez) - Tersnaus","7122":"Carrera - Valendas","7126":"Castrisch","7127":"Sevgein","7128":"Riein","7130":"Schnaus - Ilanz","7132":"Vals","7133":"Obersaxen Affeier","7134":"Obersaxen Meierhof","7135":"Obersaxen Giraniga","7136":"Obersaxen Friggahüs","7137":"Flond","7138":"Surcuolm","7141":"Luven","7142":"Cumbel","7143":"Morissen","7144":"Vella","7145":"Degen","7146":"Vattiz","7147":"Vignogn","7148":"Lumbrein - Surin","7149":"Vrin","7151":"Schluein","7152":"Sagogn","7153":"Falera","7154":"Ruschein","7155":"Ladir","7156":"Rueun - Pigniu","7157":"Siat","7158":"Waltensburg/Vuorz","7159":"Andiast","7162":"Tavanasa","7163":"Danis","7164":"Dardin","7165":"Breil/Brigels","7166":"Trun","7167":"Zignau","7168":"Schlans","7172":"Rabius","7173":"Surrein","7174":"S. Benedetg","7175":"Sumvitg","7176":"Cumpadials","7180":"Disentis/Mustér","7182":"Cavardiras","7183":"Mumpé Medel","7184":"Curaglia","7185":"Platta","7186":"Segnas","7187":"Camischolas","7188":"Sedrun","7189":"Rueras","7202":"Says","7203":"Trimmis","7204":"Untervaz","7205":"Zizers","7206":"Igis","7208":"Malans","7212":"Seewis-Pardisla - Seewis Dorf - Seewis-Schmitten","7213":"Valzeina","7214":"Seewis-Schmitten - Seewis-Pardisla - Grüsch","7215":"Fanas","7220":"Schiers","7222":"Mittellunden","7223":"Buchen im Prättigau","7224":"Putz","7226":"Stels - Fajauna","7228":"Schuders - Pusserein","7231":"Pragg-Jenaz","7232":"Furna","7233":"Jenaz","7235":"Fideris","7240":"Küblis","7241":"Conters im Prättigau","7242":"Luzein","7243":"Pany","7244":"Gadenstätt","7245":"Ascharina","7246":"St. Antönien","7247":"Saas im Prättigau","7249":"Serneus","7250":"Klosters","7252":"Klosters Dorf","7260":"Davos Dorf","7265":"Davos Wolfgang","7270":"Davos Platz","7272":"Davos Clavadel","7276":"Davos Frauenkirch","7277":"Davos Glaris","7278":"Davos Monstein","7302":"Landquart","7303":"Mastrils","7304":"Maienfeld","7306":"Fläsch","7307":"Jenins","7310":"Bad Ragaz","7312":"Pfäfers","7313":"St. Margrethenberg","7314":"Vadura","7315":"Vättis","7317":"Vasön - Valens","7320":"Sargans","7323":"Wangs","7324":"Vilters","7325":"Schwendi im Weisstannental","7326":"Weisstannen","7402":"Bonaduz","7403":"Rhäzüns","7404":"Feldis/Veulden","7405":"Rothenbrunnen","7407":"Trans","7408":"Realta - Cazis","7411":"Sils im Domleschg","7412":"Scharans","7413":"Fürstenaubruck","7414":"Fürstenau","7415":"Pratval - Rodels","7416":"Almens","7417":"Paspels","7418":"Tumegl/Tomils","7419":"Scheid","7421":"Summaprada","7422":"Tartar","7423":"Sarn - Portein","7424":"Dalin - Präz","7425":"Masein","7426":"Flerden","7427":"Urmein","7428":"Tschappina - Glaspass","7430":"Rongellen - Thusis","7431":"Mutten - Obermutten","7432":"Zillis","7433":"Farden - Mathon - Lohn - Wergenstein - Donat","7434":"Sufers","7435":"Splügen","7436":"Medels im Rheinwald","7437":"Nufenen","7438":"Hinterrhein","7440":"Andeer","7442":"Clugin","7443":"Pignia","7444":"Ausserferrera","7445":"Innerferrera","7446":"Campsut-Cröt","7447":"Am Bach (Avers) - Cresta (Avers)","7448":"Juf","7450":"Tiefencastel","7451":"Alvaschein","7452":"Cunter","7453":"Tinizong","7454":"Rona","7455":"Mulegns","7456":"Sur - Marmorera","7457":"Bivio","7458":"Mon","7459":"Stierva","7460":"Savognin","7462":"Salouf","7463":"Riom","7464":"Parsonz","7472":"Surava","7473":"Alvaneu Bad","7477":"Filisur","7482":"Bergün/Bravuogn - Preda - Stugl/Stuls","7484":"Latsch","7492":"Alvaneu Dorf","7493":"Schmitten (Albula)","7494":"Davos Wiesen","7500":"St. Moritz","7502":"Bever","7503":"Samedan","7504":"Pontresina","7505":"Celerina/Schlarigna","7512":"Champfèr","7513":"Silvaplana - Silvaplana-Surlej","7514":"Fex - Sils/Segl Maria","7515":"Sils/Segl Baselgia","7516":"Maloja","7517":"Plaun da Lej","7522":"La Punt-Chamues-ch","7523":"Madulain","7524":"Zuoz","7525":"S-chanf","7526":"Cinuos-chel","7527":"Brail","7530":"Zernez","7532":"Tschierv","7533":"Fuldera","7534":"Lü","7535":"Valchava","7536":"Sta. Maria Val Müstair","7537":"Müstair","7542":"Susch","7543":"Lavin","7545":"Guarda","7546":"Ardez","7550":"Scuol","7551":"Ftan","7552":"Vulpera","7553":"Tarasp","7554":"Sent - Crusch","7556":"Ramosch","7557":"Vnà","7558":"Strada","7559":"Tschlin","7560":"Martina","7562":"Samnaun-Compatsch","7563":"Samnaun Dorf","7602":"Casaccia","7603":"Vicosoprano","7604":"Borgonovo","7605":"Stampa","7606":"Promontogno","7608":"Castasegna","7610":"Soglio","7710":"Ospizio Bernina - Alp Grüm","7741":"S. Carlo (Poschiavo)","7742":"La Rösa - Sfazù - Poschiavo","7743":"Brusio - Miralago","7744":"Campocologno","7745":"Li Curt","7746":"Le Prese","7747":"Viano","7748":"Campascio","8000":"Zürich","8001":"Zürich","8002":"Zürich","8003":"Zürich","8004":"Zürich","8005":"Zürich","8006":"Zürich","8008":"Zürich","8010":"Zürich","8012":"Zürich","8015":"Zürich 15","8020":"Zürich 1","8021":"Zürich 1","8022":"Zürich","8023":"Zürich","8024":"Zürich","8026":"Zürich","8027":"Zürich","8030":"Zürich","8031":"Zürich","8032":"Zürich","8033":"Zürich","8034":"Zürich","8036":"Zürich","8037":"Zürich","8038":"Zürich","8039":"Zürich","8040":"Zürich","8041":"Zürich","8042":"Zürich","8044":"Gockhausen - Zürich","8045":"Zürich","8046":"Zürich","8047":"Zürich","8048":"Zürich","8049":"Zürich","8050":"Zürich","8051":"Zürich","8052":"Zürich","8053":"Zürich","8055":"Zürich","8057":"Zürich","8058":"Zürich","8060":"Zürich","8061":"Zürich","8063":"Zürich","8064":"Zürich","8065":"Zürich","8066":"Zürich","8068":"Zürich","8070":"Zürich","8080":"Zürich 80","8087":"Zürich","8088":"Zürich","8090":"Zürich","8091":"Zürich","8098":"Zürich","8099":"Zürich Sonderdienste","8102":"Oberengstringen","8103":"Unterengstringen","8104":"Weiningen","8105":"Watt - Regensdorf","8106":"Adlikon b. Regensdorf","8107":"Buchs","8108":"Dällikon","8109":"Kloster Fahr","8112":"Otelfingen","8113":"Boppelsen","8114":"Dänikon","8115":"Hüttikon","8117":"Fällanden","8118":"Pfaffhausen","8121":"Benglen","8122":"Binz","8123":"Ebmatingen","8124":"Maur","8125":"Zollikerberg","8126":"Zumikon","8127":"Forch","8132":"Egg b. Zürich - Hinteregg","8133":"Esslingen","8134":"Adliswil","8135":"Sihlwald - Langnau am Albis","8136":"Gattikon","8142":"Uitikon Waldegg","8143":"Uetliberg - Stallikon","8152":"Opfikon - Glattpark (Opfikon) - Glattbrugg","8153":"Rümlang","8154":"Oberglatt","8155":"Niederhasli - Nassenwil","8156":"Oberhasli","8157":"Dielsdorf","8158":"Regensberg","8162":"Sünikon - Steinmaur","8164":"Bachs","8165":"Schöfflisdorf - Schleinikon - Oberweningen","8166":"Niederweningen","8172":"Niederglatt","8173":"Neerach","8174":"Stadel b. Niederglatt","8175":"Windlach","8180":"Bülach","8181":"Höri","8182":"Hochfelden","8183":"Bülach Dist Ba","8184":"Bachenbülach","8185":"Winkel","8187":"Weiach","8192":"Zweidlen - Glattfelden","8193":"Eglisau","8194":"Hüntwangen","8195":"Wasterkingen","8196":"Wil","8197":"Rafz","8200":"Schaffhausen","8201":"Schaffhausen","8202":"Schaffhausen","8203":"Schaffhausen","8204":"Schaffhausen","8205":"Schaffhausen","8207":"Schaffhausen","8208":"Schaffhausen","8210":"Schaffhausen Dist Ba","8212":"Neuhausen am Rheinfall - Nohl","8213":"Neunkirch","8214":"Gächlingen","8215":"Hallau","8216":"Oberhallau","8217":"Wilchingen","8218":"Osterfingen","8219":"Trasadingen","8222":"Beringen","8223":"Guntmadingen","8224":"Löhningen","8225":"Siblingen","8226":"Schleitheim","8228":"Beggingen","8231":"Hemmental","8232":"Merishausen","8233":"Bargen","8234":"Stetten","8235":"Lohn","8236":"Opfertshofen - Büttenhardt","8239":"Dörflingen","8240":"Thayngen","8241":"Barzheim","8242":"Hofen - Bibern","8243":"Altdorf","8245":"Feuerthalen","8246":"Langwiesen","8247":"Flurlingen","8248":"Uhwiesen","8252":"Schlatt","8253":"Willisdorf - Diessenhofen","8254":"Basadingen","8255":"Schlattingen","8259":"Rheinklingen - Kaltenbach - Etzwilen - Wagenhausen","8260":"Stein am Rhein","8261":"Hemishofen","8262":"Ramsen","8263":"Buch","8264":"Eschenz","8265":"Mammern","8266":"Steckborn","8267":"Berlingen","8268":"Salenstein - Mannenbach-Salenstein","8269":"Fruthwilen","8272":"Ermatingen","8273":"Triboltingen","8274":"Tägerwilen - Gottlieben","8280":"Kreuzlingen","8301":"Glattzentrum b. Wallisellen","8302":"Kloten","8303":"Bassersdorf","8304":"Wallisellen","8305":"Dietlikon","8306":"Brüttisellen","8307":"Ottikon b. Kemptthal - Effretikon","8308":"Agasul - Illnau","8309":"Nürensdorf","8310":"Kemptthal - Grafstal","8311":"Brütten","8312":"Winterberg","8314":"Kyburg","8315":"Lindau","8317":"Tagelswangen","8320":"Fehraltorf","8322":"Madetswil - Gündisau","8325":"Effretikon Dist Ba","8330":"Pfäffikon - Hermatswil","8331":"Auslikon","8332":"Russikon - Rumlikon","8335":"Hittnau","8340":"Hinwil","8342":"Wernetshausen","8343":"Hinwil Dist Ba","8344":"Bäretswil","8345":"Adetswil","8352":"Ricketwil (Winterthur) - Elsau","8353":"Elgg","8354":"Hofstetten","8355":"Aadorf","8356":"Ettenhausen","8357":"Guntershausen b. Aadorf","8360":"Wallenwil - Eschlikon","8362":"Balterswil","8363":"Bichelsee","8370":"Sirnach","8371":"Busswil","8372":"Wiezikon b. Sirnach","8374":"Oberwangen - Dussnang","8376":"Au - Fischingen","8400":"Winterthur","8401":"Winterthur","8402":"Winterthur","8404":"Winterthur - Stadel (Winterthur) - Reutlingen (Winterthur)","8405":"Winterthur","8406":"Winterthur","8408":"Winterthur","8409":"Winterthur","8410":"Winterthur","8411":"Winterthur","8412":"Aesch (Neftenbach) - Hünikon (Neftenbach) - Riet (Neftenbach)","8413":"Neftenbach","8414":"Buch am Irchel","8415":"Gräslikon - Berg am Irchel","8416":"Flaach","8418":"Schlatt b. Winterthur","8421":"Dättlikon","8422":"Pfungen","8423":"Embrach-Embraport","8424":"Embrach","8425":"Oberembrach","8426":"Lufingen","8427":"Rorbas - Freienstein","8428":"Teufen","8442":"Hettlingen","8444":"Henggart","8447":"Dachsen","8450":"Andelfingen","8451":"Kleinandelfingen","8452":"Adlikon b. Andelfingen","8453":"Alten","8454":"Buchberg","8455":"Rüdlingen - Buchberg","8457":"Humlikon","8458":"Dorf","8459":"Volken","8460":"Marthalen","8461":"Oerlingen","8462":"Rheinau","8463":"Benken","8464":"Ellikon am Rhein","8465":"Wildensbuch - Rudolfingen","8466":"Trüllikon","8467":"Truttikon","8468":"Waltalingen - Guntalingen","8471":"Oberwil (Dägerlen) - Rutschwil (Dägerlen) - Dägerlen - Berg (Dägerlen) - Bänk (Dägerlen)","8472":"Seuzach","8474":"Dinhard","8475":"Ossingen","8476":"Unterstammheim","8477":"Oberstammheim","8478":"Thalheim an der Thur","8479":"Altikon","8482":"Sennhof (Winterthur)","8483":"Kollbrunn","8484":"Neschwil - Weisslingen - Theilingen","8486":"Rikon im Tösstal","8487":"Zell - Rämismühle","8488":"Turbenthal","8489":"Wildberg","8492":"Wila","8493":"Saland","8494":"Bauma","8495":"Schmidrüti","8496":"Steg im Tösstal","8497":"Fischenthal","8498":"Gibswil","8499":"Sternenberg","8500":"Frauenfeld - Gerlikon","8501":"Frauenfeld","8502":"Frauenfeld","8503":"Frauenfeld","8505":"Pfyn - Dettighofen","8506":"Lanzenneunforn","8507":"Hörhausen","8508":"Homburg","8510":"Frauenfeld Kant. Verwaltung","8512":"Thundorf - Lustdorf - Wetzikon","8514":"Amlikon-Bissegg","8520":"Frauenfeld Paketzentrum - Frauenfeld Dist Ba","8522":"Häuslenen - Aawangen","8523":"Hagenbuch","8524":"Buch b. Frauenfeld - Uesslingen","8525":"Wilen b. Neunforn - Niederneunforn","8526":"Oberneunforn","8532":"Warth - Weiningen","8535":"Herdern","8536":"Hüttwilen","8537":"Uerschhausen - Nussbaumen","8542":"Wiesendangen","8543":"Gundetswil - Kefikon - Bertschikon","8544":"Attikon","8545":"Rickenbach Sulz - Rickenbach","8546":"Islikon - Kefikon - Menzengrüt","8547":"Gachnang","8548":"Ellikon an der Thur","8552":"Felben-Wellhausen","8553":"Hüttlingen - Eschikofen - Harenwilen - Mettendorf","8554":"Bonau - Müllheim-Wigoltingen","8555":"Müllheim Dorf","8556":"Lamperswil - Engwang - Wigoltingen - Illhart","8558":"Raperswilen","8560":"Märstetten","8561":"Ottoberg","8564":"Lipperswil - Hattenhausen - Wäldi - Sonterswil - Engwilen - Gunterswilen - Hefenhausen - Wagerswil","8565":"Hugelshofen","8566":"Neuwilen - Dotnacht - Lippoldswilen - Ellighausen","8570":"Weinfelden","8572":"Berg - Guntershausen b. Berg - Andhausen - Graltshausen","8573":"Alterswilen - Siegershausen - Altishausen","8574":"Dettighofen (Lengwil) - Illighausen - Oberhofen - Lengwil","8575":"Istighofen - Bürglen","8576":"Mauren","8577":"Schönholzerswilen","8580":"Hefenhofen - Sommeri - Hagenwil b. Amriswil - Amriswil","8581":"Schocherswil","8582":"Dozwil","8583":"Donzhausen - Sulgen - Götighofen","8584":"Leimbach - Opfershofen","8585":"Herrenhof - Schönenbaumgarten - Zuben - Langrickenbach - Mattwil - Klarsreuti - Happerswil - Birwinken","8586":"Kümmertshausen - Erlen - Ennetaach - Riedt b. Erlen - Engishofen - Andwil - Buchackern - Buch b. Kümmertshausen","8587":"Oberaach","8588":"Zihlschlacht","8589":"Sitterdorf","8590":"Romanshorn","8592":"Uttwil","8593":"Kesswil","8594":"Güttingen","8595":"Altnau","8596":"Münsterlingen - Scherzingen","8597":"Landschlacht","8598":"Bottighofen","8599":"Salmsach","8600":"Dübendorf","8602":"Wangen b. Dübendorf","8603":"Schwerzenbach","8604":"Volketswil","8605":"Gutenswil","8606":"Nänikon - Greifensee","8607":"Aathal-Seegräben","8608":"Bubikon","8610":"Uster","8612":"Uster 2","8613":"Uster 3","8614":"Bertschikon (Gossau ZH) - Sulzbach","8615":"Wermatswil - Freudwil","8616":"Riedikon","8617":"Mönchaltorf","8618":"Oetwil am See","8620":"Wetzikon","8621":"Wetzikon 4","8622":"Wetzikon","8623":"Wetzikon","8624":"Grüt (Gossau ZH)","8625":"Gossau","8626":"Ottikon (Gossau ZH)","8627":"Grüningen","8630":"Rüti","8632":"Tann","8633":"Wolfhausen","8634":"Hombrechtikon","8635":"Dürnten","8636":"Wald","8637":"Laupen","8638":"Goldingen","8639":"Faltigberg","8640":"Rapperswil - Hurden","8645":"Jona","8646":"Wagen","8700":"Küsnacht","8702":"Zollikon","8703":"Erlenbach","8704":"Herrliberg","8706":"Meilen","8707":"Uetikon am See","8708":"Männedorf","8712":"Stäfa","8713":"Uerikon","8714":"Feldbach","8715":"Bollingen","8716":"Schmerikon","8717":"Benken","8718":"Schänis","8722":"Kaltbrunn","8723":"Rufi - Maseltrangen","8725":"Ernetschwil - Gebertingen","8726":"Ricken","8727":"Walde","8730":"Uznach","8732":"Neuhaus","8733":"Eschenbach","8734":"Ermenswil","8735":"St. Gallenkappel - Rüeterswil","8737":"Gommiswald","8738":"Uetliburg","8739":"Rieden","8750":"Riedern - Klöntal - Glarus","8751":"Urnerboden","8752":"Näfels","8753":"Mollis","8754":"Netstal","8755":"Ennenda","8756":"Mitlödi","8757":"Filzbach","8758":"Obstalden","8759":"Netstal","8762":"Schwanden - Sool - Schwändi b. Schwanden","8765":"Engi","8766":"Matt","8767":"Elm","8772":"Nidfurn","8773":"Haslen","8774":"Leuggelbach","8775":"Luchsingen - Hätzingen","8777":"Diesbach - Betschwanden","8782":"Rüti","8783":"Linthal","8784":"Braunwald","8800":"Thalwil","8801":"Thalwil Fächer","8802":"Kilchberg","8803":"Rüschlikon","8804":"Au","8805":"Richterswil","8806":"Bäch","8807":"Freienbach","8808":"Pfäffikon","8810":"Horgen","8812":"Horgen Bahnhof Oberdorf","8813":"Horgen","8815":"Horgenberg","8816":"Hirzel","8820":"Wädenswil","8824":"Schönenberg","8825":"Hütten","8832":"Wollerau - Wilen b. Wollerau","8833":"Samstagern","8834":"Schindellegi","8835":"Feusisberg","8836":"Bennau","8840":"Trachslau - Einsiedeln","8841":"Gross","8842":"Unteriberg","8843":"Oberiberg","8844":"Euthal","8845":"Studen","8846":"Willerzell","8847":"Egg","8849":"Alpthal","8852":"Altendorf","8853":"Lachen","8854":"Galgenen - Siebnen","8855":"Wangen","8856":"Tuggen","8857":"Vorderthal","8858":"Innerthal","8862":"Schübelbach","8863":"Buttikon","8864":"Reichenburg","8865":"Bilten","8866":"Ziegelbrücke","8867":"Niederurnen","8868":"Oberurnen","8872":"Weesen","8873":"Amden","8874":"Mühlehorn","8877":"Murg","8878":"Quinten","8879":"Pizolpark (Mels)","8880":"Walenstadt","8881":"Knoblisbühl - Walenstadtberg - Tscherlach","8882":"Unterterzen","8883":"Quarten","8884":"Oberterzen","8885":"Mols","8886":"Mädris-Vermol","8887":"Mels","8888":"Heiligkreuz (Mels)","8889":"Plons","8890":"Flums","8892":"Berschis","8902":"Urdorf","8903":"Birmensdorf","8904":"Aesch","8905":"Islisberg - Arni","8906":"Bonstetten","8907":"Wettswil","8908":"Hedingen","8909":"Zwillikon","8910":"Affoltern am Albis","8911":"Rifferswil","8912":"Obfelden","8913":"Ottenbach","8914":"Aeugstertal - Aeugst am Albis","8915":"Hausen am Albis","8916":"Jonen","8917":"Oberlunkhofen","8918":"Unterlunkhofen","8919":"Rottenschwil","8925":"Ebertswil","8926":"Uerzlikon - Kappel am Albis - Hauptikon","8932":"Mettmenstetten","8933":"Maschwanden","8934":"Knonau","8942":"Oberrieden","8951":"Fahrweid","8952":"Schlieren","8953":"Dietikon","8954":"Geroldswil","8955":"Oetwil an der Limmat","8956":"Killwangen","8957":"Spreitenbach","8962":"Bergdietikon","8964":"Rudolfstetten","8965":"Berikon","8966":"Oberwil-Lieli","8967":"Widen","9000":"St. Gallen","9001":"St. Gallen","9004":"St. Gallen","9006":"St. Gallen","9007":"St. Gallen","9008":"St. Gallen","9009":"St. Gallen","9010":"St. Gallen","9011":"St. Gallen","9012":"St. Gallen","9013":"St. Gallen","9014":"St. Gallen","9015":"St. Gallen","9016":"St. Gallen","9020":"St. Gallen","9022":"St. Gallen","9023":"St. Gallen","9028":"St. Gallen","9029":"St. Gallen Sonderdienste","9030":"Abtwil - St. Josefen","9032":"Engelburg","9033":"Untereggen","9034":"Eggersriet","9035":"Grub","9036":"Grub","9037":"Speicherschwendi","9038":"Rehetobel","9042":"Speicher","9043":"Trogen","9044":"Wald","9050":"Appenzell - Appenzell Eggerstanden - Appenzell Enggenhütten - Appenzell Meistersrüte - Appenzell Steinegg - Appenzell Schlatt","9052":"Niederteufen","9053":"Teufen","9054":"Haslen","9055":"Bühler","9056":"Gais","9057":"Weissbad - Wasserauen - Schwende","9058":"Brülisau","9062":"Lustmühle","9063":"Stein","9064":"Hundwil","9100":"Herisau","9101":"Herisau","9102":"Herisau","9103":"Schwellbrunn","9104":"Waldstatt","9105":"Schönengrund","9107":"Urnäsch","9108":"Gonten - Gontenbad - Jakobsbad","9112":"Schachen b. Herisau","9113":"Degersheim","9114":"Hoffeld","9115":"Dicken","9116":"Wolfertswil","9122":"Mogelsberg - Ebersol","9123":"Nassen","9125":"Brunnadern","9126":"Necker","9127":"St. Peterzell","9200":"Gossau","9201":"Gossau","9203":"Niederwil","9204":"Andwil","9205":"Waldkirch","9212":"Arnegg","9213":"Hauptwil","9214":"Kradolf","9215":"Schönenberg an der Thur - Buhwil","9216":"Hohentannen - Heldswil","9217":"Neukirch an der Thur","9220":"Bischofszell","9223":"Halden - Schweizersholz","9225":"St. Pelagiberg - Wilen (Gottshaus)","9230":"Flawil","9231":"Egg (Flawil)","9240":"Niederglatt - Uzwil","9242":"Oberuzwil","9243":"Jonschwil","9244":"Niederuzwil","9245":"Sonnental - Oberbüren","9246":"Niederbüren","9247":"Henau","9248":"Bichwil","9249":"Oberstetten - Niederstetten - Algetshausen","9300":"Wittenbach","9301":"Wittenbach","9304":"Bernhardzell","9305":"Berg","9306":"Freidorf","9308":"Lömmenschwil","9312":"Häggenschwil","9313":"Muolen","9314":"Steinebrunn","9315":"Winden - Neukirch (Egnach)","9320":"Stachen - Arbon - Frasnacht","9322":"Egnach","9323":"Steinach","9325":"Roggwil","9326":"Horn","9327":"Tübach","9400":"Rorschach","9401":"Rorschach","9402":"Mörschwil","9403":"Goldach","9404":"Rorschacherberg","9405":"Wienacht-Tobel","9410":"Heiden","9411":"Reute","9413":"Oberegg","9414":"Schachen b. Reute","9422":"Staad","9423":"Altenrhein","9424":"Rheineck","9425":"Thal","9426":"Lutzenberg","9427":"Wolfhalden","9428":"Walzenhausen","9430":"St. Margrethen","9434":"Au","9435":"Heerbrugg","9436":"Balgach","9437":"Marbach","9442":"Büriswilen - Berneck","9443":"Widnau","9444":"Diepoldsau","9445":"Rebstein","9450":"Altstätten - Lüchingen","9451":"Kriessern","9452":"Hinterforst","9453":"Eichberg","9462":"Montlingen","9463":"Oberriet","9464":"Rüthi (Rheintal) - Lienz","9465":"Salez","9466":"Sennwald","9467":"Frümsen","9468":"Sax","9469":"Haag (Rheintal)","9470":"Werdenberg - Buchs","9471":"Buchs","9472":"Grabserberg - Grabs","9473":"Gams","9475":"Sevelen","9476":"Fontnas - Weite","9477":"Trübbach","9478":"Azmoos","9479":"Malans - Oberschan - Gretschins","9500":"Wil","9501":"Wil","9502":"Braunau","9503":"Stehrenberg - Lanterswil","9504":"Friltschen","9506":"Lommis","9507":"Stettfurt","9508":"Weingarten-Kalthäusern","9512":"Rossrüti","9514":"Wuppenau","9515":"Hosenruck","9517":"Mettlen","9523":"Züberwangen","9524":"Zuzwil","9525":"Lenggenwil","9526":"Zuckenriet","9527":"Niederhelfenschwil","9532":"Rickenbach b. Wil","9533":"Dietschwil - Kirchberg","9534":"Gähwil","9535":"Wilen b. Wil","9536":"Schwarzenbach","9542":"Münchwilen","9543":"St. Margarethen","9545":"Wängi","9546":"Tuttwil","9547":"Wittenwil","9548":"Matzingen","9552":"Bronschhofen","9553":"Bettwiesen","9554":"Tägerschen","9555":"Tobel","9556":"Affeltrangen - Zezikon","9562":"Buch b. Märwil - Märwil","9565":"Bussnang - Oppikon - Oberbussnang - Rothenhausen - Schmidshof","9573":"Littenheid","9601":"Lütisburg Station","9602":"Müselbach - Bazenheid","9604":"Lütisburg - Oberrindal - Unterrindal","9606":"Bütschwil","9607":"Mosnang","9608":"Ganterschwil","9612":"Dreien","9613":"Mühlrüti","9614":"Libingen","9615":"Dietfurt","9620":"Lichtensteig","9621":"Oberhelfenschwil","9622":"Krinau","9630":"Wattwil","9631":"Ulisbach","9633":"Hemberg - Bächli (Hemberg)","9642":"Ebnat-Kappel","9643":"Krummenau","9650":"Nesslau","9651":"Ennetbühl","9652":"Neu St. Johann","9655":"Stein","9656":"Alt St. Johann","9657":"Unterwasser","9658":"Wildhaus"};

// EOF

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-util.js */
/* File: js/machinata-core-bundle.js/machinata-core-util.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Useful javascript functions.
/// Some of the util methods are directly taken from jQuery, or 1:1 compatible with jQuery, which allows a headless
/// profile (such as ```nodejs```) to run without jQuery.
/// </summary>
/// <type>namespace</type>
Machinata.Util = {};


/// <summary>
/// Clones a JSON object, creating a new identical copy.
/// The incomming data must be a pure JSON and cannot contain cyclic references.
/// </summary>
Machinata.Util.cloneJSON = function (json) {
    //TODO: @dan is there a faster way we can do this?
    return JSON.parse(JSON.stringify(json)); 
    //return Machinata.Util.extend({}, json);
};

/// <summary>
/// Merge the contents of two or more objects together into the first object, exactly the same as jQuery does.
/// See https://api.jquery.com/jQuery.extend/ for more details.
/// </summary>
Machinata.Util.extend = function () {
    var options, name, src, copy, copyIsArray, clone,
		target = arguments[0] || {},
		i = 1,
		length = arguments.length,
		deep = false;

    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;

        // Skip the boolean and the target
        target = arguments[i] || {};
        i++;
    }

    // Handle case when target is a string or something (possible in deep copy)
    if (typeof target !== "object" && typeof target !== "function") {
        target = {};
    }

    // Extend jQuery itself if only one argument is passed
    if (i === length) {
        target = this;
        i--;
    }

    for (; i < length; i++) {

        // Only deal with non-null/undefined values
        if ((options = arguments[i]) != null) {

            // Extend the base object
            for (name in options) {
                copy = options[name];

                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) {
                    continue;
                }

                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (Machinata.Util.isPlainObject(copy) ||
					(copyIsArray = Array.isArray(copy)))) {
                    src = target[name];

                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) {
                        clone = [];
                    } else if (!copyIsArray && !Machinata.Util.isPlainObject(src)) {
                        clone = {};
                    } else {
                        clone = src;
                    }
                    copyIsArray = false;

                    // Never move original objects, clone them
                    target[name] = Machinata.Util.extend(deep, clone, copy);

                    // Don't bring in undefined values
                } else if (copy !== undefined) {
                    target[name] = copy;
                }
            }
        }
    }

    // Return the modified object
    return target;
};


/// <summary>
/// Check to see if an object is a plain object (created using "{}" or "new Object").
/// See https://api.jquery.com/jQuery.isPlainObject/#jQuery-isPlainObject-object for more details.
/// </summary>
Machinata.Util.isPlainObject = function (obj) {
    var proto, Ctor;

    // Detect obvious negatives
    // Use toString instead of jQuery.type to catch host objects
    if (!obj || Machinata.Util._toString.call(obj) !== "[object Object]") {
        return false;
    }

    proto = Machinata.Util._getProto(obj);

    // Objects with no prototype (e.g., `Object.create( null )`) are plain
    if (!proto) {
        return true;
    }

    // Objects with prototype are plain iff they were constructed by a global Object function
    Ctor = Machinata.Util._hasOwn.call(proto, "constructor") && proto.constructor;
    return typeof Ctor === "function" && Machinata.Util._fnToString.call(Ctor) === Machinata.Util._ObjectFunctionString();
};

/// <summary>
/// A generic iterator function, which can be used to seamlessly iterate over 
/// both objects and arrays. Arrays and array-like objects with a length property 
/// (such as a function's arguments object) are iterated by numeric index, 
/// from 0 to length-1. Other objects are iterated via their named properties.
/// See https://api.jquery.com/jQuery.each/#jQuery-each-object-callback for more details.
/// </summary>
Machinata.Util.each = function (obj, callback) {
    var length, i = 0;

    if (Machinata.Util._isArrayLike(obj)) {
        length = obj.length;
        for (; i < length; i++) {
            if (callback.call(obj[i], i, obj[i]) === false) {
                break;
            }
        }
    } else {
        for (i in obj) {
            if (callback.call(obj[i], i, obj[i]) === false) {
                break;
            }
        }
    }

    return obj;
};

Machinata.each = Machinata.Util.each; // shortcut

/// <summary>
/// Internal Util method based on jQuery util libs.
/// </summary>
/// <hidden/>
Machinata.Util._isArrayLike = function (obj) {

    var length = !!obj && obj.length,
		type = Machinata.Util._toType(obj);

    if (typeof obj === "function" || Machinata.Util._isWindow(obj)) {
        return false;
    }

    return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && (length - 1) in obj;
};

/// <summary>
/// Internal Util method based on jQuery util libs.
/// </summary>
/// <hidden/>
Machinata.Util._isWindow = function( obj ) {
    return obj != null && obj === obj.window;
};

/// <summary>
/// Internal Util method based on jQuery util libs.
/// </summary>
/// <hidden/>
Machinata.Util._toType = function (obj) {
    if (obj == null) {
        return obj + "";
    }

    return typeof obj === "object" ?
		Machinata.Util._class2type[Machinata.Util._toString.call(obj)] || "object" :
		typeof obj;
};

/// <summary>
/// Internal Util method based on jQuery util libs.
/// </summary>
/// <hidden/>
Machinata.Util._class2type = {};
{
    var classes = "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" ");
    for(var i = 0; i < classes.length; i++) {
        var name = classes[i];
        Machinata.Util._class2type["[object " + name + "]"] = name.toLowerCase();
    }
}

/// <summary>
/// Internal Util method based on jQuery util libs.
/// </summary>
/// <hidden/>
Machinata.Util._toString = Machinata.Util._class2type.toString;

/// <summary>
/// Internal Util method based on jQuery util libs.
/// </summary>
/// <hidden/>
Machinata.Util._hasOwn = Machinata.Util._class2type.hasOwnProperty;

/// <summary>
/// Internal Util method based on jQuery util libs.
/// </summary>
/// <hidden/>
Machinata.Util._getProto = Object._getPrototypeOf;

/// <summary>
/// Internal Util method based on jQuery util libs.
/// </summary>
/// <hidden/>
Machinata.Util._fnToString = Machinata.Util._hasOwn.toString;

/// <summary>
/// Internal Util method based on jQuery util libs.
/// </summary>
/// <hidden/>
Machinata.Util._ObjectFunctionString = function () {
    return Machinata.Util._fnToString.call(Object);
};

/// <summary>
/// Returns true if the value is a function
/// </summary>
/// <hidden/>
Machinata.Util.isFunction = function (value) {
    // See https://stackoverflow.com/questions/5999998/check-if-a-variable-is-of-function-type
    return value && (Object.prototype.toString.call(value) === "[object Function]" || "function" === typeof value || value instanceof Function);
};

/// <summary>
/// Returns true if the value is a string
/// </summary>
/// <hidden/>
Machinata.Util.isString = function (val) {
    if (typeof val === 'string' || val instanceof String) return true;
    else return false;
};



/// <summary>
/// 
/// </summary>
Machinata.Util.changeNodeName = function (oldNode, newTagName) {
    var newNode = document.createElement(newTagName),node,nextNode;
    node = oldNode.firstChild;
    while (node) {
        nextNode = node.nextSibling;
        newNode.appendChild(node);
        node = nextNode;
    }
    newNode.className = oldNode.className;
    newNode.id = oldNode.id; // (Not invalid, they're not both in the tree at the same time)
    oldNode.parentNode.replaceChild(newNode, oldNode);
};

/// <summary>
/// 
/// </summary>
Machinata.Util.changeNodeNameByTag = function (oldTagName, newTagName) {
    var nodes = document.getElementsByTagName(oldTagName);
    for (var i = 0; i < nodes.length; i++) Machinata.Util.changeNodeName(nodes[i],newTagName);
};


/// <summary>
/// Creates a watchdog that monitors all iframes and automatically reloades them if they fail to load.
/// </summary>
Machinata.Util.createIFrameWatchdog = function (iframes, opts) {
    if (opts == null) opts = {};
    if (opts.selector == null) opts.selector = "iframe";
    if (opts.interval == null) opts.interval = 1000;
    if (opts.cacheBust == null) opts.cacheBust = false;
    iframes = $(opts.selector);

    iframes.each(function () {
        $(this).attr("orig-src", $(this).attr("src"));
    });

    function validateFrame(frame) {
        var ret = true;
        try {
            if(frame.contentWindow.document == null) throw "iframe document is null";
        } catch (e) {
            ret = false;
        }
        return ret;
    }

    function validateFrames() {
        iframes.each(function () {
            var frameElem = $(this);
            var frame = frameElem[0];
            var valid = validateFrame(frame);
            if (valid == false) {
                console.log("***iFrame invalid***");
                console.log("Reloading...");
                var newUrl = frameElem.attr("orig-src");
                if (opts.cacheBust == true) newUrl = Machinata.updateQueryString("rnd", Math.random(), newUrl);
                frame.src = newUrl;
            }
        });
    }

    setInterval(function () {
        validateFrames();
    }, opts.interval);
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-debugging.js */
/* File: js/machinata-core-bundle.js/machinata-core-debugging.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// </summary>
/// <type>namespace</type>
Machinata.Debugging = {};

Machinata.Debugging._start = null;
Machinata.Debugging._timers = null;

/// <summary>
///
/// </summary>
Machinata.Debugging.startTimer = function (id, category) {
    var ms = new Date();
    if (Machinata.Debugging._start == null) Machinata.Debugging._start = ms;
    if (Machinata.Debugging._timers == null) Machinata.Debugging._timers = {};
    var timer = {
        id: id,
        category: category,
        start: ms
    };
    Machinata.Debugging._timers[id] = timer;
    return timer;
};

/// <summary>
///
/// </summary>
Machinata.Debugging.stopTimer = function (id) {
    var timer = Machinata.Debugging._timers[id];
    timer.end = new Date();
    return timer;
};


/// <summary>
///
/// </summary>
Machinata.Debugging.compileTimerStats = function () {
    $.each(Machinata.Debugging._timers, function (key, timer) {
        timer.ellapsed = timer.end - timer.start;
        timer.rstart = timer.start - Machinata.Debugging._start;
        timer.rend = timer.end - Machinata.Debugging._start;
    });
};

/// <summary>
///
/// </summary>
Machinata.Debugging.createTimersDebugPanel = function (title) {
    var data = {};
    var totalEllapsed = 0;
    Machinata.Debugging.compileTimerStats();
    $.each(Machinata.Debugging._timers, function (key, timer) {
        data[key] = [timer.ellapsed + "ms", timer.rstart+"ms..."+ timer.rend+"ms"];
        totalEllapsed += timer.ellapsed;
    });
    data["Total"] = totalEllapsed + "ms";
    return Machinata.UI.createDebugPanel(title, data);
};




/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-params.js */
/* File: js/machinata-core-bundle.js/machinata-core-params.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Shorthand functions for getting common paremeters from the context.
/// This module mimicks the Machinata Server Core Handler Params.
/// </summary>
/// <type>namespace</type>
Machinata.Params = {};

/// <summary>
/// 
/// </summary>
Machinata.Params.string = function (key) {
    return Machinata.queryParameter(key);
};

/// <summary>
/// 
/// </summary>
Machinata.Params.hasString = function (key) {
    return String.isEmpty(Machinata.queryParameter(key)) == false;
};



/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-math.js */
/* File: js/machinata-core-bundle.js/machinata-core-math.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */


/// <summary>
/// Collection of common math routines.
/// </summary>
/// <type>namespace</type>
Machinata.Math = {};



/// <summary>
///
/// </summary>
Machinata.Math.rnd = function (min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
};

/// <summary>
/// Returns true randomly for a probability p, where 1.0 being always true, and 0.0 never true, 0.5 half the time true
/// </summary>
Machinata.Math.prob = function (p) {
    return Math.random() <= p;
};

/// <summary>
/// Each subsequent call to the return function of xmur3 produces a new "random" 32-bit hash value to be used as a seed in a PRNG. 
/// Based on MurmurHash3's mixing function
/// </summary>
Machinata.Math.xmur3 = function(str) {
    for (var i = 0, h = 1779033703 ^ str.length; i < str.length; i++)
        h = Math.imul(h ^ str.charCodeAt(i), 3432918353),
            h = h << 13 | h >>> 19;
    return function () {
        h = Math.imul(h ^ h >>> 16, 2246822507);
        h = Math.imul(h ^ h >>> 13, 3266489909);
        return (h ^= h >>> 16) >>> 0;
    }
}

/// <summary>
/// sfc32 is part of the PractRand random number testing suite (which it passes of course). sfc32 has a 128-bit state and is very fast in JS.
/// </summary>
Machinata.Math.sfc32 = function (a, b, c, d) {
    // See https://stackoverflow.com/questions/521295/seeding-the-random-number-generator-in-javascript
    return function () {
        a >>>= 0; b >>>= 0; c >>>= 0; d >>>= 0;
        var t = (a + b) | 0;
        a = b ^ b >>> 9;
        b = c + (c << 3) | 0;
        c = (c << 21 | c >>> 11);
        d = d + 1 | 0;
        t = t + d | 0;
        c = c + t | 0;
        return (t >>> 0) / 4294967296;
    }
}

/// <summary>
/// Mulberry32 is a simple generator with a 32-bit state, but is extremely fast and has good quality (author states it passes all tests of gjrand testing suite and has a full 232 period, but I haven't verified).
/// </summary>
Machinata.Math.mulberry32 = function (a) {
    // See https://stackoverflow.com/questions/521295/seeding-the-random-number-generator-in-javascript
    return function () {
        var t = a += 0x6D2B79F5;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    }
}

/// <summary>
///
/// </summary>
Machinata.Math.rndWithSeed = function (seed, min, max) {

    var seed = Machinata.Math.xmur3(""+seed+""); // ensures seed is a string
    var randomGenerator = Machinata.Math.sfc32(seed(), seed(), seed(), seed());
    var randomNumber = randomGenerator();

    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(randomNumber * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive

    // Old method: does not integrate nicely because domain is unknown
    /*var mask = 0xffffffff;
    var m_w = (123456789 + seed) & mask;
    var m_z = (987654321 - seed) & mask;

    function getSeededRandom() {
        m_z = (36969 * (m_z & 65535) + (m_z >>> 16)) & mask;
        m_w = (18000 * (m_w & 65535) + (m_w >>> 16)) & mask;

        var result = ((m_z << 16) + (m_w & 65535)) >>> 0;
        result /= 4294967296;
        return result;
    }
    console.log(getSeededRandom());
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(getSeededRandom() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
    */
};

/// <summary>
///
/// </summary>
Machinata.Math.isEven = function (n) {
    return n % 2 == 0;
};

/// <summary>
///
/// </summary>
Machinata.Math.isOdd = function (n) {
    return Math.abs(n % 2) == 1;
};

/// <summary>
///
/// </summary>
Machinata.Math.makeEven = function (n) {
    n = Math.floor(n);
    if (Machinata.Math.isEven(n)) return n;
    return n - 1;
};

/// <summary>
///
/// </summary>
Machinata.Math.degToRad = function (degrees) {
    return Math.PI / 180 * degrees;
}
Machinata.Math.rad2Deg = function (rad) {
    return ((rad + Math.PI) / (2 * Math.PI)) * 360;
}

/// <summary>
///
/// </summary>
Machinata.Math.min3 = function (a, b, c) {
    return Math.min(a, b, c);
}
/// <summary>
///
/// </summary>
Machinata.Math.min4 = function (a, b, c, d) {
    return Math.min(a, b, c, d);
}

/// <summary>
///
/// </summary>
Machinata.Math.max3 = function (a, b, c) {
    return Math.max(a, b, c);
}

/// <summary>
///
/// </summary>
Machinata.Math.max4 = function (a, b, c, d) {
    return Math.max(a, b, c, d);
}

/// <summary>
///
/// </summary>
Machinata.Math.vec2Dist = function (x1, y1, x2, y2) {
    var a = x1 - x2;
    var b = y1 - y2;
    var c = Math.sqrt(a * a + b * b);
    return c;
}

/// <summary>
///
/// </summary>
Machinata.Math.xy2Polar = function (x, y) {
    var r = Math.sqrt(x * x + y * y);
    var phi = Math.atan2(y, x);
    return [r, phi];
}

/// <summary>
///
/// </summary>
Machinata.Math.roundUpToNearest = function (number, fraction) {
    var divisor = 1.0 / fraction;
    return (Math.ceil(number * divisor) / divisor).toFixed(2);
};

/// <summary>
///
/// </summary>
Machinata.Math.roundDownToNearest = function (number, fraction) {
    var divisor = 1.0 / fraction;
    return (Math.floor(number * divisor) / divisor).toFixed(2);
};


/// <summary>
///
/// </summary>
Machinata.Math.rbgInvert = function (rgb) {
    return [255 - rgb[0], 255 - rgb[1], 255 - rgb[2]];
};

/// <summary>
///
/// </summary>
Machinata.Math.rbgBrightness = function (rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var p = (r + g + b) / 3.0
    return p;
};

/// <summary>
///
/// </summary>
Machinata.Math.rbgGrayscale = function (rgb) {
    // Y = 0.2126 * R + 0.7152 * G + 0.0722 * B
    // https://en.wikipedia.org/wiki/Grayscale
    var y = 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
    return [y, y, y];
};

/// <summary>
///
/// </summary>
Machinata.Math.hexToRBG = function (hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
    ] : null;
};

/// <summary>
///
/// </summary>
Machinata.Math.rgbToHex = function (rgb) {
    return "#" + ((1 << 24) + (rgb[0] << 16) + (rgb[1] << 8) + rgb[2]).toString(16).slice(1);
};

/// <summary>
///
/// </summary>
// hue in range [0, 360]
// saturation, value in range [0,1]
// return [r,g,b] each in range [0,255]
// See: https://en.wikipedia.org/wiki/HSL_and_HSV#From_HSV
Machinata.Math.hsv2RGB = function (hue, saturation, value, roundValues) {
    var chroma = value * saturation;
    var hue1 = hue / 60;
    var x = chroma * (1 - Math.abs((hue1 % 2) - 1));
    var r1, g1, b1;
    if (hue1 >= 0 && hue1 <= 1) {
        r1 = chroma;
        g1 = x;
        b1 = 0;
    } else if (hue1 >= 1 && hue1 <= 2) {
        r1 = x;
        g1 = chroma;
        b1 = 0;
    } else if (hue1 >= 2 && hue1 <= 3) {
        r1 = 0;
        g1 = chroma;
        b1 = x;
    } else if (hue1 >= 3 && hue1 <= 4) {
        r1 = 0;
        g1 = x;
        b1 = chroma;
    } else if (hue1 >= 4 && hue1 <= 5) {
        r1 = x;
        g1 = 0;
        b1 = chroma;
    } else if (hue1 >= 5 && hue1 <= 6) {
        r1 = chroma;
        g1 = 0;
        b1 = x;
    }

    var m = value - chroma;
    var r = r1 + m;
    var g = g1 + m;
    var b = b1 + m;

    // Change r,g,b values from [0,1] to [0,255]
    if (roundValues == true) {
        return [Math.round(255 * r), Math.round(255 * g), Math.round(255 * b)];
    } else {
        return [255 * r, 255 * g, 255 * b];
    }
};


/// <summary>
///
/// </summary>
Machinata.Math.map = function (val, inputMin, inputMax, outputMin, outputMax) {
    return (val - inputMin) * (outputMax - outputMin) / (inputMax - inputMin) + outputMin;
};

/// <summary>
///
/// </summary>
Machinata.Math.clamp = function (val, outputMin, outputMax) {
    return Math.min(Math.max(val, outputMin), outputMax);
};

/// <summary>
///
/// </summary>

/// <summary>
///
/// </summary>
Machinata.Math.inchesToPixels = function (inches, dpi) {
    if (dpi == null) dpi = 96;
    var px = dpi * inches;
    return px;
};

/// <summary>
///
/// </summary>
Machinata.Math.pixelsToInches = function (px, dpi) {
    if (dpi == null) dpi = 96;
    var inches = px / dpi;
    return inches;
};

/// <summary>
///
/// </summary>
Machinata.Math.millimetersToInches = function (mm) {
    var inches = mm * 0.0393701;
    return inches;
};

/// <summary>
///
/// </summary>
Machinata.Math.inchesToMillimeters = function (inches) {
    var mm = inches / 0.0393701;
    return mm;
};

/// <summary>
///
/// </summary>
Machinata.Math.millimetersToPixels = function (mm, dpi) {
    var inches = Machinata.Math.millimetersToInches(mm);
    return Machinata.Math.inchesToPixels(inches,dpi);
};

/// <summary>
///
/// </summary>
Machinata.Math.pixelsToMillimeters = function (px, dpi) {
    var inches = Machinata.Math.pixelsToInches(px, dpi);
    return Machinata.Math.inchesToMillimeters(inches);
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-api.js */
/* File: js/machinata-core-bundle.js/machinata-core-api.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Extensions for Machinata API Calls.
/// </summary>
/// <hidden/>
Machinata.onInit(function () {
    // Find all links bound to a api-call
    $("a[api-call]").each(function () {
        var link = $(this);
        var apiCall = link.attr("api-call");
        var confirm = link.attr("confirm-message");
        var input = link.attr("input-message");
        var successCallback = link.attr("on-success");
        var errorCallback = link.attr("on-error");
        var inputName = link.attr("input-name");
        var inputType = link.attr("input-type");
        var confirmDelete = link.attr("confirm-delete");
        var title = null;
        if (link.attr("confirm-title") != null) title = link.attr("confirm-title");
        if (link.attr("input-title") != null) title = link.attr("input-title");
        if (!String.isEmpty(confirmDelete)) {
            var text1 = "Are you sure you want to delete";
            var text2 = "?";
            confirm = text1 + " " + confirmDelete + " " + text2;
            title = "Delete";
        }
        Machinata.apiCallForLink(apiCall, link, title, confirm, input, function (message) {
            Machinata.processCallback(successCallback, message);
        }, function (message) {
            if (String.isEmpty(errorCallback)) Machinata.apiErrorForGeneric(message.data.code, message.data.message);
            else Machinata.processCallback(errorCallback, message);
        }, inputName);
    });
});


/// <summary>
/// </summary>
Machinata.apiCallForLink = function (apiCall, linkElem, title, confirm, input, onSuccess, onError, inputName) {
    function doCall(val) {
        // Init api call
        apiCall = apiCall.replace("{value}", val);
        var call = Machinata.apiCall(apiCall);
        // Init data to send
        if (inputName == null) inputName = "input";
        var data = {};
        if (val != null) data[inputName] = val;
        call.data(data);
        // Prepare api call
        call.success(function (message) {
            linkElem.removeClass("loading");
        })
        call.error(function (message) {
            linkElem.removeClass("loading");
        });
        if (onSuccess) call.success(onSuccess);
        if (onError) call.error(onError);
        // Send
        call.send();
    }
    // Intercept submit
    linkElem.click(function (e) {
        // Stop browser
        e.preventDefault();
        // Show confirm diag?
        if (!String.isEmpty(confirm) || !String.isEmpty(input)) {

            if (!String.isEmpty(input)) {
                // Show input dialog
                var dialogTitle = title;
                var dialogMessage = input;
                var inputType = null;
                var inputValue = null;
                var inputPlaceholder = null;
                if (!String.isEmpty(linkElem.attr("input-type"))) inputType = linkElem.attr("input-type");
                if (!String.isEmpty(linkElem.attr("input-value"))) inputValue = linkElem.attr("input-value");
                if (!String.isEmpty(linkElem.attr("input-placeholder"))) inputPlaceholder = linkElem.attr("input-placeholder");
                if (String.isEmpty(dialogTitle)) {
                    dialogTitle = input;
                    dialogMessage = null;
                }
                Machinata.inputDialog(dialogTitle, dialogMessage, inputValue, inputPlaceholder, inputType)
                    .input(function (val, id) {
                        doCall(val);
                    })
                    .show();
            } else {
                // Just show confirm dialog
                var dialogTitle = title;
                var dialogMessage = confirm;
                if (String.isEmpty(dialogTitle)) {
                    dialogTitle = confirm;
                    dialogMessage = null;
                }
                Machinata.confirmDialog(dialogTitle, dialogMessage)
                    .okay(function () { doCall(); })
                    .show();
            }

        } else {
            doCall();
        }
    });
};




/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-device.js */
/* File: js/machinata-core-bundle.js/machinata-core-device.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// Collection of device-related information and compatibility data.
/// </summary>
/// <type>namespace</type>
Machinata.Device = {};


/// <summary>
/// 
/// </summary>
/// <hidden/>
Machinata.Device._infoLoaded = false;
Machinata.Device._loadDeviceInfos = function () {
    if (Machinata.Device._infoLoaded == true) return;

    var deviceAgent = navigator.userAgent.toLowerCase();
    Machinata.Device._isIOS = false;
    Machinata.Device._isAndroid = false;
    Machinata.Device._isWindowsPhone = false;
    Machinata.Device._isMSSurface = false;
    Machinata.Device._isMSIE = false;
    Machinata.Device._isEdge = false;

    Machinata.Device._browserName = null;
    Machinata.Device._browserVersion = null;
    Machinata.Device._osName = null;
    Machinata.Device._osVersion = null;
    Machinata.Device._osVersionName = null;
    Machinata.Device._platformType = null;
    Machinata.Device._engineName = null;
    Machinata.Device._engineVersion = null;

    // Deprecated
    /*
    if (window.Bowser != null) {
        // See https://lancedikson.github.io/bowser/docs/
        var bowserInfos = window.Bowser.parse(window.navigator.userAgent);
        Machinata.Device._browserName = bowserInfos.browser.name;
        Machinata.Device._browserVersion = bowserInfos.browser.version;
        Machinata.Device._osName = bowserInfos.os.name;
        Machinata.Device._osVersion = bowserInfos.os.version;
        Machinata.Device._osVersionName = bowserInfos.os.versionName;
        Machinata.Device._platformType = bowserInfos.platform.type;
        Machinata.Device._engineName = bowserInfos.engine.name;
        Machinata.Device._engineVersion = bowserInfos.engine.version;
    }*/

    if (deviceAgent != null) {
        // IOS
        if (deviceAgent.indexOf("iphone") > -1) Machinata.Device._isIOS = true;
        else if (deviceAgent.indexOf("ipod") > -1) Machinata.Device._isIOS = true;
        else if (deviceAgent.indexOf("ipad") > -1) Machinata.Device._isIOS = true;
        // Android
        Machinata.Device._isAndroid = deviceAgent.indexOf("android") > -1;
        // Windows Phone
        Machinata.Device._isWindowsPhone = deviceAgent.indexOf("windows phone") > -1;
        // MS Surface
        //TODO: not very accurate, but also not really a better way to tell
        if (deviceAgent.indexOf("windows nt") > -1 && deviceAgent.indexOf("touch") > -1) {
            Machinata.Device._isMSSurface = true;
        } 
        // MS Internet Explorer
        if (deviceAgent.indexOf("msie ") > -1) {
            Machinata.Device._isMSIE = true;
        } else if (deviceAgent.match(/trident.*rv\:11\./)) {
            Machinata.Device._isMSIE = true;
        }
        // Edge
        if (deviceAgent.indexOf("edge/") > -1) {
            Machinata.Device._isEdge = true;
        }
        // Register
        Machinata.Device._infoLoaded = true;
    }
};

/// <summary>
/// 
/// </summary>
Machinata.Device.browserName = function () {
    Machinata.Device._loadDeviceInfos();
    return Machinata.Device._browserName;
};

/// <summary>
/// 
/// </summary>
Machinata.Device.browserVersion = function () {
    Machinata.Device._loadDeviceInfos();
    return Machinata.Device._browserVersion;
};

/// <summary>
/// 
/// </summary>
Machinata.Device.osName = function () {
    Machinata.Device._loadDeviceInfos();
    return Machinata.Device._osName;
};

/// <summary>
/// 
/// </summary>
Machinata.Device.osVersion = function () {
    Machinata.Device._loadDeviceInfos();
    return Machinata.Device._osVersion;
};

/// <summary>
/// 
/// </summary>
Machinata.Device.osVersionName = function () {
    Machinata.Device._loadDeviceInfos();
    return Machinata.Device._osVersionName;
};

/// <summary>
/// 
/// </summary>
Machinata.Device.platformType = function () {
    Machinata.Device._loadDeviceInfos();
    return Machinata.Device._platformType;
};

/// <summary>
/// 
/// </summary>
Machinata.Device.engineName = function () {
    Machinata.Device._loadDeviceInfos();
    return Machinata.Device._engineName;
};

/// <summary>
/// 
/// </summary>
Machinata.Device.engineVersion = function () {
    Machinata.Device._loadDeviceInfos();
    return Machinata.Device._engineVersion;
};

/// <summary>
/// 
/// </summary>
Machinata.Device._isTouchEnabled = null;
Machinata.Device.isTouchEnabled = function () {
    // Cached?
    if (Machinata.Device._isTouchEnabled != null) return Machinata.Device._isTouchEnabled;

    // NEW METHOD 2020: (via https://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript)
    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    var mq = function (query) {
        return window.matchMedia(query).matches;
    }
    //if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
    //    return true;
    //}
    if (('ontouchstart' in window) || window.DocumentTouch) {
        return true;
    }
    var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    Machinata.Device._isTouchEnabled = mq(query);
    return Machinata.Device._isTouchEnabled;


    // OLD METHOD: (since browsers started to return touch on all platforms)
    /*
    //TODO: Probably a smarter way
    return Machinata.Device.isMobileOS();
    */
};

/// <summary>
/// Note: Currently no longer works on Chrome browser on Windows
/// </summary>
Machinata.Device._isHighContrast = null;
Machinata.Device.isHighContrast = function () {
    // Cached?
    if (Machinata.Device._isHighContrast != null) return Machinata.Device._isHighContrast;

    //http://jsfiddle.net/karlgroves/XR8Su/6/

    var objDiv, strColor;

    // Create a test div
    objDiv = document.createElement('div');

    //Set its color style to something unusual
    objDiv.style.color = 'rgb(31, 41, 59)';

    // Attach to body so we can inspect it
    document.body.appendChild(objDiv);

    // Read computed color value
    strColor = document.defaultView ? document.defaultView.getComputedStyle(objDiv, null).color : objDiv.currentStyle.color;
    strColor = strColor.replace(/ /g, '');

    // Delete the test DIV
    document.body.removeChild(objDiv);

    // Check if we get the color back that we set. If not, we're in 
    // high contrast mode. 
    if (strColor !== 'rgb(31,41,59)') {
        Machinata.Device._isHighContrast = true;
    } else {
        Machinata.Device._isHighContrast = false;
    }
    return Machinata.Device._isHighContrast;
};

/// <summary>
/// 
/// </summary>
Machinata.Device.isIOS = function () {
    Machinata.Device._loadDeviceInfos();
    return Machinata.Device._isIOS;
};

/// <summary>
/// 
/// </summary>
Machinata.Device.isAndroid = function () {
    Machinata.Device._loadDeviceInfos();
    return Machinata.Device._isAndroid;
};

/// <summary>
/// 
/// </summary>
Machinata.Device.isWindowsPhone = function () {
    Machinata.Device._loadDeviceInfos();
    return Machinata.Device._isWindowsPhone;
};

/// <summary>
/// 
/// </summary>
Machinata.Device.isMSSurfacePhone = function () {
    Machinata.Device._loadDeviceInfos();
    return Machinata.Device._isMSSurface;
};

/// <summary>
/// 
/// </summary>
Machinata.Device.isMSIE = function () {
    Machinata.Device._loadDeviceInfos();
    return Machinata.Device._isMSIE;
};

/// <summary>
/// 
/// </summary>
Machinata.Device.isEdge = function () {
    Machinata.Device._loadDeviceInfos();
    return Machinata.Device._isEdge;
};

/// <summary>
/// 
/// </summary>
Machinata.Device.isMobileOS = function () {
    Machinata.Device._loadDeviceInfos();
    return Machinata.Device._isIOS || Machinata.Device._isAndroid || Machinata.Device._isWindowsPhone || Machinata.Device._isMSSurface;
};

/// <summary>
/// 
/// </summary>
Machinata.Device.getIOSVersion = function () {
    if (Machinata.Device.isIOS() == false) return {
        major: 0,
        minor: 0,
        revision: 0
    };
    var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
    return {
        major: parseInt(v[1], 10),
        minor: parseInt(v[2], 10),
        revision: parseInt(v[3] || 0, 10)
    };
};


/// <summary>
/// 
/// </summary>
Machinata.Device.getAndroidVersion = function () {
    if (Machinata.Device.isAndroid() == false) return {
        major: 0,
        minor: 0,
        revision: 0
    };
    var v = (navigator.userAgent).toLowerCase().match(/android\s([0-9\.]*)/)[1];
    var segs = v.split('.');
    return {
        major: parseInt(segs[0], 10),
        minor: parseInt(segs[1] || 0, 10),
        revision: parseInt(segs[2] || 0, 10)
    };
};

/// <summary>
/// 
/// </summary>
Machinata.Device.isChromeBrowser = function () {
    return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
};


/// <summary>
/// 
/// </summary>
Machinata.Device.supportsThreeD = function () {
    // All IE browsers don't
    if (Machinata.Device.isMSIE() == true) return false;
    // All others that support WebGL...
    return Machinata.Device.supportsWebGL();
};

/// <summary>
/// 
/// </summary>
Machinata.Device.supportsWebGL = function () {
    try {
        var canvas = document.createElement('canvas');
        return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
    } catch (e) {
        return false;
    }
};

/// <summary>
/// 
/// </summary>
/// <deprecated/>
Machinata.Device.getAllFeatures = function () {
    throw "Machinata.Device.getAllFeatures is deprecated, please use the newer specific methods:" +
    +"\nMachinata.Device.browserName"
    + "\nMachinata.Device.browserVersion"
    + "\nMachinata.Device.osName"
    + "\nMachinata.Device.osVersion"
    + "\nMachinata.Device.osVersionName"
    + "\nMachinata.Device.platformType"
    + "\nMachinata.Device.engineName"
    + "\nMachinata.Device.engineVersion";
};

/// <summary>
/// 
/// </summary>
Machinata.Device.waitForWebfonts = function(fonts, callback) {
    // From https://stackoverflow.com/questions/4383226/using-jquery-to-know-when-font-face-fonts-are-loaded
    var loadedFonts = 0;
    for (var i = 0, l = fonts.length; i < l; ++i) {
        (function (font) {
            var node = document.createElement('span');
            // Characters that vary significantly among different fonts
            node.innerHTML = 'giItT1WQy@!-/#';
            // Visible - so we can measure it - but not on the screen
            node.style.position = 'absolute';
            node.style.left = '-10000px';
            node.style.top = '-10000px';
            // Large font size makes even subtle changes obvious
            node.style.fontSize = '300px';
            // Reset any font properties
            node.style.fontFamily = 'sans-serif';
            node.style.fontVariant = 'normal';
            node.style.fontStyle = 'normal';
            node.style.fontWeight = 'normal';
            node.style.letterSpacing = '0';
            document.body.appendChild(node);

            // Remember width with no applied web font
            var width = node.offsetWidth;

            node.style.fontFamily = font + ', sans-serif';

            var interval;
            function checkFont() {
                // Compare current width with original width
                if (node && node.offsetWidth != width) {
                    ++loadedFonts;
                    node.parentNode.removeChild(node);
                    node = null;
                }

                // If all fonts have been loaded
                if (loadedFonts >= fonts.length) {
                    if (interval) {
                        clearInterval(interval);
                    }
                    if (loadedFonts == fonts.length) {
                        callback();
                        return true;
                    }
                }
            };

            if (!checkFont()) {
                interval = setInterval(checkFont, 50);
            }
        })(fonts[i]);
    }
};

/// <summary>
/// Shows warning messages for browsers that are no longer supported.
/// No longer supported browsers:
///  - Microsoft Internet Explorer
///    - All Versions
/// </summary>
Machinata.Device.showWarningForOldBrowsers = function () {
    if (Machinata.Device.isMSIE()) {
        Machinata.ready(function () {
            Machinata.messageDialog("Old Browser", "You are using an old Microsoft Internet Explorer browser. This browser is no longer supported by Microsoft and has several security issues. We highly recommend you download and install the newer Microsoft Edge browser.").show();
        });
    }
};

/// <summary>
/// 
/// </summary>
Machinata.Device.getWifiLoginURL = function (ssid, password, encryption) {
    // NOTE: This only generates a URL used for a QR Code. Browsers do not understand these URLs
    // Encryption can be:
    // WPA, WEP, or empty string
    if(encryption == null) encryption = "";
    var WIFI_LOGIN_URL = "WIFI:S:{ssid};T:{encryption};P:{password};;";
    var loginURL = WIFI_LOGIN_URL;
    loginURL = loginURL.replace("{ssid}", ssid);
    loginURL = loginURL.replace("{encryption}", encryption);
    loginURL = loginURL.replace("{password}", password);
    // Does this device support the url?
    if (Machinata.Device.isMobileOS() == false) {
        return false;
    }
    if (Machinata.Device.isIOS() == true) {
        // Only iOS 11+ is supported
        if (Machinata.Device.getIOSVersion().major < 11) {
            //return false;
        }
    }
    if (Machinata.Device.isAndroid() == true) {
        // Only iOS 11+ is supported
        if (Machinata.Device.getAndroidVersion().major < 11) {
            //return false;
        }
    }
    return loginURL;
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-cache.js */
/* File: js/machinata-core-bundle.js/machinata-core-cache.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// Extensions for automatically caching requests or objects.
/// </summary>


/// <summary>
/// </summary>
Machinata.CACHE_ENABLED = true;


/// <summary>
/// </summary>
Machinata.CACHE_DEBUG_CONSOLE = false;

/// <summary>
/// </summary>
Machinata.resetCache = function (prefix) {
    if (!window.localStorage) return null;
    // Use Web Storage API
    if (prefix == null) {
        // All
        return localStorage.clear();
    } else {
        // Only those with the prefix
        var keysToRemove = [];
        for (var i = 0; i < localStorage.length; i++) {
            var key = localStorage.key(i);
            if (key.startsWith(prefix)) keysToRemove.push(key);
        }
        for (var i = 0; i < keysToRemove.length; i++) {
            var key = keysToRemove[i];
            localStorage.removeItem(key);
        }
    }
};

/// <summary>
/// Gets a value from the cache using a key.
/// </summary>
Machinata.getCache = function (key) {
    if (!window.localStorage) return null;
    // Use Web Storage API
    return JSON.parse(localStorage.getItem(key));
};

/// <summary>
/// Sets a value in the cache using the key.
/// </summary>
Machinata.setCache = function (key, value) {
    if (!window.localStorage) return null;
    // Use Web Storage API
    return localStorage.setItem(key, JSON.stringify(value));
};

/// <summary>
/// Helper method to automatically either get the cached value by key (if it exists),
/// or generate and set the cache value (if it does not exist).
/// Example:
/// Machinata.getOrSetCacheWithHashedKey("GEOCODE", search, function (setCacheValue) {
///     // Generator
///     var val = calculateSomeComplicatedValue();
///     setCacheValue(val);
/// }, function (val) {
///     // Callback
///     val.doSomething();
/// });
/// </summary>
Machinata.getOrSetCache = function (key, generator, callback) {
    // Use Web Storage API
    if (Machinata.CACHE_DEBUG_CONSOLE) Machinata.debug("Getting cache with key '" + key + "'");
    var ret = Machinata.getCache(key);
    if (ret == null) {
        if (Machinata.CACHE_DEBUG_CONSOLE) Machinata.debug("  Cache-miss! Will generate...");
        generator(function (val) {
            if (Machinata.CACHE_DEBUG_CONSOLE) Machinata.debug("  Got generated value: " + val);
            Machinata.setCache(key, val);
            callback(val);
        });
    } else {
        if (Machinata.CACHE_DEBUG_CONSOLE) Machinata.debug("  Cache-hit!");
        if (Machinata.CACHE_DEBUG_CONSOLE) Machinata.debug("  Got value: " + ret);
        callback(ret);
    }
};

/// <summary>
/// </summary>
Machinata.getOrSetCacheWithHashedKey = function (type, key, generator, callback) {
    Machinata.getOrSetCache(type + "_" + key.hashCode(), generator, callback);
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-time.js */
/* File: js/machinata-core-bundle.js/machinata-core-time.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */


/* ======== Time Extensions ======== */

Date.prototype.addDays = function (days) {
    return new Date(this.getTime() + (days * 24 * 60 * 60 * 1000));
};

Date.prototype.iso8601CalendarWeek = function () {
    // Via https://stackoverflow.com/questions/6117814/get-week-of-year-in-javascript-like-in-php
    var d = new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate()));
    var dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
};

Date.prototype.isToday = function () {
    var now = new Date();
    if (this.getYear() == now.getYear()
        && this.getMonth() == now.getMonth()
        && this.getDay() == now.getDay()) {
        return true;
    } else {
        return false;
    }
};


/// <summary>
/// Collection of useful time related functions.
/// Many of the functions align with the Machinata Server Core Time utilities.
/// </summary>
Machinata.Time = {};

/// <summary>
/// 
/// </summary>
Machinata.DEFAULT_DATE_FORMAT_JAVASCRIPT_UI = "dd.MM.yyyy";

/// <summary>
/// 
/// </summary>
Machinata.DEFAULT_TIME_FORMAT_JAVASCRIPT_UI = "HH:mm";

/// <summary>
/// 
/// </summary>
Machinata.DEFAULT_DATETIME_FORMAT_JAVASCRIPT_UI = "dd.MM.yyyy HH:mm";

/// <summary>
/// 
/// </summary>
Machinata.DEFAULT_TIMEZONE = "Central European Standard Time";

/// <summary>
/// 
/// </summary>
Machinata.DEFAULT_DATERANGE_SEPARATOR = " - ";

/// <summary>
///
/// </summary>
/// <hidden/>

Machinata.onInit(function () {
    // Custom time picker
    Machinata.initCustomTimePicker();
});

/// <summary>
/// Converts a .net time string to javascript time string.
/// Supported params: 'HH','mm'
/// Currently this does not do anything.
/// </summary>
Machinata.convertDotNetTimeFormatToJavascriptFormat = function (format) {
    // .net: https://docs.microsoft.com/en-us/dotnet/standard/base-types/custom-date-and-time-format-strings
    // Datepicker: http://api.jqueryui.com/datepicker/#utility-formatDate 
    // Timepicker: http://trentrichardson.com/examples/timepicker/
    return format;
};

/// <summary>
/// Converts a .net time string to datepicker time string to allow for a single
/// format representation.
/// Supported params: 'yyyy','MM','dd','HH','mm','zzz'
/// </summary>
Machinata.convertDotNetTimeFormatToDatepickerFormat = function (format) {
    // .net: https://docs.microsoft.com/en-us/dotnet/standard/base-types/custom-date-and-time-format-strings
    // Datepicker: http://api.jqueryui.com/datepicker/#utility-formatDate 
    // Timepicker: http://trentrichardson.com/examples/timepicker/
    format = format.replace("yyyy", "yy");
    format = format.replace("MM", "mm");
    format = format.replace("dd", "dd"); // Same
    format = format.replace("zzz", "Z");
    return format;
};
Machinata.convertDatepickerTimeFormatToDotNetFormat = function (format) {
    format = format.replace("yy", "yyyy");
    format = format.replace("mm", "MM");
    format = format.replace("dd", "dd"); // Same
    format = format.replace("Z","zzz");
    return format;
    };

/// <summary>
/// Parses a utcms string to a javascript date time object.
/// If you are coming from the backend world, use ```Machinata.Util.Time.GetUTCMillisecondsFromDateTime()```.
/// </summary>
Machinata.dateFromUTCMilliseconds = function (utcmsString) {
    var utcms = parseInt(utcmsString);
    return new Date(utcms);
};

/// <summary>
/// Converts a javascript date time object to a utcms integer.
/// If the input is a string, the date is first automatically converted
/// using the native javascript new Date(str) method.
/// </summary>
Machinata.UTCMillisecondsFromDate = function (date) {
    // https://www.electrictoolbox.com/unix-timestamp-javascript/
    if (typeof date === 'string' || date instanceof String) {
        date = new Date(date);
    }
    return Math.round(date.getTime());
};

/// <summary>
/// Gets a formatted time from a date object.
/// </summary>
Machinata.formattedTimeFromDate = function (date) {
    return Machinata.formattedDate(date, Machinata.DEFAULT_TIME_FORMAT_JAVASCRIPT_UI);
};

/// <summary>
/// Gets a formatted date from a date object.
/// </summary>
Machinata.formattedDateFromDate = function (date) {
    return Machinata.formattedDate(date, Machinata.DEFAULT_DATE_FORMAT_JAVASCRIPT_UI);
};

/// <summary>
/// Gets a formatted date and time from a date object, separated by a space.
/// </summary>
Machinata.formattedDateTimeFromDate = function (date) {
    return Machinata.formattedDateFromDate(date) + " " + Machinata.formattedTimeFromDate(date);
};

/// <summary>
/// Returns a string for the date and given format using .net style replacements.
/// This custom implementation ensures that all browsers behave the same way.
/// Supported params: 'yyyy', 'MM', 'dd', 'HH', 'mm'
/// If not format is provided, then the default format DEFAULT_DATETIME_FORMAT_JAVASCRIPT_UI is used.
/// </summary>
Machinata.formattedDate = function (date, format) {
    // Init
    if (format == null) format = Machinata.DEFAULT_DATETIME_FORMAT_JAVASCRIPT_UI;
    var yy = date.getYear().toString();
    var yyyy = date.getFullYear().toString();
    var MM = (date.getMonth() + 1).toString().padLeft(2, '0');
    var dd = date.getDate().toString().padLeft(2, '0');
    var HH = date.getHours().toString().padLeft(2, '0');
    var mm = date.getMinutes().toString().padLeft(2, '0');
    var ss = date.getSeconds().toString().padLeft(2, '0');
    var ret = format;
    // Do replacements
    ret = ret.replace("yyyy", yyyy);
    ret = ret.replace("MM", MM);
    ret = ret.replace("dd", dd);
    ret = ret.replace("HH", HH);
    ret = ret.replace("mm", mm);
    ret = ret.replace("ss", ss);
    //ret = ret.replace("yy", yy);
    return ret;
};


/// <summary>
/// 
/// </summary>
Machinata.dateFromString = function (strDateTime, format, verbose) {
    // Init
    //Machinata.debug("Converting date string to date object: '" + strDateTime + "' with format '" + format + "'");
    if (strDateTime == null || strDateTime == "") return null;
    if (format == null) format = Machinata.DEFAULT_DATETIME_FORMAT_JAVASCRIPT_UI;
    var segs = strDateTime.split(' ');
    var formatSegs = format.split(' ');
    if (segs.length < 0) {
        Machinata.debug("Error parsing date: " +strDateTime);
        return null;
    }
    // Extract the date and time
    var strDate = segs[0];
    var strTime = null; if (segs.length > 1) strTime = segs[1];
    // Extract format
    var formatDate = formatSegs[0];
    var formatTime = null; if (formatSegs.length > 1) formatTime = formatSegs[1];
    if (verbose == true) Machinata.debug("  strDate: " + strDate);
    if (verbose == true) Machinata.debug("  strTime: " + strTime);
    if (verbose == true) Machinata.debug("  formatDate: " + formatDate);
    if (verbose == true) Machinata.debug("  formatTime: " + formatTime);
    // Get the date and time
    var date = $.datepicker.parseDate(formatDate, strDate);
    if (verbose == true) Machinata.debug("  date: " + date);
    if (formatTime != null) {
        var time = $.datepicker.parseTime(formatTime, strTime);
        date.setHours(time.hour);
        date.setMinutes(time.minute);
        date.setSeconds(time.second);
    }
    if (verbose == true) Machinata.debug("  Converted to: " + date);
    return date;
}

/// <summary>
/// 
/// </summary>
Machinata.daysHoursMinutesSecondsFromDate = function (date) {
    var ms = date.getTime();
    var s = Math.floor(ms / 1000);
    var m = Math.floor(s / 60);
    s = s % 60;
    var h = Math.floor(m / 60);
    m = m % 60;
    var d = Math.floor(h / 24);
    h = h % 24;
    return { days: d, hours: h, minutes: m, seconds: s };
};

/// <summary>
/// 
/// </summary>
Machinata.Time.getMonths = function (start, end) {
    var dates = [];
    var current = new Date(start.getFullYear(), start.getMonth(), 1, 0, 0, 0, 0);
    
    var i = 0;
    while (current < end && i < 1000) {
        dates.push(current);
        var currentYear = current.getFullYear();
        var nextYear = currentYear;
        var currentMonth = current.getMonth();
        var nextMonth = currentMonth+1;
        if (nextMonth > 11) {
            nextMonth = 0;
            nextYear++;
        }
        var next = new Date(nextYear, nextMonth, 1, 0, 0, 0, 0);
        //dates.push(next);
        current = next;
        i++;
    }
    return dates;
};

/// <summary>
/// 
/// </summary>
Machinata.Time.getShortMonth = function (date) {
    // Mimicks date.toLocaleString("de-ch", { month: "short" });
    // (due to browser support of toLocalString)
    var m = date.getMonth();
    if (m == 0) return "Jan";
    else if (m == 1) return "Feb";
    else if (m == 2) return "Mar";
    else if (m == 3) return "Apr";
    else if (m == 4) return "May";
    else if (m == 5) return "Jun";
    else if (m == 6) return "Jul";
    else if (m == 7) return "Aug";
    else if (m == 8) return "Sept";
    else if (m == 9) return "Oct";
    else if (m == 10) return "Nov";
    else if (m == 11) return "Dec";
    else return null;
};

/// <summary>
/// 
/// </summary>
Machinata.Time.humanReadableTimestamp = function (datetime, now) {
    // Init
    if (now == null) now = new Date();
    var timestamp = datetime;
    var timesince_ms = (now - timestamp);
    var timesince_s = timesince_ms / 1000;
    var timesince_m = timesince_s / 60;
    var timesince_h = timesince_m / 60;
    var timesince_d = timesince_h / 24;
    var today = new Date(now.getTime());
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    var yesterday = new Date(now.getTime());
    yesterday.setHours(0);
    yesterday.setMinutes(0);
    yesterday.setSeconds(0);
    yesterday.setDate(yesterday.getDate() - 1);
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    // Future or past???
    if (timesince_ms < 0) {

        // Future!

        // In less than one minute - show seconds
        if (timesince_m > -1) {
            return "in {time}".replace("{time}", Math.floor(timesince_s * -1) + "s");
        }

        // In less than one hour - show minutes
        else if (timesince_h > -1) {
            return "in {time}".replace("{time}", Math.floor(timesince_m * -1) + "m");
        }

        // Today - show hours
        else  {
            return "in {time}".replace("{time}", Math.floor(timesince_h * -1) + "h");
        }

    } else {

        // Past!

        // Less than one minute - show seconds
        if (timesince_m < 1) {
            if (timesince_ms == 5000) {
                return "just now";
            } else {
                return "{time} ago".replace("{time}", Math.floor(timesince_s) + "s");
                //return "1m ago"
            }
        }

            // Less than one minute - show minutes
        else if (timesince_h < 1) {
            return "{time} ago".replace("{time}", Math.floor(timesince_m) + "m");
        }

            // Today - show hours
        else if (timestamp > today) {
            return "{time} ago".replace("{time}", Math.floor(timesince_h) + "h");
        }

            // Yesterday - show day and time
        else if (timestamp > yesterday) {
            return "yesterday";
        }

            // One week ago - show day and time
        else if (timesince_d < 6) {
            return days[timestamp.getDay()];
        }

            // More than a week - show date
        else {
            return timestamp.getDate() + "." + (timestamp.getMonth() + 1) + "." + timestamp.getFullYear();
        }

    }


};

/// <summary>
/// 
/// </summary>
Machinata.Time.today = function () {
    return new Date();
};

/// <summary>
/// 
/// </summary>
Machinata.Time.yesterday = function () {
    return (new Date()).addDays(-1);
};

/// <summary>
/// 
/// </summary>
Machinata.Time.tomorrow = function () {
    return (new Date()).addDays(+1);
};


/// <summary>
/// 
/// </summary>
Machinata.Time.humanReadableDuration = function (datetime) {
    // Init
    var timestamp = datetime;
    var timesince_ms = timestamp.getTime();
    var timesince_s = timesince_ms / 1000;
    var timesince_m = timesince_s / 60;
    var timesince_h = timesince_m / 60;
    var timesince_d = timesince_h / 24;
    var timesince_mm = timesince_d / 30;
    var timesince_yy = timesince_mm / 12;
    
    if (timesince_s < 1) {
        return "{time} milliseconds".replace("{time}", Math.floor(timesince_ms));
    } else if (timesince_m < 1) {
        return "{time} seconds".replace("{time}", Math.floor(timesince_s));
    } else if (timesince_h < 1) {
        return "{time} minutes".replace("{time}", Math.floor(timesince_m));
    } else if (timesince_d < 1) {
        return "{time} hours".replace("{time}", Math.floor(timesince_h));
    } else if (timesince_mm < 1) {
        return "{time} days".replace("{time}", Math.floor(timesince_d));
    } else if (timesince_yy < 1) {
        return "{time} months".replace("{time}", Math.floor(timesince_mm));
    } else  {
        return "{time} years".replace("{time}", Math.floor(timesince_yy));
    }

};


/// <summary>
/// Machinata custom time picker
/// Registers the custom time picker control.
/// </summary>
Machinata.initCustomTimePicker = function () {
    // Custom control object
    var customControl = {
        createButton: function (tp_inst, obj, hour, minute) {
            var button = $("<button/>");
            var textHour = hour;
            if (hour < 10) textHour = "0" +textHour;
            var textMinute = minute;
            if (minute < 10) textMinute = "0" +textMinute;
            button.text(textHour + ":" +textMinute);
            button.attr("data-hour", hour);
            button.attr("data-minute", minute);
            button.addClass("hour-"+hour);
            button.addClass("minute-"+minute);
            button.button();
            button.click(function () {
                //button.parent().find("button").removeClass("selected");
                //button.addClass("selected");
                tp_inst.control.value(tp_inst, obj, "hour", hour);
                tp_inst.control.value(tp_inst, obj, "minute", minute);
                tp_inst._onTimeChange();
                tp_inst._onSelectHandler();
                });
                return button;
        },
            create: function (tp_inst, obj, unit, val, min, max, step) {
                //Machinata.debug("CustomTimePicker: create control with '" + val + "' for " + unit);
            var self = this;
            if (unit == "hour") {
                // Register value
                tp_inst.currentHour = val;
            } else if (unit == "minute") {
                // Register value
                tp_inst.currentMinute = val;
                // Fix some ui stuff
                var container = obj.closest(".ui-timepicker-div");
                container.find(".ui_tpicker_hour_label").hide();
                container.find(".ui_tpicker_minute_label").hide();
                tp_inst.inst.dpDiv.find(".ui-datepicker-current").hide();
                tp_inst.inst.dpDiv.find(".ui-datepicker-buttonpane button").button();
                // Generate all options
                var buttons = $("<div class='ui-time-buttons'/>");
                for (var h = 0; h < 24; h++) {
                    for (var m = 0; m < 60; m += step) {
                        var button = self.createButton(tp_inst, obj, h, m);
                        buttons.append(button);
                }
            }
                buttons.appendTo(container);
        }
            return obj;
        },
            options: function (tp_inst, obj, unit, opts, val) {
            return obj;
                //if(typeof(opts) == 'string' && val !== undefined)
                //    return obj.find('.ui-timepicker-input').spinner(opts, val);
                //return obj.find('.ui-timepicker-input').spinner(opts);
        },
            value: function (tp_inst, obj, unit, val) {
            if (val !== undefined) {
                // Set
                //Machinata.debug("CustomTimePicker: set value '" +val +"' for "+unit);
                if (unit == "hour") {
                    tp_inst.currentHour = val;
            }
                if (unit == "minute") {
                    tp_inst.currentMinute = val;
                    var timeSelector = ".hour-" +tp_inst.currentHour + ".minute-" +tp_inst.currentMinute;
                    Machinata.debug("CustomTimePicker: selecting elem " + timeSelector);
                    obj.closest(".ui-timepicker-div").find(".ui-time-buttons button").removeClass("selected");
                    var selected = obj.closest(".ui-timepicker-div").find(".ui-time-buttons button" +timeSelector);
                    if (selected.length > 0) {
                        selected.addClass("selected");
                        var offsetV = -selected.parent().height() / 2 + selected.height() / 2;
                        setTimeout(function () {
                            selected.parent().scrollTo(selected, 0, { offset: offsetV });
                        }, 10);
                        
                }
            }
                return obj;
            } else {
                // Get
                //Machinata.debug("CustomTimePicker: get value for "+unit);
                if (unit == "hour") return parseInt(tp_inst.currentHour);
                if (unit == "minute") return parseInt(tp_inst.currentMinute);
                return 0; // We only support hour/minute
        }
    }
    };
    // Register
    if ($.timepicker) $.timepicker.setDefaults({ controlType: customControl});
};



/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-dialogs.js */
/* File: js/machinata-core-bundle.js/machinata-core-dialogs.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// Library for displaying dialogs of all sorts.
/// </summary>
/// <type>namespace</type>
Machinata.Dialogs = {};

/// <summary>
/// 
/// </summary>
Machinata.Dialogs.MAX_DIALOG_WIDTH = 420;

/// <summary>
/// 
/// </summary>
Machinata.Dialogs.DIALOG_ADDITIONAL_CLASSES = null;

/// <summary>
/// 
/// </summary>
Machinata.Dialogs.DEFAULT_API_CALL_CONTENT_FILES_CREATE = "/api/admin/content/files/create";

/// <summary>
/// 
/// </summary>
Machinata.Dialogs.DEFAULT_API_CALL_CONTENT_PAGES_LIST = "/api/admin/content/pages/list";

/// <summary>
/// 
/// </summary>
Machinata.Dialogs.DEFAULT_API_CALL_CONTENT_FILES_SEARCH = "/api/admin/content/files/search";

/// <summary>
/// 
/// </summary>
/// <hidden/>
Machinata.Dialogs._dialogUID = 0;

/// <summary>
/// 
/// </summary>
/// <type>class</type>
var Dialog = function (title, contents, buttons) {
    // Init
    this.uid = Machinata.Dialogs._dialogUID++; 
    this.id = "dialog_" + this.uid;
    Machinata.debug("Dialog: creating "+this.id+"...");
    this.title = title;
    this.contents = contents;
    this.buttons = buttons;
    this._noButtons = false;
    this.options = [];
    this._onDidShows = [];
    this._onOkays = [];
    this._onCancels = [];
    this._onInputs = [];
    this._inputSanitizers = [];
    this._inputValue = null;
    this._closeOnOverlayClick = true;
    // Create elem
    this.elem = $('<div id="' + this.id + '">');
    this.elem.attr("title", this.title);
    this.elem.attr("class", "bb-dialog");
    this.elem.css("display", "none");
    this.elem.html(contents);
    $("body").append(this.elem);
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.getButton = function (id) {
    return this.elem.parent().find("#"+id);
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.close = function () {
    this.elem.dialog("close");
    return this;
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.didShow = function (onDidShowFunction) {
    this._onDidShows.push(onDidShowFunction);
    return this;
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.okay = function (onOkayFunction) {
    Machinata.debug("Dialog: register onOkayFunction");
    this._onOkays.push(onOkayFunction);
    return this;
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.cancel = function (onCancelFunction) {
    Machinata.debug("Dialog: register onCancelFunction");
    this._onCancels.push(onCancelFunction);
    return this;
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.input = function (onInputFunction) {
    Machinata.debug("Dialog: register onInputFunction");
    this._onInputs.push(onInputFunction);
    return this;
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.inputSanitizer = function (inputSanitizerFunc) {
    Machinata.debug("Dialog: register inputSanitizer");
    this._inputSanitizers.push(inputSanitizerFunc);
    return this;
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.option = function (title, id, click, isCancel) {
    Machinata.debug("Dialog: adding option '" + title + "'");
    var self = this;
    if (id == null) id = title.toLowerCase();
    var wrapper = self.elem.find(".ui-dialog-options");
    if (wrapper.length == 0) {
        wrapper = $("<div class='ui-dialog-options'></div>");
        self.elem.append(wrapper);
    }
    if (title == "-") {
        wrapper.append($("<div class='ui-spacer'></div>"));
        return this;
    }
    var button = $("<button type='button'></button>");
    var clearer = $("<div class='clear'></div>");
    button.text(title);
    button.click(function () {
        self.elem.dialog("close");
        if (click) click(id, self, this);
        if (isCancel == true) for (var i = 0; i < self._onCancels.length; i++) self._onCancels[i](id, self, this);
        else for (var i = 0; i < self._onOkays.length; i++) self._onOkays[i](id, self, this);
    });
    button.button();
    wrapper.append(button);
    wrapper.append(clearer);
    self.options.push(button);
    return this;
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.button = function (title,id,click,isCancel,closeOnClick) {
    Machinata.debug("Dialog: adding button '" + title + "'");
    var self = this;
    if (id == null) id = title.toLowerCase();
    if (self.buttons == null) self.buttons = [];
    self.buttons.push({
        id: id,
        text: title, 
        closeOnClick: closeOnClick,
        click: function () {
            // Close dialog by default
            if (closeOnClick != false) $(this).dialog("close");
            //TODO: is this really the button?
            if (click) click(id, self, this);
            if (isCancel == true) for (var i = 0; i < self._onCancels.length; i++) self._onCancels[i](id, self, this);
            else {
                var val = null;
                if (self.elem.find("input").length > 0 || self._inputValue != null) {
                    var val = null;
                    if (self._inputValue != null) val = self._inputValue;
                    else val = self.elem.find("input").val();
                    for (var i = 0; i < self._inputSanitizers.length; i++) val = self._inputSanitizers[i](val);
                    for (var i = 0; i < self._onInputs.length; i++) self._onInputs[i](val, id, self, this);
                } 
                for (var i = 0; i < self._onOkays.length; i++) self._onOkays[i](id, self, this, val);
            }
        }
    });
    return this;
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.triggerOkay = function (id, val) {
    var self = this;
    self.elem.dialog("close");
    for (var i = 0; i < self._onOkays.length; i++) self._onOkays[i](id, self, null, val);
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.triggerInput = function (id, val) {
    var self = this;
    self.elem.dialog("close");
    for (var i = 0; i < self._inputSanitizers.length; i++) val = self._inputSanitizers[i](val);
    for (var i = 0; i < self._onInputs.length; i++) self._onInputs[i](val, id, self, null);
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.cancelButton = function (title, id, click) {
    if (title == null) title = "Cancel";
    return this.button(title, id, click, true);
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.okayButton = function (title, id, click) {
    if (title == null) title = "Okay";
    return this.button(title, id, click, false);
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.design = function (className) {
    return this.elem.addClass(className);
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.noButtons = function () {
    return this._noButtons = true;
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.data = function (key,val) {
    if (val == null) {
        return this.elem.data(key);
    } else {
        return this.elem.data(key, val);
    }
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.setInputValue = function (val) {
    Machinata.debug("Setting dialog input value to " + val);
    return this._inputValue = val;
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.closeOnOverlayClick = function (val) {
    this._closeOnOverlayClick = val;
};

/// <summary>
/// 
/// </summary>
Dialog.prototype.show = function () {
    Machinata.debug("Dialog: showing " + this.id + "...");
    // Validate buttons
    var self = this;
    if ((self.buttons == null || self.buttons.length == 0) && self.options.length == 0 && this._noButtons != true) {
        Machinata.debug("Dialog: adding default button");
        self.button("Okay");
    }
    // Get width
    var dialogWidth = Math.min($(window).width(), Machinata.Dialogs.MAX_DIALOG_WIDTH);
    // Use jquery ui to show the dialog
    $("#"+this.id).dialog({
        modal: true,
        dialogClass: Machinata.Dialogs.DIALOG_ADDITIONAL_CLASSES,
        buttons: this.buttons,
        width: dialogWidth, // used to be auto
        open: function (event, ui) {
            if (Machinata.Dialogs.DIALOG_ADDITIONAL_CLASSES != null) {
                $('.ui-widget-overlay').addClass(Machinata.Dialogs.DIALOG_ADDITIONAL_CLASSES+"-overlay");
            }
            if (self._closeOnOverlayClick == true) {
                $('.ui-widget-overlay').on('click', function () {
                    self.elem.dialog('close');
                });
            }
            for (var i = 0; i < self._onDidShows.length; i++) self._onDidShows[i](self);
        },
    });
    this.elem.css("minHeight", "");
    return this;
};
/// <summary>
/// 
/// </summary>
Dialog.prototype.reposition = function () {
    Machinata.debug("Dialog: repositioning " + this.id + "...");
    $("#" + this.id).dialog({
        position: { 'my': 'center', 'at': 'center', 'of':window }
    });
    return this;
};


/// <summary>
/// Dialog: generic
/// </summary>
Machinata.dialog = function (title, contents, buttons) {
    Machinata.debug("showDialog(" + title + "," + JSON.stringify(buttons) + ")");
    var diag = new Dialog(title, contents, buttons);
    return diag;
};

/// <summary>
/// Dialog: message
/// </summary>
Machinata.messageDialog = function (title, message, buttons) {
    var contents = "";
    contents += "<p>";
    if (message != null) contents += message;
    contents += "</p>";
    var diag = Machinata.dialog(title, contents, buttons);
    return diag;
};

/// <summary>
/// Dialog: full-window-size
/// Use the full-sized .dialog-contents div to add to the dialog.
/// </summary>
Machinata.fullwindowDialog = function (title, buttons) {
    var contents = "<div class='dialog-contents' style='width:100%;position:relative;'></div>";
    var diag = Machinata.dialog(title, contents, buttons);
    // Resize helper method
    function updateSize() {
        diag.elem.parent().css({
            'width': $(window).width(),
            'height': $(window).height(),
        });
        var dialogHeight = diag.elem.parent().height();
        var titleHeight = diag.elem.parent().find(".ui-dialog-title").outerHeight(true);
        var buttonsHeight = diag.elem.parent().find(".ui-dialog-buttonset").outerHeight(true);
        var contentsHeight = dialogHeight - titleHeight - buttonsHeight - 16;
        diag.elem.parent().find(".dialog-contents").css({
            'height': contentsHeight,
            'padding-bottom': "16px"
        });
    }
    // Bind events to size the dialog 
    diag.elem.on("dialogopen", function (event, ui) {
        diag.elem.parent().css({
            'left': '0px',
            'top': '0px',
            'max-width':'unset',
            'position':'fixed',
        });
        updateSize();
    });
    $(window).resize(function () {
        updateSize();
    });

    return diag;
};

/// <summary>
/// Dialog: confirm
/// </summary>
Machinata.confirmDialog = function (title, message, buttons) {
    var diag = Machinata.messageDialog(title, message, buttons);
    diag.cancelButton("Cancel");
    diag.button("Okay");
    diag.closeOnOverlayClick(false);
    return diag;
};


/// <summary>
/// Dialog: yes No
/// </summary>
Machinata.yesNoDialog = function (title, message, buttons) {
    var diag = Machinata.messageDialog(title, message, buttons);
    diag.cancelButton("No");
    diag.button("Yes");
    diag.closeOnOverlayClick(false);
    return diag;
};

/// <summary>
/// Dialog: input
/// </summary>
Machinata.inputDialog = function (title, message, defaultValue, placeholder, type, buttons) {
    // Init contents
    var contents = "";
    if (!String.isEmpty(message)) {
        contents += "<p>";
        contents += message;
        contents += "</p>";
    }
    contents += "<div class='ui-form'>";
    contents += "<input/>";
    contents += "</div>";
    // Create the dialog
    var diag = Machinata.dialog(title, contents, buttons);
    var inputElem = diag.elem.find("input");
    if (defaultValue != null) inputElem.val(defaultValue);
    if (placeholder != null) inputElem.attr("placeholder", placeholder);
    if (type != null) inputElem.attr("type", type);
    else inputElem.attr("type", "text");
    diag.cancelButton("Cancel");
    diag.button("Okay");
    // Bind input
    inputElem.keypress(function (e) {
        if (e.which == 13) {
            var okayButton = diag.getButton("okay");
            okayButton.trigger("click");
        }
    });
    return diag;
};

/// <summary>
/// Dialog: input
/// </summary>
Machinata.numberDialog = function (title, message, defaultValue, placeholder, buttons) {
    return Machinata.inputDialog(title, message, defaultValue, placeholder, "number", buttons);
};


/// <summary>
/// Dialog: options
/// </summary>
Machinata.optionsDialog = function (title, message, options, buttons) {
    // Create the dialog
    var diag = Machinata.messageDialog(title, message, buttons);
    for (var key in options) {
        diag.option(options[key], key)
    }
    diag.cancelButton("Cancel");
    //diag.button("Okay");
    return diag;
};


/// <summary>
/// Dialog: progress
/// </summary>
Machinata.progressDialog = function (title, message, buttons) {
    // Init diag
    var contents = "";
    contents += "<div class='ui-progressbar'>";
    contents += "  <div class='progress'>";
    contents += "  </div>";
    contents += "</div>";
    var diag = Machinata.dialog(title, contents, buttons);
    // Prepare progressbar
    var progressBar = diag.elem.find(".ui-progressbar");
    // Update event
    diag.updateProgress = function (percent) {
        progressBar.find(".progress").css("width", percent+"%");
    };
    diag.closeOnOverlayClick(false);
    // Return
    return diag;
};


/// <summary>
/// Dialog: upload
/// </summary>
Machinata.uploadDialog = function (title, source, category, buttons, apiCall, apiCallSuccess) {
    // Validate
    if (source == null) {
        console.log("You must specify a source when using Machinata.uploadDialog!");
        return;
    }
    // Set api call
    if (apiCall == null) apiCall = Machinata.Dialogs.DEFAULT_API_CALL_CONTENT_FILES_CREATE;
    // Init diag
    var diag = Machinata.progressDialog(title, null, buttons);
    diag.noButtons();
    // Do API Call
    var call = Machinata.apiCall(apiCall);
    var data = {};
    data["source"] = source;
    data["category"] = category;
    call.data(data);
    call.success(function (message) {
        diag.close();
    });
    if (apiCallSuccess == null) {
        call.success(function (message) {
            var contentURL = message.data["content-file"]["content-url"];
            diag.triggerInput("upload", contentURL);
        });
    } else {
        call.success(apiCallSuccess);
    }
    call.progress(function (percent) {
        diag.updateProgress(percent);
    });
    call.genericError();
    call.error(function () {
        diag.close();
    });
    // Get file via a input elem by invoking it's click
    var inputAccept = "";
    if (category == "image") inputAccept = "image/*";
    else if (category == "json") inputAccept = "json/*";
    var inputElem = $("<input type='file' accept='" + inputAccept + "' style='position:absolute;left:-10000px;top:0px;'/>");
    diag.elem.append(inputElem);
    inputElem.on("change", function () {
        // Show diag
        diag.show();
        // Attach file to call and send
        var fileNative = $(this)[0];
        call.attachFileInput(fileNative.files[0], name, fileNative.files[0].name);
        call.send();
    });
    inputElem.trigger("click");
    // Return self
    diag.closeOnOverlayClick(false);
    return diag;
};


/// <summary>
/// Dialog: file
/// </summary>
Machinata.fileDialog = function (title, source, category, buttons, apiCall) {
    // Validate
    if (source == null) {
        console.log("You must specify a source when using Machinata.fileDialog!");
        return;
    }
    // Find filetype from category
    var filetype = null;
    if (category != null) {
        if (category.indexOf('/') > 0) {
            var catType = category.split('/');
            if (catType.length == 2) {
                category = catType[0];
                filetype = catType[1];
            }
        }
    }
    // Init diag
    var contents = "";
    contents += "<div class='content-file-browser'>";
    contents += "   <div class='ui-form'><input type='text' class='filter' placeholder='Filter'/></div>";
    contents += "   <div class='content-files ui-file-panel'>";
    contents += "   </div>";
    contents += "</div>";
    var diag = Machinata.dialog(title, contents, buttons);
    diag.design("wide");
    diag.button("Cancel", "cancel", null, true);
    if (source == "*") {
        
    } else {
        diag.button("Upload", "upload", function () {
            Machinata.uploadDialog("Upload File", source, category)
                .input(function (val) {
                    diag.triggerOkay(val);
                });
        }, true);
    }
    diag.updateFiles = function () { //TODO: this should be diag.data(...)
        var self = this;
        self.elem.addClass("loading");
        var contentFilesElem = self.elem.find(".content-files");
        contentFilesElem.text("");
        contentFilesElem.append($("<p>Loading...</p>"));
        // Prepare api call
        if (apiCall == null) apiCall = Machinata.Dialogs.DEFAULT_API_CALL_CONTENT_FILES_SEARCH;
        var call = Machinata.apiCall(apiCall);
        var data = {};
        data["category"] = category;
        data["source"] = source;
        data["filter"] = self.elem.find("input.filter").val();
        if (filetype != null) data["filetype"] = filetype;
        call.data(data);
        call.success(function (message) {
            // Remove loading
            self.elem.removeClass("loading");
            contentFilesElem.text("");
            // Add contetns
            for (var i = 0; i < message.data.length; i++) {
                var cf = message.data[i];
                var thumbnail = Machinata.createFilePreview(cf["content-url"], cf["file-name"], true);
                thumbnail.click(function () {
                    diag.triggerOkay($(this).attr("content-url"));
                });
                contentFilesElem.append(thumbnail);
            }
            if (message.data.length == 0) {
                contentFilesElem.append($("<p>No Results</p>"));
            }
        })
        call.error(function (message) {
            self.elem.removeClass("loading");
        });
        call.genericError();
        // Send
        call.send();
    };
    diag.updateFiles();
    // Bind input enter
    diag.elem.find("input.filter").keypress(function (e) {
        if (e.which == 13) {
            diag.updateFiles();
            return false;
        }
    });
    // Return
    return diag;
};


/// <summary>
/// Dialog: page
/// </summary>
Machinata.cmsPageDialog = function (title, path, buttons, apiCall, apiCallSuccess) {
    // Init diag
    var contents = "";
    contents += "<div class='content-file-browser'>";
    contents += "   <div class='ui-form'><input type='text' class='filter' placeholder='Search'/></div>";
    contents += "   <div style='height:8px;'></div>";
    contents += "   <ul class='ui-breadcrumb breadcrumb'></ul>";
    contents += "   <div style='height:8px;'></div>";
    contents += "   <div class='content-files ui-file-panel'></div>";
    contents += "</div>";
    var diag = Machinata.dialog(title, contents, buttons);
    diag.data("path", path);
    diag.design("wide");
    diag.button("Cancel", "cancel", null, true);
    diag.button("Select", "input", function () {
        diag.triggerInput("path",diag.data("path"));
    }, true);
    diag.updatePages = function () { //TODO: this should be diag.data(...)
        var self = this;
        // Update breadcrumb
        var crumbPathToSplit = diag.data("path");
        if (crumbPathToSplit == "/") crumbPathToSplit = "";
        var crumbs = crumbPathToSplit.split("/");
        self.elem.find(".breadcrumb").empty();
        var crumbPath = "";
        for (var i = 0; i < crumbs.length; i++) {
            var crumb = $("<li><a class='item'></a></li>");
            if (i == 0) {
                crumb.find("a").text("Content");
            } else {
                crumb.find("a").text(crumbs[i]);
                crumbPath += "/" + crumbs[i];
            }
            crumb.attr("node-path", crumbPath);
            crumb.click(function () {
                diag.data("path", $(this).attr("node-path"));
                diag.updatePages();
            });
            self.elem.find(".breadcrumb").append(crumb);
        }
        // Update sub pages
        self.elem.addClass("loading");
        var contentFilesElem = self.elem.find(".content-files");
        contentFilesElem.text("");
        contentFilesElem.append($("<p>Loading...</p>"));
        // Prepare api call
        if (apiCall == null) apiCall = Machinata.Dialogs.DEFAULT_API_CALL_CONTENT_PAGES_LIST;
        var call = Machinata.apiCall(apiCall);
        var data = {};
        data["path"] = diag.data("path");
        data["search"] = diag.data("search");
        call.data(data);
        call.success(function (message) {
            // Remove loading
            self.elem.removeClass("loading");
            contentFilesElem.text("");
            // Clear previous serach
            diag.data("search", null);
            // Add contetns
            for (var i = 0; i < message.data.pages.length; i++) {
                var page = message.data.pages[i];
                //var thumbnail = Machinata.createPagePreview(page["path"], page["name"], page["summary"]);
                var thumbnail = Machinata.createGenericPreview(
                    page["name"],
                    null,
                    null,
                    "Page",
                    "document",
                    "page"
                );
                thumbnail.data("node-path", page["path"]);
                thumbnail.click(function () {
                    diag.data("path", $(this).data("node-path"));
                    diag.updatePages();
                });
                contentFilesElem.append(thumbnail);
            }
            if (message.data.length == 0) {
                contentFilesElem.append($("<p>No Results</p>"));
            }
        })
        call.error(function (message) {
            self.elem.removeClass("loading");
        });
        call.genericError();
        // Send
        call.send();
    };
    diag.updatePages();
    // Bind input enter
    diag.elem.find("input.filter").keypress(function (e) {
        console.warn("TODO: not yet supported");
        return;
        //if (e.which == 13) {
        //    diag.updatePages();
        //    return false;
        //}
    });
    // Return
    return diag;
};



/// <summary>
/// Dialog: product
/// </summary>
Machinata.productDialog = function (title, buttons) {
    // Init diag
    var contents = "";
    contents += "<div class='content-file-browser'>";
    contents += "   <ul class='breadcrumb auto-select-last wide'>";
    contents += "   </ul>";
    contents += "   <div style='height:8px;'>";
    contents += "   </div>";
    contents += "   <div class='content-files'>";
    contents += "   </div>";
    contents += "</div>";
    var diag = Machinata.dialog(title, contents, buttons);
    var path = "/";
    diag.data("path", path);
    diag.design("wide");
    diag.button("Cancel", "cancel", null, true);
    diag.updatePages = function () { //TODO: this should be diag.data(...)
        var self = this;
        // Update breadcrumb
        var crumbPathToSplit = diag.data("path");
        if (crumbPathToSplit == "/") crumbPathToSplit = "";
        var crumbs = crumbPathToSplit.split("/");
        self.elem.find(".breadcrumb").empty();
        var crumbPath = "/";
        for (var i = 0; i < crumbs.length; i++) {
            var crumb = $("<li><a class='item'></a></li>");
            if (i == 0) {
                crumb.find("a").text("Catalog Groups");
            } else {
                crumb.find("a").text(crumbs[i]);
                if(i != 1) crumbPath += "/";
                crumbPath += crumbs[i];
            }
            crumb.attr("node-path", crumbPath);
            crumb.click(function () {
                diag.data("path", $(this).attr("node-path"));
                diag.updatePages();
            });
            self.elem.find(".breadcrumb").append(crumb);
        }
        // Update sub pages
        self.elem.addClass("loading");
        var contentFilesElem = self.elem.find(".content-files");
        contentFilesElem.text("");
        contentFilesElem.append($("<p>Loading...</p>"));
        // Prepare api call
        var call = Machinata.apiCall("/api/admin/shop/browse-catalog");
        var data = {};
        data["path"] = diag.data("path");
        call.data(data);
        call.success(function (message) {
            // Remove loading
            self.elem.removeClass("loading");
            contentFilesElem.text("");
            // Clear previous serach
            diag.data("search", null);
            // Add contetns
            for (var i = 0; i < message.data.pages.length; i++) {
                var data = message.data.pages[i];
                var thumbnail = Machinata.createGenericPreview(
                    data["name"],
                    data["catalog-name"],
                    null,
                    data["type"],
                    "tag",
                    "product"
                );
                thumbnail.data("data", data);
                thumbnail.click(function () {
                    var data = $(this).data("data");
                    if (data["product-name"] != null) {
                        diag.triggerInput("product-public-id", data);
                    } else {
                        diag.data("path", data["path"]);
                        diag.updatePages();
                    }
                });
                contentFilesElem.append(thumbnail);
            }
            if (message.data.length == 0) {
                contentFilesElem.append($("<p>No Results</p>"));
            }
        })
        call.error(function (message) {
            self.elem.removeClass("loading");
        });
        call.genericError();
        // Send
        call.send();
    };
    diag.updatePages();
    // Return
    return diag;
};


/// <summary>
/// Dialog: link
/// </summary>
Machinata.linkDialog = function (title, message, defaultValue, placeholder, buttons) {
    if (title == null) title = "Link";
    //if (message == null) message = "Enter a domain or link:";
    if (placeholder == null) placeholder = "www.domain.com";
    var diag = Machinata.inputDialog(title, message, defaultValue, placeholder, null, buttons);
    diag.inputSanitizer(function (val) {
        // Sanity
        Machinata.debug("Dialog: link sanitizing '"+val+"'");
        if(val == null || val == "") return null;
        // If it is already a link just return
        if (val.startsWith("http://") || val.startsWith("https://")) return val;
        if (val.startsWith("mailto:")) return val;
        if (val.startsWith("tel:")) return val;
        if (val.startsWith("skype:")) return val;
        if (val.startsWith("/")) return val;
        if (val.startsWith("{")) return val;
        if (val.startsWith("#")) return val;
        // Email?
        if (val.indexOf("@") > -1) return "mailto:"+val;
        // Add default http
        return "http://" + val;
    });
    return diag;
};

/// <summary>
/// Dialog: month
/// </summary>
Machinata.monthDialog = function (title, message, buttons, format) {
    
    var contents = "";
    if (message != null) contents += "<p>";
    if (message != null) contents += message;
    if (message != null) contents += "</p>";
    contents += "<div class='month-picker'>";
    contents += "   <select class=\"year\" style='min-width:100px'></select>";
    contents += "   <select class=\"month\" style='min-width:50px'></select>";
    contents += "</div>";
    var diag = Machinata.dialog(title, contents, buttons);
    var today = new Date();
    for (var yy = today.getFullYear(); yy >= 1960; yy--) {
        diag.elem.find("select.year").append("<option value='"+yy+"'>" + yy + "</option>");
    }
    for (var mm = 1; mm <= 12; mm++) {
        var optElem = $("<option value='" + mm + "'>" + mm + "</option>");
        if (mm == today.getMonth()+1) optElem.attr("selected", "selected");
        diag.elem.find("select.month").append(optElem);
    }
    diag.cancelButton();
    //diag.button("Clear", "clear");
    diag.okayButton();

    // Bind interactions
    function updateInputValue() {
        var year = parseInt(diag.elem.find("select.year").val());
        var month = parseInt(diag.elem.find("select.month").val());
        var date = new Date(year, month-1, 1, 0, 0, 0, 0);
        if (format == null) {
            diag.setInputValue(date);
        } else {
            var formatted = Machinata.formattedDate(date, format);
            diag.setInputValue(formatted);
        }
    }
    diag.elem.find("select").on("change", updateInputValue);
    updateInputValue();
    
    // Return
    return diag;
};



/// <summary>
/// Dialog: month
/// </summary>
Machinata.calendarWeekDialog = function (title, message, buttons,format) {

    var contents = "";
    if (message != null) contents += "<p>";
    if (message != null) contents += message;
    if (message != null) contents += "</p>";
    contents += "<div class='cw-picker'>";
    contents += "   <select class=\"year\" style='min-width:100px'/>";
    contents += "   <select class=\"week\" style='min-width:80px'/>";
    contents += "</div>";
    var diag = Machinata.dialog(title, contents, buttons);
    var today = new Date();
    for (var yy = today.getFullYear(); yy >= 1960; yy--) {
        diag.elem.find("select.year").append("<option value='" + yy + "'>" + yy + "</option>");
    }
    for (var ww = 1; ww <= 52; ww++) {
        var optElem = $("<option value='" + ww + "'>" + ww + "</option>");
        if (ww == today.iso8601CalendarWeek()) optElem.attr("selected", "selected");
        diag.elem.find("select.week").append(optElem);
    }
    diag.cancelButton();
    //diag.button("Clear", "clear");
    diag.okayButton();

    // Bind interactions
    function updateInputValue() {
        var year = parseInt(diag.elem.find("select.year").val());
        var week = parseInt(diag.elem.find("select.week").val());
        var days = (week-1) * 7;
        var date = new Date(year, 0, 1, 0, 0, 0, 0);
        date.setDate(date.getDate() + days);
        if (format == null) {
            diag.setInputValue(date);
        } else {
            var formatted = Machinata.formattedDate(date, format);
            diag.setInputValue(formatted);
        }
    }
    diag.elem.find("select").on("change", updateInputValue);
    updateInputValue();

    // Return
    return diag;
};

/// <summary>
/// Dialog: date
/// </summary>
Machinata.dateDialog = function (title, message, buttons, currentDateString, dateFormat, timeFormat, isDateRange) {
    Machinata.debug("Creating date dialog with '" + currentDateString + "'");
    Machinata.debug("  Date format: '" + dateFormat + "'");
    Machinata.debug("  Time format: '" + timeFormat + "'");
    Machinata.debug("  Current date: '" + currentDateString + "'");
    // Convert string to date
    if (dateFormat != null) dateFormat = Machinata.convertDotNetTimeFormatToDatepickerFormat(dateFormat);
    else dateFormat = Machinata.convertDotNetTimeFormatToDatepickerFormat(Machinata.DEFAULT_DATE_FORMAT_JAVASCRIPT_UI); // default
    var format = dateFormat;
    if (timeFormat != null) format = dateFormat + " " + timeFormat;
    var currentDate1 = null;
    var currentDate2 = null;
    // Range?
    if (isDateRange == true) {
        // Split on dash
        if (currentDateString != null && currentDateString != "") {
            var segs = currentDateString.split(Machinata.DEFAULT_DATERANGE_SEPARATOR);
            if (segs.length != 2) {
                alert("invalid date range "+currentDateString);
                return;
            }
            currentDate1 = Machinata.dateFromString(segs[0], format);
            currentDate2 = Machinata.dateFromString(segs[1], format);
        }
    } else {
        // Single date
        currentDate1 = Machinata.dateFromString(currentDateString, format);
    }
    Machinata.debug("  Converted date: '" + currentDate1 + "'");
    // Init diag
    if (title == null) {
        if (isDateRange == true) title = "Select a Date Range";
        else title = "Select a Date";
    }
    var contents = "";
    contents += "<div class=''>";
    contents += "   <div class=\"datetimepicker1\"></div>";
    contents += "   <div class='datetimepickerSpacer' style='height:1em;'></div>";
    contents += "   <div class=\"datetimepicker2\"></div>";
    contents += "</div>";
    var diag = Machinata.dialog(title, contents, buttons);
    diag.cancelButton();
    diag.button("Clear", "clear");
    diag.okayButton();
    // Init picker elems
    var dateTimePickerElem1 = diag.elem.find(".datetimepicker1");
    var dateTimePickerElemSpacer = diag.elem.find(".datetimepickerSpacer");
    var dateTimePickerElem2 = diag.elem.find(".datetimepicker2");
    // Create options
    var opts = {};
    opts.stepHour = 1;
    opts.stepMinute = 30;
    opts.showTime = false;
    opts.showMinute = false;
    opts.showHour = false;
    opts.showButtonPanel = false;
    opts.dateFormat = dateFormat;
    opts.timeFormat = timeFormat;
    opts.showTimezone = false;
    opts.onSelect = function (selectedDateTime, datepickerInstance) {
        if (isDateRange == true) {
            // Update value
            var date1 = dateTimePickerElem1.datepicker("getDate");
            var date2 = dateTimePickerElem2.datepicker("getDate");
            // Do constraints
            if (datepickerInstance != null) {
                if (datepickerInstance.id == dateTimePickerElem2.attr("id")) dateTimePickerElem1.datepicker("option", "maxDate", date2);
                if (datepickerInstance.id == dateTimePickerElem1.attr("id")) dateTimePickerElem2.datepicker("option", "minDate", date1);
            }
            diag.setInputValue({start:date1,end:date2});
        } else {
            // Single date
            diag.setInputValue(dateTimePickerElem1.datepicker("getDate"));
        }
    }
    if (timeFormat == null) opts.showTimepicker = false;

    

    // Create the picker
    if (isDateRange == true) {
        opts.minDate = null;
        if (currentDate2 != null) opts.maxDate = currentDate2;
        dateTimePickerElem1.datetimepicker(opts);
        opts.maxDate = null;
        if (currentDate1 != null) opts.minDate = currentDate1;
        dateTimePickerElem2.datetimepicker(opts);
        // If dates are null, set default to noon today (otherwise widget will set to 00:00 today)
        if (currentDate1 == null) {
            currentDate1 = new Date();
            currentDate1.setHours(12);
            currentDate1.setMinutes(0);
            currentDate1.setSeconds(0);
            currentDate1.setMilliseconds(0);
        }
        if (currentDate2 == null) {
            currentDate2 = new Date();
            currentDate2.setHours(12);
            currentDate2.setMinutes(0);
            currentDate2.setSeconds(0);
            currentDate2.setMilliseconds(0);
        }
        dateTimePickerElem1.datetimepicker("setDate", currentDate1);
        dateTimePickerElem2.datetimepicker("setDate", currentDate2);
    } else {
        // Only need one picker...
        dateTimePickerElemSpacer.hide();
        dateTimePickerElem1.datetimepicker(opts);
        // If dates are null, set default to noon today (otherwise widget will set to 00:00 today)
        if (currentDate1 == null) {
            currentDate1 = new Date();
            currentDate1.setHours(12);
            currentDate1.setMinutes(0);
            currentDate1.setSeconds(0);
            currentDate1.setMilliseconds(0);
        }
        dateTimePickerElem1.datetimepicker("setDate", currentDate1);
    }
    // Initial value
    if (isDateRange == true) {
        diag.setInputValue({ start: currentDate1, end: currentDate2 });
    } else {
        diag.setInputValue(currentDate1);
    }
    // Return
    return diag;
};

/// <summary>
/// Dialog: language change
/// </summary>
Machinata.showLanguageChangeDialog = function (callback) {
    Machinata.apiCall("/api/admin/config/core/supported-languages")
        .genericError()
        .success(function(message){
            var sourceLanguage = null;
            var targetLanguage = null;
            var diagFrom = Machinata.messageDialog("Export for Translation", "Source Language:")
                .cancelButton()
                .okay(function (id) {
                    sourceLanguage = id;
                    var diagTo = Machinata.messageDialog("Export for Translation", "Target Language:")
                        .cancelButton()
                        .okay(function (id) {
                            targetLanguage = id;
                            callback(sourceLanguage, targetLanguage);
                        });
                    for (var i = 0; i < message.data.value.length; i++) {
                        var lang = message.data.value[i];
                        if (lang == sourceLanguage) continue;
                        diagTo.option(lang.toUpperCase(), lang);
                    }
                    diagTo.show();
                });
            for (var i = 0; i < message.data.value.length; i++) {
                var lang = message.data.value[i];
                diagFrom.option(lang.toUpperCase(), lang);
            }
            diagFrom.show();
        })
        .send();
};


/// <summary>
/// Dialog: load a page and display its contents as a dialog
/// Example:
/// ```Machinata.showPageAsDialog("/help/popup/xyz","#content")```
/// </summary>
Machinata.pageDialog = function (url, selector, maxContentHeight) {
    if (maxContentHeight == null) maxContentHeight = $(window).height() * 0.5;
    var urlToForLoad = url;
    if (selector != null) urlToForLoad += " " + selector;

    Machinata.showLoading(true);
    var tempNode = $("<div></div>");
    tempNode.load(urlToForLoad, function () {
        var title = tempNode.find("h1").first().text();
        tempNode.find("h1").first().remove();
        var diag = Machinata.dialog(title, tempNode.html());
        diag.show();
        if (maxContentHeight != null && maxContentHeight != 0) {
            diag.elem.css("overflow-y", "auto");
            diag.elem.css("max-height", maxContentHeight + "px");
        }
        Machinata.showLoading(false);
    });
    
};

/// <deprecated/>
Machinata.showPageAsDialog = function (url, selector, maxContentHeight) {
    Machinata.pageDialog(url, selector, maxContentHeight);
};



/// <summary>
/// 
/// </summary>
Machinata.colorDialog = function (title, message, colorSystems, opts) {
    if (opts == null) opts = {};

    // Create swatch
    //opts.onSelect = function (data) {
    //    diag.setInputValue({ code: data.code, hex: data.hex });
    //};
    //var colorSwatches = Machinata.UI.createSwatchPicker(colorSystems, opts);

    // Create loading elem
    //var loadingElem = $("<div class='loader'>Loading...</div>");
    var loadingElem = $("<div class='loader'>Loading...<div class='bb-color-swatch ui-color-swatch'><div class='colors' style='border:none'></div></div></div>");

    // Setup dialog
    var diag = Machinata.messageDialog(title, message);
    //diag.elem.append(colorSwatches);
    diag.elem.append(loadingElem);
    diag.cancelButton("Cancel");
    diag.button("Okay");
    diag.didShow(function (diag) {
        // Create swatch
        setTimeout(function () {

            opts.onSelect = function (data) {
                diag.setInputValue({ code: data.code, hex: data.hex });
            };
            var colorSwatches = Machinata.UI.createSwatchPicker(colorSystems, opts);
            diag.elem.find(".loader").empty();
            diag.elem.append(colorSwatches);
            // Reposition
            //setTimeout(function () {
            //    diag.reposition();
            //}, 10);
        },10);
    });
    diag.show();

    return diag;
};



/// <summary>
/// 
/// </summary>
Machinata.locationDialog = function (title, message, opts) {
    if (opts == null) opts = {};
    if (opts.readonly == null) opts.readonly = false;

    // Create custom input
    var formElem = $("<div class='ui-form'><input type='text' placeholder='Address or coordinates'/></div>");
    var inputElem = formElem.find("input");
    inputElem.attr("title", "Address or coordinates. Press enter to search");

    // Create map
    var mapElem = $("<div class='ui-map'></div>");
    mapElem.css("width", "100%");
    mapElem.css("height", "200px");
    
    // Setup dialog
    var diag = Machinata.messageDialog(title, message);
    if (opts.readonly != true) diag.elem.append(formElem);
    diag.elem.append(mapElem);
    if (opts.readonly != true) diag.cancelButton("Cancel");
    if (opts.readonly != true) diag.button("Clear", "clear");
    diag.button("Okay");
    diag.show();

    // Initial state
    diag.setInputValue(opts.address);
    inputElem.val(Machinata.String.readAddressFromLocationString(opts.address));

    // Helper function update coords
    function updateCoords(newLatLon) {
        var newLocationString = Machinata.String.updateLatLonInLocationString(inputElem.val(), newLatLon);
        var newAddressString = Machinata.String.readAddressFromLocationString(newLocationString);
        inputElem.val(newAddressString);
        diag.setInputValue(newLocationString);
        console.log(newLocationString);
    }

    // Create map
    var mapOpts = {
        address: opts.address,
        doubleClickZoom: false,
        scrollWheelZoom: true
    };
    var map = Machinata.maps.createMap(mapElem, mapOpts);
    map.on("dblclick", function (event) {
        mapElem.trigger("update", {
            address: event.latlng.lat + "," + event.latlng.lng,
            callback: function (result) {
                updateCoords(result.lat + "," + result.lng);
                //inputElem.val(result.lat + "," + result.lng);
                //diag.setInputValue(result.lat + "," + result.lng);
            }
        });
    });
    // Bind interaction
    if (opts.readonly != true) {
        mapElem.on("markermove", function (event, args) {
            updateCoords(args.lat + "," + args.lng);
            //inputElem.val(args.lat + "," + args.lng);
            //diag.setInputValue(args.lat + "," + args.lng);
        });
    }
    inputElem.on("keypress", function (event) {
        if (event.which == 13) {
            mapElem.trigger("update", {
                address: inputElem.val(),
                callback: function (result) {
                    updateCoords(result.lat + "," + result.lng);
                    //inputElem.val(result.lat + "," + result.lng);
                    //diag.setInputValue(result.lat + "," + result.lng);
                }
            });
        }
    });

    return diag;
};




/// <summary>
/// Get a list of entities via an API call and displays them using ```Machinata.entityListingDialog```.
/// Parameters:
///  - ```apiCall```: defines the server endpoint to call for the entieis data. 
///    If the url has```{search}``` in it, the dialog box will automatically set the option 
///    ```apiCallForSearch``` to the same url and do an initial update with a blank filter. The server can choose if it should return
///    some initial entities for the empty search (smaller list) or return no entities for empty search (very large lists).
///  - ```opts```: defines a configuration object with all the different options
/// Options:
///  - ```entitiesKey```: defines the key where the array of entities is stored in the api call returned message data
/// See ```Machinata.entityListingDialog``` for further details and options
/// </summary>
/// <example>
/// ```
/// var diag = Machinata.entityListingDialogForAPICall("Select entity", "Please select an entity below", "/api/portal/easy-dfi/contents/list", {
///     entitiesKey: "contents",
///     entityIdKey: "public-id",
///     selectedEntityId: "hTKaaQ",
///     search: true,
/// });
/// diag.input(function (entity) {
///     console.log(entity); // this was selected
/// });
/// ```
/// </example>
Machinata.entityListingDialogForAPICall = function (title, message, apiCall, opts) {
    // Init diag, we need to already return this to the caller...
    var diag = Machinata.messageDialog(title, message);
    if (opts == null) opts = {};
    opts.diag = diag;
    if (opts.apiCallForSearch == null && apiCall.indexOf("{search}") > -1) {
        opts.apiCallForSearch = apiCall;
    }
    // Do API Call
    var url = apiCall.replace("{search}", "");
    var call = Machinata.apiCall(url);
    call.success(function (message) {
        var entities = message.data[opts.entitiesKey];
        Machinata.entityListingDialog(title, message, entities, opts);
    });
    call.genericError();
    call.send();
    // Return to caller
    return diag;
};

/// <summary>
/// Generic and flexible entity listing chooser dialog. 
/// Will automatically build a listing of choosable entities based on an array ```entities```.
/// Unless specifically specified, the dialog will automatically create a UI based on the properties
/// of the entity objects (except the id key).
/// Options:
///  - ```entityIdKey```: defines which key to use as the entity id
///  - ```selectedEntityId```: optional, defines which entity is currently selected
///  - ```properties```: optional, defines a custom properties to display, must be an arrow of objects with ```key``` and ```title```
///  - ```search```: optional, if true a search box will allow quick filtering
///  - ```multipleSelection```: optional, if true multiple items will be selectable
///  - ```returnEntityIds```: optional, if true instead of returning the entity object, entityIds will be returned
///  - ```allowClear```: optional, if true a clear button is added with return value 'clear'
///  - ```requireSearchForResults```: optional, if true a search is required before any results are shown
///  - ```apiCallForSearch```: optional, if set instead of searching using the provided entities the search is performed using a new result from the server where the parameter variable {search} can be used
/// </summary>
/// <example>
/// ```
/// var entities = [
///     {
///         "public-id": "hTKaaQ",
///         "name": "Test content 1",
///         "user": "hBcd9s",
///         "type": "Timetable"
///     },
///     {
///         "public-id": "4nj_RQ",
///         "name": "Test content 2",
///         "user": "hBcd9s",
///         "type": "Timetable"
///     },
///     {
///         "public-id": "z6bQIQ",
///         "name": "Test content 3",
///         "user": "hBcd9s",
///         "type": "Infoscreen"
///     }
/// ];
/// var diag = Machinata.entityListingDialog("Select entity", "Please select an entity below", entities, {
///     entityIdKey: "public-id", // defines which key should be used as the entity id
///     selectedEntityId: "4nj_RQ", // allows a pre-selection based on the id
///     search: true, // adds a realtime searchbox
///     header: true, // adds a header to the listing
///     properties: [ // defines a custom properties to display (in this case we dont include the user field)
///         {key:"name", title:"Name"},
///         {key:"type", title:"Type"}
///     ]
/// });
/// diag.input(function (entity) {
///     console.log(entity); // this is the object selected
/// });
/// diag.show();
/// ```
/// </example>
Machinata.entityListingDialog = function (title, message, entities, opts) {
    if (opts == null) opts = {};
    if (opts.header == null) opts.header = false;
    if (opts.entityIdKey == null) opts.entityIdKey = "public-id";
    if (opts.returnEntityIds == null) opts.returnEntityIds = false;
    if (opts.multipleSelection == null) opts.multipleSelection = false;
    if (opts.search == null) opts.search = false;
    if (opts.searchOnKeyStroke == null) opts.searchOnKeyStroke = false;
    if (opts.requireSearchForResults == null) opts.requireSearchForResults = false;
    if (opts.allowClear == null) opts.allowClear = false;
    if (opts.apiCallForSearch == null) opts.apiCallForSearch = null;

    // Validate
    if (opts.multipleSelection == true && opts.returnEntityIds == false && opts.apiCallForSearch != null) {
        // The problem here is that we might not have all the data to actually get the entity already, so if the user does nothing
        alert("WARNING: Machinata.entityListingDialog() opts.multipleSelection == true && opts.returnEntityIds == false && opts.apiCallForSearch != null is not supported!");
    }

    // Init initial selection
    var currentlySelectedIds = null;
    var currentlySelectedEntities = null;
    if (opts.selectedEntityId != null && opts.selectedEntityId != "") {
        currentlySelectedIds = opts.selectedEntityId.split(",");
        currentlySelectedEntities = []; //TODO: not really supported on lazy load api call...
    } else {
        currentlySelectedIds = [];
        currentlySelectedEntities = [];
    }
    
    // Setup dialog
    var diag = opts.diag;
    if (diag == null) diag = Machinata.messageDialog(title, message);

    // Create custom input
    var formElem = $("<div class='ui-form'><input type='text' placeholder='Search'/></div>");
    var inputElem = formElem.find("input");

    // Create table
    var tableWrapperElem = $("<div class=''></div>");
    tableWrapperElem.css("width", "100%");
    tableWrapperElem.css("height", "200px");
    tableWrapperElem.css("overflow-y", "auto");
    var tableElem = $("<table class='ui-table'><thead></thead><tbody></tbody></table>");
    tableElem.css("width", "100%");
    tableElem.appendTo(tableWrapperElem);
    var tableHeadElem = tableElem.find("thead");
    var tableBodyElem = tableElem.find("tbody");

    // Helper function for selecting/deselecting an item
    function updateSelectionForRow(rowElem,selected) {
        //currentlySelectedEntities;
        if (selected == true) {
            rowElem.addClass("selected");
            currentlySelectedIds.push(rowElem.data("key"));
            currentlySelectedEntities.push(rowElem.data("entity"));
        } else {
            rowElem.removeClass("selected");
            {
                var index = currentlySelectedIds.indexOf(rowElem.data("key"));
                currentlySelectedIds.splice(index, 1);
            }
            {
                var index = -1;
                for (var i = 0; i < currentlySelectedEntities.length; i++) {
                    if (currentlySelectedEntities[i][opts.entityIdKey] == rowElem.data("key")) index = i;
                }
                if(index != -1) currentlySelectedEntities.splice(index, 1);
            }
        }
        updateSelection();
    }
    function updateSelection() {
        if (opts.returnEntityIds == true) {
            diag.setInputValue(currentlySelectedIds.join(","));
        } else {
            if (opts.multipleSelection == true) {
                diag.setInputValue(currentlySelectedEntities);
            } else {
                diag.setInputValue(currentlySelectedEntities[0]);
            }
        }
        //console.log("currentlySelectedIds", currentlySelectedIds);
        //console.log("currentlySelectedEntities", currentlySelectedEntities);
    }


    // Helper function for building all entities rows
    function rebuildTableRows(entities) {
        // Remove all existing
        tableBodyElem.empty();

        // Auto properties?
        var props = opts.properties;
        if (props == null) {
            props = [];
            if (entities.length > 0) {
                Machinata.Util.each(entities[0], function (key, val) {
                    if (key == opts.entityIdKey) return;
                    props.push({
                        key: key,
                        title: key
                    });
                });
            }
        }

        // Header
        if (opts.header == true) {
            var rowElem = $("<tr></tr>");
            Machinata.Util.each(props, function (index, prop) {
                var columnElem = $("<th></th>");
                columnElem.text(prop.title);
                rowElem.append(columnElem);
            });
            tableHeadElem.empty();
            tableHeadElem.append(rowElem);
        }

        // Add all entity rows
        Machinata.Util.each(entities, function (index, entity) {
            var rowElem = $("<tr class='link'></tr>");
            // Columns
            var keywords = "";
            Machinata.Util.each(props, function (index, prop) {
                var columnElem = $("<td></td>");
                columnElem.text(entity[prop.key]);
                rowElem.append(columnElem);
                var keyword = entity[prop.key];
                if (keyword != null) {
                    keywords += keyword.toString().toLowerCase() + " ";
                }
            });
            rowElem.attr("data-key", entity[opts.entityIdKey]);
            rowElem.data("key", entity[opts.entityIdKey]);
            rowElem.data("entity", entity);
            rowElem.data("keywords", keywords);
            rowElem.click(function () {
                if (opts.multipleSelection == false) {
                    // Unselect all
                    $(this).closest("table").find("tr.selected").removeClass("selected");
                    currentlySelectedIds = [];
                    currentlySelectedEntities = [];
                    // Select this row
                    updateSelectionForRow($(this), true);
                } else {
                    // Just toggle this id
                    if ($(this).hasClass("selected"))   updateSelectionForRow($(this), false);
                    else                                updateSelectionForRow($(this), true);
                }
            });
            if (currentlySelectedIds != null && currentlySelectedIds.length > 0) {
                for (var i = 0; i < currentlySelectedIds.length; i++) {
                    if (currentlySelectedIds[i] == rowElem.data("key")) {
                        rowElem.addClass("selected");
                        currentlySelectedEntities.push(rowElem.data("entity"));
                    }
                }
            }
            if (opts.requireSearchForResults == true) rowElem.hide();
            tableBodyElem.append(rowElem);
        });
        updateNoResultsInfo(entities.length, "List is empty.");
    }



    // No results
    var noResultsElem = $("<div><p></p></div>");
    noResultsElem.css("height", "200px");
    function updateNoResultsInfo(count, text) {
        if (count == 0) {
            tableWrapperElem.hide();
            noResultsElem.find("p").text(text);
            noResultsElem.show();
        } else {
            tableWrapperElem.show();
            noResultsElem.hide();
        }
    }

    // Initial rebuild
    rebuildTableRows(entities);
    updateSelection();
    

    // Search helper function
    function performSearch(search) {
        if (opts.apiCallForSearch != null) {
            performSearchOnServer(search);
        } else {
            performSearchInMemory(search);
        }
    }
    function performSearchOnServer(search) {
        // Do API Call
        var url = opts.apiCallForSearch.replace("{search}", encodeURIComponent(search));
        var call = Machinata.apiCall(url);
        call.success(function (message) {
            var entities = message.data[opts.entitiesKey];
            rebuildTableRows(entities);
        });
        call.genericError();
        call.send();
    }
    function performSearchInMemory(search) {
        Machinata.showLoading(true);
        if (search == null || search == "") {
            tableBodyElem.find("tr").show();
            updateNoResultsInfo(entities.length, "List is empty.");
            Machinata.showLoading(false);
        } else {
            search = search.toLowerCase();
            var searchSegs = search.split(' ');
            var matches = 0;
            tableBodyElem.find("tr").each(function () {
                var rowElem = $(this);
                var allMatch = true;
                var keywords = rowElem.data("keywords");
                for (var i = 0; i < searchSegs.length; i++) {
                    if (keywords.indexOf(searchSegs[i]) == -1) {
                        allMatch = false;
                        break;
                    }
                }
                if (allMatch == true) { rowElem.show(); matches++ }
                else rowElem.hide();
            });
            updateNoResultsInfo(matches, "Search has no results.");
            Machinata.showLoading(false);
        }
    }

    // Bind interaction
    if (opts.search == true) {
        inputElem.on("keyup", function (event) {
            if (event.keyCode == 13) {
                performSearch(inputElem.val())
            }
        });
    }
    if (opts.search == true && opts.searchOnKeyStroke == true) {
        inputElem.on("input", function (event) {
            performSearch(inputElem.val())
        });
    }

    // Finalize diag
    diag.elem.append(formElem);
    diag.elem.append(tableWrapperElem);
    diag.elem.append(noResultsElem);
    diag.cancelButton("Cancel");
    if(opts.allowClear == true) diag.button("Clear", "clear");
    diag.button("Okay");
    diag.show();

    return diag;
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-notebook.js */
/* File: js/machinata-core-bundle.js/machinata-core-notebook.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// Machinata Notebook by Dan Krusi
/// Based on jQuery Notebook 0.5
/// 
/// Copyright (c) 2014
/// Raphael Cruzeiro - http://raphaelcruzeiro.eu/
/// Otávio Soares
/// 
/// Released under the MIT License
/// http://opensource.org/licenses/MIT
/// 
/// Some functions of this plugin were based on Jacob Kelley's Medium.js
/// https://github.com/jakiestfu/Medium.js/
/// 
/// </summary>
/// <hidden/>
(function ($, d, w) {

    /*
     * This module deals with the CSS transforms. As it is not possible to easily
     * combine the transform functions with JavaScript this module abstract those
     * functions and generates a raw transform matrix, combining the new transform
     * with the others that were previously applied to the element.
     */

    var transform = (function () {
        var matrixToArray = function (str) {
            if (!str || str == 'none') {
                return [1, 0, 0, 1, 0, 0];
            }
            return str.match(/(-?[0-9\.]+)/g);
        };

        var getPreviousTransforms = function (elem) {
            return elem.css('-webkit-transform') || elem.css('transform') || elem.css('-moz-transform') ||
                elem.css('-o-transform') || elem.css('-ms-transform');
        };

        var getMatrix = function (elem) {
            var previousTransform = getPreviousTransforms(elem);
            return matrixToArray(previousTransform);
        };

        var applyTransform = function (elem, transform) {
            elem.css('-webkit-transform', transform);
            elem.css('-moz-transform', transform);
            elem.css('-o-transform', transform);
            elem.css('-ms-transform', transform);
            elem.css('transform', transform);
        };

        var buildTransformString = function (matrix) {
            return 'matrix(' + matrix[0] +
                ', ' + matrix[1] +
                ', ' + matrix[2] +
                ', ' + matrix[3] +
                ', ' + matrix[4] +
                ', ' + matrix[5] + ')';
        };

        var getTranslate = function (elem) {
            var matrix = getMatrix(elem);
            return {
                x: parseInt(matrix[4]),
                y: parseInt(matrix[5])
            };
        };

        var scale = function (elem, _scale) {
            var matrix = getMatrix(elem);
            matrix[0] = matrix[3] = _scale;
            var transform = buildTransformString(matrix);
            applyTransform(elem, transform);
        };

        var translate = function (elem, x, y) {
            var matrix = getMatrix(elem);
            matrix[4] = Math.round(x);
            matrix[5] = Math.round(y);
            var transform = buildTransformString(matrix);
            applyTransform(elem, transform);
        };

        var rotate = function (elem, deg) {
            var matrix = getMatrix(elem);
            var rad1 = deg * (Math.PI / 180);
            var rad2 = rad1 * -1;
            matrix[1] = rad1;
            matrix[2] = rad2;
            var transform = buildTransformString(matrix);
            applyTransform(elem, transform);
        };

        return {
            scale: scale,
            translate: translate,
            rotate: rotate,
            getTranslate: getTranslate
        };
    })();

    var isMac = w.navigator.platform == 'MacIntel',
        mouseX = 0,
        mouseY = 0,
        cache = {
            command: false,
            shift: false,
            isSelecting: false
        },
        modifiers = {
            66: 'bold',
            73: 'italic',
            85: 'underline',
            112: 'h1',
            113: 'h2',
            122: 'undo'
        },
        options,
        utils = {
            keyboard: {
                isCommand: function (e, callbackTrue, callbackFalse) {
                    if (isMac && e.metaKey || !isMac && e.ctrlKey) {
                        callbackTrue();
                    } else {
                        callbackFalse();
                    }
                },
                isShift: function (e, callbackTrue, callbackFalse) {
                    if (e.shiftKey) {
                        callbackTrue();
                    } else {
                        callbackFalse();
                    }
                },
                isModifier: function (e, callback) {
                    var key = e.which,
                        cmd = modifiers[key];
                    if (cmd) {
                        callback.call(this, cmd);
                    }
                },
                isEnter: function (e, callback) {
                    if (e.which === 13) {
                        callback();
                    }
                },
                isArrow: function (e, callback) {
                    if (e.which >= 37 || e.which <= 40) {
                        callback();
                    }
                }
            },
            html: {
                addTag: function (elem, tag, focus, editable) {
                    var newElement = $(d.createElement(tag));
                    if(editable==false)newElement.attr('contenteditable', Boolean(editable));
                    newElement.append(' ');
                    elem.append(newElement);
                    if (focus) {
                        cache.focusedElement = elem.children().last();
                        utils.cursor.set(elem, 0, cache.focusedElement);
                    }
                    return newElement;
                }
            },
            cursor: {
                set: function (editor, pos, elem) {
                    var range;
                    if (d.createRange) {
                        range = d.createRange();
                        var selection = w.getSelection(),
                            lastChild = editor.children().last(),
                            length = lastChild.html().length - 1,
                            toModify = elem ? elem[0] : lastChild[0],
                            theLength = typeof pos !== 'undefined' ? pos : length;
                        range.setStart(toModify, theLength);
                        range.collapse(true);
                        selection.removeAllRanges();
                        selection.addRange(range);
                    } else {
                        range = d.body.createTextRange();
                        range.moveToElementText(elem);
                        range.collapse(false);
                        range.select();
                    }
                }
            },
            selection: {
                save: function () {
                    if (w.getSelection) {
                        var sel = w.getSelection();
                        if (sel.rangeCount > 0) {
                            return sel.getRangeAt(0);
                        }
                    } else if (d.selection && d.selection.createRange) { // IE
                        return d.selection.createRange();
                    }
                    return null;
                },
                restore: function (range) {
                    if (range) {
                        if (w.getSelection) {
                            var sel = w.getSelection();
                            sel.removeAllRanges();
                            sel.addRange(range);
                        } else if (d.selection && range.select) { // IE
                            range.select();
                        }
                    }
                },
                getText: function () {
                    var txt = '';
                    if (w.getSelection) {
                        txt = w.getSelection().toString();
                    } else if (d.getSelection) {
                        txt = d.getSelection().toString();
                    } else if (d.selection) {
                        txt = d.selection.createRange().text;
                    }
                    return txt;
                },
                clear: function () {
                    if (window.getSelection) {
                        if (window.getSelection().empty) { // Chrome
                            window.getSelection().empty();
                        } else if (window.getSelection().removeAllRanges) { // Firefox
                            window.getSelection().removeAllRanges();
                        }
                    } else if (document.selection) { // IE?
                        document.selection.empty();
                    }
                },
                getContainer: function (sel) {
                    if (w.getSelection && sel && sel.commonAncestorContainer) {
                        return sel.commonAncestorContainer;
                    } else if (d.selection && sel && sel.parentElement) {
                        return sel.parentElement();
                    }
                    return null;
                },
                getSelection: function () {
                    if (w.getSelection) {
                        return w.getSelection();
                    } else if (d.selection && d.selection.createRange) { // IE
                        return d.selection;
                    }
                    return null;
                }
            },
            validation: {
                isUrl: function (url) {
                    return (/^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/).test(url);
                }
            }
        },
        bubble = {
            /*
             * This is called to position the bubble above the selection.
             */
            updatePos: function (editor, elem) {
                var sel = w.getSelection(),
                    range = sel.getRangeAt(0),
                    boundary = range.getBoundingClientRect(),
                    bubbleWidth = elem.width(),
                    bubbleHeight = elem.height(),
                    offset = editor.offset(),
                    position = editor.position();
                var boundary = {
                    left: boundary.left - offset.left,
                    //top: boundary.top - offset.top + $(document).scrollTop(),
                    top: boundary.top - offset.top + $(document).scrollTop(),
                    width: boundary.width,
                    height: boundary.height,
                };
                var pos = {
                    x: (boundary.left + boundary.width / 2) - (bubbleWidth / 2) + position.left,
                    y: boundary.top - bubbleHeight - 20
                };
                console.log(offset,position,boundary,pos);
                transform.translate(elem, pos.x, pos.y);
            },
            /*
             * Updates the bubble to set the active formats for the current selection.
             */
            updateState: function (editor, elem) {
                elem.find('button').removeClass('active');
                var sel = w.getSelection(),
                    formats = [];
                bubble.checkForFormatting(sel.focusNode, formats);
                var formatDict = {
                    'b': 'bold',
                    'i': 'italic',
                    'u': 'underline',
                    'h1': 'h1',
                    'h2': 'h2',
                    'p': 'p',
                    'a': 'anchor',
                    'img': 'image',
                    'strike': 'strike',
                    'ul': 'ul',
                    'ol': 'ol'
                };
                for (var i = 0; i < formats.length; i++) {
                    var format = formats[i];
                    elem.find('button.cmd-' + formatDict[format]).addClass('active');
                }
            },
            /*
             * Recursively navigates upwards in the DOM to find all the format
             * tags enclosing the selection.
             */
            checkForFormatting: function (currentNode, formats) {
                //Machinata.debug("checkForFormatting: " + currentNode.nodeName);
                //Machinata.debug("  html: " + $(currentNode).html());
                var validFormats = ['b', 'i', 'u', 'h1', 'h2', 'ol', 'ul', 'li', 'a', 'img', 'strike', 'p'];
                if (currentNode.nodeName === '#text' ||
                    validFormats.indexOf(currentNode.nodeName.toLowerCase()) != -1) {
                    if (currentNode.nodeName != '#text') {
                        formats.push(currentNode.nodeName.toLowerCase());
                    }
                    //Machinata.debug("  will recurse");
                    bubble.checkForFormatting(currentNode.parentNode, formats);
                } else {
                    // Special handling for some cases where the selction contains just a single sub child
                    // For example, when double-clicking a link on a single line
                    if ($(currentNode).children().length == 1) {
                        if ($(currentNode).children().first().prop("tagName") == "A") {
                            formats.push("a");
                        }
                    }
                }
            },
            getIcon: function (cmd) {
                //Machinata.debug("notebook: getIcon " + cmd);
                for (var i = 0; i < options.icons.length; i++) {
                    //Machinata.debug("icon " + options.icons[i].cmd);
                    if (options.icons[i].cmd == cmd) {
                        return options.icons[i];
                    }
                }
                return {"text":cmd}; // Fallback
            },
            buildMenu: function (editor, elem) {
                // Create main elems
                var helper = utils.html.addTag(elem, 'div', false, false);
                helper.addClass("helper-text");
                helper.text(options.title);
                var ul = utils.html.addTag(elem, 'ul', false, false);
                // Create all buttons
                for (var cmdi in options.modifiers) {
                    var cmd = options.modifiers[cmdi];
                    // Setup button elem
                    var li = utils.html.addTag(ul, 'li', false, false);
                    var btn = utils.html.addTag(li, 'button', false, false);
                    btn.attr('editor-command', cmd);
                    btn.addClass("cmd-" + cmd);
                    // Setup button icon
                    var icon = bubble.getIcon(cmd);
                    if (icon.text != null) {
                        btn.text(icon.text);
                    } else {
                        btn.addClass("icon");
                        btn.addClass("icon-" + icon.icon);
                        if (icon.icon == "link") {
                            btn.append("<svg class='icon icon-link'><use xlink:href='/static/bundle/svg/uikit-icons8win10-bundle.svg?profile=digital&lang=en&theme=uikit&build=941a6590-3a33-4a37-97eb-662c9cabda58#link'></use></svg>");
                        } else if (icon.icon == "image") {
                            btn.append("<svg class='icon icon-picture'><use xlink:href='/static/bundle/svg/uikit-icons8win10-bundle.svg?profile=digital&lang=en&theme=uikit&build=941a6590-3a33-4a37-97eb-662c9cabda58#picture'></use></svg>");
                        } else if (icon.icon == "document") {
                            btn.append("<svg class='icon icon-document'><use xlink:href='/static/bundle/svg/uikit-icons8win10-bundle.svg?profile=digital&lang=en&theme=uikit&build=941a6590-3a33-4a37-97eb-662c9cabda58#document'></use></svg>");
                        } else if (icon.icon == "clipboard") {
                            btn.append("<svg class='icon icon-scroll'><use xlink:href='/static/bundle/svg/uikit-icons8win10-bundle.svg?profile=digital&lang=en&theme=uikit&build=941a6590-3a33-4a37-97eb-662c9cabda58#scroll'></use></svg>");
                        } else if (icon.icon == "th-list") {
                            btn.append("<svg class='icon icon-numbered-list'><use xlink:href='/static/bundle/svg/uikit-icons8win10-bundle.svg?profile=digital&lang=en&theme=uikit&build=941a6590-3a33-4a37-97eb-662c9cabda58#numbered-list'></use></svg>");
                        } else if (icon.icon == "th-menu") {
                            btn.append("<svg class='icon icon-list'><use xlink:href='/static/bundle/svg/uikit-icons8win10-bundle.svg?profile=digital&lang=en&theme=uikit&build=941a6590-3a33-4a37-97eb-662c9cabda58#list'></use></svg>");
                        }
                    }
                    if (icon.helper != null) btn.attr("helper-text", icon.helper);
                    if (icon.style != null) btn.attr("style", icon.style);
                }
                elem.find('button').click(function (e) {
                    e.preventDefault();
                    var cmd = $(this).attr('editor-command');
                    events.commands[cmd].call(editor, e);
                });
                elem.find('button[helper-text]').hover(function () {
                    helper.text($(this).attr("helper-text"));
                }, function () {
                    helper.text(options.title);
                });
                var linkArea = utils.html.addTag(elem, 'div', false, false);
                linkArea.addClass('link-area');
                var linkInput = utils.html.addTag(linkArea, 'input', false, false);
                linkInput.attr({
                    type: 'text'
                });
                var closeBtn = utils.html.addTag(linkArea, 'button', false, false);
                closeBtn.click(function (e) {
                    e.preventDefault();
                    var editor = $(this).closest('.editor');
                    $(this).closest('.link-area').hide();
                    $(this).closest('.bubble').find('ul').show();
                });
            },
            show: function () {
                var tag = $(this).parent().find('.bubble');
                if (!tag.length) {
                    tag = utils.html.addTag($(this).parent(), 'div', false, false);
                    tag.addClass('jquery-notebook bubble');
                }
                tag.empty();
                bubble.buildMenu(this, tag);
                tag.show();
                bubble.updateState(this, tag);
                if (!tag.hasClass('active')) {
                    tag.addClass('jump');
                } else {
                    tag.removeClass('jump');
                }
                bubble.updatePos($(this), tag);
                tag.addClass('active');
            },
            update: function () {
                var tag = $(this).parent().find('.bubble');
                bubble.updateState(this, tag);
            },
            clear: function () {
                var elem = $(this).parent().find('.bubble');
                if (!elem.hasClass('active')) return;
                elem.removeClass('active');
                bubble.hideLinkInput.call(this);
                bubble.showButtons.call(this);
                setTimeout(function () {
                    if (elem.hasClass('active')) return;
                    elem.hide();
                }, 500);
            },
            hideButtons: function () {
                $(this).parent().find('.bubble').find('ul').hide();
            },
            showButtons: function () {
                $(this).parent().find('.bubble').find('ul').show();
            },
            showLinkInput: function (selection) {
                // Init
                var editor = this;
                var currentLink = null;
                // Get the selection anchor element
                var anchor = $(utils.selection.getContainer(selection)).closest('a');
                // Special handling if selection is wrapping the entire link and its single parent (for example: <p><a.../></p>)
                if (anchor.length == 0) {
                    var sel = utils.selection.getSelection(selection);
                    var selNode = $(sel.focusNode);
                    if (selNode.children().length == 1) {
                        if (selNode.children().first().prop("tagName") == "A") {
                            anchor = selNode.children().first();
                        }
                    }
                }
                if (anchor.length > 0) {
                    currentLink = anchor.attr('href');
                }
                Machinata.linkDialog(null, null, currentLink)
                    .button("Remove", "remove")
                    .input(function (val, id) {
                        Machinata.debug("notebook: got link input '" + val + "' for id " + id);
                        if (id == "remove") {
                            // Remove
                            var e = {};
                            events.commands.removeLink(e, selection);
                            bubble.update.call(editor);
                            events.change.call(editor);
                        } else if(val != null) {
                            // Create
                            var e = {};
                            e.url = val;
                            events.commands.createLink(e, selection);
                            bubble.update.call(editor);
                            events.change.call(editor);
                        }
                    })
                    .cancel(function (id) {  })
                    .show();
                // Hide the bubble
                bubble.clear.call(editor);
                /*
                bubble.hideButtons.call(this);
                var editor = this;
                var elem = $(this).parent().find('.bubble').find('input[type=text]');
                var hasLink = elem.closest('.jquery-notebook').find('button.anchor').hasClass('active');
                elem.unbind('keydown');
                elem.keydown(function (e) {
                    var elem = $(this);
                    utils.keyboard.isEnter(e, function () {
                        e.preventDefault();
                        var url = elem.val();
                        if (utils.validation.isUrl(url)) {
                            e.url = url;
                            events.commands.createLink(e, selection);
                            bubble.clear.call(editor);
                        } else if (url === '' && hasLink) {
                            events.commands.removeLink(e, selection);
                            bubble.clear.call(editor);
                        }
                    });
                });
                elem.bind('paste', function (e) {
                    var elem = $(this);
                    setTimeout(function () {
                        var text = elem.val();
                        if (/http:\/\/https?:\/\//.test(text)) {
                            text = text.substring(7);
                            elem.val(text);
                        }
                    }, 1);
                });
                var linkText = 'http://';
                if (hasLink) {
                    var anchor = $(utils.selection.getContainer(selection)).closest('a');
                    linkText = anchor.prop('href') || linkText;
                }
                $(this).parent().find('.link-area').show();
                elem.val(linkText).focus();
                */
            },
            hideLinkInput: function () {
                $(this).parent().find('.bubble').find('.link-area').hide();
            },
            showImageInput: function (selection) {
                // Init
                var editor = this;
                var currentImage = null;
                // Get the selection anchor element
                /*var img = $(utils.selection.getContainer(selection)).closest('img');
                // Special handling if selection is wrapping the entire link and its single parent (for example: <p><a.../></p>)
                if (img.length == 0) {
                    var sel = utils.selection.getSelection(selection);
                    var selNode = $(sel.focusNode);
                    if (selNode.children().length == 1) {
                        if (selNode.children().first().prop("tagName") == "IMG") {
                            img = selNode.children().first();
                        }
                    }
                }
                if (img.length > 0) {
                    currentImage = img.prop('src');
                }*/
                var source = $(editor).attr("data-content-source");
                if (source == null || source == "") source = "ContentNode"; // fallback
                Machinata.fileDialog("Choose a Image", source, "image") 
                    //.button("Remove", "remove")
                    .okay(function (val, btn, id) {
                        Machinata.debug("notebook: got image input '" + val + "' for id " + id);
                        if (val == "remove") {
                            // Remove
                            var e = {};
                            events.commands.removeImage(e, selection);
                            bubble.update.call(editor);
                            events.change.call(editor);
                        } else if(val != null) {
                            // Create
                            var e = {};
                            e.url = val;
                            events.commands.insertImage(e, selection);
                            bubble.update.call(editor);
                            events.change.call(editor);
                        }
                    })
                    .show();
                // Hide the bubble
                bubble.clear.call(editor);
            }
        },
        actions = {
            bindEvents: function (elem) {
                elem.keydown(rawEvents.keydown);
                elem.keyup(rawEvents.keyup);
                elem.focus(rawEvents.focus);
                elem.bind('paste', events.paste);
                elem.mousedown(rawEvents.mouseClick);
                elem.mouseup(rawEvents.mouseUp);
                elem.mousemove(rawEvents.mouseMove);
                elem.blur(rawEvents.blur);
                $('body').mouseup(function (e) {
                    if (e.target == e.currentTarget && cache.isSelecting) {
                        rawEvents.mouseUp.call(elem, e);
                    }
                });
            },
            setPlaceholder: function (e) {
                var placeholderText = $(this).attr('editor-placeholder');
                if (placeholderText == "" || placeholderText == null) return;
                if (/^\s*$/.test($(this).text())) {
                    $(this).empty();
                    var placeholder = utils.html.addTag($(this), 'p').addClass('placeholder');
                    placeholder.append(placeholderText);
                    utils.html.addTag($(this), 'p', typeof e.focus != 'undefined' ? e.focus : false, true);
                } else {
                    $(this).find('.placeholder').remove();
                }
            },
            enableObjectResizing: function (e) {
                d.execCommand('enableObjectResizing', false, true);
            },
            disableObjectResizing: function (e) {
                d.execCommand('enableObjectResizing', false, false);
            },
            setInitialP: function (e) {
                var p = utils.html.addTag($(this), 'p', typeof e.focus != 'undefined' ? e.focus : false, true);
                p.html("&nbsp;");
            },
            setDefaultP: function (e) {
                d.execCommand("DefaultParagraphSeparator", false, "p");
            },
            removePlaceholder: function (e) {
                var placeholderText = $(this).attr('editor-placeholder');
                if (placeholderText == "" || placeholderText == null) return;
                $(this).find('.placeholder').remove();
            },
            preserveElementFocus: function () {
                var anchorNode = w.getSelection() ? w.getSelection().anchorNode : d.activeElement;
                if (anchorNode) {
                    var current = anchorNode.parentNode,
                        diff = current !== cache.focusedElement,
                        children = this.children,
                        elementIndex = 0;
                    if (current === this) {
                        current = anchorNode;
                    }
                    for (var i = 0; i < children.length; i++) {
                        if (current === children[i]) {
                            elementIndex = i;
                            break;
                        }
                    }
                    if (diff) {
                        cache.focusedElement = current;
                        cache.focusedElementIndex = elementIndex;
                    }
                }
            },
            setContentArea: function (elem) {
                var id = $('body').find('.jquery-notebook.editor').length + 1;
                elem.attr('data-jquery-notebook-id', id);
                var body = $('body');
                var contentArea = $('<textarea class="jquery-notebook-content"></textarea>');
                contentArea.css({
                    position: 'absolute',
                    left: -1000
                });
                contentArea.val(elem.html());
                contentArea.attr('id', 'jquery-notebook-content-' + id);
                body.append(contentArea);
            },
            prepare: function (elem, customOptions) {
                options = customOptions;
                actions.setContentArea(elem);
                elem.attr('editor-mode', options.mode);
                elem.attr('editor-placeholder', options.placeholder);
                elem.attr('contenteditable', true);
                elem.css('position', 'relative');
                elem.addClass('jquery-notebook editor');
                if (elem.html() == "") actions.setInitialP.call(elem, {});
                actions.setDefaultP.call(elem, {});
                actions.setPlaceholder.call(elem, {});
                actions.preserveElementFocus.call(elem);
                actions.disableObjectResizing.call(elem);
                if (options.autoFocus === true) {
                    var firstP = elem.find('p:not(.placeholder)');
                    utils.cursor.set(elem, 0, firstP);
                }
            }
        },
        rawEvents = {
            keydown: function (e) {
                var elem = this;
                if (cache.command && e.which === 65) {
                    setTimeout(function () {
                        bubble.show.call(elem);
                    }, 50);
                }
                utils.keyboard.isCommand(e, function () {
                    cache.command = true;
                }, function () {
                    cache.command = false;
                });
                utils.keyboard.isShift(e, function () {
                    cache.shift = true;
                }, function () {
                    cache.shift = false;
                });
                utils.keyboard.isModifier.call(this, e, function (modifier) {
                    if (cache.command) {
                        events.commands[modifier].call(this, e);
                    }
                });

                if (cache.shift) {
                    utils.keyboard.isArrow.call(this, e, function () {
                        setTimeout(function () {
                            var txt = utils.selection.getText();
                            if (txt !== '') {
                                bubble.show.call(elem);
                            } else {
                                bubble.clear.call(elem);
                            }
                        }, 100);
                    });
                } else {
                    utils.keyboard.isArrow.call(this, e, function () {
                        bubble.clear.call(elem);
                    });
                }

                if (e.which === 13) {
                    events.enterKey.call(this, e);
                }
                if (e.which === 27) {
                    bubble.clear.call(this);
                }
                if (e.which === 86 && cache.command) {
                    //events.paste.call(this, e);
                }
                if (e.which === 90 && cache.command) {
                    events.commands.undo.call(this, e);
                }
            },
            keyup: function (e) {
                utils.keyboard.isCommand(e, function () {
                    cache.command = false;
                }, function () {
                    cache.command = true;
                });
                actions.preserveElementFocus.call(this);
                actions.removePlaceholder.call(this);

                /*
                 * This breaks the undo when the whole text is deleted but so far
                 * it is the only way that I fould to solve the more serious bug
                 * that the editor was losing the p elements after deleting the whole text
                 */
                //console.log($(this).html());
                //if ($(this).html() == "" || $(this).html() == "<br>") {
                //    utils.html.addTag($(this), 'p', true, true);
                //}
                //if (/^\s*$/.test($(this).text())) {
                //    $(this).empty();
                //    utils.html.addTag($(this), 'p', true, true);
                //}
                events.change.call(this);
            },
            focus: function (e) {
                cache.command = false;
                cache.shift = false;
            },
            mouseClick: function (e) {
                var elem = this;
                cache.isSelecting = true;
                if ($(this).parent().find('.bubble:visible').length) {
                    var bubbleTag = $(this).parent().find('.bubble:visible'),
                        bubbleX = bubbleTag.offset().left,
                        bubbleY = bubbleTag.offset().top,
                        bubbleWidth = bubbleTag.width(),
                        bubbleHeight = bubbleTag.height();
                    if (mouseX > bubbleX && mouseX < bubbleX + bubbleWidth &&
                        mouseY > bubbleY && mouseY < bubbleY + bubbleHeight) {
                        return;
                    }
                }
            },
            mouseUp: function (e) {
                var elem = this;
                cache.isSelecting = false;
                setTimeout(function () {
                    var s = utils.selection.save();
                    if (s) {
                        if (s.collapsed) {
                            bubble.clear.call(elem);
                        } else {
                            bubble.show.call(elem);
                            e.preventDefault();
                        }
                    }
                }, 50);
            },
            mouseMove: function (e) {
                mouseX = e.pageX;
                mouseY = e.pageY;
            },
            blur: function (e) {
                actions.setPlaceholder.call(this, {
                    focus: false
                });
            }
        },
        events = {
            // For execCommand see https://developer.mozilla.org/en-US/docs/Web/API/Document/execCommand
            commands: {
                bold: function (e) {
                    e.preventDefault();
                    d.execCommand('bold', false);
                    bubble.update.call(this);
                    events.change.call(this);
                },
                italic: function (e) {
                    e.preventDefault();
                    d.execCommand('italic', false);
                    bubble.update.call(this);
                    events.change.call(this);
                },
                underline: function (e) {
                    e.preventDefault();
                    d.execCommand('underline', false);
                    bubble.update.call(this);
                    events.change.call(this);
                },
                strike: function (e) {
                    e.preventDefault();
                    d.execCommand('strikeThrough', false);
                    bubble.update.call(this);
                    events.change.call(this);
                },
                anchor: function (e) {
                    e.preventDefault();
                    var s = utils.selection.save();
                    bubble.showLinkInput.call(this, s);
                    //events.change.call(this);
                },
                createLink: function (e, s) {
                    Machinata.debug("notebook: creating link '" + e.url + "' for " + s);
                    utils.selection.restore(s);
                    d.execCommand('createLink', false, e.url);
                },
                removeLink: function (e, s) {
                    var el = $(utils.selection.getContainer(s)).closest('a');
                    el.contents().first().unwrap();
                },
                image: function (e) {
                    e.preventDefault();
                    var s = utils.selection.save();
                    bubble.showImageInput.call(this, s);
                },
                insertImage: function (e, s) {
                    Machinata.debug("notebook: creating image '" + e.url + "' for " + s);
                    utils.selection.restore(s);
                    d.execCommand('insertImage', false, e.url);
                },
                removeImage: function (e, s) {
                    var el = $(utils.selection.getContainer(s)).closest('img');
                    el.contents().first().unwrap();
                },
                h1: function (e) {
                    e.preventDefault();
                    if ($(window.getSelection().anchorNode.parentNode).is('h1')) {
                        d.execCommand('formatBlock', false, '<p>');
                    } else {
                        d.execCommand('removeFormat', false);
                        d.execCommand('formatBlock', false, '<h1>');
                    }
                    bubble.update.call(this);
                    events.change.call(this);
                },
                h2: function (e) {
                    e.preventDefault();
                    if ($(window.getSelection().anchorNode.parentNode).is('h2')) {
                        d.execCommand('formatBlock', false, '<p>');
                    } else {
                        d.execCommand('removeFormat', false);
                        d.execCommand('formatBlock', false, '<h2>');
                    }
                    bubble.update.call(this);
                    events.change.call(this);
                },
                p: function (e) {
                    e.preventDefault();
                    if ($(window.getSelection().anchorNode.parentNode).is('p')) {
                        d.execCommand('removeFormat', false);
                    } else {
                        d.execCommand('removeFormat', false);
                        d.execCommand('formatBlock', false, '<p>');
                    }
                    bubble.update.call(this);
                    events.change.call(this);
                },
                ipsum: function (e) {
                    e.preventDefault();
                    var dummyText = [];
                    dummyText.push("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam imperdiet ultricies molestie. Sed at urna quis ligula pretium dignissim. Maecenas ipsum diam, bibendum ut scelerisque eu, ornare vel augue. Duis at sem vitae nunc tempus vehicula quis at enim. Aliquam pharetra lectus sit amet magna lobortis egestas. Nunc consequat feugiat ornare. Aliquam et risus augue.");
                    dummyText.push("Lorem ipsum nam sit amet lacinia turpis. Quisque aliquet, elit sit amet maximus feugiat, orci justo ullamcorper justo, eu dapibus ligula sapien quis libero. Duis massa ex, sollicitudin id commodo sit amet, consectetur id lacus. Vivamus rutrum maximus nunc, ac vulputate felis vehicula in. Suspendisse blandit eu elit at dapibus. Mauris sem dui, efficitur eu velit vel, pulvinar hendrerit sapien. Sed volutpat leo vitae neque bibendum tempus non eget mi. Mauris scelerisque imperdiet odio eget elementum. Interdum et malesuada fames ac ante ipsum primis in faucibus. Sed tristique iaculis mi, non pharetra lacus sodales a.");
                    dummyText.push("Lorem ipsum maecenas malesuada, massa sed fermentum accumsan, mi lacus tempus eros, nec ullamcorper erat est nec nibh. Nam sagittis, augue at ullamcorper dignissim, purus urna maximus quam, nec gravida ante mi non velit. Curabitur tincidunt odio arcu, eget aliquam est finibus in. Sed nec nulla eget metus tempus lobortis quis sit amet diam. In faucibus, nibh non mollis interdum, massa ipsum pretium diam, non aliquet risus sem sed risus. Quisque et metus a quam mattis tincidunt. Aliquam scelerisque nisi sit amet ipsum consectetur, eget varius magna venenatis. Quisque hendrerit scelerisque lorem ut efficitur.");
                    dummyText.push("Lorem ipsum nulla vulputate, tellus nec semper aliquam, purus ligula fermentum magna, eu viverra massa diam imperdiet tellus. Aliquam erat volutpat. Phasellus eu porta mauris, at malesuada metus. Mauris finibus enim nisl. Praesent faucibus vestibulum metus ac ullamcorper. Suspendisse vel finibus neque. Curabitur turpis elit, sollicitudin eu tortor non, euismod ultrices sem. Vestibulum elementum erat vitae egestas malesuada. Curabitur et placerat magna, a sollicitudin tortor.");
                    dummyText.push("Lorem ipsum vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Suspendisse a ligula eu nisl vehicula vestibulum. ");
                    dummyText.push("Lorem ipsum maecenas consectetur, massa sit amet pellentesque egestas, augue lectus suscipit dolor, at placerat ipsum ligula vel dui. Quisque eget molestie dolor. ");
                    dummyText.push("Lorem ipsum cras vitae feugiat orci. Praesent in pretium purus. Nullam ullamcorper est eget placerat semper. Morbi condimentum laoreet tempus. ");
                    var text = dummyText[Machinata.Math.rnd(0, dummyText.length)];
                    d.execCommand('insertText', false, text);
                    bubble.update.call(this);
                    events.change.call(this);
                },
                ul: function (e) {
                    e.preventDefault();
                    d.execCommand('insertUnorderedList', false);
                    bubble.update.call(this);
                    events.change.call(this);
                },
                ol: function (e) {
                    e.preventDefault();
                    d.execCommand('insertOrderedList', false);
                    bubble.update.call(this);
                    events.change.call(this);
                },
                undo: function (e) {
                    e.preventDefault();
                    d.execCommand('undo', false);
                    var sel = w.getSelection(),
                        range = sel.getRangeAt(0),
                        boundary = range.getBoundingClientRect();
                    $(document).scrollTop($(document).scrollTop() + boundary.top);
                    events.change.call(this);
                }
            },
            enterKey: function (e) {
                return; //dankrusi: the default browser behaviour seems to be much more reliable

                if ($(this).attr('editor-mode') === 'inline') {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }

                var sel = utils.selection.getSelection();
                var elem = $(sel.focusNode.parentElement);
                var nextElem = elem.next();
                if (!nextElem.length && elem.prop('tagName') != 'LI') {
                    var tagName = elem.prop('tagName');
                    if (tagName === 'OL' || tagName === 'UL') {
                        var lastLi = elem.children().last();
                        if (lastLi.length && lastLi.text() === '') {
                            lastLi.remove();
                        }
                    }
                    utils.html.addTag($(this), 'p', true, true);
                    e.preventDefault();
                    e.stopPropagation();
                }
                events.change.call(this);
            },
            paste: function (e) {

                // Which mode?
                // Can be "notebook", "rich", "plain"
                var pasteMode = "plain"; 

                if (pasteMode == "plain") {

                    // Plain-text mode

                    //TODO: @dan Do we need to make sure to wrap the content in a p?

                    // Get text representation of clipboard
                    // https://stackoverflow.com/questions/12027137/javascript-trick-for-paste-as-plain-text-in-execcommand
                    e.preventDefault();
                    var text = '';
                    if (e.clipboardData || e.originalEvent.clipboardData) {
                        text = (e.originalEvent || e).clipboardData.getData('text/plain');
                    } else if (window.clipboardData) {
                        text = window.clipboardData.getData('Text');
                    } else {
                        console.log("warning: could not get clipboard data");
                    }
                    if (d.queryCommandSupported('insertText')) {
                        d.execCommand('insertText', false, text);
                    } else {
                        d.execCommand('paste', false, text);
                    }
                    events.change.call(this);

                } else if (pasteMode == "rich") {

                    // Rich mode
                    d.execCommand('paste');

                } else if (pasteMode == "notebook") {
                    
                    // notebook mode
                    // Note: very buggy

                    var elem = $(this),
                        id = 'jqeditor-temparea',
                        range = utils.selection.save(),
                        tempArea = $('#' + id);
                    if (tempArea.length < 1) {
                        var body = $('body');
                        tempArea = $('<textarea></textarea>');
                        tempArea.css({
                            position: 'absolute',
                            left: -1000
                        });
                        tempArea.attr('id', id);
                        body.append(tempArea);
                    }
                    tempArea.focus();

                    setTimeout(function () {
                        var clipboardContent = '',
                            paragraphs = tempArea.val().split('\n');
                        for (var i = 0; i < paragraphs.length; i++) {
                            clipboardContent += ['<p>', paragraphs[i], '</p>'].join('');
                        }
                        tempArea.val('');
                        utils.selection.restore(range);
                        d.execCommand('delete');
                        d.execCommand('insertHTML', false, clipboardContent);
                        events.change.call(this);
                    }, 500);
                }
            },
            change: function (e) {
                Machinata.debug("Notebook: change");
                var contentArea = $('#jquery-notebook-content-' + $(this).attr('data-jquery-notebook-id'));
                if(contentArea.length < 1) Machinata.debug("Notebook: warning change has not content area");
                contentArea.val($(this).html());
                var content = contentArea.val();
                var changeEvent = new CustomEvent('contentChange', { 'detail': { 'content': content } });
                this.dispatchEvent(changeEvent);
            }
        };

    $.fn.notebook = function (options) {
        options = $.extend({}, $.fn.notebook.defaults, options);
        actions.prepare(this, options);
        actions.bindEvents(this);
        return this;
    };

    $.fn.notebook.defaults = {
        autoFocus: false,
        placeholder: 'Insert content here...',
        title: 'Formatting',
        mode: 'multiline',
        modifiers: ['h1', 'h2', 'p', 'sep', 'bold', 'italic', 'underline', 'strike', 'sep', 'anchor', 'image', 'file', 'ipsum', 'ol', 'ul'], //dankrusi: removed table
        icons: [
            { cmd: 'sep', icon: null, text: '|', helper: null, style: null },
            { cmd: 'bold', icon: null, text: 'b', helper: 'Bold', style: 'font-weight:bold;' },
            { cmd: 'italic', icon: null, text: 'i', helper: 'Italic', style: 'font-style:italic;font-weight:bold;' },
            { cmd: 'underline', icon: null, text: 'u', helper: 'Underline', style: 'text-decoration:underline;font-weight:bold;' },
            { cmd: 'strike', icon: null, text: 's', helper: 'Strikethrough', style: 'text-decoration:line-through;font-weight:bold;' },
            { cmd: 'p', icon: null, text: "p", helper: 'Paragraph', style: 'font-weight:nomrmal;' },
            { cmd: 'h1', icon: null, text: "T", helper: 'Title', style: 'font-weight:bold;' },
            { cmd: 'h2', icon: null, text: "t", helper: 'Subtitle', style: 'font-weight:bold;' },
            { cmd: 'ol', icon: 'th-list', text: null, helper: 'Numbered List', style: null },
            { cmd: 'ul', icon: 'th-menu', text: null, helper: 'Unnumbered List', style: null },
            { cmd: 'anchor', icon: 'link', text: null, helper: 'Link', style: null },
            { cmd: 'table', icon: 'th-small', text: null, helper: 'Table', style: null },
            { cmd: 'image', icon: 'image', text: null, helper: 'Image', style: null },
            { cmd: 'file', icon: 'document', text: null, helper: 'File', style: null },
            { cmd: 'ipsum', icon: 'clipboard', text: null, helper: 'Dummy Text', style: null },
        ]
    };

})(jQuery, document, window);


/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-qrcode.js */
/* File: js/machinata-core-bundle.js/machinata-core-qrcode.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// QR Code integrations
/// </summary>
/// <hidden/>
Machinata.onInit(function () {
    $(".bb-qrcode").not(".generated").addClass("generated").each(function () {
        var elem = $(this);
        var imgURL = "https://cinnamon-reporting.dev.nerves.ch/static/qrcode?background=transparent&color=black&size=400&data=" + encodeURIComponent(elem.attr("data-qr-code"));
        var imgURLLarge = "https://cinnamon-reporting.dev.nerves.ch/static/qrcode?background=white&color=black&size=800&data=" + encodeURIComponent(elem.attr("data-qr-code"));
        var imgElem = $("<img/>");
        imgElem.attr("src", imgURL);
        imgElem.css("cursor", "pointer");
        imgElem.addClass("qrcode");
        elem.append(imgElem);
        elem.click(function () {
            var diag = Machinata.dialog("Scan Code", "<div class='qrcode'></div>", null);
            diag.design("wide");
            var imgElem2 = $("<img/>");
            imgElem2.attr("src", imgURLLarge);
            diag.elem.find(".qrcode").append(imgElem2);
            var dataElem = $("<h2/>");
            dataElem.text(elem.attr("data-qr-code"));
            diag.elem.find(".qrcode").append(dataElem);
            diag.show();
        });
    });

    $(".bb-barcode").not(".generated").addClass("generated").each(function () {
        var elem = $(this);
        var imgURL = "https://cinnamon-reporting.dev.nerves.ch/static/barcode?background=transparent&color=black&size=400&data=" + encodeURIComponent(elem.attr("data-bar-code"));
        var imgURLLarge = "https://cinnamon-reporting.dev.nerves.ch/static/barcode?background=white&color=black&size=800&data=" + encodeURIComponent(elem.attr("data-bar-code"));
        var imgElem = $("<img/>");
        imgElem.attr("src", imgURL);
        imgElem.css("cursor", "pointer");
        imgElem.addClass("qrcode");
        elem.append(imgElem);
        elem.click(function () {
            var diag = Machinata.dialog("Bar Code", "<div class='qrcode'></div>", null);
            diag.design("wide");
            var imgElem2 = $("<img/>");
            imgElem2.attr("src", imgURLLarge);
            diag.elem.find(".qrcode").append(imgElem2);
            var dataElem = $("<h2/>");
            dataElem.text(elem.attr("data-qr-code"));
            diag.elem.find(".qrcode").append(dataElem);
            diag.show();
        });
    });
});





/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-ui.js */
/* File: js/machinata-core-bundle.js/machinata-core-ui.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */


/// <summary>
/// jQuery DOM Ready
/// </summary>
/// <hidden/>
$(document).ready(function () {
    Machinata.init();
});

/// <summary>
/// jQuery Window Load
/// </summary>
/// <hidden/>
$(window).on('load', function () {
    // Run all on loaded...
    for (var i = 0; i < Machinata._onLoaded.length; i++) Machinata._onLoaded[i]();
});

/// <summary>
/// Collection of useful UI related utilities.
/// </summary>
/// <type>namespace</type>
Machinata.UI = {};

/// <summary>
/// 
/// </summary>
Machinata.UI.elemUID = 0;

/// <summary>
/// 
/// </summary>
Machinata.DISABLE_CORE_UI = false;

/// <summary>
/// 
/// </summary>
Machinata.UI.getElemUID = function (name) {
    Machinata.UI.elemUID++;
    if (name != null) return name + "_" + Machinata.UI.elemUID;
    else return "machinata_autoid_" + Machinata.UI.elemUID;
};

/// <summary>
/// 
/// </summary>
Machinata.UI.autoUIDElem = function (elem) {
    if (elem.attr("id") == null) elem.attr("id", Machinata.UI.getElemUID());
    return elem.attr("id");
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.onInit(function () {
    if (Machinata.DISABLE_CORE_UI == true) return;
    // Register bind events
    Machinata.UI.onUIBind(Machinata.UI.bindEvents);
    Machinata.UI.onUIBind(Machinata.UI.bindButtons);
    Machinata.UI.onUIBind(Machinata.UI.bindAnimations);
    Machinata.UI.onUIBind(Machinata.UI.bindInputs);
    Machinata.UI.onUIBind(Machinata.UI.bindTables);
    Machinata.UI.onUIBind(Machinata.UI.bindText);
    Machinata.UI.onUIBind(Machinata.UI.bindAutosave);
    Machinata.UI.onUIBind(Machinata.UI.bindCurrencies);
});

/// <summary>
///
/// </summary>
/// <hidden/>

Machinata.ready(function () {
    if (Machinata.DISABLE_CORE_UI == true) return;
    // Initial bind
    Machinata.UI.bind();
});

/// <summary>
///
/// </summary>
/// <hidden/>
Machinata.UI._onUIBind = [];

/// <summary>
///
/// </summary>
/// <hidden/>
Machinata.UI.onUIBind = function (fn) {
    Machinata.UI._onUIBind.push(fn);
};


/// <summary>
/// 
/// </summary>
Machinata.UI.bind = function (elements) {
    if (Machinata.DISABLE_CORE_UI == true) return;

    var elementsName = "custom elements";
    if (elements == null) {
        elements = $("body");
        elementsName = "body";
    }
    var filteredElements = elements.not(".bb-ui-bound");
    if (Machinata.DebugEnabled == true) {
        Machinata.debug("Machinata.UI.bind(" + elementsName + ")");
        Machinata.debug("  Found " + filteredElements.length +" elements");
    }
    for (var i = 0; i < Machinata.UI._onUIBind.length; i++) {
        Machinata.UI._onUIBind[i](filteredElements);
    }
};


/// <summary>
/// 
/// </summary>
Machinata.UI.bindInputs = function (elements) {
    elements.find("textarea.bb-autogrow").autogrow({ vertical: true, horizontal: false, flickering: true });

    elements.find(".ui-input-and-action").each(function () {
        var inputAndActionElem = $(this);
        function incrementOrDecrement(amount) {
            var val = parseInt(inputAndActionElem.find("input").val());
            if (isNaN(val)) val = 0;
            val = val + amount;
            // Validate
            if (!isNaN(inputAndActionElem.find("input").attr("min"))) {
                var minVal = parseInt(inputAndActionElem.find("input").attr("min"));
                if (val < minVal) val = minVal;
            }
            if (!isNaN(inputAndActionElem.find("input").attr("max"))) {
                var maxVal = parseInt(inputAndActionElem.find("input").attr("max"));
                if (val > maxVal) val = maxVal;
            }
            // Set
            inputAndActionElem.find("input").val(val).trigger("change");
        }
        inputAndActionElem.find("button.option-minus").click(function (event) {
            event.preventDefault();
            incrementOrDecrement(-1);
        });
        inputAndActionElem.find("button.option-plus").click(function (event) {
            event.preventDefault();
            incrementOrDecrement(+1);
        });
    });

    
};


/// <summary>
/// 
/// </summary>
Machinata.UI.autogrowTextArea = function (elements, opts) {
    function update(domElem) {
        domElem.style.height = 'inherit';
        var computed = window.getComputedStyle(domElem);
        var height = parseInt(computed.getPropertyValue('border-top-width'), 10)
            + parseInt(computed.getPropertyValue('padding-top'), 10)
            + domElem.scrollHeight
            + parseInt(computed.getPropertyValue('padding-bottom'), 10)
            + parseInt(computed.getPropertyValue('border-bottom-width'), 10);
        domElem.style.height = height + 'px';
    }
    elements.on("input", function () {
        update(this);
    });
    setTimeout(function () {
        elements.each(function () {
            update(this);
        });
    }, 50);
    
};

/// <summary>
/// 
/// </summary>
Machinata.UI.bindTables = function (elements) {
    // See https://github.com/jmosbech/StickyTableHeaders
    elements.find("table.bb-sticky-headers,table.ui-table.option-sticky-header").each(function () {
        var elem = $(this);
        var rows = elem.find("tr").length;
        var minRowCount = 15; // default
        var attrMinRowCount = elem.attr("data-sticky-headers-min-row-count");
        if (attrMinRowCount != "" && attrMinRowCount != null) minRowCount = parseInt(attrMinRowCount);
        if (rows >= minRowCount) elem.stickyTableHeaders({ cacheHeaderHeight: true, fixedOffset: $("#header") });
    })
};

/// <summary>
/// 
/// </summary>
Machinata.UI.bindEvents = function (elements) {


    // Zoomable backgrounds
    elements.find(".bb-zoom-background").each(function () {
        var elem = $(this);
        elem.zoom({
            // TODO: options, see http://www.jacklmoore.com/zoom/
            // Property 	Default 	Description
            // url 	false 	The url of the large photo to be displayed. If no url is provided, zoom uses the src of the first child IMG element inside the element it is assigned to.
            // on 	'mouseover' 	The type of event that triggers zooming. Choose from mouseover, grab, click, or toggle.
            // duration 	120 	The fadeIn/fadeOut speed of the large image.
            // target 	false 	A selector or DOM element that should be used as the parent container for the zoomed image.
            // touch 	true 	Enables interaction via touch events.
            // magnify 	1 	This value is multiplied against the full size of the zoomed image. The default value is 1, meaning the zoomed image should be at 100% of its natural width and height.
            // callback 	false 	A function to be called when the image has loaded. Inside the function, `this` references the image element.
            // onZoomIn 	false 	A function to be called when the image has zoomed in. Inside the function, `this` references the image element.
            // onZoomOut 	false 	A function to be called when the image has zoomed out. Inside the function, `this` references the image element. 
        });
    }); 

    // Button on-press
    elements.find("[on-press]").addClass("bb-ui-bound").each(function () {
        var elem = $(this);
        var confirm = elem.attr("confirm-message");
        var input = elem.attr("input-message");
        var inputName = elem.attr("input-name");
        if (inputName == null) inputName = "input";
        var title = null;
        if (elem.attr("confirm-title") != null) title = elem.attr("confirm-title");
        if (elem.attr("input-title") != null) title = elem.attr("input-title");
        elem.click(function () {
            // Show confirm diag?
            if (!String.isEmpty(confirm) || !String.isEmpty(input)) {
                if (!String.isEmpty(input)) {
                    // Show input dialog
                    var dialogTitle = title;
                    var dialogMessage = input;
                    if (String.isEmpty(dialogTitle)) {
                        dialogTitle = input;
                        dialogMessage = null;
                    }
                    Machinata.inputDialog(dialogTitle, dialogMessage, null)
                        .input(function (val, id) {
                            var page = elem.attr("on-press");
                            page = page.replace("{" + inputName + "}",encodeURIComponent(val));
                            Machinata.goToPage(page);
                        })
                        .show();
                } else {
                    // Just show confirm dialog
                    var dialogTitle = title;
                    var dialogMessage = confirm;
                    if (String.isEmpty(dialogTitle)) {
                        dialogTitle = confirm;
                        dialogMessage = null;
                    }
                    Machinata.confirmDialog(dialogTitle, dialogMessage)
                        .okay(function () {
                            Machinata.goToPage(elem.attr("on-press"));
                        })
                        .show();
                }

            } else {
                Machinata.goToPage(elem.attr("on-press"));
            }
        });
    });

};


/// <summary>
/// 
/// </summary>
Machinata.UI.bindText = function (elements) {
    // Line breaks
    $(".bb-auto-linebreak").each(function () {
        $(this).html($(this).html().replaceAll("\n", "<br/>"));
        $(this).html($(this).html().replaceAll("\\\\", "<br/>"));
    });
};

/// <summary>
/// 
/// </summary>
Machinata.UI.convertNewLinesToLineBreaks = function (elements) {
    elements.each(function () {
        $(this).html($(this).html().replaceAll("\n", "<br/>"));
    });
};


/// <summary>
/// 
/// </summary>
Machinata.UI.bindButtons = function (elements) {
    // Pre-pass for jquery UI checkbox/radio
    elements.find(".bb-checkbox,.bb-radio").each(function () { //TODO:@dan why not add class uibound?
        var elem = $(this);
        // No ID?
        if (String.isEmpty(elem.attr("id"))) {
            elem.attr("id", Machinata.UI.getElemUID());
        }
        // Selected?
        if (elem.hasClass("selected")) {
            elem.attr("checked", "checked");
        }
        // Missing label elem?
        var labelElem = $("label[for='" + elem.attr("id") + "']");
        if (labelElem.length == 0) {
            var labelText = elem.attr("label");
            labelElem = $("<label for=''></label>");
            labelElem.attr("for", elem.attr("id"));
            labelElem.text(labelText);
            labelElem.insertAfter(elem);
        }
        // Custom state labels?
        //TODO
        
    });

    // Do button sets
    elements.find(".bb-button-set").addClass("bb-ui-bound").each(function () {
        var elem = $(this);
        if (elem.attr("selected-button") != null) {
            var button = elem.find(".button[name='" + elem.attr("selected-button") + "']");
            button.addClass("selected");
        }
        elem.buttonset();
    });

    // Do toggle sets
    elements.find(".bb-toggle-content").addClass("bb-ui-bound").each(function () {
        var toggleContent = $(this);
        var buttons = toggleContent.find("[data-toggle-element]");
        var elems = toggleContent.find("[data-element-id]");
        // Strip elements that are purposfully hidden, as we want to make sure we dont show these through the toggle...
        buttons.filter(":hidden").remove();
        elems.filter(":hidden").remove();
        buttons = toggleContent.find("[data-toggle-element]");
        elems = toggleContent.find("[data-element-id]");
        buttons.click(function () {
            var button = $(this);
            elems.hide();
            elems.filter("[data-element-id=\"" + button.attr("data-toggle-element") + "\"]").show();
            buttons.removeClass("selected");
            button.addClass("selected");
        });
        buttons.first().trigger("click");
    });

    // Post-pass for jquery UI checkbox/radio
    elements.find(".bb-checkbox,.bb-radio").checkboxradio().addClass("bb-ui-bound").each(function () {
        var elem = $(this);
        // Row selector?
        if (elem.hasClass("selects-row")) {
            if (!elem.is(":checked")) {
                elem.closest("tr").addClass("deselected");
            }
            elem.on('change selected deselected', function () {
                if (elem.is(":checked")) elem.closest("tr").removeClass("deselected");
                else elem.closest("tr").addClass("deselected")
            });
        }
    });
    elements.find(".ui-checkbox input").addClass("bb-ui-bound").each(function () { //Backwards compatibility to new uikit
        var elem = $(this);
        // Row selector?
        if (elem.hasClass("selects-row")) {
            if (!elem.prop("checked")) {
                elem.closest("tr").addClass("deselected");
            }
            elem.on('change selected deselected', function () {
                if (elem.prop("checked")) elem.closest("tr").removeClass("deselected");
                else elem.closest("tr").addClass("deselected")
            });
        }
    });

    // Select menu
    elements.find(".bb-select").selectmenu().addClass("bb-ui-bound");

    // Date range
    elements.find(".bb-daterange").addClass("bb-ui-bound").click(function () {
        // Init
        var input = $(this);
        var dateFormat = Machinata.DEFAULT_DATE_FORMAT_JAVASCRIPT_UI;
        var timeFormat = Machinata.DEFAULT_TIME_FORMAT_JAVASCRIPT_UI;
        if (!String.isEmpty(input.attr("date-format"))) dateFormat = input.attr("date-format");
        if (!String.isEmpty(input.attr("time-format"))) timeFormat = input.attr("time-format");
        var format = dateFormat + " " + timeFormat;
        // Convert for picker
        if (dateFormat != null) dateFormat = Machinata.convertDotNetTimeFormatToDatepickerFormat(dateFormat);
        if (timeFormat != null) timeFormat = Machinata.convertDotNetTimeFormatToDatepickerFormat(timeFormat);
        Machinata.dateDialog(null, null, null, input.val(), dateFormat, timeFormat, true)
                    .input(function (datetime, id) {
                        if (id == "clear") {
                            input.val("");
                            return;
                        }
                        input.val(Machinata.formattedDate(datetime.start, format) + Machinata.DEFAULT_DATERANGE_SEPARATOR + Machinata.formattedDate(datetime.end, format));
                    })
                    .show();
    });


};


/// <summary>
/// 
/// </summary>
Machinata.UI.bindAutosave = function (elements) {
    if (!window.localStorage) return;
    elements.find("input.bb-autosave").each(function () {
        var elem = $(this);
        var key = elem.attr("data-bb-autosave");
        if (key == null || key == "") key = elem.attr("name");
        key = "autosave_" + key;
        elem.on("blur", function () {
            window.localStorage.setItem(key, elem.val());
        });
        if (elem.val() == null || elem.val() == "") {
            elem.val(window.localStorage.getItem(key));
        }
    });
    
};


/// <summary>
/// 
/// </summary>
Machinata.UI.bindCurrencies = function (elements) {
    Machinata.Formatting.formatCurrencyElements(elements.find(".bb-currency"));
};


/// <summary>
/// 
/// </summary>
Machinata.UI.isInViewport = function (elem) {
    var top_of_element = elem.offset().top;
    var bottom_of_element = elem.offset().top + elem.outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();

    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
        return true;
    } else {
        return false;
    }
};


/// <summary>
/// 
/// </summary>
Machinata.UI.getElementBoundsInViewport = function (elem) {
    var topOfElement = elem.offset().top;
    var bottomOfelement = topOfElement + elem.outerHeight();

    var leftOfElement = elem.offset().left;
    var rightOfElement = leftOfElement + elem.outerWidth();

    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();

    return {
        top: topOfElement,
        left: leftOfElement,
        right: rightOfElement,
        bottom: bottomOfelement,
    }
};


/// <summary>
/// 
/// </summary>
Machinata.UI.getElementBoundsInPage = function (elem) {
    var topOfElement = elem.offset().top;
    var bottomOfelement = topOfElement + elem.outerHeight();
    var leftOfElement = elem.offset().left;
    var rightOfElement = leftOfElement + elem.outerWidth();
    return {
        top: topOfElement,
        left: leftOfElement,
        right: rightOfElement,
        bottom: bottomOfelement,
    }
};

/// <summary>
/// 
/// </summary>
Machinata.UI.SCROLL_TO_HEADER_PUSHER_MULTIPLIER = 1.2;

/// <summary>
/// 
/// </summary>
Machinata.UI.scrollTo = function (target,duration,settings) {
    // Forward to jquery.scrollTo
    // Settings:
    //   axis: The axes to animate: xy (default), x, y, yx
    //   interrupt: If true will cancel the animation if the user scrolls. Default is false
    //   limit: If true the plugin will not scroll beyond the container's size. Default is true
    //   margin: If true, subtracts the margin and border of the target element. Default is false
    //   offset: Added to the final position, can be a number or an object with left and top
    //   over: Adds a % of the target dimensions: {left:0.5, top:0.5}
    //   queue: If true will scroll one axis and then the other. Default is false
    //   onAfter(target, settings): A callback triggered when the animation ends (jQuery's complete())
    //   onAfterFirst(target, settings): A callback triggered after the first axis scrolls when queueing
    if (settings == null) settings = {};
    // Automatically set the offset (if not set) to the header pusher height
    var headerPusherElem = $("#headerpusher,#header-pusher");
    if (settings.offset == null && headerPusherElem.length == 1) {
        settings.offset = -headerPusherElem.height() * Machinata.UI.SCROLL_TO_HEADER_PUSHER_MULTIPLIER;
    }
    // Validate that we even need to do a scroll, if the elem is close to the destination, then
    // we don't do the scroll, as it just annoys the user.
    var performScroll = true;
    if (settings.ignoreIfTargetIsCloseToDestination == true) {
        var targetTop = target.offset().top;
        var windowTop = $(window).scrollTop();
        var offsetTop = 0;
        if (settings.offset != null && settings.offset.top != null) offsetTop = settings.offset.top;
        else if (settings.offset != null) offsetTop = settings.offset;
        var windowTargetTop = targetTop + offsetTop;
        var dist = windowTargetTop - windowTop;
        // Only account for positive distances (if minus we need to reveal the element)
        var minDist = $(window).height() * 0.6;
        if (dist > 0 && dist < minDist) performScroll = false;
    }
    // Perform the scroll using jquery
    if (performScroll == true) {
        $(window).scrollTo(target, duration, settings);
    }
};


/// <summary>
/// 
/// </summary>
Machinata.UI.bindAncorsToScroll = function (duration, settings) {
    $("[href^='#']").click(function (e) {
        e.preventDefault();
        var target = $($(this).attr("href")); // Try element id, ie #id
        if (target.length == 0) target = $("a[name='" + $(this).attr("href").substring(1) + "']");
        Machinata.UI.scrollTo(target, duration, settings);
    });
};


/// <summary>
/// 
/// </summary>
Machinata.UI.bindAnimations = function (elements) {
    // Animate on appear
    elements.find(".ui-animate-on-appear,.bb-animate-on-appear").not(".ui-bound").addClass("ui-bound").each(function () {
        var elem = $(this);
        var update = function () {
            if (elem.visible(true)) {
                var delay = elem.attr("data-animate-on-appear-delay");
                if (delay == null) {
                    elem.addClass("on-appear");
                } else {
                    delay = parseInt(delay);
                    setTimeout(function () {
                        elem.addClass("on-appear");
                    }, delay);
                }
                
            } else if (elem.hasClass("animate-on-disappear")) {
                elem.removeClass("on-appear");
            }
        };
        $(window).on('scroll', update);
        update();
    });
};



/// <summary>
/// <param name="input">input element selector</param>
/// <param name="countries">string array of country codes</param>
/// </summary>
Machinata.UI.convertInputToCountrySelection = function (input, countries, additional) {
    var selectElem = $("<select></select>");
    var didSetVal = false;
    var selectedVal = input.val();
    var selectedCountries = null;
    if (countries == null) {
        // All
        selectedCountries = Machinata.COUNTRIES;
    } else {
        // Create selection
        selectedCountries = [];
        for (var cci = 0; cci < countries.length; cci++) {
            var cc = countries[cci];
            for (var ci = 0; ci < Machinata.COUNTRIES.length; ci++) {
                var c = Machinata.COUNTRIES[ci];
                if (c.code == cc) {
                    selectedCountries.push(c);
                    break;
                }
            }
        }
    }
    // Additional?
    if (additional != null) {
        var additionals = additional.split(",");
        for (var i = 0; i < additionals.length; i++) {
            for (var ci = 0; ci < Machinata.COUNTRIES.length; ci++) {
                var c = Machinata.COUNTRIES[ci];
                if (c.code == additionals[i]) {
                    selectedCountries.push(c);
                    break;
                }
            }
        }
    }
    // Sort!
    selectedCountries.sort(function (a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
    });
    if(selectedVal != null) selectedVal = selectedVal.toLowerCase();
    for (var i = 0; i < selectedCountries.length; i++) {
        var c = selectedCountries[i];
        var optElem = $("<option/>");
        optElem.text(c.name);
        optElem.attr("value", c.code.toLowerCase());
        if (c.code.toLowerCase() == selectedVal) {
            optElem.attr("selected", "selected");
            didSetVal = true;
        }
        selectElem.append(optElem);
    }
    selectElem.attr("name", input.attr("name"));
    selectElem.attr("class", input.attr("class"));
    if (input.attr("required") != null) selectElem.attr("required", input.attr("required"));
    input.replaceWith(selectElem);
};

/// <summary>
/// 
/// </summary>
Machinata.UI.convertExternalLinksToBlankTargets = function (elements) {
    if (elements == null) elements = $("body");
    var links = elements.find("a");
    links.each(function () {
        var link = $(this);
        var url = link.attr("href");
        if(url == null) return;
        if (url.startsWith("http://") || url.startsWith("https://")) {
            link.attr("target", "_blank");
        }
    });
};


/// <summary>
/// 
/// </summary>
Machinata.UI.userSelectElement = function (element) {
    // Create a user selection in the document for the given jquery element
    var body = document.body, range, sel;
    var el = element[0];
    if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();
        try {
            range.selectNodeContents(el);
            sel.addRange(range);
        } catch (e) {
            range.selectNode(el);
            sel.addRange(range);
        }
    } else if (body.createTextRange) {
        range = body.createTextRange();
        range.moveToElementText(el);
        range.select();
    }
};

/// <summary>
/// 
/// </summary>
Machinata.UI.copyElementToClipboardInTemporaryDOM = function (element, showSuccess) {
    var tempContainer = $("<div style='position: absolute; top: 0px; left:0px; pointer-events:none; opacity: 0;'></div>");
    tempContainer.append(element);
    $("body").append(tempContainer);
    Machinata.UI.copyElementToClipboard(element, showSuccess);
    setTimeout(function () {
        tempContainer.remove();
    }, 100);
};

/// <summary>
/// 
/// </summary>
Machinata.UI.copyElementToClipboard = function (element,showSuccess) {
    Machinata.UI.userSelectElement(element);
    document.execCommand("copy");

    if (showSuccess == true) {
        setTimeout(function () {
            var diag = Machinata.messageDialog("Copied", "Text has been copied to your clipboard.");
            diag.show();
        }, 100);
    }
};

/// <summary>
/// 
/// </summary>
Machinata.UI.copyTextToClipboard = function (text, showSuccess, successMessage) {
    var elem = $("<p></p>");
    elem.text(text);
    $("body").append(elem);
    Machinata.UI.userSelectElement(elem);
    document.execCommand("copy");
    elem.remove();
    console.log("WARNING: Machinata.UI.copyTextToClipboard seems to be not working");

    if (showSuccess == true) {
        setTimeout(function () {
            var diag = Machinata.messageDialog("Copied", successMessage || "Text has been copied to your clipboard.");
            diag.elem.find("p").css("word-break","break-word");
            diag.show();
        }, 100);
    }
};

/// <summary>
/// 
/// </summary>
Machinata.UI.enableAutoScroll = function () {
    if (Machinata.queryParameter("auto-scroll") != "") {
        Machinata.debug("Will auto-scroll window...");
        var y = 0;
        var scrollSpeed = 25;
        var scrollAmount = 1;
        var beginDelay = 0;
        var reloadURL = window.location.href;
        if (Machinata.queryParameter("auto-scroll-delay") != "") beginDelay = parseInt(Machinata.queryParameter("auto-scroll-delay"))
        setTimeout(function () {
            var scrollTimer = setInterval(function () {
                y += scrollAmount;
                if (y >= $(document).height() - $(window).height()) {
                    clearInterval(scrollTimer);
                    if (Machinata.queryParameter("auto-reload-after-scroll") == "true") {
                        Machinata.reload();
                        //window.location = reloadURL + "&uid=" + Math.random();
                    } else {
                        y = 0;
                    }
                }
                window.scrollTo(0, y);
            }, scrollSpeed);
        }, beginDelay);
    }
};

/// <summary>
/// 
/// </summary>
Machinata.UI.enableAutoReload = function () {
    if (Machinata.queryParameter("auto-reload") != "" && Machinata.queryParameter("auto-scroll") == "") {
        Machinata.debug("Will auto-reload window...");
        $("body").addClass("auto-reload-enabled");
        var autoReloadStr = Machinata.queryParameter("auto-reload");
        var autoReloadMS = parseInt(autoReloadStr);
        setTimeout(function () {
            window.location = window.location;
        }, autoReloadMS);
    }
};


/// <summary>
/// Automatically updates a body class when the user scrolls from the top of the page
/// A tolerance (in px) can be specified
/// </summary>
Machinata.UI.enableScrollChangeMonitor = function (tolerance) {
    if (tolerance == null) tolerance = 5;
    var bodyElem = $("body");
    function update() {
        if (window.scrollY > tolerance) {
            bodyElem.removeClass("scroll-top");
            bodyElem.addClass("scroll-middle");
        } else {
            bodyElem.addClass("scroll-top");
            bodyElem.removeClass("scroll-middle");
        }
    }
    $(window).scroll(function () {
        update();
    });
    update();
};


/// <summary>
///  Create a horizontal scrolling timeline based on timestamps in it's items attributes
/// </summary>
Machinata.UI.createTimeline = function (elements, pixelsPerMonth, endPaddingMonth, dateFormat) {
    elements.each(function () {

        // Cache some selectors
        var timeline = $(this);
        var view = timeline.find(".view");
        var items = timeline.find(".items .item");
        var contents = timeline.find(".contents");
        var axisMonths = timeline.find(".axis-months");

        // Init size
        if (pixelsPerMonth == null) pixelsPerMonth = 80;
        var pixelsPerDay = pixelsPerMonth / 30;
        var pixelsPerHour = pixelsPerDay / 24;
        var pixelsPerMinute = pixelsPerHour / 60;
        var pixelsPerSecond = pixelsPerMinute / 60;
        var pixelsPerTick = pixelsPerSecond / 1000;
        var minDate = null;
        var maxDate = null;
        if (endPaddingMonth == null) endPaddingMonth = 1;
        if (dateFormat == null) dateFormat = Machinata.convertDotNetTimeFormatToDatepickerFormat(Machinata.DEFAULT_DATE_FORMAT_JAVASCRIPT_UI);

        // Pre-process
        Machinata.debug("Machinata.UI.createTimeline");
        Machinata.debug("  Pre-processing items...");
        items.each(function () {
            // Init items start/end
            var item = $(this);
            var timeStart = Machinata.dateFromString(item.attr("data-start"), dateFormat);
            var timeEnd = Machinata.dateFromString(item.attr("data-end"), dateFormat);
            if (timeStart < minDate || minDate == null) minDate = timeStart;
            if (timeEnd > maxDate || maxDate == null) maxDate = timeEnd;
            // Convert to ticks
            item.data("ticks-start", timeStart.getTime());
            item.data("ticks-end", timeEnd.getTime());
            // Debug
            Machinata.debug("  " + "Item:");
            Machinata.debug("  " + "  " + item.attr("data-title"));
            Machinata.debug("  " + "  " + item.attr("data-start") + ": " + timeStart);
            Machinata.debug("  " + "  " + item.attr("data-end") + ": " + timeEnd);
        });

        // Validate
        if (minDate == null) minDate = new Date();
        if (maxDate == null) maxDate = new Date();


        // Trim timeline to start of the first month, and end of last month
        var timelineStart = new Date(minDate.getFullYear(), minDate.getMonth(), 1, 0, 0, 0, 0);
        var timelineEnd = new Date(maxDate.getFullYear(), maxDate.getMonth() + 1 + endPaddingMonth, 1, 0, 0, 0, 0);
        timelineEnd = new Date(timelineEnd.getTime() - 1000); // subtract a second to get previous month (since we added a hole)
        var timelineTicksStart = timelineStart.getTime();
        var timelineTicksEnd = timelineEnd.getTime();
        var timelineTicksSpan = timelineTicksEnd - timelineTicksStart;
        var timelinePixels = timelineTicksSpan * pixelsPerTick;
        var months = Machinata.Time.getMonths(timelineStart, timelineEnd);

        // Debug
        Machinata.debug("  " + "Configuration:");
        Machinata.debug("  " + "  " + "pixelsPerMonth: " + pixelsPerMonth);
        Machinata.debug("  " + "  " + "pixelsPerDay: " + pixelsPerDay);
        Machinata.debug("  " + "  " + "pixelsPerHour: " + pixelsPerHour);
        Machinata.debug("  " + "  " + "pixelsPerMinute: " + pixelsPerMinute);
        Machinata.debug("  " + "  " + "pixelsPerSecond: " + pixelsPerSecond);
        Machinata.debug("  " + "  " + "pixelsPerTick: " + pixelsPerTick);
        Machinata.debug("  " + "  " + "minDate: " + minDate);
        Machinata.debug("  " + "  " + "maxDate: " + maxDate);
        Machinata.debug("  " + "  " + "months: " + months);
        Machinata.debug("  " + "  " + "timelineStart: " + timelineStart);
        Machinata.debug("  " + "  " + "timelineEnd: " + timelineEnd);
        Machinata.debug("  " + "  " + "timelineTicksStart: " + timelineTicksStart);
        Machinata.debug("  " + "  " + "timelineTicksEnd: " + timelineTicksEnd);
        Machinata.debug("  " + "  " + "timelineTicksSpan: " + timelineTicksSpan);
        Machinata.debug("  " + "  " + "timelinePixels: " + timelinePixels);

        // Process each axis
        axisMonths.each(function () {
            var axisElem = $(this);
            // Loop all months
            for (var i = 0; i < months.length; i++) {
                // Get start end time
                var timeStart = months[i];
                var timeEnd = new Date(timeStart.getFullYear(), timeStart.getMonth() + 1, 1, 0, 0, 0, 0);
                // Create tick elem
                var tickElem = $("<div class='tick time-positioned'></div>");
                tickElem.data("ticks-start", timeStart.getTime());
                tickElem.data("ticks-end", timeEnd.getTime());
                // Addition tick data
                if (axisElem.hasClass("labels")) {
                    var label = Machinata.Time.getShortMonth(timeStart);
                    if (timeStart.getMonth() == 0) label += " " + timeStart.getFullYear();
                    tickElem.append($("<span></span>").text(label));
                }
                axisElem.append(tickElem);
            }
        });

        // Position each positioned element
        // Each such element is positioned in percent, meaning the entire timeline
        // is responsive out-of-the-box
        var positionedElems = timeline.find(".time-positioned");
        contents.css("width", timelinePixels + "px");
        positionedElems.each(function () {
            var elem = $(this);
            var percentStart = (elem.data("ticks-start") - timelineTicksStart) / timelineTicksSpan;
            var percentEnd = (elem.data("ticks-end") - timelineTicksStart) / timelineTicksSpan;
            elem.css("left", (percentStart) * 100.0 + "%");
            elem.css("width", (percentEnd - percentStart) * 100.0 + "%");
            elem.data("original-width", (percentEnd - percentStart) * 100.0 + "%");
        });

        // Extra interaction for items that got trimmed
        var expandableElems = timeline.find(".item.expandable");
        expandableElems.hover(function () {
            var title = $(this).find(".title").text();
            var fontSize = 4;
            var titleWidth = title.length * fontSize;
            if ($(this).width() < titleWidth) {
                $(this).css("width", "unset").data("expanded", true);
            }
        }, function () {
            if ($(this).data("expanded") == true) {
                $(this).css("width", $(this).data("original-width")).data("expanded", false);
            }
        });

        // Drag scroll
        if ($("body").hasClass("not-touch-enabled")) {
            var curDown = false;
            var curXPos = 0;
            timeline.addClass("grab-to-scroll");
            timeline.mousemove(function (event) {
                if (curDown == true) {
                    var parentOffset = timeline.parent().offset();
                    var newX = (curXPos - (event.pageX - parentOffset.left));
                    view.scrollLeft(newX);
                }
            });
            timeline.mousedown(function (event) {
                var parentOffset = timeline.parent().offset();
                curXPos = view.scrollLeft() + (event.pageX - parentOffset.left);
                curDown = true;
                timeline.addClass("grabbing");
            });
            timeline.mouseup(function () {
                curDown = false;
                timeline.removeClass("grabbing");
            });
            $(window).mouseup(function () {
                curDown = false;
                timeline.removeClass("grabbing");
            });
        }
    });
};


/// <summary>
/// 
/// </summary>
Machinata.UI.bindPageDownElements = function (elements, opts) {
    if (opts == null) opts = {};
    if (opts.nextTargetSelector == null) opts.nextTargetSelector = null;
    if (opts.closestTargetSelector == null) opts.closestTargetSelector = opts.nextTargetSelector;
    if (opts.duration == null) opts.duration = 1200;

    elements.each(function () {
        var elem = $(this);
        elem.click(function () {
            var resolveMethod = "direct via opts.target";
            var nextTargetSelector = opts.nextTargetSelector;
            if (nextTargetSelector == null) nextTargetSelector = elem.attr("data-page-down-next-target");
            var closestTargetSelector = opts.closestTargetSelector;
            if (closestTargetSelector == null) closestTargetSelector = elem.attr("data-page-down-closest-target");
            // Resolve the target
            var target = opts.target;
            if ((target == null || target.length == 0) && nextTargetSelector != null && closestTargetSelector != null) {
                target = elem.closest(closestTargetSelector).nextAll(nextTargetSelector).first();
                resolveMethod = "tree up via closestTargetSelector '" + closestTargetSelector + "' then next via nextTargetSelector '" + nextTargetSelector +"'";
            } else if ((target == null || target.length == 0) && nextTargetSelector) {
                target = elem.nextAll(nextTargetSelector).first();
                resolveMethod = "next via nextTargetSelector '" + nextTargetSelector + "'";
            }
            //else if (target == null || target.length == 0) Machinata.debug("Machinata.UI.bindPageDownElements: warning could not find target");
            // Warning
            if (target == null || target.length == 0) Machinata.debug("Machinata.UI.bindPageDownElements: warning could not find target for options:", { resolveMethod: resolveMethod, nextTargetSelector: nextTargetSelector, closestTargetSelector: closestTargetSelector, opts: opts });
            // Scroll to
            Machinata.UI.scrollTo(target, opts.duration);
        });
    });
};

/// <summary>
/// 
/// </summary>
Machinata.UI.createToggleSlideshow = function (elements, opts) {
    // Init
    if (opts == null) opts = {};
    if (opts.slideDuration == null) opts.slideDuration = 3000;
    if (opts.restartPause == null) opts.restartPause = 6000;
    if (opts.fadeSpeed == null) opts.fadeSpeed = 300;
    if (opts.toggleButtonHtml == null) opts.toggleButtonHtml = "<a class='toggle-button'></a>";

    elements.each(function () {
        // Init
        var elem = $(this);
        var items = elem.find(".toggle-item");
        var buttonContainer = elem.find(".toggle-buttons");
        var timer = null;
        // Helper functions
        function selectNext() {
            var selected = buttonContainer.find(".toggle-button.selected");
            var next = selected.next();
            if (next.length == 0) next = buttonContainer.find(".toggle-button").first();
            next.trigger("select");
        }
        function restartTimer() {
            if (timer != null) clearInterval(timer);
            timer = setInterval(function () {
                selectNext();
            }, opts.slideDuration);
        }
        function restartTimerAfterPause() {
            if (timer != null) clearInterval(timer);
            setTimeout(function () {
                restartTimer();
            }, opts.restartPause);
        }
        // Create all buttons
        items.each(function () {
            var item = $(this);
            var radio = $(opts.toggleButtonHtml);
            radio.on("click select", function () {
                if ($(this).hasClass("selected")) return;
                items.not(item).fadeTo(opts.fadeSpeed, 0.0);
                item.fadeTo(0, 0.0).delay(opts.fadeSpeed).show().fadeTo(opts.fadeSpeed, 1.0);
                buttonContainer.find(".toggle-button").not(radio).removeClass("selected");
                radio.addClass("selected");
            });
            radio.on("click", function () {
                restartTimerAfterPause();
            });
            buttonContainer.append(radio);
        });
        // Initial state
        items.first().show();
        buttonContainer.find(".toggle-button").first().addClass("selected");
        restartTimer();
    });
};

/// <summary>
/// 
/// </summary>
Machinata.UI.calculateIfElementsOverlap = function (elem1, elem2, elementsAreSVGGroups) {
    // Via https://gist.github.com/jtsternberg/c272d7de5b967cec2d3d

    // Elem 1 data
    var d1_offset = elem1.offset();
    var d1_height = elem1.outerHeight(true);
    var d1_width = elem1.outerWidth(true);
    if (elementsAreSVGGroups == true) {
        d1_height = elem1[0].getBoundingClientRect().height;
        d1_width = elem1[0].getBoundingClientRect().width;
    }
    var d1_distance_from_top = d1_offset.top + d1_height;
    var d1_distance_from_left = d1_offset.left + d1_width;

    // Elem 2 data
    var d2_offset = elem2.offset();
    var d2_height = elem2.outerHeight(true);
    var d2_width = elem2.outerWidth(true);
    if (elementsAreSVGGroups == true) {
        d2_height = elem2[0].getBoundingClientRect().height;
        d2_width = elem2[0].getBoundingClientRect().width;
    }
    var d2_distance_from_top = d2_offset.top + d2_height;
    var d2_distance_from_left = d2_offset.left + d2_width;

    var not_colliding = (d1_distance_from_top < d2_offset.top || d1_offset.top > d2_distance_from_top || d1_distance_from_left < d2_offset.left || d1_offset.left > d2_distance_from_left);

    // Return whether it IS colliding
    return !not_colliding;
};


/// <summary>
/// 
/// </summary>
Machinata.UI.bindPageScrolledEvent = function (tolerance, classes) {
    // Init
    if (tolerance == null) tolerance = 10;
    if (classes == null) classes = "page-scrolled";
    // Helper functions
    var bodyElem = $("body");
    function updateHeaderState() {
        var scrollTop = $(window).scrollTop();
        if (scrollTop > tolerance) {
            bodyElem.addClass(classes);
        } else {
            bodyElem.removeClass(classes);
        }
    }
    $(window).scroll(function () {
        updateHeaderState();
    });
    updateHeaderState();
};

/// <summary>
///
/// </summary>
/// <hidden/>
Machinata.UI._doWithDelayTimers = {};

/// <summary>
/// Performs an action after a delay, but only ever once at a time. For each
/// time the method is called, the timer on the key will reset.
/// This is useful, for example, for updating a UI after a text input keystroke.
/// </summary>
/// <param  name="key">unique key for the timer to use</param>
/// <param  name="delay"> delay in milliseconds</param>
/// <param  name="action"> function to perform</param>
Machinata.UI.doWithDelay = function (key, delay, action) {
    var currentTimer = Machinata.UI._doWithDelayTimers[key];
    if (currentTimer != null) clearTimeout(currentTimer);
    currentTimer = setTimeout(function () {
        action();
    }, delay);
    Machinata.UI._doWithDelayTimers[key] = currentTimer;
};





/// <summary>
/// Creates a simple debug panel with series of key value elements.
/// keyvalue: JSON key value object
/// </summary>
Machinata.UI.createDebugPanel = function (title, keyvalue) {
    var debugElem = $("<div class='ui-debug-panel bb-debug-panel'></div>");
    debugElem.append($("<tr class='keyval head'></tr>")
        .append($("<td class='title' colspan='2'></td>").text(title))
    );
    function addKeyValue(key, value) {
        var isLink = false;
        if (value != null && typeof value == "string") {
            if (value.startsWith("http://") || value.startsWith("https://")) {
                isLink = true;
            }
            if (value.startsWith("/") && value.length > 5 && (value[value.length - 5] == '.')) {
                isLink = true;
            }
        }
        var debugItem = $("<div class='keyval'></div>").append($("<div class='key'></div>").text(key));
        if (Array.isArray(value)) {
            $.each(value, function (index, val) {
                debugItem.append($("<div class='val'></div>").text(val));
            });
        } else {
            debugItem.append($("<div class='val'></div>").text(value));
        }
        debugElem.append(debugItem);
        if (isLink == true) {
            debugItem.find(".val").text("").append($("<a></a>").text(value).attr("href", value));
        }
    }
    $.each(keyvalue, function (key, value) {
        addKeyValue(key, value);
    });
    return debugElem;
};



/// <summary>
/// Creates a super high-performance SVG donut with a single segment.
/// You must provide the attribute data-value="[dot percent]" to specify
/// the donut segment size.
/// </summary>
Machinata.UI.microdonut = function (elements) {
    var total = 0;
    elements.each(function () {
        // Init
        var elem = $(this);
        var val = elem.attr("data-value");
        var p = parseFloat(val);
        var pp = Math.floor(p * 100.0);
        var ppd = pp;
        if (ppd == 100) ppd = 99;
        var da1 = ppd;
        var da2 = 100 - da1;
        var dao = 25; // default offset starting at top
        total += pp;
        // Generate SVG code
        // Inspired from from https://medium.com/@heyoka/scratch-made-svg-donut-pie-charts-in-html5-2c587e935d72
        var svgcode =
        '<svg viewBox="0 0 42 42">' +
            '<circle class="hole" cx="21" cy="21" r="15.91549430918954"></circle>' +
            '<circle class="ring" cx="21" cy="21" r="15.91549430918954"></circle>' +
            '<circle class="segment" cx="21" cy="21" r="15.91549430918954" stroke-dasharray="' + da1 + ' ' + da2 + '" stroke-dashoffset="'+dao+'"></circle>' +
        '</svg>';
        elem.append($(svgcode));
    });
};


/// <summary>
/// Creates a super high-performance bar chart using divs.
/// </summary>
Machinata.UI.microBar = function (val, title) {
    var p = val * 100;
    var barElem = $("<div class='microbar'><div class='bar'></div></div>");
    barElem.find(".bar").css("width", (p) + "%");
    barElem.attr("title", title);
    return barElem;
};




/// <summary>
/// Creates a custom tooltip UI for all tooltip events
/// </summary>
/// <example>
/// ## Example CSS
/// ```
/// .ui-tooltip {
///     padding: $padding-half;
///     position: absolute;
///     z-index: 9999;
///     max-width: 300px;
///     transition: none;
///     box-shadow: none;
///     border: none !important;
/// }
/// .ui-tooltip, 
/// .ui-tooltip .arrow:after {
///     background: $solid-color;
/// }
/// .ui-tooltip * {
///     color: $solid-text-color;
/// }
/// .ui-tooltip .arrow {
///     width: 70px;
///     height: 16px;
///     overflow: hidden;
///     position: absolute;
///     left: 50%;
///     margin-left: -35px;
///     bottom: -16px;
/// }
/// .ui-tooltip .arrow.top {
///     top: -16px;
///     bottom: auto;
/// }
/// .ui-tooltip .arrow.left {
///     left: 20%;
/// }
/// .ui-tooltip .arrow:after {
///     content: "";
///     position: absolute;
///     left: 20px;
///     top: -20px;
///     width: 25px;
///     height: 25px;
///     transform: rotate(45deg);
/// }
/// .ui-tooltip .arrow.top:after {
///     bottom: -20px;
///     top: auto;
/// }
/// .ui-helper-hidden-accessible {
///     display: none;
/// }
/// ```
/// </example>
Machinata.UI.tooltips = function (opts, elements) {
    // Init
    if (elements == null) elements = $(document);
    if (opts == null) opts = {};
    if (opts.my == null) opts.my = "center bottom-30";
    if (opts.at == null) opts.at = "center top";
    // Call jQuery UI tooltip plugin
    elements.tooltip({
        track: true,
        show: {
            delay: 0,
            effect: "none"
        },
        hide: {
            delay: 0,
            effect: "none"
        },
        position: {
            my: opts.my,
            at: opts.at,
            using: function (position, feedback) {
                $(this).css(position);
                $("<div>").addClass("arrow").addClass(feedback.vertical).appendTo(this);
            }
        }
    });
}




/// <summary>
/// Creates a interactive table-of-contents
/// </summary>
Machinata.UI.createTOC = function (tocElem, opts) {
    // Init
    var defaults = {
        tocEntryHTML: "<li><a></a></li>",
        tocElementsSelector: "h1,h2,h3,h4,.bb-toc-trigger,.bb-virtual-toc-trigger",
        tocElementsClassFilter: null,
        scrollDuration: 800,
        scrollOffset: -100
    };
    $.extend(defaults, opts);

    // Find triggers
    var tocTriggers = $(defaults.tocElementsSelector);
    if (defaults.tocElementsClassFilter) tocTriggers = tocTriggers.filter("." + defaults.tocElementsClassFilter + ",.bb-toc-trigger,.bb-virtual-toc-trigger")
    tocTriggers = tocTriggers.filter(":visible,.bb-virtual-toc-trigger");

    // Init
    var tocEntriesContainer = tocElem.find("ul");
    var scrollElem = $(window);

    // Build
    tocTriggers.each(function () {
        // Init
        var triggerElem = $(this);
        var actualTrigger = triggerElem;
        if (triggerElem.attr("data-toc-trigger-selector") != null) {
            actualTrigger = $(triggerElem.attr("data-toc-trigger-selector"));
            triggerElem.data("actual-trigger", actualTrigger);
        }
        Machinata.UI.autoUIDElem(actualTrigger);
        var tocEntryElem = $(defaults.tocEntryHTML)
            .addClass("autogen")
            .addClass("bb-toc-entry")
            .data("toc-trigger-elem", actualTrigger)
            .attr("data-toc-id", actualTrigger.attr("id"));
        triggerElem.data("toc-elem", tocEntryElem);
        if (triggerElem.attr("data-toc-level") != null) tocEntryElem.addClass("level-" + triggerElem.attr("data-toc-level"));
        if (triggerElem.attr("data-toc-url") != null) tocEntryElem.data("toc-url", triggerElem.attr("data-toc-url"));
        // Linked trigger?
       
        // Get title
        var title = triggerElem.attr("data-toc-title");
        if (title == null || title == "") title = triggerElem.text();
        // Interaction
        tocEntryElem.click(function () {
            var targetURL = $(this).data("toc-url");
            if (targetURL != null) {
                Machinata.goToPage(targetURL);
            } else {
                var targetElem = $(this).data("toc-trigger-elem");
                Machinata.UI.scrollTo(targetElem, defaults.scrollDuration, { offset: defaults.scrollOffset });
            }
        });
        // Register
        tocEntryElem.find("a").text(title);
        tocEntriesContainer.append(tocEntryElem);
    });
    var tocEntries = tocEntriesContainer.find(".bb-toc-entry");
    if (tocEntries.length > 0) tocElem.addClass("has-entries");

    // Helper function update toc selection
    function updateTOCUI() {
        // Init
        var minDist = Number.MAX_SAFE_INTEGER;
        var scrollTop = scrollElem.scrollTop();
        var scrollMiddle = scrollTop + (scrollElem.height() * 0.5);
        // Find match
        var matchingEntry = null;
        tocTriggers.each(function () {
            var triggerElem = $(this);
            if (triggerElem.hasClass("no-toc-trigger")) return;
            // Switch to actual trigger?
            var actualTrigger = triggerElem;
            if (triggerElem.data("actual-trigger") != null) actualTrigger = triggerElem.data("actual-trigger");
            // Calc dist to trigger...
            //TODO: probably not best algo for this
            var distToTrigger = Math.abs(scrollTop - actualTrigger.offset().top);
            if (distToTrigger < minDist) {
                minDist = distToTrigger;
                matchingEntry = triggerElem;
            }
        });
        if (matchingEntry != null) {
            var tocElem = matchingEntry.data("toc-elem");
            tocElem.addClass("selected");
            tocEntries.not(tocElem).removeClass("selected");
        } else {
            tocEntries.removeClass("selected");
        }
    }

    // Bind scroll for auto-selection
    scrollElem.scroll(function () {
        // Throttle updates
        //TODO
        updateTOCUI();
    });

    // Initial state
    updateTOCUI();
};



/// <summary>
/// 
/// </summary>
Machinata.UI.mirrorInputValueFromMaster = function (masterElem, mirrorElems) {
    mirrorElems.on("change", function () {
        $(this).data("has-custom-value", true);
    });
    masterElem.on("change", function () {
        mirrorElems.each(function () {
            if ($(this).data("has-custom-value") != true) {
                $(this).val(masterElem.val());
            }
        });
        
    });
};


/// <summary>
/// 
/// </summary>
Machinata.UI.createSwatchPicker = function (colorSystems, opts) {
    if (colorSystems == null) colorSystems = "*";
    if (opts == null) opts = {};
    if (opts.dropletSize == null) opts.dropletSize = 20;
    if (opts.swatchSize == null) opts.swatchSize = 300;
    var swatches = [];
    var includeRAL = false;
    var includeNCS = false;
    var includePantone = false;
    var colorSystemsArray = colorSystems.split(",");
    for (var i = 0; i < colorSystemsArray.length; i++) {
        if (colorSystemsArray[i] == "ral" || colorSystemsArray[i] == "RAL") includeRAL = true;
        if (colorSystemsArray[i] == "ncs" || colorSystemsArray[i] == "NCS") includeNCS = true;
        if (colorSystemsArray[i] == "pantone" || colorSystemsArray[i] == "Pantone") includePantone = true;
    }

    if (includeRAL || colorSystems == "*") {
        // From https://gist.github.com/hertsch/5876462
        // Converted to JSON via https://www.csvjson.com/csv2json
        var ralSwatches = [{ "code": "RAL 1000", "rgb": "190-189-127", "hex": "#BEBD7F", "de": "Grünbeige", "en": "Green beige", "fr": "Beige vert", "es": "Beige verdoso", "it": "Beige verdastro", "nl": "Groenbeige" }, { "code": "RAL 1001", "rgb": "194-176-120", "hex": "#C2B078", "de": "Beige", "en": "Beige", "fr": "Beige", "es": "Beige", "it": "Beige", "nl": "Beige" }, { "code": "RAL 1002", "rgb": "198-166-100", "hex": "#C6A664", "de": "Sandgelb", "en": "Sand yellow", "fr": "Jaune sable", "es": "Amarillo arena", "it": "Giallo sabbia", "nl": "Zandgeel" }, { "code": "RAL 1003", "rgb": "229-190-001", "hex": "#E5BE01", "de": "Signalgelb", "en": "Signal yellow", "fr": "Jaune de sécurité", "es": "Amarillo señales", "it": "Giallo segnale", "nl": "Signaalgeel" }, { "code": "RAL 1004", "rgb": "205-164-052", "hex": "#CDA434", "de": "Goldgelb", "en": "Golden yellow", "fr": "Jaune or", "es": "Amarillo oro", "it": "Giallo oro", "nl": "Goudgeel" }, { "code": "RAL 1005", "rgb": "169-131-007", "hex": "#A98307", "de": "Honiggelb", "en": "Honey yellow", "fr": "Jaune miel", "es": "Amarillo miel", "it": "Giallo miele", "nl": "Honinggeel" }, { "code": "RAL 1006", "rgb": "228-160-016", "hex": "#E4A010", "de": "Maisgelb", "en": "Maize yellow", "fr": "Jaune maïs", "es": "Amarillo maiz", "it": "Giallo polenta", "nl": "Maisgeel" }, { "code": "RAL 1007", "rgb": "220-156-000", "hex": "#DC9D00", "de": "Narzissengelb", "en": "Daffodil yellow", "fr": "Jaune narcisse", "es": "Amarillo narciso", "it": "Giallo narciso", "nl": "Narcissengeel" }, { "code": "RAL 1011", "rgb": "138-102-066", "hex": "#8A6642", "de": "Braunbeige", "en": "Brown beige", "fr": "Beige brun", "es": "Beige pardo", "it": "Beige marrone", "nl": "Bruinbeige" }, { "code": "RAL 1012", "rgb": "199-180-070", "hex": "#C7B446", "de": "Zitronengelb", "en": "Lemon yellow", "fr": "Jaune citron", "es": "Amarillo limón", "it": "Giallo limone", "nl": "Citroengeel" }, { "code": "RAL 1013", "rgb": "234-230-202", "hex": "#EAE6CA", "de": "Perlweiß", "en": "Oyster white", "fr": "Blanc perlé", "es": "Blanco perla", "it": "Bianco perla", "nl": "Parelwit" }, { "code": "RAL 1014", "rgb": "225-204-079", "hex": "#E1CC4F", "de": "Elfenbein", "en": "Ivory", "fr": "Ivoire", "es": "Marfil", "it": "Avorio", "nl": "Ivoorkleurig" }, { "code": "RAL 1015", "rgb": "230-214-144", "hex": "#E6D690", "de": "Hellelfenbein", "en": "Light ivory", "fr": "Ivoire clair", "es": "Marfil claro", "it": "Avorio chiaro", "nl": "Licht ivoorkleurig" }, { "code": "RAL 1016", "rgb": "237-255-033", "hex": "#EDFF21", "de": "Schwefelgelb", "en": "Sulfur yellow", "fr": "Jaune soufre", "es": "Amarillo azufre", "it": "Giallo zolfo", "nl": "Zwavelgeel" }, { "code": "RAL 1017", "rgb": "245-208-051", "hex": "#F5D033", "de": "Safrangelb", "en": "Saffron yellow", "fr": "Jaune safran", "es": "Amarillo azafrán", "it": "Giallo zafferano", "nl": "Saffraangeel" }, { "code": "RAL 1018", "rgb": "248-243-053", "hex": "#F8F32B", "de": "Zinkgelb", "en": "Zinc yellow", "fr": "Jaune zinc", "es": "Amarillo de zinc", "it": "Giallo zinco", "nl": "Zinkgeel" }, { "code": "RAL 1019", "rgb": "158-151-100", "hex": "#9E9764", "de": "Graubeige", "en": "Grey beige", "fr": "Beige gris", "es": "Beige agrisado", "it": "Beige grigiastro", "nl": "Grijsbeige" }, { "code": "RAL 1020", "rgb": "153-153-080", "hex": "#999950", "de": "Olivgelb", "en": "Olive yellow", "fr": "Jaune olive", "es": "Amarillo oliva", "it": "Giallo olivastro", "nl": "Olijfgeel" }, { "code": "RAL 1021", "rgb": "243-218-011", "hex": "#F3DA0B", "de": "Rapsgelb", "en": "Rape yellow", "fr": "Jaune colza", "es": "Amarillo colza", "it": "Giallo navone", "nl": "Koolzaadgeel" }, { "code": "RAL 1023", "rgb": "250-210-001", "hex": "#FAD201", "de": "Verkehrsgelb", "en": "Traffic yellow", "fr": "Jaune signalisation", "es": "Amarillo tráfico", "it": "Giallo traffico", "nl": "Verkeersgeel" }, { "code": "RAL 1024", "rgb": "174-160-075", "hex": "#AEA04B", "de": "Ockergelb", "en": "Ochre yellow", "fr": "Jaune ocre", "es": "Amarillo ocre", "it": "Giallo ocra", "nl": "Okergeel" }, { "code": "RAL 1026", "rgb": "255-255-000", "hex": "#FFFF00", "de": "Leuchtgelb", "en": "Luminous yellow", "fr": "Jaune brillant", "es": "Amarillo brillante", "it": "Giallo brillante", "nl": "Briljantgeel" }, { "code": "RAL 1027", "rgb": "157-145-001", "hex": "#9D9101", "de": "Currygelb", "en": "Curry", "fr": "Jaune curry", "es": "Amarillo curry", "it": "Giallo curry", "nl": "Kerriegeel" }, { "code": "RAL 1028", "rgb": "244-169-000", "hex": "#F4A900", "de": "Melonengelb", "en": "Melon yellow", "fr": "Jaune melon", "es": "Amarillo melón", "it": "Giallo melone", "nl": "Meloengeel" }, { "code": "RAL 1032", "rgb": "214-174-001", "hex": "#D6AE01", "de": "Ginstergelb", "en": "Broom yellow", "fr": "Jaune genêt", "es": "Amarillo retama", "it": "Giallo scopa", "nl": "Bremgeel" }, { "code": "RAL 1033", "rgb": "243-165-005", "hex": "#F3A505", "de": "Dahliengelb", "en": "Dahlia yellow", "fr": "Jaune dahlia", "es": "Amarillo dalia", "it": "Giallo dahlien", "nl": "Dahliageel" }, { "code": "RAL 1034", "rgb": "239-169-074", "hex": "#EFA94A", "de": "Pastellgelb", "en": "Pastel yellow", "fr": "Jaune pastel", "es": "Amarillo pastel", "it": "Giallo pastello", "nl": "Pastelgeel" }, { "code": "RAL 1035", "rgb": "106-093-077", "hex": "#6A5D4D", "de": "Perlbeige", "en": "Pearl beige", "fr": "Beige nacré", "es": "Beige perlado", "it": "Beige perlato", "nl": "Parelmoergrijs" }, { "code": "RAL 1036", "rgb": "112-083-053", "hex": "#705335", "de": "Perlgold", "en": "Pearl gold", "fr": "Or nacré", "es": "Oro perlado", "it": "Oro perlato", "nl": "Parelmoergoud" }, { "code": "RAL 1037", "rgb": "243-159-024", "hex": "#F39F18", "de": "Sonnengelb", "en": "Sun yellow", "fr": "Jaune soleil", "es": "Amarillo sol", "it": "Giallo sole", "nl": "Zonnegeel" }, { "code": "RAL 1039", "rgb": "206-193-158", "hex": "#CEC19E", "de": "Sandbeige", "en": "Sandbeige", "fr": "Sandbeige", "es": "Sandbeige", "it": "Sandbeige", "nl": "Sandbeige" }, { "code": "RAL 1040", "rgb": "187-172-129", "hex": "#BBAC81", "de": "Lehmbeige", "en": "Lehmbeige", "fr": "Lehmbeige", "es": "Lehmbeige", "it": "Lehmbeige", "nl": "Lehmbeige" }, { "code": "RAL 2000", "rgb": "237-118-014", "hex": "#ED760E", "de": "Gelborange", "en": "Yellow orange", "fr": "Orangé jaune", "es": "Amarillo naranja", "it": "Arancio giallastro", "nl": "Geeloranje" }, { "code": "RAL 2001", "rgb": "201-060-032", "hex": "#C93C20", "de": "Rotorange", "en": "Red orange", "fr": "Orangé rouge", "es": "Rojo anaranjado", "it": "Arancio rossastro", "nl": "Roodoranje" }, { "code": "RAL 2002", "rgb": "203-040-033", "hex": "#CB2821", "de": "Blutorange", "en": "Vermilion", "fr": "Orangé sang", "es": "Naranja sanguineo", "it": "Arancio sanguigno", "nl": "Vermiljoen" }, { "code": "RAL 2003", "rgb": "255-117-020", "hex": "#FF7514", "de": "Pastellorange", "en": "Pastel orange", "fr": "Orangé pastel", "es": "Naranja pálido", "it": "Arancio pastello", "nl": "Pasteloranje" }, { "code": "RAL 2004", "rgb": "244-070-017", "hex": "#F44611", "de": "Reinorange", "en": "Pure orange", "fr": "Orangé pur", "es": "Naranja puro", "it": "Arancio puro", "nl": "Zuiver oranje" }, { "code": "RAL 2005", "rgb": "255-035-001", "hex": "#FF2301", "de": "Leuchtorange", "en": "Luminous orange", "fr": "Orangé brillant", "es": "Naranja brillante", "it": "Arancio brillante", "nl": "Briljant oranje" }, { "code": "RAL 2007", "rgb": "255-164-032", "hex": "#FFA420", "de": "Leuchthellorange", "en": "Luminous bright orange", "fr": "Orangé clair rillant", "es": "Naranja claro brillante", "it": "Arancio chiaro brillante", "nl": "Briljant lichtoranje" }, { "code": "RAL 2008", "rgb": "247-094-037", "hex": "#F75E25", "de": "Hellrotorange", "en": "Bright red orange", "fr": "Orangé rouge clair", "es": "Rojo claro anaranjado", "it": "Rosso arancio chiaro", "nl": "Licht roodoranje" }, { "code": "RAL 2009", "rgb": "245-064-033", "hex": "#F54021", "de": "Verkehrsorange", "en": "Traffic orange", "fr": "Orangé signalisation", "es": "Naranja tráfico", "it": "Arancio traffico", "nl": "Verkeersoranje" }, { "code": "RAL 2010", "rgb": "216-075-032", "hex": "#D84B20", "de": "Signalorange", "en": "Signal orange", "fr": "Orangé de sécurité", "es": "Naranja señales", "it": "Arancio segnale", "nl": "Signaaloranje" }, { "code": "RAL 2011", "rgb": "236-124-038", "hex": "#EC7C26", "de": "Tieforange", "en": "Deep orange", "fr": "Orangé foncé", "es": "Naranja intenso", "it": "Arancio profondo", "nl": "Dieporanje" }, { "code": "RAL 2012", "rgb": "235-106-014", "hex": "#E55137", "de": "Lachsorange", "en": "Salmon range", "fr": "Orangé saumon", "es": "Naranja salmón", "it": "Arancio salmone", "nl": "Zalmoranje" }, { "code": "RAL 2013", "rgb": "195-088-049", "hex": "#C35831", "de": "Perlorange", "en": "Pearl orange", "fr": "Orangé nacré", "es": "Naranja perlado", "it": "Arancio perlato", "nl": "Parelmoeroranje" }, { "code": "RAL 3000", "rgb": "175-043-030", "hex": "#AF2B1E", "de": "Feuerrot", "en": "Flame red", "fr": "Rouge feu", "es": "Rojo vivo", "it": "Rosso fuoco", "nl": "Vuurrood" }, { "code": "RAL 3001", "rgb": "165-032-025", "hex": "#A52019", "de": "Signalrot", "en": "Signal red", "fr": "Rouge de sécurité", "es": "Rojo señales", "it": "Rosso  segnale", "nl": "Signaalrood" }, { "code": "RAL 3002", "rgb": "162-035-029", "hex": "#A2231D", "de": "Karminrot", "en": "Carmine red", "fr": "Rouge carmin", "es": "Rojo carmin", "it": "Rosso carminio", "nl": "Karmijnrood" }, { "code": "RAL 3003", "rgb": "155-017-030", "hex": "#9B111E", "de": "Rubinrot", "en": "Ruby red", "fr": "Rouge rubis", "es": "Rojo rubí", "it": "Rosso rubino", "nl": "Robijnrood" }, { "code": "RAL 3004", "rgb": "117-021-030", "hex": "#75151E", "de": "Purpurrot", "en": "Purple red", "fr": "Rouge pourpre", "es": "Rojo purpura", "it": "Rosso porpora", "nl": "Purperrood" }, { "code": "RAL 3005", "rgb": "094-033-041", "hex": "#5E2129", "de": "Weinrot", "en": "Wine red", "fr": "Rouge vin", "es": "Rojo vino", "it": "Rosso vino", "nl": "Wijnrood" }, { "code": "RAL 3007", "rgb": "065-034-039", "hex": "#412227", "de": "Schwarzrot", "en": "Black red", "fr": "Rouge noir", "es": "Rojo negruzco", "it": "Rosso nerastro", "nl": "Zwartrood" }, { "code": "RAL 3009", "rgb": "100-036-036", "hex": "#642424", "de": "Oxidrot", "en": "Oxide red", "fr": "Rouge oxyde", "es": "Rojo óxido", "it": "Rosso  ossido", "nl": "Oxyderood" }, { "code": "RAL 3011", "rgb": "120-031-025", "hex": "#781F19", "de": "Braunrot", "en": "Brown red", "fr": "Rouge brun", "es": "Rojo pardo", "it": "Rosso marrone", "nl": "Bruinrood" }, { "code": "RAL 3012", "rgb": "193-135-107", "hex": "#C1876B", "de": "Beigerot", "en": "Beige red", "fr": "Rouge beige", "es": "Rojo beige", "it": "Rosso beige", "nl": "Beigerood" }, { "code": "RAL 3013", "rgb": "161-035-018", "hex": "#A12312", "de": "Tomatenrot", "en": "Tomato red", "fr": "Rouge tomate", "es": "Rojo tomate", "it": "Rosso pomodoro", "nl": "Tomaatrood" }, { "code": "RAL 3014", "rgb": "211-110-112", "hex": "#D36E70", "de": "Altrosa", "en": "Antique pink", "fr": "Vieux rose", "es": "Rojo viejo", "it": "Rosa antico", "nl": "Oudroze" }, { "code": "RAL 3015", "rgb": "234-137-154", "hex": "#EA899A", "de": "Hellrosa", "en": "Light pink", "fr": "Rose clair", "es": "Rosa claro", "it": "Rosa chiaro", "nl": "Lichtroze" }, { "code": "RAL 3016", "rgb": "179-040-033", "hex": "#B32821", "de": "Korallenrot", "en": "Coral red", "fr": "Rouge corail", "es": "Rojo coral", "it": "Rosso corallo", "nl": "Koraalrood" }, { "code": "RAL 3017", "rgb": "230-050-068", "hex": "#E63244", "de": "Rosé", "en": "Rose", "fr": "Rosé", "es": "Rosa", "it": "Rosato", "nl": "Bleekrood" }, { "code": "RAL 3018", "rgb": "213-048-050", "hex": "#D53032", "de": "Erdbeerrot", "en": "Strawberry red", "fr": "Rouge fraise", "es": "Rojo fresa", "it": "Rosso fragola", "nl": "Aardbeirood" }, { "code": "RAL 3020", "rgb": "204-006-005", "hex": "#CC0605", "de": "Verkehrsrot", "en": "Traffic red", "fr": "Rouge signalisation", "es": "Rojo tráfico", "it": "Rosso traffico", "nl": "Verkeersrood" }, { "code": "RAL 3022", "rgb": "217-080-048", "hex": "#D95030", "de": "Lachsrot", "en": "Salmon pink", "fr": "Rouge saumon", "es": "Rojo salmón", "it": "Rosso salmone", "nl": "Zalmrood" }, { "code": "RAL 3024", "rgb": "248-000-000", "hex": "#F80000", "de": "Leuchtrot", "en": "Luminous red", "fr": "Rouge brillant", "es": "Rojo brillante", "it": "Rosso brillante", "nl": "Briljantrood" }, { "code": "RAL 3026", "rgb": "254-000-000", "hex": "#FE0000", "de": "Leuchthellrot", "en": "Luminous bright red", "fr": "Rouge clair brillant", "es": "Rojo claro brillante", "it": "Rosso chiaro brillante", "nl": "Briljant lichtrood" }, { "code": "RAL 3027", "rgb": "197-029-052", "hex": "#C51D34", "de": "Himbeerrot", "en": "Raspberry red", "fr": "Rouge framboise", "es": "Rojo frambuesa", "it": "Rosso lampone", "nl": "Framboosrood" }, { "code": "RAL 3028", "rgb": "203-050-052", "hex": "#CB3234", "de": "Reinrot", "en": "Pure  red", "fr": "Rouge puro", "es": "Rojo puro", "it": "Rosso puro", "nl": "Zuiverrood" }, { "code": "RAL 3031", "rgb": "179-036-040", "hex": "#B32428", "de": "Orientrot", "en": "Orient red", "fr": "Rouge oriental", "es": "Rojo oriente", "it": "Rosso oriente", "nl": "Oriëntrood" }, { "code": "RAL 3032", "rgb": "114-020-034", "hex": "#721422", "de": "Perlrubinrot", "en": "Pearl ruby red", "fr": "Rouge rubis nacré", "es": "Rojo rubí perlado", "it": "Rosso rubino perlato", "nl": "Parelmoer-donkerrood" }, { "code": "RAL 3033", "rgb": "180-076-067", "hex": "#B44C43", "de": "Perlrosa", "en": "Pearl pink", "fr": "Rose nacré", "es": "Rosa perlado", "it": "Rosa perlato", "nl": "Parelmoer-lichtrood" }, { "code": "RAL 4001", "rgb": "222-076-138", "hex": "#6D3F5B", "de": "Rotlila", "en": "Red lilac", "fr": "Lilas rouge", "es": "Rojo lila", "it": "Lilla rossastro", "nl": "Roodlila" }, { "code": "RAL 4002", "rgb": "146-043-062", "hex": "#922B3E", "de": "Rotviolett", "en": "Red violet", "fr": "Violet rouge", "es": "Rojo violeta", "it": "Viola rossastro", "nl": "Roodpaars" }, { "code": "RAL 4003", "rgb": "222-076-138", "hex": "#DE4C8A", "de": "Erikaviolett", "en": "Heather violet", "fr": "Violet bruyère", "es": "Violeta érica", "it": "Viola erica", "nl": "Heidepaars" }, { "code": "RAL 4004", "rgb": "110-028-052", "hex": "#641C34", "de": "Bordeauxviolett", "en": "Claret violet", "fr": "Violet bordeaux", "es": "Burdeos", "it": "Viola bordeaux", "nl": "Bordeauxpaars" }, { "code": "RAL 4005", "rgb": "108-070-117", "hex": "#6C4675", "de": "Blaulila", "en": "Blue lilac", "fr": "Lilas bleu", "es": "Lila azulado", "it": "Lilla bluastro", "nl": "Blauwlila" }, { "code": "RAL 4006", "rgb": "160-052-114", "hex": "#A03472", "de": "Verkehrspurpur", "en": "Traffic purple", "fr": "Pourpre signalisation", "es": "Púrpurá tráfico", "it": "Porpora traffico", "nl": "Verkeerspurper" }, { "code": "RAL 4007", "rgb": "074-025-044", "hex": "#4A192C", "de": "Purpurviolett", "en": "Purple violet", "fr": "Violet pourpre", "es": "Violeta púrpura", "it": "Porpora violetto", "nl": "Purperviolet" }, { "code": "RAL 4008", "rgb": "144-070-132", "hex": "#924E7D", "de": "Signalviolett", "en": "Signal violet", "fr": "Violet de sécurité", "es": "Violeta señales", "it": "Violetto segnale", "nl": "Signaalviolet" }, { "code": "RAL 4009", "rgb": "164-125-144", "hex": "#A18594", "de": "Pastellviolett", "en": "Pastel violet", "fr": "Violet pastel", "es": "Violeta pastel", "it": "Violetto pastello", "nl": "Pastelviolet" }, { "code": "RAL 4010", "rgb": "215-045-109", "hex": "#CF3476", "de": "Telemagenta", "en": "Telemagenta", "fr": "Telemagenta", "es": "Magenta tele", "it": "Tele Magenta", "nl": "Telemagenta" }, { "code": "RAL 4011", "rgb": "134-115-161", "hex": "#8673A1", "de": "Perlviolett", "en": "Pearl violet", "fr": "Violet nacré", "es": "Violeta perlado", "it": "Violetto perlato", "nl": "Parelmoer-donkerviolet" }, { "code": "RAL 4012", "rgb": "108-104-129", "hex": "#6C6874", "de": "Perlbrombeer", "en": "Pearl black berry", "fr": "Mûre nacré", "es": "Morado perlado", "it": "Mora perlato", "nl": "Parelmoer-lichtviolet" }, { "code": "RAL 5000", "rgb": "042-046-075", "hex": "#354D73", "de": "Violettblau", "en": "Violet blue", "fr": "Bleu violet", "es": "Azul violeta", "it": "Blu violaceo", "nl": "Paarsblauw" }, { "code": "RAL 5001", "rgb": "031-052-056", "hex": "#1F3438", "de": "Grünblau", "en": "Green blue", "fr": "Bleu vert", "es": "Azul verdoso", "it": "Blu verdastro", "nl": "Groenblauw" }, { "code": "RAL 5002", "rgb": "032-033-079", "hex": "#20214F", "de": "Ultramarinblau", "en": "Ultramarine blue", "fr": "Bleu outremer", "es": "Azul ultramar", "it": "Blu oltremare", "nl": "Ultramarijnblauw" }, { "code": "RAL 5003", "rgb": "029-030-051", "hex": "#1D1E33", "de": "Saphirblau", "en": "Saphire blue", "fr": "Bleu saphir", "es": "Azul zafiro", "it": "Blu zaffiro", "nl": "Saffierblauw" }, { "code": "RAL 5004", "rgb": "032-033-079", "hex": "#18171C", "de": "Schwarzblau", "en": "Black blue", "fr": "Bleu noir", "es": "Azul negruzco", "it": "Blu nerastro", "nl": "Zwartblauw" }, { "code": "RAL 5005", "rgb": "030-045-110", "hex": "#1E2460", "de": "Signalblau", "en": "Signal blue", "fr": "Bleu de sécurité", "es": "Azul señales", "it": "Blu segnale", "nl": "Signaalblauw" }, { "code": "RAL 5007", "rgb": "062-095-138", "hex": "#3E5F8A", "de": "Brillantblau", "en": "Brillant blue", "fr": "Bleu brillant", "es": "Azul brillante", "it": "Blu brillante", "nl": "Briljantblauw" }, { "code": "RAL 5008", "rgb": "038-037-045", "hex": "#26252D", "de": "Graublau", "en": "Grey blue", "fr": "Bleu gris", "es": "Azul grisáceo", "it": "Blu grigiastro", "nl": "Grijsblauw" }, { "code": "RAL 5009", "rgb": "002-086-105", "hex": "#025669", "de": "Azurblau", "en": "Azure blue", "fr": "Bleu azur", "es": "Azul azur", "it": "Blu  azzurro", "nl": "Azuurblauw" }, { "code": "RAL 5010", "rgb": "014-041-075", "hex": "#0E294B", "de": "Enzianblau", "en": "Gentian blue", "fr": "Bleu gentiane", "es": "Azul genciana", "it": "Blu  genziana", "nl": "Gentiaanblauw" }, { "code": "RAL 5011", "rgb": "035-026-036", "hex": "#231A24", "de": "Stahlblau", "en": "Steel blue", "fr": "Bleu acier", "es": "Azul acero", "it": "Blu acciaio", "nl": "Staalblauw" }, { "code": "RAL 5012", "rgb": "059-131-189", "hex": "#3B83BD", "de": "Lichtblau", "en": "Light blue", "fr": "Bleu clair", "es": "Azul luminoso", "it": "Blu luce", "nl": "Lichtblauw" }, { "code": "RAL 5013", "rgb": "037-041-074", "hex": "#1E213D", "de": "Kobaltblau", "en": "Cobalt blue", "fr": "Bleu cobalt", "es": "Azul cobalto", "it": "Blu cobalto", "nl": "Kobaltblauw" }, { "code": "RAL 5014", "rgb": "096-111-140", "hex": "#606E8C", "de": "Taubenblau", "en": "Pigeon blue", "fr": "Bleu pigeon", "es": "Azul olombino", "it": "Blu colomba", "nl": "Duifblauw" }, { "code": "RAL 5015", "rgb": "034-113-179", "hex": "#2271B3", "de": "Himmelblau", "en": "Sky blue", "fr": "Bleu ciel", "es": "Azul celeste", "it": "Blu cielo", "nl": "Hemelsblauw" }, { "code": "RAL 5017", "rgb": "006-057-113", "hex": "#063971", "de": "Verkehrsblau", "en": "Traffic blue", "fr": "Bleu signalisation", "es": "Azul tráfico", "it": "Blu traffico", "nl": "Verkeersblauw" }, { "code": "RAL 5018", "rgb": "063-136-143", "hex": "#3F888F", "de": "Türkisblau", "en": "Turquoise blue", "fr": "Bleu turquoise", "es": "Azul turquesa", "it": "Blu turchese", "nl": "Turkooisblauw" }, { "code": "RAL 5019", "rgb": "027-085-131", "hex": "#1B5583", "de": "Capriblau", "en": "Capri blue", "fr": "Bleu capri", "es": "Azul capri", "it": "Blu capri", "nl": "Capriblauw" }, { "code": "RAL 5020", "rgb": "029-051-074", "hex": "#1D334A", "de": "Ozeanblau", "en": "Ocean blue", "fr": "Bleu océan", "es": "Azul oceano", "it": "Blu oceano", "nl": "Oceaanblauw" }, { "code": "RAL 5021", "rgb": "037-109-123", "hex": "#256D7B", "de": "Wasserblau", "en": "Water blue", "fr": "Bleu d’eau", "es": "Azul agua", "it": "Blu acqua", "nl": "Waterblauw" }, { "code": "RAL 5022", "rgb": "037-040-080", "hex": "#252850", "de": "Nachtblau", "en": "Night blue", "fr": "Bleu nocturne", "es": "Azul noche", "it": "Blu notte", "nl": "Nachtblauw" }, { "code": "RAL 5023", "rgb": "073-103-141", "hex": "#49678D", "de": "Fernblau", "en": "Distant blue", "fr": "Bleu distant", "es": "Azul lejanía", "it": "Blu distante", "nl": "Verblauw" }, { "code": "RAL 5024", "rgb": "093-155-155", "hex": "#5D9B9B", "de": "Pastellblau", "en": "Pastel blue", "fr": "Bleu pastel", "es": "Azul pastel", "it": "Blu pastello", "nl": "Pastelblauw" }, { "code": "RAL 5025", "rgb": "042-100-120", "hex": "#2A6478", "de": "Perlenzian", "en": "Pearl gentian blue", "fr": "Gentiane nacré", "es": "Gencian perlado", "it": "Blu genziana perlato", "nl": "Parelmoerblauw" }, { "code": "RAL 5026", "rgb": "016-044-084", "hex": "#102C54", "de": "Perlnachtblau", "en": "Pearl night blue", "fr": "Bleu nuit nacré", "es": "Azul noche perlado", "it": "Blu notte perlato", "nl": "Parelmoer-nachtblauw" }, { "code": "RAL 6000", "rgb": "049-102-080", "hex": "#316650", "de": "Patinagrün", "en": "Patina green", "fr": "Vert patine", "es": "Verde patina", "it": "Verde patina", "nl": "Patinagroen" }, { "code": "RAL 6001", "rgb": "040-114-051", "hex": "#287233", "de": "Smaragdgrün", "en": "Emerald green", "fr": "Vert émeraude", "es": "Verde esmeralda", "it": "Verde smeraldo", "nl": "Smaragdgroen" }, { "code": "RAL 6002", "rgb": "045-087-044", "hex": "#2D572C", "de": "Laubgrün", "en": "Leaf green", "fr": "Vert feuillage", "es": "Verde hoja", "it": "Verde foglia", "nl": "Loofgroen" }, { "code": "RAL 6003", "rgb": "066-070-050", "hex": "#424632", "de": "Olivgrün", "en": "Olive green", "fr": "Vert olive", "es": "Verde oliva", "it": "Verde oliva", "nl": "Olijfgroen" }, { "code": "RAL 6004", "rgb": "031-058-061", "hex": "#1F3A3D", "de": "Blaugrün", "en": "Blue green", "fr": "Vert bleu", "es": "Verde azulado", "it": "Verde bluastro", "nl": "Blauwgroen" }, { "code": "RAL 6005", "rgb": "047-069-056", "hex": "#2F4538", "de": "Moosgrün", "en": "Moss green", "fr": "Vert mousse", "es": "Verde musgo", "it": "Verde muschio", "nl": "Mosgroen" }, { "code": "RAL 6006", "rgb": "062-059-050", "hex": "#3E3B32", "de": "Grauoliv", "en": "Grey olive", "fr": "Olive gris", "es": "Oliva grisáceo", "it": "Oliva grigiastro", "nl": "Grijs olijfgroen" }, { "code": "RAL 6007", "rgb": "052-059-041", "hex": "#343B29", "de": "Flaschengrün", "en": "Bottle green", "fr": "Vert bouteille", "es": "Verde botella", "it": "Verde bottiglia", "nl": "Flessegroen" }, { "code": "RAL 6008", "rgb": "057-053-042", "hex": "#39352A", "de": "Braungrün", "en": "Brown green", "fr": "Vert brun", "es": "Verde parduzco", "it": "Verde brunastro", "nl": "Bruingroen" }, { "code": "RAL 6009", "rgb": "049-055-043", "hex": "#31372B", "de": "Tannengrün", "en": "Fir green", "fr": "Vert sapin", "es": "Verde abeto", "it": "Verde abete", "nl": "Dennegroen" }, { "code": "RAL 6010", "rgb": "053-104-045", "hex": "#35682D", "de": "Grasgrün", "en": "Grass green", "fr": "Vert herbe", "es": "Verde hierba", "it": "Verde erba", "nl": "Grasgroen" }, { "code": "RAL 6011", "rgb": "088-114-070", "hex": "#587246", "de": "Resedagrün", "en": "Reseda green", "fr": "Vert réséda", "es": "Verde reseda", "it": "Verde reseda", "nl": "Resedagroen" }, { "code": "RAL 6012", "rgb": "052-062-064", "hex": "#343E40", "de": "Schwarzgrün", "en": "Black green", "fr": "Vert noir", "es": "Verde negruzco", "it": "Verde nerastro", "nl": "Zwartgroen" }, { "code": "RAL 6013", "rgb": "108-113-086", "hex": "#6C7156", "de": "Schilfgrün", "en": "Reed green", "fr": "Vert jonc", "es": "Verde caña", "it": "Verde canna", "nl": "Rietgroen" }, { "code": "RAL 6014", "rgb": "071-064-046", "hex": "#47402E", "de": "Gelboliv", "en": "Yellow olive", "fr": "Olive jaune", "es": "Amarillo oliva", "it": "Oliva giallastro", "nl": "Geel olijfgroen" }, { "code": "RAL 6015", "rgb": "059-060-054", "hex": "#3B3C36", "de": "Schwarzoliv", "en": "Black olive", "fr": "Olive noir", "es": "Oliva negruzco", "it": "Oliva nerastro", "nl": "Zwart olijfgroen" }, { "code": "RAL 6016", "rgb": "030-089-069", "hex": "#1E5945", "de": "Türkisgrün", "en": "Turquoise green", "fr": "Vert turquoise", "es": "Verde turquesa", "it": "Verde turchese", "nl": "Turkooisgroen" }, { "code": "RAL 6017", "rgb": "076-145-065", "hex": "#4C9141", "de": "Maigrün", "en": "May green", "fr": "Vert mai", "es": "Verde mayo", "it": "Verde maggio", "nl": "Meigroen" }, { "code": "RAL 6018", "rgb": "087-166-057", "hex": "#57A639", "de": "Gelbgrün", "en": "Yellow green", "fr": "Vert jaune", "es": "Verde amarillento", "it": "Verde giallastro", "nl": "Geelgroen" }, { "code": "RAL 6019", "rgb": "189-236-182", "hex": "#BDECB6", "de": "Weißgrün", "en": "Pastel green", "fr": "Vert blanc", "es": "Verde lanquecino", "it": "Verde biancastro", "nl": "Witgroen" }, { "code": "RAL 6020", "rgb": "046-058-035", "hex": "#2E3A23", "de": "Chromoxidgrün", "en": "Chrome green", "fr": "Vert oxyde chromique", "es": "Verde cromo", "it": "Verde cromo", "nl": "Chroom-oxydegroen" }, { "code": "RAL 6021", "rgb": "137-172-118", "hex": "#89AC76", "de": "Blassgrün", "en": "Pale green", "fr": "Vert pâle", "es": "Verde pálido", "it": "Verde pallido", "nl": "Bleekgroen" }, { "code": "RAL 6022", "rgb": "037-034-027", "hex": "#25221B", "de": "Braunoliv", "en": "Olive drab", "fr": "Olive brun", "es": "Oliva parduzco", "it": "Oliva brunastro", "nl": "Bruin olijfgroen" }, { "code": "RAL 6024", "rgb": "048-132-070", "hex": "#308446", "de": "Verkehrsgrün", "en": "Traffic green", "fr": "Vert signalisation", "es": "Verde tráfico", "it": "Verde traffico", "nl": "Verkeersgroen" }, { "code": "RAL 6025", "rgb": "061-100-045", "hex": "#3D642D", "de": "Farngrün", "en": "Fern green", "fr": "Vert fougère", "es": "Verde helecho", "it": "Verde felce", "nl": "Varengroen" }, { "code": "RAL 6026", "rgb": "001-093-082", "hex": "#015D52", "de": "Opalgrün", "en": "Opal green", "fr": "Vert opale", "es": "Verde opalo", "it": "Verde opale", "nl": "Opaalgroen" }, { "code": "RAL 6027", "rgb": "132-195-190", "hex": "#84C3BE", "de": "Lichtgrün", "en": "Light green", "fr": "Vert clair", "es": "Verde luminoso", "it": "Verde chiaro", "nl": "Lichtgroen" }, { "code": "RAL 6028", "rgb": "044-085-069", "hex": "#2C5545", "de": "Kieferngrün", "en": "Pine green", "fr": "Vert pin", "es": "Verde pino", "it": "Verde pino", "nl": "Pijnboomgroen" }, { "code": "RAL 6029", "rgb": "032-096-061", "hex": "#20603D", "de": "Minzgrün", "en": "Mint green", "fr": "Vert menthe", "es": "Verde menta", "it": "Verde menta", "nl": "Mintgroen" }, { "code": "RAL 6031", "rgb": "072-087-070", "hex": "#485746", "de": "Bronzegrün", "en": "Bronzegrün", "fr": "Bronzegrün", "es": "Bronzegrün", "it": "Bronzegrün", "nl": "Bronzegrün" }, { "code": "RAL 6032", "rgb": "049-127-067", "hex": "#317F43", "de": "Signalgrün", "en": "Signal green", "fr": "Vert de sécurité", "es": "Verde señales", "it": "Verde segnale", "nl": "Signaalgroen" }, { "code": "RAL 6033", "rgb": "073-126-118", "hex": "#497E76", "de": "Minttürkis", "en": "Mint turquoise", "fr": "Turquoise menthe", "es": "Turquesa menta", "it": "Turchese menta", "nl": "Mintturquoise" }, { "code": "RAL 6034", "rgb": "127-181-181", "hex": "#7FB5B5", "de": "Pastelltürkis", "en": "Pastel turquoise", "fr": "Turquoise pastel", "es": "Turquesa pastel", "it": "Turchese pastello", "nl": "Pastelturquoise" }, { "code": "RAL 6035", "rgb": "028-084-045", "hex": "#1C542D", "de": "Perlgrün", "en": "Pearl green", "fr": "Vert nacré", "es": "Verde perlado", "it": "Verde perlato", "nl": "Parelmoer-donkergroen" }, { "code": "RAL 6036", "rgb": "022-053-055", "hex": "#193737", "de": "Perlopalgrün", "en": "Pearl opal green", "fr": "Vert opal nacré", "es": "Verde ópalo perlado", "it": "Verde opalo perlato", "nl": "Parelmoer-lichtgroen" }, { "code": "RAL 6037", "rgb": "000-143-057", "hex": "#008F39", "de": "Reingrün", "en": "Pure green", "fr": "Vert pur", "es": "Verde puro", "it": "Verde puro", "nl": "Zuivergroen" }, { "code": "RAL 6038", "rgb": "000-187-045", "hex": "#00BB2D", "de": "Leuchtgrün", "en": "Luminous green", "fr": "Vert brillant", "es": "Verde brillante", "it": "Verde brillante", "nl": "Briljantgroen" }, { "code": "RAL 6040", "rgb": "130-126-88", "hex": "#827E58", "de": "Helloliv", "en": "Helloliv", "fr": "Helloliv", "es": "Helloliv", "it": "Helloliv", "nl": "Helloliv" }, { "code": "RAL 7000", "rgb": "120-133-139", "hex": "#78858B", "de": "Fehgrau", "en": "Squirrel grey", "fr": "Gris petit-gris", "es": "Gris ardilla", "it": "Grigio vaio", "nl": "Pelsgrijs" }, { "code": "RAL 7001", "rgb": "138-149-151", "hex": "#8A9597", "de": "Silbergrau", "en": "Silver grey", "fr": "Gris argent", "es": "Gris plata", "it": "Grigio argento", "nl": "Zilvergrijs" }, { "code": "RAL 7002", "rgb": "126-123-082", "hex": "#7E7B52", "de": "Olivgrau", "en": "Olive grey", "fr": "Gris olive", "es": "Gris oliva", "it": "Grigio olivastro", "nl": "Olijfgrijs" }, { "code": "RAL 7003", "rgb": "108-112-089", "hex": "#6C7059", "de": "Moosgrau", "en": "Moss grey", "fr": "Gris mousse", "es": "Gris musgo", "it": "Grigio muschio", "nl": "Mosgrijs" }, { "code": "RAL 7004", "rgb": "150-153-146", "hex": "#969992", "de": "Signalgrau", "en": "Signal grey", "fr": "Gris de sécurité", "es": "Gris señales", "it": "Grigio segnale", "nl": "Signaalgrijs" }, { "code": "RAL 7005", "rgb": "100-107-099", "hex": "#646B63", "de": "Mausgrau", "en": "Mouse grey", "fr": "Gris souris", "es": "Gris ratón", "it": "Grigio topo", "nl": "Muisgrijs" }, { "code": "RAL 7006", "rgb": "109-101-082", "hex": "#6D6552", "de": "Beigegrau", "en": "Beige grey", "fr": "Gris beige", "es": "Gris beige", "it": "Grigio beige", "nl": "Beigegrijs" }, { "code": "RAL 7008", "rgb": "106-095-049", "hex": "#6A5F31", "de": "Khakigrau", "en": "Khaki grey", "fr": "Gris kaki", "es": "Gris caqui", "it": "Grigio kaki", "nl": "Kakigrijs" }, { "code": "RAL 7009", "rgb": "077-086-069", "hex": "#4D5645", "de": "Grüngrau", "en": "Green grey", "fr": "Gris vert", "es": "Gris verdoso", "it": "Grigio verdastro", "nl": "Groengrijs" }, { "code": "RAL 7010", "rgb": "076-081-074", "hex": "#4C514A", "de": "Zeltgrau", "en": "Tarpaulin grey", "fr": "Gris tente", "es": "Gris lona", "it": "Grigio tenda", "nl": "Zeildoekgrijs" }, { "code": "RAL 7011", "rgb": "067-075-077", "hex": "#434B4D", "de": "Eisengrau", "en": "Iron grey", "fr": "Gris fer", "es": "Gris hierro", "it": "Grigio ferro", "nl": "IJzergrijs" }, { "code": "RAL 7012", "rgb": "078-087-084", "hex": "#4E5754", "de": "Basaltgrau", "en": "Basalt grey", "fr": "Gris basalte", "es": "Gris basalto", "it": "Grigio basalto", "nl": "Bazaltgrijs" }, { "code": "RAL 7013", "rgb": "070-069-049", "hex": "#464531", "de": "Braungrau", "en": "Brown grey", "fr": "Gris brun", "es": "Gris parduzco", "it": "Grigio brunastro", "nl": "Bruingrijs" }, { "code": "RAL 7015", "rgb": "067-071-080", "hex": "#434750", "de": "Schiefergrau", "en": "Slate grey", "fr": "Gris ardoise", "es": "Gris pizarra", "it": "Grigio ardesia", "nl": "Leigrijs" }, { "code": "RAL 7016", "rgb": "041-049-051", "hex": "#293133", "de": "Anthrazitgrau", "en": "Anthracite grey", "fr": "Gris anthracite", "es": "Gris antracita", "it": "Grigio antracite", "nl": "Antracietgrijs" }, { "code": "RAL 7021", "rgb": "035-040-043", "hex": "#23282B", "de": "Schwarzgrau", "en": "Black grey", "fr": "Gris noir", "es": "Gris negruzco", "it": "Grigio nerastro", "nl": "Zwartgrijs" }, { "code": "RAL 7022", "rgb": "051-047-044", "hex": "#332F2C", "de": "Umbragrau", "en": "Umbra grey", "fr": "Gris terre d’ombre", "es": "Gris sombra", "it": "Grigio ombra", "nl": "Ombergrijs" }, { "code": "RAL 7023", "rgb": "104-108-094", "hex": "#686C5E", "de": "Betongrau", "en": "Concrete grey", "fr": "Gris béton", "es": "Gris hormigón", "it": "Grigio calcestruzzo", "nl": "Betongrijs" }, { "code": "RAL 7024", "rgb": "071-074-081", "hex": "#474A51", "de": "Graphitgrau", "en": "Graphite grey", "fr": "Gris graphite", "es": "Gris grafita", "it": "Grigio grafite", "nl": "Grafietgrijs" }, { "code": "RAL 7026", "rgb": "047-053-059", "hex": "#2F353B", "de": "Granitgrau", "en": "Granite grey", "fr": "Gris granit", "es": "Gris granito", "it": "Grigio granito", "nl": "Granietgrijs" }, { "code": "RAL 7030", "rgb": "139-140-122", "hex": "#8B8C7A", "de": "Steingrau", "en": "Stone grey", "fr": "Gris pierre", "es": "Gris piedra", "it": "Grigio pietra", "nl": "Steengrijs" }, { "code": "RAL 7031", "rgb": "071-075-078", "hex": "#474B4E", "de": "Blaugrau", "en": "Blue grey", "fr": "Gris bleu", "es": "Gris azulado", "it": "Grigio bluastro", "nl": "Blauwgrijs" }, { "code": "RAL 7032", "rgb": "184-183-153", "hex": "#B8B799", "de": "Kieselgrau", "en": "Pebble grey", "fr": "Gris silex", "es": "Gris guijarro", "it": "Grigio ghiaia", "nl": "Kiezelgrijs" }, { "code": "RAL 7033", "rgb": "125-132-113", "hex": "#7D8471", "de": "Zementgrau", "en": "Cement grey", "fr": "Gris ciment", "es": "Gris cemento", "it": "Grigio cemento", "nl": "Cementgrijs" }, { "code": "RAL 7034", "rgb": "143-139-102", "hex": "#8F8B66", "de": "Gelbgrau", "en": "Yellow grey", "fr": "Gris jaune", "es": "Gris amarillento", "it": "Grigio giallastro", "nl": "Geelgrijs" }, { "code": "RAL 7035", "rgb": "215-215-215", "hex": "#D7D7D7", "de": "Lichtgrau", "en": "Light grey", "fr": "Gris clair", "es": "Gris luminoso", "it": "Grigio luce", "nl": "Lichtgrijs" }, { "code": "RAL 7036", "rgb": "127-118-121", "hex": "#7F7679", "de": "Platingrau", "en": "Platinum grey", "fr": "Gris platine", "es": "Gris platino", "it": "Grigio platino", "nl": "Platinagrijs" }, { "code": "RAL 7037", "rgb": "125-127-120", "hex": "#7D7F7D", "de": "Staubgrau", "en": "Dusty grey", "fr": "Gris poussière", "es": "Gris polvo", "it": "Grigio polvere", "nl": "Stofgrijs" }, { "code": "RAL 7038", "rgb": "195-195-195", "hex": "#B5B8B1", "de": "Achatgrau", "en": "Agate grey", "fr": "Gris agate", "es": "Gris ágata", "it": "Grigio agata", "nl": "Agaatgrijs" }, { "code": "RAL 7039", "rgb": "108-105-096", "hex": "#6C6960", "de": "Quarzgrau", "en": "Quartz grey", "fr": "Gris quartz", "es": "Gris cuarzo", "it": "Grigio quarzo", "nl": "Kwartsgrijs" }, { "code": "RAL 7040", "rgb": "157-161-170", "hex": "#9DA1AA", "de": "Fenstergrau", "en": "Window grey", "fr": "Gris fenêtre", "es": "Gris ventana", "it": "Grigio finestra", "nl": "Venstergrijs" }, { "code": "RAL 7042", "rgb": "141-148-141", "hex": "#8D948D", "de": "Verkehrsgrau A", "en": "Traffic grey A", "fr": "Gris signalisation A", "es": "Gris tráfico A", "it": "Grigio traffico A", "nl": "Verkeesgrijs A" }, { "code": "RAL 7043", "rgb": "078-084-082", "hex": "#4E5452", "de": "Verkehrsgrau B", "en": "Traffic grey B", "fr": "Gris signalisation B", "es": "Gris tráfico B", "it": "Grigio traffico B", "nl": "Verkeersgrijs B" }, { "code": "RAL 7044", "rgb": "202-196-176", "hex": "#CAC4B0", "de": "Seidengrau", "en": "Silk grey", "fr": "Gris soie", "es": "Gris seda", "it": "Grigio seta", "nl": "Zijdegrijs" }, { "code": "RAL 7045", "rgb": "144-144-144", "hex": "#909090", "de": "Telegrau 1", "en": "Telegrey 1", "fr": "Telegris 1", "es": "Gris tele 1", "it": "Tele grigio 1", "nl": "Telegrijs 1" }, { "code": "RAL 7046", "rgb": "130-137-143", "hex": "#82898F", "de": "Telegrau 2", "en": "Telegrey 2", "fr": "Telegris 2", "es": "Gris tele 2", "it": "Tele grigio 2", "nl": "Telegrijs 2" }, { "code": "RAL 7047", "rgb": "208-208-208", "hex": "#D0D0D0", "de": "Telegrau 4", "en": "Telegrey 4", "fr": "Telegris 4", "es": "Gris tele 4", "it": "Tele grigio 4", "nl": "Telegrijs 4" }, { "code": "RAL 7048", "rgb": "137-129-118", "hex": "#898176", "de": "Perlmausgrau", "en": "Pearl mouse grey", "fr": "Gris souris nacré", "es": "Gris musgo perlado", "it": "Grigio topo perlato", "nl": "Parelmoer-muisgrijs" }, { "code": "RAL 7050", "rgb": "130-136-122", "hex": "#82887A", "de": "Tarngrau", "en": "Tarngrau", "fr": "Tarngrau", "es": "Tarngrau", "it": "Tarngrau", "nl": "Tarngrau" }, { "code": "RAL 8000", "rgb": "130-108-052", "hex": "#826C34", "de": "Grünbraun", "en": "Green brown", "fr": "Brun vert", "es": "Pardo verdoso", "it": "Marrone verdastro", "nl": "Groenbruin" }, { "code": "RAL 8001", "rgb": "149-095-032", "hex": "#955F20", "de": "Ockerbraun", "en": "Ochre brown", "fr": "Brun terre de Sienne", "es": "Pardo ocre", "it": "Marrone ocra", "nl": "Okerbruin" }, { "code": "RAL 8002", "rgb": "108-059-042", "hex": "#6C3B2A", "de": "Signalbraun", "en": "Signal brown", "fr": "Brun de sécurité", "es": "Marrón señales", "it": "Marrone segnale", "nl": "Signaalbruin" }, { "code": "RAL 8003", "rgb": "115-066-034", "hex": "#734222", "de": "Lehmbraun", "en": "Clay brown", "fr": "Brun argile", "es": "Pardo arcilla", "it": "Marrone fango", "nl": "Leembruin" }, { "code": "RAL 8004", "rgb": "142-064-042", "hex": "#8E402A", "de": "Kupferbraun", "en": "Copper brown", "fr": "Brun cuivré", "es": "Pardo cobre", "it": "Marrone rame", "nl": "Koperbruin" }, { "code": "RAL 8007", "rgb": "089-053-031", "hex": "#59351F", "de": "Rehbraun", "en": "Fawn brown", "fr": "Brun fauve", "es": "Pardo corzo", "it": "Marrone capriolo", "nl": "Reebruin" }, { "code": "RAL 8008", "rgb": "111-079-040", "hex": "#6F4F28", "de": "Olivbraun", "en": "Olive brown", "fr": "Brun olive", "es": "Pardo oliva", "it": "Marrone oliva", "nl": "Olijfbruin" }, { "code": "RAL 8011", "rgb": "091-058-041", "hex": "#5B3A29", "de": "Nussbraun", "en": "Nut brown", "fr": "Brun noisette", "es": "Pardo nuez", "it": "Marrone noce", "nl": "Notebruin" }, { "code": "RAL 8012", "rgb": "089-035-033", "hex": "#592321", "de": "Rotbraun", "en": "Red brown", "fr": "Brun rouge", "es": "Pardo rojo", "it": "Marrone rossiccio", "nl": "Roodbruin" }, { "code": "RAL 8014", "rgb": "056-044-030", "hex": "#382C1E", "de": "Sepiabraun", "en": "Sepia brown", "fr": "Brun sépia", "es": "Sepia", "it": "Marrone seppia", "nl": "Sepiabruin" }, { "code": "RAL 8015", "rgb": "099-058-052", "hex": "#633A34", "de": "Kastanienbraun", "en": "Chestnut brown", "fr": "Marron", "es": "Castaño", "it": "Marrone castagna", "nl": "Kastanjebruin" }, { "code": "RAL 8016", "rgb": "076-047-039", "hex": "#4C2F27", "de": "Mahagonibraun", "en": "Mahogany brown", "fr": "Brun acajou", "es": "Caoba", "it": "Marrone mogano", "nl": "Mahoniebruin" }, { "code": "RAL 8017", "rgb": "069-050-046", "hex": "#45322E", "de": "Schokoladen-braun", "en": "Chocolate brown", "fr": "Brun chocolat", "es": "Chocolate", "it": "Marrone cioccolata", "nl": "Chocoladebruin" }, { "code": "RAL 8019", "rgb": "064-058-058", "hex": "#403A3A", "de": "Graubraun", "en": "Grey brown", "fr": "Brun gris", "es": "Pardo grisáceo", "it": "Marrone grigiastro", "nl": "Grijsbruin" }, { "code": "RAL 8022", "rgb": "033-033-033", "hex": "#212121", "de": "Schwarzbraun", "en": "Black brown", "fr": "Brun noir", "es": "Pardo negruzco", "it": "Marrone nerastro", "nl": "Zwartbruin" }, { "code": "RAL 8023", "rgb": "166-094-046", "hex": "#A65E2E", "de": "Orangebraun", "en": "Orange brown", "fr": "Brun orangé", "es": "Pardo anaranjado", "it": "Marrone arancio", "nl": "Oranjebruin" }, { "code": "RAL 8024", "rgb": "121-085-061", "hex": "#79553D", "de": "Beigebraun", "en": "Beige brown", "fr": "Brun beige", "es": "Pardo beige", "it": "Marrone beige", "nl": "Beigebruin" }, { "code": "RAL 8025", "rgb": "117-092-072", "hex": "#755C48", "de": "Blassbraun", "en": "Pale brown", "fr": "Brun pâle", "es": "Pardo pálido", "it": "Marrone pallido", "nl": "Bleekbruin" }, { "code": "RAL 8027", "rgb": "080-073-056", "hex": "#504938", "de": "Lederbraun", "en": "Lederbraun", "fr": "Lederbraun", "es": "Lederbraun", "it": "Lederbraun", "nl": "Lederbraun" }, { "code": "RAL 8028", "rgb": "078-059-049", "hex": "#4E3B31", "de": "Terrabraun", "en": "Terra brown", "fr": "Brun terre", "es": "Marrón tierra", "it": "Marrone terra", "nl": "Terrabruin" }, { "code": "RAL 8029", "rgb": "118-060-040", "hex": "#763C28", "de": "Perlkupfer", "en": "Pearl copper", "fr": "Cuivre nacré", "es": "Cobre perlado", "it": "Rame perlato", "nl": "Parelmoerkoper" }, { "code": "RAL 8031", "rgb": "180-157-123", "hex": "#B49D7B", "de": "Sandbraun", "en": "Sandbraun", "fr": "Sandbraun", "es": "Sandbraun", "it": "Sandbraun", "nl": "Sandbraun" }, { "code": "RAL 9001", "rgb": "250-244-227", "hex": "#FDF4E3", "de": "Cremeweiß", "en": "Cream", "fr": "Blanc crème", "es": "Blanco crema", "it": "Bianco crema", "nl": "Crèmewit" }, { "code": "RAL 9002", "rgb": "231-235-218", "hex": "#E7EBDA", "de": "Grauweiß", "en": "Grey white", "fr": "Blanc gris", "es": "Blanco grisáceo", "it": "Bianco grigiastro", "nl": "Grijswit" }, { "code": "RAL 9003", "rgb": "244-244-244", "hex": "#F4F4F4", "de": "Signalweiß", "en": "Signal white", "fr": "Blanc de sécurité", "es": "Blanco señales", "it": "Bianco segnale", "nl": "Signaalwit" }, { "code": "RAL 9004", "rgb": "040-040-040", "hex": "#282828", "de": "Signalschwarz", "en": "Signal black", "fr": "Noir de sécurité", "es": "Negro señales", "it": "Nero segnale", "nl": "Signaalzwart" }, { "code": "RAL 9005", "rgb": "010-010-013", "hex": "#0A0A0A", "de": "Tiefschwarz", "en": "Jet black", "fr": "Noir foncé", "es": "Negro intenso", "it": "Nero intenso", "nl": "Gitzwart" }, { "code": "RAL 9006", "rgb": "165-165-165", "hex": "#A5A5A5", "de": "Weißaluminium", "en": "White aluminium", "fr": "Aluminium blanc", "es": "Aluminio blanco", "it": "Aluminio brillante", "nl": "Blank aluminiumkleurig" }, { "code": "RAL 9007", "rgb": "143-143-143", "hex": "#8F8F8F", "de": "Graualuminium", "en": "Grey aluminium", "fr": "Aluminium gris", "es": "Aluminio gris", "it": "Aluminio grigiastro", "nl": "Grijs aluminiumkleurig" }, { "code": "RAL 9010", "rgb": "255-255-255", "hex": "#FFFFFF", "de": "Reinweiß", "en": "Pure white", "fr": "Blanc pur", "es": "Blanco puro", "it": "Bianco puro", "nl": "Zuiverwit" }, { "code": "RAL 9011", "rgb": "028-028-028", "hex": "#1C1C1C", "de": "Graphitschwarz", "en": "Graphite black", "fr": "Noir graphite", "es": "Negro grafito", "it": "Nero grafite", "nl": "Grafietzwart" }, { "code": "RAL 9016", "rgb": "246-246-246", "hex": "#F6F6F6", "de": "Verkehrsweiß", "en": "Traffic white", "fr": "Blanc signalisation", "es": "Blanco tráfico", "it": "Bianco traffico", "nl": "Verkeerswit" }, { "code": "RAL 9017", "rgb": "030-030-030", "hex": "#1E1E1E", "de": "Verkehrs-schwarz", "en": "Traffic black", "fr": "Noir signalisation", "es": "Negro tráfico", "it": "Nero traffico", "nl": "Verkeerszwart" }, { "code": "RAL 9018", "rgb": "215-215-215", "hex": "#D7D7D7", "de": "Papyrusweiß", "en": "Papyrus white", "fr": "Blanc papyrus", "es": "Blanco papiro", "it": "Bianco papiro", "nl": "Papyruswit" }, { "code": "RAL 9020", "rgb": "253-253-253", "hex": "#FDFDFD", "de": "Seidenmattweiß", "en": "Seidenmattweiß", "fr": "Seidenmattweiß", "es": "Seidenmattweiß", "it": "Seidenmattweiß", "nl": "Seidenmattweiß" }, { "code": "RAL 9021", "rgb": "001-005-014", "hex": "#01050E", "de": "Teerschwarz", "en": "Teerschwarz", "fr": "Teerschwarz", "es": "Teerschwarz", "it": "Teerschwarz", "nl": "Teerschwarz" }, { "code": "RAL 9022", "rgb": "156-156-156", "hex": "#9C9C9C", "de": "Perlhellgrau", "en": "Pearl light grey", "fr": "Gris clair nacré", "es": "Gris claro perlado", "it": "Grigio chiaro perlato", "nl": "Parelmoer-lichtgrijs" }, { "code": "RAL 9023", "rgb": "130-130-130", "hex": "#828282", "de": "Perldunkelgrau", "en": "Pearl dark grey", "fr": "Gris fonçé nacré", "es": "Gris oscuro perlado", "it": "Grigio scuro perlato", "nl": "Parelmoer-donkergrijs" }];
        for (var i = 0; i < ralSwatches.length; i++) swatches.push(ralSwatches[i]);
    }
    if (includeNCS || colorSystems == "*") {
        // From view-source: https://www.w3schools.com/colors/colors_ncs.asp
        // Converted manually
        var ncsSwatches = [{"code":"S 0300-N","hex":"#f7f7f7"},{"code":"S 0500-N","hex":"#f2f2f2"},{"code":"S 0502-B","hex":"#f5fbff"},{"code":"S 0502-B50G","hex":"#f7fffe"},{"code":"S 0502-G","hex":"#f4fff8"},{"code":"S 0502-G50Y","hex":"#fdfff6"},{"code":"S 0502-R","hex":"#fff1f2"},{"code":"S 0502-R50B","hex":"#fef6fd"},{"code":"S 0502-Y","hex":"#fffdf6"},{"code":"S 0502-Y50R","hex":"#fef8f4"},{"code":"S 0505-B","hex":"#e8f6fe"},{"code":"S 0505-B20G","hex":"#eafbff"},{"code":"S 0505-B50G","hex":"#ecfffe"},{"code":"S 0505-B80G","hex":"#eafffa"},{"code":"S 0505-G","hex":"#e4ffef"},{"code":"S 0505-G10Y","hex":"#ecffec"},{"code":"S 0505-G20Y","hex":"#f1ffeb"},{"code":"S 0505-G30Y","hex":"#f4ffea"},{"code":"S 0505-G40Y","hex":"#f7ffe9"},{"code":"S 0505-G50Y","hex":"#faffea"},{"code":"S 0505-G60Y","hex":"#fcffeb"},{"code":"S 0505-G70Y","hex":"#feffeb"},{"code":"S 0505-G80Y","hex":"#fffeec"},{"code":"S 0505-G90Y","hex":"#fefdeb"},{"code":"S 0505-R","hex":"#ffdee0"},{"code":"S 0505-R10B","hex":"#ffdfe3"},{"code":"S 0505-R20B","hex":"#ffe1e7"},{"code":"S 0505-R30B","hex":"#ffe3ec"},{"code":"S 0505-R40B","hex":"#fee6f2"},{"code":"S 0505-R50B","hex":"#ffeafb"},{"code":"S 0505-R60B","hex":"#f8e9fe"},{"code":"S 0505-R70B","hex":"#f0e8ff"},{"code":"S 0505-R80B","hex":"#e1e6ff"},{"code":"S 0505-R90B","hex":"#e3ecfe"},{"code":"S 0505-Y","hex":"#fffbea"},{"code":"S 0505-Y10R","hex":"#fffaea"},{"code":"S 0505-Y20R","hex":"#fff7e9"},{"code":"S 0505-Y30R","hex":"#fff5e8"},{"code":"S 0505-Y40R","hex":"#fff3e6"},{"code":"S 0505-Y50R","hex":"#fff0e5"},{"code":"S 0505-Y60R","hex":"#feede4"},{"code":"S 0505-Y70R","hex":"#ffe9e2"},{"code":"S 0505-Y80R","hex":"#fee5e0"},{"code":"S 0505-Y90R","hex":"#ffe2e0"},{"code":"S 0507-B","hex":"#dff3ff"},{"code":"S 0507-B20G","hex":"#e3faff"},{"code":"S 0507-B80G","hex":"#e2fff8"},{"code":"S 0507-G","hex":"#dbffe9"},{"code":"S 0507-G40Y","hex":"#f4ffe0"},{"code":"S 0507-G80Y","hex":"#fffee4"},{"code":"S 0507-R","hex":"#ffd2d5"},{"code":"S 0507-R20B","hex":"#ffd6de"},{"code":"S 0507-R40B","hex":"#ffddee"},{"code":"S 0507-R60B","hex":"#f5e0ff"},{"code":"S 0507-R80B","hex":"#d6ddff"},{"code":"S 0507-Y","hex":"#fffae3"},{"code":"S 0507-Y20R","hex":"#fff5e0"},{"code":"S 0507-Y40R","hex":"#ffeedd"},{"code":"S 0507-Y60R","hex":"#ffe6da"},{"code":"S 0507-Y80R","hex":"#fedcd5"},{"code":"S 0510-B","hex":"#d3eeff"},{"code":"S 0510-B10G","hex":"#d6f4ff"},{"code":"S 0510-B30G","hex":"#d9fbff"},{"code":"S 0510-B50G","hex":"#dafffd"},{"code":"S 0510-B70G","hex":"#d8fef9"},{"code":"S 0510-B90G","hex":"#d1ffea"},{"code":"S 0510-G","hex":"#cdffe0"},{"code":"S 0510-G10Y","hex":"#dbffdc"},{"code":"S 0510-G20Y","hex":"#e4ffd9"},{"code":"S 0510-G30Y","hex":"#ebffd6"},{"code":"S 0510-G40Y","hex":"#f0ffd4"},{"code":"S 0510-G50Y","hex":"#f5ffd6"},{"code":"S 0510-G60Y","hex":"#f9ffd8"},{"code":"S 0510-G70Y","hex":"#fdffd9"},{"code":"S 0510-G80Y","hex":"#fffdda"},{"code":"S 0510-G90Y","hex":"#fefbd8"},{"code":"S 0510-R","hex":"#ffc2c6"},{"code":"S 0510-R10B","hex":"#ffc4cb"},{"code":"S 0510-R20B","hex":"#ffc7d2"},{"code":"S 0510-R30B","hex":"#ffcbdb"},{"code":"S 0510-R40B","hex":"#ffd0e7"},{"code":"S 0510-R50B","hex":"#ffd7f7"},{"code":"S 0510-R60B","hex":"#f1d4ff"},{"code":"S 0510-R70B","hex":"#e3d4ff"},{"code":"S 0510-R80B","hex":"#c6d1ff"},{"code":"S 0510-R90B","hex":"#cbdcff"},{"code":"S 0510-Y","hex":"#fff9d8"},{"code":"S 0510-Y10R","hex":"#fff5d6"},{"code":"S 0510-Y20R","hex":"#fff1d4"},{"code":"S 0510-Y30R","hex":"#ffedd2"},{"code":"S 0510-Y40R","hex":"#ffe8d0"},{"code":"S 0510-Y50R","hex":"#ffe3ce"},{"code":"S 0510-Y60R","hex":"#ffddcc"},{"code":"S 0510-Y70R","hex":"#fed7c9"},{"code":"S 0510-Y80R","hex":"#ffd0c6"},{"code":"S 0510-Y90R","hex":"#ffc9c5"},{"code":"S 0515-B","hex":"#c0e7ff"},{"code":"S 0515-B20G","hex":"#c5f5fe"},{"code":"S 0515-B50G","hex":"#c8fffd"},{"code":"S 0515-B80G","hex":"#c4fff1"},{"code":"S 0515-G","hex":"#b8ffd4"},{"code":"S 0515-G20Y","hex":"#d8ffc8"},{"code":"S 0515-G40Y","hex":"#eaffc1"},{"code":"S 0515-G60Y","hex":"#f7fec6"},{"code":"S 0515-G80Y","hex":"#fffdc8"},{"code":"S 0515-G90Y","hex":"#fff9c7"},{"code":"S 0515-R","hex":"#feaaaf"},{"code":"S 0515-R10B","hex":"#feadb7"},{"code":"S 0515-R20B","hex":"#feb1c0"},{"code":"S 0515-R40B","hex":"#ffbcdd"},{"code":"S 0515-R60B","hex":"#ebc1ff"},{"code":"S 0515-R80B","hex":"#b0befe"},{"code":"S 0515-R90B","hex":"#b6ceff"},{"code":"S 0515-Y","hex":"#fff6c6"},{"code":"S 0515-Y10R","hex":"#fff1c4"},{"code":"S 0515-Y20R","hex":"#ffebc1"},{"code":"S 0515-Y30R","hex":"#ffe5bf"},{"code":"S 0515-Y40R","hex":"#ffdebc"},{"code":"S 0515-Y50R","hex":"#ffd7b9"},{"code":"S 0515-Y60R","hex":"#ffcfb6"},{"code":"S 0515-Y70R","hex":"#ffc6b3"},{"code":"S 0515-Y80R","hex":"#ffbdaf"},{"code":"S 0515-Y90R","hex":"#ffb4ae"},{"code":"S 0520-B","hex":"#aee0ff"},{"code":"S 0520-B10G","hex":"#b2ebff"},{"code":"S 0520-B30G","hex":"#b6f8ff"},{"code":"S 0520-B40G","hex":"#b8fcff"},{"code":"S 0520-B50G","hex":"#b8fffc"},{"code":"S 0520-B60G","hex":"#b7fff8"},{"code":"S 0520-B70G","hex":"#b5fff4"},{"code":"S 0520-B90G","hex":"#abffd9"},{"code":"S 0520-G","hex":"#a5ffc8"},{"code":"S 0520-G10Y","hex":"#bdffc0"},{"code":"S 0520-G20Y","hex":"#cdffb9"},{"code":"S 0520-G30Y","hex":"#daffb4"},{"code":"S 0520-G40Y","hex":"#e4ffb0"},{"code":"S 0520-G50Y","hex":"#edffb3"},{"code":"S 0520-G60Y","hex":"#f4feb5"},{"code":"S 0520-G70Y","hex":"#fbffb8"},{"code":"S 0520-G80Y","hex":"#fffcb8"},{"code":"S 0520-G90Y","hex":"#fff7b6"},{"code":"S 0520-R","hex":"#ff959c"},{"code":"S 0520-R10B","hex":"#ff98a5"},{"code":"S 0520-R20B","hex":"#ff9cb0"},{"code":"S 0520-R30B","hex":"#ffa2c0"},{"code":"S 0520-R40B","hex":"#ffa9d4"},{"code":"S 0520-R50B","hex":"#ffb4f0"},{"code":"S 0520-R60B","hex":"#e5b0ff"},{"code":"S 0520-R70B","hex":"#cbb0ff"},{"code":"S 0520-R80B","hex":"#9caeff"},{"code":"S 0520-R90B","hex":"#a3c1ff"},{"code":"S 0520-Y","hex":"#fff3b5"},{"code":"S 0520-Y10R","hex":"#feedb2"},{"code":"S 0520-Y20R","hex":"#ffe5b0"},{"code":"S 0520-Y30R","hex":"#ffddad"},{"code":"S 0520-Y40R","hex":"#ffd5aa"},{"code":"S 0520-Y50R","hex":"#ffcca7"},{"code":"S 0520-Y60R","hex":"#ffc2a3"},{"code":"S 0520-Y70R","hex":"#ffb89f"},{"code":"S 0520-Y80R","hex":"#ffac9b"},{"code":"S 0520-Y90R","hex":"#ffa19b"},{"code":"S 0525-R60B","hex":"#e09ffe"},{"code":"S 0525-R70B","hex":"#c1a0ff"},{"code":"S 0530-B","hex":"#8ed4ff"},{"code":"S 0530-B10G","hex":"#92e3ff"},{"code":"S 0530-B30G","hex":"#98f5ff"},{"code":"S 0530-B40G","hex":"#9afcff"},{"code":"S 0530-B50G","hex":"#9afffb"},{"code":"S 0530-B60G","hex":"#98fff5"},{"code":"S 0530-B70G","hex":"#96ffef"},{"code":"S 0530-B90G","hex":"#8bffcb"},{"code":"S 0530-G","hex":"#84ffb4"},{"code":"S 0530-G10Y","hex":"#a3ffa7"},{"code":"S 0530-G20Y","hex":"#baff9e"},{"code":"S 0530-G30Y","hex":"#cbff96"},{"code":"S 0530-G40Y","hex":"#dafe90"},{"code":"S 0530-G50Y","hex":"#e6ff93"},{"code":"S 0530-G60Y","hex":"#f0fe96"},{"code":"S 0530-G70Y","hex":"#f9fe99"},{"code":"S 0530-G80Y","hex":"#fefb9a"},{"code":"S 0530-G90Y","hex":"#fef598"},{"code":"S 0530-R","hex":"#ff737c"},{"code":"S 0530-R10B","hex":"#ff7687"},{"code":"S 0530-R20B","hex":"#fe7b95"},{"code":"S 0530-R30B","hex":"#ff81a9"},{"code":"S 0530-R40B","hex":"#fe89c4"},{"code":"S 0530-R50B","hex":"#ff95ea"},{"code":"S 0530-R80B","hex":"#7a92ff"},{"code":"S 0530-R90B","hex":"#81aaff"},{"code":"S 0530-Y","hex":"#ffef96"},{"code":"S 0530-Y10R","hex":"#fee593"},{"code":"S 0530-Y20R","hex":"#ffdb90"},{"code":"S 0530-Y30R","hex":"#ffd08d"},{"code":"S 0530-Y40R","hex":"#fec589"},{"code":"S 0530-Y50R","hex":"#feb986"},{"code":"S 0530-Y60R","hex":"#feac82"},{"code":"S 0530-Y70R","hex":"#ff9f7e"},{"code":"S 0530-Y80R","hex":"#ff9079"},{"code":"S 0530-Y90R","hex":"#ff8279"},{"code":"S 0540-B","hex":"#72caff"},{"code":"S 0540-B10G","hex":"#76dcff"},{"code":"S 0540-B30G","hex":"#7cf2ff"},{"code":"S 0540-G","hex":"#68ffa3"},{"code":"S 0540-G10Y","hex":"#8eff93"},{"code":"S 0540-G20Y","hex":"#a9ff86"},{"code":"S 0540-G30Y","hex":"#bfff7c"},{"code":"S 0540-G40Y","hex":"#d0ff74"},{"code":"S 0540-G50Y","hex":"#dfff77"},{"code":"S 0540-G60Y","hex":"#ecff7a"},{"code":"S 0540-G70Y","hex":"#f8fe7d"},{"code":"S 0540-G80Y","hex":"#fffa7e"},{"code":"S 0540-G90Y","hex":"#fff27c"},{"code":"S 0540-R","hex":"#ff5863"},{"code":"S 0540-R10B","hex":"#ff5b6f"},{"code":"S 0540-R20B","hex":"#ff5f7f"},{"code":"S 0540-R30B","hex":"#ff6596"},{"code":"S 0540-R90B","hex":"#6598ff"},{"code":"S 0540-Y","hex":"#ffeb7a"},{"code":"S 0540-Y10R","hex":"#ffdf77"},{"code":"S 0540-Y20R","hex":"#ffd274"},{"code":"S 0540-Y30R","hex":"#ffc571"},{"code":"S 0540-Y40R","hex":"#ffb76d"},{"code":"S 0540-Y50R","hex":"#ffa96a"},{"code":"S 0540-Y60R","hex":"#fe9a66"},{"code":"S 0540-Y70R","hex":"#ff8a62"},{"code":"S 0540-Y80R","hex":"#ff7a5e"},{"code":"S 0540-Y90R","hex":"#ff695f"},{"code":"S 0550-G10Y","hex":"#7bff81"},{"code":"S 0550-G20Y","hex":"#9aff71"},{"code":"S 0550-G30Y","hex":"#b3ff65"},{"code":"S 0550-G40Y","hex":"#c8ff5b"},{"code":"S 0550-G50Y","hex":"#daff5e"},{"code":"S 0550-G60Y","hex":"#e8ff61"},{"code":"S 0550-G70Y","hex":"#f7ff64"},{"code":"S 0550-G80Y","hex":"#fffa65"},{"code":"S 0550-G90Y","hex":"#ffef62"},{"code":"S 0550-R","hex":"#ff424e"},{"code":"S 0550-R10B","hex":"#ff455b"},{"code":"S 0550-Y","hex":"#ffe761"},{"code":"S 0550-Y10R","hex":"#ffd95e"},{"code":"S 0550-Y20R","hex":"#ffca5b"},{"code":"S 0550-Y30R","hex":"#ffbb58"},{"code":"S 0550-Y40R","hex":"#ffab55"},{"code":"S 0550-Y50R","hex":"#ff9b52"},{"code":"S 0550-Y60R","hex":"#ff8a4e"},{"code":"S 0550-Y70R","hex":"#fe794b"},{"code":"S 0550-Y80R","hex":"#ff6747"},{"code":"S 0550-Y90R","hex":"#ff5549"},{"code":"S 0560-G10Y","hex":"#6bff71"},{"code":"S 0560-G20Y","hex":"#8eff5f"},{"code":"S 0560-G30Y","hex":"#a9ff51"},{"code":"S 0560-G40Y","hex":"#c0ff45"},{"code":"S 0560-G50Y","hex":"#d4ff47"},{"code":"S 0560-G60Y","hex":"#e5ff4a"},{"code":"S 0560-G70Y","hex":"#f6ff4d"},{"code":"S 0560-G80Y","hex":"#fff94d"},{"code":"S 0560-G90Y","hex":"#ffed4b"},{"code":"S 0560-R","hex":"#ff303e"},{"code":"S 0560-Y","hex":"#fee34a"},{"code":"S 0560-Y10R","hex":"#ffd347"},{"code":"S 0560-Y20R","hex":"#ffc345"},{"code":"S 0560-Y30R","hex":"#ffb242"},{"code":"S 0560-Y40R","hex":"#ffa140"},{"code":"S 0560-Y50R","hex":"#fe8f3d"},{"code":"S 0560-Y60R","hex":"#ff7d3a"},{"code":"S 0560-Y70R","hex":"#ff6a37"},{"code":"S 0560-Y80R","hex":"#ff5734"},{"code":"S 0560-Y90R","hex":"#ff4437"},{"code":"S 0565-G10Y","hex":"#63ff6a"},{"code":"S 0565-G50Y","hex":"#d2ff3d"},{"code":"S 0565-R","hex":"#ff2836"},{"code":"S 0570-G20Y","hex":"#82ff4f"},{"code":"S 0570-G30Y","hex":"#a1ff3f"},{"code":"S 0570-G40Y","hex":"#baff31"},{"code":"S 0570-G60Y","hex":"#e2ff35"},{"code":"S 0570-G70Y","hex":"#f4ff37"},{"code":"S 0570-G80Y","hex":"#fff837"},{"code":"S 0570-G90Y","hex":"#ffeb36"},{"code":"S 0570-Y","hex":"#ffe035"},{"code":"S 0570-Y10R","hex":"#ffcf33"},{"code":"S 0570-Y20R","hex":"#ffbd31"},{"code":"S 0570-Y30R","hex":"#feaa2f"},{"code":"S 0570-Y40R","hex":"#fe982d"},{"code":"S 0570-Y50R","hex":"#ff852b"},{"code":"S 0570-Y60R","hex":"#ff7128"},{"code":"S 0570-Y70R","hex":"#ff5e26"},{"code":"S 0570-Y80R","hex":"#fe4a24"},{"code":"S 0570-Y90R","hex":"#fe3628"},{"code":"S 0575-G20Y","hex":"#7dff48"},{"code":"S 0575-G40Y","hex":"#b7ff28"},{"code":"S 0575-G60Y","hex":"#e1ff2b"},{"code":"S 0575-G70Y","hex":"#f4ff2d"},{"code":"S 0575-G90Y","hex":"#ffea2c"},{"code":"S 0580-G30Y","hex":"#99ff2e"},{"code":"S 0580-Y","hex":"#ffdd22"},{"code":"S 0580-Y10R","hex":"#ffca20"},{"code":"S 0580-Y10R","hex":"#ffca20"},{"code":"S 0580-Y20R","hex":"#feb71f"},{"code":"S 0580-Y20R","hex":"#feb71f"},{"code":"S 0580-Y30R","hex":"#ffa31d"},{"code":"S 0580-Y40R","hex":"#ff901c"},{"code":"S 0580-Y50R","hex":"#ff7b1b"},{"code":"S 0580-Y60R","hex":"#ff6719"},{"code":"S 0580-Y70R","hex":"#ff5318"},{"code":"S 0580-Y80R","hex":"#ff3e16"},{"code":"S 0580-Y90R","hex":"#ff2a1b"},{"code":"S 0585-Y20R","hex":"#ffb416"},{"code":"S 0585-Y30R","hex":"#ffa015"},{"code":"S 0585-Y40R","hex":"#fe8c14"},{"code":"S 0585-Y50R","hex":"#ff7713"},{"code":"S 0585-Y60R","hex":"#ff6212"},{"code":"S 0585-Y70R","hex":"#ff4e11"},{"code":"S 0585-Y80R","hex":"#ff3910"},{"code":"S 0603-G40Y","hex":"#f7fcef"},{"code":"S 0603-G80Y","hex":"#fcfbf0"},{"code":"S 0603-R20B","hex":"#fceaed"},{"code":"S 0603-R40B","hex":"#fcedf4"},{"code":"S 0603-R60B","hex":"#f8effc"},{"code":"S 0603-R80B","hex":"#e9edfc"},{"code":"S 0603-Y20R","hex":"#fcf8ef"},{"code":"S 0603-Y40R","hex":"#fcf5ed"},{"code":"S 0603-Y60R","hex":"#fcf1eb"},{"code":"S 0603-Y80R","hex":"#fcede9"},{"code":"S 0804-B50G","hex":"#e8f6f6"},{"code":"S 0804-G20Y","hex":"#ecf6e7"},{"code":"S 0804-G60Y","hex":"#f4f6e7"},{"code":"S 0804-G90Y","hex":"#f6f5e7"},{"code":"S 0804-R10B","hex":"#f6dee1"},{"code":"S 0804-R30B","hex":"#f6e1e8"},{"code":"S 0804-R50B","hex":"#f6e7f3"},{"code":"S 0804-R70B","hex":"#ebe5f6"},{"code":"S 0804-R90B","hex":"#e1e8f6"},{"code":"S 0804-Y10R","hex":"#f6f3e6"},{"code":"S 0804-Y30R","hex":"#f6efe5"},{"code":"S 0804-Y50R","hex":"#f6ebe3"},{"code":"S 0804-Y70R","hex":"#f6e6e0"},{"code":"S 0804-Y90R","hex":"#f6e0de"},{"code":"S 0907-B20G","hex":"#d9eff4"},{"code":"S 0907-B80G","hex":"#d8f4ee"},{"code":"S 0907-G20Y","hex":"#e1f4da"},{"code":"S 0907-G60Y","hex":"#f0f4d9"},{"code":"S 0907-G90Y","hex":"#f4f1da"},{"code":"S 0907-R10B","hex":"#f4cbd0"},{"code":"S 0907-R30B","hex":"#f4d0db"},{"code":"S 0907-R50B","hex":"#f4d9ef"},{"code":"S 0907-R70B","hex":"#e0d6f4"},{"code":"S 0907-R90B","hex":"#d0dcf4"},{"code":"S 0907-Y10R","hex":"#f4edd8"},{"code":"S 0907-Y30R","hex":"#f4e8d5"},{"code":"S 0907-Y50R","hex":"#f4e1d2"},{"code":"S 0907-Y70R","hex":"#f4d8cf"},{"code":"S 0907-Y90R","hex":"#f4cecc"},{"code":"S 1000-N","hex":"#e5e5e5"},{"code":"S 1002-B","hex":"#e8eef1"},{"code":"S 1002-B","hex":"#e8eef1"},{"code":"S 1002-B50G","hex":"#eaf1f1"},{"code":"S 1002-G","hex":"#e7f1eb"},{"code":"S 1002-G","hex":"#e7f1eb"},{"code":"S 1002-G50Y","hex":"#eff1e9"},{"code":"S 1002-R","hex":"#f1e4e5"},{"code":"S 1002-R","hex":"#f1e4e5"},{"code":"S 1002-R50B","hex":"#f1e9f0"},{"code":"S 1002-Y","hex":"#f1f0e9"},{"code":"S 1002-Y50R","hex":"#f1ebe7"},{"code":"S 1005-B","hex":"#dce9f1"},{"code":"S 1005-B20G","hex":"#deeef1"},{"code":"S 1005-B50G","hex":"#dff1f1"},{"code":"S 1005-B80G","hex":"#ddf1ed"},{"code":"S 1005-B80G","hex":"#ddf1ed"},{"code":"S 1005-G","hex":"#d8f1e2"},{"code":"S 1005-G10Y","hex":"#dff1e0"},{"code":"S 1005-G20Y","hex":"#e4f1de"},{"code":"S 1005-G20Y","hex":"#e4f1de"},{"code":"S 1005-G30Y","hex":"#e7f1dd"},{"code":"S 1005-G40Y","hex":"#eaf1dc"},{"code":"S 1005-G50Y","hex":"#edf1dd"},{"code":"S 1005-G60Y","hex":"#eef1de"},{"code":"S 1005-G70Y","hex":"#f0f1df"},{"code":"S 1005-G80Y","hex":"#f1f1df"},{"code":"S 1005-G80Y","hex":"#f1f1df"},{"code":"S 1005-G90Y","hex":"#f1efdf"},{"code":"S 1005-R","hex":"#f1d2d4"},{"code":"S 1005-R10B","hex":"#f1d3d7"},{"code":"S 1005-R20B","hex":"#f1d5db"},{"code":"S 1005-R20B","hex":"#f1d5db"},{"code":"S 1005-R30B","hex":"#f1d7e0"},{"code":"S 1005-R40B","hex":"#f1dae6"},{"code":"S 1005-R50B","hex":"#f1deed"},{"code":"S 1005-R60B","hex":"#eadcf1"},{"code":"S 1005-R70B","hex":"#e3dcf1"},{"code":"S 1005-R80B","hex":"#d5daf1"},{"code":"S 1005-R90B","hex":"#d7e0f1"},{"code":"S 1005-Y","hex":"#f1eede"},{"code":"S 1005-Y10R","hex":"#f1ecdd"},{"code":"S 1005-Y20R","hex":"#f1eadc"},{"code":"S 1005-Y20R","hex":"#f1eadc"},{"code":"S 1005-Y30R","hex":"#f1e8db"},{"code":"S 1005-Y40R","hex":"#f1e6da"},{"code":"S 1005-Y50R","hex":"#f1e3d9"},{"code":"S 1005-Y60R","hex":"#f1e0d8"},{"code":"S 1005-Y70R","hex":"#f1ddd6"},{"code":"S 1005-Y80R","hex":"#f1d9d4"},{"code":"S 1005-Y90R","hex":"#f1d6d4"},{"code":"S 1010-B","hex":"#c8e2f1"},{"code":"S 1010-B10G","hex":"#cae7f1"},{"code":"S 1010-B30G","hex":"#cdeef1"},{"code":"S 1010-B50G","hex":"#cef1f0"},{"code":"S 1010-B70G","hex":"#ccf1ec"},{"code":"S 1010-B90G","hex":"#c6f1de"},{"code":"S 1010-G","hex":"#c2f1d5"},{"code":"S 1010-G10Y","hex":"#cff1d1"},{"code":"S 1010-G20Y","hex":"#d8f1cd"},{"code":"S 1010-G30Y","hex":"#def1cb"},{"code":"S 1010-G40Y","hex":"#e4f1c9"},{"code":"S 1010-G50Y","hex":"#e8f1cb"},{"code":"S 1010-G60Y","hex":"#ecf1cc"},{"code":"S 1010-G70Y","hex":"#eff1ce"},{"code":"S 1010-G80Y","hex":"#f1f0ce"},{"code":"S 1010-G90Y","hex":"#f1eecd"},{"code":"S 1010-R","hex":"#f1b8bb"},{"code":"S 1010-R10B","hex":"#f1bac0"},{"code":"S 1010-R20B","hex":"#f1bdc7"},{"code":"S 1010-R30B","hex":"#f1c0d0"},{"code":"S 1010-R40B","hex":"#f1c5db"},{"code":"S 1010-R50B","hex":"#f1ccea"},{"code":"S 1010-R60B","hex":"#e4c9f1"},{"code":"S 1010-R70B","hex":"#d7c8f1"},{"code":"S 1010-R80B","hex":"#bcc6f1"},{"code":"S 1010-R90B","hex":"#c1d1f1"},{"code":"S 1010-Y","hex":"#f1eccc"},{"code":"S 1010-Y10R","hex":"#f1e8cb"},{"code":"S 1010-Y20R","hex":"#f1e4c9"},{"code":"S 1010-Y30R","hex":"#f1e0c7"},{"code":"S 1010-Y40R","hex":"#f1dcc5"},{"code":"S 1010-Y50R","hex":"#f1d7c3"},{"code":"S 1010-Y60R","hex":"#f1d1c1"},{"code":"S 1010-Y70R","hex":"#f1cbbe"},{"code":"S 1010-Y80R","hex":"#f1c5bc"},{"code":"S 1010-Y90R","hex":"#f1bebb"},{"code":"S 1015-B","hex":"#b6dbf1"},{"code":"S 1015-B20G","hex":"#bbe8f1"},{"code":"S 1015-B50G","hex":"#bef1ef"},{"code":"S 1015-B80G","hex":"#baf1e5"},{"code":"S 1015-G","hex":"#aef1c8"},{"code":"S 1015-G20Y","hex":"#cdf1be"},{"code":"S 1015-G40Y","hex":"#def1b7"},{"code":"S 1015-G60Y","hex":"#eaf1bc"},{"code":"S 1015-G80Y","hex":"#f1f0be"},{"code":"S 1015-G90Y","hex":"#f1ecbd"},{"code":"S 1015-R","hex":"#f1a1a6"},{"code":"S 1015-R10B","hex":"#f1a4ad"},{"code":"S 1015-R20B","hex":"#f1a7b6"},{"code":"S 1015-R40B","hex":"#f1b2d2"},{"code":"S 1015-R60B","hex":"#dfb7f1"},{"code":"S 1015-R80B","hex":"#a6b4f1"},{"code":"S 1015-R90B","hex":"#acc3f1"},{"code":"S 1015-Y","hex":"#f1e9bb"},{"code":"S 1015-Y10R","hex":"#f1e4b9"},{"code":"S 1015-Y20R","hex":"#f1dfb7"},{"code":"S 1015-Y30R","hex":"#f1d9b5"},{"code":"S 1015-Y40R","hex":"#f1d2b2"},{"code":"S 1015-Y50R","hex":"#f1cbb0"},{"code":"S 1015-Y60R","hex":"#f1c4ad"},{"code":"S 1015-Y70R","hex":"#f1bca9"},{"code":"S 1015-Y80R","hex":"#f1b3a6"},{"code":"S 1015-Y90R","hex":"#f1aaa5"},{"code":"S 1020-B","hex":"#a5d5f1"},{"code":"S 1020-B10G","hex":"#a8dff1"},{"code":"S 1020-B30G","hex":"#adebf1"},{"code":"S 1020-B40G","hex":"#afeff1"},{"code":"S 1020-B50G","hex":"#aef1ef"},{"code":"S 1020-B60G","hex":"#adf1eb"},{"code":"S 1020-B70G","hex":"#abf1e7"},{"code":"S 1020-B90G","hex":"#a2f1ce"},{"code":"S 1020-G","hex":"#9cf1bd"},{"code":"S 1020-G10Y","hex":"#b3f1b5"},{"code":"S 1020-G20Y","hex":"#c2f1af"},{"code":"S 1020-G30Y","hex":"#cef1aa"},{"code":"S 1020-G40Y","hex":"#d8f1a6"},{"code":"S 1020-G50Y","hex":"#e1f1a9"},{"code":"S 1020-G60Y","hex":"#e7f1ac"},{"code":"S 1020-G70Y","hex":"#eef1ae"},{"code":"S 1020-G80Y","hex":"#f1efae"},{"code":"S 1020-G90Y","hex":"#f1eaad"},{"code":"S 1020-R","hex":"#f18d94"},{"code":"S 1020-R10B","hex":"#f1909c"},{"code":"S 1020-R20B","hex":"#f194a7"},{"code":"S 1020-R30B","hex":"#f19ab5"},{"code":"S 1020-R40B","hex":"#f1a1c9"},{"code":"S 1020-R50B","hex":"#f1aae4"},{"code":"S 1020-R60B","hex":"#d9a7f1"},{"code":"S 1020-R70B","hex":"#c1a7f1"},{"code":"S 1020-R80B","hex":"#93a5f1"},{"code":"S 1020-R90B","hex":"#9ab7f1"},{"code":"S 1020-Y","hex":"#f1e7ab"},{"code":"S 1020-Y10R","hex":"#f1e0a9"},{"code":"S 1020-Y20R","hex":"#f1d9a7"},{"code":"S 1020-Y30R","hex":"#f1d2a4"},{"code":"S 1020-Y40R","hex":"#f1caa1"},{"code":"S 1020-Y50R","hex":"#f1c19e"},{"code":"S 1020-Y60R","hex":"#f1b89a"},{"code":"S 1020-Y70R","hex":"#f1ae97"},{"code":"S 1020-Y80R","hex":"#f1a393"},{"code":"S 1020-Y90R","hex":"#f19892"},{"code":"S 1030-B","hex":"#86c9f1"},{"code":"S 1030-B10G","hex":"#8bd7f1"},{"code":"S 1030-B30G","hex":"#90e8f1"},{"code":"S 1030-B40G","hex":"#92eef1"},{"code":"S 1030-B50G","hex":"#92f1ee"},{"code":"S 1030-B60G","hex":"#90f1e8"},{"code":"S 1030-B70G","hex":"#8ef1e2"},{"code":"S 1030-B90G","hex":"#84f1c0"},{"code":"S 1030-G","hex":"#7df1aa"},{"code":"S 1030-G10Y","hex":"#9bf19f"},{"code":"S 1030-G20Y","hex":"#b0f195"},{"code":"S 1030-G30Y","hex":"#c1f18e"},{"code":"S 1030-G40Y","hex":"#cef188"},{"code":"S 1030-G50Y","hex":"#daf18b"},{"code":"S 1030-G60Y","hex":"#e3f18e"},{"code":"S 1030-G70Y","hex":"#ecf191"},{"code":"S 1030-G80Y","hex":"#f1ee92"},{"code":"S 1030-G90Y","hex":"#f1e890"},{"code":"S 1030-R","hex":"#f16d76"},{"code":"S 1030-R10B","hex":"#f17080"},{"code":"S 1030-R20B","hex":"#f1748d"},{"code":"S 1030-R30B","hex":"#f17aa0"},{"code":"S 1030-R40B","hex":"#f182b9"},{"code":"S 1030-R50B","hex":"#f18dde"},{"code":"S 1030-R60B","hex":"#d088f1"},{"code":"S 1030-R70B","hex":"#ae8af1"},{"code":"S 1030-R80B","hex":"#738bf1"},{"code":"S 1030-R90B","hex":"#7aa1f1"},{"code":"S 1030-Y","hex":"#f1e28e"},{"code":"S 1030-Y10R","hex":"#f1d98b"},{"code":"S 1030-Y20R","hex":"#f1d088"},{"code":"S 1030-Y30R","hex":"#f1c585"},{"code":"S 1030-Y40R","hex":"#f1bb82"},{"code":"S 1030-Y50R","hex":"#f1af7f"},{"code":"S 1030-Y60R","hex":"#f1a37b"},{"code":"S 1030-Y70R","hex":"#f19677"},{"code":"S 1030-Y80R","hex":"#f18973"},{"code":"S 1030-Y90R","hex":"#f17b73"},{"code":"S 1040-B","hex":"#6cbff1"},{"code":"S 1040-B10G","hex":"#70d0f1"},{"code":"S 1040-B20G","hex":"#73dcf1"},{"code":"S 1040-B30G","hex":"#75e5f1"},{"code":"S 1040-B40G","hex":"#77eef1"},{"code":"S 1040-B50G","hex":"#77f1ed"},{"code":"S 1040-B60G","hex":"#75f1e6"},{"code":"S 1040-B70G","hex":"#74f1de"},{"code":"S 1040-B80G","hex":"#71f1d5"},{"code":"S 1040-B90G","hex":"#69f1b4"},{"code":"S 1040-G","hex":"#63f19a"},{"code":"S 1040-G10Y","hex":"#86f18b"},{"code":"S 1040-G20Y","hex":"#a0f17f"},{"code":"S 1040-G30Y","hex":"#b5f175"},{"code":"S 1040-G40Y","hex":"#c5f16e"},{"code":"S 1040-G50Y","hex":"#d4f171"},{"code":"S 1040-G60Y","hex":"#dff174"},{"code":"S 1040-G70Y","hex":"#ebf177"},{"code":"S 1040-G80Y","hex":"#f1ed77"},{"code":"S 1040-G90Y","hex":"#f1e575"},{"code":"S 1040-R","hex":"#f1535e"},{"code":"S 1040-R10B","hex":"#f15669"},{"code":"S 1040-R20B","hex":"#f15a79"},{"code":"S 1040-R30B","hex":"#f1608e"},{"code":"S 1040-R40B","hex":"#f167ac"},{"code":"S 1040-R50B","hex":"#f172d9"},{"code":"S 1040-R60B","hex":"#c76ef1"},{"code":"S 1040-R70B","hex":"#9e72f1"},{"code":"S 1040-R80B","hex":"#5975f1"},{"code":"S 1040-R90B","hex":"#6090f1"},{"code":"S 1040-Y","hex":"#f1de74"},{"code":"S 1040-Y10R","hex":"#f1d371"},{"code":"S 1040-Y20R","hex":"#f1c76e"},{"code":"S 1040-Y30R","hex":"#f1bb6b"},{"code":"S 1040-Y40R","hex":"#f1ae67"},{"code":"S 1040-Y50R","hex":"#f1a064"},{"code":"S 1040-Y60R","hex":"#f19260"},{"code":"S 1040-Y70R","hex":"#f1835d"},{"code":"S 1040-Y80R","hex":"#f17359"},{"code":"S 1040-Y90R","hex":"#f1645a"},{"code":"S 1050-B","hex":"#54b6f1"},{"code":"S 1050-B10G","hex":"#58caf1"},{"code":"S 1050-B20G","hex":"#5bd8f1"},{"code":"S 1050-B30G","hex":"#5de3f1"},{"code":"S 1050-B40G","hex":"#5fedf1"},{"code":"S 1050-B50G","hex":"#5ff1ec"},{"code":"S 1050-B60G","hex":"#5df1e3"},{"code":"S 1050-B70G","hex":"#5cf1db"},{"code":"S 1050-B80G","hex":"#59f1cf"},{"code":"S 1050-B90G","hex":"#52f1aa"},{"code":"S 1050-G","hex":"#4cf18c"},{"code":"S 1050-G10Y","hex":"#75f17a"},{"code":"S 1050-G10Y","hex":"#75f17a"},{"code":"S 1050-G20Y","hex":"#92f16b"},{"code":"S 1050-G20Y","hex":"#92f16b"},{"code":"S 1050-G30Y","hex":"#aaf160"},{"code":"S 1050-G40Y","hex":"#bdf156"},{"code":"S 1050-G50Y","hex":"#cef159"},{"code":"S 1050-G60Y","hex":"#dcf15c"},{"code":"S 1050-G70Y","hex":"#eaf15f"},{"code":"S 1050-G80Y","hex":"#f1ed5f"},{"code":"S 1050-G90Y","hex":"#f1e35d"},{"code":"S 1050-R","hex":"#f13f4a"},{"code":"S 1050-R10B","hex":"#f14157"},{"code":"S 1050-R20B","hex":"#f14567"},{"code":"S 1050-R30B","hex":"#f1497f"},{"code":"S 1050-R40B","hex":"#f150a1"},{"code":"S 1050-R90B","hex":"#4a81f1"},{"code":"S 1050-Y","hex":"#f1db5c"},{"code":"S 1050-Y10R","hex":"#f1cd59"},{"code":"S 1050-Y20R","hex":"#f1c056"},{"code":"S 1050-Y30R","hex":"#f1b153"},{"code":"S 1050-Y40R","hex":"#f1a250"},{"code":"S 1050-Y50R","hex":"#f1934d"},{"code":"S 1050-Y60R","hex":"#f1834a"},{"code":"S 1050-Y70R","hex":"#f17247"},{"code":"S 1050-Y80R","hex":"#f16143"},{"code":"S 1050-Y90R","hex":"#f15045"},{"code":"S 1055-B90G","hex":"#47f1a5"},{"code":"S 1060-B","hex":"#40aff1"},{"code":"S 1060-G","hex":"#39f180"},{"code":"S 1060-G10Y","hex":"#65f16b"},{"code":"S 1060-G20Y","hex":"#86f15a"},{"code":"S 1060-G30Y","hex":"#a0f14c"},{"code":"S 1060-G40Y","hex":"#b6f141"},{"code":"S 1060-G50Y","hex":"#c9f144"},{"code":"S 1060-G60Y","hex":"#d9f146"},{"code":"S 1060-G70Y","hex":"#e9f149"},{"code":"S 1060-G80Y","hex":"#f1ec49"},{"code":"S 1060-G90Y","hex":"#f1e147"},{"code":"S 1060-R","hex":"#f12e3a"},{"code":"S 1060-R10B","hex":"#f13047"},{"code":"S 1060-R20B","hex":"#f13259"},{"code":"S 1060-R30B","hex":"#f13672"},{"code":"S 1060-Y","hex":"#f1d746"},{"code":"S 1060-Y10R","hex":"#f1c844"},{"code":"S 1060-Y20R","hex":"#f1b941"},{"code":"S 1060-Y30R","hex":"#f1a93f"},{"code":"S 1060-Y40R","hex":"#f1983c"},{"code":"S 1060-Y50R","hex":"#f1883a"},{"code":"S 1060-Y60R","hex":"#f17637"},{"code":"S 1060-Y70R","hex":"#f16534"},{"code":"S 1060-Y80R","hex":"#f15331"},{"code":"S 1060-Y90R","hex":"#f14134"},{"code":"S 1070-G10Y","hex":"#57f15e"},{"code":"S 1070-G20Y","hex":"#7bf14b"},{"code":"S 1070-G30Y","hex":"#98f13b"},{"code":"S 1070-G40Y","hex":"#b0f12e"},{"code":"S 1070-G50Y","hex":"#c5f130"},{"code":"S 1070-G60Y","hex":"#d6f132"},{"code":"S 1070-G70Y","hex":"#e8f134"},{"code":"S 1070-G80Y","hex":"#f1eb35"},{"code":"S 1070-G90Y","hex":"#f1df33"},{"code":"S 1070-R","hex":"#f11f2d"},{"code":"S 1070-R10B","hex":"#f1213a"},{"code":"S 1070-R20B","hex":"#f1234c"},{"code":"S 1070-Y","hex":"#f1d432"},{"code":"S 1070-Y10R","hex":"#f1c430"},{"code":"S 1070-Y20R","hex":"#f1b32e"},{"code":"S 1070-Y30R","hex":"#f1a12c"},{"code":"S 1070-Y40R","hex":"#f1902a"},{"code":"S 1070-Y50R","hex":"#f17e28"},{"code":"S 1070-Y60R","hex":"#f16b26"},{"code":"S 1070-Y70R","hex":"#f15924"},{"code":"S 1070-Y80R","hex":"#f14622"},{"code":"S 1070-Y90R","hex":"#f13326"},{"code":"S 1075-G20Y","hex":"#76f144"},{"code":"S 1075-G40Y","hex":"#adf126"},{"code":"S 1075-G50Y","hex":"#c3f127"},{"code":"S 1075-G60Y","hex":"#d5f129"},{"code":"S 1075-G70Y","hex":"#e7f12b"},{"code":"S 1075-G80Y","hex":"#f1eb2b"},{"code":"S 1075-G90Y","hex":"#f1de2a"},{"code":"S 1080-G30Y","hex":"#91f12c"},{"code":"S 1080-R","hex":"#f11322"},{"code":"S 1080-Y","hex":"#f1d220"},{"code":"S 1080-Y10R","hex":"#f1c01e"},{"code":"S 1080-Y20R","hex":"#f1ad1d"},{"code":"S 1080-Y30R","hex":"#f19b1c"},{"code":"S 1080-Y40R","hex":"#f1881b"},{"code":"S 1080-Y50R","hex":"#f17519"},{"code":"S 1080-Y60R","hex":"#f16218"},{"code":"S 1080-Y70R","hex":"#f14e16"},{"code":"S 1080-Y80R","hex":"#f13b15"},{"code":"S 1080-Y90R","hex":"#f1281a"},{"code":"S 1085-Y80R","hex":"#f1360f"},{"code":"S 1085-Y90R","hex":"#f12214"},{"code":"S 1500-N","hex":"#d8d8d8"},{"code":"S 1502-B","hex":"#dbe1e4"},{"code":"S 1502-B50G","hex":"#dde4e3"},{"code":"S 1502-G","hex":"#dae4de"},{"code":"S 1502-G50Y","hex":"#e2e4dc"},{"code":"S 1502-R","hex":"#e4d7d8"},{"code":"S 1502-R50B","hex":"#e4dce2"},{"code":"S 1502-Y","hex":"#e4e3dc"},{"code":"S 1502-Y50R","hex":"#e4deda"},{"code":"S 1505-G80Y","hex":"#e4e3d3"},{"code":"S 1505-G90Y","hex":"#e4e2d2"},{"code":"S 1505-Y","hex":"#e4e1d2"},{"code":"S 1505-Y10R","hex":"#e4dfd1"},{"code":"S 1505-Y20R","hex":"#e4ddd0"},{"code":"S 1505-Y30R","hex":"#e4dbcf"},{"code":"S 1505-Y40R","hex":"#e4d9ce"},{"code":"S 1505-Y50R","hex":"#e4d7cd"},{"code":"S 1505-Y60R","hex":"#e4d4cc"},{"code":"S 1505-Y70R","hex":"#e4d1ca"},{"code":"S 1505-Y80R","hex":"#e4cdc9"},{"code":"S 1505-Y90R","hex":"#e4cac8"},{"code":"S 1510-B","hex":"#bdd5e4"},{"code":"S 1510-B20G","hex":"#c1dee4"},{"code":"S 1510-B50G","hex":"#c3e4e3"},{"code":"S 1510-B80G","hex":"#c0e4dc"},{"code":"S 1510-G","hex":"#b8e4c9"},{"code":"S 1510-G20Y","hex":"#cce4c2"},{"code":"S 1510-G40Y","hex":"#d7e4be"},{"code":"S 1510-G60Y","hex":"#dfe4c1"},{"code":"S 1510-G80Y","hex":"#e4e3c3"},{"code":"S 1510-G90Y","hex":"#e4e0c2"},{"code":"S 1510-R","hex":"#e4adb1"},{"code":"S 1510-R10B","hex":"#e4afb6"},{"code":"S 1510-R20B","hex":"#e4b2bc"},{"code":"S 1510-R40B","hex":"#e4bacf"},{"code":"S 1510-R60B","hex":"#d8bee4"},{"code":"S 1510-R80B","hex":"#b2bbe4"},{"code":"S 1510-R90B","hex":"#b6c5e4"},{"code":"S 1510-Y","hex":"#e4dec1"},{"code":"S 1510-Y10R","hex":"#e4dbbf"},{"code":"S 1510-Y20R","hex":"#e4d8be"},{"code":"S 1510-Y30R","hex":"#e4d4bc"},{"code":"S 1510-Y40R","hex":"#e4d0ba"},{"code":"S 1510-Y50R","hex":"#e4cbb8"},{"code":"S 1510-Y60R","hex":"#e4c6b6"},{"code":"S 1510-Y70R","hex":"#e4c0b4"},{"code":"S 1510-Y80R","hex":"#e4bab1"},{"code":"S 1510-Y90R","hex":"#e4b4b1"},{"code":"S 1515-B","hex":"#accfe4"},{"code":"S 1515-B20G","hex":"#b1dbe4"},{"code":"S 1515-B50G","hex":"#b3e4e2"},{"code":"S 1515-B80G","hex":"#afe4d8"},{"code":"S 1515-G","hex":"#a5e4bd"},{"code":"S 1515-G20Y","hex":"#c1e4b3"},{"code":"S 1515-G40Y","hex":"#d1e4ad"},{"code":"S 1515-G60Y","hex":"#dde4b1"},{"code":"S 1515-G80Y","hex":"#e4e2b3"},{"code":"S 1515-G90Y","hex":"#e4dfb2"},{"code":"S 1515-R","hex":"#e4989d"},{"code":"S 1515-R10B","hex":"#e49ba3"},{"code":"S 1515-R20B","hex":"#e49eac"},{"code":"S 1515-R40B","hex":"#e4a8c6"},{"code":"S 1515-R60B","hex":"#d2ade4"},{"code":"S 1515-R80B","hex":"#9daae4"},{"code":"S 1515-R90B","hex":"#a3b8e4"},{"code":"S 1515-Y","hex":"#e4dcb1"},{"code":"S 1515-Y10R","hex":"#e4d7af"},{"code":"S 1515-Y20R","hex":"#e4d2ad"},{"code":"S 1515-Y30R","hex":"#e4cdab"},{"code":"S 1515-Y40R","hex":"#e4c7a8"},{"code":"S 1515-Y50R","hex":"#e4c0a6"},{"code":"S 1515-Y60R","hex":"#e4b9a3"},{"code":"S 1515-Y70R","hex":"#e4b1a0"},{"code":"S 1515-Y80R","hex":"#e4a99d"},{"code":"S 1515-Y90R","hex":"#e4a19c"},{"code":"S 1550-R70B","hex":"#8857e4"},{"code":"S 1550-R80B","hex":"#405ee4"},{"code":"S 1555-B10G","hex":"#49bce4"},{"code":"S 1555-R70B","hex":"#824ee4"},{"code":"S 1555-R80B","hex":"#3757e4"},{"code":"S 1560-R90B","hex":"#346ee4"},{"code":"S 1565-B","hex":"#33a1e4"},{"code":"S 1565-G","hex":"#2de474"},{"code":"S 1575-R10B","hex":"#e41931"},{"code":"S 1580-R","hex":"#e41220"},{"code":"S 1580-Y80R","hex":"#e43814"},{"code":"S 1580-Y90R","hex":"#e42518"},{"code":"S 2000-N","hex":"#cccccc"},{"code":"S 2002-B","hex":"#cfd3d6"},{"code":"S 2002-B50G","hex":"#d0d6d6"},{"code":"S 2002-G","hex":"#cdd6d1"},{"code":"S 2002-G50Y","hex":"#d5d6cf"},{"code":"S 2002-R","hex":"#d6cbcb"},{"code":"S 2002-R50B","hex":"#d6cfd5"},{"code":"S 2002-Y","hex":"#d6d5cf"},{"code":"S 2002-Y50R","hex":"#d6d1cd"},{"code":"S 2005-B","hex":"#c3cfd6"},{"code":"S 2005-B20G","hex":"#c5d3d6"},{"code":"S 2005-B20G","hex":"#c5d3d6"},{"code":"S 2005-B50G","hex":"#c6d6d6"},{"code":"S 2005-B80G","hex":"#c5d6d2"},{"code":"S 2005-B80G","hex":"#c5d6d2"},{"code":"S 2005-G","hex":"#c0d6c9"},{"code":"S 2005-G10Y","hex":"#c6d6c7"},{"code":"S 2005-G20Y","hex":"#cbd6c6"},{"code":"S 2005-G20Y","hex":"#cbd6c6"},{"code":"S 2005-G30Y","hex":"#ced6c5"},{"code":"S 2005-G40Y","hex":"#d0d6c4"},{"code":"S 2005-G50Y","hex":"#d2d6c5"},{"code":"S 2005-G60Y","hex":"#d4d6c6"},{"code":"S 2005-G70Y","hex":"#d6d6c6"},{"code":"S 2005-G80Y","hex":"#d6d6c6"},{"code":"S 2005-G90Y","hex":"#d6d5c6"},{"code":"S 2005-R","hex":"#d6bbbc"},{"code":"S 2005-R10B","hex":"#d6bcbf"},{"code":"S 2005-R20B","hex":"#d6bdc2"},{"code":"S 2005-R20B","hex":"#d6bdc2"},{"code":"S 2005-R30B","hex":"#d6bfc7"},{"code":"S 2005-R40B","hex":"#d6c2cc"},{"code":"S 2005-R50B","hex":"#d6c5d3"},{"code":"S 2005-R50B","hex":"#d6c5d3"},{"code":"S 2005-R60B","hex":"#d0c4d6"},{"code":"S 2005-R70B","hex":"#cac3d6"},{"code":"S 2005-R80B","hex":"#bdc2d6"},{"code":"S 2005-R90B","hex":"#c0c7d6"},{"code":"S 2005-Y","hex":"#d6d4c5"},{"code":"S 2005-Y10R","hex":"#d6d2c5"},{"code":"S 2005-Y20R","hex":"#d6d0c4"},{"code":"S 2005-Y30R","hex":"#d6cfc3"},{"code":"S 2005-Y40R","hex":"#d6ccc2"},{"code":"S 2005-Y50R","hex":"#d6cac1"},{"code":"S 2005-Y50R","hex":"#d6cac1"},{"code":"S 2005-Y60R","hex":"#d6c7c0"},{"code":"S 2005-Y70R","hex":"#d6c4be"},{"code":"S 2005-Y80R","hex":"#d6c1bd"},{"code":"S 2005-Y90R","hex":"#d6bebc"},{"code":"S 2010-B","hex":"#b2c9d6"},{"code":"S 2010-B10G","hex":"#b4ced6"},{"code":"S 2010-B30G","hex":"#b6d3d6"},{"code":"S 2010-B50G","hex":"#b7d6d5"},{"code":"S 2010-B70G","hex":"#b6d6d1"},{"code":"S 2010-B90G","hex":"#b0d6c5"},{"code":"S 2010-G","hex":"#add6bd"},{"code":"S 2010-G10Y","hex":"#b8d6b9"},{"code":"S 2010-G20Y","hex":"#c0d6b7"},{"code":"S 2010-G30Y","hex":"#c6d6b4"},{"code":"S 2010-G40Y","hex":"#cad6b3"},{"code":"S 2010-G50Y","hex":"#ced6b4"},{"code":"S 2010-G60Y","hex":"#d2d6b6"},{"code":"S 2010-G70Y","hex":"#d5d6b7"},{"code":"S 2010-G80Y","hex":"#d6d5b7"},{"code":"S 2010-G90Y","hex":"#d6d3b6"},{"code":"S 2010-R","hex":"#d6a3a6"},{"code":"S 2010-R10B","hex":"#d6a5ab"},{"code":"S 2010-R20B","hex":"#d6a8b1"},{"code":"S 2010-R30B","hex":"#d6abb9"},{"code":"S 2010-R40B","hex":"#d6afc3"},{"code":"S 2010-R50B","hex":"#d6b5d0"},{"code":"S 2010-R60B","hex":"#cbb3d6"},{"code":"S 2010-R70B","hex":"#bfb2d6"},{"code":"S 2010-R80B","hex":"#a7b0d6"},{"code":"S 2010-R90B","hex":"#abb9d6"},{"code":"S 2010-Y","hex":"#d6d1b6"},{"code":"S 2010-Y10R","hex":"#d6ceb4"},{"code":"S 2010-Y20R","hex":"#d6cbb3"},{"code":"S 2010-Y30R","hex":"#d6c7b1"},{"code":"S 2010-Y40R","hex":"#d6c3af"},{"code":"S 2010-Y50R","hex":"#d6bfae"},{"code":"S 2010-Y60R","hex":"#d6baac"},{"code":"S 2010-Y70R","hex":"#d6b5a9"},{"code":"S 2010-Y80R","hex":"#d6afa7"},{"code":"S 2010-Y90R","hex":"#d6a9a6"},{"code":"S 2020-B","hex":"#92bdd6"},{"code":"S 2020-B10G","hex":"#96c6d6"},{"code":"S 2020-B30G","hex":"#9ad1d6"},{"code":"S 2020-B40G","hex":"#9bd5d6"},{"code":"S 2020-B50G","hex":"#9bd6d4"},{"code":"S 2020-B60G","hex":"#9ad6d1"},{"code":"S 2020-B70G","hex":"#98d6cd"},{"code":"S 2020-B90G","hex":"#90d6b7"},{"code":"S 2020-G","hex":"#8bd6a8"},{"code":"S 2020-G10Y","hex":"#9fd6a1"},{"code":"S 2020-G20Y","hex":"#add69c"},{"code":"S 2020-G30Y","hex":"#b7d697"},{"code":"S 2020-G40Y","hex":"#c0d694"},{"code":"S 2020-G50Y","hex":"#c8d696"},{"code":"S 2020-G60Y","hex":"#ced699"},{"code":"S 2020-G70Y","hex":"#d3d69b"},{"code":"S 2020-G80Y","hex":"#d6d49b"},{"code":"S 2020-G90Y","hex":"#d6d09a"},{"code":"S 2020-R","hex":"#d67e83"},{"code":"S 2020-R10B","hex":"#d6808b"},{"code":"S 2020-R20B","hex":"#d68494"},{"code":"S 2020-R30B","hex":"#d688a1"},{"code":"S 2020-R40B","hex":"#d68fb3"},{"code":"S 2020-R50B","hex":"#d697ca"},{"code":"S 2020-R60B","hex":"#c194d6"},{"code":"S 2020-R70B","hex":"#ab94d6"},{"code":"S 2020-R80B","hex":"#8392d6"},{"code":"S 2020-R90B","hex":"#89a2d6"},{"code":"S 2020-Y","hex":"#d6cd98"},{"code":"S 2020-Y10R","hex":"#d6c796"},{"code":"S 2020-Y20R","hex":"#d6c194"},{"code":"S 2020-Y30R","hex":"#d6bb92"},{"code":"S 2020-Y40R","hex":"#d6b38f"},{"code":"S 2020-Y50R","hex":"#d6ac8c"},{"code":"S 2020-Y60R","hex":"#d6a389"},{"code":"S 2020-Y70R","hex":"#d69b86"},{"code":"S 2020-Y80R","hex":"#d69183"},{"code":"S 2020-Y90R","hex":"#d68882"},{"code":"S 2030-B","hex":"#77b3d6"},{"code":"S 2030-B10G","hex":"#7bbfd6"},{"code":"S 2030-B30G","hex":"#80ced6"},{"code":"S 2030-B40G","hex":"#82d4d6"},{"code":"S 2030-B50G","hex":"#81d6d3"},{"code":"S 2030-B60G","hex":"#80d6ce"},{"code":"S 2030-B70G","hex":"#7ed6c9"},{"code":"S 2030-B90G","hex":"#75d6ab"},{"code":"S 2030-G","hex":"#6fd697"},{"code":"S 2030-G10Y","hex":"#8ad68d"},{"code":"S 2030-G20Y","hex":"#9cd685"},{"code":"S 2030-G30Y","hex":"#abd67e"},{"code":"S 2030-G40Y","hex":"#b7d679"},{"code":"S 2030-G50Y","hex":"#c2d67c"},{"code":"S 2030-G60Y","hex":"#cad67f"},{"code":"S 2030-G70Y","hex":"#d2d681"},{"code":"S 2030-G80Y","hex":"#d6d481"},{"code":"S 2030-G90Y","hex":"#d6ce80"},{"code":"S 2030-R","hex":"#d66168"},{"code":"S 2030-R10B","hex":"#d66471"},{"code":"S 2030-R20B","hex":"#d6677e"},{"code":"S 2030-R30B","hex":"#d66c8e"},{"code":"S 2030-R40B","hex":"#d673a5"},{"code":"S 2030-R50B","hex":"#d67dc5"},{"code":"S 2030-R60B","hex":"#b979d6"},{"code":"S 2030-R70B","hex":"#9b7bd6"},{"code":"S 2030-R80B","hex":"#677bd6"},{"code":"S 2030-R90B","hex":"#6d8fd6"},{"code":"S 2030-Y","hex":"#d6c97e"},{"code":"S 2030-Y10R","hex":"#d6c17c"},{"code":"S 2030-Y20R","hex":"#d6b979"},{"code":"S 2030-Y30R","hex":"#d6b076"},{"code":"S 2030-Y40R","hex":"#d6a674"},{"code":"S 2030-Y50R","hex":"#d69c70"},{"code":"S 2030-Y60R","hex":"#d6916d"},{"code":"S 2030-Y70R","hex":"#d6856a"},{"code":"S 2030-Y80R","hex":"#d67966"},{"code":"S 2030-Y90R","hex":"#d66d66"},{"code":"S 2040-B","hex":"#60aad6"},{"code":"S 2040-B10G","hex":"#64b9d6"},{"code":"S 2040-B20G","hex":"#66c4d6"},{"code":"S 2040-B30G","hex":"#68ccd6"},{"code":"S 2040-B40G","hex":"#6ad3d6"},{"code":"S 2040-B50G","hex":"#6ad6d3"},{"code":"S 2040-B60G","hex":"#68d6cc"},{"code":"S 2040-B70G","hex":"#67d6c6"},{"code":"S 2040-B80G","hex":"#65d6bd"},{"code":"S 2040-B90G","hex":"#5dd6a0"},{"code":"S 2040-G","hex":"#58d689"},{"code":"S 2040-G10Y","hex":"#77d67c"},{"code":"S 2040-G20Y","hex":"#8ed671"},{"code":"S 2040-G30Y","hex":"#a0d668"},{"code":"S 2040-G40Y","hex":"#afd661"},{"code":"S 2040-G50Y","hex":"#bcd664"},{"code":"S 2040-G60Y","hex":"#c7d667"},{"code":"S 2040-G70Y","hex":"#d1d66a"},{"code":"S 2040-G80Y","hex":"#d6d36a"},{"code":"S 2040-G90Y","hex":"#d6cc68"},{"code":"S 2040-R","hex":"#d64a53"},{"code":"S 2040-R10B","hex":"#d64d5d"},{"code":"S 2040-R20B","hex":"#d6506b"},{"code":"S 2040-R30B","hex":"#d6557e"},{"code":"S 2040-R40B","hex":"#d65c99"},{"code":"S 2040-R50B","hex":"#d666c1"},{"code":"S 2040-R60B","hex":"#b162d6"},{"code":"S 2040-R70B","hex":"#8d65d6"},{"code":"S 2040-R80B","hex":"#4f68d6"},{"code":"S 2040-R90B","hex":"#5580d6"},{"code":"S 2040-Y","hex":"#d6c667"},{"code":"S 2040-Y10R","hex":"#d6bc64"},{"code":"S 2040-Y20R","hex":"#d6b162"},{"code":"S 2040-Y30R","hex":"#d6a65f"},{"code":"S 2040-Y40R","hex":"#d69a5c"},{"code":"S 2040-Y50R","hex":"#d68e59"},{"code":"S 2040-Y60R","hex":"#d68156"},{"code":"S 2040-Y70R","hex":"#d67452"},{"code":"S 2040-Y80R","hex":"#d6664f"},{"code":"S 2040-Y90R","hex":"#d65950"},{"code":"S 2050-B","hex":"#4ba2d6"},{"code":"S 2050-B10G","hex":"#4fb4d6"},{"code":"S 2050-B20G","hex":"#51c0d6"},{"code":"S 2050-B30G","hex":"#53cad6"},{"code":"S 2050-B40G","hex":"#55d3d6"},{"code":"S 2050-B50G","hex":"#55d6d2"},{"code":"S 2050-B60G","hex":"#53d6ca"},{"code":"S 2050-B70G","hex":"#51d6c3"},{"code":"S 2050-B80G","hex":"#4fd6b8"},{"code":"S 2050-B90G","hex":"#49d697"},{"code":"S 2050-G","hex":"#44d67d"},{"code":"S 2050-G10Y","hex":"#68d66c"},{"code":"S 2050-G20Y","hex":"#82d660"},{"code":"S 2050-G30Y","hex":"#97d655"},{"code":"S 2050-G40Y","hex":"#a8d64d"},{"code":"S 2050-G50Y","hex":"#b7d64f"},{"code":"S 2050-G60Y","hex":"#c4d652"},{"code":"S 2050-G70Y","hex":"#d0d654"},{"code":"S 2050-G80Y","hex":"#d6d255"},{"code":"S 2050-G90Y","hex":"#d6ca53"},{"code":"S 2050-R","hex":"#d63842"},{"code":"S 2050-R10B","hex":"#d63a4d"},{"code":"S 2050-R20B","hex":"#d63d5c"},{"code":"S 2050-R30B","hex":"#d64171"},{"code":"S 2050-R40B","hex":"#d6478f"},{"code":"S 2050-R50B","hex":"#d650bd"},{"code":"S 2050-R60B","hex":"#aa4dd6"},{"code":"S 2050-R70B","hex":"#8052d6"},{"code":"S 2050-R80B","hex":"#3c59d6"},{"code":"S 2050-R90B","hex":"#4172d6"},{"code":"S 2050-Y","hex":"#d6c251"},{"code":"S 2050-Y10R","hex":"#d6b74f"},{"code":"S 2050-Y20R","hex":"#d6aa4d"},{"code":"S 2050-Y30R","hex":"#d69e4a"},{"code":"S 2050-Y40R","hex":"#d69047"},{"code":"S 2050-Y50R","hex":"#d68345"},{"code":"S 2050-Y60R","hex":"#d67442"},{"code":"S 2050-Y70R","hex":"#d6663f"},{"code":"S 2050-Y80R","hex":"#d6573c"},{"code":"S 2050-Y90R","hex":"#d6483e"},{"code":"S 2055-B10G","hex":"#45b1d6"},{"code":"S 2060-B","hex":"#399bd6"},{"code":"S 2060-B50G","hex":"#41d6d1"},{"code":"S 2060-B70G","hex":"#3ed6c0"},{"code":"S 2060-B90G","hex":"#37d68f"},{"code":"S 2060-G","hex":"#32d672"},{"code":"S 2060-G10Y","hex":"#5ad65f"},{"code":"S 2060-G20Y","hex":"#77d650"},{"code":"S 2060-G30Y","hex":"#8fd644"},{"code":"S 2060-G40Y","hex":"#a2d63a"},{"code":"S 2060-G50Y","hex":"#b3d63c"},{"code":"S 2060-G60Y","hex":"#c1d63e"},{"code":"S 2060-G70Y","hex":"#cfd640"},{"code":"S 2060-G80Y","hex":"#d6d241"},{"code":"S 2060-G90Y","hex":"#d6c83f"},{"code":"S 2060-R","hex":"#d62934"},{"code":"S 2060-R10B","hex":"#d62a3f"},{"code":"S 2060-R20B","hex":"#d62d4f"},{"code":"S 2060-R30B","hex":"#d63065"},{"code":"S 2060-R40B","hex":"#d63586"},{"code":"S 2060-R70B","hex":"#7642d6"},{"code":"S 2060-R80B","hex":"#2c4cd6"},{"code":"S 2060-R90B","hex":"#3067d6"},{"code":"S 2060-Y","hex":"#d6c03e"},{"code":"S 2060-Y10R","hex":"#d6b23c"},{"code":"S 2060-Y20R","hex":"#d6a43a"},{"code":"S 2060-Y30R","hex":"#d69638"},{"code":"S 2060-Y40R","hex":"#d68835"},{"code":"S 2060-Y50R","hex":"#d67933"},{"code":"S 2060-Y60R","hex":"#d66931"},{"code":"S 2060-Y70R","hex":"#d6592e"},{"code":"S 2060-Y80R","hex":"#d6492c"},{"code":"S 2060-Y90R","hex":"#d6392f"},{"code":"S 2065-B","hex":"#3098d6"},{"code":"S 2065-R20B","hex":"#d62649"},{"code":"S 2065-R90B","hex":"#2962d6"},{"code":"S 2070-G10Y","hex":"#4ed654"},{"code":"S 2070-G20Y","hex":"#6ed643"},{"code":"S 2070-G30Y","hex":"#87d635"},{"code":"S 2070-G40Y","hex":"#9dd629"},{"code":"S 2070-G50Y","hex":"#afd62b"},{"code":"S 2070-G60Y","hex":"#bed62d"},{"code":"S 2070-G70Y","hex":"#ced62e"},{"code":"S 2070-G80Y","hex":"#d6d12f"},{"code":"S 2070-G90Y","hex":"#d6c62d"},{"code":"S 2070-R","hex":"#d61c28"},{"code":"S 2070-R10B","hex":"#d61d34"},{"code":"S 2070-Y","hex":"#d6bd2c"},{"code":"S 2070-Y10R","hex":"#d6ae2b"},{"code":"S 2070-Y20R","hex":"#d69f29"},{"code":"S 2070-Y30R","hex":"#d68f27"},{"code":"S 2070-Y40R","hex":"#d68026"},{"code":"S 2070-Y50R","hex":"#d67024"},{"code":"S 2070-Y60R","hex":"#d65f22"},{"code":"S 2070-Y70R","hex":"#d64f20"},{"code":"S 2070-Y80R","hex":"#d63e1e"},{"code":"S 2070-Y90R","hex":"#d62d22"},{"code":"S 2075-G20Y","hex":"#69d63c"},{"code":"S 2075-G30Y","hex":"#84d62e"},{"code":"S 2075-Y60R","hex":"#d65b1b"},{"code":"S 2075-Y70R","hex":"#d64a1a"},{"code":"S 2500-N","hex":"#bfbfbf"},{"code":"S 2502-B","hex":"#c2c6c9"},{"code":"S 2502-G","hex":"#c0c9c4"},{"code":"S 2502-R","hex":"#c9bebf"},{"code":"S 2502-Y","hex":"#c9c8c2"},{"code":"S 2555-B20G","hex":"#43b3c9"},{"code":"S 2555-B30G","hex":"#44bcc9"},{"code":"S 2555-B40G","hex":"#46c5c9"},{"code":"S 2555-B60G","hex":"#44c9bd"},{"code":"S 2555-B80G","hex":"#41c9ab"},{"code":"S 2565-G","hex":"#28c967"},{"code":"S 2565-R80B","hex":"#2341c9"},{"code":"S 2570-G20Y","hex":"#67c93e"},{"code":"S 2570-G30Y","hex":"#7fc931"},{"code":"S 2570-R","hex":"#c91a25"},{"code":"S 2570-Y30R","hex":"#c98725"},{"code":"S 2570-Y40R","hex":"#c97823"},{"code":"S 2570-Y50R","hex":"#c96922"},{"code":"S 2570-Y60R","hex":"#c95920"},{"code":"S 2570-Y70R","hex":"#c94a1e"},{"code":"S 2570-Y80R","hex":"#c93a1c"},{"code":"S 2570-Y90R","hex":"#c92b20"},{"code":"S 3000-N","hex":"#b2b2b2"},{"code":"S 3005-B20G","hex":"#adb9bc"},{"code":"S 3005-B80G","hex":"#acbcb8"},{"code":"S 3005-G20Y","hex":"#b1bcad"},{"code":"S 3005-G50Y","hex":"#b8bcac"},{"code":"S 3005-G80Y","hex":"#bcbbae"},{"code":"S 3005-R20B","hex":"#bca6aa"},{"code":"S 3005-R50B","hex":"#bcacb9"},{"code":"S 3005-R80B","hex":"#a5aabc"},{"code":"S 3005-Y20R","hex":"#bcb6ab"},{"code":"S 3005-Y50R","hex":"#bcb1a9"},{"code":"S 3005-Y80R","hex":"#bca9a5"},{"code":"S 3010-B","hex":"#9cb0bc"},{"code":"S 3010-B10G","hex":"#9db4bc"},{"code":"S 3010-B30G","hex":"#a0b9bc"},{"code":"S 3010-B50G","hex":"#a0bcbb"},{"code":"S 3010-B70G","hex":"#9fbcb7"},{"code":"S 3010-B90G","hex":"#9abcad"},{"code":"S 3010-G","hex":"#97bca5"},{"code":"S 3010-G10Y","hex":"#a1bca2"},{"code":"S 3010-G20Y","hex":"#a8bca0"},{"code":"S 3010-G30Y","hex":"#adbc9e"},{"code":"S 3010-G40Y","hex":"#b1bc9c"},{"code":"S 3010-G50Y","hex":"#b5bc9e"},{"code":"S 3010-G60Y","hex":"#b8bc9f"},{"code":"S 3010-G70Y","hex":"#babca0"},{"code":"S 3010-G80Y","hex":"#bcbba0"},{"code":"S 3010-G90Y","hex":"#bcb9a0"},{"code":"S 3010-R","hex":"#bc8f92"},{"code":"S 3010-R10B","hex":"#bc9096"},{"code":"S 3010-R20B","hex":"#bc939b"},{"code":"S 3010-R30B","hex":"#bc96a2"},{"code":"S 3010-R40B","hex":"#bc99aa"},{"code":"S 3010-R50B","hex":"#bc9eb6"},{"code":"S 3010-R60B","hex":"#b29cbc"},{"code":"S 3010-R70B","hex":"#a79cbc"},{"code":"S 3010-R80B","hex":"#929abc"},{"code":"S 3010-R90B","hex":"#96a2bc"},{"code":"S 3010-Y","hex":"#bcb79f"},{"code":"S 3010-Y10R","hex":"#bcb59e"},{"code":"S 3010-Y20R","hex":"#bcb29c"},{"code":"S 3010-Y30R","hex":"#bcae9b"},{"code":"S 3010-Y40R","hex":"#bcab9a"},{"code":"S 3010-Y50R","hex":"#bca798"},{"code":"S 3010-Y60R","hex":"#bca396"},{"code":"S 3010-Y70R","hex":"#bc9e94"},{"code":"S 3010-Y80R","hex":"#bc9992"},{"code":"S 3010-Y90R","hex":"#bc9491"},{"code":"S 3020-B","hex":"#80a5bc"},{"code":"S 3020-B10G","hex":"#83adbc"},{"code":"S 3020-B30G","hex":"#86b7bc"},{"code":"S 3020-B40G","hex":"#88babc"},{"code":"S 3020-B50G","hex":"#88bcba"},{"code":"S 3020-B60G","hex":"#86bcb7"},{"code":"S 3020-B70G","hex":"#85bcb3"},{"code":"S 3020-B90G","hex":"#7ebca0"},{"code":"S 3020-G","hex":"#7abc93"},{"code":"S 3020-G10Y","hex":"#8bbc8d"},{"code":"S 3020-G20Y","hex":"#97bc88"},{"code":"S 3020-G30Y","hex":"#a1bc84"},{"code":"S 3020-G40Y","hex":"#a8bc81"},{"code":"S 3020-G50Y","hex":"#afbc84"},{"code":"S 3020-G60Y","hex":"#b4bc86"},{"code":"S 3020-G70Y","hex":"#b9bc87"},{"code":"S 3020-G80Y","hex":"#bcba88"},{"code":"S 3020-G90Y","hex":"#bcb686"},{"code":"S 3020-R","hex":"#bc6e73"},{"code":"S 3020-R10B","hex":"#bc7079"},{"code":"S 3020-R20B","hex":"#bc7382"},{"code":"S 3020-R30B","hex":"#bc778d"},{"code":"S 3020-R40B","hex":"#bc7d9c"},{"code":"S 3020-R50B","hex":"#bc84b1"},{"code":"S 3020-R60B","hex":"#a982bc"},{"code":"S 3020-R70B","hex":"#9682bc"},{"code":"S 3020-R80B","hex":"#7380bc"},{"code":"S 3020-R90B","hex":"#788ebc"},{"code":"S 3020-Y","hex":"#bcb385"},{"code":"S 3020-Y10R","hex":"#bcae83"},{"code":"S 3020-Y20R","hex":"#bca982"},{"code":"S 3020-Y30R","hex":"#bca37f"},{"code":"S 3020-Y40R","hex":"#bc9d7d"},{"code":"S 3020-Y50R","hex":"#bc967b"},{"code":"S 3020-Y60R","hex":"#bc8f78"},{"code":"S 3020-Y70R","hex":"#bc8775"},{"code":"S 3020-Y80R","hex":"#bc7f72"},{"code":"S 3020-Y90R","hex":"#bc7772"},{"code":"S 3030-B","hex":"#689cbc"},{"code":"S 3030-B10G","hex":"#6ca7bc"},{"code":"S 3030-B30G","hex":"#70b4bc"},{"code":"S 3030-B40G","hex":"#71b9bc"},{"code":"S 3030-B50G","hex":"#71bcb9"},{"code":"S 3030-B60G","hex":"#70bcb5"},{"code":"S 3030-B70G","hex":"#6ebcb0"},{"code":"S 3030-B90G","hex":"#66bc95"},{"code":"S 3030-G","hex":"#61bc84"},{"code":"S 3030-G10Y","hex":"#78bc7b"},{"code":"S 3030-G20Y","hex":"#89bc74"},{"code":"S 3030-G30Y","hex":"#96bc6e"},{"code":"S 3030-G40Y","hex":"#a0bc6a"},{"code":"S 3030-G50Y","hex":"#a9bc6c"},{"code":"S 3030-G60Y","hex":"#b1bc6f"},{"code":"S 3030-G70Y","hex":"#b8bc71"},{"code":"S 3030-G80Y","hex":"#bcb971"},{"code":"S 3030-G90Y","hex":"#bcb470"},{"code":"S 3030-R","hex":"#bc555b"},{"code":"S 3030-R10B","hex":"#bc5763"},{"code":"S 3030-R20B","hex":"#bc5a6e"},{"code":"S 3030-R30B","hex":"#bc5f7c"},{"code":"S 3030-R40B","hex":"#bc6590"},{"code":"S 3030-R50B","hex":"#bc6dad"},{"code":"S 3030-R60B","hex":"#a26abc"},{"code":"S 3030-R70B","hex":"#876bbc"},{"code":"S 3030-R80B","hex":"#5a6cbc"},{"code":"S 3030-R90B","hex":"#5f7ebc"},{"code":"S 3030-Y","hex":"#bcb06e"},{"code":"S 3030-Y10R","hex":"#bca96c"},{"code":"S 3030-Y20R","hex":"#bca16a"},{"code":"S 3030-Y30R","hex":"#bc9a68"},{"code":"S 3030-Y40R","hex":"#bc9165"},{"code":"S 3030-Y50R","hex":"#bc8862"},{"code":"S 3030-Y60R","hex":"#bc7f5f"},{"code":"S 3030-Y70R","hex":"#bc755c"},{"code":"S 3030-Y80R","hex":"#bc6a59"},{"code":"S 3030-Y90R","hex":"#bc6059"},{"code":"S 3040-B","hex":"#5495bc"},{"code":"S 3040-B10G","hex":"#57a2bc"},{"code":"S 3040-B20G","hex":"#59abbc"},{"code":"S 3040-B30G","hex":"#5bb3bc"},{"code":"S 3040-B40G","hex":"#5db9bc"},{"code":"S 3040-B50G","hex":"#5dbcb8"},{"code":"S 3040-B60G","hex":"#5bbcb3"},{"code":"S 3040-B70G","hex":"#5abcad"},{"code":"S 3040-B80G","hex":"#58bca5"},{"code":"S 3040-B90G","hex":"#52bc8c"},{"code":"S 3040-G","hex":"#4dbc78"},{"code":"S 3040-G10Y","hex":"#68bc6c"},{"code":"S 3040-G20Y","hex":"#7dbc63"},{"code":"S 3040-G30Y","hex":"#8cbc5b"},{"code":"S 3040-G40Y","hex":"#99bc55"},{"code":"S 3040-G50Y","hex":"#a5bc58"},{"code":"S 3040-G60Y","hex":"#aebc5a"},{"code":"S 3040-G70Y","hex":"#b7bc5c"},{"code":"S 3040-G80Y","hex":"#bcb95d"},{"code":"S 3040-G90Y","hex":"#bcb25b"},{"code":"S 3040-R","hex":"#bc4149"},{"code":"S 3040-R10B","hex":"#bc4352"},{"code":"S 3040-R20B","hex":"#bc465e"},{"code":"S 3040-R30B","hex":"#bc4a6e"},{"code":"S 3040-R40B","hex":"#bc5086"},{"code":"S 3040-R50B","hex":"#bc59a9"},{"code":"S 3040-R60B","hex":"#9b55bc"},{"code":"S 3040-R70B","hex":"#7b58bc"},{"code":"S 3040-R80B","hex":"#455bbc"},{"code":"S 3040-R90B","hex":"#4b70bc"},{"code":"S 3040-Y","hex":"#bcad5a"},{"code":"S 3040-Y10R","hex":"#bca458"},{"code":"S 3040-Y20R","hex":"#bc9b55"},{"code":"S 3040-Y30R","hex":"#bc9153"},{"code":"S 3040-Y40R","hex":"#bc8750"},{"code":"S 3040-Y50R","hex":"#bc7c4e"},{"code":"S 3040-Y60R","hex":"#bc714b"},{"code":"S 3040-Y70R","hex":"#bc6648"},{"code":"S 3040-Y80R","hex":"#bc5a45"},{"code":"S 3040-Y90R","hex":"#bc4d46"},{"code":"S 3050-B","hex":"#428ebc"},{"code":"S 3050-B10G","hex":"#459dbc"},{"code":"S 3050-B20G","hex":"#47a8bc"},{"code":"S 3050-B30G","hex":"#49b1bc"},{"code":"S 3050-B40G","hex":"#4ab8bc"},{"code":"S 3050-B50G","hex":"#4abcb8"},{"code":"S 3050-B60G","hex":"#49bcb1"},{"code":"S 3050-B70G","hex":"#47bcaa"},{"code":"S 3050-B80G","hex":"#45bca1"},{"code":"S 3050-B90G","hex":"#40bc84"},{"code":"S 3050-G","hex":"#3bbc6d"},{"code":"S 3050-G10Y","hex":"#5bbc5f"},{"code":"S 3050-G20Y","hex":"#72bc54"},{"code":"S 3050-G30Y","hex":"#84bc4a"},{"code":"S 3050-G40Y","hex":"#93bc43"},{"code":"S 3050-G50Y","hex":"#a0bc45"},{"code":"S 3050-G60Y","hex":"#abbc47"},{"code":"S 3050-G70Y","hex":"#b6bc4a"},{"code":"S 3050-G80Y","hex":"#bcb84a"},{"code":"S 3050-G90Y","hex":"#bcb048"},{"code":"S 3050-R","hex":"#bc313a"},{"code":"S 3050-R10B","hex":"#bc3343"},{"code":"S 3050-R20B","hex":"#bc3550"},{"code":"S 3050-R30B","hex":"#bc3963"},{"code":"S 3050-R40B","hex":"#bc3e7d"},{"code":"S 3050-R50B","hex":"#bc46a5"},{"code":"S 3050-R60B","hex":"#9543bc"},{"code":"S 3050-R70B","hex":"#7048bc"},{"code":"S 3050-R80B","hex":"#354ebc"},{"code":"S 3050-R90B","hex":"#3964bc"},{"code":"S 3050-Y","hex":"#bcaa47"},{"code":"S 3050-Y10R","hex":"#bca045"},{"code":"S 3050-Y20R","hex":"#bc9543"},{"code":"S 3050-Y30R","hex":"#bc8a41"},{"code":"S 3050-Y40R","hex":"#bc7e3e"},{"code":"S 3050-Y50R","hex":"#bc723c"},{"code":"S 3050-Y60R","hex":"#bc663a"},{"code":"S 3050-Y70R","hex":"#bc5937"},{"code":"S 3050-Y80R","hex":"#bc4c34"},{"code":"S 3050-Y90R","hex":"#bc3f36"},{"code":"S 3055-B50G","hex":"#41bcb7"},{"code":"S 3055-R30B","hex":"#bc315d"},{"code":"S 3055-R40B","hex":"#bc3679"},{"code":"S 3055-R50B","hex":"#bc3ea3"},{"code":"S 3060-B","hex":"#3188bc"},{"code":"S 3060-B10G","hex":"#3499bc"},{"code":"S 3060-B20G","hex":"#36a5bc"},{"code":"S 3060-B30G","hex":"#37afbc"},{"code":"S 3060-B40G","hex":"#39b8bc"},{"code":"S 3060-B70G","hex":"#36bca8"},{"code":"S 3060-B90G","hex":"#30bc7d"},{"code":"S 3060-G","hex":"#2cbc64"},{"code":"S 3060-G10Y","hex":"#4fbc53"},{"code":"S 3060-G20Y","hex":"#68bc46"},{"code":"S 3060-G30Y","hex":"#7dbc3b"},{"code":"S 3060-G40Y","hex":"#8ebc33"},{"code":"S 3060-G50Y","hex":"#9cbc35"},{"code":"S 3060-G60Y","hex":"#a9bc36"},{"code":"S 3060-G70Y","hex":"#b5bc38"},{"code":"S 3060-G80Y","hex":"#bcb739"},{"code":"S 3060-G90Y","hex":"#bcaf37"},{"code":"S 3060-R","hex":"#bc232d"},{"code":"S 3060-R10B","hex":"#bc2537"},{"code":"S 3060-R20B","hex":"#bc2745"},{"code":"S 3060-R70B","hex":"#673abc"},{"code":"S 3060-R80B","hex":"#2742bc"},{"code":"S 3060-R90B","hex":"#2a5abc"},{"code":"S 3060-Y","hex":"#bca836"},{"code":"S 3060-Y10R","hex":"#bc9c34"},{"code":"S 3060-Y20R","hex":"#bc9033"},{"code":"S 3060-Y30R","hex":"#bc8331"},{"code":"S 3060-Y40R","hex":"#bc772f"},{"code":"S 3060-Y50R","hex":"#bc692d"},{"code":"S 3060-Y60R","hex":"#bc5c2b"},{"code":"S 3060-Y70R","hex":"#bc4e29"},{"code":"S 3060-Y80R","hex":"#bc4026"},{"code":"S 3060-Y90R","hex":"#bc3229"},{"code":"S 3065-G10Y","hex":"#49bc4e"},{"code":"S 3065-G40Y","hex":"#8bbc2b"},{"code":"S 3065-G50Y","hex":"#9bbc2d"},{"code":"S 3065-G60Y","hex":"#a8bc2f"},{"code":"S 3065-R90B","hex":"#2456bc"},{"code":"S 3065-Y20R","hex":"#bc8d2b"},{"code":"S 3500-N","hex":"#a5a5a5"},{"code":"S 3502-B","hex":"#a8acae"},{"code":"S 3502-G","hex":"#a7aeaa"},{"code":"S 3502-R","hex":"#aea5a5"},{"code":"S 3502-Y","hex":"#aeada9"},{"code":"S 3555-B60G","hex":"#3baea4"},{"code":"S 3555-B80G","hex":"#39ae94"},{"code":"S 3555-R60B","hex":"#8836ae"},{"code":"S 3560-G","hex":"#29ae5d"},{"code":"S 3560-G10Y","hex":"#49ae4d"},{"code":"S 3560-G20Y","hex":"#61ae41"},{"code":"S 3560-G30Y","hex":"#74ae37"},{"code":"S 3560-G40Y","hex":"#84ae2f"},{"code":"S 3560-G50Y","hex":"#91ae31"},{"code":"S 3560-G60Y","hex":"#9dae33"},{"code":"S 3560-G70Y","hex":"#a8ae34"},{"code":"S 3560-R","hex":"#ae212a"},{"code":"S 3560-R80B","hex":"#243dae"},{"code":"S 3560-R90B","hex":"#2754ae"},{"code":"S 3560-Y","hex":"#ae9c32"},{"code":"S 3560-Y20R","hex":"#ae852f"},{"code":"S 3560-Y30R","hex":"#ae7a2d"},{"code":"S 3560-Y40R","hex":"#ae6e2b"},{"code":"S 3560-Y50R","hex":"#ae622a"},{"code":"S 3560-Y60R","hex":"#ae5528"},{"code":"S 3560-Y70R","hex":"#ae4926"},{"code":"S 3560-Y80R","hex":"#ae3c24"},{"code":"S 3560-Y90R","hex":"#ae2f26"},{"code":"S 4000-N","hex":"#999999"},{"code":"S 4005-B20G","hex":"#949fa1"},{"code":"S 4005-B80G","hex":"#94a19e"},{"code":"S 4005-G20Y","hex":"#98a194"},{"code":"S 4005-G50Y","hex":"#9ea194"},{"code":"S 4005-G80Y","hex":"#a1a095"},{"code":"S 4005-R20B","hex":"#a18e92"},{"code":"S 4005-R50B","hex":"#a1949e"},{"code":"S 4005-R80B","hex":"#8e91a1"},{"code":"S 4005-Y20R","hex":"#a19c93"},{"code":"S 4005-Y50R","hex":"#a19891"},{"code":"S 4005-Y80R","hex":"#a1918e"},{"code":"S 4010-B10G","hex":"#879aa1"},{"code":"S 4010-B30G","hex":"#899fa1"},{"code":"S 4010-B50G","hex":"#89a1a0"},{"code":"S 4010-B70G","hex":"#88a19d"},{"code":"S 4010-B90G","hex":"#84a194"},{"code":"S 4010-G10Y","hex":"#8aa18b"},{"code":"S 4010-G30Y","hex":"#94a187"},{"code":"S 4010-G50Y","hex":"#9ba187"},{"code":"S 4010-G70Y","hex":"#a0a189"},{"code":"S 4010-G90Y","hex":"#a19e89"},{"code":"S 4010-R10B","hex":"#a17c80"},{"code":"S 4010-R30B","hex":"#a1808b"},{"code":"S 4010-R50B","hex":"#a1889c"},{"code":"S 4010-R70B","hex":"#8f86a1"},{"code":"S 4010-R90B","hex":"#808ba1"},{"code":"S 4010-Y10R","hex":"#a19b87"},{"code":"S 4010-Y30R","hex":"#a19585"},{"code":"S 4010-Y50R","hex":"#a18f82"},{"code":"S 4010-Y70R","hex":"#a1887f"},{"code":"S 4010-Y90R","hex":"#a17f7d"},{"code":"S 4020-B","hex":"#6e8ea1"},{"code":"S 4020-B10G","hex":"#7094a1"},{"code":"S 4020-B30G","hex":"#739da1"},{"code":"S 4020-B50G","hex":"#74a19f"},{"code":"S 4020-B70G","hex":"#72a19a"},{"code":"S 4020-B90G","hex":"#6ca189"},{"code":"S 4020-G","hex":"#68a17e"},{"code":"S 4020-G10Y","hex":"#77a179"},{"code":"S 4020-G30Y","hex":"#8aa171"},{"code":"S 4020-G50Y","hex":"#96a171"},{"code":"S 4020-G70Y","hex":"#9fa174"},{"code":"S 4020-G90Y","hex":"#a19c73"},{"code":"S 4020-R","hex":"#a15e62"},{"code":"S 4020-R10B","hex":"#a16068"},{"code":"S 4020-R20B","hex":"#a1636f"},{"code":"S 4020-R30B","hex":"#a16679"},{"code":"S 4020-R40B","hex":"#a16b86"},{"code":"S 4020-R50B","hex":"#a17298"},{"code":"S 4020-R60B","hex":"#916fa1"},{"code":"S 4020-R70B","hex":"#806fa1"},{"code":"S 4020-R80B","hex":"#626ea1"},{"code":"S 4020-R90B","hex":"#677aa1"},{"code":"S 4020-Y","hex":"#a19a72"},{"code":"S 4020-Y10R","hex":"#a19571"},{"code":"S 4020-Y20R","hex":"#a1916f"},{"code":"S 4020-Y30R","hex":"#a18c6d"},{"code":"S 4020-Y40R","hex":"#a1876b"},{"code":"S 4020-Y50R","hex":"#a18169"},{"code":"S 4020-Y60R","hex":"#a17b67"},{"code":"S 4020-Y70R","hex":"#a17464"},{"code":"S 4020-Y80R","hex":"#a16d62"},{"code":"S 4020-Y90R","hex":"#a16662"},{"code":"S 4030-B","hex":"#5a86a1"},{"code":"S 4030-B10G","hex":"#5c8fa1"},{"code":"S 4030-B30G","hex":"#609ba1"},{"code":"S 4030-B50G","hex":"#61a19f"},{"code":"S 4030-B70G","hex":"#5fa197"},{"code":"S 4030-B90G","hex":"#58a180"},{"code":"S 4030-G","hex":"#53a171"},{"code":"S 4030-G10Y","hex":"#67a16a"},{"code":"S 4030-G30Y","hex":"#80a15f"},{"code":"S 4030-G50Y","hex":"#91a15d"},{"code":"S 4030-G70Y","hex":"#9ea161"},{"code":"S 4030-G90Y","hex":"#a19a60"},{"code":"S 4030-R","hex":"#a1494e"},{"code":"S 4030-R10B","hex":"#a14b55"},{"code":"S 4030-R20B","hex":"#a14d5e"},{"code":"S 4030-R30B","hex":"#a1516b"},{"code":"S 4030-R40B","hex":"#a1567c"},{"code":"S 4030-R50B","hex":"#a15e94"},{"code":"S 4030-R60B","hex":"#8b5ba1"},{"code":"S 4030-R70B","hex":"#745ca1"},{"code":"S 4030-R80B","hex":"#4d5ca1"},{"code":"S 4030-R90B","hex":"#516ca1"},{"code":"S 4030-Y","hex":"#a1975f"},{"code":"S 4030-Y10R","hex":"#a1915d"},{"code":"S 4030-Y20R","hex":"#a18a5b"},{"code":"S 4030-Y30R","hex":"#a18459"},{"code":"S 4030-Y40R","hex":"#a17c57"},{"code":"S 4030-Y50R","hex":"#a17554"},{"code":"S 4030-Y60R","hex":"#a16d52"},{"code":"S 4030-Y70R","hex":"#a1644f"},{"code":"S 4030-Y80R","hex":"#a15b4c"},{"code":"S 4030-Y90R","hex":"#a1524d"},{"code":"S 4040-B","hex":"#487fa1"},{"code":"S 4040-B10G","hex":"#4b8ba1"},{"code":"S 4040-B20G","hex":"#4d93a1"},{"code":"S 4040-B30G","hex":"#4e99a1"},{"code":"S 4040-B40G","hex":"#509ea1"},{"code":"S 4040-B50G","hex":"#4fa19e"},{"code":"S 4040-B60G","hex":"#4ea199"},{"code":"S 4040-B70G","hex":"#4da194"},{"code":"S 4040-B80G","hex":"#4ba18e"},{"code":"S 4040-B90G","hex":"#46a178"},{"code":"S 4040-G","hex":"#42a167"},{"code":"S 4040-G10Y","hex":"#59a15d"},{"code":"S 4040-G20Y","hex":"#6ba155"},{"code":"S 4040-G30Y","hex":"#78a14e"},{"code":"S 4040-G40Y","hex":"#83a149"},{"code":"S 4040-G50Y","hex":"#8da14b"},{"code":"S 4040-G60Y","hex":"#95a14d"},{"code":"S 4040-G70Y","hex":"#9da14f"},{"code":"S 4040-G80Y","hex":"#a19e50"},{"code":"S 4040-G90Y","hex":"#a1994e"},{"code":"S 4040-R","hex":"#a1383e"},{"code":"S 4040-R10B","hex":"#a13946"},{"code":"S 4040-R20B","hex":"#a13c50"},{"code":"S 4040-R30B","hex":"#a1405f"},{"code":"S 4040-R40B","hex":"#a14573"},{"code":"S 4040-R50B","hex":"#a14c91"},{"code":"S 4040-R60B","hex":"#8549a1"},{"code":"S 4040-R70B","hex":"#694ca1"},{"code":"S 4040-R80B","hex":"#3b4ea1"},{"code":"S 4040-R90B","hex":"#4060a1"},{"code":"S 4040-Y","hex":"#a1944d"},{"code":"S 4040-Y10R","hex":"#a18d4b"},{"code":"S 4040-Y20R","hex":"#a18549"},{"code":"S 4040-Y30R","hex":"#a17c47"},{"code":"S 4040-Y40R","hex":"#a17445"},{"code":"S 4040-Y50R","hex":"#a16b43"},{"code":"S 4040-Y60R","hex":"#a16140"},{"code":"S 4040-Y70R","hex":"#a1573e"},{"code":"S 4040-Y80R","hex":"#a14d3b"},{"code":"S 4040-Y90R","hex":"#a1423c"},{"code":"S 4050-B","hex":"#387aa1"},{"code":"S 4050-B10G","hex":"#3b87a1"},{"code":"S 4050-B20G","hex":"#3d90a1"},{"code":"S 4050-B30G","hex":"#3e98a1"},{"code":"S 4050-B40G","hex":"#3f9ea1"},{"code":"S 4050-B50G","hex":"#3fa19e"},{"code":"S 4050-B60G","hex":"#3ea198"},{"code":"S 4050-B70G","hex":"#3da192"},{"code":"S 4050-B80G","hex":"#3ca18a"},{"code":"S 4050-B90G","hex":"#36a171"},{"code":"S 4050-G","hex":"#33a15d"},{"code":"S 4050-G10Y","hex":"#4ea151"},{"code":"S 4050-G20Y","hex":"#62a148"},{"code":"S 4050-G30Y","hex":"#71a140"},{"code":"S 4050-G40Y","hex":"#7ea139"},{"code":"S 4050-G50Y","hex":"#89a13b"},{"code":"S 4050-G60Y","hex":"#93a13d"},{"code":"S 4050-G70Y","hex":"#9ca13f"},{"code":"S 4050-G80Y","hex":"#a19e3f"},{"code":"S 4050-G90Y","hex":"#a1973e"},{"code":"S 4050-R","hex":"#a12a31"},{"code":"S 4050-R10B","hex":"#a12b3a"},{"code":"S 4050-R20B","hex":"#a12e45"},{"code":"S 4050-R30B","hex":"#a13154"},{"code":"S 4050-R40B","hex":"#a1356b"},{"code":"S 4050-R50B","hex":"#a13c8e"},{"code":"S 4050-R60B","hex":"#8039a1"},{"code":"S 4050-R70B","hex":"#603ea1"},{"code":"S 4050-R80B","hex":"#2d42a1"},{"code":"S 4050-R90B","hex":"#3156a1"},{"code":"S 4050-Y","hex":"#a1923d"},{"code":"S 4050-Y10R","hex":"#a1893b"},{"code":"S 4050-Y20R","hex":"#a18039"},{"code":"S 4050-Y30R","hex":"#a17637"},{"code":"S 4050-Y40R","hex":"#a16c36"},{"code":"S 4050-Y50R","hex":"#a16233"},{"code":"S 4050-Y60R","hex":"#a15731"},{"code":"S 4050-Y70R","hex":"#a14c2f"},{"code":"S 4050-Y80R","hex":"#a1412d"},{"code":"S 4050-Y90R","hex":"#a1362e"},{"code":"S 4055-B","hex":"#3177a1"},{"code":"S 4055-B40G","hex":"#389ea1"},{"code":"S 4055-R70B","hex":"#5c37a1"},{"code":"S 4055-R95B","hex":"#2d5fa1"},{"code":"S 4055-Y10R","hex":"#a18734"},{"code":"S 4500-N","hex":"#8c8c8c"},{"code":"S 4502-B","hex":"#8e9193"},{"code":"S 4502-G","hex":"#8d9390"},{"code":"S 4502-R","hex":"#938b8c"},{"code":"S 4502-Y","hex":"#93938f"},{"code":"S 4550-B","hex":"#336f93"},{"code":"S 4550-B20G","hex":"#388493"},{"code":"S 4550-B30G","hex":"#398b93"},{"code":"S 4550-B40G","hex":"#3a9193"},{"code":"S 4550-B50G","hex":"#3a9390"},{"code":"S 4550-B80G","hex":"#37937f"},{"code":"S 4550-B90G","hex":"#329368"},{"code":"S 4550-G","hex":"#2e9356"},{"code":"S 4550-G10Y","hex":"#47934b"},{"code":"S 4550-G20Y","hex":"#599342"},{"code":"S 4550-G30Y","hex":"#68933a"},{"code":"S 4550-G40Y","hex":"#749335"},{"code":"S 4550-G50Y","hex":"#7e9336"},{"code":"S 4550-G60Y","hex":"#879338"},{"code":"S 4550-G70Y","hex":"#8f933a"},{"code":"S 4550-R70B","hex":"#583993"},{"code":"S 4550-R80B","hex":"#293d93"},{"code":"S 4550-R90B","hex":"#2d4f93"},{"code":"S 4550-Y","hex":"#938638"},{"code":"S 4550-Y30R","hex":"#936c33"},{"code":"S 4550-Y40R","hex":"#936331"},{"code":"S 4550-Y50R","hex":"#935a2f"},{"code":"S 4550-Y60R","hex":"#93502d"},{"code":"S 4550-Y70R","hex":"#93462b"},{"code":"S 4550-Y80R","hex":"#933b29"},{"code":"S 4550-Y90R","hex":"#93312a"},{"code":"S 5000-N","hex":"#7f7f7f"},{"code":"S 5005-B20G","hex":"#7b8486"},{"code":"S 5005-B80G","hex":"#7b8684"},{"code":"S 5005-G20Y","hex":"#7f867c"},{"code":"S 5005-G50Y","hex":"#83867b"},{"code":"S 5005-G80Y","hex":"#86867c"},{"code":"S 5005-R20B","hex":"#86767a"},{"code":"S 5005-R50B","hex":"#867b84"},{"code":"S 5005-R80B","hex":"#767986"},{"code":"S 5005-Y20R","hex":"#86827a"},{"code":"S 5005-Y50R","hex":"#867e79"},{"code":"S 5005-Y80R","hex":"#867976"},{"code":"S 5010-B10G","hex":"#708186"},{"code":"S 5010-B30G","hex":"#728486"},{"code":"S 5010-B50G","hex":"#738685"},{"code":"S 5010-B70G","hex":"#718683"},{"code":"S 5010-B90G","hex":"#6e867b"},{"code":"S 5010-G10Y","hex":"#738674"},{"code":"S 5010-G30Y","hex":"#7c8671"},{"code":"S 5010-G50Y","hex":"#818671"},{"code":"S 5010-G70Y","hex":"#858672"},{"code":"S 5010-G90Y","hex":"#868472"},{"code":"S 5010-R10B","hex":"#86676b"},{"code":"S 5010-R30B","hex":"#866b74"},{"code":"S 5010-R50B","hex":"#867182"},{"code":"S 5010-R70B","hex":"#776f86"},{"code":"S 5010-R90B","hex":"#6b7486"},{"code":"S 5010-Y10R","hex":"#868171"},{"code":"S 5010-Y30R","hex":"#867d6f"},{"code":"S 5010-Y50R","hex":"#86776d"},{"code":"S 5010-Y70R","hex":"#86716a"},{"code":"S 5010-Y90R","hex":"#866a68"},{"code":"S 5020-B","hex":"#5c7686"},{"code":"S 5020-B10G","hex":"#5e7c86"},{"code":"S 5020-B30G","hex":"#608286"},{"code":"S 5020-B50G","hex":"#618685"},{"code":"S 5020-B70G","hex":"#5f8680"},{"code":"S 5020-B90G","hex":"#5a8672"},{"code":"S 5020-G","hex":"#578669"},{"code":"S 5020-G10Y","hex":"#638665"},{"code":"S 5020-G30Y","hex":"#73865f"},{"code":"S 5020-G50Y","hex":"#7d865e"},{"code":"S 5020-G70Y","hex":"#848661"},{"code":"S 5020-G90Y","hex":"#868260"},{"code":"S 5020-R","hex":"#864e52"},{"code":"S 5020-R10B","hex":"#865057"},{"code":"S 5020-R20B","hex":"#86525d"},{"code":"S 5020-R30B","hex":"#865565"},{"code":"S 5020-R40B","hex":"#865970"},{"code":"S 5020-R50B","hex":"#865f7e"},{"code":"S 5020-R60B","hex":"#795d86"},{"code":"S 5020-R70B","hex":"#6b5d86"},{"code":"S 5020-R80B","hex":"#525b86"},{"code":"S 5020-R90B","hex":"#556586"},{"code":"S 5020-Y","hex":"#86805f"},{"code":"S 5020-Y10R","hex":"#867d5e"},{"code":"S 5020-Y20R","hex":"#86795c"},{"code":"S 5020-Y30R","hex":"#86755b"},{"code":"S 5020-Y40R","hex":"#867059"},{"code":"S 5020-Y50R","hex":"#866b58"},{"code":"S 5020-Y60R","hex":"#866656"},{"code":"S 5020-Y70R","hex":"#866154"},{"code":"S 5020-Y80R","hex":"#865b52"},{"code":"S 5020-Y90R","hex":"#865551"},{"code":"S 5030-B","hex":"#4b7086"},{"code":"S 5030-B10G","hex":"#4d7786"},{"code":"S 5030-B30G","hex":"#508186"},{"code":"S 5030-B50G","hex":"#518684"},{"code":"S 5030-B70G","hex":"#4f867e"},{"code":"S 5030-B90G","hex":"#49866b"},{"code":"S 5030-G","hex":"#45865f"},{"code":"S 5030-G10Y","hex":"#568658"},{"code":"S 5030-G30Y","hex":"#6b864f"},{"code":"S 5030-G50Y","hex":"#79864d"},{"code":"S 5030-G70Y","hex":"#838651"},{"code":"S 5030-G90Y","hex":"#868150"},{"code":"S 5030-R","hex":"#863c41"},{"code":"S 5030-R10B","hex":"#863e47"},{"code":"S 5030-R20B","hex":"#86404e"},{"code":"S 5030-R30B","hex":"#864459"},{"code":"S 5030-R40B","hex":"#864867"},{"code":"S 5030-R50B","hex":"#864e7b"},{"code":"S 5030-R60B","hex":"#734c86"},{"code":"S 5030-R70B","hex":"#614d86"},{"code":"S 5030-R80B","hex":"#404d86"},{"code":"S 5030-R90B","hex":"#445a86"},{"code":"S 5030-Y","hex":"#867e4f"},{"code":"S 5030-Y10R","hex":"#86794d"},{"code":"S 5030-Y20R","hex":"#86734c"},{"code":"S 5030-Y30R","hex":"#866e4a"},{"code":"S 5030-Y40R","hex":"#866848"},{"code":"S 5030-Y50R","hex":"#866146"},{"code":"S 5030-Y60R","hex":"#865b44"},{"code":"S 5030-Y70R","hex":"#865342"},{"code":"S 5030-Y80R","hex":"#864c40"},{"code":"S 5030-Y90R","hex":"#864440"},{"code":"S 5040-B","hex":"#3c6a86"},{"code":"S 5040-B10G","hex":"#3e7486"},{"code":"S 5040-B20G","hex":"#407a86"},{"code":"S 5040-B30G","hex":"#418086"},{"code":"S 5040-B40G","hex":"#428486"},{"code":"S 5040-B50G","hex":"#428684"},{"code":"S 5040-B60G","hex":"#418680"},{"code":"S 5040-B70G","hex":"#40867c"},{"code":"S 5040-B80G","hex":"#3f8676"},{"code":"S 5040-B90G","hex":"#3a8664"},{"code":"S 5040-G","hex":"#378656"},{"code":"S 5040-G10Y","hex":"#4b864d"},{"code":"S 5040-G20Y","hex":"#598646"},{"code":"S 5040-G30Y","hex":"#648641"},{"code":"S 5040-G40Y","hex":"#6e863d"},{"code":"S 5040-G50Y","hex":"#76863f"},{"code":"S 5040-G60Y","hex":"#7c8640"},{"code":"S 5040-G70Y","hex":"#838642"},{"code":"S 5040-G80Y","hex":"#868442"},{"code":"S 5040-G90Y","hex":"#867f41"},{"code":"S 5040-R","hex":"#862e34"},{"code":"S 5040-R10B","hex":"#86303a"},{"code":"S 5040-R20B","hex":"#863243"},{"code":"S 5040-R30B","hex":"#86354f"},{"code":"S 5040-R40B","hex":"#863960"},{"code":"S 5040-R50B","hex":"#863f78"},{"code":"S 5040-R60B","hex":"#6f3d86"},{"code":"S 5040-R70B","hex":"#583f86"},{"code":"S 5040-R80B","hex":"#324186"},{"code":"S 5040-R90B","hex":"#355086"},{"code":"S 5040-Y","hex":"#867c40"},{"code":"S 5040-Y10R","hex":"#86753f"},{"code":"S 5040-Y20R","hex":"#866f3d"},{"code":"S 5040-Y30R","hex":"#86683b"},{"code":"S 5040-Y40R","hex":"#866039"},{"code":"S 5040-Y50R","hex":"#865937"},{"code":"S 5040-Y60R","hex":"#865135"},{"code":"S 5040-Y70R","hex":"#864933"},{"code":"S 5040-Y80R","hex":"#864031"},{"code":"S 5040-Y90R","hex":"#863732"},{"code":"S 5045-B10G","hex":"#377286"},{"code":"S 5500-N","hex":"#727272"},{"code":"S 5502-B","hex":"#747779"},{"code":"S 5502-G","hex":"#747976"},{"code":"S 5502-R","hex":"#797272"},{"code":"S 5502-Y","hex":"#797875"},{"code":"S 5540-B","hex":"#366079"},{"code":"S 5540-B10G","hex":"#386879"},{"code":"S 5540-B20G","hex":"#396e79"},{"code":"S 5540-B30G","hex":"#3b7379"},{"code":"S 5540-B40G","hex":"#3c7779"},{"code":"S 5540-B50G","hex":"#3c7977"},{"code":"S 5540-B80G","hex":"#38796a"},{"code":"S 5540-B90G","hex":"#34795a"},{"code":"S 5540-G","hex":"#31794d"},{"code":"S 5540-G10Y","hex":"#437945"},{"code":"S 5540-G20Y","hex":"#50793f"},{"code":"S 5540-G30Y","hex":"#5a793b"},{"code":"S 5540-G40Y","hex":"#637937"},{"code":"S 5540-G50Y","hex":"#6a7938"},{"code":"S 5540-G60Y","hex":"#70793a"},{"code":"S 5540-G70Y","hex":"#76793b"},{"code":"S 5540-R70B","hex":"#4f3979"},{"code":"S 5540-R90B","hex":"#304879"},{"code":"S 5540-Y90R","hex":"#79322d"},{"code":"S 6000-N","hex":"#666666"},{"code":"S 6005-B20G","hex":"#636a6b"},{"code":"S 6005-B80G","hex":"#626b69"},{"code":"S 6005-G20Y","hex":"#656b63"},{"code":"S 6005-G50Y","hex":"#696b62"},{"code":"S 6005-G80Y","hex":"#6b6b63"},{"code":"S 6005-R20B","hex":"#6b5f61"},{"code":"S 6005-R50B","hex":"#6b636a"},{"code":"S 6005-R80B","hex":"#5f616b"},{"code":"S 6005-Y20R","hex":"#6b6862"},{"code":"S 6005-Y50R","hex":"#6b6560"},{"code":"S 6005-Y80R","hex":"#6b615e"},{"code":"S 6010-B10G","hex":"#5a676b"},{"code":"S 6010-B30G","hex":"#5b6a6b"},{"code":"S 6010-B50G","hex":"#5c6b6b"},{"code":"S 6010-B70G","hex":"#5b6b69"},{"code":"S 6010-B90G","hex":"#586b63"},{"code":"S 6010-G10Y","hex":"#5c6b5d"},{"code":"S 6010-G30Y","hex":"#636b5a"},{"code":"S 6010-G50Y","hex":"#676b5a"},{"code":"S 6010-G70Y","hex":"#6a6b5c"},{"code":"S 6010-G90Y","hex":"#6b6a5b"},{"code":"S 6010-R10B","hex":"#6b5356"},{"code":"S 6010-R30B","hex":"#6b565c"},{"code":"S 6010-R50B","hex":"#6b5a68"},{"code":"S 6010-R70B","hex":"#5f596b"},{"code":"S 6010-R90B","hex":"#565d6b"},{"code":"S 6010-Y10R","hex":"#6b675a"},{"code":"S 6010-Y30R","hex":"#6b6459"},{"code":"S 6010-Y50R","hex":"#6b5f57"},{"code":"S 6010-Y70R","hex":"#6b5a55"},{"code":"S 6010-Y90R","hex":"#6b5553"},{"code":"S 6020-B","hex":"#495e6b"},{"code":"S 6020-B10G","hex":"#4b636b"},{"code":"S 6020-B30G","hex":"#4d686b"},{"code":"S 6020-B50G","hex":"#4d6b6a"},{"code":"S 6020-B70G","hex":"#4c6b67"},{"code":"S 6020-B90G","hex":"#486b5b"},{"code":"S 6020-G","hex":"#456b54"},{"code":"S 6020-G10Y","hex":"#4f6b51"},{"code":"S 6020-G30Y","hex":"#5c6b4c"},{"code":"S 6020-G50Y","hex":"#646b4b"},{"code":"S 6020-G70Y","hex":"#6a6b4d"},{"code":"S 6020-G90Y","hex":"#6b684d"},{"code":"S 6020-R","hex":"#6b3f42"},{"code":"S 6020-R10B","hex":"#6b4045"},{"code":"S 6020-R20B","hex":"#6b424a"},{"code":"S 6020-R30B","hex":"#6b4451"},{"code":"S 6020-R40B","hex":"#6b4759"},{"code":"S 6020-R50B","hex":"#6b4c65"},{"code":"S 6020-R60B","hex":"#614a6b"},{"code":"S 6020-R70B","hex":"#564a6b"},{"code":"S 6020-R80B","hex":"#41496b"},{"code":"S 6020-R90B","hex":"#44516b"},{"code":"S 6020-Y","hex":"#6b674c"},{"code":"S 6020-Y10R","hex":"#6b644b"},{"code":"S 6020-Y20R","hex":"#6b614a"},{"code":"S 6020-Y30R","hex":"#6b5d49"},{"code":"S 6020-Y40R","hex":"#6b5a47"},{"code":"S 6020-Y50R","hex":"#6b5646"},{"code":"S 6020-Y60R","hex":"#6b5245"},{"code":"S 6020-Y70R","hex":"#6b4d43"},{"code":"S 6020-Y80R","hex":"#6b4841"},{"code":"S 6020-Y90R","hex":"#6b4441"},{"code":"S 6030-B","hex":"#3c596b"},{"code":"S 6030-B10G","hex":"#3e606b"},{"code":"S 6030-B30G","hex":"#40676b"},{"code":"S 6030-B50G","hex":"#416b6a"},{"code":"S 6030-B70G","hex":"#3f6b65"},{"code":"S 6030-B90G","hex":"#3a6b55"},{"code":"S 6030-G","hex":"#376b4c"},{"code":"S 6030-G10Y","hex":"#456b46"},{"code":"S 6030-G30Y","hex":"#566b3f"},{"code":"S 6030-G50Y","hex":"#616b3e"},{"code":"S 6030-G70Y","hex":"#696b40"},{"code":"S 6030-G90Y","hex":"#6b6740"},{"code":"S 6030-R","hex":"#6b3034"},{"code":"S 6030-R10B","hex":"#6b3239"},{"code":"S 6030-R20B","hex":"#6b343f"},{"code":"S 6030-R30B","hex":"#6b3647"},{"code":"S 6030-R40B","hex":"#6b3a52"},{"code":"S 6030-R50B","hex":"#6b3e63"},{"code":"S 6030-R60B","hex":"#5c3d6b"},{"code":"S 6030-R70B","hex":"#4d3d6b"},{"code":"S 6030-R80B","hex":"#333d6b"},{"code":"S 6030-R90B","hex":"#36486b"},{"code":"S 6030-Y","hex":"#6b653f"},{"code":"S 6030-Y10R","hex":"#6b613e"},{"code":"S 6030-Y20R","hex":"#6b5c3d"},{"code":"S 6030-Y30R","hex":"#6b583b"},{"code":"S 6030-Y40R","hex":"#6b533a"},{"code":"S 6030-Y50R","hex":"#6b4e38"},{"code":"S 6030-Y60R","hex":"#6b4836"},{"code":"S 6030-Y70R","hex":"#6b4335"},{"code":"S 6030-Y80R","hex":"#6b3d33"},{"code":"S 6030-Y90R","hex":"#6b3733"},{"code":"S 6035-B60G","hex":"#3a6b67"},{"code":"S 6500-N","hex":"#595959"},{"code":"S 6502-B","hex":"#5a5d5e"},{"code":"S 6502-G","hex":"#5a5e5b"},{"code":"S 6502-R","hex":"#5e5959"},{"code":"S 6502-Y","hex":"#5e5d5b"},{"code":"S 6530-B30G","hex":"#385a5e"},{"code":"S 6530-B50G","hex":"#395e5d"},{"code":"S 6530-G10Y","hex":"#3c5e3e"},{"code":"S 6530-G50Y","hex":"#555e36"},{"code":"S 7000-N","hex":"#4c4c4c"},{"code":"S 7005-B20G","hex":"#4a4f50"},{"code":"S 7005-B80G","hex":"#4a504f"},{"code":"S 7005-G20Y","hex":"#4c504a"},{"code":"S 7005-G50Y","hex":"#4f504a"},{"code":"S 7005-G80Y","hex":"#50504a"},{"code":"S 7005-R20B","hex":"#504749"},{"code":"S 7005-R50B","hex":"#504a4f"},{"code":"S 7005-R80B","hex":"#474950"},{"code":"S 7005-Y20R","hex":"#504e4a"},{"code":"S 7005-Y50R","hex":"#504c48"},{"code":"S 7005-Y80R","hex":"#504947"},{"code":"S 7010-B10G","hex":"#434d50"},{"code":"S 7010-B30G","hex":"#444f50"},{"code":"S 7010-B50G","hex":"#455050"},{"code":"S 7010-B70G","hex":"#44504f"},{"code":"S 7010-B90G","hex":"#42504a"},{"code":"S 7010-G10Y","hex":"#455046"},{"code":"S 7010-G30Y","hex":"#4a5044"},{"code":"S 7010-G50Y","hex":"#4e5044"},{"code":"S 7010-G70Y","hex":"#505045"},{"code":"S 7010-G90Y","hex":"#504f44"},{"code":"S 7010-R10B","hex":"#503e40"},{"code":"S 7010-R30B","hex":"#504045"},{"code":"S 7010-R50B","hex":"#50444e"},{"code":"S 7010-R70B","hex":"#484350"},{"code":"S 7010-R90B","hex":"#404650"},{"code":"S 7010-Y10R","hex":"#504d44"},{"code":"S 7010-Y30R","hex":"#504b42"},{"code":"S 7010-Y50R","hex":"#504841"},{"code":"S 7010-Y70R","hex":"#50443f"},{"code":"S 7010-Y90R","hex":"#503f3e"},{"code":"S 7020-B","hex":"#374750"},{"code":"S 7020-B10G","hex":"#384a50"},{"code":"S 7020-B30G","hex":"#3a4e50"},{"code":"S 7020-B50G","hex":"#3a5050"},{"code":"S 7020-B70G","hex":"#39504d"},{"code":"S 7020-B90G","hex":"#365045"},{"code":"S 7020-G","hex":"#34503f"},{"code":"S 7020-G10Y","hex":"#3c503c"},{"code":"S 7020-G30Y","hex":"#455039"},{"code":"S 7020-G50Y","hex":"#4b5038"},{"code":"S 7020-G70Y","hex":"#4f503a"},{"code":"S 7020-G90Y","hex":"#504e3a"},{"code":"S 7020-R","hex":"#502f31"},{"code":"S 7020-R10B","hex":"#503034"},{"code":"S 7020-R20B","hex":"#503138"},{"code":"S 7020-R30B","hex":"#50333c"},{"code":"S 7020-R40B","hex":"#503543"},{"code":"S 7020-R50B","hex":"#50394c"},{"code":"S 7020-R60B","hex":"#483750"},{"code":"S 7020-R70B","hex":"#403750"},{"code":"S 7020-R80B","hex":"#313750"},{"code":"S 7020-R90B","hex":"#333d50"},{"code":"S 7020-Y","hex":"#504d39"},{"code":"S 7020-Y10R","hex":"#504b38"},{"code":"S 7020-Y20R","hex":"#504837"},{"code":"S 7020-Y30R","hex":"#504637"},{"code":"S 7020-Y40R","hex":"#504336"},{"code":"S 7020-Y50R","hex":"#504035"},{"code":"S 7020-Y60R","hex":"#503d33"},{"code":"S 7020-Y70R","hex":"#503a32"},{"code":"S 7020-Y80R","hex":"#503631"},{"code":"S 7020-Y90R","hex":"#503331"},{"code":"S 7500-N","hex":"#3f3f3f"},{"code":"S 7502-B","hex":"#414243"},{"code":"S 7502-G","hex":"#404341"},{"code":"S 7502-R","hex":"#433f40"},{"code":"S 7502-Y","hex":"#434341"},{"code":"S 8000-N","hex":"#323232"},{"code":"S 8005-B20G","hex":"#313536"},{"code":"S 8005-B80G","hex":"#313635"},{"code":"S 8005-G20Y","hex":"#333632"},{"code":"S 8005-G50Y","hex":"#353631"},{"code":"S 8005-G80Y","hex":"#363632"},{"code":"S 8005-R20B","hex":"#362f31"},{"code":"S 8005-R50B","hex":"#363135"},{"code":"S 8005-R80B","hex":"#2f3036"},{"code":"S 8005-Y20R","hex":"#363431"},{"code":"S 8005-Y50R","hex":"#363330"},{"code":"S 8005-Y80R","hex":"#36302f"},{"code":"S 8010-B10G","hex":"#2d3336"},{"code":"S 8010-B30G","hex":"#2e3536"},{"code":"S 8010-B50G","hex":"#2e3635"},{"code":"S 8010-B70G","hex":"#2d3634"},{"code":"S 8010-B90G","hex":"#2c3631"},{"code":"S 8010-G10Y","hex":"#2e362e"},{"code":"S 8010-G30Y","hex":"#31362d"},{"code":"S 8010-G50Y","hex":"#34362d"},{"code":"S 8010-G70Y","hex":"#35362e"},{"code":"S 8010-G90Y","hex":"#36352e"},{"code":"S 8010-R10B","hex":"#36292b"},{"code":"S 8010-R30B","hex":"#362b2e"},{"code":"S 8010-R50B","hex":"#362d34"},{"code":"S 8010-R70B","hex":"#302d36"},{"code":"S 8010-R90B","hex":"#2b2e36"},{"code":"S 8010-Y10R","hex":"#36342d"},{"code":"S 8010-Y30R","hex":"#36322c"},{"code":"S 8010-Y50R","hex":"#36302b"},{"code":"S 8010-Y70R","hex":"#362d2a"},{"code":"S 8010-Y90R","hex":"#362a2a"},{"code":"S 8500-N","hex":"#262626"},{"code":"S 8500-N","hex":"#262626"},{"code":"S 8502-B","hex":"#272828"},{"code":"S 8502-G","hex":"#272827"},{"code":"S 8502-R","hex":"#282626"},{"code":"S 8502-Y","hex":"#282827"},{"code":"S 8505-B20G","hex":"#252828"},{"code":"S 8505-B80G","hex":"#252828"},{"code":"S 8505-G20Y","hex":"#262825"},{"code":"S 8505-G80Y","hex":"#282825"},{"code":"S 8505-R20B","hex":"#282425"},{"code":"S 8505-R80B","hex":"#242428"},{"code":"S 8505-Y20R","hex":"#282725"},{"code":"S 8505-Y80R","hex":"#282423"}];
        for (var i = 0; i < ncsSwatches.length; i++) {
            ncsSwatches[i].code = "NC"+ncsSwatches[i].code;
            swatches.push(ncsSwatches[i]);
        }
    }
    if (includePantone || colorSystems == "*") {
        // From view-source: https://github.com/vanderlee/colorpicker/wiki/Pantone-colors-(csv,-semicolon-separated)
        // Converted to JSON via https://www.csvjson.com/csv2json
        var pantoneSwatches = [{"code":100,"r":244,"g":237,"b":124,"hex":"#F4ED7C"},{"code":101,"r":244,"g":237,"b":71,"hex":"#F4ED47"},{"code":102,"r":249,"g":232,"b":20,"hex":"#F9E814"},{"code":103,"r":198,"g":173,"b":15,"hex":"#C6AD0F"},{"code":104,"r":173,"g":155,"b":12,"hex":"#AD9B0C"},{"code":105,"r":130,"g":117,"b":15,"hex":"#82750F"},{"code":106,"r":247,"g":232,"b":89,"hex":"#F7E859"},{"code":107,"r":249,"g":229,"b":38,"hex":"#F9E526"},{"code":108,"r":249,"g":221,"b":22,"hex":"#F9DD16"},{"code":109,"r":249,"g":214,"b":22,"hex":"#F9D616"},{"code":110,"r":216,"g":181,"b":17,"hex":"#D8B511"},{"code":111,"r":170,"g":147,"b":10,"hex":"#AA930A"},{"code":112,"r":153,"g":132,"b":10,"hex":"#99840A"},{"code":113,"r":249,"g":229,"b":91,"hex":"#F9E55B"},{"code":114,"r":249,"g":226,"b":76,"hex":"#F9E24C"},{"code":115,"r":249,"g":224,"b":76,"hex":"#F9E04C"},{"code":116,"r":252,"g":209,"b":22,"hex":"#FCD116"},{"code":"116 2X","r":247,"g":181,"b":12,"hex":"#F7B50C"},{"code":117,"r":198,"g":160,"b":12,"hex":"#C6A00C"},{"code":118,"r":170,"g":142,"b":10,"hex":"#AA8E0A"},{"code":119,"r":137,"g":119,"b":25,"hex":"#897719"},{"code":120,"r":249,"g":226,"b":127,"hex":"#F9E27F"},{"code":1205,"r":247,"g":232,"b":170,"hex":"#F7E8AA"},{"code":121,"r":249,"g":224,"b":112,"hex":"#F9E070"},{"code":1215,"r":249,"g":224,"b":140,"hex":"#F9E08C"},{"code":122,"r":252,"g":216,"b":86,"hex":"#FCD856"},{"code":1225,"r":255,"g":204,"b":73,"hex":"#FFCC49"},{"code":123,"r":255,"g":198,"b":30,"hex":"#FFC61E"},{"code":1235,"r":252,"g":181,"b":20,"hex":"#FCB514"},{"code":124,"r":224,"g":170,"b":15,"hex":"#E0AA0F"},{"code":1245,"r":191,"g":145,"b":12,"hex":"#BF910C"},{"code":125,"r":181,"g":140,"b":10,"hex":"#B58C0A"},{"code":1255,"r":163,"g":127,"b":20,"hex":"#A37F14"},{"code":126,"r":163,"g":130,"b":5,"hex":"#A38205"},{"code":1265,"r":124,"g":99,"b":22,"hex":"#7C6316"},{"code":127,"r":244,"g":226,"b":135,"hex":"#F4E287"},{"code":128,"r":244,"g":219,"b":96,"hex":"#F4DB60"},{"code":129,"r":242,"g":209,"b":61,"hex":"#F2D13D"},{"code":130,"r":234,"g":175,"b":15,"hex":"#EAAF0F"},{"code":"130 2X","r":226,"g":145,"b":0,"hex":"#E29100"},{"code":131,"r":198,"g":147,"b":10,"hex":"#C6930A"},{"code":132,"r":158,"g":124,"b":10,"hex":"#9E7C0A"},{"code":133,"r":112,"g":91,"b":10,"hex":"#705B0A"},{"code":134,"r":255,"g":216,"b":127,"hex":"#FFD87F"},{"code":1345,"r":255,"g":214,"b":145,"hex":"#FFD691"},{"code":135,"r":252,"g":201,"b":99,"hex":"#FCC963"},{"code":1355,"r":252,"g":206,"b":135,"hex":"#FCCE87"},{"code":136,"r":252,"g":191,"b":73,"hex":"#FCBF49"},{"code":1365,"r":252,"g":186,"b":94,"hex":"#FCBA5E"},{"code":137,"r":252,"g":163,"b":17,"hex":"#FCA311"},{"code":1375,"r":249,"g":155,"b":12,"hex":"#F99B0C"},{"code":138,"r":216,"g":140,"b":2,"hex":"#D88C02"},{"code":1385,"r":204,"g":122,"b":2,"hex":"#CC7A02"},{"code":139,"r":175,"g":117,"b":5,"hex":"#AF7505"},{"code":1395,"r":153,"g":96,"b":7,"hex":"#996007"},{"code":140,"r":122,"g":91,"b":17,"hex":"#7A5B11"},{"code":1405,"r":107,"g":71,"b":20,"hex":"#6B4714"},{"code":141,"r":242,"g":206,"b":104,"hex":"#F2CE68"},{"code":142,"r":242,"g":191,"b":73,"hex":"#F2BF49"},{"code":143,"r":239,"g":178,"b":45,"hex":"#EFB22D"},{"code":144,"r":226,"g":140,"b":5,"hex":"#E28C05"},{"code":145,"r":198,"g":127,"b":7,"hex":"#C67F07"},{"code":146,"r":158,"g":107,"b":5,"hex":"#9E6B05"},{"code":147,"r":114,"g":94,"b":38,"hex":"#725E26"},{"code":148,"r":255,"g":214,"b":155,"hex":"#FFD69B"},{"code":1485,"r":255,"g":183,"b":119,"hex":"#FFB777"},{"code":149,"r":252,"g":204,"b":147,"hex":"#FCCC93"},{"code":1495,"r":255,"g":153,"b":63,"hex":"#FF993F"},{"code":150,"r":252,"g":173,"b":86,"hex":"#FCAD56"},{"code":1505,"r":244,"g":124,"b":0,"hex":"#F47C00"},{"code":151,"r":247,"g":127,"b":0,"hex":"#F77F00"},{"code":152,"r":221,"g":117,"b":0,"hex":"#DD7500"},{"code":1525,"r":181,"g":84,"b":0,"hex":"#B55400"},{"code":153,"r":188,"g":109,"b":10,"hex":"#BC6D0A"},{"code":1535,"r":140,"g":68,"b":0,"hex":"#8C4400"},{"code":154,"r":153,"g":89,"b":5,"hex":"#995905"},{"code":1545,"r":71,"g":34,"b":0,"hex":"#472200"},{"code":155,"r":244,"g":219,"b":170,"hex":"#F4DBAA"},{"code":1555,"r":249,"g":191,"b":158,"hex":"#F9BF9E"},{"code":156,"r":242,"g":198,"b":140,"hex":"#F2C68C"},{"code":1565,"r":252,"g":165,"b":119,"hex":"#FCA577"},{"code":157,"r":237,"g":160,"b":79,"hex":"#EDA04F"},{"code":1575,"r":252,"g":135,"b":68,"hex":"#FC8744"},{"code":158,"r":232,"g":117,"b":17,"hex":"#E87511"},{"code":1585,"r":249,"g":107,"b":7,"hex":"#F96B07"},{"code":159,"r":198,"g":96,"b":5,"hex":"#C66005"},{"code":1595,"r":209,"g":91,"b":5,"hex":"#D15B05"},{"code":160,"r":158,"g":84,"b":10,"hex":"#9E540A"},{"code":1605,"r":160,"g":79,"b":17,"hex":"#A04F11"},{"code":161,"r":99,"g":58,"b":17,"hex":"#633A11"},{"code":1615,"r":132,"g":63,"b":15,"hex":"#843F0F"},{"code":162,"r":249,"g":198,"b":170,"hex":"#F9C6AA"},{"code":1625,"r":249,"g":165,"b":140,"hex":"#F9A58C"},{"code":163,"r":252,"g":158,"b":112,"hex":"#FC9E70"},{"code":1635,"r":249,"g":142,"b":109,"hex":"#F98E6D"},{"code":164,"r":252,"g":127,"b":63,"hex":"#FC7F3F"},{"code":1645,"r":249,"g":114,"b":66,"hex":"#F97242"},{"code":165,"r":249,"g":99,"b":2,"hex":"#F96302"},{"code":"165 2X","r":234,"g":79,"b":0,"hex":"#EA4F00"},{"code":1655,"r":249,"g":86,"b":2,"hex":"#F95602"},{"code":166,"r":221,"g":89,"b":0,"hex":"#DD5900"},{"code":1665,"r":221,"g":79,"b":5,"hex":"#DD4F05"},{"code":167,"r":188,"g":79,"b":7,"hex":"#BC4F07"},{"code":1675,"r":165,"g":63,"b":15,"hex":"#A53F0F"},{"code":168,"r":109,"g":48,"b":17,"hex":"#6D3011"},{"code":1685,"r":132,"g":53,"b":17,"hex":"#843511"},{"code":169,"r":249,"g":186,"b":170,"hex":"#F9BAAA"},{"code":170,"r":249,"g":137,"b":114,"hex":"#F98972"},{"code":171,"r":249,"g":96,"b":58,"hex":"#F9603A"},{"code":172,"r":247,"g":73,"b":2,"hex":"#F74902"},{"code":173,"r":209,"g":68,"b":20,"hex":"#D14414"},{"code":174,"r":147,"g":51,"b":17,"hex":"#933311"},{"code":175,"r":109,"g":51,"b":33,"hex":"#6D3321"},{"code":176,"r":249,"g":175,"b":173,"hex":"#F9AFAD"},{"code":1765,"r":249,"g":158,"b":163,"hex":"#F99EA3"},{"code":1767,"r":249,"g":178,"b":183,"hex":"#F9B2B7"},{"code":177,"r":249,"g":130,"b":127,"hex":"#F9827F"},{"code":1775,"r":249,"g":132,"b":142,"hex":"#F9848E"},{"code":1777,"r":252,"g":102,"b":117,"hex":"#FC6675"},{"code":178,"r":249,"g":94,"b":89,"hex":"#F95E59"},{"code":1785,"r":252,"g":79,"b":89,"hex":"#FC4F59"},{"code":1787,"r":244,"g":63,"b":79,"hex":"#F43F4F"},{"code":1788,"r":239,"g":43,"b":45,"hex":"#EF2B2D"},{"code":"1788 2X","r":214,"g":33,"b":0,"hex":"#D62100"},{"code":179,"r":226,"g":61,"b":40,"hex":"#E23D28"},{"code":1795,"r":214,"g":40,"b":40,"hex":"#D62828"},{"code":1797,"r":204,"g":45,"b":48,"hex":"#CC2D30"},{"code":180,"r":193,"g":56,"b":40,"hex":"#C13828"},{"code":1805,"r":175,"g":38,"b":38,"hex":"#AF2626"},{"code":1807,"r":160,"g":48,"b":51,"hex":"#A03033"},{"code":181,"r":124,"g":45,"b":35,"hex":"#7C2D23"},{"code":1810,"r":124,"g":33,"b":30,"hex":"#7C211E"},{"code":1817,"r":91,"g":45,"b":40,"hex":"#5B2D28"},{"code":182,"r":249,"g":191,"b":193,"hex":"#F9BFC1"},{"code":183,"r":252,"g":140,"b":153,"hex":"#FC8C99"},{"code":184,"r":252,"g":94,"b":114,"hex":"#FC5E72"},{"code":185,"r":232,"g":17,"b":45,"hex":"#E8112D"},{"code":"185 2X","r":209,"g":22,"b":0,"hex":"#D11600"},{"code":186,"r":206,"g":17,"b":38,"hex":"#CE1126"},{"code":187,"r":175,"g":30,"b":45,"hex":"#AF1E2D"},{"code":188,"r":124,"g":33,"b":40,"hex":"#7C2128"},{"code":189,"r":255,"g":163,"b":178,"hex":"#FFA3B2"},{"code":1895,"r":252,"g":191,"b":201,"hex":"#FCBFC9"},{"code":190,"r":252,"g":117,"b":142,"hex":"#FC758E"},{"code":1905,"r":252,"g":155,"b":178,"hex":"#FC9BB2"},{"code":191,"r":244,"g":71,"b":107,"hex":"#F4476B"},{"code":1915,"r":244,"g":84,"b":124,"hex":"#F4547C"},{"code":192,"r":229,"g":5,"b":58,"hex":"#E5053A"},{"code":1925,"r":224,"g":7,"b":71,"hex":"#E00747"},{"code":193,"r":196,"g":0,"b":67,"hex":"#C40043"},{"code":1935,"r":193,"g":5,"b":56,"hex":"#C10538"},{"code":194,"r":153,"g":33,"b":53,"hex":"#992135"},{"code":1945,"r":168,"g":12,"b":53,"hex":"#A80C35"},{"code":1955,"r":147,"g":22,"b":56,"hex":"#931638"},{"code":196,"r":250,"g":213,"b":225,"hex":"#FAD5E1"},{"code":197,"r":246,"g":165,"b":190,"hex":"#F6A5BE"},{"code":198,"r":239,"g":91,"b":132,"hex":"#EF5B84"},{"code":199,"r":160,"g":39,"b":75,"hex":"#A0274B"},{"code":200,"r":196,"g":30,"b":58,"hex":"#C41E3A"},{"code":201,"r":163,"g":38,"b":56,"hex":"#A32638"},{"code":202,"r":140,"g":38,"b":51,"hex":"#8C2633"},{"code":203,"r":242,"g":175,"b":193,"hex":"#F2AFC1"},{"code":204,"r":237,"g":122,"b":158,"hex":"#ED7A9E"},{"code":205,"r":229,"g":76,"b":124,"hex":"#E54C7C"},{"code":206,"r":211,"g":5,"b":71,"hex":"#D30547"},{"code":207,"r":192,"g":0,"b":78,"hex":"#C0004E"},{"code":208,"r":142,"g":35,"b":68,"hex":"#8E2344"},{"code":209,"r":117,"g":38,"b":61,"hex":"#75263D"},{"code":210,"r":255,"g":160,"b":191,"hex":"#FFA0BF"},{"code":211,"r":255,"g":119,"b":168,"hex":"#FF77A8"},{"code":212,"r":249,"g":79,"b":142,"hex":"#F94F8E"},{"code":213,"r":234,"g":15,"b":107,"hex":"#EA0F6B"},{"code":214,"r":204,"g":2,"b":86,"hex":"#CC0256"},{"code":215,"r":165,"g":5,"b":68,"hex":"#A50544"},{"code":216,"r":124,"g":30,"b":63,"hex":"#7C1E3F"},{"code":217,"r":244,"g":191,"b":209,"hex":"#F4BFD1"},{"code":218,"r":237,"g":114,"b":170,"hex":"#ED72AA"},{"code":219,"r":226,"g":40,"b":130,"hex":"#E22882"},{"code":220,"r":170,"g":0,"b":79,"hex":"#AA004F"},{"code":221,"r":147,"g":0,"b":66,"hex":"#930042"},{"code":222,"r":112,"g":25,"b":61,"hex":"#70193D"},{"code":223,"r":249,"g":147,"b":196,"hex":"#F993C4"},{"code":224,"r":244,"g":107,"b":175,"hex":"#F46BAF"},{"code":225,"r":237,"g":40,"b":147,"hex":"#ED2893"},{"code":226,"r":214,"g":2,"b":112,"hex":"#D60270"},{"code":227,"r":173,"g":0,"b":91,"hex":"#AD005B"},{"code":228,"r":140,"g":0,"b":76,"hex":"#8C004C"},{"code":229,"r":109,"g":33,"b":63,"hex":"#6D213F"},{"code":230,"r":255,"g":160,"b":204,"hex":"#FFA0CC"},{"code":231,"r":252,"g":112,"b":186,"hex":"#FC70BA"},{"code":232,"r":244,"g":63,"b":165,"hex":"#F43FA5"},{"code":233,"r":206,"g":0,"b":124,"hex":"#CE007C"},{"code":234,"r":170,"g":0,"b":102,"hex":"#AA0066"},{"code":235,"r":142,"g":5,"b":84,"hex":"#8E0554"},{"code":236,"r":249,"g":175,"b":211,"hex":"#F9AFD3"},{"code":2365,"r":247,"g":196,"b":216,"hex":"#F7C4D8"},{"code":237,"r":244,"g":132,"b":196,"hex":"#F484C4"},{"code":2375,"r":234,"g":107,"b":191,"hex":"#EA6BBF"},{"code":238,"r":237,"g":79,"b":175,"hex":"#ED4FAF"},{"code":2385,"r":219,"g":40,"b":165,"hex":"#DB28A5"},{"code":239,"r":224,"g":33,"b":158,"hex":"#E0219E"},{"code":2395,"r":196,"g":0,"b":140,"hex":"#C4008C"},{"code":240,"r":196,"g":15,"b":137,"hex":"#C40F89"},{"code":2405,"r":168,"g":0,"b":122,"hex":"#A8007A"},{"code":241,"r":173,"g":0,"b":117,"hex":"#AD0075"},{"code":2415,"r":155,"g":0,"b":112,"hex":"#9B0070"},{"code":242,"r":124,"g":28,"b":81,"hex":"#7C1C51"},{"code":2425,"r":135,"g":0,"b":91,"hex":"#87005B"},{"code":243,"r":242,"g":186,"b":216,"hex":"#F2BAD8"},{"code":244,"r":237,"g":160,"b":211,"hex":"#EDA0D3"},{"code":245,"r":232,"g":127,"b":201,"hex":"#E87FC9"},{"code":246,"r":204,"g":0,"b":160,"hex":"#CC00A0"},{"code":247,"r":183,"g":0,"b":142,"hex":"#B7008E"},{"code":248,"r":163,"g":5,"b":127,"hex":"#A3057F"},{"code":249,"r":127,"g":40,"b":96,"hex":"#7F2860"},{"code":250,"r":237,"g":196,"b":221,"hex":"#EDC4DD"},{"code":251,"r":226,"g":158,"b":214,"hex":"#E29ED6"},{"code":252,"r":211,"g":107,"b":198,"hex":"#D36BC6"},{"code":253,"r":175,"g":35,"b":165,"hex":"#AF23A5"},{"code":254,"r":160,"g":45,"b":150,"hex":"#A02D96"},{"code":255,"r":119,"g":45,"b":107,"hex":"#772D6B"},{"code":256,"r":229,"g":196,"b":214,"hex":"#E5C4D6"},{"code":2562,"r":216,"g":168,"b":216,"hex":"#D8A8D8"},{"code":2563,"r":209,"g":160,"b":204,"hex":"#D1A0CC"},{"code":2567,"r":191,"g":147,"b":204,"hex":"#BF93CC"},{"code":257,"r":211,"g":165,"b":201,"hex":"#D3A5C9"},{"code":2572,"r":198,"g":135,"b":209,"hex":"#C687D1"},{"code":2573,"r":186,"g":124,"b":188,"hex":"#BA7CBC"},{"code":2577,"r":170,"g":114,"b":191,"hex":"#AA72BF"},{"code":258,"r":155,"g":79,"b":150,"hex":"#9B4F96"},{"code":2582,"r":170,"g":71,"b":186,"hex":"#AA47BA"},{"code":2583,"r":158,"g":79,"b":165,"hex":"#9E4FA5"},{"code":2587,"r":142,"g":71,"b":173,"hex":"#8E47AD"},{"code":259,"r":114,"g":22,"b":107,"hex":"#72166B"},{"code":2592,"r":147,"g":15,"b":165,"hex":"#930FA5"},{"code":2593,"r":135,"g":43,"b":147,"hex":"#872B93"},{"code":2597,"r":102,"g":0,"b":140,"hex":"#66008C"},{"code":260,"r":104,"g":30,"b":91,"hex":"#681E5B"},{"code":2602,"r":130,"g":12,"b":142,"hex":"#820C8E"},{"code":2603,"r":112,"g":20,"b":122,"hex":"#70147A"},{"code":2607,"r":91,"g":2,"b":122,"hex":"#5B027A"},{"code":261,"r":94,"g":33,"b":84,"hex":"#5E2154"},{"code":2612,"r":112,"g":30,"b":114,"hex":"#701E72"},{"code":2613,"r":102,"g":17,"b":109,"hex":"#66116D"},{"code":2617,"r":86,"g":12,"b":112,"hex":"#560C70"},{"code":262,"r":84,"g":35,"b":68,"hex":"#542344"},{"code":2622,"r":96,"g":45,"b":89,"hex":"#602D59"},{"code":2623,"r":91,"g":25,"b":94,"hex":"#5B195E"},{"code":2627,"r":76,"g":20,"b":94,"hex":"#4C145E"},{"code":263,"r":224,"g":206,"b":224,"hex":"#E0CEE0"},{"code":2635,"r":201,"g":173,"b":216,"hex":"#C9ADD8"},{"code":264,"r":198,"g":170,"b":219,"hex":"#C6AADB"},{"code":2645,"r":181,"g":145,"b":209,"hex":"#B591D1"},{"code":265,"r":150,"g":99,"b":196,"hex":"#9663C4"},{"code":2655,"r":155,"g":109,"b":198,"hex":"#9B6DC6"},{"code":266,"r":109,"g":40,"b":170,"hex":"#6D28AA"},{"code":2665,"r":137,"g":79,"b":191,"hex":"#894FBF"},{"code":267,"r":89,"g":17,"b":142,"hex":"#59118E"},{"code":268,"r":79,"g":33,"b":112,"hex":"#4F2170"},{"code":2685,"r":86,"g":0,"b":140,"hex":"#56008C"},{"code":269,"r":68,"g":35,"b":89,"hex":"#442359"},{"code":2695,"r":68,"g":35,"b":94,"hex":"#44235E"},{"code":270,"r":186,"g":175,"b":211,"hex":"#BAAFD3"},{"code":2705,"r":173,"g":158,"b":211,"hex":"#AD9ED3"},{"code":2706,"r":209,"g":206,"b":221,"hex":"#D1CEDD"},{"code":2707,"r":191,"g":209,"b":229,"hex":"#BFD1E5"},{"code":2708,"r":175,"g":188,"b":219,"hex":"#AFBCDB"},{"code":271,"r":158,"g":145,"b":198,"hex":"#9E91C6"},{"code":2715,"r":147,"g":122,"b":204,"hex":"#937ACC"},{"code":2716,"r":165,"g":160,"b":214,"hex":"#A5A0D6"},{"code":2717,"r":165,"g":186,"b":224,"hex":"#A5BAE0"},{"code":2718,"r":91,"g":119,"b":204,"hex":"#5B77CC"},{"code":272,"r":137,"g":119,"b":186,"hex":"#8977BA"},{"code":2725,"r":114,"g":81,"b":188,"hex":"#7251BC"},{"code":2726,"r":102,"g":86,"b":188,"hex":"#6656BC"},{"code":2727,"r":94,"g":104,"b":196,"hex":"#5E68C4"},{"code":2728,"r":48,"g":68,"b":181,"hex":"#3044B5"},{"code":273,"r":56,"g":25,"b":122,"hex":"#38197A"},{"code":2735,"r":79,"g":0,"b":147,"hex":"#4F0093"},{"code":2736,"r":73,"g":48,"b":173,"hex":"#4930AD"},{"code":2738,"r":45,"g":0,"b":142,"hex":"#2D008E"},{"code":274,"r":43,"g":17,"b":102,"hex":"#2B1166"},{"code":2745,"r":63,"g":0,"b":119,"hex":"#3F0077"},{"code":2746,"r":63,"g":40,"b":147,"hex":"#3F2893"},{"code":2747,"r":28,"g":20,"b":107,"hex":"#1C146B"},{"code":2748,"r":30,"g":28,"b":119,"hex":"#1E1C77"},{"code":275,"r":38,"g":15,"b":84,"hex":"#260F54"},{"code":2755,"r":53,"g":0,"b":109,"hex":"#35006D"},{"code":2756,"r":51,"g":40,"b":117,"hex":"#332875"},{"code":2757,"r":20,"g":22,"b":84,"hex":"#141654"},{"code":2758,"r":25,"g":33,"b":104,"hex":"#192168"},{"code":276,"r":43,"g":33,"b":71,"hex":"#2B2147"},{"code":2765,"r":43,"g":12,"b":86,"hex":"#2B0C56"},{"code":2766,"r":43,"g":38,"b":91,"hex":"#2B265B"},{"code":2767,"r":20,"g":33,"b":61,"hex":"#14213D"},{"code":2768,"r":17,"g":33,"b":81,"hex":"#112151"},{"code":277,"r":181,"g":209,"b":232,"hex":"#B5D1E8"},{"code":278,"r":153,"g":186,"b":221,"hex":"#99BADD"},{"code":279,"r":102,"g":137,"b":204,"hex":"#6689CC"},{"code":280,"r":0,"g":43,"b":127,"hex":"#002B7F"},{"code":281,"r":0,"g":40,"b":104,"hex":"#002868"},{"code":282,"r":0,"g":38,"b":84,"hex":"#002654"},{"code":283,"r":155,"g":196,"b":226,"hex":"#9BC4E2"},{"code":284,"r":117,"g":170,"b":219,"hex":"#75AADB"},{"code":285,"r":58,"g":117,"b":196,"hex":"#3A75C4"},{"code":286,"r":0,"g":56,"b":168,"hex":"#0038A8"},{"code":287,"r":0,"g":56,"b":147,"hex":"#003893"},{"code":288,"r":0,"g":51,"b":127,"hex":"#00337F"},{"code":289,"r":0,"g":38,"b":73,"hex":"#002649"},{"code":290,"r":196,"g":216,"b":226,"hex":"#C4D8E2"},{"code":2905,"r":147,"g":198,"b":224,"hex":"#93C6E0"},{"code":291,"r":168,"g":206,"b":226,"hex":"#A8CEE2"},{"code":2915,"r":96,"g":175,"b":221,"hex":"#60AFDD"},{"code":292,"r":117,"g":178,"b":221,"hex":"#75B2DD"},{"code":2925,"r":0,"g":142,"b":214,"hex":"#008ED6"},{"code":293,"r":0,"g":81,"b":186,"hex":"#0051BA"},{"code":2935,"r":0,"g":91,"b":191,"hex":"#005BBF"},{"code":294,"r":0,"g":63,"b":135,"hex":"#003F87"},{"code":2945,"r":0,"g":84,"b":160,"hex":"#0054A0"},{"code":295,"r":0,"g":56,"b":107,"hex":"#00386B"},{"code":2955,"r":0,"g":61,"b":107,"hex":"#003D6B"},{"code":296,"r":0,"g":45,"b":71,"hex":"#002D47"},{"code":2965,"r":0,"g":51,"b":76,"hex":"#00334C"},{"code":297,"r":130,"g":198,"b":226,"hex":"#82C6E2"},{"code":2975,"r":186,"g":224,"b":226,"hex":"#BAE0E2"},{"code":298,"r":81,"g":181,"b":224,"hex":"#51B5E0"},{"code":2985,"r":81,"g":191,"b":226,"hex":"#51BFE2"},{"code":299,"r":0,"g":163,"b":221,"hex":"#00A3DD"},{"code":2995,"r":0,"g":165,"b":219,"hex":"#00A5DB"},{"code":300,"r":0,"g":114,"b":198,"hex":"#0072C6"},{"code":3005,"r":0,"g":132,"b":201,"hex":"#0084C9"},{"code":301,"r":0,"g":91,"b":153,"hex":"#005B99"},{"code":3015,"r":0,"g":112,"b":158,"hex":"#00709E"},{"code":302,"r":0,"g":79,"b":109,"hex":"#004F6D"},{"code":3025,"r":0,"g":84,"b":107,"hex":"#00546B"},{"code":303,"r":0,"g":63,"b":84,"hex":"#003F54"},{"code":3035,"r":0,"g":68,"b":84,"hex":"#004454"},{"code":304,"r":165,"g":221,"b":226,"hex":"#A5DDE2"},{"code":305,"r":112,"g":206,"b":226,"hex":"#70CEE2"},{"code":306,"r":0,"g":188,"b":226,"hex":"#00BCE2"},{"code":"306 2X","r":0,"g":163,"b":209,"hex":"#00A3D1"},{"code":307,"r":0,"g":122,"b":165,"hex":"#007AA5"},{"code":308,"r":0,"g":96,"b":124,"hex":"#00607C"},{"code":309,"r":0,"g":63,"b":73,"hex":"#003F49"},{"code":310,"r":114,"g":209,"b":221,"hex":"#72D1DD"},{"code":3105,"r":127,"g":214,"b":219,"hex":"#7FD6DB"},{"code":311,"r":40,"g":196,"b":216,"hex":"#28C4D8"},{"code":3115,"r":45,"g":198,"b":214,"hex":"#2DC6D6"},{"code":312,"r":0,"g":173,"b":198,"hex":"#00ADC6"},{"code":3125,"r":0,"g":183,"b":198,"hex":"#00B7C6"},{"code":313,"r":0,"g":153,"b":181,"hex":"#0099B5"},{"code":3135,"r":0,"g":155,"b":170,"hex":"#009BAA"},{"code":314,"r":0,"g":130,"b":155,"hex":"#00829B"},{"code":3145,"r":0,"g":132,"b":142,"hex":"#00848E"},{"code":315,"r":0,"g":107,"b":119,"hex":"#006B77"},{"code":3155,"r":0,"g":109,"b":117,"hex":"#006D75"},{"code":316,"r":0,"g":73,"b":79,"hex":"#00494F"},{"code":3165,"r":0,"g":86,"b":91,"hex":"#00565B"},{"code":317,"r":201,"g":232,"b":221,"hex":"#C9E8DD"},{"code":318,"r":147,"g":221,"b":219,"hex":"#93DDDB"},{"code":319,"r":76,"g":206,"b":209,"hex":"#4CCED1"},{"code":320,"r":0,"g":158,"b":160,"hex":"#009EA0"},{"code":"320 2X","r":0,"g":127,"b":130,"hex":"#007F82"},{"code":321,"r":0,"g":135,"b":137,"hex":"#008789"},{"code":322,"r":0,"g":114,"b":114,"hex":"#007272"},{"code":323,"r":0,"g":102,"b":99,"hex":"#006663"},{"code":324,"r":170,"g":221,"b":214,"hex":"#AADDD6"},{"code":3242,"r":135,"g":221,"b":209,"hex":"#87DDD1"},{"code":3245,"r":140,"g":224,"b":209,"hex":"#8CE0D1"},{"code":3248,"r":122,"g":211,"b":193,"hex":"#7AD3C1"},{"code":325,"r":86,"g":201,"b":193,"hex":"#56C9C1"},{"code":3252,"r":86,"g":214,"b":201,"hex":"#56D6C9"},{"code":3255,"r":71,"g":214,"b":193,"hex":"#47D6C1"},{"code":3258,"r":53,"g":196,"b":175,"hex":"#35C4AF"},{"code":326,"r":0,"g":178,"b":170,"hex":"#00B2AA"},{"code":3262,"r":0,"g":193,"b":181,"hex":"#00C1B5"},{"code":3265,"r":0,"g":198,"b":178,"hex":"#00C6B2"},{"code":3268,"r":0,"g":175,"b":153,"hex":"#00AF99"},{"code":327,"r":0,"g":140,"b":130,"hex":"#008C82"},{"code":"327 2X","r":0,"g":137,"b":119,"hex":"#008977"},{"code":3272,"r":0,"g":170,"b":158,"hex":"#00AA9E"},{"code":3275,"r":0,"g":178,"b":160,"hex":"#00B2A0"},{"code":3278,"r":0,"g":155,"b":132,"hex":"#009B84"},{"code":328,"r":0,"g":119,"b":112,"hex":"#007770"},{"code":3282,"r":0,"g":140,"b":130,"hex":"#008C82"},{"code":3285,"r":0,"g":153,"b":135,"hex":"#009987"},{"code":3288,"r":0,"g":130,"b":112,"hex":"#008270"},{"code":329,"r":0,"g":109,"b":102,"hex":"#006D66"},{"code":3292,"r":0,"g":96,"b":86,"hex":"#006056"},{"code":3295,"r":0,"g":130,"b":114,"hex":"#008272"},{"code":3298,"r":0,"g":107,"b":91,"hex":"#006B5B"},{"code":330,"r":0,"g":89,"b":81,"hex":"#005951"},{"code":3302,"r":0,"g":73,"b":63,"hex":"#00493F"},{"code":3305,"r":0,"g":79,"b":66,"hex":"#004F42"},{"code":3308,"r":0,"g":68,"b":56,"hex":"#004438"},{"code":331,"r":186,"g":234,"b":214,"hex":"#BAEAD6"},{"code":332,"r":160,"g":229,"b":206,"hex":"#A0E5CE"},{"code":333,"r":94,"g":221,"b":193,"hex":"#5EDDC1"},{"code":334,"r":0,"g":153,"b":124,"hex":"#00997C"},{"code":335,"r":0,"g":124,"b":102,"hex":"#007C66"},{"code":336,"r":0,"g":104,"b":84,"hex":"#006854"},{"code":337,"r":155,"g":219,"b":193,"hex":"#9BDBC1"},{"code":3375,"r":142,"g":226,"b":188,"hex":"#8EE2BC"},{"code":338,"r":122,"g":209,"b":181,"hex":"#7AD1B5"},{"code":3385,"r":84,"g":216,"b":168,"hex":"#54D8A8"},{"code":339,"r":0,"g":178,"b":140,"hex":"#00B28C"},{"code":3395,"r":0,"g":201,"b":147,"hex":"#00C993"},{"code":340,"r":0,"g":153,"b":119,"hex":"#009977"},{"code":3405,"r":0,"g":178,"b":122,"hex":"#00B27A"},{"code":341,"r":0,"g":122,"b":94,"hex":"#007A5E"},{"code":3415,"r":0,"g":124,"b":89,"hex":"#007C59"},{"code":342,"r":0,"g":107,"b":84,"hex":"#006B54"},{"code":3425,"r":0,"g":104,"b":71,"hex":"#006847"},{"code":343,"r":0,"g":86,"b":63,"hex":"#00563F"},{"code":3435,"r":2,"g":73,"b":48,"hex":"#024930"},{"code":344,"r":181,"g":226,"b":191,"hex":"#B5E2BF"},{"code":345,"r":150,"g":216,"b":175,"hex":"#96D8AF"},{"code":346,"r":112,"g":206,"b":155,"hex":"#70CE9B"},{"code":347,"r":0,"g":158,"b":96,"hex":"#009E60"},{"code":348,"r":0,"g":135,"b":81,"hex":"#008751"},{"code":349,"r":0,"g":107,"b":63,"hex":"#006B3F"},{"code":350,"r":35,"g":79,"b":51,"hex":"#234F33"},{"code":351,"r":181,"g":232,"b":191,"hex":"#B5E8BF"},{"code":352,"r":153,"g":229,"b":178,"hex":"#99E5B2"},{"code":353,"r":132,"g":226,"b":168,"hex":"#84E2A8"},{"code":354,"r":0,"g":183,"b":96,"hex":"#00B760"},{"code":355,"r":0,"g":158,"b":73,"hex":"#009E49"},{"code":356,"r":0,"g":122,"b":61,"hex":"#007A3D"},{"code":357,"r":33,"g":91,"b":51,"hex":"#215B33"},{"code":358,"r":170,"g":221,"b":150,"hex":"#AADD96"},{"code":359,"r":160,"g":219,"b":142,"hex":"#A0DB8E"},{"code":360,"r":96,"g":198,"b":89,"hex":"#60C659"},{"code":361,"r":30,"g":181,"b":58,"hex":"#1EB53A"},{"code":362,"r":51,"g":158,"b":53,"hex":"#339E35"},{"code":363,"r":61,"g":142,"b":51,"hex":"#3D8E33"},{"code":364,"r":58,"g":119,"b":40,"hex":"#3A7728"},{"code":365,"r":211,"g":232,"b":163,"hex":"#D3E8A3"},{"code":366,"r":196,"g":229,"b":142,"hex":"#C4E58E"},{"code":367,"r":170,"g":221,"b":109,"hex":"#AADD6D"},{"code":368,"r":91,"g":191,"b":33,"hex":"#5BBF21"},{"code":"368 2X","r":0,"g":158,"b":15,"hex":"#009E0F"},{"code":369,"r":86,"g":170,"b":28,"hex":"#56AA1C"},{"code":370,"r":86,"g":142,"b":20,"hex":"#568E14"},{"code":371,"r":86,"g":107,"b":33,"hex":"#566B21"},{"code":372,"r":216,"g":237,"b":150,"hex":"#D8ED96"},{"code":373,"r":206,"g":234,"b":130,"hex":"#CEEA82"},{"code":374,"r":186,"g":232,"b":96,"hex":"#BAE860"},{"code":375,"r":140,"g":214,"b":0,"hex":"#8CD600"},{"code":"375 2X","r":84,"g":188,"b":0,"hex":"#54BC00"},{"code":376,"r":127,"g":186,"b":0,"hex":"#7FBA00"},{"code":377,"r":112,"g":147,"b":2,"hex":"#709302"},{"code":378,"r":86,"g":99,"b":20,"hex":"#566314"},{"code":379,"r":224,"g":234,"b":104,"hex":"#E0EA68"},{"code":380,"r":214,"g":229,"b":66,"hex":"#D6E542"},{"code":381,"r":204,"g":226,"b":38,"hex":"#CCE226"},{"code":382,"r":186,"g":216,"b":10,"hex":"#BAD80A"},{"code":"382 2X","r":158,"g":196,"b":0,"hex":"#9EC400"},{"code":383,"r":163,"g":175,"b":7,"hex":"#A3AF07"},{"code":384,"r":147,"g":153,"b":5,"hex":"#939905"},{"code":385,"r":112,"g":112,"b":20,"hex":"#707014"},{"code":386,"r":232,"g":237,"b":96,"hex":"#E8ED60"},{"code":387,"r":224,"g":237,"b":68,"hex":"#E0ED44"},{"code":388,"r":214,"g":232,"b":15,"hex":"#D6E80F"},{"code":389,"r":206,"g":224,"b":7,"hex":"#CEE007"},{"code":390,"r":186,"g":196,"b":5,"hex":"#BAC405"},{"code":391,"r":158,"g":158,"b":7,"hex":"#9E9E07"},{"code":392,"r":132,"g":130,"b":5,"hex":"#848205"},{"code":393,"r":242,"g":239,"b":135,"hex":"#F2EF87"},{"code":3935,"r":242,"g":237,"b":109,"hex":"#F2ED6D"},{"code":394,"r":234,"g":237,"b":53,"hex":"#EAED35"},{"code":3945,"r":239,"g":234,"b":7,"hex":"#EFEA07"},{"code":395,"r":229,"g":232,"b":17,"hex":"#E5E811"},{"code":3955,"r":237,"g":226,"b":17,"hex":"#EDE211"},{"code":396,"r":224,"g":226,"b":12,"hex":"#E0E20C"},{"code":3965,"r":232,"g":221,"b":17,"hex":"#E8DD11"},{"code":397,"r":193,"g":191,"b":10,"hex":"#C1BF0A"},{"code":3975,"r":181,"g":168,"b":12,"hex":"#B5A80C"},{"code":398,"r":175,"g":168,"b":10,"hex":"#AFA80A"},{"code":3985,"r":153,"g":140,"b":10,"hex":"#998C0A"},{"code":399,"r":153,"g":142,"b":7,"hex":"#998E07"},{"code":3995,"r":109,"g":96,"b":2,"hex":"#6D6002"},{"code":400,"r":209,"g":198,"b":181,"hex":"#D1C6B5"},{"code":401,"r":193,"g":181,"b":165,"hex":"#C1B5A5"},{"code":402,"r":175,"g":165,"b":147,"hex":"#AFA593"},{"code":403,"r":153,"g":140,"b":124,"hex":"#998C7C"},{"code":404,"r":130,"g":117,"b":102,"hex":"#827566"},{"code":405,"r":107,"g":94,"b":79,"hex":"#6B5E4F"},{"code":406,"r":206,"g":193,"b":181,"hex":"#CEC1B5"},{"code":408,"r":168,"g":153,"b":140,"hex":"#A8998C"},{"code":409,"r":153,"g":137,"b":124,"hex":"#99897C"},{"code":410,"r":124,"g":109,"b":99,"hex":"#7C6D63"},{"code":411,"r":102,"g":89,"b":76,"hex":"#66594C"},{"code":412,"r":61,"g":48,"b":40,"hex":"#3D3028"},{"code":413,"r":198,"g":193,"b":178,"hex":"#C6C1B2"},{"code":414,"r":181,"g":175,"b":160,"hex":"#B5AFA0"},{"code":415,"r":163,"g":158,"b":140,"hex":"#A39E8C"},{"code":416,"r":142,"g":140,"b":122,"hex":"#8E8C7A"},{"code":417,"r":119,"g":114,"b":99,"hex":"#777263"},{"code":418,"r":96,"g":94,"b":79,"hex":"#605E4F"},{"code":419,"r":40,"g":40,"b":33,"hex":"#282821"},{"code":420,"r":209,"g":204,"b":191,"hex":"#D1CCBF"},{"code":421,"r":191,"g":186,"b":175,"hex":"#BFBAAF"},{"code":422,"r":175,"g":170,"b":163,"hex":"#AFAAA3"},{"code":423,"r":150,"g":147,"b":142,"hex":"#96938E"},{"code":424,"r":130,"g":127,"b":119,"hex":"#827F77"},{"code":425,"r":96,"g":96,"b":91,"hex":"#60605B"},{"code":426,"r":43,"g":43,"b":40,"hex":"#2B2B28"},{"code":427,"r":221,"g":219,"b":209,"hex":"#DDDBD1"},{"code":428,"r":209,"g":206,"b":198,"hex":"#D1CEC6"},{"code":429,"r":173,"g":175,"b":170,"hex":"#ADAFAA"},{"code":430,"r":145,"g":150,"b":147,"hex":"#919693"},{"code":431,"r":102,"g":109,"b":112,"hex":"#666D70"},{"code":432,"r":68,"g":79,"b":81,"hex":"#444F51"},{"code":433,"r":48,"g":56,"b":58,"hex":"#30383A"},{"code":"433 2X","r":10,"g":12,"b":17,"hex":"#0A0C11"},{"code":434,"r":224,"g":209,"b":198,"hex":"#E0D1C6"},{"code":435,"r":211,"g":191,"b":183,"hex":"#D3BFB7"},{"code":436,"r":188,"g":165,"b":158,"hex":"#BCA59E"},{"code":437,"r":140,"g":112,"b":107,"hex":"#8C706B"},{"code":438,"r":89,"g":63,"b":61,"hex":"#593F3D"},{"code":439,"r":73,"g":53,"b":51,"hex":"#493533"},{"code":440,"r":63,"g":48,"b":43,"hex":"#3F302B"},{"code":441,"r":209,"g":209,"b":198,"hex":"#D1D1C6"},{"code":442,"r":186,"g":191,"b":183,"hex":"#BABFB7"},{"code":443,"r":163,"g":168,"b":163,"hex":"#A3A8A3"},{"code":444,"r":137,"g":142,"b":140,"hex":"#898E8C"},{"code":445,"r":86,"g":89,"b":89,"hex":"#565959"},{"code":446,"r":73,"g":76,"b":73,"hex":"#494C49"},{"code":447,"r":63,"g":63,"b":56,"hex":"#3F3F38"},{"code":448,"r":84,"g":71,"b":45,"hex":"#54472D"},{"code":4485,"r":96,"g":76,"b":17,"hex":"#604C11"},{"code":449,"r":84,"g":71,"b":38,"hex":"#544726"},{"code":4495,"r":135,"g":117,"b":48,"hex":"#877530"},{"code":450,"r":96,"g":84,"b":43,"hex":"#60542B"},{"code":4505,"r":160,"g":145,"b":81,"hex":"#A09151"},{"code":451,"r":173,"g":160,"b":122,"hex":"#ADA07A"},{"code":4515,"r":188,"g":173,"b":117,"hex":"#BCAD75"},{"code":452,"r":196,"g":183,"b":150,"hex":"#C4B796"},{"code":4525,"r":204,"g":191,"b":142,"hex":"#CCBF8E"},{"code":453,"r":214,"g":204,"b":175,"hex":"#D6CCAF"},{"code":4535,"r":219,"g":206,"b":165,"hex":"#DBCEA5"},{"code":454,"r":226,"g":216,"b":191,"hex":"#E2D8BF"},{"code":4545,"r":229,"g":219,"b":186,"hex":"#E5DBBA"},{"code":455,"r":102,"g":86,"b":20,"hex":"#665614"},{"code":456,"r":153,"g":135,"b":20,"hex":"#998714"},{"code":457,"r":181,"g":155,"b":12,"hex":"#B59B0C"},{"code":458,"r":221,"g":204,"b":107,"hex":"#DDCC6B"},{"code":459,"r":226,"g":214,"b":124,"hex":"#E2D67C"},{"code":460,"r":234,"g":221,"b":150,"hex":"#EADD96"},{"code":461,"r":237,"g":229,"b":173,"hex":"#EDE5AD"},{"code":462,"r":91,"g":71,"b":35,"hex":"#5B4723"},{"code":4625,"r":71,"g":35,"b":17,"hex":"#472311"},{"code":463,"r":117,"g":84,"b":38,"hex":"#755426"},{"code":4635,"r":140,"g":89,"b":51,"hex":"#8C5933"},{"code":464,"r":135,"g":96,"b":40,"hex":"#876028"},{"code":"464 2X","r":112,"g":66,"b":20,"hex":"#704214"},{"code":4645,"r":178,"g":130,"b":96,"hex":"#B28260"},{"code":465,"r":193,"g":168,"b":117,"hex":"#C1A875"},{"code":4655,"r":196,"g":153,"b":119,"hex":"#C49977"},{"code":466,"r":209,"g":191,"b":145,"hex":"#D1BF91"},{"code":4665,"r":216,"g":181,"b":150,"hex":"#D8B596"},{"code":467,"r":221,"g":204,"b":165,"hex":"#DDCCA5"},{"code":4675,"r":229,"g":198,"b":170,"hex":"#E5C6AA"},{"code":468,"r":226,"g":214,"b":181,"hex":"#E2D6B5"},{"code":4685,"r":237,"g":211,"b":188,"hex":"#EDD3BC"},{"code":469,"r":96,"g":51,"b":17,"hex":"#603311"},{"code":4695,"r":81,"g":38,"b":28,"hex":"#51261C"},{"code":470,"r":155,"g":79,"b":25,"hex":"#9B4F19"},{"code":4705,"r":124,"g":81,"b":61,"hex":"#7C513D"},{"code":471,"r":188,"g":94,"b":30,"hex":"#BC5E1E"},{"code":"471 2X","r":163,"g":68,"b":2,"hex":"#A34402"},{"code":4715,"r":153,"g":112,"b":91,"hex":"#99705B"},{"code":472,"r":234,"g":170,"b":122,"hex":"#EAAA7A"},{"code":4725,"r":181,"g":145,"b":124,"hex":"#B5917C"},{"code":473,"r":244,"g":196,"b":160,"hex":"#F4C4A0"},{"code":4735,"r":204,"g":175,"b":155,"hex":"#CCAF9B"},{"code":474,"r":244,"g":204,"b":170,"hex":"#F4CCAA"},{"code":4745,"r":216,"g":191,"b":170,"hex":"#D8BFAA"},{"code":475,"r":247,"g":211,"b":181,"hex":"#F7D3B5"},{"code":4755,"r":226,"g":204,"b":186,"hex":"#E2CCBA"},{"code":476,"r":89,"g":61,"b":43,"hex":"#593D2B"},{"code":477,"r":99,"g":56,"b":38,"hex":"#633826"},{"code":478,"r":122,"g":63,"b":40,"hex":"#7A3F28"},{"code":479,"r":175,"g":137,"b":112,"hex":"#AF8970"},{"code":480,"r":211,"g":183,"b":163,"hex":"#D3B7A3"},{"code":481,"r":224,"g":204,"b":186,"hex":"#E0CCBA"},{"code":482,"r":229,"g":211,"b":193,"hex":"#E5D3C1"},{"code":483,"r":107,"g":48,"b":33,"hex":"#6B3021"},{"code":484,"r":155,"g":48,"b":28,"hex":"#9B301C"},{"code":485,"r":216,"g":30,"b":5,"hex":"#D81E05"},{"code":"485 2X","r":204,"g":12,"b":0,"hex":"#CC0C00"},{"code":486,"r":237,"g":158,"b":132,"hex":"#ED9E84"},{"code":487,"r":239,"g":181,"b":160,"hex":"#EFB5A0"},{"code":488,"r":242,"g":196,"b":175,"hex":"#F2C4AF"},{"code":489,"r":242,"g":209,"b":191,"hex":"#F2D1BF"},{"code":490,"r":91,"g":38,"b":38,"hex":"#5B2626"},{"code":491,"r":117,"g":40,"b":40,"hex":"#752828"},{"code":492,"r":145,"g":51,"b":56,"hex":"#913338"},{"code":494,"r":242,"g":173,"b":178,"hex":"#F2ADB2"},{"code":495,"r":244,"g":188,"b":191,"hex":"#F4BCBF"},{"code":496,"r":247,"g":201,"b":198,"hex":"#F7C9C6"},{"code":497,"r":81,"g":40,"b":38,"hex":"#512826"},{"code":4975,"r":68,"g":30,"b":28,"hex":"#441E1C"},{"code":498,"r":109,"g":51,"b":43,"hex":"#6D332B"},{"code":4985,"r":132,"g":73,"b":73,"hex":"#844949"},{"code":499,"r":122,"g":56,"b":45,"hex":"#7A382D"},{"code":4995,"r":165,"g":107,"b":109,"hex":"#A56B6D"},{"code":500,"r":206,"g":137,"b":140,"hex":"#CE898C"},{"code":5005,"r":188,"g":135,"b":135,"hex":"#BC8787"},{"code":501,"r":234,"g":178,"b":178,"hex":"#EAB2B2"},{"code":5015,"r":216,"g":173,"b":168,"hex":"#D8ADA8"},{"code":502,"r":242,"g":198,"b":196,"hex":"#F2C6C4"},{"code":5025,"r":226,"g":188,"b":183,"hex":"#E2BCB7"},{"code":503,"r":244,"g":209,"b":204,"hex":"#F4D1CC"},{"code":5035,"r":237,"g":206,"b":198,"hex":"#EDCEC6"},{"code":504,"r":81,"g":30,"b":38,"hex":"#511E26"},{"code":505,"r":102,"g":30,"b":43,"hex":"#661E2B"},{"code":506,"r":122,"g":38,"b":56,"hex":"#7A2638"},{"code":507,"r":216,"g":137,"b":155,"hex":"#D8899B"},{"code":508,"r":232,"g":165,"b":175,"hex":"#E8A5AF"},{"code":509,"r":242,"g":186,"b":191,"hex":"#F2BABF"},{"code":510,"r":244,"g":198,"b":201,"hex":"#F4C6C9"},{"code":511,"r":96,"g":33,"b":68,"hex":"#602144"},{"code":5115,"r":79,"g":33,"b":58,"hex":"#4F213A"},{"code":512,"r":132,"g":33,"b":107,"hex":"#84216B"},{"code":5125,"r":117,"g":71,"b":96,"hex":"#754760"},{"code":513,"r":158,"g":35,"b":135,"hex":"#9E2387"},{"code":5135,"r":147,"g":107,"b":127,"hex":"#936B7F"},{"code":514,"r":216,"g":132,"b":188,"hex":"#D884BC"},{"code":5145,"r":173,"g":135,"b":153,"hex":"#AD8799"},{"code":515,"r":232,"g":163,"b":201,"hex":"#E8A3C9"},{"code":5155,"r":204,"g":175,"b":183,"hex":"#CCAFB7"},{"code":516,"r":242,"g":186,"b":211,"hex":"#F2BAD3"},{"code":5165,"r":224,"g":201,"b":204,"hex":"#E0C9CC"},{"code":517,"r":244,"g":204,"b":216,"hex":"#F4CCD8"},{"code":5175,"r":232,"g":214,"b":209,"hex":"#E8D6D1"},{"code":518,"r":81,"g":45,"b":68,"hex":"#512D44"},{"code":5185,"r":71,"g":40,"b":53,"hex":"#472835"},{"code":519,"r":99,"g":48,"b":94,"hex":"#63305E"},{"code":5195,"r":89,"g":51,"b":68,"hex":"#593344"},{"code":520,"r":112,"g":53,"b":114,"hex":"#703572"},{"code":5205,"r":142,"g":104,"b":119,"hex":"#8E6877"},{"code":521,"r":181,"g":140,"b":178,"hex":"#B58CB2"},{"code":5215,"r":181,"g":147,"b":155,"hex":"#B5939B"},{"code":522,"r":198,"g":163,"b":193,"hex":"#C6A3C1"},{"code":5225,"r":204,"g":173,"b":175,"hex":"#CCADAF"},{"code":523,"r":211,"g":183,"b":204,"hex":"#D3B7CC"},{"code":5235,"r":221,"g":198,"b":196,"hex":"#DDC6C4"},{"code":524,"r":226,"g":204,"b":211,"hex":"#E2CCD3"},{"code":5245,"r":229,"g":211,"b":204,"hex":"#E5D3CC"},{"code":525,"r":81,"g":38,"b":84,"hex":"#512654"},{"code":5255,"r":53,"g":38,"b":79,"hex":"#35264F"},{"code":526,"r":104,"g":33,"b":122,"hex":"#68217A"},{"code":5265,"r":73,"g":61,"b":99,"hex":"#493D63"},{"code":527,"r":122,"g":30,"b":153,"hex":"#7A1E99"},{"code":5275,"r":96,"g":86,"b":119,"hex":"#605677"},{"code":528,"r":175,"g":114,"b":193,"hex":"#AF72C1"},{"code":5285,"r":140,"g":130,"b":153,"hex":"#8C8299"},{"code":529,"r":206,"g":163,"b":211,"hex":"#CEA3D3"},{"code":5295,"r":178,"g":168,"b":181,"hex":"#B2A8B5"},{"code":530,"r":214,"g":175,"b":214,"hex":"#D6AFD6"},{"code":5305,"r":204,"g":193,"b":198,"hex":"#CCC1C6"},{"code":531,"r":229,"g":198,"b":219,"hex":"#E5C6DB"},{"code":5315,"r":219,"g":211,"b":211,"hex":"#DBD3D3"},{"code":532,"r":53,"g":56,"b":66,"hex":"#353842"},{"code":533,"r":53,"g":63,"b":91,"hex":"#353F5B"},{"code":534,"r":58,"g":73,"b":114,"hex":"#3A4972"},{"code":535,"r":155,"g":163,"b":183,"hex":"#9BA3B7"},{"code":536,"r":173,"g":178,"b":193,"hex":"#ADB2C1"},{"code":537,"r":196,"g":198,"b":206,"hex":"#C4C6CE"},{"code":538,"r":214,"g":211,"b":214,"hex":"#D6D3D6"},{"code":539,"r":0,"g":48,"b":73,"hex":"#003049"},{"code":5395,"r":2,"g":40,"b":58,"hex":"#02283A"},{"code":540,"r":0,"g":51,"b":91,"hex":"#00335B"},{"code":5405,"r":63,"g":96,"b":117,"hex":"#3F6075"},{"code":541,"r":0,"g":63,"b":119,"hex":"#003F77"},{"code":5415,"r":96,"g":124,"b":140,"hex":"#607C8C"},{"code":542,"r":102,"g":147,"b":188,"hex":"#6693BC"},{"code":5425,"r":132,"g":153,"b":165,"hex":"#8499A5"},{"code":543,"r":147,"g":183,"b":209,"hex":"#93B7D1"},{"code":5435,"r":175,"g":188,"b":191,"hex":"#AFBCBF"},{"code":544,"r":183,"g":204,"b":219,"hex":"#B7CCDB"},{"code":5445,"r":196,"g":204,"b":204,"hex":"#C4CCCC"},{"code":545,"r":196,"g":211,"b":221,"hex":"#C4D3DD"},{"code":5455,"r":214,"g":216,"b":211,"hex":"#D6D8D3"},{"code":546,"r":12,"g":56,"b":68,"hex":"#0C3844"},{"code":5463,"r":0,"g":53,"b":58,"hex":"#00353A"},{"code":5467,"r":25,"g":56,"b":51,"hex":"#193833"},{"code":547,"r":0,"g":63,"b":84,"hex":"#003F54"},{"code":5473,"r":38,"g":104,"b":109,"hex":"#26686D"},{"code":5477,"r":58,"g":86,"b":79,"hex":"#3A564F"},{"code":548,"r":0,"g":68,"b":89,"hex":"#004459"},{"code":5483,"r":96,"g":145,"b":145,"hex":"#609191"},{"code":5487,"r":102,"g":124,"b":114,"hex":"#667C72"},{"code":549,"r":94,"g":153,"b":170,"hex":"#5E99AA"},{"code":5493,"r":140,"g":175,"b":173,"hex":"#8CAFAD"},{"code":5497,"r":145,"g":163,"b":153,"hex":"#91A399"},{"code":550,"r":135,"g":175,"b":191,"hex":"#87AFBF"},{"code":5503,"r":170,"g":196,"b":191,"hex":"#AAC4BF"},{"code":5507,"r":175,"g":186,"b":178,"hex":"#AFBAB2"},{"code":551,"r":163,"g":193,"b":201,"hex":"#A3C1C9"},{"code":5513,"r":206,"g":216,"b":209,"hex":"#CED8D1"},{"code":5517,"r":201,"g":206,"b":196,"hex":"#C9CEC4"},{"code":552,"r":196,"g":214,"b":214,"hex":"#C4D6D6"},{"code":5523,"r":214,"g":221,"b":214,"hex":"#D6DDD6"},{"code":5527,"r":206,"g":209,"b":198,"hex":"#CED1C6"},{"code":553,"r":35,"g":68,"b":53,"hex":"#234435"},{"code":5535,"r":33,"g":61,"b":48,"hex":"#213D30"},{"code":554,"r":25,"g":94,"b":71,"hex":"#195E47"},{"code":5545,"r":79,"g":109,"b":94,"hex":"#4F6D5E"},{"code":555,"r":7,"g":109,"b":84,"hex":"#076D54"},{"code":5555,"r":119,"g":145,"b":130,"hex":"#779182"},{"code":556,"r":122,"g":168,"b":145,"hex":"#7AA891"},{"code":5565,"r":150,"g":170,"b":153,"hex":"#96AA99"},{"code":557,"r":163,"g":193,"b":173,"hex":"#A3C1AD"},{"code":5575,"r":175,"g":191,"b":173,"hex":"#AFBFAD"},{"code":558,"r":183,"g":206,"b":188,"hex":"#B7CEBC"},{"code":5585,"r":196,"g":206,"b":191,"hex":"#C4CEBF"},{"code":559,"r":198,"g":214,"b":196,"hex":"#C6D6C4"},{"code":5595,"r":216,"g":219,"b":204,"hex":"#D8DBCC"},{"code":560,"r":43,"g":76,"b":63,"hex":"#2B4C3F"},{"code":5605,"r":35,"g":58,"b":45,"hex":"#233A2D"},{"code":561,"r":38,"g":102,"b":89,"hex":"#266659"},{"code":5615,"r":84,"g":104,"b":86,"hex":"#546856"},{"code":562,"r":30,"g":122,"b":109,"hex":"#1E7A6D"},{"code":5625,"r":114,"g":132,"b":112,"hex":"#728470"},{"code":563,"r":127,"g":188,"b":170,"hex":"#7FBCAA"},{"code":5635,"r":158,"g":170,"b":153,"hex":"#9EAA99"},{"code":564,"r":5,"g":112,"b":94,"hex":"#05705E"},{"code":5645,"r":188,"g":193,"b":178,"hex":"#BCC1B2"},{"code":565,"r":188,"g":219,"b":204,"hex":"#BCDBCC"},{"code":5655,"r":198,"g":204,"b":186,"hex":"#C6CCBA"},{"code":566,"r":209,"g":226,"b":211,"hex":"#D1E2D3"},{"code":5665,"r":214,"g":214,"b":198,"hex":"#D6D6C6"},{"code":567,"r":38,"g":81,"b":66,"hex":"#265142"},{"code":568,"r":0,"g":114,"b":99,"hex":"#007263"},{"code":569,"r":0,"g":135,"b":114,"hex":"#008772"},{"code":570,"r":127,"g":198,"b":178,"hex":"#7FC6B2"},{"code":571,"r":170,"g":219,"b":198,"hex":"#AADBC6"},{"code":572,"r":188,"g":226,"b":206,"hex":"#BCE2CE"},{"code":573,"r":204,"g":229,"b":214,"hex":"#CCE5D6"},{"code":574,"r":73,"g":89,"b":40,"hex":"#495928"},{"code":5743,"r":63,"g":73,"b":38,"hex":"#3F4926"},{"code":5747,"r":66,"g":71,"b":22,"hex":"#424716"},{"code":575,"r":84,"g":119,"b":48,"hex":"#547730"},{"code":5753,"r":94,"g":102,"b":58,"hex":"#5E663A"},{"code":5757,"r":107,"g":112,"b":43,"hex":"#6B702B"},{"code":576,"r":96,"g":142,"b":58,"hex":"#608E3A"},{"code":5763,"r":119,"g":124,"b":79,"hex":"#777C4F"},{"code":5767,"r":140,"g":145,"b":79,"hex":"#8C914F"},{"code":577,"r":181,"g":204,"b":142,"hex":"#B5CC8E"},{"code":5773,"r":155,"g":158,"b":114,"hex":"#9B9E72"},{"code":5777,"r":170,"g":173,"b":117,"hex":"#AAAD75"},{"code":578,"r":198,"g":214,"b":160,"hex":"#C6D6A0"},{"code":5783,"r":181,"g":181,"b":142,"hex":"#B5B58E"},{"code":5787,"r":198,"g":198,"b":153,"hex":"#C6C699"},{"code":579,"r":201,"g":214,"b":163,"hex":"#C9D6A3"},{"code":5793,"r":198,"g":198,"b":165,"hex":"#C6C6A5"},{"code":5797,"r":211,"g":209,"b":170,"hex":"#D3D1AA"},{"code":580,"r":216,"g":221,"b":181,"hex":"#D8DDB5"},{"code":5803,"r":216,"g":214,"b":183,"hex":"#D8D6B7"},{"code":5807,"r":224,"g":221,"b":188,"hex":"#E0DDBC"},{"code":581,"r":96,"g":94,"b":17,"hex":"#605E11"},{"code":5815,"r":73,"g":68,"b":17,"hex":"#494411"},{"code":582,"r":135,"g":137,"b":5,"hex":"#878905"},{"code":5825,"r":117,"g":112,"b":43,"hex":"#75702B"},{"code":583,"r":170,"g":186,"b":10,"hex":"#AABA0A"},{"code":5835,"r":158,"g":153,"b":89,"hex":"#9E9959"},{"code":584,"r":206,"g":214,"b":73,"hex":"#CED649"},{"code":5845,"r":178,"g":170,"b":112,"hex":"#B2AA70"},{"code":585,"r":219,"g":224,"b":107,"hex":"#DBE06B"},{"code":5855,"r":204,"g":198,"b":147,"hex":"#CCC693"},{"code":586,"r":226,"g":229,"b":132,"hex":"#E2E584"},{"code":5865,"r":214,"g":206,"b":163,"hex":"#D6CEA3"},{"code":587,"r":232,"g":232,"b":155,"hex":"#E8E89B"},{"code":5875,"r":224,"g":219,"b":181,"hex":"#E0DBB5"},{"code":600,"r":244,"g":237,"b":175,"hex":"#F4EDAF"},{"code":601,"r":242,"g":237,"b":158,"hex":"#F2ED9E"},{"code":602,"r":242,"g":234,"b":135,"hex":"#F2EA87"},{"code":603,"r":237,"g":232,"b":91,"hex":"#EDE85B"},{"code":604,"r":232,"g":221,"b":33,"hex":"#E8DD21"},{"code":605,"r":221,"g":206,"b":17,"hex":"#DDCE11"},{"code":606,"r":211,"g":191,"b":17,"hex":"#D3BF11"},{"code":607,"r":242,"g":234,"b":188,"hex":"#F2EABC"},{"code":608,"r":239,"g":232,"b":173,"hex":"#EFE8AD"},{"code":609,"r":234,"g":229,"b":150,"hex":"#EAE596"},{"code":610,"r":226,"g":219,"b":114,"hex":"#E2DB72"},{"code":611,"r":214,"g":206,"b":73,"hex":"#D6CE49"},{"code":612,"r":196,"g":186,"b":0,"hex":"#C4BA00"},{"code":613,"r":175,"g":160,"b":12,"hex":"#AFA00C"},{"code":614,"r":234,"g":226,"b":183,"hex":"#EAE2B7"},{"code":615,"r":226,"g":219,"b":170,"hex":"#E2DBAA"},{"code":616,"r":221,"g":214,"b":155,"hex":"#DDD69B"},{"code":617,"r":204,"g":196,"b":124,"hex":"#CCC47C"},{"code":618,"r":181,"g":170,"b":89,"hex":"#B5AA59"},{"code":619,"r":150,"g":140,"b":40,"hex":"#968C28"},{"code":620,"r":132,"g":119,"b":17,"hex":"#847711"},{"code":621,"r":216,"g":221,"b":206,"hex":"#D8DDCE"},{"code":622,"r":193,"g":209,"b":191,"hex":"#C1D1BF"},{"code":623,"r":165,"g":191,"b":170,"hex":"#A5BFAA"},{"code":624,"r":127,"g":160,"b":140,"hex":"#7FA08C"},{"code":625,"r":91,"g":135,"b":114,"hex":"#5B8772"},{"code":626,"r":33,"g":84,"b":63,"hex":"#21543F"},{"code":627,"r":12,"g":48,"b":38,"hex":"#0C3026"},{"code":628,"r":204,"g":226,"b":221,"hex":"#CCE2DD"},{"code":629,"r":178,"g":216,"b":216,"hex":"#B2D8D8"},{"code":630,"r":140,"g":204,"b":211,"hex":"#8CCCD3"},{"code":631,"r":84,"g":183,"b":198,"hex":"#54B7C6"},{"code":632,"r":0,"g":160,"b":186,"hex":"#00A0BA"},{"code":633,"r":0,"g":127,"b":153,"hex":"#007F99"},{"code":634,"r":0,"g":102,"b":127,"hex":"#00667F"},{"code":635,"r":186,"g":224,"b":224,"hex":"#BAE0E0"},{"code":636,"r":153,"g":214,"b":221,"hex":"#99D6DD"},{"code":637,"r":107,"g":201,"b":219,"hex":"#6BC9DB"},{"code":638,"r":0,"g":181,"b":214,"hex":"#00B5D6"},{"code":639,"r":0,"g":160,"b":196,"hex":"#00A0C4"},{"code":640,"r":0,"g":140,"b":178,"hex":"#008CB2"},{"code":641,"r":0,"g":122,"b":165,"hex":"#007AA5"},{"code":642,"r":209,"g":216,"b":216,"hex":"#D1D8D8"},{"code":643,"r":198,"g":209,"b":214,"hex":"#C6D1D6"},{"code":644,"r":155,"g":175,"b":196,"hex":"#9BAFC4"},{"code":645,"r":119,"g":150,"b":178,"hex":"#7796B2"},{"code":646,"r":94,"g":130,"b":163,"hex":"#5E82A3"},{"code":647,"r":38,"g":84,"b":124,"hex":"#26547C"},{"code":648,"r":0,"g":48,"b":94,"hex":"#00305E"},{"code":649,"r":214,"g":214,"b":216,"hex":"#D6D6D8"},{"code":650,"r":191,"g":198,"b":209,"hex":"#BFC6D1"},{"code":651,"r":155,"g":170,"b":191,"hex":"#9BAABF"},{"code":652,"r":109,"g":135,"b":168,"hex":"#6D87A8"},{"code":653,"r":51,"g":86,"b":135,"hex":"#335687"},{"code":654,"r":15,"g":43,"b":91,"hex":"#0F2B5B"},{"code":655,"r":12,"g":28,"b":71,"hex":"#0C1C47"},{"code":656,"r":214,"g":219,"b":224,"hex":"#D6DBE0"},{"code":657,"r":193,"g":201,"b":221,"hex":"#C1C9DD"},{"code":658,"r":165,"g":175,"b":214,"hex":"#A5AFD6"},{"code":659,"r":127,"g":140,"b":191,"hex":"#7F8CBF"},{"code":660,"r":89,"g":96,"b":168,"hex":"#5960A8"},{"code":661,"r":45,"g":51,"b":142,"hex":"#2D338E"},{"code":662,"r":12,"g":25,"b":117,"hex":"#0C1975"},{"code":663,"r":226,"g":211,"b":214,"hex":"#E2D3D6"},{"code":664,"r":216,"g":204,"b":209,"hex":"#D8CCD1"},{"code":665,"r":198,"g":181,"b":196,"hex":"#C6B5C4"},{"code":666,"r":168,"g":147,"b":173,"hex":"#A893AD"},{"code":667,"r":127,"g":102,"b":137,"hex":"#7F6689"},{"code":668,"r":102,"g":73,"b":117,"hex":"#664975"},{"code":669,"r":71,"g":43,"b":89,"hex":"#472B59"},{"code":670,"r":242,"g":214,"b":216,"hex":"#F2D6D8"},{"code":671,"r":239,"g":198,"b":211,"hex":"#EFC6D3"},{"code":672,"r":234,"g":170,"b":196,"hex":"#EAAAC4"},{"code":673,"r":224,"g":140,"b":178,"hex":"#E08CB2"},{"code":674,"r":211,"g":107,"b":158,"hex":"#D36B9E"},{"code":675,"r":188,"g":56,"b":119,"hex":"#BC3877"},{"code":676,"r":160,"g":0,"b":84,"hex":"#A00054"},{"code":677,"r":237,"g":214,"b":214,"hex":"#EDD6D6"},{"code":678,"r":234,"g":204,"b":206,"hex":"#EACCCE"},{"code":679,"r":229,"g":191,"b":198,"hex":"#E5BFC6"},{"code":680,"r":211,"g":158,"b":175,"hex":"#D39EAF"},{"code":681,"r":183,"g":114,"b":142,"hex":"#B7728E"},{"code":682,"r":160,"g":81,"b":117,"hex":"#A05175"},{"code":683,"r":127,"g":40,"b":79,"hex":"#7F284F"},{"code":684,"r":239,"g":204,"b":206,"hex":"#EFCCCE"},{"code":685,"r":234,"g":191,"b":196,"hex":"#EABFC4"},{"code":686,"r":224,"g":170,"b":186,"hex":"#E0AABA"},{"code":687,"r":201,"g":137,"b":158,"hex":"#C9899E"},{"code":688,"r":178,"g":102,"b":132,"hex":"#B26684"},{"code":689,"r":147,"g":66,"b":102,"hex":"#934266"},{"code":690,"r":112,"g":35,"b":66,"hex":"#702342"},{"code":691,"r":239,"g":209,"b":201,"hex":"#EFD1C9"},{"code":692,"r":232,"g":191,"b":186,"hex":"#E8BFBA"},{"code":693,"r":219,"g":168,"b":165,"hex":"#DBA8A5"},{"code":694,"r":201,"g":140,"b":140,"hex":"#C98C8C"},{"code":695,"r":178,"g":107,"b":112,"hex":"#B26B70"},{"code":696,"r":142,"g":71,"b":73,"hex":"#8E4749"},{"code":697,"r":127,"g":56,"b":58,"hex":"#7F383A"},{"code":698,"r":247,"g":209,"b":204,"hex":"#F7D1CC"},{"code":699,"r":247,"g":191,"b":191,"hex":"#F7BFBF"},{"code":700,"r":242,"g":165,"b":170,"hex":"#F2A5AA"},{"code":701,"r":232,"g":135,"b":142,"hex":"#E8878E"},{"code":702,"r":214,"g":96,"b":109,"hex":"#D6606D"},{"code":703,"r":183,"g":56,"b":68,"hex":"#B73844"},{"code":704,"r":158,"g":40,"b":40,"hex":"#9E2828"},{"code":705,"r":249,"g":221,"b":214,"hex":"#F9DDD6"},{"code":706,"r":252,"g":201,"b":198,"hex":"#FCC9C6"},{"code":707,"r":252,"g":173,"b":175,"hex":"#FCADAF"},{"code":708,"r":249,"g":142,"b":153,"hex":"#F98E99"},{"code":709,"r":242,"g":104,"b":119,"hex":"#F26877"},{"code":710,"r":224,"g":66,"b":81,"hex":"#E04251"},{"code":711,"r":209,"g":45,"b":51,"hex":"#D12D33"},{"code":712,"r":255,"g":211,"b":170,"hex":"#FFD3AA"},{"code":713,"r":249,"g":201,"b":163,"hex":"#F9C9A3"},{"code":714,"r":249,"g":186,"b":130,"hex":"#F9BA82"},{"code":715,"r":252,"g":158,"b":73,"hex":"#FC9E49"},{"code":716,"r":242,"g":132,"b":17,"hex":"#F28411"},{"code":717,"r":211,"g":109,"b":0,"hex":"#D36D00"},{"code":718,"r":191,"g":91,"b":0,"hex":"#BF5B00"},{"code":719,"r":244,"g":209,"b":175,"hex":"#F4D1AF"},{"code":720,"r":239,"g":196,"b":158,"hex":"#EFC49E"},{"code":721,"r":232,"g":178,"b":130,"hex":"#E8B282"},{"code":722,"r":209,"g":142,"b":84,"hex":"#D18E54"},{"code":723,"r":186,"g":117,"b":48,"hex":"#BA7530"},{"code":724,"r":142,"g":73,"b":5,"hex":"#8E4905"},{"code":725,"r":117,"g":56,"b":2,"hex":"#753802"},{"code":726,"r":237,"g":211,"b":181,"hex":"#EDD3B5"},{"code":727,"r":226,"g":191,"b":155,"hex":"#E2BF9B"},{"code":728,"r":211,"g":168,"b":124,"hex":"#D3A87C"},{"code":729,"r":193,"g":142,"b":96,"hex":"#C18E60"},{"code":730,"r":170,"g":117,"b":63,"hex":"#AA753F"},{"code":731,"r":114,"g":63,"b":10,"hex":"#723F0A"},{"code":732,"r":96,"g":51,"b":10,"hex":"#60330A"},{"code":801,"r":0,"g":170,"b":204,"hex":"#00AACC"},{"code":"801 2X","r":0,"g":137,"b":175,"hex":"#0089AF"},{"code":802,"r":96,"g":221,"b":73,"hex":"#60DD49"},{"code":"802 2X","r":28,"g":206,"b":40,"hex":"#1CCE28"},{"code":803,"r":255,"g":237,"b":56,"hex":"#FFED38"},{"code":"803 2X","r":255,"g":216,"b":22,"hex":"#FFD816"},{"code":804,"r":255,"g":147,"b":56,"hex":"#FF9338"},{"code":"804 2X","r":255,"g":127,"b":30,"hex":"#FF7F1E"},{"code":805,"r":249,"g":89,"b":81,"hex":"#F95951"},{"code":"805 2X","r":249,"g":58,"b":43,"hex":"#F93A2B"},{"code":806,"r":255,"g":0,"b":147,"hex":"#FF0093"},{"code":"806 2X","r":247,"g":2,"b":124,"hex":"#F7027C"},{"code":807,"r":214,"g":0,"b":158,"hex":"#D6009E"},{"code":"807 2X","r":191,"g":0,"b":140,"hex":"#BF008C"},{"code":808,"r":0,"g":181,"b":155,"hex":"#00B59B"},{"code":"808 2X","r":0,"g":160,"b":135,"hex":"#00A087"},{"code":809,"r":221,"g":224,"b":15,"hex":"#DDE00F"},{"code":"809 2X","r":214,"g":214,"b":12,"hex":"#D6D60C"},{"code":810,"r":255,"g":204,"b":30,"hex":"#FFCC1E"},{"code":"810 2X","r":255,"g":188,"b":33,"hex":"#FFBC21"},{"code":811,"r":255,"g":114,"b":71,"hex":"#FF7247"},{"code":"811 2X","r":255,"g":84,"b":22,"hex":"#FF5416"},{"code":812,"r":252,"g":35,"b":102,"hex":"#FC2366"},{"code":"812 2X","r":252,"g":7,"b":79,"hex":"#FC074F"},{"code":813,"r":229,"g":0,"b":153,"hex":"#E50099"},{"code":"813 2X","r":209,"g":0,"b":132,"hex":"#D10084"},{"code":814,"r":140,"g":96,"b":193,"hex":"#8C60C1"},{"code":"814 2X","r":112,"g":63,"b":175,"hex":"#703FAF"}];
        for (var i = 0; i < pantoneSwatches.length; i++) {
            pantoneSwatches[i].code = "Pantone " + pantoneSwatches[i].code;
            swatches.push(pantoneSwatches[i]);
        }
    }


    // Search
    var searchElem = $("<input class='ui-input' type='text'/>");
    searchElem.attr("placeholder", "Search");

    var elemColors = $("<div class='colors'></div>");
    for (var i = 0; i < swatches.length; i++) {
        var color = swatches[i];
        var rgb = Machinata.Math.hexToRBG(color.hex);
        var brighness = Machinata.Math.rbgBrightness(rgb);
        var colorElem = $("<div class='color'></div>");
        colorElem.css("background-color", color.hex);
        colorElem.data("code", color.code);
        colorElem.data("code-searchable", color.code.toLowerCase().replaceAll(" ",""));
        colorElem.data("hex", color.hex);
        colorElem.data("color", color);
        var labelElem = $("<div class='label'></div>");
        if (brighness < 0.5) {
            labelElem.css("color", "white");
        } else {
            labelElem.css("color", "black");
        }
        labelElem.text(color.code);
        labelElem.appendTo(colorElem);
        colorElem.appendTo(elemColors);
    }

    var elem = $("<div class='bb-color-swatch ui-color-swatch'></div>");
    elem.append(searchElem);
    elem.append(elemColors);

    var allColorsElems = elemColors.find(".color");
    searchElem.on("change keyup", function () {
        var val = searchElem.val().toLowerCase().replaceAll(" ", "");
        var numSelected = 0;
        var firstSelected = null;
        allColorsElems.each(function () {
            var code = $(this).data("code-searchable");
            if (code.indexOf(val) != -1) {
                $(this).show();
                numSelected++;
                firstSelected = $(this);
            } else {
                $(this).hide();
            }
        });
        if (numSelected == 1) {
            firstSelected.trigger("click");
        }
    });
    allColorsElems.click(function () {
        allColorsElems.removeClass("selected");
        var colorElem = $(this);
        colorElem.addClass("selected");
        elem.attr("data-selected-code", colorElem.data("code"));
        elem.attr("data-selected-hex", colorElem.data("hex"));
        if (opts.onSelect) opts.onSelect({code:colorElem.data("code"), hex: colorElem.data("hex"), elem:colorElem});
    });

    return elem;
};


/// <summary>
/// 
/// </summary>
Machinata.UI.createColorPicker = function (pickerType, opts) {

    // Init
    if (opts == null) opts = {};
    if (opts.dropletSize == null) opts.dropletSize = 20;
    if (opts.swatchSize == null) opts.swatchSize = 300;
    if (opts.swatch == null) opts.swatch = "hsv";


    var currentColorRGB = [255, 255, 255];
    var dropletCoord = [opts.swatchSize/2, opts.swatchSize/2];

    // For HSL wheel, see https://medium.com/@bantic/hand-coding-a-color-wheel-with-canvas-78256c9d7d43
    var elem = $("<div class='bb-color-picker'></div>");
    elem.addClass(pickerType);

    // Containers
    var elemSwatch = $("<div class='swatch'></div>");
    elemSwatch.css("position", "relative");
    elem.append(elemSwatch);

    var elemSliders = $("<div class='sliders'></div>");
    elemSliders.css("position", "relative");
    elem.append(elemSliders);



    // Swatch droplet elem
    var elemSwatchDroplet = $("<div class='droplet'></div>");
    elemSwatchDroplet.css("position", "absolute");
    elemSwatchDroplet.css("width", opts.dropletSize+"px");
    elemSwatchDroplet.css("height", opts.dropletSize+"px");
    elemSwatchDroplet.css("border-radius", "50%");
    elemSwatchDroplet.css("border", "1px solid black");
    elemSwatchDroplet.css("pointer-events", "none");
    elemSwatch.append(elemSwatchDroplet);

    var colorWheelCanvasElem = $("<canvas class='select-on-click select-on-drag'></canvas>");
    colorWheelCanvasElem.attr("data-canvas-type", "hsv-color-wheel");
    colorWheelCanvasElem.attr("width", opts.swatchSize);
    colorWheelCanvasElem.attr("height", opts.swatchSize);
    colorWheelCanvasElem.css("border-radius", "50%");
    colorWheelCanvasElem.css("border", "1px solid black");
    elemSwatch.append(colorWheelCanvasElem);

    var sliderHSVValueCanvasElem = null;
    {
        sliderHSVValueCanvasElem = $("<canvas class='horizontal-slider'></canvas>");
        sliderHSVValueCanvasElem.attr("data-canvas-type", "slider");
        sliderHSVValueCanvasElem.attr("data-slider-type", "hsv-value");
        sliderHSVValueCanvasElem.data("value", 1.0);
        sliderHSVValueCanvasElem.attr("width", opts.swatchSize);
        sliderHSVValueCanvasElem.attr("height", 30);
        sliderHSVValueCanvasElem.css("border", "1px solid black");
        elemSliders.append(sliderHSVValueCanvasElem);
        elemSliders.append("<div class='clear'></div>");
    }

    var sliderRGBRCanvasElem = null;
    if(false){
        sliderRGBRCanvasElem = $("<canvas class='horizontal-slider'></canvas>");
        sliderRGBRCanvasElem.attr("data-canvas-type", "slider");
        sliderRGBRCanvasElem.attr("data-slider-type", "rgb-r");
        sliderRGBRCanvasElem.attr("width", opts.swatchSize);
        sliderRGBRCanvasElem.attr("height", 30 / 2);
        sliderRGBRCanvasElem.css("border", "1px solid black");
        elemSliders.append(sliderRGBRCanvasElem);
        elemSliders.append("<div class='clear'></div>");
    }
    var sliderRGBGCanvasElem = null;
    if (false) {
        sliderRGBGCanvasElem = $("<canvas class='horizontal-slider'></canvas>");
        sliderRGBGCanvasElem.attr("data-canvas-type", "slider");
        sliderRGBGCanvasElem.attr("data-slider-type", "rgb-g");
        sliderRGBGCanvasElem.attr("width", opts.swatchSize);
        sliderRGBGCanvasElem.attr("height", 30 / 2);
        sliderRGBGCanvasElem.css("border", "1px solid black");
        elemSliders.append(sliderRGBGCanvasElem);
        elemSliders.append("<div class='clear'></div>");
    }
    var sliderRGBBCanvasElem = null;
    if (false) {
        sliderRGBBCanvasElem = $("<canvas class='horizontal-slider'></canvas>");
        sliderRGBBCanvasElem.attr("data-canvas-type", "slider");
        sliderRGBBCanvasElem.attr("data-slider-type", "rgb-b");
        sliderRGBBCanvasElem.attr("width", opts.swatchSize);
        sliderRGBBCanvasElem.attr("height", 30 / 2);
        sliderRGBBCanvasElem.css("border", "1px solid black");
        elemSliders.append(sliderRGBBCanvasElem);
        elemSliders.append("<div class='clear'></div>");
    }


    var colorCanvasElem = $("<canvas></canvas>");
    colorCanvasElem.attr("data-canvas-type", "color");
    colorCanvasElem.attr("width", opts.swatchSize);
    colorCanvasElem.attr("height", 80);
    colorCanvasElem.css("border", "1px solid black");
    elem.append(colorCanvasElem);

  

    function updateCanvases() {
        

        elem.find("canvas").each(function () {
            var canvasElem = $(this);
            var canvas = canvasElem[0];
            var ctx = canvas.getContext('2d');
            var ww = canvas.width;
            var hh = canvas.height;
            if (canvasElem.attr("data-canvas-type") == "color") {

                // Selected Color
                ctx.fillStyle = "rgb(" + currentColorRGB[0] + "," + currentColorRGB[1] + "," + currentColorRGB[2] + ")";
                ctx.fillRect(0, 0, ww, hh);

            } else if (canvasElem.attr("data-canvas-type") == "slider") {

                // Draw bar
                var val = canvasElem.data("value");
                var closestRGB = null;
                var closestDist = null;
                for (var x = 0; x < ww; x++) {
                    var px = x / ww;
                    var dist = val - px;
                    var rgb = [0, 0, 0];
                    if (canvasElem.attr("data-slider-type") == "hsv-value") {
                        rgb = [Math.round(currentColorRGB[0] * px), Math.round(currentColorRGB[1] * px), Math.round(currentColorRGB[2] * px)];
                    } else if (canvasElem.attr("data-slider-type") == "rgb-r") {
                        rgb = [Math.round(currentColorRGB[0] * px), 0, 0];
                    } else if (canvasElem.attr("data-slider-type") == "rgb-g") {
                        rgb = [0,Math.round(currentColorRGB[1] * px), 0];
                    } else if (canvasElem.attr("data-slider-type") == "rgb-b") {
                        rgb = [0,0,Math.round(currentColorRGB[2] * px)];
                    }
                    if (closestDist == null || dist < closestDist) {
                        closestRGB = rgb;
                        closestDist = dist;
                    }
                    ctx.fillStyle = "rgb(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + ")";
                    ctx.fillRect(x, 0, 1, hh);
                }
                // Draw slider
                var closestRGBInverted = Machinata.Math.rbgInvert(closestRGB);
                var closestRGBGrayscale = Machinata.Math.rbgGrayscale(closestRGBInverted);
                ctx.fillStyle = "rgb(" + (closestRGBGrayscale[0]) + "," + (closestRGBGrayscale[1]) + "," + (closestRGBGrayscale[2]) + ")";
                ctx.fillRect(Math.round(val*ww)-8/2, 0, 8, hh);

            } else if (canvasElem.attr("data-canvas-type") == "hsv-color-wheel") {

                // HSV Color Wheel

                // Draw a flat RBG color grid
                var radius = Math.min(ww/2,hh/2);
                var image = ctx.createImageData(2 * radius, 2 * radius);
                var data = image.data;
                var hsvValue = sliderHSVValueCanvasElem.data("value");
                if (hsvValue == null) hsvValue = 1.0;

                for (var x = -radius; x < radius; x++) {
                    for (var y = -radius; y < radius; y++) {
        
                        //let [r, phi] = xy2polar(x, y);
                        var p = Machinata.Math.xy2Polar(x, y);
                        var r = p[0];
                        var phi = p[1];
        
                        if (r > radius+1) {
                            // skip all (x,y) coordinates that are outside of the circle
                            continue;
                        }
        
                        var deg = Machinata.Math.rad2Deg(phi);
        
                        // Figure out the starting index of this pixel in the image data array.
                        var rowLength = 2*radius;
                        var adjustedX = x + radius; // convert x from [-50, 50] to [0, 100] (the coordinates of the image data array)
                        var adjustedY = y + radius; // convert y from [-50, 50] to [0, 100] (the coordinates of the image data array)
                        var pixelWidth = 4; // each pixel requires 4 slots in the data array
                        var index = (adjustedX + (adjustedY * rowLength)) * pixelWidth;
        
                        var hue = deg;
                        var saturation = r / radius;

                        var rgb = Machinata.Math.hsv2RGB(hue, saturation, hsvValue, true);
                        var rgbToDraw = Machinata.Math.hsv2RGB(hue, saturation, 1.0, true);
                        var alpha = 255;
        
                        data[index] = rgbToDraw[0];
                        data[index + 1] = rgbToDraw[1];
                        data[index + 2] = rgbToDraw[2];
                        data[index + 3] = alpha;

                        //if (rgb[0] == currentColorRGB[0] && rgb[1] == currentColorRGB[1] && rgb[2] == currentColorRGB[2]) {
                        //    selectedPixel = [adjustedX, adjustedY];
                        //}
                        if (adjustedX == dropletCoord[0] && adjustedY == dropletCoord[1]) {
                            currentColorRGB = rgb;
                            if(sliderRGBRCanvasElem != null) sliderRGBRCanvasElem.data("value", (currentColorRGB[0] / 255));
                            if (sliderRGBGCanvasElem != null) sliderRGBGCanvasElem.data("value", (currentColorRGB[1] / 255));
                            if (sliderRGBBCanvasElem != null) sliderRGBBCanvasElem.data("value", (currentColorRGB[2] / 255));
                        }
                    }
                }
                ctx.putImageData(image, 0, 0);
                

                
            }

            

            if (canvasElem.hasClass("ui-bound") == false) {
                canvasElem.addClass("ui-bound");
                if (canvasElem.hasClass("horizontal-slider")) {
                    var mouseDown = false;
                    canvasElem.mousemove(function (event) {
                        if (mouseDown == true) {
                            var x = event.pageX - $(this).offset().left;
                            canvasElem.data("value", x / canvasElem.width());
                            updateCanvases();
                        }
                    });
                    canvasElem.mousedown(function (event) {
                        mouseDown = true;
                        updateCanvases();
                    });
                    canvasElem.mouseup(function (event) {
                        mouseDown = false;
                        var x = event.pageX - $(this).offset().left;
                        canvasElem.data("value", x / canvasElem.width());
                        updateCanvases();
                    });
                    canvasElem.mouseout(function (event) {
                        mouseDown = false;
                        updateCanvases();
                    });
                }
                if (canvasElem.hasClass("select-on-drag")) {
                    var mouseDown = false;
                    canvasElem.mousemove(function (event) {
                        if (mouseDown == true) {
                            var x = event.pageX - $(this).offset().left;
                            var y = event.pageY - $(this).offset().top;
                            dropletCoord = [x, y];
                            updateCanvases();
                        }
                    });
                    canvasElem.mousedown(function (event) {
                        mouseDown = true;
                        updateCanvases();
                    });
                    canvasElem.mouseup(function (event) {
                        mouseDown = false;
                        updateCanvases();
                    });
                    canvasElem.mouseout(function (event) {
                        mouseDown = false;
                        updateCanvases();
                    });
                }
                if (canvasElem.hasClass("select-on-click")) {
                    canvasElem.on("click", function (event) {
                        var x = event.pageX - $(this).offset().left;
                        var y = event.pageY - $(this).offset().top;
                        dropletCoord = [x,y];
                        updateCanvases();
                    });
                }
            }
        });

        if (elemSwatchDroplet != null) {
            elemSwatchDroplet.css("background-color", "rgb(" + currentColorRGB[0] + "," + currentColorRGB[1] + "," + currentColorRGB[2] + ")");
            elemSwatchDroplet.css("left", (dropletCoord[0] - opts.dropletSize / 2) + "px");
            elemSwatchDroplet.css("top", (dropletCoord[1] - opts.dropletSize / 2) + "px");
        }
    }
    updateCanvases();

    return elem;
};



/// <summary>
/// 
/// </summary>
Machinata.UI.restartCSSAnimation = function (elem, className) {
    elem.removeClass(className);
    elem.each(function () {
        void this.offsetWidth;
    });
    elem.addClass(className);
};


/// <summary>
/// 
/// </summary>
Machinata.UI.delayedExpandable = function (elems, opts) {
    if (opts == null) opts = {};
    if (opts.delay == null) opts.delay = 800;

    elems.each(function () {
        var elem = $(this);
        var hoverElem = elem;
        if (elem.find(".expandable-trigger").length > 0) hoverElem = elem.find(".expandable-trigger");

        hoverElem.hover(function () {
            elem.addClass("waiting");
            elem.addClass("option-waiting");
            setTimeout(function () {
                if (!elem.hasClass("waiting")) return;
                elem.addClass("expanded");
                elem.addClass("option-expanded");
                elem.removeClass("waiting");
                elem.removeClass("option-waiting");
            }, opts.delay);
        }, function () {
            
        });
        elem.hover(function () {
            
        }, function () {
            elem.removeClass("waiting");
            elem.removeClass("option-waiting");
            elem.removeClass("expanded");
            elem.removeClass("option-expanded");
        });
    });

    
};



/// <summary>
/// Automatically applies the proper first/last classes to a control group buttons which contain
/// invisible elements.
/// Use this method for control groups that have magnetic styling (ie the buttons stick to each other)
/// </summary>
Machinata.UI.updateControlGroupClasses = function (elem) {
    var buttons = elem.find(".ui-button");
    buttons.removeClass("option-first").removeClass("option-last");
    buttons.filter(":visible").first().addClass("option-first");
    buttons.filter(":visible").last().addClass("option-last");
};

/// <summary>
/// 
/// </summary>
Machinata.UI.magnificationPopup = function (elems, opts) {
    if (opts == null) opts = {};
    if (opts.delay == null) opts.delay = 100;

    elems.each(function () {
        var elem = $(this);
        var hoverElem = elem;
        if (elem.find(".magnification-trigger").length > 0) hoverElem = elem.find(".magnification-trigger");

        function update(event) {
            if (event == null) return;
            var magElem = elem.data("mag-elem");
            if (magElem != null) {
                magElem.css("left", event.pageX + "px");
                magElem.css("top", event.pageY + "px");
            }
            elem.data("last-move-event", event);
        }

        hoverElem.on("mousemove", function (event) {
            update(event);
        });
        hoverElem.hover(function (event) {
            elem.addClass("waiting");
            elem.addClass("option-waiting");


            // Create mag elem
            var bgImage = "url(" + elem.attr("data-magnification-image") + ")";
            if (elem.find(".magnification-image").length > 0) {
                bgImage = elem.find(".magnification-image").css("background-image");
            }
            var magElem = $("<div class='ui-magnification'></div>");
            magElem.css("width", hoverElem.width() + "px");
            magElem.css("height", hoverElem.height() + "px");
            magElem.css("background-image", bgImage);
            magElem.addClass("hidden");
            $("body").append(magElem);
            elem.data("mag-elem", magElem);


            setTimeout(function () {
                if (!elem.hasClass("waiting")) return;


                setTimeout(function () {

                    update(elem.data("last-move-event"));
                    magElem.removeClass("hidden");
                    magElem.css("width", "").css("height", "");
                }, 10);

                elem.addClass("magnified");
                elem.addClass("option-magnified");
                elem.removeClass("waiting");
                elem.removeClass("option-waiting");
            }, opts.delay);
        }, function () {

        });
        hoverElem.hover(function () {

        }, function () {
            elem.removeClass("waiting");
            elem.removeClass("option-waiting");
            elem.removeClass("magnified");
            elem.removeClass("option-magnified");
            var magElem = elem.data("mag-elem");
            if (magElem != null) magElem.remove();
        });
    });


};

/// <summary>
/// 
/// </summary>
Machinata.UI.buildSVGIcon = function (iconName, iconURL) {
    return $('<svg class="icon icon-' + iconName + '"><use xlink:href="' + iconURL + '"></use></svg>');
};

/// <summary>
/// 
/// </summary>
Machinata.UI.isTruncated = function (elem) {
    // See https://stackoverflow.com/questions/7738117/html-text-overflow-ellipsis-detection
    var tolerance = 2; // In px. Depends on the font you are using
    return (elem.outerWidth() + tolerance < elem[0].scrollWidth);

};

/// <summary>
/// 
/// </summary>
Machinata.UI.autoShowTextAsTooltipOnTruncated = function (elements) {
    elements.hover(function () {
        if (Machinata.UI.isTruncated($(this))) {
            $(this).attr("data-title-orig", $(this).attr("title"));
            $(this).attr("title", $(this).text());
        } else {
            $(this).attr("title", $(this).attr("data-title-orig"));
        }
    });
};



/// <summary>
/// 
/// </summary>
Machinata.UI.triggerOnElementInViewport = function (elements, enterViewportCallback, leaveViewportCallback) {
    elements.each(function () {
        var elem = $(this);
        var update = function () {
            if (elem.visible(true)) {
                //TODO: only call on change state
                if (enterViewportCallback) enterViewportCallback(elem);
            } else if (elem.hasClass("animate-on-disappear")) {
                //TODO: only call on change state
                if (leaveViewportCallback) leaveViewportCallback(elem);
            }
        };
        $(window).on('scroll', update);
        update();
    });
};




/// <summary>
/// 
/// </summary>
Machinata.UI.createFileDropZone = function (elements) {
    elements.each(function () {
        var elem = $(this);
        elem.append("<div class='tip'>Drop files here</div>");
        elem.append("<div class='previews'></div>");
        elem.append("<div class='clear'></div>");
        var files = [];
        elem.on('dragover', function (e) {
            e.preventDefault();
            e.stopPropagation();
        });
        elem.on('dragenter', function (e) {
            e.preventDefault();
            e.stopPropagation();
        });
        elem.on('drop',function (e) {
            if (e.originalEvent.dataTransfer && e.originalEvent.dataTransfer.files.length) {
                e.preventDefault();
                e.stopPropagation();
                    
                console.log(e.originalEvent.dataTransfer.files);
                for (var i = 0; i < e.originalEvent.dataTransfer.files.length; i++) {
                    // Register in form
                    var file = e.originalEvent.dataTransfer.files[i];
                    files.push(file);
                    // Create preview
                    var previewElem = Machinata.createFilePreview(file.name, file.name, false);
                    elem.find(".previews").append(previewElem);
                    elem.find(".tip").hide();
                }
            }
        });
        var uploadButtonElem = $(elem.attr("data-dropzone-button"));
        uploadButtonElem.click(function () {
            uploadButtonElem.addClass("disabled");
            elem.addClass("uploading");
            // Do API call to upload
            var call = Machinata.apiCall(elem.attr("data-dropzone-api-call"));
            for (var i = 0; i < files.length; i++) {
                // Register in form
                call.attachFileObject(files[i]);
            }
            // Prepare api call
            call.success(function (message) {
                uploadButtonElem.removeClass("disabled");
                elem.removeClass("uploading");
                Machinata.processCallback(elem.attr("data-dropzone-api-call-success"), message);
            })
            call.error(function (message) {
                uploadButtonElem.removeClass("disabled");
                elem.removeClass("uploading");
            });
            call.genericError();
            // Send
            call.send();
        });
    });
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-forms.js */
/* File: js/machinata-core-bundle.js/machinata-core-forms.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// Library for extending web forms to make them more powerful and user-friendly.
/// </summary>
/// <type>namespace</type>
Machinata.Forms = {};

/// <summary>
/// 
/// </summary>
/// <hidden/>
Machinata._onFormInputBinds = [];

/// <summary>
/// Register new form input binding routines through this method.
/// The function passed as an argument should have the following signature:
/// ```
/// function(propertyType, type, form, input) 
/// ```
/// Example:
/// ```
/// Machinata.onFormInputBind(function (propertyType, type, form, input) {
///   // Your code here...
/// });
/// ```
/// </summary>
Machinata.onFormInputBind = function (fn) {
    Machinata._onFormInputBinds.push(fn); //TODO: instead of push, insert at 0 to allow overriding?
};



/// <summary>
/// 
/// </summary>
/// <hidden/>
Machinata.onInit(function () {

    // Find all forms that need auto-bind on input-properties
    Machinata.Forms.bindFormBuilderUIForForms($("form.auto-bind-input-properties"));
    Machinata.Forms.bindApiCallForForms($("form[api-call]"));
 
    // Find submit buttons
    //$("form .submit-form").click(function () {
    //   $(this).closest("form").submit();
    //});
    $("form .submit-form").each(function () {
        var elem = $(this);
        var form = $(this).closest("form");
        if (elem.is("a")
            || elem.attr("type") == "submit" 
            || elem.attr("type") == "button") {
            // Button input (bind click)
            elem.click(function () {
                Machinata.debug("Click detected on .submit-form submit/a/button, will submit form...");
                form.submit();
            });
        } else {
            // Text input (bind enter)
            elem.keypress(function(event) {
                var keycode = event.keyCode || event.which;
                if (keycode == '13') {
                    Machinata.debug("Enter key detected on .submit-form, will submit form...");
                    form.submit();
                }
            });
        }
    });
    // Find submit buttons
    $("form[autocomplete='off']").each(function () {
        var form = $(this);
        setTimeout(function () {
            form.find("input[autocomplete='off']").val("");
        }, 100);
        
    });
    // Find all inputs with on change event
    $("input[api-call-on-change]").each(function () {
        var input = $(this);
        var apiCall = input.attr("api-call-on-change");
        input.on('change', function () {
            input.addClass("loading");
            var type = input.attr("type");
            var val = input.val();
            if (type == "checkbox") {
                //val = $(this).is(':checked');
                val = $(this).prop('checked');
            }
            if (type == "radio") {
                //val = $(this).is(':checked');
                val = $(this).prop('checked');
                var others = input.closest(".entity-list").find("input[type='radio']").not($(this));
                others.prop('checked', false);
                //others.button("refresh");
                others.trigger("selected");
            }
            // Don't do a API call if we dont ahve one (but do the UI update)
            if (String.isEmpty(apiCall)) {
                return;
            }
            // Init data to send
            var call = Machinata.apiCall(apiCall);
            var data = {};
            data["value"] = val;
            call.data(data);
            // Prepare api call
            call.success(function (message) {
                input.removeClass("loading");
            })
            call.error(function (message) {
                input.removeClass("loading");
                // Rollback value
                if (type == "checkbox") {
                    input.prop('checked', !val);
                    //input.button("refresh");
                    input.trigger("selected");
                } else if (type == "radio") {
                    //TODO reselect last item
                    input.prop('checked', false);
                    //input.button("refresh");
                    input.trigger("selected");
                }
            });
            call.genericError();
            // Send
            call.send();
        });


    });
    
});


/// <summary>
/// 
/// </summary>
Machinata.apiCallForForm = function (apiCall, form, onSuccess, onError) {
    // Intercept submit
    form.submit(function (e) {
        Machinata.debug("Machinata.apiCallForForm: intercepting submit...");
        // Stop browser
        e.preventDefault();
        // Do we have a validation function?
        // This will first execute, and if it doesnt pass then we abort the api call...
        var validateFunction = form.data("on-validate");
        if (validateFunction != null) {
            Machinata.debug("Machinata.apiCallForForm: executing pre-validation...");
            var validateReturn = validateFunction(form);
            Machinata.debug("Machinata.apiCallForForm: pre-validation: "+validateReturn);
            if (validateReturn == false) {
                Machinata.debug("Machinata.apiCallForForm: pre-validation failed, will abort.");
                return;
            }
        }
        // Init api call
        var call = Machinata.apiCall(apiCall);
        // Init data to send
        var nativeForm = this;
        var data = {};
        form.addClass("loading");
        form.find("input,textarea,select").each(function () {
            var type = $(this).attr("type");
            var propertyType = $(this).attr("data-property-type");
            var name = $(this).attr("name");
            if (!String.isEmpty(name)) {
                if (type == "file") {
                    // Special file upload (we only support one file per input)
                    var fileNative = $(this)[0];
                    if (fileNative.files.length > 0) {
                        call.attachFileInput(fileNative.files[0], name, fileNative.files[0].name);
                    }
                } else if (propertyType == "ContentNode") {
                    var editorElem = $(".content-editor[editor-bind-to-input='" + name + "']");
                    var editor = Machinata.getContentEditor(editorElem);
                    var val = editor.compileContentAsJSON();
                    data[name] = JSON.stringify(val);
                } else if (propertyType == "DateTime" || propertyType == "DateRange") {
                    // Convert to UTCMS
                    var val = $(this).val();
                    var utcms = $(this).attr("data-property-universal-value");
                    if (utcms != null && utcms != "") {
                        val = utcms;
                        Machinata.debug("Using utcms for " + propertyType + " prop: " + val);
                    }
                    data[name] = utcms;
                } else if (propertyType == "Properties") {
                    var props = $("input[properties-field='" + name + "']");
                    var json = {};
                    props.each(function () {
                        json[$(this).attr("properties-key")] = $(this).val();
                    });
                    data[name] = JSON.stringify(json);
                } else {
                    // Just regular form
                    var val = $(this).val();
                    // Skip if the input is a checkbox and we are not checked
                    if (type == "checkbox" || type == "radio") {
                        if ($(this).prop('checked') == false) return;
                    }
                    // Exists already?
                    if (data[name] != null) {
                        if (data[name].constructor === Array) {
                            data[name].push(val);
                        } else {
                            var newArray = [];
                            newArray.push(data[name]);
                            newArray.push(val);
                            data[name] = newArray;
                        }
                    } else {
                        data[name] = val;
                    }
                }
            }
        });
        // Focused submit button with action?
        var submitButton = $(this).find("input[type=submit]:focus"); // Note: doesnt work on OSX!
        if (submitButton.length == 0) submitButton = $(this).find("input[type=submit]"); // fallback to default single button
        if (submitButton.length > 0) {
            if (!String.isEmpty(submitButton.attr("action"))) {
                data["action"] = submitButton.attr("action");
            }
        }
        call.data(data);
        // Prepare api call
        call.success(function (message) {
            form.removeClass("loading");
        })
        call.error(function (message) {
            form.removeClass("loading");
        });
        // Function handlers given via data variables?
        var successDataFunction = form.data("on-success");
        if (successDataFunction != null) call.success(function () {
            successDataFunction(form);
        }); 
        // Function handlers given via parameters?
        if (onSuccess) call.success(onSuccess);
        if (onError) call.error(onError);

        // Send
        call.send();
    });
};

/// <summary>
/// 
/// </summary>
Machinata.Forms.bindFormBuilderUIForForms = function (elements) {
    elements.each(function () {
        var form = $(this);
        var inputs = form.find("input");
        function bindTextAttribute(input, nameFrom, nameTo, valueIfExists) {
            if (!String.isEmpty(input.attr(nameFrom))) {
                var val = input.attr(nameFrom);
                if (valueIfExists != null) val = valueIfExists;
                input.attr(nameTo, val);
            }
        };
        function bindBoolAttribute(input, nameFrom, nameTo, valueIfExists) {
            if (input.attr(nameFrom) == "true") {
                var val = input.attr(nameFrom);
                if (valueIfExists != null) val = valueIfExists;
                input.attr(nameTo, val);
            }
        };
        inputs.each(function () {
            // Bind all standard attributes to the standard html5 attributes
            var input = $(this);
            //bindTextAttribute(input, "data-property-min-length", "min-length");
            //bindTextAttribute(input, "data-property-max-length", "max-length");
            bindTextAttribute(input, "data-property-placeholder", "placeholder");
            bindBoolAttribute(input, "data-property-required", "required", "required");
            bindBoolAttribute(input, "data-property-disabled", "disabled", "disabled");
            bindBoolAttribute(input, "data-property-readonly", "disabled", "disabled");
            bindTextAttribute(input, "data-property-form-type", "type");
            bindTextAttribute(input, "data-property-format", "format"); //BUG: Browsers (webkit based) now validate this much more stricly, we disable it for now
            bindTextAttribute(input, "data-property-autocomplete", "autocomplete");
            if (!String.isEmpty(input.attr("data-property-tooltip"))) {
                form.find(".ui-label[data-form-name='" + input.attr("name") + "']").attr("title", input.attr("data-property-tooltip"));
                bindTextAttribute(input, "data-property-tooltip", "title");
            }
            bindTextAttribute(input, "data-property-min-value", "min");
            bindTextAttribute(input, "data-property-max-value", "max");
            // Do min/max len
            // pattern=".{3,}"  pattern=".{5,10}"   pattern=".{0}|.{5,10}"    pattern=".{0}|.{8,}"
            var req = input.attr("data-property-required");
            var minLen = input.attr("data-property-min-length");
            var maxLen = input.attr("data-property-max-length");
            var pattern = input.attr("data-property-pattern");
            if (pattern == null) pattern = "";
            //if (req != "true") pattern += ".{0}";
            if (!String.isEmpty(minLen) || !String.isEmpty(maxLen)) {
                if (pattern == "") pattern += "."; // Make sure this prefixes the pattern
                pattern += "{";
                if (!String.isEmpty(minLen)) pattern += minLen;
                pattern += ",";
                if (!String.isEmpty(maxLen)) pattern += maxLen;
                pattern += "}";
                input.attr("pattern", pattern);
            }
            // Call all binders to see if one can process the type...
            for (var i = 0; i < Machinata._onFormInputBinds.length; i++) {
                var ret = Machinata._onFormInputBinds[i](input.attr("data-property-type"), input.attr("data-property-form-type"), form, input);
                if (ret == true) break;
            }
        });
    });
};


/// <summary>
/// 
/// </summary>
Machinata.Forms.bindApiCallForForms = function (elements) {
    // Find all forms bound to a api-call
    elements.each(function () {
        var form = $(this);
        var apiCall = form.attr("api-call");
        var successCallback = form.attr("on-success");
        var errorCallback = form.attr("on-error");
        Machinata.apiCallForForm(apiCall, form, function (message) {
            Machinata.processCallback(successCallback, message);
        }, function (message) {
            if (String.isEmpty(errorCallback)) Machinata.apiErrorForGeneric(message.data.code, message.data.message);
            else Machinata.processCallback(errorCallback, message);
        });
    });
};


/// <summary>
/// 
/// </summary>
Machinata.Forms.currencyInput = function (elem, currency, locale, digits, zeroCents, min, max) {
    // Load settings
    if (currency == null) currency = elem.attr("data-currency");
    if (currency == null) currency = Machinata.Currency.DEFAULT_CURRENCY; // default
    if (locale == null) locale = elem.attr("data-locale");
    if (locale == null) locale = Machinata.Currency.DEFAULT_LOCALE; // default
    if (digits == null) digits = 0; // default
    // Attach to element
    elem.data("currency", currency);
    // Helper function
    function setFormattedValue() {
        // Get the value
        var val = elem.val();
        if (val == "") return null;
        val = val.replaceAll(elem.data("currency"), "");
        if (zeroCents != null) val = val.replaceAll(zeroCents, ".00");
        if (zeroCents != null) val = val.replaceAll(".-", ".00");
        if (zeroCents != null) val = val.replaceAll(".–", ".00");
        val = val.replaceAll("'", "");
        val = val.replaceAll("’", "");
        var rawVal = parseFloat(val);
        if (isNaN(rawVal)) rawVal = min;
        if (min != null && rawVal < min) rawVal = min;
        if (max != null && rawVal > max) rawVal = max;
        var newVal = Machinata.Currency.getFormattedString(rawVal, elem.data("currency"), locale, digits, zeroCents);
        elem.val(newVal);
        elem.attr("data-raw-value", rawVal);
        elem.data("raw-value", rawVal);
        return rawVal;
    }
    // Bind change and do initial update
    elem.on("change update", function () { setFormattedValue(); });
    setFormattedValue();
};

/// <summary>
/// 
/// </summary>
Machinata.Forms.percentInput = function (elem, min, max) {
    // Load settings
    
    // Helper function
    function setFormattedValue() {
        // Get the value
        var val = elem.val();
        if (val == "") return null;
        val = val.replaceAll("%", "");
        var rawVal = parseFloat(val);
        if (isNaN(rawVal)) rawVal = min;
        if (min != null && rawVal < min) rawVal = min;
        if (max != null && rawVal > max) rawVal = max;
        var newVal = rawVal + "%";
        elem.val(newVal);
        elem.attr("data-raw-value", rawVal);
        elem.data("raw-value", rawVal);
        return rawVal / 100.0;
    }
    // Bind change and do initial update
    elem.on("change update", function () { setFormattedValue(); });
    setFormattedValue();
};


/// <summary>
/// 
/// </summary>
Machinata.Forms.numberInput = function (elem, min, max, format, locale, opts) {
    // Load settings

    // Helper function
    function setFormattedValue() {
        // Get the value
        var val = elem.val();
        if (val == "") return null;
        var rawVal = parseFloat(val);
        if (isNaN(rawVal)) rawVal = min;
        if (min != null && rawVal < min) rawVal = min;
        if (max != null && rawVal > max) rawVal = max;
        var newVal = rawVal;
        if (format != null) {
            newVal = Machinata.Formatting.formatNumber(rawVal, format, locale, opts);
        }
        elem.val(newVal);
        elem.attr("data-raw-value", rawVal);
        elem.data("raw-value", rawVal);
        return rawVal;
    }
    // Bind change and do initial update
    elem.on("change update", function () { setFormattedValue(); });
    setFormattedValue();
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-forms-bindings.js */
/* File: js/machinata-core-bundle.js/machinata-core-forms-bindings.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// Email form binding
/// </summary>
/// <hidden/>
Machinata.onFormInputBind(function (propertyType, type, form, input) {
    if (type == "emailaddress") {
        input.attr("type", "email");
        return true;
    } 
});


/// <summary>
/// DateTime/DateRange form binding
/// </summary>
/// <hidden/>
Machinata.onFormInputBind(function (propertyType, type, form, input) {
    if (propertyType == "DateTime" || propertyType == "DateRange") {
        Machinata.debug("Creating Form Input " + propertyType + " for " + input.attr("name"));
        // Init
        input.attr("type", "text"); // Make sure the browser doesnt do it's own date field
        input.attr("format", ""); // Make sure the browser doesnt do format
        input.val(input.attr("data-property-original-value")); // Make sure the browser doesnt do format
        var isDateRange = propertyType == "DateRange";
        var format = input.attr("data-property-format");
        var dateFormat = Machinata.DEFAULT_DATE_FORMAT_JAVASCRIPT_UI;
        var timeFormat = Machinata.DEFAULT_TIME_FORMAT_JAVASCRIPT_UI;
        var formatSegs = format.split(" ");
        if (formatSegs.length == 2) {
            dateFormat = formatSegs[0];
            timeFormat = formatSegs[1];
        } else {
            if (String.isEmpty(format)) format = dateFormat + " " + timeFormat;
            else {
                if (format.indexOf("HH") != -1 || format.indexOf("mm") != -1) {
                    // Its just a time
                    dateFormat = null;
                    timeFormat = format;
                } else {
                    // Its just a date
                    dateFormat = format;
                    timeFormat = null;
                }
            }
        }
        // Date range
        if (isDateRange == true) {
            //timeFormat = null;
            //format = dateFormat;
        }
        Machinata.debug("  format: " + format);
        Machinata.debug("  dateFormat: " + dateFormat);
        Machinata.debug("  timeFormat: " + timeFormat);
        Machinata.debug("  isDateRange: " + isDateRange);
        // Convert for picker
        if (dateFormat != null) dateFormat = Machinata.convertDotNetTimeFormatToDatepickerFormat(dateFormat);
        if (timeFormat != null) timeFormat = Machinata.convertDotNetTimeFormatToDatepickerFormat(timeFormat);
        // Show date/time picker when clicking
        input.click(function () {
            Machinata.dateDialog(null, null, null, input.val(), dateFormat, timeFormat, isDateRange)
                .input(function (datetime, id) {
                    if (id == "clear") {
                        input.val("");
                        input.attr("data-property-universal-value", "");
                        return;
                    }
                    if (isDateRange == true) {
                        Machinata.debug("DateRange selected: " + datetime);
                        Machinata.debug("  start: " + datetime.start);
                        Machinata.debug("  end: " + datetime.end);
                        var utcmsStart = Machinata.UTCMillisecondsFromDate(datetime.start);
                        var utcmsEnd = Machinata.UTCMillisecondsFromDate(datetime.end);
                        Machinata.debug("  utcms start: " + utcmsStart);
                        Machinata.debug("  utcms end: " + utcmsEnd);
                        input.attr("data-property-universal-value", utcmsStart + Machinata.DEFAULT_DATERANGE_SEPARATOR + utcmsEnd);
                        input.val(Machinata.formattedDate(datetime.start, format) + Machinata.DEFAULT_DATERANGE_SEPARATOR + Machinata.formattedDate(datetime.end, format));
                    } else {
                        Machinata.debug("DateTime selected: " + datetime);
                        var utcms = Machinata.UTCMillisecondsFromDate(datetime);
                        Machinata.debug("  utcms: " + utcms);
                        input.attr("data-property-universal-value", utcms);
                        input.val(Machinata.formattedDate(datetime, format));
                    }
                })
                .show();
        });
        return true;
    }
});

/// <summary>
/// Image/Upload form binding
/// </summary>
/// <hidden/>
Machinata.onFormInputBind(function (propertyType, type, form, input) {
    if (type == "imageurl" || type == "upload") {
        input.hide();
        var autodectImages = false;
        var fileCategory = null;
        if (type == "imageurl") {
            autodectImages = true;
            fileCategory = "image";
        }
        var fileURL = input.val();
        var previewContainer = $("<div class='preview-container'/>");
        var filePreview = Machinata.createFilePreview(fileURL, fileURL, autodectImages);
        filePreview.addClass("cursor-pointer");
        previewContainer.append(filePreview);
        previewContainer.append("<div class='clear'/>");
        previewContainer.click(function () {
            var buttons = null;
            var title = "Choose a Image";
            if (type == "upload") title = "Choose a File";
            if (input.attr("data-property-required") == "false") {
                buttons = [];
                buttons.push({
                    id: "clear",
                    text: "Clear",
                    click: function () {
                        var newVal = "";
                        input.val(newVal);
                        previewContainer.text("");
                        var newFilePreview = Machinata.createFilePreview(newVal, newVal, autodectImages);
                        newFilePreview.addClass("cursor-pointer");
                        previewContainer.append(newFilePreview);
                        $(this).dialog("close");
                    },
                })
            }
            var source = input.attr("data-content-source");
            if (source == null || source == "") source = input.attr("data-property-parent-type");
            var fileDiag = Machinata.fileDialog(title, source, fileCategory, buttons)
                .okay(function (val) {
                    input.val(val);
                    previewContainer.text("");
                    var newFilePreview = Machinata.createFilePreview(val, val, autodectImages);
                    newFilePreview.addClass("cursor-pointer");
                    previewContainer.append(newFilePreview);
                });
            fileDiag.show();
        });
        input.parent().append(previewContainer);
        return true;
    }
});

/// <summary>
/// Country form binding
/// </summary>
/// <hidden/>
Machinata.onFormInputBind(function (propertyType, type, form, input) {
    if (type == "country") {
        input.hide();
        var selectElem = $("<select/>");
        var universalValue = input.attr("data-property-universal-value");
        var required = input.attr("data-property-required");
        if (required == "false") {
            var optElem = $("<option/>");
            optElem.text("");
            optElem.attr("value", "");
            selectElem.append(optElem);
        }
        var didSetVal = false;
        for (var i = 0; i < Machinata.COUNTRIES.length; i++) {
            var c = Machinata.COUNTRIES[i];
            var optElem = $("<option/>");
            optElem.text(c.name);
            optElem.attr("value", c.code.toLowerCase());
            if (c.code.toLowerCase() == input.val() || c.code.toLowerCase() == universalValue) {
                optElem.attr("selected", "selected");
                didSetVal = true;
            }
            selectElem.append(optElem);
        }
        input.parent().append(selectElem);
        /*selectElem.selectmenu();
        input.val(selectElem.val());
        selectElem.on("selectmenuchange", function () {
            input.val(selectElem.val());
        });*/
        input.val(selectElem.val());
        selectElem.on("change", function () {
            input.val(selectElem.val());
        });
        return true;
    }
});

/// <summary>
/// List/Select form binding
/// </summary>
/// <hidden/>
Machinata.onFormInputBind(function (propertyType, type, form, input) {
    if (type == "list" || type == "select") {
        input.hide();
        var selectElem = $("<select/>");
        selectElem.attr("title", input.attr("data-property-tooltip"));
        var opts = input.attr("data-property-options").split(",");
        var universalValue = input.attr("data-property-universal-value");
        var rawValue = input.attr("data-property-raw-value");
        var optsTitles = null;
        if (input.attr("data-property-options-titles") != null) optsTitles = input.attr("data-property-options-titles").split(",");
        var didSetVal = false;
        var hasCustomVal = false;
        if (input.attr("data-property-required") == "false") {
            opts.splice(0, 0, "");
            if (optsTitles != null) optsTitles.splice(0, 0, "");
        }
        for (var i = 0; i < opts.length; i++) {
            var opt = opts[i];
            var title = opt;
            if (optsTitles != null && optsTitles.length > i) title = optsTitles[i];
            var optElem = $("<option/>");
            optElem.text(title);
            optElem.attr("value", opt);
            if (opt == "*") hasCustomVal = true;
            if (opt == input.val() || opt == universalValue || opt == rawValue) {
                optElem.attr("selected", "selected");
                didSetVal = true;
            }
            selectElem.append(optElem);
        }
        var originalValue = input.val();
        input.parent().append(selectElem);
        input.val(selectElem.val());
        selectElem.on("change", function () {
            if (selectElem.val() == "*") {
                input.trigger("updateCustomInput");
            } else {
                input.trigger("updateCustomInput");
                input.val(selectElem.val());
                input.trigger("change");
            }
        });
        input.on("updateCustomInput", function () {
            var customElem = input.parent().find(".custom-input");
            var customElemInput = input.parent().find(".custom-input input");
            if (selectElem.val() == "*") {
                // Show the custom field, also updaet the current value to it...
                input.val(customElemInput.val());
                customElem.show();
                if (input.attr("data-property-required") == "true") {
                    customElemInput.attr("required", "required");
                }
            } else {
                customElem.hide();
                if (input.attr("data-property-required") == "true") {
                    customElemInput.attr("required", null);
                }
            }
        });

        if (hasCustomVal == true) {
            // Setup the custom ui
            var customElem = $("<div class='custom-input'><input type='text'/></div>");
            var customElemInput = customElem.find("input");
            customElemInput.on("change", function () {
                input.val($(this).val());
            });
            if (didSetVal == false) {
                customElemInput.val(originalValue);
            }
            customElemInput.attr("title", input.attr("data-property-tooltip"));
            customElemInput.attr("placeholder", input.attr("data-property-placeholder"));
            customElem.hide(); // prevent flicker
            input.parent().append(customElem);
            input.trigger("updateCustomInput");
        }
        return true;
    } 
});

/// <summary>
/// Toggle/Bool/Selectable form binding
/// </summary>
/// <hidden/>
Machinata.onFormInputBind(function (propertyType, type, form, input) {
    if (type == "toggle" || type == "bool" || type == "radiolist" || type == "checkboxlist") {
        input.hide();
        var buttonsElem = $("<div class='buttons bb-button-set'>");
        var opts = input.attr("data-property-options").split(",");
        var optsTitles = null;
        if (input.attr("data-property-options-titles") != null) optsTitles = input.attr("data-property-options-titles").split(",");
        var inputType = "radio";
        var vals = input.val().split(",");
        if (type == "checkboxlist") inputType = "checkbox";
        for (var i = 0; i < opts.length; i++) {
            var opt = opts[i];
            var title = opt;
            if (optsTitles != null && optsTitles.length > i) title = optsTitles[i];
            var optElem = $("<input class='bb-" + inputType + "'/>");
            optElem.attr("value", opt)
            optElem.attr("label", title);
            optElem.attr("name", input.attr("name") + "_opt");
            optElem.attr("type", inputType);
            for (var ii = 0; ii < vals.length; ii++) {
                if (opt == vals[ii]) {
                    optElem.attr("selected", "selected");
                    optElem.addClass("selected");
                }
            }
            optElem.click(function (e) {
                // Toggle UI
                var newVal = "";
                buttonsElem.find("input").each(function () {
                    if ($(this).is(':checked')) {
                        if (newVal != "") newVal += ",";
                        newVal += $(this).attr("value");
                    }
                });
                input.val(newVal);
                input.trigger("change");
            });
            buttonsElem.append(optElem);
        }
        input.parent().append(buttonsElem);
        Machinata.UI.bind(buttonsElem);
        return true;
    }
});

/// <summary>
/// Properties form binding
/// </summary>
/// <hidden/>
Machinata.onFormInputBind(function (propertyType, type, form, input) {
    if (propertyType == "Properties") {
        var rawJSON = input.attr("data-property-raw-value");
        if (String.isEmpty(rawJSON)) {
            rawJSON = "{}";
        }
        var json = JSON.parse(rawJSON);
        var keys = Object.keys(json);
        keys.sort();
        // Table form or newer ui-form-row?
        if (input.parent().parent().hasClass("ui-form-row")) {
            var originalRow = input.closest(".ui-form-row");
            for (i = 0; i < keys.length; i++) {
                var key = keys[i];
                var val = json[key];
                var newRow = originalRow.clone();
                newRow.find(".ui-label").text(key.toSentence());
                var newInput = newRow.find(".ui-input input");
                newInput.val(val);
                newInput.attr("name", input.attr("name") + "_" + key);
                newInput.attr("properties-field", input.attr("name"));
                newInput.attr("properties-key", key);
                newRow.insertBefore(originalRow);
            }
            originalRow.hide();
        } else {
            // Just plain table row (tr)
            var originalRow = input.closest("tr");
            for (i = 0; i < keys.length; i++) {
                var key = keys[i];
                var val = json[key];
                var newRow = originalRow.clone();
                newRow.find("td.label").text(key.toSentence());
                var newInput = newRow.find("td.input input");
                newInput.val(val);
                newInput.attr("name", input.attr("name") + "_" + key);
                newInput.attr("properties-field", input.attr("name"));
                newInput.attr("properties-key", key);
                newRow.insertBefore(originalRow);
            }
            originalRow.hide();
        }
        return true;
    }
});

/// <summary>
/// ContentNode form binding
/// </summary>
/// <hidden/>
Machinata.onFormInputBind(function (propertyType, type, form, input) {
    if (propertyType == "ContentNode") {
        input.hide();
        // The content node type is handled by the template
        return true;
    }
});

/// <summary>
/// Multiline Text form binding
/// </summary>
/// <hidden/>
Machinata.onFormInputBind(function (propertyType, type, form, input) {
    if (type == "multilinetext") {
        //input.hide();
        var textareaElem = $("<textarea></textarea>");
        textareaElem.attr("name", input.attr("name"));
        input.parent().append(textareaElem);
        textareaElem.val(input.attr("data-property-raw-value"));
        input.remove();
        return true;
    }
});


/// <summary>
/// LatLon form binding
/// </summary>
/// <hidden/>
Machinata.onFormInputBind(function (propertyType, type, form, input) {
    if (type == "latlon") {
        input.val(input.attr("data-property-raw-value"));
        input.on("click", function () {
            var opts = {
                address: input.val()
            }
            Machinata.locationDialog("Coordinates", null, opts)
                .input(function (val, id) {
                    if (id == "okay") {
                        input.val(val);
                    }
                    else if (id == "clear") {
                        input.val("");
                    }
                });
        });

        return true;
    }
});


/// <summary>
/// Range form binding
/// </summary>
/// <hidden/>
Machinata.onFormInputBind(function (propertyType, type, form, input) {
    if (type == "range") {
        // Alter and create ui...
        input.attr("type", "number");
        var rangeInput = $("<input type='range' class='ui-range'/>");
        rangeInput.attr("value", input.attr("value"));
        rangeInput.attr("min", input.attr("min"));
        rangeInput.attr("max", input.attr("max"));
        rangeInput.attr("step", input.attr("step"));
        rangeInput.insertAfter(input);
        var numberInput = input;
        // Change bindings
        numberInput.on("change", function () {
            rangeInput.val(input.val());
        });
        rangeInput.on("change", function () {
            numberInput.val(rangeInput.val());
        });
        rangeInput.on("input", function () {
            numberInput.val(rangeInput.val());
        });
        return true;
    }
    else if (propertyType == "IntRange") {

        // Helper function
        function getValuesFromString(str) {
            // Parse out the str 'A - B', where A and B can be flaots
            var regex = new RegExp('([-+]?[0-9]*\.?[0-9]+) ?- ?([-+]?[0-9]*\.?[0-9]+)', 'gm'); // see https://regex101.com/r/QuGm0A/1
            var matches = regex.exec(str);
            if (matches == null || matches.length != 3) throw "IntRange invalid value "+str;
            // Parse the numbers
            var valA = parseFloat(matches[1].trim());
            var valB = parseFloat(matches[2].trim());
            if (isNaN(valA)) throw "IntRange invalid value A";
            if (isNaN(valB)) throw "IntRange invalid value B";
            return [valA, valB];
        }

        // Alter and create ui...
        var rangeSliderElem = $("<div class='ui-input-wrapper'><div class='ui-ab-range'/></div>");
        var originalValues = getValuesFromString(input.val());

        // Init slider options
        var lastGoodValues = originalValues;
        var sliderOpts = {};
        sliderOpts.range = true;
        sliderOpts.values = originalValues;
        sliderOpts.slide = function (event, ui) {
            input.val(ui.values[0] + " - " + ui.values[1]);
            lastGoodValues = ui.values;
        };
        sliderOpts.min = parseFloat(input.attr("data-property-min-value"));
        sliderOpts.max = parseFloat(input.attr("data-property-max-value"));
        if (isNaN(sliderOpts.min)) sliderOpts.min = 0;
        if (isNaN(sliderOpts.max)) sliderOpts.max = null;

        // Create jQ UI slider...
        rangeSliderElem.find(".ui-ab-range").slider(sliderOpts);
        rangeSliderElem.insertAfter(input);

        // Bind input change so that its two way...
        input.on("change", function () {
            try {
                var newValues = getValuesFromString(input.val());
                if (sliderOpts.min != null && newValues[0] < sliderOpts.min) newValues[0] = sliderOpts.min; //throw "invalid A val (less than min)";
                if (sliderOpts.min != null && newValues[1] < sliderOpts.min) newValues[1] = sliderOpts.min; //throw "invalid B val (less than min)";
                if (sliderOpts.max != null && newValues[0] > sliderOpts.max) newValues[0] = sliderOpts.max; //throw "invalid A val (greater than max)";
                if (sliderOpts.max != null && newValues[1] > sliderOpts.max) newValues[1] = sliderOpts.max; //throw "invalid B val (greater than max)";
                if (newValues[0] > newValues[1]) newValues[0] = newValues[1];//throw "invalid A val (greater than B)";
                if (newValues[1] < newValues[0]) newValues[1] = newValues[0];// throw "invalid B val (greater than A)";
                rangeSliderElem.find(".ui-ab-range").slider("values", 0, newValues[0]);
                rangeSliderElem.find(".ui-ab-range").slider("values", 1, newValues[1]);
                lastGoodValues = newValues;
                input.val(lastGoodValues[0] + " - " + lastGoodValues[1]);
            } catch (e) {
                console.warn(e);
                input.val(lastGoodValues[0] + " - " + lastGoodValues[1]);
            }
        });

        return true;
    }
});


/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-user.js */
/* File: js/machinata-core-bundle.js/machinata-core-user.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Extensions related to use login and logout.
/// </summary>

/// <summary>
///
/// </summary>
/// <hidden/>
Machinata._onLogins = [];

/// <summary>
/// Bind a handler to a login event.
/// </summary>
Machinata.onLogin = function (fn) {
    Machinata._onLogins.push(fn);
};

/// <summary>
///
/// </summary>
/// <hidden/>
Machinata._onLogouts = [];

/// <summary>
/// Bind a handler to a logout event.
/// </summary>
Machinata.onLogout = function (fn) {
    Machinata._onLogouts.push(fn);
};

/// <summary>
/// Executes the standard login procedure after recieving a login API packet.
/// This can be used on a login form.
/// If redirect is false, the redirect or reload is never done.
/// </summary>
Machinata.doLogin = function (message, redirect) {
    Machinata.registerAuthToken(message);
    if (redirect == null && redirect != false) {
        if (Machinata.queryParameter("redirect") != "") {
            redirect = Machinata.queryParameter("redirect");
        }
    }
    if (redirect != false) {
        if (redirect == null) window.location.reload();
        else window.location = redirect;
    }
};

/// <summary>
/// </summary>
Machinata.doVerifiedLogin = function (message, redirect, verifyPage) {
    Machinata.registerAuthToken(message);
    if (redirect == null) {
        if (Machinata.queryParameter("redirect") != "") {
            redirect = Machinata.queryParameter("redirect");
        }
    }
    if (redirect == null) redirect = window.location;
    if (verifyPage == null) verifyPage = "/admin/verify-login";

    window.location = verifyPage + "?redirect=" + encodeURIComponent(redirect);
};

/// <summary>
/// 
/// </summary>
Machinata.logout = function (redirect) {
    Machinata.apiCall("/api/logout").success(function (message) {
        Machinata.doLogout(message, redirect)
    }).send();
};

/// <summary>
/// 
/// </summary>
Machinata.doLogout = function (message, redirect) {
    Machinata.unregisterAuthToken();
    if (redirect == null) window.location.reload();
    else window.location = redirect;
};

/// <summary>
/// 
/// </summary>
Machinata.registerAuthToken = function (message) {
    Machinata.debug("registerAuthToken");
    // Set cookies
    var expires = null;
    var expiresStr = message.data["auth-token"]["expires"];
    if (expiresStr != null && expiresStr != "") {
        expires = new Date(expiresStr); // set to datetime obj
    } else {
        // Fallback (backwards compatibility
        var expiresInDaysStr = message.data["auth-token"]["expires-in-days"];
        if (expiresStr != null && expiresStr != "") {
            var expiresInDays = parseInt(expiresInDaysStr);
            expires = expiresInDays; // set to days (number)
        }
    }
    
    $.cookie("AuthTokenHash", message.data["auth-token"]["hash"], { expires: expires, path: '/' });
    $.cookie("AuthTokenCreated", message.data["auth-token"]["created"], { expires: expires, path: '/' });
    $.cookie("AuthTokenExpires", message.data["auth-token"]["expires"], { expires: expires, path: '/' });
    // Trigger events
    for (var i = 0; i < Machinata._onLogins.length; i++) Machinata._onLogins[i]();
};

/// <summary>
/// 
/// </summary>
Machinata.unregisterAuthToken = function () {
    Machinata.debug("unregisterAuthToken");
    $.cookie("AuthTokenHash", null, { path: '/' });
    $.cookie("AuthTokenCreated", null, { path: '/' });
    $.cookie("AuthTokenExpires", null, { path: '/' });
    for (var i = 0; i < Machinata._onLogouts.length; i++) Machinata._onLogouts[i]();
};



/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-content.js */
/* File: js/machinata-core-bundle.js/machinata-core-content.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// CMS Library
/// </summary>
/// <type>namespace</type>
Machinata.Content = {};


/// <summary>
/// </summary>
Machinata.Content.PREVIEW_MAX_IMAGE_SIZE = 200;


/* ======== Machinata Content Editor Class ======== */

/// <summary>
/// </summary>
var ContentEditor = function (elem) {
    // Init
    this.elem = elem;
    this.contentSource = "ContentNode"; // default
    this.uid = ContentEditor._uid++;
    this.elem.attr("editor-uid", this.uid);
    ContentEditor._editors["editor"+this.uid] = this;
};

ContentEditor._uid = 0;
ContentEditor._editors = {};

/// <summary>
/// </summary>
ContentEditor.prototype.debug = function (msg) {
    Machinata.debug("Editor " + this.uid + ": " + msg);
};


/// <summary>
/// Set published state
/// </summary>
ContentEditor.prototype.setNodePublished = function (val) {
    if (val == true) {
        this.elem.find(".publish-toggle.true").addClass("selected");
        this.elem.find(".publish-toggle.false").removeClass("selected");
        this.elem.attr("node-published", "true");
    } else {
        this.elem.find(".publish-toggle.false").addClass("selected");
        this.elem.find(".publish-toggle.true").removeClass("selected");
        this.elem.attr("node-published", "false");
    }
    this.markDirty();
};

/// <summary>
/// Setup content type
/// </summary>
ContentEditor.prototype.setupContentType = function (contentNode) {
    var self = this;
    if (contentNode.length > 1) alert("DO NOT PASS MULTIPLE TO editor.setupContentType");
    if (contentNode.length == 0) alert("NO CONTENT NODE PASSED");
    var nodeType = contentNode.attr("node-type");
    var nodeId = contentNode.attr("node-id");
    var nodeValue = contentNode.attr("node-value");
    this.debug("Setting up content type " + nodeType + "...");
    this.debug("  type: " + nodeType);
    this.debug("  value: " + nodeValue);
    this.debug("  id: " + nodeId);
    contentNode.addClass("type-" + nodeType);
    // Call all binders to see if one can process the type...
    for (var i = 0; i < Machinata._onSetupContentNode.length; i++) {
        Machinata._onSetupContentNode[i](self, contentNode, nodeType, nodeValue);
    }
    // Bind action buttons
    contentNode.find(".action-delete").click(function () {
        self.debug("Removing content node...");
        var translation = contentNode.closest(".content-translation");
        // Last on page?
        var contentCount = contentNode.closest(".page-contents").find(".content-node").length;
        if (contentCount == 1) {
            self.debug("Last content node, will remove translation...");
            self.removeTranslation(translation);
            return;
        }
        // Remove the node
        contentNode.remove();
        // Update buttons
        self.updateContentTypeButtons(translation);
        self.markDirty();
    });
};

/// <summary>
/// Remove translation page
/// </summary>
ContentEditor.prototype.removeTranslation = function (translation) {
    var langID = translation.attr("translation-lang");
    //if (langID == "default") return;
    this.debug("Removing translation " + langID + "...");
    // Remove all content nodes
    translation.find(".content-node").remove();
    // Mark for deletion
    translation.attr("node-delete", "true");
    // Disable button
    var toggleButton = this.elem.find(".language-toggle.lang-" + langID);
    toggleButton.removeClass("enabled");
    toggleButton.hide();
    // Select default language
    this.elem.find(".content-translation").hide();
    this.elem.find(".language-toggle.enabled").first().not(".lang-add").trigger("click");
    this.markDirty();
    this.updateTranslationButtons();
};

ContentEditor.prototype.updateTranslationButtons = function () {
    this.elem.find(".translation-buttons .language-toggle").removeClass("option-first").removeClass("option-last");
    this.elem.find(".translation-buttons .language-toggle.enabled").first().addClass("option-first");
    this.elem.find(".translation-buttons .language-toggle.enabled").last().addClass("option-last");
};

/// <summary>
/// Update the buttons states for content types
/// </summary>
ContentEditor.prototype.updateContentTypeButtons = function (translation) {
    translation.find(".content-type.add-to-page").removeClass("option-first").removeClass("option-last");
    translation.find(".content-type.add-to-page").not(".disabled").each(function () {
        var button = $(this);
        // Validate
        var allowMultiple = button.attr("node-type-allow-multiple");
        if (allowMultiple == "false") {
            var count = translation.find(".content-node.type-" + button.attr("node-type")).length;
            if (count >= 1) button.hide().addClass("max-items");
            else button.show().removeClass("max-items");
        }
    });
    translation.find(".content-type.add-to-page").not(".disabled,.max-items").first().addClass("option-first");
    translation.find(".content-type.add-to-page").not(".disabled,.max-items").last().addClass("option-last");
};

/// <summary>
/// Setup translation page
/// </summary>
ContentEditor.prototype.setupTranslation = function (translation) {
    var self = this;
    var langID = translation.attr("translation-lang");
    this.debug("Setting up translation " + langID + "...");
    // Toggle button
    var toggleButton = this.elem.find(".language-toggle.lang-" + langID).not(".lang-add");
    toggleButton.click(function (e) {
        var button = $(this);
        self.showTranslation(button.attr("translation-lang"), e.shiftKey);
    });
    toggleButton.addClass("enabled");
    toggleButton.show();
    // Set title
    translation.find(".page-title").text(toggleButton.first().text());
    // Setup all content nodes
    translation.find(".content-node").not(".template").each(function () {
        self.setupContentType($(this));
    });
    // Make the nodes sortable
    translation.find(".page-contents").sortable({
        placeholder: "content-node placeholder",
        handle: ".handle"
    });
    // Bind add-to-page buttons
    translation.find(".content-type.add-to-page").each(function () {
        var button = $(this);
        button.click(function () {
            // See if a onAdd event has been registered...
            var didDoOnAdd = false;
            for (var i = 0; i < Machinata._onAddContentNode.length; i++) {
                var ret = Machinata._onAddContentNode[i](self, translation, button.attr("node-type"), button.attr("node-type-title"));
                if (ret == true) didDoOnAdd = true;
            }
            if (didDoOnAdd == true) {
                // On add is responsible
            } else {
                self.addContentType(translation, button.attr("node-type"), button.attr("node-type-title"));
            }
            self.updateContentTypeButtons(translation);
        });
    });
    // Bind translation actions
    translation.find(".delete-translation").click(function () {
        self.removeTranslation(translation);
    });
    translation.find(".duplicate-translation").click(function () {
        // Compile a dialog and ask for new language
        var title = "Duplicate translation";
        var descr = "Choose which new translation to duplicate to:";
        var diag = Machinata.messageDialog(title, descr)
            .cancelButton()
            .okay(function (id) {
                self.copyTranslation(translation.attr("translation-lang"), id);
            });
        self.elem.find(".language-toggle").not(".enabled").each(function () {
            diag.option($(this).text(), $(this).attr("translation-lang"));
        });
        diag.show();
    });
    // Are we only supporting specific types?
    var supportedTypes = this.elem.attr("supported-content-types");
    
    if (supportedTypes != "" && supportedTypes != null && supportedTypes != "*") {
        translation.find(".content-type.add-to-page").hide().addClass("disabled");
        var types = supportedTypes.split(",");
        for (var i = 0; i < types.length; i++) {
            translation.find(".content-type[node-type='" + types[i] + "']").show().removeClass("disabled");
        }
    }
    self.updateContentTypeButtons(translation);
    self.updateTranslationButtons();
    
};


/// <summary>
/// Add content type
/// </summary>
ContentEditor.prototype.addContentType = function (translation, nodeType, typeTitle, nodeValue, nodeOptions) {
    this.debug("Adding content type " + nodeType + "...");
    // Make sure we support it
    var supportedTypes = this.elem.attr("supported-content-types");
    if (supportedTypes != "" && supportedTypes != null && supportedTypes != "*") {
        var types = supportedTypes.split(",");
        var supported = false;
        for (var i = 0; i < types.length; i++) {
            if (types[i] == nodeType) supported = true;
        }
        if (!supported) return;
    }
    // Copy template
    var newContentNode = this.contentNodeTemplate.clone();
    // Modify
    newContentNode.removeClass("template");
    newContentNode.removeClass("hidden-content");
    newContentNode.find(".content-type .node-type").text(typeTitle);
    newContentNode.attr("node-type", nodeType);
    if (nodeValue != null) newContentNode.attr("node-value", nodeValue);
    if (nodeOptions != null) newContentNode.attr("node-options", nodeOptions);
    // Append
    this.setupContentType(newContentNode);
    translation.find(".page-contents").append(newContentNode);
    translation.find(".page-contents").sortable('refresh');
    this.markDirty();
};


/// <summary>
/// 
/// </summary>
ContentEditor.prototype.copyTranslation = function (currentLangID, newLangID) {
    this.debug("Copying translation " + currentLangID + " to translation " + newLangID + "...");
    var self = this;
    // Snapshot data
    var json = this.compileContentAsJSON();
    // Create new translation node
    var newTranslationNode = this.createTranslation(newLangID);
    this.setupTranslation(newTranslationNode);
    // Create a copy of all the content nodes
    var currentTranslation = this.elem.find(".content-translation.lang-" + currentLangID);
    var currentTranslationData = null;
    for (var i = 0; i < json["translations"].length; i++) {
        if (json["translations"][i]["lang"] == currentLangID) currentTranslationData = json["translations"][i];
    }
    for (var i = 0; i < currentTranslationData["nodes"].length; i++) {
        var node = currentTranslationData["nodes"][i];
        var typeTitle = newTranslationNode.find(".content-type.add-to-page[node-type='" + node["type"] + "']").attr("node-type-title");
        self.addContentType(newTranslationNode, node["type"], typeTitle, node["data"], node["options"]);
        
    }
    // Show
    //this.setupTranslation(newTranslationNode);
    this.showTranslation(newLangID);
    this.updateTranslationButtons();
    this.markDirty();
};

/// <summary>
/// 
/// </summary>
ContentEditor.prototype.createTranslation = function (langID) {
    this.debug("Creating translation " + langID + "...");
    // Validate...
    // Supported?
    if (this.elem.find(".language-toggle.lang-" + langID).length == 0) {
        Machinata.apiError("invalid-language", "This language is not supported on your system.");
        return;
    }
    // Already exist?
    if (this.elem.find(".content-translation.lang-" + langID).length > 0) {
        var existingTranslation = this.elem.find(".content-translation.lang-" + langID);
        if (existingTranslation.attr("node-delete") == "true") {
            // We previously deleted it, so since we are adding it again we can remove this one and start fresh again
            existingTranslation.remove();
        } else {
            Machinata.apiError("language-already-exists", "The language you entered already exists!");
            return;
        }
    }
    // Copy template
    var newTranslationNode = this.translationNodeTemplate.clone();
    // Modify
    newTranslationNode.removeClass("lang-add");
    newTranslationNode.addClass("lang-" + langID);
    newTranslationNode.attr("translation-lang", langID);
    // Append
    this.elem.find(".translations").append(newTranslationNode);
    this.updateTranslationButtons();
    return newTranslationNode;
};

/// <summary>
/// 
/// </summary>
ContentEditor.prototype.addTranslation = function (langID) {
    this.debug("Adding translation " + langID + "...");
    // Create
    var newTranslationNode = this.createTranslation(langID);
    // Show
    this.setupTranslation(newTranslationNode);
    // Default content type?
    if (this.elem.attr("default-content-type") != "") {
        var contentButton = newTranslationNode.find(".content-type.add-to-page[node-type='" + this.elem.attr("default-content-type") + "']");
        contentButton.trigger("click");
    }
    this.showTranslation(langID);
    this.markDirty();
};

/// <summary>
/// 
/// </summary>
ContentEditor.prototype.showTranslation = function (langID, toggle) {
    this.debug((toggle == true ? "Toggling" : "Showing") + " translation " + langID + "...");
    var translation = this.elem.find(".content-translation.lang-" + langID);
    if (toggle == true) {
        // Toggled mode
        this.elem.find(".content-translation").addClass("toggled");
        if (translation.hasClass("visible")) {
            // Make sure this is not the only one
            if (this.elem.find(".content-translation.visible").length == 1) return;
            this.elem.find(".language-toggle.lang-" + langID).removeClass("selected");
            translation.removeClass("visible");
            translation.hide();
        } else {
            this.elem.find(".language-toggle.lang-" + langID).addClass("selected");
            translation.addClass("visible");
            translation.show();
        }
        // Update padding for visible 
        this.elem.find(".content-translation").removeClass("padded");
        this.elem.find(".content-translation.visible").slice(1).addClass("padded");
    } else {
        // Single mode
        this.elem.find(".content-translation").removeClass("toggled").removeClass("padded").removeClass("visible").not(translation).hide();
        this.elem.find(".language-toggle").removeClass("selected");
        this.elem.find(".language-toggle.lang-" + langID).addClass("selected");
        translation.addClass("visible");
        translation.show();
    }

};

/// <summary>
/// 
/// </summary>
ContentEditor.prototype.compileContentAsJSON = function () {
    var self = this;
    // Init data structure
    var data = {};
    var dataDebug = "";
    data.nodeid = self.elem.attr("node-id");
    data.nodepath = self.elem.attr("node-path");
    data.type = "node";
    data["delete"] = self.elem.attr("node-delete"); // Note delete is reserved Ecma keyword
    data.published = self.elem.attr("node-published");
    data.layout = self.elem.attr("node-layout");
    data.options = self.getNodeLayoutOptions();
    data.translations = [];
    // Debug
    dataDebug += "" + "Delete: " + data["delete"] + "\n";
    dataDebug += "" + "Published: " + data.published + "\n";
    // Interate all tranlsations
    self.elem.find(".content-translation").not(".lang-add").each(function () {
        // Init
        var translation = $(this);
        var tranlsationID = translation.attr("node-id");
        var tranlsationLang = translation.attr("translation-lang");
        // Create json data
        var dataTranslation = {};
        dataTranslation.nodeid = tranlsationID;
        dataTranslation.type = "trans";
        dataTranslation.lang = tranlsationLang;
        dataTranslation["delete"] = translation.attr("node-delete");
        dataTranslation.published = translation.attr("node-published");
        dataTranslation.nodes = [];
        // Debug
        Machinata.debug("Comping data for translation " + tranlsationLang + "...");
        dataDebug += "" + "Translation " + tranlsationLang + " (" + tranlsationID + "):\n";
        dataDebug += "  " + "Delete: " + dataTranslation["delete"] + "\n";
        dataDebug += "  " + "Published: " + dataTranslation.published + "\n";
        // Discover all content nodes for this page
        var contentNodes = translation.find(".content-node").not(".lang-add");
        var i = 0;
        contentNodes.each(function () {
            // Init
            var contentNode = $(this);
            var nodeData = contentNode.data("node-value")();
            var nodeSummary = contentNode.data("node-summary")();
            var nodeShortURL = contentNode.data("node-short-url")();
            var nodeTitle = contentNode.data("node-title") ();
            var nodeType = contentNode.attr("node-type");
            var nodeID = contentNode.attr("node-id");
            var nodeOptions = contentNode.attr("node-options");
            // Create json data
            var dataNode = {};
            dataNode.nodeid = nodeID;
            dataNode.type = nodeType;
            dataNode.data = nodeData;
            dataNode.options = nodeOptions;
            dataNode.summary = nodeSummary;
            dataNode.shorturl = nodeShortURL;
            dataNode.title = nodeTitle;
            dataNode.sort = i;
            // Debug
            dataDebug += "  " + "Node " + i + " (" + nodeID + "):\n"
            dataDebug += "  " + "  " + nodeType + "\n";
            dataDebug += "  " + "  " + nodeData + "\n";
            dataDebug += "  " + "  " + nodeSummary + "\n";
            // Register and next
            dataTranslation.nodes.push(dataNode);
            i++;
        });
        // Register
        data.translations.push(dataTranslation);
    });

    //alert(dataDebug);
    //alert(JSON.stringify(data));

    return data;
};

/// <summary>
/// 
/// </summary>
ContentEditor.prototype.markClean = function () {
    this.dirty = false;
};
/// <summary>
/// 
/// </summary>
ContentEditor.prototype.markDirty = function () {
    this.dirty = true;
};

/// <summary>
/// 
/// </summary>
ContentEditor.prototype.getNodeLayout = function () {
    return this.elem.attr("node-layout");
};

/// <summary>
/// 
/// </summary>
ContentEditor.prototype.getNodeLayoutOptions = function () {
    var self = this;
    var layout = self.getNodeLayout();
    var selectedOptions = self.elem.find(".options-buttons[layout-name=\"" + layout + "\"] .option-toggle.selected");
    var ret = {};
    selectedOptions.each(function () {
        ret[$(this).attr("option-name")] = true;
    });
    return ret;
};

/// <summary>
/// 
/// </summary>
ContentEditor.prototype.setNodeLayout = function (layout) {
    var self = this;
    // Update node
    self.elem.attr("node-layout", layout);
    // Update layout UI
    //self.elem.find(".layout-toggle").removeClass("selected");
    //self.elem.find(".layout-toggle[layout-name=\"" + layout + "\"]").addClass("selected");
    self.elem.find(".layout-buttons").val(layout);
    // Update options UI
    var allOptions = self.elem.find(".options-buttons");
    var currentOptions = self.elem.find(".options-buttons[layout-name=\"" + layout + "\"]");
    allOptions.hide();
    currentOptions.show();
    if (currentOptions.find(".option-toggle").length == 0) {
        self.elem.find(".options-ui").hide();
    } else {
        self.elem.find(".options-ui").show();
    }
};

/// <summary>
/// 
/// </summary>
ContentEditor.prototype.save = function () {
    var self = this;
    var progress = Machinata.progressDialog("Saving...");
    progress.show();
    progress.updateProgress(10);
    // Get data
    var compiledData = self.compileContentAsJSON();
    progress.updateProgress(30);
    // Make flat
    var data = {};
    data["content"] = JSON.stringify(compiledData);
    progress.updateProgress(50);
    // Do API call to save
    var call = Machinata.apiCall("/api/admin/content/page/" + self.elem.attr("node-id") + "/save");
    call.data(data);
    // Prepare api call
    call.success(function (message) {
        self.markClean();
        progress.updateProgress(100);
        progress.close();
    })
    call.error(function (message) {
        progress.close();
    });
    call.genericError();
    // Send
    call.send();
    progress.updateProgress(70);
    return call;
};

/// <summary>
/// 
/// </summary>
ContentEditor.prototype.init = function () {
    var self = this;

    // Cache some handles
    self.contentNodeTemplate = self.elem.find(".content-node.template");
    self.translationNodeTemplate = self.elem.find(".content-translation.lang-add");

    // Init some settings
    self.boundToInput = false;
    if (self.elem.attr("editor-bind-to-input") != "") self.boundToInput = true;
    if (self.elem.attr("content-source") != null && self.elem.attr("content-source") != "") self.contentSource = self.elem.attr("content-source");

    // Debug
    self.debug("Creating content editor for node id " + self.elem.attr("node-id") + "...");

    // Bind add lang button
    self.elem.find(".language-toggle.lang-add").addClass("enabled").click(function (event) {
        self.debug("Add Language");
        var button = $(this);
        var title = "Add Translation";
        var descr = "Choose a new translation to add to this page:";
        var doCopy = event.shiftKey;
        var currentLangID = self.elem.find(".language-toggle.selected").first().attr("translation-lang");
        var currentLangTitle = self.elem.find(".language-toggle.selected").first().text();
        if (doCopy) {
            title = "Copy Translation";
            descr = "Choose a new translation to copy from" + " " + currentLangTitle + ":";
            if (self.elem.find(".language-toggle.selected").length > 1) {
                Machinata.apiError("invalid-copy", "Multiple translations are open. You must have only a single translation open to copy it.");
                return;
            }
        }
        // Compile a dialog and ask for new language
        var diag = Machinata.messageDialog(title, descr)
                .cancelButton()
                .okay(function (id) {
                    if (doCopy) {
                        self.copyTranslation(currentLangID,id);
                    } else {
                        self.addTranslation(id);
                    }
                });
        self.elem.find(".language-toggle").not(".enabled").each(function () {
            diag.option($(this).text(), $(this).attr("translation-lang"));
        });
        diag.show();
    });

    // Setup all translations
    var transCount = 0;
    var firstTransLangID = null;
    self.elem.find(".content-translation").not(".lang-add").each(function () {
        if (firstTransLangID == null) firstTransLangID = $(this).attr("translation-lang");
        self.setupTranslation($(this));
        transCount++;
    });

    // No translation? Add default
    //if (transCount == 0 && self.boundToInput) {
    //    self.addTranslation("default");
    //    firstTransLangID = "default";
    //}

    // Is the editor bound to a input?
    if (self.boundToInput) {
        self.elem.find(".save-button").remove();
        self.elem.find(".published-buttons").hide();
        self.elem.find(".remove-if-bound-to-input").remove();
    } else {
        self.elem.find(".show-if-bound-to-input").remove();
    }

    // Bind save button
    //self.elem.find(".save-button").click(function () {
    //    Machinata.saveContentEditor(self);
    //});
    self.elem.closest(".ui-card").find(".ui-toolbar .save-button").click(function () {
        Machinata.saveContentEditor(self);
    });

    // Publish toggle
    self.elem.find(".publish-toggle.true").click(function () {
        self.setNodePublished(true);
    });
    self.elem.find(".publish-toggle.false").click(function () {
        self.setNodePublished(false);
    });

    // Layout selection
    self.elem.find(".layout-buttons").on("change",function () {
        //self.setNodeLayout($(this).attr("layout-name"));
        self.setNodeLayout($(this).val());
    });
    self.setNodeLayout(self.elem.attr("node-layout"));

    // Options toggle
    self.elem.find(".option-toggle").click(function () {
        if ($(this).hasClass("selected")) $(this).removeClass("selected");
        else $(this).addClass("selected");
    });

    // Before unload
    self.dirty = false;
    window.onbeforeunload = function () {
        if (self.dirty == true && self.boundToInput == false) return "{text.unsaved-changes=You have unsaved changes. Are you sure you want to leave the page?";
        else return null;
    }

    // Set initial state
    self.elem.find(".content-translation.hidden-content").hide();
    self.setNodePublished(self.elem.attr("node-published") == "true");
    self.elem.find(".language-toggle").not(".enabled").hide();
    // Show first translation from togglebar (not good since order is not always same)
    //self.elem.find(".language-toggle").not(".lang-add").first().trigger("click");
    // Show first translation supported langs (not good since many people dont see the translations)
    //if (firstTransLangID != null) self.showTranslation(firstTransLangID);
    // Show all enabled langs
    self.elem.find(".language-toggle.enabled").not(".lang-add").each(function () {
        self.showTranslation($(this).attr("translation-lang"),true);
    });
    self.updateTranslationButtons();
    self.elem.show();
    self.markClean();
};





/* ======== Machinata Content ======== */

Machinata._onSetupContentNode = [];

/// <summary>
/// 
/// </summary>
Machinata.onSetupContentNode = function (fn) {
    Machinata._onSetupContentNode.push(fn);
};


Machinata._onAddContentNode = [];

/// <summary>
/// 
/// </summary>
Machinata.onAddContentNode = function (fn) {
    Machinata._onAddContentNode.push(fn);
};

/// <summary>
/// 
/// </summary>
Machinata.setNodeOption = function (contentNode, key, val) {
    var json = contentNode.attr("node-options");
    var obj = {};
    if (json != null && json != "") obj = JSON.parse(json);
    obj[key] = val;
    json = JSON.stringify(obj);
    if (json == "{}") json = "";
    contentNode.attr("node-options", json);
};

/// <summary>
/// 
/// </summary>
Machinata.getNodeOption = function (contentNode,key) {
    var json = contentNode.attr("node-options");
    var obj = {};
    if (json != null && json != "") obj = JSON.parse(json);
    return obj[key];
};

/// <summary>
/// 
/// </summary>
/// <hidden/>
Machinata.onInit(function () {
    
    // Setup our core content node setups
    Machinata.onSetupContentNode(function (editor, contentNode, nodeType, nodeValue) {
        if (contentNode.length > 1) alert("DO NOT PASS MULTIPLE TO Machinata.onSetupContentNode");
        // Default
        contentNode.data("node-value", function () {
            Machinata.debug("    Get default node value for " + nodeType);
            return contentNode.find(".content-value").text();
        });
        contentNode.data("node-summary", function () {
            Machinata.debug("    Get default node summary for " + nodeType);
            return null;
        });
        contentNode.data("node-title", function () {
            Machinata.debug("    Get default node title for " + nodeType);
            return null;
        });
        contentNode.data("node-short-url", function () {
            Machinata.debug("    Get default node short url for " + nodeType);
            return null;
        });
        // HTML node
        if (nodeType == "html") {
            Machinata.debug("Creating HTML notebook...");
            var notebookWrapper = $("<div class='notebook rich-text'></div>");
            notebookWrapper.attr("data-content-source", editor.contentSource);
            notebookWrapper.html(decodeURIComponent(nodeValue));
            contentNode.find(".content-value").addClass("cursor-text");
            contentNode.find(".content-value").append(notebookWrapper);
            // See https://github.com/raphaelcruzeiro/jquery-notebook
            notebookWrapper.notebook({
                autoFocus: false,
                placeholder: null,
                mode: 'multiline', // multiline or inline
                //modifiers: ['bold', 'italic', 'underline', 'h1', 'h2', 'ol', 'ul', 'anchor','image']
            });
            notebookWrapper.on('contentChange', function () {
                editor.markDirty();
            });
            contentNode.data("node-value", function () {
                Machinata.debug("    Get custom nodeValue for " + nodeType + " (notebook id " + notebookWrapper.attr('data-jquery-notebook-id') + ")");
                // Get the content area html
                var contentArea = $('#jquery-notebook-content-' + notebookWrapper.attr('data-jquery-notebook-id'));
                var html = contentArea.val();
                // Reformat some oddities
                html = html.replaceAll("<p> </p>", "");
                html = html.replaceAll("<h1> </h1>", "");
                html = html.replaceAll("<h2> </h2>", "");
                return encodeURIComponent(html);
            });
            contentNode.data("node-summary", function () {
                if (notebookWrapper.children().length == 0) {
                    return notebookWrapper.text();
                }
                var summary = "";
                notebookWrapper.children().each(function () {
                    //TODO: @dan .text() is not returning line breaks, we probably need to create our own method to do this
                    summary += $(this).text() + "\n";
                });
                return summary;
            });
        } else if (nodeType == "image" || nodeType == "thumb") {
            Machinata.debug("Creating Image/Thumbnail node...");
            var contentValElem = contentNode.find(".content-value");
            var imageElem = $("<img/>");
            imageElem.attr("src", nodeValue);
            contentValElem.addClass("cursor-pointer").addClass("checkered");
            imageElem.click(function () {
                Machinata.fileDialog("Choose a Image", editor.contentSource, "image")
                .okay(function (val) {
                    imageElem.attr("src", val);
                    contentNode.attr("node-value", val);
                    editor.markDirty();
                })
                .show();
            });
            contentValElem.append(imageElem);
            contentValElem.append($("<div class='clear'/>"));
            //contentValElem.append($("<div class='label'>[TRANS:content-type-image-description.en]</div>"));
            contentValElem.append($("<input class='no-ui type-meta description' placeholder=\"Description\"/>"));
            // Load values
            contentNode.find(".description").val(Machinata.getNodeOption(contentNode, "description"));
            contentNode.find(".description").on("change keyup",function () {
                if ($(this).val() != "") $(this).removeClass("faded");
                else $(this).addClass("faded");
            }).trigger("change");
            // Data handler
            contentNode.data("node-value", function () {
                Machinata.setNodeOption(contentNode, "description", contentNode.find(".description").val());
                return contentNode.attr("node-value");
            });
            // Download button
            var downloadButton = $("<button title='Download content' class='ui-button option-small option-translucent option-icon-only node-tools action-download'><svg class='icon icon-download'><use xlink:href='/static/bundle/svg/uikit-icons8win10-bundle.svg?profile=digital&lang=en&theme=uikit&build=941a6590-3a33-4a37-97eb-662c9cabda58#download'></use></svg></button>");
            downloadButton.click(function () {
                Machinata.openPage(contentNode.attr("node-value") + "?download=true");
            });
            contentNode.find(".content-actions").append(downloadButton);
        } else if (nodeType == "video") {
            Machinata.debug("Creating Video node...");
            // Video image / gif
            var imageElem = $("<img/>");
            imageElem.attr("src", nodeValue);
            imageElem.addClass("cursor-pointer");
            imageElem.click(function () {
                Machinata.fileDialog("Choose a Thumbnail", editor.contentSource, "image")
                .okay(function (val) {
                    imageElem.attr("src", val);
                    contentNode.attr("node-value", val);
                    editor.markDirty();
                })
                .show();
            });
            contentNode.find(".content-value").append(imageElem);
            contentNode.find(".content-value").append($("<div class='clear'></div>"));
            // Video files
            function createVideoFileUI(filetype) {
                var fileMP4 = Machinata.getNodeOption(contentNode, filetype);
                var fileTitle = filetype.toUpperCase();
                var fileElemMP4 = Machinata.createFilePreview(fileMP4 == null ? fileTitle : fileMP4, fileTitle, false);
                fileElemMP4.addClass("cursor-pointer");
                fileElemMP4.click(function () {
                    Machinata.fileDialog("Choose a Video (" + filetype + ")", editor.contentSource, "video/" + filetype)
                    .okay(function (val) {
                        if (val == "delete") return;
                        Machinata.updateFilePreview(fileElemMP4, val, fileTitle, false);
                        Machinata.setNodeOption(contentNode, filetype, val);
                        editor.markDirty();
                    })
                    .button("Remove", "delete", function () {
                        Machinata.updateFilePreview(fileElemMP4, fileTitle, fileTitle, false);
                        Machinata.setNodeOption(contentNode, filetype, null);
                        editor.markDirty();
                    })
                    .show();
                });
                contentNode.find(".content-value").append(fileElemMP4);
            }
            createVideoFileUI("mp4");
            createVideoFileUI("webm");
            createVideoFileUI("ogv");
            contentNode.data("node-value", function () {
                // Re-calculate aspect ratio
                var ar = imageElem.width() / imageElem.height();
                Machinata.setNodeOption(contentNode, "aspectratio", ar);
                return contentNode.attr("node-value");
            });
        } else if (nodeType == "file") {
            Machinata.debug("Creating File node...");
            var fileElem = Machinata.createFilePreview(nodeValue, nodeValue, false);
            var contentValElem = contentNode.find(".content-value");
            fileElem.addClass("cursor-pointer");
            fileElem.click(function () {
                Machinata.fileDialog("Choose a File", editor.contentSource)
                .okay(function (val) {
                    Machinata.updateFilePreview(fileElem, val, val, false);
                    contentNode.attr("node-value", val);
                    editor.markDirty();
                })
                .show();
            });
            contentValElem.append(fileElem);
            contentValElem.append($("<div class='clear'/>"));
            contentValElem.append($("<input class='no-ui type-meta title' placeholder=\"Title\"/>"));
            // Load values
            contentNode.find("input.title").val(Machinata.getNodeOption(contentNode, "title"));
            contentNode.find("input.title").on("change keyup", function () {
                if ($(this).val() != "") $(this).removeClass("faded");
                else $(this).addClass("faded");
            }).trigger("change");
            // Data handler
            contentNode.data("node-value", function () {
                Machinata.setNodeOption(contentNode, "title", contentNode.find("input.title").val());
                return contentNode.attr("node-value");
            });
            // Download button
            var downloadButton = $("<button title='Download content' class='ui-button option-small option-translucent option-icon-only node-tools action-download'><svg class='icon icon-download'><use xlink:href='/static/bundle/svg/uikit-icons8win10-bundle.svg?profile=digital&lang=en&theme=uikit&build=941a6590-3a33-4a37-97eb-662c9cabda58#download'></use></svg></button>");
            downloadButton.click(function () {
                Machinata.openPage(contentNode.attr("node-value")+"?download=true");
            });
            contentNode.find(".content-actions").append(downloadButton);
        } else if (nodeType == "title") {
            Machinata.debug("Creating title node...");
            var inputElem = $("<input class='no-ui type-title'/>");
            inputElem.val(nodeValue);
            inputElem.on("change keyup", function () { editor.markDirty(); });
            contentNode.find(".content-value").append(inputElem);
            contentNode.data("node-value", function () {
                return contentNode.find(".content-value input").val();
            });
            contentNode.data("node-title", function () {
                return contentNode.find(".content-value input").val();
            });
        } else if (nodeType == "embed") {
            Machinata.debug("Creating embed node...");
            var inputElem = $("<textarea class='no-ui type-embed'/>");
            var embedCode = decodeURIComponent(nodeValue);
            var lines = embedCode.split('\n').length;
            inputElem.attr("rows", Math.max(lines, 4));
            inputElem.val(embedCode);
            inputElem.on("change keyup", function () { editor.markDirty(); });
            contentNode.find(".content-value").append(inputElem);
            contentNode.data("node-value", function () {
                var html = contentNode.find(".content-value textarea").val();
                return encodeURIComponent(html);
            });
        } else if (nodeType == "label") {
            Machinata.debug("Creating label node...");
            var inputElem = $("<input class='no-ui type-label'/>");
            inputElem.val(nodeValue);
            inputElem.on("change keyup", function () { editor.markDirty(); });
            contentNode.find(".content-value").append($("<div class='label'>Label</div>")).append(inputElem);
            contentNode.data("node-value", function () {
                return contentNode.find(".content-value input").val();
            });
        } else if (nodeType == "shorturl") {
            Machinata.debug("Creating shorturl node...");
            var inputElem = $("<input class='no-ui type-shorturl'/>");
            inputElem.val(nodeValue);
            inputElem.on("change keyup", function () { editor.markDirty(); });
            contentNode.find(".content-value").append($("<div class='label'>Page URL</div>")).append(inputElem);
            contentNode.data("node-value", function () {
                return contentNode.find(".content-value input").val();
            });
            contentNode.data("node-short-url", function () {
                return contentNode.find(".content-value input").val();
            });
        } else if (nodeType == "option") {
            Machinata.debug("Creating option node...");
            var inputElem = $("<input class='no-ui type-option'/>");
            inputElem.val(nodeValue);
            inputElem.on("change keyup", function () { editor.markDirty(); });
            contentNode.find(".content-value").append($("<div class='label'>Option</div>"));
            contentNode.find(".content-value").append(inputElem);
            contentNode.data("node-value", function () {
                return contentNode.find(".content-value input").val();
            });
        } else if (nodeType == "meta") {
            Machinata.debug("Creating meta node...");
            // Create all meta attribs
            var contentValElem = contentNode.find(".content-value");
            contentValElem.append($("<div class='label'>Title</div>")).append($("<input class='no-ui type-meta meta-title'/>"));
            contentValElem.append($("<div class='label'>Description</div>")).append($("<input class='no-ui type-meta meta-description'/>"));
            contentValElem.append($("<div class='label'>Keywords</div>")).append($("<input class='no-ui type-meta meta-keywords'/>"));
            contentValElem.append($("<div class='label'>Image</div>")).append($("<img class='no-ui cursor-pointer checkered type-meta meta-image'/>"));
            // Load values
            contentNode.find(".meta-title").val(Machinata.getNodeOption(contentNode, "meta-title"));
            contentNode.find(".meta-description").val(Machinata.getNodeOption(contentNode, "meta-description"));
            contentNode.find(".meta-keywords").val(Machinata.getNodeOption(contentNode, "meta-keywords"));
            // Bind image
            function updateImage(propName) {
                var imageSRC = Machinata.getNodeOption(contentNode, "meta-"+propName);
                if (imageSRC == null) imageSRC = "";
                console.log(imageSRC);
                contentNode.find(".meta-" + propName).attr("src", imageSRC);
            }
            updateImage("image");
            contentNode.find(".meta-image").click(function () {
                Machinata.fileDialog("Choose a Image", editor.contentSource, "image")
                .okay(function (val) {
                    Machinata.setNodeOption(contentNode, "meta-image", val);
                    updateImage("image");
                    editor.markDirty();
                })
                .show();
            });
            // Bind changes
            contentNode.find("input").on("change keyup", function () { editor.markDirty(); });
            // Value/option functions
            contentNode.data("node-value", function () {
                Machinata.setNodeOption(contentNode, "meta-title", contentNode.find(".meta-title").val());
                Machinata.setNodeOption(contentNode, "meta-description", contentNode.find(".meta-description").val());
                Machinata.setNodeOption(contentNode, "meta-keywords", contentNode.find(".meta-keywords").val());
                return null;
            });
        } else if (nodeType == "product") {
            Machinata.debug("Creating Product node...");
            // Create preview
            var previewElem = Machinata.createGenericPreview(
                Machinata.getNodeOption(contentNode, "product-name"), 
                Machinata.getNodeOption(contentNode, "catalog-name"),
                null,
                "[TRANS:product.en]",
                "tag",
                "product"
            );
            var contentValElem = contentNode.find(".content-value");
            previewElem.addClass("cursor-pointer");
            // Show product browser on click
            previewElem.click(function () {
                var diag = Machinata.productDialog("Choose a Product");
                diag.input(function (data) {
                    // Product was selected, update node options
                    Machinata.setNodeOption(contentNode, "product-name", data["product-name"]);
                    Machinata.setNodeOption(contentNode, "product-public-id", data["product-public-id"]);
                    Machinata.setNodeOption(contentNode, "config-public-id", data["config-public-id"]);
                    Machinata.setNodeOption(contentNode, "catalog-name", data["catalog-name"]);
                    Machinata.setNodeOption(contentNode, "catalog-short-url", data["catalog-short-url"]);
                    Machinata.setNodeOption(contentNode, "catalog-public-id", data["catalog-public-id"]);
                    // Update preview
                    Machinata.updateGenericPreview(
                        previewElem,
                        data["product-name"],
                        data["catalog-name"]
                    );
                    // Set node value
                    contentNode.attr("node-value", data["product-public-id"]);
                    editor.markDirty();
                });
                diag.show();
            });
            contentValElem.append(previewElem);

            // Data handler
            contentNode.data("node-title", function () {
                return Machinata.getNodeOption(contentNode, "product-name");
            });
            contentNode.data("node-value", function () {
                return contentNode.attr("node-value");
            });
        } else if (nodeType == "link") {
            Machinata.debug("Creating link node...");
            var inputElem = $("<input class='no-ui no-padding link-url'/>");
            inputElem.val(nodeValue);
            contentNode.find(".content-value").append($("<div class='label'>URL</div>"));
            contentNode.find(".content-value").append(inputElem);
            contentNode.find(".content-value").append($("<div class='label'>Title</div>"));
            contentNode.find(".content-value").append($("<input class='no-ui no-padding link-title'/>"));
            contentNode.find(".content-value input.link-title").val(Machinata.getNodeOption(contentNode, "title"));
            contentNode.find(".content-value input").on("change keyup", function () { editor.markDirty(); });
            contentNode.data("node-value", function () {
                Machinata.setNodeOption(contentNode, "title", contentNode.find("input.link-title").val());
                return contentNode.find(".content-value input.link-url").val();
            });
        } else if (nodeType == "quote") {
            Machinata.debug("Creating quote node...");
            var inputElem = $("<input class='no-ui no-padding quote-text'/>");
            inputElem.val(nodeValue);
            contentNode.find(".content-value").append($("<div class='label'>Text</div>"));
            contentNode.find(".content-value").append(inputElem);
            contentNode.find(".content-value").append($("<div class='label'>Author</div>"));
            contentNode.find(".content-value").append($("<input class='no-ui no-padding quote-author'/>"));
            contentNode.find(".content-value").append($("<div class='label'>Title</div>"));
            contentNode.find(".content-value").append($("<input class='no-ui no-padding quote-title'/>"));
            contentNode.find(".content-value input.quote-author").val(Machinata.getNodeOption(contentNode, "author"));
            contentNode.find(".content-value input.quote-title").val(Machinata.getNodeOption(contentNode, "title"));
            contentNode.find(".content-value input").on("change keyup", function () { editor.markDirty(); });
            contentNode.data("node-value", function () {
                Machinata.setNodeOption(contentNode, "author", contentNode.find("input.quote-author").val());
                Machinata.setNodeOption(contentNode, "title", contentNode.find("input.quote-title").val());
                return contentNode.find(".content-value input.quote-text").val();
            });
        }  else if (nodeType == "button") {
            Machinata.debug("Creating button node...");
            var inputElem = $("<input class='no-ui no-padding link-url'/>");
            inputElem.val(nodeValue);
            contentNode.find(".content-value").append($("<div class='label'>Action</div>"));
            contentNode.find(".content-value").append(inputElem);
            contentNode.find(".content-value").append($("<div class='label'>Title</div>"));
            contentNode.find(".content-value").append($("<input class='no-ui no-padding link-title'/>"));
            contentNode.find(".content-value input.link-title").val(Machinata.getNodeOption(contentNode, "title"));
            contentNode.find(".content-value input").on("change keyup", function () { editor.markDirty(); });
            contentNode.data("node-value", function () {
                Machinata.setNodeOption(contentNode, "title", contentNode.find("input.link-title").val());
                return contentNode.find(".content-value input.link-url").val();
            });
        } else if (nodeType == "desc") {
            Machinata.debug("Creating description node...");
            var inputElem = $("<input class='no-ui type-description'/>");
            inputElem.val(nodeValue);
            inputElem.on("change keyup", function () { editor.markDirty(); });
            contentNode.find(".content-value").append(inputElem);
            contentNode.data("node-value", function () {
                return contentNode.find(".content-value input").val();
            });
            }
    });

    // Setup our core content node setups
    Machinata.onAddContentNode(function (editor, translation, nodeType, nodeTitle) {
        if (nodeType == "image" || nodeType == "thumb") {
            Machinata.fileDialog("Choose a Image", editor.contentSource, "image")
                .okay(function (val) {
                    editor.addContentType(translation, nodeType, nodeTitle, val)
                })
                .show();
            return true;
        } else if (nodeType == "video") {
            Machinata.fileDialog("Choose a Thumbnail", editor.contentSource, "image")
                .okay(function (val) {
                    editor.addContentType(translation, nodeType, nodeTitle, val)
                })
                .show();
            return true;
        } else if (nodeType == "file") {
            Machinata.fileDialog("Choose a File", editor.contentSource)
                .okay(function (val) {
                    editor.addContentType(translation, nodeType, nodeTitle, val)
                })
                .show();
            return true;
        }
        return false;
    });

    // Auto-init all content editor nodes
    $(".ui-content-editor").each(function () {
        var editor = new ContentEditor($(this));
        editor.init();
    });

});


/// <summary>
///
/// </summary>
Machinata.getContentEditor = function (elem) {
    var key = "editor" + elem.attr("editor-uid");
    return ContentEditor._editors[key];
};

/// <summary>
///
/// </summary>
Machinata.saveContentEditor = function (editor) {
    editor.save();
};



/// <summary>
///
/// </summary>
Machinata.createPagePreview = function (path, title, summary) {
    // Sanity
    var icon = "document";
    // Create the elem
    var previewElem = $("<div class='file-preview'/>");
    previewElem.attr("node-path", path);
    var pathElem = $("<div class='path'/>");
    pathElem.text(title);
    previewElem.append(pathElem);
    var iconElem = $("<div class='icon icon-" + icon + "'/>");
    previewElem.append(iconElem);
    previewElem.addClass("category-page");
    previewElem.attr("title", title);
    // Return
    return previewElem;
};

/// <summary>
///
/// </summary>
Machinata.createGenericPreview = function (name, title, subtitle, type, icon, category) {

    // Create the elem
    var previewElem = $("<div class='file-preview ui-file-preview'/>");
    var metaElem = $("<div class='meta'/>");
    metaElem.append($("<div class='meta-name'/>").text(name));
    metaElem.append($("<div class='meta-title'/>").text(title));
    metaElem.append($("<div class='meta-subtitle'/>").text(subtitle));
    previewElem.append(metaElem);
    var iconElem = $("<div class='icon icon-" + icon + "'/>");
    previewElem.append(iconElem);
    var tagElem = $("<div class='tag'/>").text(type);
    previewElem.append(tagElem);
    previewElem.addClass("category-" + category);
    previewElem.attr("title", title);
    // Return
    return previewElem;
};

/// <summary>
///
/// </summary>
Machinata.updateGenericPreview = function (previewElem, name, title, subtitle, type, icon, category) {
    // Update
    if (name != null) previewElem.find(".meta-name").text(name);
    if (title != null) previewElem.find(".meta-title").text(title);
    if (subtitle != null) previewElem.find(".meta-subtitle").text(subtitle);
    // Return
    return previewElem;
};


/// <summary>
///
/// </summary>
Machinata.updateFilePreview = function (previewElem, contentURL, title, autoDetectImages) {
    // Is it an image?
    var isImage = false;
    if (contentURL.endsWith(".png")) isImage = true;
    else if (contentURL.endsWith(".jpg")) isImage = true;
    else if (contentURL.endsWith(".gif")) isImage = true;
    else if (contentURL.endsWith(".tiff")) isImage = true;
    var icon = "document"; // fallback
    if (isImage == true) icon = "image";
    else if (contentURL.endsWith(".pdf")) icon = "document-text";
    else if (contentURL.endsWith(".doc")) icon = "document-text";
    else if (contentURL.endsWith(".docx")) icon = "document-text";
    else if (contentURL.endsWith(".rtf")) icon = "document-text";
    else if (contentURL.endsWith(".txt")) icon = "document-text";
    else if (contentURL.endsWith(".zip")) icon = "briefcase";
    else if (contentURL.endsWith(".ppt")) icon = "device-desktop";
    else if (contentURL.endsWith(".pptx")) icon = "device-desktop";
    else if (contentURL.endsWith(".mp4")) icon = "video-outline";
    else if (contentURL.endsWith(".mov")) icon = "video-outline";
    else if (contentURL.endsWith(".3gp")) icon = "video-outline";
    else if (contentURL.endsWith(".webm")) icon = "video-outline";
    else if (contentURL.endsWith(".avi")) icon = "video-outline";
    // Update
    previewElem.html("");
    previewElem.attr("content-url", contentURL);

    var filename = contentURL.substring(contentURL.lastIndexOf('/') + 1, contentURL.length) || contentURL;
    var ext = contentURL.substring(contentURL.lastIndexOf('.') + 1, contentURL.length) || contentURL;
    var metaElem = $("<div class='meta'/>");
    metaElem.append($("<div class='meta-name'/>").text(filename));
    previewElem.append(metaElem);
    var tagElem = $("<div class='tag'/>").text(ext);
    previewElem.append(tagElem);
    if (isImage && autoDetectImages) {
        var imageElem = $("<div class='image'/>");
        imageElem.css("background-image", "url('" + contentURL + "?size=" + Machinata.Content.PREVIEW_MAX_IMAGE_SIZE + "')");
        previewElem.append(imageElem);
        previewElem.addClass("category-image");
    } else {
        previewElem.addClass("category-other");
    }
    //previewElem.attr("title", title);
    // Return
    return previewElem;
};


/// <summary>
///
/// </summary>
Machinata.createFilePreview = function (contentURL, title, autoDetectImages) {
    // Sanity
    if (contentURL == null) return null;
    // Create the elem
    var previewElem = $("<div class='file-preview ui-file-preview'/>");
    return Machinata.updateFilePreview(previewElem, contentURL, title, autoDetectImages);
};






/* ======== Machinata Content Editor Frontned ======== */

Machinata.FrontendContentEditor = {};


Machinata.FrontendContentEditor.bind = function (elements) {
    var elems = elements.find("[data-node-path]");
    elems.hover(function () {
        // Hover in
        var elem = $(this);
        // Remove all other
        $(".content-node-overlay").remove();
        // Create clone overlay
        var position = elem.offset();
        var useNativePositionCalculation = false;
        if (useNativePositionCalculation) {
            var bodyRect = document.body.getBoundingClientRect();
            var elemRect = elem[0].getBoundingClientRect();
            position.top = elemRect.top - bodyRect.top;
            position.left = elemRect.left - bodyRect.left;
        }
        var overlayElem = $("<div></div>");
        overlayElem.addClass("content-node-overlay");
        overlayElem.css("position", "absolute");
        overlayElem.css("background-color", "rgba(0,0,0,0.2)");
        overlayElem.css("width", elem.outerWidth() + "px");
        overlayElem.css("height", elem.outerHeight() + "px");
        overlayElem.css("pointer-events", "none");
        overlayElem.css("box-sizing", "border-box");
        overlayElem.css("border", "3px dotted black");
        overlayElem.css({ top: position.top, left: position.left });
        // Meta infos and link
        var metaElem = $("<div><a></a></div>");
        var metaElemA = metaElem.find("a");
        metaElemA.text(elem.attr("data-node-path"));
        metaElemA.css("color", "white");
        metaElemA.css("background-color", "rgba(0,0,0,0.6)");
        metaElemA.css("font-weight", "bold");
        metaElemA.css("font-size", "10px");
        metaElemA.css("padding", "3px");
        metaElemA.css("pointer-events", "all");
        metaElemA.attr("href", "/admin/content/page/" + elem.attr("data-node-path"));
        metaElemA.attr("target", "_blank");
        overlayElem.append(metaElem)
        // Register
        elem.data("content-node-overlay", overlayElem);
        $("body").append(overlayElem);
    }, function () {
        /*// Hover out
        var elem = $(this);
        // Remove overlay
        var overlayElem = elem.data("content-node-overlay");
        if(overlayElem != null) overlayElem.remove();*/
    });
};

Machinata.ready(function () {
    if (Machinata.Params.string("edit") == "true") {
        // Bind the frontend editor
        Machinata.FrontendContentEditor.bind($("body"));
        // Do we have a node path to find?
        if (Machinata.Params.string("node-path") != null) {
            var elem = $("[data-node-path='" + Machinata.Params.string("node-path") + "'");
            Machinata.UI.scrollTo(elem);
        }
    }
});

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-responsive.js */
/* File: js/machinata-core-bundle.js/machinata-core-responsive.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// An extensive library for handling responsive UI layouts using paremeterized
/// and easy to use attributes in markup.
/// Currently, this implementation uses inline attributes on responsive elements, however
/// it would be easily ported to use CSS in the document head.
///
/// To quickly force an update of responsive elements, use 
///    Machinata.Responsive.updateResponsiveElements();
/// </summary>
/// <type>namespace</type>
Machinata.Responsive = {};

/// <summary>
/// 
/// </summary>
Machinata.DISABLE_CORE_RESPONSIVE = false;

/// <summary>
/// 
/// </summary>
Machinata.Responsive.definitions = [];

/// <summary>
/// 
/// </summary>
Machinata.Responsive.media = [];

/// <summary>
/// 
/// </summary>
Machinata.Responsive.responsiveIds = {};

/// <summary>
/// 
/// </summary>
Machinata.Responsive.containerElem = null;

/// <summary>
/// 
/// </summary>
Machinata.Responsive.VIEWPORT_MAX_WIDTH_MOBILE = 580;

/// <summary>
/// 
/// </summary>
Machinata.Responsive.VIEWPORT_MAX_WIDTH_TABLET = 900;

/// <summary>
/// 
/// </summary>
Machinata.Responsive.FORCE_LAYOUT = null;

/// <summary>
/// 
/// </summary>
Machinata.Responsive.DATAURL_TRANSPARENT_GIF = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

/// <summary>
/// 
/// </summary>
Machinata.Responsive.SNAP_TO_GRID = null;

/// <summary>
/// 
/// </summary>
Machinata.Responsive.currentLayout = "desktop";

/// <summary>
/// 
/// </summary>
Machinata.Responsive.verboseDebug = false;

/// <summary>
/// 
/// </summary>
Machinata.Responsive.isDesktopLayout = function () {
    return Machinata.Responsive.currentLayout == "desktop";
};

/// <summary>
/// 
/// </summary>
Machinata.Responsive.isMobileLayout = function () {
    return Machinata.Responsive.currentLayout == "mobile";
};

/// <summary>
/// 
/// </summary>
/// <hidden/>
Machinata.Responsive._onLayoutChange = [];

/// <summary>
/// 
/// </summary>
Machinata.Responsive.onLayoutChange = function (fn) {
    Machinata.Responsive._onLayoutChange.push(fn);
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Responsive._onResize = [];

/// <summary>
/// 
/// </summary>
Machinata.Responsive.onResize = function (fn) {
    Machinata.Responsive._onResize.push(fn);
};


/// <summary>
/// </summary>
/// <hidden/>
Machinata.Responsive._onResized = [];

/// <summary>
/// 
/// </summary>
Machinata.Responsive.onResized = function (fn) {
    Machinata.Responsive._onResized.push(fn);
};

/// <summary>
/// 
/// </summary>
Machinata.Responsive.bindCoverImages = function (elements) {
    if (Machinata.DISABLE_CORE_RESPONSIVE == true) return;

    // Coverize images
    elements.find(".bb-cover-images img").addClass("bb-ui-bound").each(function () {
        var img = $(this);
        var src = img.attr("src");
        img.css("background-size", "cover");
        img.css("background-position", "50% 50%");
        img.css("background-image", "url(\"" + src + "\")");
        img.attr("src", Machinata.Responsive.DATAURL_TRANSPARENT_GIF);
    });
};

/// <summary>
/// 
/// </summary>
/// <hidden/>
Machinata.Responsive._registerResponsiveDefinition = function (definition) {

    if (definition.globalSelector == null) definition.globalSelector = true;

    function preparseDefinitionParam(name) {

        // Validate null
        if (definition[name] == null) definition[name] = {};
        // Validate if it is a shorthand definition
        else if ($.type(definition[name]) === "string") {
            var defaultVal = definition[name];
            definition[name] = {};
            definition[name]["default"] = defaultVal;
        }
        // Validate further shortcuts...
        if (definition[name + "-mobile"] != null) definition[name]["mobile"] = definition[name + "-mobile"]
        if (definition[name + "-tablet"] != null) definition[name]["tablet"] = definition[name + "-tablet"]
        if (definition[name + "-desktop"] != null) definition[name]["desktop"] = definition[name + "-desktop"]
        // Process replacement variables
        definition[name]["default"] = Machinata.Responsive._preparseSizeAttribute(definition[name]["default"]);
        definition[name]["mobile"] = Machinata.Responsive._preparseSizeAttribute(definition[name]["mobile"]);
        definition[name]["tablet"] = Machinata.Responsive._preparseSizeAttribute(definition[name]["tablet"]);
        definition[name]["desktop"] = Machinata.Responsive._preparseSizeAttribute(definition[name]["desktop"]);
        
    }
    // Max
    preparseDefinitionParam("max-width");
    preparseDefinitionParam("max-height");
    // Min
    preparseDefinitionParam("min-width");
    preparseDefinitionParam("min-height");
    // Top/Left
    preparseDefinitionParam("top");
    preparseDefinitionParam("left");
    // Margins
    preparseDefinitionParam("margin-left");
    preparseDefinitionParam("margin-right");
    // Aspect ratio
    preparseDefinitionParam("aspect-ratio");
    // Cover
    preparseDefinitionParam("cover");
    // Font size
    preparseDefinitionParam("font-size");

    Machinata.Responsive.definitions.push(definition);

};

/// <summary>
/// 
/// </summary>
Machinata.Responsive.registerResponsiveDefinitions = function (definitions) {

    for (var i = 0; i < definitions.length; i++) {
        var definition = definitions[i];
        Machinata.Responsive._registerResponsiveDefinition(definition);
    }

    Machinata.Responsive.detectNewResponsiveElements();
    Machinata.Responsive.updateResponsiveElements();

};

/// <summary>
/// 
/// </summary>
Machinata.Responsive.bindResponsiveElements = function (elements) {
    if (Machinata.DISABLE_CORE_RESPONSIVE == true) return;

    // Helper function for transposing the attributes to the definition structure:
    function populateDefinitionParamsForAttribute(name, elem, definition) {
        definition[name] = {};
        definition[name]["default"]     = elem.attr("responsive-" + name);
        definition[name]["mobile"]      = elem.attr("responsive-" + name + "-mobile");
        definition[name]["tablet"]      = elem.attr("responsive-" + name + "-tablet");
        definition[name]["desktop"]     = elem.attr("responsive-" + name + "-desktop");
    }

    elements.find(".bb-responsive").addClass("bb-ui-bound").each(function () {
        // Init
        var elem = $(this);
        // Do we have a ID?
        var responsiveId = elem.attr("responsive-id");
        if (!String.isEmpty(responsiveId)) {
            // Only process the element if it is unqiue id (ie, don't do the id's twice)
            if (Machinata.Responsive.responsiveIds[responsiveId] != null) return;
            // Register the id
            Machinata.Responsive.responsiveIds[responsiveId] = elem;
        }
        // Cached data?
        var definition = jQuery.data(elem, "responsive-definition");
        if (definition == null) {
            // Init
            definition = {};
            // Get selector
            //definition.self = elem; //TODO
            definition.bindingElem = elem; //TODO
            definition.selector = elem.attr("responsive-selector");
            if (definition.selector == "") definition.selector = null;
            if (elem.attr("responsive-global") == "true") definition.globalSelector = true;
            else definition.globalSelector = false;
            // Get elems
            definition.elems = null;
            // Max
            populateDefinitionParamsForAttribute("max-width", elem, definition);
            populateDefinitionParamsForAttribute("max-height", elem, definition);
            // Min
            populateDefinitionParamsForAttribute("min-width", elem, definition);
            populateDefinitionParamsForAttribute("min-height", elem, definition);
            // Top/Left
            populateDefinitionParamsForAttribute("top", elem, definition);
            populateDefinitionParamsForAttribute("left", elem, definition);
            // Margins
            populateDefinitionParamsForAttribute("margin-left", elem, definition);
            populateDefinitionParamsForAttribute("margin-right", elem, definition);
            // Aspect ratio
            populateDefinitionParamsForAttribute("aspect-ratio", elem, definition);
            // Cover
            populateDefinitionParamsForAttribute("cover", elem, definition);
            // Font size
            populateDefinitionParamsForAttribute("font-size", elem, definition);
            // Update
            jQuery.data(elem, "responsive-definition", definition);

        }
        // Register elemenet
        Machinata.Responsive._registerResponsiveDefinition(definition);
    });

    Machinata.Responsive.detectNewResponsiveElements();
    Machinata.Responsive.updateResponsiveElements();
};




/// <summary>
/// 
/// </summary>
Machinata.Responsive.bindResponsiveMedia = function (elements) {
    if (Machinata.DISABLE_CORE_RESPONSIVE == true) return;

    function convertAttributeToData(elem, name) {
        elem.data(name+"-default", elem.attr("data-"+name+"-default"));
        if (elem.data(name + "-default") == null) elem.data(name+"-default", elem.attr(name));
        elem.data(name + "-mobile", elem.attr("data-" + name + "-mobile"));
        elem.data(name + "-desktop", elem.attr("data-" + name + "-desktop"));
        elem.data(name + "-tablet", elem.attr("data-" + name + "-tablet"));
    }
    elements.find(".bb-responsive-media").addClass("bb-ui-bound").each(function () {
        // Init
        var elem = $(this);
        // Cache settings
        convertAttributeToData(elem, "style");
        convertAttributeToData(elem, "src");
        // Register elemenet
        Machinata.Responsive.media.push(elem);
    });
    // Monitor layout changes
    Machinata.Responsive.updateResponsiveMedia();
    Machinata.Responsive.onLayoutChange(function () {
        Machinata.Responsive.updateResponsiveMedia();
    });
};

/// <summary>
/// 
/// </summary>
Machinata.Responsive.updateResponsiveMedia = function () {
    // Skip if we have none
    if (Machinata.Responsive.media == null || Machinata.Responsive.media.length == 0) return;
    // Helper function
    function getAttributeForLayout(elem,name) {
        // Get layout specific attribute
        var attr = elem.data(name+"-"+Machinata.Responsive.currentLayout); // style-mobile
        if (attr != null && attr != "") return attr;
        // Get default
        return elem.data("style-default");
    }
    // Process all
    Machinata.debug("Machinata.Responsive: updateResponsiveMedia");
    for (var i = 0; i < Machinata.Responsive.media.length; i++) {
        // Init
        var elem = Machinata.Responsive.media[i];
        // Process style
        var style = getAttributeForLayout(elem, "style");
        if (style != null) {
            Machinata.debug("Machinata.Responsive: swapping media style to "+style);
            elem.attr("style", style);
        }
        // Process src
        var src = getAttributeForLayout(elem, "src");
        if (src != null) {
            Machinata.debug("Machinata.Responsive: swapping media src to " + src);
            elem.attr("src", src);
        }
    }
};




/// <summary>
/// 
/// </summary>
Machinata.Responsive.updateElementsForResponsiveElement = function (definition) {
    if (definition.selector == null) {
        definition.elems = definition.bindingElem; //self
    } else {
        if (definition.globalSelector == true) {
            definition.elems = $(definition.selector);
        } else {
            definition.elems = definition.bindingElem.find(definition.selector);
        }
    }
    return definition.elems;
};


/// <summary>
/// 
/// </summary>
Machinata.Responsive.detectNewResponsiveElements = function () {
    // Skip if we have none
    if (Machinata.Responsive.definitions == null || Machinata.Responsive.definitions.length == 0) return;
    // Process all
    for (var i = 0; i < Machinata.Responsive.definitions.length; i++) {
        //var elem = Machinata.Responsive.definitions[i];
        //var definition = jQuery.data(elem, "responsive-definition");
        var definition = Machinata.Responsive.definitions[i];
        Machinata.Responsive.updateElementsForResponsiveElement(definition);
    }
};


/// <summary>
/// 
/// </summary>
Machinata.Responsive._preparseSizeAttribute = function (attr) {
    if (attr == null || attr == "") return null;
    var ret = attr;
    var useAlternativeWindowHeightForMobiles = false; // Not nice on iOS
    ret = ret.replaceAll("{width}", "elem.width()");
    ret = ret.replaceAll("{height}", "elem.height()");
    ret = ret.replaceAll("{window.width}", "$(window).width()");
    if (useAlternativeWindowHeightForMobiles && Machinata.Device.isMobileOS()) {
        // https://stackoverflow.com/questions/14388367/mobile-safari-window-height-url-bar-discrepancy
        ret = ret.replaceAll("{window.height}", "window.innerHeight");
    } else {
        ret = ret.replaceAll("{window.height}", "$(window).height()");
    }
    ret = ret.replaceAll("{parent.width}", "elem.parent().width()");
    ret = ret.replaceAll("{parent.height}", "elem.parent().height()");
    ret = ret.replaceAll("{parent.floored-width}", "Math.floor(elem.parent().width())");
    ret = ret.replaceAll("{parent.floored-height}", "Math.floor(elem.parent().height())");
    ret = ret.replaceAll("{parent.even-width}", "Machinata.Math.makeEven(elem.parent().width())");
    ret = ret.replaceAll("{parent.even-height}", "Machinata.Math.makeEven(elem.parent().height())");
    ret = ret.replaceAll("{parent.snapped-width}", "Machinata.Math.makeEven(Machinata.Responsive.snapToGrid(elem.parent().width()))");
    ret = ret.replaceAll("{parent.snapped-height}", "Machinata.Math.makeEven(Machinata.Responsive.snapToGrid(elem.parent().height()))");
    ret = ret.replaceAll("{grandparent.width}", "elem.parent().parent().width()");
    ret = ret.replaceAll("{grandparent.height}", "elem.parent().parent().height()");
    ret = ret.replaceAll("{header.width}", "$('#header').width()");
    ret = ret.replaceAll("{header.height}", "$('#header').height()");
    ret = ret.replaceAll("{footer.width}", "$('#footer').width()");
    ret = ret.replaceAll("{footer.height}", "$('#footer').height()");
    ret = ret.replaceAll("{container.width}", "$('#container').width()");
    ret = ret.replaceAll("{container.height}", "$('#container').height()");
    ret = ret.replaceAll("{body.width}", "$('body').width()");
    ret = ret.replaceAll("{body.height}", "$('body').height()");
    return ret;
};



/// <summary>
/// 
/// </summary>
Machinata.Responsive.snapToGrid = function (val) {
    if (Machinata.Responsive.SNAP_TO_GRID != null) {
        val = Math.floor(val);
        return val - (val % Machinata.Responsive.SNAP_TO_GRID);
    } else {
        return val;
    }
};


/// <summary>
/// 
/// </summary>
Machinata.Responsive.getCSSStyleForAttribute = function (val) {
    if (typeof (val) == "number") {
        var ret = Math.floor(val);
        if (Machinata.Responsive.SNAP_TO_GRID != null) {
            ret = Machinata.Responsive.snapToGrid(ret);
        }
        return ret + "px";
    }
    else return val;
};


/// <summary>
/// 
/// </summary>
Machinata.Responsive.calculateSizeForAttribute = function (elem, rule) {
    if (rule == "none") return "";
    if (rule == "auto") return "auto";
    var ret = eval(rule); // Note: we use eval here with shortcuts to the parameter elem, so don't change that.
    return ret;
};


/// <summary>
/// 
/// </summary>
Machinata.Responsive.getParamForLayout = function (definition, name, layout) {
    if (layout == null) throw "Machinata.Responsive.getParamForLayout: layout is null";
    if (definition[name][layout] != null) return definition[name][layout];
    else return definition[name]["default"];
};


/// <summary>
/// 
/// </summary>
Machinata.Responsive.updateBodyTags = function () {
    if (document.body.clientWidth < Machinata.Responsive.VIEWPORT_MAX_WIDTH_MOBILE || Machinata.Responsive.FORCE_LAYOUT ==  "mobile") {
        // Mobile
        Machinata.Responsive.currentLayout = "mobile";
        Machinata.Responsive.containerElem
            .addClass("mobile")
            .addClass("tablet-or-mobile")
            .removeClass("desktop-or-tablet")
            .removeClass("desktop")
            .removeClass("tablet");
    } else if (document.body.clientWidth < Machinata.Responsive.VIEWPORT_MAX_WIDTH_TABLET || Machinata.Responsive.FORCE_LAYOUT == "tablet") {
        // Tablet
        Machinata.Responsive.currentLayout = "tablet";
        Machinata.Responsive.containerElem
            .addClass("tablet")
            .addClass("tablet-or-mobile")
            .addClass("desktop-or-tablet")
            .removeClass("desktop")
            .removeClass("mobile");
    } else {
        // Desktop
        Machinata.Responsive.currentLayout = "desktop";
        Machinata.Responsive.containerElem
            .addClass("desktop")
            .addClass("desktop-or-tablet")
            .removeClass("tablet-or-mobile")
            .removeClass("tablet")
            .removeClass("mobile");
    }
};


/// <summary>
/// 
/// </summary>
Machinata.Responsive.updateResponsiveElements = function () {
    // Mobile or tablet or desktop?
    var oldLayout = Machinata.Responsive.currentLayout;
    Machinata.Responsive.updateBodyTags();

    // Layout change?
    if (oldLayout != Machinata.Responsive.currentLayout) {
        Machinata.debug("Machinata.Responsive: layout change from " + oldLayout + " to " + Machinata.Responsive.currentLayout);
        for (var i = 0; i < Machinata.Responsive._onLayoutChange.length; i++) Machinata.Responsive._onLayoutChange[i]();
    }

    // Call resizes
    for (var i = 0; i < Machinata.Responsive._onResize.length; i++) Machinata.Responsive._onResize[i]();

    // Skip if we have none
    if (Machinata.Responsive.definitions != null && Machinata.Responsive.definitions.length != 0) {

        // Process all
        for (var i = 0; i < Machinata.Responsive.definitions.length; i++) {

            /*// Init
            var elem = Machinata.Responsive.definitions[i];
            // Get cached definition
            var definition = jQuery.data(elem, "responsive-definition");*/

            // Init
            var definition = Machinata.Responsive.definitions[i];
            //var elem = definition.bindingElem;

            // Elems cached?
            if (definition["allow-selector-caching"] == false) {
                Machinata.Responsive.updateElementsForResponsiveElement(definition);
            }


            if (Machinata.Responsive.verboseDebug == true) Machinata.debug("Machinata.Responsive: processing " + definition.selector);
            if (Machinata.Responsive.verboseDebug == true) Machinata.debug("  " + definition.elems.length + " elems");
            // Process each of the elements of the selector
            definition.elems.each(function () {
                var responsiveElem = $(this);


                // Get the layout to use
                var layout = Machinata.Responsive.currentLayout;

                // Get layout via definition callback?
                if (definition["layout-handler"] != null) {
                    layout = definition["layout-handler"](responsiveElem, definition);
                    if (layout == null) {
                        console.warn("***WARNING: Machinata.Responsive.updateResponsiveElements got null from definition layout-handler, falling back to page layout.")
                        layout = Machinata.Responsive.currentLayout;
                    }
                }

                // Set max widht and height
                var newWidth = null;
                var newHeight = null;
                var newTop = null;
                var newLeft = null;
                var newMarginLeft = null;
                var newMarginRight = null;
                var newAspectRatio = null;
                var paramMinWidth = Machinata.Responsive.getParamForLayout(definition, "min-width", layout);
                var paramMaxWidth = Machinata.Responsive.getParamForLayout(definition, "max-width", layout);
                if (paramMaxWidth != null) {
                    newWidth = Machinata.Responsive.calculateSizeForAttribute(responsiveElem, paramMaxWidth);
                    if (paramMinWidth != null) {
                        var minWidth = Machinata.Responsive.calculateSizeForAttribute(responsiveElem, paramMinWidth);
                        if (newWidth < minWidth) newWidth = minWidth;
                    }
                    if (paramMaxWidth != "elem.width()") responsiveElem.css("width", Machinata.Responsive.getCSSStyleForAttribute(newWidth));
                }
                var paramMinHeight = Machinata.Responsive.getParamForLayout(definition, "min-height", layout);
                var paramMaxHeight = Machinata.Responsive.getParamForLayout(definition, "max-height", layout);
                if (paramMaxHeight != null) {
                    newHeight = Machinata.Responsive.calculateSizeForAttribute(responsiveElem, paramMaxHeight);
                    if (paramMinHeight != null) {
                        var minHeight = Machinata.Responsive.calculateSizeForAttribute(responsiveElem, paramMinHeight);
                        if (newHeight < minHeight) newHeight = minHeight;
                    }
                    if (paramMaxHeight != "elem.height()") responsiveElem.css("height", Machinata.Responsive.getCSSStyleForAttribute(newHeight));
                }
                // Cover fill/fit
                var paramCover = Machinata.Responsive.getParamForLayout(definition, "cover", layout);
                var paramAspectRatio = Machinata.Responsive.getParamForLayout(definition, "aspect-ratio", layout);
                if (paramAspectRatio != null && paramCover != null) {
                    if (newAspectRatio == null) newAspectRatio = Machinata.Responsive.calculateSizeForAttribute(responsiveElem, paramAspectRatio);
                    var pw = responsiveElem.parent().width();
                    var ph = responsiveElem.parent().height();
                    var ear = newAspectRatio;
                    var par = pw / ph;
                    if (paramCover == "fill") {
                        if (ear < par) {
                            // Fit to width
                            newWidth = pw;
                            newHeight = responsiveElem.parent().width() / ear;
                        } else {
                            // Fit to height
                            newWidth = ear * responsiveElem.parent().height();
                            newHeight = ph;
                        }
                    } else if (paramCover == "fit") {
                        if (ear < par) {
                            // Fit to height
                            newWidth = ear * responsiveElem.parent().height();
                            newHeight = ph;
                        } else {
                            // Fit to width
                            newWidth = pw;
                            newHeight = responsiveElem.parent().width() / ear;
                        }
                    }
                    // Center
                    var newX = pw / 2 - newWidth / 2;
                    var newY = ph / 2 - newHeight / 2;
                    // Set
                    responsiveElem.css("left", Machinata.Responsive.getCSSStyleForAttribute(newX));
                    responsiveElem.css("top", Machinata.Responsive.getCSSStyleForAttribute(newY));
                    responsiveElem.css("width", Machinata.Responsive.getCSSStyleForAttribute(newWidth));
                    responsiveElem.css("height", Machinata.Responsive.getCSSStyleForAttribute(newHeight));
                }
                if (paramAspectRatio != null && newWidth == null) {
                    if (newAspectRatio == null) newAspectRatio = Machinata.Responsive.calculateSizeForAttribute(responsiveElem, paramAspectRatio);
                    newWidth = newAspectRatio * newHeight;
                    responsiveElem.css("width", Machinata.Responsive.getCSSStyleForAttribute(newWidth));
                }
                if (paramAspectRatio != null && newHeight == null) {
                    if (newAspectRatio == null) newAspectRatio = Machinata.Responsive.calculateSizeForAttribute(responsiveElem, paramAspectRatio);
                    newHeight = newWidth / newAspectRatio;
                    responsiveElem.css("height", Machinata.Responsive.getCSSStyleForAttribute(newHeight));
                }
                // Top
                var paramTop = Machinata.Responsive.getParamForLayout(definition, "top", layout);
                if (paramTop != null) {
                    newTop = Machinata.Responsive.calculateSizeForAttribute(responsiveElem, paramTop);
                    responsiveElem.css("top", Machinata.Responsive.getCSSStyleForAttribute(newTop));
                }
                // Left
                var paramLeft = Machinata.Responsive.getParamForLayout(definition, "left", layout);
                if (paramLeft != null) {
                    newLeft = Machinata.Responsive.calculateSizeForAttribute(responsiveElem, paramLeft);
                    responsiveElem.css("left", Machinata.Responsive.getCSSStyleForAttribute(newLeft));
                }
                // Margins
                var paramMarginLeft = Machinata.Responsive.getParamForLayout(definition, "margin-left", layout);
                if (paramMarginLeft != null) {
                    newMarginLeft = Machinata.Responsive.calculateSizeForAttribute(responsiveElem, paramMarginLeft);
                    responsiveElem.css("margin-left", Machinata.Responsive.getCSSStyleForAttribute(newMarginLeft));
                }
                var paramMarginRight = Machinata.Responsive.getParamForLayout(definition, "margin-right", layout);
                if (paramMarginRight != null) {
                    newMarginRight = Machinata.Responsive.calculateSizeForAttribute(responsiveElem, paramMarginRight);
                    responsiveElem.css("margin-right", Machinata.Responsive.getCSSStyleForAttribute(newMarginRight));
                }
                // Font
                var paramFontSize = Machinata.Responsive.getParamForLayout(definition, "font-size", layout);
                if (paramFontSize != null) {
                    var newFontSize = Machinata.Responsive.calculateSizeForAttribute(responsiveElem, paramFontSize);
                    responsiveElem.css("font-size", Machinata.Responsive.getCSSStyleForAttribute(newFontSize));
                }
                // Sanity
                if (newWidth < 1) console.warn("A element for responsive defintion " + definition.id + " has new width of " + newWidth);
                if (newHeight < 1) console.warn("A element for responsive defintion " + definition.id + " has new height of " + newHeight);
            });
        }
    }



    // Call post-resizes
    for (var i = 0; i < Machinata.Responsive._onResized.length; i++) Machinata.Responsive._onResized[i]();

};











/// <summary>
/// 
/// </summary>
/// <hidden/>
Machinata.onInit(function () {
    if (Machinata.DISABLE_CORE_RESPONSIVE == true) return;

    // Register some permamant settings
    Machinata.Responsive.containerElem = $("body");
    if (Machinata.Device.isTouchEnabled() == true) {
        Machinata.Responsive.containerElem.addClass("touch-enabled");
    } else {
        Machinata.Responsive.containerElem.addClass("not-touch-enabled");
    }
    Machinata.Responsive.updateBodyTags();

    // Register bind events
    Machinata.UI.onUIBind(Machinata.Responsive.bindResponsiveMedia);
    Machinata.UI.onUIBind(Machinata.Responsive.bindCoverImages);
    Machinata.UI.onUIBind(Machinata.Responsive.bindResponsiveElements);

    // Hook on resize
    $(window).resize(function () {
        if (Machinata.DISABLE_CORE_RESPONSIVE == true) return;
        Machinata.Responsive.updateResponsiveElements();
    });
});

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-triggers.js */
/* File: js/machinata-core-bundle.js/machinata-core-triggers.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */


/// <summary>
/// Very light-weight and fast trigger mechanisim for triggering certain UI classes when
/// DOM elements appear/dissppear.
/// See also machinata-scrollkit-bundle.js as an alternative.
/// </summary>
/// <type>namespace</type>
Machinata.Triggers = {};


/// <summary>
/// 
/// </summary>
Machinata.Triggers.elements = null;


/// <summary>
/// 
/// </summary>
Machinata.Triggers.triggerIds = {};

/// <summary>
///
/// </summary>
/// <hidden/>
Machinata.onInit(function () {
    
    // Get a handle on all repsonsive elements/containers
    Machinata.Triggers.elements = [];

    $(".bb-trigger").each(function () {
        // Init
        var elem = $(this);
        // Do we have a ID?
        var triggerId = elem.attr("data-trigger-id");
        if (!String.isEmpty(triggerId)) {
            // Only process the element if it is unqiue id (ie, don't do the id's twice)
            if (Machinata.Triggers.triggerIds[triggerId] != null) return;
            // Register the id
            Machinata.Triggers.triggerIds[triggerId] = elem;
        }
        // Cached data?
        var params = jQuery.data(elem, "trigger-params");
        if (params == null) {
            // Init
            params = {};
            params.event = elem.attr("data-trigger-event");
            params["class"] = elem.attr("data-trigger-class");
            // Get selector
            params.selector = elem.attr("data-trigger-selector");
            if (params.selector == "") params.selector = null;
            // Get elems
            params.elems = null;
            if (params.selector == null) params.elems = elem; //self
            else params.elems = $(params.selector);
            // Update
            jQuery.data(elem, "trigger-params", params);
        }
        // Register elemenet
        Machinata.Triggers.elements.push(elem);
    });

    Machinata.Triggers.updateTriggersElements();
    // Hook on events
    $(window).resize(function () {
        Machinata.Triggers.updateTriggersElements();
    });
    $(window).on('scroll', function () {
        Machinata.Triggers.updateTriggersElements();
    });
});

/// <summary>
/// 
/// </summary>
Machinata.Triggers.updateTriggersElements = function () {
    // Skip if we have none
    if (Machinata.Triggers.elements == null || Machinata.Triggers.elements.length == 0) return;
    // Process all
    for(var i = 0; i < Machinata.Triggers.elements.length; i++) {
        // Init
        var elem = Machinata.Triggers.elements[i];
        // Get cached params
        var params = jQuery.data(elem,"trigger-params");
        // Process each of the elements of the selector
        if (params.event == "appear") {
            if (params.elems.visible()) {
                elem.addClass(params["class"]);
            } else {
                elem.removeClass(params["class"]);
            }
        } else {
            console.error("invalid trigger event: " + params.event);
        }
    }
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-pagination.js */
/* File: js/machinata-core-bundle.js/machinata-core-pagination.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Library for automatically paginating and creating forever-scrollable content.
/// </summary>
/// <type>namespace</type>
Machinata.Pagination = {};

/// <summary>
/// 
/// </summary>
Machinata.Pagination.elements = null;

/// <summary>
/// 
/// </summary>
Machinata.Pagination.proximityElements = null;

/// <summary>
///
/// </summary>
/// <hidden/>
Machinata.onInit(function () {
    
    $(".bb-pagination").each(function () {
        // Init
        var elem = $(this);
        // Set settings
        elem.data("pagination-url", elem.attr("data-pagination-url"));
        elem.data("pagination-page-size", elem.attr("data-pagination-size"));
        elem.data("pagination-current-page", elem.attr("data-pagination-current-page"));
        elem.data("pagination-selector", elem.attr("data-pagination-selector"));
        elem.data("pagination-proximity", elem.attr("data-pagination-proximity"));
        if (elem.data("pagination-url") == null) {
            var url = window.location.href;
            Machinata.debug("Machinata.Pagination: autodetect URL: " + url);
            elem.data("pagination-url", url);
        }
        if (elem.data("pagination-current-page") == null) {
            elem.data("pagination-current-page", 1);
        } else {
            elem.data("pagination-current-page", parseInt(elem.data("pagination-current-page")));
        }
        if (elem.data("pagination-proximity") != null) {
            elem.data("pagination-proximity", parseFloat(elem.data("pagination-proximity")));
            // Register element
            if (Machinata.Pagination.proximityElements == null) Machinata.Pagination.proximityElements = [];
            Machinata.Pagination.proximityElements.push(elem);
        }
        // Register element
        if (Machinata.Pagination.elements == null) Machinata.Pagination.elements = [];
        Machinata.Pagination.elements.push(elem);
    });

    if (Machinata.Pagination.proximityElements != null) {
        Machinata.Pagination.updateProximityElements();
        // Hook on scroll
        $(window).scroll(function () {
            Machinata.Pagination.updateProximityElements();
        });
    }
});


/// <summary>
/// 
/// </summary>
Machinata.Pagination.countElements = function (elem) {
    if (elem.data("pagination-selector") != null) {
        return elem.find(elem.data("pagination-selector")).length;
    } else {
        return elem.children().length;
    }
};

/// <summary>
/// 
/// </summary>
Machinata.Pagination.loadNextPage = function (elem) {
    // Validate
    if (elem.data("pagination-loading") == true) return;
    if (elem.data("pagination-finished") == true) return;
    // Show loading
    elem.addClass("loading");
    elem.data("pagination-loading", true);
    Machinata.showLoading(true);
    // Increment
    elem.data("pagination-current-page", elem.data("pagination-current-page")+1);
    // Build URL
    var loadString = elem.data("pagination-url");
    loadString = Machinata.updateQueryString("page", elem.data("pagination-current-page"), loadString);
    if (elem.data("pagination-page-size") != null) loadString = Machinata.updateQueryString("page-size", elem.data("pagination-page-size"), loadString);
    if (elem.data("pagination-selector") != null) loadString += " " + elem.data("pagination-selector");
    // Bookeeping
    var currentElems = Machinata.Pagination.countElements(elem);
    Machinata.debug("Machinata.Pagination: currentElems: " + currentElems);
    // Make request
    Machinata.debug("Machinata.Pagination: load URL: " + loadString);
    var newElemsContainer = $("<div></div>");
    newElemsContainer.load(loadString, null, function (responseText, textStatus, jqXHR) {
        Machinata.showLoading(false);
        elem.removeClass("loading");
        elem.trigger("pagination-updated");
        // Error?
        if (textStatus == "error") {
            Machinata.debug("Machinata.Pagination: error with URL: " + loadString);
            elem.data("pagination-loading", false);
        } else {
            elem.data("pagination-loading", false);
            elem.find(".new-item").removeClass("new-item");
            newElemsContainer.children().appendTo(elem).addClass("new-item");
        }
        // Did we add elements?
        var newElems = elem.find(".new-item");
        var newElemsCount = Machinata.Pagination.countElements(elem);
        Machinata.debug("Machinata.Pagination: newElems: " + newElemsCount);
        if (newElemsCount <= currentElems) {
            Machinata.debug("Machinata.Pagination: no more elements added, will disable");
            elem.data("pagination-finished", true);
            elem.addClass("finished");
        } else {
            Machinata.UI.bind(newElems);
        }
    });
};

/// <summary>
/// 
/// </summary>
Machinata.Pagination.updateProximityElements = function () {
    var scrollBottom = window.scrollY + window.innerWidth;
    for (var i = 0; i < Machinata.Pagination.proximityElements.length; i++) {
        var elem = Machinata.Pagination.proximityElements[i];
        if (elem.data("pagination-loading") == true) return;
        var elemBottom = elem.offset().top + elem.height();
        var p = scrollBottom / elemBottom;
        if (p > elem.data("pagination-proximity")) {
            Machinata.Pagination.loadNextPage(elem);
        }
    }
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-filter.js */
/* File: js/machinata-core-bundle.js/machinata-core-filter.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Library for a generic filter on a set of elements.
/// </summary>
/// <type>namespace</type>
Machinata.Filter = {};


/// <summary>
/// 
/// </summary>
Machinata.Filter.elements = null;


/// <summary>
/// 
/// </summary>
/// <hidden/>
Machinata.onInit(function () {
    
    $(".bb-data-filter").each(function () {
        // Init
        var elem = $(this);
        // Set settings
        elem.data("filter-url", elem.attr("data-filter-url"));
        elem.data("filter-results-selector", elem.attr("data-filter-results-selector"));
        elem.data("filter-item-selector", elem.attr("data-filter-item-selector"));
        if (elem.data("filter-url") == null) {
            var url = window.location.href;
            Machinata.debug("Machinata.Filter: autodetect URL: " + url);
            elem.data("filter-url", url);
        }
        if (elem.data("filter-item-selector") == null) {
            elem.data("filter-item-selector", ".bb-data-filter-results-item");
        }
        if (elem.data("filter-results-selector") == null) {
            elem.data("filter-results-selector", ".bb-data-filter-results");
        }
        // Bind interactions
        elem.find(".bb-data-filter-toggle").click(function () {
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected")
            } else {
                $(this).addClass("selected")
            }
            Machinata.Filter.update(elem);
        });
        var inputTimer = null;
        elem.find(".bb-data-filter-input").on("keyup", function () {
            if (inputTimer != null) clearTimeout(inputTimer);
            inputTimer = setTimeout(function () {
                Machinata.Filter.update(elem);
            }, 600);
            
        });
        // Initial state
        elem.find(".bb-data-filter-show-if-loading").hide();
        elem.find(".bb-data-filter-show-if-success").hide();
        elem.find(".bb-data-filter-show-if-empty").hide();
        elem.find(".bb-data-filter-show-if-error").hide();
        // Register element
        if (Machinata.Filter.elements == null) Machinata.Filter.elements = [];
        Machinata.Filter.elements.push(elem);
    });
});


/// <summary>
/// 
/// </summary>
Machinata.Filter.countElements = function (elem) {
    if (elem.data("filter-item-selector") != null) {
        return elem.find(elem.data("filter-item-selector")).length;
    } else {
        return elem.children().length;
    }
};

/// <summary>
/// 
/// </summary>
Machinata.Filter.update = function (elem) {
    // Validate
    if (elem.data("filter-loading") == true) return;
    // Show loading
    elem.addClass("loading");
    elem.data("filter-loading", true);
    elem.find(".bb-data-filter-show-if-loading").show();
    elem.find(".bb-data-filter-show-if-success").hide();
    elem.find(".bb-data-filter-show-if-empty").hide();
    elem.find(".bb-data-filter-show-if-error").hide();
    Machinata.showLoading(true);
    // Empty
    var resultsContainer = $(elem.data("filter-results-selector"));
    resultsContainer.empty();
    // Build URL
    var filterData = {};
    elem.find(".bb-data-filter-toggle.selected").each(function () {
        var key = $(this).attr("data-key");
        var val = $(this).attr("data-value");
        if (filterData[key] == null) {
            filterData[key] = val;
        } else {
            filterData[key] = filterData[key] + "," + val;
        }
    });
    elem.find(".bb-data-filter-input").each(function () {
        var key = $(this).attr("data-key");
        var val = $(this).val();
        if (val == null || val == "") return;
        if (filterData[key] == null) {
            filterData[key] = val;
        } else {
            filterData[key] = filterData[key] + "," + val;
        }
    });
    var loadString = elem.data("filter-url");
    var keys = Object.keys(filterData);
    for (var i = 0; i <keys.length; i++) {
        var key = keys[i];
        var val = filterData[key];
        loadString = Machinata.updateQueryString(key, val, loadString);
    }
    if (elem.data("filter-results-selector") != null) loadString += " " + elem.data("filter-results-selector");
    // Bookeeping
    var currentElems = Machinata.Filter.countElements(elem);
    Machinata.debug("Machinata.Filter: currentElems: " + currentElems);
    // Make request
    Machinata.debug("Machinata.Filter: load URL: " + loadString);
    var newElemsContainer = $("<div></div>");
    newElemsContainer.load(loadString, null, function (responseText, textStatus, jqXHR) {
        Machinata.showLoading(false);
        elem.removeClass("loading");
        // Error?
        if (textStatus == "error") {
            Machinata.debug("Machinata.Filter: error with URL: " + loadString);
            elem.data("filter-loading", false);
            elem.find(".bb-data-filter-show-if-loading").hide();
            elem.find(".bb-data-filter-show-if-error").show();
        } else {
            elem.data("filter-loading", false);
            elem.find(".bb-data-filter-show-if-loading").hide();
            elem.find(".bb-data-filter-show-if-success").show();
            newElemsContainer.children().appendTo(resultsContainer).addClass("new-item");
        }
        // Did we add elements?
        var newElems = Machinata.Filter.countElements(elem);
        Machinata.debug("Machinata.Filter: newElems: " + newElems);
        if (newElems <= 0) {
            Machinata.debug("Machinata.Filter: no elements added");
            elem.addClass("empty");
            elem.find(".bb-data-filter-show-if-empty").show();
            elem.find(".bb-data-filter-show-if-success").hide();
        } else {
            Machinata.UI.bind(newElemsContainer);
        }
    });
};





/// <summary>
/// </summary>
/// <type>namespace</type>
Machinata.Filter.Tables = {};

/// <summary>
/// </summary>
Machinata.Filter.Tables.makeTableFilterable = function (tableElem, opts) {
    // Init
    if (opts == null) opts = {};
    if (opts.keyDelay == null) opts.keyDelay = 300;
    if (opts.noResultsText == null) opts.noResultsText = "No results.";
    if (opts.filters == null) opts.filters = [];
    if (opts.didFilterWithResults == null) opts.didFilterWithResults = null;
    if (opts.didFilterWithNoResults == null) opts.didFilterWithNoResults = null;
    if (opts.buildNoResultsUI == null) opts.buildNoResultsUI = null;
    if (opts.buildFilterInputUI == null) opts.buildFilterInputUI = null;
    if (opts.buildNamedFilterUI == null) opts.buildNamedFilterUI = null;

    // Set initial filters
    Machinata.Filter.Tables.convertNamelessFiltersToExpressions(opts.filters);
    tableElem.data("filters", opts.filters);

    // Helper functions
    function getFilters() {
        var ret = tableElem.data("filters");
        if (ret == null) {
            ret = {};
            tableElem.data("filters", ret);
        }
        return ret;
    }
    function getNamedFiltersForColumn(columnId) {
        var filters = getFilters();
        var matches = [];
        for (var i = 0; i < filters.length; i++) {
            if (filters[i].columnId == columnId && filters[i].name != null) {
                matches.push(filters[i])
            }
        }
        return matches;
    }
    function getUITextFilterForColumn(columnId) {
        var filters = getFilters();
        var matches = [];
        for (var i = 0; i < filters.length; i++) {
            if (filters[i].columnId == columnId && filters[i].isUIText == true) {
                return filters[i];
            }
            if (filters[i].columnId == columnId) {
                matches.push(filters[i]);
            }
        }
        // Could any of the column matches be a ui text filter?
        for (var i = 0; i < matches.length; i++) {
            if (matches[i].expression != null && matches[i].name == null) {
                matches[i].isUIText = true; // convert into this
                matches[i].didConvertFromOriginalFilters = true;
                return matches[i];
            }
        }
        // No match, create one...
        var newFilter = {
            columnId: columnId,
            expression: "",
            isUIText: true,
            didAutoCreate: true
        };
        filters.push(newFilter);
        return newFilter;
    }
    function setFilters(filters) {
        Machinata.Filter.Tables.convertNamelessFiltersToExpressions(filters);
        tableElem.data("filters", filters);
        updateFiltersUIForCurrentFilters();
    }
    function updateFiltersUIForCurrentFilters() {
        tableElem.find("thead .filter-input").each(function () {
            // Init
            var textInputElem = $(this);
            // Update ui
            updateFilterInputUI(textInputElem);
        });
    }
    function log(msg, arg1, arg2) {
        return; // disabled for production
        if (arg2 != null) {
            console.log("Machinata.Filter.Tables.makeTableFilterable: " + msg, arg1, arg2);
        } else if (arg1 != null) {
            console.log("Machinata.Filter.Tables.makeTableFilterable: " + msg, arg1);
        } else {
            console.log("Machinata.Filter.Tables.makeTableFilterable: " + msg);
        }
    }
    function updateAllFilterInputUIs(updateText) {
        tableElem.find("thead .filter-input.option-text").each(function () {
            var textInputElem = $(this);
            updateFilterInputUI(textInputElem, updateText);
        });
    }
    function updateFilterInputUI(inputElem, updateText, updateNamedFilters) {
        // Update the text
        var columnId = getFilterInputColumnId(inputElem);
        var currentInputText = getFilterInputFilterText(inputElem);
        if (updateText != false) {
            var filter = getUITextFilterForColumn(columnId);
            if (currentInputText != filter.expression) setFilterInputFilterText(inputElem,filter.expression);
        }
        if (updateNamedFilters != false) {
            // Clear all named filters
            inputElem.find(".named-filters").empty();
            // Now re-add them
            var namedFilters = getNamedFiltersForColumn(columnId);
            for (var i = 0; i < namedFilters.length; i++) {
                var filter = namedFilters[i];
                // Build UI
                var namedFilterElem = $("<span></span>");
                namedFilterElem.text(filter.name);
                namedFilterElem.addClass("named-filter");
                namedFilterElem.attr("title",filter.expression);
                namedFilterElem.attr("data-id", filter.id);
                //console.log(filter);
                if (opts.buildNamedFilterUI) opts.buildNamedFilterUI(tableElem, opts, namedFilterElem, filter);
                // Actions
                namedFilterElem.find(".action-remove-filter").click(function () {
                    $(this).closest(".named-filter").remove();
                    onFilterInputChange(inputElem);
                });
                // Does the container exist? If not create it...
                if (inputElem.find(".named-filters").length == 0) inputElem.prepend($("<span class='named-filters' contenteditable='false'></span>"));
                // Add the named filter ui...
                inputElem.find(".named-filters").prepend(namedFilterElem);
            }
        }
        // Make parent grow by own height
        inputElem.parent().height(inputElem.height());
    }
    function onFilterInputChange(inputElem) {
        // UI Update
        updateFilterInputUI(inputElem, false, false);
        // Get filter text from this input
        var columnId = getFilterInputColumnId(inputElem);
        var filterText = getFilterInputFilterText(inputElem);
        //log("filterText for " + columnId + ": " + filterText);
        // Update the text filter
        var filter = getUITextFilterForColumn(columnId);
        filter.expression = filterText;
        // Update named filters
        // We basically need to validate if it needs to be removed
        var namedFiltersToRemove = [];
        var namedFilters = getNamedFiltersForColumn(columnId);
        for (var i = 0; i < namedFilters.length; i++) {
            // Does it exist?
            var namedFilterUIElem = inputElem.find("[data-id='" + namedFilters[i].id + "']");
            if (namedFilterUIElem.length == 0) namedFiltersToRemove.push(namedFilters[i]);
        }
        if (namedFiltersToRemove.length > 0) {
            for (var i = 0; i < namedFiltersToRemove.length; i++) {
                var filter = namedFiltersToRemove[i];
                var filterIndex = getFilters().indexOf(filter);
                if (filterIndex != -1) getFilters().splice(filterIndex, 1);
            }
        }
        // Do delayed trigger
        triggerDelayedFilterUpdate(inputElem);
    }
    function triggerDelayedFilterUpdate() {
        // Reset timer
        var changeTimer = tableElem.data("changeTimer");
        if (changeTimer != null) clearTimeout(changeTimer);
        // Create new timer
        changeTimer = setTimeout(function () {
            triggerFilterUpdate();
        }, opts.keyDelay);
        tableElem.data("changeTimer", changeTimer);
    }
    function triggerFilterUpdate() {
        updateTableForFilters();
    }
    function getFilterInputFilterText(inputElem) {
        // We need to loop all children and get all the text nodes, building our returned string
        var ret = null;
        for (var i = 0; i < inputElem[0].childNodes.length; i++) {
            var node = inputElem[0].childNodes[i];
            if (node.nodeType == 3) {
                if (ret == null) ret = node.nodeValue;
                else ret += " " + node.nodeValue; //TODO: should this be a expression?
            }
        }
        if (ret == "") ret = null;
        return ret;
    }
    function setFilterInputFilterText(inputElem, text) {
        // We need to loop all children and get all the text nodes
        // assigning the text to the first and removing the rest (that the user may have created)
        var didSetText = false;
        for (var i = 0; i < inputElem[0].childNodes.length; i++) {
            var node = inputElem[0].childNodes[i];
            if (node.nodeType == 3) {
                if (didSetText == false) {
                    // Set the first
                    node.nodeValue = text;
                    didSetText = true;
                } else {
                    // Remove the rest
                    node.remove();
                }
            }
        }
        // Did we never set the text because there weren't any?
        if (didSetText == false) {
            var newNode = document.createTextNode(text); 
            inputElem[0].appendChild(newNode);
        }
    }
    function getFilterInputColumnId(inputElem, columnNumber) {
        // Column number is zero-based
        return inputElem.attr("data-col-id") || inputElem.attr("data-column") || columnNumber+"";
    }
    function getColumnCellColumnId(cellElem, columnNumber) {
        // Column number is zero-based
        return cellElem.attr("data-col-id") || cellElem.attr("data-column") || columnNumber + "";
    }
    function getColumnCellFilterValue(cellElem) {
        // Values can be any of the following strings which should be returned as a number:
        // 20
        // 20.0
        // 21%
        // 21.9%
        var text = cellElem.attr("data-text") || cellElem.text();
        return Machinata.Parser.normalizeStringInputToBasicType(text);
    }

    function resetFilters() {
        setFilters([]);
    }
    function resetFiltersAndUpdate() {
        resetFilters();
        updateTableForFilters();
    }
    function updateTableForFilters() {
        // First thing - sync the ui
        updateAllFilterInputUIs();

        // Init
        var rows = tableElem.find("tbody tr");
        var totalRows = 0;
        var rowsShown = 0;
        var rowsHidden = 0;
        var maxColumns = tableElem.find("thead").first().find("tr").first().find("th").length;
        var filters = getFilters();
        if (filters == null) filters = []; // sanity
        var noResultsRow = null;

        // Pre-build the full filter query
        var filterExpressionForColumn = {};
        function convertFilterToExpression(filter) {
            // Get the expression by converting all others
            var ret = null;
            if (filter.expression != null) ret = filter.expression;
            else if (filter.value != null) ret = Machinata.Parser.escapeString(filter.value);
            else if (filter.isAny != null) ret = Machinata.Parser.convertIsAnyArrayToTextFilter(filter.isAny);
            else if (filter.notAny != null) ret = Machinata.Parser.convertNotAnyArrayToTextFilter(filter.notAny);
            else console.warn("Machinata.Filter.Tables: could not convert filter to expression: ", filter);
            // Cleanup
            if (ret != null) ret = ret.trim();
            if (ret == "") ret = null;
            return ret;
        }
        for (var i = 0; i < filters.length; i++) {
            var filter = filters[i];
            var filterExpression = convertFilterToExpression(filter);
            if (filterExpression != null) {
                if (filterExpressionForColumn[filter.columnId] == null) {
                    // New, just set the expression
                    filterExpressionForColumn[filter.columnId] = filterExpression;
                } else {
                    // Already exists, we need to append
                    //TODO
                    filterExpressionForColumn[filter.columnId] += " AND " + filterExpression;
                }
            }
        }
        log("updateTableForFilters: ", filters, filterExpressionForColumn);

        // Loop each row, figuring out if we need to show or hide rows based on the filters
        rows.each(function (rowIndex) {
            // Init
            var rowElem = $(this);
            var showRow = true; // by default true

            // Special handling no results row
            if (rowElem.hasClass("filter-no-results")) {
                noResultsRow = rowElem;
                return true;
            }

            // Go through each column of the row
            rowElem.find("td").each(function (columnIndex, item) {
                var columnElem = $(this);
                var columnId = getColumnCellColumnId(columnElem, columnIndex);
                // Do we have a filter for this?
                var columnFilter = filterExpressionForColumn[columnId];
                if (columnFilter != null) {
                    // Get the normalized value
                    var normalizedColumnValue = getColumnCellFilterValue(columnElem);
                    // Test
                    var filterResult = Machinata.Parser.parseTextFilter(columnFilter, normalizedColumnValue);
                    if (filterResult == false) {
                        log("cell filter: " + columnId + ": ", normalizedColumnValue + " vs " + columnFilter, filterResult);
                        showRow = false;
                        return false; // abort each
                    }
                }
            });

            // Update the row as needed
            if (showRow) {
                rowElem.show();
                rowsShown++;
            } else {
                rowElem.hide();
                rowsHidden++;
            }
            totalRows++;
        });


        // Update no results row
        if (rowsShown == 0) {
            // No results - show noResultsRow
            if (noResultsRow == null) {
                // Not yet created, create one
                noResultsRow = $("<tr class='filter-no-results'><td colspan='" + maxColumns + "'></td></tr>");
                if (opts.noResultsText != null) noResultsRow.find("td").text(opts.noResultsText);
                if (opts.buildNoResultsUI) opts.buildNoResultsUI(tableElem, opts, noResultsRow);
                // Bind events
                noResultsRow.find("a.reset-action").click(function () {
                    Machinata.Filter.Tables.resetFilters(tableElem);
                });
                // Add to table
                tableElem.find("tbody").last().append(noResultsRow);
            }
            noResultsRow.show();
            // Callback
            if (opts.didFilterWithNoResults) opts.didFilterWithNoResults(tableElem, opts, noResultsRow);
        } else {
            // We have results - hide noResultsRow
            if (noResultsRow != null) {
                noResultsRow.hide();
            }
            // Callback
            if (opts.didFilterWithResults) opts.didFilterWithResults(tableElem, opts, noResultsRow);
        }

        // Do a deffered update on the input UIs - we need the table to reflow the column widths first...
        setTimeout(function () {
            updateAllFilterInputUIs(false);
        }, 1);
    }

    function rebuildFiltersRow() {
        log("rebuildFiltersRow");
        // Create a row just for filtering...
        var headerColumnsRow = tableElem.find("thead .header.columns");
        var headerFiltersRow = tableElem.find("thead .header.filters");
        headerFiltersRow.remove();
        if (headerFiltersRow.length == 0) {
            // Re-create
            headerFiltersRow = headerColumnsRow.clone();
            headerFiltersRow.removeClass("columns");
            headerFiltersRow.removeClass("tablesorter-headerRow");
            headerFiltersRow.addClass("filters");
            headerFiltersRow.attr("role", "search");
            headerFiltersRow.find("th").text("");

            headerFiltersRow.find("th").each(function (index,item) {
                var filterHeaderColumnElem = $(this);
                var headerColumnElem = headerColumnsRow.find("[data-col-id='" + filterHeaderColumnElem.attr("data-col-id")+"']");
                filterHeaderColumnElem.removeClass("column");
                filterHeaderColumnElem.addClass("filter");
                // Add text input (as contenteditable)
                var inputWrapperElem = $("<div class='filter-input-wrapper'></div>").appendTo(filterHeaderColumnElem);
                var textInputElem = $("<div contenteditable='true'></div>");
                textInputElem.addClass("filter-input");
                textInputElem.addClass("option-text");
                textInputElem.attr("data-col-id", filterHeaderColumnElem.attr("data-col-id"));
                textInputElem.attr("data-column", filterHeaderColumnElem.attr("data-column") || index);
                textInputElem.attr("data-column-title", headerColumnElem.text());
                textInputElem.text("");
                textInputElem.on("input", function () {
                    onFilterInputChange($(this));
                });
                textInputElem.on("update-ui", function () {
                    updateFilterInputUI($(this));
                });
                // Build handler
                if (opts.buildFilterInputUI) opts.buildFilterInputUI(tableElem, opts, textInputElem, filterHeaderColumnElem);
                // Add to th
                inputWrapperElem.append(textInputElem);
            });

            // Append to table head (after the header columns)
            headerFiltersRow.insertAfter(headerColumnsRow);

            // Initial update
            headerFiltersRow.find(".filter-input").each(function () {
                updateFilterInputUI($(this));
            });
        }

    }

    // Bind events
    tableElem.on("reset-filters", function () {
        resetFiltersAndUpdate();
    });
    tableElem.on("update-for-filters", function () {
        //updateFiltersUIForCurrentFilters();
        updateTableForFilters();
    });

    // Initial setup
    log("-------------");
    log("opts filters", JSON.stringify(getFilters()));
    rebuildFiltersRow();
    updateTableForFilters();
    
};

/// <summary>
/// </summary>
Machinata.Filter.Tables.convertNamelessFiltersToExpressions = function (filters) {
    for (var i = 0; i < filters.length; i++) {
        var filter = filters[i];
        if (filter.name == null && filter.expression == null) {
            if (filter.value != null) filter.expression = Machinata.Parser.escapeString(filter.value); 
            else if (filter.isAny != null) filter.expression = Machinata.Parser.convertIsAnyArrayToTextFilter(filter.isAny);
            else if (filter.notAny != null) filter.expression = Machinata.Parser.convertNotAnyArrayToTextFilter(filter.notAny);
        }
        if (filter.id == null) filter.id = Machinata.guid();
    }
};

/// <summary>
/// </summary>
Machinata.Filter.Tables.resetFilters = function (tableElem) {
    tableElem.trigger("reset-filters");
};

/// <summary>
/// </summary>
Machinata.Filter.Tables.setFilters = function (tableElem, filters) {
    // Get a copy of filters
    var filters = Machinata.Util.cloneJSON(filters);
    Machinata.Filter.Tables.convertNamelessFiltersToExpressions(filters);
    tableElem.data("filters", filters);
    tableElem.trigger("update-for-filters");
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-video.js */
/* File: js/machinata-core-bundle.js/machinata-core-video.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Collection of utilities for displaying, sizing and playing HTML5 videos.
/// </summary>
/// <type>namespace</type>
Machinata.Video = {};

/// <summary>
/// 
/// </summary>
Machinata.Video.WATCHDOG_TIMEOUT_MS = 5000;

/// <summary>
/// 
/// </summary>
Machinata.Video.parseVideoSource = function (src) {
    if (src == null) return null;
    if (src == "") return null;
    if (src.startsWith("{") && src.endsWith("}")) return null;
    return src;
};

/// <summary>
/// 
/// </summary>
/// <hidden/>
Machinata.UI.onUIBind(function (elements) {
    var videoElements = elements.find(".bb-video");
    if (Machinata.DebugEnabled == true) {
        Machinata.debug("Machinata.UI.onUIBind: video");
        Machinata.debug("  Found " + videoElements.length + " video elements");
    }
    videoElements.addClass("bb-ui-bound").each(function () {
        // Init
        var elem = $(this);
        var src = elem.attr("src");
        if (src == null) src = elem.attr("data-video-source");
        var srcCover = elem.attr("data-video-cover");
        var srcGIF = elem.attr("data-video-gif");
        var srcMP4 = elem.attr("data-video-mp4");
        var srcOGV = elem.attr("data-video-ogv");
        var srcWEBM = elem.attr("data-video-webm");
        var ar = elem.attr("data-video-aspectratio");
        var autoplay = elem.attr("data-video-autoplay");
        var controls = elem.attr("data-video-controls");
        var loop = elem.attr("data-video-loop");
        var muted = elem.attr("data-video-muted");
        var watchdog = elem.attr("data-video-watchdog"); // if not 'false', we assume a watchdog
        // Detect src automatically
        if (src.endsWith(".gif") && srcGIF == null) srcGIF = src;
        else if (src.endsWith(".mp4") && srcMP4 == null) srcMP4 = src;
        else if (src.endsWith(".ogv") && srcOGV == null) srcOGV = src;
        else if (src.endsWith(".webm") && srcWEBM == null) srcWEBM = src;
        if (src.endsWith(".png") && srcCover == null) srcCover = src;
        else if (src.endsWith(".jpg") && srcCover == null) srcCover = src;
        else if (src.endsWith(".gif") && srcCover == null) srcCover = src;
        // Nullize
        srcGIF = Machinata.Video.parseVideoSource(srcGIF);
        srcMP4 = Machinata.Video.parseVideoSource(srcMP4);
        srcOGV = Machinata.Video.parseVideoSource(srcOGV);
        srcWEBM = Machinata.Video.parseVideoSource(srcWEBM);
        srcCover = Machinata.Video.parseVideoSource(srcCover);
        // Video file?
        var hasVideoFile = false;
        if (srcMP4 != null) hasVideoFile = true;
        if (srcOGV != null) hasVideoFile = true;
        if (srcWEBM != null) hasVideoFile = true;
        // Debug
        if (Machinata.DebugEnabled == true) {
            Machinata.debug("Machinata.Video: Found new video");
            Machinata.debug("  src:" + src);
            Machinata.debug("  srcMP4:" + srcMP4);
            Machinata.debug("  srcOGV:" + srcOGV);
            Machinata.debug("  srcWEBM:" + srcWEBM);
            Machinata.debug("  srcGIF:" + srcGIF);
            Machinata.debug("  srcCover:" + srcCover);
            Machinata.debug("  ar:" + ar);
            Machinata.debug("  autoplay:" + autoplay);
            Machinata.debug("  hasVideoFile:" + hasVideoFile);
        }
        // Disable autoplay?
        if ($("body").hasClass("bb-video-no-autoplay-mobile") && ($("body").hasClass("mobile") || $("body").hasClass("tablet"))) {
            autoplay = "false";
            controls = "true";
        }
        if ($("body").hasClass("bb-video-show-controls")) {
            controls = "true";
        }
        // AR fallback
        if (ar == null) ar = elem.width() / elem.height();
        else ar = parseFloat(ar);
        // Strategy
        if (hasVideoFile) {
            // Create new video elem
            var videoAttribs = "";
            if (autoplay == "true") videoAttribs += " autoplay";
            if (controls == "true") videoAttribs += " controls";
            if (loop == "true") videoAttribs += " loop";
            if (muted == "true") videoAttribs += " muted";
            if (srcCover != null) videoAttribs += " poster=\"" + srcCover + "\"";
            videoAttribs += " preload=\"metadata\"";
            videoAttribs += " playsinline";
            videoAttribs += " webkit-playsinline";
            // Elem
            var videoHTML = "<video " + videoAttribs + ">";
            if (srcWEBM != null) videoHTML += "<source src=\""+srcWEBM+"\" type='video/webm'/>";
            if (srcMP4 != null) videoHTML += "<source src=\""+srcMP4+"\" type='video/mp4'/>";
            if (srcOGV != null) videoHTML += "<source src=\""+srcOGV+"\" type='video/ogg'/>";
            videoHTML += "</video>";
            var videoElem = $(videoHTML);
            // Bind events
            videoElem.on("play", function () {
                $(this).data("video-loaded", true);
                $(this).data("video-playing", true);
            });
            // Insert into DOM
            elem.hide();
            elem.parent().addClass("contains-video-element");
            elem.parent().append(videoElem);
            // Special helper for android
            //if (Machinata.Device.isAndroid()) {
            //}
            // Create watchdog
            // If the video doesnt start auto-playing, we add controls as a fallback
            // so the user can play the video
            if (autoplay == "true" && watchdog != "false") {
                setTimeout(function () {
                    if (videoElem.data("video-loaded") != true) {
                        Machinata.debug("bb-video: watchdog fired, will add controls as fallback");
                        videoElem.attr("controls", "controls");
                    }
                }, Machinata.Video.WATCHDOG_TIMEOUT_MS);
            }
        } else {
            // Cover/gif fallback
        }
    });
    
});


/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-privacy.js */
/* File: js/machinata-core-bundle.js/machinata-core-privacy.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Framework for providing common privacy related settings and challenges.
/// </summary>
/// <type>namespace</type>
Machinata.Privacy = {};

/// <summary>
/// 
/// </summary>
Machinata.Privacy.autopadBody = false;

/// <summary>
/// 
/// </summary>
Machinata.Privacy.fadeInSpeedMS = 400;

/// <summary>
/// 
/// </summary>
Machinata.Privacy.autoShowDelayMS = 500;

/// <summary>
/// 
/// </summary>
Machinata.Privacy.agreements = [];

/// <summary>
/// 
/// </summary>
Machinata.Privacy.options = [];

/// <summary>
///
/// </summary>
/// <hidden/>
Machinata.Privacy._cachedSettings = null;

/// <summary>
/// 
/// </summary>
Machinata.Privacy.settings = function (val) {
    if (val == null) {
        if (Machinata.Privacy._cachedSettings == null) {
            var ret = $.cookie("Privacy");
            if (ret == null) Machinata.Privacy._cachedSettings = {};
            else Machinata.Privacy._cachedSettings = JSON.parse(ret);
        }
        return Machinata.Privacy._cachedSettings;
    } else {
        Machinata.debug("Machinata.Privacy.settings: saving");
        var expiresInDays = 360 * 2;
        $.cookie("Privacy", JSON.stringify(val), { expires: expiresInDays, path: '/' });
        return val;
    }
};

/// <summary>
/// 
/// </summary>
Machinata.Privacy.registerAgreement = function (type, version, date, link, title) {
    Machinata.debug("Machinata.Privacy.registerAgreement: "+type);
    //Machinata.debug("  type: " + type);
    //Machinata.debug("  version: " + version);
    //Machinata.debug("  date: " + date);
    //Machinata.debug("  link: " + link);
    //Machinata.debug("  title: " + title);
    var agreement = {};
    agreement["type"] = type;
    agreement["version"] = version;
    agreement["date"] = date;
    agreement["link"] = link;
    agreement["title"] = title;
    agreement["id"] = type + "_" + version;
    Machinata.Privacy.agreements.push(agreement);
};

/// <summary>
/// 
/// </summary>
Machinata.Privacy.registerOption = function (key, source, type, defaultValue, required, link, title, description, callback) {
    Machinata.debug("Machinata.Privacy.registerOption: "+key);
    //Machinata.debug("  key: " + key);
    //Machinata.debug("  type: " + type);
    //Machinata.debug("  defaultValue: " + defaultValue);
    //Machinata.debug("  required: " + required);
    //Machinata.debug("  link: " + link);
    //Machinata.debug("  title: " + title);
    //Machinata.debug("  description: " + description);
    // Validate
    if (source != "cookie") { alert("invalid option source"); return; };
    // Create option obj
    var option = {};
    option["key"] = key;
    option["type"] = type;
    option["defaultValue"] = defaultValue;
    option["source"] = source;
    option["required"] = required;
    option["link"] = link;
    option["title"] = title;
    option["description"] = description;
    option["id"] = key;
    option["callback"] = callback;
    Machinata.Privacy.options.push(option);
};

/// <summary>
/// 
/// </summary>
Machinata.Privacy.automaticValidationAndInfo = function (callback) {
    Machinata.debug("Machinata.Privacy.automaticValidationAndInfo");
    if ($("body").hasClass("bb-no-privacy-validation")) return;
    if (Machinata.queryParameter("privacy-validation") == "false") return;

    var pending = Machinata.Privacy.pendingAgreements();
    var settings = Machinata.Privacy.settings();
    if (pending.length > 0) {
        var reason = "new-visitor";
        if (settings["agreed"] == true) reason = "new-agreement";
        var elem = Machinata.Privacy.showSettings(reason, Machinata.Privacy.autoShowDelayMS);
        if (callback) callback(elem);
    } else {
        // Settings callback
        var options = Machinata.Privacy.currentOptions();
        for (var i = 0; i < options.length; i++) {
            var o = options[i];
            if (o["callback"] != null) o["callback"](Machinata.Privacy.getOption(o["key"], o));
        }
    }
};

/// <summary>
/// 
/// </summary>
Machinata.Privacy.closeSettings = function () {
    $("#privacy_settings").remove();
    if (Machinata.Privacy.autopadBody == true) {
        $("body").css("padding-top", "unset");
    }
};

/// <summary>
/// 
/// </summary>
Machinata.Privacy.showSettings = function (reason, delay) {

    // Init
    var agreements = Machinata.Privacy.currentAgreements();

    // Reason
    if (reason == null) reason = "preferences";

    // Main elem
    var elem = $("<div class='bb-privacy-settings' id='privacy_settings'></div>");
    elem.hide();
    elem.addClass("settings-collapsed");

    // Title and description
    var agreeText = "I agree";
    var title = null;
    if (reason == "preferences" || reason == "new-visitor") title = "Privacy Preferences";
    if (reason == "new-agreement") title = "Updated Agreements";
    var desc = null;
    if (reason == "preferences" || reason == "new-visitor") desc = "We want to deliver the best, most functional, experience to you.";
    if (reason == "new-agreement") desc = "We've updated our agreements.";
    desc += " By clicking 'I agree' you agree to the {terms} and settings below. Your personal data is processed in accordance with the {privacy} and European Law.";
    if (reason == "preferences") agreeText += ", Save"

    // Links
    var privacyLink = "";
    var termsLink = "";
    for (var i = 0; i < agreements.length; i++) {
        var a = agreements[i];
        if (a["type"] == "privacy") privacyLink = a["link"];
        if (a["type"] == "terms") termsLink = a["link"];
    }

    // Description elems
    desc = desc.replace("{terms}", "<a class='terms link'></a>");
    desc = desc.replace("{privacy}", "<a class='privacy link'></a>");
    var elemDesc = $("<div class='description'></div>");
    elemDesc.append($("<h1></h1>").text(title));
    elemDesc.append($("<p></p>").html(desc));
    elemDesc.find("a.link.terms").text("Terms of Use").attr("href", termsLink).attr("target", "_blank");
    elemDesc.find("a.link.privacy").text("Privacy Policy").attr("href", privacyLink).attr("target", "_blank");
    elem.append(elemDesc);

    // Settings
    var options = Machinata.Privacy.currentOptions();
    var elemSettings = $("<div class='settings'></div>");
    var elemSettingsTitle = $("<div class='title-and-button'></div>");
    elemSettingsTitle.append($("<h2></h2>").text("Your Settings"));
    elemSettingsTitle.append($("<a class='edit-button toggle-settings-button'></a>").text("Edit"));
    elemSettingsTitle.append($("<a class='hide-button toggle-settings-button'></a>").text("Hide"));
    elemSettings.append(elemSettingsTitle);
    var elemSettingsOptions = $("<div class='options'></div>");
    for (var i = 0; i < options.length; i++) {
        var o = options[i];
        var elemOption = $("<div class='option'></div>");
        var elemId = "privacy_option_" + o["id"]
        var elemInput = $("<input/>").attr("type", o["type"]).attr("id", elemId);
        var val = o["value"];
        if (val == null) val = o["defaultValue"];
        if (val == true && o["type"] == "checkbox") {
            elemInput.attr("checked", "checked");
        }
        if (o["required"] == true) {
            elemInput.attr("disabled", "disabled");
        }
        elemOption.append(elemInput);
        elemOption.append($("<label/>").attr("for", elemId).text(o["title"]));
        elemOption.append($("<div/>").text(o["description"]));
        if (o["required"] == true) {
            elemInput.attr("title", "This setting is required.");
            elemOption.find("label").attr("title", "This setting is required.");
        }
        elemSettingsOptions.append(elemOption);
    }
    elemSettings.append(elemSettingsOptions);
    elem.append(elemSettings);

    // Agree button
    var elemButtons = $("<div class='buttons'></div>");
    elemButtons.append($("<input class='agree-button'/>").attr("type", "button").val(agreeText));
    elem.append(elemButtons);
    
    // Bind actions
    elemSettings.find(".toggle-settings-button").click(function () {
        if (elem.hasClass("settings-collapsed")) {
            elem.removeClass("settings-collapsed");
        } else {
            elem.addClass("settings-collapsed");
        }
    });
    elemButtons.find(".agree-button").click(function () {
        // Register options
        for (var i = 0; i < options.length; i++) {
            var o = options[i];
            var optionElem = $("#privacy_option_" + o.key);
            var val = optionElem.val();
            if (o["type"] == "checkbox") val = optionElem.is(":checked");
            Machinata.Privacy.setOption(o.key, val);
            if (o["callback"] != null) o["callback"](val, o);
        }
        // Accept agreements
        Machinata.Privacy.acceptCurrentAgrrements();
        // Mimick some loading activity
        Machinata.showLoading(true);
        setTimeout(function () {
            Machinata.showLoading(false);
            // Close
            if (!elem.hasClass("settings-inline")) Machinata.Privacy.closeSettings();
        }, 300);
    });

    // Add to DOM
    $("body").append(elem);
    if (delay == null) delay = 0;
    setTimeout(function () {
        if (Machinata.Privacy.fadeInSpeedMS == 0 || Machinata.Privacy.fadeInSpeedMS == null) {
            elem.show();
        } else {
            elem.fadeTo(0, 0.0);
            elem.show();
            elem.fadeTo(Machinata.Privacy.fadeInSpeedMS, 1.0);
        }
        if (Machinata.Privacy.autopadBody == true) {
            elem.css("position", "absolute");
            $("body").css("padding-top", elem.height() + "px");
        }
    }, delay);
    return elem;
};

/// <summary>
/// 
/// </summary>
Machinata.Privacy.setOption = function (key, val) {
    Machinata.debug("Machinata.Privacy.setOption: "+key+"="+val);
    //Machinata.debug("  key: " + key);
    //Machinata.debug("  val: " + val);
    var settings = Machinata.Privacy.settings();
    settings["option_" + key] = val;
    Machinata.Privacy.settings(settings);
};

/// <summary>
/// 
/// </summary>
Machinata.Privacy.getOption = function (key) {
    Machinata.debug("Machinata.Privacy.getOption: "+key);
    //Machinata.debug("  key: " + key);
    var settings = Machinata.Privacy.settings();
    var val = settings["option_" + key];
    Machinata.debug("  val: " + val);
    return val;
};

/// <summary>
/// 
/// </summary>
Machinata.Privacy.cookie = function (option,key,val) {
    var optionValue = Machinata.Privacy.getOption(option);
    if (optionValue == true) {
        if (val != null) {
            var expiresInDays = 360 * 1;
            $.cookie(key, val, { expires: expiresInDays, path: '/' });
            return val;
        } else {
            return $.cookie(key);
        }
    } else {
        return null;
    }
};

/// <summary>
/// 
/// </summary>
Machinata.Privacy.acceptCurrentAgrrements = function () {
    var settings = Machinata.Privacy.settings();
    var current = Machinata.Privacy.currentAgreements();
    Machinata.debug("Machinata.Privacy.acceptCurrentAgrrements");
    for (var i = 0; i < current.length; i++) {
        var a = current[i];
        Machinata.debug("  " + a.id);
        settings["agreement_" + a.id + "_agreed"] = true;
        settings["agreement_" + a.id + "_agreedate"] = new Date();
    }
    settings["agreed"] = true;
    settings["agreedate"] = new Date();
    Machinata.Privacy.settings(settings);
};

/// <summary>
/// 
/// </summary>
Machinata.Privacy.currentOptions = function () {
    var ret = [];
    for (var i = 0; i < Machinata.Privacy.options.length; i++) {
        var o = Machinata.Privacy.options[i];
        o["value"] = Machinata.Privacy.getOption(o["key"]);
        ret.push(o);
    }
    return ret;
};

/// <summary>
/// 
/// </summary>
Machinata.Privacy.currentAgreements = function () {
    // Get the current most agreements
    var settings = Machinata.Privacy.settings();
    Machinata.debug("Machinata.Privacy.currentAgreements");
    var types = {};
    for (var i = 0; i < Machinata.Privacy.agreements.length; i++) {
        var a = Machinata.Privacy.agreements[i];
        if (types[a.type] == null || a.version > types[a.type].version) {
            types[a.type] = a;
        }
    }
    var ret = [];
    for (var i = 0; i < Object.keys(types).length; i++) {
        var k = Object.keys(types)[i];
        var a = types[k];
        Machinata.debug("  " + a.id);
        a["agreed"] = settings["agreement_" + a.id + "_agreed"];
        a["agreedate"] = settings["agreement_" + a.id + "_agreedate"];
        ret.push(a);
    }
    return ret;
};

/// <summary>
/// 
/// </summary>
Machinata.Privacy.pendingAgreements = function () {
    var current = Machinata.Privacy.currentAgreements();
    Machinata.debug("Machinata.Privacy.pendingAgreements");
    var ret = [];
    for (var i = 0; i < current.length; i++) {
        var a = current[i];
        if (a.agreed != true) {
            ret.push(a);
            Machinata.debug("  "+a.id);
        }
    }
    return ret;
};



/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-currency.js */
/* File: js/machinata-core-bundle.js/machinata-core-currency.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// Currency related routines for web shops.
/// </summary>
/// <type>namespace</type>
Machinata.Currency = {};

Machinata.Currency.DEFAULT_CURRENCY = "CHF"; //TODO read from config
Machinata.Currency.DEFAULT_LOCALE = "de-CH"; //TODO read from config

Machinata.Currency.getFormattedString = function (val, currency, locale, digits, zeroCents) {
    if (currency == null) currency = Machinata.Currency.DEFAULT_CURRENCY; // default
    if (locale == null) locale = Machinata.Currency.DEFAULT_LOCALE; // default
    if (digits == null) digits = 0; // default

    var formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
    });
    var ret = formatter.format(val);
    if (zeroCents != null) ret = ret.replace(".00", zeroCents); //TODO: replace only end?
    ret = ret.replaceAll("$", "USD");
    ret = ret.replace(/\u00A0/g, ' '); // replace non-breaking spaces 
    return ret;
};

/// <summary>
///
/// </summary>
Machinata.Currency.getValueFromString = function (str) {
    if (str == null) return null;

    var p = new Price(str);
    return p.value;
};



/// <summary>
/// Price class implemented 1:1 as Machinata Server Price
/// </summary>
function Price(str) {
    this.value = 0;
    this.currency = Machinata.Currency.DEFAULT_CURRENCY;
    if (str != null && str != "") this.parse(str);
}
Price.prototype.parse = function (str) {
    str = str.replaceAll(".-", "");
    str = str.replaceAll(",", "");
    str = str.replaceAll("'", "");
    str = str.replaceAll("’", "");
    var segs = str.split(' ');
    this.value = parseFloat(segs[1]);
    this.currency = segs[0];
};
Price.validateCompatibility = function (a,b) {
    if (a.currency != b.currency) throw "Cannot add two prices with different currencies ("+a.currency+" vs "+b.currency+")!";
};
Price.prototype.add = function (other) {
    // Validate
    Price.validateCompatibility(this, other);
    this.value = this.value + other.value;
};
Price.prototype.equals = function (other) {
    // Validate
    Price.validateCompatibility(this, other);
    return (this.value == other.value);
};
Price.prototype.toString = function () {
    return this.currency + ' ' + this.value.toFixed(2);
};



/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-imaging.js */
/* File: js/machinata-core-bundle.js/machinata-core-imaging.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Collection of powerful imaging tools.
/// </summary>
/// <type>namespace</type>
Machinata.Imaging = {};

/// <summary>
/// 
/// </summary>
Machinata.Imaging.createDrawingCanvas = function(width, height, canvasEngine) {
    if (typeof (require) !== "undefined") {
        // NodeJS environment
        var canvasLib = require('canvas');
        if (canvasEngine == "png") canvasEngine = null;
        if (canvasEngine == "jpg") canvasEngine = null;
        if (canvasEngine == null) {
            return new canvasLib.Canvas(width, height);
        } else {
            return new canvasLib.Canvas(width, height, canvasEngine);
        }
    } else {
        // Browser DOM
        if (canvasEngine != null) throw "Machinata.Imaging.createDrawingCanvas: canvasEngine is not supported on browsers."
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
};


/// <summary>
/// 
/// </summary>
Machinata.Imaging.measureText = function (text, font, size, context, allowMetricsCalibration) {
    // Init
    if (allowMetricsCalibration == null) allowMetricsCalibration = true;
    if (context == null) {
        var canvas = Machinata.Imaging.createDrawingCanvas(1, 1);
        context = canvas.getContext('2d');
    }
    var fontString = size+"px " + font;
    context.font = fontString;
    // Perform measurement
    var metrics = context.measureText(text);
    return metrics;
};


/// <summary>
/// 
/// </summary>
Machinata.Imaging.getCalibrationMetricsForFont = function (fontName, opts) {
    // Init
    if (opts == null) opts = {};
    if (opts.calibrationText == null) opts.calibrationText = "abcdefghijklmnopqstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
    var results = {};

    var measureCanvas = Machinata.Imaging.createDrawingCanvas(1, 1, opts.canvasEngine);
    var measureContext = measureCanvas.getContext('2d');

    for (var i = 6; i <= 24; i++) {
        // Initial measurement
        var fontSize = i;
        var initialMetrics = Machinata.Imaging.measureText(opts.calibrationText, fontName, fontSize, measureContext);
        console.log(initialMetrics);
        var fontString = fontSize + "px " + fontName;
        console.log(opts.calibrationText);
        console.log(fontString);
        // Create canvas for actual draw
        var paddingPixels = 20;
        var drawingWidth = initialMetrics.width;
        var drawingHeight = initialMetrics.actualBoundingBoxAscent + initialMetrics.actualBoundingBoxDescent;
        console.log(drawingWidth, drawingHeight);
        drawingWidth = drawingWidth + +paddingPixels*2;
        drawingHeight = drawingHeight + paddingPixels*2;
        console.log(drawingWidth, drawingHeight);
        drawingWidth = Math.ceil(drawingWidth);
        drawingHeight = Math.ceil(drawingHeight);
        console.log(drawingWidth, drawingHeight);
        console.log("will create drawing canvas...")
        var drawingCanvas = Machinata.Imaging.createDrawingCanvas(drawingWidth, drawingHeight, opts.canvasEngine);
        var drawingContext = drawingCanvas.getContext('2d');
        drawingContext.font = fontString;
        drawingContext.textBaseline = 'top';

        // Draw intial meas box
        drawingContext.lineWidth = "1px";
        drawingContext.strokeStyle = "red";
        drawingContext.beginPath();
        drawingContext.rect(paddingPixels, paddingPixels, Math.ceil(initialMetrics.width), Math.ceil(initialMetrics.actualBoundingBoxAscent + initialMetrics.actualBoundingBoxDescent));
        drawingContext.stroke();

        // Draw baseline
        drawingContext.strokeStyle = "blue";
        drawingContext.beginPath();
        drawingContext.moveTo(paddingPixels, paddingPixels + Math.ceil(initialMetrics.actualBoundingBoxAscent));
        drawingContext.lineTo(paddingPixels + Math.ceil(initialMetrics.width), paddingPixels + Math.ceil(initialMetrics.actualBoundingBoxAscent));
        drawingContext.stroke();

        // Draw text
        drawingContext.fillText(opts.calibrationText, paddingPixels, paddingPixels);


        // Now scan all pixels
        var minBlackX = drawingWidth;
        var maxBlackX = 0;
        for (var px = 0; px < drawingWidth; px++) {
            for (var py = 0; py < drawingHeight; py++) {
                var p = drawingContext.getImageData(px, py, 1, 1).data; // [r,g,b,a]
                if (p[0] == 0 && p[1] == 0 && p[2] == 0 && p[3] > 0) {
                    // black (text)
                    if (px < minBlackX) minBlackX = px;
                    if (px > maxBlackX) maxBlackX = px;
                }
            }
        }
        console.log(minBlackX, maxBlackX);

        // Draw min/max
        drawingContext.strokeStyle = "green";
        drawingContext.beginPath();
        drawingContext.moveTo(minBlackX, 0);
        drawingContext.lineTo(minBlackX, drawingHeight);
        drawingContext.stroke();
        drawingContext.beginPath();
        drawingContext.moveTo(maxBlackX, 0);
        drawingContext.lineTo(maxBlackX, drawingHeight);
        drawingContext.stroke();

        var adjustedMetrics = {
            width: maxBlackX - minBlackX

        };
        var delta = adjustedMetrics.width - initialMetrics.width;

        console.log("width api", initialMetrics.width);
        console.log("width scan", adjustedMetrics.width);
        console.log("delta", delta);

        // Track results
        results[fontString] = {
            apiWidth: initialMetrics.width,
            scanWidth: adjustedMetrics.width,
            delta: delta
        };

        // Show what happened
        if (opts.addCanvasesToSelector != null) {
            $(opts.addCanvasesToSelector).append(drawingCanvas);
        }

        // Write file to disk
        if (opts.addCanvasesToDir != null) {
            // Only supported on NodeJS
            var filetype = opts.canvasEngine || "png";
            var fs = require('fs');
            var filepath = opts.addCanvasesToDir + '/FontCalibration_' + fontString + '_delta' + delta + '.' + filetype;
            var out = fs.createWriteStream(filepath);
            if (filetype == "png") {
                var stream = drawingCanvas.createPNGStream();
                stream.pipe(out);
            } else if (filetype == "pdf") {
                console.log("will create pdf " + filepath);
                fs.writeFileSync(filepath, drawingCanvas.toBuffer());
            } else if (filetype == "svg") {
                console.log("will create svg " + filepath);
                fs.writeFileSync(filepath, drawingCanvas.toBuffer());
            } 
        }

    }

    // Results
    console.log(results);
    return results;
};


/// <summary>
/// 
/// </summary>
Machinata.Imaging.loadImageWithCallback = function (src, containerElem, callbackSingle, callbackAll) {
    var imgElem = $("<img style='display:none;'/>");
    containerElem.append(imgElem);
    Machinata.Imaging._loadImageWithCallbackLookupTable[src] = false;
    imgElem[0].onload = function () {
        Machinata.Imaging._loadImageWithCallbackLookupTable[src] = true;
        if (callbackSingle != null) callbackSingle(imgElem);
        if (callbackAll != null) {
            var allLoaded = true;
            Machinata.Util.each(Machinata.Imaging._loadImageWithCallbackLookupTable, function (key) {
                var val = Machinata.Imaging._loadImageWithCallbackLookupTable[key];
                if (val == false) allLoaded = false;
            });
            if (allLoaded == true) callbackAll(imgElem);
        }
    };
    imgElem[0].src = src;
    return imgElem;
};

/// <summary>
/// 
/// </summary>
Machinata.Imaging._loadImageWithCallbackLookupTable = {};

/// <summary>
/// 
/// </summary>
Machinata.Imaging.testImagePixel = function (imgObject, x, y) {
    // Init
    if (x == null) x = 0;
    if (y == null) y = 0;
    var canvas = document.createElement("canvas");
    var ww = imgObject.width;
    var hh = imgObject.height;
    canvas.width = ww;
    canvas.height = hh;
    // Get the requested pixel
    var ctx = canvas.getContext("2d");
    ctx.drawImage(imgObject, 0, 0, ww, hh);
    var pixel = ctx.getImageData(x, y, 1, 1).data; // [r,g,b,a]
    return pixel;
};

/// <summary>
/// 
/// </summary>
Machinata.Imaging.testImageTransparence = function (imgObject, tolerance) {
    // Init
    if (tolerance == null) tolerance = 0;
    var canvas = document.createElement("canvas");
    var ww = imgObject.width;
    var hh = imgObject.height;
    canvas.width = ww;
    canvas.height = hh;

    // Draw to canvas
    var ctx = canvas.getContext("2d");
    ctx.drawImage(imgObject, 0, 0, ww, hh);

    // Get data
    var map = ctx.getImageData(0, 0, ww, hh);
    var rawdata = map.data;

    // Convert to grayscale
    var r, g, b, a;
    var total = 0;
    for (var p = 0, len = rawdata.length; p < len; p += 4) {
        //r = rawdata[p]
        //g = rawdata[p + 1];
        //b = rawdata[p + 2];
        a = rawdata[p + 3];
        if(a <= tolerance) total += 1;
    }
    return total;
};

/// <summary>
/// 
/// </summary>
Machinata.Imaging.changeColor = function (imgObject, imgColor) {
    // Init
    var canvas = document.createElement("canvas");
    var ww = imgObject.width;
    var hh = imgObject.height;
    canvas.width = ww;
    canvas.height = hh;

    // Draw to canvas
    var ctx = canvas.getContext("2d");
    ctx.drawImage(imgObject, 0, 0, ww, hh);

    // Get data
    var map = ctx.getImageData(0, 0, ww, hh);
    var rawdata = map.data;

    // Convert to grayscale
    var r, g, b, avg;
    for (var p = 0, len = rawdata.length; p < len; p += 4) {
        r = rawdata[p]
        g = rawdata[p + 1];
        b = rawdata[p + 2];
        avg = Math.floor((r + g + b) / 3);
        rawdata[p] = rawdata[p + 1] = rawdata[p + 2] = avg;
    }
    ctx.putImageData(map, 0, 0);

    // Overlay using source-atop
    ctx.globalCompositeOperation = "source-atop"
    ctx.fillStyle = imgColor;
    ctx.fillRect(0, 0, ww, hh);

    // Return
    return canvas;
};


/// <summary>
/// Use the two last parameters to offset the image:
///     var offsetX = 0.5;   // center x
///     var offsetY = 0.5;   // center y
/// Original By Ken Fyrstenberg Nilsen
/// Via https://stackoverflow.com/questions/21961839/simulation-background-size-cover-in-canvas/21961894#21961894
/// </summary>
Machinata.Imaging.drawImageCoverFill = function(ctx, imgObject, x, y, w, h, offsetX, offsetY) {
    // Init
    if (arguments.length === 2) {
        x = y = 0;
        w = ctx.canvas.width;
        h = ctx.canvas.height;
    }
    offsetX = typeof offsetX === "number" ? offsetX : 0.5;
    offsetY = typeof offsetY === "number" ? offsetY : 0.5;

    // keep bounds [0.0, 1.0]
    if (offsetX < 0) offsetX = 0;
    if (offsetY < 0) offsetY = 0;
    if (offsetX > 1) offsetX = 1;
    if (offsetY > 1) offsetY = 1;

    var iw = imgObject.width,
        ih = imgObject.height,
        r = Math.min(w / iw, h / ih),
        nw = iw * r,   // new prop. width
        nh = ih * r,   // new prop. height
        cx, cy, cw, ch, ar = 1;

    // Decide which gap to fill    
    if (nw < w) ar = w / nw;
    if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;  // updated
    nw *= ar;
    nh *= ar;

    // Position
    cw = iw / (nw / w);
    ch = ih / (nh / h);
    cx = (iw - cw) * offsetX;
    cy = (ih - ch) * offsetY;

    // Validate
    if (cx < 0) cx = 0;
    if (cy < 0) cy = 0;
    if (cw > iw) cw = iw;
    if (ch > ih) ch = ih;

    // Draw
    ctx.drawImage(imgObject, cx, cy, cw, ch, x, y, w, h);
};


/// <summary>
/// 
/// </summary>
Machinata.Imaging.drawImageContainFit = function (ctx, imgObject, x, y, w, h) {
    // Init
    if (arguments.length === 2) {
        x = y = 0;
        w = ctx.canvas.width;
        h = ctx.canvas.height;
    }
    var newImageAR = w/h;
    var overlayAR = imgObject.width / imgObject.height;
    var newOverlayW = imgObject.width;
    var newOverlayH = imgObject.height;

    // Scale to fit
    if(overlayAR > newImageAR) {
        // Fit to width
        newOverlayW = w;
        newOverlayH = newOverlayW / overlayAR;
    } else {
        // Fit to height
        newOverlayH = h;
        newOverlayW = overlayAR * newOverlayH;
    }

    // Position
    var cx = x + (w/2.0 - newOverlayW/2.0); 
    var cy = y + (h/2.0 - newOverlayH/2.0); 
    var cw = newOverlayW; 
    var ch = newOverlayH;
    var iw = imgObject.width;
    var ih = imgObject.height;
       
    // Clip bounds
    if (cx < 0) cx = 0;
    if (cy < 0) cy = 0;
    if (cw > iw) cw = iw;
    if (ch > ih) ch = ih;

    // Draw
    ctx.drawImage(imgObject, 0, 0, iw, ih, cx, cy, cw, ch);
};

/// <summary>
/// 
/// </summary>
Machinata.Imaging.wrapText = function (ctx, text, x, y, maxWidth, lineHeight) {
    // From https://www.html5canvastutorials.com/tutorials/html5-canvas-wrap-text-tutorial/
    var words = text.split(' ');
    var line = '';
    for (var n = 0; n < words.length; n++) {
        var testLine = line + words[n] + ' ';
        var metrics = ctx.measureText(testLine);
        var testWidth = metrics.width;
        if (testWidth > maxWidth && n > 0) {
            ctx.fillText(line, x, y);
            line = words[n] + ' ';
            y += lineHeight;
        } else {
            line = testLine;
        }
    }
    ctx.fillText(line, x, y);
};


/// <summary>
/// 
/// </summary>
Machinata.Imaging.exportSVGasPNG = function (svgElem, title) {
    // via https://stackoverflow.com/questions/3975499/convert-svg-to-image-jpeg-png-etc-in-the-browser
    downloadSvg(svgElem[0], title);
    function copyStylesInline(destinationNode, sourceNode) {
        var containerElements = ["svg", "g"];
        for (var cd = 0; cd < destinationNode.childNodes.length; cd++) {
            var child = destinationNode.childNodes[cd];
            if (containerElements.indexOf(child.tagName) != -1) {
                copyStylesInline(child, sourceNode.childNodes[cd]);
                continue;
            }
            var style = sourceNode.childNodes[cd].currentStyle || window.getComputedStyle(sourceNode.childNodes[cd]);
            if (style == "undefined" || style == null) continue;
            for (var st = 0; st < style.length; st++) {
                child.style.setProperty(style[st], style.getPropertyValue(style[st]));
            }
        }
    }

    function triggerDownload(imgURI, fileName) {
        var evt = new MouseEvent("click", {
            view: window,
            bubbles: false,
            cancelable: true
        });
        var a = document.createElement("a");
        a.setAttribute("download", fileName);
        a.setAttribute("href", imgURI);
        a.setAttribute("target", '_blank');
        a.dispatchEvent(evt);
    }

    function downloadSvg(svg, fileName) {
        var copy = svg.cloneNode(true);
        copyStylesInline(copy, svg);
        var canvas = document.createElement("canvas");
        var bbox = svg.getBBox();
        canvas.width = bbox.width + 30; //TODO: some sort of styling bug
        canvas.height = bbox.height + 30; //TODO: some sort of styling bug
        canvas.width = svgElem.width();
        canvas.height = svgElem.height();
        var ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, bbox.width, bbox.height);
        var data = (new XMLSerializer()).serializeToString(copy);
        var DOMURL = window.URL || window.webkitURL || window;
        var img = new Image();
        var svgBlob = new Blob([data], { type: "image/svg+xml;charset=utf-8" });
        var url = DOMURL.createObjectURL(svgBlob);
        img.onload = function () {
            ctx.drawImage(img, 0, 0);
            DOMURL.revokeObjectURL(url);
            if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
                var blob = canvas.msToBlob();
                navigator.msSaveOrOpenBlob(blob, fileName);
            }
            else {
                var imgURI = canvas
                    .toDataURL("image/png")
                    .replace("image/png", "image/octet-stream");
                triggerDownload(imgURI, fileName);
            }
            document.removeChild(canvas);
        };
        img.src = url;
    }
};


/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-drawing.js */
/* File: js/machinata-core-bundle.js/machinata-core-drawing.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Collection of powerful drawing tools.
/// </summary>
/// <type>namespace</type>
Machinata.Drawing = {};


/// <summary>
/// Provides a mechanism for automatically rendering a draw loop 
/// using the browsers builtin callbacks.
/// The renderer provides functionality for bookkeeping (fps) as well
/// as start/stop/pause.
/// </summary>
Machinata.Drawing.createRenderer = function (canvasElem, renderCallback) {


    var renderer = {
        enabled: false,
        canvas: canvasElem[0],
        lastRenderTime: new Date().getTime(),
        lastDebugTime: new Date().getTime(),
        fps: 0,
        showStats: false,
        stats: "initializing...",

        start: function () {
            this.enabled = true;
            window.requestAnimationFrame(animate);
        },
        stop: function () {
            this.enabled = false;
        },
        debugStepOnClick: function () {
            this.enabled = false;
            var step = 0;
            canvasElem.click(function () {
                step += 1000 / 60;
                console.log("render step", step);
                render(step); 
            });
            render(step); 
        },
    };

    function render(time) {
        // Get drawing context
        var ctx = renderer.canvas.getContext("2d");
        // Save/resrotre (we provide this to the callback)
        ctx.save(); {
            // Call callback
            renderCallback(ctx, time, renderer);
        } ctx.restore();
        // Stats?
        if (renderer.showStats == true) {
            Machinata.Drawing.debugText(ctx, renderer.stats, 10, 10+3, false);
        }
    }

    function animate(time) {
        // Bookkeeping
        var nowTime = new Date().getTime();
        renderer.deltaRenderTime = nowTime - renderer.lastRenderTime;
        renderer.lastRenderTime = nowTime;
        renderer.fps = Math.round(1000 / renderer.deltaRenderTime);
        if (nowTime - renderer.lastDebugTime > 1000) {
            renderer.lastDebugTime = nowTime;
            renderer.stats = renderer.fps + " fps @ " + renderer.canvas.width+"x"+renderer.canvas.height+" (" + time + ")";
            if (Machinata.DebugEnabled == true) console.log(renderer.stats);
        }
        // Re-render
        if (renderer.enabled == true) {
            render(time);
            window.requestAnimationFrame(animate);
        }
    }
    

    return renderer;
};

/// <summary>
/// 
/// </summary>
Machinata.Drawing.debugText = function (ctx, text, x, y, centered) {
    ctx.save();
    var fontSize = 10;
    var padding = 3;
    var prevComp = ctx.globalCompositeOperation; 
    ctx.globalCompositeOperation = "source-over"; 
    ctx.font = fontSize+"px Arial";
    var metrics = ctx.measureText(text);
    if (x == null) x = 10;
    if (y == null) y = 10;
    if (centered == null) centered = true;
    if (centered == true) x = x - metrics.width / 2;
    // BG
    ctx.fillStyle = "rgba(0,0,0,0.5)";
    ctx.fillRect(
        x - padding,
        y - fontSize ,
        metrics.width + padding + padding,
        fontSize + padding
    );
    // Text
    ctx.fillStyle = "white";
    ctx.fillText(text, x, y);
    ctx.globalCompositeOperation = prevComp; 
    ctx.restore();
};



/// <summary>
/// 
/// </summary>
Machinata.Drawing.cardinalSplinePathForPoints = function (ctx, points, tension, isClosed, numOfSegments) {
    // See https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Cardinal_spline
    // See https://github.com/gdenisov/cardinal-spline-js/blob/master/src/curve_func.js

    // options or defaults
    tension = (typeof tension === 'number') ? tension : 0.5;
    numOfSegments = numOfSegments ? numOfSegments : 25;

    var pts,									// for cloning point array
        i = 1,
        l = points.length,
        rPos = 0,
        rLen = (l - 2) * numOfSegments + 2 + (isClosed ? 2 * numOfSegments : 0),
        res = new Float32Array(rLen),
        cache = new Float32Array((numOfSegments + 2) * 4),
        cachePtr = 4;

    pts = points.slice(0);

    if (isClosed) {
        pts.unshift(points[l - 1]);				// insert end point as first point
        pts.unshift(points[l - 2]);
        pts.push(points[0], points[1]); 		// first point as last point
    }
    else {
        pts.unshift(points[1]);					// copy 1. point and insert at beginning
        pts.unshift(points[0]);
        pts.push(points[l - 2], points[l - 1]);	// duplicate end-points
    }

    // cache inner-loop calculations as they are based on t alone
    cache[0] = 1;								// 1,0,0,0

    for (; i < numOfSegments; i++) {

        var st = i / numOfSegments,
            st2 = st * st,
            st3 = st2 * st,
            st23 = st3 * 2,
            st32 = st2 * 3;

        cache[cachePtr++] = st23 - st32 + 1;	// c1
        cache[cachePtr++] = st32 - st23;		// c2
        cache[cachePtr++] = st3 - 2 * st2 + st;	// c3
        cache[cachePtr++] = st3 - st2;			// c4
    }

    cache[++cachePtr] = 1;						// 0,1,0,0

    // calc. points
    parse(pts, cache, l);

    if (isClosed) {
        //l = points.length;
        pts = [];
        pts.push(points[l - 4], points[l - 3], points[l - 2], points[l - 1]); // second last and last
        pts.push(points[0], points[1], points[2], points[3]); // first and second
        parse(pts, cache, 4);
    }

    function parse(pts, cache, l) {

        for (var i = 2, t; i < l; i += 2) {

            var pt1 = pts[i],
                pt2 = pts[i + 1],
                pt3 = pts[i + 2],
                pt4 = pts[i + 3],

                t1x = (pt3 - pts[i - 2]) * tension,
                t1y = (pt4 - pts[i - 1]) * tension,
                t2x = (pts[i + 4] - pt1) * tension,
                t2y = (pts[i + 5] - pt2) * tension;

            for (t = 0; t < numOfSegments; t++) {

                var c = t << 2, //t * 4;

                    c1 = cache[c],
                    c2 = cache[c + 1],
                    c3 = cache[c + 2],
                    c4 = cache[c + 3];

                res[rPos++] = c1 * pt1 + c2 * pt3 + c3 * t1x + c4 * t2x;
                res[rPos++] = c1 * pt2 + c2 * pt4 + c3 * t1y + c4 * t2y;
            }
        }
    }

    // add last point
    l = isClosed ? 0 : points.length - 2;
    res[rPos++] = points[l];
    res[rPos] = points[l + 1];

    // add lines to path
    for (i = 0, l = res.length; i < l; i += 2)
        ctx.lineTo(res[i], res[i + 1]);

    return res;
};


/// <summary>
/// Draws a rounded rectangle using the current state of the canvas.
/// @param {CanvasRenderingContext2D} ctx
/// @param {Number} x The top left x coordinate
/// @param {Number} y The top left y coordinate
/// @param {Number} width The width of the rectangle
/// @param {Number} height The height of the rectangle
/// @param {Number} [radius = 5] The corner radius; It can also be an object
///                 to specify different radii for corners
/// @param {Number} [radius.tl = 0] Top left
/// @param {Number} [radius.tr = 0] Top right
/// @param {Number} [radius.br = 0] Bottom right
/// @param {Number} [radius.bl = 0] Bottom left
/// @param {Boolean} [fill = false] Whether to fill the rectangle.
/// @param {Boolean} [stroke = true] Whether to stroke the rectangle.
/// </summary>
Machinata.Drawing.roundedRect = function(ctx, x, y, width, height, radius) {
    // See https://stackoverflow.com/questions/1255512/how-to-draw-a-rounded-rectangle-on-html-canvas
    if (typeof radius === 'undefined') {
        radius = 5;
    }
    if (typeof radius === 'number') {
        radius = { tl: radius, tr: radius, br: radius, bl: radius };
    } else {
        var defaultRadius = { tl: 0, tr: 0, br: 0, bl: 0 };
        for (var side in defaultRadius) {
            radius[side] = radius[side] || defaultRadius[side];
        }
    }
    //ctx.beginPath();
    ctx.moveTo(x + radius.tl, y);
    ctx.lineTo(x + width - radius.tr, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
    ctx.lineTo(x + width, y + height - radius.br);
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
    ctx.lineTo(x + radius.bl, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
    ctx.lineTo(x, y + radius.tl);
    ctx.quadraticCurveTo(x, y, x + radius.tl, y);
    //ctx.closePath();
}

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-social.js */
/* File: js/machinata-core-bundle.js/machinata-core-social.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Common social media routines.
/// </summary>
/// <type>namespace</type>
Machinata.Social = {};

/// <summary>
/// 
/// </summary>
Machinata.Social.getShareURLForService = function (service, url, text, media) {
    if (url == null) {
        url = window.location;
    }
    if (text == null) {
        text = "";
    }

    if (service == "facebook") {
        return "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url);
    }

    if (service == "linkedin") {
        return "https://www.linkedin.com/shareArticle?mini=true&url=" + encodeURIComponent(url) + "&title=" + encodeURIComponent(text);
    }

    if (service == "twitter") {
        if (text != null && text != "") return "https://www.twitter.com/share?text=" + encodeURIComponent(text) + "&url=" + encodeURIComponent(url);
        else return "https://www.twitter.com/share?url=" + encodeURIComponent(url);
    }

    if (service == "link") {
        return url;
    }

    if (service == "email") {
        return "mailto:?body=" + encodeURIComponent(text+"\n\n"+url);
    }

    if (service == "pinterest") return "https://pinterest.com/pin/create/button/?url=" + encodeURIComponent(url) + "&description=" + encodeURIComponent(text);
    if (service == "tumblr") return "https://www.tumblr.com/share/photo?source=" + encodeURIComponent(url) + "&click_thru=" + encodeURIComponent(url);
    if (service == "googleplus") return "https://plus.google.com/share?url=" + encodeURIComponent(url);
    if (service == "stumbleupon") return "https://www.stumbleupon.com/submit?url=" + encodeURIComponent(url);
    if (service == "weheartit") return "https://weheartit.com/heart-it/new_entry?via=" + encodeURIComponent(url) + "&encoding=UTF-8&extension_version=3.2.0&hearting_method=heartbutton&href=" + encodeURIComponent(url) + "&original_title=" + encodeURIComponent(text) + "&caption=" + encodeURIComponent(text) + "&popup=1";
    if (service == "reddit") return "https://www.reddit.com/submit?title=" + encodeURIComponent(text) + "&url=" + encodeURIComponent(url);

    return null;
};



/// <summary>
/// 
/// </summary>
Machinata.Social.openShareWindowForService = function(service, url, text, media) {
    // Init
    var w = 700;
    var h = 450;
    if (service == "reddit") {
        w = "auto";
        h = "auto";
    }
    var left = (window.screen.width / 2) - (w / 2);
    var top = (window.screen.height / 2) - (h / 2);
    var shareURL = Machinata.Social.getShareURLForService(service, url, text, media);
    // Open
    if (service == "copylink") {
        Machinata.UI.copyTextToClipboard(shareURL);
    } else if (service == "email") {
        // Open email window
        window.open(shareURL, "_blank");
    } else {
        // Open popup
        window.open(shareURL, "_blank", "menubar=no,location=no,toolbar=no,width=" + w + ",height=" + h + ",status=no,left=" + left + ",top=" + top, false);
    }
}

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-data.js */
/* File: js/machinata-core-bundle.js/machinata-core-data.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// Collection of data-related routines, such as exporting strings as blobs in the browser.
/// </summary>
/// <type>namespace</type>
Machinata.Data = {};


/// <summary>
///
/// </summary>
Machinata.Data.openDataInNewWindow = function (data, mimetype, filename) {

    // Write the bytes of the string to an ArrayBuffer buffer
    var byteString = atob(data);
    var buffer = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(buffer);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    // Create download link element
    var downloadNode = document.createElement("a");
    document.body.appendChild(downloadNode);

    // Get blob url
    var blob = new Blob([buffer], { type: mimetype })
    var url = URL.createObjectURL(blob);
    downloadNode.href = url;
    downloadNode.setAttribute("target", "_blank");

    // Setting the file name
    //downloadNode.download = filename;

    // Tricker download
    downloadNode.click();

    // Hide link after some time...
    setTimeout(function () {
        downloadNode.setAttribute("style", "display:none");
    }, 200);

    // Old method: doesnt work on Chrome
    //var url = "data:" + mimetype + ";base64," + encodeURIComponent(data);
    //Machinata.openPage(url);
};

/// <summary>
///
/// </summary>
Machinata.Data.exportBlob = function (blob, mimetype, filename) {
    // Switch on browser support
    if (navigator.msSaveOrOpenBlob) {

        // MS Blob
        blob.type = mimetype;
        navigator.msSaveOrOpenBlob(blob, filename);

    } else if (window.Blob) {

        // Blob API

        blob.type = mimetype;
        

        // Create download link element
        var downloadNode = document.createElement("a");
        document.body.appendChild(downloadNode);

        // Get blob url
        var url = URL.createObjectURL(blob);
        downloadNode.href = url;

        // Setting the file name
        downloadNode.download = filename;

        // Tricker download
        downloadNode.click();

        // Hide link after some time...
        setTimeout(function () {
            downloadNode.setAttribute("style", "display:none");
        }, 200);

    }
};

/// <summary>
///
/// </summary>
Machinata.Data.exportDataAsBlob = function (data, mimetype, filename) {


    // Switch on browser support
    if (navigator.msSaveOrOpenBlob) {

        // MS Blob
        var blob = new Blob(['\ufeff', data], {
            type: mimetype
        });
        navigator.msSaveOrOpenBlob(blob, filename);
        
    } else if(window.Blob) {
    
        // Blob API

        // Write the bytes of the string to an ArrayBuffer buffer
        var byteString = atob(data);
        var buffer = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(buffer);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        // Create download link element
        var downloadNode = document.createElement("a");
        document.body.appendChild(downloadNode);

        // Get blob url
        var blob = new Blob([buffer], { type: mimetype })
        var url = URL.createObjectURL(blob);
        downloadNode.href = url;

        // Setting the file name
        downloadNode.download = filename;

        // Tricker download
        downloadNode.click();

        // Hide link after some time...
        setTimeout(function () {
            downloadNode.setAttribute("style", "display:none");
        }, 200);

    } else {

        // Fallback Data URI

        // Create download link element
        var downloadNode = document.createElement("a");
        document.body.appendChild(downloadNode);
        // Create a link to the file
        downloadNode.href = 'data:' + mimetype + ',' + encodeURIComponent(data);
        // Setting the file name
        downloadNode.download = filename;
        // Trigger download
        downloadNode.click();
        // Hide link after some time...
        setTimeout(function () {
            downloadNode.setAttribute("style", "display:none");
        }, 200);
    }

    //TODO: how to cleanup after download?
};


/// <summary>
///
/// </summary>
Machinata.Data.exportObjectAsJSON = function (obj, filename, pretty) {
    // Create JSON string
    var data = null;
    if (pretty == true) data = JSON.stringify(obj, null, 4);
    else data = JSON.stringify(obj);
    // Send blob back to browser
    Machinata.Data.exportDataAsBlob(data, "application/json", filename);
};

/// <summary>
/// Exports a table element as a Excel document by packaging
/// the table HTML inside a schemas-microsoft-com:office:excel
/// XML Excel document. This effectly allows a Excel document to be
/// represented as a HTML table, including a subset of styling.
/// </summary>
Machinata.Data.exportTableAsExcel = function (tableElem, filename) {
    var tableHTML = tableElem[0].outerHTML;
    // Create html XLS
    var data = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
    data = data + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';
    data = data + '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>';
    data = data + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
    data = data + tableHTML;
    data = data + '</body></html>';

    // Send to browser
    Machinata.Data.exportDataAsBlob(btoa(data), "application/vnd.ms-excel", filename); //TODO: extend exportDataAsBlob so that the unecessary btoa and then atob conversion doenst happen
};

/// <summary>
/// Exports a table element as a CSV document by automatically
/// transposing the table rows and columns to CSV fields.
/// </summary>
Machinata.Data.exportTableAsCSV = function (tableElem, filename) {
    // Init
    var columnSeperator = ",";
    var rowSeperator = "\r\n";
    var stringDelimiter = "\"";
    var useSeperatorMarker = true;
    var data = "";
    // Marker?
    if (useSeperatorMarker == true) {
        data = "sep=" + columnSeperator + rowSeperator;
    }
    // Helper functions
    function addCellToData(cellElem) {
        var insertValue = $(cellElem).text(); //TODO: raw types?
        insertValue = insertValue.replaceAll(stringDelimiter, stringDelimiter + stringDelimiter); // escape
        var useDelimiter = true;
        if (insertValue == null || insertValue == "") useDelimiter = false;
        if (useDelimiter == true) data += stringDelimiter + insertValue + stringDelimiter;
        else data += insertValue;
        // Handle colspan
        if ($(cellElem).attr("colspan") != null) {
            var colspans = parseInt($(cellElem).attr("colspan"));
            for (var i = 1; i < colspans; i++) {
                data += columnSeperator;
            }
        }
    }
    // Create CSV data...
    // Headers
    tableElem.find("thead").each(function (index, theadElem) {
        $(theadElem).find("tr").each(function (index, trElem) {
            $(trElem).find("th").each(function (index, cellElem) {
                if (index != 0) data += columnSeperator;
                addCellToData(cellElem);
            });
            data += rowSeperator;
        });
    });
    // Bodies
    tableElem.find("tbody").each(function (index, tbodyElem) {
        $(tbodyElem).find("tr").each(function (index, trElem) {
            $(trElem).find("td").each(function (index, cellElem) {
                if (index != 0) data += columnSeperator;
                addCellToData(cellElem);
            });
            data += rowSeperator;
        });
    });
    // Send to browser
    Machinata.Data.exportDataAsBlob(btoa(data), "text/csv", filename); //TODO: extend exportDataAsBlob so that the unecessary btoa and then atob conversion doenst happen
};

/// <summary>
/// Clones a javascript object.
/// </summary>
Machinata.Data.deepClone = function (obj) {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = Machinata.Data.deepClone(obj[i]);
        }
        return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = Machinata.Data.deepClone(obj[attr]);
        }
        return copy;
    }

    // We dont understand this object, throw error
    throw new Error("Unable to copy obj! Its type isn't supported.");
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-string.js */
/* File: js/machinata-core-bundle.js/machinata-core-string.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Useful string-related functions.
/// Many of the functions align with the Machinata Server Core String functions.
/// </summary>
/// <type>namespace</type>
Machinata.String = {};

/// <summary>
/// 
/// </summary>
Machinata.String.createShortURL = function (text) {
    //TODO special characters

    // Lower case
    text = text.toLowerCase();
    // Remove double spaces
    text = text.replace(/\s\s+/g, ' ');
    // Remove spaces
    text = text.replace(/\s/g, '-');
    // Remove slashes
    text = text.replace(/\//g, '-');
    text = text.replace(/\\/g, '-');
    // Remove all special characters
    text = text.replace(/[^a-zA-Z0-9]/g, '-');

    return text.trim();
};

/// <summary>
/// 
/// </summary>
Machinata.String.createSummarizedText = function (text, length, includeTrail, breakAtWordIfPossible) {

    //Note: ported from Core.Util.String (CS)

    if (length == null) length = 60;
    if (includeTrail == null) includeTrail = true;
    if (breakAtWordIfPossible == null) breakAtWordIfPossible = true;

    // Remove special characters
    //TODO: PORT: 
    //if (!allowSpecialCharacters) {
    //    text = ReplaceUmlauts(text);
    //    text = RemoveDiacritics(text);
    //    text = System.Text.RegularExpressions.Regex.Replace(text, @"[^A-Za-z0-9 -]+", " ");
    //}
    // Remove double spaces
    text = text.replace(/\s\s+/g, ' ');
    // Trim to length, if longer
    if (text.length > length) {
        var trimLength = length;
        if(breakAtWordIfPossible == true) {
            // Try to find a length to cutoff at a word
            var tolerance = 12;
            for(var i = 0; i <= tolerance; i++) {
                var c1 = length - i;
                var c2 = length + i;
                if(c1 > 0 && c1 < text.length && text[c1] == ' ') {
                    trimLength = c1;
                    break;
                }
                if(c2 > 0 && c2 < text.length && text[c2] == ' ') {
                    trimLength = c2;
                    break;
                }
            }
        }
        // Cut strimg
        text = text.substring(0, trimLength);
        // Add trail
        if (includeTrail == true) {
            //TODO: PORT: text = text.trim('.');
            text += "...";
        }
    }
    return text.trim();
};



/// <summary>
/// 
/// </summary>
Machinata.String.isHTML = function (str) {
    var a = document.createElement('div');
    a.innerHTML = str;
    for (var c = a.childNodes, i = c.length; i--;) {
        if (c[i].nodeType == 1) return true;
    }
    return false;
};


/// <summary>
/// 
/// </summary>
Machinata.String.replaceAll = function (str, replace, withThis) {
    return str.split(replace).join(withThis);
};

/// <summary>
/// Returns the latlon coordinate from a location string.
/// Thus when ```8003 Z�rich (47.3744489,8.5410422)``` is input,
/// this method will return ```47.3744489,8.5410422```
///
/// A location string looks like:
/// -```47.3744489,8.5410422```
/// -```8003 Z�rich (47.3744489,8.5410422)```
/// -```8003 Z�rich```
/// 
/// See also Machinata.Core.String.ReadLatLonFromLocationString (Core Server)
/// </summary>
Machinata.String.readLatLonFromLocationString = function (location) {
    // Sanity
    if (location == null || location == "") return null;
    // Parse out coord pair
    var regex = /(\d*\.\d*,\d*\.\d*)/; // match any coord pair 47.3744489,8.5410422
    var latlons = location.match(regex);
    
    if (latlons != null && latlons.length > 0) {
        return latlons[latlons.length-1];
    } else {
        return null;
    }
};

/// <summary>
/// Reads the address portion from the a coordinate string.
/// Thus when ```8003 Z�rich (47.3744489,8.5410422)``` is input,
/// this method will return ```8003 Z�rich```
////
/// A location string looks like:
/// -```47.3744489,8.5410422```
/// -```8003 Z�rich (47.3744489,8.5410422)```
/// -```8003 Z�rich```
/// 
/// See also Machinata.Core.String.ReadAddressFromLocationString (Core Server)
/// </summary>
Machinata.String.readAddressFromLocationString = function (location) {
    // Sanity
    if (location == null || location == "") return null;
    // Get latlon
    var latlon = Machinata.String.readLatLonFromLocationString(location);
    if (latlon == null) {
        return location;
    } else {
        // Replace it
        var ret = location.replace("(" + latlon + ")", ""); // try with () first
        ret = ret.replace(latlon, ""); // try without
        ret = ret.trim();
        // Nothing left?
        if (ret == "") return location.trim();
        else return ret;
    }
};

/// <summary>
/// Updates the latlon portion of a location string. If the coordinate does not exist,
/// it is automatically added.
/// A location string looks like:
/// -```47.3744489,8.5410422```
/// -```8003 Z�rich (47.3744489,8.5410422)```
/// -```8003 Z�rich```
/// </summary>
Machinata.String.updateLatLonInLocationString = function (location,newLatLon) {
    var oldLatLon = Machinata.String.readLatLonFromLocationString(location);
    if (oldLatLon == null) {
        // Append it?
        return location + " (" + newLatLon + ")";
    } else {
        // Replace it
        var ret = location.replace("(" + oldLatLon + ")", "(" + newLatLon + ")"); // try with () first
        ret = ret.replace(oldLatLon, newLatLon); // try without
        return ret.trim();
    }
};



/// <summary>
/// Strips all leading indents from a multiline-string.
/// Useful for displaying source code that has built in indents.
/// </summary>
Machinata.String.stripExtraIndents = function (str) {
    // Init
    var ret = "";
    var lines = str.split("\n");
    // Count min indents per line
    var minIndents = 9999999;
    function countIndent(line) {
        var indents = 0;
        if (line == null || line.trim() == "") return 9999999;
        for (var c = 0; c < line.length - 1; c++) {
            if (line[c] == " ") {
                indents++;
            } else {
                break;
            }
        }
        return indents;
    }
    for (var i = 0; i < lines.length - 1; i++) {
        var indents = countIndent(lines[i]);
        if (indents < minIndents) minIndents = indents;
    }
    // Strip out each line
    for (var i = 0; i < lines.length - 1; i++) {
        ret += lines[i].substring(minIndents) + "\n";
        
    }
    return ret.trim();
};

/// <summary>
/// </summary>
Machinata.String.startsWith = function (str, prefix) {
    return str.slice(0, prefix.length) == prefix;
};

/// <summary>
/// </summary>
Machinata.String.endsWith = function (str, ending) {
    return str.slice(-ending.length) == ending;
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-formatting.js */
/* File: js/machinata-core-bundle.js/machinata-core-formatting.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */


/// <summary>
/// Common formatting routines for numbers, dates, text and more.
/// </summary>
/// <type>namespace</type>
Machinata.Formatting = {};

/// <summary>
/// 
/// </summary>
Machinata.Formatting.defaultNumberFormatterOptions = {
    minimumFractionDigits: 0,
};


/// <summary>
/// 
/// </summary>
Machinata.Formatting.defaultNumberLocale = 'de-CH';

/// <summary>
/// 
/// </summary>
Machinata.Formatting.defaultNumberFormatter = null;

/// <summary>
/// 
/// </summary>
Machinata.Formatting.setDefaultNumberLocale = function (locale) {
    Machinata.Formatting.defaultNumberFormatter = new Intl.NumberFormat(locale, Machinata.Formatting.defaultNumberFormatterOptions);
}

/// <summary>
/// Formats a number according to the format and locale.
/// </summary>
Machinata.Formatting.formatNumber = function (amount, format, locale, opts) {
    if (opts == null) opts = Machinata.Formatting.defaultNumberFormatterOptions;
    
    if (format == null) {
        // Init default if null (lazy load)
        if (Machinata.Formatting.defaultNumberFormatter == null) Machinata.Formatting.defaultNumberFormatter = new Intl.NumberFormat(Machinata.Formatting.defaultNumberLocale, Machinata.Formatting.defaultNumberFormatterOptions);
        // Set the formatter to the default
        var formatter = Machinata.Formatting.defaultNumberFormatter; // default
        if (locale != null) {
            formatter = new Intl.NumberFormat(locale, opts);
        }
        return formatter.format(amount);
    } else {
        amount = parseFloat(amount);
        if (format == "autoscale") {
            if (amount >= 1000000000) format = "billion";
            else if (amount >= 1000000) format = "million";
            else if (amount >= 1000) format = "thousand";
            opts.maximumFractionDigits = 2;
        }
        var trailer = "";
        if (format == "billion") {
            amount = amount / 1000000000.0;
            trailer = "b"
        } else if (format == "million") {
            amount = amount / 1000000.0;
            trailer = "m"
        } else if (format == "thousand") {
            amount = amount / 1000.0;
            trailer = "k"
        } else if (format == "price") {
            opts.minimumFractionDigits = 2;
            opts.maximumFractionDigits = 2;
        }
        if (locale == null) locale = Machinata.Formatting.defaultNumberLocale;
        var formatter = new Intl.NumberFormat(locale, opts);
        return formatter.format(amount) + trailer;
    }
};




/// <summary>
/// Automatically formats each given element using its attributes:
///     data-format
///     data-locale
/// </summary>
Machinata.Formatting.formatCurrencyElements = function (elements) {
    elements.each(function () {
        var elem = $(this);
        var amount = elem.text();
        var format = elem.attr("data-format");

        elem.text(Machinata.Formatting.formatNumber(amount, format, elem.attr("data-locale")));
        elem.addClass("currency-" + elem.attr("data-currency"));
    });
};



/// <summary>
/// </summary>
Machinata.Formatting.numberToCommasString = function (number, thousandsSeparator) {
    if (thousandsSeparator == null) thousandsSeparator = "'";
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
};
/// <summary>
/// </summary>
Machinata.Formatting.commaStringToNumber = function (str, thousandsSeparator) {
    if (thousandsSeparator == null) thousandsSeparator = "'";
    str = str.replace(thousandsSeparator, "");
    str = str.replace(/[^\d.-]/g, ''); // remove all non digits (allowing . -)
    var num = parseInt(str);
    return num;
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-components.js */
/* File: js/machinata-core-bundle.js/machinata-core-components.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */




/// <summary>
/// A generic toolkit and infastructure for packaging high-performance interface components for easy use and integration.
/// ## Performance Overview
/// Components provide a very fast data read/write interface with a disjoint UI update lifecycle, allowing for blazing fast
/// and optimised UI updates in the browser with hundreds of instances. This requires a bit more plumbing, but allows for very
/// optimised update calls in the browser graphics stack.
/// </summary>
/// <type>namespace</type>
Machinata.Component = {};


/// <summary>
/// Provides the namespace for all component implementations.
/// For example, if you have created a component called ```SuperFancyWidget```,
/// you can push it to this namespace with the key ```SuperFancyWidget```.
/// </summary>
/// <namespace>Machinata.Component.Library</namespace>
/// <example>
/// ## Component Interface
/// ```
/// Machinata.Component.Library.SuperFancyWidget = {};
/// Machinata.Component.Library.SuperFancyWidget.DefaultConfig = {};
/// Machinata.Component.Library.SuperFancyWidget.DefaultConfig.inputElem = null;
/// Machinata.Component.Library.SuperFancyWidget.DefaultConfig.labelElem = null;
/// Machinata.Component.Library.SuperFancyWidget.DefaultConfig.onChange = null;
/// Machinata.Component.Library.SuperFancyWidget.DefaultData = {};
/// Machinata.Component.Library.SuperFancyWidget.DefaultData.value = "Test";
/// Machinata.Component.Library.SuperFancyWidget.build = function (instance) {
///     // Shortcuts
///     var config = instance.config, data = instance.data, impl = instance.impl, containerElem = instance.config.containerElem;
/// 
///     // Build UI
///     if (config.inputElem != null) {
///         instance.inputElem = config.inputElem;
///     } else {
///         instance.inputElem = $("<input></input>");
///         containerElem.append(instance.inputElem);
///     }
///     instance.inputElem.val(data.value); // set the initial state
/// 
///     // Bind events
///     instance.inputElem.on("keyup", function (event) {
///         instance.update();
///     });
///     instance.inputElem.on("change", function (event) {
///         if(config.onChange != null) config.onChange(event); // trigger change event when the input is changed
///     });
/// };
/// Machinata.Component.Library.SuperFancyWidget.update = function (instance) {
///     // Shortcuts
///     var config = instance.config, data = instance.data, impl = instance.impl, containerElem = instance.config.containerElem;
///
///     // Sync the browser input with our component data
///     var inputVal = instance.inputElem.val();
///     data.value = inputVal;
///
///     // do something...
/// };
/// ```
/// </example>
Machinata.Component.Library = {};

/// <summary>
/// Definees the default global config values that trickle down to all components' config.
/// If a component has their own default config value defined, or if a custom config is passed
/// in the component build routine, then these values are overridden.
/// </summary>
Machinata.Component.DefaultConfig = {};

/// <summary>
/// Each component can have a container element (jQuery selector) defined.
/// If no component is defined, then it is injected directly into the page where the build routine is called.
/// </summary>
Machinata.Component.DefaultConfig.containerElem = null;

/// <summary>
/// Defines where the assets are stored for the server environment.
/// </summary>
Machinata.Component.DefaultConfig.assetPath = "/static/file/";

/// <summary>
/// A universal handler you can hook into for when components are built.
/// Usefull for running some global post-build hooks/updates.
/// </summary>
Machinata.Component.onBuild = null;

/// <summary>
/// Builds a component using the specified implementation.
/// The parameter ```type``` is a string that must match a implementation registered in ```Machinata.Component.Library```.
/// This method with return the component instance which is a new object consisting of:
///  - ```impl```: the component implementation object
///  - ```config```: the component configuration object
///  - ```data```: the component data object
///  - ```update()```: a function call shortcut to call a comonent update
/// Each component implementation can also provide additional instance variables and methods.
/// Note: You must call this build function after the DOM of the page is ready.
/// </summary>
/// <example>
/// ## Simple build call
/// ```
/// Machinata.Component.buildComponent("SuperFancyWidget");
/// ```
/// ## Advanced build call
/// ```
/// var config = {
///     containerElem: $("#my-component-container"), // custom container (or 'location')
///     myCustomConfig: "value"
/// };
/// var data = {
///     myDataPoint1: 100,
///     myDataPoint2: 50
/// };
/// var component = Machinata.Component.buildComponent("SuperFancyWidget");
/// $("#my-other-component").click(function () {
///     component.data.myDataPoint1 = $(this).val();
///     component.update();
/// });
/// ```
/// </example>
Machinata.Component.buildComponent = function (type, config, data, container) {

    // Sanity
    if (config == null) config = {};
    if (data == null) data = {};

    // Create a container on-the-fly if needed
    if (container != null) config.containerElem = container;
    if (config.containerElem == null) {
        var id = "machinata-" + Machinata.guid();
        document.write("<div class='machinata-component-container' id='" + id + "'></div>");
        config.containerElem = $("#" + id);
    } else {
        config.containerElem.addClass("machinata-component-container");
    }

    // Load implementation
    var impl = Machinata.Component.Library[type];
    if (impl == null) throw "The component '" + type + "' could not be found. It must implemented at Machinata.Component.Library." + type + ".";

    // Create merged data
    var mergedData = {};
    Machinata.Util.extend(mergedData, impl.DefaultData);
    Machinata.Util.extend(mergedData, data);


    // Create merged config
    var mergedConfig = {};
    Machinata.Util.extend(mergedConfig, Machinata.Component.DefaultConfig);
    Machinata.Util.extend(mergedConfig, impl.DefaultConfig);
    Machinata.Util.extend(mergedConfig, config);

    // Create component
    var componentElem = $("<div class='machinata-component'></div>");
    componentElem.addClass("machinata-component-" + type);
    componentElem.attr("id", "machinata-" + Machinata.guid());
    if (config.styles != null) {
        for (var i = 0; i < config.styles.length; i++) componentElem.addClass("style-" + config.styles[i]);
    }
    config.containerElem.append(componentElem);

    // Create instance
    var instance = {
        impl: impl,
        config: mergedConfig,
        data: mergedData,
        componentElem: componentElem
    };

    // Bind instance shortcut functions
    instance.update = function () {
        this.impl.update(this);
    };
    instance.resize = function () {
        if (this.impl.resize != null) this.impl.resize(this);
    };

    // Call the implementation build
    impl.build(instance);

    // Responsiveness (only if the implemtation has a resize handler)
    if (impl.resize != null) {
        Machinata.Responsive.onResize(function () {
            impl.resize(instance);
        });
    }

    // onBuild event
    if (Machinata.Component.onBuild != null) Machinata.Component.onBuild(instance);

    return instance;
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-compatibility.js */
/* File: js/machinata-core-bundle.js/machinata-core-compatibility.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Collection of utilities for helping with website compatibility with older browsers.
/// </summary>
/// <type>namespace</type>
Machinata.Compatibility = {};

/// <summary>
/// </summary>
Machinata.Compatibility.addMouseEventConstructor = function () {
    // See https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/MouseEvent#polyfill
    try {
        new MouseEvent('test');
        return false; // No need to polyfill
    } catch (e) {
        // Need to polyfill - fall through
    }

    // Polyfills DOM4 MouseEvent
    var MouseEventPolyfill = function (eventType, params) {
        params = params || { bubbles: false, cancelable: false };
        var mouseEvent = document.createEvent('MouseEvent');
        mouseEvent.initMouseEvent(eventType,
            params.bubbles,
            params.cancelable,
            window,
            0,
            params.screenX || 0,
            params.screenY || 0,
            params.clientX || 0,
            params.clientY || 0,
            params.ctrlKey || false,
            params.altKey || false,
            params.shiftKey || false,
            params.metaKey || false,
            params.button || 0,
            params.relatedTarget || null
        );

        return mouseEvent;
    }

    MouseEventPolyfill.prototype = Event.prototype;

    window.MouseEvent = MouseEventPolyfill;
}

/// <summary>
/// Allows support for SVG xuse (commonly used for efficiently displaying icons).
/// Uses the engine provided by https://github.com/Keyamoon/svgxuse (version 1.2.6)
/// </summary>
Machinata.Compatibility.addSupportForSVGXUse = function () {
    // See https://raw.githubusercontent.com/Keyamoon/svgxuse/master/svgxuse.js
    var cache = Object.create(null); // holds xhr objects to prevent multiple requests
    var checkUseElems;
    var tid; // timeout id
    var debouncedCheck = function () {
        clearTimeout(tid);
        tid = setTimeout(checkUseElems, 100);
    };
    var unobserveChanges = function () {
        return;
    };
    var observeChanges = function () {
        var observer;
        window.addEventListener("resize", debouncedCheck, false);
        window.addEventListener("orientationchange", debouncedCheck, false);
        if (window.MutationObserver) {
            observer = new MutationObserver(debouncedCheck);
            observer.observe(document.documentElement, {
                childList: true,
                subtree: true,
                attributes: true
            });
            unobserveChanges = function () {
                try {
                    observer.disconnect();
                    window.removeEventListener("resize", debouncedCheck, false);
                    window.removeEventListener("orientationchange", debouncedCheck, false);
                } catch (ignore) { }
            };
        } else {
            document.documentElement.addEventListener("DOMSubtreeModified", debouncedCheck, false);
            unobserveChanges = function () {
                document.documentElement.removeEventListener("DOMSubtreeModified", debouncedCheck, false);
                window.removeEventListener("resize", debouncedCheck, false);
                window.removeEventListener("orientationchange", debouncedCheck, false);
            };
        }
    };
    var createRequest = function (url) {
        // In IE 9, cross origin requests can only be sent using XDomainRequest.
        // XDomainRequest would fail if CORS headers are not set.
        // Therefore, XDomainRequest should only be used with cross origin requests.
        function getOrigin(loc) {
            var a;
            if (loc.protocol !== undefined) {
                a = loc;
            } else {
                a = document.createElement("a");
                a.href = loc;
            }
            return a.protocol.replace(/:/g, "") + a.host;
        }
        var Request;
        var origin;
        var origin2;
        if (window.XMLHttpRequest) {
            Request = new XMLHttpRequest();
            origin = getOrigin(location);
            origin2 = getOrigin(url);
            if (Request.withCredentials === undefined && origin2 !== "" && origin2 !== origin) {
                /*eslint-disable no-undef*/
                Request = XDomainRequest || undefined;
                /*eslint-enable no-undef*/
            } else {
                Request = XMLHttpRequest;
            }
        }
        return Request;
    };
    var xlinkNS = "http://www.w3.org/1999/xlink";
    checkUseElems = function () {
        var base;
        var bcr;
        var fallback = ""; // optional fallback URL in case no base path to SVG file was given and no symbol definition was found.
        var hash;
        var href;
        var i;
        var inProgressCount = 0;
        var isHidden;
        var Request;
        var url;
        var uses;
        var xhr;
        function observeIfDone() {
            // If done with making changes, start watching for chagnes in DOM again
            inProgressCount -= 1;
            if (inProgressCount === 0) { // if all xhrs were resolved
                unobserveChanges(); // make sure to remove old handlers
                observeChanges(); // watch for changes to DOM
            }
        }
        function attrUpdateFunc(spec) {
            return function () {
                if (cache[spec.base] !== true) {
                    spec.useEl.setAttributeNS(xlinkNS, "xlink:href", "#" + spec.hash);
                    if (spec.useEl.hasAttribute("href")) {
                        spec.useEl.setAttribute("href", "#" + spec.hash);
                    }
                }
            };
        }
        function onloadFunc(xhr) {
            return function () {
                var body = document.body;
                var x = document.createElement("x");
                var svg;
                xhr.onload = null;
                x.innerHTML = xhr.responseText;
                svg = x.getElementsByTagName("svg")[0];
                if (svg) {
                    svg.setAttribute("aria-hidden", "true");
                    svg.style.position = "absolute";
                    svg.style.width = 0;
                    svg.style.height = 0;
                    svg.style.overflow = "hidden";
                    body.insertBefore(svg, body.firstChild);
                }
                observeIfDone();
            };
        }
        function onErrorTimeout(xhr) {
            return function () {
                xhr.onerror = null;
                xhr.ontimeout = null;
                observeIfDone();
            };
        }
        unobserveChanges(); // stop watching for changes to DOM
        // find all use elements
        uses = document.getElementsByTagName("use");
        for (i = 0; i < uses.length; i += 1) {
            try {
                bcr = uses[i].getBoundingClientRect();
            } catch (ignore) {
                // failed to get bounding rectangle of the use element
                bcr = false;
            }
            href = uses[i].getAttribute("href")
                || uses[i].getAttributeNS(xlinkNS, "href")
                || uses[i].getAttribute("xlink:href");
            if (href && href.split) {
                url = href.split("#");
            } else {
                url = ["", ""];
            }
            base = url[0];
            hash = url[1];
            isHidden = bcr && bcr.left === 0 && bcr.right === 0 && bcr.top === 0 && bcr.bottom === 0;
            if (bcr && bcr.width === 0 && bcr.height === 0 && !isHidden) {
                // the use element is empty
                // if there is a reference to an external SVG, try to fetch it
                // use the optional fallback URL if there is no reference to an external SVG
                if (fallback && !base.length && hash && !document.getElementById(hash)) {
                    base = fallback;
                }
                if (uses[i].hasAttribute("href")) {
                    uses[i].setAttributeNS(xlinkNS, "xlink:href", href);
                }
                if (base.length) {
                    // schedule updating xlink:href
                    xhr = cache[base];
                    if (xhr !== true) {
                        // true signifies that prepending the SVG was not required
                        setTimeout(attrUpdateFunc({
                            useEl: uses[i],
                            base: base,
                            hash: hash
                        }), 0);
                    }
                    if (xhr === undefined) {
                        Request = createRequest(base);
                        if (Request !== undefined) {
                            xhr = new Request();
                            cache[base] = xhr;
                            xhr.onload = onloadFunc(xhr);
                            xhr.onerror = onErrorTimeout(xhr);
                            xhr.ontimeout = onErrorTimeout(xhr);
                            xhr.open("GET", base);
                            xhr.send();
                            inProgressCount += 1;
                        }
                    }
                }
            } else {
                if (!isHidden) {
                    if (cache[base] === undefined) {
                        // remember this URL if the use element was not empty and no request was sent
                        cache[base] = true;
                    } else if (cache[base].onload) {
                        // if it turns out that prepending the SVG is not necessary,
                        // abort the in-progress xhr.
                        cache[base].abort();
                        delete cache[base].onload;
                        cache[base] = true;
                    }
                } else if (base.length && cache[base]) {
                    setTimeout(attrUpdateFunc({
                        useEl: uses[i],
                        base: base,
                        hash: hash
                    }), 0);
                }
            }
        }
        uses = "";
        inProgressCount += 1;
        observeIfDone();
    };
    var winLoad;
    winLoad = function () {
        window.removeEventListener("load", winLoad, false); // to prevent memory leaks
        tid = setTimeout(checkUseElems, 0);
    };
    if (document.readyState !== "complete") {
        // The load event fires when all resources have finished loading, which allows detecting whether SVG use elements are empty.
        window.addEventListener("load", winLoad, false);
    } else {
        // No need to add a listener if the document is already loaded, initialize immediately.
        winLoad();
    }
};

Machinata.Compatibility.addIESupport = function () {
    if (Machinata.Device.isMSIE() == true) {
        Machinata.Compatibility.addSupportForSVGXUse();
        Machinata.Compatibility.addMouseEventConstructor();
    }
};



/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-parser.js */
/* File: js/machinata-core-bundle.js/machinata-core-parser.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */



/// <summary>
/// Utilities for parsing data...
/// </summary>
/// <type>namespace</type>
Machinata.Parser = {};

/// <summary>
/// A lightweight yet powerful text expression parser for filtering.
/// To normalize the input for the filter you can use ```Machinata.Parser.normalizeStringInputToBasicType```.
///
/// ## Filter Expressions
/// Expressions in filters allow for some simple yet powerful syntax within filters. The expression language
/// has been purposefully crafted with the end-user in mind, which can use expressions from the table filters UI.
/// The expression parser behind the filters is provided by ```Machinata.Parser.parseTextFilter```.
/// 
/// The following filter expressions are supported:
///  - exact match: ```"keyword"```,```'keyword'```
///  - not: ```!"keyword"```, ```!100```
///  - less than: ```< 100```, ```<100```, ```<= 100```
///  - greater than: ```> 100```, ```>100```, ```>= 100```
///  - and: ```> 100 and < 102```
///  - or: ```'EUR' or 'USD'```
///  - range: ```10 - 30```
///
/// String literals are provided by the ```'``` or ```"``` character, and can be escaped through ```\'``` or ```\"``` characters.
/// The util method Machinata.Parser.escapeString can be used to escape a string.
///
/// Numbers are represented through the regex ```/^-?\d+\.?\d*$/``` and table cell content is normalized to basic types
/// using ```Machinata.Parser.normalizeStringInputToBasicType```, where some characters (```'``` and ```,```) are stripped before testing for number.
/// </summary>
Machinata.Parser.parseTextFilter = function (filter, normalizedInput) {
    // Return from parser
    return Machinata.Parser._textFilterParser.parse(filter, { input: normalizedInput });
};

/// <summary>
/// </summary>
Machinata.Parser.escapeString = function (str) {
    // Sanity
    if (str == null) return "''";
    // Replace all ' chars with escape sequence
    str = Machinata.String.replaceAll(str, "'", "\\'");
    // Return escaped version
    return "'" + str + "'";
};

/// <summary>
/// </summary>
Machinata.Parser.convertIsAnyArrayToTextFilter = function (isAny) {
    // Sanity
    if (isAny == null) return "";
    if (isAny.length == 0) return "";
    // Generate
    var filters = [];
    for (var i = 0; i < isAny.length; i++) {
        // Escape strings, but not numbers
        if (isNaN(isAny[i])) {
            filters.push(Machinata.Parser.escapeString(isAny[i]));
        } else {
            filters.push(isAny[i]);
        }
    }
    return filters.join(" or ");
};

/// <summary>
/// </summary>
Machinata.Parser.convertNotAnyArrayToTextFilter = function (isAny) {
    // Sanity
    if (isAny == null) return "";
    if (isAny.length == 0) return "";
    // Generate
    var filters = [];
    for (var i = 0; i < isAny.length; i++) {
        // Escape strings, but not numbers
        if (isNaN(isAny[i])) {
            filters.push("!" +Machinata.Parser.escapeString(isAny[i]));
        } else {
            filters.push("!"+isAny[i]);
        }
    }
    return filters.join(" and ");
};

/// <summary>
/// </summary>
/// <hidden/>
Machinata.Parser._IS_INT_OR_FLOAT_REGEX = /^-?\d+\.?\d*$/

/// <summary>
/// Normalizes string input into basic types (strings and floats) and returns the normalized type.
/// All numbers are returned as floats.
/// Numbers are represented through the regex ```/^-?\d+\.?\d*$/``` and table cell content is normalized to basic types
/// Some characters (```'``` and ```,```) are stripped before testing for a number, in addition numbers ending in % are treated as a number.
/// </summary>
Machinata.Parser.normalizeStringInputToBasicType = function (str) {
    // Sanity
    if (str == null || str == "") return str;
    // Get a simplified string version of the potential number
    var numberStrToTest = str.trim();
    // Does it start or end with a escape char?
    if (str[0] == "'" || str[0] == "\"") return str;
    if (str[str.length - 1] == "'" || str[str.length - 1] == "\"") return str;
    // Clean out digit makeup...
    numberStrToTest = Machinata.String.replaceAll(numberStrToTest,"'","");
    numberStrToTest = Machinata.String.replaceAll(numberStrToTest,",","");
    if (numberStrToTest[numberStrToTest.length - 1] == '%') numberStrToTest = numberStrToTest.substring(0, numberStrToTest.length - 1);
    //console.log("numberStrToTest", str, numberStrToTest);
    // Test if it is a number
    if (Machinata.Parser._IS_INT_OR_FLOAT_REGEX.test(numberStrToTest) == true) {
        var strAsFloat = parseFloat(numberStrToTest);
        if (isNaN(strAsFloat) == false) {
            //console.log("strAsFloat", strAsFloat);
            return strAsFloat; // float
        } else {
            return str; // fallback to string
        }
    } else {
        return str; // string
    }
};

/* -------------------------------------------------------------------------------------------------- */
/* machinata-core-parser-text-filter.js */
/* File: js/machinata-core-bundle.js/machinata-core-parser-text-filter.js */
/* Language: en */
/* -------------------------------------------------------------------------------------------------- */

/// <summary>
/// Powerful text filter parser generated with peg.js.
/// Note: this file was generated with Peg using machinata-core-parser-text-filter.grammar and Machinata.Server\Machinata.Core\Libraries\pegjs-parsers
/// </summary>
/// <type>function</type>
/// <hidden/>
Machinata.Parser._textFilterParser = 
(function() {
/*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */

"use strict";

function peg$subclass(child, parent) {
  function ctor() { this.constructor = child; }
  ctor.prototype = parent.prototype;
  child.prototype = new ctor();
}

function peg$SyntaxError(message, expected, found, location) {
  this.message  = message;
  this.expected = expected;
  this.found    = found;
  this.location = location;
  this.name     = "SyntaxError";

  if (typeof Error.captureStackTrace === "function") {
    Error.captureStackTrace(this, peg$SyntaxError);
  }
}

peg$subclass(peg$SyntaxError, Error);

peg$SyntaxError.buildMessage = function(expected, found) {
  var DESCRIBE_EXPECTATION_FNS = {
        literal: function(expectation) {
          return "\"" + literalEscape(expectation.text) + "\"";
        },

        "class": function(expectation) {
          var escapedParts = "",
              i;

          for (i = 0; i < expectation.parts.length; i++) {
            escapedParts += expectation.parts[i] instanceof Array
              ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1])
              : classEscape(expectation.parts[i]);
          }

          return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
        },

        any: function(expectation) {
          return "any character";
        },

        end: function(expectation) {
          return "end of input";
        },

        other: function(expectation) {
          return expectation.description;
        }
      };

  function hex(ch) {
    return ch.charCodeAt(0).toString(16).toUpperCase();
  }

  function literalEscape(s) {
    return s
      .replace(/\\/g, '\\\\')
      .replace(/"/g,  '\\"')
      .replace(/\0/g, '\\0')
      .replace(/\t/g, '\\t')
      .replace(/\n/g, '\\n')
      .replace(/\r/g, '\\r')
      .replace(/[\x00-\x0F]/g,          function(ch) { return '\\x0' + hex(ch); })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return '\\x'  + hex(ch); });
  }

  function classEscape(s) {
    return s
      .replace(/\\/g, '\\\\')
      .replace(/\]/g, '\\]')
      .replace(/\^/g, '\\^')
      .replace(/-/g,  '\\-')
      .replace(/\0/g, '\\0')
      .replace(/\t/g, '\\t')
      .replace(/\n/g, '\\n')
      .replace(/\r/g, '\\r')
      .replace(/[\x00-\x0F]/g,          function(ch) { return '\\x0' + hex(ch); })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return '\\x'  + hex(ch); });
  }

  function describeExpectation(expectation) {
    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
  }

  function describeExpected(expected) {
    var descriptions = new Array(expected.length),
        i, j;

    for (i = 0; i < expected.length; i++) {
      descriptions[i] = describeExpectation(expected[i]);
    }

    descriptions.sort();

    if (descriptions.length > 0) {
      for (i = 1, j = 1; i < descriptions.length; i++) {
        if (descriptions[i - 1] !== descriptions[i]) {
          descriptions[j] = descriptions[i];
          j++;
        }
      }
      descriptions.length = j;
    }

    switch (descriptions.length) {
      case 1:
        return descriptions[0];

      case 2:
        return descriptions[0] + " or " + descriptions[1];

      default:
        return descriptions.slice(0, -1).join(", ")
          + ", or "
          + descriptions[descriptions.length - 1];
    }
  }

  function describeFound(found) {
    return found ? "\"" + literalEscape(found) + "\"" : "end of input";
  }

  return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};

function peg$parse(input, options) {
  options = options !== void 0 ? options : {};

  var peg$FAILED = {},

      peg$startRuleFunctions = { START: peg$parseSTART },
      peg$startRuleFunction  = peg$parseSTART,

      peg$c0 = function(val) { return val; },
      peg$c1 = "or",
      peg$c2 = peg$literalExpectation("or", true),
      peg$c3 = function(left, right) { return left || right },
      peg$c4 = "and",
      peg$c5 = peg$literalExpectation("and", true),
      peg$c6 = function(left, right) { return left && right },
      peg$c7 = "!",
      peg$c8 = peg$literalExpectation("!", false),
      peg$c9 = function(operand) { return !operand },
      peg$c10 = "(",
      peg$c11 = peg$literalExpectation("(", false),
      peg$c12 = ")",
      peg$c13 = peg$literalExpectation(")", false),
      peg$c14 = function(logical_or) { return logical_or; },
      peg$c15 = "-",
      peg$c16 = peg$literalExpectation("-", false),
      peg$c17 = function(val1, val2) { return getInput() >= val1 && getInput() <= val2; },
      peg$c18 = "<=",
      peg$c19 = peg$literalExpectation("<=", false),
      peg$c20 = function(val) { return getInput() <= val; },
      peg$c21 = ">=",
      peg$c22 = peg$literalExpectation(">=", false),
      peg$c23 = function(val) { return getInput() >= val; },
      peg$c24 = "<",
      peg$c25 = peg$literalExpectation("<", false),
      peg$c26 = function(val) { return getInput() < val; },
      peg$c27 = ">",
      peg$c28 = peg$literalExpectation(">", false),
      peg$c29 = function(val) { return getInput() > val; },
      peg$c30 = function(val) { return getInput() == val; },
      peg$c31 = function(val) { return strFullMatch(getInput(),val); },
      peg$c32 = function(val) { return strPartialMatch(getInput(),val); },
      peg$c33 = "\"",
      peg$c34 = peg$literalExpectation("\"", false),
      peg$c35 = function(chars) { return chars.join(''); },
      peg$c36 = "'",
      peg$c37 = peg$literalExpectation("'", false),
      peg$c38 = "\\",
      peg$c39 = peg$literalExpectation("\\", false),
      peg$c40 = peg$anyExpectation(),
      peg$c41 = function(char) { return char; },
      peg$c42 = function(sequence) { return sequence; },
      peg$c43 = /^[^!"']/,
      peg$c44 = peg$classExpectation(["!", "\"", "'"], true, false),
      peg$c45 = function(chars) { return chars.join(""); },
      peg$c46 = /^[+\-]/,
      peg$c47 = peg$classExpectation(["+", "-"], false, false),
      peg$c48 = /^[0-9]/,
      peg$c49 = peg$classExpectation([["0", "9"]], false, false),
      peg$c50 = ".",
      peg$c51 = peg$literalExpectation(".", false),
      peg$c52 = /^[%]/,
      peg$c53 = peg$classExpectation(["%"], false, false),
      peg$c54 = function(digits) { return Number(digits.flat().join("").replace("%","")); },
      peg$c55 = /^[ \t]/,
      peg$c56 = peg$classExpectation([" ", "\t"], false, false),

      peg$currPos          = 0,
      peg$savedPos         = 0,
      peg$posDetailsCache  = [{ line: 1, column: 1 }],
      peg$maxFailPos       = 0,
      peg$maxFailExpected  = [],
      peg$silentFails      = 0,

      peg$resultsCache = {},

      peg$result;

  if ("startRule" in options) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }

  function text() {
    return input.substring(peg$savedPos, peg$currPos);
  }

  function location() {
    return peg$computeLocation(peg$savedPos, peg$currPos);
  }

  function expected(description, location) {
    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)

    throw peg$buildStructuredError(
      [peg$otherExpectation(description)],
      input.substring(peg$savedPos, peg$currPos),
      location
    );
  }

  function error(message, location) {
    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)

    throw peg$buildSimpleError(message, location);
  }

  function peg$literalExpectation(text, ignoreCase) {
    return { type: "literal", text: text, ignoreCase: ignoreCase };
  }

  function peg$classExpectation(parts, inverted, ignoreCase) {
    return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
  }

  function peg$anyExpectation() {
    return { type: "any" };
  }

  function peg$endExpectation() {
    return { type: "end" };
  }

  function peg$otherExpectation(description) {
    return { type: "other", description: description };
  }

  function peg$computePosDetails(pos) {
    var details = peg$posDetailsCache[pos], p;

    if (details) {
      return details;
    } else {
      p = pos - 1;
      while (!peg$posDetailsCache[p]) {
        p--;
      }

      details = peg$posDetailsCache[p];
      details = {
        line:   details.line,
        column: details.column
      };

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;
      return details;
    }
  }

  function peg$computeLocation(startPos, endPos) {
    var startPosDetails = peg$computePosDetails(startPos),
        endPosDetails   = peg$computePosDetails(endPos);

    return {
      start: {
        offset: startPos,
        line:   startPosDetails.line,
        column: startPosDetails.column
      },
      end: {
        offset: endPos,
        line:   endPosDetails.line,
        column: endPosDetails.column
      }
    };
  }

  function peg$fail(expected) {
    if (peg$currPos < peg$maxFailPos) { return; }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected);
  }

  function peg$buildSimpleError(message, location) {
    return new peg$SyntaxError(message, null, null, location);
  }

  function peg$buildStructuredError(expected, found, location) {
    return new peg$SyntaxError(
      peg$SyntaxError.buildMessage(expected, found),
      expected,
      found,
      location
    );
  }

  function peg$parseSTART() {
    var s0, s1, s2, s3, s4;

    var key    = peg$currPos * 14 + 0,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseWS();
    while (s2 !== peg$FAILED) {
      s1.push(s2);
      s2 = peg$parseWS();
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseLOGICAL_OR();
      if (s2 !== peg$FAILED) {
        s3 = [];
        s4 = peg$parseWS();
        while (s4 !== peg$FAILED) {
          s3.push(s4);
          s4 = peg$parseWS();
        }
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c0(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

    return s0;
  }

  function peg$parseLOGICAL_OR() {
    var s0, s1, s2, s3, s4, s5;

    var key    = peg$currPos * 14 + 1,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$parseLOGICAL_AND();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseWS();
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseWS();
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        if (input.substr(peg$currPos, 2).toLowerCase() === peg$c1) {
          s3 = input.substr(peg$currPos, 2);
          peg$currPos += 2;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c2); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parseWS();
          if (s5 !== peg$FAILED) {
            while (s5 !== peg$FAILED) {
              s4.push(s5);
              s5 = peg$parseWS();
            }
          } else {
            s4 = peg$FAILED;
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parseLOGICAL_OR();
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c3(s1, s5);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parseLOGICAL_AND();
    }

    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

    return s0;
  }

  function peg$parseLOGICAL_AND() {
    var s0, s1, s2, s3, s4, s5;

    var key    = peg$currPos * 14 + 2,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$parseFACTOR();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseWS();
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseWS();
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        if (input.substr(peg$currPos, 3).toLowerCase() === peg$c4) {
          s3 = input.substr(peg$currPos, 3);
          peg$currPos += 3;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c5); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parseWS();
          if (s5 !== peg$FAILED) {
            while (s5 !== peg$FAILED) {
              s4.push(s5);
              s5 = peg$parseWS();
            }
          } else {
            s4 = peg$FAILED;
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parseLOGICAL_AND();
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c6(s1, s5);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parseFACTOR();
    }

    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

    return s0;
  }

  function peg$parseFACTOR() {
    var s0, s1, s2;

    var key    = peg$currPos * 14 + 3,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 33) {
      s1 = peg$c7;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c8); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseFACTOR();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c9(s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parsePRIMARY();
    }

    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

    return s0;
  }

  function peg$parsePRIMARY() {
    var s0, s1, s2, s3;

    var key    = peg$currPos * 14 + 4,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$parseRANGE();
    if (s0 === peg$FAILED) {
      s0 = peg$parseTEST();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 40) {
          s1 = peg$c10;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c11); }
        }
        if (s1 !== peg$FAILED) {
          s2 = peg$parseLOGICAL_OR();
          if (s2 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 41) {
              s3 = peg$c12;
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c13); }
            }
            if (s3 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c14(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }
    }

    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

    return s0;
  }

  function peg$parseRANGE() {
    var s0, s1, s2, s3, s4, s5;

    var key    = peg$currPos * 14 + 5,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$parseNUMBER();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseWS();
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseWS();
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 45) {
          s3 = peg$c15;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c16); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parseWS();
          if (s5 !== peg$FAILED) {
            while (s5 !== peg$FAILED) {
              s4.push(s5);
              s5 = peg$parseWS();
            }
          } else {
            s4 = peg$FAILED;
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parseNUMBER();
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c17(s1, s5);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

    return s0;
  }

  function peg$parseTEST() {
    var s0, s1, s2, s3;

    var key    = peg$currPos * 14 + 6,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    if (input.substr(peg$currPos, 2) === peg$c18) {
      s1 = peg$c18;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c19); }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseWS();
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parseWS();
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseNUMBER();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c20(s3);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c21) {
        s1 = peg$c21;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c22); }
      }
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$parseWS();
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseWS();
        }
        if (s2 !== peg$FAILED) {
          s3 = peg$parseNUMBER();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c23(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 60) {
          s1 = peg$c24;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c25); }
        }
        if (s1 !== peg$FAILED) {
          s2 = [];
          s3 = peg$parseWS();
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$parseWS();
          }
          if (s2 !== peg$FAILED) {
            s3 = peg$parseNUMBER();
            if (s3 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c26(s3);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 62) {
            s1 = peg$c27;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c28); }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parseWS();
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parseWS();
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parseNUMBER();
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c29(s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parseNUMBER();
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c30(s1);
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = peg$parseSTRING_LITERAL();
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c31(s1);
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parseSTRING_SIMPLE();
                if (s1 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c32(s1);
                }
                s0 = s1;
              }
            }
          }
        }
      }
    }

    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

    return s0;
  }

  function peg$parseSTRING_LITERAL() {
    var s0, s1, s2, s3;

    var key    = peg$currPos * 14 + 7,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 34) {
      s1 = peg$c33;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c34); }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseSTRING_LITERAL_DOUBLE_QUOTE();
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parseSTRING_LITERAL_DOUBLE_QUOTE();
      }
      if (s2 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 34) {
          s3 = peg$c33;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c34); }
        }
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c35(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 39) {
        s1 = peg$c36;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$parseSTRING_LITERAL_SINGLE_QUOTE();
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseSTRING_LITERAL_SINGLE_QUOTE();
        }
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 39) {
            s3 = peg$c36;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c35(s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

    return s0;
  }

  function peg$parseSTRING_LITERAL_DOUBLE_QUOTE() {
    var s0, s1, s2;

    var key    = peg$currPos * 14 + 8,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$currPos;
    peg$silentFails++;
    if (input.charCodeAt(peg$currPos) === 34) {
      s2 = peg$c33;
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c34); }
    }
    if (s2 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 92) {
        s2 = peg$c38;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c39); }
      }
    }
    peg$silentFails--;
    if (s2 === peg$FAILED) {
      s1 = void 0;
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      if (input.length > peg$currPos) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c41(s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 92) {
        s1 = peg$c38;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c39); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parseSTRING_LITERAL_ESCAPE_SEQUENCE();
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c42(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

    return s0;
  }

  function peg$parseSTRING_LITERAL_SINGLE_QUOTE() {
    var s0, s1, s2;

    var key    = peg$currPos * 14 + 9,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$currPos;
    peg$silentFails++;
    if (input.charCodeAt(peg$currPos) === 39) {
      s2 = peg$c36;
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c37); }
    }
    if (s2 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 92) {
        s2 = peg$c38;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c39); }
      }
    }
    peg$silentFails--;
    if (s2 === peg$FAILED) {
      s1 = void 0;
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      if (input.length > peg$currPos) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c41(s2);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 92) {
        s1 = peg$c38;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c39); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parseSTRING_LITERAL_ESCAPE_SEQUENCE();
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c42(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

    return s0;
  }

  function peg$parseSTRING_LITERAL_ESCAPE_SEQUENCE() {
    var s0;

    var key    = peg$currPos * 14 + 10,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    if (input.charCodeAt(peg$currPos) === 39) {
      s0 = peg$c36;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c37); }
    }
    if (s0 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 34) {
        s0 = peg$c33;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c34); }
      }
      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 92) {
          s0 = peg$c38;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c39); }
        }
      }
    }

    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

    return s0;
  }

  function peg$parseSTRING_SIMPLE() {
    var s0, s1, s2;

    var key    = peg$currPos * 14 + 11,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = [];
    if (peg$c43.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c44); }
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        if (peg$c43.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c44); }
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c45(s1);
    }
    s0 = s1;

    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

    return s0;
  }

  function peg$parseNUMBER() {
    var s0, s1, s2, s3, s4, s5, s6;

    var key    = peg$currPos * 14 + 12,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    s0 = peg$currPos;
    s1 = peg$currPos;
    if (peg$c46.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c47); }
    }
    if (s2 === peg$FAILED) {
      s2 = null;
    }
    if (s2 !== peg$FAILED) {
      s3 = [];
      if (peg$c48.test(input.charAt(peg$currPos))) {
        s4 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s4 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s4 !== peg$FAILED) {
        while (s4 !== peg$FAILED) {
          s3.push(s4);
          if (peg$c48.test(input.charAt(peg$currPos))) {
            s4 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c49); }
          }
        }
      } else {
        s3 = peg$FAILED;
      }
      if (s3 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 46) {
          s4 = peg$c50;
          peg$currPos++;
        } else {
          s4 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s4 !== peg$FAILED) {
          s5 = [];
          if (peg$c48.test(input.charAt(peg$currPos))) {
            s6 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s6 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c49); }
          }
          if (s6 !== peg$FAILED) {
            while (s6 !== peg$FAILED) {
              s5.push(s6);
              if (peg$c48.test(input.charAt(peg$currPos))) {
                s6 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c49); }
              }
            }
          } else {
            s5 = peg$FAILED;
          }
          if (s5 !== peg$FAILED) {
            if (peg$c52.test(input.charAt(peg$currPos))) {
              s6 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s6 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c53); }
            }
            if (s6 === peg$FAILED) {
              s6 = null;
            }
            if (s6 !== peg$FAILED) {
              s2 = [s2, s3, s4, s5, s6];
              s1 = s2;
            } else {
              peg$currPos = s1;
              s1 = peg$FAILED;
            }
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c54(s1);
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$currPos;
      if (peg$c46.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c47); }
      }
      if (s2 === peg$FAILED) {
        s2 = null;
      }
      if (s2 !== peg$FAILED) {
        s3 = [];
        if (peg$c48.test(input.charAt(peg$currPos))) {
          s4 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s4 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c49); }
        }
        if (s4 !== peg$FAILED) {
          while (s4 !== peg$FAILED) {
            s3.push(s4);
            if (peg$c48.test(input.charAt(peg$currPos))) {
              s4 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c49); }
            }
          }
        } else {
          s3 = peg$FAILED;
        }
        if (s3 !== peg$FAILED) {
          if (peg$c52.test(input.charAt(peg$currPos))) {
            s4 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c53); }
          }
          if (s4 === peg$FAILED) {
            s4 = null;
          }
          if (s4 !== peg$FAILED) {
            s2 = [s2, s3, s4];
            s1 = s2;
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c54(s1);
      }
      s0 = s1;
    }

    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

    return s0;
  }

  function peg$parseWS() {
    var s0;

    var key    = peg$currPos * 14 + 13,
        cached = peg$resultsCache[key];

    if (cached) {
      peg$currPos = cached.nextPos;

      return cached.result;
    }

    if (peg$c55.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c56); }
    }

    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

    return s0;
  }


    function getInput() {
      //return "hello world"; // testing
      return options.input;
    }
    function strFullMatch(a,b) {
    	if(isNaN(a)==false || isNaN(b)==false) return a == b; // sanity if numbers are passed
      return a.toLowerCase() == b.toLowerCase(); 
    }
    function strPartialMatch(a,b) {
    	if(isNaN(a)==false || isNaN(b)==false) return a == b; // sanity if numbers are passed
      return a.toLowerCase().indexOf(b.toLowerCase()) !== -1; 
    }


  peg$result = peg$startRuleFunction();

  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }

    throw peg$buildStructuredError(
      peg$maxFailExpected,
      peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
      peg$maxFailPos < input.length
        ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
        : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
    );
  }
}


  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();


/* -------------------------------------------------------------------------------------------------- */
/* jquery-namespace-postprocess.js */
/* File: js/machinata-core-bundle.js/jquery-namespace-postprocess.js */
/* -------------------------------------------------------------------------------------------------- */


}) (MACHINATA_GLOBAL.MACHINATA_JQUERY, MACHINATA_GLOBAL.MACHINATA_JQUERY, window.location, window.Globalize);

